import { Jsonifiable, JsonValue, PartialDeep } from "type-fest";
import { Ref } from "@graphql-tools/mock";
import {
  GraphQLResolveInfo,
  GraphQLScalarType,
  GraphQLScalarTypeConfig,
} from "graphql";
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) =>
  | Promise<PartialDeep<TResult, { recurseIntoArrays: true }>>
  | PartialDeep<TResult, { recurseIntoArrays: true }>
  | Ref;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & {
  [P in K]-?: NonNullable<T[P]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: { input: string; output: string };
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: { input: string; output: string };
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: number; output: number };
  /** The day, does not include a time. */
  Date: { input: string; output: string };
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: { input: string; output: string };
  /** An IPv4 or IPv6 host address, and optionally its subnet. */
  InternetAddress: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: Jsonifiable; output: JsonValue };
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: { input: string; output: string };
};

export type AdminProject = {
  __typename: "AdminProject";
  id: Maybe<Scalars["UUID"]["output"]>;
  tenantId: Maybe<Scalars["Int"]["output"]>;
};

/**
 * A condition to be used against `AdminProject` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AdminProjectCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `AdminProject` object types. All fields are combined with a logical ‘and.’ */
export type AdminProjectFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AdminProjectFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AdminProjectFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AdminProjectFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `AdminProject` */
export type AdminProjectInput = {
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A connection to a list of `AdminProject` values. */
export type AdminProjectsConnection = {
  __typename: "AdminProjectsConnection";
  /** A list of edges which contains the `AdminProject` and cursor to aid in pagination. */
  edges: Array<AdminProjectsEdge>;
  /** A list of `AdminProject` objects. */
  nodes: Array<AdminProject>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AdminProject` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `AdminProject` edge in the connection. */
export type AdminProjectsEdge = {
  __typename: "AdminProjectsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AdminProject` at the end of the edge. */
  node: AdminProject;
};

/** Methods to use when ordering `AdminProject`. */
export enum AdminProjectsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
}

export type ApplicationUser = {
  __typename: "ApplicationUser";
  /** Reads and enables pagination through a set of `ApplicationUserGroup`. */
  applicationUserGroupsByUserId: ApplicationUserGroupsConnection;
  /** Reads and enables pagination through a set of `ApplicationUserMembership`. */
  applicationUserMembershipsByUserId: ApplicationUserMembershipsConnection;
  /** Reads and enables pagination through a set of `ApplicationUserMetadatum`. */
  applicationUserMetadataByUserId: ApplicationUserMetadataConnection;
  /** Reads and enables pagination through a set of `ApplicationUserSession`. */
  applicationUserSessionsByUserId: ApplicationUserSessionsConnection;
  /** Reads and enables pagination through a set of `ApplicationUserUserPermission`. */
  applicationUserUserPermissionsByUserId: ApplicationUserUserPermissionsConnection;
  /** Reads and enables pagination through a set of `AuditlogLogentry`. */
  auditlogLogentriesByActorId: AuditlogLogentriesConnection;
  /** Reads a single `Avatar` that is related to this `ApplicationUser`. */
  avatarByUserId: Maybe<Avatar>;
  /**
   * Reads and enables pagination through a set of `Avatar`.
   * @deprecated Please use avatarByUserId instead
   */
  avatarsByUserId: AvatarsConnection;
  /** Reads and enables pagination through a set of `CodeFile`. */
  codeFilesByUserId: CodeFilesConnection;
  cognitoTenantKey: Maybe<Scalars["String"]["output"]>;
  /** Reads and enables pagination through a set of `Command`. */
  commandsByUserId: CommandsConnection;
  /** Reads and enables pagination through a set of `ContainerImageRepository`. */
  containerImageRepositoriesByUserId: ContainerImageRepositoriesConnection;
  /** Reads and enables pagination through a set of `ContainerImage`. */
  containerImagesByUserId: ContainerImagesConnection;
  created: Maybe<Scalars["Datetime"]["output"]>;
  /** Reads and enables pagination through a set of `DataTableColumnGroup`. */
  dataTableColumnGroupsByUserId: DataTableColumnGroupsConnection;
  /** Reads and enables pagination through a set of `DataTableColumn`. */
  dataTableColumnsByUserId: DataTableColumnsConnection;
  /** Reads and enables pagination through a set of `DataTableRow`. */
  dataTableRowsByUserId: DataTableRowsConnection;
  /** Reads and enables pagination through a set of `DataTable`. */
  dataTablesByUserId: DataTablesConnection;
  dateCreated: Scalars["Datetime"]["output"];
  /** Reads and enables pagination through a set of `DjangoAdminLog`. */
  djangoAdminLogsByUserId: DjangoAdminLogsConnection;
  email: Scalars["String"]["output"];
  emailMarketingConsent: Scalars["Boolean"]["output"];
  /** Reads and enables pagination through a set of `EulaVersionUserAcceptance`. */
  eulaVersionUserAcceptancesByUserId: EulaVersionUserAcceptancesConnection;
  /** Reads and enables pagination through a set of `FeatureFlagsUser`. */
  featureFlagsUsersByUserId: FeatureFlagsUsersConnection;
  /** Reads and enables pagination through a set of `FileActivity`. */
  fileActivitiesByUserId: FileActivitiesConnection;
  /** Reads and enables pagination through a set of `FileOutputGroup`. */
  fileOutputGroupsByUserId: FileOutputGroupsConnection;
  /** Reads and enables pagination through a set of `FileProcessingNotification`. */
  fileProcessingNotificationsByUserId: FileProcessingNotificationsConnection;
  /** Reads and enables pagination through a set of `File`. */
  filesByUserId: FilesConnection;
  firstName: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `GdtAnalysisTableColumnGroup`. */
  gdtAnalysisTableColumnGroupsByUserId: GdtAnalysisTableColumnGroupsConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTableColumn`. */
  gdtAnalysisTableColumnsByUserId: GdtAnalysisTableColumnsConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTableRow`. */
  gdtAnalysisTableRowsByUserId: GdtAnalysisTableRowsConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTable`. */
  gdtAnalysisTablesByUserId: GdtAnalysisTablesConnection;
  globalUserId: Maybe<Scalars["UUID"]["output"]>;
  homeRegion: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  internal: Scalars["Boolean"]["output"];
  isActive: Scalars["Boolean"]["output"];
  isStaff: Scalars["Boolean"]["output"];
  isSuperuser: Scalars["Boolean"]["output"];
  lastName: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `MetadataValue`. */
  metadataValuesByUserId: MetadataValuesConnection;
  /** Reads and enables pagination through a set of `Notification`. */
  notificationsByUserId: NotificationsConnection;
  personalRegion: Maybe<Scalars["String"]["output"]>;
  /** Reads and enables pagination through a set of `PinnedTool`. */
  pinnedToolsByUserId: PinnedToolsConnection;
  /** Reads and enables pagination through a set of `ProjectClonedNotification`. */
  projectClonedNotificationsByUserId: ProjectClonedNotificationsConnection;
  /** Reads and enables pagination through a set of `ProjectFolder`. */
  projectFoldersByUserId: ProjectFoldersConnection;
  /** Reads and enables pagination through a set of `ProjectSharedNotification`. */
  projectSharedNotificationsBySharerId: ProjectSharedNotificationsConnection;
  /** Reads and enables pagination through a set of `ProjectSharedNotification`. */
  projectSharedNotificationsByUserId: ProjectSharedNotificationsConnection;
  /** Reads and enables pagination through a set of `ProjectTag`. */
  projectTagsByUserId: ProjectTagsConnection;
  /** Reads and enables pagination through a set of `Project`. */
  projectsByUserId: ProjectsConnection;
  /** Reads and enables pagination through a set of `RoleChangeNotification`. */
  roleChangeNotificationsByUserId: RoleChangeNotificationsConnection;
  /** Reads and enables pagination through a set of `Task`. */
  tasksByUserId: TasksConnection;
  /** Reads and enables pagination through a set of `TenantMonthlyConsumedResource`. */
  tenantMonthlyConsumedResourcesByUserId: TenantMonthlyConsumedResourcesConnection;
  /** Reads and enables pagination through a set of `TenantUserMembershipNotification`. */
  tenantUserMembershipNotificationsByInviterId: TenantUserMembershipNotificationsConnection;
  /** Reads and enables pagination through a set of `TenantUserMembershipNotification`. */
  tenantUserMembershipNotificationsByUserId: TenantUserMembershipNotificationsConnection;
  /** Reads and enables pagination through a set of `ToolVersion`. */
  toolVersionsByUserId: ToolVersionsConnection;
  /** Reads and enables pagination through a set of `Tool`. */
  toolsByUserId: ToolsConnection;
  /** Reads and enables pagination through a set of `UserOnboardingQuestionResponse`. */
  userOnboardingQuestionResponsesByUserId: UserOnboardingQuestionResponsesConnection;
  userOrigin: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `UserPersonalSpaceRequest`. */
  userPersonalSpaceRequestsByUserId: UserPersonalSpaceRequestsConnection;
  username: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `WorkflowVersion`. */
  workflowVersionsByUserId: WorkflowVersionsConnection;
  /** Reads and enables pagination through a set of `Workflow`. */
  workflowsByUserId: WorkflowsConnection;
};

export type ApplicationUserApplicationUserGroupsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserGroupCondition>;
  filter?: InputMaybe<ApplicationUserGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserGroupsOrderBy>>;
};

export type ApplicationUserApplicationUserMembershipsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserMembershipCondition>;
  filter?: InputMaybe<ApplicationUserMembershipFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserMembershipsOrderBy>>;
};

export type ApplicationUserApplicationUserMetadataByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserMetadatumCondition>;
  filter?: InputMaybe<ApplicationUserMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserMetadataOrderBy>>;
};

export type ApplicationUserApplicationUserSessionsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserSessionCondition>;
  filter?: InputMaybe<ApplicationUserSessionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserSessionsOrderBy>>;
};

export type ApplicationUserApplicationUserUserPermissionsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserUserPermissionCondition>;
  filter?: InputMaybe<ApplicationUserUserPermissionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserUserPermissionsOrderBy>>;
};

export type ApplicationUserAuditlogLogentriesByActorIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditlogLogentryCondition>;
  filter?: InputMaybe<AuditlogLogentryFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditlogLogentriesOrderBy>>;
};

export type ApplicationUserAvatarsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AvatarCondition>;
  filter?: InputMaybe<AvatarFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AvatarsOrderBy>>;
};

export type ApplicationUserCodeFilesByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CodeFileCondition>;
  filter?: InputMaybe<CodeFileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CodeFilesOrderBy>>;
};

export type ApplicationUserCommandsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CommandCondition>;
  filter?: InputMaybe<CommandFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CommandsOrderBy>>;
};

export type ApplicationUserContainerImageRepositoriesByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ContainerImageRepositoryCondition>;
  filter?: InputMaybe<ContainerImageRepositoryFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContainerImageRepositoriesOrderBy>>;
};

export type ApplicationUserContainerImagesByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ContainerImageCondition>;
  filter?: InputMaybe<ContainerImageFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContainerImagesOrderBy>>;
};

export type ApplicationUserDataTableColumnGroupsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnGroupCondition>;
  filter?: InputMaybe<DataTableColumnGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnGroupsOrderBy>>;
};

export type ApplicationUserDataTableColumnsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnCondition>;
  filter?: InputMaybe<DataTableColumnFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnsOrderBy>>;
};

export type ApplicationUserDataTableRowsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableRowCondition>;
  filter?: InputMaybe<DataTableRowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableRowsOrderBy>>;
};

export type ApplicationUserDataTablesByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableCondition>;
  filter?: InputMaybe<DataTableFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTablesOrderBy>>;
};

export type ApplicationUserDjangoAdminLogsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DjangoAdminLogCondition>;
  filter?: InputMaybe<DjangoAdminLogFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DjangoAdminLogsOrderBy>>;
};

export type ApplicationUserEulaVersionUserAcceptancesByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<EulaVersionUserAcceptanceCondition>;
  filter?: InputMaybe<EulaVersionUserAcceptanceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<EulaVersionUserAcceptancesOrderBy>>;
};

export type ApplicationUserFeatureFlagsUsersByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FeatureFlagsUserCondition>;
  filter?: InputMaybe<FeatureFlagsUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FeatureFlagsUsersOrderBy>>;
};

export type ApplicationUserFileActivitiesByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileActivityCondition>;
  filter?: InputMaybe<FileActivityFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileActivitiesOrderBy>>;
};

export type ApplicationUserFileOutputGroupsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileOutputGroupCondition>;
  filter?: InputMaybe<FileOutputGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileOutputGroupsOrderBy>>;
};

export type ApplicationUserFileProcessingNotificationsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileProcessingNotificationCondition>;
  filter?: InputMaybe<FileProcessingNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileProcessingNotificationsOrderBy>>;
};

export type ApplicationUserFilesByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};

export type ApplicationUserGdtAnalysisTableColumnGroupsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableColumnGroupCondition>;
  filter?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableColumnGroupsOrderBy>>;
};

export type ApplicationUserGdtAnalysisTableColumnsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableColumnCondition>;
  filter?: InputMaybe<GdtAnalysisTableColumnFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableColumnsOrderBy>>;
};

export type ApplicationUserGdtAnalysisTableRowsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableRowCondition>;
  filter?: InputMaybe<GdtAnalysisTableRowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableRowsOrderBy>>;
};

export type ApplicationUserGdtAnalysisTablesByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableCondition>;
  filter?: InputMaybe<GdtAnalysisTableFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTablesOrderBy>>;
};

export type ApplicationUserMetadataValuesByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<MetadataValueCondition>;
  filter?: InputMaybe<MetadataValueFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<MetadataValuesOrderBy>>;
};

export type ApplicationUserNotificationsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

export type ApplicationUserPinnedToolsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<PinnedToolCondition>;
  filter?: InputMaybe<PinnedToolFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<PinnedToolsOrderBy>>;
};

export type ApplicationUserProjectClonedNotificationsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectClonedNotificationCondition>;
  filter?: InputMaybe<ProjectClonedNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectClonedNotificationsOrderBy>>;
};

export type ApplicationUserProjectFoldersByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectFolderCondition>;
  filter?: InputMaybe<ProjectFolderFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectFoldersOrderBy>>;
};

export type ApplicationUserProjectSharedNotificationsBySharerIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectSharedNotificationCondition>;
  filter?: InputMaybe<ProjectSharedNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectSharedNotificationsOrderBy>>;
};

export type ApplicationUserProjectSharedNotificationsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectSharedNotificationCondition>;
  filter?: InputMaybe<ProjectSharedNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectSharedNotificationsOrderBy>>;
};

export type ApplicationUserProjectTagsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectTagCondition>;
  filter?: InputMaybe<ProjectTagFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectTagsOrderBy>>;
};

export type ApplicationUserProjectsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

export type ApplicationUserRoleChangeNotificationsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<RoleChangeNotificationCondition>;
  filter?: InputMaybe<RoleChangeNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<RoleChangeNotificationsOrderBy>>;
};

export type ApplicationUserTasksByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

export type ApplicationUserTenantMonthlyConsumedResourcesByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantMonthlyConsumedResourceCondition>;
  filter?: InputMaybe<TenantMonthlyConsumedResourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantMonthlyConsumedResourcesOrderBy>>;
};

export type ApplicationUserTenantUserMembershipNotificationsByInviterIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantUserMembershipNotificationCondition>;
  filter?: InputMaybe<TenantUserMembershipNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantUserMembershipNotificationsOrderBy>>;
};

export type ApplicationUserTenantUserMembershipNotificationsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantUserMembershipNotificationCondition>;
  filter?: InputMaybe<TenantUserMembershipNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantUserMembershipNotificationsOrderBy>>;
};

export type ApplicationUserToolVersionsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolVersionCondition>;
  filter?: InputMaybe<ToolVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolVersionsOrderBy>>;
};

export type ApplicationUserToolsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolCondition>;
  filter?: InputMaybe<ToolFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolsOrderBy>>;
};

export type ApplicationUserUserOnboardingQuestionResponsesByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<UserOnboardingQuestionResponseCondition>;
  filter?: InputMaybe<UserOnboardingQuestionResponseFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<UserOnboardingQuestionResponsesOrderBy>>;
};

export type ApplicationUserUserPersonalSpaceRequestsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<UserPersonalSpaceRequestCondition>;
  filter?: InputMaybe<UserPersonalSpaceRequestFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<UserPersonalSpaceRequestsOrderBy>>;
};

export type ApplicationUserWorkflowVersionsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowVersionCondition>;
  filter?: InputMaybe<WorkflowVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowVersionsOrderBy>>;
};

export type ApplicationUserWorkflowsByUserIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowCondition>;
  filter?: InputMaybe<WorkflowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowsOrderBy>>;
};

/** The fields on `applicationUser` to look up the row to connect. */
export type ApplicationUserApplicationUserEmailKeyConnect = {
  email: Scalars["String"]["input"];
};

/** The fields on `applicationUser` to look up the row to delete. */
export type ApplicationUserApplicationUserEmailKeyDelete = {
  email: Scalars["String"]["input"];
};

/** The fields on `applicationUser` to look up the row to connect. */
export type ApplicationUserApplicationUserGlobalUserIdKeyConnect = {
  globalUserId: Scalars["UUID"]["input"];
};

/** The fields on `applicationUser` to look up the row to delete. */
export type ApplicationUserApplicationUserGlobalUserIdKeyDelete = {
  globalUserId: Scalars["UUID"]["input"];
};

/** The fields on `applicationUser` to look up the row to connect. */
export type ApplicationUserApplicationUserPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `applicationUser` to look up the row to delete. */
export type ApplicationUserApplicationUserPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `applicationUser` to look up the row to connect. */
export type ApplicationUserApplicationUserUsernameKeyConnect = {
  username: Scalars["String"]["input"];
};

/** The fields on `applicationUser` to look up the row to delete. */
export type ApplicationUserApplicationUserUsernameKeyDelete = {
  username: Scalars["String"]["input"];
};

/** Input for the nested mutation of `tenantUserexecutor` in the `ApplicationUserInput` mutation. */
export type ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput = {
  /** The primary key(s) for `tenantUserexecutor` for the far side of the relationship. */
  connectById?: InputMaybe<TenantUserexecutorTenantUserexecutorPkeyConnect>;
  /** The primary key(s) for `tenantUserexecutor` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantUserexecutorTenantUserexecutorPkeyDelete>;
};

/** Input for the nested mutation of `applicationUser` in the `TenantUserexecutorInput` mutation. */
export type ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInverseInput =
  {
    /** The primary key(s) for `applicationUser` for the far side of the relationship. */
    connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
    /** The primary key(s) for `applicationUser` for the far side of the relationship. */
    connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
    /** The primary key(s) for `applicationUser` for the far side of the relationship. */
    connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
    /** The primary key(s) for `applicationUser` for the far side of the relationship. */
    connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
    /** The primary key(s) for `applicationUser` for the far side of the relationship. */
    deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
    /** The primary key(s) for `applicationUser` for the far side of the relationship. */
    deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
    /** The primary key(s) for `applicationUser` for the far side of the relationship. */
    deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
    /** The primary key(s) for `applicationUser` for the far side of the relationship. */
    deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
    /** Flag indicating whether all other `applicationUser` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

/** A filter to be used against `ApplicationUser` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApplicationUserFilter>>;
  /** Filter by the object’s `applicationUserGroupsByUserId` relation. */
  applicationUserGroupsByUserId?: InputMaybe<ApplicationUserToManyApplicationUserGroupFilter>;
  /** Some related `applicationUserGroupsByUserId` exist. */
  applicationUserGroupsByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `applicationUserMembershipsByUserId` relation. */
  applicationUserMembershipsByUserId?: InputMaybe<ApplicationUserToManyApplicationUserMembershipFilter>;
  /** Some related `applicationUserMembershipsByUserId` exist. */
  applicationUserMembershipsByUserIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `applicationUserMetadataByUserId` relation. */
  applicationUserMetadataByUserId?: InputMaybe<ApplicationUserToManyApplicationUserMetadatumFilter>;
  /** Some related `applicationUserMetadataByUserId` exist. */
  applicationUserMetadataByUserIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `applicationUserSessionsByUserId` relation. */
  applicationUserSessionsByUserId?: InputMaybe<ApplicationUserToManyApplicationUserSessionFilter>;
  /** Some related `applicationUserSessionsByUserId` exist. */
  applicationUserSessionsByUserIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `applicationUserUserPermissionsByUserId` relation. */
  applicationUserUserPermissionsByUserId?: InputMaybe<ApplicationUserToManyApplicationUserUserPermissionFilter>;
  /** Some related `applicationUserUserPermissionsByUserId` exist. */
  applicationUserUserPermissionsByUserIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `auditlogLogentriesByActorId` relation. */
  auditlogLogentriesByActorId?: InputMaybe<ApplicationUserToManyAuditlogLogentryFilter>;
  /** Some related `auditlogLogentriesByActorId` exist. */
  auditlogLogentriesByActorIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `avatarByUserId` relation. */
  avatarByUserId?: InputMaybe<AvatarFilter>;
  /** A related `avatarByUserId` exists. */
  avatarByUserIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `codeFilesByUserId` relation. */
  codeFilesByUserId?: InputMaybe<ApplicationUserToManyCodeFileFilter>;
  /** Some related `codeFilesByUserId` exist. */
  codeFilesByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `cognitoTenantKey` field. */
  cognitoTenantKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `commandsByUserId` relation. */
  commandsByUserId?: InputMaybe<ApplicationUserToManyCommandFilter>;
  /** Some related `commandsByUserId` exist. */
  commandsByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `containerImageRepositoriesByUserId` relation. */
  containerImageRepositoriesByUserId?: InputMaybe<ApplicationUserToManyContainerImageRepositoryFilter>;
  /** Some related `containerImageRepositoriesByUserId` exist. */
  containerImageRepositoriesByUserIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `containerImagesByUserId` relation. */
  containerImagesByUserId?: InputMaybe<ApplicationUserToManyContainerImageFilter>;
  /** Some related `containerImagesByUserId` exist. */
  containerImagesByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dataTableColumnGroupsByUserId` relation. */
  dataTableColumnGroupsByUserId?: InputMaybe<ApplicationUserToManyDataTableColumnGroupFilter>;
  /** Some related `dataTableColumnGroupsByUserId` exist. */
  dataTableColumnGroupsByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dataTableColumnsByUserId` relation. */
  dataTableColumnsByUserId?: InputMaybe<ApplicationUserToManyDataTableColumnFilter>;
  /** Some related `dataTableColumnsByUserId` exist. */
  dataTableColumnsByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dataTableRowsByUserId` relation. */
  dataTableRowsByUserId?: InputMaybe<ApplicationUserToManyDataTableRowFilter>;
  /** Some related `dataTableRowsByUserId` exist. */
  dataTableRowsByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dataTablesByUserId` relation. */
  dataTablesByUserId?: InputMaybe<ApplicationUserToManyDataTableFilter>;
  /** Some related `dataTablesByUserId` exist. */
  dataTablesByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `djangoAdminLogsByUserId` relation. */
  djangoAdminLogsByUserId?: InputMaybe<ApplicationUserToManyDjangoAdminLogFilter>;
  /** Some related `djangoAdminLogsByUserId` exist. */
  djangoAdminLogsByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emailMarketingConsent` field. */
  emailMarketingConsent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `eulaVersionUserAcceptancesByUserId` relation. */
  eulaVersionUserAcceptancesByUserId?: InputMaybe<ApplicationUserToManyEulaVersionUserAcceptanceFilter>;
  /** Some related `eulaVersionUserAcceptancesByUserId` exist. */
  eulaVersionUserAcceptancesByUserIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `featureFlagsUsersByUserId` relation. */
  featureFlagsUsersByUserId?: InputMaybe<ApplicationUserToManyFeatureFlagsUserFilter>;
  /** Some related `featureFlagsUsersByUserId` exist. */
  featureFlagsUsersByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `fileActivitiesByUserId` relation. */
  fileActivitiesByUserId?: InputMaybe<ApplicationUserToManyFileActivityFilter>;
  /** Some related `fileActivitiesByUserId` exist. */
  fileActivitiesByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `fileOutputGroupsByUserId` relation. */
  fileOutputGroupsByUserId?: InputMaybe<ApplicationUserToManyFileOutputGroupFilter>;
  /** Some related `fileOutputGroupsByUserId` exist. */
  fileOutputGroupsByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `fileProcessingNotificationsByUserId` relation. */
  fileProcessingNotificationsByUserId?: InputMaybe<ApplicationUserToManyFileProcessingNotificationFilter>;
  /** Some related `fileProcessingNotificationsByUserId` exist. */
  fileProcessingNotificationsByUserIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `filesByUserId` relation. */
  filesByUserId?: InputMaybe<ApplicationUserToManyFileFilter>;
  /** Some related `filesByUserId` exist. */
  filesByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `gdtAnalysisTableColumnGroupsByUserId` relation. */
  gdtAnalysisTableColumnGroupsByUserId?: InputMaybe<ApplicationUserToManyGdtAnalysisTableColumnGroupFilter>;
  /** Some related `gdtAnalysisTableColumnGroupsByUserId` exist. */
  gdtAnalysisTableColumnGroupsByUserIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `gdtAnalysisTableColumnsByUserId` relation. */
  gdtAnalysisTableColumnsByUserId?: InputMaybe<ApplicationUserToManyGdtAnalysisTableColumnFilter>;
  /** Some related `gdtAnalysisTableColumnsByUserId` exist. */
  gdtAnalysisTableColumnsByUserIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `gdtAnalysisTableRowsByUserId` relation. */
  gdtAnalysisTableRowsByUserId?: InputMaybe<ApplicationUserToManyGdtAnalysisTableRowFilter>;
  /** Some related `gdtAnalysisTableRowsByUserId` exist. */
  gdtAnalysisTableRowsByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `gdtAnalysisTablesByUserId` relation. */
  gdtAnalysisTablesByUserId?: InputMaybe<ApplicationUserToManyGdtAnalysisTableFilter>;
  /** Some related `gdtAnalysisTablesByUserId` exist. */
  gdtAnalysisTablesByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `globalUserId` field. */
  globalUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `homeRegion` field. */
  homeRegion?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `internal` field. */
  internal?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isStaff` field. */
  isStaff?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isSuperuser` field. */
  isSuperuser?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadataValuesByUserId` relation. */
  metadataValuesByUserId?: InputMaybe<ApplicationUserToManyMetadataValueFilter>;
  /** Some related `metadataValuesByUserId` exist. */
  metadataValuesByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Negates the expression. */
  not?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `notificationsByUserId` relation. */
  notificationsByUserId?: InputMaybe<ApplicationUserToManyNotificationFilter>;
  /** Some related `notificationsByUserId` exist. */
  notificationsByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApplicationUserFilter>>;
  /** Filter by the object’s `personalRegion` field. */
  personalRegion?: InputMaybe<StringFilter>;
  /** Filter by the object’s `pinnedToolsByUserId` relation. */
  pinnedToolsByUserId?: InputMaybe<ApplicationUserToManyPinnedToolFilter>;
  /** Some related `pinnedToolsByUserId` exist. */
  pinnedToolsByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `projectClonedNotificationsByUserId` relation. */
  projectClonedNotificationsByUserId?: InputMaybe<ApplicationUserToManyProjectClonedNotificationFilter>;
  /** Some related `projectClonedNotificationsByUserId` exist. */
  projectClonedNotificationsByUserIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `projectFoldersByUserId` relation. */
  projectFoldersByUserId?: InputMaybe<ApplicationUserToManyProjectFolderFilter>;
  /** Some related `projectFoldersByUserId` exist. */
  projectFoldersByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `projectSharedNotificationsBySharerId` relation. */
  projectSharedNotificationsBySharerId?: InputMaybe<ApplicationUserToManyProjectSharedNotificationFilter>;
  /** Some related `projectSharedNotificationsBySharerId` exist. */
  projectSharedNotificationsBySharerIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `projectSharedNotificationsByUserId` relation. */
  projectSharedNotificationsByUserId?: InputMaybe<ApplicationUserToManyProjectSharedNotificationFilter>;
  /** Some related `projectSharedNotificationsByUserId` exist. */
  projectSharedNotificationsByUserIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `projectTagsByUserId` relation. */
  projectTagsByUserId?: InputMaybe<ApplicationUserToManyProjectTagFilter>;
  /** Some related `projectTagsByUserId` exist. */
  projectTagsByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `projectsByUserId` relation. */
  projectsByUserId?: InputMaybe<ApplicationUserToManyProjectFilter>;
  /** Some related `projectsByUserId` exist. */
  projectsByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `roleChangeNotificationsByUserId` relation. */
  roleChangeNotificationsByUserId?: InputMaybe<ApplicationUserToManyRoleChangeNotificationFilter>;
  /** Some related `roleChangeNotificationsByUserId` exist. */
  roleChangeNotificationsByUserIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `tasksByUserId` relation. */
  tasksByUserId?: InputMaybe<ApplicationUserToManyTaskFilter>;
  /** Some related `tasksByUserId` exist. */
  tasksByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `tenantMonthlyConsumedResourcesByUserId` relation. */
  tenantMonthlyConsumedResourcesByUserId?: InputMaybe<ApplicationUserToManyTenantMonthlyConsumedResourceFilter>;
  /** Some related `tenantMonthlyConsumedResourcesByUserId` exist. */
  tenantMonthlyConsumedResourcesByUserIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `tenantUserMembershipNotificationsByInviterId` relation. */
  tenantUserMembershipNotificationsByInviterId?: InputMaybe<ApplicationUserToManyTenantUserMembershipNotificationFilter>;
  /** Some related `tenantUserMembershipNotificationsByInviterId` exist. */
  tenantUserMembershipNotificationsByInviterIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `tenantUserMembershipNotificationsByUserId` relation. */
  tenantUserMembershipNotificationsByUserId?: InputMaybe<ApplicationUserToManyTenantUserMembershipNotificationFilter>;
  /** Some related `tenantUserMembershipNotificationsByUserId` exist. */
  tenantUserMembershipNotificationsByUserIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `toolVersionsByUserId` relation. */
  toolVersionsByUserId?: InputMaybe<ApplicationUserToManyToolVersionFilter>;
  /** Some related `toolVersionsByUserId` exist. */
  toolVersionsByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `toolsByUserId` relation. */
  toolsByUserId?: InputMaybe<ApplicationUserToManyToolFilter>;
  /** Some related `toolsByUserId` exist. */
  toolsByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `userOnboardingQuestionResponsesByUserId` relation. */
  userOnboardingQuestionResponsesByUserId?: InputMaybe<ApplicationUserToManyUserOnboardingQuestionResponseFilter>;
  /** Some related `userOnboardingQuestionResponsesByUserId` exist. */
  userOnboardingQuestionResponsesByUserIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `userOrigin` field. */
  userOrigin?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userPersonalSpaceRequestsByUserId` relation. */
  userPersonalSpaceRequestsByUserId?: InputMaybe<ApplicationUserToManyUserPersonalSpaceRequestFilter>;
  /** Some related `userPersonalSpaceRequestsByUserId` exist. */
  userPersonalSpaceRequestsByUserIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `username` field. */
  username?: InputMaybe<StringFilter>;
  /** Filter by the object’s `workflowVersionsByUserId` relation. */
  workflowVersionsByUserId?: InputMaybe<ApplicationUserToManyWorkflowVersionFilter>;
  /** Some related `workflowVersionsByUserId` exist. */
  workflowVersionsByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `workflowsByUserId` relation. */
  workflowsByUserId?: InputMaybe<ApplicationUserToManyWorkflowFilter>;
  /** Some related `workflowsByUserId` exist. */
  workflowsByUserIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ApplicationUserGroup = {
  __typename: "ApplicationUserGroup";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserGroup`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** Reads a single `AuthGroup` that is related to this `ApplicationUserGroup`. */
  authGroupByGroupId: Maybe<AuthGroup>;
  groupId: Scalars["Int"]["output"];
  id: Scalars["BigInt"]["output"];
  userId: Scalars["UUID"]["output"];
};

/** The fields on `applicationUserGroup` to look up the row to connect. */
export type ApplicationUserGroupApplicationUserGroupsPkeyConnect = {
  id: Scalars["BigInt"]["input"];
};

/** The fields on `applicationUserGroup` to look up the row to delete. */
export type ApplicationUserGroupApplicationUserGroupsPkeyDelete = {
  id: Scalars["BigInt"]["input"];
};

/** The fields on `applicationUserGroup` to look up the row to connect. */
export type ApplicationUserGroupApplicationUserGroupsUserIdGroupId3A20Ace4UniqConnect =
  {
    groupId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUserGroup` to look up the row to delete. */
export type ApplicationUserGroupApplicationUserGroupsUserIdGroupId3A20Ace4UniqDelete =
  {
    groupId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/**
 * A condition to be used against `ApplicationUserGroup` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ApplicationUserGroupCondition = {
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `ApplicationUserGroup` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApplicationUserGroupFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `authGroupByGroupId` relation. */
  authGroupByGroupId?: InputMaybe<AuthGroupFilter>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ApplicationUserGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApplicationUserGroupFilter>>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ApplicationUserGroup` */
export type ApplicationUserGroupInput = {
  applicationUserToUserId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInput>;
  authGroupToGroupId?: InputMaybe<ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInput>;
  groupId?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `applicationUserGroup` to look up the row to update. */
export type ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingApplicationUserGroupsPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUserGroup` being updated. */
    applicationUserGroupPatch: UpdateApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdPatch;
    id: Scalars["BigInt"]["input"];
  };

/** The fields on `applicationUserGroup` to look up the row to update. */
export type ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingApplicationUserGroupsUserIdGroupId3A20Ace4UniqUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUserGroup` being updated. */
    applicationUserGroupPatch: UpdateApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdPatch;
    groupId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUserGroup` to look up the row to update. */
export type ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGroupsPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUserGroup` being updated. */
    applicationUserGroupPatch: UpdateApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdPatch;
    id: Scalars["BigInt"]["input"];
  };

/** The fields on `applicationUserGroup` to look up the row to update. */
export type ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGroupsUserIdGroupId3A20Ace4UniqUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUserGroup` being updated. */
    applicationUserGroupPatch: UpdateApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdPatch;
    groupId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** Represents an update to a `ApplicationUserGroup`. Fields that are set will be updated. */
export type ApplicationUserGroupPatch = {
  applicationUserToUserId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInput>;
  authGroupToGroupId?: InputMaybe<ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInput>;
  groupId?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A connection to a list of `ApplicationUserGroup` values. */
export type ApplicationUserGroupsConnection = {
  __typename: "ApplicationUserGroupsConnection";
  /** A list of edges which contains the `ApplicationUserGroup` and cursor to aid in pagination. */
  edges: Array<ApplicationUserGroupsEdge>;
  /** A list of `ApplicationUserGroup` objects. */
  nodes: Array<ApplicationUserGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ApplicationUserGroup` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ApplicationUserGroup` edge in the connection. */
export type ApplicationUserGroupsEdge = {
  __typename: "ApplicationUserGroupsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ApplicationUserGroup` at the end of the edge. */
  node: ApplicationUserGroup;
};

/** The `applicationUserGroup` to be created by this mutation. */
export type ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdApplicationUserGroupsCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInput>;
    authGroupToGroupId?: InputMaybe<ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** The `authGroup` to be created by this mutation. */
export type ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdAuthGroupCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInverseInput>;
    authGroupPermissionsUsingId?: InputMaybe<AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInverseInput>;
    featureFlagsGroupsUsingId?: InputMaybe<FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name: Scalars["String"]["input"];
  };

/** Input for the nested mutation of `authGroup` in the `ApplicationUserGroupInput` mutation. */
export type ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInput = {
  /** The primary key(s) for `authGroup` for the far side of the relationship. */
  connectById?: InputMaybe<AuthGroupAuthGroupPkeyConnect>;
  /** The primary key(s) for `authGroup` for the far side of the relationship. */
  connectByName?: InputMaybe<AuthGroupAuthGroupNameKeyConnect>;
  /** A `AuthGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdAuthGroupCreateInput>;
  /** The primary key(s) for `authGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<AuthGroupAuthGroupPkeyDelete>;
  /** The primary key(s) for `authGroup` for the far side of the relationship. */
  deleteByName?: InputMaybe<AuthGroupAuthGroupNameKeyDelete>;
  /** The primary key(s) and patch data for `authGroup` for the far side of the relationship. */
  updateById?: InputMaybe<AuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingAuthGroupPkeyUpdate>;
  /** The primary key(s) and patch data for `authGroup` for the far side of the relationship. */
  updateByName?: InputMaybe<AuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingAuthGroupNameKeyUpdate>;
};

/** Input for the nested mutation of `applicationUserGroup` in the `AuthGroupInput` mutation. */
export type ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInverseInput = {
  /** The primary key(s) for `applicationUserGroup` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ApplicationUserGroupApplicationUserGroupsPkeyConnect>
  >;
  /** The primary key(s) for `applicationUserGroup` for the far side of the relationship. */
  connectByUserIdAndGroupId?: InputMaybe<
    Array<ApplicationUserGroupApplicationUserGroupsUserIdGroupId3A20Ace4UniqConnect>
  >;
  /** A `ApplicationUserGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdApplicationUserGroupsCreateInput>
  >;
  /** The primary key(s) for `applicationUserGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<ApplicationUserGroupApplicationUserGroupsPkeyDelete>
  >;
  /** The primary key(s) for `applicationUserGroup` for the far side of the relationship. */
  deleteByUserIdAndGroupId?: InputMaybe<
    Array<ApplicationUserGroupApplicationUserGroupsUserIdGroupId3A20Ace4UniqDelete>
  >;
  /** Flag indicating whether all other `applicationUserGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `applicationUserGroup` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingApplicationUserGroupsPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `applicationUserGroup` for the far side of the relationship. */
  updateByUserIdAndGroupId?: InputMaybe<
    Array<ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingApplicationUserGroupsUserIdGroupId3A20Ace4UniqUpdate>
  >;
};

/** Methods to use when ordering `ApplicationUserGroup`. */
export enum ApplicationUserGroupsOrderBy {
  GroupIdAsc = "GROUP_ID_ASC",
  GroupIdDesc = "GROUP_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** The `applicationUser` to be created by this mutation. */
export type ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** The `applicationUserGroup` to be created by this mutation. */
export type ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdApplicationUserGroupsCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInput>;
    authGroupToGroupId?: InputMaybe<ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInput>;
    groupId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
  };

/** Input for the nested mutation of `applicationUser` in the `ApplicationUserGroupInput` mutation. */
export type ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `applicationUserGroup` in the `ApplicationUserInput` mutation. */
export type ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput =
  {
    /** The primary key(s) for `applicationUserGroup` for the far side of the relationship. */
    connectById?: InputMaybe<
      Array<ApplicationUserGroupApplicationUserGroupsPkeyConnect>
    >;
    /** The primary key(s) for `applicationUserGroup` for the far side of the relationship. */
    connectByUserIdAndGroupId?: InputMaybe<
      Array<ApplicationUserGroupApplicationUserGroupsUserIdGroupId3A20Ace4UniqConnect>
    >;
    /** A `ApplicationUserGroupInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdApplicationUserGroupsCreateInput>
    >;
    /** The primary key(s) for `applicationUserGroup` for the far side of the relationship. */
    deleteById?: InputMaybe<
      Array<ApplicationUserGroupApplicationUserGroupsPkeyDelete>
    >;
    /** The primary key(s) for `applicationUserGroup` for the far side of the relationship. */
    deleteByUserIdAndGroupId?: InputMaybe<
      Array<ApplicationUserGroupApplicationUserGroupsUserIdGroupId3A20Ace4UniqDelete>
    >;
    /** Flag indicating whether all other `applicationUserGroup` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The primary key(s) and patch data for `applicationUserGroup` for the far side of the relationship. */
    updateById?: InputMaybe<
      Array<ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGroupsPkeyUpdate>
    >;
    /** The primary key(s) and patch data for `applicationUserGroup` for the far side of the relationship. */
    updateByUserIdAndGroupId?: InputMaybe<
      Array<ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGroupsUserIdGroupId3A20Ace4UniqUpdate>
    >;
  };

/** An input for mutations affecting `ApplicationUser` */
export type ApplicationUserInput = {
  applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
  auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
  commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
  dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
  dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
  email: Scalars["String"]["input"];
  emailMarketingConsent: Scalars["Boolean"]["input"];
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  executorId?: InputMaybe<Scalars["Int"]["input"]>;
  featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName: Scalars["String"]["input"];
  gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
  gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  homeRegion?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  internal: Scalars["Boolean"]["input"];
  isActive: Scalars["Boolean"]["input"];
  isStaff: Scalars["Boolean"]["input"];
  isSuperuser: Scalars["Boolean"]["input"];
  lastName: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars["String"]["input"]>;
  pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
  userOrigin: Scalars["String"]["input"];
  userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
  username: Scalars["String"]["input"];
  workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
};

/** The `applicationUser` to be created by this mutation. */
export type ApplicationUserMemUserId631Fddc5FkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** The `applicationUserMembership` to be created by this mutation. */
export type ApplicationUserMemUserId631Fddc5FkApplicatiApplicationUserMembershipCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    role: Scalars["Int"]["input"];
    sfLeadCreated: Scalars["Boolean"]["input"];
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `ApplicationUserMembershipInput` mutation. */
export type ApplicationUserMemUserId631Fddc5FkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `applicationUserMembership` in the `ApplicationUserInput` mutation. */
export type ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput = {
  /** The primary key(s) for `applicationUserMembership` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ApplicationUserMembershipApplicationUserMembershipPkeyConnect>
  >;
  /** The primary key(s) for `applicationUserMembership` for the far side of the relationship. */
  connectByUserIdAndTenantId?: InputMaybe<
    Array<ApplicationUserMembershipUserTenantUniqueConnect>
  >;
  /** A `ApplicationUserMembershipInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ApplicationUserMemUserId631Fddc5FkApplicatiApplicationUserMembershipCreateInput>
  >;
  /** The primary key(s) for `applicationUserMembership` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<ApplicationUserMembershipApplicationUserMembershipPkeyDelete>
  >;
  /** The primary key(s) for `applicationUserMembership` for the far side of the relationship. */
  deleteByUserIdAndTenantId?: InputMaybe<
    Array<ApplicationUserMembershipUserTenantUniqueDelete>
  >;
  /** Flag indicating whether all other `applicationUserMembership` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `applicationUserMembership` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserMembershipPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `applicationUserMembership` for the far side of the relationship. */
  updateByUserIdAndTenantId?: InputMaybe<
    Array<ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingUserTenantUniqueUpdate>
  >;
};

export type ApplicationUserMembership = {
  __typename: "ApplicationUserMembership";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserMembership`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  id: Scalars["Int"]["output"];
  role: Scalars["Int"]["output"];
  sfLeadCreated: Scalars["Boolean"]["output"];
  /** Reads a single `Tenant` that is related to this `ApplicationUserMembership`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
  userId: Scalars["UUID"]["output"];
};

/** The fields on `applicationUserMembership` to look up the row to connect. */
export type ApplicationUserMembershipApplicationUserMembershipPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `applicationUserMembership` to look up the row to delete. */
export type ApplicationUserMembershipApplicationUserMembershipPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/**
 * A condition to be used against `ApplicationUserMembership` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ApplicationUserMembershipCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `sfLeadCreated` field. */
  sfLeadCreated?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `ApplicationUserMembership` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserMembershipFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApplicationUserMembershipFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ApplicationUserMembershipFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApplicationUserMembershipFilter>>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sfLeadCreated` field. */
  sfLeadCreated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ApplicationUserMembership` */
export type ApplicationUserMembershipInput = {
  applicationUserToUserId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  role: Scalars["Int"]["input"];
  sfLeadCreated: Scalars["Boolean"]["input"];
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `applicationUserMembership` to look up the row to update. */
export type ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserMembershipPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUserMembership` being updated. */
    applicationUserMembershipPatch: UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `applicationUserMembership` to look up the row to update. */
export type ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingUserTenantUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUserMembership` being updated. */
    applicationUserMembershipPatch: UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
    tenantId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUserMembership` to look up the row to update. */
export type ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingApplicationUserMembershipPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUserMembership` being updated. */
    applicationUserMembershipPatch: UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `applicationUserMembership` to look up the row to update. */
export type ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingUserTenantUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUserMembership` being updated. */
    applicationUserMembershipPatch: UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
    tenantId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** Represents an update to a `ApplicationUserMembership`. Fields that are set will be updated. */
export type ApplicationUserMembershipPatch = {
  applicationUserToUserId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  role?: InputMaybe<Scalars["Int"]["input"]>;
  sfLeadCreated?: InputMaybe<Scalars["Boolean"]["input"]>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `applicationUserMembership` to be created by this mutation. */
export type ApplicationUserMembershipTenantId5E54Da7AFkTenantIdApplicationUserMembershipCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    role: Scalars["Int"]["input"];
    sfLeadCreated: Scalars["Boolean"]["input"];
    tenantToTenantId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** Input for the nested mutation of `tenant` in the `ApplicationUserMembershipInput` mutation. */
export type ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `applicationUserMembership` in the `TenantInput` mutation. */
export type ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput = {
  /** The primary key(s) for `applicationUserMembership` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ApplicationUserMembershipApplicationUserMembershipPkeyConnect>
  >;
  /** The primary key(s) for `applicationUserMembership` for the far side of the relationship. */
  connectByUserIdAndTenantId?: InputMaybe<
    Array<ApplicationUserMembershipUserTenantUniqueConnect>
  >;
  /** A `ApplicationUserMembershipInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdApplicationUserMembershipCreateInput>
  >;
  /** The primary key(s) for `applicationUserMembership` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<ApplicationUserMembershipApplicationUserMembershipPkeyDelete>
  >;
  /** The primary key(s) for `applicationUserMembership` for the far side of the relationship. */
  deleteByUserIdAndTenantId?: InputMaybe<
    Array<ApplicationUserMembershipUserTenantUniqueDelete>
  >;
  /** Flag indicating whether all other `applicationUserMembership` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `applicationUserMembership` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingApplicationUserMembershipPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `applicationUserMembership` for the far side of the relationship. */
  updateByUserIdAndTenantId?: InputMaybe<
    Array<ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingUserTenantUniqueUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type ApplicationUserMembershipTenantId5E54Da7AFkTenantIdTenantCreateInput =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal: Scalars["Boolean"]["input"];
    key: Scalars["String"]["input"];
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name: Scalars["String"]["input"];
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName: Scalars["String"]["input"];
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status: Scalars["Int"]["input"];
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType: Scalars["Int"]["input"];
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** The fields on `applicationUserMembership` to look up the row to connect. */
export type ApplicationUserMembershipUserTenantUniqueConnect = {
  tenantId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The fields on `applicationUserMembership` to look up the row to delete. */
export type ApplicationUserMembershipUserTenantUniqueDelete = {
  tenantId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** A connection to a list of `ApplicationUserMembership` values. */
export type ApplicationUserMembershipsConnection = {
  __typename: "ApplicationUserMembershipsConnection";
  /** A list of edges which contains the `ApplicationUserMembership` and cursor to aid in pagination. */
  edges: Array<ApplicationUserMembershipsEdge>;
  /** A list of `ApplicationUserMembership` objects. */
  nodes: Array<ApplicationUserMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ApplicationUserMembership` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ApplicationUserMembership` edge in the connection. */
export type ApplicationUserMembershipsEdge = {
  __typename: "ApplicationUserMembershipsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ApplicationUserMembership` at the end of the edge. */
  node: ApplicationUserMembership;
};

/** Methods to use when ordering `ApplicationUserMembership`. */
export enum ApplicationUserMembershipsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  RoleAsc = "ROLE_ASC",
  RoleDesc = "ROLE_DESC",
  SfLeadCreatedAsc = "SF_LEAD_CREATED_ASC",
  SfLeadCreatedDesc = "SF_LEAD_CREATED_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** The `applicationUser` to be created by this mutation. */
export type ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** The `applicationUserMetadatum` to be created by this mutation. */
export type ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserMetadataCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    key: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
  };

/** Input for the nested mutation of `applicationUser` in the `ApplicationUserMetadatumInput` mutation. */
export type ApplicationUserMetUserId897Fbde1FkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `applicationUserMetadatum` in the `ApplicationUserInput` mutation. */
export type ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput = {
  /** The primary key(s) for `applicationUserMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ApplicationUserMetadatumApplicationUserMetadataPkeyConnect>
  >;
  /** The primary key(s) for `applicationUserMetadatum` for the far side of the relationship. */
  connectByUserIdAndKey?: InputMaybe<
    Array<ApplicationUserMetadatumUserKeyConnect>
  >;
  /** A `ApplicationUserMetadatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserMetadataCreateInput>
  >;
  /** The primary key(s) for `applicationUserMetadatum` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<ApplicationUserMetadatumApplicationUserMetadataPkeyDelete>
  >;
  /** The primary key(s) for `applicationUserMetadatum` for the far side of the relationship. */
  deleteByUserIdAndKey?: InputMaybe<
    Array<ApplicationUserMetadatumUserKeyDelete>
  >;
  /** Flag indicating whether all other `applicationUserMetadatum` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `applicationUserMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserMetadataPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `applicationUserMetadatum` for the far side of the relationship. */
  updateByUserIdAndKey?: InputMaybe<
    Array<ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingUserKeyUpdate>
  >;
};

/** A connection to a list of `ApplicationUserMetadatum` values. */
export type ApplicationUserMetadataConnection = {
  __typename: "ApplicationUserMetadataConnection";
  /** A list of edges which contains the `ApplicationUserMetadatum` and cursor to aid in pagination. */
  edges: Array<ApplicationUserMetadataEdge>;
  /** A list of `ApplicationUserMetadatum` objects. */
  nodes: Array<ApplicationUserMetadatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ApplicationUserMetadatum` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ApplicationUserMetadatum` edge in the connection. */
export type ApplicationUserMetadataEdge = {
  __typename: "ApplicationUserMetadataEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ApplicationUserMetadatum` at the end of the edge. */
  node: ApplicationUserMetadatum;
};

/** Methods to use when ordering `ApplicationUserMetadatum`. */
export enum ApplicationUserMetadataOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  KeyAsc = "KEY_ASC",
  KeyDesc = "KEY_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
  ValueAsc = "VALUE_ASC",
  ValueDesc = "VALUE_DESC",
}

export type ApplicationUserMetadatum = {
  __typename: "ApplicationUserMetadatum";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserMetadatum`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  id: Scalars["Int"]["output"];
  key: Scalars["String"]["output"];
  userId: Scalars["UUID"]["output"];
  value: Scalars["String"]["output"];
};

/** The fields on `applicationUserMetadatum` to look up the row to connect. */
export type ApplicationUserMetadatumApplicationUserMetadataPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `applicationUserMetadatum` to look up the row to delete. */
export type ApplicationUserMetadatumApplicationUserMetadataPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/**
 * A condition to be used against `ApplicationUserMetadatum` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ApplicationUserMetadatumCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars["String"]["input"]>;
};

/** A filter to be used against `ApplicationUserMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserMetadatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApplicationUserMetadatumFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ApplicationUserMetadatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApplicationUserMetadatumFilter>>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `ApplicationUserMetadatum` */
export type ApplicationUserMetadatumInput = {
  applicationUserToUserId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key: Scalars["String"]["input"];
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  value: Scalars["String"]["input"];
};

/** The fields on `applicationUserMetadatum` to look up the row to update. */
export type ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserMetadataPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUserMetadatum` being updated. */
    applicationUserMetadatumPatch: UpdateApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `applicationUserMetadatum` to look up the row to update. */
export type ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingUserKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUserMetadatum` being updated. */
    applicationUserMetadatumPatch: UpdateApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
    key: Scalars["String"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** Represents an update to a `ApplicationUserMetadatum`. Fields that are set will be updated. */
export type ApplicationUserMetadatumPatch = {
  applicationUserToUserId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  value?: InputMaybe<Scalars["String"]["input"]>;
};

/** The fields on `applicationUserMetadatum` to look up the row to connect. */
export type ApplicationUserMetadatumUserKeyConnect = {
  key: Scalars["String"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The fields on `applicationUserMetadatum` to look up the row to delete. */
export type ApplicationUserMetadatumUserKeyDelete = {
  key: Scalars["String"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserEmailKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdPatch;
    email: Scalars["String"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdPatch;
    globalUserId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUser` to look up the row to update. */
export type ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUser` being updated. */
    applicationUserPatch: UpdateApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdPatch;
    username: Scalars["String"]["input"];
  };

/** Represents an update to a `ApplicationUser`. Fields that are set will be updated. */
export type ApplicationUserPatch = {
  applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
  auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
  commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
  dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
  dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  executorId?: InputMaybe<Scalars["Int"]["input"]>;
  featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
  gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  homeRegion?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
  isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars["String"]["input"]>;
  pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
  userOrigin?: InputMaybe<Scalars["String"]["input"]>;
  userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
  username?: InputMaybe<Scalars["String"]["input"]>;
  workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
};

/** The `applicationUser` to be created by this mutation. */
export type ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** The `applicationUserSession` to be created by this mutation. */
export type ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserSessionCreateInput =
  {
    active: Scalars["Boolean"]["input"];
    applicationUserToUserId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInput>;
    datetimeLastActive?: InputMaybe<Scalars["Datetime"]["input"]>;
    id: Scalars["UUID"]["input"];
    lastPath?: InputMaybe<Scalars["String"]["input"]>;
    state?: InputMaybe<Scalars["JSON"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `ApplicationUserSessionInput` mutation. */
export type ApplicationUserSesUserId2Fb30D0CFkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `applicationUserSession` in the `ApplicationUserInput` mutation. */
export type ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput = {
  /** The primary key(s) for `applicationUserSession` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ApplicationUserSessionApplicationUserSessionPkeyConnect>
  >;
  /** A `ApplicationUserSessionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserSessionCreateInput>
  >;
  /** The primary key(s) for `applicationUserSession` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<ApplicationUserSessionApplicationUserSessionPkeyDelete>
  >;
  /** Flag indicating whether all other `applicationUserSession` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `applicationUserSession` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserSessionPkeyUpdate>
  >;
};

export type ApplicationUserSession = {
  __typename: "ApplicationUserSession";
  active: Scalars["Boolean"]["output"];
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserSession`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  datetimeLastActive: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  lastPath: Maybe<Scalars["String"]["output"]>;
  state: Maybe<Scalars["JSON"]["output"]>;
  /** Reads a single `Tenant` that is related to this `ApplicationUserSession`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Maybe<Scalars["Int"]["output"]>;
  userId: Scalars["UUID"]["output"];
};

/** The fields on `applicationUserSession` to look up the row to connect. */
export type ApplicationUserSessionApplicationUserSessionPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `applicationUserSession` to look up the row to delete. */
export type ApplicationUserSessionApplicationUserSessionPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/**
 * A condition to be used against `ApplicationUserSession` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ApplicationUserSessionCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `datetimeLastActive` field. */
  datetimeLastActive?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `lastPath` field. */
  lastPath?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `ApplicationUserSession` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserSessionFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApplicationUserSessionFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `datetimeLastActive` field. */
  datetimeLastActive?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `lastPath` field. */
  lastPath?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ApplicationUserSessionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApplicationUserSessionFilter>>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** A related `tenantByTenantId` exists. */
  tenantByTenantIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ApplicationUserSession` */
export type ApplicationUserSessionInput = {
  active: Scalars["Boolean"]["input"];
  applicationUserToUserId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInput>;
  datetimeLastActive?: InputMaybe<Scalars["Datetime"]["input"]>;
  id: Scalars["UUID"]["input"];
  lastPath?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["JSON"]["input"]>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `applicationUserSession` to look up the row to update. */
export type ApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserSessionPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUserSession` being updated. */
    applicationUserSessionPatch: UpdateApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUserSession` to look up the row to update. */
export type ApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingApplicationUserSessionPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUserSession` being updated. */
    applicationUserSessionPatch: UpdateApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** Represents an update to a `ApplicationUserSession`. Fields that are set will be updated. */
export type ApplicationUserSessionPatch = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  applicationUserToUserId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInput>;
  datetimeLastActive?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  lastPath?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["JSON"]["input"]>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `applicationUserSession` to be created by this mutation. */
export type ApplicationUserSessionTenantId00A81Cc5FkTenantIdApplicationUserSessionCreateInput =
  {
    active: Scalars["Boolean"]["input"];
    applicationUserToUserId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInput>;
    datetimeLastActive?: InputMaybe<Scalars["Datetime"]["input"]>;
    id: Scalars["UUID"]["input"];
    lastPath?: InputMaybe<Scalars["String"]["input"]>;
    state?: InputMaybe<Scalars["JSON"]["input"]>;
    tenantToTenantId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** Input for the nested mutation of `tenant` in the `ApplicationUserSessionInput` mutation. */
export type ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `applicationUserSession` in the `TenantInput` mutation. */
export type ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput = {
  /** The primary key(s) for `applicationUserSession` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ApplicationUserSessionApplicationUserSessionPkeyConnect>
  >;
  /** A `ApplicationUserSessionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ApplicationUserSessionTenantId00A81Cc5FkTenantIdApplicationUserSessionCreateInput>
  >;
  /** The primary key(s) for `applicationUserSession` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<ApplicationUserSessionApplicationUserSessionPkeyDelete>
  >;
  /** Flag indicating whether all other `applicationUserSession` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `applicationUserSession` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingApplicationUserSessionPkeyUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type ApplicationUserSessionTenantId00A81Cc5FkTenantIdTenantCreateInput =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal: Scalars["Boolean"]["input"];
    key: Scalars["String"]["input"];
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name: Scalars["String"]["input"];
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName: Scalars["String"]["input"];
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status: Scalars["Int"]["input"];
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType: Scalars["Int"]["input"];
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** A connection to a list of `ApplicationUserSession` values. */
export type ApplicationUserSessionsConnection = {
  __typename: "ApplicationUserSessionsConnection";
  /** A list of edges which contains the `ApplicationUserSession` and cursor to aid in pagination. */
  edges: Array<ApplicationUserSessionsEdge>;
  /** A list of `ApplicationUserSession` objects. */
  nodes: Array<ApplicationUserSession>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ApplicationUserSession` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ApplicationUserSession` edge in the connection. */
export type ApplicationUserSessionsEdge = {
  __typename: "ApplicationUserSessionsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ApplicationUserSession` at the end of the edge. */
  node: ApplicationUserSession;
};

/** Methods to use when ordering `ApplicationUserSession`. */
export enum ApplicationUserSessionsOrderBy {
  ActiveAsc = "ACTIVE_ASC",
  ActiveDesc = "ACTIVE_DESC",
  DatetimeLastActiveAsc = "DATETIME_LAST_ACTIVE_ASC",
  DatetimeLastActiveDesc = "DATETIME_LAST_ACTIVE_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  LastPathAsc = "LAST_PATH_ASC",
  LastPathDesc = "LAST_PATH_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  StateAsc = "STATE_ASC",
  StateDesc = "STATE_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** A filter to be used against many `ApplicationUserGroup` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyApplicationUserGroupFilter = {
  /** Every related `ApplicationUserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ApplicationUserGroupFilter>;
  /** No related `ApplicationUserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ApplicationUserGroupFilter>;
  /** Some related `ApplicationUserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ApplicationUserGroupFilter>;
};

/** A filter to be used against many `ApplicationUserMembership` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyApplicationUserMembershipFilter = {
  /** Every related `ApplicationUserMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ApplicationUserMembershipFilter>;
  /** No related `ApplicationUserMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ApplicationUserMembershipFilter>;
  /** Some related `ApplicationUserMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ApplicationUserMembershipFilter>;
};

/** A filter to be used against many `ApplicationUserMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyApplicationUserMetadatumFilter = {
  /** Every related `ApplicationUserMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ApplicationUserMetadatumFilter>;
  /** No related `ApplicationUserMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ApplicationUserMetadatumFilter>;
  /** Some related `ApplicationUserMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ApplicationUserMetadatumFilter>;
};

/** A filter to be used against many `ApplicationUserSession` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyApplicationUserSessionFilter = {
  /** Every related `ApplicationUserSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ApplicationUserSessionFilter>;
  /** No related `ApplicationUserSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ApplicationUserSessionFilter>;
  /** Some related `ApplicationUserSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ApplicationUserSessionFilter>;
};

/** A filter to be used against many `ApplicationUserUserPermission` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyApplicationUserUserPermissionFilter = {
  /** Every related `ApplicationUserUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ApplicationUserUserPermissionFilter>;
  /** No related `ApplicationUserUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ApplicationUserUserPermissionFilter>;
  /** Some related `ApplicationUserUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ApplicationUserUserPermissionFilter>;
};

/** A filter to be used against many `AuditlogLogentry` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyAuditlogLogentryFilter = {
  /** Every related `AuditlogLogentry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditlogLogentryFilter>;
  /** No related `AuditlogLogentry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditlogLogentryFilter>;
  /** Some related `AuditlogLogentry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditlogLogentryFilter>;
};

/** A filter to be used against many `CodeFile` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyCodeFileFilter = {
  /** Every related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CodeFileFilter>;
  /** No related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CodeFileFilter>;
  /** Some related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CodeFileFilter>;
};

/** A filter to be used against many `Command` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyCommandFilter = {
  /** Every related `Command` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CommandFilter>;
  /** No related `Command` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CommandFilter>;
  /** Some related `Command` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CommandFilter>;
};

/** A filter to be used against many `ContainerImage` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyContainerImageFilter = {
  /** Every related `ContainerImage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContainerImageFilter>;
  /** No related `ContainerImage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContainerImageFilter>;
  /** Some related `ContainerImage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContainerImageFilter>;
};

/** A filter to be used against many `ContainerImageRepository` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyContainerImageRepositoryFilter = {
  /** Every related `ContainerImageRepository` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContainerImageRepositoryFilter>;
  /** No related `ContainerImageRepository` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContainerImageRepositoryFilter>;
  /** Some related `ContainerImageRepository` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContainerImageRepositoryFilter>;
};

/** A filter to be used against many `DataTableColumn` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyDataTableColumnFilter = {
  /** Every related `DataTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnFilter>;
  /** No related `DataTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnFilter>;
  /** Some related `DataTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnFilter>;
};

/** A filter to be used against many `DataTableColumnGroup` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyDataTableColumnGroupFilter = {
  /** Every related `DataTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnGroupFilter>;
  /** No related `DataTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnGroupFilter>;
  /** Some related `DataTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnGroupFilter>;
};

/** A filter to be used against many `DataTable` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyDataTableFilter = {
  /** Every related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableFilter>;
  /** No related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableFilter>;
  /** Some related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableFilter>;
};

/** A filter to be used against many `DataTableRow` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyDataTableRowFilter = {
  /** Every related `DataTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableRowFilter>;
  /** No related `DataTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableRowFilter>;
  /** Some related `DataTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableRowFilter>;
};

/** A filter to be used against many `DjangoAdminLog` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyDjangoAdminLogFilter = {
  /** Every related `DjangoAdminLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DjangoAdminLogFilter>;
  /** No related `DjangoAdminLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DjangoAdminLogFilter>;
  /** Some related `DjangoAdminLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DjangoAdminLogFilter>;
};

/** A filter to be used against many `EulaVersionUserAcceptance` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyEulaVersionUserAcceptanceFilter = {
  /** Every related `EulaVersionUserAcceptance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EulaVersionUserAcceptanceFilter>;
  /** No related `EulaVersionUserAcceptance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EulaVersionUserAcceptanceFilter>;
  /** Some related `EulaVersionUserAcceptance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EulaVersionUserAcceptanceFilter>;
};

/** A filter to be used against many `FeatureFlagsUser` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyFeatureFlagsUserFilter = {
  /** Every related `FeatureFlagsUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FeatureFlagsUserFilter>;
  /** No related `FeatureFlagsUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FeatureFlagsUserFilter>;
  /** Some related `FeatureFlagsUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FeatureFlagsUserFilter>;
};

/** A filter to be used against many `FileActivity` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyFileActivityFilter = {
  /** Every related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileActivityFilter>;
  /** No related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileActivityFilter>;
  /** Some related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileActivityFilter>;
};

/** A filter to be used against many `File` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyFileFilter = {
  /** Every related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileFilter>;
  /** No related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileFilter>;
  /** Some related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileFilter>;
};

/** A filter to be used against many `FileOutputGroup` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyFileOutputGroupFilter = {
  /** Every related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileOutputGroupFilter>;
  /** No related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileOutputGroupFilter>;
  /** Some related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileOutputGroupFilter>;
};

/** A filter to be used against many `FileProcessingNotification` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyFileProcessingNotificationFilter = {
  /** Every related `FileProcessingNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileProcessingNotificationFilter>;
  /** No related `FileProcessingNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileProcessingNotificationFilter>;
  /** Some related `FileProcessingNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileProcessingNotificationFilter>;
};

/** A filter to be used against many `GdtAnalysisTableColumn` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyGdtAnalysisTableColumnFilter = {
  /** Every related `GdtAnalysisTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableColumnFilter>;
  /** No related `GdtAnalysisTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableColumnFilter>;
  /** Some related `GdtAnalysisTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableColumnFilter>;
};

/** A filter to be used against many `GdtAnalysisTableColumnGroup` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyGdtAnalysisTableColumnGroupFilter = {
  /** Every related `GdtAnalysisTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
  /** No related `GdtAnalysisTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
  /** Some related `GdtAnalysisTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
};

/** A filter to be used against many `GdtAnalysisTable` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyGdtAnalysisTableFilter = {
  /** Every related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableFilter>;
  /** No related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableFilter>;
  /** Some related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableFilter>;
};

/** A filter to be used against many `GdtAnalysisTableRow` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyGdtAnalysisTableRowFilter = {
  /** Every related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** No related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** Some related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableRowFilter>;
};

/** A filter to be used against many `MetadataValue` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyMetadataValueFilter = {
  /** Every related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MetadataValueFilter>;
  /** No related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MetadataValueFilter>;
  /** Some related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MetadataValueFilter>;
};

/** A filter to be used against many `Notification` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyNotificationFilter = {
  /** Every related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationFilter>;
  /** No related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationFilter>;
  /** Some related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationFilter>;
};

/** A filter to be used against many `PinnedTool` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyPinnedToolFilter = {
  /** Every related `PinnedTool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PinnedToolFilter>;
  /** No related `PinnedTool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PinnedToolFilter>;
  /** Some related `PinnedTool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PinnedToolFilter>;
};

/** A filter to be used against many `ProjectClonedNotification` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyProjectClonedNotificationFilter = {
  /** Every related `ProjectClonedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectClonedNotificationFilter>;
  /** No related `ProjectClonedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectClonedNotificationFilter>;
  /** Some related `ProjectClonedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectClonedNotificationFilter>;
};

/** A filter to be used against many `Project` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyProjectFilter = {
  /** Every related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectFilter>;
  /** No related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectFilter>;
  /** Some related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectFilter>;
};

/** A filter to be used against many `ProjectFolder` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyProjectFolderFilter = {
  /** Every related `ProjectFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectFolderFilter>;
  /** No related `ProjectFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectFolderFilter>;
  /** Some related `ProjectFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectFolderFilter>;
};

/** A filter to be used against many `ProjectSharedNotification` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyProjectSharedNotificationFilter = {
  /** Every related `ProjectSharedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectSharedNotificationFilter>;
  /** No related `ProjectSharedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectSharedNotificationFilter>;
  /** Some related `ProjectSharedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectSharedNotificationFilter>;
};

/** A filter to be used against many `ProjectTag` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyProjectTagFilter = {
  /** Every related `ProjectTag` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectTagFilter>;
  /** No related `ProjectTag` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectTagFilter>;
  /** Some related `ProjectTag` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectTagFilter>;
};

/** A filter to be used against many `RoleChangeNotification` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyRoleChangeNotificationFilter = {
  /** Every related `RoleChangeNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoleChangeNotificationFilter>;
  /** No related `RoleChangeNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoleChangeNotificationFilter>;
  /** Some related `RoleChangeNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoleChangeNotificationFilter>;
};

/** A filter to be used against many `Task` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyTaskFilter = {
  /** Every related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskFilter>;
  /** No related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskFilter>;
  /** Some related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskFilter>;
};

/** A filter to be used against many `TenantMonthlyConsumedResource` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyTenantMonthlyConsumedResourceFilter = {
  /** Every related `TenantMonthlyConsumedResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TenantMonthlyConsumedResourceFilter>;
  /** No related `TenantMonthlyConsumedResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TenantMonthlyConsumedResourceFilter>;
  /** Some related `TenantMonthlyConsumedResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TenantMonthlyConsumedResourceFilter>;
};

/** A filter to be used against many `TenantUserMembershipNotification` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyTenantUserMembershipNotificationFilter = {
  /** Every related `TenantUserMembershipNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TenantUserMembershipNotificationFilter>;
  /** No related `TenantUserMembershipNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TenantUserMembershipNotificationFilter>;
  /** Some related `TenantUserMembershipNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TenantUserMembershipNotificationFilter>;
};

/** A filter to be used against many `Tool` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyToolFilter = {
  /** Every related `Tool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolFilter>;
  /** No related `Tool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolFilter>;
  /** Some related `Tool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolFilter>;
};

/** A filter to be used against many `ToolVersion` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyToolVersionFilter = {
  /** Every related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolVersionFilter>;
  /** No related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolVersionFilter>;
  /** Some related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolVersionFilter>;
};

/** A filter to be used against many `UserOnboardingQuestionResponse` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyUserOnboardingQuestionResponseFilter = {
  /** Every related `UserOnboardingQuestionResponse` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserOnboardingQuestionResponseFilter>;
  /** No related `UserOnboardingQuestionResponse` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserOnboardingQuestionResponseFilter>;
  /** Some related `UserOnboardingQuestionResponse` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserOnboardingQuestionResponseFilter>;
};

/** A filter to be used against many `UserPersonalSpaceRequest` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyUserPersonalSpaceRequestFilter = {
  /** Every related `UserPersonalSpaceRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserPersonalSpaceRequestFilter>;
  /** No related `UserPersonalSpaceRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserPersonalSpaceRequestFilter>;
  /** Some related `UserPersonalSpaceRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserPersonalSpaceRequestFilter>;
};

/** A filter to be used against many `Workflow` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyWorkflowFilter = {
  /** Every related `Workflow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkflowFilter>;
  /** No related `Workflow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkflowFilter>;
  /** Some related `Workflow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkflowFilter>;
};

/** A filter to be used against many `WorkflowVersion` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserToManyWorkflowVersionFilter = {
  /** Every related `WorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkflowVersionFilter>;
  /** No related `WorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkflowVersionFilter>;
  /** Some related `WorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkflowVersionFilter>;
};

/** The `applicationUserUserPermission` to be created by this mutation. */
export type ApplicationUserUsePermissionIdDbf9693DFkAuthPermApplicationUserUserPermissionsCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInput>;
    authPermissionToPermissionId?: InputMaybe<ApplicationUserUsePermissionIdDbf9693DFkAuthPermInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** The `authPermission` to be created by this mutation. */
export type ApplicationUserUsePermissionIdDbf9693DFkAuthPermAuthPermissionCreateInput =
  {
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUsePermissionIdDbf9693DFkAuthPermInverseInput>;
    authGroupPermissionsUsingId?: InputMaybe<AuthGroupPermissioPermissionId84C5C92EFkAuthPermInverseInput>;
    codename: Scalars["String"]["input"];
    contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name: Scalars["String"]["input"];
  };

/** Input for the nested mutation of `authPermission` in the `ApplicationUserUserPermissionInput` mutation. */
export type ApplicationUserUsePermissionIdDbf9693DFkAuthPermInput = {
  /** The primary key(s) for `authPermission` for the far side of the relationship. */
  connectByContentTypeIdAndCodename?: InputMaybe<AuthPermissionAuthPermissionContentTypeIdCodename01Ab375AUniqConnect>;
  /** The primary key(s) for `authPermission` for the far side of the relationship. */
  connectById?: InputMaybe<AuthPermissionAuthPermissionPkeyConnect>;
  /** A `AuthPermissionInput` object that will be created and connected to this object. */
  create?: InputMaybe<ApplicationUserUsePermissionIdDbf9693DFkAuthPermAuthPermissionCreateInput>;
  /** The primary key(s) for `authPermission` for the far side of the relationship. */
  deleteByContentTypeIdAndCodename?: InputMaybe<AuthPermissionAuthPermissionContentTypeIdCodename01Ab375AUniqDelete>;
  /** The primary key(s) for `authPermission` for the far side of the relationship. */
  deleteById?: InputMaybe<AuthPermissionAuthPermissionPkeyDelete>;
  /** The primary key(s) and patch data for `authPermission` for the far side of the relationship. */
  updateByContentTypeIdAndCodename?: InputMaybe<AuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate>;
  /** The primary key(s) and patch data for `authPermission` for the far side of the relationship. */
  updateById?: InputMaybe<AuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingAuthPermissionPkeyUpdate>;
};

/** Input for the nested mutation of `applicationUserUserPermission` in the `AuthPermissionInput` mutation. */
export type ApplicationUserUsePermissionIdDbf9693DFkAuthPermInverseInput = {
  /** The primary key(s) for `applicationUserUserPermission` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ApplicationUserUserPermissionApplicationUserUserPermissionsPkeyConnect>
  >;
  /** The primary key(s) for `applicationUserUserPermission` for the far side of the relationship. */
  connectByUserIdAndPermissionId?: InputMaybe<
    Array<ApplicationUserUserPermissionApplicationUserUserPeUserIdPermissionId52D58A70UniqConnect>
  >;
  /** A `ApplicationUserUserPermissionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ApplicationUserUsePermissionIdDbf9693DFkAuthPermApplicationUserUserPermissionsCreateInput>
  >;
  /** The primary key(s) for `applicationUserUserPermission` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<ApplicationUserUserPermissionApplicationUserUserPermissionsPkeyDelete>
  >;
  /** The primary key(s) for `applicationUserUserPermission` for the far side of the relationship. */
  deleteByUserIdAndPermissionId?: InputMaybe<
    Array<ApplicationUserUserPermissionApplicationUserUserPeUserIdPermissionId52D58A70UniqDelete>
  >;
  /** Flag indicating whether all other `applicationUserUserPermission` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `applicationUserUserPermission` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingApplicationUserUserPermissionsPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `applicationUserUserPermission` for the far side of the relationship. */
  updateByUserIdAndPermissionId?: InputMaybe<
    Array<ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingApplicationUserUserPeUserIdPermissionId52D58A70UniqUpdate>
  >;
};

/** The `applicationUser` to be created by this mutation. */
export type ApplicationUserUseUserIdE643F548FkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** The `applicationUserUserPermission` to be created by this mutation. */
export type ApplicationUserUseUserIdE643F548FkApplicatiApplicationUserUserPermissionsCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInput>;
    authPermissionToPermissionId?: InputMaybe<ApplicationUserUsePermissionIdDbf9693DFkAuthPermInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    permissionId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** Input for the nested mutation of `applicationUser` in the `ApplicationUserUserPermissionInput` mutation. */
export type ApplicationUserUseUserIdE643F548FkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `applicationUserUserPermission` in the `ApplicationUserInput` mutation. */
export type ApplicationUserUseUserIdE643F548FkApplicatiInverseInput = {
  /** The primary key(s) for `applicationUserUserPermission` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ApplicationUserUserPermissionApplicationUserUserPermissionsPkeyConnect>
  >;
  /** The primary key(s) for `applicationUserUserPermission` for the far side of the relationship. */
  connectByUserIdAndPermissionId?: InputMaybe<
    Array<ApplicationUserUserPermissionApplicationUserUserPeUserIdPermissionId52D58A70UniqConnect>
  >;
  /** A `ApplicationUserUserPermissionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ApplicationUserUseUserIdE643F548FkApplicatiApplicationUserUserPermissionsCreateInput>
  >;
  /** The primary key(s) for `applicationUserUserPermission` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<ApplicationUserUserPermissionApplicationUserUserPermissionsPkeyDelete>
  >;
  /** The primary key(s) for `applicationUserUserPermission` for the far side of the relationship. */
  deleteByUserIdAndPermissionId?: InputMaybe<
    Array<ApplicationUserUserPermissionApplicationUserUserPeUserIdPermissionId52D58A70UniqDelete>
  >;
  /** Flag indicating whether all other `applicationUserUserPermission` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `applicationUserUserPermission` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUserPermissionsPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `applicationUserUserPermission` for the far side of the relationship. */
  updateByUserIdAndPermissionId?: InputMaybe<
    Array<ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUserPeUserIdPermissionId52D58A70UniqUpdate>
  >;
};

export type ApplicationUserUserPermission = {
  __typename: "ApplicationUserUserPermission";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserUserPermission`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** Reads a single `AuthPermission` that is related to this `ApplicationUserUserPermission`. */
  authPermissionByPermissionId: Maybe<AuthPermission>;
  id: Scalars["BigInt"]["output"];
  permissionId: Scalars["Int"]["output"];
  userId: Scalars["UUID"]["output"];
};

/** The fields on `applicationUserUserPermission` to look up the row to connect. */
export type ApplicationUserUserPermissionApplicationUserUserPeUserIdPermissionId52D58A70UniqConnect =
  {
    permissionId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUserUserPermission` to look up the row to delete. */
export type ApplicationUserUserPermissionApplicationUserUserPeUserIdPermissionId52D58A70UniqDelete =
  {
    permissionId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUserUserPermission` to look up the row to connect. */
export type ApplicationUserUserPermissionApplicationUserUserPermissionsPkeyConnect =
  {
    id: Scalars["BigInt"]["input"];
  };

/** The fields on `applicationUserUserPermission` to look up the row to delete. */
export type ApplicationUserUserPermissionApplicationUserUserPermissionsPkeyDelete =
  {
    id: Scalars["BigInt"]["input"];
  };

/**
 * A condition to be used against `ApplicationUserUserPermission` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ApplicationUserUserPermissionCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `permissionId` field. */
  permissionId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `ApplicationUserUserPermission` object types. All fields are combined with a logical ‘and.’ */
export type ApplicationUserUserPermissionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ApplicationUserUserPermissionFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `authPermissionByPermissionId` relation. */
  authPermissionByPermissionId?: InputMaybe<AuthPermissionFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ApplicationUserUserPermissionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ApplicationUserUserPermissionFilter>>;
  /** Filter by the object’s `permissionId` field. */
  permissionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ApplicationUserUserPermission` */
export type ApplicationUserUserPermissionInput = {
  applicationUserToUserId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInput>;
  authPermissionToPermissionId?: InputMaybe<ApplicationUserUsePermissionIdDbf9693DFkAuthPermInput>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  permissionId?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `applicationUserUserPermission` to look up the row to update. */
export type ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingApplicationUserUserPeUserIdPermissionId52D58A70UniqUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUserUserPermission` being updated. */
    applicationUserUserPermissionPatch: UpdateApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermPatch;
    permissionId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUserUserPermission` to look up the row to update. */
export type ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingApplicationUserUserPermissionsPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUserUserPermission` being updated. */
    applicationUserUserPermissionPatch: UpdateApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermPatch;
    id: Scalars["BigInt"]["input"];
  };

/** The fields on `applicationUserUserPermission` to look up the row to update. */
export type ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUserPeUserIdPermissionId52D58A70UniqUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUserUserPermission` being updated. */
    applicationUserUserPermissionPatch: UpdateApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiPatch;
    permissionId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** The fields on `applicationUserUserPermission` to look up the row to update. */
export type ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUserPermissionsPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `applicationUserUserPermission` being updated. */
    applicationUserUserPermissionPatch: UpdateApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiPatch;
    id: Scalars["BigInt"]["input"];
  };

/** Represents an update to a `ApplicationUserUserPermission`. Fields that are set will be updated. */
export type ApplicationUserUserPermissionPatch = {
  applicationUserToUserId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInput>;
  authPermissionToPermissionId?: InputMaybe<ApplicationUserUsePermissionIdDbf9693DFkAuthPermInput>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  permissionId?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A connection to a list of `ApplicationUserUserPermission` values. */
export type ApplicationUserUserPermissionsConnection = {
  __typename: "ApplicationUserUserPermissionsConnection";
  /** A list of edges which contains the `ApplicationUserUserPermission` and cursor to aid in pagination. */
  edges: Array<ApplicationUserUserPermissionsEdge>;
  /** A list of `ApplicationUserUserPermission` objects. */
  nodes: Array<ApplicationUserUserPermission>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ApplicationUserUserPermission` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ApplicationUserUserPermission` edge in the connection. */
export type ApplicationUserUserPermissionsEdge = {
  __typename: "ApplicationUserUserPermissionsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ApplicationUserUserPermission` at the end of the edge. */
  node: ApplicationUserUserPermission;
};

/** Methods to use when ordering `ApplicationUserUserPermission`. */
export enum ApplicationUserUserPermissionsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PermissionIdAsc = "PERMISSION_ID_ASC",
  PermissionIdDesc = "PERMISSION_ID_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** A `ApplicationUser` edge in the connection. */
export type ApplicationUsersEdge = {
  __typename: "ApplicationUsersEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ApplicationUser` at the end of the edge. */
  node: ApplicationUser;
};

/** Methods to use when ordering `ApplicationUser`. */
export enum ApplicationUsersOrderBy {
  CognitoTenantKeyAsc = "COGNITO_TENANT_KEY_ASC",
  CognitoTenantKeyDesc = "COGNITO_TENANT_KEY_DESC",
  CreatedAsc = "CREATED_ASC",
  CreatedDesc = "CREATED_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  EmailAsc = "EMAIL_ASC",
  EmailDesc = "EMAIL_DESC",
  EmailMarketingConsentAsc = "EMAIL_MARKETING_CONSENT_ASC",
  EmailMarketingConsentDesc = "EMAIL_MARKETING_CONSENT_DESC",
  FirstNameAsc = "FIRST_NAME_ASC",
  FirstNameDesc = "FIRST_NAME_DESC",
  GlobalUserIdAsc = "GLOBAL_USER_ID_ASC",
  GlobalUserIdDesc = "GLOBAL_USER_ID_DESC",
  HomeRegionAsc = "HOME_REGION_ASC",
  HomeRegionDesc = "HOME_REGION_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  InternalAsc = "INTERNAL_ASC",
  InternalDesc = "INTERNAL_DESC",
  IsActiveAsc = "IS_ACTIVE_ASC",
  IsActiveDesc = "IS_ACTIVE_DESC",
  IsStaffAsc = "IS_STAFF_ASC",
  IsStaffDesc = "IS_STAFF_DESC",
  IsSuperuserAsc = "IS_SUPERUSER_ASC",
  IsSuperuserDesc = "IS_SUPERUSER_DESC",
  LastNameAsc = "LAST_NAME_ASC",
  LastNameDesc = "LAST_NAME_DESC",
  Natural = "NATURAL",
  PersonalRegionAsc = "PERSONAL_REGION_ASC",
  PersonalRegionDesc = "PERSONAL_REGION_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  UsernameAsc = "USERNAME_ASC",
  UsernameDesc = "USERNAME_DESC",
  UserOriginAsc = "USER_ORIGIN_ASC",
  UserOriginDesc = "USER_ORIGIN_DESC",
}

/** A connection to a list of `AuditlogLogentry` values. */
export type AuditlogLogentriesConnection = {
  __typename: "AuditlogLogentriesConnection";
  /** A list of edges which contains the `AuditlogLogentry` and cursor to aid in pagination. */
  edges: Array<AuditlogLogentriesEdge>;
  /** A list of `AuditlogLogentry` objects. */
  nodes: Array<AuditlogLogentry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuditlogLogentry` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `AuditlogLogentry` edge in the connection. */
export type AuditlogLogentriesEdge = {
  __typename: "AuditlogLogentriesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AuditlogLogentry` at the end of the edge. */
  node: AuditlogLogentry;
};

/** Methods to use when ordering `AuditlogLogentry`. */
export enum AuditlogLogentriesOrderBy {
  ActionAsc = "ACTION_ASC",
  ActionDesc = "ACTION_DESC",
  ActorEmailAsc = "ACTOR_EMAIL_ASC",
  ActorEmailDesc = "ACTOR_EMAIL_DESC",
  ActorIdAsc = "ACTOR_ID_ASC",
  ActorIdDesc = "ACTOR_ID_DESC",
  AdditionalDataAsc = "ADDITIONAL_DATA_ASC",
  AdditionalDataDesc = "ADDITIONAL_DATA_DESC",
  ChangesAsc = "CHANGES_ASC",
  ChangesDesc = "CHANGES_DESC",
  ChangesTextAsc = "CHANGES_TEXT_ASC",
  ChangesTextDesc = "CHANGES_TEXT_DESC",
  CidAsc = "CID_ASC",
  CidDesc = "CID_DESC",
  ContentTypeIdAsc = "CONTENT_TYPE_ID_ASC",
  ContentTypeIdDesc = "CONTENT_TYPE_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  ObjectIdAsc = "OBJECT_ID_ASC",
  ObjectIdDesc = "OBJECT_ID_DESC",
  ObjectPkAsc = "OBJECT_PK_ASC",
  ObjectPkDesc = "OBJECT_PK_DESC",
  ObjectReprAsc = "OBJECT_REPR_ASC",
  ObjectReprDesc = "OBJECT_REPR_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  RemoteAddrAsc = "REMOTE_ADDR_ASC",
  RemoteAddrDesc = "REMOTE_ADDR_DESC",
  RemotePortAsc = "REMOTE_PORT_ASC",
  RemotePortDesc = "REMOTE_PORT_DESC",
  SerializedDataAsc = "SERIALIZED_DATA_ASC",
  SerializedDataDesc = "SERIALIZED_DATA_DESC",
  TimestampAsc = "TIMESTAMP_ASC",
  TimestampDesc = "TIMESTAMP_DESC",
}

export type AuditlogLogentry = {
  __typename: "AuditlogLogentry";
  action: Scalars["Int"]["output"];
  actorEmail: Maybe<Scalars["String"]["output"]>;
  actorId: Maybe<Scalars["UUID"]["output"]>;
  additionalData: Maybe<Scalars["JSON"]["output"]>;
  /** Reads a single `ApplicationUser` that is related to this `AuditlogLogentry`. */
  applicationUserByActorId: Maybe<ApplicationUser>;
  changes: Maybe<Scalars["JSON"]["output"]>;
  changesText: Scalars["String"]["output"];
  cid: Maybe<Scalars["String"]["output"]>;
  contentTypeId: Scalars["Int"]["output"];
  /** Reads a single `DjangoContentType` that is related to this `AuditlogLogentry`. */
  djangoContentTypeByContentTypeId: Maybe<DjangoContentType>;
  id: Scalars["Int"]["output"];
  objectId: Maybe<Scalars["BigInt"]["output"]>;
  objectPk: Scalars["String"]["output"];
  objectRepr: Scalars["String"]["output"];
  remoteAddr: Maybe<Scalars["InternetAddress"]["output"]>;
  remotePort: Maybe<Scalars["Int"]["output"]>;
  serializedData: Maybe<Scalars["JSON"]["output"]>;
  timestamp: Scalars["Datetime"]["output"];
};

/** The `applicationUser` to be created by this mutation. */
export type AuditlogLogentryActorId959271D2FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** The `auditlogLogentry` to be created by this mutation. */
export type AuditlogLogentryActorId959271D2FkApplicationUserIdAuditlogLogentryCreateInput =
  {
    action: Scalars["Int"]["input"];
    actorEmail?: InputMaybe<Scalars["String"]["input"]>;
    additionalData?: InputMaybe<Scalars["JSON"]["input"]>;
    applicationUserToActorId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInput>;
    changes?: InputMaybe<Scalars["JSON"]["input"]>;
    changesText: Scalars["String"]["input"];
    cid?: InputMaybe<Scalars["String"]["input"]>;
    contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    objectId?: InputMaybe<Scalars["BigInt"]["input"]>;
    objectPk: Scalars["String"]["input"];
    objectRepr: Scalars["String"]["input"];
    remoteAddr?: InputMaybe<Scalars["InternetAddress"]["input"]>;
    remotePort?: InputMaybe<Scalars["Int"]["input"]>;
    serializedData?: InputMaybe<Scalars["JSON"]["input"]>;
    timestamp: Scalars["Datetime"]["input"];
  };

/** Input for the nested mutation of `applicationUser` in the `AuditlogLogentryInput` mutation. */
export type AuditlogLogentryActorId959271D2FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `auditlogLogentry` in the `ApplicationUserInput` mutation. */
export type AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `auditlogLogentry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuditlogLogentryAuditlogLogentryPkeyConnect>>;
  /** A `AuditlogLogentryInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuditlogLogentryActorId959271D2FkApplicationUserIdAuditlogLogentryCreateInput>
  >;
  /** The primary key(s) for `auditlogLogentry` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AuditlogLogentryAuditlogLogentryPkeyDelete>>;
  /** Flag indicating whether all other `auditlogLogentry` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `auditlogLogentry` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditlogLogentryOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingAuditlogLogentryPkeyUpdate>
  >;
};

/** The fields on `auditlogLogentry` to look up the row to connect. */
export type AuditlogLogentryAuditlogLogentryPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `auditlogLogentry` to look up the row to delete. */
export type AuditlogLogentryAuditlogLogentryPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/**
 * A condition to be used against `AuditlogLogentry` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AuditlogLogentryCondition = {
  /** Checks for equality with the object’s `action` field. */
  action?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `actorEmail` field. */
  actorEmail?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `actorId` field. */
  actorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `additionalData` field. */
  additionalData?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `changes` field. */
  changes?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `changesText` field. */
  changesText?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `cid` field. */
  cid?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `contentTypeId` field. */
  contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `objectId` field. */
  objectId?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `objectPk` field. */
  objectPk?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `objectRepr` field. */
  objectRepr?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `remoteAddr` field. */
  remoteAddr?: InputMaybe<Scalars["InternetAddress"]["input"]>;
  /** Checks for equality with the object’s `remotePort` field. */
  remotePort?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `serializedData` field. */
  serializedData?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** The `auditlogLogentry` to be created by this mutation. */
export type AuditlogLogentryContentTypeId75830218FkDjangoCoAuditlogLogentryCreateInput =
  {
    action: Scalars["Int"]["input"];
    actorEmail?: InputMaybe<Scalars["String"]["input"]>;
    actorId?: InputMaybe<Scalars["UUID"]["input"]>;
    additionalData?: InputMaybe<Scalars["JSON"]["input"]>;
    applicationUserToActorId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInput>;
    changes?: InputMaybe<Scalars["JSON"]["input"]>;
    changesText: Scalars["String"]["input"];
    cid?: InputMaybe<Scalars["String"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    objectId?: InputMaybe<Scalars["BigInt"]["input"]>;
    objectPk: Scalars["String"]["input"];
    objectRepr: Scalars["String"]["input"];
    remoteAddr?: InputMaybe<Scalars["InternetAddress"]["input"]>;
    remotePort?: InputMaybe<Scalars["Int"]["input"]>;
    serializedData?: InputMaybe<Scalars["JSON"]["input"]>;
    timestamp: Scalars["Datetime"]["input"];
  };

/** The `djangoContentType` to be created by this mutation. */
export type AuditlogLogentryContentTypeId75830218FkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `AuditlogLogentryInput` mutation. */
export type AuditlogLogentryContentTypeId75830218FkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `auditlogLogentry` in the `DjangoContentTypeInput` mutation. */
export type AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput = {
  /** The primary key(s) for `auditlogLogentry` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuditlogLogentryAuditlogLogentryPkeyConnect>>;
  /** A `AuditlogLogentryInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuditlogLogentryContentTypeId75830218FkDjangoCoAuditlogLogentryCreateInput>
  >;
  /** The primary key(s) for `auditlogLogentry` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AuditlogLogentryAuditlogLogentryPkeyDelete>>;
  /** Flag indicating whether all other `auditlogLogentry` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `auditlogLogentry` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuditlogLogentryOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingAuditlogLogentryPkeyUpdate>
  >;
};

/** A filter to be used against `AuditlogLogentry` object types. All fields are combined with a logical ‘and.’ */
export type AuditlogLogentryFilter = {
  /** Filter by the object’s `action` field. */
  action?: InputMaybe<IntFilter>;
  /** Filter by the object’s `actorEmail` field. */
  actorEmail?: InputMaybe<StringFilter>;
  /** Filter by the object’s `actorId` field. */
  actorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `additionalData` field. */
  additionalData?: InputMaybe<JsonFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuditlogLogentryFilter>>;
  /** Filter by the object’s `applicationUserByActorId` relation. */
  applicationUserByActorId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByActorId` exists. */
  applicationUserByActorIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `changes` field. */
  changes?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `changesText` field. */
  changesText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cid` field. */
  cid?: InputMaybe<StringFilter>;
  /** Filter by the object’s `contentTypeId` field. */
  contentTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `djangoContentTypeByContentTypeId` relation. */
  djangoContentTypeByContentTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuditlogLogentryFilter>;
  /** Filter by the object’s `objectId` field. */
  objectId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `objectPk` field. */
  objectPk?: InputMaybe<StringFilter>;
  /** Filter by the object’s `objectRepr` field. */
  objectRepr?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuditlogLogentryFilter>>;
  /** Filter by the object’s `remoteAddr` field. */
  remoteAddr?: InputMaybe<InternetAddressFilter>;
  /** Filter by the object’s `remotePort` field. */
  remotePort?: InputMaybe<IntFilter>;
  /** Filter by the object’s `serializedData` field. */
  serializedData?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `AuditlogLogentry` */
export type AuditlogLogentryInput = {
  action: Scalars["Int"]["input"];
  actorEmail?: InputMaybe<Scalars["String"]["input"]>;
  actorId?: InputMaybe<Scalars["UUID"]["input"]>;
  additionalData?: InputMaybe<Scalars["JSON"]["input"]>;
  applicationUserToActorId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInput>;
  changes?: InputMaybe<Scalars["JSON"]["input"]>;
  changesText: Scalars["String"]["input"];
  cid?: InputMaybe<Scalars["String"]["input"]>;
  contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  djangoContentTypeToContentTypeId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  objectId?: InputMaybe<Scalars["BigInt"]["input"]>;
  objectPk: Scalars["String"]["input"];
  objectRepr: Scalars["String"]["input"];
  remoteAddr?: InputMaybe<Scalars["InternetAddress"]["input"]>;
  remotePort?: InputMaybe<Scalars["Int"]["input"]>;
  serializedData?: InputMaybe<Scalars["JSON"]["input"]>;
  timestamp: Scalars["Datetime"]["input"];
};

/** The fields on `auditlogLogentry` to look up the row to update. */
export type AuditlogLogentryOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingAuditlogLogentryPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `auditlogLogentry` being updated. */
    auditlogLogentryPatch: UpdateAuditlogLogentryOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `auditlogLogentry` to look up the row to update. */
export type AuditlogLogentryOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingAuditlogLogentryPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `auditlogLogentry` being updated. */
    auditlogLogentryPatch: UpdateAuditlogLogentryOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** Represents an update to a `AuditlogLogentry`. Fields that are set will be updated. */
export type AuditlogLogentryPatch = {
  action?: InputMaybe<Scalars["Int"]["input"]>;
  actorEmail?: InputMaybe<Scalars["String"]["input"]>;
  actorId?: InputMaybe<Scalars["UUID"]["input"]>;
  additionalData?: InputMaybe<Scalars["JSON"]["input"]>;
  applicationUserToActorId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInput>;
  changes?: InputMaybe<Scalars["JSON"]["input"]>;
  changesText?: InputMaybe<Scalars["String"]["input"]>;
  cid?: InputMaybe<Scalars["String"]["input"]>;
  contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  djangoContentTypeToContentTypeId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  objectId?: InputMaybe<Scalars["BigInt"]["input"]>;
  objectPk?: InputMaybe<Scalars["String"]["input"]>;
  objectRepr?: InputMaybe<Scalars["String"]["input"]>;
  remoteAddr?: InputMaybe<Scalars["InternetAddress"]["input"]>;
  remotePort?: InputMaybe<Scalars["Int"]["input"]>;
  serializedData?: InputMaybe<Scalars["JSON"]["input"]>;
  timestamp?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type AuthGroup = {
  __typename: "AuthGroup";
  /** Reads and enables pagination through a set of `ApplicationUserGroup`. */
  applicationUserGroupsByGroupId: ApplicationUserGroupsConnection;
  /** Reads and enables pagination through a set of `AuthGroupPermission`. */
  authGroupPermissionsByGroupId: AuthGroupPermissionsConnection;
  /** Reads and enables pagination through a set of `FeatureFlagsGroup`. */
  featureFlagsGroupsByGroupId: FeatureFlagsGroupsConnection;
  id: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
};

export type AuthGroupApplicationUserGroupsByGroupIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserGroupCondition>;
  filter?: InputMaybe<ApplicationUserGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserGroupsOrderBy>>;
};

export type AuthGroupAuthGroupPermissionsByGroupIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuthGroupPermissionCondition>;
  filter?: InputMaybe<AuthGroupPermissionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuthGroupPermissionsOrderBy>>;
};

export type AuthGroupFeatureFlagsGroupsByGroupIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FeatureFlagsGroupCondition>;
  filter?: InputMaybe<FeatureFlagsGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FeatureFlagsGroupsOrderBy>>;
};

/** The fields on `authGroup` to look up the row to connect. */
export type AuthGroupAuthGroupNameKeyConnect = {
  name: Scalars["String"]["input"];
};

/** The fields on `authGroup` to look up the row to delete. */
export type AuthGroupAuthGroupNameKeyDelete = {
  name: Scalars["String"]["input"];
};

/** The fields on `authGroup` to look up the row to connect. */
export type AuthGroupAuthGroupPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `authGroup` to look up the row to delete. */
export type AuthGroupAuthGroupPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/**
 * A condition to be used against `AuthGroup` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AuthGroupCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** A filter to be used against `AuthGroup` object types. All fields are combined with a logical ‘and.’ */
export type AuthGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuthGroupFilter>>;
  /** Filter by the object’s `applicationUserGroupsByGroupId` relation. */
  applicationUserGroupsByGroupId?: InputMaybe<AuthGroupToManyApplicationUserGroupFilter>;
  /** Some related `applicationUserGroupsByGroupId` exist. */
  applicationUserGroupsByGroupIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `authGroupPermissionsByGroupId` relation. */
  authGroupPermissionsByGroupId?: InputMaybe<AuthGroupToManyAuthGroupPermissionFilter>;
  /** Some related `authGroupPermissionsByGroupId` exist. */
  authGroupPermissionsByGroupIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `featureFlagsGroupsByGroupId` relation. */
  featureFlagsGroupsByGroupId?: InputMaybe<AuthGroupToManyFeatureFlagsGroupFilter>;
  /** Some related `featureFlagsGroupsByGroupId` exist. */
  featureFlagsGroupsByGroupIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuthGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuthGroupFilter>>;
};

/** An input for mutations affecting `AuthGroup` */
export type AuthGroupInput = {
  applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInverseInput>;
  authGroupPermissionsUsingId?: InputMaybe<AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInverseInput>;
  featureFlagsGroupsUsingId?: InputMaybe<FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
};

/** The fields on `authGroup` to look up the row to update. */
export type AuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingAuthGroupNameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `authGroup` being updated. */
    authGroupPatch: UpdateAuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdPatch;
    name: Scalars["String"]["input"];
  };

/** The fields on `authGroup` to look up the row to update. */
export type AuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingAuthGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `authGroup` being updated. */
    authGroupPatch: UpdateAuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `authGroup` to look up the row to update. */
export type AuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupNameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `authGroup` being updated. */
    authGroupPatch: UpdateAuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdPatch;
    name: Scalars["String"]["input"];
  };

/** The fields on `authGroup` to look up the row to update. */
export type AuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `authGroup` being updated. */
    authGroupPatch: UpdateAuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `authGroup` to look up the row to update. */
export type AuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingAuthGroupNameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `authGroup` being updated. */
    authGroupPatch: UpdateAuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdPatch;
    name: Scalars["String"]["input"];
  };

/** The fields on `authGroup` to look up the row to update. */
export type AuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingAuthGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `authGroup` being updated. */
    authGroupPatch: UpdateAuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdPatch;
    id: Scalars["Int"]["input"];
  };

/** Represents an update to a `AuthGroup`. Fields that are set will be updated. */
export type AuthGroupPatch = {
  applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInverseInput>;
  authGroupPermissionsUsingId?: InputMaybe<AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInverseInput>;
  featureFlagsGroupsUsingId?: InputMaybe<FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** The `authGroupPermission` to be created by this mutation. */
export type AuthGroupPermissioPermissionId84C5C92EFkAuthPermAuthGroupPermissionsCreateInput =
  {
    authGroupToGroupId?: InputMaybe<AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInput>;
    authPermissionToPermissionId?: InputMaybe<AuthGroupPermissioPermissionId84C5C92EFkAuthPermInput>;
    groupId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
  };

/** The `authPermission` to be created by this mutation. */
export type AuthGroupPermissioPermissionId84C5C92EFkAuthPermAuthPermissionCreateInput =
  {
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUsePermissionIdDbf9693DFkAuthPermInverseInput>;
    authGroupPermissionsUsingId?: InputMaybe<AuthGroupPermissioPermissionId84C5C92EFkAuthPermInverseInput>;
    codename: Scalars["String"]["input"];
    contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name: Scalars["String"]["input"];
  };

/** Input for the nested mutation of `authPermission` in the `AuthGroupPermissionInput` mutation. */
export type AuthGroupPermissioPermissionId84C5C92EFkAuthPermInput = {
  /** The primary key(s) for `authPermission` for the far side of the relationship. */
  connectByContentTypeIdAndCodename?: InputMaybe<AuthPermissionAuthPermissionContentTypeIdCodename01Ab375AUniqConnect>;
  /** The primary key(s) for `authPermission` for the far side of the relationship. */
  connectById?: InputMaybe<AuthPermissionAuthPermissionPkeyConnect>;
  /** A `AuthPermissionInput` object that will be created and connected to this object. */
  create?: InputMaybe<AuthGroupPermissioPermissionId84C5C92EFkAuthPermAuthPermissionCreateInput>;
  /** The primary key(s) for `authPermission` for the far side of the relationship. */
  deleteByContentTypeIdAndCodename?: InputMaybe<AuthPermissionAuthPermissionContentTypeIdCodename01Ab375AUniqDelete>;
  /** The primary key(s) for `authPermission` for the far side of the relationship. */
  deleteById?: InputMaybe<AuthPermissionAuthPermissionPkeyDelete>;
  /** The primary key(s) and patch data for `authPermission` for the far side of the relationship. */
  updateByContentTypeIdAndCodename?: InputMaybe<AuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate>;
  /** The primary key(s) and patch data for `authPermission` for the far side of the relationship. */
  updateById?: InputMaybe<AuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthPermissionPkeyUpdate>;
};

/** Input for the nested mutation of `authGroupPermission` in the `AuthPermissionInput` mutation. */
export type AuthGroupPermissioPermissionId84C5C92EFkAuthPermInverseInput = {
  /** The primary key(s) for `authGroupPermission` for the far side of the relationship. */
  connectByGroupIdAndPermissionId?: InputMaybe<
    Array<AuthGroupPermissionAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqConnect>
  >;
  /** The primary key(s) for `authGroupPermission` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<AuthGroupPermissionAuthGroupPermissionsPkeyConnect>
  >;
  /** A `AuthGroupPermissionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuthGroupPermissioPermissionId84C5C92EFkAuthPermAuthGroupPermissionsCreateInput>
  >;
  /** The primary key(s) for `authGroupPermission` for the far side of the relationship. */
  deleteByGroupIdAndPermissionId?: InputMaybe<
    Array<AuthGroupPermissionAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqDelete>
  >;
  /** The primary key(s) for `authGroupPermission` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<AuthGroupPermissionAuthGroupPermissionsPkeyDelete>
  >;
  /** Flag indicating whether all other `authGroupPermission` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `authGroupPermission` for the far side of the relationship. */
  updateByGroupIdAndPermissionId?: InputMaybe<
    Array<AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqUpdate>
  >;
  /** The primary key(s) and patch data for `authGroupPermission` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthGroupPermissionsPkeyUpdate>
  >;
};

export type AuthGroupPermission = {
  __typename: "AuthGroupPermission";
  /** Reads a single `AuthGroup` that is related to this `AuthGroupPermission`. */
  authGroupByGroupId: Maybe<AuthGroup>;
  /** Reads a single `AuthPermission` that is related to this `AuthGroupPermission`. */
  authPermissionByPermissionId: Maybe<AuthPermission>;
  groupId: Scalars["Int"]["output"];
  id: Scalars["BigInt"]["output"];
  permissionId: Scalars["Int"]["output"];
};

/** The fields on `authGroupPermission` to look up the row to connect. */
export type AuthGroupPermissionAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqConnect =
  {
    groupId: Scalars["Int"]["input"];
    permissionId: Scalars["Int"]["input"];
  };

/** The fields on `authGroupPermission` to look up the row to delete. */
export type AuthGroupPermissionAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqDelete =
  {
    groupId: Scalars["Int"]["input"];
    permissionId: Scalars["Int"]["input"];
  };

/** The fields on `authGroupPermission` to look up the row to connect. */
export type AuthGroupPermissionAuthGroupPermissionsPkeyConnect = {
  id: Scalars["BigInt"]["input"];
};

/** The fields on `authGroupPermission` to look up the row to delete. */
export type AuthGroupPermissionAuthGroupPermissionsPkeyDelete = {
  id: Scalars["BigInt"]["input"];
};

/**
 * A condition to be used against `AuthGroupPermission` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AuthGroupPermissionCondition = {
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `permissionId` field. */
  permissionId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `AuthGroupPermission` object types. All fields are combined with a logical ‘and.’ */
export type AuthGroupPermissionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuthGroupPermissionFilter>>;
  /** Filter by the object’s `authGroupByGroupId` relation. */
  authGroupByGroupId?: InputMaybe<AuthGroupFilter>;
  /** Filter by the object’s `authPermissionByPermissionId` relation. */
  authPermissionByPermissionId?: InputMaybe<AuthPermissionFilter>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuthGroupPermissionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuthGroupPermissionFilter>>;
  /** Filter by the object’s `permissionId` field. */
  permissionId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `AuthGroupPermission` */
export type AuthGroupPermissionInput = {
  authGroupToGroupId?: InputMaybe<AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInput>;
  authPermissionToPermissionId?: InputMaybe<AuthGroupPermissioPermissionId84C5C92EFkAuthPermInput>;
  groupId?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  permissionId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `authGroupPermission` to look up the row to update. */
export type AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqUpdate =
  {
    /** An object where the defined keys will be set on the `authGroupPermission` being updated. */
    authGroupPermissionPatch: UpdateAuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermPatch;
    groupId: Scalars["Int"]["input"];
    permissionId: Scalars["Int"]["input"];
  };

/** The fields on `authGroupPermission` to look up the row to update. */
export type AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthGroupPermissionsPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `authGroupPermission` being updated. */
    authGroupPermissionPatch: UpdateAuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermPatch;
    id: Scalars["BigInt"]["input"];
  };

/** The fields on `authGroupPermission` to look up the row to update. */
export type AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqUpdate =
  {
    /** An object where the defined keys will be set on the `authGroupPermission` being updated. */
    authGroupPermissionPatch: UpdateAuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdPatch;
    groupId: Scalars["Int"]["input"];
    permissionId: Scalars["Int"]["input"];
  };

/** The fields on `authGroupPermission` to look up the row to update. */
export type AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPermissionsPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `authGroupPermission` being updated. */
    authGroupPermissionPatch: UpdateAuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdPatch;
    id: Scalars["BigInt"]["input"];
  };

/** Represents an update to a `AuthGroupPermission`. Fields that are set will be updated. */
export type AuthGroupPermissionPatch = {
  authGroupToGroupId?: InputMaybe<AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInput>;
  authPermissionToPermissionId?: InputMaybe<AuthGroupPermissioPermissionId84C5C92EFkAuthPermInput>;
  groupId?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  permissionId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A connection to a list of `AuthGroupPermission` values. */
export type AuthGroupPermissionsConnection = {
  __typename: "AuthGroupPermissionsConnection";
  /** A list of edges which contains the `AuthGroupPermission` and cursor to aid in pagination. */
  edges: Array<AuthGroupPermissionsEdge>;
  /** A list of `AuthGroupPermission` objects. */
  nodes: Array<AuthGroupPermission>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuthGroupPermission` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `AuthGroupPermission` edge in the connection. */
export type AuthGroupPermissionsEdge = {
  __typename: "AuthGroupPermissionsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AuthGroupPermission` at the end of the edge. */
  node: AuthGroupPermission;
};

/** The `authGroup` to be created by this mutation. */
export type AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdAuthGroupCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInverseInput>;
    authGroupPermissionsUsingId?: InputMaybe<AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInverseInput>;
    featureFlagsGroupsUsingId?: InputMaybe<FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name: Scalars["String"]["input"];
  };

/** The `authGroupPermission` to be created by this mutation. */
export type AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdAuthGroupPermissionsCreateInput =
  {
    authGroupToGroupId?: InputMaybe<AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInput>;
    authPermissionToPermissionId?: InputMaybe<AuthGroupPermissioPermissionId84C5C92EFkAuthPermInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    permissionId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** Input for the nested mutation of `authGroup` in the `AuthGroupPermissionInput` mutation. */
export type AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInput = {
  /** The primary key(s) for `authGroup` for the far side of the relationship. */
  connectById?: InputMaybe<AuthGroupAuthGroupPkeyConnect>;
  /** The primary key(s) for `authGroup` for the far side of the relationship. */
  connectByName?: InputMaybe<AuthGroupAuthGroupNameKeyConnect>;
  /** A `AuthGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdAuthGroupCreateInput>;
  /** The primary key(s) for `authGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<AuthGroupAuthGroupPkeyDelete>;
  /** The primary key(s) for `authGroup` for the far side of the relationship. */
  deleteByName?: InputMaybe<AuthGroupAuthGroupNameKeyDelete>;
  /** The primary key(s) and patch data for `authGroup` for the far side of the relationship. */
  updateById?: InputMaybe<AuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPkeyUpdate>;
  /** The primary key(s) and patch data for `authGroup` for the far side of the relationship. */
  updateByName?: InputMaybe<AuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupNameKeyUpdate>;
};

/** Input for the nested mutation of `authGroupPermission` in the `AuthGroupInput` mutation. */
export type AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInverseInput = {
  /** The primary key(s) for `authGroupPermission` for the far side of the relationship. */
  connectByGroupIdAndPermissionId?: InputMaybe<
    Array<AuthGroupPermissionAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqConnect>
  >;
  /** The primary key(s) for `authGroupPermission` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<AuthGroupPermissionAuthGroupPermissionsPkeyConnect>
  >;
  /** A `AuthGroupPermissionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdAuthGroupPermissionsCreateInput>
  >;
  /** The primary key(s) for `authGroupPermission` for the far side of the relationship. */
  deleteByGroupIdAndPermissionId?: InputMaybe<
    Array<AuthGroupPermissionAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqDelete>
  >;
  /** The primary key(s) for `authGroupPermission` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<AuthGroupPermissionAuthGroupPermissionsPkeyDelete>
  >;
  /** Flag indicating whether all other `authGroupPermission` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `authGroupPermission` for the far side of the relationship. */
  updateByGroupIdAndPermissionId?: InputMaybe<
    Array<AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqUpdate>
  >;
  /** The primary key(s) and patch data for `authGroupPermission` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPermissionsPkeyUpdate>
  >;
};

/** Methods to use when ordering `AuthGroupPermission`. */
export enum AuthGroupPermissionsOrderBy {
  GroupIdAsc = "GROUP_ID_ASC",
  GroupIdDesc = "GROUP_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PermissionIdAsc = "PERMISSION_ID_ASC",
  PermissionIdDesc = "PERMISSION_ID_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

/** A filter to be used against many `ApplicationUserGroup` object types. All fields are combined with a logical ‘and.’ */
export type AuthGroupToManyApplicationUserGroupFilter = {
  /** Every related `ApplicationUserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ApplicationUserGroupFilter>;
  /** No related `ApplicationUserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ApplicationUserGroupFilter>;
  /** Some related `ApplicationUserGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ApplicationUserGroupFilter>;
};

/** A filter to be used against many `AuthGroupPermission` object types. All fields are combined with a logical ‘and.’ */
export type AuthGroupToManyAuthGroupPermissionFilter = {
  /** Every related `AuthGroupPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuthGroupPermissionFilter>;
  /** No related `AuthGroupPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuthGroupPermissionFilter>;
  /** Some related `AuthGroupPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuthGroupPermissionFilter>;
};

/** A filter to be used against many `FeatureFlagsGroup` object types. All fields are combined with a logical ‘and.’ */
export type AuthGroupToManyFeatureFlagsGroupFilter = {
  /** Every related `FeatureFlagsGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FeatureFlagsGroupFilter>;
  /** No related `FeatureFlagsGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FeatureFlagsGroupFilter>;
  /** Some related `FeatureFlagsGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FeatureFlagsGroupFilter>;
};

/** A connection to a list of `AuthGroup` values. */
export type AuthGroupsConnection = {
  __typename: "AuthGroupsConnection";
  /** A list of edges which contains the `AuthGroup` and cursor to aid in pagination. */
  edges: Array<AuthGroupsEdge>;
  /** A list of `AuthGroup` objects. */
  nodes: Array<AuthGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuthGroup` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `AuthGroup` edge in the connection. */
export type AuthGroupsEdge = {
  __typename: "AuthGroupsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AuthGroup` at the end of the edge. */
  node: AuthGroup;
};

/** Methods to use when ordering `AuthGroup`. */
export enum AuthGroupsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type AuthPermission = {
  __typename: "AuthPermission";
  /** Reads and enables pagination through a set of `ApplicationUserUserPermission`. */
  applicationUserUserPermissionsByPermissionId: ApplicationUserUserPermissionsConnection;
  /** Reads and enables pagination through a set of `AuthGroupPermission`. */
  authGroupPermissionsByPermissionId: AuthGroupPermissionsConnection;
  codename: Scalars["String"]["output"];
  contentTypeId: Scalars["Int"]["output"];
  /** Reads a single `DjangoContentType` that is related to this `AuthPermission`. */
  djangoContentTypeByContentTypeId: Maybe<DjangoContentType>;
  id: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
};

export type AuthPermissionApplicationUserUserPermissionsByPermissionIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserUserPermissionCondition>;
  filter?: InputMaybe<ApplicationUserUserPermissionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserUserPermissionsOrderBy>>;
};

export type AuthPermissionAuthGroupPermissionsByPermissionIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuthGroupPermissionCondition>;
  filter?: InputMaybe<AuthGroupPermissionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuthGroupPermissionsOrderBy>>;
};

/** The fields on `authPermission` to look up the row to connect. */
export type AuthPermissionAuthPermissionContentTypeIdCodename01Ab375AUniqConnect =
  {
    codename: Scalars["String"]["input"];
    contentTypeId: Scalars["Int"]["input"];
  };

/** The fields on `authPermission` to look up the row to delete. */
export type AuthPermissionAuthPermissionContentTypeIdCodename01Ab375AUniqDelete =
  {
    codename: Scalars["String"]["input"];
    contentTypeId: Scalars["Int"]["input"];
  };

/** The fields on `authPermission` to look up the row to connect. */
export type AuthPermissionAuthPermissionPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `authPermission` to look up the row to delete. */
export type AuthPermissionAuthPermissionPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/**
 * A condition to be used against `AuthPermission` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AuthPermissionCondition = {
  /** Checks for equality with the object’s `codename` field. */
  codename?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `contentTypeId` field. */
  contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** The `authPermission` to be created by this mutation. */
export type AuthPermissionContentTypeId2F476E4BFkDjangoCoAuthPermissionCreateInput =
  {
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUsePermissionIdDbf9693DFkAuthPermInverseInput>;
    authGroupPermissionsUsingId?: InputMaybe<AuthGroupPermissioPermissionId84C5C92EFkAuthPermInverseInput>;
    codename: Scalars["String"]["input"];
    djangoContentTypeToContentTypeId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name: Scalars["String"]["input"];
  };

/** The `djangoContentType` to be created by this mutation. */
export type AuthPermissionContentTypeId2F476E4BFkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `AuthPermissionInput` mutation. */
export type AuthPermissionContentTypeId2F476E4BFkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `authPermission` in the `DjangoContentTypeInput` mutation. */
export type AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput = {
  /** The primary key(s) for `authPermission` for the far side of the relationship. */
  connectByContentTypeIdAndCodename?: InputMaybe<
    Array<AuthPermissionAuthPermissionContentTypeIdCodename01Ab375AUniqConnect>
  >;
  /** The primary key(s) for `authPermission` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AuthPermissionAuthPermissionPkeyConnect>>;
  /** A `AuthPermissionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AuthPermissionContentTypeId2F476E4BFkDjangoCoAuthPermissionCreateInput>
  >;
  /** The primary key(s) for `authPermission` for the far side of the relationship. */
  deleteByContentTypeIdAndCodename?: InputMaybe<
    Array<AuthPermissionAuthPermissionContentTypeIdCodename01Ab375AUniqDelete>
  >;
  /** The primary key(s) for `authPermission` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AuthPermissionAuthPermissionPkeyDelete>>;
  /** Flag indicating whether all other `authPermission` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `authPermission` for the far side of the relationship. */
  updateByContentTypeIdAndCodename?: InputMaybe<
    Array<AuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate>
  >;
  /** The primary key(s) and patch data for `authPermission` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<AuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingAuthPermissionPkeyUpdate>
  >;
};

/** A filter to be used against `AuthPermission` object types. All fields are combined with a logical ‘and.’ */
export type AuthPermissionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuthPermissionFilter>>;
  /** Filter by the object’s `applicationUserUserPermissionsByPermissionId` relation. */
  applicationUserUserPermissionsByPermissionId?: InputMaybe<AuthPermissionToManyApplicationUserUserPermissionFilter>;
  /** Some related `applicationUserUserPermissionsByPermissionId` exist. */
  applicationUserUserPermissionsByPermissionIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `authGroupPermissionsByPermissionId` relation. */
  authGroupPermissionsByPermissionId?: InputMaybe<AuthPermissionToManyAuthGroupPermissionFilter>;
  /** Some related `authGroupPermissionsByPermissionId` exist. */
  authGroupPermissionsByPermissionIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `codename` field. */
  codename?: InputMaybe<StringFilter>;
  /** Filter by the object’s `contentTypeId` field. */
  contentTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `djangoContentTypeByContentTypeId` relation. */
  djangoContentTypeByContentTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuthPermissionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuthPermissionFilter>>;
};

/** An input for mutations affecting `AuthPermission` */
export type AuthPermissionInput = {
  applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUsePermissionIdDbf9693DFkAuthPermInverseInput>;
  authGroupPermissionsUsingId?: InputMaybe<AuthGroupPermissioPermissionId84C5C92EFkAuthPermInverseInput>;
  codename: Scalars["String"]["input"];
  contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  djangoContentTypeToContentTypeId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
};

/** The fields on `authPermission` to look up the row to update. */
export type AuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate =
  {
    /** An object where the defined keys will be set on the `authPermission` being updated. */
    authPermissionPatch: UpdateAuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermPatch;
    codename: Scalars["String"]["input"];
    contentTypeId: Scalars["Int"]["input"];
  };

/** The fields on `authPermission` to look up the row to update. */
export type AuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingAuthPermissionPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `authPermission` being updated. */
    authPermissionPatch: UpdateAuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `authPermission` to look up the row to update. */
export type AuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate =
  {
    /** An object where the defined keys will be set on the `authPermission` being updated. */
    authPermissionPatch: UpdateAuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermPatch;
    codename: Scalars["String"]["input"];
    contentTypeId: Scalars["Int"]["input"];
  };

/** The fields on `authPermission` to look up the row to update. */
export type AuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthPermissionPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `authPermission` being updated. */
    authPermissionPatch: UpdateAuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `authPermission` to look up the row to update. */
export type AuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate =
  {
    /** An object where the defined keys will be set on the `authPermission` being updated. */
    authPermissionPatch: UpdateAuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoPatch;
    codename: Scalars["String"]["input"];
    contentTypeId: Scalars["Int"]["input"];
  };

/** The fields on `authPermission` to look up the row to update. */
export type AuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingAuthPermissionPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `authPermission` being updated. */
    authPermissionPatch: UpdateAuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** Represents an update to a `AuthPermission`. Fields that are set will be updated. */
export type AuthPermissionPatch = {
  applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUsePermissionIdDbf9693DFkAuthPermInverseInput>;
  authGroupPermissionsUsingId?: InputMaybe<AuthGroupPermissioPermissionId84C5C92EFkAuthPermInverseInput>;
  codename?: InputMaybe<Scalars["String"]["input"]>;
  contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  djangoContentTypeToContentTypeId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** A filter to be used against many `ApplicationUserUserPermission` object types. All fields are combined with a logical ‘and.’ */
export type AuthPermissionToManyApplicationUserUserPermissionFilter = {
  /** Every related `ApplicationUserUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ApplicationUserUserPermissionFilter>;
  /** No related `ApplicationUserUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ApplicationUserUserPermissionFilter>;
  /** Some related `ApplicationUserUserPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ApplicationUserUserPermissionFilter>;
};

/** A filter to be used against many `AuthGroupPermission` object types. All fields are combined with a logical ‘and.’ */
export type AuthPermissionToManyAuthGroupPermissionFilter = {
  /** Every related `AuthGroupPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuthGroupPermissionFilter>;
  /** No related `AuthGroupPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuthGroupPermissionFilter>;
  /** Some related `AuthGroupPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuthGroupPermissionFilter>;
};

/** A connection to a list of `AuthPermission` values. */
export type AuthPermissionsConnection = {
  __typename: "AuthPermissionsConnection";
  /** A list of edges which contains the `AuthPermission` and cursor to aid in pagination. */
  edges: Array<AuthPermissionsEdge>;
  /** A list of `AuthPermission` objects. */
  nodes: Array<AuthPermission>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuthPermission` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `AuthPermission` edge in the connection. */
export type AuthPermissionsEdge = {
  __typename: "AuthPermissionsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AuthPermission` at the end of the edge. */
  node: AuthPermission;
};

/** Methods to use when ordering `AuthPermission`. */
export enum AuthPermissionsOrderBy {
  CodenameAsc = "CODENAME_ASC",
  CodenameDesc = "CODENAME_DESC",
  ContentTypeIdAsc = "CONTENT_TYPE_ID_ASC",
  ContentTypeIdDesc = "CONTENT_TYPE_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type AvailableNonRestrictedProject = {
  __typename: "AvailableNonRestrictedProject";
  defaultUserAccessLevel: Maybe<Scalars["Int"]["output"]>;
  id: Maybe<Scalars["UUID"]["output"]>;
  status: Maybe<Scalars["Int"]["output"]>;
  tenantId: Maybe<Scalars["Int"]["output"]>;
  userId: Maybe<Scalars["UUID"]["output"]>;
};

/**
 * A condition to be used against `AvailableNonRestrictedProject` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type AvailableNonRestrictedProjectCondition = {
  /** Checks for equality with the object’s `defaultUserAccessLevel` field. */
  defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `AvailableNonRestrictedProject` object types. All fields are combined with a logical ‘and.’ */
export type AvailableNonRestrictedProjectFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AvailableNonRestrictedProjectFilter>>;
  /** Filter by the object’s `defaultUserAccessLevel` field. */
  defaultUserAccessLevel?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AvailableNonRestrictedProjectFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AvailableNonRestrictedProjectFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `AvailableNonRestrictedProject` */
export type AvailableNonRestrictedProjectInput = {
  defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A connection to a list of `AvailableNonRestrictedProject` values. */
export type AvailableNonRestrictedProjectsConnection = {
  __typename: "AvailableNonRestrictedProjectsConnection";
  /** A list of edges which contains the `AvailableNonRestrictedProject` and cursor to aid in pagination. */
  edges: Array<AvailableNonRestrictedProjectsEdge>;
  /** A list of `AvailableNonRestrictedProject` objects. */
  nodes: Array<AvailableNonRestrictedProject>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AvailableNonRestrictedProject` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `AvailableNonRestrictedProject` edge in the connection. */
export type AvailableNonRestrictedProjectsEdge = {
  __typename: "AvailableNonRestrictedProjectsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AvailableNonRestrictedProject` at the end of the edge. */
  node: AvailableNonRestrictedProject;
};

/** Methods to use when ordering `AvailableNonRestrictedProject`. */
export enum AvailableNonRestrictedProjectsOrderBy {
  DefaultUserAccessLevelAsc = "DEFAULT_USER_ACCESS_LEVEL_ASC",
  DefaultUserAccessLevelDesc = "DEFAULT_USER_ACCESS_LEVEL_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  StatusAsc = "STATUS_ASC",
  StatusDesc = "STATUS_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

export type Avatar = {
  __typename: "Avatar";
  /** Reads a single `ApplicationUser` that is related to this `Avatar`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  color: Scalars["String"]["output"];
  id: Scalars["BigInt"]["output"];
  imageBase64: Maybe<Scalars["String"]["output"]>;
  initials: Scalars["String"]["output"];
  useImage: Scalars["Boolean"]["output"];
  userId: Scalars["UUID"]["output"];
};

/** The fields on `avatar` to look up the row to connect. */
export type AvatarAvatarPkeyConnect = {
  id: Scalars["BigInt"]["input"];
};

/** The fields on `avatar` to look up the row to delete. */
export type AvatarAvatarPkeyDelete = {
  id: Scalars["BigInt"]["input"];
};

/** The fields on `avatar` to look up the row to connect. */
export type AvatarAvatarUserIdKeyConnect = {
  userId: Scalars["UUID"]["input"];
};

/** The fields on `avatar` to look up the row to delete. */
export type AvatarAvatarUserIdKeyDelete = {
  userId: Scalars["UUID"]["input"];
};

/** A condition to be used against `Avatar` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AvatarCondition = {
  /** Checks for equality with the object’s `color` field. */
  color?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `imageBase64` field. */
  imageBase64?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `initials` field. */
  initials?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `useImage` field. */
  useImage?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `Avatar` object types. All fields are combined with a logical ‘and.’ */
export type AvatarFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AvatarFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `color` field. */
  color?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `imageBase64` field. */
  imageBase64?: InputMaybe<StringFilter>;
  /** Filter by the object’s `initials` field. */
  initials?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AvatarFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AvatarFilter>>;
  /** Filter by the object’s `useImage` field. */
  useImage?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `Avatar` */
export type AvatarInput = {
  applicationUserToUserId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInput>;
  color: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  imageBase64?: InputMaybe<Scalars["String"]["input"]>;
  initials: Scalars["String"]["input"];
  useImage: Scalars["Boolean"]["input"];
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `avatar` to look up the row to update. */
export type AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `avatar` being updated. */
    avatarPatch: UpdateAvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
    id: Scalars["BigInt"]["input"];
  };

/** The fields on `avatar` to look up the row to update. */
export type AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarUserIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `avatar` being updated. */
    avatarPatch: UpdateAvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
    userId: Scalars["UUID"]["input"];
  };

/** Represents an update to a `Avatar`. Fields that are set will be updated. */
export type AvatarPatch = {
  applicationUserToUserId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInput>;
  color?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  imageBase64?: InputMaybe<Scalars["String"]["input"]>;
  initials?: InputMaybe<Scalars["String"]["input"]>;
  useImage?: InputMaybe<Scalars["Boolean"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `applicationUser` to be created by this mutation. */
export type AvatarUserId771332F2FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** The `avatar` to be created by this mutation. */
export type AvatarUserId771332F2FkApplicationUserIdAvatarCreateInput = {
  applicationUserToUserId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInput>;
  color: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  imageBase64?: InputMaybe<Scalars["String"]["input"]>;
  initials: Scalars["String"]["input"];
  useImage: Scalars["Boolean"]["input"];
};

/** Input for the nested mutation of `applicationUser` in the `AvatarInput` mutation. */
export type AvatarUserId771332F2FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `avatar` in the `ApplicationUserInput` mutation. */
export type AvatarUserId771332F2FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `avatar` for the far side of the relationship. */
  connectById?: InputMaybe<AvatarAvatarPkeyConnect>;
  /** The primary key(s) for `avatar` for the far side of the relationship. */
  connectByUserId?: InputMaybe<AvatarAvatarUserIdKeyConnect>;
  /** A `AvatarInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AvatarUserId771332F2FkApplicationUserIdAvatarCreateInput>
  >;
  /** The primary key(s) for `avatar` for the far side of the relationship. */
  deleteById?: InputMaybe<AvatarAvatarPkeyDelete>;
  /** The primary key(s) for `avatar` for the far side of the relationship. */
  deleteByUserId?: InputMaybe<AvatarAvatarUserIdKeyDelete>;
  /** Flag indicating whether all other `avatar` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `avatar` for the far side of the relationship. */
  updateById?: InputMaybe<AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarPkeyUpdate>;
  /** The primary key(s) and patch data for `avatar` for the far side of the relationship. */
  updateByUserId?: InputMaybe<AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarUserIdKeyUpdate>;
};

/** A connection to a list of `Avatar` values. */
export type AvatarsConnection = {
  __typename: "AvatarsConnection";
  /** A list of edges which contains the `Avatar` and cursor to aid in pagination. */
  edges: Array<AvatarsEdge>;
  /** A list of `Avatar` objects. */
  nodes: Array<Avatar>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Avatar` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `Avatar` edge in the connection. */
export type AvatarsEdge = {
  __typename: "AvatarsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `Avatar` at the end of the edge. */
  node: Avatar;
};

/** Methods to use when ordering `Avatar`. */
export enum AvatarsOrderBy {
  ColorAsc = "COLOR_ASC",
  ColorDesc = "COLOR_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  ImageBase_64Asc = "IMAGE_BASE_64_ASC",
  ImageBase_64Desc = "IMAGE_BASE_64_DESC",
  InitialsAsc = "INITIALS_ASC",
  InitialsDesc = "INITIALS_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
  UseImageAsc = "USE_IMAGE_ASC",
  UseImageDesc = "USE_IMAGE_DESC",
}

export type AwsBatchTask = {
  __typename: "AwsBatchTask";
  awsDataBucketName: Maybe<Scalars["String"]["output"]>;
  awsInstanceId: Maybe<Scalars["String"]["output"]>;
  awsInstanceMemory: Maybe<Scalars["Int"]["output"]>;
  awsInstanceType: Maybe<Scalars["String"]["output"]>;
  awsInstanceVcpus: Maybe<Scalars["Int"]["output"]>;
  awsJobId: Maybe<Scalars["String"]["output"]>;
  awsJobQueue: Maybe<Scalars["String"]["output"]>;
  awsJobStatus: Maybe<Scalars["Int"]["output"]>;
  awsJobStatusReason: Scalars["String"]["output"];
  /** Reads a single `AwsMockBatchTask` that is related to this `AwsBatchTask`. */
  awsMockBatchTaskByAwstaskexecutorPtrId: Maybe<AwsMockBatchTask>;
  /**
   * Reads and enables pagination through a set of `AwsMockBatchTask`.
   * @deprecated Please use awsMockBatchTaskByAwstaskexecutorPtrId instead
   */
  awsMockBatchTasksByAwstaskexecutorPtrId: AwsMockBatchTasksConnection;
  awsRegion: Maybe<Scalars["String"]["output"]>;
  awsTaskPath: Maybe<Scalars["String"]["output"]>;
  exitcode: Maybe<Scalars["Int"]["output"]>;
  resultsProcessed: Scalars["Boolean"]["output"];
  taskexecutorPtrId: Scalars["UUID"]["output"];
  /** Reads a single `TesTaskexecutor` that is related to this `AwsBatchTask`. */
  tesTaskexecutorByTaskexecutorPtrId: Maybe<TesTaskexecutor>;
};

export type AwsBatchTaskAwsMockBatchTasksByAwstaskexecutorPtrIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsMockBatchTaskCondition>;
  filter?: InputMaybe<AwsMockBatchTaskFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsMockBatchTasksOrderBy>>;
};

/** The fields on `awsBatchTask` to look up the row to connect. */
export type AwsBatchTaskAwsBatchTaskPkeyConnect = {
  taskexecutorPtrId: Scalars["UUID"]["input"];
};

/** The fields on `awsBatchTask` to look up the row to delete. */
export type AwsBatchTaskAwsBatchTaskPkeyDelete = {
  taskexecutorPtrId: Scalars["UUID"]["input"];
};

/**
 * A condition to be used against `AwsBatchTask` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AwsBatchTaskCondition = {
  /** Checks for equality with the object’s `awsDataBucketName` field. */
  awsDataBucketName?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `awsInstanceId` field. */
  awsInstanceId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `awsInstanceMemory` field. */
  awsInstanceMemory?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `awsInstanceType` field. */
  awsInstanceType?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `awsInstanceVcpus` field. */
  awsInstanceVcpus?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `awsJobId` field. */
  awsJobId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `awsJobQueue` field. */
  awsJobQueue?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `awsJobStatus` field. */
  awsJobStatus?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `awsJobStatusReason` field. */
  awsJobStatusReason?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `awsRegion` field. */
  awsRegion?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `awsTaskPath` field. */
  awsTaskPath?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `exitcode` field. */
  exitcode?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `resultsProcessed` field. */
  resultsProcessed?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `taskexecutorPtrId` field. */
  taskexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `AwsBatchTask` object types. All fields are combined with a logical ‘and.’ */
export type AwsBatchTaskFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AwsBatchTaskFilter>>;
  /** Filter by the object’s `awsDataBucketName` field. */
  awsDataBucketName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `awsInstanceId` field. */
  awsInstanceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `awsInstanceMemory` field. */
  awsInstanceMemory?: InputMaybe<IntFilter>;
  /** Filter by the object’s `awsInstanceType` field. */
  awsInstanceType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `awsInstanceVcpus` field. */
  awsInstanceVcpus?: InputMaybe<IntFilter>;
  /** Filter by the object’s `awsJobId` field. */
  awsJobId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `awsJobQueue` field. */
  awsJobQueue?: InputMaybe<StringFilter>;
  /** Filter by the object’s `awsJobStatus` field. */
  awsJobStatus?: InputMaybe<IntFilter>;
  /** Filter by the object’s `awsJobStatusReason` field. */
  awsJobStatusReason?: InputMaybe<StringFilter>;
  /** Filter by the object’s `awsMockBatchTaskByAwstaskexecutorPtrId` relation. */
  awsMockBatchTaskByAwstaskexecutorPtrId?: InputMaybe<AwsMockBatchTaskFilter>;
  /** A related `awsMockBatchTaskByAwstaskexecutorPtrId` exists. */
  awsMockBatchTaskByAwstaskexecutorPtrIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `awsRegion` field. */
  awsRegion?: InputMaybe<StringFilter>;
  /** Filter by the object’s `awsTaskPath` field. */
  awsTaskPath?: InputMaybe<StringFilter>;
  /** Filter by the object’s `exitcode` field. */
  exitcode?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AwsBatchTaskFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AwsBatchTaskFilter>>;
  /** Filter by the object’s `resultsProcessed` field. */
  resultsProcessed?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `taskexecutorPtrId` field. */
  taskexecutorPtrId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tesTaskexecutorByTaskexecutorPtrId` relation. */
  tesTaskexecutorByTaskexecutorPtrId?: InputMaybe<TesTaskexecutorFilter>;
};

/** An input for mutations affecting `AwsBatchTask` */
export type AwsBatchTaskInput = {
  awsDataBucketName?: InputMaybe<Scalars["String"]["input"]>;
  awsInstanceId?: InputMaybe<Scalars["String"]["input"]>;
  awsInstanceMemory?: InputMaybe<Scalars["Int"]["input"]>;
  awsInstanceType?: InputMaybe<Scalars["String"]["input"]>;
  awsInstanceVcpus?: InputMaybe<Scalars["Int"]["input"]>;
  awsJobId?: InputMaybe<Scalars["String"]["input"]>;
  awsJobQueue?: InputMaybe<Scalars["String"]["input"]>;
  awsJobStatus?: InputMaybe<Scalars["Int"]["input"]>;
  awsJobStatusReason: Scalars["String"]["input"];
  awsMockBatchTaskUsingTaskexecutorPtrId?: InputMaybe<AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInverseInput>;
  awsRegion?: InputMaybe<Scalars["String"]["input"]>;
  awsTaskPath?: InputMaybe<Scalars["String"]["input"]>;
  exitcode?: InputMaybe<Scalars["Int"]["input"]>;
  resultsProcessed: Scalars["Boolean"]["input"];
  taskexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
  tesTaskexecutorToTaskexecutorPtrId?: InputMaybe<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInput>;
};

/** The fields on `awsBatchTask` to look up the row to update. */
export type AwsBatchTaskOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeUsingAwsBatchTaskPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `awsBatchTask` being updated. */
    awsBatchTaskPatch: UpdateAwsBatchTaskOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskePatch;
    taskexecutorPtrId: Scalars["UUID"]["input"];
  };

/** The fields on `awsBatchTask` to look up the row to update. */
export type AwsBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchUsingAwsBatchTaskPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `awsBatchTask` being updated. */
    awsBatchTaskPatch: UpdateAwsBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchPatch;
    taskexecutorPtrId: Scalars["UUID"]["input"];
  };

/** Represents an update to a `AwsBatchTask`. Fields that are set will be updated. */
export type AwsBatchTaskPatch = {
  awsDataBucketName?: InputMaybe<Scalars["String"]["input"]>;
  awsInstanceId?: InputMaybe<Scalars["String"]["input"]>;
  awsInstanceMemory?: InputMaybe<Scalars["Int"]["input"]>;
  awsInstanceType?: InputMaybe<Scalars["String"]["input"]>;
  awsInstanceVcpus?: InputMaybe<Scalars["Int"]["input"]>;
  awsJobId?: InputMaybe<Scalars["String"]["input"]>;
  awsJobQueue?: InputMaybe<Scalars["String"]["input"]>;
  awsJobStatus?: InputMaybe<Scalars["Int"]["input"]>;
  awsJobStatusReason?: InputMaybe<Scalars["String"]["input"]>;
  awsMockBatchTaskUsingTaskexecutorPtrId?: InputMaybe<AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInverseInput>;
  awsRegion?: InputMaybe<Scalars["String"]["input"]>;
  awsTaskPath?: InputMaybe<Scalars["String"]["input"]>;
  exitcode?: InputMaybe<Scalars["Int"]["input"]>;
  resultsProcessed?: InputMaybe<Scalars["Boolean"]["input"]>;
  taskexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
  tesTaskexecutorToTaskexecutorPtrId?: InputMaybe<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInput>;
};

/** The `awsBatchTask` to be created by this mutation. */
export type AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeAwsBatchTaskCreateInput =
  {
    awsDataBucketName?: InputMaybe<Scalars["String"]["input"]>;
    awsInstanceId?: InputMaybe<Scalars["String"]["input"]>;
    awsInstanceMemory?: InputMaybe<Scalars["Int"]["input"]>;
    awsInstanceType?: InputMaybe<Scalars["String"]["input"]>;
    awsInstanceVcpus?: InputMaybe<Scalars["Int"]["input"]>;
    awsJobId?: InputMaybe<Scalars["String"]["input"]>;
    awsJobQueue?: InputMaybe<Scalars["String"]["input"]>;
    awsJobStatus?: InputMaybe<Scalars["Int"]["input"]>;
    awsJobStatusReason: Scalars["String"]["input"];
    awsMockBatchTaskUsingTaskexecutorPtrId?: InputMaybe<AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInverseInput>;
    awsRegion?: InputMaybe<Scalars["String"]["input"]>;
    awsTaskPath?: InputMaybe<Scalars["String"]["input"]>;
    exitcode?: InputMaybe<Scalars["Int"]["input"]>;
    resultsProcessed: Scalars["Boolean"]["input"];
    tesTaskexecutorToTaskexecutorPtrId?: InputMaybe<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInput>;
  };

/** Input for the nested mutation of `tesTaskexecutor` in the `AwsBatchTaskInput` mutation. */
export type AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInput = {
  /** The primary key(s) for `tesTaskexecutor` for the far side of the relationship. */
  connectById?: InputMaybe<TesTaskexecutorTesTaskexecutorPkeyConnect>;
  /** A `TesTaskexecutorInput` object that will be created and connected to this object. */
  create?: InputMaybe<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeTesTaskexecutorCreateInput>;
  /** The primary key(s) for `tesTaskexecutor` for the far side of the relationship. */
  deleteById?: InputMaybe<TesTaskexecutorTesTaskexecutorPkeyDelete>;
  /** The primary key(s) and patch data for `tesTaskexecutor` for the far side of the relationship. */
  updateById?: InputMaybe<TesTaskexecutorOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeUsingTesTaskexecutorPkeyUpdate>;
};

/** Input for the nested mutation of `awsBatchTask` in the `TesTaskexecutorInput` mutation. */
export type AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInverseInput = {
  /** The primary key(s) for `awsBatchTask` for the far side of the relationship. */
  connectByTaskexecutorPtrId?: InputMaybe<AwsBatchTaskAwsBatchTaskPkeyConnect>;
  /** A `AwsBatchTaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeAwsBatchTaskCreateInput>
  >;
  /** The primary key(s) for `awsBatchTask` for the far side of the relationship. */
  deleteByTaskexecutorPtrId?: InputMaybe<AwsBatchTaskAwsBatchTaskPkeyDelete>;
  /** Flag indicating whether all other `awsBatchTask` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `awsBatchTask` for the far side of the relationship. */
  updateByTaskexecutorPtrId?: InputMaybe<AwsBatchTaskOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeUsingAwsBatchTaskPkeyUpdate>;
};

/** The `tesTaskexecutor` to be created by this mutation. */
export type AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeTesTaskexecutorCreateInput =
  {
    awsBatchTaskUsingId?: InputMaybe<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInput>;
    id: Scalars["UUID"]["input"];
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    taskUsingId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInverseInput>;
    tesMocktaskexecutorUsingId?: InputMaybe<TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInverseInput>;
  };

/** A connection to a list of `AwsBatchTask` values. */
export type AwsBatchTasksConnection = {
  __typename: "AwsBatchTasksConnection";
  /** A list of edges which contains the `AwsBatchTask` and cursor to aid in pagination. */
  edges: Array<AwsBatchTasksEdge>;
  /** A list of `AwsBatchTask` objects. */
  nodes: Array<AwsBatchTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AwsBatchTask` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `AwsBatchTask` edge in the connection. */
export type AwsBatchTasksEdge = {
  __typename: "AwsBatchTasksEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AwsBatchTask` at the end of the edge. */
  node: AwsBatchTask;
};

/** Methods to use when ordering `AwsBatchTask`. */
export enum AwsBatchTasksOrderBy {
  AwsDataBucketNameAsc = "AWS_DATA_BUCKET_NAME_ASC",
  AwsDataBucketNameDesc = "AWS_DATA_BUCKET_NAME_DESC",
  AwsInstanceIdAsc = "AWS_INSTANCE_ID_ASC",
  AwsInstanceIdDesc = "AWS_INSTANCE_ID_DESC",
  AwsInstanceMemoryAsc = "AWS_INSTANCE_MEMORY_ASC",
  AwsInstanceMemoryDesc = "AWS_INSTANCE_MEMORY_DESC",
  AwsInstanceTypeAsc = "AWS_INSTANCE_TYPE_ASC",
  AwsInstanceTypeDesc = "AWS_INSTANCE_TYPE_DESC",
  AwsInstanceVcpusAsc = "AWS_INSTANCE_VCPUS_ASC",
  AwsInstanceVcpusDesc = "AWS_INSTANCE_VCPUS_DESC",
  AwsJobIdAsc = "AWS_JOB_ID_ASC",
  AwsJobIdDesc = "AWS_JOB_ID_DESC",
  AwsJobQueueAsc = "AWS_JOB_QUEUE_ASC",
  AwsJobQueueDesc = "AWS_JOB_QUEUE_DESC",
  AwsJobStatusAsc = "AWS_JOB_STATUS_ASC",
  AwsJobStatusDesc = "AWS_JOB_STATUS_DESC",
  AwsJobStatusReasonAsc = "AWS_JOB_STATUS_REASON_ASC",
  AwsJobStatusReasonDesc = "AWS_JOB_STATUS_REASON_DESC",
  AwsRegionAsc = "AWS_REGION_ASC",
  AwsRegionDesc = "AWS_REGION_DESC",
  AwsTaskPathAsc = "AWS_TASK_PATH_ASC",
  AwsTaskPathDesc = "AWS_TASK_PATH_DESC",
  ExitcodeAsc = "EXITCODE_ASC",
  ExitcodeDesc = "EXITCODE_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ResultsProcessedAsc = "RESULTS_PROCESSED_ASC",
  ResultsProcessedDesc = "RESULTS_PROCESSED_DESC",
  TaskexecutorPtrIdAsc = "TASKEXECUTOR_PTR_ID_ASC",
  TaskexecutorPtrIdDesc = "TASKEXECUTOR_PTR_ID_DESC",
}

export type AwsCognitoUser = {
  __typename: "AwsCognitoUser";
  /** Reads a single `AwsMockIamUser` that is related to this `AwsCognitoUser`. */
  awsMockIamUserByAwsuserexecutorPtrId: Maybe<AwsMockIamUser>;
  /**
   * Reads and enables pagination through a set of `AwsMockIamUser`.
   * @deprecated Please use awsMockIamUserByAwsuserexecutorPtrId instead
   */
  awsMockIamUsersByAwsuserexecutorPtrId: AwsMockIamUsersConnection;
  /** Reads a single `TenantUserexecutor` that is related to this `AwsCognitoUser`. */
  tenantUserexecutorByUserexecutorPtrId: Maybe<TenantUserexecutor>;
  userexecutorPtrId: Scalars["Int"]["output"];
};

export type AwsCognitoUserAwsMockIamUsersByAwsuserexecutorPtrIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsMockIamUserCondition>;
  filter?: InputMaybe<AwsMockIamUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsMockIamUsersOrderBy>>;
};

/** The fields on `awsCognitoUser` to look up the row to connect. */
export type AwsCognitoUserAwsCognitoUserPkeyConnect = {
  userexecutorPtrId: Scalars["Int"]["input"];
};

/** The fields on `awsCognitoUser` to look up the row to delete. */
export type AwsCognitoUserAwsCognitoUserPkeyDelete = {
  userexecutorPtrId: Scalars["Int"]["input"];
};

/**
 * A condition to be used against `AwsCognitoUser` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AwsCognitoUserCondition = {
  /** Checks for equality with the object’s `userexecutorPtrId` field. */
  userexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `AwsCognitoUser` object types. All fields are combined with a logical ‘and.’ */
export type AwsCognitoUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AwsCognitoUserFilter>>;
  /** Filter by the object’s `awsMockIamUserByAwsuserexecutorPtrId` relation. */
  awsMockIamUserByAwsuserexecutorPtrId?: InputMaybe<AwsMockIamUserFilter>;
  /** A related `awsMockIamUserByAwsuserexecutorPtrId` exists. */
  awsMockIamUserByAwsuserexecutorPtrIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Negates the expression. */
  not?: InputMaybe<AwsCognitoUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AwsCognitoUserFilter>>;
  /** Filter by the object’s `tenantUserexecutorByUserexecutorPtrId` relation. */
  tenantUserexecutorByUserexecutorPtrId?: InputMaybe<TenantUserexecutorFilter>;
  /** Filter by the object’s `userexecutorPtrId` field. */
  userexecutorPtrId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `AwsCognitoUser` */
export type AwsCognitoUserInput = {
  awsMockIamUserUsingUserexecutorPtrId?: InputMaybe<AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInverseInput>;
  tenantUserexecutorToUserexecutorPtrId?: InputMaybe<AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInput>;
  userexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `awsCognitoUser` to look up the row to update. */
export type AwsCognitoUserOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsUsingAwsCognitoUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `awsCognitoUser` being updated. */
    awsCognitoUserPatch: UpdateAwsCognitoUserOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsPatch;
    userexecutorPtrId: Scalars["Int"]["input"];
  };

/** The fields on `awsCognitoUser` to look up the row to update. */
export type AwsCognitoUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniUsingAwsCognitoUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `awsCognitoUser` being updated. */
    awsCognitoUserPatch: UpdateAwsCognitoUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniPatch;
    userexecutorPtrId: Scalars["Int"]["input"];
  };

/** Represents an update to a `AwsCognitoUser`. Fields that are set will be updated. */
export type AwsCognitoUserPatch = {
  awsMockIamUserUsingUserexecutorPtrId?: InputMaybe<AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInverseInput>;
  tenantUserexecutorToUserexecutorPtrId?: InputMaybe<AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInput>;
  userexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The `awsCognitoUser` to be created by this mutation. */
export type AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsAwsCognitoUserCreateInput =
  {
    awsMockIamUserUsingUserexecutorPtrId?: InputMaybe<AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInverseInput>;
    tenantUserexecutorToUserexecutorPtrId?: InputMaybe<AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInput>;
  };

/** Input for the nested mutation of `tenantUserexecutor` in the `AwsCognitoUserInput` mutation. */
export type AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInput = {
  /** The primary key(s) for `tenantUserexecutor` for the far side of the relationship. */
  connectById?: InputMaybe<TenantUserexecutorTenantUserexecutorPkeyConnect>;
  /** A `TenantUserexecutorInput` object that will be created and connected to this object. */
  create?: InputMaybe<AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsTenantUserexecutorCreateInput>;
  /** The primary key(s) for `tenantUserexecutor` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantUserexecutorTenantUserexecutorPkeyDelete>;
  /** The primary key(s) and patch data for `tenantUserexecutor` for the far side of the relationship. */
  updateById?: InputMaybe<TenantUserexecutorOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsUsingTenantUserexecutorPkeyUpdate>;
};

/** Input for the nested mutation of `awsCognitoUser` in the `TenantUserexecutorInput` mutation. */
export type AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInverseInput = {
  /** The primary key(s) for `awsCognitoUser` for the far side of the relationship. */
  connectByUserexecutorPtrId?: InputMaybe<AwsCognitoUserAwsCognitoUserPkeyConnect>;
  /** A `AwsCognitoUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsAwsCognitoUserCreateInput>
  >;
  /** The primary key(s) for `awsCognitoUser` for the far side of the relationship. */
  deleteByUserexecutorPtrId?: InputMaybe<AwsCognitoUserAwsCognitoUserPkeyDelete>;
  /** Flag indicating whether all other `awsCognitoUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `awsCognitoUser` for the far side of the relationship. */
  updateByUserexecutorPtrId?: InputMaybe<AwsCognitoUserOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsUsingAwsCognitoUserPkeyUpdate>;
};

/** The `tenantUserexecutor` to be created by this mutation. */
export type AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsTenantUserexecutorCreateInput =
  {
    applicationUserUsingId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInverseInput>;
    awsCognitoUserUsingId?: InputMaybe<AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantMockuserexecutorUsingId?: InputMaybe<TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInverseInput>;
  };

/** A connection to a list of `AwsCognitoUser` values. */
export type AwsCognitoUsersConnection = {
  __typename: "AwsCognitoUsersConnection";
  /** A list of edges which contains the `AwsCognitoUser` and cursor to aid in pagination. */
  edges: Array<AwsCognitoUsersEdge>;
  /** A list of `AwsCognitoUser` objects. */
  nodes: Array<AwsCognitoUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AwsCognitoUser` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `AwsCognitoUser` edge in the connection. */
export type AwsCognitoUsersEdge = {
  __typename: "AwsCognitoUsersEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AwsCognitoUser` at the end of the edge. */
  node: AwsCognitoUser;
};

/** Methods to use when ordering `AwsCognitoUser`. */
export enum AwsCognitoUsersOrderBy {
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  UserexecutorPtrIdAsc = "USEREXECUTOR_PTR_ID_ASC",
  UserexecutorPtrIdDesc = "USEREXECUTOR_PTR_ID_DESC",
}

export type AwsEcrImage = {
  __typename: "AwsEcrImage";
  /** Reads a single `AwsMockEcrImage` that is related to this `AwsEcrImage`. */
  awsMockEcrImageByAwscontainerimageexecutorPtrId: Maybe<AwsMockEcrImage>;
  /**
   * Reads and enables pagination through a set of `AwsMockEcrImage`.
   * @deprecated Please use awsMockEcrImageByAwscontainerimageexecutorPtrId instead
   */
  awsMockEcrImagesByAwscontainerimageexecutorPtrId: AwsMockEcrImagesConnection;
  containerimageexecutorPtrId: Scalars["Int"]["output"];
  jobDefinitionName: Maybe<Scalars["String"]["output"]>;
  jobDefinitionRevision: Maybe<Scalars["Int"]["output"]>;
  repositoryArn: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `TesContainerimageexecutor` that is related to this `AwsEcrImage`. */
  tesContainerimageexecutorByContainerimageexecutorPtrId: Maybe<TesContainerimageexecutor>;
};

export type AwsEcrImageAwsMockEcrImagesByAwscontainerimageexecutorPtrIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsMockEcrImageCondition>;
  filter?: InputMaybe<AwsMockEcrImageFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsMockEcrImagesOrderBy>>;
};

/** The fields on `awsEcrImage` to look up the row to connect. */
export type AwsEcrImageAwsEcrImagePkeyConnect = {
  containerimageexecutorPtrId: Scalars["Int"]["input"];
};

/** The fields on `awsEcrImage` to look up the row to delete. */
export type AwsEcrImageAwsEcrImagePkeyDelete = {
  containerimageexecutorPtrId: Scalars["Int"]["input"];
};

/**
 * A condition to be used against `AwsEcrImage` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AwsEcrImageCondition = {
  /** Checks for equality with the object’s `containerimageexecutorPtrId` field. */
  containerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `jobDefinitionName` field. */
  jobDefinitionName?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `jobDefinitionRevision` field. */
  jobDefinitionRevision?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `repositoryArn` field. */
  repositoryArn?: InputMaybe<Scalars["String"]["input"]>;
};

/** The `awsEcrImage` to be created by this mutation. */
export type AwsEcrImageContainerimageexecutAabe4FdbFkTesContaAwsEcrImageCreateInput =
  {
    awsMockEcrImageUsingContainerimageexecutorPtrId?: InputMaybe<AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInverseInput>;
    jobDefinitionName?: InputMaybe<Scalars["String"]["input"]>;
    jobDefinitionRevision?: InputMaybe<Scalars["Int"]["input"]>;
    repositoryArn?: InputMaybe<Scalars["String"]["input"]>;
    tesContainerimageexecutorToContainerimageexecutorPtrId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInput>;
  };

/** Input for the nested mutation of `tesContainerimageexecutor` in the `AwsEcrImageInput` mutation. */
export type AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInput = {
  /** The primary key(s) for `tesContainerimageexecutor` for the far side of the relationship. */
  connectById?: InputMaybe<TesContainerimageexecutorTesContainerimageexecutorPkeyConnect>;
  /** A `TesContainerimageexecutorInput` object that will be created and connected to this object. */
  create?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaTesContainerimageexecutorCreateInput>;
  /** The primary key(s) for `tesContainerimageexecutor` for the far side of the relationship. */
  deleteById?: InputMaybe<TesContainerimageexecutorTesContainerimageexecutorPkeyDelete>;
  /** The primary key(s) and patch data for `tesContainerimageexecutor` for the far side of the relationship. */
  updateById?: InputMaybe<TesContainerimageexecutorOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaUsingTesContainerimageexecutorPkeyUpdate>;
};

/** Input for the nested mutation of `awsEcrImage` in the `TesContainerimageexecutorInput` mutation. */
export type AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInverseInput = {
  /** The primary key(s) for `awsEcrImage` for the far side of the relationship. */
  connectByContainerimageexecutorPtrId?: InputMaybe<AwsEcrImageAwsEcrImagePkeyConnect>;
  /** A `AwsEcrImageInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaAwsEcrImageCreateInput>
  >;
  /** The primary key(s) for `awsEcrImage` for the far side of the relationship. */
  deleteByContainerimageexecutorPtrId?: InputMaybe<AwsEcrImageAwsEcrImagePkeyDelete>;
  /** Flag indicating whether all other `awsEcrImage` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `awsEcrImage` for the far side of the relationship. */
  updateByContainerimageexecutorPtrId?: InputMaybe<AwsEcrImageOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaUsingAwsEcrImagePkeyUpdate>;
};

/** The `tesContainerimageexecutor` to be created by this mutation. */
export type AwsEcrImageContainerimageexecutAabe4FdbFkTesContaTesContainerimageexecutorCreateInput =
  {
    awsEcrImageUsingId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInverseInput>;
    containerImageUsingId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInverseInput>;
    distributionRegistryImageUsingId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    tesMockcontainerimageexecutorUsingId?: InputMaybe<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInverseInput>;
  };

/** A filter to be used against `AwsEcrImage` object types. All fields are combined with a logical ‘and.’ */
export type AwsEcrImageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AwsEcrImageFilter>>;
  /** Filter by the object’s `awsMockEcrImageByAwscontainerimageexecutorPtrId` relation. */
  awsMockEcrImageByAwscontainerimageexecutorPtrId?: InputMaybe<AwsMockEcrImageFilter>;
  /** A related `awsMockEcrImageByAwscontainerimageexecutorPtrId` exists. */
  awsMockEcrImageByAwscontainerimageexecutorPtrIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `containerimageexecutorPtrId` field. */
  containerimageexecutorPtrId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `jobDefinitionName` field. */
  jobDefinitionName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `jobDefinitionRevision` field. */
  jobDefinitionRevision?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AwsEcrImageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AwsEcrImageFilter>>;
  /** Filter by the object’s `repositoryArn` field. */
  repositoryArn?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tesContainerimageexecutorByContainerimageexecutorPtrId` relation. */
  tesContainerimageexecutorByContainerimageexecutorPtrId?: InputMaybe<TesContainerimageexecutorFilter>;
};

/** An input for mutations affecting `AwsEcrImage` */
export type AwsEcrImageInput = {
  awsMockEcrImageUsingContainerimageexecutorPtrId?: InputMaybe<AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInverseInput>;
  containerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
  jobDefinitionName?: InputMaybe<Scalars["String"]["input"]>;
  jobDefinitionRevision?: InputMaybe<Scalars["Int"]["input"]>;
  repositoryArn?: InputMaybe<Scalars["String"]["input"]>;
  tesContainerimageexecutorToContainerimageexecutorPtrId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInput>;
};

/** The fields on `awsEcrImage` to look up the row to update. */
export type AwsEcrImageOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaUsingAwsEcrImagePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `awsEcrImage` being updated. */
    awsEcrImagePatch: UpdateAwsEcrImageOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaPatch;
    containerimageexecutorPtrId: Scalars["Int"]["input"];
  };

/** The fields on `awsEcrImage` to look up the row to update. */
export type AwsEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIUsingAwsEcrImagePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `awsEcrImage` being updated. */
    awsEcrImagePatch: UpdateAwsEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIPatch;
    containerimageexecutorPtrId: Scalars["Int"]["input"];
  };

/** Represents an update to a `AwsEcrImage`. Fields that are set will be updated. */
export type AwsEcrImagePatch = {
  awsMockEcrImageUsingContainerimageexecutorPtrId?: InputMaybe<AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInverseInput>;
  containerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
  jobDefinitionName?: InputMaybe<Scalars["String"]["input"]>;
  jobDefinitionRevision?: InputMaybe<Scalars["Int"]["input"]>;
  repositoryArn?: InputMaybe<Scalars["String"]["input"]>;
  tesContainerimageexecutorToContainerimageexecutorPtrId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInput>;
};

/** A connection to a list of `AwsEcrImage` values. */
export type AwsEcrImagesConnection = {
  __typename: "AwsEcrImagesConnection";
  /** A list of edges which contains the `AwsEcrImage` and cursor to aid in pagination. */
  edges: Array<AwsEcrImagesEdge>;
  /** A list of `AwsEcrImage` objects. */
  nodes: Array<AwsEcrImage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AwsEcrImage` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `AwsEcrImage` edge in the connection. */
export type AwsEcrImagesEdge = {
  __typename: "AwsEcrImagesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AwsEcrImage` at the end of the edge. */
  node: AwsEcrImage;
};

/** Methods to use when ordering `AwsEcrImage`. */
export enum AwsEcrImagesOrderBy {
  ContainerimageexecutorPtrIdAsc = "CONTAINERIMAGEEXECUTOR_PTR_ID_ASC",
  ContainerimageexecutorPtrIdDesc = "CONTAINERIMAGEEXECUTOR_PTR_ID_DESC",
  JobDefinitionNameAsc = "JOB_DEFINITION_NAME_ASC",
  JobDefinitionNameDesc = "JOB_DEFINITION_NAME_DESC",
  JobDefinitionRevisionAsc = "JOB_DEFINITION_REVISION_ASC",
  JobDefinitionRevisionDesc = "JOB_DEFINITION_REVISION_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  RepositoryArnAsc = "REPOSITORY_ARN_ASC",
  RepositoryArnDesc = "REPOSITORY_ARN_DESC",
}

export type AwsMockBatchTask = {
  __typename: "AwsMockBatchTask";
  /** Reads a single `AwsBatchTask` that is related to this `AwsMockBatchTask`. */
  awsBatchTaskByAwstaskexecutorPtrId: Maybe<AwsBatchTask>;
  awstaskexecutorPtrId: Scalars["UUID"]["output"];
  containerName: Maybe<Scalars["String"]["output"]>;
};

/** The fields on `awsMockBatchTask` to look up the row to connect. */
export type AwsMockBatchTaskAwsMockBatchTaskPkeyConnect = {
  awstaskexecutorPtrId: Scalars["UUID"]["input"];
};

/** The fields on `awsMockBatchTask` to look up the row to delete. */
export type AwsMockBatchTaskAwsMockBatchTaskPkeyDelete = {
  awstaskexecutorPtrId: Scalars["UUID"]["input"];
};

/** The `awsBatchTask` to be created by this mutation. */
export type AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchAwsBatchTaskCreateInput =
  {
    awsDataBucketName?: InputMaybe<Scalars["String"]["input"]>;
    awsInstanceId?: InputMaybe<Scalars["String"]["input"]>;
    awsInstanceMemory?: InputMaybe<Scalars["Int"]["input"]>;
    awsInstanceType?: InputMaybe<Scalars["String"]["input"]>;
    awsInstanceVcpus?: InputMaybe<Scalars["Int"]["input"]>;
    awsJobId?: InputMaybe<Scalars["String"]["input"]>;
    awsJobQueue?: InputMaybe<Scalars["String"]["input"]>;
    awsJobStatus?: InputMaybe<Scalars["Int"]["input"]>;
    awsJobStatusReason: Scalars["String"]["input"];
    awsMockBatchTaskUsingTaskexecutorPtrId?: InputMaybe<AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInverseInput>;
    awsRegion?: InputMaybe<Scalars["String"]["input"]>;
    awsTaskPath?: InputMaybe<Scalars["String"]["input"]>;
    exitcode?: InputMaybe<Scalars["Int"]["input"]>;
    resultsProcessed: Scalars["Boolean"]["input"];
    taskexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
    tesTaskexecutorToTaskexecutorPtrId?: InputMaybe<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInput>;
  };

/** The `awsMockBatchTask` to be created by this mutation. */
export type AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchAwsMockBatchTaskCreateInput =
  {
    awsBatchTaskToAwstaskexecutorPtrId?: InputMaybe<AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInput>;
    containerName?: InputMaybe<Scalars["String"]["input"]>;
  };

/** Input for the nested mutation of `awsBatchTask` in the `AwsMockBatchTaskInput` mutation. */
export type AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInput = {
  /** The primary key(s) for `awsBatchTask` for the far side of the relationship. */
  connectByTaskexecutorPtrId?: InputMaybe<AwsBatchTaskAwsBatchTaskPkeyConnect>;
  /** A `AwsBatchTaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchAwsBatchTaskCreateInput>;
  /** The primary key(s) for `awsBatchTask` for the far side of the relationship. */
  deleteByTaskexecutorPtrId?: InputMaybe<AwsBatchTaskAwsBatchTaskPkeyDelete>;
  /** The primary key(s) and patch data for `awsBatchTask` for the far side of the relationship. */
  updateByTaskexecutorPtrId?: InputMaybe<AwsBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchUsingAwsBatchTaskPkeyUpdate>;
};

/** Input for the nested mutation of `awsMockBatchTask` in the `AwsBatchTaskInput` mutation. */
export type AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInverseInput = {
  /** The primary key(s) for `awsMockBatchTask` for the far side of the relationship. */
  connectByAwstaskexecutorPtrId?: InputMaybe<AwsMockBatchTaskAwsMockBatchTaskPkeyConnect>;
  /** A `AwsMockBatchTaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchAwsMockBatchTaskCreateInput>
  >;
  /** The primary key(s) for `awsMockBatchTask` for the far side of the relationship. */
  deleteByAwstaskexecutorPtrId?: InputMaybe<AwsMockBatchTaskAwsMockBatchTaskPkeyDelete>;
  /** Flag indicating whether all other `awsMockBatchTask` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `awsMockBatchTask` for the far side of the relationship. */
  updateByAwstaskexecutorPtrId?: InputMaybe<AwsMockBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchUsingAwsMockBatchTaskPkeyUpdate>;
};

/**
 * A condition to be used against `AwsMockBatchTask` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AwsMockBatchTaskCondition = {
  /** Checks for equality with the object’s `awstaskexecutorPtrId` field. */
  awstaskexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `containerName` field. */
  containerName?: InputMaybe<Scalars["String"]["input"]>;
};

/** A filter to be used against `AwsMockBatchTask` object types. All fields are combined with a logical ‘and.’ */
export type AwsMockBatchTaskFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AwsMockBatchTaskFilter>>;
  /** Filter by the object’s `awsBatchTaskByAwstaskexecutorPtrId` relation. */
  awsBatchTaskByAwstaskexecutorPtrId?: InputMaybe<AwsBatchTaskFilter>;
  /** Filter by the object’s `awstaskexecutorPtrId` field. */
  awstaskexecutorPtrId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `containerName` field. */
  containerName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AwsMockBatchTaskFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AwsMockBatchTaskFilter>>;
};

/** An input for mutations affecting `AwsMockBatchTask` */
export type AwsMockBatchTaskInput = {
  awsBatchTaskToAwstaskexecutorPtrId?: InputMaybe<AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInput>;
  awstaskexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
  containerName?: InputMaybe<Scalars["String"]["input"]>;
};

/** The fields on `awsMockBatchTask` to look up the row to update. */
export type AwsMockBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchUsingAwsMockBatchTaskPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `awsMockBatchTask` being updated. */
    awsMockBatchTaskPatch: UpdateAwsMockBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchPatch;
    awstaskexecutorPtrId: Scalars["UUID"]["input"];
  };

/** Represents an update to a `AwsMockBatchTask`. Fields that are set will be updated. */
export type AwsMockBatchTaskPatch = {
  awsBatchTaskToAwstaskexecutorPtrId?: InputMaybe<AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInput>;
  awstaskexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
  containerName?: InputMaybe<Scalars["String"]["input"]>;
};

/** A connection to a list of `AwsMockBatchTask` values. */
export type AwsMockBatchTasksConnection = {
  __typename: "AwsMockBatchTasksConnection";
  /** A list of edges which contains the `AwsMockBatchTask` and cursor to aid in pagination. */
  edges: Array<AwsMockBatchTasksEdge>;
  /** A list of `AwsMockBatchTask` objects. */
  nodes: Array<AwsMockBatchTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AwsMockBatchTask` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `AwsMockBatchTask` edge in the connection. */
export type AwsMockBatchTasksEdge = {
  __typename: "AwsMockBatchTasksEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AwsMockBatchTask` at the end of the edge. */
  node: AwsMockBatchTask;
};

/** Methods to use when ordering `AwsMockBatchTask`. */
export enum AwsMockBatchTasksOrderBy {
  AwstaskexecutorPtrIdAsc = "AWSTASKEXECUTOR_PTR_ID_ASC",
  AwstaskexecutorPtrIdDesc = "AWSTASKEXECUTOR_PTR_ID_DESC",
  ContainerNameAsc = "CONTAINER_NAME_ASC",
  ContainerNameDesc = "CONTAINER_NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

/** The `awsMockDistributionImage` to be created by this mutation. */
export type AwsMockDistributioDistributioncontaineD5Bda68DFkDistributAwsMockDistributionImageCreateInput =
  {
    distributionRegistryImageToDistributioncontainerimageexecutorPtrId?: InputMaybe<AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInput>;
  };

/** The `distributionRegistryImage` to be created by this mutation. */
export type AwsMockDistributioDistributioncontaineD5Bda68DFkDistributDistributionRegistryImageCreateInput =
  {
    awsMockDistributionImageUsingContainerimageexecutorPtrId?: InputMaybe<AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInverseInput>;
    containerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
    jobDefinitionName?: InputMaybe<Scalars["String"]["input"]>;
    jobDefinitionRevision?: InputMaybe<Scalars["Int"]["input"]>;
    tesContainerimageexecutorToContainerimageexecutorPtrId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInput>;
  };

/** Input for the nested mutation of `distributionRegistryImage` in the `AwsMockDistributionImageInput` mutation. */
export type AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInput = {
  /** The primary key(s) for `distributionRegistryImage` for the far side of the relationship. */
  connectByContainerimageexecutorPtrId?: InputMaybe<DistributionRegistryImageDistributionRegistryImagePkeyConnect>;
  /** A `DistributionRegistryImageInput` object that will be created and connected to this object. */
  create?: InputMaybe<AwsMockDistributioDistributioncontaineD5Bda68DFkDistributDistributionRegistryImageCreateInput>;
  /** The primary key(s) for `distributionRegistryImage` for the far side of the relationship. */
  deleteByContainerimageexecutorPtrId?: InputMaybe<DistributionRegistryImageDistributionRegistryImagePkeyDelete>;
  /** The primary key(s) and patch data for `distributionRegistryImage` for the far side of the relationship. */
  updateByContainerimageexecutorPtrId?: InputMaybe<DistributionRegistryImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributUsingDistributionRegistryImagePkeyUpdate>;
};

/** Input for the nested mutation of `awsMockDistributionImage` in the `DistributionRegistryImageInput` mutation. */
export type AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInverseInput =
  {
    /** The primary key(s) for `awsMockDistributionImage` for the far side of the relationship. */
    connectByDistributioncontainerimageexecutorPtrId?: InputMaybe<AwsMockDistributionImageAwsMockDistributionImagePkeyConnect>;
    /** A `AwsMockDistributionImageInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<AwsMockDistributioDistributioncontaineD5Bda68DFkDistributAwsMockDistributionImageCreateInput>
    >;
    /** The primary key(s) for `awsMockDistributionImage` for the far side of the relationship. */
    deleteByDistributioncontainerimageexecutorPtrId?: InputMaybe<AwsMockDistributionImageAwsMockDistributionImagePkeyDelete>;
    /** Flag indicating whether all other `awsMockDistributionImage` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The primary key(s) and patch data for `awsMockDistributionImage` for the far side of the relationship. */
    updateByDistributioncontainerimageexecutorPtrId?: InputMaybe<AwsMockDistributionImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributUsingAwsMockDistributionImagePkeyUpdate>;
  };

export type AwsMockDistributionImage = {
  __typename: "AwsMockDistributionImage";
  /** Reads a single `DistributionRegistryImage` that is related to this `AwsMockDistributionImage`. */
  distributionRegistryImageByDistributioncontainerimageexecutorPtrId: Maybe<DistributionRegistryImage>;
  distributioncontainerimageexecutorPtrId: Scalars["Int"]["output"];
};

/** The fields on `awsMockDistributionImage` to look up the row to connect. */
export type AwsMockDistributionImageAwsMockDistributionImagePkeyConnect = {
  distributioncontainerimageexecutorPtrId: Scalars["Int"]["input"];
};

/** The fields on `awsMockDistributionImage` to look up the row to delete. */
export type AwsMockDistributionImageAwsMockDistributionImagePkeyDelete = {
  distributioncontainerimageexecutorPtrId: Scalars["Int"]["input"];
};

/**
 * A condition to be used against `AwsMockDistributionImage` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type AwsMockDistributionImageCondition = {
  /** Checks for equality with the object’s `distributioncontainerimageexecutorPtrId` field. */
  distributioncontainerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `AwsMockDistributionImage` object types. All fields are combined with a logical ‘and.’ */
export type AwsMockDistributionImageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AwsMockDistributionImageFilter>>;
  /** Filter by the object’s `distributionRegistryImageByDistributioncontainerimageexecutorPtrId` relation. */
  distributionRegistryImageByDistributioncontainerimageexecutorPtrId?: InputMaybe<DistributionRegistryImageFilter>;
  /** Filter by the object’s `distributioncontainerimageexecutorPtrId` field. */
  distributioncontainerimageexecutorPtrId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AwsMockDistributionImageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AwsMockDistributionImageFilter>>;
};

/** An input for mutations affecting `AwsMockDistributionImage` */
export type AwsMockDistributionImageInput = {
  distributionRegistryImageToDistributioncontainerimageexecutorPtrId?: InputMaybe<AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInput>;
  distributioncontainerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `awsMockDistributionImage` to look up the row to update. */
export type AwsMockDistributionImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributUsingAwsMockDistributionImagePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `awsMockDistributionImage` being updated. */
    awsMockDistributionImagePatch: UpdateAwsMockDistributionImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributPatch;
    distributioncontainerimageexecutorPtrId: Scalars["Int"]["input"];
  };

/** Represents an update to a `AwsMockDistributionImage`. Fields that are set will be updated. */
export type AwsMockDistributionImagePatch = {
  distributionRegistryImageToDistributioncontainerimageexecutorPtrId?: InputMaybe<AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInput>;
  distributioncontainerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A connection to a list of `AwsMockDistributionImage` values. */
export type AwsMockDistributionImagesConnection = {
  __typename: "AwsMockDistributionImagesConnection";
  /** A list of edges which contains the `AwsMockDistributionImage` and cursor to aid in pagination. */
  edges: Array<AwsMockDistributionImagesEdge>;
  /** A list of `AwsMockDistributionImage` objects. */
  nodes: Array<AwsMockDistributionImage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AwsMockDistributionImage` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `AwsMockDistributionImage` edge in the connection. */
export type AwsMockDistributionImagesEdge = {
  __typename: "AwsMockDistributionImagesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AwsMockDistributionImage` at the end of the edge. */
  node: AwsMockDistributionImage;
};

/** Methods to use when ordering `AwsMockDistributionImage`. */
export enum AwsMockDistributionImagesOrderBy {
  DistributioncontainerimageexecutorPtrIdAsc = "DISTRIBUTIONCONTAINERIMAGEEXECUTOR_PTR_ID_ASC",
  DistributioncontainerimageexecutorPtrIdDesc = "DISTRIBUTIONCONTAINERIMAGEEXECUTOR_PTR_ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type AwsMockEcrImage = {
  __typename: "AwsMockEcrImage";
  /** Reads a single `AwsEcrImage` that is related to this `AwsMockEcrImage`. */
  awsEcrImageByAwscontainerimageexecutorPtrId: Maybe<AwsEcrImage>;
  awscontainerimageexecutorPtrId: Scalars["Int"]["output"];
};

/** The fields on `awsMockEcrImage` to look up the row to connect. */
export type AwsMockEcrImageAwsMockEcrImagePkeyConnect = {
  awscontainerimageexecutorPtrId: Scalars["Int"]["input"];
};

/** The fields on `awsMockEcrImage` to look up the row to delete. */
export type AwsMockEcrImageAwsMockEcrImagePkeyDelete = {
  awscontainerimageexecutorPtrId: Scalars["Int"]["input"];
};

/** The `awsEcrImage` to be created by this mutation. */
export type AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIAwsEcrImageCreateInput =
  {
    awsMockEcrImageUsingContainerimageexecutorPtrId?: InputMaybe<AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInverseInput>;
    containerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
    jobDefinitionName?: InputMaybe<Scalars["String"]["input"]>;
    jobDefinitionRevision?: InputMaybe<Scalars["Int"]["input"]>;
    repositoryArn?: InputMaybe<Scalars["String"]["input"]>;
    tesContainerimageexecutorToContainerimageexecutorPtrId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInput>;
  };

/** The `awsMockEcrImage` to be created by this mutation. */
export type AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIAwsMockEcrImageCreateInput =
  {
    awsEcrImageToAwscontainerimageexecutorPtrId?: InputMaybe<AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInput>;
  };

/** Input for the nested mutation of `awsEcrImage` in the `AwsMockEcrImageInput` mutation. */
export type AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInput = {
  /** The primary key(s) for `awsEcrImage` for the far side of the relationship. */
  connectByContainerimageexecutorPtrId?: InputMaybe<AwsEcrImageAwsEcrImagePkeyConnect>;
  /** A `AwsEcrImageInput` object that will be created and connected to this object. */
  create?: InputMaybe<AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIAwsEcrImageCreateInput>;
  /** The primary key(s) for `awsEcrImage` for the far side of the relationship. */
  deleteByContainerimageexecutorPtrId?: InputMaybe<AwsEcrImageAwsEcrImagePkeyDelete>;
  /** The primary key(s) and patch data for `awsEcrImage` for the far side of the relationship. */
  updateByContainerimageexecutorPtrId?: InputMaybe<AwsEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIUsingAwsEcrImagePkeyUpdate>;
};

/** Input for the nested mutation of `awsMockEcrImage` in the `AwsEcrImageInput` mutation. */
export type AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInverseInput = {
  /** The primary key(s) for `awsMockEcrImage` for the far side of the relationship. */
  connectByAwscontainerimageexecutorPtrId?: InputMaybe<AwsMockEcrImageAwsMockEcrImagePkeyConnect>;
  /** A `AwsMockEcrImageInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIAwsMockEcrImageCreateInput>
  >;
  /** The primary key(s) for `awsMockEcrImage` for the far side of the relationship. */
  deleteByAwscontainerimageexecutorPtrId?: InputMaybe<AwsMockEcrImageAwsMockEcrImagePkeyDelete>;
  /** Flag indicating whether all other `awsMockEcrImage` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `awsMockEcrImage` for the far side of the relationship. */
  updateByAwscontainerimageexecutorPtrId?: InputMaybe<AwsMockEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIUsingAwsMockEcrImagePkeyUpdate>;
};

/**
 * A condition to be used against `AwsMockEcrImage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AwsMockEcrImageCondition = {
  /** Checks for equality with the object’s `awscontainerimageexecutorPtrId` field. */
  awscontainerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `AwsMockEcrImage` object types. All fields are combined with a logical ‘and.’ */
export type AwsMockEcrImageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AwsMockEcrImageFilter>>;
  /** Filter by the object’s `awsEcrImageByAwscontainerimageexecutorPtrId` relation. */
  awsEcrImageByAwscontainerimageexecutorPtrId?: InputMaybe<AwsEcrImageFilter>;
  /** Filter by the object’s `awscontainerimageexecutorPtrId` field. */
  awscontainerimageexecutorPtrId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AwsMockEcrImageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AwsMockEcrImageFilter>>;
};

/** An input for mutations affecting `AwsMockEcrImage` */
export type AwsMockEcrImageInput = {
  awsEcrImageToAwscontainerimageexecutorPtrId?: InputMaybe<AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInput>;
  awscontainerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `awsMockEcrImage` to look up the row to update. */
export type AwsMockEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIUsingAwsMockEcrImagePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `awsMockEcrImage` being updated. */
    awsMockEcrImagePatch: UpdateAwsMockEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIPatch;
    awscontainerimageexecutorPtrId: Scalars["Int"]["input"];
  };

/** Represents an update to a `AwsMockEcrImage`. Fields that are set will be updated. */
export type AwsMockEcrImagePatch = {
  awsEcrImageToAwscontainerimageexecutorPtrId?: InputMaybe<AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInput>;
  awscontainerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A connection to a list of `AwsMockEcrImage` values. */
export type AwsMockEcrImagesConnection = {
  __typename: "AwsMockEcrImagesConnection";
  /** A list of edges which contains the `AwsMockEcrImage` and cursor to aid in pagination. */
  edges: Array<AwsMockEcrImagesEdge>;
  /** A list of `AwsMockEcrImage` objects. */
  nodes: Array<AwsMockEcrImage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AwsMockEcrImage` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `AwsMockEcrImage` edge in the connection. */
export type AwsMockEcrImagesEdge = {
  __typename: "AwsMockEcrImagesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AwsMockEcrImage` at the end of the edge. */
  node: AwsMockEcrImage;
};

/** Methods to use when ordering `AwsMockEcrImage`. */
export enum AwsMockEcrImagesOrderBy {
  AwscontainerimageexecutorPtrIdAsc = "AWSCONTAINERIMAGEEXECUTOR_PTR_ID_ASC",
  AwscontainerimageexecutorPtrIdDesc = "AWSCONTAINERIMAGEEXECUTOR_PTR_ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type AwsMockIamUser = {
  __typename: "AwsMockIamUser";
  /** Reads a single `AwsCognitoUser` that is related to this `AwsMockIamUser`. */
  awsCognitoUserByAwsuserexecutorPtrId: Maybe<AwsCognitoUser>;
  awsuserexecutorPtrId: Scalars["Int"]["output"];
};

/** The fields on `awsMockIamUser` to look up the row to connect. */
export type AwsMockIamUserAwsMockIamUserPkeyConnect = {
  awsuserexecutorPtrId: Scalars["Int"]["input"];
};

/** The fields on `awsMockIamUser` to look up the row to delete. */
export type AwsMockIamUserAwsMockIamUserPkeyDelete = {
  awsuserexecutorPtrId: Scalars["Int"]["input"];
};

/** The `awsCognitoUser` to be created by this mutation. */
export type AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniAwsCognitoUserCreateInput =
  {
    awsMockIamUserUsingUserexecutorPtrId?: InputMaybe<AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInverseInput>;
    tenantUserexecutorToUserexecutorPtrId?: InputMaybe<AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInput>;
    userexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** The `awsMockIamUser` to be created by this mutation. */
export type AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniAwsMockIamUserCreateInput =
  {
    awsCognitoUserToAwsuserexecutorPtrId?: InputMaybe<AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInput>;
  };

/** Input for the nested mutation of `awsCognitoUser` in the `AwsMockIamUserInput` mutation. */
export type AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInput = {
  /** The primary key(s) for `awsCognitoUser` for the far side of the relationship. */
  connectByUserexecutorPtrId?: InputMaybe<AwsCognitoUserAwsCognitoUserPkeyConnect>;
  /** A `AwsCognitoUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniAwsCognitoUserCreateInput>;
  /** The primary key(s) for `awsCognitoUser` for the far side of the relationship. */
  deleteByUserexecutorPtrId?: InputMaybe<AwsCognitoUserAwsCognitoUserPkeyDelete>;
  /** The primary key(s) and patch data for `awsCognitoUser` for the far side of the relationship. */
  updateByUserexecutorPtrId?: InputMaybe<AwsCognitoUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniUsingAwsCognitoUserPkeyUpdate>;
};

/** Input for the nested mutation of `awsMockIamUser` in the `AwsCognitoUserInput` mutation. */
export type AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInverseInput = {
  /** The primary key(s) for `awsMockIamUser` for the far side of the relationship. */
  connectByAwsuserexecutorPtrId?: InputMaybe<AwsMockIamUserAwsMockIamUserPkeyConnect>;
  /** A `AwsMockIamUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniAwsMockIamUserCreateInput>
  >;
  /** The primary key(s) for `awsMockIamUser` for the far side of the relationship. */
  deleteByAwsuserexecutorPtrId?: InputMaybe<AwsMockIamUserAwsMockIamUserPkeyDelete>;
  /** Flag indicating whether all other `awsMockIamUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `awsMockIamUser` for the far side of the relationship. */
  updateByAwsuserexecutorPtrId?: InputMaybe<AwsMockIamUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniUsingAwsMockIamUserPkeyUpdate>;
};

/**
 * A condition to be used against `AwsMockIamUser` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AwsMockIamUserCondition = {
  /** Checks for equality with the object’s `awsuserexecutorPtrId` field. */
  awsuserexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `AwsMockIamUser` object types. All fields are combined with a logical ‘and.’ */
export type AwsMockIamUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AwsMockIamUserFilter>>;
  /** Filter by the object’s `awsCognitoUserByAwsuserexecutorPtrId` relation. */
  awsCognitoUserByAwsuserexecutorPtrId?: InputMaybe<AwsCognitoUserFilter>;
  /** Filter by the object’s `awsuserexecutorPtrId` field. */
  awsuserexecutorPtrId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AwsMockIamUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AwsMockIamUserFilter>>;
};

/** An input for mutations affecting `AwsMockIamUser` */
export type AwsMockIamUserInput = {
  awsCognitoUserToAwsuserexecutorPtrId?: InputMaybe<AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInput>;
  awsuserexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `awsMockIamUser` to look up the row to update. */
export type AwsMockIamUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniUsingAwsMockIamUserPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `awsMockIamUser` being updated. */
    awsMockIamUserPatch: UpdateAwsMockIamUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniPatch;
    awsuserexecutorPtrId: Scalars["Int"]["input"];
  };

/** Represents an update to a `AwsMockIamUser`. Fields that are set will be updated. */
export type AwsMockIamUserPatch = {
  awsCognitoUserToAwsuserexecutorPtrId?: InputMaybe<AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInput>;
  awsuserexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A connection to a list of `AwsMockIamUser` values. */
export type AwsMockIamUsersConnection = {
  __typename: "AwsMockIamUsersConnection";
  /** A list of edges which contains the `AwsMockIamUser` and cursor to aid in pagination. */
  edges: Array<AwsMockIamUsersEdge>;
  /** A list of `AwsMockIamUser` objects. */
  nodes: Array<AwsMockIamUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AwsMockIamUser` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `AwsMockIamUser` edge in the connection. */
export type AwsMockIamUsersEdge = {
  __typename: "AwsMockIamUsersEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AwsMockIamUser` at the end of the edge. */
  node: AwsMockIamUser;
};

/** Methods to use when ordering `AwsMockIamUser`. */
export enum AwsMockIamUsersOrderBy {
  AwsuserexecutorPtrIdAsc = "AWSUSEREXECUTOR_PTR_ID_ASC",
  AwsuserexecutorPtrIdDesc = "AWSUSEREXECUTOR_PTR_ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type AwsMockS3File = {
  __typename: "AwsMockS3File";
  /** Reads a single `AwsS3File` that is related to this `AwsMockS3File`. */
  awsS3FileByAwsfileexecutorPtrId: Maybe<AwsS3File>;
  awsfileexecutorPtrId: Scalars["UUID"]["output"];
};

/** The fields on `awsMockS3File` to look up the row to connect. */
export type AwsMockS3FileAwsMockS3FilePkeyConnect = {
  awsfileexecutorPtrId: Scalars["UUID"]["input"];
};

/** The fields on `awsMockS3File` to look up the row to delete. */
export type AwsMockS3FileAwsMockS3FilePkeyDelete = {
  awsfileexecutorPtrId: Scalars["UUID"]["input"];
};

/** The `awsMockS3File` to be created by this mutation. */
export type AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiAwsMockS3FileCreateInput =
  {
    awsS3FileToAwsfileexecutorPtrId?: InputMaybe<AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInput>;
  };

/** The `awsS3File` to be created by this mutation. */
export type AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiAwsS3FileCreateInput =
  {
    awsMockS3FileUsingFileexecutorPtrId?: InputMaybe<AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInverseInput>;
    awsUploadPath: Scalars["String"]["input"];
    drsFileexecutorToFileexecutorPtrId?: InputMaybe<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInput>;
    fileexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** Input for the nested mutation of `awsS3File` in the `AwsMockS3FileInput` mutation. */
export type AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInput = {
  /** The primary key(s) for `awsS3File` for the far side of the relationship. */
  connectByFileexecutorPtrId?: InputMaybe<AwsS3FileAwsS3FilePkeyConnect>;
  /** A `AwsS3FileInput` object that will be created and connected to this object. */
  create?: InputMaybe<AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiAwsS3FileCreateInput>;
  /** The primary key(s) for `awsS3File` for the far side of the relationship. */
  deleteByFileexecutorPtrId?: InputMaybe<AwsS3FileAwsS3FilePkeyDelete>;
  /** The primary key(s) and patch data for `awsS3File` for the far side of the relationship. */
  updateByFileexecutorPtrId?: InputMaybe<AwsS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiUsingAwsS3FilePkeyUpdate>;
};

/** Input for the nested mutation of `awsMockS3File` in the `AwsS3FileInput` mutation. */
export type AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInverseInput = {
  /** The primary key(s) for `awsMockS3File` for the far side of the relationship. */
  connectByAwsfileexecutorPtrId?: InputMaybe<AwsMockS3FileAwsMockS3FilePkeyConnect>;
  /** A `AwsMockS3FileInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiAwsMockS3FileCreateInput>
  >;
  /** The primary key(s) for `awsMockS3File` for the far side of the relationship. */
  deleteByAwsfileexecutorPtrId?: InputMaybe<AwsMockS3FileAwsMockS3FilePkeyDelete>;
  /** Flag indicating whether all other `awsMockS3File` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `awsMockS3File` for the far side of the relationship. */
  updateByAwsfileexecutorPtrId?: InputMaybe<AwsMockS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiUsingAwsMockS3FilePkeyUpdate>;
};

/**
 * A condition to be used against `AwsMockS3File` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AwsMockS3FileCondition = {
  /** Checks for equality with the object’s `awsfileexecutorPtrId` field. */
  awsfileexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `AwsMockS3File` object types. All fields are combined with a logical ‘and.’ */
export type AwsMockS3FileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AwsMockS3FileFilter>>;
  /** Filter by the object’s `awsS3FileByAwsfileexecutorPtrId` relation. */
  awsS3FileByAwsfileexecutorPtrId?: InputMaybe<AwsS3FileFilter>;
  /** Filter by the object’s `awsfileexecutorPtrId` field. */
  awsfileexecutorPtrId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AwsMockS3FileFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AwsMockS3FileFilter>>;
};

/** An input for mutations affecting `AwsMockS3File` */
export type AwsMockS3FileInput = {
  awsS3FileToAwsfileexecutorPtrId?: InputMaybe<AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInput>;
  awsfileexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `awsMockS3File` to look up the row to update. */
export type AwsMockS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiUsingAwsMockS3FilePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `awsMockS3File` being updated. */
    awsMockS3FilePatch: UpdateAwsMockS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiPatch;
    awsfileexecutorPtrId: Scalars["UUID"]["input"];
  };

/** Represents an update to a `AwsMockS3File`. Fields that are set will be updated. */
export type AwsMockS3FilePatch = {
  awsS3FileToAwsfileexecutorPtrId?: InputMaybe<AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInput>;
  awsfileexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A connection to a list of `AwsMockS3File` values. */
export type AwsMockS3FilesConnection = {
  __typename: "AwsMockS3FilesConnection";
  /** A list of edges which contains the `AwsMockS3File` and cursor to aid in pagination. */
  edges: Array<AwsMockS3FilesEdge>;
  /** A list of `AwsMockS3File` objects. */
  nodes: Array<AwsMockS3File>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AwsMockS3File` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `AwsMockS3File` edge in the connection. */
export type AwsMockS3FilesEdge = {
  __typename: "AwsMockS3FilesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AwsMockS3File` at the end of the edge. */
  node: AwsMockS3File;
};

/** Methods to use when ordering `AwsMockS3File`. */
export enum AwsMockS3FilesOrderBy {
  AwsfileexecutorPtrIdAsc = "AWSFILEEXECUTOR_PTR_ID_ASC",
  AwsfileexecutorPtrIdDesc = "AWSFILEEXECUTOR_PTR_ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type AwsS3File = {
  __typename: "AwsS3File";
  /** Reads a single `AwsMockS3File` that is related to this `AwsS3File`. */
  awsMockS3FileByAwsfileexecutorPtrId: Maybe<AwsMockS3File>;
  /**
   * Reads and enables pagination through a set of `AwsMockS3File`.
   * @deprecated Please use awsMockS3FileByAwsfileexecutorPtrId instead
   */
  awsMockS3FilesByAwsfileexecutorPtrId: AwsMockS3FilesConnection;
  awsUploadPath: Scalars["String"]["output"];
  /** Reads a single `DrsFileexecutor` that is related to this `AwsS3File`. */
  drsFileexecutorByFileexecutorPtrId: Maybe<DrsFileexecutor>;
  fileexecutorPtrId: Scalars["UUID"]["output"];
};

export type AwsS3FileAwsMockS3FilesByAwsfileexecutorPtrIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsMockS3FileCondition>;
  filter?: InputMaybe<AwsMockS3FileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsMockS3FilesOrderBy>>;
};

/** The fields on `awsS3File` to look up the row to connect. */
export type AwsS3FileAwsS3FilePkeyConnect = {
  fileexecutorPtrId: Scalars["UUID"]["input"];
};

/** The fields on `awsS3File` to look up the row to delete. */
export type AwsS3FileAwsS3FilePkeyDelete = {
  fileexecutorPtrId: Scalars["UUID"]["input"];
};

/**
 * A condition to be used against `AwsS3File` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AwsS3FileCondition = {
  /** Checks for equality with the object’s `awsUploadPath` field. */
  awsUploadPath?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `fileexecutorPtrId` field. */
  fileexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `awsS3File` to be created by this mutation. */
export type AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdAwsS3FileCreateInput =
  {
    awsMockS3FileUsingFileexecutorPtrId?: InputMaybe<AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInverseInput>;
    awsUploadPath: Scalars["String"]["input"];
    drsFileexecutorToFileexecutorPtrId?: InputMaybe<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInput>;
  };

/** The `drsFileexecutor` to be created by this mutation. */
export type AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdDrsFileexecutorCreateInput =
  {
    awsS3FileUsingId?: InputMaybe<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInput>;
    drsMockfileexecutorUsingId?: InputMaybe<DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInverseInput>;
    filesUsingId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInverseInput>;
    id: Scalars["UUID"]["input"];
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** Input for the nested mutation of `drsFileexecutor` in the `AwsS3FileInput` mutation. */
export type AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInput = {
  /** The primary key(s) for `drsFileexecutor` for the far side of the relationship. */
  connectById?: InputMaybe<DrsFileexecutorDrsFileexecutorPkeyConnect>;
  /** A `DrsFileexecutorInput` object that will be created and connected to this object. */
  create?: InputMaybe<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdDrsFileexecutorCreateInput>;
  /** The primary key(s) for `drsFileexecutor` for the far side of the relationship. */
  deleteById?: InputMaybe<DrsFileexecutorDrsFileexecutorPkeyDelete>;
  /** The primary key(s) and patch data for `drsFileexecutor` for the far side of the relationship. */
  updateById?: InputMaybe<DrsFileexecutorOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdUsingDrsFileexecutorPkeyUpdate>;
};

/** Input for the nested mutation of `awsS3File` in the `DrsFileexecutorInput` mutation. */
export type AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInverseInput =
  {
    /** The primary key(s) for `awsS3File` for the far side of the relationship. */
    connectByFileexecutorPtrId?: InputMaybe<AwsS3FileAwsS3FilePkeyConnect>;
    /** A `AwsS3FileInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdAwsS3FileCreateInput>
    >;
    /** The primary key(s) for `awsS3File` for the far side of the relationship. */
    deleteByFileexecutorPtrId?: InputMaybe<AwsS3FileAwsS3FilePkeyDelete>;
    /** Flag indicating whether all other `awsS3File` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The primary key(s) and patch data for `awsS3File` for the far side of the relationship. */
    updateByFileexecutorPtrId?: InputMaybe<AwsS3FileOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdUsingAwsS3FilePkeyUpdate>;
  };

/** A filter to be used against `AwsS3File` object types. All fields are combined with a logical ‘and.’ */
export type AwsS3FileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AwsS3FileFilter>>;
  /** Filter by the object’s `awsMockS3FileByAwsfileexecutorPtrId` relation. */
  awsMockS3FileByAwsfileexecutorPtrId?: InputMaybe<AwsMockS3FileFilter>;
  /** A related `awsMockS3FileByAwsfileexecutorPtrId` exists. */
  awsMockS3FileByAwsfileexecutorPtrIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `awsUploadPath` field. */
  awsUploadPath?: InputMaybe<StringFilter>;
  /** Filter by the object’s `drsFileexecutorByFileexecutorPtrId` relation. */
  drsFileexecutorByFileexecutorPtrId?: InputMaybe<DrsFileexecutorFilter>;
  /** Filter by the object’s `fileexecutorPtrId` field. */
  fileexecutorPtrId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AwsS3FileFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AwsS3FileFilter>>;
};

/** An input for mutations affecting `AwsS3File` */
export type AwsS3FileInput = {
  awsMockS3FileUsingFileexecutorPtrId?: InputMaybe<AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInverseInput>;
  awsUploadPath: Scalars["String"]["input"];
  drsFileexecutorToFileexecutorPtrId?: InputMaybe<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInput>;
  fileexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `awsS3File` to look up the row to update. */
export type AwsS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiUsingAwsS3FilePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `awsS3File` being updated. */
    awsS3FilePatch: UpdateAwsS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiPatch;
    fileexecutorPtrId: Scalars["UUID"]["input"];
  };

/** The fields on `awsS3File` to look up the row to update. */
export type AwsS3FileOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdUsingAwsS3FilePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `awsS3File` being updated. */
    awsS3FilePatch: UpdateAwsS3FileOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdPatch;
    fileexecutorPtrId: Scalars["UUID"]["input"];
  };

/** Represents an update to a `AwsS3File`. Fields that are set will be updated. */
export type AwsS3FilePatch = {
  awsMockS3FileUsingFileexecutorPtrId?: InputMaybe<AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInverseInput>;
  awsUploadPath?: InputMaybe<Scalars["String"]["input"]>;
  drsFileexecutorToFileexecutorPtrId?: InputMaybe<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInput>;
  fileexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A connection to a list of `AwsS3File` values. */
export type AwsS3FilesConnection = {
  __typename: "AwsS3FilesConnection";
  /** A list of edges which contains the `AwsS3File` and cursor to aid in pagination. */
  edges: Array<AwsS3FilesEdge>;
  /** A list of `AwsS3File` objects. */
  nodes: Array<AwsS3File>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AwsS3File` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `AwsS3File` edge in the connection. */
export type AwsS3FilesEdge = {
  __typename: "AwsS3FilesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `AwsS3File` at the end of the edge. */
  node: AwsS3File;
};

/** Methods to use when ordering `AwsS3File`. */
export enum AwsS3FilesOrderBy {
  AwsUploadPathAsc = "AWS_UPLOAD_PATH_ASC",
  AwsUploadPathDesc = "AWS_UPLOAD_PATH_DESC",
  FileexecutorPtrIdAsc = "FILEEXECUTOR_PTR_ID_ASC",
  FileexecutorPtrIdDesc = "FILEEXECUTOR_PTR_ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["BigFloat"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["BigFloat"]["input"]>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["BigInt"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["BigInt"]["input"]>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["Boolean"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["Boolean"]["input"]>>;
};

/** All input for the `changeUserSession` mutation. */
export type ChangeUserSessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  userid: Scalars["UUID"]["input"];
};

/** The output of our `changeUserSession` mutation. */
export type ChangeUserSessionPayload = {
  __typename: "ChangeUserSessionPayload";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserSession`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  applicationUserSession: Maybe<ApplicationUserSession>;
  /** An edge for our `ApplicationUserSession`. May be used by Relay 1. */
  applicationUserSessionEdge: Maybe<ApplicationUserSessionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ApplicationUserSession`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our `changeUserSession` mutation. */
export type ChangeUserSessionPayloadApplicationUserSessionEdgeArgs = {
  orderBy?: InputMaybe<Array<ApplicationUserSessionsOrderBy>>;
};

export type CodeFile = {
  __typename: "CodeFile";
  /** Reads a single `ApplicationUser` that is related to this `CodeFile`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  checksum: Scalars["String"]["output"];
  /** Reads a single `CodeFile` that is related to this `CodeFile`. */
  codeFileBySeriesParentId: Maybe<CodeFile>;
  /** Reads and enables pagination through a set of `CodeFile`. */
  codeFilesBySeriesParentId: CodeFilesConnection;
  /** Reads and enables pagination through a set of `Command`. */
  commandsByCodeFileId: CommandsConnection;
  compressed: Scalars["Boolean"]["output"];
  dateArchived: Maybe<Scalars["Datetime"]["output"]>;
  dateCreated: Scalars["Datetime"]["output"];
  dateDataDeleted: Maybe<Scalars["Datetime"]["output"]>;
  dateDeleted: Maybe<Scalars["Datetime"]["output"]>;
  /** Reads a single `DrsFileexecutor` that is related to this `CodeFile`. */
  drsFileexecutorByExecutorId: Maybe<DrsFileexecutor>;
  executorId: Maybe<Scalars["UUID"]["output"]>;
  fileFormat: Maybe<Scalars["Int"]["output"]>;
  fileStructure: Maybe<Scalars["Int"]["output"]>;
  fileType: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["UUID"]["output"];
  isSeries: Scalars["Boolean"]["output"];
  key: Maybe<Scalars["String"]["output"]>;
  location: Maybe<Scalars["String"]["output"]>;
  multipartUploadId: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  originalName: Scalars["String"]["output"];
  partSize: Maybe<Scalars["Int"]["output"]>;
  seriesParentId: Maybe<Scalars["UUID"]["output"]>;
  signal: Maybe<Scalars["Int"]["output"]>;
  size: Maybe<Scalars["BigInt"]["output"]>;
  status: Scalars["Int"]["output"];
  tags: Array<Maybe<Scalars["String"]["output"]>>;
  /** Reads a single `Tenant` that is related to this `CodeFile`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
  uploadStatus: Maybe<Scalars["Int"]["output"]>;
  userId: Scalars["UUID"]["output"];
};

export type CodeFileCodeFilesBySeriesParentIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CodeFileCondition>;
  filter?: InputMaybe<CodeFileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CodeFilesOrderBy>>;
};

export type CodeFileCommandsByCodeFileIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CommandCondition>;
  filter?: InputMaybe<CommandFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CommandsOrderBy>>;
};

/** The fields on `codeFile` to look up the row to connect. */
export type CodeFileCodeFilePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `codeFile` to look up the row to delete. */
export type CodeFileCodeFilePkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/**
 * A condition to be used against `CodeFile` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CodeFileCondition = {
  /** Checks for equality with the object’s `checksum` field. */
  checksum?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `compressed` field. */
  compressed?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `dateArchived` field. */
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateDataDeleted` field. */
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `executorId` field. */
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `fileFormat` field. */
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `fileStructure` field. */
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `fileType` field. */
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `isSeries` field. */
  isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `location` field. */
  location?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `multipartUploadId` field. */
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `originalName` field. */
  originalName?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `partSize` field. */
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `seriesParentId` field. */
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `signal` field. */
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `size` field. */
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `tags` field. */
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `uploadStatus` field. */
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `codeFile` to be created by this mutation. */
export type CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdCodeFileCreateInput = {
  applicationUserToUserId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInput>;
  checksum: Scalars["String"]["input"];
  codeFileToSeriesParentId?: InputMaybe<CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput>;
  commandsUsingId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInverseInput>;
  compressed: Scalars["Boolean"]["input"];
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["UUID"]["input"];
  isSeries: Scalars["Boolean"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  originalName: Scalars["String"]["input"];
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `drsFileexecutor` to be created by this mutation. */
export type CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdDrsFileexecutorCreateInput =
  {
    awsS3FileUsingId?: InputMaybe<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInput>;
    drsMockfileexecutorUsingId?: InputMaybe<DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInverseInput>;
    filesUsingId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInverseInput>;
    id: Scalars["UUID"]["input"];
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** Input for the nested mutation of `drsFileexecutor` in the `CodeFileInput` mutation. */
export type CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInput = {
  /** The primary key(s) for `drsFileexecutor` for the far side of the relationship. */
  connectById?: InputMaybe<DrsFileexecutorDrsFileexecutorPkeyConnect>;
  /** A `DrsFileexecutorInput` object that will be created and connected to this object. */
  create?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdDrsFileexecutorCreateInput>;
  /** The primary key(s) for `drsFileexecutor` for the far side of the relationship. */
  deleteById?: InputMaybe<DrsFileexecutorDrsFileexecutorPkeyDelete>;
  /** The primary key(s) and patch data for `drsFileexecutor` for the far side of the relationship. */
  updateById?: InputMaybe<DrsFileexecutorOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdUsingDrsFileexecutorPkeyUpdate>;
};

/** Input for the nested mutation of `codeFile` in the `DrsFileexecutorInput` mutation. */
export type CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInverseInput = {
  /** The primary key(s) for `codeFile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CodeFileCodeFilePkeyConnect>>;
  /** A `CodeFileInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdCodeFileCreateInput>
  >;
  /** The primary key(s) for `codeFile` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CodeFileCodeFilePkeyDelete>>;
  /** Flag indicating whether all other `codeFile` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `codeFile` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<CodeFileOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdUsingCodeFilePkeyUpdate>
  >;
};

/** A filter to be used against `CodeFile` object types. All fields are combined with a logical ‘and.’ */
export type CodeFileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CodeFileFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `checksum` field. */
  checksum?: InputMaybe<StringFilter>;
  /** Filter by the object’s `codeFileBySeriesParentId` relation. */
  codeFileBySeriesParentId?: InputMaybe<CodeFileFilter>;
  /** A related `codeFileBySeriesParentId` exists. */
  codeFileBySeriesParentIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `codeFilesBySeriesParentId` relation. */
  codeFilesBySeriesParentId?: InputMaybe<CodeFileToManyCodeFileFilter>;
  /** Some related `codeFilesBySeriesParentId` exist. */
  codeFilesBySeriesParentIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `commandsByCodeFileId` relation. */
  commandsByCodeFileId?: InputMaybe<CodeFileToManyCommandFilter>;
  /** Some related `commandsByCodeFileId` exist. */
  commandsByCodeFileIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `compressed` field. */
  compressed?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dateArchived` field. */
  dateArchived?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDataDeleted` field. */
  dateDataDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `drsFileexecutorByExecutorId` relation. */
  drsFileexecutorByExecutorId?: InputMaybe<DrsFileexecutorFilter>;
  /** A related `drsFileexecutorByExecutorId` exists. */
  drsFileexecutorByExecutorIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `executorId` field. */
  executorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fileFormat` field. */
  fileFormat?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fileStructure` field. */
  fileStructure?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fileType` field. */
  fileType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isSeries` field. */
  isSeries?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `location` field. */
  location?: InputMaybe<StringFilter>;
  /** Filter by the object’s `multipartUploadId` field. */
  multipartUploadId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CodeFileFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CodeFileFilter>>;
  /** Filter by the object’s `originalName` field. */
  originalName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `partSize` field. */
  partSize?: InputMaybe<IntFilter>;
  /** Filter by the object’s `seriesParentId` field. */
  seriesParentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `signal` field. */
  signal?: InputMaybe<IntFilter>;
  /** Filter by the object’s `size` field. */
  size?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `uploadStatus` field. */
  uploadStatus?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `CodeFile` */
export type CodeFileInput = {
  applicationUserToUserId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInput>;
  checksum: Scalars["String"]["input"];
  codeFileToSeriesParentId?: InputMaybe<CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput>;
  commandsUsingId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInverseInput>;
  compressed: Scalars["Boolean"]["input"];
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["UUID"]["input"];
  isSeries: Scalars["Boolean"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  originalName: Scalars["String"]["input"];
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `codeFile` to look up the row to update. */
export type CodeFileOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdUsingCodeFilePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `codeFile` being updated. */
    codeFilePatch: UpdateCodeFileOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `codeFile` to look up the row to update. */
export type CodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdUsingCodeFilePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `codeFile` being updated. */
    codeFilePatch: UpdateCodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `codeFile` to look up the row to update. */
export type CodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingCodeFilePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `codeFile` being updated. */
    codeFilePatch: UpdateCodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `codeFile` to look up the row to update. */
export type CodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingCodeFilePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `codeFile` being updated. */
    codeFilePatch: UpdateCodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `codeFile` to look up the row to update. */
export type CodeFileOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCodeFilePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `codeFile` being updated. */
    codeFilePatch: UpdateCodeFileOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** Represents an update to a `CodeFile`. Fields that are set will be updated. */
export type CodeFilePatch = {
  applicationUserToUserId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInput>;
  checksum?: InputMaybe<Scalars["String"]["input"]>;
  codeFileToSeriesParentId?: InputMaybe<CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput>;
  commandsUsingId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInverseInput>;
  compressed?: InputMaybe<Scalars["Boolean"]["input"]>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  originalName?: InputMaybe<Scalars["String"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `codeFile` to be created by this mutation. */
export type CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdCodeFileCreateInput = {
  applicationUserToUserId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInput>;
  checksum: Scalars["String"]["input"];
  codeFileToSeriesParentId?: InputMaybe<CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput>;
  commandsUsingId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInverseInput>;
  compressed: Scalars["Boolean"]["input"];
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["UUID"]["input"];
  isSeries: Scalars["Boolean"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  originalName: Scalars["String"]["input"];
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `codeFile` in the `CodeFileInput` mutation. */
export type CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput = {
  /** The primary key(s) for `codeFile` for the far side of the relationship. */
  connectById?: InputMaybe<CodeFileCodeFilePkeyConnect>;
  /** A `CodeFileInput` object that will be created and connected to this object. */
  create?: InputMaybe<CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdCodeFileCreateInput>;
  /** The primary key(s) for `codeFile` for the far side of the relationship. */
  deleteById?: InputMaybe<CodeFileCodeFilePkeyDelete>;
  /** The primary key(s) and patch data for `codeFile` for the far side of the relationship. */
  updateById?: InputMaybe<CodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdUsingCodeFilePkeyUpdate>;
};

/** The `codeFile` to be created by this mutation. */
export type CodeFileTenantIdC35D8B4EFkTenantIdCodeFileCreateInput = {
  applicationUserToUserId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInput>;
  checksum: Scalars["String"]["input"];
  codeFileToSeriesParentId?: InputMaybe<CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput>;
  commandsUsingId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInverseInput>;
  compressed: Scalars["Boolean"]["input"];
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["UUID"]["input"];
  isSeries: Scalars["Boolean"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  originalName: Scalars["String"]["input"];
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  tenantToTenantId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `tenant` in the `CodeFileInput` mutation. */
export type CodeFileTenantIdC35D8B4EFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `codeFile` in the `TenantInput` mutation. */
export type CodeFileTenantIdC35D8B4EFkTenantIdInverseInput = {
  /** The primary key(s) for `codeFile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CodeFileCodeFilePkeyConnect>>;
  /** A `CodeFileInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<CodeFileTenantIdC35D8B4EFkTenantIdCodeFileCreateInput>
  >;
  /** The primary key(s) for `codeFile` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CodeFileCodeFilePkeyDelete>>;
  /** Flag indicating whether all other `codeFile` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `codeFile` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<CodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingCodeFilePkeyUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type CodeFileTenantIdC35D8B4EFkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** A filter to be used against many `CodeFile` object types. All fields are combined with a logical ‘and.’ */
export type CodeFileToManyCodeFileFilter = {
  /** Every related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CodeFileFilter>;
  /** No related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CodeFileFilter>;
  /** Some related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CodeFileFilter>;
};

/** A filter to be used against many `Command` object types. All fields are combined with a logical ‘and.’ */
export type CodeFileToManyCommandFilter = {
  /** Every related `Command` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CommandFilter>;
  /** No related `Command` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CommandFilter>;
  /** Some related `Command` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CommandFilter>;
};

/** The `applicationUser` to be created by this mutation. */
export type CodeFileUserIdAb9E5143FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** The `codeFile` to be created by this mutation. */
export type CodeFileUserIdAb9E5143FkApplicationUserIdCodeFileCreateInput = {
  applicationUserToUserId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInput>;
  checksum: Scalars["String"]["input"];
  codeFileToSeriesParentId?: InputMaybe<CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput>;
  commandsUsingId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInverseInput>;
  compressed: Scalars["Boolean"]["input"];
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["UUID"]["input"];
  isSeries: Scalars["Boolean"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  originalName: Scalars["String"]["input"];
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input for the nested mutation of `applicationUser` in the `CodeFileInput` mutation. */
export type CodeFileUserIdAb9E5143FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `codeFile` in the `ApplicationUserInput` mutation. */
export type CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `codeFile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CodeFileCodeFilePkeyConnect>>;
  /** A `CodeFileInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<CodeFileUserIdAb9E5143FkApplicationUserIdCodeFileCreateInput>
  >;
  /** The primary key(s) for `codeFile` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CodeFileCodeFilePkeyDelete>>;
  /** Flag indicating whether all other `codeFile` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `codeFile` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<CodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingCodeFilePkeyUpdate>
  >;
};

/** A connection to a list of `CodeFile` values. */
export type CodeFilesConnection = {
  __typename: "CodeFilesConnection";
  /** A list of edges which contains the `CodeFile` and cursor to aid in pagination. */
  edges: Array<CodeFilesEdge>;
  /** A list of `CodeFile` objects. */
  nodes: Array<CodeFile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CodeFile` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `CodeFile` edge in the connection. */
export type CodeFilesEdge = {
  __typename: "CodeFilesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `CodeFile` at the end of the edge. */
  node: CodeFile;
};

/** Methods to use when ordering `CodeFile`. */
export enum CodeFilesOrderBy {
  ChecksumAsc = "CHECKSUM_ASC",
  ChecksumDesc = "CHECKSUM_DESC",
  CompressedAsc = "COMPRESSED_ASC",
  CompressedDesc = "COMPRESSED_DESC",
  DateArchivedAsc = "DATE_ARCHIVED_ASC",
  DateArchivedDesc = "DATE_ARCHIVED_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DateDataDeletedAsc = "DATE_DATA_DELETED_ASC",
  DateDataDeletedDesc = "DATE_DATA_DELETED_DESC",
  DateDeletedAsc = "DATE_DELETED_ASC",
  DateDeletedDesc = "DATE_DELETED_DESC",
  ExecutorIdAsc = "EXECUTOR_ID_ASC",
  ExecutorIdDesc = "EXECUTOR_ID_DESC",
  FileFormatAsc = "FILE_FORMAT_ASC",
  FileFormatDesc = "FILE_FORMAT_DESC",
  FileStructureAsc = "FILE_STRUCTURE_ASC",
  FileStructureDesc = "FILE_STRUCTURE_DESC",
  FileTypeAsc = "FILE_TYPE_ASC",
  FileTypeDesc = "FILE_TYPE_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  IsSeriesAsc = "IS_SERIES_ASC",
  IsSeriesDesc = "IS_SERIES_DESC",
  KeyAsc = "KEY_ASC",
  KeyDesc = "KEY_DESC",
  LocationAsc = "LOCATION_ASC",
  LocationDesc = "LOCATION_DESC",
  MultipartUploadIdAsc = "MULTIPART_UPLOAD_ID_ASC",
  MultipartUploadIdDesc = "MULTIPART_UPLOAD_ID_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  OriginalNameAsc = "ORIGINAL_NAME_ASC",
  OriginalNameDesc = "ORIGINAL_NAME_DESC",
  PartSizeAsc = "PART_SIZE_ASC",
  PartSizeDesc = "PART_SIZE_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  SeriesParentIdAsc = "SERIES_PARENT_ID_ASC",
  SeriesParentIdDesc = "SERIES_PARENT_ID_DESC",
  SignalAsc = "SIGNAL_ASC",
  SignalDesc = "SIGNAL_DESC",
  SizeAsc = "SIZE_ASC",
  SizeDesc = "SIZE_DESC",
  StatusAsc = "STATUS_ASC",
  StatusDesc = "STATUS_DESC",
  TagsAsc = "TAGS_ASC",
  TagsDesc = "TAGS_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  UploadStatusAsc = "UPLOAD_STATUS_ASC",
  UploadStatusDesc = "UPLOAD_STATUS_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

export type Command = {
  __typename: "Command";
  /** Reads a single `ApplicationUser` that is related to this `Command`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** Reads a single `CodeFile` that is related to this `Command`. */
  codeFileByCodeFileId: Maybe<CodeFile>;
  codeFileId: Scalars["UUID"]["output"];
  /** Reads a single `ContainerImage` that is related to this `Command`. */
  containerImageByContainerImageId: Maybe<ContainerImage>;
  containerImageId: Maybe<Scalars["Int"]["output"]>;
  entryPoint: Maybe<Scalars["String"]["output"]>;
  filePath: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  originalToolSpec: Scalars["JSON"]["output"];
  programType: Scalars["Int"]["output"];
  /** Reads a single `Tenant` that is related to this `Command`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
  /** Reads a single `ToolVersion` that is related to this `Command`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
  toolVersionId: Scalars["Int"]["output"];
  userId: Maybe<Scalars["UUID"]["output"]>;
};

/** The `codeFile` to be created by this mutation. */
export type CommandCodeFileIdE6Dc0F85FkCodeFileIdCodeFileCreateInput = {
  applicationUserToUserId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInput>;
  checksum: Scalars["String"]["input"];
  codeFileToSeriesParentId?: InputMaybe<CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput>;
  commandsUsingId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInverseInput>;
  compressed: Scalars["Boolean"]["input"];
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["UUID"]["input"];
  isSeries: Scalars["Boolean"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  originalName: Scalars["String"]["input"];
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `command` to be created by this mutation. */
export type CommandCodeFileIdE6Dc0F85FkCodeFileIdCommandCreateInput = {
  applicationUserToUserId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInput>;
  codeFileToCodeFileId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInput>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInput>;
  entryPoint?: InputMaybe<Scalars["String"]["input"]>;
  filePath?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  originalToolSpec: Scalars["JSON"]["input"];
  programType: Scalars["Int"]["input"];
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInput>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `codeFile` in the `CommandInput` mutation. */
export type CommandCodeFileIdE6Dc0F85FkCodeFileIdInput = {
  /** The primary key(s) for `codeFile` for the far side of the relationship. */
  connectById?: InputMaybe<CodeFileCodeFilePkeyConnect>;
  /** A `CodeFileInput` object that will be created and connected to this object. */
  create?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdCodeFileCreateInput>;
  /** The primary key(s) for `codeFile` for the far side of the relationship. */
  deleteById?: InputMaybe<CodeFileCodeFilePkeyDelete>;
  /** The primary key(s) and patch data for `codeFile` for the far side of the relationship. */
  updateById?: InputMaybe<CodeFileOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCodeFilePkeyUpdate>;
};

/** Input for the nested mutation of `command` in the `CodeFileInput` mutation. */
export type CommandCodeFileIdE6Dc0F85FkCodeFileIdInverseInput = {
  /** The primary key(s) for `command` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CommandCommandPkeyConnect>>;
  /** The primary key(s) for `command` for the far side of the relationship. */
  connectByToolVersionId?: InputMaybe<
    Array<CommandCommandToolVersionId9DbddabaUniqConnect>
  >;
  /** The primary key(s) for `command` for the far side of the relationship. */
  connectByToolVersionIdAndCodeFileId?: InputMaybe<
    Array<CommandToolVersionCodeFileUniqueOnCommandConnect>
  >;
  /** A `CommandInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<CommandCodeFileIdE6Dc0F85FkCodeFileIdCommandCreateInput>
  >;
  /** The primary key(s) for `command` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CommandCommandPkeyDelete>>;
  /** The primary key(s) for `command` for the far side of the relationship. */
  deleteByToolVersionId?: InputMaybe<
    Array<CommandCommandToolVersionId9DbddabaUniqDelete>
  >;
  /** The primary key(s) for `command` for the far side of the relationship. */
  deleteByToolVersionIdAndCodeFileId?: InputMaybe<
    Array<CommandToolVersionCodeFileUniqueOnCommandDelete>
  >;
  /** Flag indicating whether all other `command` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `command` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCommandPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `command` for the far side of the relationship. */
  updateByToolVersionId?: InputMaybe<
    Array<CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCommandToolVersionId9DbddabaUniqUpdate>
  >;
  /** The primary key(s) and patch data for `command` for the far side of the relationship. */
  updateByToolVersionIdAndCodeFileId?: InputMaybe<
    Array<CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingToolVersionCodeFileUniqueOnCommandUpdate>
  >;
};

/** The fields on `command` to look up the row to connect. */
export type CommandCommandPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `command` to look up the row to delete. */
export type CommandCommandPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `command` to look up the row to connect. */
export type CommandCommandToolVersionId9DbddabaUniqConnect = {
  toolVersionId: Scalars["Int"]["input"];
};

/** The fields on `command` to look up the row to delete. */
export type CommandCommandToolVersionId9DbddabaUniqDelete = {
  toolVersionId: Scalars["Int"]["input"];
};

/** A condition to be used against `Command` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type CommandCondition = {
  /** Checks for equality with the object’s `codeFileId` field. */
  codeFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `containerImageId` field. */
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `entryPoint` field. */
  entryPoint?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `filePath` field. */
  filePath?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `originalToolSpec` field. */
  originalToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `programType` field. */
  programType?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `command` to be created by this mutation. */
export type CommandContainerImageId447E7Cb3FkContainerImageIdCommandCreateInput =
  {
    applicationUserToUserId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInput>;
    codeFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    codeFileToCodeFileId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInput>;
    containerImageToContainerImageId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInput>;
    entryPoint?: InputMaybe<Scalars["String"]["input"]>;
    filePath?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    originalToolSpec: Scalars["JSON"]["input"];
    programType: Scalars["Int"]["input"];
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** The `containerImage` to be created by this mutation. */
export type CommandContainerImageId447E7Cb3FkContainerImageIdContainerImageCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
    containerImageRepositoryId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    label: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    readme?: InputMaybe<Scalars["String"]["input"]>;
    size: Scalars["BigInt"]["input"];
    spec?: InputMaybe<Scalars["JSON"]["input"]>;
    status: Scalars["Int"]["input"];
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
    tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
  };

/** Input for the nested mutation of `containerImage` in the `CommandInput` mutation. */
export type CommandContainerImageId447E7Cb3FkContainerImageIdInput = {
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<ContainerImageContainerImageExecutorIdKeyConnect>;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  connectById?: InputMaybe<ContainerImageContainerImagePkeyConnect>;
  /** A `ContainerImageInput` object that will be created and connected to this object. */
  create?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdContainerImageCreateInput>;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<ContainerImageContainerImageExecutorIdKeyDelete>;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  deleteById?: InputMaybe<ContainerImageContainerImagePkeyDelete>;
  /** The primary key(s) and patch data for `containerImage` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<ContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `containerImage` for the far side of the relationship. */
  updateById?: InputMaybe<ContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingContainerImagePkeyUpdate>;
};

/** Input for the nested mutation of `command` in the `ContainerImageInput` mutation. */
export type CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput = {
  /** The primary key(s) for `command` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CommandCommandPkeyConnect>>;
  /** The primary key(s) for `command` for the far side of the relationship. */
  connectByToolVersionId?: InputMaybe<
    Array<CommandCommandToolVersionId9DbddabaUniqConnect>
  >;
  /** The primary key(s) for `command` for the far side of the relationship. */
  connectByToolVersionIdAndCodeFileId?: InputMaybe<
    Array<CommandToolVersionCodeFileUniqueOnCommandConnect>
  >;
  /** A `CommandInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<CommandContainerImageId447E7Cb3FkContainerImageIdCommandCreateInput>
  >;
  /** The primary key(s) for `command` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CommandCommandPkeyDelete>>;
  /** The primary key(s) for `command` for the far side of the relationship. */
  deleteByToolVersionId?: InputMaybe<
    Array<CommandCommandToolVersionId9DbddabaUniqDelete>
  >;
  /** The primary key(s) for `command` for the far side of the relationship. */
  deleteByToolVersionIdAndCodeFileId?: InputMaybe<
    Array<CommandToolVersionCodeFileUniqueOnCommandDelete>
  >;
  /** Flag indicating whether all other `command` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `command` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingCommandPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `command` for the far side of the relationship. */
  updateByToolVersionId?: InputMaybe<
    Array<CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingCommandToolVersionId9DbddabaUniqUpdate>
  >;
  /** The primary key(s) and patch data for `command` for the far side of the relationship. */
  updateByToolVersionIdAndCodeFileId?: InputMaybe<
    Array<CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingToolVersionCodeFileUniqueOnCommandUpdate>
  >;
};

/** A filter to be used against `Command` object types. All fields are combined with a logical ‘and.’ */
export type CommandFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CommandFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `codeFileByCodeFileId` relation. */
  codeFileByCodeFileId?: InputMaybe<CodeFileFilter>;
  /** Filter by the object’s `codeFileId` field. */
  codeFileId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `containerImageByContainerImageId` relation. */
  containerImageByContainerImageId?: InputMaybe<ContainerImageFilter>;
  /** A related `containerImageByContainerImageId` exists. */
  containerImageByContainerImageIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `containerImageId` field. */
  containerImageId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `entryPoint` field. */
  entryPoint?: InputMaybe<StringFilter>;
  /** Filter by the object’s `filePath` field. */
  filePath?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CommandFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CommandFilter>>;
  /** Filter by the object’s `originalToolSpec` field. */
  originalToolSpec?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `programType` field. */
  programType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toolVersionByToolVersionId` relation. */
  toolVersionByToolVersionId?: InputMaybe<ToolVersionFilter>;
  /** Filter by the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `Command` */
export type CommandInput = {
  applicationUserToUserId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInput>;
  codeFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  codeFileToCodeFileId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInput>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInput>;
  entryPoint?: InputMaybe<Scalars["String"]["input"]>;
  filePath?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  originalToolSpec: Scalars["JSON"]["input"];
  programType: Scalars["Int"]["input"];
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInput>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `command` to look up the row to update. */
export type CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCommandPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `command` being updated. */
    commandPatch: UpdateCommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `command` to look up the row to update. */
export type CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCommandToolVersionId9DbddabaUniqUpdate =
  {
    /** An object where the defined keys will be set on the `command` being updated. */
    commandPatch: UpdateCommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdPatch;
    toolVersionId: Scalars["Int"]["input"];
  };

/** The fields on `command` to look up the row to update. */
export type CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingToolVersionCodeFileUniqueOnCommandUpdate =
  {
    codeFileId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `command` being updated. */
    commandPatch: UpdateCommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdPatch;
    toolVersionId: Scalars["Int"]["input"];
  };

/** The fields on `command` to look up the row to update. */
export type CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingCommandPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `command` being updated. */
    commandPatch: UpdateCommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `command` to look up the row to update. */
export type CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingCommandToolVersionId9DbddabaUniqUpdate =
  {
    /** An object where the defined keys will be set on the `command` being updated. */
    commandPatch: UpdateCommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdPatch;
    toolVersionId: Scalars["Int"]["input"];
  };

/** The fields on `command` to look up the row to update. */
export type CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingToolVersionCodeFileUniqueOnCommandUpdate =
  {
    codeFileId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `command` being updated. */
    commandPatch: UpdateCommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdPatch;
    toolVersionId: Scalars["Int"]["input"];
  };

/** The fields on `command` to look up the row to update. */
export type CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingCommandPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `command` being updated. */
    commandPatch: UpdateCommandOnCommandForCommandTenantId36F95C3CFkTenantIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `command` to look up the row to update. */
export type CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingCommandToolVersionId9DbddabaUniqUpdate =
  {
    /** An object where the defined keys will be set on the `command` being updated. */
    commandPatch: UpdateCommandOnCommandForCommandTenantId36F95C3CFkTenantIdPatch;
    toolVersionId: Scalars["Int"]["input"];
  };

/** The fields on `command` to look up the row to update. */
export type CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingToolVersionCodeFileUniqueOnCommandUpdate =
  {
    codeFileId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `command` being updated. */
    commandPatch: UpdateCommandOnCommandForCommandTenantId36F95C3CFkTenantIdPatch;
    toolVersionId: Scalars["Int"]["input"];
  };

/** The fields on `command` to look up the row to update. */
export type CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingCommandPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `command` being updated. */
    commandPatch: UpdateCommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `command` to look up the row to update. */
export type CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingCommandToolVersionId9DbddabaUniqUpdate =
  {
    /** An object where the defined keys will be set on the `command` being updated. */
    commandPatch: UpdateCommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdPatch;
    toolVersionId: Scalars["Int"]["input"];
  };

/** The fields on `command` to look up the row to update. */
export type CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingToolVersionCodeFileUniqueOnCommandUpdate =
  {
    codeFileId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `command` being updated. */
    commandPatch: UpdateCommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdPatch;
    toolVersionId: Scalars["Int"]["input"];
  };

/** The fields on `command` to look up the row to update. */
export type CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingCommandPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `command` being updated. */
    commandPatch: UpdateCommandOnCommandForCommandUserId4A445414FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `command` to look up the row to update. */
export type CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingCommandToolVersionId9DbddabaUniqUpdate =
  {
    /** An object where the defined keys will be set on the `command` being updated. */
    commandPatch: UpdateCommandOnCommandForCommandUserId4A445414FkApplicationUserIdPatch;
    toolVersionId: Scalars["Int"]["input"];
  };

/** The fields on `command` to look up the row to update. */
export type CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingToolVersionCodeFileUniqueOnCommandUpdate =
  {
    codeFileId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `command` being updated. */
    commandPatch: UpdateCommandOnCommandForCommandUserId4A445414FkApplicationUserIdPatch;
    toolVersionId: Scalars["Int"]["input"];
  };

/** Represents an update to a `Command`. Fields that are set will be updated. */
export type CommandPatch = {
  applicationUserToUserId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInput>;
  codeFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  codeFileToCodeFileId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInput>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInput>;
  entryPoint?: InputMaybe<Scalars["String"]["input"]>;
  filePath?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  originalToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
  programType?: InputMaybe<Scalars["Int"]["input"]>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInput>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `command` to be created by this mutation. */
export type CommandTenantId36F95C3CFkTenantIdCommandCreateInput = {
  applicationUserToUserId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInput>;
  codeFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  codeFileToCodeFileId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInput>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInput>;
  entryPoint?: InputMaybe<Scalars["String"]["input"]>;
  filePath?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  originalToolSpec: Scalars["JSON"]["input"];
  programType: Scalars["Int"]["input"];
  tenantToTenantId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInput>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `tenant` in the `CommandInput` mutation. */
export type CommandTenantId36F95C3CFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<CommandTenantId36F95C3CFkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `command` in the `TenantInput` mutation. */
export type CommandTenantId36F95C3CFkTenantIdInverseInput = {
  /** The primary key(s) for `command` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CommandCommandPkeyConnect>>;
  /** The primary key(s) for `command` for the far side of the relationship. */
  connectByToolVersionId?: InputMaybe<
    Array<CommandCommandToolVersionId9DbddabaUniqConnect>
  >;
  /** The primary key(s) for `command` for the far side of the relationship. */
  connectByToolVersionIdAndCodeFileId?: InputMaybe<
    Array<CommandToolVersionCodeFileUniqueOnCommandConnect>
  >;
  /** A `CommandInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<CommandTenantId36F95C3CFkTenantIdCommandCreateInput>
  >;
  /** The primary key(s) for `command` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CommandCommandPkeyDelete>>;
  /** The primary key(s) for `command` for the far side of the relationship. */
  deleteByToolVersionId?: InputMaybe<
    Array<CommandCommandToolVersionId9DbddabaUniqDelete>
  >;
  /** The primary key(s) for `command` for the far side of the relationship. */
  deleteByToolVersionIdAndCodeFileId?: InputMaybe<
    Array<CommandToolVersionCodeFileUniqueOnCommandDelete>
  >;
  /** Flag indicating whether all other `command` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `command` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingCommandPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `command` for the far side of the relationship. */
  updateByToolVersionId?: InputMaybe<
    Array<CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingCommandToolVersionId9DbddabaUniqUpdate>
  >;
  /** The primary key(s) and patch data for `command` for the far side of the relationship. */
  updateByToolVersionIdAndCodeFileId?: InputMaybe<
    Array<CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingToolVersionCodeFileUniqueOnCommandUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type CommandTenantId36F95C3CFkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** The fields on `command` to look up the row to connect. */
export type CommandToolVersionCodeFileUniqueOnCommandConnect = {
  codeFileId: Scalars["UUID"]["input"];
  toolVersionId: Scalars["Int"]["input"];
};

/** The fields on `command` to look up the row to delete. */
export type CommandToolVersionCodeFileUniqueOnCommandDelete = {
  codeFileId: Scalars["UUID"]["input"];
  toolVersionId: Scalars["Int"]["input"];
};

/** The `command` to be created by this mutation. */
export type CommandToolVersionId9DbddabaFkToolVersionIdCommandCreateInput = {
  applicationUserToUserId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInput>;
  codeFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  codeFileToCodeFileId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInput>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInput>;
  entryPoint?: InputMaybe<Scalars["String"]["input"]>;
  filePath?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  originalToolSpec: Scalars["JSON"]["input"];
  programType: Scalars["Int"]["input"];
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInput>;
  toolVersionToToolVersionId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `toolVersion` in the `CommandInput` mutation. */
export type CommandToolVersionId9DbddabaFkToolVersionIdInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<ToolVersionToolVersionPkeyConnect>;
  /** A `ToolVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdToolVersionCreateInput>;
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<ToolVersionToolVersionPkeyDelete>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<ToolVersionOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingToolVersionPkeyUpdate>;
};

/** Input for the nested mutation of `command` in the `ToolVersionInput` mutation. */
export type CommandToolVersionId9DbddabaFkToolVersionIdInverseInput = {
  /** The primary key(s) for `command` for the far side of the relationship. */
  connectById?: InputMaybe<CommandCommandPkeyConnect>;
  /** The primary key(s) for `command` for the far side of the relationship. */
  connectByToolVersionId?: InputMaybe<CommandCommandToolVersionId9DbddabaUniqConnect>;
  /** The primary key(s) for `command` for the far side of the relationship. */
  connectByToolVersionIdAndCodeFileId?: InputMaybe<CommandToolVersionCodeFileUniqueOnCommandConnect>;
  /** A `CommandInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<CommandToolVersionId9DbddabaFkToolVersionIdCommandCreateInput>
  >;
  /** The primary key(s) for `command` for the far side of the relationship. */
  deleteById?: InputMaybe<CommandCommandPkeyDelete>;
  /** The primary key(s) for `command` for the far side of the relationship. */
  deleteByToolVersionId?: InputMaybe<CommandCommandToolVersionId9DbddabaUniqDelete>;
  /** The primary key(s) for `command` for the far side of the relationship. */
  deleteByToolVersionIdAndCodeFileId?: InputMaybe<CommandToolVersionCodeFileUniqueOnCommandDelete>;
  /** Flag indicating whether all other `command` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `command` for the far side of the relationship. */
  updateById?: InputMaybe<CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingCommandPkeyUpdate>;
  /** The primary key(s) and patch data for `command` for the far side of the relationship. */
  updateByToolVersionId?: InputMaybe<CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingCommandToolVersionId9DbddabaUniqUpdate>;
  /** The primary key(s) and patch data for `command` for the far side of the relationship. */
  updateByToolVersionIdAndCodeFileId?: InputMaybe<CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingToolVersionCodeFileUniqueOnCommandUpdate>;
};

/** The `toolVersion` to be created by this mutation. */
export type CommandToolVersionId9DbddabaFkToolVersionIdToolVersionCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible: Scalars["Boolean"]["input"];
    isUpgradableToNextVersion: Scalars["Boolean"]["input"];
    maturity: Scalars["Int"]["input"];
    status: Scalars["Int"]["input"];
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion: Scalars["Int"]["input"];
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version: Scalars["String"]["input"];
    visibility: Scalars["Int"]["input"];
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** The `applicationUser` to be created by this mutation. */
export type CommandUserId4A445414FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** The `command` to be created by this mutation. */
export type CommandUserId4A445414FkApplicationUserIdCommandCreateInput = {
  applicationUserToUserId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInput>;
  codeFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  codeFileToCodeFileId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInput>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInput>;
  entryPoint?: InputMaybe<Scalars["String"]["input"]>;
  filePath?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  originalToolSpec: Scalars["JSON"]["input"];
  programType: Scalars["Int"]["input"];
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInput>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInput>;
};

/** Input for the nested mutation of `applicationUser` in the `CommandInput` mutation. */
export type CommandUserId4A445414FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<CommandUserId4A445414FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `command` in the `ApplicationUserInput` mutation. */
export type CommandUserId4A445414FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `command` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CommandCommandPkeyConnect>>;
  /** The primary key(s) for `command` for the far side of the relationship. */
  connectByToolVersionId?: InputMaybe<
    Array<CommandCommandToolVersionId9DbddabaUniqConnect>
  >;
  /** The primary key(s) for `command` for the far side of the relationship. */
  connectByToolVersionIdAndCodeFileId?: InputMaybe<
    Array<CommandToolVersionCodeFileUniqueOnCommandConnect>
  >;
  /** A `CommandInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<CommandUserId4A445414FkApplicationUserIdCommandCreateInput>
  >;
  /** The primary key(s) for `command` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CommandCommandPkeyDelete>>;
  /** The primary key(s) for `command` for the far side of the relationship. */
  deleteByToolVersionId?: InputMaybe<
    Array<CommandCommandToolVersionId9DbddabaUniqDelete>
  >;
  /** The primary key(s) for `command` for the far side of the relationship. */
  deleteByToolVersionIdAndCodeFileId?: InputMaybe<
    Array<CommandToolVersionCodeFileUniqueOnCommandDelete>
  >;
  /** Flag indicating whether all other `command` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `command` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingCommandPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `command` for the far side of the relationship. */
  updateByToolVersionId?: InputMaybe<
    Array<CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingCommandToolVersionId9DbddabaUniqUpdate>
  >;
  /** The primary key(s) and patch data for `command` for the far side of the relationship. */
  updateByToolVersionIdAndCodeFileId?: InputMaybe<
    Array<CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingToolVersionCodeFileUniqueOnCommandUpdate>
  >;
};

/** A connection to a list of `Command` values. */
export type CommandsConnection = {
  __typename: "CommandsConnection";
  /** A list of edges which contains the `Command` and cursor to aid in pagination. */
  edges: Array<CommandsEdge>;
  /** A list of `Command` objects. */
  nodes: Array<Command>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Command` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `Command` edge in the connection. */
export type CommandsEdge = {
  __typename: "CommandsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `Command` at the end of the edge. */
  node: Command;
};

/** Methods to use when ordering `Command`. */
export enum CommandsOrderBy {
  CodeFileIdAsc = "CODE_FILE_ID_ASC",
  CodeFileIdDesc = "CODE_FILE_ID_DESC",
  ContainerImageIdAsc = "CONTAINER_IMAGE_ID_ASC",
  ContainerImageIdDesc = "CONTAINER_IMAGE_ID_DESC",
  EntryPointAsc = "ENTRY_POINT_ASC",
  EntryPointDesc = "ENTRY_POINT_DESC",
  FilePathAsc = "FILE_PATH_ASC",
  FilePathDesc = "FILE_PATH_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  OriginalToolSpecAsc = "ORIGINAL_TOOL_SPEC_ASC",
  OriginalToolSpecDesc = "ORIGINAL_TOOL_SPEC_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProgramTypeAsc = "PROGRAM_TYPE_ASC",
  ProgramTypeDesc = "PROGRAM_TYPE_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  ToolVersionIdAsc = "TOOL_VERSION_ID_ASC",
  ToolVersionIdDesc = "TOOL_VERSION_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

export type ContainerImage = {
  __typename: "ContainerImage";
  /** Reads a single `ApplicationUser` that is related to this `ContainerImage`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  checksum: Maybe<Scalars["String"]["output"]>;
  /** Reads and enables pagination through a set of `Command`. */
  commandsByContainerImageId: CommandsConnection;
  /** Reads a single `ContainerImageRepository` that is related to this `ContainerImage`. */
  containerImageRepositoryByContainerImageRepositoryId: Maybe<ContainerImageRepository>;
  containerImageRepositoryId: Maybe<Scalars["Int"]["output"]>;
  dateCreated: Scalars["Datetime"]["output"];
  dateDeleted: Maybe<Scalars["Datetime"]["output"]>;
  dateUpdated: Scalars["Datetime"]["output"];
  description: Maybe<Scalars["String"]["output"]>;
  executorId: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["Int"]["output"];
  label: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  readme: Maybe<Scalars["String"]["output"]>;
  size: Scalars["BigInt"]["output"];
  spec: Maybe<Scalars["JSON"]["output"]>;
  status: Scalars["Int"]["output"];
  tags: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** Reads and enables pagination through a set of `Task`. */
  tasksByContainerImageId: TasksConnection;
  /** Reads a single `Tenant` that is related to this `ContainerImage`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Maybe<Scalars["Int"]["output"]>;
  /** Reads a single `TesContainerimageexecutor` that is related to this `ContainerImage`. */
  tesContainerimageexecutorByExecutorId: Maybe<TesContainerimageexecutor>;
  /** Reads and enables pagination through a set of `ToolVersion`. */
  toolVersionsByContainerImageId: ToolVersionsConnection;
  userId: Maybe<Scalars["UUID"]["output"]>;
  /** Reads and enables pagination through a set of `Workflow`. */
  workflowsByContainerId: WorkflowsConnection;
};

export type ContainerImageCommandsByContainerImageIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CommandCondition>;
  filter?: InputMaybe<CommandFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CommandsOrderBy>>;
};

export type ContainerImageTasksByContainerImageIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

export type ContainerImageToolVersionsByContainerImageIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolVersionCondition>;
  filter?: InputMaybe<ToolVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolVersionsOrderBy>>;
};

export type ContainerImageWorkflowsByContainerIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowCondition>;
  filter?: InputMaybe<WorkflowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowsOrderBy>>;
};

/**
 * A condition to be used against `ContainerImage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ContainerImageCondition = {
  /** Checks for equality with the object’s `checksum` field. */
  checksum?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `containerImageRepositoryId` field. */
  containerImageRepositoryId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateUpdated` field. */
  dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `executorId` field. */
  executorId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `readme` field. */
  readme?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `size` field. */
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `spec` field. */
  spec?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `tags` field. */
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `containerImage` to look up the row to connect. */
export type ContainerImageContainerImageExecutorIdKeyConnect = {
  executorId: Scalars["Int"]["input"];
};

/** The fields on `containerImage` to look up the row to delete. */
export type ContainerImageContainerImageExecutorIdKeyDelete = {
  executorId: Scalars["Int"]["input"];
};

/** The fields on `containerImage` to look up the row to connect. */
export type ContainerImageContainerImagePkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `containerImage` to look up the row to delete. */
export type ContainerImageContainerImagePkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** The `containerImage` to be created by this mutation. */
export type ContainerImageContainerImageRepoBe6Ba4A8FkContainerContainerImageCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
    containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    label: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    readme?: InputMaybe<Scalars["String"]["input"]>;
    size: Scalars["BigInt"]["input"];
    spec?: InputMaybe<Scalars["JSON"]["input"]>;
    status: Scalars["Int"]["input"];
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
    tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
  };

/** The `containerImageRepository` to be created by this mutation. */
export type ContainerImageContainerImageRepoBe6Ba4A8FkContainerContainerImageRepositoryCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name: Scalars["String"]["input"];
    registryType: Scalars["Int"]["input"];
    repository: Scalars["String"]["input"];
    status: Scalars["Int"]["input"];
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    visibility: Scalars["Int"]["input"];
  };

/** Input for the nested mutation of `containerImageRepository` in the `ContainerImageInput` mutation. */
export type ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput = {
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  connectById?: InputMaybe<ContainerImageRepositoryContainerImageRepositoryPkeyConnect>;
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  connectByNameAndTenantIdAndRegistryType?: InputMaybe<ContainerImageRepositoryContainerImageRepositoryNameTenantTypeUniqueConnect>;
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  connectByRepository?: InputMaybe<ContainerImageRepositoryContainerImageRepositoryRepositoryKeyConnect>;
  /** A `ContainerImageRepositoryInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerContainerImageRepositoryCreateInput>;
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  deleteById?: InputMaybe<ContainerImageRepositoryContainerImageRepositoryPkeyDelete>;
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  deleteByNameAndTenantIdAndRegistryType?: InputMaybe<ContainerImageRepositoryContainerImageRepositoryNameTenantTypeUniqueDelete>;
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  deleteByRepository?: InputMaybe<ContainerImageRepositoryContainerImageRepositoryRepositoryKeyDelete>;
  /** The primary key(s) and patch data for `containerImageRepository` for the far side of the relationship. */
  updateById?: InputMaybe<ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryPkeyUpdate>;
  /** The primary key(s) and patch data for `containerImageRepository` for the far side of the relationship. */
  updateByNameAndTenantIdAndRegistryType?: InputMaybe<ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryNameTenantTypeUniqueUpdate>;
  /** The primary key(s) and patch data for `containerImageRepository` for the far side of the relationship. */
  updateByRepository?: InputMaybe<ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryRepositoryKeyUpdate>;
};

/** Input for the nested mutation of `containerImage` in the `ContainerImageRepositoryInput` mutation. */
export type ContainerImageContainerImageRepoBe6Ba4A8FkContainerInverseInput = {
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<
    Array<ContainerImageContainerImageExecutorIdKeyConnect>
  >;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContainerImageContainerImagePkeyConnect>>;
  /** A `ContainerImageInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ContainerImageContainerImageRepoBe6Ba4A8FkContainerContainerImageCreateInput>
  >;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<
    Array<ContainerImageContainerImageExecutorIdKeyDelete>
  >;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ContainerImageContainerImagePkeyDelete>>;
  /** Flag indicating whether all other `containerImage` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `containerImage` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<
    Array<ContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageExecutorIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `containerImage` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImagePkeyUpdate>
  >;
};

/** The `containerImage` to be created by this mutation. */
export type ContainerImageExecutorId68979Fb6FkTesContaContainerImageCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
    containerImageRepositoryId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    label: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    readme?: InputMaybe<Scalars["String"]["input"]>;
    size: Scalars["BigInt"]["input"];
    spec?: InputMaybe<Scalars["JSON"]["input"]>;
    status: Scalars["Int"]["input"];
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
    tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
  };

/** Input for the nested mutation of `tesContainerimageexecutor` in the `ContainerImageInput` mutation. */
export type ContainerImageExecutorId68979Fb6FkTesContaInput = {
  /** The primary key(s) for `tesContainerimageexecutor` for the far side of the relationship. */
  connectById?: InputMaybe<TesContainerimageexecutorTesContainerimageexecutorPkeyConnect>;
  /** A `TesContainerimageexecutorInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaTesContainerimageexecutorCreateInput>;
  /** The primary key(s) for `tesContainerimageexecutor` for the far side of the relationship. */
  deleteById?: InputMaybe<TesContainerimageexecutorTesContainerimageexecutorPkeyDelete>;
  /** The primary key(s) and patch data for `tesContainerimageexecutor` for the far side of the relationship. */
  updateById?: InputMaybe<TesContainerimageexecutorOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingTesContainerimageexecutorPkeyUpdate>;
};

/** Input for the nested mutation of `containerImage` in the `TesContainerimageexecutorInput` mutation. */
export type ContainerImageExecutorId68979Fb6FkTesContaInverseInput = {
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<ContainerImageContainerImageExecutorIdKeyConnect>;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  connectById?: InputMaybe<ContainerImageContainerImagePkeyConnect>;
  /** A `ContainerImageInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ContainerImageExecutorId68979Fb6FkTesContaContainerImageCreateInput>
  >;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<ContainerImageContainerImageExecutorIdKeyDelete>;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  deleteById?: InputMaybe<ContainerImageContainerImagePkeyDelete>;
  /** Flag indicating whether all other `containerImage` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `containerImage` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<ContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingContainerImageExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `containerImage` for the far side of the relationship. */
  updateById?: InputMaybe<ContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingContainerImagePkeyUpdate>;
};

/** The `tesContainerimageexecutor` to be created by this mutation. */
export type ContainerImageExecutorId68979Fb6FkTesContaTesContainerimageexecutorCreateInput =
  {
    awsEcrImageUsingId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInverseInput>;
    containerImageUsingId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInverseInput>;
    distributionRegistryImageUsingId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    tesMockcontainerimageexecutorUsingId?: InputMaybe<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInverseInput>;
  };

/** A filter to be used against `ContainerImage` object types. All fields are combined with a logical ‘and.’ */
export type ContainerImageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ContainerImageFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `checksum` field. */
  checksum?: InputMaybe<StringFilter>;
  /** Filter by the object’s `commandsByContainerImageId` relation. */
  commandsByContainerImageId?: InputMaybe<ContainerImageToManyCommandFilter>;
  /** Some related `commandsByContainerImageId` exist. */
  commandsByContainerImageIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `containerImageRepositoryByContainerImageRepositoryId` relation. */
  containerImageRepositoryByContainerImageRepositoryId?: InputMaybe<ContainerImageRepositoryFilter>;
  /** A related `containerImageRepositoryByContainerImageRepositoryId` exists. */
  containerImageRepositoryByContainerImageRepositoryIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `containerImageRepositoryId` field. */
  containerImageRepositoryId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateUpdated` field. */
  dateUpdated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `executorId` field. */
  executorId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ContainerImageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ContainerImageFilter>>;
  /** Filter by the object’s `readme` field. */
  readme?: InputMaybe<StringFilter>;
  /** Filter by the object’s `size` field. */
  size?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `spec` field. */
  spec?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tasksByContainerImageId` relation. */
  tasksByContainerImageId?: InputMaybe<ContainerImageToManyTaskFilter>;
  /** Some related `tasksByContainerImageId` exist. */
  tasksByContainerImageIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** A related `tenantByTenantId` exists. */
  tenantByTenantIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tesContainerimageexecutorByExecutorId` relation. */
  tesContainerimageexecutorByExecutorId?: InputMaybe<TesContainerimageexecutorFilter>;
  /** A related `tesContainerimageexecutorByExecutorId` exists. */
  tesContainerimageexecutorByExecutorIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `toolVersionsByContainerImageId` relation. */
  toolVersionsByContainerImageId?: InputMaybe<ContainerImageToManyToolVersionFilter>;
  /** Some related `toolVersionsByContainerImageId` exist. */
  toolVersionsByContainerImageIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `workflowsByContainerId` relation. */
  workflowsByContainerId?: InputMaybe<ContainerImageToManyWorkflowFilter>;
  /** Some related `workflowsByContainerId` exist. */
  workflowsByContainerIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** An input for mutations affecting `ContainerImage` */
export type ContainerImageInput = {
  applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
  checksum?: InputMaybe<Scalars["String"]["input"]>;
  commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
  containerImageRepositoryId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  executorId?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  label: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  readme?: InputMaybe<Scalars["String"]["input"]>;
  size: Scalars["BigInt"]["input"];
  spec?: InputMaybe<Scalars["JSON"]["input"]>;
  status: Scalars["Int"]["input"];
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
  tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
};

/** The fields on `containerImage` to look up the row to update. */
export type ContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImage` being updated. */
    containerImagePatch: UpdateContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdPatch;
    executorId: Scalars["Int"]["input"];
  };

/** The fields on `containerImage` to look up the row to update. */
export type ContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingContainerImagePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImage` being updated. */
    containerImagePatch: UpdateContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `containerImage` to look up the row to update. */
export type ContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageExecutorIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImage` being updated. */
    containerImagePatch: UpdateContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerPatch;
    executorId: Scalars["Int"]["input"];
  };

/** The fields on `containerImage` to look up the row to update. */
export type ContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImagePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImage` being updated. */
    containerImagePatch: UpdateContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `containerImage` to look up the row to update. */
export type ContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingContainerImageExecutorIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImage` being updated. */
    containerImagePatch: UpdateContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaPatch;
    executorId: Scalars["Int"]["input"];
  };

/** The fields on `containerImage` to look up the row to update. */
export type ContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingContainerImagePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImage` being updated. */
    containerImagePatch: UpdateContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `containerImage` to look up the row to update. */
export type ContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingContainerImageExecutorIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImage` being updated. */
    containerImagePatch: UpdateContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdPatch;
    executorId: Scalars["Int"]["input"];
  };

/** The fields on `containerImage` to look up the row to update. */
export type ContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingContainerImagePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImage` being updated. */
    containerImagePatch: UpdateContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `containerImage` to look up the row to update. */
export type ContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingContainerImageExecutorIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImage` being updated. */
    containerImagePatch: UpdateContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdPatch;
    executorId: Scalars["Int"]["input"];
  };

/** The fields on `containerImage` to look up the row to update. */
export type ContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingContainerImagePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImage` being updated. */
    containerImagePatch: UpdateContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `containerImage` to look up the row to update. */
export type ContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingContainerImageExecutorIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImage` being updated. */
    containerImagePatch: UpdateContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdPatch;
    executorId: Scalars["Int"]["input"];
  };

/** The fields on `containerImage` to look up the row to update. */
export type ContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingContainerImagePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImage` being updated. */
    containerImagePatch: UpdateContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `containerImage` to look up the row to update. */
export type ContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImage` being updated. */
    containerImagePatch: UpdateContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdPatch;
    executorId: Scalars["Int"]["input"];
  };

/** The fields on `containerImage` to look up the row to update. */
export type ContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingContainerImagePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImage` being updated. */
    containerImagePatch: UpdateContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `containerImage` to look up the row to update. */
export type ContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImage` being updated. */
    containerImagePatch: UpdateContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdPatch;
    executorId: Scalars["Int"]["input"];
  };

/** The fields on `containerImage` to look up the row to update. */
export type ContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingContainerImagePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImage` being updated. */
    containerImagePatch: UpdateContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdPatch;
    id: Scalars["Int"]["input"];
  };

/** Represents an update to a `ContainerImage`. Fields that are set will be updated. */
export type ContainerImagePatch = {
  applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
  checksum?: InputMaybe<Scalars["String"]["input"]>;
  commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
  containerImageRepositoryId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  executorId?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  readme?: InputMaybe<Scalars["String"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  spec?: InputMaybe<Scalars["JSON"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
  tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
};

/** The `applicationUser` to be created by this mutation. */
export type ContainerImageRepoUserIdAf9751AfFkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** The `containerImageRepository` to be created by this mutation. */
export type ContainerImageRepoUserIdAf9751AfFkApplicatiContainerImageRepositoryCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name: Scalars["String"]["input"];
    registryType: Scalars["Int"]["input"];
    repository: Scalars["String"]["input"];
    status: Scalars["Int"]["input"];
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInput>;
    visibility: Scalars["Int"]["input"];
  };

/** Input for the nested mutation of `applicationUser` in the `ContainerImageRepositoryInput` mutation. */
export type ContainerImageRepoUserIdAf9751AfFkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `containerImageRepository` in the `ApplicationUserInput` mutation. */
export type ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput = {
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ContainerImageRepositoryContainerImageRepositoryPkeyConnect>
  >;
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  connectByNameAndTenantIdAndRegistryType?: InputMaybe<
    Array<ContainerImageRepositoryContainerImageRepositoryNameTenantTypeUniqueConnect>
  >;
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  connectByRepository?: InputMaybe<
    Array<ContainerImageRepositoryContainerImageRepositoryRepositoryKeyConnect>
  >;
  /** A `ContainerImageRepositoryInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ContainerImageRepoUserIdAf9751AfFkApplicatiContainerImageRepositoryCreateInput>
  >;
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<ContainerImageRepositoryContainerImageRepositoryPkeyDelete>
  >;
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  deleteByNameAndTenantIdAndRegistryType?: InputMaybe<
    Array<ContainerImageRepositoryContainerImageRepositoryNameTenantTypeUniqueDelete>
  >;
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  deleteByRepository?: InputMaybe<
    Array<ContainerImageRepositoryContainerImageRepositoryRepositoryKeyDelete>
  >;
  /** Flag indicating whether all other `containerImageRepository` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `containerImageRepository` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `containerImageRepository` for the far side of the relationship. */
  updateByNameAndTenantIdAndRegistryType?: InputMaybe<
    Array<ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryNameTenantTypeUniqueUpdate>
  >;
  /** The primary key(s) and patch data for `containerImageRepository` for the far side of the relationship. */
  updateByRepository?: InputMaybe<
    Array<ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryRepositoryKeyUpdate>
  >;
};

/** A connection to a list of `ContainerImageRepository` values. */
export type ContainerImageRepositoriesConnection = {
  __typename: "ContainerImageRepositoriesConnection";
  /** A list of edges which contains the `ContainerImageRepository` and cursor to aid in pagination. */
  edges: Array<ContainerImageRepositoriesEdge>;
  /** A list of `ContainerImageRepository` objects. */
  nodes: Array<ContainerImageRepository>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ContainerImageRepository` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ContainerImageRepository` edge in the connection. */
export type ContainerImageRepositoriesEdge = {
  __typename: "ContainerImageRepositoriesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ContainerImageRepository` at the end of the edge. */
  node: ContainerImageRepository;
};

/** Methods to use when ordering `ContainerImageRepository`. */
export enum ContainerImageRepositoriesOrderBy {
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  RegistryTypeAsc = "REGISTRY_TYPE_ASC",
  RegistryTypeDesc = "REGISTRY_TYPE_DESC",
  RepositoryAsc = "REPOSITORY_ASC",
  RepositoryDesc = "REPOSITORY_DESC",
  StatusAsc = "STATUS_ASC",
  StatusDesc = "STATUS_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
  VisibilityAsc = "VISIBILITY_ASC",
  VisibilityDesc = "VISIBILITY_DESC",
}

export type ContainerImageRepository = {
  __typename: "ContainerImageRepository";
  /** Reads a single `ApplicationUser` that is related to this `ContainerImageRepository`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** Reads and enables pagination through a set of `ContainerImage`. */
  containerImagesByContainerImageRepositoryId: ContainerImagesConnection;
  dateCreated: Scalars["Datetime"]["output"];
  id: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  registryType: Scalars["Int"]["output"];
  repository: Scalars["String"]["output"];
  status: Scalars["Int"]["output"];
  /** Reads a single `Tenant` that is related to this `ContainerImageRepository`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
  userId: Maybe<Scalars["UUID"]["output"]>;
  visibility: Scalars["Int"]["output"];
};

export type ContainerImageRepositoryContainerImagesByContainerImageRepositoryIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<ContainerImageCondition>;
    filter?: InputMaybe<ContainerImageFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<ContainerImagesOrderBy>>;
  };

/**
 * A condition to be used against `ContainerImageRepository` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ContainerImageRepositoryCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `registryType` field. */
  registryType?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `repository` field. */
  repository?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `visibility` field. */
  visibility?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `containerImageRepository` to look up the row to connect. */
export type ContainerImageRepositoryContainerImageRepositoryNameTenantTypeUniqueConnect =
  {
    name: Scalars["String"]["input"];
    registryType: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `containerImageRepository` to look up the row to delete. */
export type ContainerImageRepositoryContainerImageRepositoryNameTenantTypeUniqueDelete =
  {
    name: Scalars["String"]["input"];
    registryType: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `containerImageRepository` to look up the row to connect. */
export type ContainerImageRepositoryContainerImageRepositoryPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `containerImageRepository` to look up the row to delete. */
export type ContainerImageRepositoryContainerImageRepositoryPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** The fields on `containerImageRepository` to look up the row to connect. */
export type ContainerImageRepositoryContainerImageRepositoryRepositoryKeyConnect =
  {
    repository: Scalars["String"]["input"];
  };

/** The fields on `containerImageRepository` to look up the row to delete. */
export type ContainerImageRepositoryContainerImageRepositoryRepositoryKeyDelete =
  {
    repository: Scalars["String"]["input"];
  };

/** A filter to be used against `ContainerImageRepository` object types. All fields are combined with a logical ‘and.’ */
export type ContainerImageRepositoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ContainerImageRepositoryFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `containerImagesByContainerImageRepositoryId` relation. */
  containerImagesByContainerImageRepositoryId?: InputMaybe<ContainerImageRepositoryToManyContainerImageFilter>;
  /** Some related `containerImagesByContainerImageRepositoryId` exist. */
  containerImagesByContainerImageRepositoryIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ContainerImageRepositoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ContainerImageRepositoryFilter>>;
  /** Filter by the object’s `registryType` field. */
  registryType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `repository` field. */
  repository?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `visibility` field. */
  visibility?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ContainerImageRepository` */
export type ContainerImageRepositoryInput = {
  applicationUserToUserId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInverseInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
  registryType: Scalars["Int"]["input"];
  repository: Scalars["String"]["input"];
  status: Scalars["Int"]["input"];
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  visibility: Scalars["Int"]["input"];
};

/** The fields on `containerImageRepository` to look up the row to update. */
export type ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryNameTenantTypeUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `containerImageRepository` being updated. */
    containerImageRepositoryPatch: UpdateContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerPatch;
    name: Scalars["String"]["input"];
    registryType: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `containerImageRepository` to look up the row to update. */
export type ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImageRepository` being updated. */
    containerImageRepositoryPatch: UpdateContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `containerImageRepository` to look up the row to update. */
export type ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryRepositoryKeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImageRepository` being updated. */
    containerImageRepositoryPatch: UpdateContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerPatch;
    repository: Scalars["String"]["input"];
  };

/** The fields on `containerImageRepository` to look up the row to update. */
export type ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryNameTenantTypeUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `containerImageRepository` being updated. */
    containerImageRepositoryPatch: UpdateContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiPatch;
    name: Scalars["String"]["input"];
    registryType: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `containerImageRepository` to look up the row to update. */
export type ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImageRepository` being updated. */
    containerImageRepositoryPatch: UpdateContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `containerImageRepository` to look up the row to update. */
export type ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryRepositoryKeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImageRepository` being updated. */
    containerImageRepositoryPatch: UpdateContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiPatch;
    repository: Scalars["String"]["input"];
  };

/** The fields on `containerImageRepository` to look up the row to update. */
export type ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryNameTenantTypeUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `containerImageRepository` being updated. */
    containerImageRepositoryPatch: UpdateContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdPatch;
    name: Scalars["String"]["input"];
    registryType: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `containerImageRepository` to look up the row to update. */
export type ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImageRepository` being updated. */
    containerImageRepositoryPatch: UpdateContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `containerImageRepository` to look up the row to update. */
export type ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryRepositoryKeyUpdate =
  {
    /** An object where the defined keys will be set on the `containerImageRepository` being updated. */
    containerImageRepositoryPatch: UpdateContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdPatch;
    repository: Scalars["String"]["input"];
  };

/** Represents an update to a `ContainerImageRepository`. Fields that are set will be updated. */
export type ContainerImageRepositoryPatch = {
  applicationUserToUserId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInverseInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  registryType?: InputMaybe<Scalars["Int"]["input"]>;
  repository?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  visibility?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The `containerImageRepository` to be created by this mutation. */
export type ContainerImageRepositoryTenantId217F4E90FkTenantIdContainerImageRepositoryCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name: Scalars["String"]["input"];
    registryType: Scalars["Int"]["input"];
    repository: Scalars["String"]["input"];
    status: Scalars["Int"]["input"];
    tenantToTenantId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    visibility: Scalars["Int"]["input"];
  };

/** Input for the nested mutation of `tenant` in the `ContainerImageRepositoryInput` mutation. */
export type ContainerImageRepositoryTenantId217F4E90FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `containerImageRepository` in the `TenantInput` mutation. */
export type ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput = {
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ContainerImageRepositoryContainerImageRepositoryPkeyConnect>
  >;
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  connectByNameAndTenantIdAndRegistryType?: InputMaybe<
    Array<ContainerImageRepositoryContainerImageRepositoryNameTenantTypeUniqueConnect>
  >;
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  connectByRepository?: InputMaybe<
    Array<ContainerImageRepositoryContainerImageRepositoryRepositoryKeyConnect>
  >;
  /** A `ContainerImageRepositoryInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ContainerImageRepositoryTenantId217F4E90FkTenantIdContainerImageRepositoryCreateInput>
  >;
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<ContainerImageRepositoryContainerImageRepositoryPkeyDelete>
  >;
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  deleteByNameAndTenantIdAndRegistryType?: InputMaybe<
    Array<ContainerImageRepositoryContainerImageRepositoryNameTenantTypeUniqueDelete>
  >;
  /** The primary key(s) for `containerImageRepository` for the far side of the relationship. */
  deleteByRepository?: InputMaybe<
    Array<ContainerImageRepositoryContainerImageRepositoryRepositoryKeyDelete>
  >;
  /** Flag indicating whether all other `containerImageRepository` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `containerImageRepository` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `containerImageRepository` for the far side of the relationship. */
  updateByNameAndTenantIdAndRegistryType?: InputMaybe<
    Array<ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryNameTenantTypeUniqueUpdate>
  >;
  /** The primary key(s) and patch data for `containerImageRepository` for the far side of the relationship. */
  updateByRepository?: InputMaybe<
    Array<ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryRepositoryKeyUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type ContainerImageRepositoryTenantId217F4E90FkTenantIdTenantCreateInput =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal: Scalars["Boolean"]["input"];
    key: Scalars["String"]["input"];
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name: Scalars["String"]["input"];
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName: Scalars["String"]["input"];
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status: Scalars["Int"]["input"];
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType: Scalars["Int"]["input"];
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** A filter to be used against many `ContainerImage` object types. All fields are combined with a logical ‘and.’ */
export type ContainerImageRepositoryToManyContainerImageFilter = {
  /** Every related `ContainerImage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContainerImageFilter>;
  /** No related `ContainerImage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContainerImageFilter>;
  /** Some related `ContainerImage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContainerImageFilter>;
};

/** The `containerImage` to be created by this mutation. */
export type ContainerImageTenantIdD0Beb309FkTenantIdContainerImageCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
    containerImageRepositoryId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    label: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    readme?: InputMaybe<Scalars["String"]["input"]>;
    size: Scalars["BigInt"]["input"];
    spec?: InputMaybe<Scalars["JSON"]["input"]>;
    status: Scalars["Int"]["input"];
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
    tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
    tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
  };

/** Input for the nested mutation of `tenant` in the `ContainerImageInput` mutation. */
export type ContainerImageTenantIdD0Beb309FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `containerImage` in the `TenantInput` mutation. */
export type ContainerImageTenantIdD0Beb309FkTenantIdInverseInput = {
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<
    Array<ContainerImageContainerImageExecutorIdKeyConnect>
  >;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContainerImageContainerImagePkeyConnect>>;
  /** A `ContainerImageInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ContainerImageTenantIdD0Beb309FkTenantIdContainerImageCreateInput>
  >;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<
    Array<ContainerImageContainerImageExecutorIdKeyDelete>
  >;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ContainerImageContainerImagePkeyDelete>>;
  /** Flag indicating whether all other `containerImage` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `containerImage` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<
    Array<ContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingContainerImageExecutorIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `containerImage` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingContainerImagePkeyUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type ContainerImageTenantIdD0Beb309FkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** A filter to be used against many `Command` object types. All fields are combined with a logical ‘and.’ */
export type ContainerImageToManyCommandFilter = {
  /** Every related `Command` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CommandFilter>;
  /** No related `Command` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CommandFilter>;
  /** Some related `Command` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CommandFilter>;
};

/** A filter to be used against many `Task` object types. All fields are combined with a logical ‘and.’ */
export type ContainerImageToManyTaskFilter = {
  /** Every related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskFilter>;
  /** No related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskFilter>;
  /** Some related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskFilter>;
};

/** A filter to be used against many `ToolVersion` object types. All fields are combined with a logical ‘and.’ */
export type ContainerImageToManyToolVersionFilter = {
  /** Every related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolVersionFilter>;
  /** No related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolVersionFilter>;
  /** Some related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolVersionFilter>;
};

/** A filter to be used against many `Workflow` object types. All fields are combined with a logical ‘and.’ */
export type ContainerImageToManyWorkflowFilter = {
  /** Every related `Workflow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkflowFilter>;
  /** No related `Workflow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkflowFilter>;
  /** Some related `Workflow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkflowFilter>;
};

/** The `applicationUser` to be created by this mutation. */
export type ContainerImageUserId3919E673FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** The `containerImage` to be created by this mutation. */
export type ContainerImageUserId3919E673FkApplicationUserIdContainerImageCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
    containerImageRepositoryId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    label: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    readme?: InputMaybe<Scalars["String"]["input"]>;
    size: Scalars["BigInt"]["input"];
    spec?: InputMaybe<Scalars["JSON"]["input"]>;
    status: Scalars["Int"]["input"];
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
    tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `ContainerImageInput` mutation. */
export type ContainerImageUserId3919E673FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `containerImage` in the `ApplicationUserInput` mutation. */
export type ContainerImageUserId3919E673FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<
    Array<ContainerImageContainerImageExecutorIdKeyConnect>
  >;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ContainerImageContainerImagePkeyConnect>>;
  /** A `ContainerImageInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ContainerImageUserId3919E673FkApplicationUserIdContainerImageCreateInput>
  >;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<
    Array<ContainerImageContainerImageExecutorIdKeyDelete>
  >;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ContainerImageContainerImagePkeyDelete>>;
  /** Flag indicating whether all other `containerImage` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `containerImage` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<
    Array<ContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingContainerImageExecutorIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `containerImage` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingContainerImagePkeyUpdate>
  >;
};

/** A connection to a list of `ContainerImage` values. */
export type ContainerImagesConnection = {
  __typename: "ContainerImagesConnection";
  /** A list of edges which contains the `ContainerImage` and cursor to aid in pagination. */
  edges: Array<ContainerImagesEdge>;
  /** A list of `ContainerImage` objects. */
  nodes: Array<ContainerImage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ContainerImage` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ContainerImage` edge in the connection. */
export type ContainerImagesEdge = {
  __typename: "ContainerImagesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ContainerImage` at the end of the edge. */
  node: ContainerImage;
};

/** Methods to use when ordering `ContainerImage`. */
export enum ContainerImagesOrderBy {
  ChecksumAsc = "CHECKSUM_ASC",
  ChecksumDesc = "CHECKSUM_DESC",
  ContainerImageRepositoryIdAsc = "CONTAINER_IMAGE_REPOSITORY_ID_ASC",
  ContainerImageRepositoryIdDesc = "CONTAINER_IMAGE_REPOSITORY_ID_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DateDeletedAsc = "DATE_DELETED_ASC",
  DateDeletedDesc = "DATE_DELETED_DESC",
  DateUpdatedAsc = "DATE_UPDATED_ASC",
  DateUpdatedDesc = "DATE_UPDATED_DESC",
  DescriptionAsc = "DESCRIPTION_ASC",
  DescriptionDesc = "DESCRIPTION_DESC",
  ExecutorIdAsc = "EXECUTOR_ID_ASC",
  ExecutorIdDesc = "EXECUTOR_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  LabelAsc = "LABEL_ASC",
  LabelDesc = "LABEL_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ReadmeAsc = "README_ASC",
  ReadmeDesc = "README_DESC",
  SizeAsc = "SIZE_ASC",
  SizeDesc = "SIZE_DESC",
  SpecAsc = "SPEC_ASC",
  SpecDesc = "SPEC_DESC",
  StatusAsc = "STATUS_ASC",
  StatusDesc = "STATUS_DESC",
  TagsAsc = "TAGS_ASC",
  TagsDesc = "TAGS_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

export type Cost = {
  __typename: "Cost";
  costType: Scalars["Int"]["output"];
  currency: Scalars["Int"]["output"];
  date: Maybe<Scalars["Datetime"]["output"]>;
  dateCreated: Scalars["Datetime"]["output"];
  /** Reads and enables pagination through a set of `FileActivity`. */
  fileActivitiesByCostId: FileActivitiesConnection;
  id: Scalars["BigInt"]["output"];
  platform: Maybe<Scalars["Int"]["output"]>;
  rateCode: Maybe<Scalars["String"]["output"]>;
  /** Reads and enables pagination through a set of `TaskActivity`. */
  taskActivitiesByCostId: TaskActivitiesConnection;
  /** Reads a single `Tenant` that is related to this `Cost`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
  value: Scalars["BigFloat"]["output"];
};

export type CostFileActivitiesByCostIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileActivityCondition>;
  filter?: InputMaybe<FileActivityFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileActivitiesOrderBy>>;
};

export type CostTaskActivitiesByCostIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskActivityCondition>;
  filter?: InputMaybe<TaskActivityFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskActivitiesOrderBy>>;
};

/** A condition to be used against `Cost` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type CostCondition = {
  /** Checks for equality with the object’s `costType` field. */
  costType?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `platform` field. */
  platform?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `rateCode` field. */
  rateCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars["BigFloat"]["input"]>;
};

/** The fields on `cost` to look up the row to connect. */
export type CostCostPkeyConnect = {
  id: Scalars["BigInt"]["input"];
};

/** The fields on `cost` to look up the row to delete. */
export type CostCostPkeyDelete = {
  id: Scalars["BigInt"]["input"];
};

/** A filter to be used against `Cost` object types. All fields are combined with a logical ‘and.’ */
export type CostFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CostFilter>>;
  /** Filter by the object’s `costType` field. */
  costType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<IntFilter>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileActivitiesByCostId` relation. */
  fileActivitiesByCostId?: InputMaybe<CostToManyFileActivityFilter>;
  /** Some related `fileActivitiesByCostId` exist. */
  fileActivitiesByCostIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CostFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CostFilter>>;
  /** Filter by the object’s `platform` field. */
  platform?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rateCode` field. */
  rateCode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `taskActivitiesByCostId` relation. */
  taskActivitiesByCostId?: InputMaybe<CostToManyTaskActivityFilter>;
  /** Some related `taskActivitiesByCostId` exist. */
  taskActivitiesByCostIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `Cost` */
export type CostInput = {
  costType: Scalars["Int"]["input"];
  currency: Scalars["Int"]["input"];
  date?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInverseInput>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  platform?: InputMaybe<Scalars["Int"]["input"]>;
  rateCode?: InputMaybe<Scalars["String"]["input"]>;
  taskActivitiesUsingId?: InputMaybe<TaskActivityCostId49E66058FkCostIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInput>;
  value: Scalars["BigFloat"]["input"];
};

/** The fields on `cost` to look up the row to update. */
export type CostOnCostForCostTenantId7Dcd58A7FkTenantIdUsingCostPkeyUpdate = {
  /** An object where the defined keys will be set on the `cost` being updated. */
  costPatch: UpdateCostOnCostForCostTenantId7Dcd58A7FkTenantIdPatch;
  id: Scalars["BigInt"]["input"];
};

/** The fields on `cost` to look up the row to update. */
export type CostOnFileActivityForFileActivityCostId2A88D90AFkCostIdUsingCostPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `cost` being updated. */
    costPatch: UpdateCostOnFileActivityForFileActivityCostId2A88D90AFkCostIdPatch;
    id: Scalars["BigInt"]["input"];
  };

/** The fields on `cost` to look up the row to update. */
export type CostOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingCostPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `cost` being updated. */
    costPatch: UpdateCostOnTaskActivityForTaskActivityCostId49E66058FkCostIdPatch;
    id: Scalars["BigInt"]["input"];
  };

/** Represents an update to a `Cost`. Fields that are set will be updated. */
export type CostPatch = {
  costType?: InputMaybe<Scalars["Int"]["input"]>;
  currency?: InputMaybe<Scalars["Int"]["input"]>;
  date?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInverseInput>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  platform?: InputMaybe<Scalars["Int"]["input"]>;
  rateCode?: InputMaybe<Scalars["String"]["input"]>;
  taskActivitiesUsingId?: InputMaybe<TaskActivityCostId49E66058FkCostIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInput>;
  value?: InputMaybe<Scalars["BigFloat"]["input"]>;
};

/** The `cost` to be created by this mutation. */
export type CostTenantId7Dcd58A7FkTenantIdCostCreateInput = {
  costType: Scalars["Int"]["input"];
  currency: Scalars["Int"]["input"];
  date?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInverseInput>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  platform?: InputMaybe<Scalars["Int"]["input"]>;
  rateCode?: InputMaybe<Scalars["String"]["input"]>;
  taskActivitiesUsingId?: InputMaybe<TaskActivityCostId49E66058FkCostIdInverseInput>;
  tenantToTenantId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInput>;
  value: Scalars["BigFloat"]["input"];
};

/** Input for the nested mutation of `tenant` in the `CostInput` mutation. */
export type CostTenantId7Dcd58A7FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `cost` in the `TenantInput` mutation. */
export type CostTenantId7Dcd58A7FkTenantIdInverseInput = {
  /** The primary key(s) for `cost` for the far side of the relationship. */
  connectById?: InputMaybe<Array<CostCostPkeyConnect>>;
  /** A `CostInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CostTenantId7Dcd58A7FkTenantIdCostCreateInput>>;
  /** The primary key(s) for `cost` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<CostCostPkeyDelete>>;
  /** Flag indicating whether all other `cost` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `cost` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<CostOnCostForCostTenantId7Dcd58A7FkTenantIdUsingCostPkeyUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type CostTenantId7Dcd58A7FkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** A filter to be used against many `FileActivity` object types. All fields are combined with a logical ‘and.’ */
export type CostToManyFileActivityFilter = {
  /** Every related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileActivityFilter>;
  /** No related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileActivityFilter>;
  /** Some related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileActivityFilter>;
};

/** A filter to be used against many `TaskActivity` object types. All fields are combined with a logical ‘and.’ */
export type CostToManyTaskActivityFilter = {
  /** Every related `TaskActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskActivityFilter>;
  /** No related `TaskActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskActivityFilter>;
  /** Some related `TaskActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskActivityFilter>;
};

/** A connection to a list of `Cost` values. */
export type CostsConnection = {
  __typename: "CostsConnection";
  /** A list of edges which contains the `Cost` and cursor to aid in pagination. */
  edges: Array<CostsEdge>;
  /** A list of `Cost` objects. */
  nodes: Array<Cost>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Cost` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `Cost` edge in the connection. */
export type CostsEdge = {
  __typename: "CostsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `Cost` at the end of the edge. */
  node: Cost;
};

/** Methods to use when ordering `Cost`. */
export enum CostsOrderBy {
  CostTypeAsc = "COST_TYPE_ASC",
  CostTypeDesc = "COST_TYPE_DESC",
  CurrencyAsc = "CURRENCY_ASC",
  CurrencyDesc = "CURRENCY_DESC",
  DateAsc = "DATE_ASC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DateDesc = "DATE_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PlatformAsc = "PLATFORM_ASC",
  PlatformDesc = "PLATFORM_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  RateCodeAsc = "RATE_CODE_ASC",
  RateCodeDesc = "RATE_CODE_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  ValueAsc = "VALUE_ASC",
  ValueDesc = "VALUE_DESC",
}

/** All input for the create `AdminProject` mutation. */
export type CreateAdminProjectInput = {
  /** The `AdminProject` to be created by this mutation. */
  adminProject: AdminProjectInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AdminProject` mutation. */
export type CreateAdminProjectPayload = {
  __typename: "CreateAdminProjectPayload";
  /** The `AdminProject` that was created by this mutation. */
  adminProject: Maybe<AdminProject>;
  /** An edge for our `AdminProject`. May be used by Relay 1. */
  adminProjectEdge: Maybe<AdminProjectsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `AdminProject` mutation. */
export type CreateAdminProjectPayloadAdminProjectEdgeArgs = {
  orderBy?: InputMaybe<Array<AdminProjectsOrderBy>>;
};

/** All input for the create `ApplicationUserGroup` mutation. */
export type CreateApplicationUserGroupInput = {
  /** The `ApplicationUserGroup` to be created by this mutation. */
  applicationUserGroup: ApplicationUserGroupInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `ApplicationUserGroup` mutation. */
export type CreateApplicationUserGroupPayload = {
  __typename: "CreateApplicationUserGroupPayload";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserGroup`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserGroup` that was created by this mutation. */
  applicationUserGroup: Maybe<ApplicationUserGroup>;
  /** An edge for our `ApplicationUserGroup`. May be used by Relay 1. */
  applicationUserGroupEdge: Maybe<ApplicationUserGroupsEdge>;
  /** Reads a single `AuthGroup` that is related to this `ApplicationUserGroup`. */
  authGroupByGroupId: Maybe<AuthGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `ApplicationUserGroup` mutation. */
export type CreateApplicationUserGroupPayloadApplicationUserGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ApplicationUserGroupsOrderBy>>;
};

/** All input for the create `ApplicationUser` mutation. */
export type CreateApplicationUserInput = {
  /** The `ApplicationUser` to be created by this mutation. */
  applicationUser: ApplicationUserInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** All input for the create `ApplicationUserMembership` mutation. */
export type CreateApplicationUserMembershipInput = {
  /** The `ApplicationUserMembership` to be created by this mutation. */
  applicationUserMembership: ApplicationUserMembershipInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `ApplicationUserMembership` mutation. */
export type CreateApplicationUserMembershipPayload = {
  __typename: "CreateApplicationUserMembershipPayload";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserMembership`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserMembership` that was created by this mutation. */
  applicationUserMembership: Maybe<ApplicationUserMembership>;
  /** An edge for our `ApplicationUserMembership`. May be used by Relay 1. */
  applicationUserMembershipEdge: Maybe<ApplicationUserMembershipsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ApplicationUserMembership`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our create `ApplicationUserMembership` mutation. */
export type CreateApplicationUserMembershipPayloadApplicationUserMembershipEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ApplicationUserMembershipsOrderBy>>;
  };

/** All input for the create `ApplicationUserMetadatum` mutation. */
export type CreateApplicationUserMetadatumInput = {
  /** The `ApplicationUserMetadatum` to be created by this mutation. */
  applicationUserMetadatum: ApplicationUserMetadatumInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `ApplicationUserMetadatum` mutation. */
export type CreateApplicationUserMetadatumPayload = {
  __typename: "CreateApplicationUserMetadatumPayload";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserMetadatum`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserMetadatum` that was created by this mutation. */
  applicationUserMetadatum: Maybe<ApplicationUserMetadatum>;
  /** An edge for our `ApplicationUserMetadatum`. May be used by Relay 1. */
  applicationUserMetadatumEdge: Maybe<ApplicationUserMetadataEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `ApplicationUserMetadatum` mutation. */
export type CreateApplicationUserMetadatumPayloadApplicationUserMetadatumEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ApplicationUserMetadataOrderBy>>;
  };

/** The output of our create `ApplicationUser` mutation. */
export type CreateApplicationUserPayload = {
  __typename: "CreateApplicationUserPayload";
  /** The `ApplicationUser` that was created by this mutation. */
  applicationUser: Maybe<ApplicationUser>;
  /** An edge for our `ApplicationUser`. May be used by Relay 1. */
  applicationUserEdge: Maybe<ApplicationUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `ApplicationUser` mutation. */
export type CreateApplicationUserPayloadApplicationUserEdgeArgs = {
  orderBy?: InputMaybe<Array<ApplicationUsersOrderBy>>;
};

/** All input for the create `ApplicationUserSession` mutation. */
export type CreateApplicationUserSessionInput = {
  /** The `ApplicationUserSession` to be created by this mutation. */
  applicationUserSession: ApplicationUserSessionInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `ApplicationUserSession` mutation. */
export type CreateApplicationUserSessionPayload = {
  __typename: "CreateApplicationUserSessionPayload";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserSession`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserSession` that was created by this mutation. */
  applicationUserSession: Maybe<ApplicationUserSession>;
  /** An edge for our `ApplicationUserSession`. May be used by Relay 1. */
  applicationUserSessionEdge: Maybe<ApplicationUserSessionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ApplicationUserSession`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our create `ApplicationUserSession` mutation. */
export type CreateApplicationUserSessionPayloadApplicationUserSessionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ApplicationUserSessionsOrderBy>>;
  };

/** All input for the create `ApplicationUserUserPermission` mutation. */
export type CreateApplicationUserUserPermissionInput = {
  /** The `ApplicationUserUserPermission` to be created by this mutation. */
  applicationUserUserPermission: ApplicationUserUserPermissionInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `ApplicationUserUserPermission` mutation. */
export type CreateApplicationUserUserPermissionPayload = {
  __typename: "CreateApplicationUserUserPermissionPayload";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserUserPermission`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserUserPermission` that was created by this mutation. */
  applicationUserUserPermission: Maybe<ApplicationUserUserPermission>;
  /** An edge for our `ApplicationUserUserPermission`. May be used by Relay 1. */
  applicationUserUserPermissionEdge: Maybe<ApplicationUserUserPermissionsEdge>;
  /** Reads a single `AuthPermission` that is related to this `ApplicationUserUserPermission`. */
  authPermissionByPermissionId: Maybe<AuthPermission>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `ApplicationUserUserPermission` mutation. */
export type CreateApplicationUserUserPermissionPayloadApplicationUserUserPermissionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ApplicationUserUserPermissionsOrderBy>>;
  };

/** All input for the create `AuditlogLogentry` mutation. */
export type CreateAuditlogLogentryInput = {
  /** The `AuditlogLogentry` to be created by this mutation. */
  auditlogLogentry: AuditlogLogentryInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AuditlogLogentry` mutation. */
export type CreateAuditlogLogentryPayload = {
  __typename: "CreateAuditlogLogentryPayload";
  /** Reads a single `ApplicationUser` that is related to this `AuditlogLogentry`. */
  applicationUserByActorId: Maybe<ApplicationUser>;
  /** The `AuditlogLogentry` that was created by this mutation. */
  auditlogLogentry: Maybe<AuditlogLogentry>;
  /** An edge for our `AuditlogLogentry`. May be used by Relay 1. */
  auditlogLogentryEdge: Maybe<AuditlogLogentriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `AuditlogLogentry`. */
  djangoContentTypeByContentTypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `AuditlogLogentry` mutation. */
export type CreateAuditlogLogentryPayloadAuditlogLogentryEdgeArgs = {
  orderBy?: InputMaybe<Array<AuditlogLogentriesOrderBy>>;
};

/** All input for the create `AuthGroup` mutation. */
export type CreateAuthGroupInput = {
  /** The `AuthGroup` to be created by this mutation. */
  authGroup: AuthGroupInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AuthGroup` mutation. */
export type CreateAuthGroupPayload = {
  __typename: "CreateAuthGroupPayload";
  /** The `AuthGroup` that was created by this mutation. */
  authGroup: Maybe<AuthGroup>;
  /** An edge for our `AuthGroup`. May be used by Relay 1. */
  authGroupEdge: Maybe<AuthGroupsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `AuthGroup` mutation. */
export type CreateAuthGroupPayloadAuthGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<AuthGroupsOrderBy>>;
};

/** All input for the create `AuthGroupPermission` mutation. */
export type CreateAuthGroupPermissionInput = {
  /** The `AuthGroupPermission` to be created by this mutation. */
  authGroupPermission: AuthGroupPermissionInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AuthGroupPermission` mutation. */
export type CreateAuthGroupPermissionPayload = {
  __typename: "CreateAuthGroupPermissionPayload";
  /** Reads a single `AuthGroup` that is related to this `AuthGroupPermission`. */
  authGroupByGroupId: Maybe<AuthGroup>;
  /** The `AuthGroupPermission` that was created by this mutation. */
  authGroupPermission: Maybe<AuthGroupPermission>;
  /** An edge for our `AuthGroupPermission`. May be used by Relay 1. */
  authGroupPermissionEdge: Maybe<AuthGroupPermissionsEdge>;
  /** Reads a single `AuthPermission` that is related to this `AuthGroupPermission`. */
  authPermissionByPermissionId: Maybe<AuthPermission>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `AuthGroupPermission` mutation. */
export type CreateAuthGroupPermissionPayloadAuthGroupPermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<AuthGroupPermissionsOrderBy>>;
};

/** All input for the create `AuthPermission` mutation. */
export type CreateAuthPermissionInput = {
  /** The `AuthPermission` to be created by this mutation. */
  authPermission: AuthPermissionInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AuthPermission` mutation. */
export type CreateAuthPermissionPayload = {
  __typename: "CreateAuthPermissionPayload";
  /** The `AuthPermission` that was created by this mutation. */
  authPermission: Maybe<AuthPermission>;
  /** An edge for our `AuthPermission`. May be used by Relay 1. */
  authPermissionEdge: Maybe<AuthPermissionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `AuthPermission`. */
  djangoContentTypeByContentTypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `AuthPermission` mutation. */
export type CreateAuthPermissionPayloadAuthPermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<AuthPermissionsOrderBy>>;
};

/** All input for the create `AvailableNonRestrictedProject` mutation. */
export type CreateAvailableNonRestrictedProjectInput = {
  /** The `AvailableNonRestrictedProject` to be created by this mutation. */
  availableNonRestrictedProject: AvailableNonRestrictedProjectInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AvailableNonRestrictedProject` mutation. */
export type CreateAvailableNonRestrictedProjectPayload = {
  __typename: "CreateAvailableNonRestrictedProjectPayload";
  /** The `AvailableNonRestrictedProject` that was created by this mutation. */
  availableNonRestrictedProject: Maybe<AvailableNonRestrictedProject>;
  /** An edge for our `AvailableNonRestrictedProject`. May be used by Relay 1. */
  availableNonRestrictedProjectEdge: Maybe<AvailableNonRestrictedProjectsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `AvailableNonRestrictedProject` mutation. */
export type CreateAvailableNonRestrictedProjectPayloadAvailableNonRestrictedProjectEdgeArgs =
  {
    orderBy?: InputMaybe<Array<AvailableNonRestrictedProjectsOrderBy>>;
  };

/** All input for the create `Avatar` mutation. */
export type CreateAvatarInput = {
  /** The `Avatar` to be created by this mutation. */
  avatar: AvatarInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `Avatar` mutation. */
export type CreateAvatarPayload = {
  __typename: "CreateAvatarPayload";
  /** Reads a single `ApplicationUser` that is related to this `Avatar`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `Avatar` that was created by this mutation. */
  avatar: Maybe<Avatar>;
  /** An edge for our `Avatar`. May be used by Relay 1. */
  avatarEdge: Maybe<AvatarsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `Avatar` mutation. */
export type CreateAvatarPayloadAvatarEdgeArgs = {
  orderBy?: InputMaybe<Array<AvatarsOrderBy>>;
};

/** All input for the create `AwsBatchTask` mutation. */
export type CreateAwsBatchTaskInput = {
  /** The `AwsBatchTask` to be created by this mutation. */
  awsBatchTask: AwsBatchTaskInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AwsBatchTask` mutation. */
export type CreateAwsBatchTaskPayload = {
  __typename: "CreateAwsBatchTaskPayload";
  /** The `AwsBatchTask` that was created by this mutation. */
  awsBatchTask: Maybe<AwsBatchTask>;
  /** An edge for our `AwsBatchTask`. May be used by Relay 1. */
  awsBatchTaskEdge: Maybe<AwsBatchTasksEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TesTaskexecutor` that is related to this `AwsBatchTask`. */
  tesTaskexecutorByTaskexecutorPtrId: Maybe<TesTaskexecutor>;
};

/** The output of our create `AwsBatchTask` mutation. */
export type CreateAwsBatchTaskPayloadAwsBatchTaskEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsBatchTasksOrderBy>>;
};

/** All input for the create `AwsCognitoUser` mutation. */
export type CreateAwsCognitoUserInput = {
  /** The `AwsCognitoUser` to be created by this mutation. */
  awsCognitoUser: AwsCognitoUserInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AwsCognitoUser` mutation. */
export type CreateAwsCognitoUserPayload = {
  __typename: "CreateAwsCognitoUserPayload";
  /** The `AwsCognitoUser` that was created by this mutation. */
  awsCognitoUser: Maybe<AwsCognitoUser>;
  /** An edge for our `AwsCognitoUser`. May be used by Relay 1. */
  awsCognitoUserEdge: Maybe<AwsCognitoUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TenantUserexecutor` that is related to this `AwsCognitoUser`. */
  tenantUserexecutorByUserexecutorPtrId: Maybe<TenantUserexecutor>;
};

/** The output of our create `AwsCognitoUser` mutation. */
export type CreateAwsCognitoUserPayloadAwsCognitoUserEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsCognitoUsersOrderBy>>;
};

/** All input for the create `AwsEcrImage` mutation. */
export type CreateAwsEcrImageInput = {
  /** The `AwsEcrImage` to be created by this mutation. */
  awsEcrImage: AwsEcrImageInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AwsEcrImage` mutation. */
export type CreateAwsEcrImagePayload = {
  __typename: "CreateAwsEcrImagePayload";
  /** The `AwsEcrImage` that was created by this mutation. */
  awsEcrImage: Maybe<AwsEcrImage>;
  /** An edge for our `AwsEcrImage`. May be used by Relay 1. */
  awsEcrImageEdge: Maybe<AwsEcrImagesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TesContainerimageexecutor` that is related to this `AwsEcrImage`. */
  tesContainerimageexecutorByContainerimageexecutorPtrId: Maybe<TesContainerimageexecutor>;
};

/** The output of our create `AwsEcrImage` mutation. */
export type CreateAwsEcrImagePayloadAwsEcrImageEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsEcrImagesOrderBy>>;
};

/** All input for the create `AwsMockBatchTask` mutation. */
export type CreateAwsMockBatchTaskInput = {
  /** The `AwsMockBatchTask` to be created by this mutation. */
  awsMockBatchTask: AwsMockBatchTaskInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AwsMockBatchTask` mutation. */
export type CreateAwsMockBatchTaskPayload = {
  __typename: "CreateAwsMockBatchTaskPayload";
  /** Reads a single `AwsBatchTask` that is related to this `AwsMockBatchTask`. */
  awsBatchTaskByAwstaskexecutorPtrId: Maybe<AwsBatchTask>;
  /** The `AwsMockBatchTask` that was created by this mutation. */
  awsMockBatchTask: Maybe<AwsMockBatchTask>;
  /** An edge for our `AwsMockBatchTask`. May be used by Relay 1. */
  awsMockBatchTaskEdge: Maybe<AwsMockBatchTasksEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `AwsMockBatchTask` mutation. */
export type CreateAwsMockBatchTaskPayloadAwsMockBatchTaskEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsMockBatchTasksOrderBy>>;
};

/** All input for the create `AwsMockDistributionImage` mutation. */
export type CreateAwsMockDistributionImageInput = {
  /** The `AwsMockDistributionImage` to be created by this mutation. */
  awsMockDistributionImage: AwsMockDistributionImageInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AwsMockDistributionImage` mutation. */
export type CreateAwsMockDistributionImagePayload = {
  __typename: "CreateAwsMockDistributionImagePayload";
  /** The `AwsMockDistributionImage` that was created by this mutation. */
  awsMockDistributionImage: Maybe<AwsMockDistributionImage>;
  /** An edge for our `AwsMockDistributionImage`. May be used by Relay 1. */
  awsMockDistributionImageEdge: Maybe<AwsMockDistributionImagesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DistributionRegistryImage` that is related to this `AwsMockDistributionImage`. */
  distributionRegistryImageByDistributioncontainerimageexecutorPtrId: Maybe<DistributionRegistryImage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `AwsMockDistributionImage` mutation. */
export type CreateAwsMockDistributionImagePayloadAwsMockDistributionImageEdgeArgs =
  {
    orderBy?: InputMaybe<Array<AwsMockDistributionImagesOrderBy>>;
  };

/** All input for the create `AwsMockEcrImage` mutation. */
export type CreateAwsMockEcrImageInput = {
  /** The `AwsMockEcrImage` to be created by this mutation. */
  awsMockEcrImage: AwsMockEcrImageInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AwsMockEcrImage` mutation. */
export type CreateAwsMockEcrImagePayload = {
  __typename: "CreateAwsMockEcrImagePayload";
  /** Reads a single `AwsEcrImage` that is related to this `AwsMockEcrImage`. */
  awsEcrImageByAwscontainerimageexecutorPtrId: Maybe<AwsEcrImage>;
  /** The `AwsMockEcrImage` that was created by this mutation. */
  awsMockEcrImage: Maybe<AwsMockEcrImage>;
  /** An edge for our `AwsMockEcrImage`. May be used by Relay 1. */
  awsMockEcrImageEdge: Maybe<AwsMockEcrImagesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `AwsMockEcrImage` mutation. */
export type CreateAwsMockEcrImagePayloadAwsMockEcrImageEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsMockEcrImagesOrderBy>>;
};

/** All input for the create `AwsMockIamUser` mutation. */
export type CreateAwsMockIamUserInput = {
  /** The `AwsMockIamUser` to be created by this mutation. */
  awsMockIamUser: AwsMockIamUserInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AwsMockIamUser` mutation. */
export type CreateAwsMockIamUserPayload = {
  __typename: "CreateAwsMockIamUserPayload";
  /** Reads a single `AwsCognitoUser` that is related to this `AwsMockIamUser`. */
  awsCognitoUserByAwsuserexecutorPtrId: Maybe<AwsCognitoUser>;
  /** The `AwsMockIamUser` that was created by this mutation. */
  awsMockIamUser: Maybe<AwsMockIamUser>;
  /** An edge for our `AwsMockIamUser`. May be used by Relay 1. */
  awsMockIamUserEdge: Maybe<AwsMockIamUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `AwsMockIamUser` mutation. */
export type CreateAwsMockIamUserPayloadAwsMockIamUserEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsMockIamUsersOrderBy>>;
};

/** All input for the create `AwsMockS3File` mutation. */
export type CreateAwsMockS3FileInput = {
  /** The `AwsMockS3File` to be created by this mutation. */
  awsMockS3File: AwsMockS3FileInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AwsMockS3File` mutation. */
export type CreateAwsMockS3FilePayload = {
  __typename: "CreateAwsMockS3FilePayload";
  /** The `AwsMockS3File` that was created by this mutation. */
  awsMockS3File: Maybe<AwsMockS3File>;
  /** An edge for our `AwsMockS3File`. May be used by Relay 1. */
  awsMockS3FileEdge: Maybe<AwsMockS3FilesEdge>;
  /** Reads a single `AwsS3File` that is related to this `AwsMockS3File`. */
  awsS3FileByAwsfileexecutorPtrId: Maybe<AwsS3File>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `AwsMockS3File` mutation. */
export type CreateAwsMockS3FilePayloadAwsMockS3FileEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsMockS3FilesOrderBy>>;
};

/** All input for the create `AwsS3File` mutation. */
export type CreateAwsS3FileInput = {
  /** The `AwsS3File` to be created by this mutation. */
  awsS3File: AwsS3FileInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our create `AwsS3File` mutation. */
export type CreateAwsS3FilePayload = {
  __typename: "CreateAwsS3FilePayload";
  /** The `AwsS3File` that was created by this mutation. */
  awsS3File: Maybe<AwsS3File>;
  /** An edge for our `AwsS3File`. May be used by Relay 1. */
  awsS3FileEdge: Maybe<AwsS3FilesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DrsFileexecutor` that is related to this `AwsS3File`. */
  drsFileexecutorByFileexecutorPtrId: Maybe<DrsFileexecutor>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `AwsS3File` mutation. */
export type CreateAwsS3FilePayloadAwsS3FileEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsS3FilesOrderBy>>;
};

/** All input for the create `CodeFile` mutation. */
export type CreateCodeFileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `CodeFile` to be created by this mutation. */
  codeFile: CodeFileInput;
};

/** The output of our create `CodeFile` mutation. */
export type CreateCodeFilePayload = {
  __typename: "CreateCodeFilePayload";
  /** Reads a single `ApplicationUser` that is related to this `CodeFile`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `CodeFile` that was created by this mutation. */
  codeFile: Maybe<CodeFile>;
  /** Reads a single `CodeFile` that is related to this `CodeFile`. */
  codeFileBySeriesParentId: Maybe<CodeFile>;
  /** An edge for our `CodeFile`. May be used by Relay 1. */
  codeFileEdge: Maybe<CodeFilesEdge>;
  /** Reads a single `DrsFileexecutor` that is related to this `CodeFile`. */
  drsFileexecutorByExecutorId: Maybe<DrsFileexecutor>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `CodeFile`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our create `CodeFile` mutation. */
export type CreateCodeFilePayloadCodeFileEdgeArgs = {
  orderBy?: InputMaybe<Array<CodeFilesOrderBy>>;
};

/** All input for the create `Command` mutation. */
export type CreateCommandInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `Command` to be created by this mutation. */
  command: CommandInput;
};

/** The output of our create `Command` mutation. */
export type CreateCommandPayload = {
  __typename: "CreateCommandPayload";
  /** Reads a single `ApplicationUser` that is related to this `Command`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `CodeFile` that is related to this `Command`. */
  codeFileByCodeFileId: Maybe<CodeFile>;
  /** The `Command` that was created by this mutation. */
  command: Maybe<Command>;
  /** An edge for our `Command`. May be used by Relay 1. */
  commandEdge: Maybe<CommandsEdge>;
  /** Reads a single `ContainerImage` that is related to this `Command`. */
  containerImageByContainerImageId: Maybe<ContainerImage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Command`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `ToolVersion` that is related to this `Command`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our create `Command` mutation. */
export type CreateCommandPayloadCommandEdgeArgs = {
  orderBy?: InputMaybe<Array<CommandsOrderBy>>;
};

/** All input for the create `ContainerImage` mutation. */
export type CreateContainerImageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `ContainerImage` to be created by this mutation. */
  containerImage: ContainerImageInput;
};

/** The output of our create `ContainerImage` mutation. */
export type CreateContainerImagePayload = {
  __typename: "CreateContainerImagePayload";
  /** Reads a single `ApplicationUser` that is related to this `ContainerImage`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `ContainerImage` that was created by this mutation. */
  containerImage: Maybe<ContainerImage>;
  /** An edge for our `ContainerImage`. May be used by Relay 1. */
  containerImageEdge: Maybe<ContainerImagesEdge>;
  /** Reads a single `ContainerImageRepository` that is related to this `ContainerImage`. */
  containerImageRepositoryByContainerImageRepositoryId: Maybe<ContainerImageRepository>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ContainerImage`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `TesContainerimageexecutor` that is related to this `ContainerImage`. */
  tesContainerimageexecutorByExecutorId: Maybe<TesContainerimageexecutor>;
};

/** The output of our create `ContainerImage` mutation. */
export type CreateContainerImagePayloadContainerImageEdgeArgs = {
  orderBy?: InputMaybe<Array<ContainerImagesOrderBy>>;
};

/** All input for the create `ContainerImageRepository` mutation. */
export type CreateContainerImageRepositoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `ContainerImageRepository` to be created by this mutation. */
  containerImageRepository: ContainerImageRepositoryInput;
};

/** The output of our create `ContainerImageRepository` mutation. */
export type CreateContainerImageRepositoryPayload = {
  __typename: "CreateContainerImageRepositoryPayload";
  /** Reads a single `ApplicationUser` that is related to this `ContainerImageRepository`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `ContainerImageRepository` that was created by this mutation. */
  containerImageRepository: Maybe<ContainerImageRepository>;
  /** An edge for our `ContainerImageRepository`. May be used by Relay 1. */
  containerImageRepositoryEdge: Maybe<ContainerImageRepositoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ContainerImageRepository`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our create `ContainerImageRepository` mutation. */
export type CreateContainerImageRepositoryPayloadContainerImageRepositoryEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ContainerImageRepositoriesOrderBy>>;
  };

/** All input for the create `Cost` mutation. */
export type CreateCostInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `Cost` to be created by this mutation. */
  cost: CostInput;
};

/** The output of our create `Cost` mutation. */
export type CreateCostPayload = {
  __typename: "CreateCostPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `Cost` that was created by this mutation. */
  cost: Maybe<Cost>;
  /** An edge for our `Cost`. May be used by Relay 1. */
  costEdge: Maybe<CostsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Cost`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our create `Cost` mutation. */
export type CreateCostPayloadCostEdgeArgs = {
  orderBy?: InputMaybe<Array<CostsOrderBy>>;
};

/** All input for the create `CurrentApplicationUser` mutation. */
export type CreateCurrentApplicationUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `CurrentApplicationUser` to be created by this mutation. */
  currentApplicationUser: CurrentApplicationUserInput;
};

/** The output of our create `CurrentApplicationUser` mutation. */
export type CreateCurrentApplicationUserPayload = {
  __typename: "CreateCurrentApplicationUserPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `CurrentApplicationUser` that was created by this mutation. */
  currentApplicationUser: Maybe<CurrentApplicationUser>;
  /** An edge for our `CurrentApplicationUser`. May be used by Relay 1. */
  currentApplicationUserEdge: Maybe<CurrentApplicationUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `CurrentApplicationUser` mutation. */
export type CreateCurrentApplicationUserPayloadCurrentApplicationUserEdgeArgs =
  {
    orderBy?: InputMaybe<Array<CurrentApplicationUsersOrderBy>>;
  };

/** All input for the create `DistributionRegistryImage` mutation. */
export type CreateDistributionRegistryImageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `DistributionRegistryImage` to be created by this mutation. */
  distributionRegistryImage: DistributionRegistryImageInput;
};

/** The output of our create `DistributionRegistryImage` mutation. */
export type CreateDistributionRegistryImagePayload = {
  __typename: "CreateDistributionRegistryImagePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `DistributionRegistryImage` that was created by this mutation. */
  distributionRegistryImage: Maybe<DistributionRegistryImage>;
  /** An edge for our `DistributionRegistryImage`. May be used by Relay 1. */
  distributionRegistryImageEdge: Maybe<DistributionRegistryImagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TesContainerimageexecutor` that is related to this `DistributionRegistryImage`. */
  tesContainerimageexecutorByContainerimageexecutorPtrId: Maybe<TesContainerimageexecutor>;
};

/** The output of our create `DistributionRegistryImage` mutation. */
export type CreateDistributionRegistryImagePayloadDistributionRegistryImageEdgeArgs =
  {
    orderBy?: InputMaybe<Array<DistributionRegistryImagesOrderBy>>;
  };

/** All input for the create `DjangoAdminLog` mutation. */
export type CreateDjangoAdminLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `DjangoAdminLog` to be created by this mutation. */
  djangoAdminLog: DjangoAdminLogInput;
};

/** The output of our create `DjangoAdminLog` mutation. */
export type CreateDjangoAdminLogPayload = {
  __typename: "CreateDjangoAdminLogPayload";
  /** Reads a single `ApplicationUser` that is related to this `DjangoAdminLog`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `DjangoAdminLog` that was created by this mutation. */
  djangoAdminLog: Maybe<DjangoAdminLog>;
  /** An edge for our `DjangoAdminLog`. May be used by Relay 1. */
  djangoAdminLogEdge: Maybe<DjangoAdminLogsEdge>;
  /** Reads a single `DjangoContentType` that is related to this `DjangoAdminLog`. */
  djangoContentTypeByContentTypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `DjangoAdminLog` mutation. */
export type CreateDjangoAdminLogPayloadDjangoAdminLogEdgeArgs = {
  orderBy?: InputMaybe<Array<DjangoAdminLogsOrderBy>>;
};

/** All input for the create `DjangoContentType` mutation. */
export type CreateDjangoContentTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `DjangoContentType` to be created by this mutation. */
  djangoContentType: DjangoContentTypeInput;
};

/** The output of our create `DjangoContentType` mutation. */
export type CreateDjangoContentTypePayload = {
  __typename: "CreateDjangoContentTypePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `DjangoContentType` that was created by this mutation. */
  djangoContentType: Maybe<DjangoContentType>;
  /** An edge for our `DjangoContentType`. May be used by Relay 1. */
  djangoContentTypeEdge: Maybe<DjangoContentTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `DjangoContentType` mutation. */
export type CreateDjangoContentTypePayloadDjangoContentTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<DjangoContentTypesOrderBy>>;
};

/** All input for the create `DjangoMigration` mutation. */
export type CreateDjangoMigrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `DjangoMigration` to be created by this mutation. */
  djangoMigration: DjangoMigrationInput;
};

/** The output of our create `DjangoMigration` mutation. */
export type CreateDjangoMigrationPayload = {
  __typename: "CreateDjangoMigrationPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `DjangoMigration` that was created by this mutation. */
  djangoMigration: Maybe<DjangoMigration>;
  /** An edge for our `DjangoMigration`. May be used by Relay 1. */
  djangoMigrationEdge: Maybe<DjangoMigrationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `DjangoMigration` mutation. */
export type CreateDjangoMigrationPayloadDjangoMigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<DjangoMigrationsOrderBy>>;
};

/** All input for the create `DjangoSesBlacklistedemail` mutation. */
export type CreateDjangoSesBlacklistedemailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `DjangoSesBlacklistedemail` to be created by this mutation. */
  djangoSesBlacklistedemail: DjangoSesBlacklistedemailInput;
};

/** The output of our create `DjangoSesBlacklistedemail` mutation. */
export type CreateDjangoSesBlacklistedemailPayload = {
  __typename: "CreateDjangoSesBlacklistedemailPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `DjangoSesBlacklistedemail` that was created by this mutation. */
  djangoSesBlacklistedemail: Maybe<DjangoSesBlacklistedemail>;
  /** An edge for our `DjangoSesBlacklistedemail`. May be used by Relay 1. */
  djangoSesBlacklistedemailEdge: Maybe<DjangoSesBlacklistedemailsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `DjangoSesBlacklistedemail` mutation. */
export type CreateDjangoSesBlacklistedemailPayloadDjangoSesBlacklistedemailEdgeArgs =
  {
    orderBy?: InputMaybe<Array<DjangoSesBlacklistedemailsOrderBy>>;
  };

/** All input for the create `DjangoSesSesstat` mutation. */
export type CreateDjangoSesSesstatInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `DjangoSesSesstat` to be created by this mutation. */
  djangoSesSesstat: DjangoSesSesstatInput;
};

/** The output of our create `DjangoSesSesstat` mutation. */
export type CreateDjangoSesSesstatPayload = {
  __typename: "CreateDjangoSesSesstatPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `DjangoSesSesstat` that was created by this mutation. */
  djangoSesSesstat: Maybe<DjangoSesSesstat>;
  /** An edge for our `DjangoSesSesstat`. May be used by Relay 1. */
  djangoSesSesstatEdge: Maybe<DjangoSesSesstatsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `DjangoSesSesstat` mutation. */
export type CreateDjangoSesSesstatPayloadDjangoSesSesstatEdgeArgs = {
  orderBy?: InputMaybe<Array<DjangoSesSesstatsOrderBy>>;
};

/** All input for the create `DjangoSession` mutation. */
export type CreateDjangoSessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `DjangoSession` to be created by this mutation. */
  djangoSession: DjangoSessionInput;
};

/** The output of our create `DjangoSession` mutation. */
export type CreateDjangoSessionPayload = {
  __typename: "CreateDjangoSessionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `DjangoSession` that was created by this mutation. */
  djangoSession: Maybe<DjangoSession>;
  /** An edge for our `DjangoSession`. May be used by Relay 1. */
  djangoSessionEdge: Maybe<DjangoSessionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `DjangoSession` mutation. */
export type CreateDjangoSessionPayloadDjangoSessionEdgeArgs = {
  orderBy?: InputMaybe<Array<DjangoSessionsOrderBy>>;
};

/** All input for the create `DrsFileexecutor` mutation. */
export type CreateDrsFileexecutorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `DrsFileexecutor` to be created by this mutation. */
  drsFileexecutor: DrsFileexecutorInput;
};

/** The output of our create `DrsFileexecutor` mutation. */
export type CreateDrsFileexecutorPayload = {
  __typename: "CreateDrsFileexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `DrsFileexecutor`. */
  djangoContentTypeByPolymorphicCtypeId: Maybe<DjangoContentType>;
  /** The `DrsFileexecutor` that was created by this mutation. */
  drsFileexecutor: Maybe<DrsFileexecutor>;
  /** An edge for our `DrsFileexecutor`. May be used by Relay 1. */
  drsFileexecutorEdge: Maybe<DrsFileexecutorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `DrsFileexecutor` mutation. */
export type CreateDrsFileexecutorPayloadDrsFileexecutorEdgeArgs = {
  orderBy?: InputMaybe<Array<DrsFileexecutorsOrderBy>>;
};

/** All input for the create `DrsMockfileexecutor` mutation. */
export type CreateDrsMockfileexecutorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `DrsMockfileexecutor` to be created by this mutation. */
  drsMockfileexecutor: DrsMockfileexecutorInput;
};

/** The output of our create `DrsMockfileexecutor` mutation. */
export type CreateDrsMockfileexecutorPayload = {
  __typename: "CreateDrsMockfileexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DrsFileexecutor` that is related to this `DrsMockfileexecutor`. */
  drsFileexecutorByFileexecutorPtrId: Maybe<DrsFileexecutor>;
  /** The `DrsMockfileexecutor` that was created by this mutation. */
  drsMockfileexecutor: Maybe<DrsMockfileexecutor>;
  /** An edge for our `DrsMockfileexecutor`. May be used by Relay 1. */
  drsMockfileexecutorEdge: Maybe<DrsMockfileexecutorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `DrsMockfileexecutor` mutation. */
export type CreateDrsMockfileexecutorPayloadDrsMockfileexecutorEdgeArgs = {
  orderBy?: InputMaybe<Array<DrsMockfileexecutorsOrderBy>>;
};

/** All input for the create `EulaVersion` mutation. */
export type CreateEulaVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `EulaVersion` to be created by this mutation. */
  eulaVersion: EulaVersionInput;
};

/** The output of our create `EulaVersion` mutation. */
export type CreateEulaVersionPayload = {
  __typename: "CreateEulaVersionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `EulaVersion` that was created by this mutation. */
  eulaVersion: Maybe<EulaVersion>;
  /** An edge for our `EulaVersion`. May be used by Relay 1. */
  eulaVersionEdge: Maybe<EulaVersionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `EulaVersion` mutation. */
export type CreateEulaVersionPayloadEulaVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<EulaVersionsOrderBy>>;
};

/** All input for the create `EulaVersionUserAcceptance` mutation. */
export type CreateEulaVersionUserAcceptanceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `EulaVersionUserAcceptance` to be created by this mutation. */
  eulaVersionUserAcceptance: EulaVersionUserAcceptanceInput;
};

/** The output of our create `EulaVersionUserAcceptance` mutation. */
export type CreateEulaVersionUserAcceptancePayload = {
  __typename: "CreateEulaVersionUserAcceptancePayload";
  /** Reads a single `ApplicationUser` that is related to this `EulaVersionUserAcceptance`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `EulaVersion` that is related to this `EulaVersionUserAcceptance`. */
  eulaVersionByEulaVersionId: Maybe<EulaVersion>;
  /** The `EulaVersionUserAcceptance` that was created by this mutation. */
  eulaVersionUserAcceptance: Maybe<EulaVersionUserAcceptance>;
  /** An edge for our `EulaVersionUserAcceptance`. May be used by Relay 1. */
  eulaVersionUserAcceptanceEdge: Maybe<EulaVersionUserAcceptancesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `EulaVersionUserAcceptance` mutation. */
export type CreateEulaVersionUserAcceptancePayloadEulaVersionUserAcceptanceEdgeArgs =
  {
    orderBy?: InputMaybe<Array<EulaVersionUserAcceptancesOrderBy>>;
  };

/** All input for the create `FeatureFlag` mutation. */
export type CreateFeatureFlagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `FeatureFlag` to be created by this mutation. */
  featureFlag: FeatureFlagInput;
};

/** The output of our create `FeatureFlag` mutation. */
export type CreateFeatureFlagPayload = {
  __typename: "CreateFeatureFlagPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `FeatureFlag` that was created by this mutation. */
  featureFlag: Maybe<FeatureFlag>;
  /** An edge for our `FeatureFlag`. May be used by Relay 1. */
  featureFlagEdge: Maybe<FeatureFlagsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `FeatureFlag` mutation. */
export type CreateFeatureFlagPayloadFeatureFlagEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureFlagsOrderBy>>;
};

/** All input for the create `FeatureFlagsGroup` mutation. */
export type CreateFeatureFlagsGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `FeatureFlagsGroup` to be created by this mutation. */
  featureFlagsGroup: FeatureFlagsGroupInput;
};

/** The output of our create `FeatureFlagsGroup` mutation. */
export type CreateFeatureFlagsGroupPayload = {
  __typename: "CreateFeatureFlagsGroupPayload";
  /** Reads a single `AuthGroup` that is related to this `FeatureFlagsGroup`. */
  authGroupByGroupId: Maybe<AuthGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `FeatureFlag` that is related to this `FeatureFlagsGroup`. */
  featureFlagByFeatureflagId: Maybe<FeatureFlag>;
  /** The `FeatureFlagsGroup` that was created by this mutation. */
  featureFlagsGroup: Maybe<FeatureFlagsGroup>;
  /** An edge for our `FeatureFlagsGroup`. May be used by Relay 1. */
  featureFlagsGroupEdge: Maybe<FeatureFlagsGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `FeatureFlagsGroup` mutation. */
export type CreateFeatureFlagsGroupPayloadFeatureFlagsGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureFlagsGroupsOrderBy>>;
};

/** All input for the create `FeatureFlagsTenant` mutation. */
export type CreateFeatureFlagsTenantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `FeatureFlagsTenant` to be created by this mutation. */
  featureFlagsTenant: FeatureFlagsTenantInput;
};

/** The output of our create `FeatureFlagsTenant` mutation. */
export type CreateFeatureFlagsTenantPayload = {
  __typename: "CreateFeatureFlagsTenantPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `FeatureFlag` that is related to this `FeatureFlagsTenant`. */
  featureFlagByFeatureflagId: Maybe<FeatureFlag>;
  /** The `FeatureFlagsTenant` that was created by this mutation. */
  featureFlagsTenant: Maybe<FeatureFlagsTenant>;
  /** An edge for our `FeatureFlagsTenant`. May be used by Relay 1. */
  featureFlagsTenantEdge: Maybe<FeatureFlagsTenantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `FeatureFlagsTenant`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our create `FeatureFlagsTenant` mutation. */
export type CreateFeatureFlagsTenantPayloadFeatureFlagsTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureFlagsTenantsOrderBy>>;
};

/** All input for the create `FeatureFlagsUser` mutation. */
export type CreateFeatureFlagsUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `FeatureFlagsUser` to be created by this mutation. */
  featureFlagsUser: FeatureFlagsUserInput;
};

/** The output of our create `FeatureFlagsUser` mutation. */
export type CreateFeatureFlagsUserPayload = {
  __typename: "CreateFeatureFlagsUserPayload";
  /** Reads a single `ApplicationUser` that is related to this `FeatureFlagsUser`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `FeatureFlag` that is related to this `FeatureFlagsUser`. */
  featureFlagByFeatureflagId: Maybe<FeatureFlag>;
  /** The `FeatureFlagsUser` that was created by this mutation. */
  featureFlagsUser: Maybe<FeatureFlagsUser>;
  /** An edge for our `FeatureFlagsUser`. May be used by Relay 1. */
  featureFlagsUserEdge: Maybe<FeatureFlagsUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `FeatureFlagsUser` mutation. */
export type CreateFeatureFlagsUserPayloadFeatureFlagsUserEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureFlagsUsersOrderBy>>;
};

/** All input for the create `FileActivity` mutation. */
export type CreateFileActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `FileActivity` to be created by this mutation. */
  fileActivity: FileActivityInput;
};

/** The output of our create `FileActivity` mutation. */
export type CreateFileActivityPayload = {
  __typename: "CreateFileActivityPayload";
  /** Reads a single `ApplicationUser` that is related to this `FileActivity`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Cost` that is related to this `FileActivity`. */
  costByCostId: Maybe<Cost>;
  /** Reads a single `DjangoContentType` that is related to this `FileActivity`. */
  djangoContentTypeByContentTypeId: Maybe<DjangoContentType>;
  /** The `FileActivity` that was created by this mutation. */
  fileActivity: Maybe<FileActivity>;
  /** An edge for our `FileActivity`. May be used by Relay 1. */
  fileActivityEdge: Maybe<FileActivitiesEdge>;
  /** Reads a single `File` that is related to this `FileActivity`. */
  fileByFileId: Maybe<File>;
  /** Reads a single `Project` that is related to this `FileActivity`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `FileActivity`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our create `FileActivity` mutation. */
export type CreateFileActivityPayloadFileActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<FileActivitiesOrderBy>>;
};

/** All input for the create `File` mutation. */
export type CreateFileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `File` to be created by this mutation. */
  file: FileInput;
};

/** All input for the create `FileMetadatum` mutation. */
export type CreateFileMetadatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `FileMetadatum` to be created by this mutation. */
  fileMetadatum: FileMetadatumInput;
};

/** The output of our create `FileMetadatum` mutation. */
export type CreateFileMetadatumPayload = {
  __typename: "CreateFileMetadatumPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `File` that is related to this `FileMetadatum`. */
  fileByFileId: Maybe<File>;
  /** The `FileMetadatum` that was created by this mutation. */
  fileMetadatum: Maybe<FileMetadatum>;
  /** An edge for our `FileMetadatum`. May be used by Relay 1. */
  fileMetadatumEdge: Maybe<FileMetadataEdge>;
  /** Reads a single `Metadatum` that is related to this `FileMetadatum`. */
  metadatumByMetadataId: Maybe<Metadatum>;
  /** Reads a single `Project` that is related to this `FileMetadatum`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `FileMetadatum`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our create `FileMetadatum` mutation. */
export type CreateFileMetadatumPayloadFileMetadatumEdgeArgs = {
  orderBy?: InputMaybe<Array<FileMetadataOrderBy>>;
};

/** All input for the create `FileOutputGroupMetadatum` mutation. */
export type CreateFileOutputGroupMetadatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `FileOutputGroupMetadatum` to be created by this mutation. */
  fileOutputGroupMetadatum: FileOutputGroupMetadatumInput;
};

/** The output of our create `FileOutputGroupMetadatum` mutation. */
export type CreateFileOutputGroupMetadatumPayload = {
  __typename: "CreateFileOutputGroupMetadatumPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `FileOutputGroup` that is related to this `FileOutputGroupMetadatum`. */
  fileOutputGroupByFileOutputGroupId: Maybe<FileOutputGroup>;
  /** The `FileOutputGroupMetadatum` that was created by this mutation. */
  fileOutputGroupMetadatum: Maybe<FileOutputGroupMetadatum>;
  /** An edge for our `FileOutputGroupMetadatum`. May be used by Relay 1. */
  fileOutputGroupMetadatumEdge: Maybe<FileOutputGroupMetadataEdge>;
  /** Reads a single `Metadatum` that is related to this `FileOutputGroupMetadatum`. */
  metadatumByMetadataId: Maybe<Metadatum>;
  /** Reads a single `Project` that is related to this `FileOutputGroupMetadatum`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `FileOutputGroupMetadatum`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our create `FileOutputGroupMetadatum` mutation. */
export type CreateFileOutputGroupMetadatumPayloadFileOutputGroupMetadatumEdgeArgs =
  {
    orderBy?: InputMaybe<Array<FileOutputGroupMetadataOrderBy>>;
  };

/** The output of our create `File` mutation. */
export type CreateFilePayload = {
  __typename: "CreateFilePayload";
  /** Reads a single `ApplicationUser` that is related to this `File`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `File` that was created by this mutation. */
  file: Maybe<File>;
  /** Reads a single `File` that is related to this `File`. */
  fileBySeriesParentId: Maybe<File>;
  /** An edge for our `File`. May be used by Relay 1. */
  fileEdge: Maybe<FilesEdge>;
  /** Reads a single `Project` that is related to this `File`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `File`. */
  taskByTaskId: Maybe<Task>;
  /** Reads a single `Tenant` that is related to this `File`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our create `File` mutation. */
export type CreateFilePayloadFileEdgeArgs = {
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};

/** All input for the create `FilesByExecutor` mutation. */
export type CreateFilesByExecutorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `FilesByExecutor` to be created by this mutation. */
  filesByExecutor: FilesByExecutorInput;
};

/** The output of our create `FilesByExecutor` mutation. */
export type CreateFilesByExecutorPayload = {
  __typename: "CreateFilesByExecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `FilesByExecutor` that was created by this mutation. */
  filesByExecutor: Maybe<FilesByExecutor>;
  /** An edge for our `FilesByExecutor`. May be used by Relay 1. */
  filesByExecutorEdge: Maybe<FilesByExecutorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `FilesByExecutor` mutation. */
export type CreateFilesByExecutorPayloadFilesByExecutorEdgeArgs = {
  orderBy?: InputMaybe<Array<FilesByExecutorsOrderBy>>;
};

/** All input for the create `MetadataValue` mutation. */
export type CreateMetadataValueInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `MetadataValue` to be created by this mutation. */
  metadataValue: MetadataValueInput;
};

/** The output of our create `MetadataValue` mutation. */
export type CreateMetadataValuePayload = {
  __typename: "CreateMetadataValuePayload";
  /** Reads a single `ApplicationUser` that is related to this `MetadataValue`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `MetadataValue` that was created by this mutation. */
  metadataValue: Maybe<MetadataValue>;
  /** An edge for our `MetadataValue`. May be used by Relay 1. */
  metadataValueEdge: Maybe<MetadataValuesEdge>;
  /** Reads a single `Metadatum` that is related to this `MetadataValue`. */
  metadatumByMetadataId: Maybe<Metadatum>;
  /** Reads a single `Project` that is related to this `MetadataValue`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `MetadataValue`. */
  taskByTaskId: Maybe<Task>;
  /** Reads a single `Tenant` that is related to this `MetadataValue`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our create `MetadataValue` mutation. */
export type CreateMetadataValuePayloadMetadataValueEdgeArgs = {
  orderBy?: InputMaybe<Array<MetadataValuesOrderBy>>;
};

/** All input for the create `Metadatum` mutation. */
export type CreateMetadatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `Metadatum` to be created by this mutation. */
  metadatum: MetadatumInput;
};

/** The output of our create `Metadatum` mutation. */
export type CreateMetadatumPayload = {
  __typename: "CreateMetadatumPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `Metadatum` that was created by this mutation. */
  metadatum: Maybe<Metadatum>;
  /** An edge for our `Metadatum`. May be used by Relay 1. */
  metadatumEdge: Maybe<MetadataEdge>;
  /** Reads a single `Project` that is related to this `Metadatum`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Metadatum`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our create `Metadatum` mutation. */
export type CreateMetadatumPayloadMetadatumEdgeArgs = {
  orderBy?: InputMaybe<Array<MetadataOrderBy>>;
};

/** All input for the create `OutputGroupFile` mutation. */
export type CreateOutputGroupFileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `OutputGroupFile` to be created by this mutation. */
  outputGroupFile: OutputGroupFileInput;
};

/** The output of our create `OutputGroupFile` mutation. */
export type CreateOutputGroupFilePayload = {
  __typename: "CreateOutputGroupFilePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `File` that is related to this `OutputGroupFile`. */
  fileByFileId: Maybe<File>;
  /** Reads a single `FileOutputGroup` that is related to this `OutputGroupFile`. */
  fileOutputGroupByFileOutputGroupId: Maybe<FileOutputGroup>;
  /** The `OutputGroupFile` that was created by this mutation. */
  outputGroupFile: Maybe<OutputGroupFile>;
  /** An edge for our `OutputGroupFile`. May be used by Relay 1. */
  outputGroupFileEdge: Maybe<OutputGroupFilesEdge>;
  /** Reads a single `Project` that is related to this `OutputGroupFile`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `OutputGroupFile` mutation. */
export type CreateOutputGroupFilePayloadOutputGroupFileEdgeArgs = {
  orderBy?: InputMaybe<Array<OutputGroupFilesOrderBy>>;
};

/** All input for the create `PinnedTool` mutation. */
export type CreatePinnedToolInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `PinnedTool` to be created by this mutation. */
  pinnedTool: PinnedToolInput;
};

/** The output of our create `PinnedTool` mutation. */
export type CreatePinnedToolPayload = {
  __typename: "CreatePinnedToolPayload";
  /** Reads a single `ApplicationUser` that is related to this `PinnedTool`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `PinnedTool` that was created by this mutation. */
  pinnedTool: Maybe<PinnedTool>;
  /** An edge for our `PinnedTool`. May be used by Relay 1. */
  pinnedToolEdge: Maybe<PinnedToolsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tool` that is related to this `PinnedTool`. */
  toolByToolId: Maybe<Tool>;
};

/** The output of our create `PinnedTool` mutation. */
export type CreatePinnedToolPayloadPinnedToolEdgeArgs = {
  orderBy?: InputMaybe<Array<PinnedToolsOrderBy>>;
};

/** All input for the create `ProjectFolder` mutation. */
export type CreateProjectFolderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `ProjectFolder` to be created by this mutation. */
  projectFolder: ProjectFolderInput;
};

/** The output of our create `ProjectFolder` mutation. */
export type CreateProjectFolderPayload = {
  __typename: "CreateProjectFolderPayload";
  /** Reads a single `ApplicationUser` that is related to this `ProjectFolder`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Project` that is related to this `ProjectFolder`. */
  projectByProjectId: Maybe<Project>;
  /** The `ProjectFolder` that was created by this mutation. */
  projectFolder: Maybe<ProjectFolder>;
  /** An edge for our `ProjectFolder`. May be used by Relay 1. */
  projectFolderEdge: Maybe<ProjectFoldersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `ProjectFolder` mutation. */
export type CreateProjectFolderPayloadProjectFolderEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectFoldersOrderBy>>;
};

/** All input for the create `ProjectTag` mutation. */
export type CreateProjectTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `ProjectTag` to be created by this mutation. */
  projectTag: ProjectTagInput;
};

/** The output of our create `ProjectTag` mutation. */
export type CreateProjectTagPayload = {
  __typename: "CreateProjectTagPayload";
  /** Reads a single `ApplicationUser` that is related to this `ProjectTag`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Project` that is related to this `ProjectTag`. */
  projectByProjectId: Maybe<Project>;
  /** The `ProjectTag` that was created by this mutation. */
  projectTag: Maybe<ProjectTag>;
  /** An edge for our `ProjectTag`. May be used by Relay 1. */
  projectTagEdge: Maybe<ProjectTagsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our create `ProjectTag` mutation. */
export type CreateProjectTagPayloadProjectTagEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTagsOrderBy>>;
};

/** All input for the `createRole` mutation. */
export type CreateRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  inpt?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our `createRole` mutation. */
export type CreateRolePayload = {
  __typename: "CreateRolePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** All input for the create `Run` mutation. */
export type CreateRunInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `Run` to be created by this mutation. */
  run: RunInput;
};

/** The output of our create `Run` mutation. */
export type CreateRunPayload = {
  __typename: "CreateRunPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Run` that was created by this mutation. */
  run: Maybe<Run>;
  /** An edge for our `Run`. May be used by Relay 1. */
  runEdge: Maybe<RunsEdge>;
  /** Reads a single `Tenant` that is related to this `Run`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our create `Run` mutation. */
export type CreateRunPayloadRunEdgeArgs = {
  orderBy?: InputMaybe<Array<RunsOrderBy>>;
};

/** All input for the `createSession` mutation. */
export type CreateSessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  tenant?: InputMaybe<Scalars["Int"]["input"]>;
  userid?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The output of our `createSession` mutation. */
export type CreateSessionPayload = {
  __typename: "CreateSessionPayload";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserSession`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  applicationUserSession: Maybe<ApplicationUserSession>;
  /** An edge for our `ApplicationUserSession`. May be used by Relay 1. */
  applicationUserSessionEdge: Maybe<ApplicationUserSessionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ApplicationUserSession`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our `createSession` mutation. */
export type CreateSessionPayloadApplicationUserSessionEdgeArgs = {
  orderBy?: InputMaybe<Array<ApplicationUserSessionsOrderBy>>;
};

/** All input for the create `TaskActivity` mutation. */
export type CreateTaskActivityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `TaskActivity` to be created by this mutation. */
  taskActivity: TaskActivityInput;
};

/** The output of our create `TaskActivity` mutation. */
export type CreateTaskActivityPayload = {
  __typename: "CreateTaskActivityPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Cost` that is related to this `TaskActivity`. */
  costByCostId: Maybe<Cost>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TaskActivity` that was created by this mutation. */
  taskActivity: Maybe<TaskActivity>;
  /** An edge for our `TaskActivity`. May be used by Relay 1. */
  taskActivityEdge: Maybe<TaskActivitiesEdge>;
  /** Reads a single `Task` that is related to this `TaskActivity`. */
  taskByTaskId: Maybe<Task>;
};

/** The output of our create `TaskActivity` mutation. */
export type CreateTaskActivityPayloadTaskActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskActivitiesOrderBy>>;
};

/** All input for the create `Task` mutation. */
export type CreateTaskInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `Task` to be created by this mutation. */
  task: TaskInput;
};

/** The output of our create `Task` mutation. */
export type CreateTaskPayload = {
  __typename: "CreateTaskPayload";
  /** Reads a single `ApplicationUser` that is related to this `Task`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `ContainerImage` that is related to this `Task`. */
  containerImageByContainerImageId: Maybe<ContainerImage>;
  /** Reads a single `Project` that is related to this `Task`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Task` that was created by this mutation. */
  task: Maybe<Task>;
  /** An edge for our `Task`. May be used by Relay 1. */
  taskEdge: Maybe<TasksEdge>;
  /** Reads a single `Tenant` that is related to this `Task`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `TesTaskexecutor` that is related to this `Task`. */
  tesTaskexecutorByExecutorId: Maybe<TesTaskexecutor>;
  /** Reads a single `ToolVersion` that is related to this `Task`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our create `Task` mutation. */
export type CreateTaskPayloadTaskEdgeArgs = {
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

/** All input for the create `TaskResource` mutation. */
export type CreateTaskResourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `TaskResource` to be created by this mutation. */
  taskResource: TaskResourceInput;
};

/** The output of our create `TaskResource` mutation. */
export type CreateTaskResourcePayload = {
  __typename: "CreateTaskResourcePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `TaskResource`. */
  taskByTaskId: Maybe<Task>;
  /** The `TaskResource` that was created by this mutation. */
  taskResource: Maybe<TaskResource>;
  /** An edge for our `TaskResource`. May be used by Relay 1. */
  taskResourceEdge: Maybe<TaskResourcesEdge>;
};

/** The output of our create `TaskResource` mutation. */
export type CreateTaskResourcePayloadTaskResourceEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskResourcesOrderBy>>;
};

/** All input for the create `TaskResourceUsage` mutation. */
export type CreateTaskResourceUsageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `TaskResourceUsage` to be created by this mutation. */
  taskResourceUsage: TaskResourceUsageInput;
};

/** The output of our create `TaskResourceUsage` mutation. */
export type CreateTaskResourceUsagePayload = {
  __typename: "CreateTaskResourceUsagePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `TaskResourceUsage`. */
  taskByTaskId: Maybe<Task>;
  /** The `TaskResourceUsage` that was created by this mutation. */
  taskResourceUsage: Maybe<TaskResourceUsage>;
  /** An edge for our `TaskResourceUsage`. May be used by Relay 1. */
  taskResourceUsageEdge: Maybe<TaskResourceUsagesEdge>;
};

/** The output of our create `TaskResourceUsage` mutation. */
export type CreateTaskResourceUsagePayloadTaskResourceUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskResourceUsagesOrderBy>>;
};

/** All input for the create `TaskSource` mutation. */
export type CreateTaskSourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `TaskSource` to be created by this mutation. */
  taskSource: TaskSourceInput;
};

/** The output of our create `TaskSource` mutation. */
export type CreateTaskSourcePayload = {
  __typename: "CreateTaskSourcePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `File` that is related to this `TaskSource`. */
  fileByFileId: Maybe<File>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `TaskSource`. */
  taskByTaskId: Maybe<Task>;
  /** The `TaskSource` that was created by this mutation. */
  taskSource: Maybe<TaskSource>;
  /** An edge for our `TaskSource`. May be used by Relay 1. */
  taskSourceEdge: Maybe<TaskSourcesEdge>;
  /** Reads a single `ToolSource` that is related to this `TaskSource`. */
  toolSourceByToolSourceId: Maybe<ToolSource>;
};

/** The output of our create `TaskSource` mutation. */
export type CreateTaskSourcePayloadTaskSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskSourcesOrderBy>>;
};

/** All input for the create `TaskStatusLog` mutation. */
export type CreateTaskStatusLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `TaskStatusLog` to be created by this mutation. */
  taskStatusLog: TaskStatusLogInput;
};

/** The output of our create `TaskStatusLog` mutation. */
export type CreateTaskStatusLogPayload = {
  __typename: "CreateTaskStatusLogPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `TaskStatusLog`. */
  taskByTaskId: Maybe<Task>;
  /** The `TaskStatusLog` that was created by this mutation. */
  taskStatusLog: Maybe<TaskStatusLog>;
  /** An edge for our `TaskStatusLog`. May be used by Relay 1. */
  taskStatusLogEdge: Maybe<TaskStatusLogsEdge>;
};

/** The output of our create `TaskStatusLog` mutation. */
export type CreateTaskStatusLogPayloadTaskStatusLogEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskStatusLogsOrderBy>>;
};

/** All input for the create `TenantContractAllowance` mutation. */
export type CreateTenantContractAllowanceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `TenantContractAllowance` to be created by this mutation. */
  tenantContractAllowance: TenantContractAllowanceInput;
};

/** The output of our create `TenantContractAllowance` mutation. */
export type CreateTenantContractAllowancePayload = {
  __typename: "CreateTenantContractAllowancePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TenantContractAllowance` that was created by this mutation. */
  tenantContractAllowance: Maybe<TenantContractAllowance>;
  /** An edge for our `TenantContractAllowance`. May be used by Relay 1. */
  tenantContractAllowanceEdge: Maybe<TenantContractAllowancesEdge>;
  /** Reads a single `TenantContractTransaction` that is related to this `TenantContractAllowance`. */
  tenantContractTransactionByTenantContractTransactionId: Maybe<TenantContractTransaction>;
};

/** The output of our create `TenantContractAllowance` mutation. */
export type CreateTenantContractAllowancePayloadTenantContractAllowanceEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TenantContractAllowancesOrderBy>>;
  };

/** All input for the create `TenantContract` mutation. */
export type CreateTenantContractInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `TenantContract` to be created by this mutation. */
  tenantContract: TenantContractInput;
};

/** The output of our create `TenantContract` mutation. */
export type CreateTenantContractPayload = {
  __typename: "CreateTenantContractPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `TenantContract`. */
  tenantByTenantId: Maybe<Tenant>;
  /** The `TenantContract` that was created by this mutation. */
  tenantContract: Maybe<TenantContract>;
  /** An edge for our `TenantContract`. May be used by Relay 1. */
  tenantContractEdge: Maybe<TenantContractsEdge>;
};

/** The output of our create `TenantContract` mutation. */
export type CreateTenantContractPayloadTenantContractEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantContractsOrderBy>>;
};

/** All input for the create `TenantContractTransaction` mutation. */
export type CreateTenantContractTransactionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `TenantContractTransaction` to be created by this mutation. */
  tenantContractTransaction: TenantContractTransactionInput;
};

/** The output of our create `TenantContractTransaction` mutation. */
export type CreateTenantContractTransactionPayload = {
  __typename: "CreateTenantContractTransactionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TenantContract` that is related to this `TenantContractTransaction`. */
  tenantContractByTenantContractId: Maybe<TenantContract>;
  /** The `TenantContractTransaction` that was created by this mutation. */
  tenantContractTransaction: Maybe<TenantContractTransaction>;
  /** An edge for our `TenantContractTransaction`. May be used by Relay 1. */
  tenantContractTransactionEdge: Maybe<TenantContractTransactionsEdge>;
};

/** The output of our create `TenantContractTransaction` mutation. */
export type CreateTenantContractTransactionPayloadTenantContractTransactionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TenantContractTransactionsOrderBy>>;
  };

/** All input for the create `Tenant` mutation. */
export type CreateTenantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `Tenant` to be created by this mutation. */
  tenant: TenantInput;
};

/** All input for the create `TenantMockuserexecutor` mutation. */
export type CreateTenantMockuserexecutorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `TenantMockuserexecutor` to be created by this mutation. */
  tenantMockuserexecutor: TenantMockuserexecutorInput;
};

/** The output of our create `TenantMockuserexecutor` mutation. */
export type CreateTenantMockuserexecutorPayload = {
  __typename: "CreateTenantMockuserexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TenantMockuserexecutor` that was created by this mutation. */
  tenantMockuserexecutor: Maybe<TenantMockuserexecutor>;
  /** An edge for our `TenantMockuserexecutor`. May be used by Relay 1. */
  tenantMockuserexecutorEdge: Maybe<TenantMockuserexecutorsEdge>;
  /** Reads a single `TenantUserexecutor` that is related to this `TenantMockuserexecutor`. */
  tenantUserexecutorByUserexecutorPtrId: Maybe<TenantUserexecutor>;
};

/** The output of our create `TenantMockuserexecutor` mutation. */
export type CreateTenantMockuserexecutorPayloadTenantMockuserexecutorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TenantMockuserexecutorsOrderBy>>;
  };

/** All input for the create `TenantMonthlyConsumedResource` mutation. */
export type CreateTenantMonthlyConsumedResourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `TenantMonthlyConsumedResource` to be created by this mutation. */
  tenantMonthlyConsumedResource: TenantMonthlyConsumedResourceInput;
};

/** The output of our create `TenantMonthlyConsumedResource` mutation. */
export type CreateTenantMonthlyConsumedResourcePayload = {
  __typename: "CreateTenantMonthlyConsumedResourcePayload";
  /** Reads a single `ApplicationUser` that is related to this `TenantMonthlyConsumedResource`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `TenantMonthlyConsumedResource`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `TenantContract` that is related to this `TenantMonthlyConsumedResource`. */
  tenantContractByTenantContractId: Maybe<TenantContract>;
  /** The `TenantMonthlyConsumedResource` that was created by this mutation. */
  tenantMonthlyConsumedResource: Maybe<TenantMonthlyConsumedResource>;
  /** An edge for our `TenantMonthlyConsumedResource`. May be used by Relay 1. */
  tenantMonthlyConsumedResourceEdge: Maybe<TenantMonthlyConsumedResourcesEdge>;
};

/** The output of our create `TenantMonthlyConsumedResource` mutation. */
export type CreateTenantMonthlyConsumedResourcePayloadTenantMonthlyConsumedResourceEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TenantMonthlyConsumedResourcesOrderBy>>;
  };

/** The output of our create `Tenant` mutation. */
export type CreateTenantPayload = {
  __typename: "CreateTenantPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Tenant` that was created by this mutation. */
  tenant: Maybe<Tenant>;
  /** An edge for our `Tenant`. May be used by Relay 1. */
  tenantEdge: Maybe<TenantsEdge>;
};

/** The output of our create `Tenant` mutation. */
export type CreateTenantPayloadTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
};

/** All input for the create `TenantUserexecutor` mutation. */
export type CreateTenantUserexecutorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `TenantUserexecutor` to be created by this mutation. */
  tenantUserexecutor: TenantUserexecutorInput;
};

/** The output of our create `TenantUserexecutor` mutation. */
export type CreateTenantUserexecutorPayload = {
  __typename: "CreateTenantUserexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `TenantUserexecutor`. */
  djangoContentTypeByPolymorphicCtypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TenantUserexecutor` that was created by this mutation. */
  tenantUserexecutor: Maybe<TenantUserexecutor>;
  /** An edge for our `TenantUserexecutor`. May be used by Relay 1. */
  tenantUserexecutorEdge: Maybe<TenantUserexecutorsEdge>;
};

/** The output of our create `TenantUserexecutor` mutation. */
export type CreateTenantUserexecutorPayloadTenantUserexecutorEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantUserexecutorsOrderBy>>;
};

/** All input for the create `TesContainerimageexecutor` mutation. */
export type CreateTesContainerimageexecutorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `TesContainerimageexecutor` to be created by this mutation. */
  tesContainerimageexecutor: TesContainerimageexecutorInput;
};

/** The output of our create `TesContainerimageexecutor` mutation. */
export type CreateTesContainerimageexecutorPayload = {
  __typename: "CreateTesContainerimageexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `TesContainerimageexecutor`. */
  djangoContentTypeByPolymorphicCtypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TesContainerimageexecutor` that was created by this mutation. */
  tesContainerimageexecutor: Maybe<TesContainerimageexecutor>;
  /** An edge for our `TesContainerimageexecutor`. May be used by Relay 1. */
  tesContainerimageexecutorEdge: Maybe<TesContainerimageexecutorsEdge>;
};

/** The output of our create `TesContainerimageexecutor` mutation. */
export type CreateTesContainerimageexecutorPayloadTesContainerimageexecutorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TesContainerimageexecutorsOrderBy>>;
  };

/** All input for the create `TesMockcontainerimageexecutor` mutation. */
export type CreateTesMockcontainerimageexecutorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `TesMockcontainerimageexecutor` to be created by this mutation. */
  tesMockcontainerimageexecutor: TesMockcontainerimageexecutorInput;
};

/** The output of our create `TesMockcontainerimageexecutor` mutation. */
export type CreateTesMockcontainerimageexecutorPayload = {
  __typename: "CreateTesMockcontainerimageexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TesContainerimageexecutor` that is related to this `TesMockcontainerimageexecutor`. */
  tesContainerimageexecutorByContainerimageexecutorPtrId: Maybe<TesContainerimageexecutor>;
  /** The `TesMockcontainerimageexecutor` that was created by this mutation. */
  tesMockcontainerimageexecutor: Maybe<TesMockcontainerimageexecutor>;
  /** An edge for our `TesMockcontainerimageexecutor`. May be used by Relay 1. */
  tesMockcontainerimageexecutorEdge: Maybe<TesMockcontainerimageexecutorsEdge>;
};

/** The output of our create `TesMockcontainerimageexecutor` mutation. */
export type CreateTesMockcontainerimageexecutorPayloadTesMockcontainerimageexecutorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TesMockcontainerimageexecutorsOrderBy>>;
  };

/** All input for the create `TesMocktaskexecutor` mutation. */
export type CreateTesMocktaskexecutorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `TesMocktaskexecutor` to be created by this mutation. */
  tesMocktaskexecutor: TesMocktaskexecutorInput;
};

/** The output of our create `TesMocktaskexecutor` mutation. */
export type CreateTesMocktaskexecutorPayload = {
  __typename: "CreateTesMocktaskexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TesMocktaskexecutor` that was created by this mutation. */
  tesMocktaskexecutor: Maybe<TesMocktaskexecutor>;
  /** An edge for our `TesMocktaskexecutor`. May be used by Relay 1. */
  tesMocktaskexecutorEdge: Maybe<TesMocktaskexecutorsEdge>;
  /** Reads a single `TesTaskexecutor` that is related to this `TesMocktaskexecutor`. */
  tesTaskexecutorByTaskexecutorPtrId: Maybe<TesTaskexecutor>;
};

/** The output of our create `TesMocktaskexecutor` mutation. */
export type CreateTesMocktaskexecutorPayloadTesMocktaskexecutorEdgeArgs = {
  orderBy?: InputMaybe<Array<TesMocktaskexecutorsOrderBy>>;
};

/** All input for the create `TesTaskexecutor` mutation. */
export type CreateTesTaskexecutorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `TesTaskexecutor` to be created by this mutation. */
  tesTaskexecutor: TesTaskexecutorInput;
};

/** The output of our create `TesTaskexecutor` mutation. */
export type CreateTesTaskexecutorPayload = {
  __typename: "CreateTesTaskexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `TesTaskexecutor`. */
  djangoContentTypeByPolymorphicCtypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TesTaskexecutor` that was created by this mutation. */
  tesTaskexecutor: Maybe<TesTaskexecutor>;
  /** An edge for our `TesTaskexecutor`. May be used by Relay 1. */
  tesTaskexecutorEdge: Maybe<TesTaskexecutorsEdge>;
};

/** The output of our create `TesTaskexecutor` mutation. */
export type CreateTesTaskexecutorPayloadTesTaskexecutorEdgeArgs = {
  orderBy?: InputMaybe<Array<TesTaskexecutorsOrderBy>>;
};

/** All input for the create `Tool` mutation. */
export type CreateToolInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `Tool` to be created by this mutation. */
  tool: ToolInput;
};

/** All input for the create `ToolParameter` mutation. */
export type CreateToolParameterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `ToolParameter` to be created by this mutation. */
  toolParameter: ToolParameterInput;
};

/** The output of our create `ToolParameter` mutation. */
export type CreateToolParameterPayload = {
  __typename: "CreateToolParameterPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ToolParameter` that was created by this mutation. */
  toolParameter: Maybe<ToolParameter>;
  /** An edge for our `ToolParameter`. May be used by Relay 1. */
  toolParameterEdge: Maybe<ToolParametersEdge>;
  /** Reads a single `ToolVersion` that is related to this `ToolParameter`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our create `ToolParameter` mutation. */
export type CreateToolParameterPayloadToolParameterEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolParametersOrderBy>>;
};

/** The output of our create `Tool` mutation. */
export type CreateToolPayload = {
  __typename: "CreateToolPayload";
  /** Reads a single `ApplicationUser` that is related to this `Tool`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Project` that is related to this `Tool`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Tool`. */
  tenantByTenantId: Maybe<Tenant>;
  /** The `Tool` that was created by this mutation. */
  tool: Maybe<Tool>;
  /** An edge for our `Tool`. May be used by Relay 1. */
  toolEdge: Maybe<ToolsEdge>;
  /** Reads a single `Toolbox` that is related to this `Tool`. */
  toolboxByToolboxId: Maybe<Toolbox>;
};

/** The output of our create `Tool` mutation. */
export type CreateToolPayloadToolEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolsOrderBy>>;
};

/** All input for the create `ToolResource` mutation. */
export type CreateToolResourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `ToolResource` to be created by this mutation. */
  toolResource: ToolResourceInput;
};

/** The output of our create `ToolResource` mutation. */
export type CreateToolResourcePayload = {
  __typename: "CreateToolResourcePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ToolResource` that was created by this mutation. */
  toolResource: Maybe<ToolResource>;
  /** An edge for our `ToolResource`. May be used by Relay 1. */
  toolResourceEdge: Maybe<ToolResourcesEdge>;
  /** Reads a single `ToolVersion` that is related to this `ToolResource`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our create `ToolResource` mutation. */
export type CreateToolResourcePayloadToolResourceEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolResourcesOrderBy>>;
};

/** All input for the create `ToolResult` mutation. */
export type CreateToolResultInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `ToolResult` to be created by this mutation. */
  toolResult: ToolResultInput;
};

/** The output of our create `ToolResult` mutation. */
export type CreateToolResultPayload = {
  __typename: "CreateToolResultPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ToolResult` that was created by this mutation. */
  toolResult: Maybe<ToolResult>;
  /** An edge for our `ToolResult`. May be used by Relay 1. */
  toolResultEdge: Maybe<ToolResultsEdge>;
  /** Reads a single `ToolVersion` that is related to this `ToolResult`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our create `ToolResult` mutation. */
export type CreateToolResultPayloadToolResultEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolResultsOrderBy>>;
};

/** All input for the create `ToolSecret` mutation. */
export type CreateToolSecretInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `ToolSecret` to be created by this mutation. */
  toolSecret: ToolSecretInput;
};

/** The output of our create `ToolSecret` mutation. */
export type CreateToolSecretPayload = {
  __typename: "CreateToolSecretPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ToolSecret` that was created by this mutation. */
  toolSecret: Maybe<ToolSecret>;
  /** An edge for our `ToolSecret`. May be used by Relay 1. */
  toolSecretEdge: Maybe<ToolSecretsEdge>;
  /** Reads a single `ToolVersion` that is related to this `ToolSecret`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our create `ToolSecret` mutation. */
export type CreateToolSecretPayloadToolSecretEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolSecretsOrderBy>>;
};

/** All input for the create `ToolSource` mutation. */
export type CreateToolSourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `ToolSource` to be created by this mutation. */
  toolSource: ToolSourceInput;
};

/** The output of our create `ToolSource` mutation. */
export type CreateToolSourcePayload = {
  __typename: "CreateToolSourcePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ToolSource` that was created by this mutation. */
  toolSource: Maybe<ToolSource>;
  /** An edge for our `ToolSource`. May be used by Relay 1. */
  toolSourceEdge: Maybe<ToolSourcesEdge>;
  /** Reads a single `ToolVersion` that is related to this `ToolSource`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our create `ToolSource` mutation. */
export type CreateToolSourcePayloadToolSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolSourcesOrderBy>>;
};

/** All input for the create `ToolTenant` mutation. */
export type CreateToolTenantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `ToolTenant` to be created by this mutation. */
  toolTenant: ToolTenantInput;
};

/** The output of our create `ToolTenant` mutation. */
export type CreateToolTenantPayload = {
  __typename: "CreateToolTenantPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ToolTenant`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `Tool` that is related to this `ToolTenant`. */
  toolByToolId: Maybe<Tool>;
  /** The `ToolTenant` that was created by this mutation. */
  toolTenant: Maybe<ToolTenant>;
  /** An edge for our `ToolTenant`. May be used by Relay 1. */
  toolTenantEdge: Maybe<ToolTenantsEdge>;
};

/** The output of our create `ToolTenant` mutation. */
export type CreateToolTenantPayloadToolTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolTenantsOrderBy>>;
};

/** All input for the create `ToolVersion` mutation. */
export type CreateToolVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `ToolVersion` to be created by this mutation. */
  toolVersion: ToolVersionInput;
};

/** The output of our create `ToolVersion` mutation. */
export type CreateToolVersionPayload = {
  __typename: "CreateToolVersionPayload";
  /** Reads a single `ApplicationUser` that is related to this `ToolVersion`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `ContainerImage` that is related to this `ToolVersion`. */
  containerImageByContainerImageId: Maybe<ContainerImage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ToolVersion`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `Tool` that is related to this `ToolVersion`. */
  toolByToolId: Maybe<Tool>;
  /** The `ToolVersion` that was created by this mutation. */
  toolVersion: Maybe<ToolVersion>;
  /** An edge for our `ToolVersion`. May be used by Relay 1. */
  toolVersionEdge: Maybe<ToolVersionsEdge>;
};

/** The output of our create `ToolVersion` mutation. */
export type CreateToolVersionPayloadToolVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolVersionsOrderBy>>;
};

/** All input for the create `Toolbox` mutation. */
export type CreateToolboxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `Toolbox` to be created by this mutation. */
  toolbox: ToolboxInput;
};

/** The output of our create `Toolbox` mutation. */
export type CreateToolboxPayload = {
  __typename: "CreateToolboxPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Toolbox` that was created by this mutation. */
  toolbox: Maybe<Toolbox>;
  /** An edge for our `Toolbox`. May be used by Relay 1. */
  toolboxEdge: Maybe<ToolboxesEdge>;
};

/** The output of our create `Toolbox` mutation. */
export type CreateToolboxPayloadToolboxEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolboxesOrderBy>>;
};

/** All input for the create `ToolboxTenant` mutation. */
export type CreateToolboxTenantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `ToolboxTenant` to be created by this mutation. */
  toolboxTenant: ToolboxTenantInput;
};

/** The output of our create `ToolboxTenant` mutation. */
export type CreateToolboxTenantPayload = {
  __typename: "CreateToolboxTenantPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ToolboxTenant`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `Toolbox` that is related to this `ToolboxTenant`. */
  toolboxByToolboxId: Maybe<Toolbox>;
  /** The `ToolboxTenant` that was created by this mutation. */
  toolboxTenant: Maybe<ToolboxTenant>;
  /** An edge for our `ToolboxTenant`. May be used by Relay 1. */
  toolboxTenantEdge: Maybe<ToolboxTenantsEdge>;
};

/** The output of our create `ToolboxTenant` mutation. */
export type CreateToolboxTenantPayloadToolboxTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolboxTenantsOrderBy>>;
};

/** All input for the create `UserPersonalSpaceRequest` mutation. */
export type CreateUserPersonalSpaceRequestInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `UserPersonalSpaceRequest` to be created by this mutation. */
  userPersonalSpaceRequest: UserPersonalSpaceRequestInput;
};

/** The output of our create `UserPersonalSpaceRequest` mutation. */
export type CreateUserPersonalSpaceRequestPayload = {
  __typename: "CreateUserPersonalSpaceRequestPayload";
  /** Reads a single `ApplicationUser` that is related to this `UserPersonalSpaceRequest`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `UserPersonalSpaceRequest` that was created by this mutation. */
  userPersonalSpaceRequest: Maybe<UserPersonalSpaceRequest>;
  /** An edge for our `UserPersonalSpaceRequest`. May be used by Relay 1. */
  userPersonalSpaceRequestEdge: Maybe<UserPersonalSpaceRequestsEdge>;
};

/** The output of our create `UserPersonalSpaceRequest` mutation. */
export type CreateUserPersonalSpaceRequestPayloadUserPersonalSpaceRequestEdgeArgs =
  {
    orderBy?: InputMaybe<Array<UserPersonalSpaceRequestsOrderBy>>;
  };

/** All input for the create `WaffleFlag` mutation. */
export type CreateWaffleFlagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `WaffleFlag` to be created by this mutation. */
  waffleFlag: WaffleFlagInput;
};

/** The output of our create `WaffleFlag` mutation. */
export type CreateWaffleFlagPayload = {
  __typename: "CreateWaffleFlagPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WaffleFlag` that was created by this mutation. */
  waffleFlag: Maybe<WaffleFlag>;
  /** An edge for our `WaffleFlag`. May be used by Relay 1. */
  waffleFlagEdge: Maybe<WaffleFlagsEdge>;
};

/** The output of our create `WaffleFlag` mutation. */
export type CreateWaffleFlagPayloadWaffleFlagEdgeArgs = {
  orderBy?: InputMaybe<Array<WaffleFlagsOrderBy>>;
};

/** All input for the create `WaffleSample` mutation. */
export type CreateWaffleSampleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `WaffleSample` to be created by this mutation. */
  waffleSample: WaffleSampleInput;
};

/** The output of our create `WaffleSample` mutation. */
export type CreateWaffleSamplePayload = {
  __typename: "CreateWaffleSamplePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WaffleSample` that was created by this mutation. */
  waffleSample: Maybe<WaffleSample>;
  /** An edge for our `WaffleSample`. May be used by Relay 1. */
  waffleSampleEdge: Maybe<WaffleSamplesEdge>;
};

/** The output of our create `WaffleSample` mutation. */
export type CreateWaffleSamplePayloadWaffleSampleEdgeArgs = {
  orderBy?: InputMaybe<Array<WaffleSamplesOrderBy>>;
};

/** All input for the create `WaffleSwitch` mutation. */
export type CreateWaffleSwitchInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `WaffleSwitch` to be created by this mutation. */
  waffleSwitch: WaffleSwitchInput;
};

/** The output of our create `WaffleSwitch` mutation. */
export type CreateWaffleSwitchPayload = {
  __typename: "CreateWaffleSwitchPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WaffleSwitch` that was created by this mutation. */
  waffleSwitch: Maybe<WaffleSwitch>;
  /** An edge for our `WaffleSwitch`. May be used by Relay 1. */
  waffleSwitchEdge: Maybe<WaffleSwitchesEdge>;
};

/** The output of our create `WaffleSwitch` mutation. */
export type CreateWaffleSwitchPayloadWaffleSwitchEdgeArgs = {
  orderBy?: InputMaybe<Array<WaffleSwitchesOrderBy>>;
};

/** All input for the create `WorkflowDatum` mutation. */
export type CreateWorkflowDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `WorkflowDatum` to be created by this mutation. */
  workflowDatum: WorkflowDatumInput;
};

/** The output of our create `WorkflowDatum` mutation. */
export type CreateWorkflowDatumPayload = {
  __typename: "CreateWorkflowDatumPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WorkflowDatum` that was created by this mutation. */
  workflowDatum: Maybe<WorkflowDatum>;
  /** An edge for our `WorkflowDatum`. May be used by Relay 1. */
  workflowDatumEdge: Maybe<WorkflowDataEdge>;
};

/** The output of our create `WorkflowDatum` mutation. */
export type CreateWorkflowDatumPayloadWorkflowDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowDataOrderBy>>;
};

/** All input for the create `Workflow` mutation. */
export type CreateWorkflowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `Workflow` to be created by this mutation. */
  workflow: WorkflowInput;
};

/** The output of our create `Workflow` mutation. */
export type CreateWorkflowPayload = {
  __typename: "CreateWorkflowPayload";
  /** Reads a single `ApplicationUser` that is related to this `Workflow`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `ContainerImage` that is related to this `Workflow`. */
  containerImageByContainerId: Maybe<ContainerImage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Workflow`. */
  tenantByTenantId: Maybe<Tenant>;
  /** The `Workflow` that was created by this mutation. */
  workflow: Maybe<Workflow>;
  /** An edge for our `Workflow`. May be used by Relay 1. */
  workflowEdge: Maybe<WorkflowsEdge>;
};

/** The output of our create `Workflow` mutation. */
export type CreateWorkflowPayloadWorkflowEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowsOrderBy>>;
};

/** All input for the create `WorkflowResult` mutation. */
export type CreateWorkflowResultInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `WorkflowResult` to be created by this mutation. */
  workflowResult: WorkflowResultInput;
};

/** The output of our create `WorkflowResult` mutation. */
export type CreateWorkflowResultPayload = {
  __typename: "CreateWorkflowResultPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WorkflowDatum` that is related to this `WorkflowResult`. */
  workflowDatumByObjectId: Maybe<WorkflowDatum>;
  /** The `WorkflowResult` that was created by this mutation. */
  workflowResult: Maybe<WorkflowResult>;
  /** An edge for our `WorkflowResult`. May be used by Relay 1. */
  workflowResultEdge: Maybe<WorkflowResultsEdge>;
};

/** The output of our create `WorkflowResult` mutation. */
export type CreateWorkflowResultPayloadWorkflowResultEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowResultsOrderBy>>;
};

/** All input for the create `WorkflowResultWorkflowVersion` mutation. */
export type CreateWorkflowResultWorkflowVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `WorkflowResultWorkflowVersion` to be created by this mutation. */
  workflowResultWorkflowVersion: WorkflowResultWorkflowVersionInput;
};

/** The output of our create `WorkflowResultWorkflowVersion` mutation. */
export type CreateWorkflowResultWorkflowVersionPayload = {
  __typename: "CreateWorkflowResultWorkflowVersionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WorkflowResult` that is related to this `WorkflowResultWorkflowVersion`. */
  workflowResultByResultId: Maybe<WorkflowResult>;
  /** The `WorkflowResultWorkflowVersion` that was created by this mutation. */
  workflowResultWorkflowVersion: Maybe<WorkflowResultWorkflowVersion>;
  /** An edge for our `WorkflowResultWorkflowVersion`. May be used by Relay 1. */
  workflowResultWorkflowVersionEdge: Maybe<WorkflowResultWorkflowVersionsEdge>;
  /** Reads a single `WorkflowVersion` that is related to this `WorkflowResultWorkflowVersion`. */
  workflowVersionByWorkflowversionId: Maybe<WorkflowVersion>;
};

/** The output of our create `WorkflowResultWorkflowVersion` mutation. */
export type CreateWorkflowResultWorkflowVersionPayloadWorkflowResultWorkflowVersionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<WorkflowResultWorkflowVersionsOrderBy>>;
  };

/** All input for the create `WorkflowSectionBlock` mutation. */
export type CreateWorkflowSectionBlockInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `WorkflowSectionBlock` to be created by this mutation. */
  workflowSectionBlock: WorkflowSectionBlockInput;
};

/** The output of our create `WorkflowSectionBlock` mutation. */
export type CreateWorkflowSectionBlockPayload = {
  __typename: "CreateWorkflowSectionBlockPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `ToolVersion` that is related to this `WorkflowSectionBlock`. */
  toolVersionByToolId: Maybe<ToolVersion>;
  /** Reads a single `WorkflowDatum` that is related to this `WorkflowSectionBlock`. */
  workflowDatumByObjectId: Maybe<WorkflowDatum>;
  /** The `WorkflowSectionBlock` that was created by this mutation. */
  workflowSectionBlock: Maybe<WorkflowSectionBlock>;
  /** An edge for our `WorkflowSectionBlock`. May be used by Relay 1. */
  workflowSectionBlockEdge: Maybe<WorkflowSectionBlocksEdge>;
};

/** The output of our create `WorkflowSectionBlock` mutation. */
export type CreateWorkflowSectionBlockPayloadWorkflowSectionBlockEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowSectionBlocksOrderBy>>;
};

/** All input for the create `WorkflowSectionBlockSection` mutation. */
export type CreateWorkflowSectionBlockSectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `WorkflowSectionBlockSection` to be created by this mutation. */
  workflowSectionBlockSection: WorkflowSectionBlockSectionInput;
};

/** The output of our create `WorkflowSectionBlockSection` mutation. */
export type CreateWorkflowSectionBlockSectionPayload = {
  __typename: "CreateWorkflowSectionBlockSectionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WorkflowSectionBlock` that is related to this `WorkflowSectionBlockSection`. */
  workflowSectionBlockByBlockId: Maybe<WorkflowSectionBlock>;
  /** The `WorkflowSectionBlockSection` that was created by this mutation. */
  workflowSectionBlockSection: Maybe<WorkflowSectionBlockSection>;
  /** An edge for our `WorkflowSectionBlockSection`. May be used by Relay 1. */
  workflowSectionBlockSectionEdge: Maybe<WorkflowSectionBlockSectionsEdge>;
  /** Reads a single `WorkflowSection` that is related to this `WorkflowSectionBlockSection`. */
  workflowSectionBySectionId: Maybe<WorkflowSection>;
};

/** The output of our create `WorkflowSectionBlockSection` mutation. */
export type CreateWorkflowSectionBlockSectionPayloadWorkflowSectionBlockSectionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<WorkflowSectionBlockSectionsOrderBy>>;
  };

/** All input for the create `WorkflowSection` mutation. */
export type CreateWorkflowSectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `WorkflowSection` to be created by this mutation. */
  workflowSection: WorkflowSectionInput;
};

/** The output of our create `WorkflowSection` mutation. */
export type CreateWorkflowSectionPayload = {
  __typename: "CreateWorkflowSectionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WorkflowSection` that was created by this mutation. */
  workflowSection: Maybe<WorkflowSection>;
  /** An edge for our `WorkflowSection`. May be used by Relay 1. */
  workflowSectionEdge: Maybe<WorkflowSectionsEdge>;
};

/** The output of our create `WorkflowSection` mutation. */
export type CreateWorkflowSectionPayloadWorkflowSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowSectionsOrderBy>>;
};

/** All input for the create `WorkflowSectionWorkflowVersion` mutation. */
export type CreateWorkflowSectionWorkflowVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `WorkflowSectionWorkflowVersion` to be created by this mutation. */
  workflowSectionWorkflowVersion: WorkflowSectionWorkflowVersionInput;
};

/** The output of our create `WorkflowSectionWorkflowVersion` mutation. */
export type CreateWorkflowSectionWorkflowVersionPayload = {
  __typename: "CreateWorkflowSectionWorkflowVersionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WorkflowSection` that is related to this `WorkflowSectionWorkflowVersion`. */
  workflowSectionBySectionId: Maybe<WorkflowSection>;
  /** The `WorkflowSectionWorkflowVersion` that was created by this mutation. */
  workflowSectionWorkflowVersion: Maybe<WorkflowSectionWorkflowVersion>;
  /** An edge for our `WorkflowSectionWorkflowVersion`. May be used by Relay 1. */
  workflowSectionWorkflowVersionEdge: Maybe<WorkflowSectionWorkflowVersionsEdge>;
  /** Reads a single `WorkflowVersion` that is related to this `WorkflowSectionWorkflowVersion`. */
  workflowVersionByWorkflowversionId: Maybe<WorkflowVersion>;
};

/** The output of our create `WorkflowSectionWorkflowVersion` mutation. */
export type CreateWorkflowSectionWorkflowVersionPayloadWorkflowSectionWorkflowVersionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<WorkflowSectionWorkflowVersionsOrderBy>>;
  };

/** All input for the create `WorkflowSource` mutation. */
export type CreateWorkflowSourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `WorkflowSource` to be created by this mutation. */
  workflowSource: WorkflowSourceInput;
};

/** The output of our create `WorkflowSource` mutation. */
export type CreateWorkflowSourcePayload = {
  __typename: "CreateWorkflowSourcePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WorkflowSource` that was created by this mutation. */
  workflowSource: Maybe<WorkflowSource>;
  /** An edge for our `WorkflowSource`. May be used by Relay 1. */
  workflowSourceEdge: Maybe<WorkflowSourcesEdge>;
};

/** The output of our create `WorkflowSource` mutation. */
export type CreateWorkflowSourcePayloadWorkflowSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowSourcesOrderBy>>;
};

/** All input for the create `WorkflowSourceWorkflowVersion` mutation. */
export type CreateWorkflowSourceWorkflowVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `WorkflowSourceWorkflowVersion` to be created by this mutation. */
  workflowSourceWorkflowVersion: WorkflowSourceWorkflowVersionInput;
};

/** The output of our create `WorkflowSourceWorkflowVersion` mutation. */
export type CreateWorkflowSourceWorkflowVersionPayload = {
  __typename: "CreateWorkflowSourceWorkflowVersionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WorkflowSource` that is related to this `WorkflowSourceWorkflowVersion`. */
  workflowSourceBySourceId: Maybe<WorkflowSource>;
  /** The `WorkflowSourceWorkflowVersion` that was created by this mutation. */
  workflowSourceWorkflowVersion: Maybe<WorkflowSourceWorkflowVersion>;
  /** An edge for our `WorkflowSourceWorkflowVersion`. May be used by Relay 1. */
  workflowSourceWorkflowVersionEdge: Maybe<WorkflowSourceWorkflowVersionsEdge>;
  /** Reads a single `WorkflowVersion` that is related to this `WorkflowSourceWorkflowVersion`. */
  workflowVersionByWorkflowversionId: Maybe<WorkflowVersion>;
};

/** The output of our create `WorkflowSourceWorkflowVersion` mutation. */
export type CreateWorkflowSourceWorkflowVersionPayloadWorkflowSourceWorkflowVersionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<WorkflowSourceWorkflowVersionsOrderBy>>;
  };

/** All input for the create `WorkflowVersion` mutation. */
export type CreateWorkflowVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The `WorkflowVersion` to be created by this mutation. */
  workflowVersion: WorkflowVersionInput;
};

/** The output of our create `WorkflowVersion` mutation. */
export type CreateWorkflowVersionPayload = {
  __typename: "CreateWorkflowVersionPayload";
  /** Reads a single `ApplicationUser` that is related to this `WorkflowVersion`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Workflow` that is related to this `WorkflowVersion`. */
  workflowByWorkflowId: Maybe<Workflow>;
  /** The `WorkflowVersion` that was created by this mutation. */
  workflowVersion: Maybe<WorkflowVersion>;
  /** An edge for our `WorkflowVersion`. May be used by Relay 1. */
  workflowVersionEdge: Maybe<WorkflowVersionsEdge>;
};

/** The output of our create `WorkflowVersion` mutation. */
export type CreateWorkflowVersionPayloadWorkflowVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowVersionsOrderBy>>;
};

export type CurrentApplicationUser = {
  __typename: "CurrentApplicationUser";
  email: Maybe<Scalars["String"]["output"]>;
  globalUserId: Maybe<Scalars["UUID"]["output"]>;
  id: Maybe<Scalars["UUID"]["output"]>;
  isActive: Maybe<Scalars["Boolean"]["output"]>;
  username: Maybe<Scalars["String"]["output"]>;
};

/**
 * A condition to be used against `CurrentApplicationUser` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CurrentApplicationUserCondition = {
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `globalUserId` field. */
  globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `username` field. */
  username?: InputMaybe<Scalars["String"]["input"]>;
};

/** A filter to be used against `CurrentApplicationUser` object types. All fields are combined with a logical ‘and.’ */
export type CurrentApplicationUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CurrentApplicationUserFilter>>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `globalUserId` field. */
  globalUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CurrentApplicationUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CurrentApplicationUserFilter>>;
  /** Filter by the object’s `username` field. */
  username?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `CurrentApplicationUser` */
export type CurrentApplicationUserInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  username?: InputMaybe<Scalars["String"]["input"]>;
};

/** A connection to a list of `CurrentApplicationUser` values. */
export type CurrentApplicationUsersConnection = {
  __typename: "CurrentApplicationUsersConnection";
  /** A list of edges which contains the `CurrentApplicationUser` and cursor to aid in pagination. */
  edges: Array<CurrentApplicationUsersEdge>;
  /** A list of `CurrentApplicationUser` objects. */
  nodes: Array<CurrentApplicationUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CurrentApplicationUser` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `CurrentApplicationUser` edge in the connection. */
export type CurrentApplicationUsersEdge = {
  __typename: "CurrentApplicationUsersEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `CurrentApplicationUser` at the end of the edge. */
  node: CurrentApplicationUser;
};

/** Methods to use when ordering `CurrentApplicationUser`. */
export enum CurrentApplicationUsersOrderBy {
  EmailAsc = "EMAIL_ASC",
  EmailDesc = "EMAIL_DESC",
  GlobalUserIdAsc = "GLOBAL_USER_ID_ASC",
  GlobalUserIdDesc = "GLOBAL_USER_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  IsActiveAsc = "IS_ACTIVE_ASC",
  IsActiveDesc = "IS_ACTIVE_DESC",
  Natural = "NATURAL",
  UsernameAsc = "USERNAME_ASC",
  UsernameDesc = "USERNAME_DESC",
}

export type CurrentUserMembership = {
  __typename: "CurrentUserMembership";
  role: Maybe<Scalars["Int"]["output"]>;
  tenantId: Maybe<Scalars["Int"]["output"]>;
  userId: Maybe<Scalars["UUID"]["output"]>;
};

/**
 * A condition to be used against `CurrentUserMembership` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CurrentUserMembershipCondition = {
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `CurrentUserMembership` object types. All fields are combined with a logical ‘and.’ */
export type CurrentUserMembershipFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CurrentUserMembershipFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<CurrentUserMembershipFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CurrentUserMembershipFilter>>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** A connection to a list of `CurrentUserMembership` values. */
export type CurrentUserMembershipsConnection = {
  __typename: "CurrentUserMembershipsConnection";
  /** A list of edges which contains the `CurrentUserMembership` and cursor to aid in pagination. */
  edges: Array<CurrentUserMembershipsEdge>;
  /** A list of `CurrentUserMembership` objects. */
  nodes: Array<CurrentUserMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CurrentUserMembership` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `CurrentUserMembership` edge in the connection. */
export type CurrentUserMembershipsEdge = {
  __typename: "CurrentUserMembershipsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `CurrentUserMembership` at the end of the edge. */
  node: CurrentUserMembership;
};

/** Methods to use when ordering `CurrentUserMembership`. */
export enum CurrentUserMembershipsOrderBy {
  Natural = "NATURAL",
  RoleAsc = "ROLE_ASC",
  RoleDesc = "ROLE_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

export type DataTable = {
  __typename: "DataTable";
  /** Reads a single `ApplicationUser` that is related to this `DataTable`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** Reads and enables pagination through a set of `DataTableCell`. */
  dataTableCellsByTableId: DataTableCellsConnection;
  /** Reads and enables pagination through a set of `DataTableColumnGroup`. */
  dataTableColumnGroupsByTableId: DataTableColumnGroupsConnection;
  /** Reads and enables pagination through a set of `DataTableColumn`. */
  dataTableColumnsByTableId: DataTableColumnsConnection;
  /** Reads and enables pagination through a set of `DataTableRow`. */
  dataTableRowsByTableId: DataTableRowsConnection;
  dateCreated: Scalars["Datetime"]["output"];
  dateDeleted: Maybe<Scalars["Datetime"]["output"]>;
  description: Scalars["String"]["output"];
  folderId: Maybe<Scalars["UUID"]["output"]>;
  hidden: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  /** Reads a single `Project` that is related to this `DataTable`. */
  projectByProjectId: Maybe<Project>;
  /** Reads a single `ProjectFolder` that is related to this `DataTable`. */
  projectFolderByFolderId: Maybe<ProjectFolder>;
  projectId: Scalars["UUID"]["output"];
  userId: Scalars["UUID"]["output"];
};

export type DataTableDataTableCellsByTableIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableCellCondition>;
  filter?: InputMaybe<DataTableCellFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableCellsOrderBy>>;
};

export type DataTableDataTableColumnGroupsByTableIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnGroupCondition>;
  filter?: InputMaybe<DataTableColumnGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnGroupsOrderBy>>;
};

export type DataTableDataTableColumnsByTableIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnCondition>;
  filter?: InputMaybe<DataTableColumnFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnsOrderBy>>;
};

export type DataTableDataTableRowsByTableIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableRowCondition>;
  filter?: InputMaybe<DataTableRowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableRowsOrderBy>>;
};

export type DataTableCell = {
  __typename: "DataTableCell";
  columnId: Scalars["UUID"]["output"];
  /** Reads a single `DataTable` that is related to this `DataTableCell`. */
  dataTableByTableId: Maybe<DataTable>;
  /** Reads a single `DataTableColumn` that is related to this `DataTableCell`. */
  dataTableColumnByColumnId: Maybe<DataTableColumn>;
  /** Reads a single `DataTableRow` that is related to this `DataTableCell`. */
  dataTableRowByRowId: Maybe<DataTableRow>;
  formula: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** Reads a single `Project` that is related to this `DataTableCell`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  rowId: Scalars["UUID"]["output"];
  tableId: Scalars["UUID"]["output"];
};

/** Input for the nested mutation of `dataTableColumn` in the `DataTableCellInput` mutation. */
export type DataTableCellColumnId9A5117BdFkDataTableColumnIdInput = {
  /** The primary key(s) for `dataTableColumn` for the far side of the relationship. */
  connectById?: InputMaybe<DataTableColumnDataTableColumnPkeyConnect>;
  /** The primary key(s) for `dataTableColumn` for the far side of the relationship. */
  connectByTableIdAndOrder?: InputMaybe<DataTableColumnDataTableColumnOrderUniqueConnect>;
  /** The primary key(s) and patch data for `dataTableColumn` for the far side of the relationship. */
  updateById?: InputMaybe<DataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableColumnPkeyUpdate>;
  /** The primary key(s) and patch data for `dataTableColumn` for the far side of the relationship. */
  updateByTableIdAndOrder?: InputMaybe<DataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableColumnOrderUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableCell` in the `DataTableColumnInput` mutation. */
export type DataTableCellColumnId9A5117BdFkDataTableColumnIdInverseInput = {
  /** The primary key(s) for `dataTableCell` for the far side of the relationship. */
  connectByColumnIdAndRowId?: InputMaybe<
    Array<DataTableCellDataTableCellUniqueConnect>
  >;
  /** The primary key(s) for `dataTableCell` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableCellDataTableCellPkeyConnect>>;
  /** The primary key(s) and patch data for `dataTableCell` for the far side of the relationship. */
  updateByColumnIdAndRowId?: InputMaybe<
    Array<DataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableCellUniqueUpdate>
  >;
  /** The primary key(s) and patch data for `dataTableCell` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableCellPkeyUpdate>
  >;
};

/**
 * A condition to be used against `DataTableCell` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DataTableCellCondition = {
  /** Checks for equality with the object’s `columnId` field. */
  columnId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `formula` field. */
  formula?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tableId` field. */
  tableId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `dataTableCell` to look up the row to connect. */
export type DataTableCellDataTableCellPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `dataTableCell` to look up the row to connect. */
export type DataTableCellDataTableCellUniqueConnect = {
  columnId: Scalars["UUID"]["input"];
  rowId: Scalars["UUID"]["input"];
};

/** A filter to be used against `DataTableCell` object types. All fields are combined with a logical ‘and.’ */
export type DataTableCellFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableCellFilter>>;
  /** Filter by the object’s `columnId` field. */
  columnId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `dataTableByTableId` relation. */
  dataTableByTableId?: InputMaybe<DataTableFilter>;
  /** Filter by the object’s `dataTableColumnByColumnId` relation. */
  dataTableColumnByColumnId?: InputMaybe<DataTableColumnFilter>;
  /** Filter by the object’s `dataTableRowByRowId` relation. */
  dataTableRowByRowId?: InputMaybe<DataTableRowFilter>;
  /** Filter by the object’s `formula` field. */
  formula?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableCellFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableCellFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tableId` field. */
  tableId?: InputMaybe<UuidFilter>;
};

/** The fields on `dataTableCell` to look up the row to update. */
export type DataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableCellPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableCell` being updated. */
    dataTableCellPatch: UpdateDataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableCell` to look up the row to update. */
export type DataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableCellUniqueUpdate =
  {
    columnId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `dataTableCell` being updated. */
    dataTableCellPatch: UpdateDataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdPatch;
    rowId: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableCell` to look up the row to update. */
export type DataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingDataTableCellPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableCell` being updated. */
    dataTableCellPatch: UpdateDataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableCell` to look up the row to update. */
export type DataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingDataTableCellUniqueUpdate =
  {
    columnId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `dataTableCell` being updated. */
    dataTableCellPatch: UpdateDataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdPatch;
    rowId: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableCell` to look up the row to update. */
export type DataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableCellPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableCell` being updated. */
    dataTableCellPatch: UpdateDataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableCell` to look up the row to update. */
export type DataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableCellUniqueUpdate =
  {
    columnId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `dataTableCell` being updated. */
    dataTableCellPatch: UpdateDataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdPatch;
    rowId: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableCell` to look up the row to update. */
export type DataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTableCellPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableCell` being updated. */
    dataTableCellPatch: UpdateDataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableCell` to look up the row to update. */
export type DataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTableCellUniqueUpdate =
  {
    columnId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `dataTableCell` being updated. */
    dataTableCellPatch: UpdateDataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdPatch;
    rowId: Scalars["UUID"]["input"];
  };

/** Input for the nested mutation of `project` in the `DataTableCellInput` mutation. */
export type DataTableCellProjectIdEf5721A0FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableCell` in the `ProjectInput` mutation. */
export type DataTableCellProjectIdEf5721A0FkProjectIdInverseInput = {
  /** The primary key(s) for `dataTableCell` for the far side of the relationship. */
  connectByColumnIdAndRowId?: InputMaybe<
    Array<DataTableCellDataTableCellUniqueConnect>
  >;
  /** The primary key(s) for `dataTableCell` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableCellDataTableCellPkeyConnect>>;
  /** The primary key(s) and patch data for `dataTableCell` for the far side of the relationship. */
  updateByColumnIdAndRowId?: InputMaybe<
    Array<DataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingDataTableCellUniqueUpdate>
  >;
  /** The primary key(s) and patch data for `dataTableCell` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingDataTableCellPkeyUpdate>
  >;
};

/** Input for the nested mutation of `dataTableRow` in the `DataTableCellInput` mutation. */
export type DataTableCellRowId3A3C7567FkDataTableRowIdInput = {
  /** The primary key(s) for `dataTableRow` for the far side of the relationship. */
  connectById?: InputMaybe<DataTableRowDataTableRowPkeyConnect>;
  /** The primary key(s) for `dataTableRow` for the far side of the relationship. */
  connectByTableIdAndIndex?: InputMaybe<DataTableRowDataTableRowUniqueConnect>;
  /** The primary key(s) and patch data for `dataTableRow` for the far side of the relationship. */
  updateById?: InputMaybe<DataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableRowPkeyUpdate>;
  /** The primary key(s) and patch data for `dataTableRow` for the far side of the relationship. */
  updateByTableIdAndIndex?: InputMaybe<DataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableRowUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableCell` in the `DataTableRowInput` mutation. */
export type DataTableCellRowId3A3C7567FkDataTableRowIdInverseInput = {
  /** The primary key(s) for `dataTableCell` for the far side of the relationship. */
  connectByColumnIdAndRowId?: InputMaybe<
    Array<DataTableCellDataTableCellUniqueConnect>
  >;
  /** The primary key(s) for `dataTableCell` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableCellDataTableCellPkeyConnect>>;
  /** The primary key(s) and patch data for `dataTableCell` for the far side of the relationship. */
  updateByColumnIdAndRowId?: InputMaybe<
    Array<DataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableCellUniqueUpdate>
  >;
  /** The primary key(s) and patch data for `dataTableCell` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableCellPkeyUpdate>
  >;
};

/** Input for the nested mutation of `dataTable` in the `DataTableCellInput` mutation. */
export type DataTableCellTableId12E87426FkDataTableIdInput = {
  /** The primary key(s) for `dataTable` for the far side of the relationship. */
  connectById?: InputMaybe<DataTableDataTablePkeyConnect>;
  /** The primary key(s) and patch data for `dataTable` for the far side of the relationship. */
  updateById?: InputMaybe<DataTableOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTablePkeyUpdate>;
};

/** Input for the nested mutation of `dataTableCell` in the `DataTableInput` mutation. */
export type DataTableCellTableId12E87426FkDataTableIdInverseInput = {
  /** The primary key(s) for `dataTableCell` for the far side of the relationship. */
  connectByColumnIdAndRowId?: InputMaybe<
    Array<DataTableCellDataTableCellUniqueConnect>
  >;
  /** The primary key(s) for `dataTableCell` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableCellDataTableCellPkeyConnect>>;
  /** The primary key(s) and patch data for `dataTableCell` for the far side of the relationship. */
  updateByColumnIdAndRowId?: InputMaybe<
    Array<DataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTableCellUniqueUpdate>
  >;
  /** The primary key(s) and patch data for `dataTableCell` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTableCellPkeyUpdate>
  >;
};

/** A connection to a list of `DataTableCell` values. */
export type DataTableCellsConnection = {
  __typename: "DataTableCellsConnection";
  /** A list of edges which contains the `DataTableCell` and cursor to aid in pagination. */
  edges: Array<DataTableCellsEdge>;
  /** A list of `DataTableCell` objects. */
  nodes: Array<DataTableCell>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableCell` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableCell` edge in the connection. */
export type DataTableCellsEdge = {
  __typename: "DataTableCellsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableCell` at the end of the edge. */
  node: DataTableCell;
};

/** Methods to use when ordering `DataTableCell`. */
export enum DataTableCellsOrderBy {
  ColumnIdAsc = "COLUMN_ID_ASC",
  ColumnIdDesc = "COLUMN_ID_DESC",
  FormulaAsc = "FORMULA_ASC",
  FormulaDesc = "FORMULA_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  RowIdAsc = "ROW_ID_ASC",
  RowIdDesc = "ROW_ID_DESC",
  TableIdAsc = "TABLE_ID_ASC",
  TableIdDesc = "TABLE_ID_DESC",
}

export type DataTableColumn = {
  __typename: "DataTableColumn";
  /** Reads a single `ApplicationUser` that is related to this `DataTableColumn`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** Reads a single `DataTable` that is related to this `DataTableColumn`. */
  dataTableByTableId: Maybe<DataTable>;
  /** Reads and enables pagination through a set of `DataTableCell`. */
  dataTableCellsByColumnId: DataTableCellsConnection;
  /** Reads a single `DataTableColumnGroup` that is related to this `DataTableColumn`. */
  dataTableColumnGroupByGroupId: Maybe<DataTableColumnGroup>;
  dateCreated: Scalars["Datetime"]["output"];
  dateDeleted: Maybe<Scalars["Datetime"]["output"]>;
  defaultFormula: Maybe<Scalars["String"]["output"]>;
  definitionId: Scalars["UUID"]["output"];
  definitionTypeId: Scalars["Int"]["output"];
  deletable: Scalars["Boolean"]["output"];
  /** Reads a single `DjangoContentType` that is related to this `DataTableColumn`. */
  djangoContentTypeByDefinitionTypeId: Maybe<DjangoContentType>;
  editable: Scalars["Boolean"]["output"];
  groupId: Maybe<Scalars["UUID"]["output"]>;
  helpText: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  identifierPosition: Maybe<Scalars["Int"]["output"]>;
  isIdColumn: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  order: Maybe<Scalars["Int"]["output"]>;
  pinned: Scalars["Boolean"]["output"];
  /** Reads a single `Project` that is related to this `DataTableColumn`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  tableId: Scalars["UUID"]["output"];
  userId: Scalars["UUID"]["output"];
  width: Scalars["Int"]["output"];
};

export type DataTableColumnDataTableCellsByColumnIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableCellCondition>;
  filter?: InputMaybe<DataTableCellFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableCellsOrderBy>>;
};

/**
 * A condition to be used against `DataTableColumn` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DataTableColumnCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `defaultFormula` field. */
  defaultFormula?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `definitionId` field. */
  definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `definitionTypeId` field. */
  definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `deletable` field. */
  deletable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `editable` field. */
  editable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `helpText` field. */
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `identifierPosition` field. */
  identifierPosition?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `isIdColumn` field. */
  isIdColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `pinned` field. */
  pinned?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tableId` field. */
  tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `width` field. */
  width?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `dataTableColumn` to look up the row to connect. */
export type DataTableColumnDataTableColumnOrderUniqueConnect = {
  order: Scalars["Int"]["input"];
  tableId: Scalars["UUID"]["input"];
};

/** The fields on `dataTableColumn` to look up the row to connect. */
export type DataTableColumnDataTableColumnPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The `djangoContentType` to be created by this mutation. */
export type DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `DataTableColumnDefinitionCellStatusInput` mutation. */
export type DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionCellStatus` in the `DjangoContentTypeInput` mutation. */
export type DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionCellStatus` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionCellStatusDataTableColumnDefinitionCellStatusPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionCellStatus` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate>
  >;
};

/** The `djangoContentType` to be created by this mutation. */
export type DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `DataTableColumnDefinitionCellStatusInput` mutation. */
export type DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionCellStatus` in the `DjangoContentTypeInput` mutation. */
export type DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionCellStatus` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionCellStatusDataTableColumnDefinitionCellStatusPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionCellStatus` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate>
  >;
};

/** The `djangoContentType` to be created by this mutation. */
export type DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `DataTableColumnDefinitionRoiFrameInput` mutation. */
export type DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionRoiFrame` in the `DjangoContentTypeInput` mutation. */
export type DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionRoiFrame` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionRoiFrameDataTableColumnDefinitionRoiFramePkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionRoiFrame` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDataTableColumnDefinitionRoiFramePkeyUpdate>
  >;
};

/** The `djangoContentType` to be created by this mutation. */
export type DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `DataTableColumnDefinitionMetadatumInput` mutation. */
export type DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionMetadatum` in the `DjangoContentTypeInput` mutation. */
export type DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionMetadatumDataTableColumnDefinitionMetadatumPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDataTableColumnDefinitionMetadatumPkeyUpdate>
  >;
};

/** The `djangoContentType` to be created by this mutation. */
export type DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `DataTableColumnDefinitionJoinInput` mutation. */
export type DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionJoin` in the `DjangoContentTypeInput` mutation. */
export type DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionJoin` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionJoinDataTableColumnDefinitionJoinPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionJoin` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate>
  >;
};

/** Input for the nested mutation of `project` in the `DataTableColumnDefinitionMetadatumInput` mutation. */
export type DataTableColumnDeProjectId3A701Ad3FkProjectIInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionMetadatum` in the `ProjectInput` mutation. */
export type DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionMetadatumDataTableColumnDefinitionMetadatumPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingDataTableColumnDefinitionMetadatumPkeyUpdate>
  >;
};

/** Input for the nested mutation of `project` in the `DataTableColumnDefinitionRoiFrameInput` mutation. */
export type DataTableColumnDeProjectId8E855Eb8FkProjectIInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionRoiFrame` in the `ProjectInput` mutation. */
export type DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionRoiFrame` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionRoiFrameDataTableColumnDefinitionRoiFramePkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionRoiFrame` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingDataTableColumnDefinitionRoiFramePkeyUpdate>
  >;
};

/** Input for the nested mutation of `project` in the `DataTableColumnDefinitionBooleanInput` mutation. */
export type DataTableColumnDeProjectId29F0D38FFkProjectIInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionBoolean` in the `ProjectInput` mutation. */
export type DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionBoolean` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionBooleanDataTableColumnDefinitionBooleanPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionBoolean` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionBooleanOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingDataTableColumnDefinitionBooleanPkeyUpdate>
  >;
};

/** Input for the nested mutation of `project` in the `DataTableColumnDefinitionFileInput` mutation. */
export type DataTableColumnDeProjectId433Daf03FkProjectIInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionFile` in the `ProjectInput` mutation. */
export type DataTableColumnDeProjectId433Daf03FkProjectIInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionFile` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionFileDataTableColumnDefinitionFilePkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionFile` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionFileOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingDataTableColumnDefinitionFilePkeyUpdate>
  >;
};

/** Input for the nested mutation of `project` in the `DataTableColumnDefinitionIntegerInput` mutation. */
export type DataTableColumnDeProjectId2487E0EbFkProjectIInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionInteger` in the `ProjectInput` mutation. */
export type DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionInteger` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionIntegerDataTableColumnDefinitionIntegerPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionInteger` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionIntegerOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingDataTableColumnDefinitionIntegerPkeyUpdate>
  >;
};

/** Input for the nested mutation of `project` in the `DataTableColumnDefinitionJoinInput` mutation. */
export type DataTableColumnDeProjectId7732E962FkProjectIInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionJoin` in the `ProjectInput` mutation. */
export type DataTableColumnDeProjectId7732E962FkProjectIInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionJoin` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionJoinDataTableColumnDefinitionJoinPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionJoin` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingDataTableColumnDefinitionJoinPkeyUpdate>
  >;
};

/** Input for the nested mutation of `project` in the `DataTableColumnDefinitionFloatInput` mutation. */
export type DataTableColumnDeProjectId869397AfFkProjectIInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionFloat` in the `ProjectInput` mutation. */
export type DataTableColumnDeProjectId869397AfFkProjectIInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionFloat` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionFloatDataTableColumnDefinitionFloatPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionFloat` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionFloatOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingDataTableColumnDefinitionFloatPkeyUpdate>
  >;
};

/** Input for the nested mutation of `project` in the `DataTableColumnDefinitionCellStatusInput` mutation. */
export type DataTableColumnDeProjectId33688488FkProjectIInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionCellStatus` in the `ProjectInput` mutation. */
export type DataTableColumnDeProjectId33688488FkProjectIInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionCellStatus` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionCellStatusDataTableColumnDefinitionCellStatusPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionCellStatus` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingDataTableColumnDefinitionCellStatusPkeyUpdate>
  >;
};

/** Input for the nested mutation of `project` in the `DataTableColumnDefinitionTextInput` mutation. */
export type DataTableColumnDeProjectIdBc4Cdb01FkProjectIInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionText` in the `ProjectInput` mutation. */
export type DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionText` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionTextDataTableColumnDefinitionTextPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionText` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionTextOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingDataTableColumnDefinitionTextPkeyUpdate>
  >;
};

/** Input for the nested mutation of `project` in the `DataTableColumnDefinitionDateInput` mutation. */
export type DataTableColumnDeProjectIdC5C8B765FkProjectIInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionDate` in the `ProjectInput` mutation. */
export type DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionDate` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionDateDataTableColumnDefinitionDatePkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionDate` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionDateOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingDataTableColumnDefinitionDatePkeyUpdate>
  >;
};

/** Input for the nested mutation of `project` in the `DataTableColumnDefinitionChoiceInput` mutation. */
export type DataTableColumnDeProjectIdC7B1D7FbFkProjectIInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionChoice` in the `ProjectInput` mutation. */
export type DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionChoice` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionChoiceDataTableColumnDefinitionChoicePkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionChoice` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionChoiceOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingDataTableColumnDefinitionChoicePkeyUpdate>
  >;
};

/** Input for the nested mutation of `project` in the `DataTableColumnDefinitionIdentifierInput` mutation. */
export type DataTableColumnDeProjectIdE2A11292FkProjectIInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionIdentifier` in the `ProjectInput` mutation. */
export type DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionIdentifier` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionIdentifierDataTableColumnDefinitionIdentifierPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionIdentifier` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingDataTableColumnDefinitionIdentifierPkeyUpdate>
  >;
};

/** The `djangoContentType` to be created by this mutation. */
export type DataTableColumnDeQcReportFileColum864C112DFkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `DataTableColumnDefinitionCellStatusInput` mutation. */
export type DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionCellStatus` in the `DjangoContentTypeInput` mutation. */
export type DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionCellStatus` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionCellStatusDataTableColumnDefinitionCellStatusPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionCellStatus` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate>
  >;
};

/** The `djangoContentType` to be created by this mutation. */
export type DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `DataTableColumnDefinitionJoinInput` mutation. */
export type DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionJoin` in the `DjangoContentTypeInput` mutation. */
export type DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionJoin` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionJoinDataTableColumnDefinitionJoinPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionJoin` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate>
  >;
};

/** The `djangoContentType` to be created by this mutation. */
export type DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `DataTableColumnDefinitionJoinInput` mutation. */
export type DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionJoin` in the `DjangoContentTypeInput` mutation. */
export type DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionJoin` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionJoinDataTableColumnDefinitionJoinPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionJoin` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate>
  >;
};

/** The `djangoContentType` to be created by this mutation. */
export type DataTableColumnDeTableTypeId6A986C02FkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `DataTableColumnDefinitionIdentifierInput` mutation. */
export type DataTableColumnDeTableTypeId6A986C02FkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `dataTableColumnDefinitionIdentifier` in the `DjangoContentTypeInput` mutation. */
export type DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput = {
  /** The primary key(s) for `dataTableColumnDefinitionIdentifier` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnDefinitionIdentifierDataTableColumnDefinitionIdentifierPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnDefinitionIdentifier` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDataTableColumnDefinitionIdentifierPkeyUpdate>
  >;
};

export type DataTableColumnDefinitionBoolean = {
  __typename: "DataTableColumnDefinitionBoolean";
  id: Scalars["UUID"]["output"];
  /** Reads a single `Project` that is related to this `DataTableColumnDefinitionBoolean`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `DataTableColumnDefinitionBoolean` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type DataTableColumnDefinitionBooleanCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `dataTableColumnDefinitionBoolean` to look up the row to connect. */
export type DataTableColumnDefinitionBooleanDataTableColumnDefinitionBooleanPkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** A filter to be used against `DataTableColumnDefinitionBoolean` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnDefinitionBooleanFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableColumnDefinitionBooleanFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableColumnDefinitionBooleanFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableColumnDefinitionBooleanFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
};

/** The fields on `dataTableColumnDefinitionBoolean` to look up the row to update. */
export type DataTableColumnDefinitionBooleanOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingDataTableColumnDefinitionBooleanPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionBoolean` being updated. */
    dataTableColumnDefinitionBooleanPatch: UpdateDataTableColumnDefinitionBooleanOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIPatch;
    id: Scalars["UUID"]["input"];
  };

/** A connection to a list of `DataTableColumnDefinitionBoolean` values. */
export type DataTableColumnDefinitionBooleansConnection = {
  __typename: "DataTableColumnDefinitionBooleansConnection";
  /** A list of edges which contains the `DataTableColumnDefinitionBoolean` and cursor to aid in pagination. */
  edges: Array<DataTableColumnDefinitionBooleansEdge>;
  /** A list of `DataTableColumnDefinitionBoolean` objects. */
  nodes: Array<DataTableColumnDefinitionBoolean>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableColumnDefinitionBoolean` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableColumnDefinitionBoolean` edge in the connection. */
export type DataTableColumnDefinitionBooleansEdge = {
  __typename: "DataTableColumnDefinitionBooleansEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableColumnDefinitionBoolean` at the end of the edge. */
  node: DataTableColumnDefinitionBoolean;
};

/** Methods to use when ordering `DataTableColumnDefinitionBoolean`. */
export enum DataTableColumnDefinitionBooleansOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
}

export type DataTableColumnDefinitionCellStatus = {
  __typename: "DataTableColumnDefinitionCellStatus";
  cellSetFileColumnId: Scalars["UUID"]["output"];
  cellSetFileColumnTypeId: Scalars["Int"]["output"];
  /** Reads a single `DjangoContentType` that is related to this `DataTableColumnDefinitionCellStatus`. */
  djangoContentTypeByCellSetFileColumnTypeId: Maybe<DjangoContentType>;
  /** Reads a single `DjangoContentType` that is related to this `DataTableColumnDefinitionCellStatus`. */
  djangoContentTypeByEventSetFileColumnTypeId: Maybe<DjangoContentType>;
  /** Reads a single `DjangoContentType` that is related to this `DataTableColumnDefinitionCellStatus`. */
  djangoContentTypeByQcReportFileColumnTypeId: Maybe<DjangoContentType>;
  eventSetFileColumnId: Maybe<Scalars["UUID"]["output"]>;
  eventSetFileColumnTypeId: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** Reads a single `Project` that is related to this `DataTableColumnDefinitionCellStatus`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  qcReportFileColumnId: Maybe<Scalars["UUID"]["output"]>;
  qcReportFileColumnTypeId: Maybe<Scalars["Int"]["output"]>;
};

/**
 * A condition to be used against `DataTableColumnDefinitionCellStatus` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type DataTableColumnDefinitionCellStatusCondition = {
  /** Checks for equality with the object’s `cellSetFileColumnId` field. */
  cellSetFileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `cellSetFileColumnTypeId` field. */
  cellSetFileColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `eventSetFileColumnId` field. */
  eventSetFileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `eventSetFileColumnTypeId` field. */
  eventSetFileColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `qcReportFileColumnId` field. */
  qcReportFileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `qcReportFileColumnTypeId` field. */
  qcReportFileColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `dataTableColumnDefinitionCellStatus` to look up the row to connect. */
export type DataTableColumnDefinitionCellStatusDataTableColumnDefinitionCellStatusPkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** A filter to be used against `DataTableColumnDefinitionCellStatus` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnDefinitionCellStatusFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableColumnDefinitionCellStatusFilter>>;
  /** Filter by the object’s `cellSetFileColumnId` field. */
  cellSetFileColumnId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `cellSetFileColumnTypeId` field. */
  cellSetFileColumnTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `djangoContentTypeByCellSetFileColumnTypeId` relation. */
  djangoContentTypeByCellSetFileColumnTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** Filter by the object’s `djangoContentTypeByEventSetFileColumnTypeId` relation. */
  djangoContentTypeByEventSetFileColumnTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** A related `djangoContentTypeByEventSetFileColumnTypeId` exists. */
  djangoContentTypeByEventSetFileColumnTypeIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `djangoContentTypeByQcReportFileColumnTypeId` relation. */
  djangoContentTypeByQcReportFileColumnTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** A related `djangoContentTypeByQcReportFileColumnTypeId` exists. */
  djangoContentTypeByQcReportFileColumnTypeIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `eventSetFileColumnId` field. */
  eventSetFileColumnId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `eventSetFileColumnTypeId` field. */
  eventSetFileColumnTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableColumnDefinitionCellStatusFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableColumnDefinitionCellStatusFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `qcReportFileColumnId` field. */
  qcReportFileColumnId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `qcReportFileColumnTypeId` field. */
  qcReportFileColumnTypeId?: InputMaybe<IntFilter>;
};

/** The fields on `dataTableColumnDefinitionCellStatus` to look up the row to update. */
export type DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionCellStatus` being updated. */
    dataTableColumnDefinitionCellStatusPatch: UpdateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumnDefinitionCellStatus` to look up the row to update. */
export type DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionCellStatus` being updated. */
    dataTableColumnDefinitionCellStatusPatch: UpdateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumnDefinitionCellStatus` to look up the row to update. */
export type DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingDataTableColumnDefinitionCellStatusPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionCellStatus` being updated. */
    dataTableColumnDefinitionCellStatusPatch: UpdateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumnDefinitionCellStatus` to look up the row to update. */
export type DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionCellStatus` being updated. */
    dataTableColumnDefinitionCellStatusPatch: UpdateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoPatch;
    id: Scalars["UUID"]["input"];
  };

/** A connection to a list of `DataTableColumnDefinitionCellStatus` values. */
export type DataTableColumnDefinitionCellStatusesConnection = {
  __typename: "DataTableColumnDefinitionCellStatusesConnection";
  /** A list of edges which contains the `DataTableColumnDefinitionCellStatus` and cursor to aid in pagination. */
  edges: Array<DataTableColumnDefinitionCellStatusesEdge>;
  /** A list of `DataTableColumnDefinitionCellStatus` objects. */
  nodes: Array<DataTableColumnDefinitionCellStatus>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableColumnDefinitionCellStatus` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableColumnDefinitionCellStatus` edge in the connection. */
export type DataTableColumnDefinitionCellStatusesEdge = {
  __typename: "DataTableColumnDefinitionCellStatusesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableColumnDefinitionCellStatus` at the end of the edge. */
  node: DataTableColumnDefinitionCellStatus;
};

/** Methods to use when ordering `DataTableColumnDefinitionCellStatus`. */
export enum DataTableColumnDefinitionCellStatusesOrderBy {
  CellSetFileColumnIdAsc = "CELL_SET_FILE_COLUMN_ID_ASC",
  CellSetFileColumnIdDesc = "CELL_SET_FILE_COLUMN_ID_DESC",
  CellSetFileColumnTypeIdAsc = "CELL_SET_FILE_COLUMN_TYPE_ID_ASC",
  CellSetFileColumnTypeIdDesc = "CELL_SET_FILE_COLUMN_TYPE_ID_DESC",
  EventSetFileColumnIdAsc = "EVENT_SET_FILE_COLUMN_ID_ASC",
  EventSetFileColumnIdDesc = "EVENT_SET_FILE_COLUMN_ID_DESC",
  EventSetFileColumnTypeIdAsc = "EVENT_SET_FILE_COLUMN_TYPE_ID_ASC",
  EventSetFileColumnTypeIdDesc = "EVENT_SET_FILE_COLUMN_TYPE_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  QcReportFileColumnIdAsc = "QC_REPORT_FILE_COLUMN_ID_ASC",
  QcReportFileColumnIdDesc = "QC_REPORT_FILE_COLUMN_ID_DESC",
  QcReportFileColumnTypeIdAsc = "QC_REPORT_FILE_COLUMN_TYPE_ID_ASC",
  QcReportFileColumnTypeIdDesc = "QC_REPORT_FILE_COLUMN_TYPE_ID_DESC",
}

export type DataTableColumnDefinitionChoice = {
  __typename: "DataTableColumnDefinitionChoice";
  choices: Scalars["JSON"]["output"];
  id: Scalars["UUID"]["output"];
  /** Reads a single `Project` that is related to this `DataTableColumnDefinitionChoice`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `DataTableColumnDefinitionChoice` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type DataTableColumnDefinitionChoiceCondition = {
  /** Checks for equality with the object’s `choices` field. */
  choices?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `dataTableColumnDefinitionChoice` to look up the row to connect. */
export type DataTableColumnDefinitionChoiceDataTableColumnDefinitionChoicePkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** A filter to be used against `DataTableColumnDefinitionChoice` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnDefinitionChoiceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableColumnDefinitionChoiceFilter>>;
  /** Filter by the object’s `choices` field. */
  choices?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableColumnDefinitionChoiceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableColumnDefinitionChoiceFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
};

/** The fields on `dataTableColumnDefinitionChoice` to look up the row to update. */
export type DataTableColumnDefinitionChoiceOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingDataTableColumnDefinitionChoicePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionChoice` being updated. */
    dataTableColumnDefinitionChoicePatch: UpdateDataTableColumnDefinitionChoiceOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIPatch;
    id: Scalars["UUID"]["input"];
  };

/** A connection to a list of `DataTableColumnDefinitionChoice` values. */
export type DataTableColumnDefinitionChoicesConnection = {
  __typename: "DataTableColumnDefinitionChoicesConnection";
  /** A list of edges which contains the `DataTableColumnDefinitionChoice` and cursor to aid in pagination. */
  edges: Array<DataTableColumnDefinitionChoicesEdge>;
  /** A list of `DataTableColumnDefinitionChoice` objects. */
  nodes: Array<DataTableColumnDefinitionChoice>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableColumnDefinitionChoice` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableColumnDefinitionChoice` edge in the connection. */
export type DataTableColumnDefinitionChoicesEdge = {
  __typename: "DataTableColumnDefinitionChoicesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableColumnDefinitionChoice` at the end of the edge. */
  node: DataTableColumnDefinitionChoice;
};

/** Methods to use when ordering `DataTableColumnDefinitionChoice`. */
export enum DataTableColumnDefinitionChoicesOrderBy {
  ChoicesAsc = "CHOICES_ASC",
  ChoicesDesc = "CHOICES_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
}

export type DataTableColumnDefinitionDate = {
  __typename: "DataTableColumnDefinitionDate";
  id: Scalars["UUID"]["output"];
  /** Reads a single `Project` that is related to this `DataTableColumnDefinitionDate`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `DataTableColumnDefinitionDate` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DataTableColumnDefinitionDateCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `dataTableColumnDefinitionDate` to look up the row to connect. */
export type DataTableColumnDefinitionDateDataTableColumnDefinitionDatePkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** A filter to be used against `DataTableColumnDefinitionDate` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnDefinitionDateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableColumnDefinitionDateFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableColumnDefinitionDateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableColumnDefinitionDateFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
};

/** The fields on `dataTableColumnDefinitionDate` to look up the row to update. */
export type DataTableColumnDefinitionDateOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingDataTableColumnDefinitionDatePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionDate` being updated. */
    dataTableColumnDefinitionDatePatch: UpdateDataTableColumnDefinitionDateOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIPatch;
    id: Scalars["UUID"]["input"];
  };

/** A connection to a list of `DataTableColumnDefinitionDate` values. */
export type DataTableColumnDefinitionDatesConnection = {
  __typename: "DataTableColumnDefinitionDatesConnection";
  /** A list of edges which contains the `DataTableColumnDefinitionDate` and cursor to aid in pagination. */
  edges: Array<DataTableColumnDefinitionDatesEdge>;
  /** A list of `DataTableColumnDefinitionDate` objects. */
  nodes: Array<DataTableColumnDefinitionDate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableColumnDefinitionDate` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableColumnDefinitionDate` edge in the connection. */
export type DataTableColumnDefinitionDatesEdge = {
  __typename: "DataTableColumnDefinitionDatesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableColumnDefinitionDate` at the end of the edge. */
  node: DataTableColumnDefinitionDate;
};

/** Methods to use when ordering `DataTableColumnDefinitionDate`. */
export enum DataTableColumnDefinitionDatesOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
}

export type DataTableColumnDefinitionFile = {
  __typename: "DataTableColumnDefinitionFile";
  fileFormats: Array<Maybe<Scalars["String"]["output"]>>;
  fileTypes: Array<Maybe<Scalars["Int"]["output"]>>;
  id: Scalars["UUID"]["output"];
  multiple: Scalars["Boolean"]["output"];
  /** Reads a single `Project` that is related to this `DataTableColumnDefinitionFile`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `DataTableColumnDefinitionFile` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DataTableColumnDefinitionFileCondition = {
  /** Checks for equality with the object’s `fileFormats` field. */
  fileFormats?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Checks for equality with the object’s `fileTypes` field. */
  fileTypes?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `multiple` field. */
  multiple?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `dataTableColumnDefinitionFile` to look up the row to connect. */
export type DataTableColumnDefinitionFileDataTableColumnDefinitionFilePkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** A filter to be used against `DataTableColumnDefinitionFile` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnDefinitionFileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableColumnDefinitionFileFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `multiple` field. */
  multiple?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableColumnDefinitionFileFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableColumnDefinitionFileFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
};

/** The fields on `dataTableColumnDefinitionFile` to look up the row to update. */
export type DataTableColumnDefinitionFileOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingDataTableColumnDefinitionFilePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionFile` being updated. */
    dataTableColumnDefinitionFilePatch: UpdateDataTableColumnDefinitionFileOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIPatch;
    id: Scalars["UUID"]["input"];
  };

/** A connection to a list of `DataTableColumnDefinitionFile` values. */
export type DataTableColumnDefinitionFilesConnection = {
  __typename: "DataTableColumnDefinitionFilesConnection";
  /** A list of edges which contains the `DataTableColumnDefinitionFile` and cursor to aid in pagination. */
  edges: Array<DataTableColumnDefinitionFilesEdge>;
  /** A list of `DataTableColumnDefinitionFile` objects. */
  nodes: Array<DataTableColumnDefinitionFile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableColumnDefinitionFile` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableColumnDefinitionFile` edge in the connection. */
export type DataTableColumnDefinitionFilesEdge = {
  __typename: "DataTableColumnDefinitionFilesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableColumnDefinitionFile` at the end of the edge. */
  node: DataTableColumnDefinitionFile;
};

/** Methods to use when ordering `DataTableColumnDefinitionFile`. */
export enum DataTableColumnDefinitionFilesOrderBy {
  FileFormatsAsc = "FILE_FORMATS_ASC",
  FileFormatsDesc = "FILE_FORMATS_DESC",
  FileTypesAsc = "FILE_TYPES_ASC",
  FileTypesDesc = "FILE_TYPES_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  MultipleAsc = "MULTIPLE_ASC",
  MultipleDesc = "MULTIPLE_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
}

export type DataTableColumnDefinitionFloat = {
  __typename: "DataTableColumnDefinitionFloat";
  id: Scalars["UUID"]["output"];
  max: Maybe<Scalars["Float"]["output"]>;
  min: Maybe<Scalars["Float"]["output"]>;
  /** Reads a single `Project` that is related to this `DataTableColumnDefinitionFloat`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `DataTableColumnDefinitionFloat` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type DataTableColumnDefinitionFloatCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `max` field. */
  max?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `min` field. */
  min?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `dataTableColumnDefinitionFloat` to look up the row to connect. */
export type DataTableColumnDefinitionFloatDataTableColumnDefinitionFloatPkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** A filter to be used against `DataTableColumnDefinitionFloat` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnDefinitionFloatFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableColumnDefinitionFloatFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `max` field. */
  max?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `min` field. */
  min?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableColumnDefinitionFloatFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableColumnDefinitionFloatFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
};

/** The fields on `dataTableColumnDefinitionFloat` to look up the row to update. */
export type DataTableColumnDefinitionFloatOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingDataTableColumnDefinitionFloatPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionFloat` being updated. */
    dataTableColumnDefinitionFloatPatch: UpdateDataTableColumnDefinitionFloatOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIPatch;
    id: Scalars["UUID"]["input"];
  };

/** A connection to a list of `DataTableColumnDefinitionFloat` values. */
export type DataTableColumnDefinitionFloatsConnection = {
  __typename: "DataTableColumnDefinitionFloatsConnection";
  /** A list of edges which contains the `DataTableColumnDefinitionFloat` and cursor to aid in pagination. */
  edges: Array<DataTableColumnDefinitionFloatsEdge>;
  /** A list of `DataTableColumnDefinitionFloat` objects. */
  nodes: Array<DataTableColumnDefinitionFloat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableColumnDefinitionFloat` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableColumnDefinitionFloat` edge in the connection. */
export type DataTableColumnDefinitionFloatsEdge = {
  __typename: "DataTableColumnDefinitionFloatsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableColumnDefinitionFloat` at the end of the edge. */
  node: DataTableColumnDefinitionFloat;
};

/** Methods to use when ordering `DataTableColumnDefinitionFloat`. */
export enum DataTableColumnDefinitionFloatsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  MaxAsc = "MAX_ASC",
  MaxDesc = "MAX_DESC",
  MinAsc = "MIN_ASC",
  MinDesc = "MIN_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
}

export type DataTableColumnDefinitionIdentifier = {
  __typename: "DataTableColumnDefinitionIdentifier";
  /** Reads a single `DjangoContentType` that is related to this `DataTableColumnDefinitionIdentifier`. */
  djangoContentTypeByTableTypeId: Maybe<DjangoContentType>;
  id: Scalars["UUID"]["output"];
  /** Reads a single `Project` that is related to this `DataTableColumnDefinitionIdentifier`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  tableId: Scalars["UUID"]["output"];
  tableTypeId: Scalars["Int"]["output"];
};

/**
 * A condition to be used against `DataTableColumnDefinitionIdentifier` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type DataTableColumnDefinitionIdentifierCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tableId` field. */
  tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tableTypeId` field. */
  tableTypeId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `dataTableColumnDefinitionIdentifier` to look up the row to connect. */
export type DataTableColumnDefinitionIdentifierDataTableColumnDefinitionIdentifierPkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** A filter to be used against `DataTableColumnDefinitionIdentifier` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnDefinitionIdentifierFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableColumnDefinitionIdentifierFilter>>;
  /** Filter by the object’s `djangoContentTypeByTableTypeId` relation. */
  djangoContentTypeByTableTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableColumnDefinitionIdentifierFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableColumnDefinitionIdentifierFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tableId` field. */
  tableId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tableTypeId` field. */
  tableTypeId?: InputMaybe<IntFilter>;
};

/** The fields on `dataTableColumnDefinitionIdentifier` to look up the row to update. */
export type DataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingDataTableColumnDefinitionIdentifierPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionIdentifier` being updated. */
    dataTableColumnDefinitionIdentifierPatch: UpdateDataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumnDefinitionIdentifier` to look up the row to update. */
export type DataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDataTableColumnDefinitionIdentifierPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionIdentifier` being updated. */
    dataTableColumnDefinitionIdentifierPatch: UpdateDataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoPatch;
    id: Scalars["UUID"]["input"];
  };

/** A connection to a list of `DataTableColumnDefinitionIdentifier` values. */
export type DataTableColumnDefinitionIdentifiersConnection = {
  __typename: "DataTableColumnDefinitionIdentifiersConnection";
  /** A list of edges which contains the `DataTableColumnDefinitionIdentifier` and cursor to aid in pagination. */
  edges: Array<DataTableColumnDefinitionIdentifiersEdge>;
  /** A list of `DataTableColumnDefinitionIdentifier` objects. */
  nodes: Array<DataTableColumnDefinitionIdentifier>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableColumnDefinitionIdentifier` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableColumnDefinitionIdentifier` edge in the connection. */
export type DataTableColumnDefinitionIdentifiersEdge = {
  __typename: "DataTableColumnDefinitionIdentifiersEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableColumnDefinitionIdentifier` at the end of the edge. */
  node: DataTableColumnDefinitionIdentifier;
};

/** Methods to use when ordering `DataTableColumnDefinitionIdentifier`. */
export enum DataTableColumnDefinitionIdentifiersOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  TableIdAsc = "TABLE_ID_ASC",
  TableIdDesc = "TABLE_ID_DESC",
  TableTypeIdAsc = "TABLE_TYPE_ID_ASC",
  TableTypeIdDesc = "TABLE_TYPE_ID_DESC",
}

export type DataTableColumnDefinitionInteger = {
  __typename: "DataTableColumnDefinitionInteger";
  id: Scalars["UUID"]["output"];
  max: Maybe<Scalars["BigInt"]["output"]>;
  min: Maybe<Scalars["BigInt"]["output"]>;
  /** Reads a single `Project` that is related to this `DataTableColumnDefinitionInteger`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `DataTableColumnDefinitionInteger` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type DataTableColumnDefinitionIntegerCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `max` field. */
  max?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `min` field. */
  min?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `dataTableColumnDefinitionInteger` to look up the row to connect. */
export type DataTableColumnDefinitionIntegerDataTableColumnDefinitionIntegerPkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** A filter to be used against `DataTableColumnDefinitionInteger` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnDefinitionIntegerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableColumnDefinitionIntegerFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `max` field. */
  max?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `min` field. */
  min?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableColumnDefinitionIntegerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableColumnDefinitionIntegerFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
};

/** The fields on `dataTableColumnDefinitionInteger` to look up the row to update. */
export type DataTableColumnDefinitionIntegerOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingDataTableColumnDefinitionIntegerPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionInteger` being updated. */
    dataTableColumnDefinitionIntegerPatch: UpdateDataTableColumnDefinitionIntegerOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIPatch;
    id: Scalars["UUID"]["input"];
  };

/** A connection to a list of `DataTableColumnDefinitionInteger` values. */
export type DataTableColumnDefinitionIntegersConnection = {
  __typename: "DataTableColumnDefinitionIntegersConnection";
  /** A list of edges which contains the `DataTableColumnDefinitionInteger` and cursor to aid in pagination. */
  edges: Array<DataTableColumnDefinitionIntegersEdge>;
  /** A list of `DataTableColumnDefinitionInteger` objects. */
  nodes: Array<DataTableColumnDefinitionInteger>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableColumnDefinitionInteger` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableColumnDefinitionInteger` edge in the connection. */
export type DataTableColumnDefinitionIntegersEdge = {
  __typename: "DataTableColumnDefinitionIntegersEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableColumnDefinitionInteger` at the end of the edge. */
  node: DataTableColumnDefinitionInteger;
};

/** Methods to use when ordering `DataTableColumnDefinitionInteger`. */
export enum DataTableColumnDefinitionIntegersOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  MaxAsc = "MAX_ASC",
  MaxDesc = "MAX_DESC",
  MinAsc = "MIN_ASC",
  MinDesc = "MIN_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
}

export type DataTableColumnDefinitionJoin = {
  __typename: "DataTableColumnDefinitionJoin";
  /** Reads a single `DjangoContentType` that is related to this `DataTableColumnDefinitionJoin`. */
  djangoContentTypeByLeftColumnTypeId: Maybe<DjangoContentType>;
  /** Reads a single `DjangoContentType` that is related to this `DataTableColumnDefinitionJoin`. */
  djangoContentTypeByRightColumnTypeId: Maybe<DjangoContentType>;
  /** Reads a single `DjangoContentType` that is related to this `DataTableColumnDefinitionJoin`. */
  djangoContentTypeBySourceColumnTypeId: Maybe<DjangoContentType>;
  id: Scalars["UUID"]["output"];
  leftColumnId: Scalars["UUID"]["output"];
  leftColumnTypeId: Scalars["Int"]["output"];
  /** Reads a single `Project` that is related to this `DataTableColumnDefinitionJoin`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  rightColumnId: Scalars["UUID"]["output"];
  rightColumnTypeId: Scalars["Int"]["output"];
  sourceColumnId: Scalars["UUID"]["output"];
  sourceColumnTypeId: Scalars["Int"]["output"];
};

/**
 * A condition to be used against `DataTableColumnDefinitionJoin` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DataTableColumnDefinitionJoinCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `leftColumnId` field. */
  leftColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `leftColumnTypeId` field. */
  leftColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `rightColumnId` field. */
  rightColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `rightColumnTypeId` field. */
  rightColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `sourceColumnId` field. */
  sourceColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `sourceColumnTypeId` field. */
  sourceColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `dataTableColumnDefinitionJoin` to look up the row to connect. */
export type DataTableColumnDefinitionJoinDataTableColumnDefinitionJoinPkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** A filter to be used against `DataTableColumnDefinitionJoin` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnDefinitionJoinFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableColumnDefinitionJoinFilter>>;
  /** Filter by the object’s `djangoContentTypeByLeftColumnTypeId` relation. */
  djangoContentTypeByLeftColumnTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** Filter by the object’s `djangoContentTypeByRightColumnTypeId` relation. */
  djangoContentTypeByRightColumnTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** Filter by the object’s `djangoContentTypeBySourceColumnTypeId` relation. */
  djangoContentTypeBySourceColumnTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `leftColumnId` field. */
  leftColumnId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `leftColumnTypeId` field. */
  leftColumnTypeId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableColumnDefinitionJoinFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableColumnDefinitionJoinFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `rightColumnId` field. */
  rightColumnId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `rightColumnTypeId` field. */
  rightColumnTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sourceColumnId` field. */
  sourceColumnId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `sourceColumnTypeId` field. */
  sourceColumnTypeId?: InputMaybe<IntFilter>;
};

/** The fields on `dataTableColumnDefinitionJoin` to look up the row to update. */
export type DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionJoin` being updated. */
    dataTableColumnDefinitionJoinPatch: UpdateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumnDefinitionJoin` to look up the row to update. */
export type DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingDataTableColumnDefinitionJoinPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionJoin` being updated. */
    dataTableColumnDefinitionJoinPatch: UpdateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumnDefinitionJoin` to look up the row to update. */
export type DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionJoin` being updated. */
    dataTableColumnDefinitionJoinPatch: UpdateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumnDefinitionJoin` to look up the row to update. */
export type DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionJoin` being updated. */
    dataTableColumnDefinitionJoinPatch: UpdateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoPatch;
    id: Scalars["UUID"]["input"];
  };

/** A connection to a list of `DataTableColumnDefinitionJoin` values. */
export type DataTableColumnDefinitionJoinsConnection = {
  __typename: "DataTableColumnDefinitionJoinsConnection";
  /** A list of edges which contains the `DataTableColumnDefinitionJoin` and cursor to aid in pagination. */
  edges: Array<DataTableColumnDefinitionJoinsEdge>;
  /** A list of `DataTableColumnDefinitionJoin` objects. */
  nodes: Array<DataTableColumnDefinitionJoin>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableColumnDefinitionJoin` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableColumnDefinitionJoin` edge in the connection. */
export type DataTableColumnDefinitionJoinsEdge = {
  __typename: "DataTableColumnDefinitionJoinsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableColumnDefinitionJoin` at the end of the edge. */
  node: DataTableColumnDefinitionJoin;
};

/** Methods to use when ordering `DataTableColumnDefinitionJoin`. */
export enum DataTableColumnDefinitionJoinsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  LeftColumnIdAsc = "LEFT_COLUMN_ID_ASC",
  LeftColumnIdDesc = "LEFT_COLUMN_ID_DESC",
  LeftColumnTypeIdAsc = "LEFT_COLUMN_TYPE_ID_ASC",
  LeftColumnTypeIdDesc = "LEFT_COLUMN_TYPE_ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  RightColumnIdAsc = "RIGHT_COLUMN_ID_ASC",
  RightColumnIdDesc = "RIGHT_COLUMN_ID_DESC",
  RightColumnTypeIdAsc = "RIGHT_COLUMN_TYPE_ID_ASC",
  RightColumnTypeIdDesc = "RIGHT_COLUMN_TYPE_ID_DESC",
  SourceColumnIdAsc = "SOURCE_COLUMN_ID_ASC",
  SourceColumnIdDesc = "SOURCE_COLUMN_ID_DESC",
  SourceColumnTypeIdAsc = "SOURCE_COLUMN_TYPE_ID_ASC",
  SourceColumnTypeIdDesc = "SOURCE_COLUMN_TYPE_ID_DESC",
}

/** A connection to a list of `DataTableColumnDefinitionMetadatum` values. */
export type DataTableColumnDefinitionMetadataConnection = {
  __typename: "DataTableColumnDefinitionMetadataConnection";
  /** A list of edges which contains the `DataTableColumnDefinitionMetadatum` and cursor to aid in pagination. */
  edges: Array<DataTableColumnDefinitionMetadataEdge>;
  /** A list of `DataTableColumnDefinitionMetadatum` objects. */
  nodes: Array<DataTableColumnDefinitionMetadatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableColumnDefinitionMetadatum` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableColumnDefinitionMetadatum` edge in the connection. */
export type DataTableColumnDefinitionMetadataEdge = {
  __typename: "DataTableColumnDefinitionMetadataEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableColumnDefinitionMetadatum` at the end of the edge. */
  node: DataTableColumnDefinitionMetadatum;
};

/** Methods to use when ordering `DataTableColumnDefinitionMetadatum`. */
export enum DataTableColumnDefinitionMetadataOrderBy {
  FileColumnIdAsc = "FILE_COLUMN_ID_ASC",
  FileColumnIdDesc = "FILE_COLUMN_ID_DESC",
  FileColumnTypeIdAsc = "FILE_COLUMN_TYPE_ID_ASC",
  FileColumnTypeIdDesc = "FILE_COLUMN_TYPE_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  MetadatumKeyAsc = "METADATUM_KEY_ASC",
  MetadatumKeyDesc = "METADATUM_KEY_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
}

export type DataTableColumnDefinitionMetadatum = {
  __typename: "DataTableColumnDefinitionMetadatum";
  /** Reads a single `DjangoContentType` that is related to this `DataTableColumnDefinitionMetadatum`. */
  djangoContentTypeByFileColumnTypeId: Maybe<DjangoContentType>;
  fileColumnId: Scalars["UUID"]["output"];
  fileColumnTypeId: Scalars["Int"]["output"];
  id: Scalars["UUID"]["output"];
  metadatumKey: Scalars["String"]["output"];
  /** Reads a single `Project` that is related to this `DataTableColumnDefinitionMetadatum`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `DataTableColumnDefinitionMetadatum` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type DataTableColumnDefinitionMetadatumCondition = {
  /** Checks for equality with the object’s `fileColumnId` field. */
  fileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `fileColumnTypeId` field. */
  fileColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `metadatumKey` field. */
  metadatumKey?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `dataTableColumnDefinitionMetadatum` to look up the row to connect. */
export type DataTableColumnDefinitionMetadatumDataTableColumnDefinitionMetadatumPkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** A filter to be used against `DataTableColumnDefinitionMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnDefinitionMetadatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableColumnDefinitionMetadatumFilter>>;
  /** Filter by the object’s `djangoContentTypeByFileColumnTypeId` relation. */
  djangoContentTypeByFileColumnTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** Filter by the object’s `fileColumnId` field. */
  fileColumnId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fileColumnTypeId` field. */
  fileColumnTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `metadatumKey` field. */
  metadatumKey?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableColumnDefinitionMetadatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableColumnDefinitionMetadatumFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
};

/** The fields on `dataTableColumnDefinitionMetadatum` to look up the row to update. */
export type DataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDataTableColumnDefinitionMetadatumPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionMetadatum` being updated. */
    dataTableColumnDefinitionMetadatumPatch: UpdateDataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumnDefinitionMetadatum` to look up the row to update. */
export type DataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingDataTableColumnDefinitionMetadatumPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionMetadatum` being updated. */
    dataTableColumnDefinitionMetadatumPatch: UpdateDataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIPatch;
    id: Scalars["UUID"]["input"];
  };

export type DataTableColumnDefinitionRoiFrame = {
  __typename: "DataTableColumnDefinitionRoiFrame";
  boundingBox: Maybe<Scalars["JSON"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `DataTableColumnDefinitionRoiFrame`. */
  djangoContentTypeByFileColumnTypeId: Maybe<DjangoContentType>;
  fileColumnId: Scalars["UUID"]["output"];
  fileColumnTypeId: Scalars["Int"]["output"];
  groups: Maybe<Scalars["JSON"]["output"]>;
  id: Scalars["UUID"]["output"];
  overlap: Scalars["Boolean"]["output"];
  /** Reads a single `Project` that is related to this `DataTableColumnDefinitionRoiFrame`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  sourceFileData: Scalars["JSON"]["output"];
};

/**
 * A condition to be used against `DataTableColumnDefinitionRoiFrame` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type DataTableColumnDefinitionRoiFrameCondition = {
  /** Checks for equality with the object’s `boundingBox` field. */
  boundingBox?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `fileColumnId` field. */
  fileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `fileColumnTypeId` field. */
  fileColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `groups` field. */
  groups?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `overlap` field. */
  overlap?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `sourceFileData` field. */
  sourceFileData?: InputMaybe<Scalars["JSON"]["input"]>;
};

/** The fields on `dataTableColumnDefinitionRoiFrame` to look up the row to connect. */
export type DataTableColumnDefinitionRoiFrameDataTableColumnDefinitionRoiFramePkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** A filter to be used against `DataTableColumnDefinitionRoiFrame` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnDefinitionRoiFrameFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableColumnDefinitionRoiFrameFilter>>;
  /** Filter by the object’s `boundingBox` field. */
  boundingBox?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `djangoContentTypeByFileColumnTypeId` relation. */
  djangoContentTypeByFileColumnTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** Filter by the object’s `fileColumnId` field. */
  fileColumnId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fileColumnTypeId` field. */
  fileColumnTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `groups` field. */
  groups?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableColumnDefinitionRoiFrameFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableColumnDefinitionRoiFrameFilter>>;
  /** Filter by the object’s `overlap` field. */
  overlap?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `sourceFileData` field. */
  sourceFileData?: InputMaybe<JsonFilter>;
};

/** The fields on `dataTableColumnDefinitionRoiFrame` to look up the row to update. */
export type DataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDataTableColumnDefinitionRoiFramePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionRoiFrame` being updated. */
    dataTableColumnDefinitionRoiFramePatch: UpdateDataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumnDefinitionRoiFrame` to look up the row to update. */
export type DataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingDataTableColumnDefinitionRoiFramePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionRoiFrame` being updated. */
    dataTableColumnDefinitionRoiFramePatch: UpdateDataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIPatch;
    id: Scalars["UUID"]["input"];
  };

/** A connection to a list of `DataTableColumnDefinitionRoiFrame` values. */
export type DataTableColumnDefinitionRoiFramesConnection = {
  __typename: "DataTableColumnDefinitionRoiFramesConnection";
  /** A list of edges which contains the `DataTableColumnDefinitionRoiFrame` and cursor to aid in pagination. */
  edges: Array<DataTableColumnDefinitionRoiFramesEdge>;
  /** A list of `DataTableColumnDefinitionRoiFrame` objects. */
  nodes: Array<DataTableColumnDefinitionRoiFrame>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableColumnDefinitionRoiFrame` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableColumnDefinitionRoiFrame` edge in the connection. */
export type DataTableColumnDefinitionRoiFramesEdge = {
  __typename: "DataTableColumnDefinitionRoiFramesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableColumnDefinitionRoiFrame` at the end of the edge. */
  node: DataTableColumnDefinitionRoiFrame;
};

/** Methods to use when ordering `DataTableColumnDefinitionRoiFrame`. */
export enum DataTableColumnDefinitionRoiFramesOrderBy {
  BoundingBoxAsc = "BOUNDING_BOX_ASC",
  BoundingBoxDesc = "BOUNDING_BOX_DESC",
  FileColumnIdAsc = "FILE_COLUMN_ID_ASC",
  FileColumnIdDesc = "FILE_COLUMN_ID_DESC",
  FileColumnTypeIdAsc = "FILE_COLUMN_TYPE_ID_ASC",
  FileColumnTypeIdDesc = "FILE_COLUMN_TYPE_ID_DESC",
  GroupsAsc = "GROUPS_ASC",
  GroupsDesc = "GROUPS_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  OverlapAsc = "OVERLAP_ASC",
  OverlapDesc = "OVERLAP_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  SourceFileDataAsc = "SOURCE_FILE_DATA_ASC",
  SourceFileDataDesc = "SOURCE_FILE_DATA_DESC",
}

export type DataTableColumnDefinitionText = {
  __typename: "DataTableColumnDefinitionText";
  id: Scalars["UUID"]["output"];
  maxLength: Maybe<Scalars["Int"]["output"]>;
  /** Reads a single `Project` that is related to this `DataTableColumnDefinitionText`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `DataTableColumnDefinitionText` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DataTableColumnDefinitionTextCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `maxLength` field. */
  maxLength?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `dataTableColumnDefinitionText` to look up the row to connect. */
export type DataTableColumnDefinitionTextDataTableColumnDefinitionTextPkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** A filter to be used against `DataTableColumnDefinitionText` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnDefinitionTextFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableColumnDefinitionTextFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `maxLength` field. */
  maxLength?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableColumnDefinitionTextFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableColumnDefinitionTextFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
};

/** The fields on `dataTableColumnDefinitionText` to look up the row to update. */
export type DataTableColumnDefinitionTextOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingDataTableColumnDefinitionTextPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnDefinitionText` being updated. */
    dataTableColumnDefinitionTextPatch: UpdateDataTableColumnDefinitionTextOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIPatch;
    id: Scalars["UUID"]["input"];
  };

/** A connection to a list of `DataTableColumnDefinitionText` values. */
export type DataTableColumnDefinitionTextsConnection = {
  __typename: "DataTableColumnDefinitionTextsConnection";
  /** A list of edges which contains the `DataTableColumnDefinitionText` and cursor to aid in pagination. */
  edges: Array<DataTableColumnDefinitionTextsEdge>;
  /** A list of `DataTableColumnDefinitionText` objects. */
  nodes: Array<DataTableColumnDefinitionText>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableColumnDefinitionText` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableColumnDefinitionText` edge in the connection. */
export type DataTableColumnDefinitionTextsEdge = {
  __typename: "DataTableColumnDefinitionTextsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableColumnDefinitionText` at the end of the edge. */
  node: DataTableColumnDefinitionText;
};

/** Methods to use when ordering `DataTableColumnDefinitionText`. */
export enum DataTableColumnDefinitionTextsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  MaxLengthAsc = "MAX_LENGTH_ASC",
  MaxLengthDesc = "MAX_LENGTH_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
}

/** The `djangoContentType` to be created by this mutation. */
export type DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `DataTableColumnInput` mutation. */
export type DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `dataTableColumn` in the `DjangoContentTypeInput` mutation. */
export type DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput = {
  /** The primary key(s) for `dataTableColumn` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableColumnDataTableColumnPkeyConnect>>;
  /** The primary key(s) for `dataTableColumn` for the far side of the relationship. */
  connectByTableIdAndOrder?: InputMaybe<
    Array<DataTableColumnDataTableColumnOrderUniqueConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumn` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDataTableColumnPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `dataTableColumn` for the far side of the relationship. */
  updateByTableIdAndOrder?: InputMaybe<
    Array<DataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDataTableColumnOrderUniqueUpdate>
  >;
};

/** A filter to be used against `DataTableColumn` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableColumnFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dataTableByTableId` relation. */
  dataTableByTableId?: InputMaybe<DataTableFilter>;
  /** Filter by the object’s `dataTableCellsByColumnId` relation. */
  dataTableCellsByColumnId?: InputMaybe<DataTableColumnToManyDataTableCellFilter>;
  /** Some related `dataTableCellsByColumnId` exist. */
  dataTableCellsByColumnIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dataTableColumnGroupByGroupId` relation. */
  dataTableColumnGroupByGroupId?: InputMaybe<DataTableColumnGroupFilter>;
  /** A related `dataTableColumnGroupByGroupId` exists. */
  dataTableColumnGroupByGroupIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defaultFormula` field. */
  defaultFormula?: InputMaybe<StringFilter>;
  /** Filter by the object’s `definitionId` field. */
  definitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `definitionTypeId` field. */
  definitionTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `deletable` field. */
  deletable?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `djangoContentTypeByDefinitionTypeId` relation. */
  djangoContentTypeByDefinitionTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** Filter by the object’s `editable` field. */
  editable?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `helpText` field. */
  helpText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `identifierPosition` field. */
  identifierPosition?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isIdColumn` field. */
  isIdColumn?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableColumnFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableColumnFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `pinned` field. */
  pinned?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tableId` field. */
  tableId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `width` field. */
  width?: InputMaybe<IntFilter>;
};

/** The `djangoContentType` to be created by this mutation. */
export type DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `DataTableColumnGroupInput` mutation. */
export type DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `dataTableColumnGroup` in the `DjangoContentTypeInput` mutation. */
export type DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput = {
  /** The primary key(s) for `dataTableColumnGroup` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnGroupDataTableColumnGroupPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnGroup` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDataTableColumnGroupPkeyUpdate>
  >;
};

/** Input for the nested mutation of `project` in the `DataTableColumnGroupDefinitionJoinInput` mutation. */
export type DataTableColumnGrProjectId2Af8Cd7EFkProjectIInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableColumnGroupDefinitionJoin` in the `ProjectInput` mutation. */
export type DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput = {
  /** The primary key(s) for `dataTableColumnGroupDefinitionJoin` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnGroupDefinitionJoinDataTableColumnGroupDefinitionJoinPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnGroupDefinitionJoin` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingDataTableColumnGroupDefinitionJoinPkeyUpdate>
  >;
};

/** Input for the nested mutation of `project` in the `DataTableColumnGroupDefinitionSourceInput` mutation. */
export type DataTableColumnGrProjectId7376573CFkProjectIInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableColumnGroupDefinitionSource` in the `ProjectInput` mutation. */
export type DataTableColumnGrProjectId7376573CFkProjectIInverseInput = {
  /** The primary key(s) for `dataTableColumnGroupDefinitionSource` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnGroupDefinitionSourceDataTableColumnGroupDefinitionSourcesPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnGroupDefinitionSource` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnGroupDefinitionSourceOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingDataTableColumnGroupDefinitionSourcesPkeyUpdate>
  >;
};

/** The `djangoContentType` to be created by this mutation. */
export type DataTableColumnGrTableTypeId70D51D68FkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `DataTableColumnGroupDefinitionJoinInput` mutation. */
export type DataTableColumnGrTableTypeId70D51D68FkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `dataTableColumnGroupDefinitionJoin` in the `DjangoContentTypeInput` mutation. */
export type DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput = {
  /** The primary key(s) for `dataTableColumnGroupDefinitionJoin` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnGroupDefinitionJoinDataTableColumnGroupDefinitionJoinPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnGroupDefinitionJoin` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDataTableColumnGroupDefinitionJoinPkeyUpdate>
  >;
};

export type DataTableColumnGroup = {
  __typename: "DataTableColumnGroup";
  /** Reads a single `ApplicationUser` that is related to this `DataTableColumnGroup`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** Reads a single `DataTable` that is related to this `DataTableColumnGroup`. */
  dataTableByTableId: Maybe<DataTable>;
  /** Reads and enables pagination through a set of `DataTableColumn`. */
  dataTableColumnsByGroupId: DataTableColumnsConnection;
  dateDeleted: Maybe<Scalars["Datetime"]["output"]>;
  definitionId: Maybe<Scalars["UUID"]["output"]>;
  definitionTypeId: Maybe<Scalars["Int"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `DataTableColumnGroup`. */
  djangoContentTypeByDefinitionTypeId: Maybe<DjangoContentType>;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  /** Reads a single `Project` that is related to this `DataTableColumnGroup`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  tableId: Scalars["UUID"]["output"];
  userId: Scalars["UUID"]["output"];
};

export type DataTableColumnGroupDataTableColumnsByGroupIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnCondition>;
  filter?: InputMaybe<DataTableColumnFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnsOrderBy>>;
};

/**
 * A condition to be used against `DataTableColumnGroup` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DataTableColumnGroupCondition = {
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `definitionId` field. */
  definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `definitionTypeId` field. */
  definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tableId` field. */
  tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `dataTableColumnGroup` to look up the row to connect. */
export type DataTableColumnGroupDataTableColumnGroupPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

export type DataTableColumnGroupDefinitionJoin = {
  __typename: "DataTableColumnGroupDefinitionJoin";
  /** Reads a single `DjangoContentType` that is related to this `DataTableColumnGroupDefinitionJoin`. */
  djangoContentTypeByTableTypeId: Maybe<DjangoContentType>;
  id: Scalars["UUID"]["output"];
  /** Reads a single `Project` that is related to this `DataTableColumnGroupDefinitionJoin`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  tableId: Scalars["UUID"]["output"];
  tableTypeId: Scalars["Int"]["output"];
};

/**
 * A condition to be used against `DataTableColumnGroupDefinitionJoin` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type DataTableColumnGroupDefinitionJoinCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tableId` field. */
  tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tableTypeId` field. */
  tableTypeId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `dataTableColumnGroupDefinitionJoin` to look up the row to connect. */
export type DataTableColumnGroupDefinitionJoinDataTableColumnGroupDefinitionJoinPkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** A filter to be used against `DataTableColumnGroupDefinitionJoin` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnGroupDefinitionJoinFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableColumnGroupDefinitionJoinFilter>>;
  /** Filter by the object’s `djangoContentTypeByTableTypeId` relation. */
  djangoContentTypeByTableTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableColumnGroupDefinitionJoinFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableColumnGroupDefinitionJoinFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tableId` field. */
  tableId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tableTypeId` field. */
  tableTypeId?: InputMaybe<IntFilter>;
};

/** The fields on `dataTableColumnGroupDefinitionJoin` to look up the row to update. */
export type DataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingDataTableColumnGroupDefinitionJoinPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnGroupDefinitionJoin` being updated. */
    dataTableColumnGroupDefinitionJoinPatch: UpdateDataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumnGroupDefinitionJoin` to look up the row to update. */
export type DataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDataTableColumnGroupDefinitionJoinPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnGroupDefinitionJoin` being updated. */
    dataTableColumnGroupDefinitionJoinPatch: UpdateDataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoPatch;
    id: Scalars["UUID"]["input"];
  };

/** A connection to a list of `DataTableColumnGroupDefinitionJoin` values. */
export type DataTableColumnGroupDefinitionJoinsConnection = {
  __typename: "DataTableColumnGroupDefinitionJoinsConnection";
  /** A list of edges which contains the `DataTableColumnGroupDefinitionJoin` and cursor to aid in pagination. */
  edges: Array<DataTableColumnGroupDefinitionJoinsEdge>;
  /** A list of `DataTableColumnGroupDefinitionJoin` objects. */
  nodes: Array<DataTableColumnGroupDefinitionJoin>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableColumnGroupDefinitionJoin` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableColumnGroupDefinitionJoin` edge in the connection. */
export type DataTableColumnGroupDefinitionJoinsEdge = {
  __typename: "DataTableColumnGroupDefinitionJoinsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableColumnGroupDefinitionJoin` at the end of the edge. */
  node: DataTableColumnGroupDefinitionJoin;
};

/** Methods to use when ordering `DataTableColumnGroupDefinitionJoin`. */
export enum DataTableColumnGroupDefinitionJoinsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  TableIdAsc = "TABLE_ID_ASC",
  TableIdDesc = "TABLE_ID_DESC",
  TableTypeIdAsc = "TABLE_TYPE_ID_ASC",
  TableTypeIdDesc = "TABLE_TYPE_ID_DESC",
}

export type DataTableColumnGroupDefinitionSource = {
  __typename: "DataTableColumnGroupDefinitionSource";
  id: Scalars["UUID"]["output"];
  /** Reads a single `Project` that is related to this `DataTableColumnGroupDefinitionSource`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `DataTableColumnGroupDefinitionSource` object
 * types. All fields are tested for equality and combined with a logical ‘and.’
 */
export type DataTableColumnGroupDefinitionSourceCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `dataTableColumnGroupDefinitionSource` to look up the row to connect. */
export type DataTableColumnGroupDefinitionSourceDataTableColumnGroupDefinitionSourcesPkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** A filter to be used against `DataTableColumnGroupDefinitionSource` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnGroupDefinitionSourceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableColumnGroupDefinitionSourceFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableColumnGroupDefinitionSourceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableColumnGroupDefinitionSourceFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
};

/** The fields on `dataTableColumnGroupDefinitionSource` to look up the row to update. */
export type DataTableColumnGroupDefinitionSourceOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingDataTableColumnGroupDefinitionSourcesPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnGroupDefinitionSource` being updated. */
    dataTableColumnGroupDefinitionSourcePatch: UpdateDataTableColumnGroupDefinitionSourceOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIPatch;
    id: Scalars["UUID"]["input"];
  };

/** A connection to a list of `DataTableColumnGroupDefinitionSource` values. */
export type DataTableColumnGroupDefinitionSourcesConnection = {
  __typename: "DataTableColumnGroupDefinitionSourcesConnection";
  /** A list of edges which contains the `DataTableColumnGroupDefinitionSource` and cursor to aid in pagination. */
  edges: Array<DataTableColumnGroupDefinitionSourcesEdge>;
  /** A list of `DataTableColumnGroupDefinitionSource` objects. */
  nodes: Array<DataTableColumnGroupDefinitionSource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableColumnGroupDefinitionSource` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableColumnGroupDefinitionSource` edge in the connection. */
export type DataTableColumnGroupDefinitionSourcesEdge = {
  __typename: "DataTableColumnGroupDefinitionSourcesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableColumnGroupDefinitionSource` at the end of the edge. */
  node: DataTableColumnGroupDefinitionSource;
};

/** Methods to use when ordering `DataTableColumnGroupDefinitionSource`. */
export enum DataTableColumnGroupDefinitionSourcesOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
}

/** A filter to be used against `DataTableColumnGroup` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableColumnGroupFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dataTableByTableId` relation. */
  dataTableByTableId?: InputMaybe<DataTableFilter>;
  /** Filter by the object’s `dataTableColumnsByGroupId` relation. */
  dataTableColumnsByGroupId?: InputMaybe<DataTableColumnGroupToManyDataTableColumnFilter>;
  /** Some related `dataTableColumnsByGroupId` exist. */
  dataTableColumnsByGroupIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `definitionId` field. */
  definitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `definitionTypeId` field. */
  definitionTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `djangoContentTypeByDefinitionTypeId` relation. */
  djangoContentTypeByDefinitionTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** A related `djangoContentTypeByDefinitionTypeId` exists. */
  djangoContentTypeByDefinitionTypeIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableColumnGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableColumnGroupFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tableId` field. */
  tableId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** Input for the nested mutation of `dataTableColumnGroup` in the `DataTableColumnInput` mutation. */
export type DataTableColumnGroupIdAbcd4Ec0FkDataTablInput = {
  /** The primary key(s) for `dataTableColumnGroup` for the far side of the relationship. */
  connectById?: InputMaybe<DataTableColumnGroupDataTableColumnGroupPkeyConnect>;
  /** The primary key(s) and patch data for `dataTableColumnGroup` for the far side of the relationship. */
  updateById?: InputMaybe<DataTableColumnGroupOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnGroupPkeyUpdate>;
};

/** Input for the nested mutation of `dataTableColumn` in the `DataTableColumnGroupInput` mutation. */
export type DataTableColumnGroupIdAbcd4Ec0FkDataTablInverseInput = {
  /** The primary key(s) for `dataTableColumn` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableColumnDataTableColumnPkeyConnect>>;
  /** The primary key(s) for `dataTableColumn` for the far side of the relationship. */
  connectByTableIdAndOrder?: InputMaybe<
    Array<DataTableColumnDataTableColumnOrderUniqueConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumn` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `dataTableColumn` for the far side of the relationship. */
  updateByTableIdAndOrder?: InputMaybe<
    Array<DataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnOrderUniqueUpdate>
  >;
};

/** The fields on `dataTableColumnGroup` to look up the row to update. */
export type DataTableColumnGroupOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnGroup` being updated. */
    dataTableColumnGroupPatch: UpdateDataTableColumnGroupOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumnGroup` to look up the row to update. */
export type DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDataTableColumnGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnGroup` being updated. */
    dataTableColumnGroupPatch: UpdateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumnGroup` to look up the row to update. */
export type DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingDataTableColumnGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnGroup` being updated. */
    dataTableColumnGroupPatch: UpdateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumnGroup` to look up the row to update. */
export type DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdUsingDataTableColumnGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnGroup` being updated. */
    dataTableColumnGroupPatch: UpdateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumnGroup` to look up the row to update. */
export type DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingDataTableColumnGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumnGroup` being updated. */
    dataTableColumnGroupPatch: UpdateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** Input for the nested mutation of `project` in the `DataTableColumnGroupInput` mutation. */
export type DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableColumnGroup` in the `ProjectInput` mutation. */
export type DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput = {
  /** The primary key(s) for `dataTableColumnGroup` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnGroupDataTableColumnGroupPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnGroup` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingDataTableColumnGroupPkeyUpdate>
  >;
};

/** Input for the nested mutation of `dataTable` in the `DataTableColumnGroupInput` mutation. */
export type DataTableColumnGroupTableId46C58CccFkDataTableIdInput = {
  /** The primary key(s) for `dataTable` for the far side of the relationship. */
  connectById?: InputMaybe<DataTableDataTablePkeyConnect>;
  /** The primary key(s) and patch data for `dataTable` for the far side of the relationship. */
  updateById?: InputMaybe<DataTableOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdUsingDataTablePkeyUpdate>;
};

/** Input for the nested mutation of `dataTableColumnGroup` in the `DataTableInput` mutation. */
export type DataTableColumnGroupTableId46C58CccFkDataTableIdInverseInput = {
  /** The primary key(s) for `dataTableColumnGroup` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<DataTableColumnGroupDataTableColumnGroupPkeyConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumnGroup` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdUsingDataTableColumnGroupPkeyUpdate>
  >;
};

/** A filter to be used against many `DataTableColumn` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnGroupToManyDataTableColumnFilter = {
  /** Every related `DataTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnFilter>;
  /** No related `DataTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnFilter>;
  /** Some related `DataTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnFilter>;
};

/** The `applicationUser` to be created by this mutation. */
export type DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `DataTableColumnGroupInput` mutation. */
export type DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `dataTableColumnGroup` in the `ApplicationUserInput` mutation. */
export type DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput =
  {
    /** The primary key(s) for `dataTableColumnGroup` for the far side of the relationship. */
    connectById?: InputMaybe<
      Array<DataTableColumnGroupDataTableColumnGroupPkeyConnect>
    >;
    /** The primary key(s) and patch data for `dataTableColumnGroup` for the far side of the relationship. */
    updateById?: InputMaybe<
      Array<DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingDataTableColumnGroupPkeyUpdate>
    >;
  };

/** A connection to a list of `DataTableColumnGroup` values. */
export type DataTableColumnGroupsConnection = {
  __typename: "DataTableColumnGroupsConnection";
  /** A list of edges which contains the `DataTableColumnGroup` and cursor to aid in pagination. */
  edges: Array<DataTableColumnGroupsEdge>;
  /** A list of `DataTableColumnGroup` objects. */
  nodes: Array<DataTableColumnGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableColumnGroup` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableColumnGroup` edge in the connection. */
export type DataTableColumnGroupsEdge = {
  __typename: "DataTableColumnGroupsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableColumnGroup` at the end of the edge. */
  node: DataTableColumnGroup;
};

/** Methods to use when ordering `DataTableColumnGroup`. */
export enum DataTableColumnGroupsOrderBy {
  DateDeletedAsc = "DATE_DELETED_ASC",
  DateDeletedDesc = "DATE_DELETED_DESC",
  DefinitionIdAsc = "DEFINITION_ID_ASC",
  DefinitionIdDesc = "DEFINITION_ID_DESC",
  DefinitionTypeIdAsc = "DEFINITION_TYPE_ID_ASC",
  DefinitionTypeIdDesc = "DEFINITION_TYPE_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  TableIdAsc = "TABLE_ID_ASC",
  TableIdDesc = "TABLE_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** The fields on `dataTableColumn` to look up the row to update. */
export type DataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableColumnOrderUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumn` being updated. */
    dataTableColumnPatch: UpdateDataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdPatch;
    order: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumn` to look up the row to update. */
export type DataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableColumnPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumn` being updated. */
    dataTableColumnPatch: UpdateDataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumn` to look up the row to update. */
export type DataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDataTableColumnOrderUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumn` being updated. */
    dataTableColumnPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoPatch;
    order: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumn` to look up the row to update. */
export type DataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDataTableColumnPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumn` being updated. */
    dataTableColumnPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumn` to look up the row to update. */
export type DataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnOrderUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumn` being updated. */
    dataTableColumnPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablPatch;
    order: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumn` to look up the row to update. */
export type DataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumn` being updated. */
    dataTableColumnPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumn` to look up the row to update. */
export type DataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingDataTableColumnOrderUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumn` being updated. */
    dataTableColumnPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdPatch;
    order: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumn` to look up the row to update. */
export type DataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingDataTableColumnPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumn` being updated. */
    dataTableColumnPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumn` to look up the row to update. */
export type DataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTableColumnOrderUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumn` being updated. */
    dataTableColumnPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdPatch;
    order: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumn` to look up the row to update. */
export type DataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTableColumnPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumn` being updated. */
    dataTableColumnPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumn` to look up the row to update. */
export type DataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingDataTableColumnOrderUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumn` being updated. */
    dataTableColumnPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdPatch;
    order: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableColumn` to look up the row to update. */
export type DataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingDataTableColumnPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableColumn` being updated. */
    dataTableColumnPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** Input for the nested mutation of `project` in the `DataTableColumnInput` mutation. */
export type DataTableColumnProjectId91C18F88FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableColumn` in the `ProjectInput` mutation. */
export type DataTableColumnProjectId91C18F88FkProjectIdInverseInput = {
  /** The primary key(s) for `dataTableColumn` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableColumnDataTableColumnPkeyConnect>>;
  /** The primary key(s) for `dataTableColumn` for the far side of the relationship. */
  connectByTableIdAndOrder?: InputMaybe<
    Array<DataTableColumnDataTableColumnOrderUniqueConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumn` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingDataTableColumnPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `dataTableColumn` for the far side of the relationship. */
  updateByTableIdAndOrder?: InputMaybe<
    Array<DataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingDataTableColumnOrderUniqueUpdate>
  >;
};

/** Input for the nested mutation of `dataTable` in the `DataTableColumnInput` mutation. */
export type DataTableColumnTableIdF295C823FkDataTableIdInput = {
  /** The primary key(s) for `dataTable` for the far side of the relationship. */
  connectById?: InputMaybe<DataTableDataTablePkeyConnect>;
  /** The primary key(s) and patch data for `dataTable` for the far side of the relationship. */
  updateById?: InputMaybe<DataTableOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTablePkeyUpdate>;
};

/** Input for the nested mutation of `dataTableColumn` in the `DataTableInput` mutation. */
export type DataTableColumnTableIdF295C823FkDataTableIdInverseInput = {
  /** The primary key(s) for `dataTableColumn` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableColumnDataTableColumnPkeyConnect>>;
  /** The primary key(s) for `dataTableColumn` for the far side of the relationship. */
  connectByTableIdAndOrder?: InputMaybe<
    Array<DataTableColumnDataTableColumnOrderUniqueConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumn` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTableColumnPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `dataTableColumn` for the far side of the relationship. */
  updateByTableIdAndOrder?: InputMaybe<
    Array<DataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTableColumnOrderUniqueUpdate>
  >;
};

/** A filter to be used against many `DataTableCell` object types. All fields are combined with a logical ‘and.’ */
export type DataTableColumnToManyDataTableCellFilter = {
  /** Every related `DataTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableCellFilter>;
  /** No related `DataTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableCellFilter>;
  /** Some related `DataTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableCellFilter>;
};

/** The `applicationUser` to be created by this mutation. */
export type DataTableColumnUserId57054882FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `DataTableColumnInput` mutation. */
export type DataTableColumnUserId57054882FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `dataTableColumn` in the `ApplicationUserInput` mutation. */
export type DataTableColumnUserId57054882FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `dataTableColumn` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableColumnDataTableColumnPkeyConnect>>;
  /** The primary key(s) for `dataTableColumn` for the far side of the relationship. */
  connectByTableIdAndOrder?: InputMaybe<
    Array<DataTableColumnDataTableColumnOrderUniqueConnect>
  >;
  /** The primary key(s) and patch data for `dataTableColumn` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingDataTableColumnPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `dataTableColumn` for the far side of the relationship. */
  updateByTableIdAndOrder?: InputMaybe<
    Array<DataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingDataTableColumnOrderUniqueUpdate>
  >;
};

/** A connection to a list of `DataTableColumn` values. */
export type DataTableColumnsConnection = {
  __typename: "DataTableColumnsConnection";
  /** A list of edges which contains the `DataTableColumn` and cursor to aid in pagination. */
  edges: Array<DataTableColumnsEdge>;
  /** A list of `DataTableColumn` objects. */
  nodes: Array<DataTableColumn>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableColumn` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableColumn` edge in the connection. */
export type DataTableColumnsEdge = {
  __typename: "DataTableColumnsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableColumn` at the end of the edge. */
  node: DataTableColumn;
};

/** Methods to use when ordering `DataTableColumn`. */
export enum DataTableColumnsOrderBy {
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DateDeletedAsc = "DATE_DELETED_ASC",
  DateDeletedDesc = "DATE_DELETED_DESC",
  DefaultFormulaAsc = "DEFAULT_FORMULA_ASC",
  DefaultFormulaDesc = "DEFAULT_FORMULA_DESC",
  DefinitionIdAsc = "DEFINITION_ID_ASC",
  DefinitionIdDesc = "DEFINITION_ID_DESC",
  DefinitionTypeIdAsc = "DEFINITION_TYPE_ID_ASC",
  DefinitionTypeIdDesc = "DEFINITION_TYPE_ID_DESC",
  DeletableAsc = "DELETABLE_ASC",
  DeletableDesc = "DELETABLE_DESC",
  EditableAsc = "EDITABLE_ASC",
  EditableDesc = "EDITABLE_DESC",
  GroupIdAsc = "GROUP_ID_ASC",
  GroupIdDesc = "GROUP_ID_DESC",
  HelpTextAsc = "HELP_TEXT_ASC",
  HelpTextDesc = "HELP_TEXT_DESC",
  IdentifierPositionAsc = "IDENTIFIER_POSITION_ASC",
  IdentifierPositionDesc = "IDENTIFIER_POSITION_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  IsIdColumnAsc = "IS_ID_COLUMN_ASC",
  IsIdColumnDesc = "IS_ID_COLUMN_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  OrderAsc = "ORDER_ASC",
  OrderDesc = "ORDER_DESC",
  PinnedAsc = "PINNED_ASC",
  PinnedDesc = "PINNED_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  TableIdAsc = "TABLE_ID_ASC",
  TableIdDesc = "TABLE_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
  WidthAsc = "WIDTH_ASC",
  WidthDesc = "WIDTH_DESC",
}

/**
 * A condition to be used against `DataTable` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type DataTableCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `folderId` field. */
  folderId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `hidden` field. */
  hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `dataTable` to look up the row to connect. */
export type DataTableDataTablePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** A filter to be used against `DataTable` object types. All fields are combined with a logical ‘and.’ */
export type DataTableFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dataTableCellsByTableId` relation. */
  dataTableCellsByTableId?: InputMaybe<DataTableToManyDataTableCellFilter>;
  /** Some related `dataTableCellsByTableId` exist. */
  dataTableCellsByTableIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dataTableColumnGroupsByTableId` relation. */
  dataTableColumnGroupsByTableId?: InputMaybe<DataTableToManyDataTableColumnGroupFilter>;
  /** Some related `dataTableColumnGroupsByTableId` exist. */
  dataTableColumnGroupsByTableIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dataTableColumnsByTableId` relation. */
  dataTableColumnsByTableId?: InputMaybe<DataTableToManyDataTableColumnFilter>;
  /** Some related `dataTableColumnsByTableId` exist. */
  dataTableColumnsByTableIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dataTableRowsByTableId` relation. */
  dataTableRowsByTableId?: InputMaybe<DataTableToManyDataTableRowFilter>;
  /** Some related `dataTableRowsByTableId` exist. */
  dataTableRowsByTableIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `folderId` field. */
  folderId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `hidden` field. */
  hidden?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectFolderByFolderId` relation. */
  projectFolderByFolderId?: InputMaybe<ProjectFolderFilter>;
  /** A related `projectFolderByFolderId` exists. */
  projectFolderByFolderIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** Input for the nested mutation of `projectFolder` in the `DataTableInput` mutation. */
export type DataTableFolderId4Fe6C7FeFkProjectFolderIdInput = {
  /** The primary key(s) for `projectFolder` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectFolderProjectFolderPkeyConnect>;
  /** A `ProjectFolderInput` object that will be created and connected to this object. */
  create?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdProjectFolderCreateInput>;
  /** The primary key(s) for `projectFolder` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectFolderProjectFolderPkeyDelete>;
  /** The primary key(s) and patch data for `projectFolder` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingProjectFolderPkeyUpdate>;
};

/** Input for the nested mutation of `dataTable` in the `ProjectFolderInput` mutation. */
export type DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput = {
  /** The primary key(s) for `dataTable` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableDataTablePkeyConnect>>;
  /** The primary key(s) and patch data for `dataTable` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingDataTablePkeyUpdate>
  >;
};

/** The `projectFolder` to be created by this mutation. */
export type DataTableFolderId4Fe6C7FeFkProjectFolderIdProjectFolderCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInput>;
    color?: InputMaybe<Scalars["String"]["input"]>;
    dataTablesUsingId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput>;
    id: Scalars["UUID"]["input"];
    name: Scalars["String"]["input"];
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** The fields on `dataTable` to look up the row to update. */
export type DataTableOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTablePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTable` being updated. */
    dataTablePatch: UpdateDataTableOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTable` to look up the row to update. */
export type DataTableOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTablePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTable` being updated. */
    dataTablePatch: UpdateDataTableOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTable` to look up the row to update. */
export type DataTableOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdUsingDataTablePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTable` being updated. */
    dataTablePatch: UpdateDataTableOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTable` to look up the row to update. */
export type DataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingDataTablePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTable` being updated. */
    dataTablePatch: UpdateDataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTable` to look up the row to update. */
export type DataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingDataTablePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTable` being updated. */
    dataTablePatch: UpdateDataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTable` to look up the row to update. */
export type DataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingDataTablePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTable` being updated. */
    dataTablePatch: UpdateDataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTable` to look up the row to update. */
export type DataTableOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTablePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTable` being updated. */
    dataTablePatch: UpdateDataTableOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** Input for the nested mutation of `project` in the `DataTableInput` mutation. */
export type DataTableProjectId59F60EaeFkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTable` in the `ProjectInput` mutation. */
export type DataTableProjectId59F60EaeFkProjectIdInverseInput = {
  /** The primary key(s) for `dataTable` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableDataTablePkeyConnect>>;
  /** The primary key(s) and patch data for `dataTable` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingDataTablePkeyUpdate>
  >;
};

export type DataTableRow = {
  __typename: "DataTableRow";
  /** Reads a single `ApplicationUser` that is related to this `DataTableRow`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** Reads a single `DataTable` that is related to this `DataTableRow`. */
  dataTableByTableId: Maybe<DataTable>;
  /** Reads and enables pagination through a set of `DataTableCell`. */
  dataTableCellsByRowId: DataTableCellsConnection;
  dateCreated: Scalars["Datetime"]["output"];
  dateDeleted: Maybe<Scalars["Datetime"]["output"]>;
  editable: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  index: Scalars["Int"]["output"];
  joinable: Scalars["Boolean"]["output"];
  /** Reads a single `Project` that is related to this `DataTableRow`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  tableId: Scalars["UUID"]["output"];
  userId: Scalars["UUID"]["output"];
};

export type DataTableRowDataTableCellsByRowIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableCellCondition>;
  filter?: InputMaybe<DataTableCellFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableCellsOrderBy>>;
};

/**
 * A condition to be used against `DataTableRow` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DataTableRowCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `editable` field. */
  editable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `joinable` field. */
  joinable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tableId` field. */
  tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `dataTableRow` to look up the row to connect. */
export type DataTableRowDataTableRowPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `dataTableRow` to look up the row to connect. */
export type DataTableRowDataTableRowUniqueConnect = {
  index: Scalars["Int"]["input"];
  tableId: Scalars["UUID"]["input"];
};

/** A filter to be used against `DataTableRow` object types. All fields are combined with a logical ‘and.’ */
export type DataTableRowFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataTableRowFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dataTableByTableId` relation. */
  dataTableByTableId?: InputMaybe<DataTableFilter>;
  /** Filter by the object’s `dataTableCellsByRowId` relation. */
  dataTableCellsByRowId?: InputMaybe<DataTableRowToManyDataTableCellFilter>;
  /** Some related `dataTableCellsByRowId` exist. */
  dataTableCellsByRowIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `editable` field. */
  editable?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `joinable` field. */
  joinable?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DataTableRowFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataTableRowFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tableId` field. */
  tableId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `dataTableRow` to look up the row to update. */
export type DataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableRowPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableRow` being updated. */
    dataTableRowPatch: UpdateDataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableRow` to look up the row to update. */
export type DataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableRowUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableRow` being updated. */
    dataTableRowPatch: UpdateDataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdPatch;
    index: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableRow` to look up the row to update. */
export type DataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingDataTableRowPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableRow` being updated. */
    dataTableRowPatch: UpdateDataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableRow` to look up the row to update. */
export type DataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingDataTableRowUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableRow` being updated. */
    dataTableRowPatch: UpdateDataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdPatch;
    index: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableRow` to look up the row to update. */
export type DataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTableRowPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableRow` being updated. */
    dataTableRowPatch: UpdateDataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableRow` to look up the row to update. */
export type DataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTableRowUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableRow` being updated. */
    dataTableRowPatch: UpdateDataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdPatch;
    index: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableRow` to look up the row to update. */
export type DataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingDataTableRowPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableRow` being updated. */
    dataTableRowPatch: UpdateDataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `dataTableRow` to look up the row to update. */
export type DataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingDataTableRowUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `dataTableRow` being updated. */
    dataTableRowPatch: UpdateDataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdPatch;
    index: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** Input for the nested mutation of `project` in the `DataTableRowInput` mutation. */
export type DataTableRowProjectId43Bf0Ab0FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `dataTableRow` in the `ProjectInput` mutation. */
export type DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput = {
  /** The primary key(s) for `dataTableRow` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableRowDataTableRowPkeyConnect>>;
  /** The primary key(s) for `dataTableRow` for the far side of the relationship. */
  connectByTableIdAndIndex?: InputMaybe<
    Array<DataTableRowDataTableRowUniqueConnect>
  >;
  /** The primary key(s) and patch data for `dataTableRow` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingDataTableRowPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `dataTableRow` for the far side of the relationship. */
  updateByTableIdAndIndex?: InputMaybe<
    Array<DataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingDataTableRowUniqueUpdate>
  >;
};

/** Input for the nested mutation of `dataTable` in the `DataTableRowInput` mutation. */
export type DataTableRowTableIdF77C2D36FkDataTableIdInput = {
  /** The primary key(s) for `dataTable` for the far side of the relationship. */
  connectById?: InputMaybe<DataTableDataTablePkeyConnect>;
  /** The primary key(s) and patch data for `dataTable` for the far side of the relationship. */
  updateById?: InputMaybe<DataTableOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTablePkeyUpdate>;
};

/** Input for the nested mutation of `dataTableRow` in the `DataTableInput` mutation. */
export type DataTableRowTableIdF77C2D36FkDataTableIdInverseInput = {
  /** The primary key(s) for `dataTableRow` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableRowDataTableRowPkeyConnect>>;
  /** The primary key(s) for `dataTableRow` for the far side of the relationship. */
  connectByTableIdAndIndex?: InputMaybe<
    Array<DataTableRowDataTableRowUniqueConnect>
  >;
  /** The primary key(s) and patch data for `dataTableRow` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTableRowPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `dataTableRow` for the far side of the relationship. */
  updateByTableIdAndIndex?: InputMaybe<
    Array<DataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTableRowUniqueUpdate>
  >;
};

/** A filter to be used against many `DataTableCell` object types. All fields are combined with a logical ‘and.’ */
export type DataTableRowToManyDataTableCellFilter = {
  /** Every related `DataTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableCellFilter>;
  /** No related `DataTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableCellFilter>;
  /** Some related `DataTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableCellFilter>;
};

/** The `applicationUser` to be created by this mutation. */
export type DataTableRowUserId3C5E98E5FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `DataTableRowInput` mutation. */
export type DataTableRowUserId3C5E98E5FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `dataTableRow` in the `ApplicationUserInput` mutation. */
export type DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `dataTableRow` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableRowDataTableRowPkeyConnect>>;
  /** The primary key(s) for `dataTableRow` for the far side of the relationship. */
  connectByTableIdAndIndex?: InputMaybe<
    Array<DataTableRowDataTableRowUniqueConnect>
  >;
  /** The primary key(s) and patch data for `dataTableRow` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingDataTableRowPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `dataTableRow` for the far side of the relationship. */
  updateByTableIdAndIndex?: InputMaybe<
    Array<DataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingDataTableRowUniqueUpdate>
  >;
};

/** A connection to a list of `DataTableRow` values. */
export type DataTableRowsConnection = {
  __typename: "DataTableRowsConnection";
  /** A list of edges which contains the `DataTableRow` and cursor to aid in pagination. */
  edges: Array<DataTableRowsEdge>;
  /** A list of `DataTableRow` objects. */
  nodes: Array<DataTableRow>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTableRow` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTableRow` edge in the connection. */
export type DataTableRowsEdge = {
  __typename: "DataTableRowsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTableRow` at the end of the edge. */
  node: DataTableRow;
};

/** Methods to use when ordering `DataTableRow`. */
export enum DataTableRowsOrderBy {
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DateDeletedAsc = "DATE_DELETED_ASC",
  DateDeletedDesc = "DATE_DELETED_DESC",
  EditableAsc = "EDITABLE_ASC",
  EditableDesc = "EDITABLE_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  IndexAsc = "INDEX_ASC",
  IndexDesc = "INDEX_DESC",
  JoinableAsc = "JOINABLE_ASC",
  JoinableDesc = "JOINABLE_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  TableIdAsc = "TABLE_ID_ASC",
  TableIdDesc = "TABLE_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** A filter to be used against many `DataTableCell` object types. All fields are combined with a logical ‘and.’ */
export type DataTableToManyDataTableCellFilter = {
  /** Every related `DataTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableCellFilter>;
  /** No related `DataTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableCellFilter>;
  /** Some related `DataTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableCellFilter>;
};

/** A filter to be used against many `DataTableColumn` object types. All fields are combined with a logical ‘and.’ */
export type DataTableToManyDataTableColumnFilter = {
  /** Every related `DataTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnFilter>;
  /** No related `DataTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnFilter>;
  /** Some related `DataTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnFilter>;
};

/** A filter to be used against many `DataTableColumnGroup` object types. All fields are combined with a logical ‘and.’ */
export type DataTableToManyDataTableColumnGroupFilter = {
  /** Every related `DataTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnGroupFilter>;
  /** No related `DataTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnGroupFilter>;
  /** Some related `DataTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnGroupFilter>;
};

/** A filter to be used against many `DataTableRow` object types. All fields are combined with a logical ‘and.’ */
export type DataTableToManyDataTableRowFilter = {
  /** Every related `DataTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableRowFilter>;
  /** No related `DataTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableRowFilter>;
  /** Some related `DataTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableRowFilter>;
};

/** The `applicationUser` to be created by this mutation. */
export type DataTableUserIdAb79B056FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `DataTableInput` mutation. */
export type DataTableUserIdAb79B056FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `dataTable` in the `ApplicationUserInput` mutation. */
export type DataTableUserIdAb79B056FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `dataTable` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DataTableDataTablePkeyConnect>>;
  /** The primary key(s) and patch data for `dataTable` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingDataTablePkeyUpdate>
  >;
};

/** A connection to a list of `DataTable` values. */
export type DataTablesConnection = {
  __typename: "DataTablesConnection";
  /** A list of edges which contains the `DataTable` and cursor to aid in pagination. */
  edges: Array<DataTablesEdge>;
  /** A list of `DataTable` objects. */
  nodes: Array<DataTable>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DataTable` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DataTable` edge in the connection. */
export type DataTablesEdge = {
  __typename: "DataTablesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DataTable` at the end of the edge. */
  node: DataTable;
};

/** Methods to use when ordering `DataTable`. */
export enum DataTablesOrderBy {
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DateDeletedAsc = "DATE_DELETED_ASC",
  DateDeletedDesc = "DATE_DELETED_DESC",
  DescriptionAsc = "DESCRIPTION_ASC",
  DescriptionDesc = "DESCRIPTION_DESC",
  FolderIdAsc = "FOLDER_ID_ASC",
  FolderIdDesc = "FOLDER_ID_DESC",
  HiddenAsc = "HIDDEN_ASC",
  HiddenDesc = "HIDDEN_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  KeyAsc = "KEY_ASC",
  KeyDesc = "KEY_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** A filter to be used against Date fields. All fields are combined with a logical ‘and.’ */
export type DateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["Date"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["Date"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["Date"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["Date"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["Date"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["Date"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["Date"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["Date"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["Date"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["Date"]["input"]>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["Datetime"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["Datetime"]["input"]>>;
};

/** All input for the `deleteApplicationUserByEmail` mutation. */
export type DeleteApplicationUserByEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
};

/** All input for the `deleteApplicationUserByGlobalUserId` mutation. */
export type DeleteApplicationUserByGlobalUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  globalUserId: Scalars["UUID"]["input"];
};

/** All input for the `deleteApplicationUserById` mutation. */
export type DeleteApplicationUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** All input for the `deleteApplicationUserByUsername` mutation. */
export type DeleteApplicationUserByUsernameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  username: Scalars["String"]["input"];
};

/** All input for the `deleteApplicationUserGroupById` mutation. */
export type DeleteApplicationUserGroupByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** All input for the `deleteApplicationUserGroupByUserIdAndGroupId` mutation. */
export type DeleteApplicationUserGroupByUserIdAndGroupIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  groupId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The output of our delete `ApplicationUserGroup` mutation. */
export type DeleteApplicationUserGroupPayload = {
  __typename: "DeleteApplicationUserGroupPayload";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserGroup`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserGroup` that was deleted by this mutation. */
  applicationUserGroup: Maybe<ApplicationUserGroup>;
  /** An edge for our `ApplicationUserGroup`. May be used by Relay 1. */
  applicationUserGroupEdge: Maybe<ApplicationUserGroupsEdge>;
  /** Reads a single `AuthGroup` that is related to this `ApplicationUserGroup`. */
  authGroupByGroupId: Maybe<AuthGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedApplicationUserGroupId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `ApplicationUserGroup` mutation. */
export type DeleteApplicationUserGroupPayloadApplicationUserGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ApplicationUserGroupsOrderBy>>;
};

/** All input for the `deleteApplicationUserMembershipById` mutation. */
export type DeleteApplicationUserMembershipByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteApplicationUserMembershipByUserIdAndTenantId` mutation. */
export type DeleteApplicationUserMembershipByUserIdAndTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  tenantId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The output of our delete `ApplicationUserMembership` mutation. */
export type DeleteApplicationUserMembershipPayload = {
  __typename: "DeleteApplicationUserMembershipPayload";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserMembership`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserMembership` that was deleted by this mutation. */
  applicationUserMembership: Maybe<ApplicationUserMembership>;
  /** An edge for our `ApplicationUserMembership`. May be used by Relay 1. */
  applicationUserMembershipEdge: Maybe<ApplicationUserMembershipsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedApplicationUserMembershipId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ApplicationUserMembership`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our delete `ApplicationUserMembership` mutation. */
export type DeleteApplicationUserMembershipPayloadApplicationUserMembershipEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ApplicationUserMembershipsOrderBy>>;
  };

/** All input for the `deleteApplicationUserMetadatumById` mutation. */
export type DeleteApplicationUserMetadatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteApplicationUserMetadatumByUserIdAndKey` mutation. */
export type DeleteApplicationUserMetadatumByUserIdAndKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  key: Scalars["String"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The output of our delete `ApplicationUserMetadatum` mutation. */
export type DeleteApplicationUserMetadatumPayload = {
  __typename: "DeleteApplicationUserMetadatumPayload";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserMetadatum`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserMetadatum` that was deleted by this mutation. */
  applicationUserMetadatum: Maybe<ApplicationUserMetadatum>;
  /** An edge for our `ApplicationUserMetadatum`. May be used by Relay 1. */
  applicationUserMetadatumEdge: Maybe<ApplicationUserMetadataEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedApplicationUserMetadatumId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `ApplicationUserMetadatum` mutation. */
export type DeleteApplicationUserMetadatumPayloadApplicationUserMetadatumEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ApplicationUserMetadataOrderBy>>;
  };

/** The output of our delete `ApplicationUser` mutation. */
export type DeleteApplicationUserPayload = {
  __typename: "DeleteApplicationUserPayload";
  /** The `ApplicationUser` that was deleted by this mutation. */
  applicationUser: Maybe<ApplicationUser>;
  /** An edge for our `ApplicationUser`. May be used by Relay 1. */
  applicationUserEdge: Maybe<ApplicationUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedApplicationUserId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `ApplicationUser` mutation. */
export type DeleteApplicationUserPayloadApplicationUserEdgeArgs = {
  orderBy?: InputMaybe<Array<ApplicationUsersOrderBy>>;
};

/** All input for the `deleteApplicationUserSessionById` mutation. */
export type DeleteApplicationUserSessionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `ApplicationUserSession` mutation. */
export type DeleteApplicationUserSessionPayload = {
  __typename: "DeleteApplicationUserSessionPayload";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserSession`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserSession` that was deleted by this mutation. */
  applicationUserSession: Maybe<ApplicationUserSession>;
  /** An edge for our `ApplicationUserSession`. May be used by Relay 1. */
  applicationUserSessionEdge: Maybe<ApplicationUserSessionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedApplicationUserSessionId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ApplicationUserSession`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our delete `ApplicationUserSession` mutation. */
export type DeleteApplicationUserSessionPayloadApplicationUserSessionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ApplicationUserSessionsOrderBy>>;
  };

/** All input for the `deleteApplicationUserUserPermissionById` mutation. */
export type DeleteApplicationUserUserPermissionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** All input for the `deleteApplicationUserUserPermissionByUserIdAndPermissionId` mutation. */
export type DeleteApplicationUserUserPermissionByUserIdAndPermissionIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  permissionId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The output of our delete `ApplicationUserUserPermission` mutation. */
export type DeleteApplicationUserUserPermissionPayload = {
  __typename: "DeleteApplicationUserUserPermissionPayload";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserUserPermission`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserUserPermission` that was deleted by this mutation. */
  applicationUserUserPermission: Maybe<ApplicationUserUserPermission>;
  /** An edge for our `ApplicationUserUserPermission`. May be used by Relay 1. */
  applicationUserUserPermissionEdge: Maybe<ApplicationUserUserPermissionsEdge>;
  /** Reads a single `AuthPermission` that is related to this `ApplicationUserUserPermission`. */
  authPermissionByPermissionId: Maybe<AuthPermission>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedApplicationUserUserPermissionId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `ApplicationUserUserPermission` mutation. */
export type DeleteApplicationUserUserPermissionPayloadApplicationUserUserPermissionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ApplicationUserUserPermissionsOrderBy>>;
  };

/** All input for the `deleteAuditlogLogentryById` mutation. */
export type DeleteAuditlogLogentryByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `AuditlogLogentry` mutation. */
export type DeleteAuditlogLogentryPayload = {
  __typename: "DeleteAuditlogLogentryPayload";
  /** Reads a single `ApplicationUser` that is related to this `AuditlogLogentry`. */
  applicationUserByActorId: Maybe<ApplicationUser>;
  /** The `AuditlogLogentry` that was deleted by this mutation. */
  auditlogLogentry: Maybe<AuditlogLogentry>;
  /** An edge for our `AuditlogLogentry`. May be used by Relay 1. */
  auditlogLogentryEdge: Maybe<AuditlogLogentriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedAuditlogLogentryId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `AuditlogLogentry`. */
  djangoContentTypeByContentTypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `AuditlogLogentry` mutation. */
export type DeleteAuditlogLogentryPayloadAuditlogLogentryEdgeArgs = {
  orderBy?: InputMaybe<Array<AuditlogLogentriesOrderBy>>;
};

/** All input for the `deleteAuthGroupById` mutation. */
export type DeleteAuthGroupByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteAuthGroupByName` mutation. */
export type DeleteAuthGroupByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

/** The output of our delete `AuthGroup` mutation. */
export type DeleteAuthGroupPayload = {
  __typename: "DeleteAuthGroupPayload";
  /** The `AuthGroup` that was deleted by this mutation. */
  authGroup: Maybe<AuthGroup>;
  /** An edge for our `AuthGroup`. May be used by Relay 1. */
  authGroupEdge: Maybe<AuthGroupsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedAuthGroupId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `AuthGroup` mutation. */
export type DeleteAuthGroupPayloadAuthGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<AuthGroupsOrderBy>>;
};

/** All input for the `deleteAuthGroupPermissionByGroupIdAndPermissionId` mutation. */
export type DeleteAuthGroupPermissionByGroupIdAndPermissionIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  groupId: Scalars["Int"]["input"];
  permissionId: Scalars["Int"]["input"];
};

/** All input for the `deleteAuthGroupPermissionById` mutation. */
export type DeleteAuthGroupPermissionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** The output of our delete `AuthGroupPermission` mutation. */
export type DeleteAuthGroupPermissionPayload = {
  __typename: "DeleteAuthGroupPermissionPayload";
  /** Reads a single `AuthGroup` that is related to this `AuthGroupPermission`. */
  authGroupByGroupId: Maybe<AuthGroup>;
  /** The `AuthGroupPermission` that was deleted by this mutation. */
  authGroupPermission: Maybe<AuthGroupPermission>;
  /** An edge for our `AuthGroupPermission`. May be used by Relay 1. */
  authGroupPermissionEdge: Maybe<AuthGroupPermissionsEdge>;
  /** Reads a single `AuthPermission` that is related to this `AuthGroupPermission`. */
  authPermissionByPermissionId: Maybe<AuthPermission>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedAuthGroupPermissionId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `AuthGroupPermission` mutation. */
export type DeleteAuthGroupPermissionPayloadAuthGroupPermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<AuthGroupPermissionsOrderBy>>;
};

/** All input for the `deleteAuthPermissionByContentTypeIdAndCodename` mutation. */
export type DeleteAuthPermissionByContentTypeIdAndCodenameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  codename: Scalars["String"]["input"];
  contentTypeId: Scalars["Int"]["input"];
};

/** All input for the `deleteAuthPermissionById` mutation. */
export type DeleteAuthPermissionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `AuthPermission` mutation. */
export type DeleteAuthPermissionPayload = {
  __typename: "DeleteAuthPermissionPayload";
  /** The `AuthPermission` that was deleted by this mutation. */
  authPermission: Maybe<AuthPermission>;
  /** An edge for our `AuthPermission`. May be used by Relay 1. */
  authPermissionEdge: Maybe<AuthPermissionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedAuthPermissionId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `AuthPermission`. */
  djangoContentTypeByContentTypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `AuthPermission` mutation. */
export type DeleteAuthPermissionPayloadAuthPermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<AuthPermissionsOrderBy>>;
};

/** All input for the `deleteAvatarById` mutation. */
export type DeleteAvatarByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** All input for the `deleteAvatarByUserId` mutation. */
export type DeleteAvatarByUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  userId: Scalars["UUID"]["input"];
};

/** The output of our delete `Avatar` mutation. */
export type DeleteAvatarPayload = {
  __typename: "DeleteAvatarPayload";
  /** Reads a single `ApplicationUser` that is related to this `Avatar`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `Avatar` that was deleted by this mutation. */
  avatar: Maybe<Avatar>;
  /** An edge for our `Avatar`. May be used by Relay 1. */
  avatarEdge: Maybe<AvatarsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedAvatarId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `Avatar` mutation. */
export type DeleteAvatarPayloadAvatarEdgeArgs = {
  orderBy?: InputMaybe<Array<AvatarsOrderBy>>;
};

/** All input for the `deleteAwsBatchTaskByTaskexecutorPtrId` mutation. */
export type DeleteAwsBatchTaskByTaskexecutorPtrIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  taskexecutorPtrId: Scalars["UUID"]["input"];
};

/** The output of our delete `AwsBatchTask` mutation. */
export type DeleteAwsBatchTaskPayload = {
  __typename: "DeleteAwsBatchTaskPayload";
  /** The `AwsBatchTask` that was deleted by this mutation. */
  awsBatchTask: Maybe<AwsBatchTask>;
  /** An edge for our `AwsBatchTask`. May be used by Relay 1. */
  awsBatchTaskEdge: Maybe<AwsBatchTasksEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedAwsBatchTaskId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TesTaskexecutor` that is related to this `AwsBatchTask`. */
  tesTaskexecutorByTaskexecutorPtrId: Maybe<TesTaskexecutor>;
};

/** The output of our delete `AwsBatchTask` mutation. */
export type DeleteAwsBatchTaskPayloadAwsBatchTaskEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsBatchTasksOrderBy>>;
};

/** All input for the `deleteAwsCognitoUserByUserexecutorPtrId` mutation. */
export type DeleteAwsCognitoUserByUserexecutorPtrIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  userexecutorPtrId: Scalars["Int"]["input"];
};

/** The output of our delete `AwsCognitoUser` mutation. */
export type DeleteAwsCognitoUserPayload = {
  __typename: "DeleteAwsCognitoUserPayload";
  /** The `AwsCognitoUser` that was deleted by this mutation. */
  awsCognitoUser: Maybe<AwsCognitoUser>;
  /** An edge for our `AwsCognitoUser`. May be used by Relay 1. */
  awsCognitoUserEdge: Maybe<AwsCognitoUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedAwsCognitoUserId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TenantUserexecutor` that is related to this `AwsCognitoUser`. */
  tenantUserexecutorByUserexecutorPtrId: Maybe<TenantUserexecutor>;
};

/** The output of our delete `AwsCognitoUser` mutation. */
export type DeleteAwsCognitoUserPayloadAwsCognitoUserEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsCognitoUsersOrderBy>>;
};

/** All input for the `deleteAwsEcrImageByContainerimageexecutorPtrId` mutation. */
export type DeleteAwsEcrImageByContainerimageexecutorPtrIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  containerimageexecutorPtrId: Scalars["Int"]["input"];
};

/** The output of our delete `AwsEcrImage` mutation. */
export type DeleteAwsEcrImagePayload = {
  __typename: "DeleteAwsEcrImagePayload";
  /** The `AwsEcrImage` that was deleted by this mutation. */
  awsEcrImage: Maybe<AwsEcrImage>;
  /** An edge for our `AwsEcrImage`. May be used by Relay 1. */
  awsEcrImageEdge: Maybe<AwsEcrImagesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedAwsEcrImageId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TesContainerimageexecutor` that is related to this `AwsEcrImage`. */
  tesContainerimageexecutorByContainerimageexecutorPtrId: Maybe<TesContainerimageexecutor>;
};

/** The output of our delete `AwsEcrImage` mutation. */
export type DeleteAwsEcrImagePayloadAwsEcrImageEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsEcrImagesOrderBy>>;
};

/** All input for the `deleteAwsMockBatchTaskByAwstaskexecutorPtrId` mutation. */
export type DeleteAwsMockBatchTaskByAwstaskexecutorPtrIdInput = {
  awstaskexecutorPtrId: Scalars["UUID"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our delete `AwsMockBatchTask` mutation. */
export type DeleteAwsMockBatchTaskPayload = {
  __typename: "DeleteAwsMockBatchTaskPayload";
  /** Reads a single `AwsBatchTask` that is related to this `AwsMockBatchTask`. */
  awsBatchTaskByAwstaskexecutorPtrId: Maybe<AwsBatchTask>;
  /** The `AwsMockBatchTask` that was deleted by this mutation. */
  awsMockBatchTask: Maybe<AwsMockBatchTask>;
  /** An edge for our `AwsMockBatchTask`. May be used by Relay 1. */
  awsMockBatchTaskEdge: Maybe<AwsMockBatchTasksEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedAwsMockBatchTaskId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `AwsMockBatchTask` mutation. */
export type DeleteAwsMockBatchTaskPayloadAwsMockBatchTaskEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsMockBatchTasksOrderBy>>;
};

/** All input for the `deleteAwsMockDistributionImageByDistributioncontainerimageexecutorPtrId` mutation. */
export type DeleteAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    distributioncontainerimageexecutorPtrId: Scalars["Int"]["input"];
  };

/** The output of our delete `AwsMockDistributionImage` mutation. */
export type DeleteAwsMockDistributionImagePayload = {
  __typename: "DeleteAwsMockDistributionImagePayload";
  /** The `AwsMockDistributionImage` that was deleted by this mutation. */
  awsMockDistributionImage: Maybe<AwsMockDistributionImage>;
  /** An edge for our `AwsMockDistributionImage`. May be used by Relay 1. */
  awsMockDistributionImageEdge: Maybe<AwsMockDistributionImagesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedAwsMockDistributionImageId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `DistributionRegistryImage` that is related to this `AwsMockDistributionImage`. */
  distributionRegistryImageByDistributioncontainerimageexecutorPtrId: Maybe<DistributionRegistryImage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `AwsMockDistributionImage` mutation. */
export type DeleteAwsMockDistributionImagePayloadAwsMockDistributionImageEdgeArgs =
  {
    orderBy?: InputMaybe<Array<AwsMockDistributionImagesOrderBy>>;
  };

/** All input for the `deleteAwsMockEcrImageByAwscontainerimageexecutorPtrId` mutation. */
export type DeleteAwsMockEcrImageByAwscontainerimageexecutorPtrIdInput = {
  awscontainerimageexecutorPtrId: Scalars["Int"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our delete `AwsMockEcrImage` mutation. */
export type DeleteAwsMockEcrImagePayload = {
  __typename: "DeleteAwsMockEcrImagePayload";
  /** Reads a single `AwsEcrImage` that is related to this `AwsMockEcrImage`. */
  awsEcrImageByAwscontainerimageexecutorPtrId: Maybe<AwsEcrImage>;
  /** The `AwsMockEcrImage` that was deleted by this mutation. */
  awsMockEcrImage: Maybe<AwsMockEcrImage>;
  /** An edge for our `AwsMockEcrImage`. May be used by Relay 1. */
  awsMockEcrImageEdge: Maybe<AwsMockEcrImagesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedAwsMockEcrImageId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `AwsMockEcrImage` mutation. */
export type DeleteAwsMockEcrImagePayloadAwsMockEcrImageEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsMockEcrImagesOrderBy>>;
};

/** All input for the `deleteAwsMockIamUserByAwsuserexecutorPtrId` mutation. */
export type DeleteAwsMockIamUserByAwsuserexecutorPtrIdInput = {
  awsuserexecutorPtrId: Scalars["Int"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our delete `AwsMockIamUser` mutation. */
export type DeleteAwsMockIamUserPayload = {
  __typename: "DeleteAwsMockIamUserPayload";
  /** Reads a single `AwsCognitoUser` that is related to this `AwsMockIamUser`. */
  awsCognitoUserByAwsuserexecutorPtrId: Maybe<AwsCognitoUser>;
  /** The `AwsMockIamUser` that was deleted by this mutation. */
  awsMockIamUser: Maybe<AwsMockIamUser>;
  /** An edge for our `AwsMockIamUser`. May be used by Relay 1. */
  awsMockIamUserEdge: Maybe<AwsMockIamUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedAwsMockIamUserId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `AwsMockIamUser` mutation. */
export type DeleteAwsMockIamUserPayloadAwsMockIamUserEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsMockIamUsersOrderBy>>;
};

/** All input for the `deleteAwsMockS3FileByAwsfileexecutorPtrId` mutation. */
export type DeleteAwsMockS3FileByAwsfileexecutorPtrIdInput = {
  awsfileexecutorPtrId: Scalars["UUID"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our delete `AwsMockS3File` mutation. */
export type DeleteAwsMockS3FilePayload = {
  __typename: "DeleteAwsMockS3FilePayload";
  /** The `AwsMockS3File` that was deleted by this mutation. */
  awsMockS3File: Maybe<AwsMockS3File>;
  /** An edge for our `AwsMockS3File`. May be used by Relay 1. */
  awsMockS3FileEdge: Maybe<AwsMockS3FilesEdge>;
  /** Reads a single `AwsS3File` that is related to this `AwsMockS3File`. */
  awsS3FileByAwsfileexecutorPtrId: Maybe<AwsS3File>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedAwsMockS3FileId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `AwsMockS3File` mutation. */
export type DeleteAwsMockS3FilePayloadAwsMockS3FileEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsMockS3FilesOrderBy>>;
};

/** All input for the `deleteAwsS3FileByFileexecutorPtrId` mutation. */
export type DeleteAwsS3FileByFileexecutorPtrIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  fileexecutorPtrId: Scalars["UUID"]["input"];
};

/** The output of our delete `AwsS3File` mutation. */
export type DeleteAwsS3FilePayload = {
  __typename: "DeleteAwsS3FilePayload";
  /** The `AwsS3File` that was deleted by this mutation. */
  awsS3File: Maybe<AwsS3File>;
  /** An edge for our `AwsS3File`. May be used by Relay 1. */
  awsS3FileEdge: Maybe<AwsS3FilesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedAwsS3FileId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `DrsFileexecutor` that is related to this `AwsS3File`. */
  drsFileexecutorByFileexecutorPtrId: Maybe<DrsFileexecutor>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `AwsS3File` mutation. */
export type DeleteAwsS3FilePayloadAwsS3FileEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsS3FilesOrderBy>>;
};

/** All input for the `deleteCodeFileById` mutation. */
export type DeleteCodeFileByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `CodeFile` mutation. */
export type DeleteCodeFilePayload = {
  __typename: "DeleteCodeFilePayload";
  /** Reads a single `ApplicationUser` that is related to this `CodeFile`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `CodeFile` that was deleted by this mutation. */
  codeFile: Maybe<CodeFile>;
  /** Reads a single `CodeFile` that is related to this `CodeFile`. */
  codeFileBySeriesParentId: Maybe<CodeFile>;
  /** An edge for our `CodeFile`. May be used by Relay 1. */
  codeFileEdge: Maybe<CodeFilesEdge>;
  deletedCodeFileId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `DrsFileexecutor` that is related to this `CodeFile`. */
  drsFileexecutorByExecutorId: Maybe<DrsFileexecutor>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `CodeFile`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our delete `CodeFile` mutation. */
export type DeleteCodeFilePayloadCodeFileEdgeArgs = {
  orderBy?: InputMaybe<Array<CodeFilesOrderBy>>;
};

/** All input for the `deleteCommandById` mutation. */
export type DeleteCommandByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** All input for the `deleteCommandByToolVersionIdAndCodeFileId` mutation. */
export type DeleteCommandByToolVersionIdAndCodeFileIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  codeFileId: Scalars["UUID"]["input"];
  toolVersionId: Scalars["Int"]["input"];
};

/** All input for the `deleteCommandByToolVersionId` mutation. */
export type DeleteCommandByToolVersionIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  toolVersionId: Scalars["Int"]["input"];
};

/** The output of our delete `Command` mutation. */
export type DeleteCommandPayload = {
  __typename: "DeleteCommandPayload";
  /** Reads a single `ApplicationUser` that is related to this `Command`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `CodeFile` that is related to this `Command`. */
  codeFileByCodeFileId: Maybe<CodeFile>;
  /** The `Command` that was deleted by this mutation. */
  command: Maybe<Command>;
  /** An edge for our `Command`. May be used by Relay 1. */
  commandEdge: Maybe<CommandsEdge>;
  /** Reads a single `ContainerImage` that is related to this `Command`. */
  containerImageByContainerImageId: Maybe<ContainerImage>;
  deletedCommandId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Command`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `ToolVersion` that is related to this `Command`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our delete `Command` mutation. */
export type DeleteCommandPayloadCommandEdgeArgs = {
  orderBy?: InputMaybe<Array<CommandsOrderBy>>;
};

/** All input for the `deleteContainerImageByExecutorId` mutation. */
export type DeleteContainerImageByExecutorIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  executorId: Scalars["Int"]["input"];
};

/** All input for the `deleteContainerImageById` mutation. */
export type DeleteContainerImageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `ContainerImage` mutation. */
export type DeleteContainerImagePayload = {
  __typename: "DeleteContainerImagePayload";
  /** Reads a single `ApplicationUser` that is related to this `ContainerImage`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `ContainerImage` that was deleted by this mutation. */
  containerImage: Maybe<ContainerImage>;
  /** An edge for our `ContainerImage`. May be used by Relay 1. */
  containerImageEdge: Maybe<ContainerImagesEdge>;
  /** Reads a single `ContainerImageRepository` that is related to this `ContainerImage`. */
  containerImageRepositoryByContainerImageRepositoryId: Maybe<ContainerImageRepository>;
  deletedContainerImageId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ContainerImage`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `TesContainerimageexecutor` that is related to this `ContainerImage`. */
  tesContainerimageexecutorByExecutorId: Maybe<TesContainerimageexecutor>;
};

/** The output of our delete `ContainerImage` mutation. */
export type DeleteContainerImagePayloadContainerImageEdgeArgs = {
  orderBy?: InputMaybe<Array<ContainerImagesOrderBy>>;
};

/** All input for the `deleteContainerImageRepositoryById` mutation. */
export type DeleteContainerImageRepositoryByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteContainerImageRepositoryByNameAndTenantIdAndRegistryType` mutation. */
export type DeleteContainerImageRepositoryByNameAndTenantIdAndRegistryTypeInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    name: Scalars["String"]["input"];
    registryType: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
  };

/** All input for the `deleteContainerImageRepositoryByRepository` mutation. */
export type DeleteContainerImageRepositoryByRepositoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  repository: Scalars["String"]["input"];
};

/** The output of our delete `ContainerImageRepository` mutation. */
export type DeleteContainerImageRepositoryPayload = {
  __typename: "DeleteContainerImageRepositoryPayload";
  /** Reads a single `ApplicationUser` that is related to this `ContainerImageRepository`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `ContainerImageRepository` that was deleted by this mutation. */
  containerImageRepository: Maybe<ContainerImageRepository>;
  /** An edge for our `ContainerImageRepository`. May be used by Relay 1. */
  containerImageRepositoryEdge: Maybe<ContainerImageRepositoriesEdge>;
  deletedContainerImageRepositoryId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ContainerImageRepository`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our delete `ContainerImageRepository` mutation. */
export type DeleteContainerImageRepositoryPayloadContainerImageRepositoryEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ContainerImageRepositoriesOrderBy>>;
  };

/** All input for the `deleteCostById` mutation. */
export type DeleteCostByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** The output of our delete `Cost` mutation. */
export type DeleteCostPayload = {
  __typename: "DeleteCostPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `Cost` that was deleted by this mutation. */
  cost: Maybe<Cost>;
  /** An edge for our `Cost`. May be used by Relay 1. */
  costEdge: Maybe<CostsEdge>;
  deletedCostId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Cost`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our delete `Cost` mutation. */
export type DeleteCostPayloadCostEdgeArgs = {
  orderBy?: InputMaybe<Array<CostsOrderBy>>;
};

/** All input for the `deleteDistributionRegistryImageByContainerimageexecutorPtrId` mutation. */
export type DeleteDistributionRegistryImageByContainerimageexecutorPtrIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    containerimageexecutorPtrId: Scalars["Int"]["input"];
  };

/** The output of our delete `DistributionRegistryImage` mutation. */
export type DeleteDistributionRegistryImagePayload = {
  __typename: "DeleteDistributionRegistryImagePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedDistributionRegistryImageId: Maybe<Scalars["ID"]["output"]>;
  /** The `DistributionRegistryImage` that was deleted by this mutation. */
  distributionRegistryImage: Maybe<DistributionRegistryImage>;
  /** An edge for our `DistributionRegistryImage`. May be used by Relay 1. */
  distributionRegistryImageEdge: Maybe<DistributionRegistryImagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TesContainerimageexecutor` that is related to this `DistributionRegistryImage`. */
  tesContainerimageexecutorByContainerimageexecutorPtrId: Maybe<TesContainerimageexecutor>;
};

/** The output of our delete `DistributionRegistryImage` mutation. */
export type DeleteDistributionRegistryImagePayloadDistributionRegistryImageEdgeArgs =
  {
    orderBy?: InputMaybe<Array<DistributionRegistryImagesOrderBy>>;
  };

/** All input for the `deleteDjangoAdminLogById` mutation. */
export type DeleteDjangoAdminLogByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `DjangoAdminLog` mutation. */
export type DeleteDjangoAdminLogPayload = {
  __typename: "DeleteDjangoAdminLogPayload";
  /** Reads a single `ApplicationUser` that is related to this `DjangoAdminLog`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedDjangoAdminLogId: Maybe<Scalars["ID"]["output"]>;
  /** The `DjangoAdminLog` that was deleted by this mutation. */
  djangoAdminLog: Maybe<DjangoAdminLog>;
  /** An edge for our `DjangoAdminLog`. May be used by Relay 1. */
  djangoAdminLogEdge: Maybe<DjangoAdminLogsEdge>;
  /** Reads a single `DjangoContentType` that is related to this `DjangoAdminLog`. */
  djangoContentTypeByContentTypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `DjangoAdminLog` mutation. */
export type DeleteDjangoAdminLogPayloadDjangoAdminLogEdgeArgs = {
  orderBy?: InputMaybe<Array<DjangoAdminLogsOrderBy>>;
};

/** All input for the `deleteDjangoContentTypeByAppLabelAndModel` mutation. */
export type DeleteDjangoContentTypeByAppLabelAndModelInput = {
  appLabel: Scalars["String"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  model: Scalars["String"]["input"];
};

/** All input for the `deleteDjangoContentTypeById` mutation. */
export type DeleteDjangoContentTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `DjangoContentType` mutation. */
export type DeleteDjangoContentTypePayload = {
  __typename: "DeleteDjangoContentTypePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedDjangoContentTypeId: Maybe<Scalars["ID"]["output"]>;
  /** The `DjangoContentType` that was deleted by this mutation. */
  djangoContentType: Maybe<DjangoContentType>;
  /** An edge for our `DjangoContentType`. May be used by Relay 1. */
  djangoContentTypeEdge: Maybe<DjangoContentTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `DjangoContentType` mutation. */
export type DeleteDjangoContentTypePayloadDjangoContentTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<DjangoContentTypesOrderBy>>;
};

/** All input for the `deleteDjangoMigrationById` mutation. */
export type DeleteDjangoMigrationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** The output of our delete `DjangoMigration` mutation. */
export type DeleteDjangoMigrationPayload = {
  __typename: "DeleteDjangoMigrationPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedDjangoMigrationId: Maybe<Scalars["ID"]["output"]>;
  /** The `DjangoMigration` that was deleted by this mutation. */
  djangoMigration: Maybe<DjangoMigration>;
  /** An edge for our `DjangoMigration`. May be used by Relay 1. */
  djangoMigrationEdge: Maybe<DjangoMigrationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `DjangoMigration` mutation. */
export type DeleteDjangoMigrationPayloadDjangoMigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<DjangoMigrationsOrderBy>>;
};

/** All input for the `deleteDjangoSesBlacklistedemailByEmail` mutation. */
export type DeleteDjangoSesBlacklistedemailByEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
};

/** All input for the `deleteDjangoSesBlacklistedemailById` mutation. */
export type DeleteDjangoSesBlacklistedemailByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `DjangoSesBlacklistedemail` mutation. */
export type DeleteDjangoSesBlacklistedemailPayload = {
  __typename: "DeleteDjangoSesBlacklistedemailPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedDjangoSesBlacklistedemailId: Maybe<Scalars["ID"]["output"]>;
  /** The `DjangoSesBlacklistedemail` that was deleted by this mutation. */
  djangoSesBlacklistedemail: Maybe<DjangoSesBlacklistedemail>;
  /** An edge for our `DjangoSesBlacklistedemail`. May be used by Relay 1. */
  djangoSesBlacklistedemailEdge: Maybe<DjangoSesBlacklistedemailsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `DjangoSesBlacklistedemail` mutation. */
export type DeleteDjangoSesBlacklistedemailPayloadDjangoSesBlacklistedemailEdgeArgs =
  {
    orderBy?: InputMaybe<Array<DjangoSesBlacklistedemailsOrderBy>>;
  };

/** All input for the `deleteDjangoSesSesstatByDate` mutation. */
export type DeleteDjangoSesSesstatByDateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  date: Scalars["Date"]["input"];
};

/** All input for the `deleteDjangoSesSesstatById` mutation. */
export type DeleteDjangoSesSesstatByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `DjangoSesSesstat` mutation. */
export type DeleteDjangoSesSesstatPayload = {
  __typename: "DeleteDjangoSesSesstatPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedDjangoSesSesstatId: Maybe<Scalars["ID"]["output"]>;
  /** The `DjangoSesSesstat` that was deleted by this mutation. */
  djangoSesSesstat: Maybe<DjangoSesSesstat>;
  /** An edge for our `DjangoSesSesstat`. May be used by Relay 1. */
  djangoSesSesstatEdge: Maybe<DjangoSesSesstatsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `DjangoSesSesstat` mutation. */
export type DeleteDjangoSesSesstatPayloadDjangoSesSesstatEdgeArgs = {
  orderBy?: InputMaybe<Array<DjangoSesSesstatsOrderBy>>;
};

/** All input for the `deleteDjangoSessionBySessionKey` mutation. */
export type DeleteDjangoSessionBySessionKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  sessionKey: Scalars["String"]["input"];
};

/** The output of our delete `DjangoSession` mutation. */
export type DeleteDjangoSessionPayload = {
  __typename: "DeleteDjangoSessionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedDjangoSessionId: Maybe<Scalars["ID"]["output"]>;
  /** The `DjangoSession` that was deleted by this mutation. */
  djangoSession: Maybe<DjangoSession>;
  /** An edge for our `DjangoSession`. May be used by Relay 1. */
  djangoSessionEdge: Maybe<DjangoSessionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `DjangoSession` mutation. */
export type DeleteDjangoSessionPayloadDjangoSessionEdgeArgs = {
  orderBy?: InputMaybe<Array<DjangoSessionsOrderBy>>;
};

/** All input for the `deleteDrsFileexecutorById` mutation. */
export type DeleteDrsFileexecutorByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `DrsFileexecutor` mutation. */
export type DeleteDrsFileexecutorPayload = {
  __typename: "DeleteDrsFileexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedDrsFileexecutorId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `DrsFileexecutor`. */
  djangoContentTypeByPolymorphicCtypeId: Maybe<DjangoContentType>;
  /** The `DrsFileexecutor` that was deleted by this mutation. */
  drsFileexecutor: Maybe<DrsFileexecutor>;
  /** An edge for our `DrsFileexecutor`. May be used by Relay 1. */
  drsFileexecutorEdge: Maybe<DrsFileexecutorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `DrsFileexecutor` mutation. */
export type DeleteDrsFileexecutorPayloadDrsFileexecutorEdgeArgs = {
  orderBy?: InputMaybe<Array<DrsFileexecutorsOrderBy>>;
};

/** All input for the `deleteDrsMockfileexecutorByFileexecutorPtrId` mutation. */
export type DeleteDrsMockfileexecutorByFileexecutorPtrIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  fileexecutorPtrId: Scalars["UUID"]["input"];
};

/** The output of our delete `DrsMockfileexecutor` mutation. */
export type DeleteDrsMockfileexecutorPayload = {
  __typename: "DeleteDrsMockfileexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedDrsMockfileexecutorId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `DrsFileexecutor` that is related to this `DrsMockfileexecutor`. */
  drsFileexecutorByFileexecutorPtrId: Maybe<DrsFileexecutor>;
  /** The `DrsMockfileexecutor` that was deleted by this mutation. */
  drsMockfileexecutor: Maybe<DrsMockfileexecutor>;
  /** An edge for our `DrsMockfileexecutor`. May be used by Relay 1. */
  drsMockfileexecutorEdge: Maybe<DrsMockfileexecutorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `DrsMockfileexecutor` mutation. */
export type DeleteDrsMockfileexecutorPayloadDrsMockfileexecutorEdgeArgs = {
  orderBy?: InputMaybe<Array<DrsMockfileexecutorsOrderBy>>;
};

/** All input for the `deleteEulaVersionById` mutation. */
export type DeleteEulaVersionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteEulaVersionByVersion` mutation. */
export type DeleteEulaVersionByVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  version: Scalars["String"]["input"];
};

/** The output of our delete `EulaVersion` mutation. */
export type DeleteEulaVersionPayload = {
  __typename: "DeleteEulaVersionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedEulaVersionId: Maybe<Scalars["ID"]["output"]>;
  /** The `EulaVersion` that was deleted by this mutation. */
  eulaVersion: Maybe<EulaVersion>;
  /** An edge for our `EulaVersion`. May be used by Relay 1. */
  eulaVersionEdge: Maybe<EulaVersionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `EulaVersion` mutation. */
export type DeleteEulaVersionPayloadEulaVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<EulaVersionsOrderBy>>;
};

/** All input for the `deleteEulaVersionUserAcceptanceById` mutation. */
export type DeleteEulaVersionUserAcceptanceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** All input for the `deleteEulaVersionUserAcceptanceByUserIdAndEulaVersionId` mutation. */
export type DeleteEulaVersionUserAcceptanceByUserIdAndEulaVersionIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  eulaVersionId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The output of our delete `EulaVersionUserAcceptance` mutation. */
export type DeleteEulaVersionUserAcceptancePayload = {
  __typename: "DeleteEulaVersionUserAcceptancePayload";
  /** Reads a single `ApplicationUser` that is related to this `EulaVersionUserAcceptance`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedEulaVersionUserAcceptanceId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `EulaVersion` that is related to this `EulaVersionUserAcceptance`. */
  eulaVersionByEulaVersionId: Maybe<EulaVersion>;
  /** The `EulaVersionUserAcceptance` that was deleted by this mutation. */
  eulaVersionUserAcceptance: Maybe<EulaVersionUserAcceptance>;
  /** An edge for our `EulaVersionUserAcceptance`. May be used by Relay 1. */
  eulaVersionUserAcceptanceEdge: Maybe<EulaVersionUserAcceptancesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `EulaVersionUserAcceptance` mutation. */
export type DeleteEulaVersionUserAcceptancePayloadEulaVersionUserAcceptanceEdgeArgs =
  {
    orderBy?: InputMaybe<Array<EulaVersionUserAcceptancesOrderBy>>;
  };

/** All input for the `deleteFeatureFlagById` mutation. */
export type DeleteFeatureFlagByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** All input for the `deleteFeatureFlagByName` mutation. */
export type DeleteFeatureFlagByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

/** The output of our delete `FeatureFlag` mutation. */
export type DeleteFeatureFlagPayload = {
  __typename: "DeleteFeatureFlagPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedFeatureFlagId: Maybe<Scalars["ID"]["output"]>;
  /** The `FeatureFlag` that was deleted by this mutation. */
  featureFlag: Maybe<FeatureFlag>;
  /** An edge for our `FeatureFlag`. May be used by Relay 1. */
  featureFlagEdge: Maybe<FeatureFlagsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `FeatureFlag` mutation. */
export type DeleteFeatureFlagPayloadFeatureFlagEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureFlagsOrderBy>>;
};

/** All input for the `deleteFeatureFlagsGroupByFeatureflagIdAndGroupId` mutation. */
export type DeleteFeatureFlagsGroupByFeatureflagIdAndGroupIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  featureflagId: Scalars["BigInt"]["input"];
  groupId: Scalars["Int"]["input"];
};

/** All input for the `deleteFeatureFlagsGroupById` mutation. */
export type DeleteFeatureFlagsGroupByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** The output of our delete `FeatureFlagsGroup` mutation. */
export type DeleteFeatureFlagsGroupPayload = {
  __typename: "DeleteFeatureFlagsGroupPayload";
  /** Reads a single `AuthGroup` that is related to this `FeatureFlagsGroup`. */
  authGroupByGroupId: Maybe<AuthGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedFeatureFlagsGroupId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `FeatureFlag` that is related to this `FeatureFlagsGroup`. */
  featureFlagByFeatureflagId: Maybe<FeatureFlag>;
  /** The `FeatureFlagsGroup` that was deleted by this mutation. */
  featureFlagsGroup: Maybe<FeatureFlagsGroup>;
  /** An edge for our `FeatureFlagsGroup`. May be used by Relay 1. */
  featureFlagsGroupEdge: Maybe<FeatureFlagsGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `FeatureFlagsGroup` mutation. */
export type DeleteFeatureFlagsGroupPayloadFeatureFlagsGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureFlagsGroupsOrderBy>>;
};

/** All input for the `deleteFeatureFlagsTenantByFeatureflagIdAndTenantId` mutation. */
export type DeleteFeatureFlagsTenantByFeatureflagIdAndTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  featureflagId: Scalars["BigInt"]["input"];
  tenantId: Scalars["Int"]["input"];
};

/** All input for the `deleteFeatureFlagsTenantById` mutation. */
export type DeleteFeatureFlagsTenantByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** The output of our delete `FeatureFlagsTenant` mutation. */
export type DeleteFeatureFlagsTenantPayload = {
  __typename: "DeleteFeatureFlagsTenantPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedFeatureFlagsTenantId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `FeatureFlag` that is related to this `FeatureFlagsTenant`. */
  featureFlagByFeatureflagId: Maybe<FeatureFlag>;
  /** The `FeatureFlagsTenant` that was deleted by this mutation. */
  featureFlagsTenant: Maybe<FeatureFlagsTenant>;
  /** An edge for our `FeatureFlagsTenant`. May be used by Relay 1. */
  featureFlagsTenantEdge: Maybe<FeatureFlagsTenantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `FeatureFlagsTenant`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our delete `FeatureFlagsTenant` mutation. */
export type DeleteFeatureFlagsTenantPayloadFeatureFlagsTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureFlagsTenantsOrderBy>>;
};

/** All input for the `deleteFeatureFlagsUserByFeatureflagIdAndUserId` mutation. */
export type DeleteFeatureFlagsUserByFeatureflagIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  featureflagId: Scalars["BigInt"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** All input for the `deleteFeatureFlagsUserById` mutation. */
export type DeleteFeatureFlagsUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** The output of our delete `FeatureFlagsUser` mutation. */
export type DeleteFeatureFlagsUserPayload = {
  __typename: "DeleteFeatureFlagsUserPayload";
  /** Reads a single `ApplicationUser` that is related to this `FeatureFlagsUser`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedFeatureFlagsUserId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `FeatureFlag` that is related to this `FeatureFlagsUser`. */
  featureFlagByFeatureflagId: Maybe<FeatureFlag>;
  /** The `FeatureFlagsUser` that was deleted by this mutation. */
  featureFlagsUser: Maybe<FeatureFlagsUser>;
  /** An edge for our `FeatureFlagsUser`. May be used by Relay 1. */
  featureFlagsUserEdge: Maybe<FeatureFlagsUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `FeatureFlagsUser` mutation. */
export type DeleteFeatureFlagsUserPayloadFeatureFlagsUserEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureFlagsUsersOrderBy>>;
};

/** All input for the `deleteFileActivityById` mutation. */
export type DeleteFileActivityByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `FileActivity` mutation. */
export type DeleteFileActivityPayload = {
  __typename: "DeleteFileActivityPayload";
  /** Reads a single `ApplicationUser` that is related to this `FileActivity`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Cost` that is related to this `FileActivity`. */
  costByCostId: Maybe<Cost>;
  deletedFileActivityId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `FileActivity`. */
  djangoContentTypeByContentTypeId: Maybe<DjangoContentType>;
  /** The `FileActivity` that was deleted by this mutation. */
  fileActivity: Maybe<FileActivity>;
  /** An edge for our `FileActivity`. May be used by Relay 1. */
  fileActivityEdge: Maybe<FileActivitiesEdge>;
  /** Reads a single `File` that is related to this `FileActivity`. */
  fileByFileId: Maybe<File>;
  /** Reads a single `Project` that is related to this `FileActivity`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `FileActivity`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our delete `FileActivity` mutation. */
export type DeleteFileActivityPayloadFileActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<FileActivitiesOrderBy>>;
};

/** All input for the `deleteFileById` mutation. */
export type DeleteFileByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** All input for the `deleteFileByProjectIdAndReferenceId` mutation. */
export type DeleteFileByProjectIdAndReferenceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  projectId: Scalars["UUID"]["input"];
  referenceId: Scalars["UUID"]["input"];
};

/** All input for the `deleteFileMetadatumById` mutation. */
export type DeleteFileMetadatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `FileMetadatum` mutation. */
export type DeleteFileMetadatumPayload = {
  __typename: "DeleteFileMetadatumPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedFileMetadatumId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `File` that is related to this `FileMetadatum`. */
  fileByFileId: Maybe<File>;
  /** The `FileMetadatum` that was deleted by this mutation. */
  fileMetadatum: Maybe<FileMetadatum>;
  /** An edge for our `FileMetadatum`. May be used by Relay 1. */
  fileMetadatumEdge: Maybe<FileMetadataEdge>;
  /** Reads a single `Metadatum` that is related to this `FileMetadatum`. */
  metadatumByMetadataId: Maybe<Metadatum>;
  /** Reads a single `Project` that is related to this `FileMetadatum`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `FileMetadatum`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our delete `FileMetadatum` mutation. */
export type DeleteFileMetadatumPayloadFileMetadatumEdgeArgs = {
  orderBy?: InputMaybe<Array<FileMetadataOrderBy>>;
};

/** All input for the `deleteFileOutputGroupById` mutation. */
export type DeleteFileOutputGroupByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** All input for the `deleteFileOutputGroupByTaskId` mutation. */
export type DeleteFileOutputGroupByTaskIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  taskId: Scalars["UUID"]["input"];
};

/** All input for the `deleteFileOutputGroupMetadatumById` mutation. */
export type DeleteFileOutputGroupMetadatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `FileOutputGroupMetadatum` mutation. */
export type DeleteFileOutputGroupMetadatumPayload = {
  __typename: "DeleteFileOutputGroupMetadatumPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedFileOutputGroupMetadatumId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `FileOutputGroup` that is related to this `FileOutputGroupMetadatum`. */
  fileOutputGroupByFileOutputGroupId: Maybe<FileOutputGroup>;
  /** The `FileOutputGroupMetadatum` that was deleted by this mutation. */
  fileOutputGroupMetadatum: Maybe<FileOutputGroupMetadatum>;
  /** An edge for our `FileOutputGroupMetadatum`. May be used by Relay 1. */
  fileOutputGroupMetadatumEdge: Maybe<FileOutputGroupMetadataEdge>;
  /** Reads a single `Metadatum` that is related to this `FileOutputGroupMetadatum`. */
  metadatumByMetadataId: Maybe<Metadatum>;
  /** Reads a single `Project` that is related to this `FileOutputGroupMetadatum`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `FileOutputGroupMetadatum`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our delete `FileOutputGroupMetadatum` mutation. */
export type DeleteFileOutputGroupMetadatumPayloadFileOutputGroupMetadatumEdgeArgs =
  {
    orderBy?: InputMaybe<Array<FileOutputGroupMetadataOrderBy>>;
  };

/** The output of our delete `FileOutputGroup` mutation. */
export type DeleteFileOutputGroupPayload = {
  __typename: "DeleteFileOutputGroupPayload";
  /** Reads a single `ApplicationUser` that is related to this `FileOutputGroup`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedFileOutputGroupId: Maybe<Scalars["ID"]["output"]>;
  /** The `FileOutputGroup` that was deleted by this mutation. */
  fileOutputGroup: Maybe<FileOutputGroup>;
  /** An edge for our `FileOutputGroup`. May be used by Relay 1. */
  fileOutputGroupEdge: Maybe<FileOutputGroupsEdge>;
  /** Reads a single `Project` that is related to this `FileOutputGroup`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `FileOutputGroup`. */
  taskByTaskId: Maybe<Task>;
  /** Reads a single `Tenant` that is related to this `FileOutputGroup`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our delete `FileOutputGroup` mutation. */
export type DeleteFileOutputGroupPayloadFileOutputGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<FileOutputGroupsOrderBy>>;
};

/** The output of our delete `File` mutation. */
export type DeleteFilePayload = {
  __typename: "DeleteFilePayload";
  /** Reads a single `ApplicationUser` that is related to this `File`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedFileId: Maybe<Scalars["ID"]["output"]>;
  /** The `File` that was deleted by this mutation. */
  file: Maybe<File>;
  /** Reads a single `File` that is related to this `File`. */
  fileBySeriesParentId: Maybe<File>;
  /** An edge for our `File`. May be used by Relay 1. */
  fileEdge: Maybe<FilesEdge>;
  /** Reads a single `Project` that is related to this `File`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `File`. */
  taskByTaskId: Maybe<Task>;
  /** Reads a single `Tenant` that is related to this `File`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our delete `File` mutation. */
export type DeleteFilePayloadFileEdgeArgs = {
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};

/** All input for the `deleteMetadataValueById` mutation. */
export type DeleteMetadataValueByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `MetadataValue` mutation. */
export type DeleteMetadataValuePayload = {
  __typename: "DeleteMetadataValuePayload";
  /** Reads a single `ApplicationUser` that is related to this `MetadataValue`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedMetadataValueId: Maybe<Scalars["ID"]["output"]>;
  /** The `MetadataValue` that was deleted by this mutation. */
  metadataValue: Maybe<MetadataValue>;
  /** An edge for our `MetadataValue`. May be used by Relay 1. */
  metadataValueEdge: Maybe<MetadataValuesEdge>;
  /** Reads a single `Metadatum` that is related to this `MetadataValue`. */
  metadatumByMetadataId: Maybe<Metadatum>;
  /** Reads a single `Project` that is related to this `MetadataValue`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `MetadataValue`. */
  taskByTaskId: Maybe<Task>;
  /** Reads a single `Tenant` that is related to this `MetadataValue`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our delete `MetadataValue` mutation. */
export type DeleteMetadataValuePayloadMetadataValueEdgeArgs = {
  orderBy?: InputMaybe<Array<MetadataValuesOrderBy>>;
};

/** All input for the `deleteMetadatumById` mutation. */
export type DeleteMetadatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `Metadatum` mutation. */
export type DeleteMetadatumPayload = {
  __typename: "DeleteMetadatumPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedMetadatumId: Maybe<Scalars["ID"]["output"]>;
  /** The `Metadatum` that was deleted by this mutation. */
  metadatum: Maybe<Metadatum>;
  /** An edge for our `Metadatum`. May be used by Relay 1. */
  metadatumEdge: Maybe<MetadataEdge>;
  /** Reads a single `Project` that is related to this `Metadatum`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Metadatum`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our delete `Metadatum` mutation. */
export type DeleteMetadatumPayloadMetadatumEdgeArgs = {
  orderBy?: InputMaybe<Array<MetadataOrderBy>>;
};

/** All input for the `deleteOutputGroupFileById` mutation. */
export type DeleteOutputGroupFileByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `OutputGroupFile` mutation. */
export type DeleteOutputGroupFilePayload = {
  __typename: "DeleteOutputGroupFilePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedOutputGroupFileId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `File` that is related to this `OutputGroupFile`. */
  fileByFileId: Maybe<File>;
  /** Reads a single `FileOutputGroup` that is related to this `OutputGroupFile`. */
  fileOutputGroupByFileOutputGroupId: Maybe<FileOutputGroup>;
  /** The `OutputGroupFile` that was deleted by this mutation. */
  outputGroupFile: Maybe<OutputGroupFile>;
  /** An edge for our `OutputGroupFile`. May be used by Relay 1. */
  outputGroupFileEdge: Maybe<OutputGroupFilesEdge>;
  /** Reads a single `Project` that is related to this `OutputGroupFile`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `OutputGroupFile` mutation. */
export type DeleteOutputGroupFilePayloadOutputGroupFileEdgeArgs = {
  orderBy?: InputMaybe<Array<OutputGroupFilesOrderBy>>;
};

/** All input for the `deletePinnedToolById` mutation. */
export type DeletePinnedToolByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** All input for the `deletePinnedToolByUserIdAndToolId` mutation. */
export type DeletePinnedToolByUserIdAndToolIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  toolId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The output of our delete `PinnedTool` mutation. */
export type DeletePinnedToolPayload = {
  __typename: "DeletePinnedToolPayload";
  /** Reads a single `ApplicationUser` that is related to this `PinnedTool`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedPinnedToolId: Maybe<Scalars["ID"]["output"]>;
  /** The `PinnedTool` that was deleted by this mutation. */
  pinnedTool: Maybe<PinnedTool>;
  /** An edge for our `PinnedTool`. May be used by Relay 1. */
  pinnedToolEdge: Maybe<PinnedToolsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tool` that is related to this `PinnedTool`. */
  toolByToolId: Maybe<Tool>;
};

/** The output of our delete `PinnedTool` mutation. */
export type DeletePinnedToolPayloadPinnedToolEdgeArgs = {
  orderBy?: InputMaybe<Array<PinnedToolsOrderBy>>;
};

/** All input for the `deleteProjectFolderById` mutation. */
export type DeleteProjectFolderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `ProjectFolder` mutation. */
export type DeleteProjectFolderPayload = {
  __typename: "DeleteProjectFolderPayload";
  /** Reads a single `ApplicationUser` that is related to this `ProjectFolder`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedProjectFolderId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `Project` that is related to this `ProjectFolder`. */
  projectByProjectId: Maybe<Project>;
  /** The `ProjectFolder` that was deleted by this mutation. */
  projectFolder: Maybe<ProjectFolder>;
  /** An edge for our `ProjectFolder`. May be used by Relay 1. */
  projectFolderEdge: Maybe<ProjectFoldersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `ProjectFolder` mutation. */
export type DeleteProjectFolderPayloadProjectFolderEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectFoldersOrderBy>>;
};

/** All input for the `deleteProjectTagById` mutation. */
export type DeleteProjectTagByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `ProjectTag` mutation. */
export type DeleteProjectTagPayload = {
  __typename: "DeleteProjectTagPayload";
  /** Reads a single `ApplicationUser` that is related to this `ProjectTag`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedProjectTagId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `Project` that is related to this `ProjectTag`. */
  projectByProjectId: Maybe<Project>;
  /** The `ProjectTag` that was deleted by this mutation. */
  projectTag: Maybe<ProjectTag>;
  /** An edge for our `ProjectTag`. May be used by Relay 1. */
  projectTagEdge: Maybe<ProjectTagsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our delete `ProjectTag` mutation. */
export type DeleteProjectTagPayloadProjectTagEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTagsOrderBy>>;
};

/** All input for the `deleteRunById` mutation. */
export type DeleteRunByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `Run` mutation. */
export type DeleteRunPayload = {
  __typename: "DeleteRunPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedRunId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Run` that was deleted by this mutation. */
  run: Maybe<Run>;
  /** An edge for our `Run`. May be used by Relay 1. */
  runEdge: Maybe<RunsEdge>;
  /** Reads a single `Tenant` that is related to this `Run`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our delete `Run` mutation. */
export type DeleteRunPayloadRunEdgeArgs = {
  orderBy?: InputMaybe<Array<RunsOrderBy>>;
};

/** All input for the `deleteSession` mutation. */
export type DeleteSessionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The output of our `deleteSession` mutation. */
export type DeleteSessionPayload = {
  __typename: "DeleteSessionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** All input for the `deleteTaskActivityById` mutation. */
export type DeleteTaskActivityByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteTaskActivityByTaskId` mutation. */
export type DeleteTaskActivityByTaskIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  taskId: Scalars["UUID"]["input"];
};

/** The output of our delete `TaskActivity` mutation. */
export type DeleteTaskActivityPayload = {
  __typename: "DeleteTaskActivityPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Cost` that is related to this `TaskActivity`. */
  costByCostId: Maybe<Cost>;
  deletedTaskActivityId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TaskActivity` that was deleted by this mutation. */
  taskActivity: Maybe<TaskActivity>;
  /** An edge for our `TaskActivity`. May be used by Relay 1. */
  taskActivityEdge: Maybe<TaskActivitiesEdge>;
  /** Reads a single `Task` that is related to this `TaskActivity`. */
  taskByTaskId: Maybe<Task>;
};

/** The output of our delete `TaskActivity` mutation. */
export type DeleteTaskActivityPayloadTaskActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskActivitiesOrderBy>>;
};

/** All input for the `deleteTaskByExecutorId` mutation. */
export type DeleteTaskByExecutorIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  executorId: Scalars["UUID"]["input"];
};

/** All input for the `deleteTaskById` mutation. */
export type DeleteTaskByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `Task` mutation. */
export type DeleteTaskPayload = {
  __typename: "DeleteTaskPayload";
  /** Reads a single `ApplicationUser` that is related to this `Task`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `ContainerImage` that is related to this `Task`. */
  containerImageByContainerImageId: Maybe<ContainerImage>;
  deletedTaskId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `Project` that is related to this `Task`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Task` that was deleted by this mutation. */
  task: Maybe<Task>;
  /** An edge for our `Task`. May be used by Relay 1. */
  taskEdge: Maybe<TasksEdge>;
  /** Reads a single `Tenant` that is related to this `Task`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `TesTaskexecutor` that is related to this `Task`. */
  tesTaskexecutorByExecutorId: Maybe<TesTaskexecutor>;
  /** Reads a single `ToolVersion` that is related to this `Task`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our delete `Task` mutation. */
export type DeleteTaskPayloadTaskEdgeArgs = {
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

/** All input for the `deleteTaskResourceById` mutation. */
export type DeleteTaskResourceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `TaskResource` mutation. */
export type DeleteTaskResourcePayload = {
  __typename: "DeleteTaskResourcePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedTaskResourceId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `TaskResource`. */
  taskByTaskId: Maybe<Task>;
  /** The `TaskResource` that was deleted by this mutation. */
  taskResource: Maybe<TaskResource>;
  /** An edge for our `TaskResource`. May be used by Relay 1. */
  taskResourceEdge: Maybe<TaskResourcesEdge>;
};

/** The output of our delete `TaskResource` mutation. */
export type DeleteTaskResourcePayloadTaskResourceEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskResourcesOrderBy>>;
};

/** All input for the `deleteTaskResourceUsageById` mutation. */
export type DeleteTaskResourceUsageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteTaskResourceUsageByTaskId` mutation. */
export type DeleteTaskResourceUsageByTaskIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  taskId: Scalars["UUID"]["input"];
};

/** The output of our delete `TaskResourceUsage` mutation. */
export type DeleteTaskResourceUsagePayload = {
  __typename: "DeleteTaskResourceUsagePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedTaskResourceUsageId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `TaskResourceUsage`. */
  taskByTaskId: Maybe<Task>;
  /** The `TaskResourceUsage` that was deleted by this mutation. */
  taskResourceUsage: Maybe<TaskResourceUsage>;
  /** An edge for our `TaskResourceUsage`. May be used by Relay 1. */
  taskResourceUsageEdge: Maybe<TaskResourceUsagesEdge>;
};

/** The output of our delete `TaskResourceUsage` mutation. */
export type DeleteTaskResourceUsagePayloadTaskResourceUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskResourceUsagesOrderBy>>;
};

/** All input for the `deleteTaskSourceById` mutation. */
export type DeleteTaskSourceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `TaskSource` mutation. */
export type DeleteTaskSourcePayload = {
  __typename: "DeleteTaskSourcePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedTaskSourceId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `File` that is related to this `TaskSource`. */
  fileByFileId: Maybe<File>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `TaskSource`. */
  taskByTaskId: Maybe<Task>;
  /** The `TaskSource` that was deleted by this mutation. */
  taskSource: Maybe<TaskSource>;
  /** An edge for our `TaskSource`. May be used by Relay 1. */
  taskSourceEdge: Maybe<TaskSourcesEdge>;
  /** Reads a single `ToolSource` that is related to this `TaskSource`. */
  toolSourceByToolSourceId: Maybe<ToolSource>;
};

/** The output of our delete `TaskSource` mutation. */
export type DeleteTaskSourcePayloadTaskSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskSourcesOrderBy>>;
};

/** All input for the `deleteTaskStatusLogById` mutation. */
export type DeleteTaskStatusLogByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteTaskStatusLogByTaskIdAndStatus` mutation. */
export type DeleteTaskStatusLogByTaskIdAndStatusInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  taskId: Scalars["UUID"]["input"];
};

/** The output of our delete `TaskStatusLog` mutation. */
export type DeleteTaskStatusLogPayload = {
  __typename: "DeleteTaskStatusLogPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedTaskStatusLogId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `TaskStatusLog`. */
  taskByTaskId: Maybe<Task>;
  /** The `TaskStatusLog` that was deleted by this mutation. */
  taskStatusLog: Maybe<TaskStatusLog>;
  /** An edge for our `TaskStatusLog`. May be used by Relay 1. */
  taskStatusLogEdge: Maybe<TaskStatusLogsEdge>;
};

/** The output of our delete `TaskStatusLog` mutation. */
export type DeleteTaskStatusLogPayloadTaskStatusLogEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskStatusLogsOrderBy>>;
};

/** All input for the `deleteTenantById` mutation. */
export type DeleteTenantByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteTenantByKey` mutation. */
export type DeleteTenantByKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  key: Scalars["String"]["input"];
};

/** All input for the `deleteTenantByRepositoryName` mutation. */
export type DeleteTenantByRepositoryNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  repositoryName: Scalars["String"]["input"];
};

/** All input for the `deleteTenantBySfid` mutation. */
export type DeleteTenantBySfidInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  sfid: Scalars["String"]["input"];
};

/** All input for the `deleteTenantContractAllowanceById` mutation. */
export type DeleteTenantContractAllowanceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteTenantContractAllowanceByTenantContractTransactionIdAndQuotaType` mutation. */
export type DeleteTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    quotaType: Scalars["Int"]["input"];
    tenantContractTransactionId: Scalars["Int"]["input"];
  };

/** The output of our delete `TenantContractAllowance` mutation. */
export type DeleteTenantContractAllowancePayload = {
  __typename: "DeleteTenantContractAllowancePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedTenantContractAllowanceId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TenantContractAllowance` that was deleted by this mutation. */
  tenantContractAllowance: Maybe<TenantContractAllowance>;
  /** An edge for our `TenantContractAllowance`. May be used by Relay 1. */
  tenantContractAllowanceEdge: Maybe<TenantContractAllowancesEdge>;
  /** Reads a single `TenantContractTransaction` that is related to this `TenantContractAllowance`. */
  tenantContractTransactionByTenantContractTransactionId: Maybe<TenantContractTransaction>;
};

/** The output of our delete `TenantContractAllowance` mutation. */
export type DeleteTenantContractAllowancePayloadTenantContractAllowanceEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TenantContractAllowancesOrderBy>>;
  };

/** All input for the `deleteTenantContractById` mutation. */
export type DeleteTenantContractByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteTenantContractByName` mutation. */
export type DeleteTenantContractByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

/** All input for the `deleteTenantContractBySfid` mutation. */
export type DeleteTenantContractBySfidInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  sfid: Scalars["String"]["input"];
};

/** The output of our delete `TenantContract` mutation. */
export type DeleteTenantContractPayload = {
  __typename: "DeleteTenantContractPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedTenantContractId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `TenantContract`. */
  tenantByTenantId: Maybe<Tenant>;
  /** The `TenantContract` that was deleted by this mutation. */
  tenantContract: Maybe<TenantContract>;
  /** An edge for our `TenantContract`. May be used by Relay 1. */
  tenantContractEdge: Maybe<TenantContractsEdge>;
};

/** The output of our delete `TenantContract` mutation. */
export type DeleteTenantContractPayloadTenantContractEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantContractsOrderBy>>;
};

/** All input for the `deleteTenantContractTransactionById` mutation. */
export type DeleteTenantContractTransactionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `TenantContractTransaction` mutation. */
export type DeleteTenantContractTransactionPayload = {
  __typename: "DeleteTenantContractTransactionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedTenantContractTransactionId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TenantContract` that is related to this `TenantContractTransaction`. */
  tenantContractByTenantContractId: Maybe<TenantContract>;
  /** The `TenantContractTransaction` that was deleted by this mutation. */
  tenantContractTransaction: Maybe<TenantContractTransaction>;
  /** An edge for our `TenantContractTransaction`. May be used by Relay 1. */
  tenantContractTransactionEdge: Maybe<TenantContractTransactionsEdge>;
};

/** The output of our delete `TenantContractTransaction` mutation. */
export type DeleteTenantContractTransactionPayloadTenantContractTransactionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TenantContractTransactionsOrderBy>>;
  };

/** All input for the `deleteTenantMockuserexecutorByUserexecutorPtrId` mutation. */
export type DeleteTenantMockuserexecutorByUserexecutorPtrIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  userexecutorPtrId: Scalars["Int"]["input"];
};

/** The output of our delete `TenantMockuserexecutor` mutation. */
export type DeleteTenantMockuserexecutorPayload = {
  __typename: "DeleteTenantMockuserexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedTenantMockuserexecutorId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TenantMockuserexecutor` that was deleted by this mutation. */
  tenantMockuserexecutor: Maybe<TenantMockuserexecutor>;
  /** An edge for our `TenantMockuserexecutor`. May be used by Relay 1. */
  tenantMockuserexecutorEdge: Maybe<TenantMockuserexecutorsEdge>;
  /** Reads a single `TenantUserexecutor` that is related to this `TenantMockuserexecutor`. */
  tenantUserexecutorByUserexecutorPtrId: Maybe<TenantUserexecutor>;
};

/** The output of our delete `TenantMockuserexecutor` mutation. */
export type DeleteTenantMockuserexecutorPayloadTenantMockuserexecutorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TenantMockuserexecutorsOrderBy>>;
  };

/** All input for the `deleteTenantMonthlyConsumedResourceById` mutation. */
export type DeleteTenantMonthlyConsumedResourceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract` mutation. */
export type DeleteTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    month: Scalars["Date"]["input"];
    monthInActiveContract: Scalars["Int"]["input"];
    quotaType: Scalars["Int"]["input"];
    tenantContractId: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** The output of our delete `TenantMonthlyConsumedResource` mutation. */
export type DeleteTenantMonthlyConsumedResourcePayload = {
  __typename: "DeleteTenantMonthlyConsumedResourcePayload";
  /** Reads a single `ApplicationUser` that is related to this `TenantMonthlyConsumedResource`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedTenantMonthlyConsumedResourceId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `TenantMonthlyConsumedResource`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `TenantContract` that is related to this `TenantMonthlyConsumedResource`. */
  tenantContractByTenantContractId: Maybe<TenantContract>;
  /** The `TenantMonthlyConsumedResource` that was deleted by this mutation. */
  tenantMonthlyConsumedResource: Maybe<TenantMonthlyConsumedResource>;
  /** An edge for our `TenantMonthlyConsumedResource`. May be used by Relay 1. */
  tenantMonthlyConsumedResourceEdge: Maybe<TenantMonthlyConsumedResourcesEdge>;
};

/** The output of our delete `TenantMonthlyConsumedResource` mutation. */
export type DeleteTenantMonthlyConsumedResourcePayloadTenantMonthlyConsumedResourceEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TenantMonthlyConsumedResourcesOrderBy>>;
  };

/** The output of our delete `Tenant` mutation. */
export type DeleteTenantPayload = {
  __typename: "DeleteTenantPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedTenantId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Tenant` that was deleted by this mutation. */
  tenant: Maybe<Tenant>;
  /** An edge for our `Tenant`. May be used by Relay 1. */
  tenantEdge: Maybe<TenantsEdge>;
};

/** The output of our delete `Tenant` mutation. */
export type DeleteTenantPayloadTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
};

/** All input for the `deleteTenantUserexecutorById` mutation. */
export type DeleteTenantUserexecutorByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `TenantUserexecutor` mutation. */
export type DeleteTenantUserexecutorPayload = {
  __typename: "DeleteTenantUserexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedTenantUserexecutorId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `TenantUserexecutor`. */
  djangoContentTypeByPolymorphicCtypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TenantUserexecutor` that was deleted by this mutation. */
  tenantUserexecutor: Maybe<TenantUserexecutor>;
  /** An edge for our `TenantUserexecutor`. May be used by Relay 1. */
  tenantUserexecutorEdge: Maybe<TenantUserexecutorsEdge>;
};

/** The output of our delete `TenantUserexecutor` mutation. */
export type DeleteTenantUserexecutorPayloadTenantUserexecutorEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantUserexecutorsOrderBy>>;
};

/** All input for the `deleteTesContainerimageexecutorById` mutation. */
export type DeleteTesContainerimageexecutorByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `TesContainerimageexecutor` mutation. */
export type DeleteTesContainerimageexecutorPayload = {
  __typename: "DeleteTesContainerimageexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedTesContainerimageexecutorId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `TesContainerimageexecutor`. */
  djangoContentTypeByPolymorphicCtypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TesContainerimageexecutor` that was deleted by this mutation. */
  tesContainerimageexecutor: Maybe<TesContainerimageexecutor>;
  /** An edge for our `TesContainerimageexecutor`. May be used by Relay 1. */
  tesContainerimageexecutorEdge: Maybe<TesContainerimageexecutorsEdge>;
};

/** The output of our delete `TesContainerimageexecutor` mutation. */
export type DeleteTesContainerimageexecutorPayloadTesContainerimageexecutorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TesContainerimageexecutorsOrderBy>>;
  };

/** All input for the `deleteTesMockcontainerimageexecutorByContainerimageexecutorPtrId` mutation. */
export type DeleteTesMockcontainerimageexecutorByContainerimageexecutorPtrIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    containerimageexecutorPtrId: Scalars["Int"]["input"];
  };

/** The output of our delete `TesMockcontainerimageexecutor` mutation. */
export type DeleteTesMockcontainerimageexecutorPayload = {
  __typename: "DeleteTesMockcontainerimageexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedTesMockcontainerimageexecutorId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TesContainerimageexecutor` that is related to this `TesMockcontainerimageexecutor`. */
  tesContainerimageexecutorByContainerimageexecutorPtrId: Maybe<TesContainerimageexecutor>;
  /** The `TesMockcontainerimageexecutor` that was deleted by this mutation. */
  tesMockcontainerimageexecutor: Maybe<TesMockcontainerimageexecutor>;
  /** An edge for our `TesMockcontainerimageexecutor`. May be used by Relay 1. */
  tesMockcontainerimageexecutorEdge: Maybe<TesMockcontainerimageexecutorsEdge>;
};

/** The output of our delete `TesMockcontainerimageexecutor` mutation. */
export type DeleteTesMockcontainerimageexecutorPayloadTesMockcontainerimageexecutorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TesMockcontainerimageexecutorsOrderBy>>;
  };

/** All input for the `deleteTesMocktaskexecutorByTaskexecutorPtrId` mutation. */
export type DeleteTesMocktaskexecutorByTaskexecutorPtrIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  taskexecutorPtrId: Scalars["UUID"]["input"];
};

/** The output of our delete `TesMocktaskexecutor` mutation. */
export type DeleteTesMocktaskexecutorPayload = {
  __typename: "DeleteTesMocktaskexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedTesMocktaskexecutorId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TesMocktaskexecutor` that was deleted by this mutation. */
  tesMocktaskexecutor: Maybe<TesMocktaskexecutor>;
  /** An edge for our `TesMocktaskexecutor`. May be used by Relay 1. */
  tesMocktaskexecutorEdge: Maybe<TesMocktaskexecutorsEdge>;
  /** Reads a single `TesTaskexecutor` that is related to this `TesMocktaskexecutor`. */
  tesTaskexecutorByTaskexecutorPtrId: Maybe<TesTaskexecutor>;
};

/** The output of our delete `TesMocktaskexecutor` mutation. */
export type DeleteTesMocktaskexecutorPayloadTesMocktaskexecutorEdgeArgs = {
  orderBy?: InputMaybe<Array<TesMocktaskexecutorsOrderBy>>;
};

/** All input for the `deleteTesTaskexecutorById` mutation. */
export type DeleteTesTaskexecutorByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `TesTaskexecutor` mutation. */
export type DeleteTesTaskexecutorPayload = {
  __typename: "DeleteTesTaskexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedTesTaskexecutorId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `TesTaskexecutor`. */
  djangoContentTypeByPolymorphicCtypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TesTaskexecutor` that was deleted by this mutation. */
  tesTaskexecutor: Maybe<TesTaskexecutor>;
  /** An edge for our `TesTaskexecutor`. May be used by Relay 1. */
  tesTaskexecutorEdge: Maybe<TesTaskexecutorsEdge>;
};

/** The output of our delete `TesTaskexecutor` mutation. */
export type DeleteTesTaskexecutorPayloadTesTaskexecutorEdgeArgs = {
  orderBy?: InputMaybe<Array<TesTaskexecutorsOrderBy>>;
};

/** All input for the `deleteToolById` mutation. */
export type DeleteToolByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteToolByProjectId` mutation. */
export type DeleteToolByProjectIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  projectId: Scalars["UUID"]["input"];
};

/** All input for the `deleteToolParameterById` mutation. */
export type DeleteToolParameterByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `ToolParameter` mutation. */
export type DeleteToolParameterPayload = {
  __typename: "DeleteToolParameterPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedToolParameterId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ToolParameter` that was deleted by this mutation. */
  toolParameter: Maybe<ToolParameter>;
  /** An edge for our `ToolParameter`. May be used by Relay 1. */
  toolParameterEdge: Maybe<ToolParametersEdge>;
  /** Reads a single `ToolVersion` that is related to this `ToolParameter`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our delete `ToolParameter` mutation. */
export type DeleteToolParameterPayloadToolParameterEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolParametersOrderBy>>;
};

/** The output of our delete `Tool` mutation. */
export type DeleteToolPayload = {
  __typename: "DeleteToolPayload";
  /** Reads a single `ApplicationUser` that is related to this `Tool`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedToolId: Maybe<Scalars["ID"]["output"]>;
  /** Reads a single `Project` that is related to this `Tool`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Tool`. */
  tenantByTenantId: Maybe<Tenant>;
  /** The `Tool` that was deleted by this mutation. */
  tool: Maybe<Tool>;
  /** An edge for our `Tool`. May be used by Relay 1. */
  toolEdge: Maybe<ToolsEdge>;
  /** Reads a single `Toolbox` that is related to this `Tool`. */
  toolboxByToolboxId: Maybe<Toolbox>;
};

/** The output of our delete `Tool` mutation. */
export type DeleteToolPayloadToolEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolsOrderBy>>;
};

/** All input for the `deleteToolResourceById` mutation. */
export type DeleteToolResourceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteToolResourceByTypeAndToolVersionId` mutation. */
export type DeleteToolResourceByTypeAndToolVersionIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  toolVersionId: Scalars["Int"]["input"];
  type: Scalars["Int"]["input"];
};

/** The output of our delete `ToolResource` mutation. */
export type DeleteToolResourcePayload = {
  __typename: "DeleteToolResourcePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedToolResourceId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ToolResource` that was deleted by this mutation. */
  toolResource: Maybe<ToolResource>;
  /** An edge for our `ToolResource`. May be used by Relay 1. */
  toolResourceEdge: Maybe<ToolResourcesEdge>;
  /** Reads a single `ToolVersion` that is related to this `ToolResource`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our delete `ToolResource` mutation. */
export type DeleteToolResourcePayloadToolResourceEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolResourcesOrderBy>>;
};

/** All input for the `deleteToolResultById` mutation. */
export type DeleteToolResultByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `ToolResult` mutation. */
export type DeleteToolResultPayload = {
  __typename: "DeleteToolResultPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedToolResultId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ToolResult` that was deleted by this mutation. */
  toolResult: Maybe<ToolResult>;
  /** An edge for our `ToolResult`. May be used by Relay 1. */
  toolResultEdge: Maybe<ToolResultsEdge>;
  /** Reads a single `ToolVersion` that is related to this `ToolResult`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our delete `ToolResult` mutation. */
export type DeleteToolResultPayloadToolResultEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolResultsOrderBy>>;
};

/** All input for the `deleteToolSecretById` mutation. */
export type DeleteToolSecretByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `ToolSecret` mutation. */
export type DeleteToolSecretPayload = {
  __typename: "DeleteToolSecretPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedToolSecretId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ToolSecret` that was deleted by this mutation. */
  toolSecret: Maybe<ToolSecret>;
  /** An edge for our `ToolSecret`. May be used by Relay 1. */
  toolSecretEdge: Maybe<ToolSecretsEdge>;
  /** Reads a single `ToolVersion` that is related to this `ToolSecret`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our delete `ToolSecret` mutation. */
export type DeleteToolSecretPayloadToolSecretEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolSecretsOrderBy>>;
};

/** All input for the `deleteToolSourceById` mutation. */
export type DeleteToolSourceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `ToolSource` mutation. */
export type DeleteToolSourcePayload = {
  __typename: "DeleteToolSourcePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedToolSourceId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ToolSource` that was deleted by this mutation. */
  toolSource: Maybe<ToolSource>;
  /** An edge for our `ToolSource`. May be used by Relay 1. */
  toolSourceEdge: Maybe<ToolSourcesEdge>;
  /** Reads a single `ToolVersion` that is related to this `ToolSource`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our delete `ToolSource` mutation. */
export type DeleteToolSourcePayloadToolSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolSourcesOrderBy>>;
};

/** All input for the `deleteToolTenantById` mutation. */
export type DeleteToolTenantByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** All input for the `deleteToolTenantByToolIdAndTenantId` mutation. */
export type DeleteToolTenantByToolIdAndTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  tenantId: Scalars["Int"]["input"];
  toolId: Scalars["Int"]["input"];
};

/** The output of our delete `ToolTenant` mutation. */
export type DeleteToolTenantPayload = {
  __typename: "DeleteToolTenantPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedToolTenantId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ToolTenant`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `Tool` that is related to this `ToolTenant`. */
  toolByToolId: Maybe<Tool>;
  /** The `ToolTenant` that was deleted by this mutation. */
  toolTenant: Maybe<ToolTenant>;
  /** An edge for our `ToolTenant`. May be used by Relay 1. */
  toolTenantEdge: Maybe<ToolTenantsEdge>;
};

/** The output of our delete `ToolTenant` mutation. */
export type DeleteToolTenantPayloadToolTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolTenantsOrderBy>>;
};

/** All input for the `deleteToolVersionById` mutation. */
export type DeleteToolVersionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `ToolVersion` mutation. */
export type DeleteToolVersionPayload = {
  __typename: "DeleteToolVersionPayload";
  /** Reads a single `ApplicationUser` that is related to this `ToolVersion`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `ContainerImage` that is related to this `ToolVersion`. */
  containerImageByContainerImageId: Maybe<ContainerImage>;
  deletedToolVersionId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ToolVersion`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `Tool` that is related to this `ToolVersion`. */
  toolByToolId: Maybe<Tool>;
  /** The `ToolVersion` that was deleted by this mutation. */
  toolVersion: Maybe<ToolVersion>;
  /** An edge for our `ToolVersion`. May be used by Relay 1. */
  toolVersionEdge: Maybe<ToolVersionsEdge>;
};

/** The output of our delete `ToolVersion` mutation. */
export type DeleteToolVersionPayloadToolVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolVersionsOrderBy>>;
};

/** All input for the `deleteToolboxById` mutation. */
export type DeleteToolboxByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteToolboxByKey` mutation. */
export type DeleteToolboxByKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  key: Scalars["String"]["input"];
};

/** The output of our delete `Toolbox` mutation. */
export type DeleteToolboxPayload = {
  __typename: "DeleteToolboxPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedToolboxId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Toolbox` that was deleted by this mutation. */
  toolbox: Maybe<Toolbox>;
  /** An edge for our `Toolbox`. May be used by Relay 1. */
  toolboxEdge: Maybe<ToolboxesEdge>;
};

/** The output of our delete `Toolbox` mutation. */
export type DeleteToolboxPayloadToolboxEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolboxesOrderBy>>;
};

/** All input for the `deleteToolboxTenantById` mutation. */
export type DeleteToolboxTenantByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** All input for the `deleteToolboxTenantByToolboxIdAndTenantId` mutation. */
export type DeleteToolboxTenantByToolboxIdAndTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  tenantId: Scalars["Int"]["input"];
  toolboxId: Scalars["Int"]["input"];
};

/** The output of our delete `ToolboxTenant` mutation. */
export type DeleteToolboxTenantPayload = {
  __typename: "DeleteToolboxTenantPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedToolboxTenantId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ToolboxTenant`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `Toolbox` that is related to this `ToolboxTenant`. */
  toolboxByToolboxId: Maybe<Toolbox>;
  /** The `ToolboxTenant` that was deleted by this mutation. */
  toolboxTenant: Maybe<ToolboxTenant>;
  /** An edge for our `ToolboxTenant`. May be used by Relay 1. */
  toolboxTenantEdge: Maybe<ToolboxTenantsEdge>;
};

/** The output of our delete `ToolboxTenant` mutation. */
export type DeleteToolboxTenantPayloadToolboxTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolboxTenantsOrderBy>>;
};

/** All input for the `deleteUserPersonalSpaceRequestById` mutation. */
export type DeleteUserPersonalSpaceRequestByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our delete `UserPersonalSpaceRequest` mutation. */
export type DeleteUserPersonalSpaceRequestPayload = {
  __typename: "DeleteUserPersonalSpaceRequestPayload";
  /** Reads a single `ApplicationUser` that is related to this `UserPersonalSpaceRequest`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedUserPersonalSpaceRequestId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `UserPersonalSpaceRequest` that was deleted by this mutation. */
  userPersonalSpaceRequest: Maybe<UserPersonalSpaceRequest>;
  /** An edge for our `UserPersonalSpaceRequest`. May be used by Relay 1. */
  userPersonalSpaceRequestEdge: Maybe<UserPersonalSpaceRequestsEdge>;
};

/** The output of our delete `UserPersonalSpaceRequest` mutation. */
export type DeleteUserPersonalSpaceRequestPayloadUserPersonalSpaceRequestEdgeArgs =
  {
    orderBy?: InputMaybe<Array<UserPersonalSpaceRequestsOrderBy>>;
  };

/** All input for the `deleteWaffleFlagById` mutation. */
export type DeleteWaffleFlagByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteWaffleFlagByName` mutation. */
export type DeleteWaffleFlagByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

/** The output of our delete `WaffleFlag` mutation. */
export type DeleteWaffleFlagPayload = {
  __typename: "DeleteWaffleFlagPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedWaffleFlagId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WaffleFlag` that was deleted by this mutation. */
  waffleFlag: Maybe<WaffleFlag>;
  /** An edge for our `WaffleFlag`. May be used by Relay 1. */
  waffleFlagEdge: Maybe<WaffleFlagsEdge>;
};

/** The output of our delete `WaffleFlag` mutation. */
export type DeleteWaffleFlagPayloadWaffleFlagEdgeArgs = {
  orderBy?: InputMaybe<Array<WaffleFlagsOrderBy>>;
};

/** All input for the `deleteWaffleSampleById` mutation. */
export type DeleteWaffleSampleByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteWaffleSampleByName` mutation. */
export type DeleteWaffleSampleByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

/** The output of our delete `WaffleSample` mutation. */
export type DeleteWaffleSamplePayload = {
  __typename: "DeleteWaffleSamplePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedWaffleSampleId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WaffleSample` that was deleted by this mutation. */
  waffleSample: Maybe<WaffleSample>;
  /** An edge for our `WaffleSample`. May be used by Relay 1. */
  waffleSampleEdge: Maybe<WaffleSamplesEdge>;
};

/** The output of our delete `WaffleSample` mutation. */
export type DeleteWaffleSamplePayloadWaffleSampleEdgeArgs = {
  orderBy?: InputMaybe<Array<WaffleSamplesOrderBy>>;
};

/** All input for the `deleteWaffleSwitchById` mutation. */
export type DeleteWaffleSwitchByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `deleteWaffleSwitchByName` mutation. */
export type DeleteWaffleSwitchByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

/** The output of our delete `WaffleSwitch` mutation. */
export type DeleteWaffleSwitchPayload = {
  __typename: "DeleteWaffleSwitchPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedWaffleSwitchId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WaffleSwitch` that was deleted by this mutation. */
  waffleSwitch: Maybe<WaffleSwitch>;
  /** An edge for our `WaffleSwitch`. May be used by Relay 1. */
  waffleSwitchEdge: Maybe<WaffleSwitchesEdge>;
};

/** The output of our delete `WaffleSwitch` mutation. */
export type DeleteWaffleSwitchPayloadWaffleSwitchEdgeArgs = {
  orderBy?: InputMaybe<Array<WaffleSwitchesOrderBy>>;
};

/** All input for the `deleteWorkflowById` mutation. */
export type DeleteWorkflowByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** All input for the `deleteWorkflowDatumById` mutation. */
export type DeleteWorkflowDatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `WorkflowDatum` mutation. */
export type DeleteWorkflowDatumPayload = {
  __typename: "DeleteWorkflowDatumPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedWorkflowDatumId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WorkflowDatum` that was deleted by this mutation. */
  workflowDatum: Maybe<WorkflowDatum>;
  /** An edge for our `WorkflowDatum`. May be used by Relay 1. */
  workflowDatumEdge: Maybe<WorkflowDataEdge>;
};

/** The output of our delete `WorkflowDatum` mutation. */
export type DeleteWorkflowDatumPayloadWorkflowDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowDataOrderBy>>;
};

/** The output of our delete `Workflow` mutation. */
export type DeleteWorkflowPayload = {
  __typename: "DeleteWorkflowPayload";
  /** Reads a single `ApplicationUser` that is related to this `Workflow`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `ContainerImage` that is related to this `Workflow`. */
  containerImageByContainerId: Maybe<ContainerImage>;
  deletedWorkflowId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Workflow`. */
  tenantByTenantId: Maybe<Tenant>;
  /** The `Workflow` that was deleted by this mutation. */
  workflow: Maybe<Workflow>;
  /** An edge for our `Workflow`. May be used by Relay 1. */
  workflowEdge: Maybe<WorkflowsEdge>;
};

/** The output of our delete `Workflow` mutation. */
export type DeleteWorkflowPayloadWorkflowEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowsOrderBy>>;
};

/** All input for the `deleteWorkflowResultById` mutation. */
export type DeleteWorkflowResultByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `WorkflowResult` mutation. */
export type DeleteWorkflowResultPayload = {
  __typename: "DeleteWorkflowResultPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedWorkflowResultId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WorkflowDatum` that is related to this `WorkflowResult`. */
  workflowDatumByObjectId: Maybe<WorkflowDatum>;
  /** The `WorkflowResult` that was deleted by this mutation. */
  workflowResult: Maybe<WorkflowResult>;
  /** An edge for our `WorkflowResult`. May be used by Relay 1. */
  workflowResultEdge: Maybe<WorkflowResultsEdge>;
};

/** The output of our delete `WorkflowResult` mutation. */
export type DeleteWorkflowResultPayloadWorkflowResultEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowResultsOrderBy>>;
};

/** All input for the `deleteWorkflowResultWorkflowVersionById` mutation. */
export type DeleteWorkflowResultWorkflowVersionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** All input for the `deleteWorkflowResultWorkflowVersionByResultIdAndWorkflowversionId` mutation. */
export type DeleteWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    resultId: Scalars["UUID"]["input"];
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The output of our delete `WorkflowResultWorkflowVersion` mutation. */
export type DeleteWorkflowResultWorkflowVersionPayload = {
  __typename: "DeleteWorkflowResultWorkflowVersionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedWorkflowResultWorkflowVersionId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WorkflowResult` that is related to this `WorkflowResultWorkflowVersion`. */
  workflowResultByResultId: Maybe<WorkflowResult>;
  /** The `WorkflowResultWorkflowVersion` that was deleted by this mutation. */
  workflowResultWorkflowVersion: Maybe<WorkflowResultWorkflowVersion>;
  /** An edge for our `WorkflowResultWorkflowVersion`. May be used by Relay 1. */
  workflowResultWorkflowVersionEdge: Maybe<WorkflowResultWorkflowVersionsEdge>;
  /** Reads a single `WorkflowVersion` that is related to this `WorkflowResultWorkflowVersion`. */
  workflowVersionByWorkflowversionId: Maybe<WorkflowVersion>;
};

/** The output of our delete `WorkflowResultWorkflowVersion` mutation. */
export type DeleteWorkflowResultWorkflowVersionPayloadWorkflowResultWorkflowVersionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<WorkflowResultWorkflowVersionsOrderBy>>;
  };

/** All input for the `deleteWorkflowSectionBlockById` mutation. */
export type DeleteWorkflowSectionBlockByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `WorkflowSectionBlock` mutation. */
export type DeleteWorkflowSectionBlockPayload = {
  __typename: "DeleteWorkflowSectionBlockPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedWorkflowSectionBlockId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `ToolVersion` that is related to this `WorkflowSectionBlock`. */
  toolVersionByToolId: Maybe<ToolVersion>;
  /** Reads a single `WorkflowDatum` that is related to this `WorkflowSectionBlock`. */
  workflowDatumByObjectId: Maybe<WorkflowDatum>;
  /** The `WorkflowSectionBlock` that was deleted by this mutation. */
  workflowSectionBlock: Maybe<WorkflowSectionBlock>;
  /** An edge for our `WorkflowSectionBlock`. May be used by Relay 1. */
  workflowSectionBlockEdge: Maybe<WorkflowSectionBlocksEdge>;
};

/** The output of our delete `WorkflowSectionBlock` mutation. */
export type DeleteWorkflowSectionBlockPayloadWorkflowSectionBlockEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowSectionBlocksOrderBy>>;
};

/** All input for the `deleteWorkflowSectionBlockSectionByBlockIdAndSectionId` mutation. */
export type DeleteWorkflowSectionBlockSectionByBlockIdAndSectionIdInput = {
  blockId: Scalars["UUID"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  sectionId: Scalars["UUID"]["input"];
};

/** All input for the `deleteWorkflowSectionBlockSectionById` mutation. */
export type DeleteWorkflowSectionBlockSectionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** The output of our delete `WorkflowSectionBlockSection` mutation. */
export type DeleteWorkflowSectionBlockSectionPayload = {
  __typename: "DeleteWorkflowSectionBlockSectionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedWorkflowSectionBlockSectionId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WorkflowSectionBlock` that is related to this `WorkflowSectionBlockSection`. */
  workflowSectionBlockByBlockId: Maybe<WorkflowSectionBlock>;
  /** The `WorkflowSectionBlockSection` that was deleted by this mutation. */
  workflowSectionBlockSection: Maybe<WorkflowSectionBlockSection>;
  /** An edge for our `WorkflowSectionBlockSection`. May be used by Relay 1. */
  workflowSectionBlockSectionEdge: Maybe<WorkflowSectionBlockSectionsEdge>;
  /** Reads a single `WorkflowSection` that is related to this `WorkflowSectionBlockSection`. */
  workflowSectionBySectionId: Maybe<WorkflowSection>;
};

/** The output of our delete `WorkflowSectionBlockSection` mutation. */
export type DeleteWorkflowSectionBlockSectionPayloadWorkflowSectionBlockSectionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<WorkflowSectionBlockSectionsOrderBy>>;
  };

/** All input for the `deleteWorkflowSectionById` mutation. */
export type DeleteWorkflowSectionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `WorkflowSection` mutation. */
export type DeleteWorkflowSectionPayload = {
  __typename: "DeleteWorkflowSectionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedWorkflowSectionId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WorkflowSection` that was deleted by this mutation. */
  workflowSection: Maybe<WorkflowSection>;
  /** An edge for our `WorkflowSection`. May be used by Relay 1. */
  workflowSectionEdge: Maybe<WorkflowSectionsEdge>;
};

/** The output of our delete `WorkflowSection` mutation. */
export type DeleteWorkflowSectionPayloadWorkflowSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowSectionsOrderBy>>;
};

/** All input for the `deleteWorkflowSectionWorkflowVersionById` mutation. */
export type DeleteWorkflowSectionWorkflowVersionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** All input for the `deleteWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionId` mutation. */
export type DeleteWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    sectionId: Scalars["UUID"]["input"];
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The output of our delete `WorkflowSectionWorkflowVersion` mutation. */
export type DeleteWorkflowSectionWorkflowVersionPayload = {
  __typename: "DeleteWorkflowSectionWorkflowVersionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedWorkflowSectionWorkflowVersionId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WorkflowSection` that is related to this `WorkflowSectionWorkflowVersion`. */
  workflowSectionBySectionId: Maybe<WorkflowSection>;
  /** The `WorkflowSectionWorkflowVersion` that was deleted by this mutation. */
  workflowSectionWorkflowVersion: Maybe<WorkflowSectionWorkflowVersion>;
  /** An edge for our `WorkflowSectionWorkflowVersion`. May be used by Relay 1. */
  workflowSectionWorkflowVersionEdge: Maybe<WorkflowSectionWorkflowVersionsEdge>;
  /** Reads a single `WorkflowVersion` that is related to this `WorkflowSectionWorkflowVersion`. */
  workflowVersionByWorkflowversionId: Maybe<WorkflowVersion>;
};

/** The output of our delete `WorkflowSectionWorkflowVersion` mutation. */
export type DeleteWorkflowSectionWorkflowVersionPayloadWorkflowSectionWorkflowVersionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<WorkflowSectionWorkflowVersionsOrderBy>>;
  };

/** All input for the `deleteWorkflowSourceById` mutation. */
export type DeleteWorkflowSourceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `WorkflowSource` mutation. */
export type DeleteWorkflowSourcePayload = {
  __typename: "DeleteWorkflowSourcePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedWorkflowSourceId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WorkflowSource` that was deleted by this mutation. */
  workflowSource: Maybe<WorkflowSource>;
  /** An edge for our `WorkflowSource`. May be used by Relay 1. */
  workflowSourceEdge: Maybe<WorkflowSourcesEdge>;
};

/** The output of our delete `WorkflowSource` mutation. */
export type DeleteWorkflowSourcePayloadWorkflowSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowSourcesOrderBy>>;
};

/** All input for the `deleteWorkflowSourceWorkflowVersionById` mutation. */
export type DeleteWorkflowSourceWorkflowVersionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** All input for the `deleteWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionId` mutation. */
export type DeleteWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    sourceId: Scalars["UUID"]["input"];
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The output of our delete `WorkflowSourceWorkflowVersion` mutation. */
export type DeleteWorkflowSourceWorkflowVersionPayload = {
  __typename: "DeleteWorkflowSourceWorkflowVersionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedWorkflowSourceWorkflowVersionId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WorkflowSource` that is related to this `WorkflowSourceWorkflowVersion`. */
  workflowSourceBySourceId: Maybe<WorkflowSource>;
  /** The `WorkflowSourceWorkflowVersion` that was deleted by this mutation. */
  workflowSourceWorkflowVersion: Maybe<WorkflowSourceWorkflowVersion>;
  /** An edge for our `WorkflowSourceWorkflowVersion`. May be used by Relay 1. */
  workflowSourceWorkflowVersionEdge: Maybe<WorkflowSourceWorkflowVersionsEdge>;
  /** Reads a single `WorkflowVersion` that is related to this `WorkflowSourceWorkflowVersion`. */
  workflowVersionByWorkflowversionId: Maybe<WorkflowVersion>;
};

/** The output of our delete `WorkflowSourceWorkflowVersion` mutation. */
export type DeleteWorkflowSourceWorkflowVersionPayloadWorkflowSourceWorkflowVersionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<WorkflowSourceWorkflowVersionsOrderBy>>;
  };

/** All input for the `deleteWorkflowVersionById` mutation. */
export type DeleteWorkflowVersionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our delete `WorkflowVersion` mutation. */
export type DeleteWorkflowVersionPayload = {
  __typename: "DeleteWorkflowVersionPayload";
  /** Reads a single `ApplicationUser` that is related to this `WorkflowVersion`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  deletedWorkflowVersionId: Maybe<Scalars["ID"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Workflow` that is related to this `WorkflowVersion`. */
  workflowByWorkflowId: Maybe<Workflow>;
  /** The `WorkflowVersion` that was deleted by this mutation. */
  workflowVersion: Maybe<WorkflowVersion>;
  /** An edge for our `WorkflowVersion`. May be used by Relay 1. */
  workflowVersionEdge: Maybe<WorkflowVersionsEdge>;
};

/** The output of our delete `WorkflowVersion` mutation. */
export type DeleteWorkflowVersionPayloadWorkflowVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowVersionsOrderBy>>;
};

/** The `distributionRegistryImage` to be created by this mutation. */
export type DistributionRegistrContainerimageexecut830E7Af5FkTesContaDistributionRegistryImageCreateInput =
  {
    awsMockDistributionImageUsingContainerimageexecutorPtrId?: InputMaybe<AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInverseInput>;
    jobDefinitionName?: InputMaybe<Scalars["String"]["input"]>;
    jobDefinitionRevision?: InputMaybe<Scalars["Int"]["input"]>;
    tesContainerimageexecutorToContainerimageexecutorPtrId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInput>;
  };

/** Input for the nested mutation of `tesContainerimageexecutor` in the `DistributionRegistryImageInput` mutation. */
export type DistributionRegistrContainerimageexecut830E7Af5FkTesContaInput = {
  /** The primary key(s) for `tesContainerimageexecutor` for the far side of the relationship. */
  connectById?: InputMaybe<TesContainerimageexecutorTesContainerimageexecutorPkeyConnect>;
  /** A `TesContainerimageexecutorInput` object that will be created and connected to this object. */
  create?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaTesContainerimageexecutorCreateInput>;
  /** The primary key(s) for `tesContainerimageexecutor` for the far side of the relationship. */
  deleteById?: InputMaybe<TesContainerimageexecutorTesContainerimageexecutorPkeyDelete>;
  /** The primary key(s) and patch data for `tesContainerimageexecutor` for the far side of the relationship. */
  updateById?: InputMaybe<TesContainerimageexecutorOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaUsingTesContainerimageexecutorPkeyUpdate>;
};

/** Input for the nested mutation of `distributionRegistryImage` in the `TesContainerimageexecutorInput` mutation. */
export type DistributionRegistrContainerimageexecut830E7Af5FkTesContaInverseInput =
  {
    /** The primary key(s) for `distributionRegistryImage` for the far side of the relationship. */
    connectByContainerimageexecutorPtrId?: InputMaybe<DistributionRegistryImageDistributionRegistryImagePkeyConnect>;
    /** A `DistributionRegistryImageInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<DistributionRegistrContainerimageexecut830E7Af5FkTesContaDistributionRegistryImageCreateInput>
    >;
    /** The primary key(s) for `distributionRegistryImage` for the far side of the relationship. */
    deleteByContainerimageexecutorPtrId?: InputMaybe<DistributionRegistryImageDistributionRegistryImagePkeyDelete>;
    /** Flag indicating whether all other `distributionRegistryImage` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The primary key(s) and patch data for `distributionRegistryImage` for the far side of the relationship. */
    updateByContainerimageexecutorPtrId?: InputMaybe<DistributionRegistryImageOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaUsingDistributionRegistryImagePkeyUpdate>;
  };

/** The `tesContainerimageexecutor` to be created by this mutation. */
export type DistributionRegistrContainerimageexecut830E7Af5FkTesContaTesContainerimageexecutorCreateInput =
  {
    awsEcrImageUsingId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInverseInput>;
    containerImageUsingId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInverseInput>;
    distributionRegistryImageUsingId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    tesMockcontainerimageexecutorUsingId?: InputMaybe<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInverseInput>;
  };

export type DistributionRegistryImage = {
  __typename: "DistributionRegistryImage";
  /** Reads a single `AwsMockDistributionImage` that is related to this `DistributionRegistryImage`. */
  awsMockDistributionImageByDistributioncontainerimageexecutorPtrId: Maybe<AwsMockDistributionImage>;
  /**
   * Reads and enables pagination through a set of `AwsMockDistributionImage`.
   * @deprecated Please use awsMockDistributionImageByDistributioncontainerimageexecutorPtrId instead
   */
  awsMockDistributionImagesByDistributioncontainerimageexecutorPtrId: AwsMockDistributionImagesConnection;
  containerimageexecutorPtrId: Scalars["Int"]["output"];
  jobDefinitionName: Maybe<Scalars["String"]["output"]>;
  jobDefinitionRevision: Maybe<Scalars["Int"]["output"]>;
  /** Reads a single `TesContainerimageexecutor` that is related to this `DistributionRegistryImage`. */
  tesContainerimageexecutorByContainerimageexecutorPtrId: Maybe<TesContainerimageexecutor>;
};

export type DistributionRegistryImageAwsMockDistributionImagesByDistributioncontainerimageexecutorPtrIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<AwsMockDistributionImageCondition>;
    filter?: InputMaybe<AwsMockDistributionImageFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<AwsMockDistributionImagesOrderBy>>;
  };

/**
 * A condition to be used against `DistributionRegistryImage` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DistributionRegistryImageCondition = {
  /** Checks for equality with the object’s `containerimageexecutorPtrId` field. */
  containerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `jobDefinitionName` field. */
  jobDefinitionName?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `jobDefinitionRevision` field. */
  jobDefinitionRevision?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `distributionRegistryImage` to look up the row to connect. */
export type DistributionRegistryImageDistributionRegistryImagePkeyConnect = {
  containerimageexecutorPtrId: Scalars["Int"]["input"];
};

/** The fields on `distributionRegistryImage` to look up the row to delete. */
export type DistributionRegistryImageDistributionRegistryImagePkeyDelete = {
  containerimageexecutorPtrId: Scalars["Int"]["input"];
};

/** A filter to be used against `DistributionRegistryImage` object types. All fields are combined with a logical ‘and.’ */
export type DistributionRegistryImageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DistributionRegistryImageFilter>>;
  /** Filter by the object’s `awsMockDistributionImageByDistributioncontainerimageexecutorPtrId` relation. */
  awsMockDistributionImageByDistributioncontainerimageexecutorPtrId?: InputMaybe<AwsMockDistributionImageFilter>;
  /** A related `awsMockDistributionImageByDistributioncontainerimageexecutorPtrId` exists. */
  awsMockDistributionImageByDistributioncontainerimageexecutorPtrIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `containerimageexecutorPtrId` field. */
  containerimageexecutorPtrId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `jobDefinitionName` field. */
  jobDefinitionName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `jobDefinitionRevision` field. */
  jobDefinitionRevision?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DistributionRegistryImageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DistributionRegistryImageFilter>>;
  /** Filter by the object’s `tesContainerimageexecutorByContainerimageexecutorPtrId` relation. */
  tesContainerimageexecutorByContainerimageexecutorPtrId?: InputMaybe<TesContainerimageexecutorFilter>;
};

/** An input for mutations affecting `DistributionRegistryImage` */
export type DistributionRegistryImageInput = {
  awsMockDistributionImageUsingContainerimageexecutorPtrId?: InputMaybe<AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInverseInput>;
  containerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
  jobDefinitionName?: InputMaybe<Scalars["String"]["input"]>;
  jobDefinitionRevision?: InputMaybe<Scalars["Int"]["input"]>;
  tesContainerimageexecutorToContainerimageexecutorPtrId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInput>;
};

/** The fields on `distributionRegistryImage` to look up the row to update. */
export type DistributionRegistryImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributUsingDistributionRegistryImagePkeyUpdate =
  {
    containerimageexecutorPtrId: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `distributionRegistryImage` being updated. */
    distributionRegistryImagePatch: UpdateDistributionRegistryImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributPatch;
  };

/** The fields on `distributionRegistryImage` to look up the row to update. */
export type DistributionRegistryImageOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaUsingDistributionRegistryImagePkeyUpdate =
  {
    containerimageexecutorPtrId: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `distributionRegistryImage` being updated. */
    distributionRegistryImagePatch: UpdateDistributionRegistryImageOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaPatch;
  };

/** Represents an update to a `DistributionRegistryImage`. Fields that are set will be updated. */
export type DistributionRegistryImagePatch = {
  awsMockDistributionImageUsingContainerimageexecutorPtrId?: InputMaybe<AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInverseInput>;
  containerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
  jobDefinitionName?: InputMaybe<Scalars["String"]["input"]>;
  jobDefinitionRevision?: InputMaybe<Scalars["Int"]["input"]>;
  tesContainerimageexecutorToContainerimageexecutorPtrId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInput>;
};

/** A connection to a list of `DistributionRegistryImage` values. */
export type DistributionRegistryImagesConnection = {
  __typename: "DistributionRegistryImagesConnection";
  /** A list of edges which contains the `DistributionRegistryImage` and cursor to aid in pagination. */
  edges: Array<DistributionRegistryImagesEdge>;
  /** A list of `DistributionRegistryImage` objects. */
  nodes: Array<DistributionRegistryImage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DistributionRegistryImage` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DistributionRegistryImage` edge in the connection. */
export type DistributionRegistryImagesEdge = {
  __typename: "DistributionRegistryImagesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DistributionRegistryImage` at the end of the edge. */
  node: DistributionRegistryImage;
};

/** Methods to use when ordering `DistributionRegistryImage`. */
export enum DistributionRegistryImagesOrderBy {
  ContainerimageexecutorPtrIdAsc = "CONTAINERIMAGEEXECUTOR_PTR_ID_ASC",
  ContainerimageexecutorPtrIdDesc = "CONTAINERIMAGEEXECUTOR_PTR_ID_DESC",
  JobDefinitionNameAsc = "JOB_DEFINITION_NAME_ASC",
  JobDefinitionNameDesc = "JOB_DEFINITION_NAME_DESC",
  JobDefinitionRevisionAsc = "JOB_DEFINITION_REVISION_ASC",
  JobDefinitionRevisionDesc = "JOB_DEFINITION_REVISION_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type DjangoAdminLog = {
  __typename: "DjangoAdminLog";
  actionFlag: Scalars["Int"]["output"];
  actionTime: Scalars["Datetime"]["output"];
  /** Reads a single `ApplicationUser` that is related to this `DjangoAdminLog`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  changeMessage: Scalars["String"]["output"];
  contentTypeId: Maybe<Scalars["Int"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `DjangoAdminLog`. */
  djangoContentTypeByContentTypeId: Maybe<DjangoContentType>;
  id: Scalars["Int"]["output"];
  objectId: Maybe<Scalars["String"]["output"]>;
  objectRepr: Scalars["String"]["output"];
  userId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `DjangoAdminLog` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DjangoAdminLogCondition = {
  /** Checks for equality with the object’s `actionFlag` field. */
  actionFlag?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `actionTime` field. */
  actionTime?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `changeMessage` field. */
  changeMessage?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `contentTypeId` field. */
  contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `objectId` field. */
  objectId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `objectRepr` field. */
  objectRepr?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `djangoAdminLog` to be created by this mutation. */
export type DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoDjangoAdminLogCreateInput =
  {
    actionFlag: Scalars["Int"]["input"];
    actionTime: Scalars["Datetime"]["input"];
    applicationUserToUserId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInput>;
    changeMessage: Scalars["String"]["input"];
    djangoContentTypeToContentTypeId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    objectId?: InputMaybe<Scalars["String"]["input"]>;
    objectRepr: Scalars["String"]["input"];
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** The `djangoContentType` to be created by this mutation. */
export type DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `DjangoAdminLogInput` mutation. */
export type DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `djangoAdminLog` in the `DjangoContentTypeInput` mutation. */
export type DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput = {
  /** The primary key(s) for `djangoAdminLog` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DjangoAdminLogDjangoAdminLogPkeyConnect>>;
  /** A `DjangoAdminLogInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoDjangoAdminLogCreateInput>
  >;
  /** The primary key(s) for `djangoAdminLog` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<DjangoAdminLogDjangoAdminLogPkeyDelete>>;
  /** Flag indicating whether all other `djangoAdminLog` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `djangoAdminLog` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DjangoAdminLogOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoAdminLogPkeyUpdate>
  >;
};

/** The fields on `djangoAdminLog` to look up the row to connect. */
export type DjangoAdminLogDjangoAdminLogPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `djangoAdminLog` to look up the row to delete. */
export type DjangoAdminLogDjangoAdminLogPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** A filter to be used against `DjangoAdminLog` object types. All fields are combined with a logical ‘and.’ */
export type DjangoAdminLogFilter = {
  /** Filter by the object’s `actionFlag` field. */
  actionFlag?: InputMaybe<IntFilter>;
  /** Filter by the object’s `actionTime` field. */
  actionTime?: InputMaybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DjangoAdminLogFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `changeMessage` field. */
  changeMessage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `contentTypeId` field. */
  contentTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `djangoContentTypeByContentTypeId` relation. */
  djangoContentTypeByContentTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** A related `djangoContentTypeByContentTypeId` exists. */
  djangoContentTypeByContentTypeIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DjangoAdminLogFilter>;
  /** Filter by the object’s `objectId` field. */
  objectId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `objectRepr` field. */
  objectRepr?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DjangoAdminLogFilter>>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `DjangoAdminLog` */
export type DjangoAdminLogInput = {
  actionFlag: Scalars["Int"]["input"];
  actionTime: Scalars["Datetime"]["input"];
  applicationUserToUserId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInput>;
  changeMessage: Scalars["String"]["input"];
  contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  djangoContentTypeToContentTypeId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  objectId?: InputMaybe<Scalars["String"]["input"]>;
  objectRepr: Scalars["String"]["input"];
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `djangoAdminLog` to look up the row to update. */
export type DjangoAdminLogOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoAdminLogPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoAdminLog` being updated. */
    djangoAdminLogPatch: UpdateDjangoAdminLogOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoAdminLog` to look up the row to update. */
export type DjangoAdminLogOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingDjangoAdminLogPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoAdminLog` being updated. */
    djangoAdminLogPatch: UpdateDjangoAdminLogOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdPatch;
    id: Scalars["Int"]["input"];
  };

/** Represents an update to a `DjangoAdminLog`. Fields that are set will be updated. */
export type DjangoAdminLogPatch = {
  actionFlag?: InputMaybe<Scalars["Int"]["input"]>;
  actionTime?: InputMaybe<Scalars["Datetime"]["input"]>;
  applicationUserToUserId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInput>;
  changeMessage?: InputMaybe<Scalars["String"]["input"]>;
  contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  djangoContentTypeToContentTypeId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  objectId?: InputMaybe<Scalars["String"]["input"]>;
  objectRepr?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `applicationUser` to be created by this mutation. */
export type DjangoAdminLogUserIdC564Eba6FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** The `djangoAdminLog` to be created by this mutation. */
export type DjangoAdminLogUserIdC564Eba6FkApplicationUserIdDjangoAdminLogCreateInput =
  {
    actionFlag: Scalars["Int"]["input"];
    actionTime: Scalars["Datetime"]["input"];
    applicationUserToUserId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInput>;
    changeMessage: Scalars["String"]["input"];
    contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    objectId?: InputMaybe<Scalars["String"]["input"]>;
    objectRepr: Scalars["String"]["input"];
  };

/** Input for the nested mutation of `applicationUser` in the `DjangoAdminLogInput` mutation. */
export type DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `djangoAdminLog` in the `ApplicationUserInput` mutation. */
export type DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `djangoAdminLog` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DjangoAdminLogDjangoAdminLogPkeyConnect>>;
  /** A `DjangoAdminLogInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdDjangoAdminLogCreateInput>
  >;
  /** The primary key(s) for `djangoAdminLog` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<DjangoAdminLogDjangoAdminLogPkeyDelete>>;
  /** Flag indicating whether all other `djangoAdminLog` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `djangoAdminLog` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DjangoAdminLogOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingDjangoAdminLogPkeyUpdate>
  >;
};

/** A connection to a list of `DjangoAdminLog` values. */
export type DjangoAdminLogsConnection = {
  __typename: "DjangoAdminLogsConnection";
  /** A list of edges which contains the `DjangoAdminLog` and cursor to aid in pagination. */
  edges: Array<DjangoAdminLogsEdge>;
  /** A list of `DjangoAdminLog` objects. */
  nodes: Array<DjangoAdminLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DjangoAdminLog` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DjangoAdminLog` edge in the connection. */
export type DjangoAdminLogsEdge = {
  __typename: "DjangoAdminLogsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DjangoAdminLog` at the end of the edge. */
  node: DjangoAdminLog;
};

/** Methods to use when ordering `DjangoAdminLog`. */
export enum DjangoAdminLogsOrderBy {
  ActionFlagAsc = "ACTION_FLAG_ASC",
  ActionFlagDesc = "ACTION_FLAG_DESC",
  ActionTimeAsc = "ACTION_TIME_ASC",
  ActionTimeDesc = "ACTION_TIME_DESC",
  ChangeMessageAsc = "CHANGE_MESSAGE_ASC",
  ChangeMessageDesc = "CHANGE_MESSAGE_DESC",
  ContentTypeIdAsc = "CONTENT_TYPE_ID_ASC",
  ContentTypeIdDesc = "CONTENT_TYPE_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  ObjectIdAsc = "OBJECT_ID_ASC",
  ObjectIdDesc = "OBJECT_ID_DESC",
  ObjectReprAsc = "OBJECT_REPR_ASC",
  ObjectReprDesc = "OBJECT_REPR_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

export type DjangoContentType = {
  __typename: "DjangoContentType";
  appLabel: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `AuditlogLogentry`. */
  auditlogLogentriesByContentTypeId: AuditlogLogentriesConnection;
  /** Reads and enables pagination through a set of `AuthPermission`. */
  authPermissionsByContentTypeId: AuthPermissionsConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionCellStatus`. */
  dataTableColumnDefinitionCellStatusesByCellSetFileColumnTypeId: DataTableColumnDefinitionCellStatusesConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionCellStatus`. */
  dataTableColumnDefinitionCellStatusesByEventSetFileColumnTypeId: DataTableColumnDefinitionCellStatusesConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionCellStatus`. */
  dataTableColumnDefinitionCellStatusesByQcReportFileColumnTypeId: DataTableColumnDefinitionCellStatusesConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionIdentifier`. */
  dataTableColumnDefinitionIdentifiersByTableTypeId: DataTableColumnDefinitionIdentifiersConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionJoin`. */
  dataTableColumnDefinitionJoinsByLeftColumnTypeId: DataTableColumnDefinitionJoinsConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionJoin`. */
  dataTableColumnDefinitionJoinsByRightColumnTypeId: DataTableColumnDefinitionJoinsConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionJoin`. */
  dataTableColumnDefinitionJoinsBySourceColumnTypeId: DataTableColumnDefinitionJoinsConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionMetadatum`. */
  dataTableColumnDefinitionMetadataByFileColumnTypeId: DataTableColumnDefinitionMetadataConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionRoiFrame`. */
  dataTableColumnDefinitionRoiFramesByFileColumnTypeId: DataTableColumnDefinitionRoiFramesConnection;
  /** Reads and enables pagination through a set of `DataTableColumnGroupDefinitionJoin`. */
  dataTableColumnGroupDefinitionJoinsByTableTypeId: DataTableColumnGroupDefinitionJoinsConnection;
  /** Reads and enables pagination through a set of `DataTableColumnGroup`. */
  dataTableColumnGroupsByDefinitionTypeId: DataTableColumnGroupsConnection;
  /** Reads and enables pagination through a set of `DataTableColumn`. */
  dataTableColumnsByDefinitionTypeId: DataTableColumnsConnection;
  /** Reads and enables pagination through a set of `DjangoAdminLog`. */
  djangoAdminLogsByContentTypeId: DjangoAdminLogsConnection;
  /** Reads and enables pagination through a set of `DrsFileexecutor`. */
  drsFileexecutorsByPolymorphicCtypeId: DrsFileexecutorsConnection;
  /** Reads and enables pagination through a set of `FileActivity`. */
  fileActivitiesByContentTypeId: FileActivitiesConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTableColumnGroup`. */
  gdtAnalysisTableColumnGroupsByDefinitionTypeId: GdtAnalysisTableColumnGroupsConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTableColumn`. */
  gdtAnalysisTableColumnsByDefinitionTypeId: GdtAnalysisTableColumnsConnection;
  id: Scalars["Int"]["output"];
  model: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `TenantUserexecutor`. */
  tenantUserexecutorsByPolymorphicCtypeId: TenantUserexecutorsConnection;
  /** Reads and enables pagination through a set of `TesContainerimageexecutor`. */
  tesContainerimageexecutorsByPolymorphicCtypeId: TesContainerimageexecutorsConnection;
  /** Reads and enables pagination through a set of `TesTaskexecutor`. */
  tesTaskexecutorsByPolymorphicCtypeId: TesTaskexecutorsConnection;
};

export type DjangoContentTypeAuditlogLogentriesByContentTypeIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditlogLogentryCondition>;
  filter?: InputMaybe<AuditlogLogentryFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditlogLogentriesOrderBy>>;
};

export type DjangoContentTypeAuthPermissionsByContentTypeIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuthPermissionCondition>;
  filter?: InputMaybe<AuthPermissionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuthPermissionsOrderBy>>;
};

export type DjangoContentTypeDataTableColumnDefinitionCellStatusesByCellSetFileColumnTypeIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<DataTableColumnDefinitionCellStatusCondition>;
    filter?: InputMaybe<DataTableColumnDefinitionCellStatusFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<DataTableColumnDefinitionCellStatusesOrderBy>>;
  };

export type DjangoContentTypeDataTableColumnDefinitionCellStatusesByEventSetFileColumnTypeIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<DataTableColumnDefinitionCellStatusCondition>;
    filter?: InputMaybe<DataTableColumnDefinitionCellStatusFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<DataTableColumnDefinitionCellStatusesOrderBy>>;
  };

export type DjangoContentTypeDataTableColumnDefinitionCellStatusesByQcReportFileColumnTypeIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<DataTableColumnDefinitionCellStatusCondition>;
    filter?: InputMaybe<DataTableColumnDefinitionCellStatusFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<DataTableColumnDefinitionCellStatusesOrderBy>>;
  };

export type DjangoContentTypeDataTableColumnDefinitionIdentifiersByTableTypeIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<DataTableColumnDefinitionIdentifierCondition>;
    filter?: InputMaybe<DataTableColumnDefinitionIdentifierFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<DataTableColumnDefinitionIdentifiersOrderBy>>;
  };

export type DjangoContentTypeDataTableColumnDefinitionJoinsByLeftColumnTypeIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<DataTableColumnDefinitionJoinCondition>;
    filter?: InputMaybe<DataTableColumnDefinitionJoinFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<DataTableColumnDefinitionJoinsOrderBy>>;
  };

export type DjangoContentTypeDataTableColumnDefinitionJoinsByRightColumnTypeIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<DataTableColumnDefinitionJoinCondition>;
    filter?: InputMaybe<DataTableColumnDefinitionJoinFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<DataTableColumnDefinitionJoinsOrderBy>>;
  };

export type DjangoContentTypeDataTableColumnDefinitionJoinsBySourceColumnTypeIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<DataTableColumnDefinitionJoinCondition>;
    filter?: InputMaybe<DataTableColumnDefinitionJoinFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<DataTableColumnDefinitionJoinsOrderBy>>;
  };

export type DjangoContentTypeDataTableColumnDefinitionMetadataByFileColumnTypeIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<DataTableColumnDefinitionMetadatumCondition>;
    filter?: InputMaybe<DataTableColumnDefinitionMetadatumFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<DataTableColumnDefinitionMetadataOrderBy>>;
  };

export type DjangoContentTypeDataTableColumnDefinitionRoiFramesByFileColumnTypeIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<DataTableColumnDefinitionRoiFrameCondition>;
    filter?: InputMaybe<DataTableColumnDefinitionRoiFrameFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<DataTableColumnDefinitionRoiFramesOrderBy>>;
  };

export type DjangoContentTypeDataTableColumnGroupDefinitionJoinsByTableTypeIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<DataTableColumnGroupDefinitionJoinCondition>;
    filter?: InputMaybe<DataTableColumnGroupDefinitionJoinFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<DataTableColumnGroupDefinitionJoinsOrderBy>>;
  };

export type DjangoContentTypeDataTableColumnGroupsByDefinitionTypeIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnGroupCondition>;
  filter?: InputMaybe<DataTableColumnGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnGroupsOrderBy>>;
};

export type DjangoContentTypeDataTableColumnsByDefinitionTypeIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnCondition>;
  filter?: InputMaybe<DataTableColumnFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnsOrderBy>>;
};

export type DjangoContentTypeDjangoAdminLogsByContentTypeIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DjangoAdminLogCondition>;
  filter?: InputMaybe<DjangoAdminLogFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DjangoAdminLogsOrderBy>>;
};

export type DjangoContentTypeDrsFileexecutorsByPolymorphicCtypeIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DrsFileexecutorCondition>;
  filter?: InputMaybe<DrsFileexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DrsFileexecutorsOrderBy>>;
};

export type DjangoContentTypeFileActivitiesByContentTypeIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileActivityCondition>;
  filter?: InputMaybe<FileActivityFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileActivitiesOrderBy>>;
};

export type DjangoContentTypeGdtAnalysisTableColumnGroupsByDefinitionTypeIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<GdtAnalysisTableColumnGroupCondition>;
    filter?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<GdtAnalysisTableColumnGroupsOrderBy>>;
  };

export type DjangoContentTypeGdtAnalysisTableColumnsByDefinitionTypeIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableColumnCondition>;
  filter?: InputMaybe<GdtAnalysisTableColumnFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableColumnsOrderBy>>;
};

export type DjangoContentTypeTenantUserexecutorsByPolymorphicCtypeIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantUserexecutorCondition>;
  filter?: InputMaybe<TenantUserexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantUserexecutorsOrderBy>>;
};

export type DjangoContentTypeTesContainerimageexecutorsByPolymorphicCtypeIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<TesContainerimageexecutorCondition>;
    filter?: InputMaybe<TesContainerimageexecutorFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<TesContainerimageexecutorsOrderBy>>;
  };

export type DjangoContentTypeTesTaskexecutorsByPolymorphicCtypeIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TesTaskexecutorCondition>;
  filter?: InputMaybe<TesTaskexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TesTaskexecutorsOrderBy>>;
};

/**
 * A condition to be used against `DjangoContentType` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DjangoContentTypeCondition = {
  /** Checks for equality with the object’s `appLabel` field. */
  appLabel?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `model` field. */
  model?: InputMaybe<Scalars["String"]["input"]>;
};

/** The fields on `djangoContentType` to look up the row to connect. */
export type DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect =
  {
    appLabel: Scalars["String"]["input"];
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to delete. */
export type DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete =
  {
    appLabel: Scalars["String"]["input"];
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to connect. */
export type DjangoContentTypeDjangoContentTypePkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `djangoContentType` to look up the row to delete. */
export type DjangoContentTypeDjangoContentTypePkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** A filter to be used against `DjangoContentType` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DjangoContentTypeFilter>>;
  /** Filter by the object’s `appLabel` field. */
  appLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `auditlogLogentriesByContentTypeId` relation. */
  auditlogLogentriesByContentTypeId?: InputMaybe<DjangoContentTypeToManyAuditlogLogentryFilter>;
  /** Some related `auditlogLogentriesByContentTypeId` exist. */
  auditlogLogentriesByContentTypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `authPermissionsByContentTypeId` relation. */
  authPermissionsByContentTypeId?: InputMaybe<DjangoContentTypeToManyAuthPermissionFilter>;
  /** Some related `authPermissionsByContentTypeId` exist. */
  authPermissionsByContentTypeIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dataTableColumnDefinitionCellStatusesByCellSetFileColumnTypeId` relation. */
  dataTableColumnDefinitionCellStatusesByCellSetFileColumnTypeId?: InputMaybe<DjangoContentTypeToManyDataTableColumnDefinitionCellStatusFilter>;
  /** Some related `dataTableColumnDefinitionCellStatusesByCellSetFileColumnTypeId` exist. */
  dataTableColumnDefinitionCellStatusesByCellSetFileColumnTypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionCellStatusesByEventSetFileColumnTypeId` relation. */
  dataTableColumnDefinitionCellStatusesByEventSetFileColumnTypeId?: InputMaybe<DjangoContentTypeToManyDataTableColumnDefinitionCellStatusFilter>;
  /** Some related `dataTableColumnDefinitionCellStatusesByEventSetFileColumnTypeId` exist. */
  dataTableColumnDefinitionCellStatusesByEventSetFileColumnTypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionCellStatusesByQcReportFileColumnTypeId` relation. */
  dataTableColumnDefinitionCellStatusesByQcReportFileColumnTypeId?: InputMaybe<DjangoContentTypeToManyDataTableColumnDefinitionCellStatusFilter>;
  /** Some related `dataTableColumnDefinitionCellStatusesByQcReportFileColumnTypeId` exist. */
  dataTableColumnDefinitionCellStatusesByQcReportFileColumnTypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionIdentifiersByTableTypeId` relation. */
  dataTableColumnDefinitionIdentifiersByTableTypeId?: InputMaybe<DjangoContentTypeToManyDataTableColumnDefinitionIdentifierFilter>;
  /** Some related `dataTableColumnDefinitionIdentifiersByTableTypeId` exist. */
  dataTableColumnDefinitionIdentifiersByTableTypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionJoinsByLeftColumnTypeId` relation. */
  dataTableColumnDefinitionJoinsByLeftColumnTypeId?: InputMaybe<DjangoContentTypeToManyDataTableColumnDefinitionJoinFilter>;
  /** Some related `dataTableColumnDefinitionJoinsByLeftColumnTypeId` exist. */
  dataTableColumnDefinitionJoinsByLeftColumnTypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionJoinsByRightColumnTypeId` relation. */
  dataTableColumnDefinitionJoinsByRightColumnTypeId?: InputMaybe<DjangoContentTypeToManyDataTableColumnDefinitionJoinFilter>;
  /** Some related `dataTableColumnDefinitionJoinsByRightColumnTypeId` exist. */
  dataTableColumnDefinitionJoinsByRightColumnTypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionJoinsBySourceColumnTypeId` relation. */
  dataTableColumnDefinitionJoinsBySourceColumnTypeId?: InputMaybe<DjangoContentTypeToManyDataTableColumnDefinitionJoinFilter>;
  /** Some related `dataTableColumnDefinitionJoinsBySourceColumnTypeId` exist. */
  dataTableColumnDefinitionJoinsBySourceColumnTypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionMetadataByFileColumnTypeId` relation. */
  dataTableColumnDefinitionMetadataByFileColumnTypeId?: InputMaybe<DjangoContentTypeToManyDataTableColumnDefinitionMetadatumFilter>;
  /** Some related `dataTableColumnDefinitionMetadataByFileColumnTypeId` exist. */
  dataTableColumnDefinitionMetadataByFileColumnTypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionRoiFramesByFileColumnTypeId` relation. */
  dataTableColumnDefinitionRoiFramesByFileColumnTypeId?: InputMaybe<DjangoContentTypeToManyDataTableColumnDefinitionRoiFrameFilter>;
  /** Some related `dataTableColumnDefinitionRoiFramesByFileColumnTypeId` exist. */
  dataTableColumnDefinitionRoiFramesByFileColumnTypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnGroupDefinitionJoinsByTableTypeId` relation. */
  dataTableColumnGroupDefinitionJoinsByTableTypeId?: InputMaybe<DjangoContentTypeToManyDataTableColumnGroupDefinitionJoinFilter>;
  /** Some related `dataTableColumnGroupDefinitionJoinsByTableTypeId` exist. */
  dataTableColumnGroupDefinitionJoinsByTableTypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnGroupsByDefinitionTypeId` relation. */
  dataTableColumnGroupsByDefinitionTypeId?: InputMaybe<DjangoContentTypeToManyDataTableColumnGroupFilter>;
  /** Some related `dataTableColumnGroupsByDefinitionTypeId` exist. */
  dataTableColumnGroupsByDefinitionTypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnsByDefinitionTypeId` relation. */
  dataTableColumnsByDefinitionTypeId?: InputMaybe<DjangoContentTypeToManyDataTableColumnFilter>;
  /** Some related `dataTableColumnsByDefinitionTypeId` exist. */
  dataTableColumnsByDefinitionTypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `djangoAdminLogsByContentTypeId` relation. */
  djangoAdminLogsByContentTypeId?: InputMaybe<DjangoContentTypeToManyDjangoAdminLogFilter>;
  /** Some related `djangoAdminLogsByContentTypeId` exist. */
  djangoAdminLogsByContentTypeIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `drsFileexecutorsByPolymorphicCtypeId` relation. */
  drsFileexecutorsByPolymorphicCtypeId?: InputMaybe<DjangoContentTypeToManyDrsFileexecutorFilter>;
  /** Some related `drsFileexecutorsByPolymorphicCtypeId` exist. */
  drsFileexecutorsByPolymorphicCtypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `fileActivitiesByContentTypeId` relation. */
  fileActivitiesByContentTypeId?: InputMaybe<DjangoContentTypeToManyFileActivityFilter>;
  /** Some related `fileActivitiesByContentTypeId` exist. */
  fileActivitiesByContentTypeIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `gdtAnalysisTableColumnGroupsByDefinitionTypeId` relation. */
  gdtAnalysisTableColumnGroupsByDefinitionTypeId?: InputMaybe<DjangoContentTypeToManyGdtAnalysisTableColumnGroupFilter>;
  /** Some related `gdtAnalysisTableColumnGroupsByDefinitionTypeId` exist. */
  gdtAnalysisTableColumnGroupsByDefinitionTypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `gdtAnalysisTableColumnsByDefinitionTypeId` relation. */
  gdtAnalysisTableColumnsByDefinitionTypeId?: InputMaybe<DjangoContentTypeToManyGdtAnalysisTableColumnFilter>;
  /** Some related `gdtAnalysisTableColumnsByDefinitionTypeId` exist. */
  gdtAnalysisTableColumnsByDefinitionTypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `model` field. */
  model?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DjangoContentTypeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DjangoContentTypeFilter>>;
  /** Filter by the object’s `tenantUserexecutorsByPolymorphicCtypeId` relation. */
  tenantUserexecutorsByPolymorphicCtypeId?: InputMaybe<DjangoContentTypeToManyTenantUserexecutorFilter>;
  /** Some related `tenantUserexecutorsByPolymorphicCtypeId` exist. */
  tenantUserexecutorsByPolymorphicCtypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `tesContainerimageexecutorsByPolymorphicCtypeId` relation. */
  tesContainerimageexecutorsByPolymorphicCtypeId?: InputMaybe<DjangoContentTypeToManyTesContainerimageexecutorFilter>;
  /** Some related `tesContainerimageexecutorsByPolymorphicCtypeId` exist. */
  tesContainerimageexecutorsByPolymorphicCtypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `tesTaskexecutorsByPolymorphicCtypeId` relation. */
  tesTaskexecutorsByPolymorphicCtypeId?: InputMaybe<DjangoContentTypeToManyTesTaskexecutorFilter>;
  /** Some related `tesTaskexecutorsByPolymorphicCtypeId` exist. */
  tesTaskexecutorsByPolymorphicCtypeIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

/** An input for mutations affecting `DjangoContentType` */
export type DjangoContentTypeInput = {
  appLabel: Scalars["String"]["input"];
  auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
  authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
  dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
  dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
  dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
  dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
  dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
  dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
  dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
  dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
  dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
  dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
  dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
  dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
  djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
  drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
  gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
  gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  model: Scalars["String"]["input"];
  tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
  tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
  tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
};

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate =
  {
    appLabel: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoPatch;
    model: Scalars["String"]["input"];
  };

/** The fields on `djangoContentType` to look up the row to update. */
export type DjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingDjangoContentTypePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `djangoContentType` being updated. */
    djangoContentTypePatch: UpdateDjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** Represents an update to a `DjangoContentType`. Fields that are set will be updated. */
export type DjangoContentTypePatch = {
  appLabel?: InputMaybe<Scalars["String"]["input"]>;
  auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
  authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
  dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
  dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
  dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
  dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
  dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
  dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
  dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
  dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
  dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
  dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
  dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
  dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
  djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
  drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
  gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
  gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  model?: InputMaybe<Scalars["String"]["input"]>;
  tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
  tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
  tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
};

/** A filter to be used against many `AuditlogLogentry` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyAuditlogLogentryFilter = {
  /** Every related `AuditlogLogentry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuditlogLogentryFilter>;
  /** No related `AuditlogLogentry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuditlogLogentryFilter>;
  /** Some related `AuditlogLogentry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuditlogLogentryFilter>;
};

/** A filter to be used against many `AuthPermission` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyAuthPermissionFilter = {
  /** Every related `AuthPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuthPermissionFilter>;
  /** No related `AuthPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuthPermissionFilter>;
  /** Some related `AuthPermission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuthPermissionFilter>;
};

/** A filter to be used against many `DataTableColumnDefinitionCellStatus` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyDataTableColumnDefinitionCellStatusFilter = {
  /** Every related `DataTableColumnDefinitionCellStatus` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnDefinitionCellStatusFilter>;
  /** No related `DataTableColumnDefinitionCellStatus` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnDefinitionCellStatusFilter>;
  /** Some related `DataTableColumnDefinitionCellStatus` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnDefinitionCellStatusFilter>;
};

/** A filter to be used against many `DataTableColumnDefinitionIdentifier` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyDataTableColumnDefinitionIdentifierFilter = {
  /** Every related `DataTableColumnDefinitionIdentifier` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnDefinitionIdentifierFilter>;
  /** No related `DataTableColumnDefinitionIdentifier` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnDefinitionIdentifierFilter>;
  /** Some related `DataTableColumnDefinitionIdentifier` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnDefinitionIdentifierFilter>;
};

/** A filter to be used against many `DataTableColumnDefinitionJoin` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyDataTableColumnDefinitionJoinFilter = {
  /** Every related `DataTableColumnDefinitionJoin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnDefinitionJoinFilter>;
  /** No related `DataTableColumnDefinitionJoin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnDefinitionJoinFilter>;
  /** Some related `DataTableColumnDefinitionJoin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnDefinitionJoinFilter>;
};

/** A filter to be used against many `DataTableColumnDefinitionMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyDataTableColumnDefinitionMetadatumFilter = {
  /** Every related `DataTableColumnDefinitionMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnDefinitionMetadatumFilter>;
  /** No related `DataTableColumnDefinitionMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnDefinitionMetadatumFilter>;
  /** Some related `DataTableColumnDefinitionMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnDefinitionMetadatumFilter>;
};

/** A filter to be used against many `DataTableColumnDefinitionRoiFrame` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyDataTableColumnDefinitionRoiFrameFilter = {
  /** Every related `DataTableColumnDefinitionRoiFrame` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnDefinitionRoiFrameFilter>;
  /** No related `DataTableColumnDefinitionRoiFrame` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnDefinitionRoiFrameFilter>;
  /** Some related `DataTableColumnDefinitionRoiFrame` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnDefinitionRoiFrameFilter>;
};

/** A filter to be used against many `DataTableColumn` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyDataTableColumnFilter = {
  /** Every related `DataTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnFilter>;
  /** No related `DataTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnFilter>;
  /** Some related `DataTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnFilter>;
};

/** A filter to be used against many `DataTableColumnGroupDefinitionJoin` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyDataTableColumnGroupDefinitionJoinFilter = {
  /** Every related `DataTableColumnGroupDefinitionJoin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnGroupDefinitionJoinFilter>;
  /** No related `DataTableColumnGroupDefinitionJoin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnGroupDefinitionJoinFilter>;
  /** Some related `DataTableColumnGroupDefinitionJoin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnGroupDefinitionJoinFilter>;
};

/** A filter to be used against many `DataTableColumnGroup` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyDataTableColumnGroupFilter = {
  /** Every related `DataTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnGroupFilter>;
  /** No related `DataTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnGroupFilter>;
  /** Some related `DataTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnGroupFilter>;
};

/** A filter to be used against many `DjangoAdminLog` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyDjangoAdminLogFilter = {
  /** Every related `DjangoAdminLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DjangoAdminLogFilter>;
  /** No related `DjangoAdminLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DjangoAdminLogFilter>;
  /** Some related `DjangoAdminLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DjangoAdminLogFilter>;
};

/** A filter to be used against many `DrsFileexecutor` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyDrsFileexecutorFilter = {
  /** Every related `DrsFileexecutor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DrsFileexecutorFilter>;
  /** No related `DrsFileexecutor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DrsFileexecutorFilter>;
  /** Some related `DrsFileexecutor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DrsFileexecutorFilter>;
};

/** A filter to be used against many `FileActivity` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyFileActivityFilter = {
  /** Every related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileActivityFilter>;
  /** No related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileActivityFilter>;
  /** Some related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileActivityFilter>;
};

/** A filter to be used against many `GdtAnalysisTableColumn` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyGdtAnalysisTableColumnFilter = {
  /** Every related `GdtAnalysisTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableColumnFilter>;
  /** No related `GdtAnalysisTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableColumnFilter>;
  /** Some related `GdtAnalysisTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableColumnFilter>;
};

/** A filter to be used against many `GdtAnalysisTableColumnGroup` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyGdtAnalysisTableColumnGroupFilter = {
  /** Every related `GdtAnalysisTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
  /** No related `GdtAnalysisTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
  /** Some related `GdtAnalysisTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
};

/** A filter to be used against many `TenantUserexecutor` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyTenantUserexecutorFilter = {
  /** Every related `TenantUserexecutor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TenantUserexecutorFilter>;
  /** No related `TenantUserexecutor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TenantUserexecutorFilter>;
  /** Some related `TenantUserexecutor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TenantUserexecutorFilter>;
};

/** A filter to be used against many `TesContainerimageexecutor` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyTesContainerimageexecutorFilter = {
  /** Every related `TesContainerimageexecutor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TesContainerimageexecutorFilter>;
  /** No related `TesContainerimageexecutor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TesContainerimageexecutorFilter>;
  /** Some related `TesContainerimageexecutor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TesContainerimageexecutorFilter>;
};

/** A filter to be used against many `TesTaskexecutor` object types. All fields are combined with a logical ‘and.’ */
export type DjangoContentTypeToManyTesTaskexecutorFilter = {
  /** Every related `TesTaskexecutor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TesTaskexecutorFilter>;
  /** No related `TesTaskexecutor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TesTaskexecutorFilter>;
  /** Some related `TesTaskexecutor` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TesTaskexecutorFilter>;
};

/** A connection to a list of `DjangoContentType` values. */
export type DjangoContentTypesConnection = {
  __typename: "DjangoContentTypesConnection";
  /** A list of edges which contains the `DjangoContentType` and cursor to aid in pagination. */
  edges: Array<DjangoContentTypesEdge>;
  /** A list of `DjangoContentType` objects. */
  nodes: Array<DjangoContentType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DjangoContentType` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DjangoContentType` edge in the connection. */
export type DjangoContentTypesEdge = {
  __typename: "DjangoContentTypesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DjangoContentType` at the end of the edge. */
  node: DjangoContentType;
};

/** Methods to use when ordering `DjangoContentType`. */
export enum DjangoContentTypesOrderBy {
  AppLabelAsc = "APP_LABEL_ASC",
  AppLabelDesc = "APP_LABEL_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  ModelAsc = "MODEL_ASC",
  ModelDesc = "MODEL_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type DjangoMigration = {
  __typename: "DjangoMigration";
  app: Scalars["String"]["output"];
  applied: Scalars["Datetime"]["output"];
  id: Scalars["BigInt"]["output"];
  name: Scalars["String"]["output"];
};

/**
 * A condition to be used against `DjangoMigration` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DjangoMigrationCondition = {
  /** Checks for equality with the object’s `app` field. */
  app?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `applied` field. */
  applied?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** A filter to be used against `DjangoMigration` object types. All fields are combined with a logical ‘and.’ */
export type DjangoMigrationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DjangoMigrationFilter>>;
  /** Filter by the object’s `app` field. */
  app?: InputMaybe<StringFilter>;
  /** Filter by the object’s `applied` field. */
  applied?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DjangoMigrationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DjangoMigrationFilter>>;
};

/** An input for mutations affecting `DjangoMigration` */
export type DjangoMigrationInput = {
  app: Scalars["String"]["input"];
  applied: Scalars["Datetime"]["input"];
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  name: Scalars["String"]["input"];
};

/** Represents an update to a `DjangoMigration`. Fields that are set will be updated. */
export type DjangoMigrationPatch = {
  app?: InputMaybe<Scalars["String"]["input"]>;
  applied?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** A connection to a list of `DjangoMigration` values. */
export type DjangoMigrationsConnection = {
  __typename: "DjangoMigrationsConnection";
  /** A list of edges which contains the `DjangoMigration` and cursor to aid in pagination. */
  edges: Array<DjangoMigrationsEdge>;
  /** A list of `DjangoMigration` objects. */
  nodes: Array<DjangoMigration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DjangoMigration` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DjangoMigration` edge in the connection. */
export type DjangoMigrationsEdge = {
  __typename: "DjangoMigrationsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DjangoMigration` at the end of the edge. */
  node: DjangoMigration;
};

/** Methods to use when ordering `DjangoMigration`. */
export enum DjangoMigrationsOrderBy {
  AppliedAsc = "APPLIED_ASC",
  AppliedDesc = "APPLIED_DESC",
  AppAsc = "APP_ASC",
  AppDesc = "APP_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type DjangoSesBlacklistedemail = {
  __typename: "DjangoSesBlacklistedemail";
  email: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
};

/**
 * A condition to be used against `DjangoSesBlacklistedemail` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type DjangoSesBlacklistedemailCondition = {
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `DjangoSesBlacklistedemail` object types. All fields are combined with a logical ‘and.’ */
export type DjangoSesBlacklistedemailFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DjangoSesBlacklistedemailFilter>>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DjangoSesBlacklistedemailFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DjangoSesBlacklistedemailFilter>>;
};

/** An input for mutations affecting `DjangoSesBlacklistedemail` */
export type DjangoSesBlacklistedemailInput = {
  email: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents an update to a `DjangoSesBlacklistedemail`. Fields that are set will be updated. */
export type DjangoSesBlacklistedemailPatch = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A connection to a list of `DjangoSesBlacklistedemail` values. */
export type DjangoSesBlacklistedemailsConnection = {
  __typename: "DjangoSesBlacklistedemailsConnection";
  /** A list of edges which contains the `DjangoSesBlacklistedemail` and cursor to aid in pagination. */
  edges: Array<DjangoSesBlacklistedemailsEdge>;
  /** A list of `DjangoSesBlacklistedemail` objects. */
  nodes: Array<DjangoSesBlacklistedemail>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DjangoSesBlacklistedemail` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DjangoSesBlacklistedemail` edge in the connection. */
export type DjangoSesBlacklistedemailsEdge = {
  __typename: "DjangoSesBlacklistedemailsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DjangoSesBlacklistedemail` at the end of the edge. */
  node: DjangoSesBlacklistedemail;
};

/** Methods to use when ordering `DjangoSesBlacklistedemail`. */
export enum DjangoSesBlacklistedemailsOrderBy {
  EmailAsc = "EMAIL_ASC",
  EmailDesc = "EMAIL_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type DjangoSesSesstat = {
  __typename: "DjangoSesSesstat";
  bounces: Scalars["Int"]["output"];
  complaints: Scalars["Int"]["output"];
  date: Scalars["Date"]["output"];
  deliveryAttempts: Scalars["Int"]["output"];
  id: Scalars["Int"]["output"];
  rejects: Scalars["Int"]["output"];
};

/**
 * A condition to be used against `DjangoSesSesstat` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DjangoSesSesstatCondition = {
  /** Checks for equality with the object’s `bounces` field. */
  bounces?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `complaints` field. */
  complaints?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars["Date"]["input"]>;
  /** Checks for equality with the object’s `deliveryAttempts` field. */
  deliveryAttempts?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `rejects` field. */
  rejects?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `DjangoSesSesstat` object types. All fields are combined with a logical ‘and.’ */
export type DjangoSesSesstatFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DjangoSesSesstatFilter>>;
  /** Filter by the object’s `bounces` field. */
  bounces?: InputMaybe<IntFilter>;
  /** Filter by the object’s `complaints` field. */
  complaints?: InputMaybe<IntFilter>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DateFilter>;
  /** Filter by the object’s `deliveryAttempts` field. */
  deliveryAttempts?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DjangoSesSesstatFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DjangoSesSesstatFilter>>;
  /** Filter by the object’s `rejects` field. */
  rejects?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `DjangoSesSesstat` */
export type DjangoSesSesstatInput = {
  bounces: Scalars["Int"]["input"];
  complaints: Scalars["Int"]["input"];
  date: Scalars["Date"]["input"];
  deliveryAttempts: Scalars["Int"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  rejects: Scalars["Int"]["input"];
};

/** Represents an update to a `DjangoSesSesstat`. Fields that are set will be updated. */
export type DjangoSesSesstatPatch = {
  bounces?: InputMaybe<Scalars["Int"]["input"]>;
  complaints?: InputMaybe<Scalars["Int"]["input"]>;
  date?: InputMaybe<Scalars["Date"]["input"]>;
  deliveryAttempts?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  rejects?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A connection to a list of `DjangoSesSesstat` values. */
export type DjangoSesSesstatsConnection = {
  __typename: "DjangoSesSesstatsConnection";
  /** A list of edges which contains the `DjangoSesSesstat` and cursor to aid in pagination. */
  edges: Array<DjangoSesSesstatsEdge>;
  /** A list of `DjangoSesSesstat` objects. */
  nodes: Array<DjangoSesSesstat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DjangoSesSesstat` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DjangoSesSesstat` edge in the connection. */
export type DjangoSesSesstatsEdge = {
  __typename: "DjangoSesSesstatsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DjangoSesSesstat` at the end of the edge. */
  node: DjangoSesSesstat;
};

/** Methods to use when ordering `DjangoSesSesstat`. */
export enum DjangoSesSesstatsOrderBy {
  BouncesAsc = "BOUNCES_ASC",
  BouncesDesc = "BOUNCES_DESC",
  ComplaintsAsc = "COMPLAINTS_ASC",
  ComplaintsDesc = "COMPLAINTS_DESC",
  DateAsc = "DATE_ASC",
  DateDesc = "DATE_DESC",
  DeliveryAttemptsAsc = "DELIVERY_ATTEMPTS_ASC",
  DeliveryAttemptsDesc = "DELIVERY_ATTEMPTS_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  RejectsAsc = "REJECTS_ASC",
  RejectsDesc = "REJECTS_DESC",
}

export type DjangoSession = {
  __typename: "DjangoSession";
  expireDate: Scalars["Datetime"]["output"];
  sessionData: Scalars["String"]["output"];
  sessionKey: Scalars["String"]["output"];
};

/**
 * A condition to be used against `DjangoSession` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DjangoSessionCondition = {
  /** Checks for equality with the object’s `expireDate` field. */
  expireDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `sessionData` field. */
  sessionData?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `sessionKey` field. */
  sessionKey?: InputMaybe<Scalars["String"]["input"]>;
};

/** A filter to be used against `DjangoSession` object types. All fields are combined with a logical ‘and.’ */
export type DjangoSessionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DjangoSessionFilter>>;
  /** Filter by the object’s `expireDate` field. */
  expireDate?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DjangoSessionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DjangoSessionFilter>>;
  /** Filter by the object’s `sessionData` field. */
  sessionData?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sessionKey` field. */
  sessionKey?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `DjangoSession` */
export type DjangoSessionInput = {
  expireDate: Scalars["Datetime"]["input"];
  sessionData: Scalars["String"]["input"];
  sessionKey: Scalars["String"]["input"];
};

/** Represents an update to a `DjangoSession`. Fields that are set will be updated. */
export type DjangoSessionPatch = {
  expireDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  sessionData?: InputMaybe<Scalars["String"]["input"]>;
  sessionKey?: InputMaybe<Scalars["String"]["input"]>;
};

/** A connection to a list of `DjangoSession` values. */
export type DjangoSessionsConnection = {
  __typename: "DjangoSessionsConnection";
  /** A list of edges which contains the `DjangoSession` and cursor to aid in pagination. */
  edges: Array<DjangoSessionsEdge>;
  /** A list of `DjangoSession` objects. */
  nodes: Array<DjangoSession>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DjangoSession` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DjangoSession` edge in the connection. */
export type DjangoSessionsEdge = {
  __typename: "DjangoSessionsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DjangoSession` at the end of the edge. */
  node: DjangoSession;
};

/** Methods to use when ordering `DjangoSession`. */
export enum DjangoSessionsOrderBy {
  ExpireDateAsc = "EXPIRE_DATE_ASC",
  ExpireDateDesc = "EXPIRE_DATE_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  SessionDataAsc = "SESSION_DATA_ASC",
  SessionDataDesc = "SESSION_DATA_DESC",
  SessionKeyAsc = "SESSION_KEY_ASC",
  SessionKeyDesc = "SESSION_KEY_DESC",
}

export type DrsFileexecutor = {
  __typename: "DrsFileexecutor";
  /** Reads a single `AwsS3File` that is related to this `DrsFileexecutor`. */
  awsS3FileByFileexecutorPtrId: Maybe<AwsS3File>;
  /**
   * Reads and enables pagination through a set of `AwsS3File`.
   * @deprecated Please use awsS3FileByFileexecutorPtrId instead
   */
  awsS3FilesByFileexecutorPtrId: AwsS3FilesConnection;
  /** Reads and enables pagination through a set of `CodeFile`. */
  codeFilesByExecutorId: CodeFilesConnection;
  /** Reads a single `DjangoContentType` that is related to this `DrsFileexecutor`. */
  djangoContentTypeByPolymorphicCtypeId: Maybe<DjangoContentType>;
  /** Reads a single `DrsMockfileexecutor` that is related to this `DrsFileexecutor`. */
  drsMockfileexecutorByFileexecutorPtrId: Maybe<DrsMockfileexecutor>;
  /**
   * Reads and enables pagination through a set of `DrsMockfileexecutor`.
   * @deprecated Please use drsMockfileexecutorByFileexecutorPtrId instead
   */
  drsMockfileexecutorsByFileexecutorPtrId: DrsMockfileexecutorsConnection;
  id: Scalars["UUID"]["output"];
  polymorphicCtypeId: Maybe<Scalars["Int"]["output"]>;
};

export type DrsFileexecutorAwsS3FilesByFileexecutorPtrIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsS3FileCondition>;
  filter?: InputMaybe<AwsS3FileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsS3FilesOrderBy>>;
};

export type DrsFileexecutorCodeFilesByExecutorIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CodeFileCondition>;
  filter?: InputMaybe<CodeFileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CodeFilesOrderBy>>;
};

export type DrsFileexecutorDrsMockfileexecutorsByFileexecutorPtrIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DrsMockfileexecutorCondition>;
  filter?: InputMaybe<DrsMockfileexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DrsMockfileexecutorsOrderBy>>;
};

/**
 * A condition to be used against `DrsFileexecutor` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DrsFileexecutorCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `polymorphicCtypeId` field. */
  polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `drsFileexecutor` to look up the row to connect. */
export type DrsFileexecutorDrsFileexecutorPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `drsFileexecutor` to look up the row to delete. */
export type DrsFileexecutorDrsFileexecutorPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** A filter to be used against `DrsFileexecutor` object types. All fields are combined with a logical ‘and.’ */
export type DrsFileexecutorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DrsFileexecutorFilter>>;
  /** Filter by the object’s `awsS3FileByFileexecutorPtrId` relation. */
  awsS3FileByFileexecutorPtrId?: InputMaybe<AwsS3FileFilter>;
  /** A related `awsS3FileByFileexecutorPtrId` exists. */
  awsS3FileByFileexecutorPtrIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `codeFilesByExecutorId` relation. */
  codeFilesByExecutorId?: InputMaybe<DrsFileexecutorToManyCodeFileFilter>;
  /** Some related `codeFilesByExecutorId` exist. */
  codeFilesByExecutorIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `djangoContentTypeByPolymorphicCtypeId` relation. */
  djangoContentTypeByPolymorphicCtypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** A related `djangoContentTypeByPolymorphicCtypeId` exists. */
  djangoContentTypeByPolymorphicCtypeIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `drsMockfileexecutorByFileexecutorPtrId` relation. */
  drsMockfileexecutorByFileexecutorPtrId?: InputMaybe<DrsMockfileexecutorFilter>;
  /** A related `drsMockfileexecutorByFileexecutorPtrId` exists. */
  drsMockfileexecutorByFileexecutorPtrIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DrsFileexecutorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DrsFileexecutorFilter>>;
  /** Filter by the object’s `polymorphicCtypeId` field. */
  polymorphicCtypeId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `DrsFileexecutor` */
export type DrsFileexecutorInput = {
  awsS3FileUsingId?: InputMaybe<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInverseInput>;
  djangoContentTypeToPolymorphicCtypeId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInput>;
  drsMockfileexecutorUsingId?: InputMaybe<DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInverseInput>;
  filesUsingId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInverseInput>;
  id: Scalars["UUID"]["input"];
  polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `drsFileexecutor` to look up the row to update. */
export type DrsFileexecutorOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdUsingDrsFileexecutorPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `drsFileexecutor` being updated. */
    drsFileexecutorPatch: UpdateDrsFileexecutorOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `drsFileexecutor` to look up the row to update. */
export type DrsFileexecutorOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdUsingDrsFileexecutorPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `drsFileexecutor` being updated. */
    drsFileexecutorPatch: UpdateDrsFileexecutorOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `drsFileexecutor` to look up the row to update. */
export type DrsFileexecutorOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDrsFileexecutorPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `drsFileexecutor` being updated. */
    drsFileexecutorPatch: UpdateDrsFileexecutorOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `drsFileexecutor` to look up the row to update. */
export type DrsFileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeUsingDrsFileexecutorPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `drsFileexecutor` being updated. */
    drsFileexecutorPatch: UpdateDrsFileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileePatch;
    id: Scalars["UUID"]["input"];
  };

/** Represents an update to a `DrsFileexecutor`. Fields that are set will be updated. */
export type DrsFileexecutorPatch = {
  awsS3FileUsingId?: InputMaybe<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInverseInput>;
  djangoContentTypeToPolymorphicCtypeId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInput>;
  drsMockfileexecutorUsingId?: InputMaybe<DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInverseInput>;
  filesUsingId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInverseInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The `djangoContentType` to be created by this mutation. */
export type DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** The `drsFileexecutor` to be created by this mutation. */
export type DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoDrsFileexecutorCreateInput =
  {
    awsS3FileUsingId?: InputMaybe<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInput>;
    drsMockfileexecutorUsingId?: InputMaybe<DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInverseInput>;
    filesUsingId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInverseInput>;
    id: Scalars["UUID"]["input"];
  };

/** Input for the nested mutation of `djangoContentType` in the `DrsFileexecutorInput` mutation. */
export type DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `drsFileexecutor` in the `DjangoContentTypeInput` mutation. */
export type DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput = {
  /** The primary key(s) for `drsFileexecutor` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DrsFileexecutorDrsFileexecutorPkeyConnect>>;
  /** A `DrsFileexecutorInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoDrsFileexecutorCreateInput>
  >;
  /** The primary key(s) for `drsFileexecutor` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<DrsFileexecutorDrsFileexecutorPkeyDelete>>;
  /** Flag indicating whether all other `drsFileexecutor` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `drsFileexecutor` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<DrsFileexecutorOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDrsFileexecutorPkeyUpdate>
  >;
};

/** A filter to be used against many `CodeFile` object types. All fields are combined with a logical ‘and.’ */
export type DrsFileexecutorToManyCodeFileFilter = {
  /** Every related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CodeFileFilter>;
  /** No related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CodeFileFilter>;
  /** Some related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CodeFileFilter>;
};

/** A connection to a list of `DrsFileexecutor` values. */
export type DrsFileexecutorsConnection = {
  __typename: "DrsFileexecutorsConnection";
  /** A list of edges which contains the `DrsFileexecutor` and cursor to aid in pagination. */
  edges: Array<DrsFileexecutorsEdge>;
  /** A list of `DrsFileexecutor` objects. */
  nodes: Array<DrsFileexecutor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DrsFileexecutor` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DrsFileexecutor` edge in the connection. */
export type DrsFileexecutorsEdge = {
  __typename: "DrsFileexecutorsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DrsFileexecutor` at the end of the edge. */
  node: DrsFileexecutor;
};

/** Methods to use when ordering `DrsFileexecutor`. */
export enum DrsFileexecutorsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PolymorphicCtypeIdAsc = "POLYMORPHIC_CTYPE_ID_ASC",
  PolymorphicCtypeIdDesc = "POLYMORPHIC_CTYPE_ID_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type DrsMockfileexecutor = {
  __typename: "DrsMockfileexecutor";
  /** Reads a single `DrsFileexecutor` that is related to this `DrsMockfileexecutor`. */
  drsFileexecutorByFileexecutorPtrId: Maybe<DrsFileexecutor>;
  fileexecutorPtrId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `DrsMockfileexecutor` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DrsMockfileexecutorCondition = {
  /** Checks for equality with the object’s `fileexecutorPtrId` field. */
  fileexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `drsMockfileexecutor` to look up the row to connect. */
export type DrsMockfileexecutorDrsMockfileexecutorPkeyConnect = {
  fileexecutorPtrId: Scalars["UUID"]["input"];
};

/** The fields on `drsMockfileexecutor` to look up the row to delete. */
export type DrsMockfileexecutorDrsMockfileexecutorPkeyDelete = {
  fileexecutorPtrId: Scalars["UUID"]["input"];
};

/** The `drsFileexecutor` to be created by this mutation. */
export type DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeDrsFileexecutorCreateInput =
  {
    awsS3FileUsingId?: InputMaybe<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInput>;
    drsMockfileexecutorUsingId?: InputMaybe<DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInverseInput>;
    filesUsingId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInverseInput>;
    id: Scalars["UUID"]["input"];
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** The `drsMockfileexecutor` to be created by this mutation. */
export type DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeDrsMockfileexecutorCreateInput =
  {
    drsFileexecutorToFileexecutorPtrId?: InputMaybe<DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInput>;
  };

/** Input for the nested mutation of `drsFileexecutor` in the `DrsMockfileexecutorInput` mutation. */
export type DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInput = {
  /** The primary key(s) for `drsFileexecutor` for the far side of the relationship. */
  connectById?: InputMaybe<DrsFileexecutorDrsFileexecutorPkeyConnect>;
  /** A `DrsFileexecutorInput` object that will be created and connected to this object. */
  create?: InputMaybe<DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeDrsFileexecutorCreateInput>;
  /** The primary key(s) for `drsFileexecutor` for the far side of the relationship. */
  deleteById?: InputMaybe<DrsFileexecutorDrsFileexecutorPkeyDelete>;
  /** The primary key(s) and patch data for `drsFileexecutor` for the far side of the relationship. */
  updateById?: InputMaybe<DrsFileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeUsingDrsFileexecutorPkeyUpdate>;
};

/** Input for the nested mutation of `drsMockfileexecutor` in the `DrsFileexecutorInput` mutation. */
export type DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInverseInput =
  {
    /** The primary key(s) for `drsMockfileexecutor` for the far side of the relationship. */
    connectByFileexecutorPtrId?: InputMaybe<DrsMockfileexecutorDrsMockfileexecutorPkeyConnect>;
    /** A `DrsMockfileexecutorInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeDrsMockfileexecutorCreateInput>
    >;
    /** The primary key(s) for `drsMockfileexecutor` for the far side of the relationship. */
    deleteByFileexecutorPtrId?: InputMaybe<DrsMockfileexecutorDrsMockfileexecutorPkeyDelete>;
    /** Flag indicating whether all other `drsMockfileexecutor` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The primary key(s) and patch data for `drsMockfileexecutor` for the far side of the relationship. */
    updateByFileexecutorPtrId?: InputMaybe<DrsMockfileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeUsingDrsMockfileexecutorPkeyUpdate>;
  };

/** A filter to be used against `DrsMockfileexecutor` object types. All fields are combined with a logical ‘and.’ */
export type DrsMockfileexecutorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DrsMockfileexecutorFilter>>;
  /** Filter by the object’s `drsFileexecutorByFileexecutorPtrId` relation. */
  drsFileexecutorByFileexecutorPtrId?: InputMaybe<DrsFileexecutorFilter>;
  /** Filter by the object’s `fileexecutorPtrId` field. */
  fileexecutorPtrId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DrsMockfileexecutorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DrsMockfileexecutorFilter>>;
};

/** An input for mutations affecting `DrsMockfileexecutor` */
export type DrsMockfileexecutorInput = {
  drsFileexecutorToFileexecutorPtrId?: InputMaybe<DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInput>;
  fileexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `drsMockfileexecutor` to look up the row to update. */
export type DrsMockfileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeUsingDrsMockfileexecutorPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `drsMockfileexecutor` being updated. */
    drsMockfileexecutorPatch: UpdateDrsMockfileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileePatch;
    fileexecutorPtrId: Scalars["UUID"]["input"];
  };

/** Represents an update to a `DrsMockfileexecutor`. Fields that are set will be updated. */
export type DrsMockfileexecutorPatch = {
  drsFileexecutorToFileexecutorPtrId?: InputMaybe<DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInput>;
  fileexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A connection to a list of `DrsMockfileexecutor` values. */
export type DrsMockfileexecutorsConnection = {
  __typename: "DrsMockfileexecutorsConnection";
  /** A list of edges which contains the `DrsMockfileexecutor` and cursor to aid in pagination. */
  edges: Array<DrsMockfileexecutorsEdge>;
  /** A list of `DrsMockfileexecutor` objects. */
  nodes: Array<DrsMockfileexecutor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DrsMockfileexecutor` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `DrsMockfileexecutor` edge in the connection. */
export type DrsMockfileexecutorsEdge = {
  __typename: "DrsMockfileexecutorsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `DrsMockfileexecutor` at the end of the edge. */
  node: DrsMockfileexecutor;
};

/** Methods to use when ordering `DrsMockfileexecutor`. */
export enum DrsMockfileexecutorsOrderBy {
  FileexecutorPtrIdAsc = "FILEEXECUTOR_PTR_ID_ASC",
  FileexecutorPtrIdDesc = "FILEEXECUTOR_PTR_ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type EulaVersion = {
  __typename: "EulaVersion";
  content: Scalars["String"]["output"];
  dateCreated: Scalars["Datetime"]["output"];
  dateVersion: Scalars["Datetime"]["output"];
  /** Reads and enables pagination through a set of `EulaVersionUserAcceptance`. */
  eulaVersionUserAcceptancesByEulaVersionId: EulaVersionUserAcceptancesConnection;
  id: Scalars["Int"]["output"];
  version: Scalars["String"]["output"];
};

export type EulaVersionEulaVersionUserAcceptancesByEulaVersionIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<EulaVersionUserAcceptanceCondition>;
  filter?: InputMaybe<EulaVersionUserAcceptanceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<EulaVersionUserAcceptancesOrderBy>>;
};

/**
 * A condition to be used against `EulaVersion` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type EulaVersionCondition = {
  /** Checks for equality with the object’s `content` field. */
  content?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateVersion` field. */
  dateVersion?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars["String"]["input"]>;
};

/** The fields on `eulaVersion` to look up the row to connect. */
export type EulaVersionEulaVersionPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `eulaVersion` to look up the row to delete. */
export type EulaVersionEulaVersionPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** The fields on `eulaVersion` to look up the row to connect. */
export type EulaVersionEulaVersionVersionKeyConnect = {
  version: Scalars["String"]["input"];
};

/** The fields on `eulaVersion` to look up the row to delete. */
export type EulaVersionEulaVersionVersionKeyDelete = {
  version: Scalars["String"]["input"];
};

/** A filter to be used against `EulaVersion` object types. All fields are combined with a logical ‘and.’ */
export type EulaVersionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EulaVersionFilter>>;
  /** Filter by the object’s `content` field. */
  content?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateVersion` field. */
  dateVersion?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eulaVersionUserAcceptancesByEulaVersionId` relation. */
  eulaVersionUserAcceptancesByEulaVersionId?: InputMaybe<EulaVersionToManyEulaVersionUserAcceptanceFilter>;
  /** Some related `eulaVersionUserAcceptancesByEulaVersionId` exist. */
  eulaVersionUserAcceptancesByEulaVersionIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EulaVersionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EulaVersionFilter>>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `EulaVersion` */
export type EulaVersionInput = {
  content: Scalars["String"]["input"];
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateVersion?: InputMaybe<Scalars["Datetime"]["input"]>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  version: Scalars["String"]["input"];
};

/** The fields on `eulaVersion` to look up the row to update. */
export type EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `eulaVersion` being updated. */
    eulaVersionPatch: UpdateEulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `eulaVersion` to look up the row to update. */
export type EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionVersionKeyUpdate =
  {
    /** An object where the defined keys will be set on the `eulaVersion` being updated. */
    eulaVersionPatch: UpdateEulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch;
    version: Scalars["String"]["input"];
  };

/** Represents an update to a `EulaVersion`. Fields that are set will be updated. */
export type EulaVersionPatch = {
  content?: InputMaybe<Scalars["String"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateVersion?: InputMaybe<Scalars["Datetime"]["input"]>;
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  version?: InputMaybe<Scalars["String"]["input"]>;
};

/** A filter to be used against many `EulaVersionUserAcceptance` object types. All fields are combined with a logical ‘and.’ */
export type EulaVersionToManyEulaVersionUserAcceptanceFilter = {
  /** Every related `EulaVersionUserAcceptance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EulaVersionUserAcceptanceFilter>;
  /** No related `EulaVersionUserAcceptance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EulaVersionUserAcceptanceFilter>;
  /** Some related `EulaVersionUserAcceptance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EulaVersionUserAcceptanceFilter>;
};

/** The `eulaVersion` to be created by this mutation. */
export type EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionCreateInput =
  {
    content: Scalars["String"]["input"];
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateVersion?: InputMaybe<Scalars["Datetime"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    version: Scalars["String"]["input"];
  };

/** The `eulaVersionUserAcceptance` to be created by this mutation. */
export type EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionUserAcceptanceCreateInput =
  {
    accepted: Scalars["Boolean"]["input"];
    applicationUserToUserId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput>;
    dateReviewed?: InputMaybe<Scalars["Datetime"]["input"]>;
    eulaVersionToEulaVersionId?: InputMaybe<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput>;
    id: Scalars["UUID"]["input"];
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** Input for the nested mutation of `eulaVersion` in the `EulaVersionUserAcceptanceInput` mutation. */
export type EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput = {
  /** The primary key(s) for `eulaVersion` for the far side of the relationship. */
  connectById?: InputMaybe<EulaVersionEulaVersionPkeyConnect>;
  /** The primary key(s) for `eulaVersion` for the far side of the relationship. */
  connectByVersion?: InputMaybe<EulaVersionEulaVersionVersionKeyConnect>;
  /** A `EulaVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionCreateInput>;
  /** The primary key(s) for `eulaVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<EulaVersionEulaVersionPkeyDelete>;
  /** The primary key(s) for `eulaVersion` for the far side of the relationship. */
  deleteByVersion?: InputMaybe<EulaVersionEulaVersionVersionKeyDelete>;
  /** The primary key(s) and patch data for `eulaVersion` for the far side of the relationship. */
  updateById?: InputMaybe<EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionPkeyUpdate>;
  /** The primary key(s) and patch data for `eulaVersion` for the far side of the relationship. */
  updateByVersion?: InputMaybe<EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionVersionKeyUpdate>;
};

/** Input for the nested mutation of `eulaVersionUserAcceptance` in the `EulaVersionInput` mutation. */
export type EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInverseInput = {
  /** The primary key(s) for `eulaVersionUserAcceptance` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyConnect>
  >;
  /** The primary key(s) for `eulaVersionUserAcceptance` for the far side of the relationship. */
  connectByUserIdAndEulaVersionId?: InputMaybe<
    Array<EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueConnect>
  >;
  /** A `EulaVersionUserAcceptanceInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionUserAcceptanceCreateInput>
  >;
  /** The primary key(s) for `eulaVersionUserAcceptance` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyDelete>
  >;
  /** The primary key(s) for `eulaVersionUserAcceptance` for the far side of the relationship. */
  deleteByUserIdAndEulaVersionId?: InputMaybe<
    Array<EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueDelete>
  >;
  /** Flag indicating whether all other `eulaVersionUserAcceptance` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `eulaVersionUserAcceptance` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptancePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `eulaVersionUserAcceptance` for the far side of the relationship. */
  updateByUserIdAndEulaVersionId?: InputMaybe<
    Array<EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptanceUniqueUpdate>
  >;
};

/** The `applicationUser` to be created by this mutation. */
export type EulaVersionUserAcUserIdB72Ed9C5FkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** The `eulaVersionUserAcceptance` to be created by this mutation. */
export type EulaVersionUserAcUserIdB72Ed9C5FkApplicatiEulaVersionUserAcceptanceCreateInput =
  {
    accepted: Scalars["Boolean"]["input"];
    applicationUserToUserId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput>;
    dateReviewed?: InputMaybe<Scalars["Datetime"]["input"]>;
    eulaVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    eulaVersionToEulaVersionId?: InputMaybe<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput>;
    id: Scalars["UUID"]["input"];
  };

/** Input for the nested mutation of `applicationUser` in the `EulaVersionUserAcceptanceInput` mutation. */
export type EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `eulaVersionUserAcceptance` in the `ApplicationUserInput` mutation. */
export type EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput = {
  /** The primary key(s) for `eulaVersionUserAcceptance` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyConnect>
  >;
  /** The primary key(s) for `eulaVersionUserAcceptance` for the far side of the relationship. */
  connectByUserIdAndEulaVersionId?: InputMaybe<
    Array<EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueConnect>
  >;
  /** A `EulaVersionUserAcceptanceInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiEulaVersionUserAcceptanceCreateInput>
  >;
  /** The primary key(s) for `eulaVersionUserAcceptance` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyDelete>
  >;
  /** The primary key(s) for `eulaVersionUserAcceptance` for the far side of the relationship. */
  deleteByUserIdAndEulaVersionId?: InputMaybe<
    Array<EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueDelete>
  >;
  /** Flag indicating whether all other `eulaVersionUserAcceptance` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `eulaVersionUserAcceptance` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptancePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `eulaVersionUserAcceptance` for the far side of the relationship. */
  updateByUserIdAndEulaVersionId?: InputMaybe<
    Array<EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptanceUniqueUpdate>
  >;
};

export type EulaVersionUserAcceptance = {
  __typename: "EulaVersionUserAcceptance";
  accepted: Scalars["Boolean"]["output"];
  /** Reads a single `ApplicationUser` that is related to this `EulaVersionUserAcceptance`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateReviewed: Scalars["Datetime"]["output"];
  /** Reads a single `EulaVersion` that is related to this `EulaVersionUserAcceptance`. */
  eulaVersionByEulaVersionId: Maybe<EulaVersion>;
  eulaVersionId: Scalars["Int"]["output"];
  id: Scalars["UUID"]["output"];
  userId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `EulaVersionUserAcceptance` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type EulaVersionUserAcceptanceCondition = {
  /** Checks for equality with the object’s `accepted` field. */
  accepted?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `dateReviewed` field. */
  dateReviewed?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `eulaVersionId` field. */
  eulaVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `eulaVersionUserAcceptance` to look up the row to connect. */
export type EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `eulaVersionUserAcceptance` to look up the row to delete. */
export type EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `eulaVersionUserAcceptance` to look up the row to connect. */
export type EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueConnect = {
  eulaVersionId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The fields on `eulaVersionUserAcceptance` to look up the row to delete. */
export type EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueDelete = {
  eulaVersionId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** A filter to be used against `EulaVersionUserAcceptance` object types. All fields are combined with a logical ‘and.’ */
export type EulaVersionUserAcceptanceFilter = {
  /** Filter by the object’s `accepted` field. */
  accepted?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EulaVersionUserAcceptanceFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dateReviewed` field. */
  dateReviewed?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eulaVersionByEulaVersionId` relation. */
  eulaVersionByEulaVersionId?: InputMaybe<EulaVersionFilter>;
  /** Filter by the object’s `eulaVersionId` field. */
  eulaVersionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EulaVersionUserAcceptanceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EulaVersionUserAcceptanceFilter>>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `EulaVersionUserAcceptance` */
export type EulaVersionUserAcceptanceInput = {
  accepted: Scalars["Boolean"]["input"];
  applicationUserToUserId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput>;
  dateReviewed?: InputMaybe<Scalars["Datetime"]["input"]>;
  eulaVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  eulaVersionToEulaVersionId?: InputMaybe<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput>;
  id: Scalars["UUID"]["input"];
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `eulaVersionUserAcceptance` to look up the row to update. */
export type EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptancePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `eulaVersionUserAcceptance` being updated. */
    eulaVersionUserAcceptancePatch: UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `eulaVersionUserAcceptance` to look up the row to update. */
export type EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptanceUniqueUpdate =
  {
    eulaVersionId: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `eulaVersionUserAcceptance` being updated. */
    eulaVersionUserAcceptancePatch: UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch;
    userId: Scalars["UUID"]["input"];
  };

/** The fields on `eulaVersionUserAcceptance` to look up the row to update. */
export type EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptancePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `eulaVersionUserAcceptance` being updated. */
    eulaVersionUserAcceptancePatch: UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `eulaVersionUserAcceptance` to look up the row to update. */
export type EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptanceUniqueUpdate =
  {
    eulaVersionId: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `eulaVersionUserAcceptance` being updated. */
    eulaVersionUserAcceptancePatch: UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
    userId: Scalars["UUID"]["input"];
  };

/** Represents an update to a `EulaVersionUserAcceptance`. Fields that are set will be updated. */
export type EulaVersionUserAcceptancePatch = {
  accepted?: InputMaybe<Scalars["Boolean"]["input"]>;
  applicationUserToUserId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput>;
  dateReviewed?: InputMaybe<Scalars["Datetime"]["input"]>;
  eulaVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  eulaVersionToEulaVersionId?: InputMaybe<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A connection to a list of `EulaVersionUserAcceptance` values. */
export type EulaVersionUserAcceptancesConnection = {
  __typename: "EulaVersionUserAcceptancesConnection";
  /** A list of edges which contains the `EulaVersionUserAcceptance` and cursor to aid in pagination. */
  edges: Array<EulaVersionUserAcceptancesEdge>;
  /** A list of `EulaVersionUserAcceptance` objects. */
  nodes: Array<EulaVersionUserAcceptance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EulaVersionUserAcceptance` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `EulaVersionUserAcceptance` edge in the connection. */
export type EulaVersionUserAcceptancesEdge = {
  __typename: "EulaVersionUserAcceptancesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `EulaVersionUserAcceptance` at the end of the edge. */
  node: EulaVersionUserAcceptance;
};

/** Methods to use when ordering `EulaVersionUserAcceptance`. */
export enum EulaVersionUserAcceptancesOrderBy {
  AcceptedAsc = "ACCEPTED_ASC",
  AcceptedDesc = "ACCEPTED_DESC",
  DateReviewedAsc = "DATE_REVIEWED_ASC",
  DateReviewedDesc = "DATE_REVIEWED_DESC",
  EulaVersionIdAsc = "EULA_VERSION_ID_ASC",
  EulaVersionIdDesc = "EULA_VERSION_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** A connection to a list of `EulaVersion` values. */
export type EulaVersionsConnection = {
  __typename: "EulaVersionsConnection";
  /** A list of edges which contains the `EulaVersion` and cursor to aid in pagination. */
  edges: Array<EulaVersionsEdge>;
  /** A list of `EulaVersion` objects. */
  nodes: Array<EulaVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EulaVersion` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `EulaVersion` edge in the connection. */
export type EulaVersionsEdge = {
  __typename: "EulaVersionsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `EulaVersion` at the end of the edge. */
  node: EulaVersion;
};

/** Methods to use when ordering `EulaVersion`. */
export enum EulaVersionsOrderBy {
  ContentAsc = "CONTENT_ASC",
  ContentDesc = "CONTENT_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DateVersionAsc = "DATE_VERSION_ASC",
  DateVersionDesc = "DATE_VERSION_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  VersionAsc = "VERSION_ASC",
  VersionDesc = "VERSION_DESC",
}

export type FeatureFlag = {
  __typename: "FeatureFlag";
  authenticated: Scalars["Boolean"]["output"];
  created: Scalars["Datetime"]["output"];
  everyone: Maybe<Scalars["Boolean"]["output"]>;
  /** Reads and enables pagination through a set of `FeatureFlagsGroup`. */
  featureFlagsGroupsByFeatureflagId: FeatureFlagsGroupsConnection;
  /** Reads and enables pagination through a set of `FeatureFlagsTenant`. */
  featureFlagsTenantsByFeatureflagId: FeatureFlagsTenantsConnection;
  /** Reads and enables pagination through a set of `FeatureFlagsUser`. */
  featureFlagsUsersByFeatureflagId: FeatureFlagsUsersConnection;
  id: Scalars["BigInt"]["output"];
  languages: Scalars["String"]["output"];
  modified: Scalars["Datetime"]["output"];
  name: Scalars["String"]["output"];
  note: Scalars["String"]["output"];
  percent: Maybe<Scalars["BigFloat"]["output"]>;
  rollout: Scalars["Boolean"]["output"];
  staff: Scalars["Boolean"]["output"];
  superusers: Scalars["Boolean"]["output"];
  testing: Scalars["Boolean"]["output"];
};

export type FeatureFlagFeatureFlagsGroupsByFeatureflagIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FeatureFlagsGroupCondition>;
  filter?: InputMaybe<FeatureFlagsGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FeatureFlagsGroupsOrderBy>>;
};

export type FeatureFlagFeatureFlagsTenantsByFeatureflagIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FeatureFlagsTenantCondition>;
  filter?: InputMaybe<FeatureFlagsTenantFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FeatureFlagsTenantsOrderBy>>;
};

export type FeatureFlagFeatureFlagsUsersByFeatureflagIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FeatureFlagsUserCondition>;
  filter?: InputMaybe<FeatureFlagsUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FeatureFlagsUsersOrderBy>>;
};

/**
 * A condition to be used against `FeatureFlag` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FeatureFlagCondition = {
  /** Checks for equality with the object’s `authenticated` field. */
  authenticated?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `everyone` field. */
  everyone?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `languages` field. */
  languages?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `modified` field. */
  modified?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `percent` field. */
  percent?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Checks for equality with the object’s `rollout` field. */
  rollout?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `staff` field. */
  staff?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `superusers` field. */
  superusers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `testing` field. */
  testing?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The fields on `featureFlag` to look up the row to connect. */
export type FeatureFlagFeatureFlagsNameKeyConnect = {
  name: Scalars["String"]["input"];
};

/** The fields on `featureFlag` to look up the row to delete. */
export type FeatureFlagFeatureFlagsNameKeyDelete = {
  name: Scalars["String"]["input"];
};

/** The fields on `featureFlag` to look up the row to connect. */
export type FeatureFlagFeatureFlagsPkeyConnect = {
  id: Scalars["BigInt"]["input"];
};

/** The fields on `featureFlag` to look up the row to delete. */
export type FeatureFlagFeatureFlagsPkeyDelete = {
  id: Scalars["BigInt"]["input"];
};

/** A filter to be used against `FeatureFlag` object types. All fields are combined with a logical ‘and.’ */
export type FeatureFlagFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FeatureFlagFilter>>;
  /** Filter by the object’s `authenticated` field. */
  authenticated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `everyone` field. */
  everyone?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `featureFlagsGroupsByFeatureflagId` relation. */
  featureFlagsGroupsByFeatureflagId?: InputMaybe<FeatureFlagToManyFeatureFlagsGroupFilter>;
  /** Some related `featureFlagsGroupsByFeatureflagId` exist. */
  featureFlagsGroupsByFeatureflagIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `featureFlagsTenantsByFeatureflagId` relation. */
  featureFlagsTenantsByFeatureflagId?: InputMaybe<FeatureFlagToManyFeatureFlagsTenantFilter>;
  /** Some related `featureFlagsTenantsByFeatureflagId` exist. */
  featureFlagsTenantsByFeatureflagIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `featureFlagsUsersByFeatureflagId` relation. */
  featureFlagsUsersByFeatureflagId?: InputMaybe<FeatureFlagToManyFeatureFlagsUserFilter>;
  /** Some related `featureFlagsUsersByFeatureflagId` exist. */
  featureFlagsUsersByFeatureflagIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `languages` field. */
  languages?: InputMaybe<StringFilter>;
  /** Filter by the object’s `modified` field. */
  modified?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FeatureFlagFilter>;
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FeatureFlagFilter>>;
  /** Filter by the object’s `percent` field. */
  percent?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `rollout` field. */
  rollout?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `staff` field. */
  staff?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `superusers` field. */
  superusers?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `testing` field. */
  testing?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `FeatureFlag` */
export type FeatureFlagInput = {
  authenticated: Scalars["Boolean"]["input"];
  created: Scalars["Datetime"]["input"];
  everyone?: InputMaybe<Scalars["Boolean"]["input"]>;
  featureFlagsGroupsUsingId?: InputMaybe<FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInverseInput>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInverseInput>;
  featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInverseInput>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  languages: Scalars["String"]["input"];
  modified: Scalars["Datetime"]["input"];
  name: Scalars["String"]["input"];
  note: Scalars["String"]["input"];
  percent?: InputMaybe<Scalars["BigFloat"]["input"]>;
  rollout: Scalars["Boolean"]["input"];
  staff: Scalars["Boolean"]["input"];
  superusers: Scalars["Boolean"]["input"];
  testing: Scalars["Boolean"]["input"];
};

/** The fields on `featureFlag` to look up the row to update. */
export type FeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsNameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlag` being updated. */
    featureFlagPatch: UpdateFeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFPatch;
    name: Scalars["String"]["input"];
  };

/** The fields on `featureFlag` to look up the row to update. */
export type FeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlag` being updated. */
    featureFlagPatch: UpdateFeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFPatch;
    id: Scalars["BigInt"]["input"];
  };

/** The fields on `featureFlag` to look up the row to update. */
export type FeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsNameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlag` being updated. */
    featureFlagPatch: UpdateFeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFPatch;
    name: Scalars["String"]["input"];
  };

/** The fields on `featureFlag` to look up the row to update. */
export type FeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlag` being updated. */
    featureFlagPatch: UpdateFeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFPatch;
    id: Scalars["BigInt"]["input"];
  };

/** The fields on `featureFlag` to look up the row to update. */
export type FeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsNameKeyUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlag` being updated. */
    featureFlagPatch: UpdateFeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdPatch;
    name: Scalars["String"]["input"];
  };

/** The fields on `featureFlag` to look up the row to update. */
export type FeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlag` being updated. */
    featureFlagPatch: UpdateFeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdPatch;
    id: Scalars["BigInt"]["input"];
  };

/** Represents an update to a `FeatureFlag`. Fields that are set will be updated. */
export type FeatureFlagPatch = {
  authenticated?: InputMaybe<Scalars["Boolean"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  everyone?: InputMaybe<Scalars["Boolean"]["input"]>;
  featureFlagsGroupsUsingId?: InputMaybe<FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInverseInput>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInverseInput>;
  featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInverseInput>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  languages?: InputMaybe<Scalars["String"]["input"]>;
  modified?: InputMaybe<Scalars["Datetime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  percent?: InputMaybe<Scalars["BigFloat"]["input"]>;
  rollout?: InputMaybe<Scalars["Boolean"]["input"]>;
  staff?: InputMaybe<Scalars["Boolean"]["input"]>;
  superusers?: InputMaybe<Scalars["Boolean"]["input"]>;
  testing?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** A filter to be used against many `FeatureFlagsGroup` object types. All fields are combined with a logical ‘and.’ */
export type FeatureFlagToManyFeatureFlagsGroupFilter = {
  /** Every related `FeatureFlagsGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FeatureFlagsGroupFilter>;
  /** No related `FeatureFlagsGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FeatureFlagsGroupFilter>;
  /** Some related `FeatureFlagsGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FeatureFlagsGroupFilter>;
};

/** A filter to be used against many `FeatureFlagsTenant` object types. All fields are combined with a logical ‘and.’ */
export type FeatureFlagToManyFeatureFlagsTenantFilter = {
  /** Every related `FeatureFlagsTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FeatureFlagsTenantFilter>;
  /** No related `FeatureFlagsTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FeatureFlagsTenantFilter>;
  /** Some related `FeatureFlagsTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FeatureFlagsTenantFilter>;
};

/** A filter to be used against many `FeatureFlagsUser` object types. All fields are combined with a logical ‘and.’ */
export type FeatureFlagToManyFeatureFlagsUserFilter = {
  /** Every related `FeatureFlagsUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FeatureFlagsUserFilter>;
  /** No related `FeatureFlagsUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FeatureFlagsUserFilter>;
  /** Some related `FeatureFlagsUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FeatureFlagsUserFilter>;
};

/** A connection to a list of `FeatureFlag` values. */
export type FeatureFlagsConnection = {
  __typename: "FeatureFlagsConnection";
  /** A list of edges which contains the `FeatureFlag` and cursor to aid in pagination. */
  edges: Array<FeatureFlagsEdge>;
  /** A list of `FeatureFlag` objects. */
  nodes: Array<FeatureFlag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FeatureFlag` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `FeatureFlag` edge in the connection. */
export type FeatureFlagsEdge = {
  __typename: "FeatureFlagsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `FeatureFlag` at the end of the edge. */
  node: FeatureFlag;
};

export type FeatureFlagsGroup = {
  __typename: "FeatureFlagsGroup";
  /** Reads a single `AuthGroup` that is related to this `FeatureFlagsGroup`. */
  authGroupByGroupId: Maybe<AuthGroup>;
  /** Reads a single `FeatureFlag` that is related to this `FeatureFlagsGroup`. */
  featureFlagByFeatureflagId: Maybe<FeatureFlag>;
  featureflagId: Scalars["BigInt"]["output"];
  groupId: Scalars["Int"]["output"];
  id: Scalars["BigInt"]["output"];
};

/**
 * A condition to be used against `FeatureFlagsGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FeatureFlagsGroupCondition = {
  /** Checks for equality with the object’s `featureflagId` field. */
  featureflagId?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
};

/** The fields on `featureFlagsGroup` to look up the row to connect. */
export type FeatureFlagsGroupFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqConnect =
  {
    featureflagId: Scalars["BigInt"]["input"];
    groupId: Scalars["Int"]["input"];
  };

/** The fields on `featureFlagsGroup` to look up the row to delete. */
export type FeatureFlagsGroupFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqDelete =
  {
    featureflagId: Scalars["BigInt"]["input"];
    groupId: Scalars["Int"]["input"];
  };

/** The fields on `featureFlagsGroup` to look up the row to connect. */
export type FeatureFlagsGroupFeatureFlagsGroupsPkeyConnect = {
  id: Scalars["BigInt"]["input"];
};

/** The fields on `featureFlagsGroup` to look up the row to delete. */
export type FeatureFlagsGroupFeatureFlagsGroupsPkeyDelete = {
  id: Scalars["BigInt"]["input"];
};

/** A filter to be used against `FeatureFlagsGroup` object types. All fields are combined with a logical ‘and.’ */
export type FeatureFlagsGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FeatureFlagsGroupFilter>>;
  /** Filter by the object’s `authGroupByGroupId` relation. */
  authGroupByGroupId?: InputMaybe<AuthGroupFilter>;
  /** Filter by the object’s `featureFlagByFeatureflagId` relation. */
  featureFlagByFeatureflagId?: InputMaybe<FeatureFlagFilter>;
  /** Filter by the object’s `featureflagId` field. */
  featureflagId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FeatureFlagsGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FeatureFlagsGroupFilter>>;
};

/** An input for mutations affecting `FeatureFlagsGroup` */
export type FeatureFlagsGroupInput = {
  authGroupToGroupId?: InputMaybe<FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInput>;
  featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInput>;
  featureflagId?: InputMaybe<Scalars["BigInt"]["input"]>;
  groupId?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
};

/** The fields on `featureFlagsGroup` to look up the row to update. */
export type FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlagsGroup` being updated. */
    featureFlagsGroupPatch: UpdateFeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFPatch;
    featureflagId: Scalars["BigInt"]["input"];
    groupId: Scalars["Int"]["input"];
  };

/** The fields on `featureFlagsGroup` to look up the row to update. */
export type FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsGroupsPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlagsGroup` being updated. */
    featureFlagsGroupPatch: UpdateFeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFPatch;
    id: Scalars["BigInt"]["input"];
  };

/** The fields on `featureFlagsGroup` to look up the row to update. */
export type FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlagsGroup` being updated. */
    featureFlagsGroupPatch: UpdateFeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdPatch;
    featureflagId: Scalars["BigInt"]["input"];
    groupId: Scalars["Int"]["input"];
  };

/** The fields on `featureFlagsGroup` to look up the row to update. */
export type FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingFeatureFlagsGroupsPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlagsGroup` being updated. */
    featureFlagsGroupPatch: UpdateFeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdPatch;
    id: Scalars["BigInt"]["input"];
  };

/** Represents an update to a `FeatureFlagsGroup`. Fields that are set will be updated. */
export type FeatureFlagsGroupPatch = {
  authGroupToGroupId?: InputMaybe<FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInput>;
  featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInput>;
  featureflagId?: InputMaybe<Scalars["BigInt"]["input"]>;
  groupId?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
};

/** A connection to a list of `FeatureFlagsGroup` values. */
export type FeatureFlagsGroupsConnection = {
  __typename: "FeatureFlagsGroupsConnection";
  /** A list of edges which contains the `FeatureFlagsGroup` and cursor to aid in pagination. */
  edges: Array<FeatureFlagsGroupsEdge>;
  /** A list of `FeatureFlagsGroup` objects. */
  nodes: Array<FeatureFlagsGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FeatureFlagsGroup` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `FeatureFlagsGroup` edge in the connection. */
export type FeatureFlagsGroupsEdge = {
  __typename: "FeatureFlagsGroupsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `FeatureFlagsGroup` at the end of the edge. */
  node: FeatureFlagsGroup;
};

/** The `featureFlag` to be created by this mutation. */
export type FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFFeatureFlagsCreateInput =
  {
    authenticated: Scalars["Boolean"]["input"];
    created: Scalars["Datetime"]["input"];
    everyone?: InputMaybe<Scalars["Boolean"]["input"]>;
    featureFlagsGroupsUsingId?: InputMaybe<FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInverseInput>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInverseInput>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInverseInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    languages: Scalars["String"]["input"];
    modified: Scalars["Datetime"]["input"];
    name: Scalars["String"]["input"];
    note: Scalars["String"]["input"];
    percent?: InputMaybe<Scalars["BigFloat"]["input"]>;
    rollout: Scalars["Boolean"]["input"];
    staff: Scalars["Boolean"]["input"];
    superusers: Scalars["Boolean"]["input"];
    testing: Scalars["Boolean"]["input"];
  };

/** The `featureFlagsGroup` to be created by this mutation. */
export type FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFFeatureFlagsGroupsCreateInput =
  {
    authGroupToGroupId?: InputMaybe<FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInput>;
    featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInput>;
    groupId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
  };

/** Input for the nested mutation of `featureFlag` in the `FeatureFlagsGroupInput` mutation. */
export type FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInput = {
  /** The primary key(s) for `featureFlag` for the far side of the relationship. */
  connectById?: InputMaybe<FeatureFlagFeatureFlagsPkeyConnect>;
  /** The primary key(s) for `featureFlag` for the far side of the relationship. */
  connectByName?: InputMaybe<FeatureFlagFeatureFlagsNameKeyConnect>;
  /** A `FeatureFlagInput` object that will be created and connected to this object. */
  create?: InputMaybe<FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFFeatureFlagsCreateInput>;
  /** The primary key(s) for `featureFlag` for the far side of the relationship. */
  deleteById?: InputMaybe<FeatureFlagFeatureFlagsPkeyDelete>;
  /** The primary key(s) for `featureFlag` for the far side of the relationship. */
  deleteByName?: InputMaybe<FeatureFlagFeatureFlagsNameKeyDelete>;
  /** The primary key(s) and patch data for `featureFlag` for the far side of the relationship. */
  updateById?: InputMaybe<FeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsPkeyUpdate>;
  /** The primary key(s) and patch data for `featureFlag` for the far side of the relationship. */
  updateByName?: InputMaybe<FeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsNameKeyUpdate>;
};

/** Input for the nested mutation of `featureFlagsGroup` in the `FeatureFlagInput` mutation. */
export type FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInverseInput = {
  /** The primary key(s) for `featureFlagsGroup` for the far side of the relationship. */
  connectByFeatureflagIdAndGroupId?: InputMaybe<
    Array<FeatureFlagsGroupFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqConnect>
  >;
  /** The primary key(s) for `featureFlagsGroup` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<FeatureFlagsGroupFeatureFlagsGroupsPkeyConnect>
  >;
  /** A `FeatureFlagsGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFFeatureFlagsGroupsCreateInput>
  >;
  /** The primary key(s) for `featureFlagsGroup` for the far side of the relationship. */
  deleteByFeatureflagIdAndGroupId?: InputMaybe<
    Array<FeatureFlagsGroupFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqDelete>
  >;
  /** The primary key(s) for `featureFlagsGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FeatureFlagsGroupFeatureFlagsGroupsPkeyDelete>>;
  /** Flag indicating whether all other `featureFlagsGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `featureFlagsGroup` for the far side of the relationship. */
  updateByFeatureflagIdAndGroupId?: InputMaybe<
    Array<FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqUpdate>
  >;
  /** The primary key(s) and patch data for `featureFlagsGroup` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsGroupsPkeyUpdate>
  >;
};

/** The `authGroup` to be created by this mutation. */
export type FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdAuthGroupCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInverseInput>;
    authGroupPermissionsUsingId?: InputMaybe<AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInverseInput>;
    featureFlagsGroupsUsingId?: InputMaybe<FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name: Scalars["String"]["input"];
  };

/** The `featureFlagsGroup` to be created by this mutation. */
export type FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdFeatureFlagsGroupsCreateInput =
  {
    authGroupToGroupId?: InputMaybe<FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInput>;
    featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInput>;
    featureflagId?: InputMaybe<Scalars["BigInt"]["input"]>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
  };

/** Input for the nested mutation of `authGroup` in the `FeatureFlagsGroupInput` mutation. */
export type FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInput = {
  /** The primary key(s) for `authGroup` for the far side of the relationship. */
  connectById?: InputMaybe<AuthGroupAuthGroupPkeyConnect>;
  /** The primary key(s) for `authGroup` for the far side of the relationship. */
  connectByName?: InputMaybe<AuthGroupAuthGroupNameKeyConnect>;
  /** A `AuthGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdAuthGroupCreateInput>;
  /** The primary key(s) for `authGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<AuthGroupAuthGroupPkeyDelete>;
  /** The primary key(s) for `authGroup` for the far side of the relationship. */
  deleteByName?: InputMaybe<AuthGroupAuthGroupNameKeyDelete>;
  /** The primary key(s) and patch data for `authGroup` for the far side of the relationship. */
  updateById?: InputMaybe<AuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingAuthGroupPkeyUpdate>;
  /** The primary key(s) and patch data for `authGroup` for the far side of the relationship. */
  updateByName?: InputMaybe<AuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingAuthGroupNameKeyUpdate>;
};

/** Input for the nested mutation of `featureFlagsGroup` in the `AuthGroupInput` mutation. */
export type FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInverseInput = {
  /** The primary key(s) for `featureFlagsGroup` for the far side of the relationship. */
  connectByFeatureflagIdAndGroupId?: InputMaybe<
    Array<FeatureFlagsGroupFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqConnect>
  >;
  /** The primary key(s) for `featureFlagsGroup` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<FeatureFlagsGroupFeatureFlagsGroupsPkeyConnect>
  >;
  /** A `FeatureFlagsGroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdFeatureFlagsGroupsCreateInput>
  >;
  /** The primary key(s) for `featureFlagsGroup` for the far side of the relationship. */
  deleteByFeatureflagIdAndGroupId?: InputMaybe<
    Array<FeatureFlagsGroupFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqDelete>
  >;
  /** The primary key(s) for `featureFlagsGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FeatureFlagsGroupFeatureFlagsGroupsPkeyDelete>>;
  /** Flag indicating whether all other `featureFlagsGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `featureFlagsGroup` for the far side of the relationship. */
  updateByFeatureflagIdAndGroupId?: InputMaybe<
    Array<FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqUpdate>
  >;
  /** The primary key(s) and patch data for `featureFlagsGroup` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingFeatureFlagsGroupsPkeyUpdate>
  >;
};

/** Methods to use when ordering `FeatureFlagsGroup`. */
export enum FeatureFlagsGroupsOrderBy {
  FeatureflagIdAsc = "FEATUREFLAG_ID_ASC",
  FeatureflagIdDesc = "FEATUREFLAG_ID_DESC",
  GroupIdAsc = "GROUP_ID_ASC",
  GroupIdDesc = "GROUP_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

/** Methods to use when ordering `FeatureFlag`. */
export enum FeatureFlagsOrderBy {
  AuthenticatedAsc = "AUTHENTICATED_ASC",
  AuthenticatedDesc = "AUTHENTICATED_DESC",
  CreatedAsc = "CREATED_ASC",
  CreatedDesc = "CREATED_DESC",
  EveryoneAsc = "EVERYONE_ASC",
  EveryoneDesc = "EVERYONE_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  LanguagesAsc = "LANGUAGES_ASC",
  LanguagesDesc = "LANGUAGES_DESC",
  ModifiedAsc = "MODIFIED_ASC",
  ModifiedDesc = "MODIFIED_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  NoteAsc = "NOTE_ASC",
  NoteDesc = "NOTE_DESC",
  PercentAsc = "PERCENT_ASC",
  PercentDesc = "PERCENT_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  RolloutAsc = "ROLLOUT_ASC",
  RolloutDesc = "ROLLOUT_DESC",
  StaffAsc = "STAFF_ASC",
  StaffDesc = "STAFF_DESC",
  SuperusersAsc = "SUPERUSERS_ASC",
  SuperusersDesc = "SUPERUSERS_DESC",
  TestingAsc = "TESTING_ASC",
  TestingDesc = "TESTING_DESC",
}

export type FeatureFlagsTenant = {
  __typename: "FeatureFlagsTenant";
  /** Reads a single `FeatureFlag` that is related to this `FeatureFlagsTenant`. */
  featureFlagByFeatureflagId: Maybe<FeatureFlag>;
  featureflagId: Scalars["BigInt"]["output"];
  id: Scalars["BigInt"]["output"];
  /** Reads a single `Tenant` that is related to this `FeatureFlagsTenant`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
};

/**
 * A condition to be used against `FeatureFlagsTenant` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FeatureFlagsTenantCondition = {
  /** Checks for equality with the object’s `featureflagId` field. */
  featureflagId?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `featureFlagsTenant` to look up the row to connect. */
export type FeatureFlagsTenantFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqConnect =
  {
    featureflagId: Scalars["BigInt"]["input"];
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `featureFlagsTenant` to look up the row to delete. */
export type FeatureFlagsTenantFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqDelete =
  {
    featureflagId: Scalars["BigInt"]["input"];
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `featureFlagsTenant` to look up the row to connect. */
export type FeatureFlagsTenantFeatureFlagsTenantsPkeyConnect = {
  id: Scalars["BigInt"]["input"];
};

/** The fields on `featureFlagsTenant` to look up the row to delete. */
export type FeatureFlagsTenantFeatureFlagsTenantsPkeyDelete = {
  id: Scalars["BigInt"]["input"];
};

/** The `featureFlag` to be created by this mutation. */
export type FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFFeatureFlagsCreateInput =
  {
    authenticated: Scalars["Boolean"]["input"];
    created: Scalars["Datetime"]["input"];
    everyone?: InputMaybe<Scalars["Boolean"]["input"]>;
    featureFlagsGroupsUsingId?: InputMaybe<FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInverseInput>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInverseInput>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInverseInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    languages: Scalars["String"]["input"];
    modified: Scalars["Datetime"]["input"];
    name: Scalars["String"]["input"];
    note: Scalars["String"]["input"];
    percent?: InputMaybe<Scalars["BigFloat"]["input"]>;
    rollout: Scalars["Boolean"]["input"];
    staff: Scalars["Boolean"]["input"];
    superusers: Scalars["Boolean"]["input"];
    testing: Scalars["Boolean"]["input"];
  };

/** The `featureFlagsTenant` to be created by this mutation. */
export type FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFFeatureFlagsTenantsCreateInput =
  {
    featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInput>;
  };

/** Input for the nested mutation of `featureFlag` in the `FeatureFlagsTenantInput` mutation. */
export type FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInput = {
  /** The primary key(s) for `featureFlag` for the far side of the relationship. */
  connectById?: InputMaybe<FeatureFlagFeatureFlagsPkeyConnect>;
  /** The primary key(s) for `featureFlag` for the far side of the relationship. */
  connectByName?: InputMaybe<FeatureFlagFeatureFlagsNameKeyConnect>;
  /** A `FeatureFlagInput` object that will be created and connected to this object. */
  create?: InputMaybe<FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFFeatureFlagsCreateInput>;
  /** The primary key(s) for `featureFlag` for the far side of the relationship. */
  deleteById?: InputMaybe<FeatureFlagFeatureFlagsPkeyDelete>;
  /** The primary key(s) for `featureFlag` for the far side of the relationship. */
  deleteByName?: InputMaybe<FeatureFlagFeatureFlagsNameKeyDelete>;
  /** The primary key(s) and patch data for `featureFlag` for the far side of the relationship. */
  updateById?: InputMaybe<FeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsPkeyUpdate>;
  /** The primary key(s) and patch data for `featureFlag` for the far side of the relationship. */
  updateByName?: InputMaybe<FeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsNameKeyUpdate>;
};

/** Input for the nested mutation of `featureFlagsTenant` in the `FeatureFlagInput` mutation. */
export type FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInverseInput = {
  /** The primary key(s) for `featureFlagsTenant` for the far side of the relationship. */
  connectByFeatureflagIdAndTenantId?: InputMaybe<
    Array<FeatureFlagsTenantFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqConnect>
  >;
  /** The primary key(s) for `featureFlagsTenant` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<FeatureFlagsTenantFeatureFlagsTenantsPkeyConnect>
  >;
  /** A `FeatureFlagsTenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFFeatureFlagsTenantsCreateInput>
  >;
  /** The primary key(s) for `featureFlagsTenant` for the far side of the relationship. */
  deleteByFeatureflagIdAndTenantId?: InputMaybe<
    Array<FeatureFlagsTenantFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqDelete>
  >;
  /** The primary key(s) for `featureFlagsTenant` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<FeatureFlagsTenantFeatureFlagsTenantsPkeyDelete>
  >;
  /** Flag indicating whether all other `featureFlagsTenant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `featureFlagsTenant` for the far side of the relationship. */
  updateByFeatureflagIdAndTenantId?: InputMaybe<
    Array<FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqUpdate>
  >;
  /** The primary key(s) and patch data for `featureFlagsTenant` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsTenantsPkeyUpdate>
  >;
};

/** A filter to be used against `FeatureFlagsTenant` object types. All fields are combined with a logical ‘and.’ */
export type FeatureFlagsTenantFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FeatureFlagsTenantFilter>>;
  /** Filter by the object’s `featureFlagByFeatureflagId` relation. */
  featureFlagByFeatureflagId?: InputMaybe<FeatureFlagFilter>;
  /** Filter by the object’s `featureflagId` field. */
  featureflagId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FeatureFlagsTenantFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FeatureFlagsTenantFilter>>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `FeatureFlagsTenant` */
export type FeatureFlagsTenantInput = {
  featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInput>;
  featureflagId?: InputMaybe<Scalars["BigInt"]["input"]>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInput>;
};

/** The fields on `featureFlagsTenant` to look up the row to update. */
export type FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlagsTenant` being updated. */
    featureFlagsTenantPatch: UpdateFeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFPatch;
    featureflagId: Scalars["BigInt"]["input"];
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `featureFlagsTenant` to look up the row to update. */
export type FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsTenantsPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlagsTenant` being updated. */
    featureFlagsTenantPatch: UpdateFeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFPatch;
    id: Scalars["BigInt"]["input"];
  };

/** The fields on `featureFlagsTenant` to look up the row to update. */
export type FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlagsTenant` being updated. */
    featureFlagsTenantPatch: UpdateFeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdPatch;
    featureflagId: Scalars["BigInt"]["input"];
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `featureFlagsTenant` to look up the row to update. */
export type FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingFeatureFlagsTenantsPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlagsTenant` being updated. */
    featureFlagsTenantPatch: UpdateFeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdPatch;
    id: Scalars["BigInt"]["input"];
  };

/** Represents an update to a `FeatureFlagsTenant`. Fields that are set will be updated. */
export type FeatureFlagsTenantPatch = {
  featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInput>;
  featureflagId?: InputMaybe<Scalars["BigInt"]["input"]>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInput>;
};

/** A connection to a list of `FeatureFlagsTenant` values. */
export type FeatureFlagsTenantsConnection = {
  __typename: "FeatureFlagsTenantsConnection";
  /** A list of edges which contains the `FeatureFlagsTenant` and cursor to aid in pagination. */
  edges: Array<FeatureFlagsTenantsEdge>;
  /** A list of `FeatureFlagsTenant` objects. */
  nodes: Array<FeatureFlagsTenant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FeatureFlagsTenant` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `FeatureFlagsTenant` edge in the connection. */
export type FeatureFlagsTenantsEdge = {
  __typename: "FeatureFlagsTenantsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `FeatureFlagsTenant` at the end of the edge. */
  node: FeatureFlagsTenant;
};

/** Methods to use when ordering `FeatureFlagsTenant`. */
export enum FeatureFlagsTenantsOrderBy {
  FeatureflagIdAsc = "FEATUREFLAG_ID_ASC",
  FeatureflagIdDesc = "FEATUREFLAG_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
}

/** The `featureFlagsTenant` to be created by this mutation. */
export type FeatureFlagsTenantsTenantId6D718C42FkTenantIdFeatureFlagsTenantsCreateInput =
  {
    featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInput>;
    featureflagId?: InputMaybe<Scalars["BigInt"]["input"]>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    tenantToTenantId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInput>;
  };

/** Input for the nested mutation of `tenant` in the `FeatureFlagsTenantInput` mutation. */
export type FeatureFlagsTenantsTenantId6D718C42FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `featureFlagsTenant` in the `TenantInput` mutation. */
export type FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput = {
  /** The primary key(s) for `featureFlagsTenant` for the far side of the relationship. */
  connectByFeatureflagIdAndTenantId?: InputMaybe<
    Array<FeatureFlagsTenantFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqConnect>
  >;
  /** The primary key(s) for `featureFlagsTenant` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<FeatureFlagsTenantFeatureFlagsTenantsPkeyConnect>
  >;
  /** A `FeatureFlagsTenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FeatureFlagsTenantsTenantId6D718C42FkTenantIdFeatureFlagsTenantsCreateInput>
  >;
  /** The primary key(s) for `featureFlagsTenant` for the far side of the relationship. */
  deleteByFeatureflagIdAndTenantId?: InputMaybe<
    Array<FeatureFlagsTenantFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqDelete>
  >;
  /** The primary key(s) for `featureFlagsTenant` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<FeatureFlagsTenantFeatureFlagsTenantsPkeyDelete>
  >;
  /** Flag indicating whether all other `featureFlagsTenant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `featureFlagsTenant` for the far side of the relationship. */
  updateByFeatureflagIdAndTenantId?: InputMaybe<
    Array<FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqUpdate>
  >;
  /** The primary key(s) and patch data for `featureFlagsTenant` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingFeatureFlagsTenantsPkeyUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type FeatureFlagsTenantsTenantId6D718C42FkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

export type FeatureFlagsUser = {
  __typename: "FeatureFlagsUser";
  /** Reads a single `ApplicationUser` that is related to this `FeatureFlagsUser`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** Reads a single `FeatureFlag` that is related to this `FeatureFlagsUser`. */
  featureFlagByFeatureflagId: Maybe<FeatureFlag>;
  featureflagId: Scalars["BigInt"]["output"];
  id: Scalars["BigInt"]["output"];
  userId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `FeatureFlagsUser` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FeatureFlagsUserCondition = {
  /** Checks for equality with the object’s `featureflagId` field. */
  featureflagId?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `featureFlagsUser` to look up the row to connect. */
export type FeatureFlagsUserFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqConnect =
  {
    featureflagId: Scalars["BigInt"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** The fields on `featureFlagsUser` to look up the row to delete. */
export type FeatureFlagsUserFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqDelete =
  {
    featureflagId: Scalars["BigInt"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** The fields on `featureFlagsUser` to look up the row to connect. */
export type FeatureFlagsUserFeatureFlagsUsersPkeyConnect = {
  id: Scalars["BigInt"]["input"];
};

/** The fields on `featureFlagsUser` to look up the row to delete. */
export type FeatureFlagsUserFeatureFlagsUsersPkeyDelete = {
  id: Scalars["BigInt"]["input"];
};

/** A filter to be used against `FeatureFlagsUser` object types. All fields are combined with a logical ‘and.’ */
export type FeatureFlagsUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FeatureFlagsUserFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `featureFlagByFeatureflagId` relation. */
  featureFlagByFeatureflagId?: InputMaybe<FeatureFlagFilter>;
  /** Filter by the object’s `featureflagId` field. */
  featureflagId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FeatureFlagsUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FeatureFlagsUserFilter>>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `FeatureFlagsUser` */
export type FeatureFlagsUserInput = {
  applicationUserToUserId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInput>;
  featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInput>;
  featureflagId?: InputMaybe<Scalars["BigInt"]["input"]>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `featureFlagsUser` to look up the row to update. */
export type FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlagsUser` being updated. */
    featureFlagsUserPatch: UpdateFeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdPatch;
    featureflagId: Scalars["BigInt"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** The fields on `featureFlagsUser` to look up the row to update. */
export type FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsUsersPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlagsUser` being updated. */
    featureFlagsUserPatch: UpdateFeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdPatch;
    id: Scalars["BigInt"]["input"];
  };

/** The fields on `featureFlagsUser` to look up the row to update. */
export type FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlagsUser` being updated. */
    featureFlagsUserPatch: UpdateFeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdPatch;
    featureflagId: Scalars["BigInt"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** The fields on `featureFlagsUser` to look up the row to update. */
export type FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingFeatureFlagsUsersPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `featureFlagsUser` being updated. */
    featureFlagsUserPatch: UpdateFeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdPatch;
    id: Scalars["BigInt"]["input"];
  };

/** Represents an update to a `FeatureFlagsUser`. Fields that are set will be updated. */
export type FeatureFlagsUserPatch = {
  applicationUserToUserId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInput>;
  featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInput>;
  featureflagId?: InputMaybe<Scalars["BigInt"]["input"]>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A connection to a list of `FeatureFlagsUser` values. */
export type FeatureFlagsUsersConnection = {
  __typename: "FeatureFlagsUsersConnection";
  /** A list of edges which contains the `FeatureFlagsUser` and cursor to aid in pagination. */
  edges: Array<FeatureFlagsUsersEdge>;
  /** A list of `FeatureFlagsUser` objects. */
  nodes: Array<FeatureFlagsUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FeatureFlagsUser` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `FeatureFlagsUser` edge in the connection. */
export type FeatureFlagsUsersEdge = {
  __typename: "FeatureFlagsUsersEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `FeatureFlagsUser` at the end of the edge. */
  node: FeatureFlagsUser;
};

/** The `featureFlag` to be created by this mutation. */
export type FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdFeatureFlagsCreateInput =
  {
    authenticated: Scalars["Boolean"]["input"];
    created: Scalars["Datetime"]["input"];
    everyone?: InputMaybe<Scalars["Boolean"]["input"]>;
    featureFlagsGroupsUsingId?: InputMaybe<FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInverseInput>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInverseInput>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInverseInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    languages: Scalars["String"]["input"];
    modified: Scalars["Datetime"]["input"];
    name: Scalars["String"]["input"];
    note: Scalars["String"]["input"];
    percent?: InputMaybe<Scalars["BigFloat"]["input"]>;
    rollout: Scalars["Boolean"]["input"];
    staff: Scalars["Boolean"]["input"];
    superusers: Scalars["Boolean"]["input"];
    testing: Scalars["Boolean"]["input"];
  };

/** The `featureFlagsUser` to be created by this mutation. */
export type FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdFeatureFlagsUsersCreateInput =
  {
    applicationUserToUserId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInput>;
    featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** Input for the nested mutation of `featureFlag` in the `FeatureFlagsUserInput` mutation. */
export type FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInput = {
  /** The primary key(s) for `featureFlag` for the far side of the relationship. */
  connectById?: InputMaybe<FeatureFlagFeatureFlagsPkeyConnect>;
  /** The primary key(s) for `featureFlag` for the far side of the relationship. */
  connectByName?: InputMaybe<FeatureFlagFeatureFlagsNameKeyConnect>;
  /** A `FeatureFlagInput` object that will be created and connected to this object. */
  create?: InputMaybe<FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdFeatureFlagsCreateInput>;
  /** The primary key(s) for `featureFlag` for the far side of the relationship. */
  deleteById?: InputMaybe<FeatureFlagFeatureFlagsPkeyDelete>;
  /** The primary key(s) for `featureFlag` for the far side of the relationship. */
  deleteByName?: InputMaybe<FeatureFlagFeatureFlagsNameKeyDelete>;
  /** The primary key(s) and patch data for `featureFlag` for the far side of the relationship. */
  updateById?: InputMaybe<FeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsPkeyUpdate>;
  /** The primary key(s) and patch data for `featureFlag` for the far side of the relationship. */
  updateByName?: InputMaybe<FeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsNameKeyUpdate>;
};

/** Input for the nested mutation of `featureFlagsUser` in the `FeatureFlagInput` mutation. */
export type FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInverseInput =
  {
    /** The primary key(s) for `featureFlagsUser` for the far side of the relationship. */
    connectByFeatureflagIdAndUserId?: InputMaybe<
      Array<FeatureFlagsUserFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqConnect>
    >;
    /** The primary key(s) for `featureFlagsUser` for the far side of the relationship. */
    connectById?: InputMaybe<
      Array<FeatureFlagsUserFeatureFlagsUsersPkeyConnect>
    >;
    /** A `FeatureFlagsUserInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdFeatureFlagsUsersCreateInput>
    >;
    /** The primary key(s) for `featureFlagsUser` for the far side of the relationship. */
    deleteByFeatureflagIdAndUserId?: InputMaybe<
      Array<FeatureFlagsUserFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqDelete>
    >;
    /** The primary key(s) for `featureFlagsUser` for the far side of the relationship. */
    deleteById?: InputMaybe<Array<FeatureFlagsUserFeatureFlagsUsersPkeyDelete>>;
    /** Flag indicating whether all other `featureFlagsUser` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The primary key(s) and patch data for `featureFlagsUser` for the far side of the relationship. */
    updateByFeatureflagIdAndUserId?: InputMaybe<
      Array<FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqUpdate>
    >;
    /** The primary key(s) and patch data for `featureFlagsUser` for the far side of the relationship. */
    updateById?: InputMaybe<
      Array<FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsUsersPkeyUpdate>
    >;
  };

/** Methods to use when ordering `FeatureFlagsUser`. */
export enum FeatureFlagsUsersOrderBy {
  FeatureflagIdAsc = "FEATUREFLAG_ID_ASC",
  FeatureflagIdDesc = "FEATUREFLAG_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** The `applicationUser` to be created by this mutation. */
export type FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** The `featureFlagsUser` to be created by this mutation. */
export type FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdFeatureFlagsUsersCreateInput =
  {
    applicationUserToUserId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInput>;
    featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInput>;
    featureflagId?: InputMaybe<Scalars["BigInt"]["input"]>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
  };

/** Input for the nested mutation of `applicationUser` in the `FeatureFlagsUserInput` mutation. */
export type FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `featureFlagsUser` in the `ApplicationUserInput` mutation. */
export type FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `featureFlagsUser` for the far side of the relationship. */
  connectByFeatureflagIdAndUserId?: InputMaybe<
    Array<FeatureFlagsUserFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqConnect>
  >;
  /** The primary key(s) for `featureFlagsUser` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FeatureFlagsUserFeatureFlagsUsersPkeyConnect>>;
  /** A `FeatureFlagsUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdFeatureFlagsUsersCreateInput>
  >;
  /** The primary key(s) for `featureFlagsUser` for the far side of the relationship. */
  deleteByFeatureflagIdAndUserId?: InputMaybe<
    Array<FeatureFlagsUserFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqDelete>
  >;
  /** The primary key(s) for `featureFlagsUser` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FeatureFlagsUserFeatureFlagsUsersPkeyDelete>>;
  /** Flag indicating whether all other `featureFlagsUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `featureFlagsUser` for the far side of the relationship. */
  updateByFeatureflagIdAndUserId?: InputMaybe<
    Array<FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqUpdate>
  >;
  /** The primary key(s) and patch data for `featureFlagsUser` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingFeatureFlagsUsersPkeyUpdate>
  >;
};

export type File = {
  __typename: "File";
  /** Reads a single `ApplicationUser` that is related to this `File`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateArchived: Maybe<Scalars["Datetime"]["output"]>;
  dateCreated: Scalars["Datetime"]["output"];
  dateDataDeleted: Maybe<Scalars["Datetime"]["output"]>;
  dateDeleted: Maybe<Scalars["Datetime"]["output"]>;
  /** Reads and enables pagination through a set of `FileActivity`. */
  fileActivitiesByFileId: FileActivitiesConnection;
  /** Reads a single `File` that is related to this `File`. */
  fileBySeriesParentId: Maybe<File>;
  fileFormat: Maybe<Scalars["Int"]["output"]>;
  /** Reads and enables pagination through a set of `FileMetadatum`. */
  fileMetadataByFileId: FileMetadataConnection;
  /** Reads and enables pagination through a set of `FileProcessingNotification`. */
  fileProcessingNotificationsByFileId: FileProcessingNotificationsConnection;
  fileStructure: Maybe<Scalars["Int"]["output"]>;
  fileType: Maybe<Scalars["Int"]["output"]>;
  /** Reads and enables pagination through a set of `File`. */
  filesBySeriesParentId: FilesConnection;
  id: Scalars["UUID"]["output"];
  isSeries: Scalars["Boolean"]["output"];
  key: Maybe<Scalars["String"]["output"]>;
  location: Maybe<Scalars["String"]["output"]>;
  multipartUploadId: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  originalName: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `OutputGroupFile`. */
  outputGroupFilesByFileId: OutputGroupFilesConnection;
  parentIds: Maybe<Scalars["JSON"]["output"]>;
  partSize: Maybe<Scalars["Int"]["output"]>;
  preview: Maybe<Scalars["JSON"]["output"]>;
  processingStatus: Scalars["Int"]["output"];
  /** Reads a single `Project` that is related to this `File`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  referenceId: Scalars["UUID"]["output"];
  seriesOrder: Maybe<Scalars["Int"]["output"]>;
  seriesParentId: Maybe<Scalars["UUID"]["output"]>;
  signal: Maybe<Scalars["Int"]["output"]>;
  size: Maybe<Scalars["BigInt"]["output"]>;
  source: Scalars["String"]["output"];
  status: Scalars["Int"]["output"];
  tags: Array<Maybe<Scalars["String"]["output"]>>;
  /** Reads a single `Task` that is related to this `File`. */
  taskByTaskId: Maybe<Task>;
  taskId: Maybe<Scalars["UUID"]["output"]>;
  /** Reads and enables pagination through a set of `TaskSource`. */
  taskSourcesByFileId: TaskSourcesConnection;
  /** Reads a single `Tenant` that is related to this `File`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
  uploadStatus: Maybe<Scalars["Int"]["output"]>;
  userId: Scalars["UUID"]["output"];
};

export type FileFileActivitiesByFileIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileActivityCondition>;
  filter?: InputMaybe<FileActivityFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileActivitiesOrderBy>>;
};

export type FileFileMetadataByFileIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileMetadatumCondition>;
  filter?: InputMaybe<FileMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileMetadataOrderBy>>;
};

export type FileFileProcessingNotificationsByFileIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileProcessingNotificationCondition>;
  filter?: InputMaybe<FileProcessingNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileProcessingNotificationsOrderBy>>;
};

export type FileFilesBySeriesParentIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};

export type FileOutputGroupFilesByFileIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<OutputGroupFileCondition>;
  filter?: InputMaybe<OutputGroupFileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<OutputGroupFilesOrderBy>>;
};

export type FileTaskSourcesByFileIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskSourceCondition>;
  filter?: InputMaybe<TaskSourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskSourcesOrderBy>>;
};

/** A connection to a list of `FileActivity` values. */
export type FileActivitiesConnection = {
  __typename: "FileActivitiesConnection";
  /** A list of edges which contains the `FileActivity` and cursor to aid in pagination. */
  edges: Array<FileActivitiesEdge>;
  /** A list of `FileActivity` objects. */
  nodes: Array<FileActivity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FileActivity` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `FileActivity` edge in the connection. */
export type FileActivitiesEdge = {
  __typename: "FileActivitiesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `FileActivity` at the end of the edge. */
  node: FileActivity;
};

/** Methods to use when ordering `FileActivity`. */
export enum FileActivitiesOrderBy {
  ActivityTypeAsc = "ACTIVITY_TYPE_ASC",
  ActivityTypeDesc = "ACTIVITY_TYPE_DESC",
  BytesAsc = "BYTES_ASC",
  BytesDesc = "BYTES_DESC",
  CommentAsc = "COMMENT_ASC",
  CommentDesc = "COMMENT_DESC",
  ContentTypeIdAsc = "CONTENT_TYPE_ID_ASC",
  ContentTypeIdDesc = "CONTENT_TYPE_ID_DESC",
  CostIdAsc = "COST_ID_ASC",
  CostIdDesc = "COST_ID_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  FileIdAsc = "FILE_ID_ASC",
  FileIdDesc = "FILE_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  ObjectIdAsc = "OBJECT_ID_ASC",
  ObjectIdDesc = "OBJECT_ID_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

export type FileActivity = {
  __typename: "FileActivity";
  activityType: Scalars["Int"]["output"];
  /** Reads a single `ApplicationUser` that is related to this `FileActivity`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  bytes: Maybe<Scalars["BigInt"]["output"]>;
  comment: Maybe<Scalars["String"]["output"]>;
  contentTypeId: Maybe<Scalars["Int"]["output"]>;
  /** Reads a single `Cost` that is related to this `FileActivity`. */
  costByCostId: Maybe<Cost>;
  costId: Maybe<Scalars["BigInt"]["output"]>;
  dateCreated: Scalars["Datetime"]["output"];
  /** Reads a single `DjangoContentType` that is related to this `FileActivity`. */
  djangoContentTypeByContentTypeId: Maybe<DjangoContentType>;
  /** Reads a single `File` that is related to this `FileActivity`. */
  fileByFileId: Maybe<File>;
  fileId: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["Int"]["output"];
  objectId: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `Project` that is related to this `FileActivity`. */
  projectByProjectId: Maybe<Project>;
  projectId: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `Tenant` that is related to this `FileActivity`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Maybe<Scalars["Int"]["output"]>;
  userId: Maybe<Scalars["UUID"]["output"]>;
};

/**
 * A condition to be used against `FileActivity` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FileActivityCondition = {
  /** Checks for equality with the object’s `activityType` field. */
  activityType?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `bytes` field. */
  bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `comment` field. */
  comment?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `contentTypeId` field. */
  contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `costId` field. */
  costId?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `fileId` field. */
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `objectId` field. */
  objectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `djangoContentType` to be created by this mutation. */
export type FileActivityContentTypeIdD010Fc58FkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** The `fileActivity` to be created by this mutation. */
export type FileActivityContentTypeIdD010Fc58FkDjangoCoFileActivityCreateInput =
  {
    activityType: Scalars["Int"]["input"];
    applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
    bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
    comment?: InputMaybe<Scalars["String"]["input"]>;
    costId?: InputMaybe<Scalars["BigInt"]["input"]>;
    costToCostId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInput>;
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    objectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** Input for the nested mutation of `djangoContentType` in the `FileActivityInput` mutation. */
export type FileActivityContentTypeIdD010Fc58FkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `fileActivity` in the `DjangoContentTypeInput` mutation. */
export type FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput = {
  /** The primary key(s) for `fileActivity` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileActivityFileActivityPkeyConnect>>;
  /** A `FileActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FileActivityContentTypeIdD010Fc58FkDjangoCoFileActivityCreateInput>
  >;
  /** The primary key(s) for `fileActivity` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileActivityFileActivityPkeyDelete>>;
  /** Flag indicating whether all other `fileActivity` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `fileActivity` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileActivityOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingFileActivityPkeyUpdate>
  >;
};

/** The `cost` to be created by this mutation. */
export type FileActivityCostId2A88D90AFkCostIdCostCreateInput = {
  costType: Scalars["Int"]["input"];
  currency: Scalars["Int"]["input"];
  date?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInverseInput>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  platform?: InputMaybe<Scalars["Int"]["input"]>;
  rateCode?: InputMaybe<Scalars["String"]["input"]>;
  taskActivitiesUsingId?: InputMaybe<TaskActivityCostId49E66058FkCostIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInput>;
  value: Scalars["BigFloat"]["input"];
};

/** The `fileActivity` to be created by this mutation. */
export type FileActivityCostId2A88D90AFkCostIdFileActivityCreateInput = {
  activityType: Scalars["Int"]["input"];
  applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
  bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  comment?: InputMaybe<Scalars["String"]["input"]>;
  contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  costToCostId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  djangoContentTypeToContentTypeId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInput>;
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  objectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `cost` in the `FileActivityInput` mutation. */
export type FileActivityCostId2A88D90AFkCostIdInput = {
  /** The primary key(s) for `cost` for the far side of the relationship. */
  connectById?: InputMaybe<CostCostPkeyConnect>;
  /** A `CostInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileActivityCostId2A88D90AFkCostIdCostCreateInput>;
  /** The primary key(s) for `cost` for the far side of the relationship. */
  deleteById?: InputMaybe<CostCostPkeyDelete>;
  /** The primary key(s) and patch data for `cost` for the far side of the relationship. */
  updateById?: InputMaybe<CostOnFileActivityForFileActivityCostId2A88D90AFkCostIdUsingCostPkeyUpdate>;
};

/** Input for the nested mutation of `fileActivity` in the `CostInput` mutation. */
export type FileActivityCostId2A88D90AFkCostIdInverseInput = {
  /** The primary key(s) for `fileActivity` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileActivityFileActivityPkeyConnect>>;
  /** A `FileActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FileActivityCostId2A88D90AFkCostIdFileActivityCreateInput>
  >;
  /** The primary key(s) for `fileActivity` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileActivityFileActivityPkeyDelete>>;
  /** Flag indicating whether all other `fileActivity` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `fileActivity` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileActivityOnFileActivityForFileActivityCostId2A88D90AFkCostIdUsingFileActivityPkeyUpdate>
  >;
};

/** The fields on `fileActivity` to look up the row to connect. */
export type FileActivityFileActivityPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `fileActivity` to look up the row to delete. */
export type FileActivityFileActivityPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** The `fileActivity` to be created by this mutation. */
export type FileActivityFileId015763A9FkFileIdFileActivityCreateInput = {
  activityType: Scalars["Int"]["input"];
  applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
  bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  comment?: InputMaybe<Scalars["String"]["input"]>;
  contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  costId?: InputMaybe<Scalars["BigInt"]["input"]>;
  costToCostId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  djangoContentTypeToContentTypeId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInput>;
  fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  objectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `file` to be created by this mutation. */
export type FileActivityFileId015763A9FkFileIdFileCreateInput = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["UUID"]["input"];
  isSeries: Scalars["Boolean"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  originalName: Scalars["String"]["input"];
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus: Scalars["Int"]["input"];
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId: Scalars["UUID"]["input"];
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source: Scalars["String"]["input"];
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `file` in the `FileActivityInput` mutation. */
export type FileActivityFileId015763A9FkFileIdInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<FileFilePkeyConnect>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueConnect>;
  /** A `FileInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileActivityFileId015763A9FkFileIdFileCreateInput>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteById?: InputMaybe<FileFilePkeyDelete>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueDelete>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFilePkeyUpdate>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingProjectReferenceIdUniqueUpdate>;
};

/** Input for the nested mutation of `fileActivity` in the `FileInput` mutation. */
export type FileActivityFileId015763A9FkFileIdInverseInput = {
  /** The primary key(s) for `fileActivity` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileActivityFileActivityPkeyConnect>>;
  /** A `FileActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FileActivityFileId015763A9FkFileIdFileActivityCreateInput>
  >;
  /** The primary key(s) for `fileActivity` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileActivityFileActivityPkeyDelete>>;
  /** Flag indicating whether all other `fileActivity` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `fileActivity` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFileActivityPkeyUpdate>
  >;
};

/** A filter to be used against `FileActivity` object types. All fields are combined with a logical ‘and.’ */
export type FileActivityFilter = {
  /** Filter by the object’s `activityType` field. */
  activityType?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FileActivityFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `bytes` field. */
  bytes?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `comment` field. */
  comment?: InputMaybe<StringFilter>;
  /** Filter by the object’s `contentTypeId` field. */
  contentTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `costByCostId` relation. */
  costByCostId?: InputMaybe<CostFilter>;
  /** A related `costByCostId` exists. */
  costByCostIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `costId` field. */
  costId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `djangoContentTypeByContentTypeId` relation. */
  djangoContentTypeByContentTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** A related `djangoContentTypeByContentTypeId` exists. */
  djangoContentTypeByContentTypeIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `fileByFileId` relation. */
  fileByFileId?: InputMaybe<FileFilter>;
  /** A related `fileByFileId` exists. */
  fileByFileIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `fileId` field. */
  fileId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FileActivityFilter>;
  /** Filter by the object’s `objectId` field. */
  objectId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FileActivityFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** A related `projectByProjectId` exists. */
  projectByProjectIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** A related `tenantByTenantId` exists. */
  tenantByTenantIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `FileActivity` */
export type FileActivityInput = {
  activityType: Scalars["Int"]["input"];
  applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
  bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  comment?: InputMaybe<Scalars["String"]["input"]>;
  contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  costId?: InputMaybe<Scalars["BigInt"]["input"]>;
  costToCostId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  djangoContentTypeToContentTypeId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInput>;
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  objectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `fileActivity` to look up the row to update. */
export type FileActivityOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingFileActivityPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileActivity` being updated. */
    fileActivityPatch: UpdateFileActivityOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `fileActivity` to look up the row to update. */
export type FileActivityOnFileActivityForFileActivityCostId2A88D90AFkCostIdUsingFileActivityPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileActivity` being updated. */
    fileActivityPatch: UpdateFileActivityOnFileActivityForFileActivityCostId2A88D90AFkCostIdPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `fileActivity` to look up the row to update. */
export type FileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFileActivityPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileActivity` being updated. */
    fileActivityPatch: UpdateFileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `fileActivity` to look up the row to update. */
export type FileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingFileActivityPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileActivity` being updated. */
    fileActivityPatch: UpdateFileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `fileActivity` to look up the row to update. */
export type FileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingFileActivityPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileActivity` being updated. */
    fileActivityPatch: UpdateFileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
    id: Scalars["Int"]["input"];
  };

/** The fields on `fileActivity` to look up the row to update. */
export type FileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingFileActivityPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileActivity` being updated. */
    fileActivityPatch: UpdateFileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
    id: Scalars["Int"]["input"];
  };

/** Represents an update to a `FileActivity`. Fields that are set will be updated. */
export type FileActivityPatch = {
  activityType?: InputMaybe<Scalars["Int"]["input"]>;
  applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
  bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  comment?: InputMaybe<Scalars["String"]["input"]>;
  contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  costId?: InputMaybe<Scalars["BigInt"]["input"]>;
  costToCostId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  djangoContentTypeToContentTypeId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInput>;
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  objectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `fileActivity` to be created by this mutation. */
export type FileActivityProjectId6F35B8CcFkProjectIdFileActivityCreateInput = {
  activityType: Scalars["Int"]["input"];
  applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
  bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  comment?: InputMaybe<Scalars["String"]["input"]>;
  contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  costId?: InputMaybe<Scalars["BigInt"]["input"]>;
  costToCostId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  djangoContentTypeToContentTypeId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInput>;
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  objectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `project` in the `FileActivityInput` mutation. */
export type FileActivityProjectId6F35B8CcFkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `fileActivity` in the `ProjectInput` mutation. */
export type FileActivityProjectId6F35B8CcFkProjectIdInverseInput = {
  /** The primary key(s) for `fileActivity` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileActivityFileActivityPkeyConnect>>;
  /** A `FileActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FileActivityProjectId6F35B8CcFkProjectIdFileActivityCreateInput>
  >;
  /** The primary key(s) for `fileActivity` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileActivityFileActivityPkeyDelete>>;
  /** Flag indicating whether all other `fileActivity` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `fileActivity` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingFileActivityPkeyUpdate>
  >;
};

/** The `fileActivity` to be created by this mutation. */
export type FileActivityTenantIdC46A4F01FkTenantIdFileActivityCreateInput = {
  activityType: Scalars["Int"]["input"];
  applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
  bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  comment?: InputMaybe<Scalars["String"]["input"]>;
  contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  costId?: InputMaybe<Scalars["BigInt"]["input"]>;
  costToCostId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  djangoContentTypeToContentTypeId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInput>;
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  objectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
  tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `tenant` in the `FileActivityInput` mutation. */
export type FileActivityTenantIdC46A4F01FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `fileActivity` in the `TenantInput` mutation. */
export type FileActivityTenantIdC46A4F01FkTenantIdInverseInput = {
  /** The primary key(s) for `fileActivity` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileActivityFileActivityPkeyConnect>>;
  /** A `FileActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FileActivityTenantIdC46A4F01FkTenantIdFileActivityCreateInput>
  >;
  /** The primary key(s) for `fileActivity` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileActivityFileActivityPkeyDelete>>;
  /** Flag indicating whether all other `fileActivity` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `fileActivity` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingFileActivityPkeyUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type FileActivityTenantIdC46A4F01FkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** The `applicationUser` to be created by this mutation. */
export type FileActivityUserId868Ad8A9FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** The `fileActivity` to be created by this mutation. */
export type FileActivityUserId868Ad8A9FkApplicationUserIdFileActivityCreateInput =
  {
    activityType: Scalars["Int"]["input"];
    applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
    bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
    comment?: InputMaybe<Scalars["String"]["input"]>;
    contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    costId?: InputMaybe<Scalars["BigInt"]["input"]>;
    costToCostId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInput>;
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    objectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `FileActivityInput` mutation. */
export type FileActivityUserId868Ad8A9FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `fileActivity` in the `ApplicationUserInput` mutation. */
export type FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `fileActivity` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileActivityFileActivityPkeyConnect>>;
  /** A `FileActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FileActivityUserId868Ad8A9FkApplicationUserIdFileActivityCreateInput>
  >;
  /** The primary key(s) for `fileActivity` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileActivityFileActivityPkeyDelete>>;
  /** Flag indicating whether all other `fileActivity` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `fileActivity` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingFileActivityPkeyUpdate>
  >;
};

/** A condition to be used against `File` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type FileCondition = {
  /** Checks for equality with the object’s `dateArchived` field. */
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateDataDeleted` field. */
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `fileFormat` field. */
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `fileStructure` field. */
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `fileType` field. */
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `isSeries` field. */
  isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `location` field. */
  location?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `multipartUploadId` field. */
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `originalName` field. */
  originalName?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `parentIds` field. */
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `partSize` field. */
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `preview` field. */
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `processingStatus` field. */
  processingStatus?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `referenceId` field. */
  referenceId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `seriesOrder` field. */
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `seriesParentId` field. */
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `signal` field. */
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `size` field. */
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `source` field. */
  source?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `tags` field. */
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `uploadStatus` field. */
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `drsFileexecutor` in the `FileInput` mutation. */
export type FileExecutorId819Da590FkDrsFileexecutorIdInput = {
  /** The primary key(s) for `drsFileexecutor` for the far side of the relationship. */
  connectById?: InputMaybe<DrsFileexecutorDrsFileexecutorPkeyConnect>;
  /** The primary key(s) for `drsFileexecutor` for the far side of the relationship. */
  deleteById?: InputMaybe<DrsFileexecutorDrsFileexecutorPkeyDelete>;
};

/** Input for the nested mutation of `file` in the `DrsFileexecutorInput` mutation. */
export type FileExecutorId819Da590FkDrsFileexecutorIdInverseInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileFilePkeyConnect>>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<
    Array<FileProjectReferenceIdUniqueConnect>
  >;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileFilePkeyDelete>>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteByProjectIdAndReferenceId?: InputMaybe<
    Array<FileProjectReferenceIdUniqueDelete>
  >;
  /** Flag indicating whether all other `file` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The fields on `file` to look up the row to connect. */
export type FileFilePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `file` to look up the row to delete. */
export type FileFilePkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** A filter to be used against `File` object types. All fields are combined with a logical ‘and.’ */
export type FileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FileFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dateArchived` field. */
  dateArchived?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDataDeleted` field. */
  dateDataDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileActivitiesByFileId` relation. */
  fileActivitiesByFileId?: InputMaybe<FileToManyFileActivityFilter>;
  /** Some related `fileActivitiesByFileId` exist. */
  fileActivitiesByFileIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `fileBySeriesParentId` relation. */
  fileBySeriesParentId?: InputMaybe<FileFilter>;
  /** A related `fileBySeriesParentId` exists. */
  fileBySeriesParentIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `fileFormat` field. */
  fileFormat?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fileMetadataByFileId` relation. */
  fileMetadataByFileId?: InputMaybe<FileToManyFileMetadatumFilter>;
  /** Some related `fileMetadataByFileId` exist. */
  fileMetadataByFileIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `fileProcessingNotificationsByFileId` relation. */
  fileProcessingNotificationsByFileId?: InputMaybe<FileToManyFileProcessingNotificationFilter>;
  /** Some related `fileProcessingNotificationsByFileId` exist. */
  fileProcessingNotificationsByFileIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `fileStructure` field. */
  fileStructure?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fileType` field. */
  fileType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `filesBySeriesParentId` relation. */
  filesBySeriesParentId?: InputMaybe<FileToManyFileFilter>;
  /** Some related `filesBySeriesParentId` exist. */
  filesBySeriesParentIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isSeries` field. */
  isSeries?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `location` field. */
  location?: InputMaybe<StringFilter>;
  /** Filter by the object’s `multipartUploadId` field. */
  multipartUploadId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FileFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FileFilter>>;
  /** Filter by the object’s `originalName` field. */
  originalName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `outputGroupFilesByFileId` relation. */
  outputGroupFilesByFileId?: InputMaybe<FileToManyOutputGroupFileFilter>;
  /** Some related `outputGroupFilesByFileId` exist. */
  outputGroupFilesByFileIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `parentIds` field. */
  parentIds?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `partSize` field. */
  partSize?: InputMaybe<IntFilter>;
  /** Filter by the object’s `preview` field. */
  preview?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `processingStatus` field. */
  processingStatus?: InputMaybe<IntFilter>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `referenceId` field. */
  referenceId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `seriesOrder` field. */
  seriesOrder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `seriesParentId` field. */
  seriesParentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `signal` field. */
  signal?: InputMaybe<IntFilter>;
  /** Filter by the object’s `size` field. */
  size?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `source` field. */
  source?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `taskByTaskId` relation. */
  taskByTaskId?: InputMaybe<TaskFilter>;
  /** A related `taskByTaskId` exists. */
  taskByTaskIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `taskSourcesByFileId` relation. */
  taskSourcesByFileId?: InputMaybe<FileToManyTaskSourceFilter>;
  /** Some related `taskSourcesByFileId` exist. */
  taskSourcesByFileIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `uploadStatus` field. */
  uploadStatus?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `File` */
export type FileInput = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["UUID"]["input"];
  isSeries: Scalars["Boolean"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  originalName: Scalars["String"]["input"];
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus: Scalars["Int"]["input"];
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId: Scalars["UUID"]["input"];
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source: Scalars["String"]["input"];
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A connection to a list of `FileMetadatum` values. */
export type FileMetadataConnection = {
  __typename: "FileMetadataConnection";
  /** A list of edges which contains the `FileMetadatum` and cursor to aid in pagination. */
  edges: Array<FileMetadataEdge>;
  /** A list of `FileMetadatum` objects. */
  nodes: Array<FileMetadatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FileMetadatum` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `FileMetadatum` edge in the connection. */
export type FileMetadataEdge = {
  __typename: "FileMetadataEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `FileMetadatum` at the end of the edge. */
  node: FileMetadatum;
};

/** The `file` to be created by this mutation. */
export type FileMetadataFileId78256936FkFileIdFileCreateInput = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["UUID"]["input"];
  isSeries: Scalars["Boolean"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  originalName: Scalars["String"]["input"];
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus: Scalars["Int"]["input"];
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId: Scalars["UUID"]["input"];
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source: Scalars["String"]["input"];
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `fileMetadatum` to be created by this mutation. */
export type FileMetadataFileId78256936FkFileIdFileMetadataCreateInput = {
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileToFileId?: InputMaybe<FileMetadataFileId78256936FkFileIdInput>;
  id: Scalars["UUID"]["input"];
  metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
  metadatumToMetadataId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInput>;
};

/** Input for the nested mutation of `file` in the `FileMetadatumInput` mutation. */
export type FileMetadataFileId78256936FkFileIdInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<FileFilePkeyConnect>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueConnect>;
  /** A `FileInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileMetadataFileId78256936FkFileIdFileCreateInput>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteById?: InputMaybe<FileFilePkeyDelete>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueDelete>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFilePkeyUpdate>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingProjectReferenceIdUniqueUpdate>;
};

/** Input for the nested mutation of `fileMetadatum` in the `FileInput` mutation. */
export type FileMetadataFileId78256936FkFileIdInverseInput = {
  /** The primary key(s) for `fileMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileMetadatumFileMetadataPkeyConnect>>;
  /** A `FileMetadatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FileMetadataFileId78256936FkFileIdFileMetadataCreateInput>
  >;
  /** The primary key(s) for `fileMetadatum` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileMetadatumFileMetadataPkeyDelete>>;
  /** Flag indicating whether all other `fileMetadatum` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `fileMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFileMetadataPkeyUpdate>
  >;
};

/** The `fileMetadatum` to be created by this mutation. */
export type FileMetadataMetadataIdFefc0061FkMetadataIdFileMetadataCreateInput =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileToFileId?: InputMaybe<FileMetadataFileId78256936FkFileIdInput>;
    id: Scalars["UUID"]["input"];
    metadatumToMetadataId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInput>;
  };

/** Input for the nested mutation of `metadatum` in the `FileMetadatumInput` mutation. */
export type FileMetadataMetadataIdFefc0061FkMetadataIdInput = {
  /** The primary key(s) for `metadatum` for the far side of the relationship. */
  connectById?: InputMaybe<MetadatumMetadataPkeyConnect>;
  /** A `MetadatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdMetadataCreateInput>;
  /** The primary key(s) for `metadatum` for the far side of the relationship. */
  deleteById?: InputMaybe<MetadatumMetadataPkeyDelete>;
  /** The primary key(s) and patch data for `metadatum` for the far side of the relationship. */
  updateById?: InputMaybe<MetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingMetadataPkeyUpdate>;
};

/** Input for the nested mutation of `fileMetadatum` in the `MetadatumInput` mutation. */
export type FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput = {
  /** The primary key(s) for `fileMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileMetadatumFileMetadataPkeyConnect>>;
  /** A `FileMetadatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FileMetadataMetadataIdFefc0061FkMetadataIdFileMetadataCreateInput>
  >;
  /** The primary key(s) for `fileMetadatum` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileMetadatumFileMetadataPkeyDelete>>;
  /** Flag indicating whether all other `fileMetadatum` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `fileMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingFileMetadataPkeyUpdate>
  >;
};

/** The `metadatum` to be created by this mutation. */
export type FileMetadataMetadataIdFefc0061FkMetadataIdMetadataCreateInput = {
  displayName: Scalars["String"]["input"];
  fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
  id: Scalars["UUID"]["input"];
  key: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
};

/** Methods to use when ordering `FileMetadatum`. */
export enum FileMetadataOrderBy {
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  FileIdAsc = "FILE_ID_ASC",
  FileIdDesc = "FILE_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  MetadataIdAsc = "METADATA_ID_ASC",
  MetadataIdDesc = "METADATA_ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
}

/** The `fileMetadatum` to be created by this mutation. */
export type FileMetadataProjectId3474994EFkProjectIdFileMetadataCreateInput = {
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileToFileId?: InputMaybe<FileMetadataFileId78256936FkFileIdInput>;
  id: Scalars["UUID"]["input"];
  metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
  metadatumToMetadataId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInput>;
  projectToProjectId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInput>;
};

/** Input for the nested mutation of `project` in the `FileMetadatumInput` mutation. */
export type FileMetadataProjectId3474994EFkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `fileMetadatum` in the `ProjectInput` mutation. */
export type FileMetadataProjectId3474994EFkProjectIdInverseInput = {
  /** The primary key(s) for `fileMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileMetadatumFileMetadataPkeyConnect>>;
  /** A `FileMetadatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FileMetadataProjectId3474994EFkProjectIdFileMetadataCreateInput>
  >;
  /** The primary key(s) for `fileMetadatum` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileMetadatumFileMetadataPkeyDelete>>;
  /** Flag indicating whether all other `fileMetadatum` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `fileMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingFileMetadataPkeyUpdate>
  >;
};

/** The `fileMetadatum` to be created by this mutation. */
export type FileMetadataTenantId79Fe438BFkTenantIdFileMetadataCreateInput = {
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileToFileId?: InputMaybe<FileMetadataFileId78256936FkFileIdInput>;
  id: Scalars["UUID"]["input"];
  metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
  metadatumToMetadataId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInput>;
  tenantToTenantId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInput>;
};

/** Input for the nested mutation of `tenant` in the `FileMetadatumInput` mutation. */
export type FileMetadataTenantId79Fe438BFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `fileMetadatum` in the `TenantInput` mutation. */
export type FileMetadataTenantId79Fe438BFkTenantIdInverseInput = {
  /** The primary key(s) for `fileMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileMetadatumFileMetadataPkeyConnect>>;
  /** A `FileMetadatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FileMetadataTenantId79Fe438BFkTenantIdFileMetadataCreateInput>
  >;
  /** The primary key(s) for `fileMetadatum` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileMetadatumFileMetadataPkeyDelete>>;
  /** Flag indicating whether all other `fileMetadatum` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `fileMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingFileMetadataPkeyUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type FileMetadataTenantId79Fe438BFkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

export type FileMetadatum = {
  __typename: "FileMetadatum";
  dateCreated: Scalars["Datetime"]["output"];
  /** Reads a single `File` that is related to this `FileMetadatum`. */
  fileByFileId: Maybe<File>;
  fileId: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  metadataId: Scalars["UUID"]["output"];
  /** Reads a single `Metadatum` that is related to this `FileMetadatum`. */
  metadatumByMetadataId: Maybe<Metadatum>;
  /** Reads a single `Project` that is related to this `FileMetadatum`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  /** Reads a single `Tenant` that is related to this `FileMetadatum`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
};

/**
 * A condition to be used against `FileMetadatum` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FileMetadatumCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `fileId` field. */
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `metadataId` field. */
  metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `fileMetadatum` to look up the row to connect. */
export type FileMetadatumFileMetadataPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `fileMetadatum` to look up the row to delete. */
export type FileMetadatumFileMetadataPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** A filter to be used against `FileMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type FileMetadatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FileMetadatumFilter>>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileByFileId` relation. */
  fileByFileId?: InputMaybe<FileFilter>;
  /** A related `fileByFileId` exists. */
  fileByFileIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `fileId` field. */
  fileId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `metadataId` field. */
  metadataId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `metadatumByMetadataId` relation. */
  metadatumByMetadataId?: InputMaybe<MetadatumFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FileMetadatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FileMetadatumFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `FileMetadatum` */
export type FileMetadatumInput = {
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileToFileId?: InputMaybe<FileMetadataFileId78256936FkFileIdInput>;
  id: Scalars["UUID"]["input"];
  metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
  metadatumToMetadataId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInput>;
};

/** The fields on `fileMetadatum` to look up the row to update. */
export type FileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFileMetadataPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileMetadatum` being updated. */
    fileMetadatumPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `fileMetadatum` to look up the row to update. */
export type FileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingFileMetadataPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileMetadatum` being updated. */
    fileMetadatumPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `fileMetadatum` to look up the row to update. */
export type FileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingFileMetadataPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileMetadatum` being updated. */
    fileMetadatumPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `fileMetadatum` to look up the row to update. */
export type FileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingFileMetadataPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileMetadatum` being updated. */
    fileMetadatumPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** Represents an update to a `FileMetadatum`. Fields that are set will be updated. */
export type FileMetadatumPatch = {
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileToFileId?: InputMaybe<FileMetadataFileId78256936FkFileIdInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
  metadatumToMetadataId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInput>;
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFilePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `file` being updated. */
    filePatch: UpdateFileOnFileActivityForFileActivityFileId015763A9FkFileIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `file` to look up the row to update. */
export type FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingProjectReferenceIdUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `file` being updated. */
    filePatch: UpdateFileOnFileActivityForFileActivityFileId015763A9FkFileIdPatch;
    projectId: Scalars["UUID"]["input"];
    referenceId: Scalars["UUID"]["input"];
  };

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileProjectId3Ecca975FkProjectIdUsingFilePkeyUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileForFileProjectId3Ecca975FkProjectIdPatch;
  id: Scalars["UUID"]["input"];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectReferenceIdUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `file` being updated. */
    filePatch: UpdateFileOnFileForFileProjectId3Ecca975FkProjectIdPatch;
    projectId: Scalars["UUID"]["input"];
    referenceId: Scalars["UUID"]["input"];
  };

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingFilePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `file` being updated. */
    filePatch: UpdateFileOnFileForFileSeriesParentIdF7A07E20FkFileIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingProjectReferenceIdUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `file` being updated. */
    filePatch: UpdateFileOnFileForFileSeriesParentIdF7A07E20FkFileIdPatch;
    projectId: Scalars["UUID"]["input"];
    referenceId: Scalars["UUID"]["input"];
  };

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingFilePkeyUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileForFileTaskIdE4Da87AeFkTaskIdPatch;
  id: Scalars["UUID"]["input"];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingProjectReferenceIdUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `file` being updated. */
    filePatch: UpdateFileOnFileForFileTaskIdE4Da87AeFkTaskIdPatch;
    projectId: Scalars["UUID"]["input"];
    referenceId: Scalars["UUID"]["input"];
  };

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileTenantId61625016FkTenantIdUsingFilePkeyUpdate = {
  /** An object where the defined keys will be set on the `file` being updated. */
  filePatch: UpdateFileOnFileForFileTenantId61625016FkTenantIdPatch;
  id: Scalars["UUID"]["input"];
};

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileTenantId61625016FkTenantIdUsingProjectReferenceIdUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `file` being updated. */
    filePatch: UpdateFileOnFileForFileTenantId61625016FkTenantIdPatch;
    projectId: Scalars["UUID"]["input"];
    referenceId: Scalars["UUID"]["input"];
  };

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingFilePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `file` being updated. */
    filePatch: UpdateFileOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `file` to look up the row to update. */
export type FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingProjectReferenceIdUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `file` being updated. */
    filePatch: UpdateFileOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
    projectId: Scalars["UUID"]["input"];
    referenceId: Scalars["UUID"]["input"];
  };

/** The fields on `file` to look up the row to update. */
export type FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFilePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `file` being updated. */
    filePatch: UpdateFileOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `file` to look up the row to update. */
export type FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingProjectReferenceIdUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `file` being updated. */
    filePatch: UpdateFileOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch;
    projectId: Scalars["UUID"]["input"];
    referenceId: Scalars["UUID"]["input"];
  };

/** The fields on `file` to look up the row to update. */
export type FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFilePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `file` being updated. */
    filePatch: UpdateFileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `file` to look up the row to update. */
export type FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingProjectReferenceIdUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `file` being updated. */
    filePatch: UpdateFileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch;
    projectId: Scalars["UUID"]["input"];
    referenceId: Scalars["UUID"]["input"];
  };

/** The fields on `file` to look up the row to update. */
export type FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingFilePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `file` being updated. */
    filePatch: UpdateFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `file` to look up the row to update. */
export type FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingProjectReferenceIdUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `file` being updated. */
    filePatch: UpdateFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch;
    projectId: Scalars["UUID"]["input"];
    referenceId: Scalars["UUID"]["input"];
  };

/** The fields on `file` to look up the row to update. */
export type FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingFilePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `file` being updated. */
    filePatch: UpdateFileOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `file` to look up the row to update. */
export type FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingProjectReferenceIdUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `file` being updated. */
    filePatch: UpdateFileOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch;
    projectId: Scalars["UUID"]["input"];
    referenceId: Scalars["UUID"]["input"];
  };

export type FileOutputGroup = {
  __typename: "FileOutputGroup";
  /** Reads a single `ApplicationUser` that is related to this `FileOutputGroup`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateCreated: Scalars["Datetime"]["output"];
  /** Reads and enables pagination through a set of `FileOutputGroupMetadatum`. */
  fileOutputGroupMetadataByFileOutputGroupId: FileOutputGroupMetadataConnection;
  groupType: Scalars["Int"]["output"];
  id: Scalars["UUID"]["output"];
  key: Maybe<Scalars["String"]["output"]>;
  /** Reads and enables pagination through a set of `OutputGroupFile`. */
  outputGroupFilesByFileOutputGroupId: OutputGroupFilesConnection;
  /** Reads a single `Project` that is related to this `FileOutputGroup`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  /** Reads a single `Task` that is related to this `FileOutputGroup`. */
  taskByTaskId: Maybe<Task>;
  taskId: Scalars["UUID"]["output"];
  /** Reads a single `Tenant` that is related to this `FileOutputGroup`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
  userId: Scalars["UUID"]["output"];
};

export type FileOutputGroupFileOutputGroupMetadataByFileOutputGroupIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileOutputGroupMetadatumCondition>;
  filter?: InputMaybe<FileOutputGroupMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileOutputGroupMetadataOrderBy>>;
};

export type FileOutputGroupOutputGroupFilesByFileOutputGroupIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<OutputGroupFileCondition>;
  filter?: InputMaybe<OutputGroupFileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<OutputGroupFilesOrderBy>>;
};

/**
 * A condition to be used against `FileOutputGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FileOutputGroupCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `groupType` field. */
  groupType?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `fileOutputGroup` to look up the row to connect. */
export type FileOutputGroupFileOutputGroupPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `fileOutputGroup` to look up the row to delete. */
export type FileOutputGroupFileOutputGroupPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `fileOutputGroup` to look up the row to connect. */
export type FileOutputGroupFileOutputGroupTaskIdKeyConnect = {
  taskId: Scalars["UUID"]["input"];
};

/** The fields on `fileOutputGroup` to look up the row to delete. */
export type FileOutputGroupFileOutputGroupTaskIdKeyDelete = {
  taskId: Scalars["UUID"]["input"];
};

/** A filter to be used against `FileOutputGroup` object types. All fields are combined with a logical ‘and.’ */
export type FileOutputGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FileOutputGroupFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileOutputGroupMetadataByFileOutputGroupId` relation. */
  fileOutputGroupMetadataByFileOutputGroupId?: InputMaybe<FileOutputGroupToManyFileOutputGroupMetadatumFilter>;
  /** Some related `fileOutputGroupMetadataByFileOutputGroupId` exist. */
  fileOutputGroupMetadataByFileOutputGroupIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `groupType` field. */
  groupType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FileOutputGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FileOutputGroupFilter>>;
  /** Filter by the object’s `outputGroupFilesByFileOutputGroupId` relation. */
  outputGroupFilesByFileOutputGroupId?: InputMaybe<FileOutputGroupToManyOutputGroupFileFilter>;
  /** Some related `outputGroupFilesByFileOutputGroupId` exist. */
  outputGroupFilesByFileOutputGroupIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `taskByTaskId` relation. */
  taskByTaskId?: InputMaybe<TaskFilter>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The `fileOutputGroupMetadatum` to be created by this mutation. */
export type FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpFileOutputGroupMetadataCreateInput =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileOutputGroupToFileOutputGroupId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput>;
    id: Scalars["UUID"]["input"];
    metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput>;
  };

/** Input for the nested mutation of `fileOutputGroup` in the `FileOutputGroupMetadatumInput` mutation. */
export type FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput = {
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectById?: InputMaybe<FileOutputGroupFileOutputGroupPkeyConnect>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<FileOutputGroupFileOutputGroupTaskIdKeyConnect>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<FileOutputGroupFileOutputGroupPkeyDelete>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  deleteByTaskId?: InputMaybe<FileOutputGroupFileOutputGroupTaskIdKeyDelete>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateById?: InputMaybe<FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupPkeyUpdate>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate>;
};

/** Input for the nested mutation of `fileOutputGroupMetadatum` in the `FileOutputGroupInput` mutation. */
export type FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput = {
  /** The primary key(s) for `fileOutputGroupMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect>
  >;
  /** A `FileOutputGroupMetadatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpFileOutputGroupMetadataCreateInput>
  >;
  /** The primary key(s) for `fileOutputGroupMetadatum` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<FileOutputGroupMetadatumFileOutputGroupMetadataPkeyDelete>
  >;
  /** Flag indicating whether all other `fileOutputGroupMetadatum` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `fileOutputGroupMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupMetadataPkeyUpdate>
  >;
};

/** A connection to a list of `FileOutputGroupMetadatum` values. */
export type FileOutputGroupMetadataConnection = {
  __typename: "FileOutputGroupMetadataConnection";
  /** A list of edges which contains the `FileOutputGroupMetadatum` and cursor to aid in pagination. */
  edges: Array<FileOutputGroupMetadataEdge>;
  /** A list of `FileOutputGroupMetadatum` objects. */
  nodes: Array<FileOutputGroupMetadatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FileOutputGroupMetadatum` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `FileOutputGroupMetadatum` edge in the connection. */
export type FileOutputGroupMetadataEdge = {
  __typename: "FileOutputGroupMetadataEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `FileOutputGroupMetadatum` at the end of the edge. */
  node: FileOutputGroupMetadatum;
};

/** The `fileOutputGroupMetadatum` to be created by this mutation. */
export type FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdFileOutputGroupMetadataCreateInput =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileOutputGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupToFileOutputGroupId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput>;
    id: Scalars["UUID"]["input"];
    metadatumToMetadataId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput>;
  };

/** Input for the nested mutation of `metadatum` in the `FileOutputGroupMetadatumInput` mutation. */
export type FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput = {
  /** The primary key(s) for `metadatum` for the far side of the relationship. */
  connectById?: InputMaybe<MetadatumMetadataPkeyConnect>;
  /** A `MetadatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdMetadataCreateInput>;
  /** The primary key(s) for `metadatum` for the far side of the relationship. */
  deleteById?: InputMaybe<MetadatumMetadataPkeyDelete>;
  /** The primary key(s) and patch data for `metadatum` for the far side of the relationship. */
  updateById?: InputMaybe<MetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingMetadataPkeyUpdate>;
};

/** Input for the nested mutation of `fileOutputGroupMetadatum` in the `MetadatumInput` mutation. */
export type FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput =
  {
    /** The primary key(s) for `fileOutputGroupMetadatum` for the far side of the relationship. */
    connectById?: InputMaybe<
      Array<FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect>
    >;
    /** A `FileOutputGroupMetadatumInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdFileOutputGroupMetadataCreateInput>
    >;
    /** The primary key(s) for `fileOutputGroupMetadatum` for the far side of the relationship. */
    deleteById?: InputMaybe<
      Array<FileOutputGroupMetadatumFileOutputGroupMetadataPkeyDelete>
    >;
    /** Flag indicating whether all other `fileOutputGroupMetadatum` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The primary key(s) and patch data for `fileOutputGroupMetadatum` for the far side of the relationship. */
    updateById?: InputMaybe<
      Array<FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingFileOutputGroupMetadataPkeyUpdate>
    >;
  };

/** The `metadatum` to be created by this mutation. */
export type FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdMetadataCreateInput =
  {
    displayName: Scalars["String"]["input"];
    fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
    id: Scalars["UUID"]["input"];
    key: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
  };

/** Methods to use when ordering `FileOutputGroupMetadatum`. */
export enum FileOutputGroupMetadataOrderBy {
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  FileOutputGroupIdAsc = "FILE_OUTPUT_GROUP_ID_ASC",
  FileOutputGroupIdDesc = "FILE_OUTPUT_GROUP_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  MetadataIdAsc = "METADATA_ID_ASC",
  MetadataIdDesc = "METADATA_ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
}

/** The `fileOutputGroupMetadatum` to be created by this mutation. */
export type FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdFileOutputGroupMetadataCreateInput =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileOutputGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupToFileOutputGroupId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput>;
    id: Scalars["UUID"]["input"];
    metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput>;
    projectToProjectId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput>;
  };

/** Input for the nested mutation of `project` in the `FileOutputGroupMetadatumInput` mutation. */
export type FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `fileOutputGroupMetadatum` in the `ProjectInput` mutation. */
export type FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput = {
  /** The primary key(s) for `fileOutputGroupMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect>
  >;
  /** A `FileOutputGroupMetadatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdFileOutputGroupMetadataCreateInput>
  >;
  /** The primary key(s) for `fileOutputGroupMetadatum` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<FileOutputGroupMetadatumFileOutputGroupMetadataPkeyDelete>
  >;
  /** Flag indicating whether all other `fileOutputGroupMetadatum` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `fileOutputGroupMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingFileOutputGroupMetadataPkeyUpdate>
  >;
};

/** The `fileOutputGroupMetadatum` to be created by this mutation. */
export type FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdFileOutputGroupMetadataCreateInput =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileOutputGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupToFileOutputGroupId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput>;
    id: Scalars["UUID"]["input"];
    metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput>;
    tenantToTenantId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput>;
  };

/** Input for the nested mutation of `tenant` in the `FileOutputGroupMetadatumInput` mutation. */
export type FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `fileOutputGroupMetadatum` in the `TenantInput` mutation. */
export type FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput = {
  /** The primary key(s) for `fileOutputGroupMetadatum` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect>
  >;
  /** A `FileOutputGroupMetadatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdFileOutputGroupMetadataCreateInput>
  >;
  /** The primary key(s) for `fileOutputGroupMetadatum` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<FileOutputGroupMetadatumFileOutputGroupMetadataPkeyDelete>
  >;
  /** Flag indicating whether all other `fileOutputGroupMetadatum` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `fileOutputGroupMetadatum` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingFileOutputGroupMetadataPkeyUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdTenantCreateInput =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal: Scalars["Boolean"]["input"];
    key: Scalars["String"]["input"];
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name: Scalars["String"]["input"];
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName: Scalars["String"]["input"];
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status: Scalars["Int"]["input"];
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType: Scalars["Int"]["input"];
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

export type FileOutputGroupMetadatum = {
  __typename: "FileOutputGroupMetadatum";
  dateCreated: Scalars["Datetime"]["output"];
  /** Reads a single `FileOutputGroup` that is related to this `FileOutputGroupMetadatum`. */
  fileOutputGroupByFileOutputGroupId: Maybe<FileOutputGroup>;
  fileOutputGroupId: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  metadataId: Scalars["UUID"]["output"];
  /** Reads a single `Metadatum` that is related to this `FileOutputGroupMetadatum`. */
  metadatumByMetadataId: Maybe<Metadatum>;
  /** Reads a single `Project` that is related to this `FileOutputGroupMetadatum`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  /** Reads a single `Tenant` that is related to this `FileOutputGroupMetadatum`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
};

/**
 * A condition to be used against `FileOutputGroupMetadatum` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type FileOutputGroupMetadatumCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `fileOutputGroupId` field. */
  fileOutputGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `metadataId` field. */
  metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `fileOutputGroupMetadatum` to look up the row to connect. */
export type FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `fileOutputGroupMetadatum` to look up the row to delete. */
export type FileOutputGroupMetadatumFileOutputGroupMetadataPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** A filter to be used against `FileOutputGroupMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type FileOutputGroupMetadatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FileOutputGroupMetadatumFilter>>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileOutputGroupByFileOutputGroupId` relation. */
  fileOutputGroupByFileOutputGroupId?: InputMaybe<FileOutputGroupFilter>;
  /** A related `fileOutputGroupByFileOutputGroupId` exists. */
  fileOutputGroupByFileOutputGroupIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `fileOutputGroupId` field. */
  fileOutputGroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `metadataId` field. */
  metadataId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `metadatumByMetadataId` relation. */
  metadatumByMetadataId?: InputMaybe<MetadatumFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FileOutputGroupMetadatumFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `FileOutputGroupMetadatum` */
export type FileOutputGroupMetadatumInput = {
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileOutputGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupToFileOutputGroupId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput>;
  id: Scalars["UUID"]["input"];
  metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
  metadatumToMetadataId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput>;
};

/** The fields on `fileOutputGroupMetadatum` to look up the row to update. */
export type FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupMetadataPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileOutputGroupMetadatum` being updated. */
    fileOutputGroupMetadatumPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `fileOutputGroupMetadatum` to look up the row to update. */
export type FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingFileOutputGroupMetadataPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileOutputGroupMetadatum` being updated. */
    fileOutputGroupMetadatumPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `fileOutputGroupMetadatum` to look up the row to update. */
export type FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingFileOutputGroupMetadataPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileOutputGroupMetadatum` being updated. */
    fileOutputGroupMetadatumPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `fileOutputGroupMetadatum` to look up the row to update. */
export type FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingFileOutputGroupMetadataPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileOutputGroupMetadatum` being updated. */
    fileOutputGroupMetadatumPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** Represents an update to a `FileOutputGroupMetadatum`. Fields that are set will be updated. */
export type FileOutputGroupMetadatumPatch = {
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileOutputGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupToFileOutputGroupId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
  metadatumToMetadataId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput>;
};

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
    fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupTaskIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
    fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch;
    taskId: Scalars["UUID"]["input"];
  };

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
    fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupTaskIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
    fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch;
    taskId: Scalars["UUID"]["input"];
  };

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
    fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupTaskIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
    fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
    taskId: Scalars["UUID"]["input"];
  };

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
    fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupTaskIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
    fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
    taskId: Scalars["UUID"]["input"];
  };

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
    fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
    fileOutputGroupPatch: UpdateFileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch;
    taskId: Scalars["UUID"]["input"];
  };

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
    fileOutputGroupPatch: UpdateFileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `fileOutputGroup` to look up the row to update. */
export type FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
    fileOutputGroupPatch: UpdateFileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch;
    taskId: Scalars["UUID"]["input"];
  };

/** Represents an update to a `FileOutputGroup`. Fields that are set will be updated. */
export type FileOutputGroupPatch = {
  applicationUserToUserId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput>;
  groupType?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInput>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskToTaskId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `project` in the `FileOutputGroupInput` mutation. */
export type FileOutputGroupProjectId908Fb9FfFkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `fileOutputGroup` in the `ProjectInput` mutation. */
export type FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput = {
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileOutputGroupFileOutputGroupPkeyConnect>>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<
    Array<FileOutputGroupFileOutputGroupTaskIdKeyConnect>
  >;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileOutputGroupFileOutputGroupPkeyDelete>>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  deleteByTaskId?: InputMaybe<
    Array<FileOutputGroupFileOutputGroupTaskIdKeyDelete>
  >;
  /** Flag indicating whether all other `fileOutputGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<
    Array<FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupTaskIdKeyUpdate>
  >;
};

/** Input for the nested mutation of `task` in the `FileOutputGroupInput` mutation. */
export type FileOutputGroupTaskId2B1Df6A1FkTaskIdInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdTaskCreateInput>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyDelete>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteById?: InputMaybe<TaskTaskPkeyDelete>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `fileOutputGroup` in the `TaskInput` mutation. */
export type FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput = {
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectById?: InputMaybe<FileOutputGroupFileOutputGroupPkeyConnect>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<FileOutputGroupFileOutputGroupTaskIdKeyConnect>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<FileOutputGroupFileOutputGroupPkeyDelete>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  deleteByTaskId?: InputMaybe<FileOutputGroupFileOutputGroupTaskIdKeyDelete>;
  /** Flag indicating whether all other `fileOutputGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateById?: InputMaybe<FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupPkeyUpdate>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupTaskIdKeyUpdate>;
};

/** The `task` to be created by this mutation. */
export type FileOutputGroupTaskId2B1Df6A1FkTaskIdTaskCreateInput = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned: Scalars["Boolean"]["input"];
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id: Scalars["UUID"]["input"];
  inputsHash: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `tenant` in the `FileOutputGroupInput` mutation. */
export type FileOutputGroupTenantId3Fa46D44FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `fileOutputGroup` in the `TenantInput` mutation. */
export type FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput = {
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileOutputGroupFileOutputGroupPkeyConnect>>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<
    Array<FileOutputGroupFileOutputGroupTaskIdKeyConnect>
  >;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileOutputGroupFileOutputGroupPkeyDelete>>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  deleteByTaskId?: InputMaybe<
    Array<FileOutputGroupFileOutputGroupTaskIdKeyDelete>
  >;
  /** Flag indicating whether all other `fileOutputGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<
    Array<FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupTaskIdKeyUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type FileOutputGroupTenantId3Fa46D44FkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** A filter to be used against many `FileOutputGroupMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type FileOutputGroupToManyFileOutputGroupMetadatumFilter = {
  /** Every related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** No related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** Some related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileOutputGroupMetadatumFilter>;
};

/** A filter to be used against many `OutputGroupFile` object types. All fields are combined with a logical ‘and.’ */
export type FileOutputGroupToManyOutputGroupFileFilter = {
  /** Every related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OutputGroupFileFilter>;
  /** No related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OutputGroupFileFilter>;
  /** Some related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OutputGroupFileFilter>;
};

/** The `applicationUser` to be created by this mutation. */
export type FileOutputGroupUserIdB22Ec436FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `FileOutputGroupInput` mutation. */
export type FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `fileOutputGroup` in the `ApplicationUserInput` mutation. */
export type FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileOutputGroupFileOutputGroupPkeyConnect>>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<
    Array<FileOutputGroupFileOutputGroupTaskIdKeyConnect>
  >;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileOutputGroupFileOutputGroupPkeyDelete>>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  deleteByTaskId?: InputMaybe<
    Array<FileOutputGroupFileOutputGroupTaskIdKeyDelete>
  >;
  /** Flag indicating whether all other `fileOutputGroup` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<
    Array<FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupTaskIdKeyUpdate>
  >;
};

/** A connection to a list of `FileOutputGroup` values. */
export type FileOutputGroupsConnection = {
  __typename: "FileOutputGroupsConnection";
  /** A list of edges which contains the `FileOutputGroup` and cursor to aid in pagination. */
  edges: Array<FileOutputGroupsEdge>;
  /** A list of `FileOutputGroup` objects. */
  nodes: Array<FileOutputGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FileOutputGroup` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `FileOutputGroup` edge in the connection. */
export type FileOutputGroupsEdge = {
  __typename: "FileOutputGroupsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `FileOutputGroup` at the end of the edge. */
  node: FileOutputGroup;
};

/** Methods to use when ordering `FileOutputGroup`. */
export enum FileOutputGroupsOrderBy {
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  GroupTypeAsc = "GROUP_TYPE_ASC",
  GroupTypeDesc = "GROUP_TYPE_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  KeyAsc = "KEY_ASC",
  KeyDesc = "KEY_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  TaskIdAsc = "TASK_ID_ASC",
  TaskIdDesc = "TASK_ID_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** Represents an update to a `File`. Fields that are set will be updated. */
export type FilePatch = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  originalName?: InputMaybe<Scalars["String"]["input"]>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus?: InputMaybe<Scalars["Int"]["input"]>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId?: InputMaybe<Scalars["UUID"]["input"]>;
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `applicationUser` to be created by this mutation. */
export type FileProcessingNotiUserId08265156FkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `FileProcessingNotificationInput` mutation. */
export type FileProcessingNotiUserId08265156FkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `fileProcessingNotification` in the `ApplicationUserInput` mutation. */
export type FileProcessingNotiUserId08265156FkApplicatiInverseInput = {
  /** The primary key(s) for `fileProcessingNotification` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<FileProcessingNotificationFileProcessingNotificationPkeyConnect>
  >;
  /** The primary key(s) and patch data for `fileProcessingNotification` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingFileProcessingNotificationPkeyUpdate>
  >;
};

export type FileProcessingNotification = {
  __typename: "FileProcessingNotification";
  /** Reads a single `ApplicationUser` that is related to this `FileProcessingNotification`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** Reads a single `File` that is related to this `FileProcessingNotification`. */
  fileByFileId: Maybe<File>;
  fileId: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  /** Reads a single `Notification` that is related to this `FileProcessingNotification`. */
  notificationById: Maybe<Notification>;
  status: Scalars["Int"]["output"];
  userId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `FileProcessingNotification` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type FileProcessingNotificationCondition = {
  /** Checks for equality with the object’s `fileId` field. */
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `file` to be created by this mutation. */
export type FileProcessingNotificationFileId717B514EFkFileIdFileCreateInput = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["UUID"]["input"];
  isSeries: Scalars["Boolean"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  originalName: Scalars["String"]["input"];
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus: Scalars["Int"]["input"];
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId: Scalars["UUID"]["input"];
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source: Scalars["String"]["input"];
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `file` in the `FileProcessingNotificationInput` mutation. */
export type FileProcessingNotificationFileId717B514EFkFileIdInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<FileFilePkeyConnect>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueConnect>;
  /** A `FileInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdFileCreateInput>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteById?: InputMaybe<FileFilePkeyDelete>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueDelete>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFilePkeyUpdate>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingProjectReferenceIdUniqueUpdate>;
};

/** Input for the nested mutation of `fileProcessingNotification` in the `FileInput` mutation. */
export type FileProcessingNotificationFileId717B514EFkFileIdInverseInput = {
  /** The primary key(s) for `fileProcessingNotification` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<FileProcessingNotificationFileProcessingNotificationPkeyConnect>
  >;
  /** The primary key(s) and patch data for `fileProcessingNotification` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFileProcessingNotificationPkeyUpdate>
  >;
};

/** The fields on `fileProcessingNotification` to look up the row to connect. */
export type FileProcessingNotificationFileProcessingNotificationPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** A filter to be used against `FileProcessingNotification` object types. All fields are combined with a logical ‘and.’ */
export type FileProcessingNotificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FileProcessingNotificationFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `fileByFileId` relation. */
  fileByFileId?: InputMaybe<FileFilter>;
  /** Filter by the object’s `fileId` field. */
  fileId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FileProcessingNotificationFilter>;
  /** Filter by the object’s `notificationById` relation. */
  notificationById?: InputMaybe<NotificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FileProcessingNotificationFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** Input for the nested mutation of `notification` in the `FileProcessingNotificationInput` mutation. */
export type FileProcessingNotificationId630E6495FkNotificationIdInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<NotificationNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<NotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingNotificationPkeyUpdate>;
};

/** Input for the nested mutation of `fileProcessingNotification` in the `NotificationInput` mutation. */
export type FileProcessingNotificationId630E6495FkNotificationIdInverseInput = {
  /** The primary key(s) for `fileProcessingNotification` for the far side of the relationship. */
  connectById?: InputMaybe<FileProcessingNotificationFileProcessingNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `fileProcessingNotification` for the far side of the relationship. */
  updateById?: InputMaybe<FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingFileProcessingNotificationPkeyUpdate>;
};

/** The fields on `fileProcessingNotification` to look up the row to update. */
export type FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingFileProcessingNotificationPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileProcessingNotification` being updated. */
    fileProcessingNotificationPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `fileProcessingNotification` to look up the row to update. */
export type FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFileProcessingNotificationPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileProcessingNotification` being updated. */
    fileProcessingNotificationPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `fileProcessingNotification` to look up the row to update. */
export type FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingFileProcessingNotificationPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `fileProcessingNotification` being updated. */
    fileProcessingNotificationPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** A connection to a list of `FileProcessingNotification` values. */
export type FileProcessingNotificationsConnection = {
  __typename: "FileProcessingNotificationsConnection";
  /** A list of edges which contains the `FileProcessingNotification` and cursor to aid in pagination. */
  edges: Array<FileProcessingNotificationsEdge>;
  /** A list of `FileProcessingNotification` objects. */
  nodes: Array<FileProcessingNotification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FileProcessingNotification` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `FileProcessingNotification` edge in the connection. */
export type FileProcessingNotificationsEdge = {
  __typename: "FileProcessingNotificationsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `FileProcessingNotification` at the end of the edge. */
  node: FileProcessingNotification;
};

/** Methods to use when ordering `FileProcessingNotification`. */
export enum FileProcessingNotificationsOrderBy {
  FileIdAsc = "FILE_ID_ASC",
  FileIdDesc = "FILE_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  StatusAsc = "STATUS_ASC",
  StatusDesc = "STATUS_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** The `file` to be created by this mutation. */
export type FileProjectId3Ecca975FkProjectIdFileCreateInput = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["UUID"]["input"];
  isSeries: Scalars["Boolean"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  originalName: Scalars["String"]["input"];
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus: Scalars["Int"]["input"];
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId: Scalars["UUID"]["input"];
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source: Scalars["String"]["input"];
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `project` in the `FileInput` mutation. */
export type FileProjectId3Ecca975FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `file` in the `ProjectInput` mutation. */
export type FileProjectId3Ecca975FkProjectIdInverseInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileFilePkeyConnect>>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<
    Array<FileProjectReferenceIdUniqueConnect>
  >;
  /** A `FileInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FileProjectId3Ecca975FkProjectIdFileCreateInput>>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileFilePkeyDelete>>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteByProjectIdAndReferenceId?: InputMaybe<
    Array<FileProjectReferenceIdUniqueDelete>
  >;
  /** Flag indicating whether all other `file` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileOnFileForFileProjectId3Ecca975FkProjectIdUsingFilePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<
    Array<FileOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectReferenceIdUniqueUpdate>
  >;
};

/** The fields on `file` to look up the row to connect. */
export type FileProjectReferenceIdUniqueConnect = {
  projectId: Scalars["UUID"]["input"];
  referenceId: Scalars["UUID"]["input"];
};

/** The fields on `file` to look up the row to delete. */
export type FileProjectReferenceIdUniqueDelete = {
  projectId: Scalars["UUID"]["input"];
  referenceId: Scalars["UUID"]["input"];
};

/** The `file` to be created by this mutation. */
export type FileSeriesParentIdF7A07E20FkFileIdFileCreateInput = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["UUID"]["input"];
  isSeries: Scalars["Boolean"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  originalName: Scalars["String"]["input"];
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus: Scalars["Int"]["input"];
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId: Scalars["UUID"]["input"];
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source: Scalars["String"]["input"];
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `file` in the `FileInput` mutation. */
export type FileSeriesParentIdF7A07E20FkFileIdInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<FileFilePkeyConnect>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueConnect>;
  /** A `FileInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdFileCreateInput>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteById?: InputMaybe<FileFilePkeyDelete>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueDelete>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingFilePkeyUpdate>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingProjectReferenceIdUniqueUpdate>;
};

/** The `file` to be created by this mutation. */
export type FileTaskIdE4Da87AeFkTaskIdFileCreateInput = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["UUID"]["input"];
  isSeries: Scalars["Boolean"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  originalName: Scalars["String"]["input"];
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus: Scalars["Int"]["input"];
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId: Scalars["UUID"]["input"];
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source: Scalars["String"]["input"];
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `task` in the `FileInput` mutation. */
export type FileTaskIdE4Da87AeFkTaskIdInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdTaskCreateInput>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyDelete>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteById?: InputMaybe<TaskTaskPkeyDelete>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `file` in the `TaskInput` mutation. */
export type FileTaskIdE4Da87AeFkTaskIdInverseInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileFilePkeyConnect>>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<
    Array<FileProjectReferenceIdUniqueConnect>
  >;
  /** A `FileInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FileTaskIdE4Da87AeFkTaskIdFileCreateInput>>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileFilePkeyDelete>>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteByProjectIdAndReferenceId?: InputMaybe<
    Array<FileProjectReferenceIdUniqueDelete>
  >;
  /** Flag indicating whether all other `file` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingFilePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<
    Array<FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingProjectReferenceIdUniqueUpdate>
  >;
};

/** The `task` to be created by this mutation. */
export type FileTaskIdE4Da87AeFkTaskIdTaskCreateInput = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned: Scalars["Boolean"]["input"];
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id: Scalars["UUID"]["input"];
  inputsHash: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `file` to be created by this mutation. */
export type FileTenantId61625016FkTenantIdFileCreateInput = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["UUID"]["input"];
  isSeries: Scalars["Boolean"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  originalName: Scalars["String"]["input"];
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus: Scalars["Int"]["input"];
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId: Scalars["UUID"]["input"];
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source: Scalars["String"]["input"];
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `tenant` in the `FileInput` mutation. */
export type FileTenantId61625016FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileTenantId61625016FkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `file` in the `TenantInput` mutation. */
export type FileTenantId61625016FkTenantIdInverseInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileFilePkeyConnect>>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<
    Array<FileProjectReferenceIdUniqueConnect>
  >;
  /** A `FileInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FileTenantId61625016FkTenantIdFileCreateInput>>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileFilePkeyDelete>>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteByProjectIdAndReferenceId?: InputMaybe<
    Array<FileProjectReferenceIdUniqueDelete>
  >;
  /** Flag indicating whether all other `file` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileOnFileForFileTenantId61625016FkTenantIdUsingFilePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<
    Array<FileOnFileForFileTenantId61625016FkTenantIdUsingProjectReferenceIdUniqueUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type FileTenantId61625016FkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** A filter to be used against many `FileActivity` object types. All fields are combined with a logical ‘and.’ */
export type FileToManyFileActivityFilter = {
  /** Every related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileActivityFilter>;
  /** No related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileActivityFilter>;
  /** Some related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileActivityFilter>;
};

/** A filter to be used against many `File` object types. All fields are combined with a logical ‘and.’ */
export type FileToManyFileFilter = {
  /** Every related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileFilter>;
  /** No related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileFilter>;
  /** Some related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileFilter>;
};

/** A filter to be used against many `FileMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type FileToManyFileMetadatumFilter = {
  /** Every related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileMetadatumFilter>;
  /** No related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileMetadatumFilter>;
  /** Some related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileMetadatumFilter>;
};

/** A filter to be used against many `FileProcessingNotification` object types. All fields are combined with a logical ‘and.’ */
export type FileToManyFileProcessingNotificationFilter = {
  /** Every related `FileProcessingNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileProcessingNotificationFilter>;
  /** No related `FileProcessingNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileProcessingNotificationFilter>;
  /** Some related `FileProcessingNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileProcessingNotificationFilter>;
};

/** A filter to be used against many `OutputGroupFile` object types. All fields are combined with a logical ‘and.’ */
export type FileToManyOutputGroupFileFilter = {
  /** Every related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OutputGroupFileFilter>;
  /** No related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OutputGroupFileFilter>;
  /** Some related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OutputGroupFileFilter>;
};

/** A filter to be used against many `TaskSource` object types. All fields are combined with a logical ‘and.’ */
export type FileToManyTaskSourceFilter = {
  /** Every related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskSourceFilter>;
  /** No related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskSourceFilter>;
  /** Some related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskSourceFilter>;
};

/** The `applicationUser` to be created by this mutation. */
export type FileUserId01D90B53FkApplicationUserIdApplicationUserCreateInput = {
  applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
  auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
  commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
  dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
  dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
  email: Scalars["String"]["input"];
  emailMarketingConsent: Scalars["Boolean"]["input"];
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  executorId?: InputMaybe<Scalars["Int"]["input"]>;
  featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName: Scalars["String"]["input"];
  gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
  gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  homeRegion?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  internal: Scalars["Boolean"]["input"];
  isActive: Scalars["Boolean"]["input"];
  isStaff: Scalars["Boolean"]["input"];
  isSuperuser: Scalars["Boolean"]["input"];
  lastName: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars["String"]["input"]>;
  pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
  userOrigin: Scalars["String"]["input"];
  userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
  username: Scalars["String"]["input"];
  workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
};

/** The `file` to be created by this mutation. */
export type FileUserId01D90B53FkApplicationUserIdFileCreateInput = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["UUID"]["input"];
  isSeries: Scalars["Boolean"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  originalName: Scalars["String"]["input"];
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus: Scalars["Int"]["input"];
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId: Scalars["UUID"]["input"];
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source: Scalars["String"]["input"];
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input for the nested mutation of `applicationUser` in the `FileInput` mutation. */
export type FileUserId01D90B53FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FileUserId01D90B53FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `file` in the `ApplicationUserInput` mutation. */
export type FileUserId01D90B53FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<Array<FileFilePkeyConnect>>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<
    Array<FileProjectReferenceIdUniqueConnect>
  >;
  /** A `FileInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<FileUserId01D90B53FkApplicationUserIdFileCreateInput>
  >;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<FileFilePkeyDelete>>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteByProjectIdAndReferenceId?: InputMaybe<
    Array<FileProjectReferenceIdUniqueDelete>
  >;
  /** Flag indicating whether all other `file` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingFilePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<
    Array<FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingProjectReferenceIdUniqueUpdate>
  >;
};

export type FilesByExecutor = {
  __typename: "FilesByExecutor";
  executorId: Maybe<Scalars["UUID"]["output"]>;
  id: Maybe<Scalars["UUID"]["output"]>;
  status: Maybe<Scalars["Int"]["output"]>;
};

/**
 * A condition to be used against `FilesByExecutor` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FilesByExecutorCondition = {
  /** Checks for equality with the object’s `executorId` field. */
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `FilesByExecutor` object types. All fields are combined with a logical ‘and.’ */
export type FilesByExecutorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FilesByExecutorFilter>>;
  /** Filter by the object’s `executorId` field. */
  executorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FilesByExecutorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FilesByExecutorFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `FilesByExecutor` */
export type FilesByExecutorInput = {
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A connection to a list of `FilesByExecutor` values. */
export type FilesByExecutorsConnection = {
  __typename: "FilesByExecutorsConnection";
  /** A list of edges which contains the `FilesByExecutor` and cursor to aid in pagination. */
  edges: Array<FilesByExecutorsEdge>;
  /** A list of `FilesByExecutor` objects. */
  nodes: Array<FilesByExecutor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FilesByExecutor` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `FilesByExecutor` edge in the connection. */
export type FilesByExecutorsEdge = {
  __typename: "FilesByExecutorsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `FilesByExecutor` at the end of the edge. */
  node: FilesByExecutor;
};

/** Methods to use when ordering `FilesByExecutor`. */
export enum FilesByExecutorsOrderBy {
  ExecutorIdAsc = "EXECUTOR_ID_ASC",
  ExecutorIdDesc = "EXECUTOR_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  StatusAsc = "STATUS_ASC",
  StatusDesc = "STATUS_DESC",
}

/** A connection to a list of `File` values. */
export type FilesConnection = {
  __typename: "FilesConnection";
  /** A list of edges which contains the `File` and cursor to aid in pagination. */
  edges: Array<FilesEdge>;
  /** A list of `File` objects. */
  nodes: Array<File>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `File` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `File` edge in the connection. */
export type FilesEdge = {
  __typename: "FilesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `File` at the end of the edge. */
  node: File;
};

/** Methods to use when ordering `File`. */
export enum FilesOrderBy {
  DateArchivedAsc = "DATE_ARCHIVED_ASC",
  DateArchivedDesc = "DATE_ARCHIVED_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DateDataDeletedAsc = "DATE_DATA_DELETED_ASC",
  DateDataDeletedDesc = "DATE_DATA_DELETED_DESC",
  DateDeletedAsc = "DATE_DELETED_ASC",
  DateDeletedDesc = "DATE_DELETED_DESC",
  FileFormatAsc = "FILE_FORMAT_ASC",
  FileFormatDesc = "FILE_FORMAT_DESC",
  FileStructureAsc = "FILE_STRUCTURE_ASC",
  FileStructureDesc = "FILE_STRUCTURE_DESC",
  FileTypeAsc = "FILE_TYPE_ASC",
  FileTypeDesc = "FILE_TYPE_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  IsSeriesAsc = "IS_SERIES_ASC",
  IsSeriesDesc = "IS_SERIES_DESC",
  KeyAsc = "KEY_ASC",
  KeyDesc = "KEY_DESC",
  LocationAsc = "LOCATION_ASC",
  LocationDesc = "LOCATION_DESC",
  MultipartUploadIdAsc = "MULTIPART_UPLOAD_ID_ASC",
  MultipartUploadIdDesc = "MULTIPART_UPLOAD_ID_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  OriginalNameAsc = "ORIGINAL_NAME_ASC",
  OriginalNameDesc = "ORIGINAL_NAME_DESC",
  ParentIdsAsc = "PARENT_IDS_ASC",
  ParentIdsDesc = "PARENT_IDS_DESC",
  PartSizeAsc = "PART_SIZE_ASC",
  PartSizeDesc = "PART_SIZE_DESC",
  PreviewAsc = "PREVIEW_ASC",
  PreviewDesc = "PREVIEW_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProcessingStatusAsc = "PROCESSING_STATUS_ASC",
  ProcessingStatusDesc = "PROCESSING_STATUS_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  ReferenceIdAsc = "REFERENCE_ID_ASC",
  ReferenceIdDesc = "REFERENCE_ID_DESC",
  SeriesOrderAsc = "SERIES_ORDER_ASC",
  SeriesOrderDesc = "SERIES_ORDER_DESC",
  SeriesParentIdAsc = "SERIES_PARENT_ID_ASC",
  SeriesParentIdDesc = "SERIES_PARENT_ID_DESC",
  SignalAsc = "SIGNAL_ASC",
  SignalDesc = "SIGNAL_DESC",
  SizeAsc = "SIZE_ASC",
  SizeDesc = "SIZE_DESC",
  SourceAsc = "SOURCE_ASC",
  SourceDesc = "SOURCE_DESC",
  StatusAsc = "STATUS_ASC",
  StatusDesc = "STATUS_DESC",
  TagsAsc = "TAGS_ASC",
  TagsDesc = "TAGS_DESC",
  TaskIdAsc = "TASK_ID_ASC",
  TaskIdDesc = "TASK_ID_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  UploadStatusAsc = "UPLOAD_STATUS_ASC",
  UploadStatusDesc = "UPLOAD_STATUS_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** A filter to be used against Float fields. All fields are combined with a logical ‘and.’ */
export type FloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["Float"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["Float"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["Float"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["Float"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["Float"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["Float"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["Float"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["Float"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["Float"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["Float"]["input"]>>;
};

export type GdtAnalysisTable = {
  __typename: "GdtAnalysisTable";
  /** Reads a single `ApplicationUser` that is related to this `GdtAnalysisTable`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateCreated: Scalars["Datetime"]["output"];
  dateDeleted: Maybe<Scalars["Datetime"]["output"]>;
  description: Scalars["String"]["output"];
  folderId: Maybe<Scalars["UUID"]["output"]>;
  /** Reads and enables pagination through a set of `GdtAnalysisTableCell`. */
  gdtAnalysisTableCellsByTableId: GdtAnalysisTableCellsConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTableColumnGroup`. */
  gdtAnalysisTableColumnGroupsByTableId: GdtAnalysisTableColumnGroupsConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTableColumn`. */
  gdtAnalysisTableColumnsByTableId: GdtAnalysisTableColumnsConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTableRow`. */
  gdtAnalysisTableRowsByTableId: GdtAnalysisTableRowsConnection;
  hidden: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  /** Reads a single `Project` that is related to this `GdtAnalysisTable`. */
  projectByProjectId: Maybe<Project>;
  /** Reads a single `ProjectFolder` that is related to this `GdtAnalysisTable`. */
  projectFolderByFolderId: Maybe<ProjectFolder>;
  projectId: Scalars["UUID"]["output"];
  /** Reads a single `ToolVersion` that is related to this `GdtAnalysisTable`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
  toolVersionId: Scalars["Int"]["output"];
  userId: Scalars["UUID"]["output"];
};

export type GdtAnalysisTableGdtAnalysisTableCellsByTableIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableCellCondition>;
  filter?: InputMaybe<GdtAnalysisTableCellFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableCellsOrderBy>>;
};

export type GdtAnalysisTableGdtAnalysisTableColumnGroupsByTableIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableColumnGroupCondition>;
  filter?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableColumnGroupsOrderBy>>;
};

export type GdtAnalysisTableGdtAnalysisTableColumnsByTableIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableColumnCondition>;
  filter?: InputMaybe<GdtAnalysisTableColumnFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableColumnsOrderBy>>;
};

export type GdtAnalysisTableGdtAnalysisTableRowsByTableIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableRowCondition>;
  filter?: InputMaybe<GdtAnalysisTableRowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableRowsOrderBy>>;
};

/** Input for the nested mutation of `gdtAnalysisTableColumn` in the `GdtAnalysisTableCellInput` mutation. */
export type GdtAnalysisTableCColumnId54344A43FkGdtAnalyInput = {
  /** The primary key(s) for `gdtAnalysisTableColumn` for the far side of the relationship. */
  connectById?: InputMaybe<GdtAnalysisTableColumnGdtAnalysisTableColumnPkeyConnect>;
  /** The primary key(s) for `gdtAnalysisTableColumn` for the far side of the relationship. */
  connectByTableIdAndOrder?: InputMaybe<GdtAnalysisTableColumnGdtAnalysisTableColumnUniqueConnect>;
  /** The primary key(s) and patch data for `gdtAnalysisTableColumn` for the far side of the relationship. */
  updateById?: InputMaybe<GdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate>;
  /** The primary key(s) and patch data for `gdtAnalysisTableColumn` for the far side of the relationship. */
  updateByTableIdAndOrder?: InputMaybe<GdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableCell` in the `GdtAnalysisTableColumnInput` mutation. */
export type GdtAnalysisTableCColumnId54344A43FkGdtAnalyInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableCell` for the far side of the relationship. */
  connectByColumnIdAndRowId?: InputMaybe<
    Array<GdtAnalysisTableCellGdtAnalysisTableCellUniqueConnect>
  >;
  /** The primary key(s) for `gdtAnalysisTableCell` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<GdtAnalysisTableCellGdtAnalysisTableCellPkeyConnect>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableCell` for the far side of the relationship. */
  updateByColumnIdAndRowId?: InputMaybe<
    Array<GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableCell` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate>
  >;
};

/** The `djangoContentType` to be created by this mutation. */
export type GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `GdtAnalysisTableColumnInput` mutation. */
export type GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableColumn` in the `DjangoContentTypeInput` mutation. */
export type GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableColumn` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<GdtAnalysisTableColumnGdtAnalysisTableColumnPkeyConnect>
  >;
  /** The primary key(s) for `gdtAnalysisTableColumn` for the far side of the relationship. */
  connectByTableIdAndOrder?: InputMaybe<
    Array<GdtAnalysisTableColumnGdtAnalysisTableColumnUniqueConnect>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableColumn` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingGdtAnalysisTableColumnPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableColumn` for the far side of the relationship. */
  updateByTableIdAndOrder?: InputMaybe<
    Array<GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingGdtAnalysisTableColumnUniqueUpdate>
  >;
};

/** The `djangoContentType` to be created by this mutation. */
export type GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `GdtAnalysisTableColumnGroupInput` mutation. */
export type GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableColumnGroup` in the `DjangoContentTypeInput` mutation. */
export type GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableColumnGroup` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<GdtAnalysisTableColumnGroupGdtAnalysisTableColumnGroupPkeyConnect>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableColumnGroup` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingGdtAnalysisTableColumnGroupPkeyUpdate>
  >;
};

/** Input for the nested mutation of `gdtAnalysisTableColumnGroup` in the `GdtAnalysisTableColumnInput` mutation. */
export type GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInput = {
  /** The primary key(s) for `gdtAnalysisTableColumnGroup` for the far side of the relationship. */
  connectById?: InputMaybe<GdtAnalysisTableColumnGroupGdtAnalysisTableColumnGroupPkeyConnect>;
  /** The primary key(s) and patch data for `gdtAnalysisTableColumnGroup` for the far side of the relationship. */
  updateById?: InputMaybe<GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnGroupPkeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableColumn` in the `GdtAnalysisTableColumnGroupInput` mutation. */
export type GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableColumn` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<GdtAnalysisTableColumnGdtAnalysisTableColumnPkeyConnect>
  >;
  /** The primary key(s) for `gdtAnalysisTableColumn` for the far side of the relationship. */
  connectByTableIdAndOrder?: InputMaybe<
    Array<GdtAnalysisTableColumnGdtAnalysisTableColumnUniqueConnect>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableColumn` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableColumn` for the far side of the relationship. */
  updateByTableIdAndOrder?: InputMaybe<
    Array<GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate>
  >;
};

/** Input for the nested mutation of `project` in the `GdtAnalysisTableColumnGroupInput` mutation. */
export type GdtAnalysisTableCProjectId77B86B06FkProjectIInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableColumnGroup` in the `ProjectInput` mutation. */
export type GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableColumnGroup` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<GdtAnalysisTableColumnGroupGdtAnalysisTableColumnGroupPkeyConnect>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableColumnGroup` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingGdtAnalysisTableColumnGroupPkeyUpdate>
  >;
};

/** Input for the nested mutation of `gdtAnalysisTableRow` in the `GdtAnalysisTableCellInput` mutation. */
export type GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInput = {
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectById?: InputMaybe<GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect>;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTableIdAndIndex?: InputMaybe<GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect>;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<GdtAnalysisTableRowGdtAnalysisTableRowTaskIdKeyConnect>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateById?: InputMaybe<GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTableIdAndIndex?: InputMaybe<GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowTaskIdKeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableCell` in the `GdtAnalysisTableRowInput` mutation. */
export type GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableCell` for the far side of the relationship. */
  connectByColumnIdAndRowId?: InputMaybe<
    Array<GdtAnalysisTableCellGdtAnalysisTableCellUniqueConnect>
  >;
  /** The primary key(s) for `gdtAnalysisTableCell` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<GdtAnalysisTableCellGdtAnalysisTableCellPkeyConnect>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableCell` for the far side of the relationship. */
  updateByColumnIdAndRowId?: InputMaybe<
    Array<GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableCell` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate>
  >;
};

/** Input for the nested mutation of `gdtAnalysisTable` in the `GdtAnalysisTableColumnGroupInput` mutation. */
export type GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInput = {
  /** The primary key(s) for `gdtAnalysisTable` for the far side of the relationship. */
  connectById?: InputMaybe<GdtAnalysisTableGdtAnalysisTablePkeyConnect>;
  /** The primary key(s) and patch data for `gdtAnalysisTable` for the far side of the relationship. */
  updateById?: InputMaybe<GdtAnalysisTableOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyUsingGdtAnalysisTablePkeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableColumnGroup` in the `GdtAnalysisTableInput` mutation. */
export type GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableColumnGroup` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<GdtAnalysisTableColumnGroupGdtAnalysisTableColumnGroupPkeyConnect>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableColumnGroup` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyUsingGdtAnalysisTableColumnGroupPkeyUpdate>
  >;
};

/** Input for the nested mutation of `gdtAnalysisTable` in the `GdtAnalysisTableColumnInput` mutation. */
export type GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInput = {
  /** The primary key(s) for `gdtAnalysisTable` for the far side of the relationship. */
  connectById?: InputMaybe<GdtAnalysisTableGdtAnalysisTablePkeyConnect>;
  /** The primary key(s) and patch data for `gdtAnalysisTable` for the far side of the relationship. */
  updateById?: InputMaybe<GdtAnalysisTableOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableColumn` in the `GdtAnalysisTableInput` mutation. */
export type GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableColumn` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<GdtAnalysisTableColumnGdtAnalysisTableColumnPkeyConnect>
  >;
  /** The primary key(s) for `gdtAnalysisTableColumn` for the far side of the relationship. */
  connectByTableIdAndOrder?: InputMaybe<
    Array<GdtAnalysisTableColumnGdtAnalysisTableColumnUniqueConnect>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableColumn` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableColumn` for the far side of the relationship. */
  updateByTableIdAndOrder?: InputMaybe<
    Array<GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate>
  >;
};

/** Input for the nested mutation of `gdtAnalysisTable` in the `GdtAnalysisTableCellInput` mutation. */
export type GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInput = {
  /** The primary key(s) for `gdtAnalysisTable` for the far side of the relationship. */
  connectById?: InputMaybe<GdtAnalysisTableGdtAnalysisTablePkeyConnect>;
  /** The primary key(s) and patch data for `gdtAnalysisTable` for the far side of the relationship. */
  updateById?: InputMaybe<GdtAnalysisTableOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableCell` in the `GdtAnalysisTableInput` mutation. */
export type GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableCell` for the far side of the relationship. */
  connectByColumnIdAndRowId?: InputMaybe<
    Array<GdtAnalysisTableCellGdtAnalysisTableCellUniqueConnect>
  >;
  /** The primary key(s) for `gdtAnalysisTableCell` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<GdtAnalysisTableCellGdtAnalysisTableCellPkeyConnect>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableCell` for the far side of the relationship. */
  updateByColumnIdAndRowId?: InputMaybe<
    Array<GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableCell` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate>
  >;
};

/** The `applicationUser` to be created by this mutation. */
export type GdtAnalysisTableCUserId75C939B7FkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `GdtAnalysisTableColumnInput` mutation. */
export type GdtAnalysisTableCUserId75C939B7FkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableColumn` in the `ApplicationUserInput` mutation. */
export type GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableColumn` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<GdtAnalysisTableColumnGdtAnalysisTableColumnPkeyConnect>
  >;
  /** The primary key(s) for `gdtAnalysisTableColumn` for the far side of the relationship. */
  connectByTableIdAndOrder?: InputMaybe<
    Array<GdtAnalysisTableColumnGdtAnalysisTableColumnUniqueConnect>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableColumn` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingGdtAnalysisTableColumnPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableColumn` for the far side of the relationship. */
  updateByTableIdAndOrder?: InputMaybe<
    Array<GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingGdtAnalysisTableColumnUniqueUpdate>
  >;
};

/** The `applicationUser` to be created by this mutation. */
export type GdtAnalysisTableCUserId8709Cf1FFkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `GdtAnalysisTableColumnGroupInput` mutation. */
export type GdtAnalysisTableCUserId8709Cf1FFkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableColumnGroup` in the `ApplicationUserInput` mutation. */
export type GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableColumnGroup` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<GdtAnalysisTableColumnGroupGdtAnalysisTableColumnGroupPkeyConnect>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableColumnGroup` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingGdtAnalysisTableColumnGroupPkeyUpdate>
  >;
};

export type GdtAnalysisTableCell = {
  __typename: "GdtAnalysisTableCell";
  columnId: Scalars["UUID"]["output"];
  formula: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `GdtAnalysisTable` that is related to this `GdtAnalysisTableCell`. */
  gdtAnalysisTableByTableId: Maybe<GdtAnalysisTable>;
  /** Reads a single `GdtAnalysisTableColumn` that is related to this `GdtAnalysisTableCell`. */
  gdtAnalysisTableColumnByColumnId: Maybe<GdtAnalysisTableColumn>;
  /** Reads a single `GdtAnalysisTableRow` that is related to this `GdtAnalysisTableCell`. */
  gdtAnalysisTableRowByRowId: Maybe<GdtAnalysisTableRow>;
  id: Scalars["UUID"]["output"];
  /** Reads a single `Project` that is related to this `GdtAnalysisTableCell`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  rowId: Scalars["UUID"]["output"];
  tableId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `GdtAnalysisTableCell` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GdtAnalysisTableCellCondition = {
  /** Checks for equality with the object’s `columnId` field. */
  columnId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `formula` field. */
  formula?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tableId` field. */
  tableId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `GdtAnalysisTableCell` object types. All fields are combined with a logical ‘and.’ */
export type GdtAnalysisTableCellFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GdtAnalysisTableCellFilter>>;
  /** Filter by the object’s `columnId` field. */
  columnId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `formula` field. */
  formula?: InputMaybe<StringFilter>;
  /** Filter by the object’s `gdtAnalysisTableByTableId` relation. */
  gdtAnalysisTableByTableId?: InputMaybe<GdtAnalysisTableFilter>;
  /** Filter by the object’s `gdtAnalysisTableColumnByColumnId` relation. */
  gdtAnalysisTableColumnByColumnId?: InputMaybe<GdtAnalysisTableColumnFilter>;
  /** Filter by the object’s `gdtAnalysisTableRowByRowId` relation. */
  gdtAnalysisTableRowByRowId?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GdtAnalysisTableCellFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GdtAnalysisTableCellFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tableId` field. */
  tableId?: InputMaybe<UuidFilter>;
};

/** The fields on `gdtAnalysisTableCell` to look up the row to connect. */
export type GdtAnalysisTableCellGdtAnalysisTableCellPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `gdtAnalysisTableCell` to look up the row to connect. */
export type GdtAnalysisTableCellGdtAnalysisTableCellUniqueConnect = {
  columnId: Scalars["UUID"]["input"];
  rowId: Scalars["UUID"]["input"];
};

/** The fields on `gdtAnalysisTableCell` to look up the row to update. */
export type GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableCell` being updated. */
    gdtAnalysisTableCellPatch: UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableCell` to look up the row to update. */
export type GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate =
  {
    columnId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `gdtAnalysisTableCell` being updated. */
    gdtAnalysisTableCellPatch: UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyPatch;
    rowId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableCell` to look up the row to update. */
export type GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableCell` being updated. */
    gdtAnalysisTableCellPatch: UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableCell` to look up the row to update. */
export type GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate =
  {
    columnId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `gdtAnalysisTableCell` being updated. */
    gdtAnalysisTableCellPatch: UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyPatch;
    rowId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableCell` to look up the row to update. */
export type GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableCell` being updated. */
    gdtAnalysisTableCellPatch: UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableCell` to look up the row to update. */
export type GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate =
  {
    columnId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `gdtAnalysisTableCell` being updated. */
    gdtAnalysisTableCellPatch: UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyPatch;
    rowId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableCell` to look up the row to update. */
export type GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingGdtAnalysisTableCellPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableCell` being updated. */
    gdtAnalysisTableCellPatch: UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableCell` to look up the row to update. */
export type GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingGdtAnalysisTableCellUniqueUpdate =
  {
    columnId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `gdtAnalysisTableCell` being updated. */
    gdtAnalysisTableCellPatch: UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdPatch;
    rowId: Scalars["UUID"]["input"];
  };

/** Input for the nested mutation of `project` in the `GdtAnalysisTableCellInput` mutation. */
export type GdtAnalysisTableCellProjectId57B70FedFkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableCell` in the `ProjectInput` mutation. */
export type GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableCell` for the far side of the relationship. */
  connectByColumnIdAndRowId?: InputMaybe<
    Array<GdtAnalysisTableCellGdtAnalysisTableCellUniqueConnect>
  >;
  /** The primary key(s) for `gdtAnalysisTableCell` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<GdtAnalysisTableCellGdtAnalysisTableCellPkeyConnect>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableCell` for the far side of the relationship. */
  updateByColumnIdAndRowId?: InputMaybe<
    Array<GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingGdtAnalysisTableCellUniqueUpdate>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableCell` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingGdtAnalysisTableCellPkeyUpdate>
  >;
};

/** A connection to a list of `GdtAnalysisTableCell` values. */
export type GdtAnalysisTableCellsConnection = {
  __typename: "GdtAnalysisTableCellsConnection";
  /** A list of edges which contains the `GdtAnalysisTableCell` and cursor to aid in pagination. */
  edges: Array<GdtAnalysisTableCellsEdge>;
  /** A list of `GdtAnalysisTableCell` objects. */
  nodes: Array<GdtAnalysisTableCell>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GdtAnalysisTableCell` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `GdtAnalysisTableCell` edge in the connection. */
export type GdtAnalysisTableCellsEdge = {
  __typename: "GdtAnalysisTableCellsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `GdtAnalysisTableCell` at the end of the edge. */
  node: GdtAnalysisTableCell;
};

/** Methods to use when ordering `GdtAnalysisTableCell`. */
export enum GdtAnalysisTableCellsOrderBy {
  ColumnIdAsc = "COLUMN_ID_ASC",
  ColumnIdDesc = "COLUMN_ID_DESC",
  FormulaAsc = "FORMULA_ASC",
  FormulaDesc = "FORMULA_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  RowIdAsc = "ROW_ID_ASC",
  RowIdDesc = "ROW_ID_DESC",
  TableIdAsc = "TABLE_ID_ASC",
  TableIdDesc = "TABLE_ID_DESC",
}

export type GdtAnalysisTableColumn = {
  __typename: "GdtAnalysisTableColumn";
  /** Reads a single `ApplicationUser` that is related to this `GdtAnalysisTableColumn`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  customDefaultFormula: Maybe<Scalars["String"]["output"]>;
  dateCreated: Scalars["Datetime"]["output"];
  dateDeleted: Maybe<Scalars["Datetime"]["output"]>;
  defaultFormula: Maybe<Scalars["String"]["output"]>;
  definitionId: Scalars["UUID"]["output"];
  definitionTypeId: Scalars["Int"]["output"];
  deletable: Scalars["Boolean"]["output"];
  /** Reads a single `DjangoContentType` that is related to this `GdtAnalysisTableColumn`. */
  djangoContentTypeByDefinitionTypeId: Maybe<DjangoContentType>;
  editable: Scalars["Boolean"]["output"];
  /** Reads a single `GdtAnalysisTable` that is related to this `GdtAnalysisTableColumn`. */
  gdtAnalysisTableByTableId: Maybe<GdtAnalysisTable>;
  /** Reads and enables pagination through a set of `GdtAnalysisTableCell`. */
  gdtAnalysisTableCellsByColumnId: GdtAnalysisTableCellsConnection;
  /** Reads a single `GdtAnalysisTableColumnGroup` that is related to this `GdtAnalysisTableColumn`. */
  gdtAnalysisTableColumnGroupByGroupId: Maybe<GdtAnalysisTableColumnGroup>;
  groupId: Maybe<Scalars["UUID"]["output"]>;
  helpText: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  identifierPosition: Maybe<Scalars["Int"]["output"]>;
  isIdColumn: Scalars["Boolean"]["output"];
  isResult: Scalars["Boolean"]["output"];
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  order: Maybe<Scalars["Int"]["output"]>;
  pinned: Scalars["Boolean"]["output"];
  /** Reads a single `Project` that is related to this `GdtAnalysisTableColumn`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  required: Scalars["Boolean"]["output"];
  tableId: Scalars["UUID"]["output"];
  userId: Scalars["UUID"]["output"];
  width: Scalars["Int"]["output"];
};

export type GdtAnalysisTableColumnGdtAnalysisTableCellsByColumnIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableCellCondition>;
  filter?: InputMaybe<GdtAnalysisTableCellFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableCellsOrderBy>>;
};

/**
 * A condition to be used against `GdtAnalysisTableColumn` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GdtAnalysisTableColumnCondition = {
  /** Checks for equality with the object’s `customDefaultFormula` field. */
  customDefaultFormula?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `defaultFormula` field. */
  defaultFormula?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `definitionId` field. */
  definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `definitionTypeId` field. */
  definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `deletable` field. */
  deletable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `editable` field. */
  editable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `helpText` field. */
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `identifierPosition` field. */
  identifierPosition?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `isIdColumn` field. */
  isIdColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `isResult` field. */
  isResult?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `pinned` field. */
  pinned?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `required` field. */
  required?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `tableId` field. */
  tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `width` field. */
  width?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `GdtAnalysisTableColumn` object types. All fields are combined with a logical ‘and.’ */
export type GdtAnalysisTableColumnFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GdtAnalysisTableColumnFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `customDefaultFormula` field. */
  customDefaultFormula?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defaultFormula` field. */
  defaultFormula?: InputMaybe<StringFilter>;
  /** Filter by the object’s `definitionId` field. */
  definitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `definitionTypeId` field. */
  definitionTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `deletable` field. */
  deletable?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `djangoContentTypeByDefinitionTypeId` relation. */
  djangoContentTypeByDefinitionTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** Filter by the object’s `editable` field. */
  editable?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `gdtAnalysisTableByTableId` relation. */
  gdtAnalysisTableByTableId?: InputMaybe<GdtAnalysisTableFilter>;
  /** Filter by the object’s `gdtAnalysisTableCellsByColumnId` relation. */
  gdtAnalysisTableCellsByColumnId?: InputMaybe<GdtAnalysisTableColumnToManyGdtAnalysisTableCellFilter>;
  /** Some related `gdtAnalysisTableCellsByColumnId` exist. */
  gdtAnalysisTableCellsByColumnIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `gdtAnalysisTableColumnGroupByGroupId` relation. */
  gdtAnalysisTableColumnGroupByGroupId?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
  /** A related `gdtAnalysisTableColumnGroupByGroupId` exists. */
  gdtAnalysisTableColumnGroupByGroupIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `helpText` field. */
  helpText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `identifierPosition` field. */
  identifierPosition?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isIdColumn` field. */
  isIdColumn?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isResult` field. */
  isResult?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GdtAnalysisTableColumnFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GdtAnalysisTableColumnFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `pinned` field. */
  pinned?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `required` field. */
  required?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `tableId` field. */
  tableId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `width` field. */
  width?: InputMaybe<IntFilter>;
};

/** The fields on `gdtAnalysisTableColumn` to look up the row to connect. */
export type GdtAnalysisTableColumnGdtAnalysisTableColumnPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `gdtAnalysisTableColumn` to look up the row to connect. */
export type GdtAnalysisTableColumnGdtAnalysisTableColumnUniqueConnect = {
  order: Scalars["Int"]["input"];
  tableId: Scalars["UUID"]["input"];
};

export type GdtAnalysisTableColumnGroup = {
  __typename: "GdtAnalysisTableColumnGroup";
  /** Reads a single `ApplicationUser` that is related to this `GdtAnalysisTableColumnGroup`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateDeleted: Maybe<Scalars["Datetime"]["output"]>;
  definitionId: Maybe<Scalars["UUID"]["output"]>;
  definitionTypeId: Maybe<Scalars["Int"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `GdtAnalysisTableColumnGroup`. */
  djangoContentTypeByDefinitionTypeId: Maybe<DjangoContentType>;
  /** Reads a single `GdtAnalysisTable` that is related to this `GdtAnalysisTableColumnGroup`. */
  gdtAnalysisTableByTableId: Maybe<GdtAnalysisTable>;
  /** Reads and enables pagination through a set of `GdtAnalysisTableColumn`. */
  gdtAnalysisTableColumnsByGroupId: GdtAnalysisTableColumnsConnection;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  /** Reads a single `Project` that is related to this `GdtAnalysisTableColumnGroup`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  tableId: Scalars["UUID"]["output"];
  userId: Scalars["UUID"]["output"];
};

export type GdtAnalysisTableColumnGroupGdtAnalysisTableColumnsByGroupIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableColumnCondition>;
  filter?: InputMaybe<GdtAnalysisTableColumnFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableColumnsOrderBy>>;
};

/**
 * A condition to be used against `GdtAnalysisTableColumnGroup` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type GdtAnalysisTableColumnGroupCondition = {
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `definitionId` field. */
  definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `definitionTypeId` field. */
  definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tableId` field. */
  tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `GdtAnalysisTableColumnGroup` object types. All fields are combined with a logical ‘and.’ */
export type GdtAnalysisTableColumnGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GdtAnalysisTableColumnGroupFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `definitionId` field. */
  definitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `definitionTypeId` field. */
  definitionTypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `djangoContentTypeByDefinitionTypeId` relation. */
  djangoContentTypeByDefinitionTypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** A related `djangoContentTypeByDefinitionTypeId` exists. */
  djangoContentTypeByDefinitionTypeIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `gdtAnalysisTableByTableId` relation. */
  gdtAnalysisTableByTableId?: InputMaybe<GdtAnalysisTableFilter>;
  /** Filter by the object’s `gdtAnalysisTableColumnsByGroupId` relation. */
  gdtAnalysisTableColumnsByGroupId?: InputMaybe<GdtAnalysisTableColumnGroupToManyGdtAnalysisTableColumnFilter>;
  /** Some related `gdtAnalysisTableColumnsByGroupId` exist. */
  gdtAnalysisTableColumnsByGroupIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GdtAnalysisTableColumnGroupFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tableId` field. */
  tableId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `gdtAnalysisTableColumnGroup` to look up the row to connect. */
export type GdtAnalysisTableColumnGroupGdtAnalysisTableColumnGroupPkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableColumnGroup` to look up the row to update. */
export type GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableColumnGroup` being updated. */
    gdtAnalysisTableColumnGroupPatch: UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableColumnGroup` to look up the row to update. */
export type GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingGdtAnalysisTableColumnGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableColumnGroup` being updated. */
    gdtAnalysisTableColumnGroupPatch: UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableColumnGroup` to look up the row to update. */
export type GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingGdtAnalysisTableColumnGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableColumnGroup` being updated. */
    gdtAnalysisTableColumnGroupPatch: UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableColumnGroup` to look up the row to update. */
export type GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyUsingGdtAnalysisTableColumnGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableColumnGroup` being updated. */
    gdtAnalysisTableColumnGroupPatch: UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableColumnGroup` to look up the row to update. */
export type GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingGdtAnalysisTableColumnGroupPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableColumnGroup` being updated. */
    gdtAnalysisTableColumnGroupPatch: UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** A filter to be used against many `GdtAnalysisTableColumn` object types. All fields are combined with a logical ‘and.’ */
export type GdtAnalysisTableColumnGroupToManyGdtAnalysisTableColumnFilter = {
  /** Every related `GdtAnalysisTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableColumnFilter>;
  /** No related `GdtAnalysisTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableColumnFilter>;
  /** Some related `GdtAnalysisTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableColumnFilter>;
};

/** A connection to a list of `GdtAnalysisTableColumnGroup` values. */
export type GdtAnalysisTableColumnGroupsConnection = {
  __typename: "GdtAnalysisTableColumnGroupsConnection";
  /** A list of edges which contains the `GdtAnalysisTableColumnGroup` and cursor to aid in pagination. */
  edges: Array<GdtAnalysisTableColumnGroupsEdge>;
  /** A list of `GdtAnalysisTableColumnGroup` objects. */
  nodes: Array<GdtAnalysisTableColumnGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GdtAnalysisTableColumnGroup` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `GdtAnalysisTableColumnGroup` edge in the connection. */
export type GdtAnalysisTableColumnGroupsEdge = {
  __typename: "GdtAnalysisTableColumnGroupsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `GdtAnalysisTableColumnGroup` at the end of the edge. */
  node: GdtAnalysisTableColumnGroup;
};

/** Methods to use when ordering `GdtAnalysisTableColumnGroup`. */
export enum GdtAnalysisTableColumnGroupsOrderBy {
  DateDeletedAsc = "DATE_DELETED_ASC",
  DateDeletedDesc = "DATE_DELETED_DESC",
  DefinitionIdAsc = "DEFINITION_ID_ASC",
  DefinitionIdDesc = "DEFINITION_ID_DESC",
  DefinitionTypeIdAsc = "DEFINITION_TYPE_ID_ASC",
  DefinitionTypeIdDesc = "DEFINITION_TYPE_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  TableIdAsc = "TABLE_ID_ASC",
  TableIdDesc = "TABLE_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** The fields on `gdtAnalysisTableColumn` to look up the row to update. */
export type GdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
    gdtAnalysisTableColumnPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableColumn` to look up the row to update. */
export type GdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
    gdtAnalysisTableColumnPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyPatch;
    order: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableColumn` to look up the row to update. */
export type GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingGdtAnalysisTableColumnPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
    gdtAnalysisTableColumnPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableColumn` to look up the row to update. */
export type GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingGdtAnalysisTableColumnUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
    gdtAnalysisTableColumnPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoPatch;
    order: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableColumn` to look up the row to update. */
export type GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
    gdtAnalysisTableColumnPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableColumn` to look up the row to update. */
export type GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
    gdtAnalysisTableColumnPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyPatch;
    order: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableColumn` to look up the row to update. */
export type GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
    gdtAnalysisTableColumnPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableColumn` to look up the row to update. */
export type GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
    gdtAnalysisTableColumnPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyPatch;
    order: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableColumn` to look up the row to update. */
export type GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingGdtAnalysisTableColumnPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
    gdtAnalysisTableColumnPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableColumn` to look up the row to update. */
export type GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingGdtAnalysisTableColumnUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
    gdtAnalysisTableColumnPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiPatch;
    order: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableColumn` to look up the row to update. */
export type GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingGdtAnalysisTableColumnPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
    gdtAnalysisTableColumnPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableColumn` to look up the row to update. */
export type GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingGdtAnalysisTableColumnUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
    gdtAnalysisTableColumnPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdPatch;
    order: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** Input for the nested mutation of `project` in the `GdtAnalysisTableColumnInput` mutation. */
export type GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableColumn` in the `ProjectInput` mutation. */
export type GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableColumn` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<GdtAnalysisTableColumnGdtAnalysisTableColumnPkeyConnect>
  >;
  /** The primary key(s) for `gdtAnalysisTableColumn` for the far side of the relationship. */
  connectByTableIdAndOrder?: InputMaybe<
    Array<GdtAnalysisTableColumnGdtAnalysisTableColumnUniqueConnect>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableColumn` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingGdtAnalysisTableColumnPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableColumn` for the far side of the relationship. */
  updateByTableIdAndOrder?: InputMaybe<
    Array<GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingGdtAnalysisTableColumnUniqueUpdate>
  >;
};

/** A filter to be used against many `GdtAnalysisTableCell` object types. All fields are combined with a logical ‘and.’ */
export type GdtAnalysisTableColumnToManyGdtAnalysisTableCellFilter = {
  /** Every related `GdtAnalysisTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableCellFilter>;
  /** No related `GdtAnalysisTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableCellFilter>;
  /** Some related `GdtAnalysisTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableCellFilter>;
};

/** A connection to a list of `GdtAnalysisTableColumn` values. */
export type GdtAnalysisTableColumnsConnection = {
  __typename: "GdtAnalysisTableColumnsConnection";
  /** A list of edges which contains the `GdtAnalysisTableColumn` and cursor to aid in pagination. */
  edges: Array<GdtAnalysisTableColumnsEdge>;
  /** A list of `GdtAnalysisTableColumn` objects. */
  nodes: Array<GdtAnalysisTableColumn>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GdtAnalysisTableColumn` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `GdtAnalysisTableColumn` edge in the connection. */
export type GdtAnalysisTableColumnsEdge = {
  __typename: "GdtAnalysisTableColumnsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `GdtAnalysisTableColumn` at the end of the edge. */
  node: GdtAnalysisTableColumn;
};

/** Methods to use when ordering `GdtAnalysisTableColumn`. */
export enum GdtAnalysisTableColumnsOrderBy {
  CustomDefaultFormulaAsc = "CUSTOM_DEFAULT_FORMULA_ASC",
  CustomDefaultFormulaDesc = "CUSTOM_DEFAULT_FORMULA_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DateDeletedAsc = "DATE_DELETED_ASC",
  DateDeletedDesc = "DATE_DELETED_DESC",
  DefaultFormulaAsc = "DEFAULT_FORMULA_ASC",
  DefaultFormulaDesc = "DEFAULT_FORMULA_DESC",
  DefinitionIdAsc = "DEFINITION_ID_ASC",
  DefinitionIdDesc = "DEFINITION_ID_DESC",
  DefinitionTypeIdAsc = "DEFINITION_TYPE_ID_ASC",
  DefinitionTypeIdDesc = "DEFINITION_TYPE_ID_DESC",
  DeletableAsc = "DELETABLE_ASC",
  DeletableDesc = "DELETABLE_DESC",
  EditableAsc = "EDITABLE_ASC",
  EditableDesc = "EDITABLE_DESC",
  GroupIdAsc = "GROUP_ID_ASC",
  GroupIdDesc = "GROUP_ID_DESC",
  HelpTextAsc = "HELP_TEXT_ASC",
  HelpTextDesc = "HELP_TEXT_DESC",
  IdentifierPositionAsc = "IDENTIFIER_POSITION_ASC",
  IdentifierPositionDesc = "IDENTIFIER_POSITION_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  IsIdColumnAsc = "IS_ID_COLUMN_ASC",
  IsIdColumnDesc = "IS_ID_COLUMN_DESC",
  IsResultAsc = "IS_RESULT_ASC",
  IsResultDesc = "IS_RESULT_DESC",
  KeyAsc = "KEY_ASC",
  KeyDesc = "KEY_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  OrderAsc = "ORDER_ASC",
  OrderDesc = "ORDER_DESC",
  PinnedAsc = "PINNED_ASC",
  PinnedDesc = "PINNED_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  RequiredAsc = "REQUIRED_ASC",
  RequiredDesc = "REQUIRED_DESC",
  TableIdAsc = "TABLE_ID_ASC",
  TableIdDesc = "TABLE_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
  WidthAsc = "WIDTH_ASC",
  WidthDesc = "WIDTH_DESC",
}

/**
 * A condition to be used against `GdtAnalysisTable` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GdtAnalysisTableCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `folderId` field. */
  folderId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `hidden` field. */
  hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `GdtAnalysisTable` object types. All fields are combined with a logical ‘and.’ */
export type GdtAnalysisTableFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GdtAnalysisTableFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `folderId` field. */
  folderId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `gdtAnalysisTableCellsByTableId` relation. */
  gdtAnalysisTableCellsByTableId?: InputMaybe<GdtAnalysisTableToManyGdtAnalysisTableCellFilter>;
  /** Some related `gdtAnalysisTableCellsByTableId` exist. */
  gdtAnalysisTableCellsByTableIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `gdtAnalysisTableColumnGroupsByTableId` relation. */
  gdtAnalysisTableColumnGroupsByTableId?: InputMaybe<GdtAnalysisTableToManyGdtAnalysisTableColumnGroupFilter>;
  /** Some related `gdtAnalysisTableColumnGroupsByTableId` exist. */
  gdtAnalysisTableColumnGroupsByTableIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `gdtAnalysisTableColumnsByTableId` relation. */
  gdtAnalysisTableColumnsByTableId?: InputMaybe<GdtAnalysisTableToManyGdtAnalysisTableColumnFilter>;
  /** Some related `gdtAnalysisTableColumnsByTableId` exist. */
  gdtAnalysisTableColumnsByTableIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `gdtAnalysisTableRowsByTableId` relation. */
  gdtAnalysisTableRowsByTableId?: InputMaybe<GdtAnalysisTableToManyGdtAnalysisTableRowFilter>;
  /** Some related `gdtAnalysisTableRowsByTableId` exist. */
  gdtAnalysisTableRowsByTableIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `hidden` field. */
  hidden?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GdtAnalysisTableFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GdtAnalysisTableFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectFolderByFolderId` relation. */
  projectFolderByFolderId?: InputMaybe<ProjectFolderFilter>;
  /** A related `projectFolderByFolderId` exists. */
  projectFolderByFolderIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `toolVersionByToolVersionId` relation. */
  toolVersionByToolVersionId?: InputMaybe<ToolVersionFilter>;
  /** Filter by the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** Input for the nested mutation of `projectFolder` in the `GdtAnalysisTableInput` mutation. */
export type GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput = {
  /** The primary key(s) for `projectFolder` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectFolderProjectFolderPkeyConnect>;
  /** A `ProjectFolderInput` object that will be created and connected to this object. */
  create?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdProjectFolderCreateInput>;
  /** The primary key(s) for `projectFolder` for the far side of the relationship. */
  deleteById?: InputMaybe<ProjectFolderProjectFolderPkeyDelete>;
  /** The primary key(s) and patch data for `projectFolder` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingProjectFolderPkeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTable` in the `ProjectFolderInput` mutation. */
export type GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput = {
  /** The primary key(s) for `gdtAnalysisTable` for the far side of the relationship. */
  connectById?: InputMaybe<Array<GdtAnalysisTableGdtAnalysisTablePkeyConnect>>;
  /** The primary key(s) and patch data for `gdtAnalysisTable` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingGdtAnalysisTablePkeyUpdate>
  >;
};

/** The `projectFolder` to be created by this mutation. */
export type GdtAnalysisTableFolderId6A997B49FkProjectFolderIdProjectFolderCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInput>;
    color?: InputMaybe<Scalars["String"]["input"]>;
    dataTablesUsingId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput>;
    id: Scalars["UUID"]["input"];
    name: Scalars["String"]["input"];
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** The fields on `gdtAnalysisTable` to look up the row to connect. */
export type GdtAnalysisTableGdtAnalysisTablePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `gdtAnalysisTable` to look up the row to update. */
export type GdtAnalysisTableOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
    gdtAnalysisTablePatch: UpdateGdtAnalysisTableOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTable` to look up the row to update. */
export type GdtAnalysisTableOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
    gdtAnalysisTablePatch: UpdateGdtAnalysisTableOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTable` to look up the row to update. */
export type GdtAnalysisTableOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyUsingGdtAnalysisTablePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
    gdtAnalysisTablePatch: UpdateGdtAnalysisTableOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTable` to look up the row to update. */
export type GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingGdtAnalysisTablePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
    gdtAnalysisTablePatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTable` to look up the row to update. */
export type GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingGdtAnalysisTablePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
    gdtAnalysisTablePatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTable` to look up the row to update. */
export type GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingGdtAnalysisTablePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
    gdtAnalysisTablePatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTable` to look up the row to update. */
export type GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingGdtAnalysisTablePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
    gdtAnalysisTablePatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTable` to look up the row to update. */
export type GdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
    gdtAnalysisTablePatch: UpdateGdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch;
    id: Scalars["UUID"]["input"];
  };

/** Input for the nested mutation of `project` in the `GdtAnalysisTableInput` mutation. */
export type GdtAnalysisTableProjectId544B76D9FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTable` in the `ProjectInput` mutation. */
export type GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput = {
  /** The primary key(s) for `gdtAnalysisTable` for the far side of the relationship. */
  connectById?: InputMaybe<Array<GdtAnalysisTableGdtAnalysisTablePkeyConnect>>;
  /** The primary key(s) and patch data for `gdtAnalysisTable` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingGdtAnalysisTablePkeyUpdate>
  >;
};

/** Input for the nested mutation of `gdtAnalysisTable` in the `GdtAnalysisTableRowInput` mutation. */
export type GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput = {
  /** The primary key(s) for `gdtAnalysisTable` for the far side of the relationship. */
  connectById?: InputMaybe<GdtAnalysisTableGdtAnalysisTablePkeyConnect>;
  /** The primary key(s) and patch data for `gdtAnalysisTable` for the far side of the relationship. */
  updateById?: InputMaybe<GdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableRow` in the `GdtAnalysisTableInput` mutation. */
export type GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect>
  >;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTableIdAndIndex?: InputMaybe<
    Array<GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect>
  >;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<
    Array<GdtAnalysisTableRowGdtAnalysisTableRowTaskIdKeyConnect>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTableIdAndIndex?: InputMaybe<
    Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<
    Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowTaskIdKeyUpdate>
  >;
};

/** Input for the nested mutation of `toolVersion` in the `GdtAnalysisTableRowInput` mutation. */
export type GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<ToolVersionToolVersionPkeyConnect>;
  /** A `ToolVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersToolVersionCreateInput>;
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<ToolVersionToolVersionPkeyDelete>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<ToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingToolVersionPkeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableRow` in the `ToolVersionInput` mutation. */
export type GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect>
  >;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTableIdAndIndex?: InputMaybe<
    Array<GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect>
  >;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<
    Array<GdtAnalysisTableRowGdtAnalysisTableRowTaskIdKeyConnect>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTableIdAndIndex?: InputMaybe<
    Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowUniqueUpdate>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<
    Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowTaskIdKeyUpdate>
  >;
};

/** The `toolVersion` to be created by this mutation. */
export type GdtAnalysisTableRToolVersionId0050D5BdFkToolVersToolVersionCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible: Scalars["Boolean"]["input"];
    isUpgradableToNextVersion: Scalars["Boolean"]["input"];
    maturity: Scalars["Int"]["input"];
    status: Scalars["Int"]["input"];
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion: Scalars["Int"]["input"];
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version: Scalars["String"]["input"];
    visibility: Scalars["Int"]["input"];
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

export type GdtAnalysisTableRow = {
  __typename: "GdtAnalysisTableRow";
  /** Reads a single `ApplicationUser` that is related to this `GdtAnalysisTableRow`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateCreated: Scalars["Datetime"]["output"];
  dateDeleted: Maybe<Scalars["Datetime"]["output"]>;
  editable: Scalars["Boolean"]["output"];
  /** Reads a single `GdtAnalysisTable` that is related to this `GdtAnalysisTableRow`. */
  gdtAnalysisTableByTableId: Maybe<GdtAnalysisTable>;
  /** Reads and enables pagination through a set of `GdtAnalysisTableCell`. */
  gdtAnalysisTableCellsByRowId: GdtAnalysisTableCellsConnection;
  id: Scalars["UUID"]["output"];
  index: Scalars["Int"]["output"];
  joinable: Scalars["Boolean"]["output"];
  /** Reads a single `Project` that is related to this `GdtAnalysisTableRow`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  resourceTier: Maybe<Scalars["Int"]["output"]>;
  tableId: Scalars["UUID"]["output"];
  /** Reads a single `Task` that is related to this `GdtAnalysisTableRow`. */
  taskByTaskId: Maybe<Task>;
  taskId: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `ToolVersion` that is related to this `GdtAnalysisTableRow`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
  toolVersionId: Maybe<Scalars["Int"]["output"]>;
  userId: Scalars["UUID"]["output"];
};

export type GdtAnalysisTableRowGdtAnalysisTableCellsByRowIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableCellCondition>;
  filter?: InputMaybe<GdtAnalysisTableCellFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableCellsOrderBy>>;
};

/**
 * A condition to be used against `GdtAnalysisTableRow` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GdtAnalysisTableRowCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `editable` field. */
  editable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `index` field. */
  index?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `joinable` field. */
  joinable?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `resourceTier` field. */
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `tableId` field. */
  tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `GdtAnalysisTableRow` object types. All fields are combined with a logical ‘and.’ */
export type GdtAnalysisTableRowFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GdtAnalysisTableRowFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `editable` field. */
  editable?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `gdtAnalysisTableByTableId` relation. */
  gdtAnalysisTableByTableId?: InputMaybe<GdtAnalysisTableFilter>;
  /** Filter by the object’s `gdtAnalysisTableCellsByRowId` relation. */
  gdtAnalysisTableCellsByRowId?: InputMaybe<GdtAnalysisTableRowToManyGdtAnalysisTableCellFilter>;
  /** Some related `gdtAnalysisTableCellsByRowId` exist. */
  gdtAnalysisTableCellsByRowIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `index` field. */
  index?: InputMaybe<IntFilter>;
  /** Filter by the object’s `joinable` field. */
  joinable?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GdtAnalysisTableRowFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `resourceTier` field. */
  resourceTier?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tableId` field. */
  tableId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `taskByTaskId` relation. */
  taskByTaskId?: InputMaybe<TaskFilter>;
  /** A related `taskByTaskId` exists. */
  taskByTaskIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `toolVersionByToolVersionId` relation. */
  toolVersionByToolVersionId?: InputMaybe<ToolVersionFilter>;
  /** A related `toolVersionByToolVersionId` exists. */
  toolVersionByToolVersionIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `gdtAnalysisTableRow` to look up the row to connect. */
export type GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to connect. */
export type GdtAnalysisTableRowGdtAnalysisTableRowTaskIdKeyConnect = {
  taskId: Scalars["UUID"]["input"];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to connect. */
export type GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect = {
  index: Scalars["Int"]["input"];
  tableId: Scalars["UUID"]["input"];
};

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowTaskIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyPatch;
    taskId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyPatch;
    index: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowTaskIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch;
    taskId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch;
    index: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowTaskIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch;
    taskId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch;
    index: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowTaskIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
    taskId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
    index: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowTaskIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
    taskId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
    index: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
    id: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowTaskIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
    taskId: Scalars["UUID"]["input"];
  };

/** The fields on `gdtAnalysisTableRow` to look up the row to update. */
export type GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
    gdtAnalysisTableRowPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
    index: Scalars["Int"]["input"];
    tableId: Scalars["UUID"]["input"];
  };

/** Input for the nested mutation of `project` in the `GdtAnalysisTableRowInput` mutation. */
export type GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableRow` in the `ProjectInput` mutation. */
export type GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect>
  >;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTableIdAndIndex?: InputMaybe<
    Array<GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect>
  >;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<
    Array<GdtAnalysisTableRowGdtAnalysisTableRowTaskIdKeyConnect>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTableIdAndIndex?: InputMaybe<
    Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowUniqueUpdate>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<
    Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowTaskIdKeyUpdate>
  >;
};

/** Input for the nested mutation of `task` in the `GdtAnalysisTableRowInput` mutation. */
export type GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdTaskCreateInput>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyDelete>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteById?: InputMaybe<TaskTaskPkeyDelete>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableRow` in the `TaskInput` mutation. */
export type GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectById?: InputMaybe<GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect>;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTableIdAndIndex?: InputMaybe<GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect>;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<GdtAnalysisTableRowGdtAnalysisTableRowTaskIdKeyConnect>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateById?: InputMaybe<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowPkeyUpdate>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTableIdAndIndex?: InputMaybe<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowUniqueUpdate>;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowTaskIdKeyUpdate>;
};

/** The `task` to be created by this mutation. */
export type GdtAnalysisTableRowTaskId14Ab233FFkTaskIdTaskCreateInput = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned: Scalars["Boolean"]["input"];
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id: Scalars["UUID"]["input"];
  inputsHash: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against many `GdtAnalysisTableCell` object types. All fields are combined with a logical ‘and.’ */
export type GdtAnalysisTableRowToManyGdtAnalysisTableCellFilter = {
  /** Every related `GdtAnalysisTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableCellFilter>;
  /** No related `GdtAnalysisTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableCellFilter>;
  /** Some related `GdtAnalysisTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableCellFilter>;
};

/** The `applicationUser` to be created by this mutation. */
export type GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `GdtAnalysisTableRowInput` mutation. */
export type GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTableRow` in the `ApplicationUserInput` mutation. */
export type GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect>
  >;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTableIdAndIndex?: InputMaybe<
    Array<GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect>
  >;
  /** The primary key(s) for `gdtAnalysisTableRow` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<
    Array<GdtAnalysisTableRowGdtAnalysisTableRowTaskIdKeyConnect>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTableIdAndIndex?: InputMaybe<
    Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowUniqueUpdate>
  >;
  /** The primary key(s) and patch data for `gdtAnalysisTableRow` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<
    Array<GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowTaskIdKeyUpdate>
  >;
};

/** A connection to a list of `GdtAnalysisTableRow` values. */
export type GdtAnalysisTableRowsConnection = {
  __typename: "GdtAnalysisTableRowsConnection";
  /** A list of edges which contains the `GdtAnalysisTableRow` and cursor to aid in pagination. */
  edges: Array<GdtAnalysisTableRowsEdge>;
  /** A list of `GdtAnalysisTableRow` objects. */
  nodes: Array<GdtAnalysisTableRow>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GdtAnalysisTableRow` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `GdtAnalysisTableRow` edge in the connection. */
export type GdtAnalysisTableRowsEdge = {
  __typename: "GdtAnalysisTableRowsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `GdtAnalysisTableRow` at the end of the edge. */
  node: GdtAnalysisTableRow;
};

/** Methods to use when ordering `GdtAnalysisTableRow`. */
export enum GdtAnalysisTableRowsOrderBy {
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DateDeletedAsc = "DATE_DELETED_ASC",
  DateDeletedDesc = "DATE_DELETED_DESC",
  EditableAsc = "EDITABLE_ASC",
  EditableDesc = "EDITABLE_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  IndexAsc = "INDEX_ASC",
  IndexDesc = "INDEX_DESC",
  JoinableAsc = "JOINABLE_ASC",
  JoinableDesc = "JOINABLE_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  ResourceTierAsc = "RESOURCE_TIER_ASC",
  ResourceTierDesc = "RESOURCE_TIER_DESC",
  TableIdAsc = "TABLE_ID_ASC",
  TableIdDesc = "TABLE_ID_DESC",
  TaskIdAsc = "TASK_ID_ASC",
  TaskIdDesc = "TASK_ID_DESC",
  ToolVersionIdAsc = "TOOL_VERSION_ID_ASC",
  ToolVersionIdDesc = "TOOL_VERSION_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** A filter to be used against many `GdtAnalysisTableCell` object types. All fields are combined with a logical ‘and.’ */
export type GdtAnalysisTableToManyGdtAnalysisTableCellFilter = {
  /** Every related `GdtAnalysisTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableCellFilter>;
  /** No related `GdtAnalysisTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableCellFilter>;
  /** Some related `GdtAnalysisTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableCellFilter>;
};

/** A filter to be used against many `GdtAnalysisTableColumn` object types. All fields are combined with a logical ‘and.’ */
export type GdtAnalysisTableToManyGdtAnalysisTableColumnFilter = {
  /** Every related `GdtAnalysisTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableColumnFilter>;
  /** No related `GdtAnalysisTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableColumnFilter>;
  /** Some related `GdtAnalysisTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableColumnFilter>;
};

/** A filter to be used against many `GdtAnalysisTableColumnGroup` object types. All fields are combined with a logical ‘and.’ */
export type GdtAnalysisTableToManyGdtAnalysisTableColumnGroupFilter = {
  /** Every related `GdtAnalysisTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
  /** No related `GdtAnalysisTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
  /** Some related `GdtAnalysisTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
};

/** A filter to be used against many `GdtAnalysisTableRow` object types. All fields are combined with a logical ‘and.’ */
export type GdtAnalysisTableToManyGdtAnalysisTableRowFilter = {
  /** Every related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** No related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** Some related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableRowFilter>;
};

/** Input for the nested mutation of `toolVersion` in the `GdtAnalysisTableInput` mutation. */
export type GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<ToolVersionToolVersionPkeyConnect>;
  /** A `ToolVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdToolVersionCreateInput>;
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<ToolVersionToolVersionPkeyDelete>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<ToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingToolVersionPkeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTable` in the `ToolVersionInput` mutation. */
export type GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput = {
  /** The primary key(s) for `gdtAnalysisTable` for the far side of the relationship. */
  connectById?: InputMaybe<Array<GdtAnalysisTableGdtAnalysisTablePkeyConnect>>;
  /** The primary key(s) and patch data for `gdtAnalysisTable` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingGdtAnalysisTablePkeyUpdate>
  >;
};

/** The `toolVersion` to be created by this mutation. */
export type GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdToolVersionCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible: Scalars["Boolean"]["input"];
    isUpgradableToNextVersion: Scalars["Boolean"]["input"];
    maturity: Scalars["Int"]["input"];
    status: Scalars["Int"]["input"];
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion: Scalars["Int"]["input"];
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version: Scalars["String"]["input"];
    visibility: Scalars["Int"]["input"];
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** The `applicationUser` to be created by this mutation. */
export type GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `GdtAnalysisTableInput` mutation. */
export type GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `gdtAnalysisTable` in the `ApplicationUserInput` mutation. */
export type GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `gdtAnalysisTable` for the far side of the relationship. */
  connectById?: InputMaybe<Array<GdtAnalysisTableGdtAnalysisTablePkeyConnect>>;
  /** The primary key(s) and patch data for `gdtAnalysisTable` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingGdtAnalysisTablePkeyUpdate>
  >;
};

/** A connection to a list of `GdtAnalysisTable` values. */
export type GdtAnalysisTablesConnection = {
  __typename: "GdtAnalysisTablesConnection";
  /** A list of edges which contains the `GdtAnalysisTable` and cursor to aid in pagination. */
  edges: Array<GdtAnalysisTablesEdge>;
  /** A list of `GdtAnalysisTable` objects. */
  nodes: Array<GdtAnalysisTable>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GdtAnalysisTable` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `GdtAnalysisTable` edge in the connection. */
export type GdtAnalysisTablesEdge = {
  __typename: "GdtAnalysisTablesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `GdtAnalysisTable` at the end of the edge. */
  node: GdtAnalysisTable;
};

/** Methods to use when ordering `GdtAnalysisTable`. */
export enum GdtAnalysisTablesOrderBy {
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DateDeletedAsc = "DATE_DELETED_ASC",
  DateDeletedDesc = "DATE_DELETED_DESC",
  DescriptionAsc = "DESCRIPTION_ASC",
  DescriptionDesc = "DESCRIPTION_DESC",
  FolderIdAsc = "FOLDER_ID_ASC",
  FolderIdDesc = "FOLDER_ID_DESC",
  HiddenAsc = "HIDDEN_ASC",
  HiddenDesc = "HIDDEN_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  KeyAsc = "KEY_ASC",
  KeyDesc = "KEY_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  ToolVersionIdAsc = "TOOL_VERSION_ID_ASC",
  ToolVersionIdDesc = "TOOL_VERSION_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["Int"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["Int"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["Int"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["Int"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["Int"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["Int"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["Int"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["Int"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

/** A filter to be used against InternetAddress fields. All fields are combined with a logical ‘and.’ */
export type InternetAddressFilter = {
  /** Contained by the specified internet address. */
  containedBy?: InputMaybe<Scalars["InternetAddress"]["input"]>;
  /** Contained by or equal to the specified internet address. */
  containedByOrEqualTo?: InputMaybe<Scalars["InternetAddress"]["input"]>;
  /** Contains the specified internet address. */
  contains?: InputMaybe<Scalars["InternetAddress"]["input"]>;
  /** Contains or contained by the specified internet address. */
  containsOrContainedBy?: InputMaybe<Scalars["InternetAddress"]["input"]>;
  /** Contains or equal to the specified internet address. */
  containsOrEqualTo?: InputMaybe<Scalars["InternetAddress"]["input"]>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["InternetAddress"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["InternetAddress"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["InternetAddress"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["InternetAddress"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["InternetAddress"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["InternetAddress"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["InternetAddress"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["InternetAddress"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["InternetAddress"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["InternetAddress"]["input"]>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type Interval = {
  __typename: "Interval";
  /** A quantity of days. */
  days: Maybe<Scalars["Int"]["output"]>;
  /** A quantity of hours. */
  hours: Maybe<Scalars["Int"]["output"]>;
  /** A quantity of minutes. */
  minutes: Maybe<Scalars["Int"]["output"]>;
  /** A quantity of months. */
  months: Maybe<Scalars["Int"]["output"]>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds: Maybe<Scalars["Float"]["output"]>;
  /** A quantity of years. */
  years: Maybe<Scalars["Int"]["output"]>;
};

/** A filter to be used against Interval fields. All fields are combined with a logical ‘and.’ */
export type IntervalFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IntervalInput>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IntervalInput>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IntervalInput>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IntervalInput>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IntervalInput>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IntervalInput>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IntervalInput>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IntervalInput>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type IntervalInput = {
  /** A quantity of days. */
  days?: InputMaybe<Scalars["Int"]["input"]>;
  /** A quantity of hours. */
  hours?: InputMaybe<Scalars["Int"]["input"]>;
  /** A quantity of minutes. */
  minutes?: InputMaybe<Scalars["Int"]["input"]>;
  /** A quantity of months. */
  months?: InputMaybe<Scalars["Int"]["input"]>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: InputMaybe<Scalars["Float"]["input"]>;
  /** A quantity of years. */
  years?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars["String"]["input"]>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["JSON"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["JSON"]["input"]>>;
};

/** A connection to a list of `Metadatum` values. */
export type MetadataConnection = {
  __typename: "MetadataConnection";
  /** A list of edges which contains the `Metadatum` and cursor to aid in pagination. */
  edges: Array<MetadataEdge>;
  /** A list of `Metadatum` objects. */
  nodes: Array<Metadatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Metadatum` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `Metadatum` edge in the connection. */
export type MetadataEdge = {
  __typename: "MetadataEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `Metadatum` at the end of the edge. */
  node: Metadatum;
};

/** Methods to use when ordering `Metadatum`. */
export enum MetadataOrderBy {
  DisplayNameAsc = "DISPLAY_NAME_ASC",
  DisplayNameDesc = "DISPLAY_NAME_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  KeyAsc = "KEY_ASC",
  KeyDesc = "KEY_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
}

/** Input for the nested mutation of `project` in the `MetadatumInput` mutation. */
export type MetadataProjectId3333C2AdFkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `metadatum` in the `ProjectInput` mutation. */
export type MetadataProjectId3333C2AdFkProjectIdInverseInput = {
  /** The primary key(s) for `metadatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MetadatumMetadataPkeyConnect>>;
  /** A `MetadatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<MetadataProjectId3333C2AdFkProjectIdMetadataCreateInput>
  >;
  /** The primary key(s) for `metadatum` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<MetadatumMetadataPkeyDelete>>;
  /** Flag indicating whether all other `metadatum` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `metadatum` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<MetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingMetadataPkeyUpdate>
  >;
};

/** The `metadatum` to be created by this mutation. */
export type MetadataProjectId3333C2AdFkProjectIdMetadataCreateInput = {
  displayName: Scalars["String"]["input"];
  fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
  id: Scalars["UUID"]["input"];
  key: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
  projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
};

/** Input for the nested mutation of `tenant` in the `MetadatumInput` mutation. */
export type MetadataTenantIdC1D8772DFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `metadatum` in the `TenantInput` mutation. */
export type MetadataTenantIdC1D8772DFkTenantIdInverseInput = {
  /** The primary key(s) for `metadatum` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MetadatumMetadataPkeyConnect>>;
  /** A `MetadatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<MetadataTenantIdC1D8772DFkTenantIdMetadataCreateInput>
  >;
  /** The primary key(s) for `metadatum` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<MetadatumMetadataPkeyDelete>>;
  /** Flag indicating whether all other `metadatum` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `metadatum` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<MetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingMetadataPkeyUpdate>
  >;
};

/** The `metadatum` to be created by this mutation. */
export type MetadataTenantIdC1D8772DFkTenantIdMetadataCreateInput = {
  displayName: Scalars["String"]["input"];
  fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
  id: Scalars["UUID"]["input"];
  key: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
  tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
};

/** The `tenant` to be created by this mutation. */
export type MetadataTenantIdC1D8772DFkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

export type MetadataValue = {
  __typename: "MetadataValue";
  /** Reads a single `ApplicationUser` that is related to this `MetadataValue`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateCreated: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  metadataId: Scalars["UUID"]["output"];
  /** Reads a single `Metadatum` that is related to this `MetadataValue`. */
  metadatumByMetadataId: Maybe<Metadatum>;
  /** Reads a single `Project` that is related to this `MetadataValue`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  /** Reads a single `Task` that is related to this `MetadataValue`. */
  taskByTaskId: Maybe<Task>;
  taskId: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `Tenant` that is related to this `MetadataValue`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
  userId: Maybe<Scalars["UUID"]["output"]>;
  value: Maybe<Scalars["JSON"]["output"]>;
};

/**
 * A condition to be used against `MetadataValue` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MetadataValueCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `metadataId` field. */
  metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars["JSON"]["input"]>;
};

/** A filter to be used against `MetadataValue` object types. All fields are combined with a logical ‘and.’ */
export type MetadataValueFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MetadataValueFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `metadataId` field. */
  metadataId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `metadatumByMetadataId` relation. */
  metadatumByMetadataId?: InputMaybe<MetadatumFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MetadataValueFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MetadataValueFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `taskByTaskId` relation. */
  taskByTaskId?: InputMaybe<TaskFilter>;
  /** A related `taskByTaskId` exists. */
  taskByTaskIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<JsonFilter>;
};

/** An input for mutations affecting `MetadataValue` */
export type MetadataValueInput = {
  applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id: Scalars["UUID"]["input"];
  metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
  metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  value?: InputMaybe<Scalars["JSON"]["input"]>;
};

/** Input for the nested mutation of `metadatum` in the `MetadataValueInput` mutation. */
export type MetadataValueMetadataId063A53B6FkMetadataIdInput = {
  /** The primary key(s) for `metadatum` for the far side of the relationship. */
  connectById?: InputMaybe<MetadatumMetadataPkeyConnect>;
  /** A `MetadatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdMetadataCreateInput>;
  /** The primary key(s) for `metadatum` for the far side of the relationship. */
  deleteById?: InputMaybe<MetadatumMetadataPkeyDelete>;
  /** The primary key(s) and patch data for `metadatum` for the far side of the relationship. */
  updateById?: InputMaybe<MetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataPkeyUpdate>;
};

/** Input for the nested mutation of `metadataValue` in the `MetadatumInput` mutation. */
export type MetadataValueMetadataId063A53B6FkMetadataIdInverseInput = {
  /** The primary key(s) for `metadataValue` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MetadataValueMetadataValuePkeyConnect>>;
  /** A `MetadataValueInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<MetadataValueMetadataId063A53B6FkMetadataIdMetadataValueCreateInput>
  >;
  /** The primary key(s) for `metadataValue` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<MetadataValueMetadataValuePkeyDelete>>;
  /** Flag indicating whether all other `metadataValue` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `metadataValue` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<MetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataValuePkeyUpdate>
  >;
};

/** The `metadatum` to be created by this mutation. */
export type MetadataValueMetadataId063A53B6FkMetadataIdMetadataCreateInput = {
  displayName: Scalars["String"]["input"];
  fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
  id: Scalars["UUID"]["input"];
  key: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
};

/** The `metadataValue` to be created by this mutation. */
export type MetadataValueMetadataId063A53B6FkMetadataIdMetadataValueCreateInput =
  {
    applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id: Scalars["UUID"]["input"];
    metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    value?: InputMaybe<Scalars["JSON"]["input"]>;
  };

/** The fields on `metadataValue` to look up the row to connect. */
export type MetadataValueMetadataValuePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `metadataValue` to look up the row to delete. */
export type MetadataValueMetadataValuePkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `metadataValue` to look up the row to update. */
export type MetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataValuePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `metadataValue` being updated. */
    metadataValuePatch: UpdateMetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch;
  };

/** The fields on `metadataValue` to look up the row to update. */
export type MetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingMetadataValuePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `metadataValue` being updated. */
    metadataValuePatch: UpdateMetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch;
  };

/** The fields on `metadataValue` to look up the row to update. */
export type MetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingMetadataValuePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `metadataValue` being updated. */
    metadataValuePatch: UpdateMetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch;
  };

/** The fields on `metadataValue` to look up the row to update. */
export type MetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingMetadataValuePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `metadataValue` being updated. */
    metadataValuePatch: UpdateMetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
  };

/** The fields on `metadataValue` to look up the row to update. */
export type MetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingMetadataValuePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `metadataValue` being updated. */
    metadataValuePatch: UpdateMetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
  };

/** Represents an update to a `MetadataValue`. Fields that are set will be updated. */
export type MetadataValuePatch = {
  applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
  metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  value?: InputMaybe<Scalars["JSON"]["input"]>;
};

/** Input for the nested mutation of `project` in the `MetadataValueInput` mutation. */
export type MetadataValueProjectId87227D96FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `metadataValue` in the `ProjectInput` mutation. */
export type MetadataValueProjectId87227D96FkProjectIdInverseInput = {
  /** The primary key(s) for `metadataValue` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MetadataValueMetadataValuePkeyConnect>>;
  /** A `MetadataValueInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<MetadataValueProjectId87227D96FkProjectIdMetadataValueCreateInput>
  >;
  /** The primary key(s) for `metadataValue` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<MetadataValueMetadataValuePkeyDelete>>;
  /** Flag indicating whether all other `metadataValue` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `metadataValue` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<MetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingMetadataValuePkeyUpdate>
  >;
};

/** The `metadataValue` to be created by this mutation. */
export type MetadataValueProjectId87227D96FkProjectIdMetadataValueCreateInput =
  {
    applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id: Scalars["UUID"]["input"];
    metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
    projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    value?: InputMaybe<Scalars["JSON"]["input"]>;
  };

/** Input for the nested mutation of `task` in the `MetadataValueInput` mutation. */
export type MetadataValueTaskId3D37D135FkTaskIdInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdTaskCreateInput>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyDelete>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteById?: InputMaybe<TaskTaskPkeyDelete>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `metadataValue` in the `TaskInput` mutation. */
export type MetadataValueTaskId3D37D135FkTaskIdInverseInput = {
  /** The primary key(s) for `metadataValue` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MetadataValueMetadataValuePkeyConnect>>;
  /** A `MetadataValueInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<MetadataValueTaskId3D37D135FkTaskIdMetadataValueCreateInput>
  >;
  /** The primary key(s) for `metadataValue` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<MetadataValueMetadataValuePkeyDelete>>;
  /** Flag indicating whether all other `metadataValue` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `metadataValue` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<MetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingMetadataValuePkeyUpdate>
  >;
};

/** The `metadataValue` to be created by this mutation. */
export type MetadataValueTaskId3D37D135FkTaskIdMetadataValueCreateInput = {
  applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id: Scalars["UUID"]["input"];
  metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
  metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
  taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  value?: InputMaybe<Scalars["JSON"]["input"]>;
};

/** The `task` to be created by this mutation. */
export type MetadataValueTaskId3D37D135FkTaskIdTaskCreateInput = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned: Scalars["Boolean"]["input"];
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id: Scalars["UUID"]["input"];
  inputsHash: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `tenant` in the `MetadataValueInput` mutation. */
export type MetadataValueTenantIdB4C2D5D6FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `metadataValue` in the `TenantInput` mutation. */
export type MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput = {
  /** The primary key(s) for `metadataValue` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MetadataValueMetadataValuePkeyConnect>>;
  /** A `MetadataValueInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<MetadataValueTenantIdB4C2D5D6FkTenantIdMetadataValueCreateInput>
  >;
  /** The primary key(s) for `metadataValue` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<MetadataValueMetadataValuePkeyDelete>>;
  /** Flag indicating whether all other `metadataValue` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `metadataValue` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<MetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingMetadataValuePkeyUpdate>
  >;
};

/** The `metadataValue` to be created by this mutation. */
export type MetadataValueTenantIdB4C2D5D6FkTenantIdMetadataValueCreateInput = {
  applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id: Scalars["UUID"]["input"];
  metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
  metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
  tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  value?: InputMaybe<Scalars["JSON"]["input"]>;
};

/** The `tenant` to be created by this mutation. */
export type MetadataValueTenantIdB4C2D5D6FkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** The `applicationUser` to be created by this mutation. */
export type MetadataValueUserIdB2Bb45AeFkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `MetadataValueInput` mutation. */
export type MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `metadataValue` in the `ApplicationUserInput` mutation. */
export type MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput = {
  /** The primary key(s) for `metadataValue` for the far side of the relationship. */
  connectById?: InputMaybe<Array<MetadataValueMetadataValuePkeyConnect>>;
  /** A `MetadataValueInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<MetadataValueUserIdB2Bb45AeFkApplicationUserIdMetadataValueCreateInput>
  >;
  /** The primary key(s) for `metadataValue` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<MetadataValueMetadataValuePkeyDelete>>;
  /** Flag indicating whether all other `metadataValue` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `metadataValue` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<MetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingMetadataValuePkeyUpdate>
  >;
};

/** The `metadataValue` to be created by this mutation. */
export type MetadataValueUserIdB2Bb45AeFkApplicationUserIdMetadataValueCreateInput =
  {
    applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id: Scalars["UUID"]["input"];
    metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
    value?: InputMaybe<Scalars["JSON"]["input"]>;
  };

/** A connection to a list of `MetadataValue` values. */
export type MetadataValuesConnection = {
  __typename: "MetadataValuesConnection";
  /** A list of edges which contains the `MetadataValue` and cursor to aid in pagination. */
  edges: Array<MetadataValuesEdge>;
  /** A list of `MetadataValue` objects. */
  nodes: Array<MetadataValue>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MetadataValue` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `MetadataValue` edge in the connection. */
export type MetadataValuesEdge = {
  __typename: "MetadataValuesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `MetadataValue` at the end of the edge. */
  node: MetadataValue;
};

/** Methods to use when ordering `MetadataValue`. */
export enum MetadataValuesOrderBy {
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  MetadataIdAsc = "METADATA_ID_ASC",
  MetadataIdDesc = "METADATA_ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  TaskIdAsc = "TASK_ID_ASC",
  TaskIdDesc = "TASK_ID_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
  ValueAsc = "VALUE_ASC",
  ValueDesc = "VALUE_DESC",
}

export type Metadatum = {
  __typename: "Metadatum";
  activeValue: Maybe<Scalars["JSON"]["output"]>;
  displayName: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `FileMetadatum`. */
  fileMetadataByMetadataId: FileMetadataConnection;
  /** Reads and enables pagination through a set of `FileOutputGroupMetadatum`. */
  fileOutputGroupMetadataByMetadataId: FileOutputGroupMetadataConnection;
  id: Scalars["UUID"]["output"];
  key: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `MetadataValue`. */
  metadataValuesByMetadataId: MetadataValuesConnection;
  /** Reads a single `Project` that is related to this `Metadatum`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  /** Reads a single `Tenant` that is related to this `Metadatum`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
};

export type MetadatumActiveValueArgs = {
  at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type MetadatumFileMetadataByMetadataIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileMetadatumCondition>;
  filter?: InputMaybe<FileMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileMetadataOrderBy>>;
};

export type MetadatumFileOutputGroupMetadataByMetadataIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileOutputGroupMetadatumCondition>;
  filter?: InputMaybe<FileOutputGroupMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileOutputGroupMetadataOrderBy>>;
};

export type MetadatumMetadataValuesByMetadataIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<MetadataValueCondition>;
  filter?: InputMaybe<MetadataValueFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<MetadataValuesOrderBy>>;
};

/**
 * A condition to be used against `Metadatum` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MetadatumCondition = {
  /** Checks for equality with the object’s `displayName` field. */
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `Metadatum` object types. All fields are combined with a logical ‘and.’ */
export type MetadatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MetadatumFilter>>;
  /** Filter by the object’s `displayName` field. */
  displayName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fileMetadataByMetadataId` relation. */
  fileMetadataByMetadataId?: InputMaybe<MetadatumToManyFileMetadatumFilter>;
  /** Some related `fileMetadataByMetadataId` exist. */
  fileMetadataByMetadataIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `fileOutputGroupMetadataByMetadataId` relation. */
  fileOutputGroupMetadataByMetadataId?: InputMaybe<MetadatumToManyFileOutputGroupMetadatumFilter>;
  /** Some related `fileOutputGroupMetadataByMetadataId` exist. */
  fileOutputGroupMetadataByMetadataIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadataValuesByMetadataId` relation. */
  metadataValuesByMetadataId?: InputMaybe<MetadatumToManyMetadataValueFilter>;
  /** Some related `metadataValuesByMetadataId` exist. */
  metadataValuesByMetadataIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Negates the expression. */
  not?: InputMaybe<MetadatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MetadatumFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Metadatum` */
export type MetadatumInput = {
  displayName: Scalars["String"]["input"];
  fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
  id: Scalars["UUID"]["input"];
  key: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
};

/** The fields on `metadatum` to look up the row to connect. */
export type MetadatumMetadataPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `metadatum` to look up the row to delete. */
export type MetadatumMetadataPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `metadatum` to look up the row to update. */
export type MetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingMetadataPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `metadatum` being updated. */
    metadatumPatch: UpdateMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch;
  };

/** The fields on `metadatum` to look up the row to update. */
export type MetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingMetadataPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `metadatum` being updated. */
    metadatumPatch: UpdateMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch;
  };

/** The fields on `metadatum` to look up the row to update. */
export type MetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `metadatum` being updated. */
    metadatumPatch: UpdateMetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch;
  };

/** The fields on `metadatum` to look up the row to update. */
export type MetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingMetadataPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `metadatum` being updated. */
    metadatumPatch: UpdateMetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch;
  };

/** The fields on `metadatum` to look up the row to update. */
export type MetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingMetadataPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `metadatum` being updated. */
    metadatumPatch: UpdateMetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
  };

/** Represents an update to a `Metadatum`. Fields that are set will be updated. */
export type MetadatumPatch = {
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
};

/** A filter to be used against many `FileMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type MetadatumToManyFileMetadatumFilter = {
  /** Every related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileMetadatumFilter>;
  /** No related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileMetadatumFilter>;
  /** Some related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileMetadatumFilter>;
};

/** A filter to be used against many `FileOutputGroupMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type MetadatumToManyFileOutputGroupMetadatumFilter = {
  /** Every related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** No related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** Some related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileOutputGroupMetadatumFilter>;
};

/** A filter to be used against many `MetadataValue` object types. All fields are combined with a logical ‘and.’ */
export type MetadatumToManyMetadataValueFilter = {
  /** Every related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MetadataValueFilter>;
  /** No related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MetadataValueFilter>;
  /** Some related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MetadataValueFilter>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename: "Mutation";
  changeUserSession: Maybe<ChangeUserSessionPayload>;
  /** Creates a single `AdminProject`. */
  createAdminProject: Maybe<CreateAdminProjectPayload>;
  /** Creates a single `ApplicationUser`. */
  createApplicationUser: Maybe<CreateApplicationUserPayload>;
  /** Creates a single `ApplicationUserGroup`. */
  createApplicationUserGroup: Maybe<CreateApplicationUserGroupPayload>;
  /** Creates a single `ApplicationUserMembership`. */
  createApplicationUserMembership: Maybe<CreateApplicationUserMembershipPayload>;
  /** Creates a single `ApplicationUserMetadatum`. */
  createApplicationUserMetadatum: Maybe<CreateApplicationUserMetadatumPayload>;
  /** Creates a single `ApplicationUserSession`. */
  createApplicationUserSession: Maybe<CreateApplicationUserSessionPayload>;
  /** Creates a single `ApplicationUserUserPermission`. */
  createApplicationUserUserPermission: Maybe<CreateApplicationUserUserPermissionPayload>;
  /** Creates a single `AuditlogLogentry`. */
  createAuditlogLogentry: Maybe<CreateAuditlogLogentryPayload>;
  /** Creates a single `AuthGroup`. */
  createAuthGroup: Maybe<CreateAuthGroupPayload>;
  /** Creates a single `AuthGroupPermission`. */
  createAuthGroupPermission: Maybe<CreateAuthGroupPermissionPayload>;
  /** Creates a single `AuthPermission`. */
  createAuthPermission: Maybe<CreateAuthPermissionPayload>;
  /** Creates a single `AvailableNonRestrictedProject`. */
  createAvailableNonRestrictedProject: Maybe<CreateAvailableNonRestrictedProjectPayload>;
  /** Creates a single `Avatar`. */
  createAvatar: Maybe<CreateAvatarPayload>;
  /** Creates a single `AwsBatchTask`. */
  createAwsBatchTask: Maybe<CreateAwsBatchTaskPayload>;
  /** Creates a single `AwsCognitoUser`. */
  createAwsCognitoUser: Maybe<CreateAwsCognitoUserPayload>;
  /** Creates a single `AwsEcrImage`. */
  createAwsEcrImage: Maybe<CreateAwsEcrImagePayload>;
  /** Creates a single `AwsMockBatchTask`. */
  createAwsMockBatchTask: Maybe<CreateAwsMockBatchTaskPayload>;
  /** Creates a single `AwsMockDistributionImage`. */
  createAwsMockDistributionImage: Maybe<CreateAwsMockDistributionImagePayload>;
  /** Creates a single `AwsMockEcrImage`. */
  createAwsMockEcrImage: Maybe<CreateAwsMockEcrImagePayload>;
  /** Creates a single `AwsMockIamUser`. */
  createAwsMockIamUser: Maybe<CreateAwsMockIamUserPayload>;
  /** Creates a single `AwsMockS3File`. */
  createAwsMockS3File: Maybe<CreateAwsMockS3FilePayload>;
  /** Creates a single `AwsS3File`. */
  createAwsS3File: Maybe<CreateAwsS3FilePayload>;
  /** Creates a single `CodeFile`. */
  createCodeFile: Maybe<CreateCodeFilePayload>;
  /** Creates a single `Command`. */
  createCommand: Maybe<CreateCommandPayload>;
  /** Creates a single `ContainerImage`. */
  createContainerImage: Maybe<CreateContainerImagePayload>;
  /** Creates a single `ContainerImageRepository`. */
  createContainerImageRepository: Maybe<CreateContainerImageRepositoryPayload>;
  /** Creates a single `Cost`. */
  createCost: Maybe<CreateCostPayload>;
  /** Creates a single `CurrentApplicationUser`. */
  createCurrentApplicationUser: Maybe<CreateCurrentApplicationUserPayload>;
  /** Creates a single `DistributionRegistryImage`. */
  createDistributionRegistryImage: Maybe<CreateDistributionRegistryImagePayload>;
  /** Creates a single `DjangoAdminLog`. */
  createDjangoAdminLog: Maybe<CreateDjangoAdminLogPayload>;
  /** Creates a single `DjangoContentType`. */
  createDjangoContentType: Maybe<CreateDjangoContentTypePayload>;
  /** Creates a single `DjangoMigration`. */
  createDjangoMigration: Maybe<CreateDjangoMigrationPayload>;
  /** Creates a single `DjangoSesBlacklistedemail`. */
  createDjangoSesBlacklistedemail: Maybe<CreateDjangoSesBlacklistedemailPayload>;
  /** Creates a single `DjangoSesSesstat`. */
  createDjangoSesSesstat: Maybe<CreateDjangoSesSesstatPayload>;
  /** Creates a single `DjangoSession`. */
  createDjangoSession: Maybe<CreateDjangoSessionPayload>;
  /** Creates a single `DrsFileexecutor`. */
  createDrsFileexecutor: Maybe<CreateDrsFileexecutorPayload>;
  /** Creates a single `DrsMockfileexecutor`. */
  createDrsMockfileexecutor: Maybe<CreateDrsMockfileexecutorPayload>;
  /** Creates a single `EulaVersion`. */
  createEulaVersion: Maybe<CreateEulaVersionPayload>;
  /** Creates a single `EulaVersionUserAcceptance`. */
  createEulaVersionUserAcceptance: Maybe<CreateEulaVersionUserAcceptancePayload>;
  /** Creates a single `FeatureFlag`. */
  createFeatureFlag: Maybe<CreateFeatureFlagPayload>;
  /** Creates a single `FeatureFlagsGroup`. */
  createFeatureFlagsGroup: Maybe<CreateFeatureFlagsGroupPayload>;
  /** Creates a single `FeatureFlagsTenant`. */
  createFeatureFlagsTenant: Maybe<CreateFeatureFlagsTenantPayload>;
  /** Creates a single `FeatureFlagsUser`. */
  createFeatureFlagsUser: Maybe<CreateFeatureFlagsUserPayload>;
  /** Creates a single `File`. */
  createFile: Maybe<CreateFilePayload>;
  /** Creates a single `FileActivity`. */
  createFileActivity: Maybe<CreateFileActivityPayload>;
  /** Creates a single `FileMetadatum`. */
  createFileMetadatum: Maybe<CreateFileMetadatumPayload>;
  /** Creates a single `FileOutputGroupMetadatum`. */
  createFileOutputGroupMetadatum: Maybe<CreateFileOutputGroupMetadatumPayload>;
  /** Creates a single `FilesByExecutor`. */
  createFilesByExecutor: Maybe<CreateFilesByExecutorPayload>;
  /** Creates a single `MetadataValue`. */
  createMetadataValue: Maybe<CreateMetadataValuePayload>;
  /** Creates a single `Metadatum`. */
  createMetadatum: Maybe<CreateMetadatumPayload>;
  /** Creates a single `OutputGroupFile`. */
  createOutputGroupFile: Maybe<CreateOutputGroupFilePayload>;
  /** Creates a single `PinnedTool`. */
  createPinnedTool: Maybe<CreatePinnedToolPayload>;
  /** Creates a single `ProjectFolder`. */
  createProjectFolder: Maybe<CreateProjectFolderPayload>;
  /** Creates a single `ProjectTag`. */
  createProjectTag: Maybe<CreateProjectTagPayload>;
  createRole: Maybe<CreateRolePayload>;
  /** Creates a single `Run`. */
  createRun: Maybe<CreateRunPayload>;
  createSession: Maybe<CreateSessionPayload>;
  /** Creates a single `Task`. */
  createTask: Maybe<CreateTaskPayload>;
  /** Creates a single `TaskActivity`. */
  createTaskActivity: Maybe<CreateTaskActivityPayload>;
  /** Creates a single `TaskResource`. */
  createTaskResource: Maybe<CreateTaskResourcePayload>;
  /** Creates a single `TaskResourceUsage`. */
  createTaskResourceUsage: Maybe<CreateTaskResourceUsagePayload>;
  /** Creates a single `TaskSource`. */
  createTaskSource: Maybe<CreateTaskSourcePayload>;
  /** Creates a single `TaskStatusLog`. */
  createTaskStatusLog: Maybe<CreateTaskStatusLogPayload>;
  /** Creates a single `Tenant`. */
  createTenant: Maybe<CreateTenantPayload>;
  /** Creates a single `TenantContract`. */
  createTenantContract: Maybe<CreateTenantContractPayload>;
  /** Creates a single `TenantContractAllowance`. */
  createTenantContractAllowance: Maybe<CreateTenantContractAllowancePayload>;
  /** Creates a single `TenantContractTransaction`. */
  createTenantContractTransaction: Maybe<CreateTenantContractTransactionPayload>;
  /** Creates a single `TenantMockuserexecutor`. */
  createTenantMockuserexecutor: Maybe<CreateTenantMockuserexecutorPayload>;
  /** Creates a single `TenantMonthlyConsumedResource`. */
  createTenantMonthlyConsumedResource: Maybe<CreateTenantMonthlyConsumedResourcePayload>;
  /** Creates a single `TenantUserexecutor`. */
  createTenantUserexecutor: Maybe<CreateTenantUserexecutorPayload>;
  /** Creates a single `TesContainerimageexecutor`. */
  createTesContainerimageexecutor: Maybe<CreateTesContainerimageexecutorPayload>;
  /** Creates a single `TesMockcontainerimageexecutor`. */
  createTesMockcontainerimageexecutor: Maybe<CreateTesMockcontainerimageexecutorPayload>;
  /** Creates a single `TesMocktaskexecutor`. */
  createTesMocktaskexecutor: Maybe<CreateTesMocktaskexecutorPayload>;
  /** Creates a single `TesTaskexecutor`. */
  createTesTaskexecutor: Maybe<CreateTesTaskexecutorPayload>;
  /** Creates a single `Tool`. */
  createTool: Maybe<CreateToolPayload>;
  /** Creates a single `ToolParameter`. */
  createToolParameter: Maybe<CreateToolParameterPayload>;
  /** Creates a single `ToolResource`. */
  createToolResource: Maybe<CreateToolResourcePayload>;
  /** Creates a single `ToolResult`. */
  createToolResult: Maybe<CreateToolResultPayload>;
  /** Creates a single `ToolSecret`. */
  createToolSecret: Maybe<CreateToolSecretPayload>;
  /** Creates a single `ToolSource`. */
  createToolSource: Maybe<CreateToolSourcePayload>;
  /** Creates a single `ToolTenant`. */
  createToolTenant: Maybe<CreateToolTenantPayload>;
  /** Creates a single `ToolVersion`. */
  createToolVersion: Maybe<CreateToolVersionPayload>;
  /** Creates a single `Toolbox`. */
  createToolbox: Maybe<CreateToolboxPayload>;
  /** Creates a single `ToolboxTenant`. */
  createToolboxTenant: Maybe<CreateToolboxTenantPayload>;
  /** Creates a single `UserPersonalSpaceRequest`. */
  createUserPersonalSpaceRequest: Maybe<CreateUserPersonalSpaceRequestPayload>;
  /** Creates a single `WaffleFlag`. */
  createWaffleFlag: Maybe<CreateWaffleFlagPayload>;
  /** Creates a single `WaffleSample`. */
  createWaffleSample: Maybe<CreateWaffleSamplePayload>;
  /** Creates a single `WaffleSwitch`. */
  createWaffleSwitch: Maybe<CreateWaffleSwitchPayload>;
  /** Creates a single `Workflow`. */
  createWorkflow: Maybe<CreateWorkflowPayload>;
  /** Creates a single `WorkflowDatum`. */
  createWorkflowDatum: Maybe<CreateWorkflowDatumPayload>;
  /** Creates a single `WorkflowResult`. */
  createWorkflowResult: Maybe<CreateWorkflowResultPayload>;
  /** Creates a single `WorkflowResultWorkflowVersion`. */
  createWorkflowResultWorkflowVersion: Maybe<CreateWorkflowResultWorkflowVersionPayload>;
  /** Creates a single `WorkflowSection`. */
  createWorkflowSection: Maybe<CreateWorkflowSectionPayload>;
  /** Creates a single `WorkflowSectionBlock`. */
  createWorkflowSectionBlock: Maybe<CreateWorkflowSectionBlockPayload>;
  /** Creates a single `WorkflowSectionBlockSection`. */
  createWorkflowSectionBlockSection: Maybe<CreateWorkflowSectionBlockSectionPayload>;
  /** Creates a single `WorkflowSectionWorkflowVersion`. */
  createWorkflowSectionWorkflowVersion: Maybe<CreateWorkflowSectionWorkflowVersionPayload>;
  /** Creates a single `WorkflowSource`. */
  createWorkflowSource: Maybe<CreateWorkflowSourcePayload>;
  /** Creates a single `WorkflowSourceWorkflowVersion`. */
  createWorkflowSourceWorkflowVersion: Maybe<CreateWorkflowSourceWorkflowVersionPayload>;
  /** Creates a single `WorkflowVersion`. */
  createWorkflowVersion: Maybe<CreateWorkflowVersionPayload>;
  /** Deletes a single `ApplicationUser` using a unique key. */
  deleteApplicationUserByEmail: Maybe<DeleteApplicationUserPayload>;
  /** Deletes a single `ApplicationUser` using a unique key. */
  deleteApplicationUserByGlobalUserId: Maybe<DeleteApplicationUserPayload>;
  /** Deletes a single `ApplicationUser` using a unique key. */
  deleteApplicationUserById: Maybe<DeleteApplicationUserPayload>;
  /** Deletes a single `ApplicationUser` using a unique key. */
  deleteApplicationUserByUsername: Maybe<DeleteApplicationUserPayload>;
  /** Deletes a single `ApplicationUserGroup` using a unique key. */
  deleteApplicationUserGroupById: Maybe<DeleteApplicationUserGroupPayload>;
  /** Deletes a single `ApplicationUserGroup` using a unique key. */
  deleteApplicationUserGroupByUserIdAndGroupId: Maybe<DeleteApplicationUserGroupPayload>;
  /** Deletes a single `ApplicationUserMembership` using a unique key. */
  deleteApplicationUserMembershipById: Maybe<DeleteApplicationUserMembershipPayload>;
  /** Deletes a single `ApplicationUserMembership` using a unique key. */
  deleteApplicationUserMembershipByUserIdAndTenantId: Maybe<DeleteApplicationUserMembershipPayload>;
  /** Deletes a single `ApplicationUserMetadatum` using a unique key. */
  deleteApplicationUserMetadatumById: Maybe<DeleteApplicationUserMetadatumPayload>;
  /** Deletes a single `ApplicationUserMetadatum` using a unique key. */
  deleteApplicationUserMetadatumByUserIdAndKey: Maybe<DeleteApplicationUserMetadatumPayload>;
  /** Deletes a single `ApplicationUserSession` using a unique key. */
  deleteApplicationUserSessionById: Maybe<DeleteApplicationUserSessionPayload>;
  /** Deletes a single `ApplicationUserUserPermission` using a unique key. */
  deleteApplicationUserUserPermissionById: Maybe<DeleteApplicationUserUserPermissionPayload>;
  /** Deletes a single `ApplicationUserUserPermission` using a unique key. */
  deleteApplicationUserUserPermissionByUserIdAndPermissionId: Maybe<DeleteApplicationUserUserPermissionPayload>;
  /** Deletes a single `AuditlogLogentry` using a unique key. */
  deleteAuditlogLogentryById: Maybe<DeleteAuditlogLogentryPayload>;
  /** Deletes a single `AuthGroup` using a unique key. */
  deleteAuthGroupById: Maybe<DeleteAuthGroupPayload>;
  /** Deletes a single `AuthGroup` using a unique key. */
  deleteAuthGroupByName: Maybe<DeleteAuthGroupPayload>;
  /** Deletes a single `AuthGroupPermission` using a unique key. */
  deleteAuthGroupPermissionByGroupIdAndPermissionId: Maybe<DeleteAuthGroupPermissionPayload>;
  /** Deletes a single `AuthGroupPermission` using a unique key. */
  deleteAuthGroupPermissionById: Maybe<DeleteAuthGroupPermissionPayload>;
  /** Deletes a single `AuthPermission` using a unique key. */
  deleteAuthPermissionByContentTypeIdAndCodename: Maybe<DeleteAuthPermissionPayload>;
  /** Deletes a single `AuthPermission` using a unique key. */
  deleteAuthPermissionById: Maybe<DeleteAuthPermissionPayload>;
  /** Deletes a single `Avatar` using a unique key. */
  deleteAvatarById: Maybe<DeleteAvatarPayload>;
  /** Deletes a single `Avatar` using a unique key. */
  deleteAvatarByUserId: Maybe<DeleteAvatarPayload>;
  /** Deletes a single `AwsBatchTask` using a unique key. */
  deleteAwsBatchTaskByTaskexecutorPtrId: Maybe<DeleteAwsBatchTaskPayload>;
  /** Deletes a single `AwsCognitoUser` using a unique key. */
  deleteAwsCognitoUserByUserexecutorPtrId: Maybe<DeleteAwsCognitoUserPayload>;
  /** Deletes a single `AwsEcrImage` using a unique key. */
  deleteAwsEcrImageByContainerimageexecutorPtrId: Maybe<DeleteAwsEcrImagePayload>;
  /** Deletes a single `AwsMockBatchTask` using a unique key. */
  deleteAwsMockBatchTaskByAwstaskexecutorPtrId: Maybe<DeleteAwsMockBatchTaskPayload>;
  /** Deletes a single `AwsMockDistributionImage` using a unique key. */
  deleteAwsMockDistributionImageByDistributioncontainerimageexecutorPtrId: Maybe<DeleteAwsMockDistributionImagePayload>;
  /** Deletes a single `AwsMockEcrImage` using a unique key. */
  deleteAwsMockEcrImageByAwscontainerimageexecutorPtrId: Maybe<DeleteAwsMockEcrImagePayload>;
  /** Deletes a single `AwsMockIamUser` using a unique key. */
  deleteAwsMockIamUserByAwsuserexecutorPtrId: Maybe<DeleteAwsMockIamUserPayload>;
  /** Deletes a single `AwsMockS3File` using a unique key. */
  deleteAwsMockS3FileByAwsfileexecutorPtrId: Maybe<DeleteAwsMockS3FilePayload>;
  /** Deletes a single `AwsS3File` using a unique key. */
  deleteAwsS3FileByFileexecutorPtrId: Maybe<DeleteAwsS3FilePayload>;
  /** Deletes a single `CodeFile` using a unique key. */
  deleteCodeFileById: Maybe<DeleteCodeFilePayload>;
  /** Deletes a single `Command` using a unique key. */
  deleteCommandById: Maybe<DeleteCommandPayload>;
  /** Deletes a single `Command` using a unique key. */
  deleteCommandByToolVersionId: Maybe<DeleteCommandPayload>;
  /** Deletes a single `Command` using a unique key. */
  deleteCommandByToolVersionIdAndCodeFileId: Maybe<DeleteCommandPayload>;
  /** Deletes a single `ContainerImage` using a unique key. */
  deleteContainerImageByExecutorId: Maybe<DeleteContainerImagePayload>;
  /** Deletes a single `ContainerImage` using a unique key. */
  deleteContainerImageById: Maybe<DeleteContainerImagePayload>;
  /** Deletes a single `ContainerImageRepository` using a unique key. */
  deleteContainerImageRepositoryById: Maybe<DeleteContainerImageRepositoryPayload>;
  /** Deletes a single `ContainerImageRepository` using a unique key. */
  deleteContainerImageRepositoryByNameAndTenantIdAndRegistryType: Maybe<DeleteContainerImageRepositoryPayload>;
  /** Deletes a single `ContainerImageRepository` using a unique key. */
  deleteContainerImageRepositoryByRepository: Maybe<DeleteContainerImageRepositoryPayload>;
  /** Deletes a single `Cost` using a unique key. */
  deleteCostById: Maybe<DeleteCostPayload>;
  /** Deletes a single `DistributionRegistryImage` using a unique key. */
  deleteDistributionRegistryImageByContainerimageexecutorPtrId: Maybe<DeleteDistributionRegistryImagePayload>;
  /** Deletes a single `DjangoAdminLog` using a unique key. */
  deleteDjangoAdminLogById: Maybe<DeleteDjangoAdminLogPayload>;
  /** Deletes a single `DjangoContentType` using a unique key. */
  deleteDjangoContentTypeByAppLabelAndModel: Maybe<DeleteDjangoContentTypePayload>;
  /** Deletes a single `DjangoContentType` using a unique key. */
  deleteDjangoContentTypeById: Maybe<DeleteDjangoContentTypePayload>;
  /** Deletes a single `DjangoMigration` using a unique key. */
  deleteDjangoMigrationById: Maybe<DeleteDjangoMigrationPayload>;
  /** Deletes a single `DjangoSesBlacklistedemail` using a unique key. */
  deleteDjangoSesBlacklistedemailByEmail: Maybe<DeleteDjangoSesBlacklistedemailPayload>;
  /** Deletes a single `DjangoSesBlacklistedemail` using a unique key. */
  deleteDjangoSesBlacklistedemailById: Maybe<DeleteDjangoSesBlacklistedemailPayload>;
  /** Deletes a single `DjangoSesSesstat` using a unique key. */
  deleteDjangoSesSesstatByDate: Maybe<DeleteDjangoSesSesstatPayload>;
  /** Deletes a single `DjangoSesSesstat` using a unique key. */
  deleteDjangoSesSesstatById: Maybe<DeleteDjangoSesSesstatPayload>;
  /** Deletes a single `DjangoSession` using a unique key. */
  deleteDjangoSessionBySessionKey: Maybe<DeleteDjangoSessionPayload>;
  /** Deletes a single `DrsFileexecutor` using a unique key. */
  deleteDrsFileexecutorById: Maybe<DeleteDrsFileexecutorPayload>;
  /** Deletes a single `DrsMockfileexecutor` using a unique key. */
  deleteDrsMockfileexecutorByFileexecutorPtrId: Maybe<DeleteDrsMockfileexecutorPayload>;
  /** Deletes a single `EulaVersion` using a unique key. */
  deleteEulaVersionById: Maybe<DeleteEulaVersionPayload>;
  /** Deletes a single `EulaVersion` using a unique key. */
  deleteEulaVersionByVersion: Maybe<DeleteEulaVersionPayload>;
  /** Deletes a single `EulaVersionUserAcceptance` using a unique key. */
  deleteEulaVersionUserAcceptanceById: Maybe<DeleteEulaVersionUserAcceptancePayload>;
  /** Deletes a single `EulaVersionUserAcceptance` using a unique key. */
  deleteEulaVersionUserAcceptanceByUserIdAndEulaVersionId: Maybe<DeleteEulaVersionUserAcceptancePayload>;
  /** Deletes a single `FeatureFlag` using a unique key. */
  deleteFeatureFlagById: Maybe<DeleteFeatureFlagPayload>;
  /** Deletes a single `FeatureFlag` using a unique key. */
  deleteFeatureFlagByName: Maybe<DeleteFeatureFlagPayload>;
  /** Deletes a single `FeatureFlagsGroup` using a unique key. */
  deleteFeatureFlagsGroupByFeatureflagIdAndGroupId: Maybe<DeleteFeatureFlagsGroupPayload>;
  /** Deletes a single `FeatureFlagsGroup` using a unique key. */
  deleteFeatureFlagsGroupById: Maybe<DeleteFeatureFlagsGroupPayload>;
  /** Deletes a single `FeatureFlagsTenant` using a unique key. */
  deleteFeatureFlagsTenantByFeatureflagIdAndTenantId: Maybe<DeleteFeatureFlagsTenantPayload>;
  /** Deletes a single `FeatureFlagsTenant` using a unique key. */
  deleteFeatureFlagsTenantById: Maybe<DeleteFeatureFlagsTenantPayload>;
  /** Deletes a single `FeatureFlagsUser` using a unique key. */
  deleteFeatureFlagsUserByFeatureflagIdAndUserId: Maybe<DeleteFeatureFlagsUserPayload>;
  /** Deletes a single `FeatureFlagsUser` using a unique key. */
  deleteFeatureFlagsUserById: Maybe<DeleteFeatureFlagsUserPayload>;
  /** Deletes a single `FileActivity` using a unique key. */
  deleteFileActivityById: Maybe<DeleteFileActivityPayload>;
  /** Deletes a single `File` using a unique key. */
  deleteFileById: Maybe<DeleteFilePayload>;
  /** Deletes a single `File` using a unique key. */
  deleteFileByProjectIdAndReferenceId: Maybe<DeleteFilePayload>;
  /** Deletes a single `FileMetadatum` using a unique key. */
  deleteFileMetadatumById: Maybe<DeleteFileMetadatumPayload>;
  /** Deletes a single `FileOutputGroup` using a unique key. */
  deleteFileOutputGroupById: Maybe<DeleteFileOutputGroupPayload>;
  /** Deletes a single `FileOutputGroup` using a unique key. */
  deleteFileOutputGroupByTaskId: Maybe<DeleteFileOutputGroupPayload>;
  /** Deletes a single `FileOutputGroupMetadatum` using a unique key. */
  deleteFileOutputGroupMetadatumById: Maybe<DeleteFileOutputGroupMetadatumPayload>;
  /** Deletes a single `MetadataValue` using a unique key. */
  deleteMetadataValueById: Maybe<DeleteMetadataValuePayload>;
  /** Deletes a single `Metadatum` using a unique key. */
  deleteMetadatumById: Maybe<DeleteMetadatumPayload>;
  /** Deletes a single `OutputGroupFile` using a unique key. */
  deleteOutputGroupFileById: Maybe<DeleteOutputGroupFilePayload>;
  /** Deletes a single `PinnedTool` using a unique key. */
  deletePinnedToolById: Maybe<DeletePinnedToolPayload>;
  /** Deletes a single `PinnedTool` using a unique key. */
  deletePinnedToolByUserIdAndToolId: Maybe<DeletePinnedToolPayload>;
  /** Deletes a single `ProjectFolder` using a unique key. */
  deleteProjectFolderById: Maybe<DeleteProjectFolderPayload>;
  /** Deletes a single `ProjectTag` using a unique key. */
  deleteProjectTagById: Maybe<DeleteProjectTagPayload>;
  /** Deletes a single `Run` using a unique key. */
  deleteRunById: Maybe<DeleteRunPayload>;
  deleteSession: Maybe<DeleteSessionPayload>;
  /** Deletes a single `TaskActivity` using a unique key. */
  deleteTaskActivityById: Maybe<DeleteTaskActivityPayload>;
  /** Deletes a single `TaskActivity` using a unique key. */
  deleteTaskActivityByTaskId: Maybe<DeleteTaskActivityPayload>;
  /** Deletes a single `Task` using a unique key. */
  deleteTaskByExecutorId: Maybe<DeleteTaskPayload>;
  /** Deletes a single `Task` using a unique key. */
  deleteTaskById: Maybe<DeleteTaskPayload>;
  /** Deletes a single `TaskResource` using a unique key. */
  deleteTaskResourceById: Maybe<DeleteTaskResourcePayload>;
  /** Deletes a single `TaskResourceUsage` using a unique key. */
  deleteTaskResourceUsageById: Maybe<DeleteTaskResourceUsagePayload>;
  /** Deletes a single `TaskResourceUsage` using a unique key. */
  deleteTaskResourceUsageByTaskId: Maybe<DeleteTaskResourceUsagePayload>;
  /** Deletes a single `TaskSource` using a unique key. */
  deleteTaskSourceById: Maybe<DeleteTaskSourcePayload>;
  /** Deletes a single `TaskStatusLog` using a unique key. */
  deleteTaskStatusLogById: Maybe<DeleteTaskStatusLogPayload>;
  /** Deletes a single `TaskStatusLog` using a unique key. */
  deleteTaskStatusLogByTaskIdAndStatus: Maybe<DeleteTaskStatusLogPayload>;
  /** Deletes a single `Tenant` using a unique key. */
  deleteTenantById: Maybe<DeleteTenantPayload>;
  /** Deletes a single `Tenant` using a unique key. */
  deleteTenantByKey: Maybe<DeleteTenantPayload>;
  /** Deletes a single `Tenant` using a unique key. */
  deleteTenantByRepositoryName: Maybe<DeleteTenantPayload>;
  /** Deletes a single `Tenant` using a unique key. */
  deleteTenantBySfid: Maybe<DeleteTenantPayload>;
  /** Deletes a single `TenantContractAllowance` using a unique key. */
  deleteTenantContractAllowanceById: Maybe<DeleteTenantContractAllowancePayload>;
  /** Deletes a single `TenantContractAllowance` using a unique key. */
  deleteTenantContractAllowanceByTenantContractTransactionIdAndQuotaType: Maybe<DeleteTenantContractAllowancePayload>;
  /** Deletes a single `TenantContract` using a unique key. */
  deleteTenantContractById: Maybe<DeleteTenantContractPayload>;
  /** Deletes a single `TenantContract` using a unique key. */
  deleteTenantContractByName: Maybe<DeleteTenantContractPayload>;
  /** Deletes a single `TenantContract` using a unique key. */
  deleteTenantContractBySfid: Maybe<DeleteTenantContractPayload>;
  /** Deletes a single `TenantContractTransaction` using a unique key. */
  deleteTenantContractTransactionById: Maybe<DeleteTenantContractTransactionPayload>;
  /** Deletes a single `TenantMockuserexecutor` using a unique key. */
  deleteTenantMockuserexecutorByUserexecutorPtrId: Maybe<DeleteTenantMockuserexecutorPayload>;
  /** Deletes a single `TenantMonthlyConsumedResource` using a unique key. */
  deleteTenantMonthlyConsumedResourceById: Maybe<DeleteTenantMonthlyConsumedResourcePayload>;
  /** Deletes a single `TenantMonthlyConsumedResource` using a unique key. */
  deleteTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract: Maybe<DeleteTenantMonthlyConsumedResourcePayload>;
  /** Deletes a single `TenantUserexecutor` using a unique key. */
  deleteTenantUserexecutorById: Maybe<DeleteTenantUserexecutorPayload>;
  /** Deletes a single `TesContainerimageexecutor` using a unique key. */
  deleteTesContainerimageexecutorById: Maybe<DeleteTesContainerimageexecutorPayload>;
  /** Deletes a single `TesMockcontainerimageexecutor` using a unique key. */
  deleteTesMockcontainerimageexecutorByContainerimageexecutorPtrId: Maybe<DeleteTesMockcontainerimageexecutorPayload>;
  /** Deletes a single `TesMocktaskexecutor` using a unique key. */
  deleteTesMocktaskexecutorByTaskexecutorPtrId: Maybe<DeleteTesMocktaskexecutorPayload>;
  /** Deletes a single `TesTaskexecutor` using a unique key. */
  deleteTesTaskexecutorById: Maybe<DeleteTesTaskexecutorPayload>;
  /** Deletes a single `Tool` using a unique key. */
  deleteToolById: Maybe<DeleteToolPayload>;
  /** Deletes a single `Tool` using a unique key. */
  deleteToolByProjectId: Maybe<DeleteToolPayload>;
  /** Deletes a single `ToolParameter` using a unique key. */
  deleteToolParameterById: Maybe<DeleteToolParameterPayload>;
  /** Deletes a single `ToolResource` using a unique key. */
  deleteToolResourceById: Maybe<DeleteToolResourcePayload>;
  /** Deletes a single `ToolResource` using a unique key. */
  deleteToolResourceByTypeAndToolVersionId: Maybe<DeleteToolResourcePayload>;
  /** Deletes a single `ToolResult` using a unique key. */
  deleteToolResultById: Maybe<DeleteToolResultPayload>;
  /** Deletes a single `ToolSecret` using a unique key. */
  deleteToolSecretById: Maybe<DeleteToolSecretPayload>;
  /** Deletes a single `ToolSource` using a unique key. */
  deleteToolSourceById: Maybe<DeleteToolSourcePayload>;
  /** Deletes a single `ToolTenant` using a unique key. */
  deleteToolTenantById: Maybe<DeleteToolTenantPayload>;
  /** Deletes a single `ToolTenant` using a unique key. */
  deleteToolTenantByToolIdAndTenantId: Maybe<DeleteToolTenantPayload>;
  /** Deletes a single `ToolVersion` using a unique key. */
  deleteToolVersionById: Maybe<DeleteToolVersionPayload>;
  /** Deletes a single `Toolbox` using a unique key. */
  deleteToolboxById: Maybe<DeleteToolboxPayload>;
  /** Deletes a single `Toolbox` using a unique key. */
  deleteToolboxByKey: Maybe<DeleteToolboxPayload>;
  /** Deletes a single `ToolboxTenant` using a unique key. */
  deleteToolboxTenantById: Maybe<DeleteToolboxTenantPayload>;
  /** Deletes a single `ToolboxTenant` using a unique key. */
  deleteToolboxTenantByToolboxIdAndTenantId: Maybe<DeleteToolboxTenantPayload>;
  /** Deletes a single `UserPersonalSpaceRequest` using a unique key. */
  deleteUserPersonalSpaceRequestById: Maybe<DeleteUserPersonalSpaceRequestPayload>;
  /** Deletes a single `WaffleFlag` using a unique key. */
  deleteWaffleFlagById: Maybe<DeleteWaffleFlagPayload>;
  /** Deletes a single `WaffleFlag` using a unique key. */
  deleteWaffleFlagByName: Maybe<DeleteWaffleFlagPayload>;
  /** Deletes a single `WaffleSample` using a unique key. */
  deleteWaffleSampleById: Maybe<DeleteWaffleSamplePayload>;
  /** Deletes a single `WaffleSample` using a unique key. */
  deleteWaffleSampleByName: Maybe<DeleteWaffleSamplePayload>;
  /** Deletes a single `WaffleSwitch` using a unique key. */
  deleteWaffleSwitchById: Maybe<DeleteWaffleSwitchPayload>;
  /** Deletes a single `WaffleSwitch` using a unique key. */
  deleteWaffleSwitchByName: Maybe<DeleteWaffleSwitchPayload>;
  /** Deletes a single `Workflow` using a unique key. */
  deleteWorkflowById: Maybe<DeleteWorkflowPayload>;
  /** Deletes a single `WorkflowDatum` using a unique key. */
  deleteWorkflowDatumById: Maybe<DeleteWorkflowDatumPayload>;
  /** Deletes a single `WorkflowResult` using a unique key. */
  deleteWorkflowResultById: Maybe<DeleteWorkflowResultPayload>;
  /** Deletes a single `WorkflowResultWorkflowVersion` using a unique key. */
  deleteWorkflowResultWorkflowVersionById: Maybe<DeleteWorkflowResultWorkflowVersionPayload>;
  /** Deletes a single `WorkflowResultWorkflowVersion` using a unique key. */
  deleteWorkflowResultWorkflowVersionByResultIdAndWorkflowversionId: Maybe<DeleteWorkflowResultWorkflowVersionPayload>;
  /** Deletes a single `WorkflowSectionBlock` using a unique key. */
  deleteWorkflowSectionBlockById: Maybe<DeleteWorkflowSectionBlockPayload>;
  /** Deletes a single `WorkflowSectionBlockSection` using a unique key. */
  deleteWorkflowSectionBlockSectionByBlockIdAndSectionId: Maybe<DeleteWorkflowSectionBlockSectionPayload>;
  /** Deletes a single `WorkflowSectionBlockSection` using a unique key. */
  deleteWorkflowSectionBlockSectionById: Maybe<DeleteWorkflowSectionBlockSectionPayload>;
  /** Deletes a single `WorkflowSection` using a unique key. */
  deleteWorkflowSectionById: Maybe<DeleteWorkflowSectionPayload>;
  /** Deletes a single `WorkflowSectionWorkflowVersion` using a unique key. */
  deleteWorkflowSectionWorkflowVersionById: Maybe<DeleteWorkflowSectionWorkflowVersionPayload>;
  /** Deletes a single `WorkflowSectionWorkflowVersion` using a unique key. */
  deleteWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionId: Maybe<DeleteWorkflowSectionWorkflowVersionPayload>;
  /** Deletes a single `WorkflowSource` using a unique key. */
  deleteWorkflowSourceById: Maybe<DeleteWorkflowSourcePayload>;
  /** Deletes a single `WorkflowSourceWorkflowVersion` using a unique key. */
  deleteWorkflowSourceWorkflowVersionById: Maybe<DeleteWorkflowSourceWorkflowVersionPayload>;
  /** Deletes a single `WorkflowSourceWorkflowVersion` using a unique key. */
  deleteWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionId: Maybe<DeleteWorkflowSourceWorkflowVersionPayload>;
  /** Deletes a single `WorkflowVersion` using a unique key. */
  deleteWorkflowVersionById: Maybe<DeleteWorkflowVersionPayload>;
  /** Updates a single `ApplicationUser` using a unique key and a patch. */
  updateApplicationUserByEmail: Maybe<UpdateApplicationUserPayload>;
  /** Updates a single `ApplicationUser` using a unique key and a patch. */
  updateApplicationUserByGlobalUserId: Maybe<UpdateApplicationUserPayload>;
  /** Updates a single `ApplicationUser` using a unique key and a patch. */
  updateApplicationUserById: Maybe<UpdateApplicationUserPayload>;
  /** Updates a single `ApplicationUser` using a unique key and a patch. */
  updateApplicationUserByUsername: Maybe<UpdateApplicationUserPayload>;
  /** Updates a single `ApplicationUserGroup` using a unique key and a patch. */
  updateApplicationUserGroupById: Maybe<UpdateApplicationUserGroupPayload>;
  /** Updates a single `ApplicationUserGroup` using a unique key and a patch. */
  updateApplicationUserGroupByUserIdAndGroupId: Maybe<UpdateApplicationUserGroupPayload>;
  /** Updates a single `ApplicationUserMembership` using a unique key and a patch. */
  updateApplicationUserMembershipById: Maybe<UpdateApplicationUserMembershipPayload>;
  /** Updates a single `ApplicationUserMembership` using a unique key and a patch. */
  updateApplicationUserMembershipByUserIdAndTenantId: Maybe<UpdateApplicationUserMembershipPayload>;
  /** Updates a single `ApplicationUserMetadatum` using a unique key and a patch. */
  updateApplicationUserMetadatumById: Maybe<UpdateApplicationUserMetadatumPayload>;
  /** Updates a single `ApplicationUserMetadatum` using a unique key and a patch. */
  updateApplicationUserMetadatumByUserIdAndKey: Maybe<UpdateApplicationUserMetadatumPayload>;
  /** Updates a single `ApplicationUserSession` using a unique key and a patch. */
  updateApplicationUserSessionById: Maybe<UpdateApplicationUserSessionPayload>;
  /** Updates a single `ApplicationUserUserPermission` using a unique key and a patch. */
  updateApplicationUserUserPermissionById: Maybe<UpdateApplicationUserUserPermissionPayload>;
  /** Updates a single `ApplicationUserUserPermission` using a unique key and a patch. */
  updateApplicationUserUserPermissionByUserIdAndPermissionId: Maybe<UpdateApplicationUserUserPermissionPayload>;
  /** Updates a single `AuditlogLogentry` using a unique key and a patch. */
  updateAuditlogLogentryById: Maybe<UpdateAuditlogLogentryPayload>;
  /** Updates a single `AuthGroup` using a unique key and a patch. */
  updateAuthGroupById: Maybe<UpdateAuthGroupPayload>;
  /** Updates a single `AuthGroup` using a unique key and a patch. */
  updateAuthGroupByName: Maybe<UpdateAuthGroupPayload>;
  /** Updates a single `AuthGroupPermission` using a unique key and a patch. */
  updateAuthGroupPermissionByGroupIdAndPermissionId: Maybe<UpdateAuthGroupPermissionPayload>;
  /** Updates a single `AuthGroupPermission` using a unique key and a patch. */
  updateAuthGroupPermissionById: Maybe<UpdateAuthGroupPermissionPayload>;
  /** Updates a single `AuthPermission` using a unique key and a patch. */
  updateAuthPermissionByContentTypeIdAndCodename: Maybe<UpdateAuthPermissionPayload>;
  /** Updates a single `AuthPermission` using a unique key and a patch. */
  updateAuthPermissionById: Maybe<UpdateAuthPermissionPayload>;
  /** Updates a single `Avatar` using a unique key and a patch. */
  updateAvatarById: Maybe<UpdateAvatarPayload>;
  /** Updates a single `Avatar` using a unique key and a patch. */
  updateAvatarByUserId: Maybe<UpdateAvatarPayload>;
  /** Updates a single `AwsBatchTask` using a unique key and a patch. */
  updateAwsBatchTaskByTaskexecutorPtrId: Maybe<UpdateAwsBatchTaskPayload>;
  /** Updates a single `AwsCognitoUser` using a unique key and a patch. */
  updateAwsCognitoUserByUserexecutorPtrId: Maybe<UpdateAwsCognitoUserPayload>;
  /** Updates a single `AwsEcrImage` using a unique key and a patch. */
  updateAwsEcrImageByContainerimageexecutorPtrId: Maybe<UpdateAwsEcrImagePayload>;
  /** Updates a single `AwsMockBatchTask` using a unique key and a patch. */
  updateAwsMockBatchTaskByAwstaskexecutorPtrId: Maybe<UpdateAwsMockBatchTaskPayload>;
  /** Updates a single `AwsMockDistributionImage` using a unique key and a patch. */
  updateAwsMockDistributionImageByDistributioncontainerimageexecutorPtrId: Maybe<UpdateAwsMockDistributionImagePayload>;
  /** Updates a single `AwsMockEcrImage` using a unique key and a patch. */
  updateAwsMockEcrImageByAwscontainerimageexecutorPtrId: Maybe<UpdateAwsMockEcrImagePayload>;
  /** Updates a single `AwsMockIamUser` using a unique key and a patch. */
  updateAwsMockIamUserByAwsuserexecutorPtrId: Maybe<UpdateAwsMockIamUserPayload>;
  /** Updates a single `AwsMockS3File` using a unique key and a patch. */
  updateAwsMockS3FileByAwsfileexecutorPtrId: Maybe<UpdateAwsMockS3FilePayload>;
  /** Updates a single `AwsS3File` using a unique key and a patch. */
  updateAwsS3FileByFileexecutorPtrId: Maybe<UpdateAwsS3FilePayload>;
  /** Updates a single `CodeFile` using a unique key and a patch. */
  updateCodeFileById: Maybe<UpdateCodeFilePayload>;
  /** Updates a single `Command` using a unique key and a patch. */
  updateCommandById: Maybe<UpdateCommandPayload>;
  /** Updates a single `Command` using a unique key and a patch. */
  updateCommandByToolVersionId: Maybe<UpdateCommandPayload>;
  /** Updates a single `Command` using a unique key and a patch. */
  updateCommandByToolVersionIdAndCodeFileId: Maybe<UpdateCommandPayload>;
  /** Updates a single `ContainerImage` using a unique key and a patch. */
  updateContainerImageByExecutorId: Maybe<UpdateContainerImagePayload>;
  /** Updates a single `ContainerImage` using a unique key and a patch. */
  updateContainerImageById: Maybe<UpdateContainerImagePayload>;
  /** Updates a single `ContainerImageRepository` using a unique key and a patch. */
  updateContainerImageRepositoryById: Maybe<UpdateContainerImageRepositoryPayload>;
  /** Updates a single `ContainerImageRepository` using a unique key and a patch. */
  updateContainerImageRepositoryByNameAndTenantIdAndRegistryType: Maybe<UpdateContainerImageRepositoryPayload>;
  /** Updates a single `ContainerImageRepository` using a unique key and a patch. */
  updateContainerImageRepositoryByRepository: Maybe<UpdateContainerImageRepositoryPayload>;
  /** Updates a single `Cost` using a unique key and a patch. */
  updateCostById: Maybe<UpdateCostPayload>;
  /** Updates a single `DistributionRegistryImage` using a unique key and a patch. */
  updateDistributionRegistryImageByContainerimageexecutorPtrId: Maybe<UpdateDistributionRegistryImagePayload>;
  /** Updates a single `DjangoAdminLog` using a unique key and a patch. */
  updateDjangoAdminLogById: Maybe<UpdateDjangoAdminLogPayload>;
  /** Updates a single `DjangoContentType` using a unique key and a patch. */
  updateDjangoContentTypeByAppLabelAndModel: Maybe<UpdateDjangoContentTypePayload>;
  /** Updates a single `DjangoContentType` using a unique key and a patch. */
  updateDjangoContentTypeById: Maybe<UpdateDjangoContentTypePayload>;
  /** Updates a single `DjangoMigration` using a unique key and a patch. */
  updateDjangoMigrationById: Maybe<UpdateDjangoMigrationPayload>;
  /** Updates a single `DjangoSesBlacklistedemail` using a unique key and a patch. */
  updateDjangoSesBlacklistedemailByEmail: Maybe<UpdateDjangoSesBlacklistedemailPayload>;
  /** Updates a single `DjangoSesBlacklistedemail` using a unique key and a patch. */
  updateDjangoSesBlacklistedemailById: Maybe<UpdateDjangoSesBlacklistedemailPayload>;
  /** Updates a single `DjangoSesSesstat` using a unique key and a patch. */
  updateDjangoSesSesstatByDate: Maybe<UpdateDjangoSesSesstatPayload>;
  /** Updates a single `DjangoSesSesstat` using a unique key and a patch. */
  updateDjangoSesSesstatById: Maybe<UpdateDjangoSesSesstatPayload>;
  /** Updates a single `DjangoSession` using a unique key and a patch. */
  updateDjangoSessionBySessionKey: Maybe<UpdateDjangoSessionPayload>;
  /** Updates a single `DrsFileexecutor` using a unique key and a patch. */
  updateDrsFileexecutorById: Maybe<UpdateDrsFileexecutorPayload>;
  /** Updates a single `DrsMockfileexecutor` using a unique key and a patch. */
  updateDrsMockfileexecutorByFileexecutorPtrId: Maybe<UpdateDrsMockfileexecutorPayload>;
  /** Updates a single `EulaVersion` using a unique key and a patch. */
  updateEulaVersionById: Maybe<UpdateEulaVersionPayload>;
  /** Updates a single `EulaVersion` using a unique key and a patch. */
  updateEulaVersionByVersion: Maybe<UpdateEulaVersionPayload>;
  /** Updates a single `EulaVersionUserAcceptance` using a unique key and a patch. */
  updateEulaVersionUserAcceptanceById: Maybe<UpdateEulaVersionUserAcceptancePayload>;
  /** Updates a single `EulaVersionUserAcceptance` using a unique key and a patch. */
  updateEulaVersionUserAcceptanceByUserIdAndEulaVersionId: Maybe<UpdateEulaVersionUserAcceptancePayload>;
  /** Updates a single `FeatureFlag` using a unique key and a patch. */
  updateFeatureFlagById: Maybe<UpdateFeatureFlagPayload>;
  /** Updates a single `FeatureFlag` using a unique key and a patch. */
  updateFeatureFlagByName: Maybe<UpdateFeatureFlagPayload>;
  /** Updates a single `FeatureFlagsGroup` using a unique key and a patch. */
  updateFeatureFlagsGroupByFeatureflagIdAndGroupId: Maybe<UpdateFeatureFlagsGroupPayload>;
  /** Updates a single `FeatureFlagsGroup` using a unique key and a patch. */
  updateFeatureFlagsGroupById: Maybe<UpdateFeatureFlagsGroupPayload>;
  /** Updates a single `FeatureFlagsTenant` using a unique key and a patch. */
  updateFeatureFlagsTenantByFeatureflagIdAndTenantId: Maybe<UpdateFeatureFlagsTenantPayload>;
  /** Updates a single `FeatureFlagsTenant` using a unique key and a patch. */
  updateFeatureFlagsTenantById: Maybe<UpdateFeatureFlagsTenantPayload>;
  /** Updates a single `FeatureFlagsUser` using a unique key and a patch. */
  updateFeatureFlagsUserByFeatureflagIdAndUserId: Maybe<UpdateFeatureFlagsUserPayload>;
  /** Updates a single `FeatureFlagsUser` using a unique key and a patch. */
  updateFeatureFlagsUserById: Maybe<UpdateFeatureFlagsUserPayload>;
  /** Updates a single `FileActivity` using a unique key and a patch. */
  updateFileActivityById: Maybe<UpdateFileActivityPayload>;
  /** Updates a single `File` using a unique key and a patch. */
  updateFileById: Maybe<UpdateFilePayload>;
  /** Updates a single `File` using a unique key and a patch. */
  updateFileByProjectIdAndReferenceId: Maybe<UpdateFilePayload>;
  /** Updates a single `FileMetadatum` using a unique key and a patch. */
  updateFileMetadatumById: Maybe<UpdateFileMetadatumPayload>;
  /** Updates a single `FileOutputGroup` using a unique key and a patch. */
  updateFileOutputGroupById: Maybe<UpdateFileOutputGroupPayload>;
  /** Updates a single `FileOutputGroup` using a unique key and a patch. */
  updateFileOutputGroupByTaskId: Maybe<UpdateFileOutputGroupPayload>;
  /** Updates a single `FileOutputGroupMetadatum` using a unique key and a patch. */
  updateFileOutputGroupMetadatumById: Maybe<UpdateFileOutputGroupMetadatumPayload>;
  /** Updates a single `MetadataValue` using a unique key and a patch. */
  updateMetadataValueById: Maybe<UpdateMetadataValuePayload>;
  /** Updates a single `Metadatum` using a unique key and a patch. */
  updateMetadatumById: Maybe<UpdateMetadatumPayload>;
  /** Updates a single `Notification` using a unique key and a patch. */
  updateNotificationById: Maybe<UpdateNotificationPayload>;
  /** Updates a single `OutputGroupFile` using a unique key and a patch. */
  updateOutputGroupFileById: Maybe<UpdateOutputGroupFilePayload>;
  /** Updates a single `PinnedTool` using a unique key and a patch. */
  updatePinnedToolById: Maybe<UpdatePinnedToolPayload>;
  /** Updates a single `PinnedTool` using a unique key and a patch. */
  updatePinnedToolByUserIdAndToolId: Maybe<UpdatePinnedToolPayload>;
  /** Updates a single `ProjectFolder` using a unique key and a patch. */
  updateProjectFolderById: Maybe<UpdateProjectFolderPayload>;
  /** Updates a single `ProjectTag` using a unique key and a patch. */
  updateProjectTagById: Maybe<UpdateProjectTagPayload>;
  /** Updates a single `Run` using a unique key and a patch. */
  updateRunById: Maybe<UpdateRunPayload>;
  /** Updates a single `TaskActivity` using a unique key and a patch. */
  updateTaskActivityById: Maybe<UpdateTaskActivityPayload>;
  /** Updates a single `TaskActivity` using a unique key and a patch. */
  updateTaskActivityByTaskId: Maybe<UpdateTaskActivityPayload>;
  /** Updates a single `Task` using a unique key and a patch. */
  updateTaskByExecutorId: Maybe<UpdateTaskPayload>;
  /** Updates a single `Task` using a unique key and a patch. */
  updateTaskById: Maybe<UpdateTaskPayload>;
  /** Updates a single `TaskResource` using a unique key and a patch. */
  updateTaskResourceById: Maybe<UpdateTaskResourcePayload>;
  /** Updates a single `TaskResourceUsage` using a unique key and a patch. */
  updateTaskResourceUsageById: Maybe<UpdateTaskResourceUsagePayload>;
  /** Updates a single `TaskResourceUsage` using a unique key and a patch. */
  updateTaskResourceUsageByTaskId: Maybe<UpdateTaskResourceUsagePayload>;
  /** Updates a single `TaskSource` using a unique key and a patch. */
  updateTaskSourceById: Maybe<UpdateTaskSourcePayload>;
  /** Updates a single `TaskStatusLog` using a unique key and a patch. */
  updateTaskStatusLogById: Maybe<UpdateTaskStatusLogPayload>;
  /** Updates a single `TaskStatusLog` using a unique key and a patch. */
  updateTaskStatusLogByTaskIdAndStatus: Maybe<UpdateTaskStatusLogPayload>;
  /** Updates a single `Tenant` using a unique key and a patch. */
  updateTenantById: Maybe<UpdateTenantPayload>;
  /** Updates a single `Tenant` using a unique key and a patch. */
  updateTenantByKey: Maybe<UpdateTenantPayload>;
  /** Updates a single `Tenant` using a unique key and a patch. */
  updateTenantByRepositoryName: Maybe<UpdateTenantPayload>;
  /** Updates a single `Tenant` using a unique key and a patch. */
  updateTenantBySfid: Maybe<UpdateTenantPayload>;
  /** Updates a single `TenantContractAllowance` using a unique key and a patch. */
  updateTenantContractAllowanceById: Maybe<UpdateTenantContractAllowancePayload>;
  /** Updates a single `TenantContractAllowance` using a unique key and a patch. */
  updateTenantContractAllowanceByTenantContractTransactionIdAndQuotaType: Maybe<UpdateTenantContractAllowancePayload>;
  /** Updates a single `TenantContract` using a unique key and a patch. */
  updateTenantContractById: Maybe<UpdateTenantContractPayload>;
  /** Updates a single `TenantContract` using a unique key and a patch. */
  updateTenantContractByName: Maybe<UpdateTenantContractPayload>;
  /** Updates a single `TenantContract` using a unique key and a patch. */
  updateTenantContractBySfid: Maybe<UpdateTenantContractPayload>;
  /** Updates a single `TenantContractTransaction` using a unique key and a patch. */
  updateTenantContractTransactionById: Maybe<UpdateTenantContractTransactionPayload>;
  /** Updates a single `TenantMockuserexecutor` using a unique key and a patch. */
  updateTenantMockuserexecutorByUserexecutorPtrId: Maybe<UpdateTenantMockuserexecutorPayload>;
  /** Updates a single `TenantMonthlyConsumedResource` using a unique key and a patch. */
  updateTenantMonthlyConsumedResourceById: Maybe<UpdateTenantMonthlyConsumedResourcePayload>;
  /** Updates a single `TenantMonthlyConsumedResource` using a unique key and a patch. */
  updateTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract: Maybe<UpdateTenantMonthlyConsumedResourcePayload>;
  /** Updates a single `TenantUserexecutor` using a unique key and a patch. */
  updateTenantUserexecutorById: Maybe<UpdateTenantUserexecutorPayload>;
  /** Updates a single `TesContainerimageexecutor` using a unique key and a patch. */
  updateTesContainerimageexecutorById: Maybe<UpdateTesContainerimageexecutorPayload>;
  /** Updates a single `TesMockcontainerimageexecutor` using a unique key and a patch. */
  updateTesMockcontainerimageexecutorByContainerimageexecutorPtrId: Maybe<UpdateTesMockcontainerimageexecutorPayload>;
  /** Updates a single `TesMocktaskexecutor` using a unique key and a patch. */
  updateTesMocktaskexecutorByTaskexecutorPtrId: Maybe<UpdateTesMocktaskexecutorPayload>;
  /** Updates a single `TesTaskexecutor` using a unique key and a patch. */
  updateTesTaskexecutorById: Maybe<UpdateTesTaskexecutorPayload>;
  /** Updates a single `Tool` using a unique key and a patch. */
  updateToolById: Maybe<UpdateToolPayload>;
  /** Updates a single `Tool` using a unique key and a patch. */
  updateToolByProjectId: Maybe<UpdateToolPayload>;
  /** Updates a single `ToolParameter` using a unique key and a patch. */
  updateToolParameterById: Maybe<UpdateToolParameterPayload>;
  /** Updates a single `ToolResource` using a unique key and a patch. */
  updateToolResourceById: Maybe<UpdateToolResourcePayload>;
  /** Updates a single `ToolResource` using a unique key and a patch. */
  updateToolResourceByTypeAndToolVersionId: Maybe<UpdateToolResourcePayload>;
  /** Updates a single `ToolResult` using a unique key and a patch. */
  updateToolResultById: Maybe<UpdateToolResultPayload>;
  /** Updates a single `ToolSecret` using a unique key and a patch. */
  updateToolSecretById: Maybe<UpdateToolSecretPayload>;
  /** Updates a single `ToolSource` using a unique key and a patch. */
  updateToolSourceById: Maybe<UpdateToolSourcePayload>;
  /** Updates a single `ToolTenant` using a unique key and a patch. */
  updateToolTenantById: Maybe<UpdateToolTenantPayload>;
  /** Updates a single `ToolTenant` using a unique key and a patch. */
  updateToolTenantByToolIdAndTenantId: Maybe<UpdateToolTenantPayload>;
  /** Updates a single `ToolVersion` using a unique key and a patch. */
  updateToolVersionById: Maybe<UpdateToolVersionPayload>;
  /** Updates a single `Toolbox` using a unique key and a patch. */
  updateToolboxById: Maybe<UpdateToolboxPayload>;
  /** Updates a single `Toolbox` using a unique key and a patch. */
  updateToolboxByKey: Maybe<UpdateToolboxPayload>;
  /** Updates a single `ToolboxTenant` using a unique key and a patch. */
  updateToolboxTenantById: Maybe<UpdateToolboxTenantPayload>;
  /** Updates a single `ToolboxTenant` using a unique key and a patch. */
  updateToolboxTenantByToolboxIdAndTenantId: Maybe<UpdateToolboxTenantPayload>;
  /** Updates a single `UserPersonalSpaceRequest` using a unique key and a patch. */
  updateUserPersonalSpaceRequestById: Maybe<UpdateUserPersonalSpaceRequestPayload>;
  /** Updates a single `WaffleFlag` using a unique key and a patch. */
  updateWaffleFlagById: Maybe<UpdateWaffleFlagPayload>;
  /** Updates a single `WaffleFlag` using a unique key and a patch. */
  updateWaffleFlagByName: Maybe<UpdateWaffleFlagPayload>;
  /** Updates a single `WaffleSample` using a unique key and a patch. */
  updateWaffleSampleById: Maybe<UpdateWaffleSamplePayload>;
  /** Updates a single `WaffleSample` using a unique key and a patch. */
  updateWaffleSampleByName: Maybe<UpdateWaffleSamplePayload>;
  /** Updates a single `WaffleSwitch` using a unique key and a patch. */
  updateWaffleSwitchById: Maybe<UpdateWaffleSwitchPayload>;
  /** Updates a single `WaffleSwitch` using a unique key and a patch. */
  updateWaffleSwitchByName: Maybe<UpdateWaffleSwitchPayload>;
  /** Updates a single `Workflow` using a unique key and a patch. */
  updateWorkflowById: Maybe<UpdateWorkflowPayload>;
  /** Updates a single `WorkflowDatum` using a unique key and a patch. */
  updateWorkflowDatumById: Maybe<UpdateWorkflowDatumPayload>;
  /** Updates a single `WorkflowResult` using a unique key and a patch. */
  updateWorkflowResultById: Maybe<UpdateWorkflowResultPayload>;
  /** Updates a single `WorkflowResultWorkflowVersion` using a unique key and a patch. */
  updateWorkflowResultWorkflowVersionById: Maybe<UpdateWorkflowResultWorkflowVersionPayload>;
  /** Updates a single `WorkflowResultWorkflowVersion` using a unique key and a patch. */
  updateWorkflowResultWorkflowVersionByResultIdAndWorkflowversionId: Maybe<UpdateWorkflowResultWorkflowVersionPayload>;
  /** Updates a single `WorkflowSectionBlock` using a unique key and a patch. */
  updateWorkflowSectionBlockById: Maybe<UpdateWorkflowSectionBlockPayload>;
  /** Updates a single `WorkflowSectionBlockSection` using a unique key and a patch. */
  updateWorkflowSectionBlockSectionByBlockIdAndSectionId: Maybe<UpdateWorkflowSectionBlockSectionPayload>;
  /** Updates a single `WorkflowSectionBlockSection` using a unique key and a patch. */
  updateWorkflowSectionBlockSectionById: Maybe<UpdateWorkflowSectionBlockSectionPayload>;
  /** Updates a single `WorkflowSection` using a unique key and a patch. */
  updateWorkflowSectionById: Maybe<UpdateWorkflowSectionPayload>;
  /** Updates a single `WorkflowSectionWorkflowVersion` using a unique key and a patch. */
  updateWorkflowSectionWorkflowVersionById: Maybe<UpdateWorkflowSectionWorkflowVersionPayload>;
  /** Updates a single `WorkflowSectionWorkflowVersion` using a unique key and a patch. */
  updateWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionId: Maybe<UpdateWorkflowSectionWorkflowVersionPayload>;
  /** Updates a single `WorkflowSource` using a unique key and a patch. */
  updateWorkflowSourceById: Maybe<UpdateWorkflowSourcePayload>;
  /** Updates a single `WorkflowSourceWorkflowVersion` using a unique key and a patch. */
  updateWorkflowSourceWorkflowVersionById: Maybe<UpdateWorkflowSourceWorkflowVersionPayload>;
  /** Updates a single `WorkflowSourceWorkflowVersion` using a unique key and a patch. */
  updateWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionId: Maybe<UpdateWorkflowSourceWorkflowVersionPayload>;
  /** Updates a single `WorkflowVersion` using a unique key and a patch. */
  updateWorkflowVersionById: Maybe<UpdateWorkflowVersionPayload>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationChangeUserSessionArgs = {
  input: ChangeUserSessionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAdminProjectArgs = {
  input: CreateAdminProjectInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateApplicationUserArgs = {
  input: CreateApplicationUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateApplicationUserGroupArgs = {
  input: CreateApplicationUserGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateApplicationUserMembershipArgs = {
  input: CreateApplicationUserMembershipInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateApplicationUserMetadatumArgs = {
  input: CreateApplicationUserMetadatumInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateApplicationUserSessionArgs = {
  input: CreateApplicationUserSessionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateApplicationUserUserPermissionArgs = {
  input: CreateApplicationUserUserPermissionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAuditlogLogentryArgs = {
  input: CreateAuditlogLogentryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAuthGroupArgs = {
  input: CreateAuthGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAuthGroupPermissionArgs = {
  input: CreateAuthGroupPermissionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAuthPermissionArgs = {
  input: CreateAuthPermissionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAvailableNonRestrictedProjectArgs = {
  input: CreateAvailableNonRestrictedProjectInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAvatarArgs = {
  input: CreateAvatarInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAwsBatchTaskArgs = {
  input: CreateAwsBatchTaskInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAwsCognitoUserArgs = {
  input: CreateAwsCognitoUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAwsEcrImageArgs = {
  input: CreateAwsEcrImageInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAwsMockBatchTaskArgs = {
  input: CreateAwsMockBatchTaskInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAwsMockDistributionImageArgs = {
  input: CreateAwsMockDistributionImageInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAwsMockEcrImageArgs = {
  input: CreateAwsMockEcrImageInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAwsMockIamUserArgs = {
  input: CreateAwsMockIamUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAwsMockS3FileArgs = {
  input: CreateAwsMockS3FileInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAwsS3FileArgs = {
  input: CreateAwsS3FileInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCodeFileArgs = {
  input: CreateCodeFileInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCommandArgs = {
  input: CreateCommandInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContainerImageArgs = {
  input: CreateContainerImageInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContainerImageRepositoryArgs = {
  input: CreateContainerImageRepositoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCostArgs = {
  input: CreateCostInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCurrentApplicationUserArgs = {
  input: CreateCurrentApplicationUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDistributionRegistryImageArgs = {
  input: CreateDistributionRegistryImageInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDjangoAdminLogArgs = {
  input: CreateDjangoAdminLogInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDjangoContentTypeArgs = {
  input: CreateDjangoContentTypeInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDjangoMigrationArgs = {
  input: CreateDjangoMigrationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDjangoSesBlacklistedemailArgs = {
  input: CreateDjangoSesBlacklistedemailInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDjangoSesSesstatArgs = {
  input: CreateDjangoSesSesstatInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDjangoSessionArgs = {
  input: CreateDjangoSessionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDrsFileexecutorArgs = {
  input: CreateDrsFileexecutorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDrsMockfileexecutorArgs = {
  input: CreateDrsMockfileexecutorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEulaVersionArgs = {
  input: CreateEulaVersionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEulaVersionUserAcceptanceArgs = {
  input: CreateEulaVersionUserAcceptanceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFeatureFlagArgs = {
  input: CreateFeatureFlagInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFeatureFlagsGroupArgs = {
  input: CreateFeatureFlagsGroupInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFeatureFlagsTenantArgs = {
  input: CreateFeatureFlagsTenantInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFeatureFlagsUserArgs = {
  input: CreateFeatureFlagsUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFileArgs = {
  input: CreateFileInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFileActivityArgs = {
  input: CreateFileActivityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFileMetadatumArgs = {
  input: CreateFileMetadatumInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFileOutputGroupMetadatumArgs = {
  input: CreateFileOutputGroupMetadatumInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFilesByExecutorArgs = {
  input: CreateFilesByExecutorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMetadataValueArgs = {
  input: CreateMetadataValueInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMetadatumArgs = {
  input: CreateMetadatumInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOutputGroupFileArgs = {
  input: CreateOutputGroupFileInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePinnedToolArgs = {
  input: CreatePinnedToolInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectFolderArgs = {
  input: CreateProjectFolderInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectTagArgs = {
  input: CreateProjectTagInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRunArgs = {
  input: CreateRunInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSessionArgs = {
  input: CreateSessionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTaskActivityArgs = {
  input: CreateTaskActivityInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTaskResourceArgs = {
  input: CreateTaskResourceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTaskResourceUsageArgs = {
  input: CreateTaskResourceUsageInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTaskSourceArgs = {
  input: CreateTaskSourceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTaskStatusLogArgs = {
  input: CreateTaskStatusLogInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTenantArgs = {
  input: CreateTenantInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTenantContractArgs = {
  input: CreateTenantContractInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTenantContractAllowanceArgs = {
  input: CreateTenantContractAllowanceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTenantContractTransactionArgs = {
  input: CreateTenantContractTransactionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTenantMockuserexecutorArgs = {
  input: CreateTenantMockuserexecutorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTenantMonthlyConsumedResourceArgs = {
  input: CreateTenantMonthlyConsumedResourceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTenantUserexecutorArgs = {
  input: CreateTenantUserexecutorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTesContainerimageexecutorArgs = {
  input: CreateTesContainerimageexecutorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTesMockcontainerimageexecutorArgs = {
  input: CreateTesMockcontainerimageexecutorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTesMocktaskexecutorArgs = {
  input: CreateTesMocktaskexecutorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTesTaskexecutorArgs = {
  input: CreateTesTaskexecutorInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateToolArgs = {
  input: CreateToolInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateToolParameterArgs = {
  input: CreateToolParameterInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateToolResourceArgs = {
  input: CreateToolResourceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateToolResultArgs = {
  input: CreateToolResultInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateToolSecretArgs = {
  input: CreateToolSecretInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateToolSourceArgs = {
  input: CreateToolSourceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateToolTenantArgs = {
  input: CreateToolTenantInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateToolVersionArgs = {
  input: CreateToolVersionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateToolboxArgs = {
  input: CreateToolboxInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateToolboxTenantArgs = {
  input: CreateToolboxTenantInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserPersonalSpaceRequestArgs = {
  input: CreateUserPersonalSpaceRequestInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWaffleFlagArgs = {
  input: CreateWaffleFlagInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWaffleSampleArgs = {
  input: CreateWaffleSampleInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWaffleSwitchArgs = {
  input: CreateWaffleSwitchInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkflowArgs = {
  input: CreateWorkflowInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkflowDatumArgs = {
  input: CreateWorkflowDatumInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkflowResultArgs = {
  input: CreateWorkflowResultInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkflowResultWorkflowVersionArgs = {
  input: CreateWorkflowResultWorkflowVersionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkflowSectionArgs = {
  input: CreateWorkflowSectionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkflowSectionBlockArgs = {
  input: CreateWorkflowSectionBlockInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkflowSectionBlockSectionArgs = {
  input: CreateWorkflowSectionBlockSectionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkflowSectionWorkflowVersionArgs = {
  input: CreateWorkflowSectionWorkflowVersionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkflowSourceArgs = {
  input: CreateWorkflowSourceInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkflowSourceWorkflowVersionArgs = {
  input: CreateWorkflowSourceWorkflowVersionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkflowVersionArgs = {
  input: CreateWorkflowVersionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteApplicationUserByEmailArgs = {
  input: DeleteApplicationUserByEmailInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteApplicationUserByGlobalUserIdArgs = {
  input: DeleteApplicationUserByGlobalUserIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteApplicationUserByIdArgs = {
  input: DeleteApplicationUserByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteApplicationUserByUsernameArgs = {
  input: DeleteApplicationUserByUsernameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteApplicationUserGroupByIdArgs = {
  input: DeleteApplicationUserGroupByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteApplicationUserGroupByUserIdAndGroupIdArgs = {
  input: DeleteApplicationUserGroupByUserIdAndGroupIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteApplicationUserMembershipByIdArgs = {
  input: DeleteApplicationUserMembershipByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteApplicationUserMembershipByUserIdAndTenantIdArgs = {
  input: DeleteApplicationUserMembershipByUserIdAndTenantIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteApplicationUserMetadatumByIdArgs = {
  input: DeleteApplicationUserMetadatumByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteApplicationUserMetadatumByUserIdAndKeyArgs = {
  input: DeleteApplicationUserMetadatumByUserIdAndKeyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteApplicationUserSessionByIdArgs = {
  input: DeleteApplicationUserSessionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteApplicationUserUserPermissionByIdArgs = {
  input: DeleteApplicationUserUserPermissionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteApplicationUserUserPermissionByUserIdAndPermissionIdArgs =
  {
    input: DeleteApplicationUserUserPermissionByUserIdAndPermissionIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAuditlogLogentryByIdArgs = {
  input: DeleteAuditlogLogentryByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAuthGroupByIdArgs = {
  input: DeleteAuthGroupByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAuthGroupByNameArgs = {
  input: DeleteAuthGroupByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAuthGroupPermissionByGroupIdAndPermissionIdArgs = {
  input: DeleteAuthGroupPermissionByGroupIdAndPermissionIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAuthGroupPermissionByIdArgs = {
  input: DeleteAuthGroupPermissionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAuthPermissionByContentTypeIdAndCodenameArgs = {
  input: DeleteAuthPermissionByContentTypeIdAndCodenameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAuthPermissionByIdArgs = {
  input: DeleteAuthPermissionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAvatarByIdArgs = {
  input: DeleteAvatarByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAvatarByUserIdArgs = {
  input: DeleteAvatarByUserIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAwsBatchTaskByTaskexecutorPtrIdArgs = {
  input: DeleteAwsBatchTaskByTaskexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAwsCognitoUserByUserexecutorPtrIdArgs = {
  input: DeleteAwsCognitoUserByUserexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAwsEcrImageByContainerimageexecutorPtrIdArgs = {
  input: DeleteAwsEcrImageByContainerimageexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAwsMockBatchTaskByAwstaskexecutorPtrIdArgs = {
  input: DeleteAwsMockBatchTaskByAwstaskexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdArgs =
  {
    input: DeleteAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAwsMockEcrImageByAwscontainerimageexecutorPtrIdArgs =
  {
    input: DeleteAwsMockEcrImageByAwscontainerimageexecutorPtrIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAwsMockIamUserByAwsuserexecutorPtrIdArgs = {
  input: DeleteAwsMockIamUserByAwsuserexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAwsMockS3FileByAwsfileexecutorPtrIdArgs = {
  input: DeleteAwsMockS3FileByAwsfileexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAwsS3FileByFileexecutorPtrIdArgs = {
  input: DeleteAwsS3FileByFileexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCodeFileByIdArgs = {
  input: DeleteCodeFileByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCommandByIdArgs = {
  input: DeleteCommandByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCommandByToolVersionIdArgs = {
  input: DeleteCommandByToolVersionIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCommandByToolVersionIdAndCodeFileIdArgs = {
  input: DeleteCommandByToolVersionIdAndCodeFileIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContainerImageByExecutorIdArgs = {
  input: DeleteContainerImageByExecutorIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContainerImageByIdArgs = {
  input: DeleteContainerImageByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContainerImageRepositoryByIdArgs = {
  input: DeleteContainerImageRepositoryByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContainerImageRepositoryByNameAndTenantIdAndRegistryTypeArgs =
  {
    input: DeleteContainerImageRepositoryByNameAndTenantIdAndRegistryTypeInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContainerImageRepositoryByRepositoryArgs = {
  input: DeleteContainerImageRepositoryByRepositoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCostByIdArgs = {
  input: DeleteCostByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDistributionRegistryImageByContainerimageexecutorPtrIdArgs =
  {
    input: DeleteDistributionRegistryImageByContainerimageexecutorPtrIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDjangoAdminLogByIdArgs = {
  input: DeleteDjangoAdminLogByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDjangoContentTypeByAppLabelAndModelArgs = {
  input: DeleteDjangoContentTypeByAppLabelAndModelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDjangoContentTypeByIdArgs = {
  input: DeleteDjangoContentTypeByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDjangoMigrationByIdArgs = {
  input: DeleteDjangoMigrationByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDjangoSesBlacklistedemailByEmailArgs = {
  input: DeleteDjangoSesBlacklistedemailByEmailInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDjangoSesBlacklistedemailByIdArgs = {
  input: DeleteDjangoSesBlacklistedemailByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDjangoSesSesstatByDateArgs = {
  input: DeleteDjangoSesSesstatByDateInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDjangoSesSesstatByIdArgs = {
  input: DeleteDjangoSesSesstatByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDjangoSessionBySessionKeyArgs = {
  input: DeleteDjangoSessionBySessionKeyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDrsFileexecutorByIdArgs = {
  input: DeleteDrsFileexecutorByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDrsMockfileexecutorByFileexecutorPtrIdArgs = {
  input: DeleteDrsMockfileexecutorByFileexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEulaVersionByIdArgs = {
  input: DeleteEulaVersionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEulaVersionByVersionArgs = {
  input: DeleteEulaVersionByVersionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEulaVersionUserAcceptanceByIdArgs = {
  input: DeleteEulaVersionUserAcceptanceByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEulaVersionUserAcceptanceByUserIdAndEulaVersionIdArgs =
  {
    input: DeleteEulaVersionUserAcceptanceByUserIdAndEulaVersionIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeatureFlagByIdArgs = {
  input: DeleteFeatureFlagByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeatureFlagByNameArgs = {
  input: DeleteFeatureFlagByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeatureFlagsGroupByFeatureflagIdAndGroupIdArgs = {
  input: DeleteFeatureFlagsGroupByFeatureflagIdAndGroupIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeatureFlagsGroupByIdArgs = {
  input: DeleteFeatureFlagsGroupByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeatureFlagsTenantByFeatureflagIdAndTenantIdArgs = {
  input: DeleteFeatureFlagsTenantByFeatureflagIdAndTenantIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeatureFlagsTenantByIdArgs = {
  input: DeleteFeatureFlagsTenantByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeatureFlagsUserByFeatureflagIdAndUserIdArgs = {
  input: DeleteFeatureFlagsUserByFeatureflagIdAndUserIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFeatureFlagsUserByIdArgs = {
  input: DeleteFeatureFlagsUserByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFileActivityByIdArgs = {
  input: DeleteFileActivityByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFileByIdArgs = {
  input: DeleteFileByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFileByProjectIdAndReferenceIdArgs = {
  input: DeleteFileByProjectIdAndReferenceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFileMetadatumByIdArgs = {
  input: DeleteFileMetadatumByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFileOutputGroupByIdArgs = {
  input: DeleteFileOutputGroupByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFileOutputGroupByTaskIdArgs = {
  input: DeleteFileOutputGroupByTaskIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFileOutputGroupMetadatumByIdArgs = {
  input: DeleteFileOutputGroupMetadatumByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMetadataValueByIdArgs = {
  input: DeleteMetadataValueByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMetadatumByIdArgs = {
  input: DeleteMetadatumByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOutputGroupFileByIdArgs = {
  input: DeleteOutputGroupFileByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePinnedToolByIdArgs = {
  input: DeletePinnedToolByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePinnedToolByUserIdAndToolIdArgs = {
  input: DeletePinnedToolByUserIdAndToolIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectFolderByIdArgs = {
  input: DeleteProjectFolderByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectTagByIdArgs = {
  input: DeleteProjectTagByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRunByIdArgs = {
  input: DeleteRunByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSessionArgs = {
  input: DeleteSessionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTaskActivityByIdArgs = {
  input: DeleteTaskActivityByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTaskActivityByTaskIdArgs = {
  input: DeleteTaskActivityByTaskIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTaskByExecutorIdArgs = {
  input: DeleteTaskByExecutorIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTaskByIdArgs = {
  input: DeleteTaskByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTaskResourceByIdArgs = {
  input: DeleteTaskResourceByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTaskResourceUsageByIdArgs = {
  input: DeleteTaskResourceUsageByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTaskResourceUsageByTaskIdArgs = {
  input: DeleteTaskResourceUsageByTaskIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTaskSourceByIdArgs = {
  input: DeleteTaskSourceByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTaskStatusLogByIdArgs = {
  input: DeleteTaskStatusLogByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTaskStatusLogByTaskIdAndStatusArgs = {
  input: DeleteTaskStatusLogByTaskIdAndStatusInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantByIdArgs = {
  input: DeleteTenantByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantByKeyArgs = {
  input: DeleteTenantByKeyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantByRepositoryNameArgs = {
  input: DeleteTenantByRepositoryNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantBySfidArgs = {
  input: DeleteTenantBySfidInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantContractAllowanceByIdArgs = {
  input: DeleteTenantContractAllowanceByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeArgs =
  {
    input: DeleteTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantContractByIdArgs = {
  input: DeleteTenantContractByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantContractByNameArgs = {
  input: DeleteTenantContractByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantContractBySfidArgs = {
  input: DeleteTenantContractBySfidInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantContractTransactionByIdArgs = {
  input: DeleteTenantContractTransactionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantMockuserexecutorByUserexecutorPtrIdArgs = {
  input: DeleteTenantMockuserexecutorByUserexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantMonthlyConsumedResourceByIdArgs = {
  input: DeleteTenantMonthlyConsumedResourceByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractArgs =
  {
    input: DeleteTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantUserexecutorByIdArgs = {
  input: DeleteTenantUserexecutorByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTesContainerimageexecutorByIdArgs = {
  input: DeleteTesContainerimageexecutorByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTesMockcontainerimageexecutorByContainerimageexecutorPtrIdArgs =
  {
    input: DeleteTesMockcontainerimageexecutorByContainerimageexecutorPtrIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTesMocktaskexecutorByTaskexecutorPtrIdArgs = {
  input: DeleteTesMocktaskexecutorByTaskexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTesTaskexecutorByIdArgs = {
  input: DeleteTesTaskexecutorByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteToolByIdArgs = {
  input: DeleteToolByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteToolByProjectIdArgs = {
  input: DeleteToolByProjectIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteToolParameterByIdArgs = {
  input: DeleteToolParameterByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteToolResourceByIdArgs = {
  input: DeleteToolResourceByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteToolResourceByTypeAndToolVersionIdArgs = {
  input: DeleteToolResourceByTypeAndToolVersionIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteToolResultByIdArgs = {
  input: DeleteToolResultByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteToolSecretByIdArgs = {
  input: DeleteToolSecretByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteToolSourceByIdArgs = {
  input: DeleteToolSourceByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteToolTenantByIdArgs = {
  input: DeleteToolTenantByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteToolTenantByToolIdAndTenantIdArgs = {
  input: DeleteToolTenantByToolIdAndTenantIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteToolVersionByIdArgs = {
  input: DeleteToolVersionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteToolboxByIdArgs = {
  input: DeleteToolboxByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteToolboxByKeyArgs = {
  input: DeleteToolboxByKeyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteToolboxTenantByIdArgs = {
  input: DeleteToolboxTenantByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteToolboxTenantByToolboxIdAndTenantIdArgs = {
  input: DeleteToolboxTenantByToolboxIdAndTenantIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserPersonalSpaceRequestByIdArgs = {
  input: DeleteUserPersonalSpaceRequestByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWaffleFlagByIdArgs = {
  input: DeleteWaffleFlagByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWaffleFlagByNameArgs = {
  input: DeleteWaffleFlagByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWaffleSampleByIdArgs = {
  input: DeleteWaffleSampleByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWaffleSampleByNameArgs = {
  input: DeleteWaffleSampleByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWaffleSwitchByIdArgs = {
  input: DeleteWaffleSwitchByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWaffleSwitchByNameArgs = {
  input: DeleteWaffleSwitchByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkflowByIdArgs = {
  input: DeleteWorkflowByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkflowDatumByIdArgs = {
  input: DeleteWorkflowDatumByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkflowResultByIdArgs = {
  input: DeleteWorkflowResultByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkflowResultWorkflowVersionByIdArgs = {
  input: DeleteWorkflowResultWorkflowVersionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdArgs =
  {
    input: DeleteWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkflowSectionBlockByIdArgs = {
  input: DeleteWorkflowSectionBlockByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkflowSectionBlockSectionByBlockIdAndSectionIdArgs =
  {
    input: DeleteWorkflowSectionBlockSectionByBlockIdAndSectionIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkflowSectionBlockSectionByIdArgs = {
  input: DeleteWorkflowSectionBlockSectionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkflowSectionByIdArgs = {
  input: DeleteWorkflowSectionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkflowSectionWorkflowVersionByIdArgs = {
  input: DeleteWorkflowSectionWorkflowVersionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdArgs =
  {
    input: DeleteWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkflowSourceByIdArgs = {
  input: DeleteWorkflowSourceByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkflowSourceWorkflowVersionByIdArgs = {
  input: DeleteWorkflowSourceWorkflowVersionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdArgs =
  {
    input: DeleteWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkflowVersionByIdArgs = {
  input: DeleteWorkflowVersionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserByEmailArgs = {
  input: UpdateApplicationUserByEmailInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserByGlobalUserIdArgs = {
  input: UpdateApplicationUserByGlobalUserIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserByIdArgs = {
  input: UpdateApplicationUserByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserByUsernameArgs = {
  input: UpdateApplicationUserByUsernameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserGroupByIdArgs = {
  input: UpdateApplicationUserGroupByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserGroupByUserIdAndGroupIdArgs = {
  input: UpdateApplicationUserGroupByUserIdAndGroupIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserMembershipByIdArgs = {
  input: UpdateApplicationUserMembershipByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserMembershipByUserIdAndTenantIdArgs = {
  input: UpdateApplicationUserMembershipByUserIdAndTenantIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserMetadatumByIdArgs = {
  input: UpdateApplicationUserMetadatumByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserMetadatumByUserIdAndKeyArgs = {
  input: UpdateApplicationUserMetadatumByUserIdAndKeyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserSessionByIdArgs = {
  input: UpdateApplicationUserSessionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserUserPermissionByIdArgs = {
  input: UpdateApplicationUserUserPermissionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateApplicationUserUserPermissionByUserIdAndPermissionIdArgs =
  {
    input: UpdateApplicationUserUserPermissionByUserIdAndPermissionIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuditlogLogentryByIdArgs = {
  input: UpdateAuditlogLogentryByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuthGroupByIdArgs = {
  input: UpdateAuthGroupByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuthGroupByNameArgs = {
  input: UpdateAuthGroupByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuthGroupPermissionByGroupIdAndPermissionIdArgs = {
  input: UpdateAuthGroupPermissionByGroupIdAndPermissionIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuthGroupPermissionByIdArgs = {
  input: UpdateAuthGroupPermissionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuthPermissionByContentTypeIdAndCodenameArgs = {
  input: UpdateAuthPermissionByContentTypeIdAndCodenameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuthPermissionByIdArgs = {
  input: UpdateAuthPermissionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAvatarByIdArgs = {
  input: UpdateAvatarByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAvatarByUserIdArgs = {
  input: UpdateAvatarByUserIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAwsBatchTaskByTaskexecutorPtrIdArgs = {
  input: UpdateAwsBatchTaskByTaskexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAwsCognitoUserByUserexecutorPtrIdArgs = {
  input: UpdateAwsCognitoUserByUserexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAwsEcrImageByContainerimageexecutorPtrIdArgs = {
  input: UpdateAwsEcrImageByContainerimageexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAwsMockBatchTaskByAwstaskexecutorPtrIdArgs = {
  input: UpdateAwsMockBatchTaskByAwstaskexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdArgs =
  {
    input: UpdateAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAwsMockEcrImageByAwscontainerimageexecutorPtrIdArgs =
  {
    input: UpdateAwsMockEcrImageByAwscontainerimageexecutorPtrIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAwsMockIamUserByAwsuserexecutorPtrIdArgs = {
  input: UpdateAwsMockIamUserByAwsuserexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAwsMockS3FileByAwsfileexecutorPtrIdArgs = {
  input: UpdateAwsMockS3FileByAwsfileexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAwsS3FileByFileexecutorPtrIdArgs = {
  input: UpdateAwsS3FileByFileexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCodeFileByIdArgs = {
  input: UpdateCodeFileByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCommandByIdArgs = {
  input: UpdateCommandByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCommandByToolVersionIdArgs = {
  input: UpdateCommandByToolVersionIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCommandByToolVersionIdAndCodeFileIdArgs = {
  input: UpdateCommandByToolVersionIdAndCodeFileIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContainerImageByExecutorIdArgs = {
  input: UpdateContainerImageByExecutorIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContainerImageByIdArgs = {
  input: UpdateContainerImageByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContainerImageRepositoryByIdArgs = {
  input: UpdateContainerImageRepositoryByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContainerImageRepositoryByNameAndTenantIdAndRegistryTypeArgs =
  {
    input: UpdateContainerImageRepositoryByNameAndTenantIdAndRegistryTypeInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContainerImageRepositoryByRepositoryArgs = {
  input: UpdateContainerImageRepositoryByRepositoryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCostByIdArgs = {
  input: UpdateCostByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDistributionRegistryImageByContainerimageexecutorPtrIdArgs =
  {
    input: UpdateDistributionRegistryImageByContainerimageexecutorPtrIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDjangoAdminLogByIdArgs = {
  input: UpdateDjangoAdminLogByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDjangoContentTypeByAppLabelAndModelArgs = {
  input: UpdateDjangoContentTypeByAppLabelAndModelInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDjangoContentTypeByIdArgs = {
  input: UpdateDjangoContentTypeByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDjangoMigrationByIdArgs = {
  input: UpdateDjangoMigrationByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDjangoSesBlacklistedemailByEmailArgs = {
  input: UpdateDjangoSesBlacklistedemailByEmailInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDjangoSesBlacklistedemailByIdArgs = {
  input: UpdateDjangoSesBlacklistedemailByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDjangoSesSesstatByDateArgs = {
  input: UpdateDjangoSesSesstatByDateInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDjangoSesSesstatByIdArgs = {
  input: UpdateDjangoSesSesstatByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDjangoSessionBySessionKeyArgs = {
  input: UpdateDjangoSessionBySessionKeyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDrsFileexecutorByIdArgs = {
  input: UpdateDrsFileexecutorByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDrsMockfileexecutorByFileexecutorPtrIdArgs = {
  input: UpdateDrsMockfileexecutorByFileexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEulaVersionByIdArgs = {
  input: UpdateEulaVersionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEulaVersionByVersionArgs = {
  input: UpdateEulaVersionByVersionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEulaVersionUserAcceptanceByIdArgs = {
  input: UpdateEulaVersionUserAcceptanceByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEulaVersionUserAcceptanceByUserIdAndEulaVersionIdArgs =
  {
    input: UpdateEulaVersionUserAcceptanceByUserIdAndEulaVersionIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeatureFlagByIdArgs = {
  input: UpdateFeatureFlagByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeatureFlagByNameArgs = {
  input: UpdateFeatureFlagByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeatureFlagsGroupByFeatureflagIdAndGroupIdArgs = {
  input: UpdateFeatureFlagsGroupByFeatureflagIdAndGroupIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeatureFlagsGroupByIdArgs = {
  input: UpdateFeatureFlagsGroupByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeatureFlagsTenantByFeatureflagIdAndTenantIdArgs = {
  input: UpdateFeatureFlagsTenantByFeatureflagIdAndTenantIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeatureFlagsTenantByIdArgs = {
  input: UpdateFeatureFlagsTenantByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeatureFlagsUserByFeatureflagIdAndUserIdArgs = {
  input: UpdateFeatureFlagsUserByFeatureflagIdAndUserIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFeatureFlagsUserByIdArgs = {
  input: UpdateFeatureFlagsUserByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFileActivityByIdArgs = {
  input: UpdateFileActivityByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFileByIdArgs = {
  input: UpdateFileByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFileByProjectIdAndReferenceIdArgs = {
  input: UpdateFileByProjectIdAndReferenceIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFileMetadatumByIdArgs = {
  input: UpdateFileMetadatumByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFileOutputGroupByIdArgs = {
  input: UpdateFileOutputGroupByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFileOutputGroupByTaskIdArgs = {
  input: UpdateFileOutputGroupByTaskIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFileOutputGroupMetadatumByIdArgs = {
  input: UpdateFileOutputGroupMetadatumByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMetadataValueByIdArgs = {
  input: UpdateMetadataValueByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMetadatumByIdArgs = {
  input: UpdateMetadatumByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateNotificationByIdArgs = {
  input: UpdateNotificationByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOutputGroupFileByIdArgs = {
  input: UpdateOutputGroupFileByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePinnedToolByIdArgs = {
  input: UpdatePinnedToolByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePinnedToolByUserIdAndToolIdArgs = {
  input: UpdatePinnedToolByUserIdAndToolIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectFolderByIdArgs = {
  input: UpdateProjectFolderByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectTagByIdArgs = {
  input: UpdateProjectTagByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRunByIdArgs = {
  input: UpdateRunByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaskActivityByIdArgs = {
  input: UpdateTaskActivityByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaskActivityByTaskIdArgs = {
  input: UpdateTaskActivityByTaskIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaskByExecutorIdArgs = {
  input: UpdateTaskByExecutorIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaskByIdArgs = {
  input: UpdateTaskByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaskResourceByIdArgs = {
  input: UpdateTaskResourceByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaskResourceUsageByIdArgs = {
  input: UpdateTaskResourceUsageByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaskResourceUsageByTaskIdArgs = {
  input: UpdateTaskResourceUsageByTaskIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaskSourceByIdArgs = {
  input: UpdateTaskSourceByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaskStatusLogByIdArgs = {
  input: UpdateTaskStatusLogByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTaskStatusLogByTaskIdAndStatusArgs = {
  input: UpdateTaskStatusLogByTaskIdAndStatusInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantByIdArgs = {
  input: UpdateTenantByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantByKeyArgs = {
  input: UpdateTenantByKeyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantByRepositoryNameArgs = {
  input: UpdateTenantByRepositoryNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantBySfidArgs = {
  input: UpdateTenantBySfidInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantContractAllowanceByIdArgs = {
  input: UpdateTenantContractAllowanceByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeArgs =
  {
    input: UpdateTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantContractByIdArgs = {
  input: UpdateTenantContractByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantContractByNameArgs = {
  input: UpdateTenantContractByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantContractBySfidArgs = {
  input: UpdateTenantContractBySfidInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantContractTransactionByIdArgs = {
  input: UpdateTenantContractTransactionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantMockuserexecutorByUserexecutorPtrIdArgs = {
  input: UpdateTenantMockuserexecutorByUserexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantMonthlyConsumedResourceByIdArgs = {
  input: UpdateTenantMonthlyConsumedResourceByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractArgs =
  {
    input: UpdateTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantUserexecutorByIdArgs = {
  input: UpdateTenantUserexecutorByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTesContainerimageexecutorByIdArgs = {
  input: UpdateTesContainerimageexecutorByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTesMockcontainerimageexecutorByContainerimageexecutorPtrIdArgs =
  {
    input: UpdateTesMockcontainerimageexecutorByContainerimageexecutorPtrIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTesMocktaskexecutorByTaskexecutorPtrIdArgs = {
  input: UpdateTesMocktaskexecutorByTaskexecutorPtrIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTesTaskexecutorByIdArgs = {
  input: UpdateTesTaskexecutorByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateToolByIdArgs = {
  input: UpdateToolByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateToolByProjectIdArgs = {
  input: UpdateToolByProjectIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateToolParameterByIdArgs = {
  input: UpdateToolParameterByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateToolResourceByIdArgs = {
  input: UpdateToolResourceByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateToolResourceByTypeAndToolVersionIdArgs = {
  input: UpdateToolResourceByTypeAndToolVersionIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateToolResultByIdArgs = {
  input: UpdateToolResultByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateToolSecretByIdArgs = {
  input: UpdateToolSecretByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateToolSourceByIdArgs = {
  input: UpdateToolSourceByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateToolTenantByIdArgs = {
  input: UpdateToolTenantByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateToolTenantByToolIdAndTenantIdArgs = {
  input: UpdateToolTenantByToolIdAndTenantIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateToolVersionByIdArgs = {
  input: UpdateToolVersionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateToolboxByIdArgs = {
  input: UpdateToolboxByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateToolboxByKeyArgs = {
  input: UpdateToolboxByKeyInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateToolboxTenantByIdArgs = {
  input: UpdateToolboxTenantByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateToolboxTenantByToolboxIdAndTenantIdArgs = {
  input: UpdateToolboxTenantByToolboxIdAndTenantIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserPersonalSpaceRequestByIdArgs = {
  input: UpdateUserPersonalSpaceRequestByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWaffleFlagByIdArgs = {
  input: UpdateWaffleFlagByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWaffleFlagByNameArgs = {
  input: UpdateWaffleFlagByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWaffleSampleByIdArgs = {
  input: UpdateWaffleSampleByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWaffleSampleByNameArgs = {
  input: UpdateWaffleSampleByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWaffleSwitchByIdArgs = {
  input: UpdateWaffleSwitchByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWaffleSwitchByNameArgs = {
  input: UpdateWaffleSwitchByNameInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowByIdArgs = {
  input: UpdateWorkflowByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowDatumByIdArgs = {
  input: UpdateWorkflowDatumByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowResultByIdArgs = {
  input: UpdateWorkflowResultByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowResultWorkflowVersionByIdArgs = {
  input: UpdateWorkflowResultWorkflowVersionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdArgs =
  {
    input: UpdateWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowSectionBlockByIdArgs = {
  input: UpdateWorkflowSectionBlockByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowSectionBlockSectionByBlockIdAndSectionIdArgs =
  {
    input: UpdateWorkflowSectionBlockSectionByBlockIdAndSectionIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowSectionBlockSectionByIdArgs = {
  input: UpdateWorkflowSectionBlockSectionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowSectionByIdArgs = {
  input: UpdateWorkflowSectionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowSectionWorkflowVersionByIdArgs = {
  input: UpdateWorkflowSectionWorkflowVersionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdArgs =
  {
    input: UpdateWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowSourceByIdArgs = {
  input: UpdateWorkflowSourceByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowSourceWorkflowVersionByIdArgs = {
  input: UpdateWorkflowSourceWorkflowVersionByIdInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdArgs =
  {
    input: UpdateWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdInput;
  };

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkflowVersionByIdArgs = {
  input: UpdateWorkflowVersionByIdInput;
};

export type Notification = {
  __typename: "Notification";
  /** Reads a single `ApplicationUser` that is related to this `Notification`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateCreated: Scalars["Datetime"]["output"];
  /** Reads a single `FileProcessingNotification` that is related to this `Notification`. */
  fileProcessingNotificationById: Maybe<FileProcessingNotification>;
  /**
   * Reads and enables pagination through a set of `FileProcessingNotification`.
   * @deprecated Please use fileProcessingNotificationById instead
   */
  fileProcessingNotificationsById: FileProcessingNotificationsConnection;
  hasSeen: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  /** Reads a single `ProjectClonedNotification` that is related to this `Notification`. */
  projectClonedNotificationById: Maybe<ProjectClonedNotification>;
  /**
   * Reads and enables pagination through a set of `ProjectClonedNotification`.
   * @deprecated Please use projectClonedNotificationById instead
   */
  projectClonedNotificationsById: ProjectClonedNotificationsConnection;
  /** Reads a single `ProjectSharedNotification` that is related to this `Notification`. */
  projectSharedNotificationById: Maybe<ProjectSharedNotification>;
  /**
   * Reads and enables pagination through a set of `ProjectSharedNotification`.
   * @deprecated Please use projectSharedNotificationById instead
   */
  projectSharedNotificationsById: ProjectSharedNotificationsConnection;
  /** Reads a single `RoleChangeNotification` that is related to this `Notification`. */
  roleChangeNotificationById: Maybe<RoleChangeNotification>;
  /**
   * Reads and enables pagination through a set of `RoleChangeNotification`.
   * @deprecated Please use roleChangeNotificationById instead
   */
  roleChangeNotificationsById: RoleChangeNotificationsConnection;
  /** Reads a single `TenantUserMembershipNotification` that is related to this `Notification`. */
  tenantUserMembershipNotificationById: Maybe<TenantUserMembershipNotification>;
  /**
   * Reads and enables pagination through a set of `TenantUserMembershipNotification`.
   * @deprecated Please use tenantUserMembershipNotificationById instead
   */
  tenantUserMembershipNotificationsById: TenantUserMembershipNotificationsConnection;
  userId: Scalars["UUID"]["output"];
};

export type NotificationFileProcessingNotificationsByIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileProcessingNotificationCondition>;
  filter?: InputMaybe<FileProcessingNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileProcessingNotificationsOrderBy>>;
};

export type NotificationProjectClonedNotificationsByIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectClonedNotificationCondition>;
  filter?: InputMaybe<ProjectClonedNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectClonedNotificationsOrderBy>>;
};

export type NotificationProjectSharedNotificationsByIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectSharedNotificationCondition>;
  filter?: InputMaybe<ProjectSharedNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectSharedNotificationsOrderBy>>;
};

export type NotificationRoleChangeNotificationsByIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<RoleChangeNotificationCondition>;
  filter?: InputMaybe<RoleChangeNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<RoleChangeNotificationsOrderBy>>;
};

export type NotificationTenantUserMembershipNotificationsByIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantUserMembershipNotificationCondition>;
  filter?: InputMaybe<TenantUserMembershipNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantUserMembershipNotificationsOrderBy>>;
};

/**
 * A condition to be used against `Notification` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type NotificationCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `hasSeen` field. */
  hasSeen?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `Notification` object types. All fields are combined with a logical ‘and.’ */
export type NotificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NotificationFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileProcessingNotificationById` relation. */
  fileProcessingNotificationById?: InputMaybe<FileProcessingNotificationFilter>;
  /** A related `fileProcessingNotificationById` exists. */
  fileProcessingNotificationByIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `hasSeen` field. */
  hasSeen?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NotificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NotificationFilter>>;
  /** Filter by the object’s `projectClonedNotificationById` relation. */
  projectClonedNotificationById?: InputMaybe<ProjectClonedNotificationFilter>;
  /** A related `projectClonedNotificationById` exists. */
  projectClonedNotificationByIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `projectSharedNotificationById` relation. */
  projectSharedNotificationById?: InputMaybe<ProjectSharedNotificationFilter>;
  /** A related `projectSharedNotificationById` exists. */
  projectSharedNotificationByIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `roleChangeNotificationById` relation. */
  roleChangeNotificationById?: InputMaybe<RoleChangeNotificationFilter>;
  /** A related `roleChangeNotificationById` exists. */
  roleChangeNotificationByIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `tenantUserMembershipNotificationById` relation. */
  tenantUserMembershipNotificationById?: InputMaybe<TenantUserMembershipNotificationFilter>;
  /** A related `tenantUserMembershipNotificationById` exists. */
  tenantUserMembershipNotificationByIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `notification` to look up the row to connect. */
export type NotificationNotificationPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `notification` to look up the row to update. */
export type NotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `notification` being updated. */
    notificationPatch: UpdateNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch;
  };

/** The fields on `notification` to look up the row to update. */
export type NotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `notification` being updated. */
    notificationPatch: UpdateNotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
  };

/** The fields on `notification` to look up the row to update. */
export type NotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `notification` being updated. */
    notificationPatch: UpdateNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch;
  };

/** The fields on `notification` to look up the row to update. */
export type NotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `notification` being updated. */
    notificationPatch: UpdateNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch;
  };

/** The fields on `notification` to look up the row to update. */
export type NotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `notification` being updated. */
    notificationPatch: UpdateNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch;
  };

/** The fields on `notification` to look up the row to update. */
export type NotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `notification` being updated. */
    notificationPatch: UpdateNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch;
  };

/** Represents an update to a `Notification`. Fields that are set will be updated. */
export type NotificationPatch = {
  applicationUserToUserId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileProcessingNotificationUsingId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInverseInput>;
  hasSeen?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  projectClonedNotificationUsingId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput>;
  projectSharedNotificationUsingId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput>;
  roleChangeNotificationUsingId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInverseInput>;
  tenantUserMembershipNotificationUsingId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInverseInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `applicationUser` to be created by this mutation. */
export type NotificationUserId1002Fc38FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `NotificationInput` mutation. */
export type NotificationUserId1002Fc38FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `notification` in the `ApplicationUserInput` mutation. */
export type NotificationUserId1002Fc38FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<Array<NotificationNotificationPkeyConnect>>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<NotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingNotificationPkeyUpdate>
  >;
};

/** A connection to a list of `Notification` values. */
export type NotificationsConnection = {
  __typename: "NotificationsConnection";
  /** A list of edges which contains the `Notification` and cursor to aid in pagination. */
  edges: Array<NotificationsEdge>;
  /** A list of `Notification` objects. */
  nodes: Array<Notification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Notification` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `Notification` edge in the connection. */
export type NotificationsEdge = {
  __typename: "NotificationsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `Notification` at the end of the edge. */
  node: Notification;
};

/** Methods to use when ordering `Notification`. */
export enum NotificationsOrderBy {
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  HasSeenAsc = "HAS_SEEN_ASC",
  HasSeenDesc = "HAS_SEEN_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

export type OutputGroupFile = {
  __typename: "OutputGroupFile";
  dateCreated: Scalars["Datetime"]["output"];
  /** Reads a single `File` that is related to this `OutputGroupFile`. */
  fileByFileId: Maybe<File>;
  fileId: Scalars["UUID"]["output"];
  /** Reads a single `FileOutputGroup` that is related to this `OutputGroupFile`. */
  fileOutputGroupByFileOutputGroupId: Maybe<FileOutputGroup>;
  fileOutputGroupId: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  /** Reads a single `Project` that is related to this `OutputGroupFile`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `OutputGroupFile` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OutputGroupFileCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `fileId` field. */
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `fileOutputGroupId` field. */
  fileOutputGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `OutputGroupFile` object types. All fields are combined with a logical ‘and.’ */
export type OutputGroupFileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OutputGroupFileFilter>>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `fileByFileId` relation. */
  fileByFileId?: InputMaybe<FileFilter>;
  /** Filter by the object’s `fileId` field. */
  fileId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fileOutputGroupByFileOutputGroupId` relation. */
  fileOutputGroupByFileOutputGroupId?: InputMaybe<FileOutputGroupFilter>;
  /** Filter by the object’s `fileOutputGroupId` field. */
  fileOutputGroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OutputGroupFileFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OutputGroupFileFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `OutputGroupFile` */
export type OutputGroupFileInput = {
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupToFileOutputGroupId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput>;
  fileToFileId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInput>;
  id: Scalars["UUID"]["input"];
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInput>;
};

/** The fields on `outputGroupFile` to look up the row to update. */
export type OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingOutputGroupFilesPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `outputGroupFile` being updated. */
    outputGroupFilePatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch;
  };

/** The fields on `outputGroupFile` to look up the row to update. */
export type OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingOutputGroupFilesPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `outputGroupFile` being updated. */
    outputGroupFilePatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch;
  };

/** The fields on `outputGroupFile` to look up the row to update. */
export type OutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingOutputGroupFilesPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `outputGroupFile` being updated. */
    outputGroupFilePatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch;
  };

/** The fields on `outputGroupFile` to look up the row to connect. */
export type OutputGroupFileOutputGroupFilesPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `outputGroupFile` to look up the row to delete. */
export type OutputGroupFileOutputGroupFilesPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** Represents an update to a `OutputGroupFile`. Fields that are set will be updated. */
export type OutputGroupFilePatch = {
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupToFileOutputGroupId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput>;
  fileToFileId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInput>;
};

/** A connection to a list of `OutputGroupFile` values. */
export type OutputGroupFilesConnection = {
  __typename: "OutputGroupFilesConnection";
  /** A list of edges which contains the `OutputGroupFile` and cursor to aid in pagination. */
  edges: Array<OutputGroupFilesEdge>;
  /** A list of `OutputGroupFile` objects. */
  nodes: Array<OutputGroupFile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OutputGroupFile` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `OutputGroupFile` edge in the connection. */
export type OutputGroupFilesEdge = {
  __typename: "OutputGroupFilesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `OutputGroupFile` at the end of the edge. */
  node: OutputGroupFile;
};

/** The `file` to be created by this mutation. */
export type OutputGroupFilesFileIdEdeabb23FkFileIdFileCreateInput = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["UUID"]["input"];
  isSeries: Scalars["Boolean"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  originalName: Scalars["String"]["input"];
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus: Scalars["Int"]["input"];
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId: Scalars["UUID"]["input"];
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source: Scalars["String"]["input"];
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `file` in the `OutputGroupFileInput` mutation. */
export type OutputGroupFilesFileIdEdeabb23FkFileIdInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<FileFilePkeyConnect>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueConnect>;
  /** A `FileInput` object that will be created and connected to this object. */
  create?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdFileCreateInput>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteById?: InputMaybe<FileFilePkeyDelete>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueDelete>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingFilePkeyUpdate>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingProjectReferenceIdUniqueUpdate>;
};

/** Input for the nested mutation of `outputGroupFile` in the `FileInput` mutation. */
export type OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput = {
  /** The primary key(s) for `outputGroupFile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<OutputGroupFileOutputGroupFilesPkeyConnect>>;
  /** A `OutputGroupFileInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<OutputGroupFilesFileIdEdeabb23FkFileIdOutputGroupFilesCreateInput>
  >;
  /** The primary key(s) for `outputGroupFile` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<OutputGroupFileOutputGroupFilesPkeyDelete>>;
  /** Flag indicating whether all other `outputGroupFile` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `outputGroupFile` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingOutputGroupFilesPkeyUpdate>
  >;
};

/** The `outputGroupFile` to be created by this mutation. */
export type OutputGroupFilesFileIdEdeabb23FkFileIdOutputGroupFilesCreateInput =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileOutputGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupToFileOutputGroupId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput>;
    fileToFileId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInput>;
    id: Scalars["UUID"]["input"];
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInput>;
  };

/** Input for the nested mutation of `fileOutputGroup` in the `OutputGroupFileInput` mutation. */
export type OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput = {
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectById?: InputMaybe<FileOutputGroupFileOutputGroupPkeyConnect>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<FileOutputGroupFileOutputGroupTaskIdKeyConnect>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  deleteById?: InputMaybe<FileOutputGroupFileOutputGroupPkeyDelete>;
  /** The primary key(s) for `fileOutputGroup` for the far side of the relationship. */
  deleteByTaskId?: InputMaybe<FileOutputGroupFileOutputGroupTaskIdKeyDelete>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateById?: InputMaybe<FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupPkeyUpdate>;
  /** The primary key(s) and patch data for `fileOutputGroup` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate>;
};

/** Input for the nested mutation of `outputGroupFile` in the `FileOutputGroupInput` mutation. */
export type OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput = {
  /** The primary key(s) for `outputGroupFile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<OutputGroupFileOutputGroupFilesPkeyConnect>>;
  /** A `OutputGroupFileInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpOutputGroupFilesCreateInput>
  >;
  /** The primary key(s) for `outputGroupFile` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<OutputGroupFileOutputGroupFilesPkeyDelete>>;
  /** Flag indicating whether all other `outputGroupFile` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `outputGroupFile` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingOutputGroupFilesPkeyUpdate>
  >;
};

/** The `outputGroupFile` to be created by this mutation. */
export type OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpOutputGroupFilesCreateInput =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupToFileOutputGroupId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput>;
    fileToFileId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInput>;
    id: Scalars["UUID"]["input"];
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInput>;
  };

/** Methods to use when ordering `OutputGroupFile`. */
export enum OutputGroupFilesOrderBy {
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  FileIdAsc = "FILE_ID_ASC",
  FileIdDesc = "FILE_ID_DESC",
  FileOutputGroupIdAsc = "FILE_OUTPUT_GROUP_ID_ASC",
  FileOutputGroupIdDesc = "FILE_OUTPUT_GROUP_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
}

/** Input for the nested mutation of `project` in the `OutputGroupFileInput` mutation. */
export type OutputGroupFilesProjectId8709B561FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `outputGroupFile` in the `ProjectInput` mutation. */
export type OutputGroupFilesProjectId8709B561FkProjectIdInverseInput = {
  /** The primary key(s) for `outputGroupFile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<OutputGroupFileOutputGroupFilesPkeyConnect>>;
  /** A `OutputGroupFileInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<OutputGroupFilesProjectId8709B561FkProjectIdOutputGroupFilesCreateInput>
  >;
  /** The primary key(s) for `outputGroupFile` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<OutputGroupFileOutputGroupFilesPkeyDelete>>;
  /** Flag indicating whether all other `outputGroupFile` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `outputGroupFile` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<OutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingOutputGroupFilesPkeyUpdate>
  >;
};

/** The `outputGroupFile` to be created by this mutation. */
export type OutputGroupFilesProjectId8709B561FkProjectIdOutputGroupFilesCreateInput =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupToFileOutputGroupId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput>;
    fileToFileId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInput>;
    id: Scalars["UUID"]["input"];
    projectToProjectId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInput>;
  };

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename: "PageInfo";
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars["Cursor"]["output"]>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars["Cursor"]["output"]>;
};

export type PinnedTool = {
  __typename: "PinnedTool";
  /** Reads a single `ApplicationUser` that is related to this `PinnedTool`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  id: Scalars["BigInt"]["output"];
  /** Reads a single `Tool` that is related to this `PinnedTool`. */
  toolByToolId: Maybe<Tool>;
  toolId: Scalars["Int"]["output"];
  userId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `PinnedTool` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PinnedToolCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `toolId` field. */
  toolId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `PinnedTool` object types. All fields are combined with a logical ‘and.’ */
export type PinnedToolFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PinnedToolFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PinnedToolFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PinnedToolFilter>>;
  /** Filter by the object’s `toolByToolId` relation. */
  toolByToolId?: InputMaybe<ToolFilter>;
  /** Filter by the object’s `toolId` field. */
  toolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `PinnedTool` */
export type PinnedToolInput = {
  applicationUserToUserId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInput>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  toolId?: InputMaybe<Scalars["Int"]["input"]>;
  toolToToolId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `pinnedTool` to look up the row to update. */
export type PinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingPinnedToolPkeyUpdate =
  {
    id: Scalars["BigInt"]["input"];
    /** An object where the defined keys will be set on the `pinnedTool` being updated. */
    pinnedToolPatch: UpdatePinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdPatch;
  };

/** The fields on `pinnedTool` to look up the row to update. */
export type PinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingPinnedToolUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `pinnedTool` being updated. */
    pinnedToolPatch: UpdatePinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdPatch;
    toolId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** The fields on `pinnedTool` to look up the row to update. */
export type PinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingPinnedToolPkeyUpdate =
  {
    id: Scalars["BigInt"]["input"];
    /** An object where the defined keys will be set on the `pinnedTool` being updated. */
    pinnedToolPatch: UpdatePinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdPatch;
  };

/** The fields on `pinnedTool` to look up the row to update. */
export type PinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingPinnedToolUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `pinnedTool` being updated. */
    pinnedToolPatch: UpdatePinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdPatch;
    toolId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** Represents an update to a `PinnedTool`. Fields that are set will be updated. */
export type PinnedToolPatch = {
  applicationUserToUserId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInput>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  toolId?: InputMaybe<Scalars["Int"]["input"]>;
  toolToToolId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `pinnedTool` to look up the row to connect. */
export type PinnedToolPinnedToolPkeyConnect = {
  id: Scalars["BigInt"]["input"];
};

/** The fields on `pinnedTool` to look up the row to delete. */
export type PinnedToolPinnedToolPkeyDelete = {
  id: Scalars["BigInt"]["input"];
};

/** The fields on `pinnedTool` to look up the row to connect. */
export type PinnedToolPinnedToolUniqueConnect = {
  toolId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The fields on `pinnedTool` to look up the row to delete. */
export type PinnedToolPinnedToolUniqueDelete = {
  toolId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** Input for the nested mutation of `tool` in the `PinnedToolInput` mutation. */
export type PinnedToolToolId7Ba143DfFkToolIdInput = {
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectById?: InputMaybe<ToolToolPkeyConnect>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectByProjectId?: InputMaybe<ToolToolProjectIdKeyConnect>;
  /** A `ToolInput` object that will be created and connected to this object. */
  create?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdToolCreateInput>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  deleteById?: InputMaybe<ToolToolPkeyDelete>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  deleteByProjectId?: InputMaybe<ToolToolProjectIdKeyDelete>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateById?: InputMaybe<ToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingToolPkeyUpdate>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateByProjectId?: InputMaybe<ToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingToolProjectIdKeyUpdate>;
};

/** Input for the nested mutation of `pinnedTool` in the `ToolInput` mutation. */
export type PinnedToolToolId7Ba143DfFkToolIdInverseInput = {
  /** The primary key(s) for `pinnedTool` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PinnedToolPinnedToolPkeyConnect>>;
  /** The primary key(s) for `pinnedTool` for the far side of the relationship. */
  connectByUserIdAndToolId?: InputMaybe<
    Array<PinnedToolPinnedToolUniqueConnect>
  >;
  /** A `PinnedToolInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<PinnedToolToolId7Ba143DfFkToolIdPinnedToolCreateInput>
  >;
  /** The primary key(s) for `pinnedTool` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PinnedToolPinnedToolPkeyDelete>>;
  /** The primary key(s) for `pinnedTool` for the far side of the relationship. */
  deleteByUserIdAndToolId?: InputMaybe<Array<PinnedToolPinnedToolUniqueDelete>>;
  /** Flag indicating whether all other `pinnedTool` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `pinnedTool` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<PinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingPinnedToolPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `pinnedTool` for the far side of the relationship. */
  updateByUserIdAndToolId?: InputMaybe<
    Array<PinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingPinnedToolUniqueUpdate>
  >;
};

/** The `pinnedTool` to be created by this mutation. */
export type PinnedToolToolId7Ba143DfFkToolIdPinnedToolCreateInput = {
  applicationUserToUserId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInput>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  toolToToolId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `tool` to be created by this mutation. */
export type PinnedToolToolId7Ba143DfFkToolIdToolCreateInput = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  codeLink?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  docsLink?: InputMaybe<Scalars["String"]["input"]>;
  helpText: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key: Scalars["String"]["input"];
  maturity: Scalars["Int"]["input"];
  name: Scalars["String"]["input"];
  pinnedToolsUsingId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  searchTerms?: InputMaybe<Scalars["JSON"]["input"]>;
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
  toolboxToToolboxId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  visibility: Scalars["Int"]["input"];
};

/** The `applicationUser` to be created by this mutation. */
export type PinnedToolUserId59D3492DFkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `PinnedToolInput` mutation. */
export type PinnedToolUserId59D3492DFkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `pinnedTool` in the `ApplicationUserInput` mutation. */
export type PinnedToolUserId59D3492DFkApplicationUserIdInverseInput = {
  /** The primary key(s) for `pinnedTool` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PinnedToolPinnedToolPkeyConnect>>;
  /** The primary key(s) for `pinnedTool` for the far side of the relationship. */
  connectByUserIdAndToolId?: InputMaybe<
    Array<PinnedToolPinnedToolUniqueConnect>
  >;
  /** A `PinnedToolInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<PinnedToolUserId59D3492DFkApplicationUserIdPinnedToolCreateInput>
  >;
  /** The primary key(s) for `pinnedTool` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PinnedToolPinnedToolPkeyDelete>>;
  /** The primary key(s) for `pinnedTool` for the far side of the relationship. */
  deleteByUserIdAndToolId?: InputMaybe<Array<PinnedToolPinnedToolUniqueDelete>>;
  /** Flag indicating whether all other `pinnedTool` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `pinnedTool` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<PinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingPinnedToolPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `pinnedTool` for the far side of the relationship. */
  updateByUserIdAndToolId?: InputMaybe<
    Array<PinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingPinnedToolUniqueUpdate>
  >;
};

/** The `pinnedTool` to be created by this mutation. */
export type PinnedToolUserId59D3492DFkApplicationUserIdPinnedToolCreateInput = {
  applicationUserToUserId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInput>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  toolId?: InputMaybe<Scalars["Int"]["input"]>;
  toolToToolId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInput>;
};

/** A connection to a list of `PinnedTool` values. */
export type PinnedToolsConnection = {
  __typename: "PinnedToolsConnection";
  /** A list of edges which contains the `PinnedTool` and cursor to aid in pagination. */
  edges: Array<PinnedToolsEdge>;
  /** A list of `PinnedTool` objects. */
  nodes: Array<PinnedTool>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PinnedTool` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `PinnedTool` edge in the connection. */
export type PinnedToolsEdge = {
  __typename: "PinnedToolsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `PinnedTool` at the end of the edge. */
  node: PinnedTool;
};

/** Methods to use when ordering `PinnedTool`. */
export enum PinnedToolsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ToolIdAsc = "TOOL_ID_ASC",
  ToolIdDesc = "TOOL_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

export type Project = {
  __typename: "Project";
  /** Reads and enables pagination through a set of `File`. */
  activeFiles: FilesConnection;
  activeStorageSize: Maybe<Scalars["BigInt"]["output"]>;
  /** Reads a single `ApplicationUser` that is related to this `Project`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  archivedStorageSize: Maybe<Scalars["BigInt"]["output"]>;
  cloneSourceId: Maybe<Scalars["UUID"]["output"]>;
  /** Reads and enables pagination through a set of `DataTableCell`. */
  dataTableCellsByProjectId: DataTableCellsConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionBoolean`. */
  dataTableColumnDefinitionBooleansByProjectId: DataTableColumnDefinitionBooleansConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionCellStatus`. */
  dataTableColumnDefinitionCellStatusesByProjectId: DataTableColumnDefinitionCellStatusesConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionChoice`. */
  dataTableColumnDefinitionChoicesByProjectId: DataTableColumnDefinitionChoicesConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionDate`. */
  dataTableColumnDefinitionDatesByProjectId: DataTableColumnDefinitionDatesConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionFile`. */
  dataTableColumnDefinitionFilesByProjectId: DataTableColumnDefinitionFilesConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionFloat`. */
  dataTableColumnDefinitionFloatsByProjectId: DataTableColumnDefinitionFloatsConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionIdentifier`. */
  dataTableColumnDefinitionIdentifiersByProjectId: DataTableColumnDefinitionIdentifiersConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionInteger`. */
  dataTableColumnDefinitionIntegersByProjectId: DataTableColumnDefinitionIntegersConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionJoin`. */
  dataTableColumnDefinitionJoinsByProjectId: DataTableColumnDefinitionJoinsConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionMetadatum`. */
  dataTableColumnDefinitionMetadataByProjectId: DataTableColumnDefinitionMetadataConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionRoiFrame`. */
  dataTableColumnDefinitionRoiFramesByProjectId: DataTableColumnDefinitionRoiFramesConnection;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionText`. */
  dataTableColumnDefinitionTextsByProjectId: DataTableColumnDefinitionTextsConnection;
  /** Reads and enables pagination through a set of `DataTableColumnGroupDefinitionJoin`. */
  dataTableColumnGroupDefinitionJoinsByProjectId: DataTableColumnGroupDefinitionJoinsConnection;
  /** Reads and enables pagination through a set of `DataTableColumnGroupDefinitionSource`. */
  dataTableColumnGroupDefinitionSourcesByProjectId: DataTableColumnGroupDefinitionSourcesConnection;
  /** Reads and enables pagination through a set of `DataTableColumnGroup`. */
  dataTableColumnGroupsByProjectId: DataTableColumnGroupsConnection;
  /** Reads and enables pagination through a set of `DataTableColumn`. */
  dataTableColumnsByProjectId: DataTableColumnsConnection;
  /** Reads and enables pagination through a set of `DataTableRow`. */
  dataTableRowsByProjectId: DataTableRowsConnection;
  /** Reads and enables pagination through a set of `DataTable`. */
  dataTablesByProjectId: DataTablesConnection;
  dateArchived: Maybe<Scalars["Datetime"]["output"]>;
  dateCreated: Scalars["Datetime"]["output"];
  dateDataDeleted: Maybe<Scalars["Datetime"]["output"]>;
  dateDeleted: Maybe<Scalars["Datetime"]["output"]>;
  dateLastActive: Maybe<Scalars["Datetime"]["output"]>;
  defaultUserAccessLevel: Scalars["Int"]["output"];
  description: Maybe<Scalars["String"]["output"]>;
  /** Reads and enables pagination through a set of `FileActivity`. */
  fileActivitiesByProjectId: FileActivitiesConnection;
  /** Reads and enables pagination through a set of `FileMetadatum`. */
  fileMetadataByProjectId: FileMetadataConnection;
  /** Reads and enables pagination through a set of `FileOutputGroupMetadatum`. */
  fileOutputGroupMetadataByProjectId: FileOutputGroupMetadataConnection;
  /** Reads and enables pagination through a set of `FileOutputGroup`. */
  fileOutputGroupsByProjectId: FileOutputGroupsConnection;
  /** Reads and enables pagination through a set of `File`. */
  filesByProjectId: FilesConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTableCell`. */
  gdtAnalysisTableCellsByProjectId: GdtAnalysisTableCellsConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTableColumnGroup`. */
  gdtAnalysisTableColumnGroupsByProjectId: GdtAnalysisTableColumnGroupsConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTableColumn`. */
  gdtAnalysisTableColumnsByProjectId: GdtAnalysisTableColumnsConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTableRow`. */
  gdtAnalysisTableRowsByProjectId: GdtAnalysisTableRowsConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTable`. */
  gdtAnalysisTablesByProjectId: GdtAnalysisTablesConnection;
  icon: Maybe<Scalars["String"]["output"]>;
  iconColor: Scalars["String"]["output"];
  iconText: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  isDemo: Scalars["Boolean"]["output"];
  isToolProject: Scalars["Boolean"]["output"];
  key: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `Metadatum`. */
  metadataByProjectId: MetadataConnection;
  /** Reads and enables pagination through a set of `MetadataValue`. */
  metadataValuesByProjectId: MetadataValuesConnection;
  name: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `OutputGroupFile`. */
  outputGroupFilesByProjectId: OutputGroupFilesConnection;
  pinned: Maybe<Scalars["Boolean"]["output"]>;
  prefix: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Project` that is related to this `Project`. */
  projectByCloneSourceId: Maybe<Project>;
  /** Reads and enables pagination through a set of `ProjectClonedNotification`. */
  projectClonedNotificationsByProjectId: ProjectClonedNotificationsConnection;
  /** Reads and enables pagination through a set of `ProjectClonedNotification`. */
  projectClonedNotificationsBySrcProjectId: ProjectClonedNotificationsConnection;
  /** Reads and enables pagination through a set of `ProjectFolder`. */
  projectFoldersByProjectId: ProjectFoldersConnection;
  /** Reads and enables pagination through a set of `ProjectSharedNotification`. */
  projectSharedNotificationsByProjectId: ProjectSharedNotificationsConnection;
  /** Reads and enables pagination through a set of `ProjectTag`. */
  projectTagsByProjectId: ProjectTagsConnection;
  /** Reads and enables pagination through a set of `Project`. */
  projectsByCloneSourceId: ProjectsConnection;
  shortDescription: Maybe<Scalars["String"]["output"]>;
  status: Scalars["Int"]["output"];
  /** Reads and enables pagination through a set of `Task`. */
  tasksByProjectId: TasksConnection;
  /** Reads a single `Tenant` that is related to this `Project`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
  /** Reads a single `Tool` that is related to this `Project`. */
  toolByProjectId: Maybe<Tool>;
  /**
   * Reads and enables pagination through a set of `Tool`.
   * @deprecated Please use toolByProjectId instead
   */
  toolsByProjectId: ToolsConnection;
  tourType: Maybe<Scalars["Int"]["output"]>;
  usedCredits: Maybe<Scalars["Float"]["output"]>;
  userId: Scalars["UUID"]["output"];
};

export type ProjectActiveFilesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  at?: InputMaybe<Scalars["Datetime"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ProjectDataTableCellsByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableCellCondition>;
  filter?: InputMaybe<DataTableCellFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableCellsOrderBy>>;
};

export type ProjectDataTableColumnDefinitionBooleansByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionBooleanCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionBooleanFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionBooleansOrderBy>>;
};

export type ProjectDataTableColumnDefinitionCellStatusesByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionCellStatusCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionCellStatusFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionCellStatusesOrderBy>>;
};

export type ProjectDataTableColumnDefinitionChoicesByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionChoiceCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionChoiceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionChoicesOrderBy>>;
};

export type ProjectDataTableColumnDefinitionDatesByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionDateCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionDateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionDatesOrderBy>>;
};

export type ProjectDataTableColumnDefinitionFilesByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionFileCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionFileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionFilesOrderBy>>;
};

export type ProjectDataTableColumnDefinitionFloatsByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionFloatCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionFloatFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionFloatsOrderBy>>;
};

export type ProjectDataTableColumnDefinitionIdentifiersByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionIdentifierCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionIdentifierFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionIdentifiersOrderBy>>;
};

export type ProjectDataTableColumnDefinitionIntegersByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionIntegerCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionIntegerFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionIntegersOrderBy>>;
};

export type ProjectDataTableColumnDefinitionJoinsByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionJoinCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionJoinFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionJoinsOrderBy>>;
};

export type ProjectDataTableColumnDefinitionMetadataByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionMetadatumCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionMetadataOrderBy>>;
};

export type ProjectDataTableColumnDefinitionRoiFramesByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionRoiFrameCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionRoiFrameFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionRoiFramesOrderBy>>;
};

export type ProjectDataTableColumnDefinitionTextsByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionTextCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionTextFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionTextsOrderBy>>;
};

export type ProjectDataTableColumnGroupDefinitionJoinsByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnGroupDefinitionJoinCondition>;
  filter?: InputMaybe<DataTableColumnGroupDefinitionJoinFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnGroupDefinitionJoinsOrderBy>>;
};

export type ProjectDataTableColumnGroupDefinitionSourcesByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnGroupDefinitionSourceCondition>;
  filter?: InputMaybe<DataTableColumnGroupDefinitionSourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnGroupDefinitionSourcesOrderBy>>;
};

export type ProjectDataTableColumnGroupsByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnGroupCondition>;
  filter?: InputMaybe<DataTableColumnGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnGroupsOrderBy>>;
};

export type ProjectDataTableColumnsByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnCondition>;
  filter?: InputMaybe<DataTableColumnFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnsOrderBy>>;
};

export type ProjectDataTableRowsByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableRowCondition>;
  filter?: InputMaybe<DataTableRowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableRowsOrderBy>>;
};

export type ProjectDataTablesByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableCondition>;
  filter?: InputMaybe<DataTableFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTablesOrderBy>>;
};

export type ProjectFileActivitiesByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileActivityCondition>;
  filter?: InputMaybe<FileActivityFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileActivitiesOrderBy>>;
};

export type ProjectFileMetadataByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileMetadatumCondition>;
  filter?: InputMaybe<FileMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileMetadataOrderBy>>;
};

export type ProjectFileOutputGroupMetadataByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileOutputGroupMetadatumCondition>;
  filter?: InputMaybe<FileOutputGroupMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileOutputGroupMetadataOrderBy>>;
};

export type ProjectFileOutputGroupsByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileOutputGroupCondition>;
  filter?: InputMaybe<FileOutputGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileOutputGroupsOrderBy>>;
};

export type ProjectFilesByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};

export type ProjectGdtAnalysisTableCellsByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableCellCondition>;
  filter?: InputMaybe<GdtAnalysisTableCellFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableCellsOrderBy>>;
};

export type ProjectGdtAnalysisTableColumnGroupsByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableColumnGroupCondition>;
  filter?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableColumnGroupsOrderBy>>;
};

export type ProjectGdtAnalysisTableColumnsByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableColumnCondition>;
  filter?: InputMaybe<GdtAnalysisTableColumnFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableColumnsOrderBy>>;
};

export type ProjectGdtAnalysisTableRowsByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableRowCondition>;
  filter?: InputMaybe<GdtAnalysisTableRowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableRowsOrderBy>>;
};

export type ProjectGdtAnalysisTablesByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableCondition>;
  filter?: InputMaybe<GdtAnalysisTableFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTablesOrderBy>>;
};

export type ProjectMetadataByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<MetadatumCondition>;
  filter?: InputMaybe<MetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<MetadataOrderBy>>;
};

export type ProjectMetadataValuesByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<MetadataValueCondition>;
  filter?: InputMaybe<MetadataValueFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<MetadataValuesOrderBy>>;
};

export type ProjectOutputGroupFilesByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<OutputGroupFileCondition>;
  filter?: InputMaybe<OutputGroupFileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<OutputGroupFilesOrderBy>>;
};

export type ProjectProjectClonedNotificationsByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectClonedNotificationCondition>;
  filter?: InputMaybe<ProjectClonedNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectClonedNotificationsOrderBy>>;
};

export type ProjectProjectClonedNotificationsBySrcProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectClonedNotificationCondition>;
  filter?: InputMaybe<ProjectClonedNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectClonedNotificationsOrderBy>>;
};

export type ProjectProjectFoldersByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectFolderCondition>;
  filter?: InputMaybe<ProjectFolderFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectFoldersOrderBy>>;
};

export type ProjectProjectSharedNotificationsByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectSharedNotificationCondition>;
  filter?: InputMaybe<ProjectSharedNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectSharedNotificationsOrderBy>>;
};

export type ProjectProjectTagsByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectTagCondition>;
  filter?: InputMaybe<ProjectTagFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectTagsOrderBy>>;
};

export type ProjectProjectsByCloneSourceIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

export type ProjectTasksByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

export type ProjectToolsByProjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolCondition>;
  filter?: InputMaybe<ToolFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolsOrderBy>>;
};

/** Input for the nested mutation of `project` in the `ProjectInput` mutation. */
export type ProjectCloneSourceId92Ccacf5FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `project` in the `ProjectClonedNotificationInput` mutation. */
export type ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `projectClonedNotification` in the `ProjectInput` mutation. */
export type ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput = {
  /** The primary key(s) for `projectClonedNotification` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ProjectClonedNotificationProjectClonedNotificationPkeyConnect>
  >;
  /** The primary key(s) and patch data for `projectClonedNotification` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectClonedNotificationPkeyUpdate>
  >;
};

/** The `applicationUser` to be created by this mutation. */
export type ProjectClonedNotifUserId4Fd693D7FkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `ProjectClonedNotificationInput` mutation. */
export type ProjectClonedNotifUserId4Fd693D7FkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `projectClonedNotification` in the `ApplicationUserInput` mutation. */
export type ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput = {
  /** The primary key(s) for `projectClonedNotification` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ProjectClonedNotificationProjectClonedNotificationPkeyConnect>
  >;
  /** The primary key(s) and patch data for `projectClonedNotification` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingProjectClonedNotificationPkeyUpdate>
  >;
};

export type ProjectClonedNotification = {
  __typename: "ProjectClonedNotification";
  /** Reads a single `ApplicationUser` that is related to this `ProjectClonedNotification`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  id: Scalars["UUID"]["output"];
  /** Reads a single `Notification` that is related to this `ProjectClonedNotification`. */
  notificationById: Maybe<Notification>;
  /** Reads a single `Project` that is related to this `ProjectClonedNotification`. */
  projectByProjectId: Maybe<Project>;
  /** Reads a single `Project` that is related to this `ProjectClonedNotification`. */
  projectBySrcProjectId: Maybe<Project>;
  projectId: Maybe<Scalars["UUID"]["output"]>;
  projectName: Maybe<Scalars["String"]["output"]>;
  srcProjectId: Maybe<Scalars["UUID"]["output"]>;
  succeeded: Scalars["Boolean"]["output"];
  userId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `ProjectClonedNotification` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ProjectClonedNotificationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `projectName` field. */
  projectName?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `srcProjectId` field. */
  srcProjectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `succeeded` field. */
  succeeded?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `ProjectClonedNotification` object types. All fields are combined with a logical ‘and.’ */
export type ProjectClonedNotificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectClonedNotificationFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectClonedNotificationFilter>;
  /** Filter by the object’s `notificationById` relation. */
  notificationById?: InputMaybe<NotificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectClonedNotificationFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** A related `projectByProjectId` exists. */
  projectByProjectIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `projectBySrcProjectId` relation. */
  projectBySrcProjectId?: InputMaybe<ProjectFilter>;
  /** A related `projectBySrcProjectId` exists. */
  projectBySrcProjectIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `projectName` field. */
  projectName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `srcProjectId` field. */
  srcProjectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `succeeded` field. */
  succeeded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** Input for the nested mutation of `notification` in the `ProjectClonedNotificationInput` mutation. */
export type ProjectClonedNotificationIdD235A018FkNotificationIdInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<NotificationNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<NotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingNotificationPkeyUpdate>;
};

/** Input for the nested mutation of `projectClonedNotification` in the `NotificationInput` mutation. */
export type ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput = {
  /** The primary key(s) for `projectClonedNotification` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectClonedNotificationProjectClonedNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `projectClonedNotification` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingProjectClonedNotificationPkeyUpdate>;
};

/** The fields on `projectClonedNotification` to look up the row to update. */
export type ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectClonedNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `projectClonedNotification` being updated. */
    projectClonedNotificationPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch;
  };

/** The fields on `projectClonedNotification` to look up the row to update. */
export type ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingProjectClonedNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `projectClonedNotification` being updated. */
    projectClonedNotificationPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
  };

/** The fields on `projectClonedNotification` to look up the row to update. */
export type ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingProjectClonedNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `projectClonedNotification` being updated. */
    projectClonedNotificationPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch;
  };

/** The fields on `projectClonedNotification` to look up the row to update. */
export type ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectClonedNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `projectClonedNotification` being updated. */
    projectClonedNotificationPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch;
  };

/** The fields on `projectClonedNotification` to look up the row to connect. */
export type ProjectClonedNotificationProjectClonedNotificationPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** Input for the nested mutation of `project` in the `ProjectClonedNotificationInput` mutation. */
export type ProjectClonedNotificationProjectIdF6267374FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `projectClonedNotification` in the `ProjectInput` mutation. */
export type ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput =
  {
    /** The primary key(s) for `projectClonedNotification` for the far side of the relationship. */
    connectById?: InputMaybe<
      Array<ProjectClonedNotificationProjectClonedNotificationPkeyConnect>
    >;
    /** The primary key(s) and patch data for `projectClonedNotification` for the far side of the relationship. */
    updateById?: InputMaybe<
      Array<ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectClonedNotificationPkeyUpdate>
    >;
  };

/** A connection to a list of `ProjectClonedNotification` values. */
export type ProjectClonedNotificationsConnection = {
  __typename: "ProjectClonedNotificationsConnection";
  /** A list of edges which contains the `ProjectClonedNotification` and cursor to aid in pagination. */
  edges: Array<ProjectClonedNotificationsEdge>;
  /** A list of `ProjectClonedNotification` objects. */
  nodes: Array<ProjectClonedNotification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectClonedNotification` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ProjectClonedNotification` edge in the connection. */
export type ProjectClonedNotificationsEdge = {
  __typename: "ProjectClonedNotificationsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ProjectClonedNotification` at the end of the edge. */
  node: ProjectClonedNotification;
};

/** Methods to use when ordering `ProjectClonedNotification`. */
export enum ProjectClonedNotificationsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  ProjectNameAsc = "PROJECT_NAME_ASC",
  ProjectNameDesc = "PROJECT_NAME_DESC",
  SrcProjectIdAsc = "SRC_PROJECT_ID_ASC",
  SrcProjectIdDesc = "SRC_PROJECT_ID_DESC",
  SucceededAsc = "SUCCEEDED_ASC",
  SucceededDesc = "SUCCEEDED_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** A condition to be used against `Project` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProjectCondition = {
  /** Checks for equality with the object’s `cloneSourceId` field. */
  cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `dateArchived` field. */
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateDataDeleted` field. */
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `defaultUserAccessLevel` field. */
  defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `icon` field. */
  icon?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `iconColor` field. */
  iconColor?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `iconText` field. */
  iconText?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `isDemo` field. */
  isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `isToolProject` field. */
  isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `prefix` field. */
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `shortDescription` field. */
  shortDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `tourType` field. */
  tourType?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `Project` object types. All fields are combined with a logical ‘and.’ */
export type ProjectFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `cloneSourceId` field. */
  cloneSourceId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `dataTableCellsByProjectId` relation. */
  dataTableCellsByProjectId?: InputMaybe<ProjectToManyDataTableCellFilter>;
  /** Some related `dataTableCellsByProjectId` exist. */
  dataTableCellsByProjectIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dataTableColumnDefinitionBooleansByProjectId` relation. */
  dataTableColumnDefinitionBooleansByProjectId?: InputMaybe<ProjectToManyDataTableColumnDefinitionBooleanFilter>;
  /** Some related `dataTableColumnDefinitionBooleansByProjectId` exist. */
  dataTableColumnDefinitionBooleansByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionCellStatusesByProjectId` relation. */
  dataTableColumnDefinitionCellStatusesByProjectId?: InputMaybe<ProjectToManyDataTableColumnDefinitionCellStatusFilter>;
  /** Some related `dataTableColumnDefinitionCellStatusesByProjectId` exist. */
  dataTableColumnDefinitionCellStatusesByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionChoicesByProjectId` relation. */
  dataTableColumnDefinitionChoicesByProjectId?: InputMaybe<ProjectToManyDataTableColumnDefinitionChoiceFilter>;
  /** Some related `dataTableColumnDefinitionChoicesByProjectId` exist. */
  dataTableColumnDefinitionChoicesByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionDatesByProjectId` relation. */
  dataTableColumnDefinitionDatesByProjectId?: InputMaybe<ProjectToManyDataTableColumnDefinitionDateFilter>;
  /** Some related `dataTableColumnDefinitionDatesByProjectId` exist. */
  dataTableColumnDefinitionDatesByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionFilesByProjectId` relation. */
  dataTableColumnDefinitionFilesByProjectId?: InputMaybe<ProjectToManyDataTableColumnDefinitionFileFilter>;
  /** Some related `dataTableColumnDefinitionFilesByProjectId` exist. */
  dataTableColumnDefinitionFilesByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionFloatsByProjectId` relation. */
  dataTableColumnDefinitionFloatsByProjectId?: InputMaybe<ProjectToManyDataTableColumnDefinitionFloatFilter>;
  /** Some related `dataTableColumnDefinitionFloatsByProjectId` exist. */
  dataTableColumnDefinitionFloatsByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionIdentifiersByProjectId` relation. */
  dataTableColumnDefinitionIdentifiersByProjectId?: InputMaybe<ProjectToManyDataTableColumnDefinitionIdentifierFilter>;
  /** Some related `dataTableColumnDefinitionIdentifiersByProjectId` exist. */
  dataTableColumnDefinitionIdentifiersByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionIntegersByProjectId` relation. */
  dataTableColumnDefinitionIntegersByProjectId?: InputMaybe<ProjectToManyDataTableColumnDefinitionIntegerFilter>;
  /** Some related `dataTableColumnDefinitionIntegersByProjectId` exist. */
  dataTableColumnDefinitionIntegersByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionJoinsByProjectId` relation. */
  dataTableColumnDefinitionJoinsByProjectId?: InputMaybe<ProjectToManyDataTableColumnDefinitionJoinFilter>;
  /** Some related `dataTableColumnDefinitionJoinsByProjectId` exist. */
  dataTableColumnDefinitionJoinsByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionMetadataByProjectId` relation. */
  dataTableColumnDefinitionMetadataByProjectId?: InputMaybe<ProjectToManyDataTableColumnDefinitionMetadatumFilter>;
  /** Some related `dataTableColumnDefinitionMetadataByProjectId` exist. */
  dataTableColumnDefinitionMetadataByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionRoiFramesByProjectId` relation. */
  dataTableColumnDefinitionRoiFramesByProjectId?: InputMaybe<ProjectToManyDataTableColumnDefinitionRoiFrameFilter>;
  /** Some related `dataTableColumnDefinitionRoiFramesByProjectId` exist. */
  dataTableColumnDefinitionRoiFramesByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnDefinitionTextsByProjectId` relation. */
  dataTableColumnDefinitionTextsByProjectId?: InputMaybe<ProjectToManyDataTableColumnDefinitionTextFilter>;
  /** Some related `dataTableColumnDefinitionTextsByProjectId` exist. */
  dataTableColumnDefinitionTextsByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnGroupDefinitionJoinsByProjectId` relation. */
  dataTableColumnGroupDefinitionJoinsByProjectId?: InputMaybe<ProjectToManyDataTableColumnGroupDefinitionJoinFilter>;
  /** Some related `dataTableColumnGroupDefinitionJoinsByProjectId` exist. */
  dataTableColumnGroupDefinitionJoinsByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnGroupDefinitionSourcesByProjectId` relation. */
  dataTableColumnGroupDefinitionSourcesByProjectId?: InputMaybe<ProjectToManyDataTableColumnGroupDefinitionSourceFilter>;
  /** Some related `dataTableColumnGroupDefinitionSourcesByProjectId` exist. */
  dataTableColumnGroupDefinitionSourcesByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnGroupsByProjectId` relation. */
  dataTableColumnGroupsByProjectId?: InputMaybe<ProjectToManyDataTableColumnGroupFilter>;
  /** Some related `dataTableColumnGroupsByProjectId` exist. */
  dataTableColumnGroupsByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `dataTableColumnsByProjectId` relation. */
  dataTableColumnsByProjectId?: InputMaybe<ProjectToManyDataTableColumnFilter>;
  /** Some related `dataTableColumnsByProjectId` exist. */
  dataTableColumnsByProjectIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dataTableRowsByProjectId` relation. */
  dataTableRowsByProjectId?: InputMaybe<ProjectToManyDataTableRowFilter>;
  /** Some related `dataTableRowsByProjectId` exist. */
  dataTableRowsByProjectIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dataTablesByProjectId` relation. */
  dataTablesByProjectId?: InputMaybe<ProjectToManyDataTableFilter>;
  /** Some related `dataTablesByProjectId` exist. */
  dataTablesByProjectIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dateArchived` field. */
  dateArchived?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDataDeleted` field. */
  dateDataDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateDeleted` field. */
  dateDeleted?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `defaultUserAccessLevel` field. */
  defaultUserAccessLevel?: InputMaybe<IntFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fileActivitiesByProjectId` relation. */
  fileActivitiesByProjectId?: InputMaybe<ProjectToManyFileActivityFilter>;
  /** Some related `fileActivitiesByProjectId` exist. */
  fileActivitiesByProjectIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `fileMetadataByProjectId` relation. */
  fileMetadataByProjectId?: InputMaybe<ProjectToManyFileMetadatumFilter>;
  /** Some related `fileMetadataByProjectId` exist. */
  fileMetadataByProjectIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `fileOutputGroupMetadataByProjectId` relation. */
  fileOutputGroupMetadataByProjectId?: InputMaybe<ProjectToManyFileOutputGroupMetadatumFilter>;
  /** Some related `fileOutputGroupMetadataByProjectId` exist. */
  fileOutputGroupMetadataByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `fileOutputGroupsByProjectId` relation. */
  fileOutputGroupsByProjectId?: InputMaybe<ProjectToManyFileOutputGroupFilter>;
  /** Some related `fileOutputGroupsByProjectId` exist. */
  fileOutputGroupsByProjectIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `filesByProjectId` relation. */
  filesByProjectId?: InputMaybe<ProjectToManyFileFilter>;
  /** Some related `filesByProjectId` exist. */
  filesByProjectIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `gdtAnalysisTableCellsByProjectId` relation. */
  gdtAnalysisTableCellsByProjectId?: InputMaybe<ProjectToManyGdtAnalysisTableCellFilter>;
  /** Some related `gdtAnalysisTableCellsByProjectId` exist. */
  gdtAnalysisTableCellsByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `gdtAnalysisTableColumnGroupsByProjectId` relation. */
  gdtAnalysisTableColumnGroupsByProjectId?: InputMaybe<ProjectToManyGdtAnalysisTableColumnGroupFilter>;
  /** Some related `gdtAnalysisTableColumnGroupsByProjectId` exist. */
  gdtAnalysisTableColumnGroupsByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `gdtAnalysisTableColumnsByProjectId` relation. */
  gdtAnalysisTableColumnsByProjectId?: InputMaybe<ProjectToManyGdtAnalysisTableColumnFilter>;
  /** Some related `gdtAnalysisTableColumnsByProjectId` exist. */
  gdtAnalysisTableColumnsByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `gdtAnalysisTableRowsByProjectId` relation. */
  gdtAnalysisTableRowsByProjectId?: InputMaybe<ProjectToManyGdtAnalysisTableRowFilter>;
  /** Some related `gdtAnalysisTableRowsByProjectId` exist. */
  gdtAnalysisTableRowsByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `gdtAnalysisTablesByProjectId` relation. */
  gdtAnalysisTablesByProjectId?: InputMaybe<ProjectToManyGdtAnalysisTableFilter>;
  /** Some related `gdtAnalysisTablesByProjectId` exist. */
  gdtAnalysisTablesByProjectIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `icon` field. */
  icon?: InputMaybe<StringFilter>;
  /** Filter by the object’s `iconColor` field. */
  iconColor?: InputMaybe<StringFilter>;
  /** Filter by the object’s `iconText` field. */
  iconText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isDemo` field. */
  isDemo?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isToolProject` field. */
  isToolProject?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadataByProjectId` relation. */
  metadataByProjectId?: InputMaybe<ProjectToManyMetadatumFilter>;
  /** Some related `metadataByProjectId` exist. */
  metadataByProjectIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `metadataValuesByProjectId` relation. */
  metadataValuesByProjectId?: InputMaybe<ProjectToManyMetadataValueFilter>;
  /** Some related `metadataValuesByProjectId` exist. */
  metadataValuesByProjectIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectFilter>>;
  /** Filter by the object’s `outputGroupFilesByProjectId` relation. */
  outputGroupFilesByProjectId?: InputMaybe<ProjectToManyOutputGroupFileFilter>;
  /** Some related `outputGroupFilesByProjectId` exist. */
  outputGroupFilesByProjectIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `prefix` field. */
  prefix?: InputMaybe<StringFilter>;
  /** Filter by the object’s `projectByCloneSourceId` relation. */
  projectByCloneSourceId?: InputMaybe<ProjectFilter>;
  /** A related `projectByCloneSourceId` exists. */
  projectByCloneSourceIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `projectClonedNotificationsByProjectId` relation. */
  projectClonedNotificationsByProjectId?: InputMaybe<ProjectToManyProjectClonedNotificationFilter>;
  /** Some related `projectClonedNotificationsByProjectId` exist. */
  projectClonedNotificationsByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `projectClonedNotificationsBySrcProjectId` relation. */
  projectClonedNotificationsBySrcProjectId?: InputMaybe<ProjectToManyProjectClonedNotificationFilter>;
  /** Some related `projectClonedNotificationsBySrcProjectId` exist. */
  projectClonedNotificationsBySrcProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `projectFoldersByProjectId` relation. */
  projectFoldersByProjectId?: InputMaybe<ProjectToManyProjectFolderFilter>;
  /** Some related `projectFoldersByProjectId` exist. */
  projectFoldersByProjectIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `projectSharedNotificationsByProjectId` relation. */
  projectSharedNotificationsByProjectId?: InputMaybe<ProjectToManyProjectSharedNotificationFilter>;
  /** Some related `projectSharedNotificationsByProjectId` exist. */
  projectSharedNotificationsByProjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `projectTagsByProjectId` relation. */
  projectTagsByProjectId?: InputMaybe<ProjectToManyProjectTagFilter>;
  /** Some related `projectTagsByProjectId` exist. */
  projectTagsByProjectIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `projectsByCloneSourceId` relation. */
  projectsByCloneSourceId?: InputMaybe<ProjectToManyProjectFilter>;
  /** Some related `projectsByCloneSourceId` exist. */
  projectsByCloneSourceIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `shortDescription` field. */
  shortDescription?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tasksByProjectId` relation. */
  tasksByProjectId?: InputMaybe<ProjectToManyTaskFilter>;
  /** Some related `tasksByProjectId` exist. */
  tasksByProjectIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toolByProjectId` relation. */
  toolByProjectId?: InputMaybe<ToolFilter>;
  /** A related `toolByProjectId` exists. */
  toolByProjectIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `tourType` field. */
  tourType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

export type ProjectFolder = {
  __typename: "ProjectFolder";
  /** Reads a single `ApplicationUser` that is related to this `ProjectFolder`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  color: Maybe<Scalars["String"]["output"]>;
  /** Reads and enables pagination through a set of `DataTable`. */
  dataTablesByFolderId: DataTablesConnection;
  dateCreated: Scalars["Datetime"]["output"];
  /** Reads and enables pagination through a set of `GdtAnalysisTable`. */
  gdtAnalysisTablesByFolderId: GdtAnalysisTablesConnection;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  /** Reads a single `Project` that is related to this `ProjectFolder`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  userId: Maybe<Scalars["UUID"]["output"]>;
};

export type ProjectFolderDataTablesByFolderIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableCondition>;
  filter?: InputMaybe<DataTableFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTablesOrderBy>>;
};

export type ProjectFolderGdtAnalysisTablesByFolderIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableCondition>;
  filter?: InputMaybe<GdtAnalysisTableFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTablesOrderBy>>;
};

/**
 * A condition to be used against `ProjectFolder` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ProjectFolderCondition = {
  /** Checks for equality with the object’s `color` field. */
  color?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `ProjectFolder` object types. All fields are combined with a logical ‘and.’ */
export type ProjectFolderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectFolderFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `color` field. */
  color?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dataTablesByFolderId` relation. */
  dataTablesByFolderId?: InputMaybe<ProjectFolderToManyDataTableFilter>;
  /** Some related `dataTablesByFolderId` exist. */
  dataTablesByFolderIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `gdtAnalysisTablesByFolderId` relation. */
  gdtAnalysisTablesByFolderId?: InputMaybe<ProjectFolderToManyGdtAnalysisTableFilter>;
  /** Some related `gdtAnalysisTablesByFolderId` exist. */
  gdtAnalysisTablesByFolderIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectFolderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectFolderFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ProjectFolder` */
export type ProjectFolderInput = {
  applicationUserToUserId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInput>;
  color?: InputMaybe<Scalars["String"]["input"]>;
  dataTablesUsingId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput>;
  id: Scalars["UUID"]["input"];
  name: Scalars["String"]["input"];
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `projectFolder` to look up the row to update. */
export type ProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingProjectFolderPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `projectFolder` being updated. */
    projectFolderPatch: UpdateProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch;
  };

/** The fields on `projectFolder` to look up the row to update. */
export type ProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingProjectFolderPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `projectFolder` being updated. */
    projectFolderPatch: UpdateProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch;
  };

/** The fields on `projectFolder` to look up the row to update. */
export type ProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectFolderPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `projectFolder` being updated. */
    projectFolderPatch: UpdateProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch;
  };

/** The fields on `projectFolder` to look up the row to update. */
export type ProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingProjectFolderPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `projectFolder` being updated. */
    projectFolderPatch: UpdateProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
  };

/** Represents an update to a `ProjectFolder`. Fields that are set will be updated. */
export type ProjectFolderPatch = {
  applicationUserToUserId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInput>;
  color?: InputMaybe<Scalars["String"]["input"]>;
  dataTablesUsingId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `projectFolder` to look up the row to connect. */
export type ProjectFolderProjectFolderPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `projectFolder` to look up the row to delete. */
export type ProjectFolderProjectFolderPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** Input for the nested mutation of `project` in the `ProjectFolderInput` mutation. */
export type ProjectFolderProjectIdEf44DadfFkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `projectFolder` in the `ProjectInput` mutation. */
export type ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput = {
  /** The primary key(s) for `projectFolder` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectFolderProjectFolderPkeyConnect>>;
  /** A `ProjectFolderInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ProjectFolderProjectIdEf44DadfFkProjectIdProjectFolderCreateInput>
  >;
  /** The primary key(s) for `projectFolder` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectFolderProjectFolderPkeyDelete>>;
  /** Flag indicating whether all other `projectFolder` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `projectFolder` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectFolderPkeyUpdate>
  >;
};

/** The `projectFolder` to be created by this mutation. */
export type ProjectFolderProjectIdEf44DadfFkProjectIdProjectFolderCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInput>;
    color?: InputMaybe<Scalars["String"]["input"]>;
    dataTablesUsingId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput>;
    id: Scalars["UUID"]["input"];
    name: Scalars["String"]["input"];
    projectToProjectId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** A filter to be used against many `DataTable` object types. All fields are combined with a logical ‘and.’ */
export type ProjectFolderToManyDataTableFilter = {
  /** Every related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableFilter>;
  /** No related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableFilter>;
  /** Some related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableFilter>;
};

/** A filter to be used against many `GdtAnalysisTable` object types. All fields are combined with a logical ‘and.’ */
export type ProjectFolderToManyGdtAnalysisTableFilter = {
  /** Every related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableFilter>;
  /** No related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableFilter>;
  /** Some related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableFilter>;
};

/** The `applicationUser` to be created by this mutation. */
export type ProjectFolderUserIdF2E16179FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `ProjectFolderInput` mutation. */
export type ProjectFolderUserIdF2E16179FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `projectFolder` in the `ApplicationUserInput` mutation. */
export type ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `projectFolder` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectFolderProjectFolderPkeyConnect>>;
  /** A `ProjectFolderInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ProjectFolderUserIdF2E16179FkApplicationUserIdProjectFolderCreateInput>
  >;
  /** The primary key(s) for `projectFolder` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectFolderProjectFolderPkeyDelete>>;
  /** Flag indicating whether all other `projectFolder` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `projectFolder` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingProjectFolderPkeyUpdate>
  >;
};

/** The `projectFolder` to be created by this mutation. */
export type ProjectFolderUserIdF2E16179FkApplicationUserIdProjectFolderCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInput>;
    color?: InputMaybe<Scalars["String"]["input"]>;
    dataTablesUsingId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput>;
    id: Scalars["UUID"]["input"];
    name: Scalars["String"]["input"];
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInput>;
  };

/** A connection to a list of `ProjectFolder` values. */
export type ProjectFoldersConnection = {
  __typename: "ProjectFoldersConnection";
  /** A list of edges which contains the `ProjectFolder` and cursor to aid in pagination. */
  edges: Array<ProjectFoldersEdge>;
  /** A list of `ProjectFolder` objects. */
  nodes: Array<ProjectFolder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectFolder` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ProjectFolder` edge in the connection. */
export type ProjectFoldersEdge = {
  __typename: "ProjectFoldersEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ProjectFolder` at the end of the edge. */
  node: ProjectFolder;
};

/** Methods to use when ordering `ProjectFolder`. */
export enum ProjectFoldersOrderBy {
  ColorAsc = "COLOR_ASC",
  ColorDesc = "COLOR_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnFileForFileProjectId3Ecca975FkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnFileForFileProjectId3Ecca975FkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnTaskForTaskProjectId963D6354FkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnTaskForTaskProjectId963D6354FkProjectIdPatch;
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectKeyTenantUniqueUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnToolForToolProjectId20A84210FkProjectIdPatch;
    tenantId: Scalars["Int"]["input"];
  };

/** The fields on `project` to look up the row to update. */
export type ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `project` being updated. */
    projectPatch: UpdateProjectOnToolForToolProjectId20A84210FkProjectIdPatch;
  };

/** The fields on `project` to look up the row to connect. */
export type ProjectProjectKeyTenantUniqueConnect = {
  key: Scalars["String"]["input"];
  tenantId: Scalars["Int"]["input"];
};

/** The fields on `project` to look up the row to connect. */
export type ProjectProjectPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The `applicationUser` to be created by this mutation. */
export type ProjectSharedNotifSharerIdAbe16C5BFkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `ProjectSharedNotificationInput` mutation. */
export type ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `projectSharedNotification` in the `ApplicationUserInput` mutation. */
export type ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput = {
  /** The primary key(s) for `projectSharedNotification` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ProjectSharedNotificationProjectSharedNotificationPkeyConnect>
  >;
  /** The primary key(s) and patch data for `projectSharedNotification` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingProjectSharedNotificationPkeyUpdate>
  >;
};

/** The `applicationUser` to be created by this mutation. */
export type ProjectSharedNotifUserId9A19122FFkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `ProjectSharedNotificationInput` mutation. */
export type ProjectSharedNotifUserId9A19122FFkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `projectSharedNotification` in the `ApplicationUserInput` mutation. */
export type ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput = {
  /** The primary key(s) for `projectSharedNotification` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<ProjectSharedNotificationProjectSharedNotificationPkeyConnect>
  >;
  /** The primary key(s) and patch data for `projectSharedNotification` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingProjectSharedNotificationPkeyUpdate>
  >;
};

export type ProjectSharedNotification = {
  __typename: "ProjectSharedNotification";
  accessLevel: Scalars["Int"]["output"];
  /** Reads a single `ApplicationUser` that is related to this `ProjectSharedNotification`. */
  applicationUserBySharerId: Maybe<ApplicationUser>;
  /** Reads a single `ApplicationUser` that is related to this `ProjectSharedNotification`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  id: Scalars["UUID"]["output"];
  /** Reads a single `Notification` that is related to this `ProjectSharedNotification`. */
  notificationById: Maybe<Notification>;
  /** Reads a single `Project` that is related to this `ProjectSharedNotification`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  sharerId: Scalars["UUID"]["output"];
  userId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `ProjectSharedNotification` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ProjectSharedNotificationCondition = {
  /** Checks for equality with the object’s `accessLevel` field. */
  accessLevel?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `sharerId` field. */
  sharerId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `ProjectSharedNotification` object types. All fields are combined with a logical ‘and.’ */
export type ProjectSharedNotificationFilter = {
  /** Filter by the object’s `accessLevel` field. */
  accessLevel?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectSharedNotificationFilter>>;
  /** Filter by the object’s `applicationUserBySharerId` relation. */
  applicationUserBySharerId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectSharedNotificationFilter>;
  /** Filter by the object’s `notificationById` relation. */
  notificationById?: InputMaybe<NotificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectSharedNotificationFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `sharerId` field. */
  sharerId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** Input for the nested mutation of `notification` in the `ProjectSharedNotificationInput` mutation. */
export type ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<NotificationNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<NotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingNotificationPkeyUpdate>;
};

/** Input for the nested mutation of `projectSharedNotification` in the `NotificationInput` mutation. */
export type ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput = {
  /** The primary key(s) for `projectSharedNotification` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectSharedNotificationProjectSharedNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `projectSharedNotification` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingProjectSharedNotificationPkeyUpdate>;
};

/** The fields on `projectSharedNotification` to look up the row to update. */
export type ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingProjectSharedNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `projectSharedNotification` being updated. */
    projectSharedNotificationPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
  };

/** The fields on `projectSharedNotification` to look up the row to update. */
export type ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingProjectSharedNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `projectSharedNotification` being updated. */
    projectSharedNotificationPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
  };

/** The fields on `projectSharedNotification` to look up the row to update. */
export type ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingProjectSharedNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `projectSharedNotification` being updated. */
    projectSharedNotificationPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch;
  };

/** The fields on `projectSharedNotification` to look up the row to update. */
export type ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectSharedNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `projectSharedNotification` being updated. */
    projectSharedNotificationPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch;
  };

/** Input for the nested mutation of `project` in the `ProjectSharedNotificationInput` mutation. */
export type ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `projectSharedNotification` in the `ProjectInput` mutation. */
export type ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput =
  {
    /** The primary key(s) for `projectSharedNotification` for the far side of the relationship. */
    connectById?: InputMaybe<
      Array<ProjectSharedNotificationProjectSharedNotificationPkeyConnect>
    >;
    /** The primary key(s) and patch data for `projectSharedNotification` for the far side of the relationship. */
    updateById?: InputMaybe<
      Array<ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectSharedNotificationPkeyUpdate>
    >;
  };

/** The fields on `projectSharedNotification` to look up the row to connect. */
export type ProjectSharedNotificationProjectSharedNotificationPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** A connection to a list of `ProjectSharedNotification` values. */
export type ProjectSharedNotificationsConnection = {
  __typename: "ProjectSharedNotificationsConnection";
  /** A list of edges which contains the `ProjectSharedNotification` and cursor to aid in pagination. */
  edges: Array<ProjectSharedNotificationsEdge>;
  /** A list of `ProjectSharedNotification` objects. */
  nodes: Array<ProjectSharedNotification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectSharedNotification` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ProjectSharedNotification` edge in the connection. */
export type ProjectSharedNotificationsEdge = {
  __typename: "ProjectSharedNotificationsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ProjectSharedNotification` at the end of the edge. */
  node: ProjectSharedNotification;
};

/** Methods to use when ordering `ProjectSharedNotification`. */
export enum ProjectSharedNotificationsOrderBy {
  AccessLevelAsc = "ACCESS_LEVEL_ASC",
  AccessLevelDesc = "ACCESS_LEVEL_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  SharerIdAsc = "SHARER_ID_ASC",
  SharerIdDesc = "SHARER_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

export type ProjectTag = {
  __typename: "ProjectTag";
  /** Reads a single `ApplicationUser` that is related to this `ProjectTag`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateCreated: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  label: Scalars["String"]["output"];
  /** Reads a single `Project` that is related to this `ProjectTag`. */
  projectByProjectId: Maybe<Project>;
  projectId: Scalars["UUID"]["output"];
  userId: Maybe<Scalars["UUID"]["output"]>;
};

/**
 * A condition to be used against `ProjectTag` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ProjectTagCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `ProjectTag` object types. All fields are combined with a logical ‘and.’ */
export type ProjectTagFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectTagFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectTagFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectTagFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `ProjectTag` */
export type ProjectTagInput = {
  applicationUserToUserId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id: Scalars["UUID"]["input"];
  label: Scalars["String"]["input"];
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `projectTag` to look up the row to update. */
export type ProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectTagPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `projectTag` being updated. */
    projectTagPatch: UpdateProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch;
  };

/** The fields on `projectTag` to look up the row to update. */
export type ProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingProjectTagPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `projectTag` being updated. */
    projectTagPatch: UpdateProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
  };

/** Represents an update to a `ProjectTag`. Fields that are set will be updated. */
export type ProjectTagPatch = {
  applicationUserToUserId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `project` in the `ProjectTagInput` mutation. */
export type ProjectTagProjectId5Ab280C9FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `projectTag` in the `ProjectInput` mutation. */
export type ProjectTagProjectId5Ab280C9FkProjectIdInverseInput = {
  /** The primary key(s) for `projectTag` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectTagProjectTagPkeyConnect>>;
  /** A `ProjectTagInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ProjectTagProjectId5Ab280C9FkProjectIdProjectTagCreateInput>
  >;
  /** The primary key(s) for `projectTag` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectTagProjectTagPkeyDelete>>;
  /** Flag indicating whether all other `projectTag` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `projectTag` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectTagPkeyUpdate>
  >;
};

/** The `projectTag` to be created by this mutation. */
export type ProjectTagProjectId5Ab280C9FkProjectIdProjectTagCreateInput = {
  applicationUserToUserId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id: Scalars["UUID"]["input"];
  label: Scalars["String"]["input"];
  projectToProjectId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `projectTag` to look up the row to connect. */
export type ProjectTagProjectTagPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `projectTag` to look up the row to delete. */
export type ProjectTagProjectTagPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** The `applicationUser` to be created by this mutation. */
export type ProjectTagUserId780C8348FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `ProjectTagInput` mutation. */
export type ProjectTagUserId780C8348FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `projectTag` in the `ApplicationUserInput` mutation. */
export type ProjectTagUserId780C8348FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `projectTag` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectTagProjectTagPkeyConnect>>;
  /** A `ProjectTagInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ProjectTagUserId780C8348FkApplicationUserIdProjectTagCreateInput>
  >;
  /** The primary key(s) for `projectTag` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ProjectTagProjectTagPkeyDelete>>;
  /** Flag indicating whether all other `projectTag` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `projectTag` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingProjectTagPkeyUpdate>
  >;
};

/** The `projectTag` to be created by this mutation. */
export type ProjectTagUserId780C8348FkApplicationUserIdProjectTagCreateInput = {
  applicationUserToUserId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id: Scalars["UUID"]["input"];
  label: Scalars["String"]["input"];
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInput>;
};

/** A connection to a list of `ProjectTag` values. */
export type ProjectTagsConnection = {
  __typename: "ProjectTagsConnection";
  /** A list of edges which contains the `ProjectTag` and cursor to aid in pagination. */
  edges: Array<ProjectTagsEdge>;
  /** A list of `ProjectTag` objects. */
  nodes: Array<ProjectTag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ProjectTag` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ProjectTag` edge in the connection. */
export type ProjectTagsEdge = {
  __typename: "ProjectTagsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ProjectTag` at the end of the edge. */
  node: ProjectTag;
};

/** Methods to use when ordering `ProjectTag`. */
export enum ProjectTagsOrderBy {
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  LabelAsc = "LABEL_ASC",
  LabelDesc = "LABEL_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** Input for the nested mutation of `tenant` in the `ProjectInput` mutation. */
export type ProjectTenantId03F0Ca53FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `project` in the `TenantInput` mutation. */
export type ProjectTenantId03F0Ca53FkTenantIdInverseInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectProjectPkeyConnect>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<
    Array<ProjectProjectKeyTenantUniqueConnect>
  >;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<
    Array<ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectKeyTenantUniqueUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type ProjectTenantId03F0Ca53FkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** A filter to be used against many `DataTableCell` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableCellFilter = {
  /** Every related `DataTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableCellFilter>;
  /** No related `DataTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableCellFilter>;
  /** Some related `DataTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableCellFilter>;
};

/** A filter to be used against many `DataTableColumnDefinitionBoolean` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableColumnDefinitionBooleanFilter = {
  /** Every related `DataTableColumnDefinitionBoolean` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnDefinitionBooleanFilter>;
  /** No related `DataTableColumnDefinitionBoolean` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnDefinitionBooleanFilter>;
  /** Some related `DataTableColumnDefinitionBoolean` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnDefinitionBooleanFilter>;
};

/** A filter to be used against many `DataTableColumnDefinitionCellStatus` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableColumnDefinitionCellStatusFilter = {
  /** Every related `DataTableColumnDefinitionCellStatus` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnDefinitionCellStatusFilter>;
  /** No related `DataTableColumnDefinitionCellStatus` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnDefinitionCellStatusFilter>;
  /** Some related `DataTableColumnDefinitionCellStatus` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnDefinitionCellStatusFilter>;
};

/** A filter to be used against many `DataTableColumnDefinitionChoice` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableColumnDefinitionChoiceFilter = {
  /** Every related `DataTableColumnDefinitionChoice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnDefinitionChoiceFilter>;
  /** No related `DataTableColumnDefinitionChoice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnDefinitionChoiceFilter>;
  /** Some related `DataTableColumnDefinitionChoice` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnDefinitionChoiceFilter>;
};

/** A filter to be used against many `DataTableColumnDefinitionDate` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableColumnDefinitionDateFilter = {
  /** Every related `DataTableColumnDefinitionDate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnDefinitionDateFilter>;
  /** No related `DataTableColumnDefinitionDate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnDefinitionDateFilter>;
  /** Some related `DataTableColumnDefinitionDate` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnDefinitionDateFilter>;
};

/** A filter to be used against many `DataTableColumnDefinitionFile` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableColumnDefinitionFileFilter = {
  /** Every related `DataTableColumnDefinitionFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnDefinitionFileFilter>;
  /** No related `DataTableColumnDefinitionFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnDefinitionFileFilter>;
  /** Some related `DataTableColumnDefinitionFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnDefinitionFileFilter>;
};

/** A filter to be used against many `DataTableColumnDefinitionFloat` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableColumnDefinitionFloatFilter = {
  /** Every related `DataTableColumnDefinitionFloat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnDefinitionFloatFilter>;
  /** No related `DataTableColumnDefinitionFloat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnDefinitionFloatFilter>;
  /** Some related `DataTableColumnDefinitionFloat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnDefinitionFloatFilter>;
};

/** A filter to be used against many `DataTableColumnDefinitionIdentifier` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableColumnDefinitionIdentifierFilter = {
  /** Every related `DataTableColumnDefinitionIdentifier` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnDefinitionIdentifierFilter>;
  /** No related `DataTableColumnDefinitionIdentifier` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnDefinitionIdentifierFilter>;
  /** Some related `DataTableColumnDefinitionIdentifier` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnDefinitionIdentifierFilter>;
};

/** A filter to be used against many `DataTableColumnDefinitionInteger` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableColumnDefinitionIntegerFilter = {
  /** Every related `DataTableColumnDefinitionInteger` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnDefinitionIntegerFilter>;
  /** No related `DataTableColumnDefinitionInteger` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnDefinitionIntegerFilter>;
  /** Some related `DataTableColumnDefinitionInteger` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnDefinitionIntegerFilter>;
};

/** A filter to be used against many `DataTableColumnDefinitionJoin` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableColumnDefinitionJoinFilter = {
  /** Every related `DataTableColumnDefinitionJoin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnDefinitionJoinFilter>;
  /** No related `DataTableColumnDefinitionJoin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnDefinitionJoinFilter>;
  /** Some related `DataTableColumnDefinitionJoin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnDefinitionJoinFilter>;
};

/** A filter to be used against many `DataTableColumnDefinitionMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableColumnDefinitionMetadatumFilter = {
  /** Every related `DataTableColumnDefinitionMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnDefinitionMetadatumFilter>;
  /** No related `DataTableColumnDefinitionMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnDefinitionMetadatumFilter>;
  /** Some related `DataTableColumnDefinitionMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnDefinitionMetadatumFilter>;
};

/** A filter to be used against many `DataTableColumnDefinitionRoiFrame` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableColumnDefinitionRoiFrameFilter = {
  /** Every related `DataTableColumnDefinitionRoiFrame` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnDefinitionRoiFrameFilter>;
  /** No related `DataTableColumnDefinitionRoiFrame` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnDefinitionRoiFrameFilter>;
  /** Some related `DataTableColumnDefinitionRoiFrame` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnDefinitionRoiFrameFilter>;
};

/** A filter to be used against many `DataTableColumnDefinitionText` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableColumnDefinitionTextFilter = {
  /** Every related `DataTableColumnDefinitionText` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnDefinitionTextFilter>;
  /** No related `DataTableColumnDefinitionText` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnDefinitionTextFilter>;
  /** Some related `DataTableColumnDefinitionText` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnDefinitionTextFilter>;
};

/** A filter to be used against many `DataTableColumn` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableColumnFilter = {
  /** Every related `DataTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnFilter>;
  /** No related `DataTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnFilter>;
  /** Some related `DataTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnFilter>;
};

/** A filter to be used against many `DataTableColumnGroupDefinitionJoin` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableColumnGroupDefinitionJoinFilter = {
  /** Every related `DataTableColumnGroupDefinitionJoin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnGroupDefinitionJoinFilter>;
  /** No related `DataTableColumnGroupDefinitionJoin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnGroupDefinitionJoinFilter>;
  /** Some related `DataTableColumnGroupDefinitionJoin` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnGroupDefinitionJoinFilter>;
};

/** A filter to be used against many `DataTableColumnGroupDefinitionSource` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableColumnGroupDefinitionSourceFilter = {
  /** Every related `DataTableColumnGroupDefinitionSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnGroupDefinitionSourceFilter>;
  /** No related `DataTableColumnGroupDefinitionSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnGroupDefinitionSourceFilter>;
  /** Some related `DataTableColumnGroupDefinitionSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnGroupDefinitionSourceFilter>;
};

/** A filter to be used against many `DataTableColumnGroup` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableColumnGroupFilter = {
  /** Every related `DataTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableColumnGroupFilter>;
  /** No related `DataTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableColumnGroupFilter>;
  /** Some related `DataTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableColumnGroupFilter>;
};

/** A filter to be used against many `DataTable` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableFilter = {
  /** Every related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableFilter>;
  /** No related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableFilter>;
  /** Some related `DataTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableFilter>;
};

/** A filter to be used against many `DataTableRow` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDataTableRowFilter = {
  /** Every related `DataTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DataTableRowFilter>;
  /** No related `DataTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DataTableRowFilter>;
  /** Some related `DataTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DataTableRowFilter>;
};

/** A filter to be used against many `FileActivity` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyFileActivityFilter = {
  /** Every related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileActivityFilter>;
  /** No related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileActivityFilter>;
  /** Some related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileActivityFilter>;
};

/** A filter to be used against many `File` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyFileFilter = {
  /** Every related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileFilter>;
  /** No related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileFilter>;
  /** Some related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileFilter>;
};

/** A filter to be used against many `FileMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyFileMetadatumFilter = {
  /** Every related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileMetadatumFilter>;
  /** No related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileMetadatumFilter>;
  /** Some related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileMetadatumFilter>;
};

/** A filter to be used against many `FileOutputGroup` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyFileOutputGroupFilter = {
  /** Every related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileOutputGroupFilter>;
  /** No related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileOutputGroupFilter>;
  /** Some related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileOutputGroupFilter>;
};

/** A filter to be used against many `FileOutputGroupMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyFileOutputGroupMetadatumFilter = {
  /** Every related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** No related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** Some related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileOutputGroupMetadatumFilter>;
};

/** A filter to be used against many `GdtAnalysisTableCell` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyGdtAnalysisTableCellFilter = {
  /** Every related `GdtAnalysisTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableCellFilter>;
  /** No related `GdtAnalysisTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableCellFilter>;
  /** Some related `GdtAnalysisTableCell` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableCellFilter>;
};

/** A filter to be used against many `GdtAnalysisTableColumn` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyGdtAnalysisTableColumnFilter = {
  /** Every related `GdtAnalysisTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableColumnFilter>;
  /** No related `GdtAnalysisTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableColumnFilter>;
  /** Some related `GdtAnalysisTableColumn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableColumnFilter>;
};

/** A filter to be used against many `GdtAnalysisTableColumnGroup` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyGdtAnalysisTableColumnGroupFilter = {
  /** Every related `GdtAnalysisTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
  /** No related `GdtAnalysisTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
  /** Some related `GdtAnalysisTableColumnGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
};

/** A filter to be used against many `GdtAnalysisTable` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyGdtAnalysisTableFilter = {
  /** Every related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableFilter>;
  /** No related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableFilter>;
  /** Some related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableFilter>;
};

/** A filter to be used against many `GdtAnalysisTableRow` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyGdtAnalysisTableRowFilter = {
  /** Every related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** No related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** Some related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableRowFilter>;
};

/** A filter to be used against many `MetadataValue` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyMetadataValueFilter = {
  /** Every related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MetadataValueFilter>;
  /** No related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MetadataValueFilter>;
  /** Some related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MetadataValueFilter>;
};

/** A filter to be used against many `Metadatum` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyMetadatumFilter = {
  /** Every related `Metadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MetadatumFilter>;
  /** No related `Metadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MetadatumFilter>;
  /** Some related `Metadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MetadatumFilter>;
};

/** A filter to be used against many `OutputGroupFile` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyOutputGroupFileFilter = {
  /** Every related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OutputGroupFileFilter>;
  /** No related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OutputGroupFileFilter>;
  /** Some related `OutputGroupFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OutputGroupFileFilter>;
};

/** A filter to be used against many `ProjectClonedNotification` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyProjectClonedNotificationFilter = {
  /** Every related `ProjectClonedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectClonedNotificationFilter>;
  /** No related `ProjectClonedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectClonedNotificationFilter>;
  /** Some related `ProjectClonedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectClonedNotificationFilter>;
};

/** A filter to be used against many `Project` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyProjectFilter = {
  /** Every related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectFilter>;
  /** No related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectFilter>;
  /** Some related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectFilter>;
};

/** A filter to be used against many `ProjectFolder` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyProjectFolderFilter = {
  /** Every related `ProjectFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectFolderFilter>;
  /** No related `ProjectFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectFolderFilter>;
  /** Some related `ProjectFolder` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectFolderFilter>;
};

/** A filter to be used against many `ProjectSharedNotification` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyProjectSharedNotificationFilter = {
  /** Every related `ProjectSharedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectSharedNotificationFilter>;
  /** No related `ProjectSharedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectSharedNotificationFilter>;
  /** Some related `ProjectSharedNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectSharedNotificationFilter>;
};

/** A filter to be used against many `ProjectTag` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyProjectTagFilter = {
  /** Every related `ProjectTag` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectTagFilter>;
  /** No related `ProjectTag` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectTagFilter>;
  /** Some related `ProjectTag` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectTagFilter>;
};

/** A filter to be used against many `Task` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyTaskFilter = {
  /** Every related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskFilter>;
  /** No related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskFilter>;
  /** Some related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskFilter>;
};

/** The `applicationUser` to be created by this mutation. */
export type ProjectUserIdB5Fbb914FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `ProjectInput` mutation. */
export type ProjectUserIdB5Fbb914FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `project` in the `ApplicationUserInput` mutation. */
export type ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ProjectProjectPkeyConnect>>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<
    Array<ProjectProjectKeyTenantUniqueConnect>
  >;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<
    Array<ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectKeyTenantUniqueUpdate>
  >;
};

/** A connection to a list of `Project` values. */
export type ProjectsConnection = {
  __typename: "ProjectsConnection";
  /** A list of edges which contains the `Project` and cursor to aid in pagination. */
  edges: Array<ProjectsEdge>;
  /** A list of `Project` objects. */
  nodes: Array<Project>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Project` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `Project` edge in the connection. */
export type ProjectsEdge = {
  __typename: "ProjectsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `Project` at the end of the edge. */
  node: Project;
};

/** Methods to use when ordering `Project`. */
export enum ProjectsOrderBy {
  CloneSourceIdAsc = "CLONE_SOURCE_ID_ASC",
  CloneSourceIdDesc = "CLONE_SOURCE_ID_DESC",
  DateArchivedAsc = "DATE_ARCHIVED_ASC",
  DateArchivedDesc = "DATE_ARCHIVED_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DateDataDeletedAsc = "DATE_DATA_DELETED_ASC",
  DateDataDeletedDesc = "DATE_DATA_DELETED_DESC",
  DateDeletedAsc = "DATE_DELETED_ASC",
  DateDeletedDesc = "DATE_DELETED_DESC",
  DefaultUserAccessLevelAsc = "DEFAULT_USER_ACCESS_LEVEL_ASC",
  DefaultUserAccessLevelDesc = "DEFAULT_USER_ACCESS_LEVEL_DESC",
  DescriptionAsc = "DESCRIPTION_ASC",
  DescriptionDesc = "DESCRIPTION_DESC",
  IconAsc = "ICON_ASC",
  IconColorAsc = "ICON_COLOR_ASC",
  IconColorDesc = "ICON_COLOR_DESC",
  IconDesc = "ICON_DESC",
  IconTextAsc = "ICON_TEXT_ASC",
  IconTextDesc = "ICON_TEXT_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  IsDemoAsc = "IS_DEMO_ASC",
  IsDemoDesc = "IS_DEMO_DESC",
  IsToolProjectAsc = "IS_TOOL_PROJECT_ASC",
  IsToolProjectDesc = "IS_TOOL_PROJECT_DESC",
  KeyAsc = "KEY_ASC",
  KeyDesc = "KEY_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrefixAsc = "PREFIX_ASC",
  PrefixDesc = "PREFIX_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ShortDescriptionAsc = "SHORT_DESCRIPTION_ASC",
  ShortDescriptionDesc = "SHORT_DESCRIPTION_DESC",
  StatusAsc = "STATUS_ASC",
  StatusDesc = "STATUS_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  TourTypeAsc = "TOUR_TYPE_ASC",
  TourTypeDesc = "TOUR_TYPE_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** The root query type which gives access points into the data universe. */
export type Query = {
  __typename: "Query";
  /** Reads and enables pagination through a set of `AdminProject`. */
  allAdminProjects: Maybe<AdminProjectsConnection>;
  /** Reads and enables pagination through a set of `ApplicationUserGroup`. */
  allApplicationUserGroups: Maybe<ApplicationUserGroupsConnection>;
  /** Reads and enables pagination through a set of `ApplicationUserMembership`. */
  allApplicationUserMemberships: Maybe<ApplicationUserMembershipsConnection>;
  /** Reads and enables pagination through a set of `ApplicationUserMetadatum`. */
  allApplicationUserMetadata: Maybe<ApplicationUserMetadataConnection>;
  /** Reads and enables pagination through a set of `ApplicationUserSession`. */
  allApplicationUserSessions: Maybe<ApplicationUserSessionsConnection>;
  /** Reads and enables pagination through a set of `ApplicationUserUserPermission`. */
  allApplicationUserUserPermissions: Maybe<ApplicationUserUserPermissionsConnection>;
  /** Reads and enables pagination through a set of `AuditlogLogentry`. */
  allAuditlogLogentries: Maybe<AuditlogLogentriesConnection>;
  /** Reads and enables pagination through a set of `AuthGroupPermission`. */
  allAuthGroupPermissions: Maybe<AuthGroupPermissionsConnection>;
  /** Reads and enables pagination through a set of `AuthGroup`. */
  allAuthGroups: Maybe<AuthGroupsConnection>;
  /** Reads and enables pagination through a set of `AuthPermission`. */
  allAuthPermissions: Maybe<AuthPermissionsConnection>;
  /** Reads and enables pagination through a set of `AvailableNonRestrictedProject`. */
  allAvailableNonRestrictedProjects: Maybe<AvailableNonRestrictedProjectsConnection>;
  /** Reads and enables pagination through a set of `Avatar`. */
  allAvatars: Maybe<AvatarsConnection>;
  /** Reads and enables pagination through a set of `AwsBatchTask`. */
  allAwsBatchTasks: Maybe<AwsBatchTasksConnection>;
  /** Reads and enables pagination through a set of `AwsCognitoUser`. */
  allAwsCognitoUsers: Maybe<AwsCognitoUsersConnection>;
  /** Reads and enables pagination through a set of `AwsEcrImage`. */
  allAwsEcrImages: Maybe<AwsEcrImagesConnection>;
  /** Reads and enables pagination through a set of `AwsMockBatchTask`. */
  allAwsMockBatchTasks: Maybe<AwsMockBatchTasksConnection>;
  /** Reads and enables pagination through a set of `AwsMockDistributionImage`. */
  allAwsMockDistributionImages: Maybe<AwsMockDistributionImagesConnection>;
  /** Reads and enables pagination through a set of `AwsMockEcrImage`. */
  allAwsMockEcrImages: Maybe<AwsMockEcrImagesConnection>;
  /** Reads and enables pagination through a set of `AwsMockIamUser`. */
  allAwsMockIamUsers: Maybe<AwsMockIamUsersConnection>;
  /** Reads and enables pagination through a set of `AwsMockS3File`. */
  allAwsMockS3Files: Maybe<AwsMockS3FilesConnection>;
  /** Reads and enables pagination through a set of `AwsS3File`. */
  allAwsS3Files: Maybe<AwsS3FilesConnection>;
  /** Reads and enables pagination through a set of `CodeFile`. */
  allCodeFiles: Maybe<CodeFilesConnection>;
  /** Reads and enables pagination through a set of `Command`. */
  allCommands: Maybe<CommandsConnection>;
  /** Reads and enables pagination through a set of `ContainerImageRepository`. */
  allContainerImageRepositories: Maybe<ContainerImageRepositoriesConnection>;
  /** Reads and enables pagination through a set of `ContainerImage`. */
  allContainerImages: Maybe<ContainerImagesConnection>;
  /** Reads and enables pagination through a set of `Cost`. */
  allCosts: Maybe<CostsConnection>;
  /** Reads and enables pagination through a set of `CurrentApplicationUser`. */
  allCurrentApplicationUsers: Maybe<CurrentApplicationUsersConnection>;
  /** Reads and enables pagination through a set of `CurrentUserMembership`. */
  allCurrentUserMemberships: Maybe<CurrentUserMembershipsConnection>;
  /** Reads and enables pagination through a set of `DataTableCell`. */
  allDataTableCells: Maybe<DataTableCellsConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionBoolean`. */
  allDataTableColumnDefinitionBooleans: Maybe<DataTableColumnDefinitionBooleansConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionCellStatus`. */
  allDataTableColumnDefinitionCellStatuses: Maybe<DataTableColumnDefinitionCellStatusesConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionChoice`. */
  allDataTableColumnDefinitionChoices: Maybe<DataTableColumnDefinitionChoicesConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionDate`. */
  allDataTableColumnDefinitionDates: Maybe<DataTableColumnDefinitionDatesConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionFile`. */
  allDataTableColumnDefinitionFiles: Maybe<DataTableColumnDefinitionFilesConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionFloat`. */
  allDataTableColumnDefinitionFloats: Maybe<DataTableColumnDefinitionFloatsConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionIdentifier`. */
  allDataTableColumnDefinitionIdentifiers: Maybe<DataTableColumnDefinitionIdentifiersConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionInteger`. */
  allDataTableColumnDefinitionIntegers: Maybe<DataTableColumnDefinitionIntegersConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionJoin`. */
  allDataTableColumnDefinitionJoins: Maybe<DataTableColumnDefinitionJoinsConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionMetadatum`. */
  allDataTableColumnDefinitionMetadata: Maybe<DataTableColumnDefinitionMetadataConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionRoiFrame`. */
  allDataTableColumnDefinitionRoiFrames: Maybe<DataTableColumnDefinitionRoiFramesConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionText`. */
  allDataTableColumnDefinitionTexts: Maybe<DataTableColumnDefinitionTextsConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnGroupDefinitionJoin`. */
  allDataTableColumnGroupDefinitionJoins: Maybe<DataTableColumnGroupDefinitionJoinsConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnGroupDefinitionSource`. */
  allDataTableColumnGroupDefinitionSources: Maybe<DataTableColumnGroupDefinitionSourcesConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnGroup`. */
  allDataTableColumnGroups: Maybe<DataTableColumnGroupsConnection>;
  /** Reads and enables pagination through a set of `DataTableColumn`. */
  allDataTableColumns: Maybe<DataTableColumnsConnection>;
  /** Reads and enables pagination through a set of `DataTableRow`. */
  allDataTableRows: Maybe<DataTableRowsConnection>;
  /** Reads and enables pagination through a set of `DataTable`. */
  allDataTables: Maybe<DataTablesConnection>;
  /** Reads and enables pagination through a set of `DistributionRegistryImage`. */
  allDistributionRegistryImages: Maybe<DistributionRegistryImagesConnection>;
  /** Reads and enables pagination through a set of `DjangoAdminLog`. */
  allDjangoAdminLogs: Maybe<DjangoAdminLogsConnection>;
  /** Reads and enables pagination through a set of `DjangoContentType`. */
  allDjangoContentTypes: Maybe<DjangoContentTypesConnection>;
  /** Reads and enables pagination through a set of `DjangoMigration`. */
  allDjangoMigrations: Maybe<DjangoMigrationsConnection>;
  /** Reads and enables pagination through a set of `DjangoSesBlacklistedemail`. */
  allDjangoSesBlacklistedemails: Maybe<DjangoSesBlacklistedemailsConnection>;
  /** Reads and enables pagination through a set of `DjangoSesSesstat`. */
  allDjangoSesSesstats: Maybe<DjangoSesSesstatsConnection>;
  /** Reads and enables pagination through a set of `DjangoSession`. */
  allDjangoSessions: Maybe<DjangoSessionsConnection>;
  /** Reads and enables pagination through a set of `DrsFileexecutor`. */
  allDrsFileexecutors: Maybe<DrsFileexecutorsConnection>;
  /** Reads and enables pagination through a set of `DrsMockfileexecutor`. */
  allDrsMockfileexecutors: Maybe<DrsMockfileexecutorsConnection>;
  /** Reads and enables pagination through a set of `EulaVersionUserAcceptance`. */
  allEulaVersionUserAcceptances: Maybe<EulaVersionUserAcceptancesConnection>;
  /** Reads and enables pagination through a set of `EulaVersion`. */
  allEulaVersions: Maybe<EulaVersionsConnection>;
  /** Reads and enables pagination through a set of `FeatureFlag`. */
  allFeatureFlags: Maybe<FeatureFlagsConnection>;
  /** Reads and enables pagination through a set of `FeatureFlagsGroup`. */
  allFeatureFlagsGroups: Maybe<FeatureFlagsGroupsConnection>;
  /** Reads and enables pagination through a set of `FeatureFlagsTenant`. */
  allFeatureFlagsTenants: Maybe<FeatureFlagsTenantsConnection>;
  /** Reads and enables pagination through a set of `FeatureFlagsUser`. */
  allFeatureFlagsUsers: Maybe<FeatureFlagsUsersConnection>;
  /** Reads and enables pagination through a set of `FileActivity`. */
  allFileActivities: Maybe<FileActivitiesConnection>;
  /** Reads and enables pagination through a set of `FileMetadatum`. */
  allFileMetadata: Maybe<FileMetadataConnection>;
  /** Reads and enables pagination through a set of `FileOutputGroupMetadatum`. */
  allFileOutputGroupMetadata: Maybe<FileOutputGroupMetadataConnection>;
  /** Reads and enables pagination through a set of `FileOutputGroup`. */
  allFileOutputGroups: Maybe<FileOutputGroupsConnection>;
  /** Reads and enables pagination through a set of `FileProcessingNotification`. */
  allFileProcessingNotifications: Maybe<FileProcessingNotificationsConnection>;
  /** Reads and enables pagination through a set of `File`. */
  allFiles: Maybe<FilesConnection>;
  /** Reads and enables pagination through a set of `FilesByExecutor`. */
  allFilesByExecutors: Maybe<FilesByExecutorsConnection>;
  /** Reads and enables pagination through a set of `GdtAnalysisTableCell`. */
  allGdtAnalysisTableCells: Maybe<GdtAnalysisTableCellsConnection>;
  /** Reads and enables pagination through a set of `GdtAnalysisTableColumnGroup`. */
  allGdtAnalysisTableColumnGroups: Maybe<GdtAnalysisTableColumnGroupsConnection>;
  /** Reads and enables pagination through a set of `GdtAnalysisTableColumn`. */
  allGdtAnalysisTableColumns: Maybe<GdtAnalysisTableColumnsConnection>;
  /** Reads and enables pagination through a set of `GdtAnalysisTableRow`. */
  allGdtAnalysisTableRows: Maybe<GdtAnalysisTableRowsConnection>;
  /** Reads and enables pagination through a set of `GdtAnalysisTable`. */
  allGdtAnalysisTables: Maybe<GdtAnalysisTablesConnection>;
  /** Reads and enables pagination through a set of `Notification`. */
  allNotifications: Maybe<NotificationsConnection>;
  /** Reads and enables pagination through a set of `OutputGroupFile`. */
  allOutputGroupFiles: Maybe<OutputGroupFilesConnection>;
  /** Reads and enables pagination through a set of `PinnedTool`. */
  allPinnedTools: Maybe<PinnedToolsConnection>;
  /** Reads and enables pagination through a set of `ProjectClonedNotification`. */
  allProjectClonedNotifications: Maybe<ProjectClonedNotificationsConnection>;
  /** Reads and enables pagination through a set of `ProjectFolder`. */
  allProjectFolders: Maybe<ProjectFoldersConnection>;
  /** Reads and enables pagination through a set of `ProjectSharedNotification`. */
  allProjectSharedNotifications: Maybe<ProjectSharedNotificationsConnection>;
  /** Reads and enables pagination through a set of `ProjectTag`. */
  allProjectTags: Maybe<ProjectTagsConnection>;
  /** Reads and enables pagination through a set of `Project`. */
  allProjects: Maybe<ProjectsConnection>;
  /** Reads and enables pagination through a set of `RoleChangeNotification`. */
  allRoleChangeNotifications: Maybe<RoleChangeNotificationsConnection>;
  /** Reads and enables pagination through a set of `Run`. */
  allRuns: Maybe<RunsConnection>;
  /** Reads and enables pagination through a set of `TaskActivity`. */
  allTaskActivities: Maybe<TaskActivitiesConnection>;
  /** Reads and enables pagination through a set of `TaskResourceUsage`. */
  allTaskResourceUsages: Maybe<TaskResourceUsagesConnection>;
  /** Reads and enables pagination through a set of `TaskResource`. */
  allTaskResources: Maybe<TaskResourcesConnection>;
  /** Reads and enables pagination through a set of `TaskSource`. */
  allTaskSources: Maybe<TaskSourcesConnection>;
  /** Reads and enables pagination through a set of `TaskStatusLog`. */
  allTaskStatusLogs: Maybe<TaskStatusLogsConnection>;
  /** Reads and enables pagination through a set of `Task`. */
  allTasks: Maybe<TasksConnection>;
  /** Reads and enables pagination through a set of `TenantContractAllowance`. */
  allTenantContractAllowances: Maybe<TenantContractAllowancesConnection>;
  /** Reads and enables pagination through a set of `TenantContractTransaction`. */
  allTenantContractTransactions: Maybe<TenantContractTransactionsConnection>;
  /** Reads and enables pagination through a set of `TenantContract`. */
  allTenantContracts: Maybe<TenantContractsConnection>;
  /** Reads and enables pagination through a set of `TenantMockuserexecutor`. */
  allTenantMockuserexecutors: Maybe<TenantMockuserexecutorsConnection>;
  /** Reads and enables pagination through a set of `TenantMonthlyConsumedResource`. */
  allTenantMonthlyConsumedResources: Maybe<TenantMonthlyConsumedResourcesConnection>;
  /** Reads and enables pagination through a set of `TenantUserMembershipNotification`. */
  allTenantUserMembershipNotifications: Maybe<TenantUserMembershipNotificationsConnection>;
  /** Reads and enables pagination through a set of `TenantUserexecutor`. */
  allTenantUserexecutors: Maybe<TenantUserexecutorsConnection>;
  /** Reads and enables pagination through a set of `TesContainerimageexecutor`. */
  allTesContainerimageexecutors: Maybe<TesContainerimageexecutorsConnection>;
  /** Reads and enables pagination through a set of `TesMockcontainerimageexecutor`. */
  allTesMockcontainerimageexecutors: Maybe<TesMockcontainerimageexecutorsConnection>;
  /** Reads and enables pagination through a set of `TesMocktaskexecutor`. */
  allTesMocktaskexecutors: Maybe<TesMocktaskexecutorsConnection>;
  /** Reads and enables pagination through a set of `TesTaskexecutor`. */
  allTesTaskexecutors: Maybe<TesTaskexecutorsConnection>;
  /** Reads and enables pagination through a set of `ToolParameter`. */
  allToolParameters: Maybe<ToolParametersConnection>;
  /** Reads and enables pagination through a set of `ToolResource`. */
  allToolResources: Maybe<ToolResourcesConnection>;
  /** Reads and enables pagination through a set of `ToolResult`. */
  allToolResults: Maybe<ToolResultsConnection>;
  /** Reads and enables pagination through a set of `ToolSecret`. */
  allToolSecrets: Maybe<ToolSecretsConnection>;
  /** Reads and enables pagination through a set of `ToolSource`. */
  allToolSources: Maybe<ToolSourcesConnection>;
  /** Reads and enables pagination through a set of `ToolTenant`. */
  allToolTenants: Maybe<ToolTenantsConnection>;
  /** Reads and enables pagination through a set of `ToolVersion`. */
  allToolVersions: Maybe<ToolVersionsConnection>;
  /** Reads and enables pagination through a set of `ToolboxTenant`. */
  allToolboxTenants: Maybe<ToolboxTenantsConnection>;
  /** Reads and enables pagination through a set of `Toolbox`. */
  allToolboxes: Maybe<ToolboxesConnection>;
  /** Reads and enables pagination through a set of `Tool`. */
  allTools: Maybe<ToolsConnection>;
  /** Reads and enables pagination through a set of `UserAccessToProject`. */
  allUserAccessToProjects: Maybe<UserAccessToProjectsConnection>;
  /** Reads and enables pagination through a set of `UserOnboardingQuestionAnswer`. */
  allUserOnboardingQuestionAnswers: Maybe<UserOnboardingQuestionAnswersConnection>;
  /** Reads and enables pagination through a set of `UserOnboardingQuestionResponse`. */
  allUserOnboardingQuestionResponses: Maybe<UserOnboardingQuestionResponsesConnection>;
  /** Reads and enables pagination through a set of `UserOnboardingQuestion`. */
  allUserOnboardingQuestions: Maybe<UserOnboardingQuestionsConnection>;
  /** Reads and enables pagination through a set of `WaffleFlag`. */
  allWaffleFlags: Maybe<WaffleFlagsConnection>;
  /** Reads and enables pagination through a set of `WaffleSample`. */
  allWaffleSamples: Maybe<WaffleSamplesConnection>;
  /** Reads and enables pagination through a set of `WaffleSwitch`. */
  allWaffleSwitches: Maybe<WaffleSwitchesConnection>;
  /** Reads and enables pagination through a set of `WorkflowDatum`. */
  allWorkflowData: Maybe<WorkflowDataConnection>;
  /** Reads and enables pagination through a set of `WorkflowResultWorkflowVersion`. */
  allWorkflowResultWorkflowVersions: Maybe<WorkflowResultWorkflowVersionsConnection>;
  /** Reads and enables pagination through a set of `WorkflowResult`. */
  allWorkflowResults: Maybe<WorkflowResultsConnection>;
  /** Reads and enables pagination through a set of `WorkflowSectionBlockSection`. */
  allWorkflowSectionBlockSections: Maybe<WorkflowSectionBlockSectionsConnection>;
  /** Reads and enables pagination through a set of `WorkflowSectionBlock`. */
  allWorkflowSectionBlocks: Maybe<WorkflowSectionBlocksConnection>;
  /** Reads and enables pagination through a set of `WorkflowSectionWorkflowVersion`. */
  allWorkflowSectionWorkflowVersions: Maybe<WorkflowSectionWorkflowVersionsConnection>;
  /** Reads and enables pagination through a set of `WorkflowSection`. */
  allWorkflowSections: Maybe<WorkflowSectionsConnection>;
  /** Reads and enables pagination through a set of `WorkflowSourceWorkflowVersion`. */
  allWorkflowSourceWorkflowVersions: Maybe<WorkflowSourceWorkflowVersionsConnection>;
  /** Reads and enables pagination through a set of `WorkflowSource`. */
  allWorkflowSources: Maybe<WorkflowSourcesConnection>;
  /** Reads and enables pagination through a set of `WorkflowVersion`. */
  allWorkflowVersions: Maybe<WorkflowVersionsConnection>;
  /** Reads and enables pagination through a set of `Workflow`. */
  allWorkflows: Maybe<WorkflowsConnection>;
  applicationUserByEmail: Maybe<ApplicationUser>;
  applicationUserByGlobalUserId: Maybe<ApplicationUser>;
  applicationUserById: Maybe<ApplicationUser>;
  applicationUserByUsername: Maybe<ApplicationUser>;
  applicationUserGroupById: Maybe<ApplicationUserGroup>;
  applicationUserGroupByUserIdAndGroupId: Maybe<ApplicationUserGroup>;
  applicationUserMembershipById: Maybe<ApplicationUserMembership>;
  applicationUserMembershipByUserIdAndTenantId: Maybe<ApplicationUserMembership>;
  applicationUserMetadatumById: Maybe<ApplicationUserMetadatum>;
  applicationUserMetadatumByUserIdAndKey: Maybe<ApplicationUserMetadatum>;
  applicationUserSessionById: Maybe<ApplicationUserSession>;
  applicationUserUserPermissionById: Maybe<ApplicationUserUserPermission>;
  applicationUserUserPermissionByUserIdAndPermissionId: Maybe<ApplicationUserUserPermission>;
  assertUserAcceptedEula: Maybe<Scalars["Boolean"]["output"]>;
  assertUserCanSeeTenantInfo: Maybe<Scalars["Boolean"]["output"]>;
  assertUserCanSeeUserInfo: Maybe<Scalars["Boolean"]["output"]>;
  assertUserHasProjectSharedByTenant: Maybe<Scalars["Boolean"]["output"]>;
  assertUserHasTenantOfId: Maybe<Scalars["Boolean"]["output"]>;
  assertUserIsAdminOfProjectTenant: Maybe<Scalars["Boolean"]["output"]>;
  assertUserIsAdminOfTenant: Maybe<Scalars["Boolean"]["output"]>;
  assertUserIsInvitedToTenant: Maybe<Scalars["Boolean"]["output"]>;
  auditlogLogentryById: Maybe<AuditlogLogentry>;
  authGroupById: Maybe<AuthGroup>;
  authGroupByName: Maybe<AuthGroup>;
  authGroupPermissionByGroupIdAndPermissionId: Maybe<AuthGroupPermission>;
  authGroupPermissionById: Maybe<AuthGroupPermission>;
  authPermissionByContentTypeIdAndCodename: Maybe<AuthPermission>;
  authPermissionById: Maybe<AuthPermission>;
  avatarById: Maybe<Avatar>;
  avatarByUserId: Maybe<Avatar>;
  awsBatchTaskByTaskexecutorPtrId: Maybe<AwsBatchTask>;
  awsCognitoUserByUserexecutorPtrId: Maybe<AwsCognitoUser>;
  awsEcrImageByContainerimageexecutorPtrId: Maybe<AwsEcrImage>;
  awsMockBatchTaskByAwstaskexecutorPtrId: Maybe<AwsMockBatchTask>;
  awsMockDistributionImageByDistributioncontainerimageexecutorPtrId: Maybe<AwsMockDistributionImage>;
  awsMockEcrImageByAwscontainerimageexecutorPtrId: Maybe<AwsMockEcrImage>;
  awsMockIamUserByAwsuserexecutorPtrId: Maybe<AwsMockIamUser>;
  awsMockS3FileByAwsfileexecutorPtrId: Maybe<AwsMockS3File>;
  awsS3FileByFileexecutorPtrId: Maybe<AwsS3File>;
  codeFileById: Maybe<CodeFile>;
  commandById: Maybe<Command>;
  commandByToolVersionId: Maybe<Command>;
  commandByToolVersionIdAndCodeFileId: Maybe<Command>;
  containerImageByExecutorId: Maybe<ContainerImage>;
  containerImageById: Maybe<ContainerImage>;
  containerImageRepositoryById: Maybe<ContainerImageRepository>;
  containerImageRepositoryByNameAndTenantIdAndRegistryType: Maybe<ContainerImageRepository>;
  containerImageRepositoryByRepository: Maybe<ContainerImageRepository>;
  costById: Maybe<Cost>;
  dataTableById: Maybe<DataTable>;
  dataTableCellByColumnIdAndRowId: Maybe<DataTableCell>;
  dataTableCellById: Maybe<DataTableCell>;
  dataTableColumnById: Maybe<DataTableColumn>;
  dataTableColumnByTableIdAndOrder: Maybe<DataTableColumn>;
  dataTableColumnDefinitionBooleanById: Maybe<DataTableColumnDefinitionBoolean>;
  dataTableColumnDefinitionCellStatusById: Maybe<DataTableColumnDefinitionCellStatus>;
  dataTableColumnDefinitionChoiceById: Maybe<DataTableColumnDefinitionChoice>;
  dataTableColumnDefinitionDateById: Maybe<DataTableColumnDefinitionDate>;
  dataTableColumnDefinitionFileById: Maybe<DataTableColumnDefinitionFile>;
  dataTableColumnDefinitionFloatById: Maybe<DataTableColumnDefinitionFloat>;
  dataTableColumnDefinitionIdentifierById: Maybe<DataTableColumnDefinitionIdentifier>;
  dataTableColumnDefinitionIntegerById: Maybe<DataTableColumnDefinitionInteger>;
  dataTableColumnDefinitionJoinById: Maybe<DataTableColumnDefinitionJoin>;
  dataTableColumnDefinitionMetadatumById: Maybe<DataTableColumnDefinitionMetadatum>;
  dataTableColumnDefinitionRoiFrameById: Maybe<DataTableColumnDefinitionRoiFrame>;
  dataTableColumnDefinitionTextById: Maybe<DataTableColumnDefinitionText>;
  dataTableColumnGroupById: Maybe<DataTableColumnGroup>;
  dataTableColumnGroupDefinitionJoinById: Maybe<DataTableColumnGroupDefinitionJoin>;
  dataTableColumnGroupDefinitionSourceById: Maybe<DataTableColumnGroupDefinitionSource>;
  dataTableRowById: Maybe<DataTableRow>;
  dataTableRowByTableIdAndIndex: Maybe<DataTableRow>;
  distributionRegistryImageByContainerimageexecutorPtrId: Maybe<DistributionRegistryImage>;
  djangoAdminLogById: Maybe<DjangoAdminLog>;
  djangoContentTypeByAppLabelAndModel: Maybe<DjangoContentType>;
  djangoContentTypeById: Maybe<DjangoContentType>;
  djangoMigrationById: Maybe<DjangoMigration>;
  djangoSesBlacklistedemailByEmail: Maybe<DjangoSesBlacklistedemail>;
  djangoSesBlacklistedemailById: Maybe<DjangoSesBlacklistedemail>;
  djangoSesSesstatByDate: Maybe<DjangoSesSesstat>;
  djangoSesSesstatById: Maybe<DjangoSesSesstat>;
  djangoSessionBySessionKey: Maybe<DjangoSession>;
  drsFileexecutorById: Maybe<DrsFileexecutor>;
  drsMockfileexecutorByFileexecutorPtrId: Maybe<DrsMockfileexecutor>;
  eulaVersionById: Maybe<EulaVersion>;
  eulaVersionByVersion: Maybe<EulaVersion>;
  eulaVersionUserAcceptanceById: Maybe<EulaVersionUserAcceptance>;
  eulaVersionUserAcceptanceByUserIdAndEulaVersionId: Maybe<EulaVersionUserAcceptance>;
  featureFlagById: Maybe<FeatureFlag>;
  featureFlagByName: Maybe<FeatureFlag>;
  featureFlagsGroupByFeatureflagIdAndGroupId: Maybe<FeatureFlagsGroup>;
  featureFlagsGroupById: Maybe<FeatureFlagsGroup>;
  featureFlagsTenantByFeatureflagIdAndTenantId: Maybe<FeatureFlagsTenant>;
  featureFlagsTenantById: Maybe<FeatureFlagsTenant>;
  featureFlagsUserByFeatureflagIdAndUserId: Maybe<FeatureFlagsUser>;
  featureFlagsUserById: Maybe<FeatureFlagsUser>;
  fileActivityById: Maybe<FileActivity>;
  fileById: Maybe<File>;
  fileByProjectIdAndReferenceId: Maybe<File>;
  fileMetadatumById: Maybe<FileMetadatum>;
  fileOutputGroupById: Maybe<FileOutputGroup>;
  fileOutputGroupByTaskId: Maybe<FileOutputGroup>;
  fileOutputGroupMetadatumById: Maybe<FileOutputGroupMetadatum>;
  fileProcessingNotificationById: Maybe<FileProcessingNotification>;
  gdtAnalysisTableById: Maybe<GdtAnalysisTable>;
  gdtAnalysisTableCellByColumnIdAndRowId: Maybe<GdtAnalysisTableCell>;
  gdtAnalysisTableCellById: Maybe<GdtAnalysisTableCell>;
  gdtAnalysisTableColumnById: Maybe<GdtAnalysisTableColumn>;
  gdtAnalysisTableColumnByTableIdAndOrder: Maybe<GdtAnalysisTableColumn>;
  gdtAnalysisTableColumnGroupById: Maybe<GdtAnalysisTableColumnGroup>;
  gdtAnalysisTableRowById: Maybe<GdtAnalysisTableRow>;
  gdtAnalysisTableRowByTableIdAndIndex: Maybe<GdtAnalysisTableRow>;
  gdtAnalysisTableRowByTaskId: Maybe<GdtAnalysisTableRow>;
  getCurrentUser: Maybe<ApplicationUser>;
  getCurrentUserId: Maybe<Scalars["UUID"]["output"]>;
  getUserActiveSession: Maybe<ApplicationUserSession>;
  jwtHasGlobalUserIdClaim: Maybe<Scalars["Boolean"]["output"]>;
  metadataValueById: Maybe<MetadataValue>;
  metadatumById: Maybe<Metadatum>;
  notificationById: Maybe<Notification>;
  outputGroupFileById: Maybe<OutputGroupFile>;
  pinnedToolById: Maybe<PinnedTool>;
  pinnedToolByUserIdAndToolId: Maybe<PinnedTool>;
  projectById: Maybe<Project>;
  projectByKeyAndTenantId: Maybe<Project>;
  projectClonedNotificationById: Maybe<ProjectClonedNotification>;
  projectFolderById: Maybe<ProjectFolder>;
  projectSharedNotificationById: Maybe<ProjectSharedNotification>;
  projectTagById: Maybe<ProjectTag>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  roleChangeNotificationById: Maybe<RoleChangeNotification>;
  runById: Maybe<Run>;
  sessionIsActive: Scalars["Boolean"]["output"];
  sessionIsActiveSession: Maybe<Scalars["Boolean"]["output"]>;
  taskActivityById: Maybe<TaskActivity>;
  taskActivityByTaskId: Maybe<TaskActivity>;
  taskByExecutorId: Maybe<Task>;
  taskById: Maybe<Task>;
  taskResourceById: Maybe<TaskResource>;
  taskResourceUsageById: Maybe<TaskResourceUsage>;
  taskResourceUsageByTaskId: Maybe<TaskResourceUsage>;
  taskSourceById: Maybe<TaskSource>;
  taskStatusLogById: Maybe<TaskStatusLog>;
  taskStatusLogByTaskIdAndStatus: Maybe<TaskStatusLog>;
  tenantById: Maybe<Tenant>;
  tenantByKey: Maybe<Tenant>;
  tenantByRepositoryName: Maybe<Tenant>;
  tenantBySfid: Maybe<Tenant>;
  tenantContractAllowanceById: Maybe<TenantContractAllowance>;
  tenantContractAllowanceByTenantContractTransactionIdAndQuotaType: Maybe<TenantContractAllowance>;
  tenantContractById: Maybe<TenantContract>;
  tenantContractByName: Maybe<TenantContract>;
  tenantContractBySfid: Maybe<TenantContract>;
  tenantContractTransactionById: Maybe<TenantContractTransaction>;
  tenantMockuserexecutorByUserexecutorPtrId: Maybe<TenantMockuserexecutor>;
  tenantMonthlyConsumedResourceById: Maybe<TenantMonthlyConsumedResource>;
  tenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract: Maybe<TenantMonthlyConsumedResource>;
  tenantUserMembershipNotificationById: Maybe<TenantUserMembershipNotification>;
  tenantUserexecutorById: Maybe<TenantUserexecutor>;
  tesContainerimageexecutorById: Maybe<TesContainerimageexecutor>;
  tesMockcontainerimageexecutorByContainerimageexecutorPtrId: Maybe<TesMockcontainerimageexecutor>;
  tesMocktaskexecutorByTaskexecutorPtrId: Maybe<TesMocktaskexecutor>;
  tesTaskexecutorById: Maybe<TesTaskexecutor>;
  toolById: Maybe<Tool>;
  toolByProjectId: Maybe<Tool>;
  toolParameterById: Maybe<ToolParameter>;
  toolResourceById: Maybe<ToolResource>;
  toolResourceByTypeAndToolVersionId: Maybe<ToolResource>;
  toolResultById: Maybe<ToolResult>;
  toolSecretById: Maybe<ToolSecret>;
  toolSourceById: Maybe<ToolSource>;
  toolTenantById: Maybe<ToolTenant>;
  toolTenantByToolIdAndTenantId: Maybe<ToolTenant>;
  toolVersionById: Maybe<ToolVersion>;
  toolboxById: Maybe<Toolbox>;
  toolboxByKey: Maybe<Toolbox>;
  toolboxTenantById: Maybe<ToolboxTenant>;
  toolboxTenantByToolboxIdAndTenantId: Maybe<ToolboxTenant>;
  userHasActiveSession: Maybe<Scalars["Boolean"]["output"]>;
  userIdIsSettingsGlobalUserId: Maybe<Scalars["Boolean"]["output"]>;
  userOnboardingQuestionAnswerById: Maybe<UserOnboardingQuestionAnswer>;
  userOnboardingQuestionByCode: Maybe<UserOnboardingQuestion>;
  userOnboardingQuestionById: Maybe<UserOnboardingQuestion>;
  userOnboardingQuestionResponseById: Maybe<UserOnboardingQuestionResponse>;
  userPersonalSpaceRequestById: Maybe<UserPersonalSpaceRequest>;
  waffleFlagById: Maybe<WaffleFlag>;
  waffleFlagByName: Maybe<WaffleFlag>;
  waffleSampleById: Maybe<WaffleSample>;
  waffleSampleByName: Maybe<WaffleSample>;
  waffleSwitchById: Maybe<WaffleSwitch>;
  waffleSwitchByName: Maybe<WaffleSwitch>;
  workflowById: Maybe<Workflow>;
  workflowDatumById: Maybe<WorkflowDatum>;
  workflowResultById: Maybe<WorkflowResult>;
  workflowResultWorkflowVersionById: Maybe<WorkflowResultWorkflowVersion>;
  workflowResultWorkflowVersionByResultIdAndWorkflowversionId: Maybe<WorkflowResultWorkflowVersion>;
  workflowSectionBlockById: Maybe<WorkflowSectionBlock>;
  workflowSectionBlockSectionByBlockIdAndSectionId: Maybe<WorkflowSectionBlockSection>;
  workflowSectionBlockSectionById: Maybe<WorkflowSectionBlockSection>;
  workflowSectionById: Maybe<WorkflowSection>;
  workflowSectionWorkflowVersionById: Maybe<WorkflowSectionWorkflowVersion>;
  workflowSectionWorkflowVersionBySectionIdAndWorkflowversionId: Maybe<WorkflowSectionWorkflowVersion>;
  workflowSourceById: Maybe<WorkflowSource>;
  workflowSourceWorkflowVersionById: Maybe<WorkflowSourceWorkflowVersion>;
  workflowSourceWorkflowVersionBySourceIdAndWorkflowversionId: Maybe<WorkflowSourceWorkflowVersion>;
  workflowVersionById: Maybe<WorkflowVersion>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllAdminProjectsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AdminProjectCondition>;
  filter?: InputMaybe<AdminProjectFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AdminProjectsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllApplicationUserGroupsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserGroupCondition>;
  filter?: InputMaybe<ApplicationUserGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllApplicationUserMembershipsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserMembershipCondition>;
  filter?: InputMaybe<ApplicationUserMembershipFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserMembershipsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllApplicationUserMetadataArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserMetadatumCondition>;
  filter?: InputMaybe<ApplicationUserMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserMetadataOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllApplicationUserSessionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserSessionCondition>;
  filter?: InputMaybe<ApplicationUserSessionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserSessionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllApplicationUserUserPermissionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserUserPermissionCondition>;
  filter?: InputMaybe<ApplicationUserUserPermissionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserUserPermissionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllAuditlogLogentriesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditlogLogentryCondition>;
  filter?: InputMaybe<AuditlogLogentryFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditlogLogentriesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllAuthGroupPermissionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuthGroupPermissionCondition>;
  filter?: InputMaybe<AuthGroupPermissionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuthGroupPermissionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllAuthGroupsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuthGroupCondition>;
  filter?: InputMaybe<AuthGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuthGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllAuthPermissionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuthPermissionCondition>;
  filter?: InputMaybe<AuthPermissionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuthPermissionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllAvailableNonRestrictedProjectsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AvailableNonRestrictedProjectCondition>;
  filter?: InputMaybe<AvailableNonRestrictedProjectFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AvailableNonRestrictedProjectsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllAvatarsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AvatarCondition>;
  filter?: InputMaybe<AvatarFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AvatarsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllAwsBatchTasksArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsBatchTaskCondition>;
  filter?: InputMaybe<AwsBatchTaskFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsBatchTasksOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllAwsCognitoUsersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsCognitoUserCondition>;
  filter?: InputMaybe<AwsCognitoUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsCognitoUsersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllAwsEcrImagesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsEcrImageCondition>;
  filter?: InputMaybe<AwsEcrImageFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsEcrImagesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllAwsMockBatchTasksArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsMockBatchTaskCondition>;
  filter?: InputMaybe<AwsMockBatchTaskFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsMockBatchTasksOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllAwsMockDistributionImagesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsMockDistributionImageCondition>;
  filter?: InputMaybe<AwsMockDistributionImageFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsMockDistributionImagesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllAwsMockEcrImagesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsMockEcrImageCondition>;
  filter?: InputMaybe<AwsMockEcrImageFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsMockEcrImagesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllAwsMockIamUsersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsMockIamUserCondition>;
  filter?: InputMaybe<AwsMockIamUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsMockIamUsersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllAwsMockS3FilesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsMockS3FileCondition>;
  filter?: InputMaybe<AwsMockS3FileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsMockS3FilesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllAwsS3FilesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsS3FileCondition>;
  filter?: InputMaybe<AwsS3FileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsS3FilesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllCodeFilesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CodeFileCondition>;
  filter?: InputMaybe<CodeFileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CodeFilesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllCommandsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CommandCondition>;
  filter?: InputMaybe<CommandFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CommandsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllContainerImageRepositoriesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ContainerImageRepositoryCondition>;
  filter?: InputMaybe<ContainerImageRepositoryFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContainerImageRepositoriesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllContainerImagesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ContainerImageCondition>;
  filter?: InputMaybe<ContainerImageFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContainerImagesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllCostsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CostCondition>;
  filter?: InputMaybe<CostFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CostsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllCurrentApplicationUsersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CurrentApplicationUserCondition>;
  filter?: InputMaybe<CurrentApplicationUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CurrentApplicationUsersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllCurrentUserMembershipsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CurrentUserMembershipCondition>;
  filter?: InputMaybe<CurrentUserMembershipFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CurrentUserMembershipsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableCellsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableCellCondition>;
  filter?: InputMaybe<DataTableCellFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableCellsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableColumnDefinitionBooleansArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionBooleanCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionBooleanFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionBooleansOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableColumnDefinitionCellStatusesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionCellStatusCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionCellStatusFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionCellStatusesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableColumnDefinitionChoicesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionChoiceCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionChoiceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionChoicesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableColumnDefinitionDatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionDateCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionDateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionDatesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableColumnDefinitionFilesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionFileCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionFileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionFilesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableColumnDefinitionFloatsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionFloatCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionFloatFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionFloatsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableColumnDefinitionIdentifiersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionIdentifierCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionIdentifierFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionIdentifiersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableColumnDefinitionIntegersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionIntegerCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionIntegerFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionIntegersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableColumnDefinitionJoinsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionJoinCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionJoinFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionJoinsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableColumnDefinitionMetadataArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionMetadatumCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionMetadataOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableColumnDefinitionRoiFramesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionRoiFrameCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionRoiFrameFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionRoiFramesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableColumnDefinitionTextsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionTextCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionTextFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionTextsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableColumnGroupDefinitionJoinsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnGroupDefinitionJoinCondition>;
  filter?: InputMaybe<DataTableColumnGroupDefinitionJoinFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnGroupDefinitionJoinsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableColumnGroupDefinitionSourcesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnGroupDefinitionSourceCondition>;
  filter?: InputMaybe<DataTableColumnGroupDefinitionSourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnGroupDefinitionSourcesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableColumnGroupsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnGroupCondition>;
  filter?: InputMaybe<DataTableColumnGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableColumnsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnCondition>;
  filter?: InputMaybe<DataTableColumnFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTableRowsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableRowCondition>;
  filter?: InputMaybe<DataTableRowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableRowsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDataTablesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableCondition>;
  filter?: InputMaybe<DataTableFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTablesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDistributionRegistryImagesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DistributionRegistryImageCondition>;
  filter?: InputMaybe<DistributionRegistryImageFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DistributionRegistryImagesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDjangoAdminLogsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DjangoAdminLogCondition>;
  filter?: InputMaybe<DjangoAdminLogFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DjangoAdminLogsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDjangoContentTypesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DjangoContentTypeCondition>;
  filter?: InputMaybe<DjangoContentTypeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DjangoContentTypesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDjangoMigrationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DjangoMigrationCondition>;
  filter?: InputMaybe<DjangoMigrationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DjangoMigrationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDjangoSesBlacklistedemailsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DjangoSesBlacklistedemailCondition>;
  filter?: InputMaybe<DjangoSesBlacklistedemailFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DjangoSesBlacklistedemailsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDjangoSesSesstatsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DjangoSesSesstatCondition>;
  filter?: InputMaybe<DjangoSesSesstatFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DjangoSesSesstatsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDjangoSessionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DjangoSessionCondition>;
  filter?: InputMaybe<DjangoSessionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DjangoSessionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDrsFileexecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DrsFileexecutorCondition>;
  filter?: InputMaybe<DrsFileexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DrsFileexecutorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllDrsMockfileexecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DrsMockfileexecutorCondition>;
  filter?: InputMaybe<DrsMockfileexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DrsMockfileexecutorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllEulaVersionUserAcceptancesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<EulaVersionUserAcceptanceCondition>;
  filter?: InputMaybe<EulaVersionUserAcceptanceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<EulaVersionUserAcceptancesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllEulaVersionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<EulaVersionCondition>;
  filter?: InputMaybe<EulaVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<EulaVersionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllFeatureFlagsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FeatureFlagCondition>;
  filter?: InputMaybe<FeatureFlagFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FeatureFlagsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllFeatureFlagsGroupsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FeatureFlagsGroupCondition>;
  filter?: InputMaybe<FeatureFlagsGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FeatureFlagsGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllFeatureFlagsTenantsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FeatureFlagsTenantCondition>;
  filter?: InputMaybe<FeatureFlagsTenantFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FeatureFlagsTenantsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllFeatureFlagsUsersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FeatureFlagsUserCondition>;
  filter?: InputMaybe<FeatureFlagsUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FeatureFlagsUsersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllFileActivitiesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileActivityCondition>;
  filter?: InputMaybe<FileActivityFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileActivitiesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllFileMetadataArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileMetadatumCondition>;
  filter?: InputMaybe<FileMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileMetadataOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllFileOutputGroupMetadataArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileOutputGroupMetadatumCondition>;
  filter?: InputMaybe<FileOutputGroupMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileOutputGroupMetadataOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllFileOutputGroupsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileOutputGroupCondition>;
  filter?: InputMaybe<FileOutputGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileOutputGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllFileProcessingNotificationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileProcessingNotificationCondition>;
  filter?: InputMaybe<FileProcessingNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileProcessingNotificationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllFilesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllFilesByExecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FilesByExecutorCondition>;
  filter?: InputMaybe<FilesByExecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FilesByExecutorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllGdtAnalysisTableCellsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableCellCondition>;
  filter?: InputMaybe<GdtAnalysisTableCellFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableCellsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllGdtAnalysisTableColumnGroupsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableColumnGroupCondition>;
  filter?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableColumnGroupsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllGdtAnalysisTableColumnsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableColumnCondition>;
  filter?: InputMaybe<GdtAnalysisTableColumnFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableColumnsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllGdtAnalysisTableRowsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableRowCondition>;
  filter?: InputMaybe<GdtAnalysisTableRowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableRowsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllGdtAnalysisTablesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableCondition>;
  filter?: InputMaybe<GdtAnalysisTableFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTablesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllNotificationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllOutputGroupFilesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<OutputGroupFileCondition>;
  filter?: InputMaybe<OutputGroupFileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<OutputGroupFilesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllPinnedToolsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<PinnedToolCondition>;
  filter?: InputMaybe<PinnedToolFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<PinnedToolsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllProjectClonedNotificationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectClonedNotificationCondition>;
  filter?: InputMaybe<ProjectClonedNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectClonedNotificationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllProjectFoldersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectFolderCondition>;
  filter?: InputMaybe<ProjectFolderFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectFoldersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllProjectSharedNotificationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectSharedNotificationCondition>;
  filter?: InputMaybe<ProjectSharedNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectSharedNotificationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllProjectTagsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectTagCondition>;
  filter?: InputMaybe<ProjectTagFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectTagsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllProjectsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllRoleChangeNotificationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<RoleChangeNotificationCondition>;
  filter?: InputMaybe<RoleChangeNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<RoleChangeNotificationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllRunsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<RunCondition>;
  filter?: InputMaybe<RunFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<RunsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllTaskActivitiesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskActivityCondition>;
  filter?: InputMaybe<TaskActivityFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskActivitiesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllTaskResourceUsagesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskResourceUsageCondition>;
  filter?: InputMaybe<TaskResourceUsageFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskResourceUsagesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllTaskResourcesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskResourceCondition>;
  filter?: InputMaybe<TaskResourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskResourcesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllTaskSourcesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskSourceCondition>;
  filter?: InputMaybe<TaskSourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskSourcesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllTaskStatusLogsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskStatusLogCondition>;
  filter?: InputMaybe<TaskStatusLogFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskStatusLogsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllTasksArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllTenantContractAllowancesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantContractAllowanceCondition>;
  filter?: InputMaybe<TenantContractAllowanceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantContractAllowancesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllTenantContractTransactionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantContractTransactionCondition>;
  filter?: InputMaybe<TenantContractTransactionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantContractTransactionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllTenantContractsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantContractCondition>;
  filter?: InputMaybe<TenantContractFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantContractsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllTenantMockuserexecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantMockuserexecutorCondition>;
  filter?: InputMaybe<TenantMockuserexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantMockuserexecutorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllTenantMonthlyConsumedResourcesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantMonthlyConsumedResourceCondition>;
  filter?: InputMaybe<TenantMonthlyConsumedResourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantMonthlyConsumedResourcesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllTenantUserMembershipNotificationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantUserMembershipNotificationCondition>;
  filter?: InputMaybe<TenantUserMembershipNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantUserMembershipNotificationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllTenantUserexecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantUserexecutorCondition>;
  filter?: InputMaybe<TenantUserexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantUserexecutorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllTesContainerimageexecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TesContainerimageexecutorCondition>;
  filter?: InputMaybe<TesContainerimageexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TesContainerimageexecutorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllTesMockcontainerimageexecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TesMockcontainerimageexecutorCondition>;
  filter?: InputMaybe<TesMockcontainerimageexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TesMockcontainerimageexecutorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllTesMocktaskexecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TesMocktaskexecutorCondition>;
  filter?: InputMaybe<TesMocktaskexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TesMocktaskexecutorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllTesTaskexecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TesTaskexecutorCondition>;
  filter?: InputMaybe<TesTaskexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TesTaskexecutorsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllToolParametersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolParameterCondition>;
  filter?: InputMaybe<ToolParameterFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolParametersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllToolResourcesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolResourceCondition>;
  filter?: InputMaybe<ToolResourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolResourcesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllToolResultsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolResultCondition>;
  filter?: InputMaybe<ToolResultFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolResultsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllToolSecretsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolSecretCondition>;
  filter?: InputMaybe<ToolSecretFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolSecretsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllToolSourcesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolSourceCondition>;
  filter?: InputMaybe<ToolSourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolSourcesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllToolTenantsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolTenantCondition>;
  filter?: InputMaybe<ToolTenantFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolTenantsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllToolVersionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolVersionCondition>;
  filter?: InputMaybe<ToolVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolVersionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllToolboxTenantsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolboxTenantCondition>;
  filter?: InputMaybe<ToolboxTenantFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolboxTenantsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllToolboxesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolboxCondition>;
  filter?: InputMaybe<ToolboxFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolboxesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllToolsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolCondition>;
  filter?: InputMaybe<ToolFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllUserAccessToProjectsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<UserAccessToProjectCondition>;
  filter?: InputMaybe<UserAccessToProjectFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<UserAccessToProjectsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllUserOnboardingQuestionAnswersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<UserOnboardingQuestionAnswerCondition>;
  filter?: InputMaybe<UserOnboardingQuestionAnswerFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<UserOnboardingQuestionAnswersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllUserOnboardingQuestionResponsesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<UserOnboardingQuestionResponseCondition>;
  filter?: InputMaybe<UserOnboardingQuestionResponseFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<UserOnboardingQuestionResponsesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllUserOnboardingQuestionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<UserOnboardingQuestionCondition>;
  filter?: InputMaybe<UserOnboardingQuestionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<UserOnboardingQuestionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllWaffleFlagsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WaffleFlagCondition>;
  filter?: InputMaybe<WaffleFlagFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WaffleFlagsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllWaffleSamplesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WaffleSampleCondition>;
  filter?: InputMaybe<WaffleSampleFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WaffleSamplesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllWaffleSwitchesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WaffleSwitchCondition>;
  filter?: InputMaybe<WaffleSwitchFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WaffleSwitchesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllWorkflowDataArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowDatumCondition>;
  filter?: InputMaybe<WorkflowDatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowDataOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllWorkflowResultWorkflowVersionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowResultWorkflowVersionCondition>;
  filter?: InputMaybe<WorkflowResultWorkflowVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowResultWorkflowVersionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllWorkflowResultsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowResultCondition>;
  filter?: InputMaybe<WorkflowResultFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowResultsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllWorkflowSectionBlockSectionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSectionBlockSectionCondition>;
  filter?: InputMaybe<WorkflowSectionBlockSectionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSectionBlockSectionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllWorkflowSectionBlocksArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSectionBlockCondition>;
  filter?: InputMaybe<WorkflowSectionBlockFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSectionBlocksOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllWorkflowSectionWorkflowVersionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSectionWorkflowVersionCondition>;
  filter?: InputMaybe<WorkflowSectionWorkflowVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSectionWorkflowVersionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllWorkflowSectionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSectionCondition>;
  filter?: InputMaybe<WorkflowSectionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSectionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllWorkflowSourceWorkflowVersionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSourceWorkflowVersionCondition>;
  filter?: InputMaybe<WorkflowSourceWorkflowVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSourceWorkflowVersionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllWorkflowSourcesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSourceCondition>;
  filter?: InputMaybe<WorkflowSourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSourcesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllWorkflowVersionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowVersionCondition>;
  filter?: InputMaybe<WorkflowVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowVersionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAllWorkflowsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowCondition>;
  filter?: InputMaybe<WorkflowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserByEmailArgs = {
  email: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserByGlobalUserIdArgs = {
  globalUserId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserByUsernameArgs = {
  username: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserGroupByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserGroupByUserIdAndGroupIdArgs = {
  groupId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserMembershipByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserMembershipByUserIdAndTenantIdArgs = {
  tenantId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserMetadatumByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserMetadatumByUserIdAndKeyArgs = {
  key: Scalars["String"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserSessionByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserUserPermissionByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryApplicationUserUserPermissionByUserIdAndPermissionIdArgs = {
  permissionId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryAssertUserCanSeeTenantInfoArgs = {
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAssertUserCanSeeUserInfoArgs = {
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAssertUserHasProjectSharedByTenantArgs = {
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAssertUserHasTenantOfIdArgs = {
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAssertUserIsAdminOfProjectTenantArgs = {
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAssertUserIsAdminOfTenantArgs = {
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAssertUserIsInvitedToTenantArgs = {
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAuditlogLogentryByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryAuthGroupByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryAuthGroupByNameArgs = {
  name: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryAuthGroupPermissionByGroupIdAndPermissionIdArgs = {
  groupId: Scalars["Int"]["input"];
  permissionId: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryAuthGroupPermissionByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryAuthPermissionByContentTypeIdAndCodenameArgs = {
  codename: Scalars["String"]["input"];
  contentTypeId: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryAuthPermissionByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryAvatarByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryAvatarByUserIdArgs = {
  userId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryAwsBatchTaskByTaskexecutorPtrIdArgs = {
  taskexecutorPtrId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryAwsCognitoUserByUserexecutorPtrIdArgs = {
  userexecutorPtrId: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryAwsEcrImageByContainerimageexecutorPtrIdArgs = {
  containerimageexecutorPtrId: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryAwsMockBatchTaskByAwstaskexecutorPtrIdArgs = {
  awstaskexecutorPtrId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdArgs =
  {
    distributioncontainerimageexecutorPtrId: Scalars["Int"]["input"];
  };

/** The root query type which gives access points into the data universe. */
export type QueryAwsMockEcrImageByAwscontainerimageexecutorPtrIdArgs = {
  awscontainerimageexecutorPtrId: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryAwsMockIamUserByAwsuserexecutorPtrIdArgs = {
  awsuserexecutorPtrId: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryAwsMockS3FileByAwsfileexecutorPtrIdArgs = {
  awsfileexecutorPtrId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryAwsS3FileByFileexecutorPtrIdArgs = {
  fileexecutorPtrId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryCodeFileByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryCommandByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryCommandByToolVersionIdArgs = {
  toolVersionId: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryCommandByToolVersionIdAndCodeFileIdArgs = {
  codeFileId: Scalars["UUID"]["input"];
  toolVersionId: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryContainerImageByExecutorIdArgs = {
  executorId: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryContainerImageByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryContainerImageRepositoryByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryContainerImageRepositoryByNameAndTenantIdAndRegistryTypeArgs =
  {
    name: Scalars["String"]["input"];
    registryType: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
  };

/** The root query type which gives access points into the data universe. */
export type QueryContainerImageRepositoryByRepositoryArgs = {
  repository: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryCostByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableCellByColumnIdAndRowIdArgs = {
  columnId: Scalars["UUID"]["input"];
  rowId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableCellByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableColumnByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableColumnByTableIdAndOrderArgs = {
  order: Scalars["Int"]["input"];
  tableId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableColumnDefinitionBooleanByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableColumnDefinitionCellStatusByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableColumnDefinitionChoiceByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableColumnDefinitionDateByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableColumnDefinitionFileByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableColumnDefinitionFloatByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableColumnDefinitionIdentifierByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableColumnDefinitionIntegerByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableColumnDefinitionJoinByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableColumnDefinitionMetadatumByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableColumnDefinitionRoiFrameByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableColumnDefinitionTextByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableColumnGroupByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableColumnGroupDefinitionJoinByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableColumnGroupDefinitionSourceByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableRowByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDataTableRowByTableIdAndIndexArgs = {
  index: Scalars["Int"]["input"];
  tableId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDistributionRegistryImageByContainerimageexecutorPtrIdArgs = {
  containerimageexecutorPtrId: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDjangoAdminLogByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDjangoContentTypeByAppLabelAndModelArgs = {
  appLabel: Scalars["String"]["input"];
  model: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDjangoContentTypeByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDjangoMigrationByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDjangoSesBlacklistedemailByEmailArgs = {
  email: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDjangoSesBlacklistedemailByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDjangoSesSesstatByDateArgs = {
  date: Scalars["Date"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDjangoSesSesstatByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDjangoSessionBySessionKeyArgs = {
  sessionKey: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDrsFileexecutorByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryDrsMockfileexecutorByFileexecutorPtrIdArgs = {
  fileexecutorPtrId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryEulaVersionByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryEulaVersionByVersionArgs = {
  version: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryEulaVersionUserAcceptanceByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryEulaVersionUserAcceptanceByUserIdAndEulaVersionIdArgs = {
  eulaVersionId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryFeatureFlagByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryFeatureFlagByNameArgs = {
  name: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryFeatureFlagsGroupByFeatureflagIdAndGroupIdArgs = {
  featureflagId: Scalars["BigInt"]["input"];
  groupId: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryFeatureFlagsGroupByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryFeatureFlagsTenantByFeatureflagIdAndTenantIdArgs = {
  featureflagId: Scalars["BigInt"]["input"];
  tenantId: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryFeatureFlagsTenantByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryFeatureFlagsUserByFeatureflagIdAndUserIdArgs = {
  featureflagId: Scalars["BigInt"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryFeatureFlagsUserByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryFileActivityByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryFileByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryFileByProjectIdAndReferenceIdArgs = {
  projectId: Scalars["UUID"]["input"];
  referenceId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryFileMetadatumByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryFileOutputGroupByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryFileOutputGroupByTaskIdArgs = {
  taskId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryFileOutputGroupMetadatumByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryFileProcessingNotificationByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryGdtAnalysisTableByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryGdtAnalysisTableCellByColumnIdAndRowIdArgs = {
  columnId: Scalars["UUID"]["input"];
  rowId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryGdtAnalysisTableCellByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryGdtAnalysisTableColumnByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryGdtAnalysisTableColumnByTableIdAndOrderArgs = {
  order: Scalars["Int"]["input"];
  tableId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryGdtAnalysisTableColumnGroupByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryGdtAnalysisTableRowByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryGdtAnalysisTableRowByTableIdAndIndexArgs = {
  index: Scalars["Int"]["input"];
  tableId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryGdtAnalysisTableRowByTaskIdArgs = {
  taskId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryGetUserActiveSessionArgs = {
  userid: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryMetadataValueByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryMetadatumByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryNotificationByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryOutputGroupFileByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryPinnedToolByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryPinnedToolByUserIdAndToolIdArgs = {
  toolId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectByKeyAndTenantIdArgs = {
  key: Scalars["String"]["input"];
  tenantId: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectClonedNotificationByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectFolderByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectSharedNotificationByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryProjectTagByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryRoleChangeNotificationByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryRunByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QuerySessionIsActiveSessionArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTaskActivityByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTaskActivityByTaskIdArgs = {
  taskId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTaskByExecutorIdArgs = {
  executorId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTaskByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTaskResourceByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTaskResourceUsageByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTaskResourceUsageByTaskIdArgs = {
  taskId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTaskSourceByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTaskStatusLogByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTaskStatusLogByTaskIdAndStatusArgs = {
  status: Scalars["Int"]["input"];
  taskId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTenantByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTenantByKeyArgs = {
  key: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTenantByRepositoryNameArgs = {
  repositoryName: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTenantBySfidArgs = {
  sfid: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTenantContractAllowanceByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeArgs =
  {
    quotaType: Scalars["Int"]["input"];
    tenantContractTransactionId: Scalars["Int"]["input"];
  };

/** The root query type which gives access points into the data universe. */
export type QueryTenantContractByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTenantContractByNameArgs = {
  name: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTenantContractBySfidArgs = {
  sfid: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTenantContractTransactionByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTenantMockuserexecutorByUserexecutorPtrIdArgs = {
  userexecutorPtrId: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTenantMonthlyConsumedResourceByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractArgs =
  {
    month: Scalars["Date"]["input"];
    monthInActiveContract: Scalars["Int"]["input"];
    quotaType: Scalars["Int"]["input"];
    tenantContractId: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** The root query type which gives access points into the data universe. */
export type QueryTenantUserMembershipNotificationByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTenantUserexecutorByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTesContainerimageexecutorByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTesMockcontainerimageexecutorByContainerimageexecutorPtrIdArgs =
  {
    containerimageexecutorPtrId: Scalars["Int"]["input"];
  };

/** The root query type which gives access points into the data universe. */
export type QueryTesMocktaskexecutorByTaskexecutorPtrIdArgs = {
  taskexecutorPtrId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryTesTaskexecutorByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryToolByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryToolByProjectIdArgs = {
  projectId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryToolParameterByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryToolResourceByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryToolResourceByTypeAndToolVersionIdArgs = {
  toolVersionId: Scalars["Int"]["input"];
  type: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryToolResultByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryToolSecretByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryToolSourceByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryToolTenantByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryToolTenantByToolIdAndTenantIdArgs = {
  tenantId: Scalars["Int"]["input"];
  toolId: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryToolVersionByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryToolboxByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryToolboxByKeyArgs = {
  key: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryToolboxTenantByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryToolboxTenantByToolboxIdAndTenantIdArgs = {
  tenantId: Scalars["Int"]["input"];
  toolboxId: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryUserHasActiveSessionArgs = {
  userid: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryUserIdIsSettingsGlobalUserIdArgs = {
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUserOnboardingQuestionAnswerByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryUserOnboardingQuestionByCodeArgs = {
  code: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryUserOnboardingQuestionByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryUserOnboardingQuestionResponseByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryUserPersonalSpaceRequestByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWaffleFlagByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWaffleFlagByNameArgs = {
  name: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWaffleSampleByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWaffleSampleByNameArgs = {
  name: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWaffleSwitchByIdArgs = {
  id: Scalars["Int"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWaffleSwitchByNameArgs = {
  name: Scalars["String"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWorkflowByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWorkflowDatumByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWorkflowResultByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWorkflowResultWorkflowVersionByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdArgs =
  {
    resultId: Scalars["UUID"]["input"];
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The root query type which gives access points into the data universe. */
export type QueryWorkflowSectionBlockByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWorkflowSectionBlockSectionByBlockIdAndSectionIdArgs = {
  blockId: Scalars["UUID"]["input"];
  sectionId: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWorkflowSectionBlockSectionByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWorkflowSectionByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWorkflowSectionWorkflowVersionByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdArgs =
  {
    sectionId: Scalars["UUID"]["input"];
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The root query type which gives access points into the data universe. */
export type QueryWorkflowSourceByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWorkflowSourceWorkflowVersionByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root query type which gives access points into the data universe. */
export type QueryWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdArgs =
  {
    sourceId: Scalars["UUID"]["input"];
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The root query type which gives access points into the data universe. */
export type QueryWorkflowVersionByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/** The `applicationUser` to be created by this mutation. */
export type RoleChangeNotificaUserId879Bd49AFkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `RoleChangeNotificationInput` mutation. */
export type RoleChangeNotificaUserId879Bd49AFkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `roleChangeNotification` in the `ApplicationUserInput` mutation. */
export type RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput = {
  /** The primary key(s) for `roleChangeNotification` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<RoleChangeNotificationRoleChangeNotificationPkeyConnect>
  >;
  /** The primary key(s) and patch data for `roleChangeNotification` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingRoleChangeNotificationPkeyUpdate>
  >;
};

export type RoleChangeNotification = {
  __typename: "RoleChangeNotification";
  /** Reads a single `ApplicationUser` that is related to this `RoleChangeNotification`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  id: Scalars["UUID"]["output"];
  /** Reads a single `Notification` that is related to this `RoleChangeNotification`. */
  notificationById: Maybe<Notification>;
  role: Scalars["Int"]["output"];
  /** Reads a single `Tenant` that is related to this `RoleChangeNotification`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
  userId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `RoleChangeNotification` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type RoleChangeNotificationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `RoleChangeNotification` object types. All fields are combined with a logical ‘and.’ */
export type RoleChangeNotificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RoleChangeNotificationFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RoleChangeNotificationFilter>;
  /** Filter by the object’s `notificationById` relation. */
  notificationById?: InputMaybe<NotificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RoleChangeNotificationFilter>>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** Input for the nested mutation of `notification` in the `RoleChangeNotificationInput` mutation. */
export type RoleChangeNotificationIdD576A528FkNotificationIdInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<NotificationNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<NotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingNotificationPkeyUpdate>;
};

/** Input for the nested mutation of `roleChangeNotification` in the `NotificationInput` mutation. */
export type RoleChangeNotificationIdD576A528FkNotificationIdInverseInput = {
  /** The primary key(s) for `roleChangeNotification` for the far side of the relationship. */
  connectById?: InputMaybe<RoleChangeNotificationRoleChangeNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `roleChangeNotification` for the far side of the relationship. */
  updateById?: InputMaybe<RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingRoleChangeNotificationPkeyUpdate>;
};

/** The fields on `roleChangeNotification` to look up the row to update. */
export type RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingRoleChangeNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `roleChangeNotification` being updated. */
    roleChangeNotificationPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
  };

/** The fields on `roleChangeNotification` to look up the row to update. */
export type RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingRoleChangeNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `roleChangeNotification` being updated. */
    roleChangeNotificationPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch;
  };

/** The fields on `roleChangeNotification` to look up the row to update. */
export type RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingRoleChangeNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `roleChangeNotification` being updated. */
    roleChangeNotificationPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
  };

/** The fields on `roleChangeNotification` to look up the row to connect. */
export type RoleChangeNotificationRoleChangeNotificationPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** Input for the nested mutation of `tenant` in the `RoleChangeNotificationInput` mutation. */
export type RoleChangeNotificationTenantId36852Ce9FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `roleChangeNotification` in the `TenantInput` mutation. */
export type RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput = {
  /** The primary key(s) for `roleChangeNotification` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<RoleChangeNotificationRoleChangeNotificationPkeyConnect>
  >;
  /** The primary key(s) and patch data for `roleChangeNotification` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingRoleChangeNotificationPkeyUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type RoleChangeNotificationTenantId36852Ce9FkTenantIdTenantCreateInput =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal: Scalars["Boolean"]["input"];
    key: Scalars["String"]["input"];
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name: Scalars["String"]["input"];
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName: Scalars["String"]["input"];
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status: Scalars["Int"]["input"];
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType: Scalars["Int"]["input"];
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** A connection to a list of `RoleChangeNotification` values. */
export type RoleChangeNotificationsConnection = {
  __typename: "RoleChangeNotificationsConnection";
  /** A list of edges which contains the `RoleChangeNotification` and cursor to aid in pagination. */
  edges: Array<RoleChangeNotificationsEdge>;
  /** A list of `RoleChangeNotification` objects. */
  nodes: Array<RoleChangeNotification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoleChangeNotification` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `RoleChangeNotification` edge in the connection. */
export type RoleChangeNotificationsEdge = {
  __typename: "RoleChangeNotificationsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `RoleChangeNotification` at the end of the edge. */
  node: RoleChangeNotification;
};

/** Methods to use when ordering `RoleChangeNotification`. */
export enum RoleChangeNotificationsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  RoleAsc = "ROLE_ASC",
  RoleDesc = "ROLE_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

export type Run = {
  __typename: "Run";
  dateCreated: Scalars["Datetime"]["output"];
  id: Scalars["Int"]["output"];
  /** Reads a single `Tenant` that is related to this `Run`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
};

/** A condition to be used against `Run` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type RunCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `Run` object types. All fields are combined with a logical ‘and.’ */
export type RunFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RunFilter>>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RunFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RunFilter>>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Run` */
export type RunInput = {
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInput>;
};

/** The fields on `run` to look up the row to update. */
export type RunOnRunForRunTenantId73Fbd8D9FkTenantIdUsingRunPkeyUpdate = {
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `run` being updated. */
  runPatch: UpdateRunOnRunForRunTenantId73Fbd8D9FkTenantIdPatch;
};

/** Represents an update to a `Run`. Fields that are set will be updated. */
export type RunPatch = {
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInput>;
};

/** The fields on `run` to look up the row to connect. */
export type RunRunPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `run` to look up the row to delete. */
export type RunRunPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** Input for the nested mutation of `tenant` in the `RunInput` mutation. */
export type RunTenantId73Fbd8D9FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `run` in the `TenantInput` mutation. */
export type RunTenantId73Fbd8D9FkTenantIdInverseInput = {
  /** The primary key(s) for `run` for the far side of the relationship. */
  connectById?: InputMaybe<Array<RunRunPkeyConnect>>;
  /** A `RunInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<RunTenantId73Fbd8D9FkTenantIdRunCreateInput>>;
  /** The primary key(s) for `run` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<RunRunPkeyDelete>>;
  /** Flag indicating whether all other `run` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `run` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<RunOnRunForRunTenantId73Fbd8D9FkTenantIdUsingRunPkeyUpdate>
  >;
};

/** The `run` to be created by this mutation. */
export type RunTenantId73Fbd8D9FkTenantIdRunCreateInput = {
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInput>;
};

/** The `tenant` to be created by this mutation. */
export type RunTenantId73Fbd8D9FkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** A connection to a list of `Run` values. */
export type RunsConnection = {
  __typename: "RunsConnection";
  /** A list of edges which contains the `Run` and cursor to aid in pagination. */
  edges: Array<RunsEdge>;
  /** A list of `Run` objects. */
  nodes: Array<Run>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Run` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `Run` edge in the connection. */
export type RunsEdge = {
  __typename: "RunsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `Run` at the end of the edge. */
  node: Run;
};

/** Methods to use when ordering `Run`. */
export enum RunsOrderBy {
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
}

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["String"]["input"]>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars["String"]["input"]>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["String"]["input"]>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars["String"]["input"]>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["String"]["input"]>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars["String"]["input"]>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["String"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars["String"]["input"]>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["String"]["input"]>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars["String"]["input"]>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars["String"]["input"]>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars["String"]["input"]>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars["String"]["input"]>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars["String"]["input"]>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type Subscription = {
  __typename: "Subscription";
  /** Reads and enables pagination through a set of `AdminProject`. (live) */
  allAdminProjects: Maybe<AdminProjectsConnection>;
  /** Reads and enables pagination through a set of `ApplicationUserGroup`. (live) */
  allApplicationUserGroups: Maybe<ApplicationUserGroupsConnection>;
  /** Reads and enables pagination through a set of `ApplicationUserMembership`. (live) */
  allApplicationUserMemberships: Maybe<ApplicationUserMembershipsConnection>;
  /** Reads and enables pagination through a set of `ApplicationUserMetadatum`. (live) */
  allApplicationUserMetadata: Maybe<ApplicationUserMetadataConnection>;
  /** Reads and enables pagination through a set of `ApplicationUserSession`. (live) */
  allApplicationUserSessions: Maybe<ApplicationUserSessionsConnection>;
  /** Reads and enables pagination through a set of `ApplicationUserUserPermission`. (live) */
  allApplicationUserUserPermissions: Maybe<ApplicationUserUserPermissionsConnection>;
  /** Reads and enables pagination through a set of `AuditlogLogentry`. (live) */
  allAuditlogLogentries: Maybe<AuditlogLogentriesConnection>;
  /** Reads and enables pagination through a set of `AuthGroupPermission`. (live) */
  allAuthGroupPermissions: Maybe<AuthGroupPermissionsConnection>;
  /** Reads and enables pagination through a set of `AuthGroup`. (live) */
  allAuthGroups: Maybe<AuthGroupsConnection>;
  /** Reads and enables pagination through a set of `AuthPermission`. (live) */
  allAuthPermissions: Maybe<AuthPermissionsConnection>;
  /** Reads and enables pagination through a set of `AvailableNonRestrictedProject`. (live) */
  allAvailableNonRestrictedProjects: Maybe<AvailableNonRestrictedProjectsConnection>;
  /** Reads and enables pagination through a set of `Avatar`. (live) */
  allAvatars: Maybe<AvatarsConnection>;
  /** Reads and enables pagination through a set of `AwsBatchTask`. (live) */
  allAwsBatchTasks: Maybe<AwsBatchTasksConnection>;
  /** Reads and enables pagination through a set of `AwsCognitoUser`. (live) */
  allAwsCognitoUsers: Maybe<AwsCognitoUsersConnection>;
  /** Reads and enables pagination through a set of `AwsEcrImage`. (live) */
  allAwsEcrImages: Maybe<AwsEcrImagesConnection>;
  /** Reads and enables pagination through a set of `AwsMockBatchTask`. (live) */
  allAwsMockBatchTasks: Maybe<AwsMockBatchTasksConnection>;
  /** Reads and enables pagination through a set of `AwsMockDistributionImage`. (live) */
  allAwsMockDistributionImages: Maybe<AwsMockDistributionImagesConnection>;
  /** Reads and enables pagination through a set of `AwsMockEcrImage`. (live) */
  allAwsMockEcrImages: Maybe<AwsMockEcrImagesConnection>;
  /** Reads and enables pagination through a set of `AwsMockIamUser`. (live) */
  allAwsMockIamUsers: Maybe<AwsMockIamUsersConnection>;
  /** Reads and enables pagination through a set of `AwsMockS3File`. (live) */
  allAwsMockS3Files: Maybe<AwsMockS3FilesConnection>;
  /** Reads and enables pagination through a set of `AwsS3File`. (live) */
  allAwsS3Files: Maybe<AwsS3FilesConnection>;
  /** Reads and enables pagination through a set of `CodeFile`. (live) */
  allCodeFiles: Maybe<CodeFilesConnection>;
  /** Reads and enables pagination through a set of `Command`. (live) */
  allCommands: Maybe<CommandsConnection>;
  /** Reads and enables pagination through a set of `ContainerImageRepository`. (live) */
  allContainerImageRepositories: Maybe<ContainerImageRepositoriesConnection>;
  /** Reads and enables pagination through a set of `ContainerImage`. (live) */
  allContainerImages: Maybe<ContainerImagesConnection>;
  /** Reads and enables pagination through a set of `Cost`. (live) */
  allCosts: Maybe<CostsConnection>;
  /** Reads and enables pagination through a set of `CurrentApplicationUser`. (live) */
  allCurrentApplicationUsers: Maybe<CurrentApplicationUsersConnection>;
  /** Reads and enables pagination through a set of `CurrentUserMembership`. (live) */
  allCurrentUserMemberships: Maybe<CurrentUserMembershipsConnection>;
  /** Reads and enables pagination through a set of `DataTableCell`. (live) */
  allDataTableCells: Maybe<DataTableCellsConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionBoolean`. (live) */
  allDataTableColumnDefinitionBooleans: Maybe<DataTableColumnDefinitionBooleansConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionCellStatus`. (live) */
  allDataTableColumnDefinitionCellStatuses: Maybe<DataTableColumnDefinitionCellStatusesConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionChoice`. (live) */
  allDataTableColumnDefinitionChoices: Maybe<DataTableColumnDefinitionChoicesConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionDate`. (live) */
  allDataTableColumnDefinitionDates: Maybe<DataTableColumnDefinitionDatesConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionFile`. (live) */
  allDataTableColumnDefinitionFiles: Maybe<DataTableColumnDefinitionFilesConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionFloat`. (live) */
  allDataTableColumnDefinitionFloats: Maybe<DataTableColumnDefinitionFloatsConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionIdentifier`. (live) */
  allDataTableColumnDefinitionIdentifiers: Maybe<DataTableColumnDefinitionIdentifiersConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionInteger`. (live) */
  allDataTableColumnDefinitionIntegers: Maybe<DataTableColumnDefinitionIntegersConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionJoin`. (live) */
  allDataTableColumnDefinitionJoins: Maybe<DataTableColumnDefinitionJoinsConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionMetadatum`. (live) */
  allDataTableColumnDefinitionMetadata: Maybe<DataTableColumnDefinitionMetadataConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionRoiFrame`. (live) */
  allDataTableColumnDefinitionRoiFrames: Maybe<DataTableColumnDefinitionRoiFramesConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnDefinitionText`. (live) */
  allDataTableColumnDefinitionTexts: Maybe<DataTableColumnDefinitionTextsConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnGroupDefinitionJoin`. (live) */
  allDataTableColumnGroupDefinitionJoins: Maybe<DataTableColumnGroupDefinitionJoinsConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnGroupDefinitionSource`. (live) */
  allDataTableColumnGroupDefinitionSources: Maybe<DataTableColumnGroupDefinitionSourcesConnection>;
  /** Reads and enables pagination through a set of `DataTableColumnGroup`. (live) */
  allDataTableColumnGroups: Maybe<DataTableColumnGroupsConnection>;
  /** Reads and enables pagination through a set of `DataTableColumn`. (live) */
  allDataTableColumns: Maybe<DataTableColumnsConnection>;
  /** Reads and enables pagination through a set of `DataTableRow`. (live) */
  allDataTableRows: Maybe<DataTableRowsConnection>;
  /** Reads and enables pagination through a set of `DataTable`. (live) */
  allDataTables: Maybe<DataTablesConnection>;
  /** Reads and enables pagination through a set of `DistributionRegistryImage`. (live) */
  allDistributionRegistryImages: Maybe<DistributionRegistryImagesConnection>;
  /** Reads and enables pagination through a set of `DjangoAdminLog`. (live) */
  allDjangoAdminLogs: Maybe<DjangoAdminLogsConnection>;
  /** Reads and enables pagination through a set of `DjangoContentType`. (live) */
  allDjangoContentTypes: Maybe<DjangoContentTypesConnection>;
  /** Reads and enables pagination through a set of `DjangoMigration`. (live) */
  allDjangoMigrations: Maybe<DjangoMigrationsConnection>;
  /** Reads and enables pagination through a set of `DjangoSesBlacklistedemail`. (live) */
  allDjangoSesBlacklistedemails: Maybe<DjangoSesBlacklistedemailsConnection>;
  /** Reads and enables pagination through a set of `DjangoSesSesstat`. (live) */
  allDjangoSesSesstats: Maybe<DjangoSesSesstatsConnection>;
  /** Reads and enables pagination through a set of `DjangoSession`. (live) */
  allDjangoSessions: Maybe<DjangoSessionsConnection>;
  /** Reads and enables pagination through a set of `DrsFileexecutor`. (live) */
  allDrsFileexecutors: Maybe<DrsFileexecutorsConnection>;
  /** Reads and enables pagination through a set of `DrsMockfileexecutor`. (live) */
  allDrsMockfileexecutors: Maybe<DrsMockfileexecutorsConnection>;
  /** Reads and enables pagination through a set of `EulaVersionUserAcceptance`. (live) */
  allEulaVersionUserAcceptances: Maybe<EulaVersionUserAcceptancesConnection>;
  /** Reads and enables pagination through a set of `EulaVersion`. (live) */
  allEulaVersions: Maybe<EulaVersionsConnection>;
  /** Reads and enables pagination through a set of `FeatureFlag`. (live) */
  allFeatureFlags: Maybe<FeatureFlagsConnection>;
  /** Reads and enables pagination through a set of `FeatureFlagsGroup`. (live) */
  allFeatureFlagsGroups: Maybe<FeatureFlagsGroupsConnection>;
  /** Reads and enables pagination through a set of `FeatureFlagsTenant`. (live) */
  allFeatureFlagsTenants: Maybe<FeatureFlagsTenantsConnection>;
  /** Reads and enables pagination through a set of `FeatureFlagsUser`. (live) */
  allFeatureFlagsUsers: Maybe<FeatureFlagsUsersConnection>;
  /** Reads and enables pagination through a set of `FileActivity`. (live) */
  allFileActivities: Maybe<FileActivitiesConnection>;
  /** Reads and enables pagination through a set of `FileMetadatum`. (live) */
  allFileMetadata: Maybe<FileMetadataConnection>;
  /** Reads and enables pagination through a set of `FileOutputGroupMetadatum`. (live) */
  allFileOutputGroupMetadata: Maybe<FileOutputGroupMetadataConnection>;
  /** Reads and enables pagination through a set of `FileOutputGroup`. (live) */
  allFileOutputGroups: Maybe<FileOutputGroupsConnection>;
  /** Reads and enables pagination through a set of `FileProcessingNotification`. (live) */
  allFileProcessingNotifications: Maybe<FileProcessingNotificationsConnection>;
  /** Reads and enables pagination through a set of `File`. (live) */
  allFiles: Maybe<FilesConnection>;
  /** Reads and enables pagination through a set of `FilesByExecutor`. (live) */
  allFilesByExecutors: Maybe<FilesByExecutorsConnection>;
  /** Reads and enables pagination through a set of `GdtAnalysisTableCell`. (live) */
  allGdtAnalysisTableCells: Maybe<GdtAnalysisTableCellsConnection>;
  /** Reads and enables pagination through a set of `GdtAnalysisTableColumnGroup`. (live) */
  allGdtAnalysisTableColumnGroups: Maybe<GdtAnalysisTableColumnGroupsConnection>;
  /** Reads and enables pagination through a set of `GdtAnalysisTableColumn`. (live) */
  allGdtAnalysisTableColumns: Maybe<GdtAnalysisTableColumnsConnection>;
  /** Reads and enables pagination through a set of `GdtAnalysisTableRow`. (live) */
  allGdtAnalysisTableRows: Maybe<GdtAnalysisTableRowsConnection>;
  /** Reads and enables pagination through a set of `GdtAnalysisTable`. (live) */
  allGdtAnalysisTables: Maybe<GdtAnalysisTablesConnection>;
  /** Reads and enables pagination through a set of `Notification`. (live) */
  allNotifications: Maybe<NotificationsConnection>;
  /** Reads and enables pagination through a set of `OutputGroupFile`. (live) */
  allOutputGroupFiles: Maybe<OutputGroupFilesConnection>;
  /** Reads and enables pagination through a set of `PinnedTool`. (live) */
  allPinnedTools: Maybe<PinnedToolsConnection>;
  /** Reads and enables pagination through a set of `ProjectClonedNotification`. (live) */
  allProjectClonedNotifications: Maybe<ProjectClonedNotificationsConnection>;
  /** Reads and enables pagination through a set of `ProjectFolder`. (live) */
  allProjectFolders: Maybe<ProjectFoldersConnection>;
  /** Reads and enables pagination through a set of `ProjectSharedNotification`. (live) */
  allProjectSharedNotifications: Maybe<ProjectSharedNotificationsConnection>;
  /** Reads and enables pagination through a set of `ProjectTag`. (live) */
  allProjectTags: Maybe<ProjectTagsConnection>;
  /** Reads and enables pagination through a set of `Project`. (live) */
  allProjects: Maybe<ProjectsConnection>;
  /** Reads and enables pagination through a set of `RoleChangeNotification`. (live) */
  allRoleChangeNotifications: Maybe<RoleChangeNotificationsConnection>;
  /** Reads and enables pagination through a set of `Run`. (live) */
  allRuns: Maybe<RunsConnection>;
  /** Reads and enables pagination through a set of `TaskActivity`. (live) */
  allTaskActivities: Maybe<TaskActivitiesConnection>;
  /** Reads and enables pagination through a set of `TaskResourceUsage`. (live) */
  allTaskResourceUsages: Maybe<TaskResourceUsagesConnection>;
  /** Reads and enables pagination through a set of `TaskResource`. (live) */
  allTaskResources: Maybe<TaskResourcesConnection>;
  /** Reads and enables pagination through a set of `TaskSource`. (live) */
  allTaskSources: Maybe<TaskSourcesConnection>;
  /** Reads and enables pagination through a set of `TaskStatusLog`. (live) */
  allTaskStatusLogs: Maybe<TaskStatusLogsConnection>;
  /** Reads and enables pagination through a set of `Task`. (live) */
  allTasks: Maybe<TasksConnection>;
  /** Reads and enables pagination through a set of `TenantContractAllowance`. (live) */
  allTenantContractAllowances: Maybe<TenantContractAllowancesConnection>;
  /** Reads and enables pagination through a set of `TenantContractTransaction`. (live) */
  allTenantContractTransactions: Maybe<TenantContractTransactionsConnection>;
  /** Reads and enables pagination through a set of `TenantContract`. (live) */
  allTenantContracts: Maybe<TenantContractsConnection>;
  /** Reads and enables pagination through a set of `TenantMockuserexecutor`. (live) */
  allTenantMockuserexecutors: Maybe<TenantMockuserexecutorsConnection>;
  /** Reads and enables pagination through a set of `TenantMonthlyConsumedResource`. (live) */
  allTenantMonthlyConsumedResources: Maybe<TenantMonthlyConsumedResourcesConnection>;
  /** Reads and enables pagination through a set of `TenantUserMembershipNotification`. (live) */
  allTenantUserMembershipNotifications: Maybe<TenantUserMembershipNotificationsConnection>;
  /** Reads and enables pagination through a set of `TenantUserexecutor`. (live) */
  allTenantUserexecutors: Maybe<TenantUserexecutorsConnection>;
  /** Reads and enables pagination through a set of `TesContainerimageexecutor`. (live) */
  allTesContainerimageexecutors: Maybe<TesContainerimageexecutorsConnection>;
  /** Reads and enables pagination through a set of `TesMockcontainerimageexecutor`. (live) */
  allTesMockcontainerimageexecutors: Maybe<TesMockcontainerimageexecutorsConnection>;
  /** Reads and enables pagination through a set of `TesMocktaskexecutor`. (live) */
  allTesMocktaskexecutors: Maybe<TesMocktaskexecutorsConnection>;
  /** Reads and enables pagination through a set of `TesTaskexecutor`. (live) */
  allTesTaskexecutors: Maybe<TesTaskexecutorsConnection>;
  /** Reads and enables pagination through a set of `ToolParameter`. (live) */
  allToolParameters: Maybe<ToolParametersConnection>;
  /** Reads and enables pagination through a set of `ToolResource`. (live) */
  allToolResources: Maybe<ToolResourcesConnection>;
  /** Reads and enables pagination through a set of `ToolResult`. (live) */
  allToolResults: Maybe<ToolResultsConnection>;
  /** Reads and enables pagination through a set of `ToolSecret`. (live) */
  allToolSecrets: Maybe<ToolSecretsConnection>;
  /** Reads and enables pagination through a set of `ToolSource`. (live) */
  allToolSources: Maybe<ToolSourcesConnection>;
  /** Reads and enables pagination through a set of `ToolTenant`. (live) */
  allToolTenants: Maybe<ToolTenantsConnection>;
  /** Reads and enables pagination through a set of `ToolVersion`. (live) */
  allToolVersions: Maybe<ToolVersionsConnection>;
  /** Reads and enables pagination through a set of `ToolboxTenant`. (live) */
  allToolboxTenants: Maybe<ToolboxTenantsConnection>;
  /** Reads and enables pagination through a set of `Toolbox`. (live) */
  allToolboxes: Maybe<ToolboxesConnection>;
  /** Reads and enables pagination through a set of `Tool`. (live) */
  allTools: Maybe<ToolsConnection>;
  /** Reads and enables pagination through a set of `UserAccessToProject`. (live) */
  allUserAccessToProjects: Maybe<UserAccessToProjectsConnection>;
  /** Reads and enables pagination through a set of `UserOnboardingQuestionAnswer`. (live) */
  allUserOnboardingQuestionAnswers: Maybe<UserOnboardingQuestionAnswersConnection>;
  /** Reads and enables pagination through a set of `UserOnboardingQuestionResponse`. (live) */
  allUserOnboardingQuestionResponses: Maybe<UserOnboardingQuestionResponsesConnection>;
  /** Reads and enables pagination through a set of `UserOnboardingQuestion`. (live) */
  allUserOnboardingQuestions: Maybe<UserOnboardingQuestionsConnection>;
  /** Reads and enables pagination through a set of `WaffleFlag`. (live) */
  allWaffleFlags: Maybe<WaffleFlagsConnection>;
  /** Reads and enables pagination through a set of `WaffleSample`. (live) */
  allWaffleSamples: Maybe<WaffleSamplesConnection>;
  /** Reads and enables pagination through a set of `WaffleSwitch`. (live) */
  allWaffleSwitches: Maybe<WaffleSwitchesConnection>;
  /** Reads and enables pagination through a set of `WorkflowDatum`. (live) */
  allWorkflowData: Maybe<WorkflowDataConnection>;
  /** Reads and enables pagination through a set of `WorkflowResultWorkflowVersion`. (live) */
  allWorkflowResultWorkflowVersions: Maybe<WorkflowResultWorkflowVersionsConnection>;
  /** Reads and enables pagination through a set of `WorkflowResult`. (live) */
  allWorkflowResults: Maybe<WorkflowResultsConnection>;
  /** Reads and enables pagination through a set of `WorkflowSectionBlockSection`. (live) */
  allWorkflowSectionBlockSections: Maybe<WorkflowSectionBlockSectionsConnection>;
  /** Reads and enables pagination through a set of `WorkflowSectionBlock`. (live) */
  allWorkflowSectionBlocks: Maybe<WorkflowSectionBlocksConnection>;
  /** Reads and enables pagination through a set of `WorkflowSectionWorkflowVersion`. (live) */
  allWorkflowSectionWorkflowVersions: Maybe<WorkflowSectionWorkflowVersionsConnection>;
  /** Reads and enables pagination through a set of `WorkflowSection`. (live) */
  allWorkflowSections: Maybe<WorkflowSectionsConnection>;
  /** Reads and enables pagination through a set of `WorkflowSourceWorkflowVersion`. (live) */
  allWorkflowSourceWorkflowVersions: Maybe<WorkflowSourceWorkflowVersionsConnection>;
  /** Reads and enables pagination through a set of `WorkflowSource`. (live) */
  allWorkflowSources: Maybe<WorkflowSourcesConnection>;
  /** Reads and enables pagination through a set of `WorkflowVersion`. (live) */
  allWorkflowVersions: Maybe<WorkflowVersionsConnection>;
  /** Reads and enables pagination through a set of `Workflow`. (live) */
  allWorkflows: Maybe<WorkflowsConnection>;
  /**  (live) */
  applicationUserByEmail: Maybe<ApplicationUser>;
  /**  (live) */
  applicationUserByGlobalUserId: Maybe<ApplicationUser>;
  /**  (live) */
  applicationUserById: Maybe<ApplicationUser>;
  /**  (live) */
  applicationUserByUsername: Maybe<ApplicationUser>;
  /**  (live) */
  applicationUserGroupById: Maybe<ApplicationUserGroup>;
  /**  (live) */
  applicationUserGroupByUserIdAndGroupId: Maybe<ApplicationUserGroup>;
  /**  (live) */
  applicationUserMembershipById: Maybe<ApplicationUserMembership>;
  /**  (live) */
  applicationUserMembershipByUserIdAndTenantId: Maybe<ApplicationUserMembership>;
  /**  (live) */
  applicationUserMetadatumById: Maybe<ApplicationUserMetadatum>;
  /**  (live) */
  applicationUserMetadatumByUserIdAndKey: Maybe<ApplicationUserMetadatum>;
  /**  (live) */
  applicationUserSessionById: Maybe<ApplicationUserSession>;
  /**  (live) */
  applicationUserUserPermissionById: Maybe<ApplicationUserUserPermission>;
  /**  (live) */
  applicationUserUserPermissionByUserIdAndPermissionId: Maybe<ApplicationUserUserPermission>;
  /**  (live) */
  assertUserAcceptedEula: Maybe<Scalars["Boolean"]["output"]>;
  /**  (live) */
  assertUserCanSeeTenantInfo: Maybe<Scalars["Boolean"]["output"]>;
  /**  (live) */
  assertUserCanSeeUserInfo: Maybe<Scalars["Boolean"]["output"]>;
  /**  (live) */
  assertUserHasProjectSharedByTenant: Maybe<Scalars["Boolean"]["output"]>;
  /**  (live) */
  assertUserHasTenantOfId: Maybe<Scalars["Boolean"]["output"]>;
  /**  (live) */
  assertUserIsAdminOfProjectTenant: Maybe<Scalars["Boolean"]["output"]>;
  /**  (live) */
  assertUserIsAdminOfTenant: Maybe<Scalars["Boolean"]["output"]>;
  /**  (live) */
  assertUserIsInvitedToTenant: Maybe<Scalars["Boolean"]["output"]>;
  /**  (live) */
  auditlogLogentryById: Maybe<AuditlogLogentry>;
  /**  (live) */
  authGroupById: Maybe<AuthGroup>;
  /**  (live) */
  authGroupByName: Maybe<AuthGroup>;
  /**  (live) */
  authGroupPermissionByGroupIdAndPermissionId: Maybe<AuthGroupPermission>;
  /**  (live) */
  authGroupPermissionById: Maybe<AuthGroupPermission>;
  /**  (live) */
  authPermissionByContentTypeIdAndCodename: Maybe<AuthPermission>;
  /**  (live) */
  authPermissionById: Maybe<AuthPermission>;
  /**  (live) */
  avatarById: Maybe<Avatar>;
  /**  (live) */
  avatarByUserId: Maybe<Avatar>;
  /**  (live) */
  awsBatchTaskByTaskexecutorPtrId: Maybe<AwsBatchTask>;
  /**  (live) */
  awsCognitoUserByUserexecutorPtrId: Maybe<AwsCognitoUser>;
  /**  (live) */
  awsEcrImageByContainerimageexecutorPtrId: Maybe<AwsEcrImage>;
  /**  (live) */
  awsMockBatchTaskByAwstaskexecutorPtrId: Maybe<AwsMockBatchTask>;
  /**  (live) */
  awsMockDistributionImageByDistributioncontainerimageexecutorPtrId: Maybe<AwsMockDistributionImage>;
  /**  (live) */
  awsMockEcrImageByAwscontainerimageexecutorPtrId: Maybe<AwsMockEcrImage>;
  /**  (live) */
  awsMockIamUserByAwsuserexecutorPtrId: Maybe<AwsMockIamUser>;
  /**  (live) */
  awsMockS3FileByAwsfileexecutorPtrId: Maybe<AwsMockS3File>;
  /**  (live) */
  awsS3FileByFileexecutorPtrId: Maybe<AwsS3File>;
  /**  (live) */
  codeFileById: Maybe<CodeFile>;
  /**  (live) */
  commandById: Maybe<Command>;
  /**  (live) */
  commandByToolVersionId: Maybe<Command>;
  /**  (live) */
  commandByToolVersionIdAndCodeFileId: Maybe<Command>;
  /**  (live) */
  containerImageByExecutorId: Maybe<ContainerImage>;
  /**  (live) */
  containerImageById: Maybe<ContainerImage>;
  /**  (live) */
  containerImageRepositoryById: Maybe<ContainerImageRepository>;
  /**  (live) */
  containerImageRepositoryByNameAndTenantIdAndRegistryType: Maybe<ContainerImageRepository>;
  /**  (live) */
  containerImageRepositoryByRepository: Maybe<ContainerImageRepository>;
  /**  (live) */
  costById: Maybe<Cost>;
  /**  (live) */
  dataTableById: Maybe<DataTable>;
  /**  (live) */
  dataTableCellByColumnIdAndRowId: Maybe<DataTableCell>;
  /**  (live) */
  dataTableCellById: Maybe<DataTableCell>;
  /**  (live) */
  dataTableColumnById: Maybe<DataTableColumn>;
  /**  (live) */
  dataTableColumnByTableIdAndOrder: Maybe<DataTableColumn>;
  /**  (live) */
  dataTableColumnDefinitionBooleanById: Maybe<DataTableColumnDefinitionBoolean>;
  /**  (live) */
  dataTableColumnDefinitionCellStatusById: Maybe<DataTableColumnDefinitionCellStatus>;
  /**  (live) */
  dataTableColumnDefinitionChoiceById: Maybe<DataTableColumnDefinitionChoice>;
  /**  (live) */
  dataTableColumnDefinitionDateById: Maybe<DataTableColumnDefinitionDate>;
  /**  (live) */
  dataTableColumnDefinitionFileById: Maybe<DataTableColumnDefinitionFile>;
  /**  (live) */
  dataTableColumnDefinitionFloatById: Maybe<DataTableColumnDefinitionFloat>;
  /**  (live) */
  dataTableColumnDefinitionIdentifierById: Maybe<DataTableColumnDefinitionIdentifier>;
  /**  (live) */
  dataTableColumnDefinitionIntegerById: Maybe<DataTableColumnDefinitionInteger>;
  /**  (live) */
  dataTableColumnDefinitionJoinById: Maybe<DataTableColumnDefinitionJoin>;
  /**  (live) */
  dataTableColumnDefinitionMetadatumById: Maybe<DataTableColumnDefinitionMetadatum>;
  /**  (live) */
  dataTableColumnDefinitionRoiFrameById: Maybe<DataTableColumnDefinitionRoiFrame>;
  /**  (live) */
  dataTableColumnDefinitionTextById: Maybe<DataTableColumnDefinitionText>;
  /**  (live) */
  dataTableColumnGroupById: Maybe<DataTableColumnGroup>;
  /**  (live) */
  dataTableColumnGroupDefinitionJoinById: Maybe<DataTableColumnGroupDefinitionJoin>;
  /**  (live) */
  dataTableColumnGroupDefinitionSourceById: Maybe<DataTableColumnGroupDefinitionSource>;
  /**  (live) */
  dataTableRowById: Maybe<DataTableRow>;
  /**  (live) */
  dataTableRowByTableIdAndIndex: Maybe<DataTableRow>;
  /**  (live) */
  distributionRegistryImageByContainerimageexecutorPtrId: Maybe<DistributionRegistryImage>;
  /**  (live) */
  djangoAdminLogById: Maybe<DjangoAdminLog>;
  /**  (live) */
  djangoContentTypeByAppLabelAndModel: Maybe<DjangoContentType>;
  /**  (live) */
  djangoContentTypeById: Maybe<DjangoContentType>;
  /**  (live) */
  djangoMigrationById: Maybe<DjangoMigration>;
  /**  (live) */
  djangoSesBlacklistedemailByEmail: Maybe<DjangoSesBlacklistedemail>;
  /**  (live) */
  djangoSesBlacklistedemailById: Maybe<DjangoSesBlacklistedemail>;
  /**  (live) */
  djangoSesSesstatByDate: Maybe<DjangoSesSesstat>;
  /**  (live) */
  djangoSesSesstatById: Maybe<DjangoSesSesstat>;
  /**  (live) */
  djangoSessionBySessionKey: Maybe<DjangoSession>;
  /**  (live) */
  drsFileexecutorById: Maybe<DrsFileexecutor>;
  /**  (live) */
  drsMockfileexecutorByFileexecutorPtrId: Maybe<DrsMockfileexecutor>;
  /**  (live) */
  eulaVersionById: Maybe<EulaVersion>;
  /**  (live) */
  eulaVersionByVersion: Maybe<EulaVersion>;
  /**  (live) */
  eulaVersionUserAcceptanceById: Maybe<EulaVersionUserAcceptance>;
  /**  (live) */
  eulaVersionUserAcceptanceByUserIdAndEulaVersionId: Maybe<EulaVersionUserAcceptance>;
  /**  (live) */
  featureFlagById: Maybe<FeatureFlag>;
  /**  (live) */
  featureFlagByName: Maybe<FeatureFlag>;
  /**  (live) */
  featureFlagsGroupByFeatureflagIdAndGroupId: Maybe<FeatureFlagsGroup>;
  /**  (live) */
  featureFlagsGroupById: Maybe<FeatureFlagsGroup>;
  /**  (live) */
  featureFlagsTenantByFeatureflagIdAndTenantId: Maybe<FeatureFlagsTenant>;
  /**  (live) */
  featureFlagsTenantById: Maybe<FeatureFlagsTenant>;
  /**  (live) */
  featureFlagsUserByFeatureflagIdAndUserId: Maybe<FeatureFlagsUser>;
  /**  (live) */
  featureFlagsUserById: Maybe<FeatureFlagsUser>;
  /**  (live) */
  fileActivityById: Maybe<FileActivity>;
  /**  (live) */
  fileById: Maybe<File>;
  /**  (live) */
  fileByProjectIdAndReferenceId: Maybe<File>;
  /**  (live) */
  fileMetadatumById: Maybe<FileMetadatum>;
  /**  (live) */
  fileOutputGroupById: Maybe<FileOutputGroup>;
  /**  (live) */
  fileOutputGroupByTaskId: Maybe<FileOutputGroup>;
  /**  (live) */
  fileOutputGroupMetadatumById: Maybe<FileOutputGroupMetadatum>;
  /**  (live) */
  fileProcessingNotificationById: Maybe<FileProcessingNotification>;
  /**  (live) */
  gdtAnalysisTableById: Maybe<GdtAnalysisTable>;
  /**  (live) */
  gdtAnalysisTableCellByColumnIdAndRowId: Maybe<GdtAnalysisTableCell>;
  /**  (live) */
  gdtAnalysisTableCellById: Maybe<GdtAnalysisTableCell>;
  /**  (live) */
  gdtAnalysisTableColumnById: Maybe<GdtAnalysisTableColumn>;
  /**  (live) */
  gdtAnalysisTableColumnByTableIdAndOrder: Maybe<GdtAnalysisTableColumn>;
  /**  (live) */
  gdtAnalysisTableColumnGroupById: Maybe<GdtAnalysisTableColumnGroup>;
  /**  (live) */
  gdtAnalysisTableRowById: Maybe<GdtAnalysisTableRow>;
  /**  (live) */
  gdtAnalysisTableRowByTableIdAndIndex: Maybe<GdtAnalysisTableRow>;
  /**  (live) */
  gdtAnalysisTableRowByTaskId: Maybe<GdtAnalysisTableRow>;
  /**  (live) */
  getCurrentUser: Maybe<ApplicationUser>;
  /**  (live) */
  getCurrentUserId: Maybe<Scalars["UUID"]["output"]>;
  /**  (live) */
  getUserActiveSession: Maybe<ApplicationUserSession>;
  /**  (live) */
  jwtHasGlobalUserIdClaim: Maybe<Scalars["Boolean"]["output"]>;
  /**  (live) */
  metadataValueById: Maybe<MetadataValue>;
  /**  (live) */
  metadatumById: Maybe<Metadatum>;
  /**  (live) */
  notificationById: Maybe<Notification>;
  /**  (live) */
  outputGroupFileById: Maybe<OutputGroupFile>;
  /**  (live) */
  pinnedToolById: Maybe<PinnedTool>;
  /**  (live) */
  pinnedToolByUserIdAndToolId: Maybe<PinnedTool>;
  /**  (live) */
  projectById: Maybe<Project>;
  /**  (live) */
  projectByKeyAndTenantId: Maybe<Project>;
  /**  (live) */
  projectClonedNotificationById: Maybe<ProjectClonedNotification>;
  /**  (live) */
  projectFolderById: Maybe<ProjectFolder>;
  /**  (live) */
  projectSharedNotificationById: Maybe<ProjectSharedNotification>;
  /**  (live) */
  projectTagById: Maybe<ProjectTag>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form. (live)
   */
  query: Query;
  /**  (live) */
  roleChangeNotificationById: Maybe<RoleChangeNotification>;
  /**  (live) */
  runById: Maybe<Run>;
  /**  (live) */
  sessionIsActiveSession: Maybe<Scalars["Boolean"]["output"]>;
  /**  (live) */
  taskActivityById: Maybe<TaskActivity>;
  /**  (live) */
  taskActivityByTaskId: Maybe<TaskActivity>;
  /**  (live) */
  taskByExecutorId: Maybe<Task>;
  /**  (live) */
  taskById: Maybe<Task>;
  /**  (live) */
  taskResourceById: Maybe<TaskResource>;
  /**  (live) */
  taskResourceUsageById: Maybe<TaskResourceUsage>;
  /**  (live) */
  taskResourceUsageByTaskId: Maybe<TaskResourceUsage>;
  /**  (live) */
  taskSourceById: Maybe<TaskSource>;
  /**  (live) */
  taskStatusLogById: Maybe<TaskStatusLog>;
  /**  (live) */
  taskStatusLogByTaskIdAndStatus: Maybe<TaskStatusLog>;
  /**  (live) */
  tenantById: Maybe<Tenant>;
  /**  (live) */
  tenantByKey: Maybe<Tenant>;
  /**  (live) */
  tenantByRepositoryName: Maybe<Tenant>;
  /**  (live) */
  tenantBySfid: Maybe<Tenant>;
  /**  (live) */
  tenantContractAllowanceById: Maybe<TenantContractAllowance>;
  /**  (live) */
  tenantContractAllowanceByTenantContractTransactionIdAndQuotaType: Maybe<TenantContractAllowance>;
  /**  (live) */
  tenantContractById: Maybe<TenantContract>;
  /**  (live) */
  tenantContractByName: Maybe<TenantContract>;
  /**  (live) */
  tenantContractBySfid: Maybe<TenantContract>;
  /**  (live) */
  tenantContractTransactionById: Maybe<TenantContractTransaction>;
  /**  (live) */
  tenantMockuserexecutorByUserexecutorPtrId: Maybe<TenantMockuserexecutor>;
  /**  (live) */
  tenantMonthlyConsumedResourceById: Maybe<TenantMonthlyConsumedResource>;
  /**  (live) */
  tenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract: Maybe<TenantMonthlyConsumedResource>;
  /**  (live) */
  tenantUserMembershipNotificationById: Maybe<TenantUserMembershipNotification>;
  /**  (live) */
  tenantUserexecutorById: Maybe<TenantUserexecutor>;
  /**  (live) */
  tesContainerimageexecutorById: Maybe<TesContainerimageexecutor>;
  /**  (live) */
  tesMockcontainerimageexecutorByContainerimageexecutorPtrId: Maybe<TesMockcontainerimageexecutor>;
  /**  (live) */
  tesMocktaskexecutorByTaskexecutorPtrId: Maybe<TesMocktaskexecutor>;
  /**  (live) */
  tesTaskexecutorById: Maybe<TesTaskexecutor>;
  /**  (live) */
  toolById: Maybe<Tool>;
  /**  (live) */
  toolByProjectId: Maybe<Tool>;
  /**  (live) */
  toolParameterById: Maybe<ToolParameter>;
  /**  (live) */
  toolResourceById: Maybe<ToolResource>;
  /**  (live) */
  toolResourceByTypeAndToolVersionId: Maybe<ToolResource>;
  /**  (live) */
  toolResultById: Maybe<ToolResult>;
  /**  (live) */
  toolSecretById: Maybe<ToolSecret>;
  /**  (live) */
  toolSourceById: Maybe<ToolSource>;
  /**  (live) */
  toolTenantById: Maybe<ToolTenant>;
  /**  (live) */
  toolTenantByToolIdAndTenantId: Maybe<ToolTenant>;
  /**  (live) */
  toolVersionById: Maybe<ToolVersion>;
  /**  (live) */
  toolboxById: Maybe<Toolbox>;
  /**  (live) */
  toolboxByKey: Maybe<Toolbox>;
  /**  (live) */
  toolboxTenantById: Maybe<ToolboxTenant>;
  /**  (live) */
  toolboxTenantByToolboxIdAndTenantId: Maybe<ToolboxTenant>;
  /**  (live) */
  userHasActiveSession: Maybe<Scalars["Boolean"]["output"]>;
  /**  (live) */
  userIdIsSettingsGlobalUserId: Maybe<Scalars["Boolean"]["output"]>;
  /**  (live) */
  userOnboardingQuestionAnswerById: Maybe<UserOnboardingQuestionAnswer>;
  /**  (live) */
  userOnboardingQuestionByCode: Maybe<UserOnboardingQuestion>;
  /**  (live) */
  userOnboardingQuestionById: Maybe<UserOnboardingQuestion>;
  /**  (live) */
  userOnboardingQuestionResponseById: Maybe<UserOnboardingQuestionResponse>;
  /**  (live) */
  userPersonalSpaceRequestById: Maybe<UserPersonalSpaceRequest>;
  /**  (live) */
  waffleFlagById: Maybe<WaffleFlag>;
  /**  (live) */
  waffleFlagByName: Maybe<WaffleFlag>;
  /**  (live) */
  waffleSampleById: Maybe<WaffleSample>;
  /**  (live) */
  waffleSampleByName: Maybe<WaffleSample>;
  /**  (live) */
  waffleSwitchById: Maybe<WaffleSwitch>;
  /**  (live) */
  waffleSwitchByName: Maybe<WaffleSwitch>;
  /**  (live) */
  workflowById: Maybe<Workflow>;
  /**  (live) */
  workflowDatumById: Maybe<WorkflowDatum>;
  /**  (live) */
  workflowResultById: Maybe<WorkflowResult>;
  /**  (live) */
  workflowResultWorkflowVersionById: Maybe<WorkflowResultWorkflowVersion>;
  /**  (live) */
  workflowResultWorkflowVersionByResultIdAndWorkflowversionId: Maybe<WorkflowResultWorkflowVersion>;
  /**  (live) */
  workflowSectionBlockById: Maybe<WorkflowSectionBlock>;
  /**  (live) */
  workflowSectionBlockSectionByBlockIdAndSectionId: Maybe<WorkflowSectionBlockSection>;
  /**  (live) */
  workflowSectionBlockSectionById: Maybe<WorkflowSectionBlockSection>;
  /**  (live) */
  workflowSectionById: Maybe<WorkflowSection>;
  /**  (live) */
  workflowSectionWorkflowVersionById: Maybe<WorkflowSectionWorkflowVersion>;
  /**  (live) */
  workflowSectionWorkflowVersionBySectionIdAndWorkflowversionId: Maybe<WorkflowSectionWorkflowVersion>;
  /**  (live) */
  workflowSourceById: Maybe<WorkflowSource>;
  /**  (live) */
  workflowSourceWorkflowVersionById: Maybe<WorkflowSourceWorkflowVersion>;
  /**  (live) */
  workflowSourceWorkflowVersionBySourceIdAndWorkflowversionId: Maybe<WorkflowSourceWorkflowVersion>;
  /**  (live) */
  workflowVersionById: Maybe<WorkflowVersion>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllAdminProjectsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AdminProjectCondition>;
  filter?: InputMaybe<AdminProjectFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AdminProjectsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllApplicationUserGroupsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserGroupCondition>;
  filter?: InputMaybe<ApplicationUserGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserGroupsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllApplicationUserMembershipsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserMembershipCondition>;
  filter?: InputMaybe<ApplicationUserMembershipFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserMembershipsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllApplicationUserMetadataArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserMetadatumCondition>;
  filter?: InputMaybe<ApplicationUserMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserMetadataOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllApplicationUserSessionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserSessionCondition>;
  filter?: InputMaybe<ApplicationUserSessionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserSessionsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllApplicationUserUserPermissionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserUserPermissionCondition>;
  filter?: InputMaybe<ApplicationUserUserPermissionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserUserPermissionsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllAuditlogLogentriesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuditlogLogentryCondition>;
  filter?: InputMaybe<AuditlogLogentryFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuditlogLogentriesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllAuthGroupPermissionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuthGroupPermissionCondition>;
  filter?: InputMaybe<AuthGroupPermissionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuthGroupPermissionsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllAuthGroupsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuthGroupCondition>;
  filter?: InputMaybe<AuthGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuthGroupsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllAuthPermissionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AuthPermissionCondition>;
  filter?: InputMaybe<AuthPermissionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AuthPermissionsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllAvailableNonRestrictedProjectsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AvailableNonRestrictedProjectCondition>;
  filter?: InputMaybe<AvailableNonRestrictedProjectFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AvailableNonRestrictedProjectsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllAvatarsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AvatarCondition>;
  filter?: InputMaybe<AvatarFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AvatarsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllAwsBatchTasksArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsBatchTaskCondition>;
  filter?: InputMaybe<AwsBatchTaskFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsBatchTasksOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllAwsCognitoUsersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsCognitoUserCondition>;
  filter?: InputMaybe<AwsCognitoUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsCognitoUsersOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllAwsEcrImagesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsEcrImageCondition>;
  filter?: InputMaybe<AwsEcrImageFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsEcrImagesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllAwsMockBatchTasksArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsMockBatchTaskCondition>;
  filter?: InputMaybe<AwsMockBatchTaskFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsMockBatchTasksOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllAwsMockDistributionImagesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsMockDistributionImageCondition>;
  filter?: InputMaybe<AwsMockDistributionImageFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsMockDistributionImagesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllAwsMockEcrImagesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsMockEcrImageCondition>;
  filter?: InputMaybe<AwsMockEcrImageFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsMockEcrImagesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllAwsMockIamUsersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsMockIamUserCondition>;
  filter?: InputMaybe<AwsMockIamUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsMockIamUsersOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllAwsMockS3FilesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsMockS3FileCondition>;
  filter?: InputMaybe<AwsMockS3FileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsMockS3FilesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllAwsS3FilesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsS3FileCondition>;
  filter?: InputMaybe<AwsS3FileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsS3FilesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllCodeFilesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CodeFileCondition>;
  filter?: InputMaybe<CodeFileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CodeFilesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllCommandsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CommandCondition>;
  filter?: InputMaybe<CommandFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CommandsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllContainerImageRepositoriesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ContainerImageRepositoryCondition>;
  filter?: InputMaybe<ContainerImageRepositoryFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContainerImageRepositoriesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllContainerImagesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ContainerImageCondition>;
  filter?: InputMaybe<ContainerImageFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContainerImagesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllCostsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CostCondition>;
  filter?: InputMaybe<CostFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CostsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllCurrentApplicationUsersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CurrentApplicationUserCondition>;
  filter?: InputMaybe<CurrentApplicationUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CurrentApplicationUsersOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllCurrentUserMembershipsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CurrentUserMembershipCondition>;
  filter?: InputMaybe<CurrentUserMembershipFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CurrentUserMembershipsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableCellsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableCellCondition>;
  filter?: InputMaybe<DataTableCellFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableCellsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableColumnDefinitionBooleansArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionBooleanCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionBooleanFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionBooleansOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableColumnDefinitionCellStatusesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionCellStatusCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionCellStatusFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionCellStatusesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableColumnDefinitionChoicesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionChoiceCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionChoiceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionChoicesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableColumnDefinitionDatesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionDateCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionDateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionDatesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableColumnDefinitionFilesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionFileCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionFileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionFilesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableColumnDefinitionFloatsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionFloatCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionFloatFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionFloatsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableColumnDefinitionIdentifiersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionIdentifierCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionIdentifierFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionIdentifiersOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableColumnDefinitionIntegersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionIntegerCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionIntegerFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionIntegersOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableColumnDefinitionJoinsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionJoinCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionJoinFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionJoinsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableColumnDefinitionMetadataArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionMetadatumCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionMetadataOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableColumnDefinitionRoiFramesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionRoiFrameCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionRoiFrameFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionRoiFramesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableColumnDefinitionTextsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnDefinitionTextCondition>;
  filter?: InputMaybe<DataTableColumnDefinitionTextFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnDefinitionTextsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableColumnGroupDefinitionJoinsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnGroupDefinitionJoinCondition>;
  filter?: InputMaybe<DataTableColumnGroupDefinitionJoinFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnGroupDefinitionJoinsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableColumnGroupDefinitionSourcesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnGroupDefinitionSourceCondition>;
  filter?: InputMaybe<DataTableColumnGroupDefinitionSourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnGroupDefinitionSourcesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableColumnGroupsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnGroupCondition>;
  filter?: InputMaybe<DataTableColumnGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnGroupsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableColumnsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableColumnCondition>;
  filter?: InputMaybe<DataTableColumnFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableColumnsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTableRowsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableRowCondition>;
  filter?: InputMaybe<DataTableRowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTableRowsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDataTablesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DataTableCondition>;
  filter?: InputMaybe<DataTableFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DataTablesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDistributionRegistryImagesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DistributionRegistryImageCondition>;
  filter?: InputMaybe<DistributionRegistryImageFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DistributionRegistryImagesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDjangoAdminLogsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DjangoAdminLogCondition>;
  filter?: InputMaybe<DjangoAdminLogFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DjangoAdminLogsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDjangoContentTypesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DjangoContentTypeCondition>;
  filter?: InputMaybe<DjangoContentTypeFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DjangoContentTypesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDjangoMigrationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DjangoMigrationCondition>;
  filter?: InputMaybe<DjangoMigrationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DjangoMigrationsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDjangoSesBlacklistedemailsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DjangoSesBlacklistedemailCondition>;
  filter?: InputMaybe<DjangoSesBlacklistedemailFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DjangoSesBlacklistedemailsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDjangoSesSesstatsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DjangoSesSesstatCondition>;
  filter?: InputMaybe<DjangoSesSesstatFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DjangoSesSesstatsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDjangoSessionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DjangoSessionCondition>;
  filter?: InputMaybe<DjangoSessionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DjangoSessionsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDrsFileexecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DrsFileexecutorCondition>;
  filter?: InputMaybe<DrsFileexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DrsFileexecutorsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllDrsMockfileexecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<DrsMockfileexecutorCondition>;
  filter?: InputMaybe<DrsMockfileexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DrsMockfileexecutorsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllEulaVersionUserAcceptancesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<EulaVersionUserAcceptanceCondition>;
  filter?: InputMaybe<EulaVersionUserAcceptanceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<EulaVersionUserAcceptancesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllEulaVersionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<EulaVersionCondition>;
  filter?: InputMaybe<EulaVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<EulaVersionsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllFeatureFlagsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FeatureFlagCondition>;
  filter?: InputMaybe<FeatureFlagFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FeatureFlagsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllFeatureFlagsGroupsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FeatureFlagsGroupCondition>;
  filter?: InputMaybe<FeatureFlagsGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FeatureFlagsGroupsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllFeatureFlagsTenantsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FeatureFlagsTenantCondition>;
  filter?: InputMaybe<FeatureFlagsTenantFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FeatureFlagsTenantsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllFeatureFlagsUsersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FeatureFlagsUserCondition>;
  filter?: InputMaybe<FeatureFlagsUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FeatureFlagsUsersOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllFileActivitiesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileActivityCondition>;
  filter?: InputMaybe<FileActivityFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileActivitiesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllFileMetadataArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileMetadatumCondition>;
  filter?: InputMaybe<FileMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileMetadataOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllFileOutputGroupMetadataArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileOutputGroupMetadatumCondition>;
  filter?: InputMaybe<FileOutputGroupMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileOutputGroupMetadataOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllFileOutputGroupsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileOutputGroupCondition>;
  filter?: InputMaybe<FileOutputGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileOutputGroupsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllFileProcessingNotificationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileProcessingNotificationCondition>;
  filter?: InputMaybe<FileProcessingNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileProcessingNotificationsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllFilesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllFilesByExecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FilesByExecutorCondition>;
  filter?: InputMaybe<FilesByExecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FilesByExecutorsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllGdtAnalysisTableCellsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableCellCondition>;
  filter?: InputMaybe<GdtAnalysisTableCellFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableCellsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllGdtAnalysisTableColumnGroupsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableColumnGroupCondition>;
  filter?: InputMaybe<GdtAnalysisTableColumnGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableColumnGroupsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllGdtAnalysisTableColumnsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableColumnCondition>;
  filter?: InputMaybe<GdtAnalysisTableColumnFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableColumnsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllGdtAnalysisTableRowsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableRowCondition>;
  filter?: InputMaybe<GdtAnalysisTableRowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableRowsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllGdtAnalysisTablesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableCondition>;
  filter?: InputMaybe<GdtAnalysisTableFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTablesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllNotificationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllOutputGroupFilesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<OutputGroupFileCondition>;
  filter?: InputMaybe<OutputGroupFileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<OutputGroupFilesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllPinnedToolsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<PinnedToolCondition>;
  filter?: InputMaybe<PinnedToolFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<PinnedToolsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllProjectClonedNotificationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectClonedNotificationCondition>;
  filter?: InputMaybe<ProjectClonedNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectClonedNotificationsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllProjectFoldersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectFolderCondition>;
  filter?: InputMaybe<ProjectFolderFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectFoldersOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllProjectSharedNotificationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectSharedNotificationCondition>;
  filter?: InputMaybe<ProjectSharedNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectSharedNotificationsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllProjectTagsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectTagCondition>;
  filter?: InputMaybe<ProjectTagFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectTagsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllProjectsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllRoleChangeNotificationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<RoleChangeNotificationCondition>;
  filter?: InputMaybe<RoleChangeNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<RoleChangeNotificationsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllRunsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<RunCondition>;
  filter?: InputMaybe<RunFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<RunsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllTaskActivitiesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskActivityCondition>;
  filter?: InputMaybe<TaskActivityFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskActivitiesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllTaskResourceUsagesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskResourceUsageCondition>;
  filter?: InputMaybe<TaskResourceUsageFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskResourceUsagesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllTaskResourcesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskResourceCondition>;
  filter?: InputMaybe<TaskResourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskResourcesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllTaskSourcesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskSourceCondition>;
  filter?: InputMaybe<TaskSourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskSourcesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllTaskStatusLogsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskStatusLogCondition>;
  filter?: InputMaybe<TaskStatusLogFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskStatusLogsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllTasksArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllTenantContractAllowancesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantContractAllowanceCondition>;
  filter?: InputMaybe<TenantContractAllowanceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantContractAllowancesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllTenantContractTransactionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantContractTransactionCondition>;
  filter?: InputMaybe<TenantContractTransactionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantContractTransactionsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllTenantContractsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantContractCondition>;
  filter?: InputMaybe<TenantContractFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantContractsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllTenantMockuserexecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantMockuserexecutorCondition>;
  filter?: InputMaybe<TenantMockuserexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantMockuserexecutorsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllTenantMonthlyConsumedResourcesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantMonthlyConsumedResourceCondition>;
  filter?: InputMaybe<TenantMonthlyConsumedResourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantMonthlyConsumedResourcesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllTenantUserMembershipNotificationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantUserMembershipNotificationCondition>;
  filter?: InputMaybe<TenantUserMembershipNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantUserMembershipNotificationsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllTenantUserexecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantUserexecutorCondition>;
  filter?: InputMaybe<TenantUserexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantUserexecutorsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllTesContainerimageexecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TesContainerimageexecutorCondition>;
  filter?: InputMaybe<TesContainerimageexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TesContainerimageexecutorsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllTesMockcontainerimageexecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TesMockcontainerimageexecutorCondition>;
  filter?: InputMaybe<TesMockcontainerimageexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TesMockcontainerimageexecutorsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllTesMocktaskexecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TesMocktaskexecutorCondition>;
  filter?: InputMaybe<TesMocktaskexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TesMocktaskexecutorsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllTesTaskexecutorsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TesTaskexecutorCondition>;
  filter?: InputMaybe<TesTaskexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TesTaskexecutorsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllToolParametersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolParameterCondition>;
  filter?: InputMaybe<ToolParameterFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolParametersOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllToolResourcesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolResourceCondition>;
  filter?: InputMaybe<ToolResourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolResourcesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllToolResultsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolResultCondition>;
  filter?: InputMaybe<ToolResultFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolResultsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllToolSecretsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolSecretCondition>;
  filter?: InputMaybe<ToolSecretFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolSecretsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllToolSourcesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolSourceCondition>;
  filter?: InputMaybe<ToolSourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolSourcesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllToolTenantsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolTenantCondition>;
  filter?: InputMaybe<ToolTenantFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolTenantsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllToolVersionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolVersionCondition>;
  filter?: InputMaybe<ToolVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolVersionsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllToolboxTenantsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolboxTenantCondition>;
  filter?: InputMaybe<ToolboxTenantFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolboxTenantsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllToolboxesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolboxCondition>;
  filter?: InputMaybe<ToolboxFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolboxesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllToolsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolCondition>;
  filter?: InputMaybe<ToolFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllUserAccessToProjectsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<UserAccessToProjectCondition>;
  filter?: InputMaybe<UserAccessToProjectFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<UserAccessToProjectsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllUserOnboardingQuestionAnswersArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<UserOnboardingQuestionAnswerCondition>;
  filter?: InputMaybe<UserOnboardingQuestionAnswerFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<UserOnboardingQuestionAnswersOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllUserOnboardingQuestionResponsesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<UserOnboardingQuestionResponseCondition>;
  filter?: InputMaybe<UserOnboardingQuestionResponseFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<UserOnboardingQuestionResponsesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllUserOnboardingQuestionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<UserOnboardingQuestionCondition>;
  filter?: InputMaybe<UserOnboardingQuestionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<UserOnboardingQuestionsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllWaffleFlagsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WaffleFlagCondition>;
  filter?: InputMaybe<WaffleFlagFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WaffleFlagsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllWaffleSamplesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WaffleSampleCondition>;
  filter?: InputMaybe<WaffleSampleFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WaffleSamplesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllWaffleSwitchesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WaffleSwitchCondition>;
  filter?: InputMaybe<WaffleSwitchFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WaffleSwitchesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllWorkflowDataArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowDatumCondition>;
  filter?: InputMaybe<WorkflowDatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowDataOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllWorkflowResultWorkflowVersionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowResultWorkflowVersionCondition>;
  filter?: InputMaybe<WorkflowResultWorkflowVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowResultWorkflowVersionsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllWorkflowResultsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowResultCondition>;
  filter?: InputMaybe<WorkflowResultFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowResultsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllWorkflowSectionBlockSectionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSectionBlockSectionCondition>;
  filter?: InputMaybe<WorkflowSectionBlockSectionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSectionBlockSectionsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllWorkflowSectionBlocksArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSectionBlockCondition>;
  filter?: InputMaybe<WorkflowSectionBlockFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSectionBlocksOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllWorkflowSectionWorkflowVersionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSectionWorkflowVersionCondition>;
  filter?: InputMaybe<WorkflowSectionWorkflowVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSectionWorkflowVersionsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllWorkflowSectionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSectionCondition>;
  filter?: InputMaybe<WorkflowSectionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSectionsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllWorkflowSourceWorkflowVersionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSourceWorkflowVersionCondition>;
  filter?: InputMaybe<WorkflowSourceWorkflowVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSourceWorkflowVersionsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllWorkflowSourcesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSourceCondition>;
  filter?: InputMaybe<WorkflowSourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSourcesOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllWorkflowVersionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowVersionCondition>;
  filter?: InputMaybe<WorkflowVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowVersionsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAllWorkflowsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowCondition>;
  filter?: InputMaybe<WorkflowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowsOrderBy>>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionApplicationUserByEmailArgs = {
  email: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionApplicationUserByGlobalUserIdArgs = {
  globalUserId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionApplicationUserByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionApplicationUserByUsernameArgs = {
  username: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionApplicationUserGroupByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionApplicationUserGroupByUserIdAndGroupIdArgs = {
  groupId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionApplicationUserMembershipByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionApplicationUserMembershipByUserIdAndTenantIdArgs = {
  tenantId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionApplicationUserMetadatumByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionApplicationUserMetadatumByUserIdAndKeyArgs = {
  key: Scalars["String"]["input"];
  userId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionApplicationUserSessionByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionApplicationUserUserPermissionByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionApplicationUserUserPermissionByUserIdAndPermissionIdArgs =
  {
    permissionId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAssertUserCanSeeTenantInfoArgs = {
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAssertUserCanSeeUserInfoArgs = {
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAssertUserHasProjectSharedByTenantArgs = {
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAssertUserHasTenantOfIdArgs = {
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAssertUserIsAdminOfProjectTenantArgs = {
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAssertUserIsAdminOfTenantArgs = {
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAssertUserIsInvitedToTenantArgs = {
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAuditlogLogentryByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAuthGroupByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAuthGroupByNameArgs = {
  name: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAuthGroupPermissionByGroupIdAndPermissionIdArgs = {
  groupId: Scalars["Int"]["input"];
  permissionId: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAuthGroupPermissionByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAuthPermissionByContentTypeIdAndCodenameArgs = {
  codename: Scalars["String"]["input"];
  contentTypeId: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAuthPermissionByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAvatarByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAvatarByUserIdArgs = {
  userId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAwsBatchTaskByTaskexecutorPtrIdArgs = {
  taskexecutorPtrId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAwsCognitoUserByUserexecutorPtrIdArgs = {
  userexecutorPtrId: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAwsEcrImageByContainerimageexecutorPtrIdArgs = {
  containerimageexecutorPtrId: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAwsMockBatchTaskByAwstaskexecutorPtrIdArgs = {
  awstaskexecutorPtrId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdArgs =
  {
    distributioncontainerimageexecutorPtrId: Scalars["Int"]["input"];
  };

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAwsMockEcrImageByAwscontainerimageexecutorPtrIdArgs = {
  awscontainerimageexecutorPtrId: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAwsMockIamUserByAwsuserexecutorPtrIdArgs = {
  awsuserexecutorPtrId: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAwsMockS3FileByAwsfileexecutorPtrIdArgs = {
  awsfileexecutorPtrId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionAwsS3FileByFileexecutorPtrIdArgs = {
  fileexecutorPtrId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionCodeFileByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionCommandByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionCommandByToolVersionIdArgs = {
  toolVersionId: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionCommandByToolVersionIdAndCodeFileIdArgs = {
  codeFileId: Scalars["UUID"]["input"];
  toolVersionId: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionContainerImageByExecutorIdArgs = {
  executorId: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionContainerImageByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionContainerImageRepositoryByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionContainerImageRepositoryByNameAndTenantIdAndRegistryTypeArgs =
  {
    name: Scalars["String"]["input"];
    registryType: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
  };

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionContainerImageRepositoryByRepositoryArgs = {
  repository: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionCostByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableCellByColumnIdAndRowIdArgs = {
  columnId: Scalars["UUID"]["input"];
  rowId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableCellByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableColumnByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableColumnByTableIdAndOrderArgs = {
  order: Scalars["Int"]["input"];
  tableId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableColumnDefinitionBooleanByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableColumnDefinitionCellStatusByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableColumnDefinitionChoiceByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableColumnDefinitionDateByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableColumnDefinitionFileByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableColumnDefinitionFloatByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableColumnDefinitionIdentifierByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableColumnDefinitionIntegerByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableColumnDefinitionJoinByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableColumnDefinitionMetadatumByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableColumnDefinitionRoiFrameByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableColumnDefinitionTextByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableColumnGroupByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableColumnGroupDefinitionJoinByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableColumnGroupDefinitionSourceByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableRowByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDataTableRowByTableIdAndIndexArgs = {
  index: Scalars["Int"]["input"];
  tableId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDistributionRegistryImageByContainerimageexecutorPtrIdArgs =
  {
    containerimageexecutorPtrId: Scalars["Int"]["input"];
  };

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDjangoAdminLogByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDjangoContentTypeByAppLabelAndModelArgs = {
  appLabel: Scalars["String"]["input"];
  model: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDjangoContentTypeByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDjangoMigrationByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDjangoSesBlacklistedemailByEmailArgs = {
  email: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDjangoSesBlacklistedemailByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDjangoSesSesstatByDateArgs = {
  date: Scalars["Date"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDjangoSesSesstatByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDjangoSessionBySessionKeyArgs = {
  sessionKey: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDrsFileexecutorByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionDrsMockfileexecutorByFileexecutorPtrIdArgs = {
  fileexecutorPtrId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionEulaVersionByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionEulaVersionByVersionArgs = {
  version: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionEulaVersionUserAcceptanceByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionEulaVersionUserAcceptanceByUserIdAndEulaVersionIdArgs =
  {
    eulaVersionId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionFeatureFlagByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionFeatureFlagByNameArgs = {
  name: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionFeatureFlagsGroupByFeatureflagIdAndGroupIdArgs = {
  featureflagId: Scalars["BigInt"]["input"];
  groupId: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionFeatureFlagsGroupByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionFeatureFlagsTenantByFeatureflagIdAndTenantIdArgs = {
  featureflagId: Scalars["BigInt"]["input"];
  tenantId: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionFeatureFlagsTenantByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionFeatureFlagsUserByFeatureflagIdAndUserIdArgs = {
  featureflagId: Scalars["BigInt"]["input"];
  userId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionFeatureFlagsUserByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionFileActivityByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionFileByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionFileByProjectIdAndReferenceIdArgs = {
  projectId: Scalars["UUID"]["input"];
  referenceId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionFileMetadatumByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionFileOutputGroupByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionFileOutputGroupByTaskIdArgs = {
  taskId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionFileOutputGroupMetadatumByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionFileProcessingNotificationByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionGdtAnalysisTableByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionGdtAnalysisTableCellByColumnIdAndRowIdArgs = {
  columnId: Scalars["UUID"]["input"];
  rowId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionGdtAnalysisTableCellByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionGdtAnalysisTableColumnByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionGdtAnalysisTableColumnByTableIdAndOrderArgs = {
  order: Scalars["Int"]["input"];
  tableId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionGdtAnalysisTableColumnGroupByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionGdtAnalysisTableRowByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionGdtAnalysisTableRowByTableIdAndIndexArgs = {
  index: Scalars["Int"]["input"];
  tableId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionGdtAnalysisTableRowByTaskIdArgs = {
  taskId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionGetUserActiveSessionArgs = {
  userid: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionMetadataValueByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionMetadatumByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionNotificationByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionOutputGroupFileByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionPinnedToolByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionPinnedToolByUserIdAndToolIdArgs = {
  toolId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProjectByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProjectByKeyAndTenantIdArgs = {
  key: Scalars["String"]["input"];
  tenantId: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProjectClonedNotificationByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProjectFolderByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProjectSharedNotificationByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionProjectTagByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionRoleChangeNotificationByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionRunByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionSessionIsActiveSessionArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTaskActivityByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTaskActivityByTaskIdArgs = {
  taskId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTaskByExecutorIdArgs = {
  executorId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTaskByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTaskResourceByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTaskResourceUsageByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTaskResourceUsageByTaskIdArgs = {
  taskId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTaskSourceByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTaskStatusLogByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTaskStatusLogByTaskIdAndStatusArgs = {
  status: Scalars["Int"]["input"];
  taskId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTenantByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTenantByKeyArgs = {
  key: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTenantByRepositoryNameArgs = {
  repositoryName: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTenantBySfidArgs = {
  sfid: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTenantContractAllowanceByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeArgs =
  {
    quotaType: Scalars["Int"]["input"];
    tenantContractTransactionId: Scalars["Int"]["input"];
  };

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTenantContractByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTenantContractByNameArgs = {
  name: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTenantContractBySfidArgs = {
  sfid: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTenantContractTransactionByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTenantMockuserexecutorByUserexecutorPtrIdArgs = {
  userexecutorPtrId: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTenantMonthlyConsumedResourceByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractArgs =
  {
    month: Scalars["Date"]["input"];
    monthInActiveContract: Scalars["Int"]["input"];
    quotaType: Scalars["Int"]["input"];
    tenantContractId: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTenantUserMembershipNotificationByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTenantUserexecutorByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTesContainerimageexecutorByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTesMockcontainerimageexecutorByContainerimageexecutorPtrIdArgs =
  {
    containerimageexecutorPtrId: Scalars["Int"]["input"];
  };

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTesMocktaskexecutorByTaskexecutorPtrIdArgs = {
  taskexecutorPtrId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionTesTaskexecutorByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionToolByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionToolByProjectIdArgs = {
  projectId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionToolParameterByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionToolResourceByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionToolResourceByTypeAndToolVersionIdArgs = {
  toolVersionId: Scalars["Int"]["input"];
  type: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionToolResultByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionToolSecretByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionToolSourceByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionToolTenantByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionToolTenantByToolIdAndTenantIdArgs = {
  tenantId: Scalars["Int"]["input"];
  toolId: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionToolVersionByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionToolboxByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionToolboxByKeyArgs = {
  key: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionToolboxTenantByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionToolboxTenantByToolboxIdAndTenantIdArgs = {
  tenantId: Scalars["Int"]["input"];
  toolboxId: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionUserHasActiveSessionArgs = {
  userid: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionUserIdIsSettingsGlobalUserIdArgs = {
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionUserOnboardingQuestionAnswerByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionUserOnboardingQuestionByCodeArgs = {
  code: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionUserOnboardingQuestionByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionUserOnboardingQuestionResponseByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionUserPersonalSpaceRequestByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWaffleFlagByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWaffleFlagByNameArgs = {
  name: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWaffleSampleByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWaffleSampleByNameArgs = {
  name: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWaffleSwitchByIdArgs = {
  id: Scalars["Int"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWaffleSwitchByNameArgs = {
  name: Scalars["String"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWorkflowByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWorkflowDatumByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWorkflowResultByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWorkflowResultWorkflowVersionByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdArgs =
  {
    resultId: Scalars["UUID"]["input"];
    workflowversionId: Scalars["UUID"]["input"];
  };

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWorkflowSectionBlockByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWorkflowSectionBlockSectionByBlockIdAndSectionIdArgs = {
  blockId: Scalars["UUID"]["input"];
  sectionId: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWorkflowSectionBlockSectionByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWorkflowSectionByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWorkflowSectionWorkflowVersionByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdArgs =
  {
    sectionId: Scalars["UUID"]["input"];
    workflowversionId: Scalars["UUID"]["input"];
  };

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWorkflowSourceByIdArgs = {
  id: Scalars["UUID"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWorkflowSourceWorkflowVersionByIdArgs = {
  id: Scalars["BigInt"]["input"];
};

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdArgs =
  {
    sourceId: Scalars["UUID"]["input"];
    workflowversionId: Scalars["UUID"]["input"];
  };

/**
 * The root subscription type: contains events and live queries you can subscribe to with the `subscription` operation.
 *
 * #### Live Queries
 *
 * Live query fields are differentiated by containing `(live)` at the end of their
 * description, they are added for each field in the `Query` type. When you
 * subscribe to a live query field, the selection set will be evaluated and sent to
 * the client, and then most things\* that would cause the output of the selection
 * set to change will trigger the selection set to be re-evaluated and the results
 * to be re-sent to the client.
 *
 * _(\* Not everything: typically only changes to persisted data referenced by the query are detected, not computed fields.)_
 *
 * Live queries can be very expensive, so try and keep them small and focussed.
 *
 * #### Events
 *
 * Event fields will run their selection set when, and only when, the specified
 * server-side event occurs. This makes them a lot more efficient than Live
 * Queries, but it is still recommended that you keep payloads fairly small.
 */
export type SubscriptionWorkflowVersionByIdArgs = {
  id: Scalars["UUID"]["input"];
};

export type Task = {
  __typename: "Task";
  /** Reads a single `ApplicationUser` that is related to this `Task`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  cloned: Scalars["Boolean"]["output"];
  /** Reads a single `ContainerImage` that is related to this `Task`. */
  containerImageByContainerImageId: Maybe<ContainerImage>;
  containerImageId: Maybe<Scalars["Int"]["output"]>;
  created: Maybe<Scalars["Datetime"]["output"]>;
  credits: Maybe<Scalars["Float"]["output"]>;
  dateCreated: Scalars["Datetime"]["output"];
  errorDescription: Maybe<Scalars["JSON"]["output"]>;
  executorId: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `FileOutputGroup` that is related to this `Task`. */
  fileOutputGroupByTaskId: Maybe<FileOutputGroup>;
  /**
   * Reads and enables pagination through a set of `FileOutputGroup`.
   * @deprecated Please use fileOutputGroupByTaskId instead
   */
  fileOutputGroupsByTaskId: FileOutputGroupsConnection;
  /** Reads and enables pagination through a set of `File`. */
  filesByTaskId: FilesConnection;
  /** Reads a single `GdtAnalysisTableRow` that is related to this `Task`. */
  gdtAnalysisTableRowByTaskId: Maybe<GdtAnalysisTableRow>;
  /**
   * Reads and enables pagination through a set of `GdtAnalysisTableRow`.
   * @deprecated Please use gdtAnalysisTableRowByTaskId instead
   */
  gdtAnalysisTableRowsByTaskId: GdtAnalysisTableRowsConnection;
  id: Scalars["UUID"]["output"];
  inputsHash: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `MetadataValue`. */
  metadataValuesByTaskId: MetadataValuesConnection;
  /** Reads a single `Project` that is related to this `Task`. */
  projectByProjectId: Maybe<Project>;
  projectId: Maybe<Scalars["UUID"]["output"]>;
  resourceTier: Maybe<Scalars["Int"]["output"]>;
  status: Scalars["Int"]["output"];
  /**
   * Reads and enables pagination through a set of `TaskActivity`.
   * @deprecated Please use taskActivityByTaskId instead
   */
  taskActivitiesByTaskId: TaskActivitiesConnection;
  /** Reads a single `TaskActivity` that is related to this `Task`. */
  taskActivityByTaskId: Maybe<TaskActivity>;
  taskParameters: Maybe<Scalars["JSON"]["output"]>;
  /** Reads a single `TaskResourceUsage` that is related to this `Task`. */
  taskResourceUsageByTaskId: Maybe<TaskResourceUsage>;
  /**
   * Reads and enables pagination through a set of `TaskResourceUsage`.
   * @deprecated Please use taskResourceUsageByTaskId instead
   */
  taskResourceUsagesByTaskId: TaskResourceUsagesConnection;
  /** Reads and enables pagination through a set of `TaskResource`. */
  taskResourcesByTaskId: TaskResourcesConnection;
  /** Reads and enables pagination through a set of `TaskSource`. */
  taskSourcesByTaskId: TaskSourcesConnection;
  /** Reads and enables pagination through a set of `TaskStatusLog`. */
  taskStatusLogsByTaskId: TaskStatusLogsConnection;
  /** Reads a single `Tenant` that is related to this `Task`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
  /** Reads a single `TesTaskexecutor` that is related to this `Task`. */
  tesTaskexecutorByExecutorId: Maybe<TesTaskexecutor>;
  toolExitcode: Maybe<Scalars["String"]["output"]>;
  toolExitcodeDescription: Maybe<Scalars["JSON"]["output"]>;
  /** Reads a single `ToolVersion` that is related to this `Task`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
  toolVersionId: Scalars["Int"]["output"];
  userId: Scalars["UUID"]["output"];
};

export type TaskFileOutputGroupsByTaskIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileOutputGroupCondition>;
  filter?: InputMaybe<FileOutputGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileOutputGroupsOrderBy>>;
};

export type TaskFilesByTaskIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};

export type TaskGdtAnalysisTableRowsByTaskIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableRowCondition>;
  filter?: InputMaybe<GdtAnalysisTableRowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableRowsOrderBy>>;
};

export type TaskMetadataValuesByTaskIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<MetadataValueCondition>;
  filter?: InputMaybe<MetadataValueFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<MetadataValuesOrderBy>>;
};

export type TaskTaskActivitiesByTaskIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskActivityCondition>;
  filter?: InputMaybe<TaskActivityFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskActivitiesOrderBy>>;
};

export type TaskTaskResourceUsagesByTaskIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskResourceUsageCondition>;
  filter?: InputMaybe<TaskResourceUsageFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskResourceUsagesOrderBy>>;
};

export type TaskTaskResourcesByTaskIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskResourceCondition>;
  filter?: InputMaybe<TaskResourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskResourcesOrderBy>>;
};

export type TaskTaskSourcesByTaskIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskSourceCondition>;
  filter?: InputMaybe<TaskSourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskSourcesOrderBy>>;
};

export type TaskTaskStatusLogsByTaskIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskStatusLogCondition>;
  filter?: InputMaybe<TaskStatusLogFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskStatusLogsOrderBy>>;
};

/** A connection to a list of `TaskActivity` values. */
export type TaskActivitiesConnection = {
  __typename: "TaskActivitiesConnection";
  /** A list of edges which contains the `TaskActivity` and cursor to aid in pagination. */
  edges: Array<TaskActivitiesEdge>;
  /** A list of `TaskActivity` objects. */
  nodes: Array<TaskActivity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TaskActivity` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `TaskActivity` edge in the connection. */
export type TaskActivitiesEdge = {
  __typename: "TaskActivitiesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `TaskActivity` at the end of the edge. */
  node: TaskActivity;
};

/** Methods to use when ordering `TaskActivity`. */
export enum TaskActivitiesOrderBy {
  ClonedAsc = "CLONED_ASC",
  ClonedDesc = "CLONED_DESC",
  CostIdAsc = "COST_ID_ASC",
  CostIdDesc = "COST_ID_DESC",
  DateAsc = "DATE_ASC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DateDesc = "DATE_DESC",
  DurationAsc = "DURATION_ASC",
  DurationDesc = "DURATION_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  InstanceTypeAsc = "INSTANCE_TYPE_ASC",
  InstanceTypeDesc = "INSTANCE_TYPE_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  TaskIdAsc = "TASK_ID_ASC",
  TaskIdDesc = "TASK_ID_DESC",
}

export type TaskActivity = {
  __typename: "TaskActivity";
  cloned: Scalars["Boolean"]["output"];
  /** Reads a single `Cost` that is related to this `TaskActivity`. */
  costByCostId: Maybe<Cost>;
  costId: Maybe<Scalars["BigInt"]["output"]>;
  date: Maybe<Scalars["Datetime"]["output"]>;
  dateCreated: Scalars["Datetime"]["output"];
  duration: Interval;
  id: Scalars["Int"]["output"];
  instanceType: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Task` that is related to this `TaskActivity`. */
  taskByTaskId: Maybe<Task>;
  taskId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `TaskActivity` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TaskActivityCondition = {
  /** Checks for equality with the object’s `cloned` field. */
  cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `costId` field. */
  costId?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `instanceType` field. */
  instanceType?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `cost` to be created by this mutation. */
export type TaskActivityCostId49E66058FkCostIdCostCreateInput = {
  costType: Scalars["Int"]["input"];
  currency: Scalars["Int"]["input"];
  date?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInverseInput>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  platform?: InputMaybe<Scalars["Int"]["input"]>;
  rateCode?: InputMaybe<Scalars["String"]["input"]>;
  taskActivitiesUsingId?: InputMaybe<TaskActivityCostId49E66058FkCostIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInput>;
  value: Scalars["BigFloat"]["input"];
};

/** Input for the nested mutation of `cost` in the `TaskActivityInput` mutation. */
export type TaskActivityCostId49E66058FkCostIdInput = {
  /** The primary key(s) for `cost` for the far side of the relationship. */
  connectById?: InputMaybe<CostCostPkeyConnect>;
  /** A `CostInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskActivityCostId49E66058FkCostIdCostCreateInput>;
  /** The primary key(s) for `cost` for the far side of the relationship. */
  deleteById?: InputMaybe<CostCostPkeyDelete>;
  /** The primary key(s) and patch data for `cost` for the far side of the relationship. */
  updateById?: InputMaybe<CostOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingCostPkeyUpdate>;
};

/** Input for the nested mutation of `taskActivity` in the `CostInput` mutation. */
export type TaskActivityCostId49E66058FkCostIdInverseInput = {
  /** The primary key(s) for `taskActivity` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskActivityTaskActivityPkeyConnect>>;
  /** The primary key(s) for `taskActivity` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<Array<TaskActivityTaskActivityTaskIdKeyConnect>>;
  /** A `TaskActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TaskActivityCostId49E66058FkCostIdTaskActivityCreateInput>
  >;
  /** The primary key(s) for `taskActivity` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TaskActivityTaskActivityPkeyDelete>>;
  /** The primary key(s) for `taskActivity` for the far side of the relationship. */
  deleteByTaskId?: InputMaybe<Array<TaskActivityTaskActivityTaskIdKeyDelete>>;
  /** Flag indicating whether all other `taskActivity` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `taskActivity` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingTaskActivityPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `taskActivity` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<
    Array<TaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingTaskActivityTaskIdKeyUpdate>
  >;
};

/** The `taskActivity` to be created by this mutation. */
export type TaskActivityCostId49E66058FkCostIdTaskActivityCreateInput = {
  cloned: Scalars["Boolean"]["input"];
  costToCostId?: InputMaybe<TaskActivityCostId49E66058FkCostIdInput>;
  date?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  instanceType?: InputMaybe<Scalars["String"]["input"]>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskToTaskId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInput>;
};

/** A filter to be used against `TaskActivity` object types. All fields are combined with a logical ‘and.’ */
export type TaskActivityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaskActivityFilter>>;
  /** Filter by the object’s `cloned` field. */
  cloned?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `costByCostId` relation. */
  costByCostId?: InputMaybe<CostFilter>;
  /** A related `costByCostId` exists. */
  costByCostIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `costId` field. */
  costId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `instanceType` field. */
  instanceType?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TaskActivityFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaskActivityFilter>>;
  /** Filter by the object’s `taskByTaskId` relation. */
  taskByTaskId?: InputMaybe<TaskFilter>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `TaskActivity` */
export type TaskActivityInput = {
  cloned: Scalars["Boolean"]["input"];
  costId?: InputMaybe<Scalars["BigInt"]["input"]>;
  costToCostId?: InputMaybe<TaskActivityCostId49E66058FkCostIdInput>;
  date?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  instanceType?: InputMaybe<Scalars["String"]["input"]>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskToTaskId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInput>;
};

/** The fields on `taskActivity` to look up the row to update. */
export type TaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingTaskActivityPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `taskActivity` being updated. */
    taskActivityPatch: UpdateTaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdPatch;
  };

/** The fields on `taskActivity` to look up the row to update. */
export type TaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingTaskActivityTaskIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `taskActivity` being updated. */
    taskActivityPatch: UpdateTaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdPatch;
    taskId: Scalars["UUID"]["input"];
  };

/** The fields on `taskActivity` to look up the row to update. */
export type TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `taskActivity` being updated. */
    taskActivityPatch: UpdateTaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch;
  };

/** The fields on `taskActivity` to look up the row to update. */
export type TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityTaskIdKeyUpdate =
  {
    /** An object where the defined keys will be set on the `taskActivity` being updated. */
    taskActivityPatch: UpdateTaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch;
    taskId: Scalars["UUID"]["input"];
  };

/** Represents an update to a `TaskActivity`. Fields that are set will be updated. */
export type TaskActivityPatch = {
  cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
  costId?: InputMaybe<Scalars["BigInt"]["input"]>;
  costToCostId?: InputMaybe<TaskActivityCostId49E66058FkCostIdInput>;
  date?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  duration?: InputMaybe<IntervalInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  instanceType?: InputMaybe<Scalars["String"]["input"]>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskToTaskId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInput>;
};

/** The fields on `taskActivity` to look up the row to connect. */
export type TaskActivityTaskActivityPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `taskActivity` to look up the row to delete. */
export type TaskActivityTaskActivityPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** The fields on `taskActivity` to look up the row to connect. */
export type TaskActivityTaskActivityTaskIdKeyConnect = {
  taskId: Scalars["UUID"]["input"];
};

/** The fields on `taskActivity` to look up the row to delete. */
export type TaskActivityTaskActivityTaskIdKeyDelete = {
  taskId: Scalars["UUID"]["input"];
};

/** Input for the nested mutation of `task` in the `TaskActivityInput` mutation. */
export type TaskActivityTaskIdC451Ae92FkTaskIdInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdTaskCreateInput>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyDelete>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteById?: InputMaybe<TaskTaskPkeyDelete>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `taskActivity` in the `TaskInput` mutation. */
export type TaskActivityTaskIdC451Ae92FkTaskIdInverseInput = {
  /** The primary key(s) for `taskActivity` for the far side of the relationship. */
  connectById?: InputMaybe<TaskActivityTaskActivityPkeyConnect>;
  /** The primary key(s) for `taskActivity` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<TaskActivityTaskActivityTaskIdKeyConnect>;
  /** A `TaskActivityInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TaskActivityTaskIdC451Ae92FkTaskIdTaskActivityCreateInput>
  >;
  /** The primary key(s) for `taskActivity` for the far side of the relationship. */
  deleteById?: InputMaybe<TaskActivityTaskActivityPkeyDelete>;
  /** The primary key(s) for `taskActivity` for the far side of the relationship. */
  deleteByTaskId?: InputMaybe<TaskActivityTaskActivityTaskIdKeyDelete>;
  /** Flag indicating whether all other `taskActivity` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `taskActivity` for the far side of the relationship. */
  updateById?: InputMaybe<TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityPkeyUpdate>;
  /** The primary key(s) and patch data for `taskActivity` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityTaskIdKeyUpdate>;
};

/** The `taskActivity` to be created by this mutation. */
export type TaskActivityTaskIdC451Ae92FkTaskIdTaskActivityCreateInput = {
  cloned: Scalars["Boolean"]["input"];
  costId?: InputMaybe<Scalars["BigInt"]["input"]>;
  costToCostId?: InputMaybe<TaskActivityCostId49E66058FkCostIdInput>;
  date?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  duration: IntervalInput;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  instanceType?: InputMaybe<Scalars["String"]["input"]>;
  taskToTaskId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInput>;
};

/** The `task` to be created by this mutation. */
export type TaskActivityTaskIdC451Ae92FkTaskIdTaskCreateInput = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned: Scalars["Boolean"]["input"];
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id: Scalars["UUID"]["input"];
  inputsHash: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A condition to be used against `Task` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type TaskCondition = {
  /** Checks for equality with the object’s `cloned` field. */
  cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `containerImageId` field. */
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `credits` field. */
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `errorDescription` field. */
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `executorId` field. */
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `inputsHash` field. */
  inputsHash?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `resourceTier` field. */
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `taskParameters` field. */
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `toolExitcode` field. */
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `toolExitcodeDescription` field. */
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `containerImage` to be created by this mutation. */
export type TaskContainerImageId92Ed2DaeFkContainerImageIdContainerImageCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
    containerImageRepositoryId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    label: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    readme?: InputMaybe<Scalars["String"]["input"]>;
    size: Scalars["BigInt"]["input"];
    spec?: InputMaybe<Scalars["JSON"]["input"]>;
    status: Scalars["Int"]["input"];
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
    tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
  };

/** Input for the nested mutation of `containerImage` in the `TaskInput` mutation. */
export type TaskContainerImageId92Ed2DaeFkContainerImageIdInput = {
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<ContainerImageContainerImageExecutorIdKeyConnect>;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  connectById?: InputMaybe<ContainerImageContainerImagePkeyConnect>;
  /** A `ContainerImageInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdContainerImageCreateInput>;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<ContainerImageContainerImageExecutorIdKeyDelete>;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  deleteById?: InputMaybe<ContainerImageContainerImagePkeyDelete>;
  /** The primary key(s) and patch data for `containerImage` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<ContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingContainerImageExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `containerImage` for the far side of the relationship. */
  updateById?: InputMaybe<ContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingContainerImagePkeyUpdate>;
};

/** Input for the nested mutation of `task` in the `ContainerImageInput` mutation. */
export type TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<Array<TaskTaskExecutorIdKeyConnect>>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTaskPkeyConnect>>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TaskContainerImageId92Ed2DaeFkContainerImageIdTaskCreateInput>
  >;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<Array<TaskTaskExecutorIdKeyDelete>>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TaskTaskPkeyDelete>>;
  /** Flag indicating whether all other `task` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<
    Array<TaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingTaskExecutorIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingTaskPkeyUpdate>
  >;
};

/** The `task` to be created by this mutation. */
export type TaskContainerImageId92Ed2DaeFkContainerImageIdTaskCreateInput = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned: Scalars["Boolean"]["input"];
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id: Scalars["UUID"]["input"];
  inputsHash: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `tesTaskexecutor` in the `TaskInput` mutation. */
export type TaskExecutorId24A67329FkTesTaskexecutorIdInput = {
  /** The primary key(s) for `tesTaskexecutor` for the far side of the relationship. */
  connectById?: InputMaybe<TesTaskexecutorTesTaskexecutorPkeyConnect>;
  /** A `TesTaskexecutorInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdTesTaskexecutorCreateInput>;
  /** The primary key(s) for `tesTaskexecutor` for the far side of the relationship. */
  deleteById?: InputMaybe<TesTaskexecutorTesTaskexecutorPkeyDelete>;
  /** The primary key(s) and patch data for `tesTaskexecutor` for the far side of the relationship. */
  updateById?: InputMaybe<TesTaskexecutorOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTesTaskexecutorPkeyUpdate>;
};

/** Input for the nested mutation of `task` in the `TesTaskexecutorInput` mutation. */
export type TaskExecutorId24A67329FkTesTaskexecutorIdInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TaskExecutorId24A67329FkTesTaskexecutorIdTaskCreateInput>
  >;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyDelete>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteById?: InputMaybe<TaskTaskPkeyDelete>;
  /** Flag indicating whether all other `task` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTaskPkeyUpdate>;
};

/** The `task` to be created by this mutation. */
export type TaskExecutorId24A67329FkTesTaskexecutorIdTaskCreateInput = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned: Scalars["Boolean"]["input"];
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id: Scalars["UUID"]["input"];
  inputsHash: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `tesTaskexecutor` to be created by this mutation. */
export type TaskExecutorId24A67329FkTesTaskexecutorIdTesTaskexecutorCreateInput =
  {
    awsBatchTaskUsingId?: InputMaybe<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInput>;
    id: Scalars["UUID"]["input"];
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    taskUsingId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInverseInput>;
    tesMocktaskexecutorUsingId?: InputMaybe<TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInverseInput>;
  };

/** A filter to be used against `Task` object types. All fields are combined with a logical ‘and.’ */
export type TaskFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaskFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `cloned` field. */
  cloned?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `containerImageByContainerImageId` relation. */
  containerImageByContainerImageId?: InputMaybe<ContainerImageFilter>;
  /** A related `containerImageByContainerImageId` exists. */
  containerImageByContainerImageIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `containerImageId` field. */
  containerImageId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `credits` field. */
  credits?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `errorDescription` field. */
  errorDescription?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `executorId` field. */
  executorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fileOutputGroupByTaskId` relation. */
  fileOutputGroupByTaskId?: InputMaybe<FileOutputGroupFilter>;
  /** A related `fileOutputGroupByTaskId` exists. */
  fileOutputGroupByTaskIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `filesByTaskId` relation. */
  filesByTaskId?: InputMaybe<TaskToManyFileFilter>;
  /** Some related `filesByTaskId` exist. */
  filesByTaskIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `gdtAnalysisTableRowByTaskId` relation. */
  gdtAnalysisTableRowByTaskId?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** A related `gdtAnalysisTableRowByTaskId` exists. */
  gdtAnalysisTableRowByTaskIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `inputsHash` field. */
  inputsHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadataValuesByTaskId` relation. */
  metadataValuesByTaskId?: InputMaybe<TaskToManyMetadataValueFilter>;
  /** Some related `metadataValuesByTaskId` exist. */
  metadataValuesByTaskIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Negates the expression. */
  not?: InputMaybe<TaskFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaskFilter>>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** A related `projectByProjectId` exists. */
  projectByProjectIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `resourceTier` field. */
  resourceTier?: InputMaybe<IntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `taskActivityByTaskId` relation. */
  taskActivityByTaskId?: InputMaybe<TaskActivityFilter>;
  /** A related `taskActivityByTaskId` exists. */
  taskActivityByTaskIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `taskParameters` field. */
  taskParameters?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `taskResourceUsageByTaskId` relation. */
  taskResourceUsageByTaskId?: InputMaybe<TaskResourceUsageFilter>;
  /** A related `taskResourceUsageByTaskId` exists. */
  taskResourceUsageByTaskIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `taskResourcesByTaskId` relation. */
  taskResourcesByTaskId?: InputMaybe<TaskToManyTaskResourceFilter>;
  /** Some related `taskResourcesByTaskId` exist. */
  taskResourcesByTaskIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `taskSourcesByTaskId` relation. */
  taskSourcesByTaskId?: InputMaybe<TaskToManyTaskSourceFilter>;
  /** Some related `taskSourcesByTaskId` exist. */
  taskSourcesByTaskIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `taskStatusLogsByTaskId` relation. */
  taskStatusLogsByTaskId?: InputMaybe<TaskToManyTaskStatusLogFilter>;
  /** Some related `taskStatusLogsByTaskId` exist. */
  taskStatusLogsByTaskIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tesTaskexecutorByExecutorId` relation. */
  tesTaskexecutorByExecutorId?: InputMaybe<TesTaskexecutorFilter>;
  /** A related `tesTaskexecutorByExecutorId` exists. */
  tesTaskexecutorByExecutorIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `toolExitcode` field. */
  toolExitcode?: InputMaybe<StringFilter>;
  /** Filter by the object’s `toolExitcodeDescription` field. */
  toolExitcodeDescription?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `toolVersionByToolVersionId` relation. */
  toolVersionByToolVersionId?: InputMaybe<ToolVersionFilter>;
  /** Filter by the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `Task` */
export type TaskInput = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned: Scalars["Boolean"]["input"];
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id: Scalars["UUID"]["input"];
  inputsHash: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskExecutorIdKeyUpdate =
  {
    executorId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnFileForFileTaskIdE4Da87AeFkTaskIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskPkeyUpdate = {
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnFileForFileTaskIdE4Da87AeFkTaskIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskExecutorIdKeyUpdate =
  {
    executorId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskExecutorIdKeyUpdate =
  {
    executorId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskExecutorIdKeyUpdate =
  {
    executorId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskExecutorIdKeyUpdate =
  {
    executorId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingTaskExecutorIdKeyUpdate =
  {
    executorId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingTaskPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTaskExecutorIdKeyUpdate =
  {
    executorId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTaskPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskExecutorIdKeyUpdate =
  {
    executorId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskForTaskProjectId963D6354FkProjectIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskPkeyUpdate = {
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskForTaskProjectId963D6354FkProjectIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskExecutorIdKeyUpdate =
  {
    executorId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskPkeyUpdate = {
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `task` being updated. */
  taskPatch: UpdateTaskOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
};

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskExecutorIdKeyUpdate =
  {
    executorId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskExecutorIdKeyUpdate =
  {
    executorId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskExecutorIdKeyUpdate =
  {
    executorId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskExecutorIdKeyUpdate =
  {
    executorId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskExecutorIdKeyUpdate =
  {
    executorId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskExecutorIdKeyUpdate =
  {
    executorId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdPatch;
  };

/** The fields on `task` to look up the row to update. */
export type TaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `task` being updated. */
    taskPatch: UpdateTaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdPatch;
  };

/** Represents an update to a `Task`. Fields that are set will be updated. */
export type TaskPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  inputsHash?: InputMaybe<Scalars["String"]["input"]>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `project` in the `TaskInput` mutation. */
export type TaskProjectId963D6354FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `task` in the `ProjectInput` mutation. */
export type TaskProjectId963D6354FkProjectIdInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<Array<TaskTaskExecutorIdKeyConnect>>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTaskPkeyConnect>>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskProjectId963D6354FkProjectIdTaskCreateInput>>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<Array<TaskTaskExecutorIdKeyDelete>>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TaskTaskPkeyDelete>>;
  /** Flag indicating whether all other `task` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<
    Array<TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskExecutorIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskPkeyUpdate>
  >;
};

/** The `task` to be created by this mutation. */
export type TaskProjectId963D6354FkProjectIdTaskCreateInput = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned: Scalars["Boolean"]["input"];
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id: Scalars["UUID"]["input"];
  inputsHash: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type TaskResource = {
  __typename: "TaskResource";
  id: Scalars["Int"]["output"];
  /** Reads a single `Task` that is related to this `TaskResource`. */
  taskByTaskId: Maybe<Task>;
  taskId: Scalars["UUID"]["output"];
  type: Scalars["Int"]["output"];
  value: Scalars["Int"]["output"];
};

/**
 * A condition to be used against `TaskResource` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TaskResourceCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `TaskResource` object types. All fields are combined with a logical ‘and.’ */
export type TaskResourceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaskResourceFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TaskResourceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaskResourceFilter>>;
  /** Filter by the object’s `taskByTaskId` relation. */
  taskByTaskId?: InputMaybe<TaskFilter>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<IntFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `TaskResource` */
export type TaskResourceInput = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskToTaskId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInput>;
  type: Scalars["Int"]["input"];
  value: Scalars["Int"]["input"];
};

/** The fields on `taskResource` to look up the row to update. */
export type TaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskResourcePkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `taskResource` being updated. */
    taskResourcePatch: UpdateTaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch;
  };

/** Represents an update to a `TaskResource`. Fields that are set will be updated. */
export type TaskResourcePatch = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskToTaskId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInput>;
  type?: InputMaybe<Scalars["Int"]["input"]>;
  value?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input for the nested mutation of `task` in the `TaskResourceInput` mutation. */
export type TaskResourceTaskId73Fcabc0FkTaskIdInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdTaskCreateInput>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyDelete>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteById?: InputMaybe<TaskTaskPkeyDelete>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `taskResource` in the `TaskInput` mutation. */
export type TaskResourceTaskId73Fcabc0FkTaskIdInverseInput = {
  /** The primary key(s) for `taskResource` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskResourceTaskResourcePkeyConnect>>;
  /** A `TaskResourceInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TaskResourceTaskId73Fcabc0FkTaskIdTaskResourceCreateInput>
  >;
  /** The primary key(s) for `taskResource` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TaskResourceTaskResourcePkeyDelete>>;
  /** Flag indicating whether all other `taskResource` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `taskResource` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskResourcePkeyUpdate>
  >;
};

/** The `task` to be created by this mutation. */
export type TaskResourceTaskId73Fcabc0FkTaskIdTaskCreateInput = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned: Scalars["Boolean"]["input"];
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id: Scalars["UUID"]["input"];
  inputsHash: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `taskResource` to be created by this mutation. */
export type TaskResourceTaskId73Fcabc0FkTaskIdTaskResourceCreateInput = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  taskToTaskId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInput>;
  type: Scalars["Int"]["input"];
  value: Scalars["Int"]["input"];
};

/** The fields on `taskResource` to look up the row to connect. */
export type TaskResourceTaskResourcePkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `taskResource` to look up the row to delete. */
export type TaskResourceTaskResourcePkeyDelete = {
  id: Scalars["Int"]["input"];
};

export type TaskResourceUsage = {
  __typename: "TaskResourceUsage";
  cpuMax: Scalars["Float"]["output"];
  cpuMean: Scalars["Float"]["output"];
  cpuMedian: Scalars["Float"]["output"];
  cpuMin: Scalars["Float"]["output"];
  cpuStd: Scalars["Float"]["output"];
  id: Scalars["Int"]["output"];
  memoryMax: Scalars["Float"]["output"];
  memoryMean: Scalars["Float"]["output"];
  memoryMedian: Scalars["Float"]["output"];
  memoryMin: Scalars["Float"]["output"];
  memoryStd: Scalars["Float"]["output"];
  storageMax: Scalars["Float"]["output"];
  storageMean: Scalars["Float"]["output"];
  storageMedian: Scalars["Float"]["output"];
  storageMin: Scalars["Float"]["output"];
  storageStd: Scalars["Float"]["output"];
  /** Reads a single `Task` that is related to this `TaskResourceUsage`. */
  taskByTaskId: Maybe<Task>;
  taskId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `TaskResourceUsage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TaskResourceUsageCondition = {
  /** Checks for equality with the object’s `cpuMax` field. */
  cpuMax?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `cpuMean` field. */
  cpuMean?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `cpuMedian` field. */
  cpuMedian?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `cpuMin` field. */
  cpuMin?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `cpuStd` field. */
  cpuStd?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `memoryMax` field. */
  memoryMax?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `memoryMean` field. */
  memoryMean?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `memoryMedian` field. */
  memoryMedian?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `memoryMin` field. */
  memoryMin?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `memoryStd` field. */
  memoryStd?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `storageMax` field. */
  storageMax?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `storageMean` field. */
  storageMean?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `storageMedian` field. */
  storageMedian?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `storageMin` field. */
  storageMin?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `storageStd` field. */
  storageStd?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `TaskResourceUsage` object types. All fields are combined with a logical ‘and.’ */
export type TaskResourceUsageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaskResourceUsageFilter>>;
  /** Filter by the object’s `cpuMax` field. */
  cpuMax?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `cpuMean` field. */
  cpuMean?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `cpuMedian` field. */
  cpuMedian?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `cpuMin` field. */
  cpuMin?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `cpuStd` field. */
  cpuStd?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `memoryMax` field. */
  memoryMax?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `memoryMean` field. */
  memoryMean?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `memoryMedian` field. */
  memoryMedian?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `memoryMin` field. */
  memoryMin?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `memoryStd` field. */
  memoryStd?: InputMaybe<FloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TaskResourceUsageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaskResourceUsageFilter>>;
  /** Filter by the object’s `storageMax` field. */
  storageMax?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `storageMean` field. */
  storageMean?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `storageMedian` field. */
  storageMedian?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `storageMin` field. */
  storageMin?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `storageStd` field. */
  storageStd?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `taskByTaskId` relation. */
  taskByTaskId?: InputMaybe<TaskFilter>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `TaskResourceUsage` */
export type TaskResourceUsageInput = {
  cpuMax: Scalars["Float"]["input"];
  cpuMean: Scalars["Float"]["input"];
  cpuMedian: Scalars["Float"]["input"];
  cpuMin: Scalars["Float"]["input"];
  cpuStd: Scalars["Float"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  memoryMax: Scalars["Float"]["input"];
  memoryMean: Scalars["Float"]["input"];
  memoryMedian: Scalars["Float"]["input"];
  memoryMin: Scalars["Float"]["input"];
  memoryStd: Scalars["Float"]["input"];
  storageMax: Scalars["Float"]["input"];
  storageMean: Scalars["Float"]["input"];
  storageMedian: Scalars["Float"]["input"];
  storageMin: Scalars["Float"]["input"];
  storageStd: Scalars["Float"]["input"];
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskToTaskId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInput>;
};

/** The fields on `taskResourceUsage` to look up the row to update. */
export type TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsagePkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `taskResourceUsage` being updated. */
    taskResourceUsagePatch: UpdateTaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch;
  };

/** The fields on `taskResourceUsage` to look up the row to update. */
export type TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsageTaskIdKeyUpdate =
  {
    taskId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `taskResourceUsage` being updated. */
    taskResourceUsagePatch: UpdateTaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch;
  };

/** Represents an update to a `TaskResourceUsage`. Fields that are set will be updated. */
export type TaskResourceUsagePatch = {
  cpuMax?: InputMaybe<Scalars["Float"]["input"]>;
  cpuMean?: InputMaybe<Scalars["Float"]["input"]>;
  cpuMedian?: InputMaybe<Scalars["Float"]["input"]>;
  cpuMin?: InputMaybe<Scalars["Float"]["input"]>;
  cpuStd?: InputMaybe<Scalars["Float"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  memoryMax?: InputMaybe<Scalars["Float"]["input"]>;
  memoryMean?: InputMaybe<Scalars["Float"]["input"]>;
  memoryMedian?: InputMaybe<Scalars["Float"]["input"]>;
  memoryMin?: InputMaybe<Scalars["Float"]["input"]>;
  memoryStd?: InputMaybe<Scalars["Float"]["input"]>;
  storageMax?: InputMaybe<Scalars["Float"]["input"]>;
  storageMean?: InputMaybe<Scalars["Float"]["input"]>;
  storageMedian?: InputMaybe<Scalars["Float"]["input"]>;
  storageMin?: InputMaybe<Scalars["Float"]["input"]>;
  storageStd?: InputMaybe<Scalars["Float"]["input"]>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskToTaskId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInput>;
};

/** Input for the nested mutation of `task` in the `TaskResourceUsageInput` mutation. */
export type TaskResourceUsageTaskIdA28F1580FkTaskIdInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdTaskCreateInput>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyDelete>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteById?: InputMaybe<TaskTaskPkeyDelete>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `taskResourceUsage` in the `TaskInput` mutation. */
export type TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput = {
  /** The primary key(s) for `taskResourceUsage` for the far side of the relationship. */
  connectById?: InputMaybe<TaskResourceUsageTaskResourceUsagePkeyConnect>;
  /** The primary key(s) for `taskResourceUsage` for the far side of the relationship. */
  connectByTaskId?: InputMaybe<TaskResourceUsageTaskResourceUsageTaskIdKeyConnect>;
  /** A `TaskResourceUsageInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TaskResourceUsageTaskIdA28F1580FkTaskIdTaskResourceUsageCreateInput>
  >;
  /** The primary key(s) for `taskResourceUsage` for the far side of the relationship. */
  deleteById?: InputMaybe<TaskResourceUsageTaskResourceUsagePkeyDelete>;
  /** The primary key(s) for `taskResourceUsage` for the far side of the relationship. */
  deleteByTaskId?: InputMaybe<TaskResourceUsageTaskResourceUsageTaskIdKeyDelete>;
  /** Flag indicating whether all other `taskResourceUsage` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `taskResourceUsage` for the far side of the relationship. */
  updateById?: InputMaybe<TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsagePkeyUpdate>;
  /** The primary key(s) and patch data for `taskResourceUsage` for the far side of the relationship. */
  updateByTaskId?: InputMaybe<TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsageTaskIdKeyUpdate>;
};

/** The `task` to be created by this mutation. */
export type TaskResourceUsageTaskIdA28F1580FkTaskIdTaskCreateInput = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned: Scalars["Boolean"]["input"];
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id: Scalars["UUID"]["input"];
  inputsHash: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `taskResourceUsage` to be created by this mutation. */
export type TaskResourceUsageTaskIdA28F1580FkTaskIdTaskResourceUsageCreateInput =
  {
    cpuMax: Scalars["Float"]["input"];
    cpuMean: Scalars["Float"]["input"];
    cpuMedian: Scalars["Float"]["input"];
    cpuMin: Scalars["Float"]["input"];
    cpuStd: Scalars["Float"]["input"];
    id?: InputMaybe<Scalars["Int"]["input"]>;
    memoryMax: Scalars["Float"]["input"];
    memoryMean: Scalars["Float"]["input"];
    memoryMedian: Scalars["Float"]["input"];
    memoryMin: Scalars["Float"]["input"];
    memoryStd: Scalars["Float"]["input"];
    storageMax: Scalars["Float"]["input"];
    storageMean: Scalars["Float"]["input"];
    storageMedian: Scalars["Float"]["input"];
    storageMin: Scalars["Float"]["input"];
    storageStd: Scalars["Float"]["input"];
    taskToTaskId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInput>;
  };

/** The fields on `taskResourceUsage` to look up the row to connect. */
export type TaskResourceUsageTaskResourceUsagePkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `taskResourceUsage` to look up the row to delete. */
export type TaskResourceUsageTaskResourceUsagePkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** The fields on `taskResourceUsage` to look up the row to connect. */
export type TaskResourceUsageTaskResourceUsageTaskIdKeyConnect = {
  taskId: Scalars["UUID"]["input"];
};

/** The fields on `taskResourceUsage` to look up the row to delete. */
export type TaskResourceUsageTaskResourceUsageTaskIdKeyDelete = {
  taskId: Scalars["UUID"]["input"];
};

/** A connection to a list of `TaskResourceUsage` values. */
export type TaskResourceUsagesConnection = {
  __typename: "TaskResourceUsagesConnection";
  /** A list of edges which contains the `TaskResourceUsage` and cursor to aid in pagination. */
  edges: Array<TaskResourceUsagesEdge>;
  /** A list of `TaskResourceUsage` objects. */
  nodes: Array<TaskResourceUsage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TaskResourceUsage` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `TaskResourceUsage` edge in the connection. */
export type TaskResourceUsagesEdge = {
  __typename: "TaskResourceUsagesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `TaskResourceUsage` at the end of the edge. */
  node: TaskResourceUsage;
};

/** Methods to use when ordering `TaskResourceUsage`. */
export enum TaskResourceUsagesOrderBy {
  CpuMaxAsc = "CPU_MAX_ASC",
  CpuMaxDesc = "CPU_MAX_DESC",
  CpuMeanAsc = "CPU_MEAN_ASC",
  CpuMeanDesc = "CPU_MEAN_DESC",
  CpuMedianAsc = "CPU_MEDIAN_ASC",
  CpuMedianDesc = "CPU_MEDIAN_DESC",
  CpuMinAsc = "CPU_MIN_ASC",
  CpuMinDesc = "CPU_MIN_DESC",
  CpuStdAsc = "CPU_STD_ASC",
  CpuStdDesc = "CPU_STD_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  MemoryMaxAsc = "MEMORY_MAX_ASC",
  MemoryMaxDesc = "MEMORY_MAX_DESC",
  MemoryMeanAsc = "MEMORY_MEAN_ASC",
  MemoryMeanDesc = "MEMORY_MEAN_DESC",
  MemoryMedianAsc = "MEMORY_MEDIAN_ASC",
  MemoryMedianDesc = "MEMORY_MEDIAN_DESC",
  MemoryMinAsc = "MEMORY_MIN_ASC",
  MemoryMinDesc = "MEMORY_MIN_DESC",
  MemoryStdAsc = "MEMORY_STD_ASC",
  MemoryStdDesc = "MEMORY_STD_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  StorageMaxAsc = "STORAGE_MAX_ASC",
  StorageMaxDesc = "STORAGE_MAX_DESC",
  StorageMeanAsc = "STORAGE_MEAN_ASC",
  StorageMeanDesc = "STORAGE_MEAN_DESC",
  StorageMedianAsc = "STORAGE_MEDIAN_ASC",
  StorageMedianDesc = "STORAGE_MEDIAN_DESC",
  StorageMinAsc = "STORAGE_MIN_ASC",
  StorageMinDesc = "STORAGE_MIN_DESC",
  StorageStdAsc = "STORAGE_STD_ASC",
  StorageStdDesc = "STORAGE_STD_DESC",
  TaskIdAsc = "TASK_ID_ASC",
  TaskIdDesc = "TASK_ID_DESC",
}

/** A connection to a list of `TaskResource` values. */
export type TaskResourcesConnection = {
  __typename: "TaskResourcesConnection";
  /** A list of edges which contains the `TaskResource` and cursor to aid in pagination. */
  edges: Array<TaskResourcesEdge>;
  /** A list of `TaskResource` objects. */
  nodes: Array<TaskResource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TaskResource` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `TaskResource` edge in the connection. */
export type TaskResourcesEdge = {
  __typename: "TaskResourcesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `TaskResource` at the end of the edge. */
  node: TaskResource;
};

/** Methods to use when ordering `TaskResource`. */
export enum TaskResourcesOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  TaskIdAsc = "TASK_ID_ASC",
  TaskIdDesc = "TASK_ID_DESC",
  TypeAsc = "TYPE_ASC",
  TypeDesc = "TYPE_DESC",
  ValueAsc = "VALUE_ASC",
  ValueDesc = "VALUE_DESC",
}

export type TaskSource = {
  __typename: "TaskSource";
  /** Reads a single `File` that is related to this `TaskSource`. */
  fileByFileId: Maybe<File>;
  fileId: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["Int"]["output"];
  /** Reads a single `Task` that is related to this `TaskSource`. */
  taskByTaskId: Maybe<Task>;
  taskId: Scalars["UUID"]["output"];
  /** Reads a single `ToolSource` that is related to this `TaskSource`. */
  toolSourceByToolSourceId: Maybe<ToolSource>;
  toolSourceId: Maybe<Scalars["Int"]["output"]>;
};

/**
 * A condition to be used against `TaskSource` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type TaskSourceCondition = {
  /** Checks for equality with the object’s `fileId` field. */
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `toolSourceId` field. */
  toolSourceId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The `file` to be created by this mutation. */
export type TaskSourceFileId2F628862FkFileIdFileCreateInput = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["UUID"]["input"];
  isSeries: Scalars["Boolean"]["input"];
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  originalName: Scalars["String"]["input"];
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus: Scalars["Int"]["input"];
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId: Scalars["UUID"]["input"];
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source: Scalars["String"]["input"];
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Input for the nested mutation of `file` in the `TaskSourceInput` mutation. */
export type TaskSourceFileId2F628862FkFileIdInput = {
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectById?: InputMaybe<FileFilePkeyConnect>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  connectByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueConnect>;
  /** A `FileInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskSourceFileId2F628862FkFileIdFileCreateInput>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteById?: InputMaybe<FileFilePkeyDelete>;
  /** The primary key(s) for `file` for the far side of the relationship. */
  deleteByProjectIdAndReferenceId?: InputMaybe<FileProjectReferenceIdUniqueDelete>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateById?: InputMaybe<FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingFilePkeyUpdate>;
  /** The primary key(s) and patch data for `file` for the far side of the relationship. */
  updateByProjectIdAndReferenceId?: InputMaybe<FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingProjectReferenceIdUniqueUpdate>;
};

/** Input for the nested mutation of `taskSource` in the `FileInput` mutation. */
export type TaskSourceFileId2F628862FkFileIdInverseInput = {
  /** The primary key(s) for `taskSource` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskSourceTaskSourcePkeyConnect>>;
  /** A `TaskSourceInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TaskSourceFileId2F628862FkFileIdTaskSourceCreateInput>
  >;
  /** The primary key(s) for `taskSource` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TaskSourceTaskSourcePkeyDelete>>;
  /** Flag indicating whether all other `taskSource` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `taskSource` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingTaskSourcePkeyUpdate>
  >;
};

/** The `taskSource` to be created by this mutation. */
export type TaskSourceFileId2F628862FkFileIdTaskSourceCreateInput = {
  fileToFileId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskToTaskId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInput>;
  toolSourceId?: InputMaybe<Scalars["Int"]["input"]>;
  toolSourceToToolSourceId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInput>;
};

/** A filter to be used against `TaskSource` object types. All fields are combined with a logical ‘and.’ */
export type TaskSourceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaskSourceFilter>>;
  /** Filter by the object’s `fileByFileId` relation. */
  fileByFileId?: InputMaybe<FileFilter>;
  /** A related `fileByFileId` exists. */
  fileByFileIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `fileId` field. */
  fileId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TaskSourceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaskSourceFilter>>;
  /** Filter by the object’s `taskByTaskId` relation. */
  taskByTaskId?: InputMaybe<TaskFilter>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `toolSourceByToolSourceId` relation. */
  toolSourceByToolSourceId?: InputMaybe<ToolSourceFilter>;
  /** A related `toolSourceByToolSourceId` exists. */
  toolSourceByToolSourceIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `toolSourceId` field. */
  toolSourceId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `TaskSource` */
export type TaskSourceInput = {
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileToFileId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskToTaskId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInput>;
  toolSourceId?: InputMaybe<Scalars["Int"]["input"]>;
  toolSourceToToolSourceId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInput>;
};

/** The fields on `taskSource` to look up the row to update. */
export type TaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingTaskSourcePkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `taskSource` being updated. */
    taskSourcePatch: UpdateTaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch;
  };

/** The fields on `taskSource` to look up the row to update. */
export type TaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskSourcePkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `taskSource` being updated. */
    taskSourcePatch: UpdateTaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch;
  };

/** The fields on `taskSource` to look up the row to update. */
export type TaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingTaskSourcePkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `taskSource` being updated. */
    taskSourcePatch: UpdateTaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch;
  };

/** Represents an update to a `TaskSource`. Fields that are set will be updated. */
export type TaskSourcePatch = {
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileToFileId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskToTaskId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInput>;
  toolSourceId?: InputMaybe<Scalars["Int"]["input"]>;
  toolSourceToToolSourceId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInput>;
};

/** Input for the nested mutation of `task` in the `TaskSourceInput` mutation. */
export type TaskSourceTaskIdF241BaedFkTaskIdInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdTaskCreateInput>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyDelete>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteById?: InputMaybe<TaskTaskPkeyDelete>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `taskSource` in the `TaskInput` mutation. */
export type TaskSourceTaskIdF241BaedFkTaskIdInverseInput = {
  /** The primary key(s) for `taskSource` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskSourceTaskSourcePkeyConnect>>;
  /** A `TaskSourceInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TaskSourceTaskIdF241BaedFkTaskIdTaskSourceCreateInput>
  >;
  /** The primary key(s) for `taskSource` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TaskSourceTaskSourcePkeyDelete>>;
  /** Flag indicating whether all other `taskSource` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `taskSource` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskSourcePkeyUpdate>
  >;
};

/** The `task` to be created by this mutation. */
export type TaskSourceTaskIdF241BaedFkTaskIdTaskCreateInput = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned: Scalars["Boolean"]["input"];
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id: Scalars["UUID"]["input"];
  inputsHash: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `taskSource` to be created by this mutation. */
export type TaskSourceTaskIdF241BaedFkTaskIdTaskSourceCreateInput = {
  fileId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileToFileId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  taskToTaskId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInput>;
  toolSourceId?: InputMaybe<Scalars["Int"]["input"]>;
  toolSourceToToolSourceId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInput>;
};

/** The fields on `taskSource` to look up the row to connect. */
export type TaskSourceTaskSourcePkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `taskSource` to look up the row to delete. */
export type TaskSourceTaskSourcePkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** Input for the nested mutation of `toolSource` in the `TaskSourceInput` mutation. */
export type TaskSourceToolSourceId14453EdbFkToolSourceIdInput = {
  /** The primary key(s) for `toolSource` for the far side of the relationship. */
  connectById?: InputMaybe<ToolSourceToolSourcePkeyConnect>;
  /** A `ToolSourceInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdToolSourceCreateInput>;
  /** The primary key(s) for `toolSource` for the far side of the relationship. */
  deleteById?: InputMaybe<ToolSourceToolSourcePkeyDelete>;
  /** The primary key(s) and patch data for `toolSource` for the far side of the relationship. */
  updateById?: InputMaybe<ToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingToolSourcePkeyUpdate>;
};

/** Input for the nested mutation of `taskSource` in the `ToolSourceInput` mutation. */
export type TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput = {
  /** The primary key(s) for `taskSource` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskSourceTaskSourcePkeyConnect>>;
  /** A `TaskSourceInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TaskSourceToolSourceId14453EdbFkToolSourceIdTaskSourceCreateInput>
  >;
  /** The primary key(s) for `taskSource` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TaskSourceTaskSourcePkeyDelete>>;
  /** Flag indicating whether all other `taskSource` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `taskSource` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingTaskSourcePkeyUpdate>
  >;
};

/** The `taskSource` to be created by this mutation. */
export type TaskSourceToolSourceId14453EdbFkToolSourceIdTaskSourceCreateInput =
  {
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileToFileId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInput>;
    toolSourceToToolSourceId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInput>;
  };

/** The `toolSource` to be created by this mutation. */
export type TaskSourceToolSourceId14453EdbFkToolSourceIdToolSourceCreateInput =
  {
    fileFormats?: InputMaybe<Scalars["JSON"]["input"]>;
    helpText: Scalars["String"]["input"];
    id?: InputMaybe<Scalars["Int"]["input"]>;
    key: Scalars["String"]["input"];
    multiple: Scalars["Boolean"]["input"];
    name: Scalars["String"]["input"];
    required: Scalars["Boolean"]["input"];
    taskSourcesUsingId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput>;
  };

/** A connection to a list of `TaskSource` values. */
export type TaskSourcesConnection = {
  __typename: "TaskSourcesConnection";
  /** A list of edges which contains the `TaskSource` and cursor to aid in pagination. */
  edges: Array<TaskSourcesEdge>;
  /** A list of `TaskSource` objects. */
  nodes: Array<TaskSource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TaskSource` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `TaskSource` edge in the connection. */
export type TaskSourcesEdge = {
  __typename: "TaskSourcesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `TaskSource` at the end of the edge. */
  node: TaskSource;
};

/** Methods to use when ordering `TaskSource`. */
export enum TaskSourcesOrderBy {
  FileIdAsc = "FILE_ID_ASC",
  FileIdDesc = "FILE_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  TaskIdAsc = "TASK_ID_ASC",
  TaskIdDesc = "TASK_ID_DESC",
  ToolSourceIdAsc = "TOOL_SOURCE_ID_ASC",
  ToolSourceIdDesc = "TOOL_SOURCE_ID_DESC",
}

export type TaskStatusLog = {
  __typename: "TaskStatusLog";
  created: Maybe<Scalars["Datetime"]["output"]>;
  dateCreated: Scalars["Datetime"]["output"];
  id: Scalars["Int"]["output"];
  status: Scalars["Int"]["output"];
  /** Reads a single `Task` that is related to this `TaskStatusLog`. */
  taskByTaskId: Maybe<Task>;
  taskId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `TaskStatusLog` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TaskStatusLogCondition = {
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `taskId` field. */
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `TaskStatusLog` object types. All fields are combined with a logical ‘and.’ */
export type TaskStatusLogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TaskStatusLogFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TaskStatusLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TaskStatusLogFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `taskByTaskId` relation. */
  taskByTaskId?: InputMaybe<TaskFilter>;
  /** Filter by the object’s `taskId` field. */
  taskId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `TaskStatusLog` */
export type TaskStatusLogInput = {
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskToTaskId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInput>;
};

/** The fields on `taskStatusLog` to look up the row to update. */
export type TaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskStatusLogPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `taskStatusLog` being updated. */
    taskStatusLogPatch: UpdateTaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdPatch;
  };

/** The fields on `taskStatusLog` to look up the row to update. */
export type TaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskStatusLogUniqueStatusPerTaskUpdate =
  {
    status: Scalars["Int"]["input"];
    taskId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `taskStatusLog` being updated. */
    taskStatusLogPatch: UpdateTaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdPatch;
  };

/** Represents an update to a `TaskStatusLog`. Fields that are set will be updated. */
export type TaskStatusLogPatch = {
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskToTaskId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInput>;
};

/** Input for the nested mutation of `task` in the `TaskStatusLogInput` mutation. */
export type TaskStatusLogTaskIdFe1B9D0BFkTaskIdInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyConnect>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<TaskTaskPkeyConnect>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdTaskCreateInput>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<TaskTaskExecutorIdKeyDelete>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteById?: InputMaybe<TaskTaskPkeyDelete>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<TaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<TaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskPkeyUpdate>;
};

/** Input for the nested mutation of `taskStatusLog` in the `TaskInput` mutation. */
export type TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput = {
  /** The primary key(s) for `taskStatusLog` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskStatusLogTaskStatusLogPkeyConnect>>;
  /** The primary key(s) for `taskStatusLog` for the far side of the relationship. */
  connectByTaskIdAndStatus?: InputMaybe<
    Array<TaskStatusLogTaskStatusLogUniqueStatusPerTaskConnect>
  >;
  /** A `TaskStatusLogInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TaskStatusLogTaskIdFe1B9D0BFkTaskIdTaskStatusLogCreateInput>
  >;
  /** The primary key(s) for `taskStatusLog` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TaskStatusLogTaskStatusLogPkeyDelete>>;
  /** The primary key(s) for `taskStatusLog` for the far side of the relationship. */
  deleteByTaskIdAndStatus?: InputMaybe<
    Array<TaskStatusLogTaskStatusLogUniqueStatusPerTaskDelete>
  >;
  /** Flag indicating whether all other `taskStatusLog` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `taskStatusLog` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskStatusLogPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `taskStatusLog` for the far side of the relationship. */
  updateByTaskIdAndStatus?: InputMaybe<
    Array<TaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskStatusLogUniqueStatusPerTaskUpdate>
  >;
};

/** The `task` to be created by this mutation. */
export type TaskStatusLogTaskIdFe1B9D0BFkTaskIdTaskCreateInput = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned: Scalars["Boolean"]["input"];
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id: Scalars["UUID"]["input"];
  inputsHash: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `taskStatusLog` to be created by this mutation. */
export type TaskStatusLogTaskIdFe1B9D0BFkTaskIdTaskStatusLogCreateInput = {
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskToTaskId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInput>;
};

/** The fields on `taskStatusLog` to look up the row to connect. */
export type TaskStatusLogTaskStatusLogPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `taskStatusLog` to look up the row to delete. */
export type TaskStatusLogTaskStatusLogPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** The fields on `taskStatusLog` to look up the row to connect. */
export type TaskStatusLogTaskStatusLogUniqueStatusPerTaskConnect = {
  status: Scalars["Int"]["input"];
  taskId: Scalars["UUID"]["input"];
};

/** The fields on `taskStatusLog` to look up the row to delete. */
export type TaskStatusLogTaskStatusLogUniqueStatusPerTaskDelete = {
  status: Scalars["Int"]["input"];
  taskId: Scalars["UUID"]["input"];
};

/** A connection to a list of `TaskStatusLog` values. */
export type TaskStatusLogsConnection = {
  __typename: "TaskStatusLogsConnection";
  /** A list of edges which contains the `TaskStatusLog` and cursor to aid in pagination. */
  edges: Array<TaskStatusLogsEdge>;
  /** A list of `TaskStatusLog` objects. */
  nodes: Array<TaskStatusLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TaskStatusLog` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `TaskStatusLog` edge in the connection. */
export type TaskStatusLogsEdge = {
  __typename: "TaskStatusLogsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `TaskStatusLog` at the end of the edge. */
  node: TaskStatusLog;
};

/** Methods to use when ordering `TaskStatusLog`. */
export enum TaskStatusLogsOrderBy {
  CreatedAsc = "CREATED_ASC",
  CreatedDesc = "CREATED_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  StatusAsc = "STATUS_ASC",
  StatusDesc = "STATUS_DESC",
  TaskIdAsc = "TASK_ID_ASC",
  TaskIdDesc = "TASK_ID_DESC",
}

/** The fields on `task` to look up the row to connect. */
export type TaskTaskExecutorIdKeyConnect = {
  executorId: Scalars["UUID"]["input"];
};

/** The fields on `task` to look up the row to delete. */
export type TaskTaskExecutorIdKeyDelete = {
  executorId: Scalars["UUID"]["input"];
};

/** The fields on `task` to look up the row to connect. */
export type TaskTaskPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `task` to look up the row to delete. */
export type TaskTaskPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** Input for the nested mutation of `tenant` in the `TaskInput` mutation. */
export type TaskTenantId148E90DaFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskTenantId148E90DaFkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `task` in the `TenantInput` mutation. */
export type TaskTenantId148E90DaFkTenantIdInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<Array<TaskTaskExecutorIdKeyConnect>>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTaskPkeyConnect>>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<TaskTenantId148E90DaFkTenantIdTaskCreateInput>>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<Array<TaskTaskExecutorIdKeyDelete>>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TaskTaskPkeyDelete>>;
  /** Flag indicating whether all other `task` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<
    Array<TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskExecutorIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskPkeyUpdate>
  >;
};

/** The `task` to be created by this mutation. */
export type TaskTenantId148E90DaFkTenantIdTaskCreateInput = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned: Scalars["Boolean"]["input"];
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id: Scalars["UUID"]["input"];
  inputsHash: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `tenant` to be created by this mutation. */
export type TaskTenantId148E90DaFkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** A filter to be used against many `File` object types. All fields are combined with a logical ‘and.’ */
export type TaskToManyFileFilter = {
  /** Every related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileFilter>;
  /** No related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileFilter>;
  /** Some related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileFilter>;
};

/** A filter to be used against many `MetadataValue` object types. All fields are combined with a logical ‘and.’ */
export type TaskToManyMetadataValueFilter = {
  /** Every related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MetadataValueFilter>;
  /** No related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MetadataValueFilter>;
  /** Some related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MetadataValueFilter>;
};

/** A filter to be used against many `TaskResource` object types. All fields are combined with a logical ‘and.’ */
export type TaskToManyTaskResourceFilter = {
  /** Every related `TaskResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskResourceFilter>;
  /** No related `TaskResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskResourceFilter>;
  /** Some related `TaskResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskResourceFilter>;
};

/** A filter to be used against many `TaskSource` object types. All fields are combined with a logical ‘and.’ */
export type TaskToManyTaskSourceFilter = {
  /** Every related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskSourceFilter>;
  /** No related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskSourceFilter>;
  /** Some related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskSourceFilter>;
};

/** A filter to be used against many `TaskStatusLog` object types. All fields are combined with a logical ‘and.’ */
export type TaskToManyTaskStatusLogFilter = {
  /** Every related `TaskStatusLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskStatusLogFilter>;
  /** No related `TaskStatusLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskStatusLogFilter>;
  /** Some related `TaskStatusLog` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskStatusLogFilter>;
};

/** Input for the nested mutation of `toolVersion` in the `TaskInput` mutation. */
export type TaskToolVersionId14506837FkToolVersionIdInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<ToolVersionToolVersionPkeyConnect>;
  /** A `ToolVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdToolVersionCreateInput>;
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<ToolVersionToolVersionPkeyDelete>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<ToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingToolVersionPkeyUpdate>;
};

/** Input for the nested mutation of `task` in the `ToolVersionInput` mutation. */
export type TaskToolVersionId14506837FkToolVersionIdInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<Array<TaskTaskExecutorIdKeyConnect>>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTaskPkeyConnect>>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TaskToolVersionId14506837FkToolVersionIdTaskCreateInput>
  >;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<Array<TaskTaskExecutorIdKeyDelete>>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TaskTaskPkeyDelete>>;
  /** Flag indicating whether all other `task` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<
    Array<TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskExecutorIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskPkeyUpdate>
  >;
};

/** The `task` to be created by this mutation. */
export type TaskToolVersionId14506837FkToolVersionIdTaskCreateInput = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned: Scalars["Boolean"]["input"];
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id: Scalars["UUID"]["input"];
  inputsHash: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `toolVersion` to be created by this mutation. */
export type TaskToolVersionId14506837FkToolVersionIdToolVersionCreateInput = {
  applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
  changelog?: InputMaybe<Scalars["String"]["input"]>;
  command?: InputMaybe<Scalars["String"]["input"]>;
  commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  isToolSpecForwardsCompatible: Scalars["Boolean"]["input"];
  isUpgradableToNextVersion: Scalars["Boolean"]["input"];
  maturity: Scalars["Int"]["input"];
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
  toolId?: InputMaybe<Scalars["Int"]["input"]>;
  toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
  toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
  toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
  toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
  toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
  toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
  toolSpecVersion: Scalars["Int"]["input"];
  toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  version: Scalars["String"]["input"];
  visibility: Scalars["Int"]["input"];
  workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
};

/** The `applicationUser` to be created by this mutation. */
export type TaskUserId270D0Bb2FkApplicationUserIdApplicationUserCreateInput = {
  applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
  auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
  commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
  dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
  dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
  email: Scalars["String"]["input"];
  emailMarketingConsent: Scalars["Boolean"]["input"];
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  executorId?: InputMaybe<Scalars["Int"]["input"]>;
  featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName: Scalars["String"]["input"];
  gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
  gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  homeRegion?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  internal: Scalars["Boolean"]["input"];
  isActive: Scalars["Boolean"]["input"];
  isStaff: Scalars["Boolean"]["input"];
  isSuperuser: Scalars["Boolean"]["input"];
  lastName: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars["String"]["input"]>;
  pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
  userOrigin: Scalars["String"]["input"];
  userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
  username: Scalars["String"]["input"];
  workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
};

/** Input for the nested mutation of `applicationUser` in the `TaskInput` mutation. */
export type TaskUserId270D0Bb2FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `task` in the `ApplicationUserInput` mutation. */
export type TaskUserId270D0Bb2FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<Array<TaskTaskExecutorIdKeyConnect>>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TaskTaskPkeyConnect>>;
  /** A `TaskInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TaskUserId270D0Bb2FkApplicationUserIdTaskCreateInput>
  >;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<Array<TaskTaskExecutorIdKeyDelete>>;
  /** The primary key(s) for `task` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TaskTaskPkeyDelete>>;
  /** Flag indicating whether all other `task` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<
    Array<TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskExecutorIdKeyUpdate>
  >;
  /** The primary key(s) and patch data for `task` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskPkeyUpdate>
  >;
};

/** The `task` to be created by this mutation. */
export type TaskUserId270D0Bb2FkApplicationUserIdTaskCreateInput = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned: Scalars["Boolean"]["input"];
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id: Scalars["UUID"]["input"];
  inputsHash: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
};

/** A connection to a list of `Task` values. */
export type TasksConnection = {
  __typename: "TasksConnection";
  /** A list of edges which contains the `Task` and cursor to aid in pagination. */
  edges: Array<TasksEdge>;
  /** A list of `Task` objects. */
  nodes: Array<Task>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Task` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `Task` edge in the connection. */
export type TasksEdge = {
  __typename: "TasksEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `Task` at the end of the edge. */
  node: Task;
};

/** Methods to use when ordering `Task`. */
export enum TasksOrderBy {
  ClonedAsc = "CLONED_ASC",
  ClonedDesc = "CLONED_DESC",
  ContainerImageIdAsc = "CONTAINER_IMAGE_ID_ASC",
  ContainerImageIdDesc = "CONTAINER_IMAGE_ID_DESC",
  CreatedAsc = "CREATED_ASC",
  CreatedDesc = "CREATED_DESC",
  CreditsAsc = "CREDITS_ASC",
  CreditsDesc = "CREDITS_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  ErrorDescriptionAsc = "ERROR_DESCRIPTION_ASC",
  ErrorDescriptionDesc = "ERROR_DESCRIPTION_DESC",
  ExecutorIdAsc = "EXECUTOR_ID_ASC",
  ExecutorIdDesc = "EXECUTOR_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  InputsHashAsc = "INPUTS_HASH_ASC",
  InputsHashDesc = "INPUTS_HASH_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  ResourceTierAsc = "RESOURCE_TIER_ASC",
  ResourceTierDesc = "RESOURCE_TIER_DESC",
  StatusAsc = "STATUS_ASC",
  StatusDesc = "STATUS_DESC",
  TaskParametersAsc = "TASK_PARAMETERS_ASC",
  TaskParametersDesc = "TASK_PARAMETERS_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  ToolExitcodeAsc = "TOOL_EXITCODE_ASC",
  ToolExitcodeDesc = "TOOL_EXITCODE_DESC",
  ToolExitcodeDescriptionAsc = "TOOL_EXITCODE_DESCRIPTION_ASC",
  ToolExitcodeDescriptionDesc = "TOOL_EXITCODE_DESCRIPTION_DESC",
  ToolVersionIdAsc = "TOOL_VERSION_ID_ASC",
  ToolVersionIdDesc = "TOOL_VERSION_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

export type Tenant = {
  __typename: "Tenant";
  activeStorageSize: Maybe<Scalars["BigInt"]["output"]>;
  /** Reads and enables pagination through a set of `ApplicationUserMembership`. */
  applicationUserMembershipsByTenantId: ApplicationUserMembershipsConnection;
  /** Reads and enables pagination through a set of `ApplicationUserSession`. */
  applicationUserSessionsByTenantId: ApplicationUserSessionsConnection;
  archivedStorageSize: Maybe<Scalars["BigInt"]["output"]>;
  /** Reads and enables pagination through a set of `CodeFile`. */
  codeFilesByTenantId: CodeFilesConnection;
  /** Reads and enables pagination through a set of `Command`. */
  commandsByTenantId: CommandsConnection;
  /** Reads and enables pagination through a set of `ContainerImageRepository`. */
  containerImageRepositoriesByTenantId: ContainerImageRepositoriesConnection;
  /** Reads and enables pagination through a set of `ContainerImage`. */
  containerImagesByTenantId: ContainerImagesConnection;
  /** Reads and enables pagination through a set of `Cost`. */
  costsByTenantId: CostsConnection;
  created: Maybe<Scalars["Datetime"]["output"]>;
  dateCreated: Scalars["Datetime"]["output"];
  /** Reads and enables pagination through a set of `FeatureFlagsTenant`. */
  featureFlagsTenantsByTenantId: FeatureFlagsTenantsConnection;
  /** Reads and enables pagination through a set of `FileActivity`. */
  fileActivitiesByTenantId: FileActivitiesConnection;
  /** Reads and enables pagination through a set of `FileMetadatum`. */
  fileMetadataByTenantId: FileMetadataConnection;
  /** Reads and enables pagination through a set of `FileOutputGroupMetadatum`. */
  fileOutputGroupMetadataByTenantId: FileOutputGroupMetadataConnection;
  /** Reads and enables pagination through a set of `FileOutputGroup`. */
  fileOutputGroupsByTenantId: FileOutputGroupsConnection;
  /** Reads and enables pagination through a set of `File`. */
  filesByTenantId: FilesConnection;
  id: Scalars["Int"]["output"];
  internal: Scalars["Boolean"]["output"];
  key: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `Metadatum`. */
  metadataByTenantId: MetadataConnection;
  /** Reads and enables pagination through a set of `MetadataValue`. */
  metadataValuesByTenantId: MetadataValuesConnection;
  name: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `Project`. */
  projectsByTenantId: ProjectsConnection;
  repositoryName: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `RoleChangeNotification`. */
  roleChangeNotificationsByTenantId: RoleChangeNotificationsConnection;
  /** Reads and enables pagination through a set of `Run`. */
  runsByTenantId: RunsConnection;
  sfid: Maybe<Scalars["String"]["output"]>;
  status: Scalars["Int"]["output"];
  /** Reads and enables pagination through a set of `Task`. */
  tasksByTenantId: TasksConnection;
  /** Reads and enables pagination through a set of `TenantContract`. */
  tenantContractsByTenantId: TenantContractsConnection;
  /** Reads and enables pagination through a set of `TenantMonthlyConsumedResource`. */
  tenantMonthlyConsumedResourcesByTenantId: TenantMonthlyConsumedResourcesConnection;
  tenantType: Scalars["Int"]["output"];
  /** Reads and enables pagination through a set of `TenantUserMembershipNotification`. */
  tenantUserMembershipNotificationsByTenantId: TenantUserMembershipNotificationsConnection;
  /** Reads and enables pagination through a set of `ToolTenant`. */
  toolTenantsByTenantId: ToolTenantsConnection;
  /** Reads and enables pagination through a set of `ToolVersion`. */
  toolVersionsByTenantId: ToolVersionsConnection;
  /** Reads and enables pagination through a set of `ToolboxTenant`. */
  toolboxTenantsByTenantId: ToolboxTenantsConnection;
  /** Reads and enables pagination through a set of `Tool`. */
  toolsByTenantId: ToolsConnection;
  /** Reads and enables pagination through a set of `Workflow`. */
  workflowsByTenantId: WorkflowsConnection;
};

export type TenantApplicationUserMembershipsByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserMembershipCondition>;
  filter?: InputMaybe<ApplicationUserMembershipFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserMembershipsOrderBy>>;
};

export type TenantApplicationUserSessionsByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ApplicationUserSessionCondition>;
  filter?: InputMaybe<ApplicationUserSessionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ApplicationUserSessionsOrderBy>>;
};

export type TenantCodeFilesByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CodeFileCondition>;
  filter?: InputMaybe<CodeFileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CodeFilesOrderBy>>;
};

export type TenantCommandsByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CommandCondition>;
  filter?: InputMaybe<CommandFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CommandsOrderBy>>;
};

export type TenantContainerImageRepositoriesByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ContainerImageRepositoryCondition>;
  filter?: InputMaybe<ContainerImageRepositoryFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContainerImageRepositoriesOrderBy>>;
};

export type TenantContainerImagesByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ContainerImageCondition>;
  filter?: InputMaybe<ContainerImageFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContainerImagesOrderBy>>;
};

export type TenantCostsByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CostCondition>;
  filter?: InputMaybe<CostFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CostsOrderBy>>;
};

export type TenantFeatureFlagsTenantsByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FeatureFlagsTenantCondition>;
  filter?: InputMaybe<FeatureFlagsTenantFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FeatureFlagsTenantsOrderBy>>;
};

export type TenantFileActivitiesByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileActivityCondition>;
  filter?: InputMaybe<FileActivityFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileActivitiesOrderBy>>;
};

export type TenantFileMetadataByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileMetadatumCondition>;
  filter?: InputMaybe<FileMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileMetadataOrderBy>>;
};

export type TenantFileOutputGroupMetadataByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileOutputGroupMetadatumCondition>;
  filter?: InputMaybe<FileOutputGroupMetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileOutputGroupMetadataOrderBy>>;
};

export type TenantFileOutputGroupsByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileOutputGroupCondition>;
  filter?: InputMaybe<FileOutputGroupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FileOutputGroupsOrderBy>>;
};

export type TenantFilesByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<FileCondition>;
  filter?: InputMaybe<FileFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};

export type TenantMetadataByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<MetadatumCondition>;
  filter?: InputMaybe<MetadatumFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<MetadataOrderBy>>;
};

export type TenantMetadataValuesByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<MetadataValueCondition>;
  filter?: InputMaybe<MetadataValueFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<MetadataValuesOrderBy>>;
};

export type TenantProjectsByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ProjectsOrderBy>>;
};

export type TenantRoleChangeNotificationsByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<RoleChangeNotificationCondition>;
  filter?: InputMaybe<RoleChangeNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<RoleChangeNotificationsOrderBy>>;
};

export type TenantRunsByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<RunCondition>;
  filter?: InputMaybe<RunFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<RunsOrderBy>>;
};

export type TenantTasksByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

export type TenantTenantContractsByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantContractCondition>;
  filter?: InputMaybe<TenantContractFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantContractsOrderBy>>;
};

export type TenantTenantMonthlyConsumedResourcesByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantMonthlyConsumedResourceCondition>;
  filter?: InputMaybe<TenantMonthlyConsumedResourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantMonthlyConsumedResourcesOrderBy>>;
};

export type TenantTenantUserMembershipNotificationsByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantUserMembershipNotificationCondition>;
  filter?: InputMaybe<TenantUserMembershipNotificationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantUserMembershipNotificationsOrderBy>>;
};

export type TenantToolTenantsByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolTenantCondition>;
  filter?: InputMaybe<ToolTenantFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolTenantsOrderBy>>;
};

export type TenantToolVersionsByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolVersionCondition>;
  filter?: InputMaybe<ToolVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolVersionsOrderBy>>;
};

export type TenantToolboxTenantsByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolboxTenantCondition>;
  filter?: InputMaybe<ToolboxTenantFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolboxTenantsOrderBy>>;
};

export type TenantToolsByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolCondition>;
  filter?: InputMaybe<ToolFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolsOrderBy>>;
};

export type TenantWorkflowsByTenantIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowCondition>;
  filter?: InputMaybe<WorkflowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowsOrderBy>>;
};

export type TenantContract = {
  __typename: "TenantContract";
  contractType: Scalars["Int"]["output"];
  created: Maybe<Scalars["Datetime"]["output"]>;
  dateCreated: Scalars["Datetime"]["output"];
  endDate: Maybe<Scalars["Datetime"]["output"]>;
  id: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  sfid: Maybe<Scalars["String"]["output"]>;
  startDate: Scalars["Datetime"]["output"];
  /** Reads a single `Tenant` that is related to this `TenantContract`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads and enables pagination through a set of `TenantContractTransaction`. */
  tenantContractTransactionsByTenantContractId: TenantContractTransactionsConnection;
  tenantId: Scalars["Int"]["output"];
  /** Reads and enables pagination through a set of `TenantMonthlyConsumedResource`. */
  tenantMonthlyConsumedResourcesByTenantContractId: TenantMonthlyConsumedResourcesConnection;
};

export type TenantContractTenantContractTransactionsByTenantContractIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantContractTransactionCondition>;
  filter?: InputMaybe<TenantContractTransactionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantContractTransactionsOrderBy>>;
};

export type TenantContractTenantMonthlyConsumedResourcesByTenantContractIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<TenantMonthlyConsumedResourceCondition>;
    filter?: InputMaybe<TenantMonthlyConsumedResourceFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<TenantMonthlyConsumedResourcesOrderBy>>;
  };

/** Input for the nested mutation of `tenantContractTransaction` in the `TenantContractAllowanceInput` mutation. */
export type TenantContractAlloTenantContractTran29C19B1CFkTenantCoInput = {
  /** The primary key(s) for `tenantContractTransaction` for the far side of the relationship. */
  connectById?: InputMaybe<TenantContractTransactionTenantContractTransactionPkeyConnect>;
  /** A `TenantContractTransactionInput` object that will be created and connected to this object. */
  create?: InputMaybe<TenantContractAlloTenantContractTran29C19B1CFkTenantCoTenantContractTransactionCreateInput>;
  /** The primary key(s) for `tenantContractTransaction` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantContractTransactionTenantContractTransactionPkeyDelete>;
  /** The primary key(s) and patch data for `tenantContractTransaction` for the far side of the relationship. */
  updateById?: InputMaybe<TenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionPkeyUpdate>;
};

/** Input for the nested mutation of `tenantContractAllowance` in the `TenantContractTransactionInput` mutation. */
export type TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput =
  {
    /** The primary key(s) for `tenantContractAllowance` for the far side of the relationship. */
    connectById?: InputMaybe<
      Array<TenantContractAllowanceTenantContractAllowancePkeyConnect>
    >;
    /** The primary key(s) for `tenantContractAllowance` for the far side of the relationship. */
    connectByTenantContractTransactionIdAndQuotaType?: InputMaybe<
      Array<TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueConnect>
    >;
    /** A `TenantContractAllowanceInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<TenantContractAlloTenantContractTran29C19B1CFkTenantCoTenantContractAllowanceCreateInput>
    >;
    /** The primary key(s) for `tenantContractAllowance` for the far side of the relationship. */
    deleteById?: InputMaybe<
      Array<TenantContractAllowanceTenantContractAllowancePkeyDelete>
    >;
    /** The primary key(s) for `tenantContractAllowance` for the far side of the relationship. */
    deleteByTenantContractTransactionIdAndQuotaType?: InputMaybe<
      Array<TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueDelete>
    >;
    /** Flag indicating whether all other `tenantContractAllowance` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The primary key(s) and patch data for `tenantContractAllowance` for the far side of the relationship. */
    updateById?: InputMaybe<
      Array<TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractAllowancePkeyUpdate>
    >;
    /** The primary key(s) and patch data for `tenantContractAllowance` for the far side of the relationship. */
    updateByTenantContractTransactionIdAndQuotaType?: InputMaybe<
      Array<TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionQuotaTypeUniqueUpdate>
    >;
  };

/** The `tenantContractAllowance` to be created by this mutation. */
export type TenantContractAlloTenantContractTran29C19B1CFkTenantCoTenantContractAllowanceCreateInput =
  {
    id?: InputMaybe<Scalars["Int"]["input"]>;
    quotaType: Scalars["Int"]["input"];
    tenantContractTransactionToTenantContractTransactionId?: InputMaybe<TenantContractAlloTenantContractTran29C19B1CFkTenantCoInput>;
    value: Scalars["String"]["input"];
  };

/** The `tenantContractTransaction` to be created by this mutation. */
export type TenantContractAlloTenantContractTran29C19B1CFkTenantCoTenantContractTransactionCreateInput =
  {
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    currency: Scalars["Int"]["input"];
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    price: Scalars["BigFloat"]["input"];
    tenantContractAllowancesUsingId?: InputMaybe<TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput>;
    tenantContractId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantContractToTenantContractId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInput>;
  };

export type TenantContractAllowance = {
  __typename: "TenantContractAllowance";
  id: Scalars["Int"]["output"];
  quotaType: Scalars["Int"]["output"];
  /** Reads a single `TenantContractTransaction` that is related to this `TenantContractAllowance`. */
  tenantContractTransactionByTenantContractTransactionId: Maybe<TenantContractTransaction>;
  tenantContractTransactionId: Scalars["Int"]["output"];
  value: Scalars["String"]["output"];
};

/**
 * A condition to be used against `TenantContractAllowance` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type TenantContractAllowanceCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `quotaType` field. */
  quotaType?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `tenantContractTransactionId` field. */
  tenantContractTransactionId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars["String"]["input"]>;
};

/** A filter to be used against `TenantContractAllowance` object types. All fields are combined with a logical ‘and.’ */
export type TenantContractAllowanceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TenantContractAllowanceFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TenantContractAllowanceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TenantContractAllowanceFilter>>;
  /** Filter by the object’s `quotaType` field. */
  quotaType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantContractTransactionByTenantContractTransactionId` relation. */
  tenantContractTransactionByTenantContractTransactionId?: InputMaybe<TenantContractTransactionFilter>;
  /** Filter by the object’s `tenantContractTransactionId` field. */
  tenantContractTransactionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `TenantContractAllowance` */
export type TenantContractAllowanceInput = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  quotaType: Scalars["Int"]["input"];
  tenantContractTransactionId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantContractTransactionToTenantContractTransactionId?: InputMaybe<TenantContractAlloTenantContractTran29C19B1CFkTenantCoInput>;
  value: Scalars["String"]["input"];
};

/** The fields on `tenantContractAllowance` to look up the row to update. */
export type TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractAllowancePkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenantContractAllowance` being updated. */
    tenantContractAllowancePatch: UpdateTenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch;
  };

/** The fields on `tenantContractAllowance` to look up the row to update. */
export type TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionQuotaTypeUniqueUpdate =
  {
    quotaType: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenantContractAllowance` being updated. */
    tenantContractAllowancePatch: UpdateTenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch;
    tenantContractTransactionId: Scalars["Int"]["input"];
  };

/** Represents an update to a `TenantContractAllowance`. Fields that are set will be updated. */
export type TenantContractAllowancePatch = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  quotaType?: InputMaybe<Scalars["Int"]["input"]>;
  tenantContractTransactionId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantContractTransactionToTenantContractTransactionId?: InputMaybe<TenantContractAlloTenantContractTran29C19B1CFkTenantCoInput>;
  value?: InputMaybe<Scalars["String"]["input"]>;
};

/** The fields on `tenantContractAllowance` to look up the row to connect. */
export type TenantContractAllowanceTenantContractAllowancePkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `tenantContractAllowance` to look up the row to delete. */
export type TenantContractAllowanceTenantContractAllowancePkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** The fields on `tenantContractAllowance` to look up the row to connect. */
export type TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueConnect =
  {
    quotaType: Scalars["Int"]["input"];
    tenantContractTransactionId: Scalars["Int"]["input"];
  };

/** The fields on `tenantContractAllowance` to look up the row to delete. */
export type TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueDelete =
  {
    quotaType: Scalars["Int"]["input"];
    tenantContractTransactionId: Scalars["Int"]["input"];
  };

/** A connection to a list of `TenantContractAllowance` values. */
export type TenantContractAllowancesConnection = {
  __typename: "TenantContractAllowancesConnection";
  /** A list of edges which contains the `TenantContractAllowance` and cursor to aid in pagination. */
  edges: Array<TenantContractAllowancesEdge>;
  /** A list of `TenantContractAllowance` objects. */
  nodes: Array<TenantContractAllowance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TenantContractAllowance` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `TenantContractAllowance` edge in the connection. */
export type TenantContractAllowancesEdge = {
  __typename: "TenantContractAllowancesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `TenantContractAllowance` at the end of the edge. */
  node: TenantContractAllowance;
};

/** Methods to use when ordering `TenantContractAllowance`. */
export enum TenantContractAllowancesOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  QuotaTypeAsc = "QUOTA_TYPE_ASC",
  QuotaTypeDesc = "QUOTA_TYPE_DESC",
  TenantContractTransactionIdAsc = "TENANT_CONTRACT_TRANSACTION_ID_ASC",
  TenantContractTransactionIdDesc = "TENANT_CONTRACT_TRANSACTION_ID_DESC",
  ValueAsc = "VALUE_ASC",
  ValueDesc = "VALUE_DESC",
}

/**
 * A condition to be used against `TenantContract` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TenantContractCondition = {
  /** Checks for equality with the object’s `contractType` field. */
  contractType?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `sfid` field. */
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `TenantContract` object types. All fields are combined with a logical ‘and.’ */
export type TenantContractFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TenantContractFilter>>;
  /** Filter by the object’s `contractType` field. */
  contractType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TenantContractFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TenantContractFilter>>;
  /** Filter by the object’s `sfid` field. */
  sfid?: InputMaybe<StringFilter>;
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantContractTransactionsByTenantContractId` relation. */
  tenantContractTransactionsByTenantContractId?: InputMaybe<TenantContractToManyTenantContractTransactionFilter>;
  /** Some related `tenantContractTransactionsByTenantContractId` exist. */
  tenantContractTransactionsByTenantContractIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantMonthlyConsumedResourcesByTenantContractId` relation. */
  tenantMonthlyConsumedResourcesByTenantContractId?: InputMaybe<TenantContractToManyTenantMonthlyConsumedResourceFilter>;
  /** Some related `tenantMonthlyConsumedResourcesByTenantContractId` exist. */
  tenantMonthlyConsumedResourcesByTenantContractIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

/** An input for mutations affecting `TenantContract` */
export type TenantContractInput = {
  contractType: Scalars["Int"]["input"];
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  endDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  tenantContractTransactionsUsingId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantContractId681267CeFkTenantCoInverseInput>;
  tenantToTenantId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInput>;
};

/** The fields on `tenantContract` to look up the row to update. */
export type TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractNameKeyUpdate =
  {
    name: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenantContract` being updated. */
    tenantContractPatch: UpdateTenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
  };

/** The fields on `tenantContract` to look up the row to update. */
export type TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenantContract` being updated. */
    tenantContractPatch: UpdateTenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
  };

/** The fields on `tenantContract` to look up the row to update. */
export type TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenantContract` being updated. */
    tenantContractPatch: UpdateTenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
  };

/** The fields on `tenantContract` to look up the row to update. */
export type TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractNameKeyUpdate =
  {
    name: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenantContract` being updated. */
    tenantContractPatch: UpdateTenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch;
  };

/** The fields on `tenantContract` to look up the row to update. */
export type TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenantContract` being updated. */
    tenantContractPatch: UpdateTenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch;
  };

/** The fields on `tenantContract` to look up the row to update. */
export type TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenantContract` being updated. */
    tenantContractPatch: UpdateTenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch;
  };

/** The fields on `tenantContract` to look up the row to update. */
export type TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractNameKeyUpdate =
  {
    name: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenantContract` being updated. */
    tenantContractPatch: UpdateTenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoPatch;
  };

/** The fields on `tenantContract` to look up the row to update. */
export type TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenantContract` being updated. */
    tenantContractPatch: UpdateTenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoPatch;
  };

/** The fields on `tenantContract` to look up the row to update. */
export type TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenantContract` being updated. */
    tenantContractPatch: UpdateTenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoPatch;
  };

/** Represents an update to a `TenantContract`. Fields that are set will be updated. */
export type TenantContractPatch = {
  contractType?: InputMaybe<Scalars["Int"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  endDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  startDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  tenantContractTransactionsUsingId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantContractId681267CeFkTenantCoInverseInput>;
  tenantToTenantId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInput>;
};

/** The fields on `tenantContract` to look up the row to connect. */
export type TenantContractTenantContractNameKeyConnect = {
  name: Scalars["String"]["input"];
};

/** The fields on `tenantContract` to look up the row to delete. */
export type TenantContractTenantContractNameKeyDelete = {
  name: Scalars["String"]["input"];
};

/** The fields on `tenantContract` to look up the row to connect. */
export type TenantContractTenantContractPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `tenantContract` to look up the row to delete. */
export type TenantContractTenantContractPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** The fields on `tenantContract` to look up the row to connect. */
export type TenantContractTenantContractSfidKeyConnect = {
  sfid: Scalars["String"]["input"];
};

/** The fields on `tenantContract` to look up the row to delete. */
export type TenantContractTenantContractSfidKeyDelete = {
  sfid: Scalars["String"]["input"];
};

/** Input for the nested mutation of `tenant` in the `TenantContractInput` mutation. */
export type TenantContractTenantIdBa8Ac167FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `tenantContract` in the `TenantInput` mutation. */
export type TenantContractTenantIdBa8Ac167FkTenantIdInverseInput = {
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TenantContractTenantContractPkeyConnect>>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  connectByName?: InputMaybe<Array<TenantContractTenantContractNameKeyConnect>>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  connectBySfid?: InputMaybe<Array<TenantContractTenantContractSfidKeyConnect>>;
  /** A `TenantContractInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TenantContractTenantIdBa8Ac167FkTenantIdTenantContractCreateInput>
  >;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TenantContractTenantContractPkeyDelete>>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  deleteByName?: InputMaybe<Array<TenantContractTenantContractNameKeyDelete>>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<Array<TenantContractTenantContractSfidKeyDelete>>;
  /** Flag indicating whether all other `tenantContract` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `tenantContract` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `tenantContract` for the far side of the relationship. */
  updateByName?: InputMaybe<
    Array<TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractNameKeyUpdate>
  >;
  /** The primary key(s) and patch data for `tenantContract` for the far side of the relationship. */
  updateBySfid?: InputMaybe<
    Array<TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractSfidKeyUpdate>
  >;
};

/** The `tenantContract` to be created by this mutation. */
export type TenantContractTenantIdBa8Ac167FkTenantIdTenantContractCreateInput =
  {
    contractType: Scalars["Int"]["input"];
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    endDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name: Scalars["String"]["input"];
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    startDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    tenantContractTransactionsUsingId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantContractId681267CeFkTenantCoInverseInput>;
    tenantToTenantId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInput>;
  };

/** The `tenant` to be created by this mutation. */
export type TenantContractTenantIdBa8Ac167FkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** A filter to be used against many `TenantContractTransaction` object types. All fields are combined with a logical ‘and.’ */
export type TenantContractToManyTenantContractTransactionFilter = {
  /** Every related `TenantContractTransaction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TenantContractTransactionFilter>;
  /** No related `TenantContractTransaction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TenantContractTransactionFilter>;
  /** Some related `TenantContractTransaction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TenantContractTransactionFilter>;
};

/** A filter to be used against many `TenantMonthlyConsumedResource` object types. All fields are combined with a logical ‘and.’ */
export type TenantContractToManyTenantMonthlyConsumedResourceFilter = {
  /** Every related `TenantMonthlyConsumedResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TenantMonthlyConsumedResourceFilter>;
  /** No related `TenantMonthlyConsumedResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TenantMonthlyConsumedResourceFilter>;
  /** Some related `TenantMonthlyConsumedResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TenantMonthlyConsumedResourceFilter>;
};

/** Input for the nested mutation of `tenantContract` in the `TenantContractTransactionInput` mutation. */
export type TenantContractTranTenantContractId1E374993FkTenantCoInput = {
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  connectById?: InputMaybe<TenantContractTenantContractPkeyConnect>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  connectByName?: InputMaybe<TenantContractTenantContractNameKeyConnect>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantContractTenantContractSfidKeyConnect>;
  /** A `TenantContractInput` object that will be created and connected to this object. */
  create?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoTenantContractCreateInput>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantContractTenantContractPkeyDelete>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  deleteByName?: InputMaybe<TenantContractTenantContractNameKeyDelete>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantContractTenantContractSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenantContract` for the far side of the relationship. */
  updateById?: InputMaybe<TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractPkeyUpdate>;
  /** The primary key(s) and patch data for `tenantContract` for the far side of the relationship. */
  updateByName?: InputMaybe<TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenantContract` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractSfidKeyUpdate>;
};

/** Input for the nested mutation of `tenantContractTransaction` in the `TenantContractInput` mutation. */
export type TenantContractTranTenantContractId1E374993FkTenantCoInverseInput = {
  /** The primary key(s) for `tenantContractTransaction` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<TenantContractTransactionTenantContractTransactionPkeyConnect>
  >;
  /** A `TenantContractTransactionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TenantContractTranTenantContractId1E374993FkTenantCoTenantContractTransactionCreateInput>
  >;
  /** The primary key(s) for `tenantContractTransaction` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<TenantContractTransactionTenantContractTransactionPkeyDelete>
  >;
  /** Flag indicating whether all other `tenantContractTransaction` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `tenantContractTransaction` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractTransactionPkeyUpdate>
  >;
};

/** The `tenantContract` to be created by this mutation. */
export type TenantContractTranTenantContractId1E374993FkTenantCoTenantContractCreateInput =
  {
    contractType: Scalars["Int"]["input"];
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    endDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name: Scalars["String"]["input"];
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    startDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    tenantContractTransactionsUsingId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantContractId681267CeFkTenantCoInverseInput>;
    tenantToTenantId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInput>;
  };

/** The `tenantContractTransaction` to be created by this mutation. */
export type TenantContractTranTenantContractId1E374993FkTenantCoTenantContractTransactionCreateInput =
  {
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    currency: Scalars["Int"]["input"];
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    price: Scalars["BigFloat"]["input"];
    tenantContractAllowancesUsingId?: InputMaybe<TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput>;
    tenantContractToTenantContractId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInput>;
  };

export type TenantContractTransaction = {
  __typename: "TenantContractTransaction";
  created: Maybe<Scalars["Datetime"]["output"]>;
  currency: Scalars["Int"]["output"];
  dateCreated: Scalars["Datetime"]["output"];
  id: Scalars["Int"]["output"];
  price: Scalars["BigFloat"]["output"];
  /** Reads and enables pagination through a set of `TenantContractAllowance`. */
  tenantContractAllowancesByTenantContractTransactionId: TenantContractAllowancesConnection;
  /** Reads a single `TenantContract` that is related to this `TenantContractTransaction`. */
  tenantContractByTenantContractId: Maybe<TenantContract>;
  tenantContractId: Scalars["Int"]["output"];
};

export type TenantContractTransactionTenantContractAllowancesByTenantContractTransactionIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<TenantContractAllowanceCondition>;
    filter?: InputMaybe<TenantContractAllowanceFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<TenantContractAllowancesOrderBy>>;
  };

/**
 * A condition to be used against `TenantContractTransaction` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type TenantContractTransactionCondition = {
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `currency` field. */
  currency?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Checks for equality with the object’s `tenantContractId` field. */
  tenantContractId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `TenantContractTransaction` object types. All fields are combined with a logical ‘and.’ */
export type TenantContractTransactionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TenantContractTransactionFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currency` field. */
  currency?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TenantContractTransactionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TenantContractTransactionFilter>>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `tenantContractAllowancesByTenantContractTransactionId` relation. */
  tenantContractAllowancesByTenantContractTransactionId?: InputMaybe<TenantContractTransactionToManyTenantContractAllowanceFilter>;
  /** Some related `tenantContractAllowancesByTenantContractTransactionId` exist. */
  tenantContractAllowancesByTenantContractTransactionIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `tenantContractByTenantContractId` relation. */
  tenantContractByTenantContractId?: InputMaybe<TenantContractFilter>;
  /** Filter by the object’s `tenantContractId` field. */
  tenantContractId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `TenantContractTransaction` */
export type TenantContractTransactionInput = {
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  currency: Scalars["Int"]["input"];
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  price: Scalars["BigFloat"]["input"];
  tenantContractAllowancesUsingId?: InputMaybe<TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput>;
  tenantContractId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantContractToTenantContractId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInput>;
};

/** The fields on `tenantContractTransaction` to look up the row to update. */
export type TenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenantContractTransaction` being updated. */
    tenantContractTransactionPatch: UpdateTenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch;
  };

/** The fields on `tenantContractTransaction` to look up the row to update. */
export type TenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractTransactionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenantContractTransaction` being updated. */
    tenantContractTransactionPatch: UpdateTenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch;
  };

/** Represents an update to a `TenantContractTransaction`. Fields that are set will be updated. */
export type TenantContractTransactionPatch = {
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  currency?: InputMaybe<Scalars["Int"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  price?: InputMaybe<Scalars["BigFloat"]["input"]>;
  tenantContractAllowancesUsingId?: InputMaybe<TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput>;
  tenantContractId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantContractToTenantContractId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInput>;
};

/** The fields on `tenantContractTransaction` to look up the row to connect. */
export type TenantContractTransactionTenantContractTransactionPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `tenantContractTransaction` to look up the row to delete. */
export type TenantContractTransactionTenantContractTransactionPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** A filter to be used against many `TenantContractAllowance` object types. All fields are combined with a logical ‘and.’ */
export type TenantContractTransactionToManyTenantContractAllowanceFilter = {
  /** Every related `TenantContractAllowance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TenantContractAllowanceFilter>;
  /** No related `TenantContractAllowance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TenantContractAllowanceFilter>;
  /** Some related `TenantContractAllowance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TenantContractAllowanceFilter>;
};

/** A connection to a list of `TenantContractTransaction` values. */
export type TenantContractTransactionsConnection = {
  __typename: "TenantContractTransactionsConnection";
  /** A list of edges which contains the `TenantContractTransaction` and cursor to aid in pagination. */
  edges: Array<TenantContractTransactionsEdge>;
  /** A list of `TenantContractTransaction` objects. */
  nodes: Array<TenantContractTransaction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TenantContractTransaction` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `TenantContractTransaction` edge in the connection. */
export type TenantContractTransactionsEdge = {
  __typename: "TenantContractTransactionsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `TenantContractTransaction` at the end of the edge. */
  node: TenantContractTransaction;
};

/** Methods to use when ordering `TenantContractTransaction`. */
export enum TenantContractTransactionsOrderBy {
  CreatedAsc = "CREATED_ASC",
  CreatedDesc = "CREATED_DESC",
  CurrencyAsc = "CURRENCY_ASC",
  CurrencyDesc = "CURRENCY_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PriceAsc = "PRICE_ASC",
  PriceDesc = "PRICE_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  TenantContractIdAsc = "TENANT_CONTRACT_ID_ASC",
  TenantContractIdDesc = "TENANT_CONTRACT_ID_DESC",
}

/** A connection to a list of `TenantContract` values. */
export type TenantContractsConnection = {
  __typename: "TenantContractsConnection";
  /** A list of edges which contains the `TenantContract` and cursor to aid in pagination. */
  edges: Array<TenantContractsEdge>;
  /** A list of `TenantContract` objects. */
  nodes: Array<TenantContract>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TenantContract` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `TenantContract` edge in the connection. */
export type TenantContractsEdge = {
  __typename: "TenantContractsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `TenantContract` at the end of the edge. */
  node: TenantContract;
};

/** Methods to use when ordering `TenantContract`. */
export enum TenantContractsOrderBy {
  ContractTypeAsc = "CONTRACT_TYPE_ASC",
  ContractTypeDesc = "CONTRACT_TYPE_DESC",
  CreatedAsc = "CREATED_ASC",
  CreatedDesc = "CREATED_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  EndDateAsc = "END_DATE_ASC",
  EndDateDesc = "END_DATE_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  SfidAsc = "SFID_ASC",
  SfidDesc = "SFID_DESC",
  StartDateAsc = "START_DATE_ASC",
  StartDateDesc = "START_DATE_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
}

/** A filter to be used against `Tenant` object types. All fields are combined with a logical ‘and.’ */
export type TenantFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TenantFilter>>;
  /** Filter by the object’s `applicationUserMembershipsByTenantId` relation. */
  applicationUserMembershipsByTenantId?: InputMaybe<TenantToManyApplicationUserMembershipFilter>;
  /** Some related `applicationUserMembershipsByTenantId` exist. */
  applicationUserMembershipsByTenantIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `applicationUserSessionsByTenantId` relation. */
  applicationUserSessionsByTenantId?: InputMaybe<TenantToManyApplicationUserSessionFilter>;
  /** Some related `applicationUserSessionsByTenantId` exist. */
  applicationUserSessionsByTenantIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `codeFilesByTenantId` relation. */
  codeFilesByTenantId?: InputMaybe<TenantToManyCodeFileFilter>;
  /** Some related `codeFilesByTenantId` exist. */
  codeFilesByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `commandsByTenantId` relation. */
  commandsByTenantId?: InputMaybe<TenantToManyCommandFilter>;
  /** Some related `commandsByTenantId` exist. */
  commandsByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `containerImageRepositoriesByTenantId` relation. */
  containerImageRepositoriesByTenantId?: InputMaybe<TenantToManyContainerImageRepositoryFilter>;
  /** Some related `containerImageRepositoriesByTenantId` exist. */
  containerImageRepositoriesByTenantIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `containerImagesByTenantId` relation. */
  containerImagesByTenantId?: InputMaybe<TenantToManyContainerImageFilter>;
  /** Some related `containerImagesByTenantId` exist. */
  containerImagesByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `costsByTenantId` relation. */
  costsByTenantId?: InputMaybe<TenantToManyCostFilter>;
  /** Some related `costsByTenantId` exist. */
  costsByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `featureFlagsTenantsByTenantId` relation. */
  featureFlagsTenantsByTenantId?: InputMaybe<TenantToManyFeatureFlagsTenantFilter>;
  /** Some related `featureFlagsTenantsByTenantId` exist. */
  featureFlagsTenantsByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `fileActivitiesByTenantId` relation. */
  fileActivitiesByTenantId?: InputMaybe<TenantToManyFileActivityFilter>;
  /** Some related `fileActivitiesByTenantId` exist. */
  fileActivitiesByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `fileMetadataByTenantId` relation. */
  fileMetadataByTenantId?: InputMaybe<TenantToManyFileMetadatumFilter>;
  /** Some related `fileMetadataByTenantId` exist. */
  fileMetadataByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `fileOutputGroupMetadataByTenantId` relation. */
  fileOutputGroupMetadataByTenantId?: InputMaybe<TenantToManyFileOutputGroupMetadatumFilter>;
  /** Some related `fileOutputGroupMetadataByTenantId` exist. */
  fileOutputGroupMetadataByTenantIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `fileOutputGroupsByTenantId` relation. */
  fileOutputGroupsByTenantId?: InputMaybe<TenantToManyFileOutputGroupFilter>;
  /** Some related `fileOutputGroupsByTenantId` exist. */
  fileOutputGroupsByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `filesByTenantId` relation. */
  filesByTenantId?: InputMaybe<TenantToManyFileFilter>;
  /** Some related `filesByTenantId` exist. */
  filesByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `internal` field. */
  internal?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `metadataByTenantId` relation. */
  metadataByTenantId?: InputMaybe<TenantToManyMetadatumFilter>;
  /** Some related `metadataByTenantId` exist. */
  metadataByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `metadataValuesByTenantId` relation. */
  metadataValuesByTenantId?: InputMaybe<TenantToManyMetadataValueFilter>;
  /** Some related `metadataValuesByTenantId` exist. */
  metadataValuesByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TenantFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TenantFilter>>;
  /** Filter by the object’s `projectsByTenantId` relation. */
  projectsByTenantId?: InputMaybe<TenantToManyProjectFilter>;
  /** Some related `projectsByTenantId` exist. */
  projectsByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `repositoryName` field. */
  repositoryName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `roleChangeNotificationsByTenantId` relation. */
  roleChangeNotificationsByTenantId?: InputMaybe<TenantToManyRoleChangeNotificationFilter>;
  /** Some related `roleChangeNotificationsByTenantId` exist. */
  roleChangeNotificationsByTenantIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `runsByTenantId` relation. */
  runsByTenantId?: InputMaybe<TenantToManyRunFilter>;
  /** Some related `runsByTenantId` exist. */
  runsByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `sfid` field. */
  sfid?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tasksByTenantId` relation. */
  tasksByTenantId?: InputMaybe<TenantToManyTaskFilter>;
  /** Some related `tasksByTenantId` exist. */
  tasksByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `tenantContractsByTenantId` relation. */
  tenantContractsByTenantId?: InputMaybe<TenantToManyTenantContractFilter>;
  /** Some related `tenantContractsByTenantId` exist. */
  tenantContractsByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `tenantMonthlyConsumedResourcesByTenantId` relation. */
  tenantMonthlyConsumedResourcesByTenantId?: InputMaybe<TenantToManyTenantMonthlyConsumedResourceFilter>;
  /** Some related `tenantMonthlyConsumedResourcesByTenantId` exist. */
  tenantMonthlyConsumedResourcesByTenantIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `tenantType` field. */
  tenantType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantUserMembershipNotificationsByTenantId` relation. */
  tenantUserMembershipNotificationsByTenantId?: InputMaybe<TenantToManyTenantUserMembershipNotificationFilter>;
  /** Some related `tenantUserMembershipNotificationsByTenantId` exist. */
  tenantUserMembershipNotificationsByTenantIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `toolTenantsByTenantId` relation. */
  toolTenantsByTenantId?: InputMaybe<TenantToManyToolTenantFilter>;
  /** Some related `toolTenantsByTenantId` exist. */
  toolTenantsByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `toolVersionsByTenantId` relation. */
  toolVersionsByTenantId?: InputMaybe<TenantToManyToolVersionFilter>;
  /** Some related `toolVersionsByTenantId` exist. */
  toolVersionsByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `toolboxTenantsByTenantId` relation. */
  toolboxTenantsByTenantId?: InputMaybe<TenantToManyToolboxTenantFilter>;
  /** Some related `toolboxTenantsByTenantId` exist. */
  toolboxTenantsByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `toolsByTenantId` relation. */
  toolsByTenantId?: InputMaybe<TenantToManyToolFilter>;
  /** Some related `toolsByTenantId` exist. */
  toolsByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `workflowsByTenantId` relation. */
  workflowsByTenantId?: InputMaybe<TenantToManyWorkflowFilter>;
  /** Some related `workflowsByTenantId` exist. */
  workflowsByTenantIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** An input for mutations affecting `Tenant` */
export type TenantInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** Input for the nested mutation of `tenantUserexecutor` in the `TenantMockuserexecutorInput` mutation. */
export type TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInput = {
  /** The primary key(s) for `tenantUserexecutor` for the far side of the relationship. */
  connectById?: InputMaybe<TenantUserexecutorTenantUserexecutorPkeyConnect>;
  /** A `TenantUserexecutorInput` object that will be created and connected to this object. */
  create?: InputMaybe<TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsTenantUserexecutorCreateInput>;
  /** The primary key(s) for `tenantUserexecutor` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantUserexecutorTenantUserexecutorPkeyDelete>;
  /** The primary key(s) and patch data for `tenantUserexecutor` for the far side of the relationship. */
  updateById?: InputMaybe<TenantUserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsUsingTenantUserexecutorPkeyUpdate>;
};

/** Input for the nested mutation of `tenantMockuserexecutor` in the `TenantUserexecutorInput` mutation. */
export type TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInverseInput =
  {
    /** The primary key(s) for `tenantMockuserexecutor` for the far side of the relationship. */
    connectByUserexecutorPtrId?: InputMaybe<TenantMockuserexecutorTenantMockuserexecutorPkeyConnect>;
    /** A `TenantMockuserexecutorInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsTenantMockuserexecutorCreateInput>
    >;
    /** The primary key(s) for `tenantMockuserexecutor` for the far side of the relationship. */
    deleteByUserexecutorPtrId?: InputMaybe<TenantMockuserexecutorTenantMockuserexecutorPkeyDelete>;
    /** Flag indicating whether all other `tenantMockuserexecutor` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The primary key(s) and patch data for `tenantMockuserexecutor` for the far side of the relationship. */
    updateByUserexecutorPtrId?: InputMaybe<TenantMockuserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsUsingTenantMockuserexecutorPkeyUpdate>;
  };

/** The `tenantMockuserexecutor` to be created by this mutation. */
export type TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsTenantMockuserexecutorCreateInput =
  {
    tenantUserexecutorToUserexecutorPtrId?: InputMaybe<TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInput>;
  };

/** The `tenantUserexecutor` to be created by this mutation. */
export type TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsTenantUserexecutorCreateInput =
  {
    applicationUserUsingId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInverseInput>;
    awsCognitoUserUsingId?: InputMaybe<AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantMockuserexecutorUsingId?: InputMaybe<TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInverseInput>;
  };

export type TenantMockuserexecutor = {
  __typename: "TenantMockuserexecutor";
  /** Reads a single `TenantUserexecutor` that is related to this `TenantMockuserexecutor`. */
  tenantUserexecutorByUserexecutorPtrId: Maybe<TenantUserexecutor>;
  userexecutorPtrId: Scalars["Int"]["output"];
};

/**
 * A condition to be used against `TenantMockuserexecutor` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type TenantMockuserexecutorCondition = {
  /** Checks for equality with the object’s `userexecutorPtrId` field. */
  userexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `TenantMockuserexecutor` object types. All fields are combined with a logical ‘and.’ */
export type TenantMockuserexecutorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TenantMockuserexecutorFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<TenantMockuserexecutorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TenantMockuserexecutorFilter>>;
  /** Filter by the object’s `tenantUserexecutorByUserexecutorPtrId` relation. */
  tenantUserexecutorByUserexecutorPtrId?: InputMaybe<TenantUserexecutorFilter>;
  /** Filter by the object’s `userexecutorPtrId` field. */
  userexecutorPtrId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `TenantMockuserexecutor` */
export type TenantMockuserexecutorInput = {
  tenantUserexecutorToUserexecutorPtrId?: InputMaybe<TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInput>;
  userexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `tenantMockuserexecutor` to look up the row to update. */
export type TenantMockuserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsUsingTenantMockuserexecutorPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `tenantMockuserexecutor` being updated. */
    tenantMockuserexecutorPatch: UpdateTenantMockuserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsPatch;
    userexecutorPtrId: Scalars["Int"]["input"];
  };

/** Represents an update to a `TenantMockuserexecutor`. Fields that are set will be updated. */
export type TenantMockuserexecutorPatch = {
  tenantUserexecutorToUserexecutorPtrId?: InputMaybe<TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInput>;
  userexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `tenantMockuserexecutor` to look up the row to connect. */
export type TenantMockuserexecutorTenantMockuserexecutorPkeyConnect = {
  userexecutorPtrId: Scalars["Int"]["input"];
};

/** The fields on `tenantMockuserexecutor` to look up the row to delete. */
export type TenantMockuserexecutorTenantMockuserexecutorPkeyDelete = {
  userexecutorPtrId: Scalars["Int"]["input"];
};

/** A connection to a list of `TenantMockuserexecutor` values. */
export type TenantMockuserexecutorsConnection = {
  __typename: "TenantMockuserexecutorsConnection";
  /** A list of edges which contains the `TenantMockuserexecutor` and cursor to aid in pagination. */
  edges: Array<TenantMockuserexecutorsEdge>;
  /** A list of `TenantMockuserexecutor` objects. */
  nodes: Array<TenantMockuserexecutor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TenantMockuserexecutor` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `TenantMockuserexecutor` edge in the connection. */
export type TenantMockuserexecutorsEdge = {
  __typename: "TenantMockuserexecutorsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `TenantMockuserexecutor` at the end of the edge. */
  node: TenantMockuserexecutor;
};

/** Methods to use when ordering `TenantMockuserexecutor`. */
export enum TenantMockuserexecutorsOrderBy {
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  UserexecutorPtrIdAsc = "USEREXECUTOR_PTR_ID_ASC",
  UserexecutorPtrIdDesc = "USEREXECUTOR_PTR_ID_DESC",
}

/** Input for the nested mutation of `tenantContract` in the `TenantMonthlyConsumedResourceInput` mutation. */
export type TenantMonthlyConsuTenantContractId681267CeFkTenantCoInput = {
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  connectById?: InputMaybe<TenantContractTenantContractPkeyConnect>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  connectByName?: InputMaybe<TenantContractTenantContractNameKeyConnect>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantContractTenantContractSfidKeyConnect>;
  /** A `TenantContractInput` object that will be created and connected to this object. */
  create?: InputMaybe<TenantMonthlyConsuTenantContractId681267CeFkTenantCoTenantContractCreateInput>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantContractTenantContractPkeyDelete>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  deleteByName?: InputMaybe<TenantContractTenantContractNameKeyDelete>;
  /** The primary key(s) for `tenantContract` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantContractTenantContractSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenantContract` for the far side of the relationship. */
  updateById?: InputMaybe<TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractPkeyUpdate>;
  /** The primary key(s) and patch data for `tenantContract` for the far side of the relationship. */
  updateByName?: InputMaybe<TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenantContract` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractSfidKeyUpdate>;
};

/** Input for the nested mutation of `tenantMonthlyConsumedResource` in the `TenantContractInput` mutation. */
export type TenantMonthlyConsuTenantContractId681267CeFkTenantCoInverseInput = {
  /** The primary key(s) for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesPkeyConnect>
  >;
  /** The primary key(s) for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  connectByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract?: InputMaybe<
    Array<TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesUniqueConnect>
  >;
  /** A `TenantMonthlyConsumedResourceInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TenantMonthlyConsuTenantContractId681267CeFkTenantCoTenantMonthlyConsumedResourcesCreateInput>
  >;
  /** The primary key(s) for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesPkeyDelete>
  >;
  /** The primary key(s) for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  deleteByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract?: InputMaybe<
    Array<TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesUniqueDelete>
  >;
  /** Flag indicating whether all other `tenantMonthlyConsumedResource` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantMonthlyConsumedResourcesPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  updateByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract?: InputMaybe<
    Array<TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantMonthlyConsumedResourcesUniqueUpdate>
  >;
};

/** The `tenantContract` to be created by this mutation. */
export type TenantMonthlyConsuTenantContractId681267CeFkTenantCoTenantContractCreateInput =
  {
    contractType: Scalars["Int"]["input"];
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    endDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name: Scalars["String"]["input"];
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    startDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    tenantContractTransactionsUsingId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantContractId681267CeFkTenantCoInverseInput>;
    tenantToTenantId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInput>;
  };

/** The `tenantMonthlyConsumedResource` to be created by this mutation. */
export type TenantMonthlyConsuTenantContractId681267CeFkTenantCoTenantMonthlyConsumedResourcesCreateInput =
  {
    applicationUserToUserId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    month: Scalars["Date"]["input"];
    monthInActiveContract?: InputMaybe<Scalars["Int"]["input"]>;
    percentage: Scalars["Float"]["input"];
    quotaType: Scalars["Int"]["input"];
    tenantContractToTenantContractId?: InputMaybe<TenantMonthlyConsuTenantContractId681267CeFkTenantCoInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    value: Scalars["String"]["input"];
  };

/** Input for the nested mutation of `tenant` in the `TenantMonthlyConsumedResourceInput` mutation. */
export type TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `tenantMonthlyConsumedResource` in the `TenantInput` mutation. */
export type TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput = {
  /** The primary key(s) for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesPkeyConnect>
  >;
  /** The primary key(s) for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  connectByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract?: InputMaybe<
    Array<TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesUniqueConnect>
  >;
  /** A `TenantMonthlyConsumedResourceInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdTenantMonthlyConsumedResourcesCreateInput>
  >;
  /** The primary key(s) for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesPkeyDelete>
  >;
  /** The primary key(s) for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  deleteByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract?: InputMaybe<
    Array<TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesUniqueDelete>
  >;
  /** Flag indicating whether all other `tenantMonthlyConsumedResource` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantMonthlyConsumedResourcesPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  updateByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract?: InputMaybe<
    Array<TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantMonthlyConsumedResourcesUniqueUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** The `tenantMonthlyConsumedResource` to be created by this mutation. */
export type TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdTenantMonthlyConsumedResourcesCreateInput =
  {
    applicationUserToUserId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    month: Scalars["Date"]["input"];
    monthInActiveContract?: InputMaybe<Scalars["Int"]["input"]>;
    percentage: Scalars["Float"]["input"];
    quotaType: Scalars["Int"]["input"];
    tenantContractId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantContractToTenantContractId?: InputMaybe<TenantMonthlyConsuTenantContractId681267CeFkTenantCoInput>;
    tenantToTenantId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    value: Scalars["String"]["input"];
  };

/** The `applicationUser` to be created by this mutation. */
export type TenantMonthlyConsuUserIdF7210F55FkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `TenantMonthlyConsumedResourceInput` mutation. */
export type TenantMonthlyConsuUserIdF7210F55FkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `tenantMonthlyConsumedResource` in the `ApplicationUserInput` mutation. */
export type TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput = {
  /** The primary key(s) for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesPkeyConnect>
  >;
  /** The primary key(s) for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  connectByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract?: InputMaybe<
    Array<TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesUniqueConnect>
  >;
  /** A `TenantMonthlyConsumedResourceInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TenantMonthlyConsuUserIdF7210F55FkApplicatiTenantMonthlyConsumedResourcesCreateInput>
  >;
  /** The primary key(s) for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesPkeyDelete>
  >;
  /** The primary key(s) for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  deleteByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract?: InputMaybe<
    Array<TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesUniqueDelete>
  >;
  /** Flag indicating whether all other `tenantMonthlyConsumedResource` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingTenantMonthlyConsumedResourcesPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `tenantMonthlyConsumedResource` for the far side of the relationship. */
  updateByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract?: InputMaybe<
    Array<TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingTenantMonthlyConsumedResourcesUniqueUpdate>
  >;
};

/** The `tenantMonthlyConsumedResource` to be created by this mutation. */
export type TenantMonthlyConsuUserIdF7210F55FkApplicatiTenantMonthlyConsumedResourcesCreateInput =
  {
    applicationUserToUserId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    month: Scalars["Date"]["input"];
    monthInActiveContract?: InputMaybe<Scalars["Int"]["input"]>;
    percentage: Scalars["Float"]["input"];
    quotaType: Scalars["Int"]["input"];
    tenantContractId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantContractToTenantContractId?: InputMaybe<TenantMonthlyConsuTenantContractId681267CeFkTenantCoInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInput>;
    value: Scalars["String"]["input"];
  };

export type TenantMonthlyConsumedResource = {
  __typename: "TenantMonthlyConsumedResource";
  /** Reads a single `ApplicationUser` that is related to this `TenantMonthlyConsumedResource`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  id: Scalars["Int"]["output"];
  month: Scalars["Date"]["output"];
  monthInActiveContract: Maybe<Scalars["Int"]["output"]>;
  percentage: Scalars["Float"]["output"];
  quotaType: Scalars["Int"]["output"];
  /** Reads a single `Tenant` that is related to this `TenantMonthlyConsumedResource`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `TenantContract` that is related to this `TenantMonthlyConsumedResource`. */
  tenantContractByTenantContractId: Maybe<TenantContract>;
  tenantContractId: Maybe<Scalars["Int"]["output"]>;
  tenantId: Scalars["Int"]["output"];
  userId: Maybe<Scalars["UUID"]["output"]>;
  value: Scalars["String"]["output"];
};

/**
 * A condition to be used against `TenantMonthlyConsumedResource` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type TenantMonthlyConsumedResourceCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `month` field. */
  month?: InputMaybe<Scalars["Date"]["input"]>;
  /** Checks for equality with the object’s `monthInActiveContract` field. */
  monthInActiveContract?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `percentage` field. */
  percentage?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `quotaType` field. */
  quotaType?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `tenantContractId` field. */
  tenantContractId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars["String"]["input"]>;
};

/** A filter to be used against `TenantMonthlyConsumedResource` object types. All fields are combined with a logical ‘and.’ */
export type TenantMonthlyConsumedResourceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TenantMonthlyConsumedResourceFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `month` field. */
  month?: InputMaybe<DateFilter>;
  /** Filter by the object’s `monthInActiveContract` field. */
  monthInActiveContract?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TenantMonthlyConsumedResourceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TenantMonthlyConsumedResourceFilter>>;
  /** Filter by the object’s `percentage` field. */
  percentage?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `quotaType` field. */
  quotaType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantContractByTenantContractId` relation. */
  tenantContractByTenantContractId?: InputMaybe<TenantContractFilter>;
  /** A related `tenantContractByTenantContractId` exists. */
  tenantContractByTenantContractIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `tenantContractId` field. */
  tenantContractId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `TenantMonthlyConsumedResource` */
export type TenantMonthlyConsumedResourceInput = {
  applicationUserToUserId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  month: Scalars["Date"]["input"];
  monthInActiveContract?: InputMaybe<Scalars["Int"]["input"]>;
  percentage: Scalars["Float"]["input"];
  quotaType: Scalars["Int"]["input"];
  tenantContractId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantContractToTenantContractId?: InputMaybe<TenantMonthlyConsuTenantContractId681267CeFkTenantCoInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  value: Scalars["String"]["input"];
};

/** The fields on `tenantMonthlyConsumedResource` to look up the row to update. */
export type TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantMonthlyConsumedResourcesPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenantMonthlyConsumedResource` being updated. */
    tenantMonthlyConsumedResourcePatch: UpdateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoPatch;
  };

/** The fields on `tenantMonthlyConsumedResource` to look up the row to update. */
export type TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantMonthlyConsumedResourcesUniqueUpdate =
  {
    month: Scalars["Date"]["input"];
    monthInActiveContract: Scalars["Int"]["input"];
    quotaType: Scalars["Int"]["input"];
    tenantContractId: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenantMonthlyConsumedResource` being updated. */
    tenantMonthlyConsumedResourcePatch: UpdateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoPatch;
    userId: Scalars["UUID"]["input"];
  };

/** The fields on `tenantMonthlyConsumedResource` to look up the row to update. */
export type TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantMonthlyConsumedResourcesPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenantMonthlyConsumedResource` being updated. */
    tenantMonthlyConsumedResourcePatch: UpdateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdPatch;
  };

/** The fields on `tenantMonthlyConsumedResource` to look up the row to update. */
export type TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantMonthlyConsumedResourcesUniqueUpdate =
  {
    month: Scalars["Date"]["input"];
    monthInActiveContract: Scalars["Int"]["input"];
    quotaType: Scalars["Int"]["input"];
    tenantContractId: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenantMonthlyConsumedResource` being updated. */
    tenantMonthlyConsumedResourcePatch: UpdateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdPatch;
    userId: Scalars["UUID"]["input"];
  };

/** The fields on `tenantMonthlyConsumedResource` to look up the row to update. */
export type TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingTenantMonthlyConsumedResourcesPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenantMonthlyConsumedResource` being updated. */
    tenantMonthlyConsumedResourcePatch: UpdateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiPatch;
  };

/** The fields on `tenantMonthlyConsumedResource` to look up the row to update. */
export type TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingTenantMonthlyConsumedResourcesUniqueUpdate =
  {
    month: Scalars["Date"]["input"];
    monthInActiveContract: Scalars["Int"]["input"];
    quotaType: Scalars["Int"]["input"];
    tenantContractId: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenantMonthlyConsumedResource` being updated. */
    tenantMonthlyConsumedResourcePatch: UpdateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiPatch;
    userId: Scalars["UUID"]["input"];
  };

/** Represents an update to a `TenantMonthlyConsumedResource`. Fields that are set will be updated. */
export type TenantMonthlyConsumedResourcePatch = {
  applicationUserToUserId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  month?: InputMaybe<Scalars["Date"]["input"]>;
  monthInActiveContract?: InputMaybe<Scalars["Int"]["input"]>;
  percentage?: InputMaybe<Scalars["Float"]["input"]>;
  quotaType?: InputMaybe<Scalars["Int"]["input"]>;
  tenantContractId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantContractToTenantContractId?: InputMaybe<TenantMonthlyConsuTenantContractId681267CeFkTenantCoInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  value?: InputMaybe<Scalars["String"]["input"]>;
};

/** The fields on `tenantMonthlyConsumedResource` to look up the row to connect. */
export type TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesPkeyConnect =
  {
    id: Scalars["Int"]["input"];
  };

/** The fields on `tenantMonthlyConsumedResource` to look up the row to delete. */
export type TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesPkeyDelete =
  {
    id: Scalars["Int"]["input"];
  };

/** The fields on `tenantMonthlyConsumedResource` to look up the row to connect. */
export type TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesUniqueConnect =
  {
    month: Scalars["Date"]["input"];
    monthInActiveContract: Scalars["Int"]["input"];
    quotaType: Scalars["Int"]["input"];
    tenantContractId: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** The fields on `tenantMonthlyConsumedResource` to look up the row to delete. */
export type TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesUniqueDelete =
  {
    month: Scalars["Date"]["input"];
    monthInActiveContract: Scalars["Int"]["input"];
    quotaType: Scalars["Int"]["input"];
    tenantContractId: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
    userId: Scalars["UUID"]["input"];
  };

/** A connection to a list of `TenantMonthlyConsumedResource` values. */
export type TenantMonthlyConsumedResourcesConnection = {
  __typename: "TenantMonthlyConsumedResourcesConnection";
  /** A list of edges which contains the `TenantMonthlyConsumedResource` and cursor to aid in pagination. */
  edges: Array<TenantMonthlyConsumedResourcesEdge>;
  /** A list of `TenantMonthlyConsumedResource` objects. */
  nodes: Array<TenantMonthlyConsumedResource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TenantMonthlyConsumedResource` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `TenantMonthlyConsumedResource` edge in the connection. */
export type TenantMonthlyConsumedResourcesEdge = {
  __typename: "TenantMonthlyConsumedResourcesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `TenantMonthlyConsumedResource` at the end of the edge. */
  node: TenantMonthlyConsumedResource;
};

/** Methods to use when ordering `TenantMonthlyConsumedResource`. */
export enum TenantMonthlyConsumedResourcesOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  MonthAsc = "MONTH_ASC",
  MonthDesc = "MONTH_DESC",
  MonthInActiveContractAsc = "MONTH_IN_ACTIVE_CONTRACT_ASC",
  MonthInActiveContractDesc = "MONTH_IN_ACTIVE_CONTRACT_DESC",
  Natural = "NATURAL",
  PercentageAsc = "PERCENTAGE_ASC",
  PercentageDesc = "PERCENTAGE_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  QuotaTypeAsc = "QUOTA_TYPE_ASC",
  QuotaTypeDesc = "QUOTA_TYPE_DESC",
  TenantContractIdAsc = "TENANT_CONTRACT_ID_ASC",
  TenantContractIdDesc = "TENANT_CONTRACT_ID_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
  ValueAsc = "VALUE_ASC",
  ValueDesc = "VALUE_DESC",
}

/** The fields on `tenant` to look up the row to update. */
export type TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnCommandForCommandTenantId36F95C3CFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnCommandForCommandTenantId36F95C3CFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnCommandForCommandTenantId36F95C3CFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnCommandForCommandTenantId36F95C3CFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnCostForCostTenantId7Dcd58A7FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnCostForCostTenantId7Dcd58A7FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnCostForCostTenantId7Dcd58A7FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnCostForCostTenantId7Dcd58A7FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileForFileTenantId61625016FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileForFileTenantId61625016FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileForFileTenantId61625016FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileForFileTenantId61625016FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnRunForRunTenantId73Fbd8D9FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantPkeyUpdate = {
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `tenant` being updated. */
  tenantPatch: UpdateTenantOnRunForRunTenantId73Fbd8D9FkTenantIdPatch;
};

/** The fields on `tenant` to look up the row to update. */
export type TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnRunForRunTenantId73Fbd8D9FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnRunForRunTenantId73Fbd8D9FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantRepositoryNameKeyUpdate =
  {
    repositoryName: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdPatch;
  };

/** The fields on `tenant` to look up the row to update. */
export type TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantSfidKeyUpdate =
  {
    sfid: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `tenant` being updated. */
    tenantPatch: UpdateTenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdPatch;
  };

/** Represents an update to a `Tenant`. Fields that are set will be updated. */
export type TenantPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName?: InputMaybe<Scalars["String"]["input"]>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType?: InputMaybe<Scalars["Int"]["input"]>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** The fields on `tenant` to look up the row to connect. */
export type TenantTenantKeyKeyConnect = {
  key: Scalars["String"]["input"];
};

/** The fields on `tenant` to look up the row to delete. */
export type TenantTenantKeyKeyDelete = {
  key: Scalars["String"]["input"];
};

/** The fields on `tenant` to look up the row to connect. */
export type TenantTenantPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `tenant` to look up the row to delete. */
export type TenantTenantPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** The fields on `tenant` to look up the row to connect. */
export type TenantTenantRepositoryNameKeyConnect = {
  repositoryName: Scalars["String"]["input"];
};

/** The fields on `tenant` to look up the row to delete. */
export type TenantTenantRepositoryNameKeyDelete = {
  repositoryName: Scalars["String"]["input"];
};

/** The fields on `tenant` to look up the row to connect. */
export type TenantTenantSfidKeyConnect = {
  sfid: Scalars["String"]["input"];
};

/** The fields on `tenant` to look up the row to delete. */
export type TenantTenantSfidKeyDelete = {
  sfid: Scalars["String"]["input"];
};

/** A filter to be used against many `ApplicationUserMembership` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyApplicationUserMembershipFilter = {
  /** Every related `ApplicationUserMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ApplicationUserMembershipFilter>;
  /** No related `ApplicationUserMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ApplicationUserMembershipFilter>;
  /** Some related `ApplicationUserMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ApplicationUserMembershipFilter>;
};

/** A filter to be used against many `ApplicationUserSession` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyApplicationUserSessionFilter = {
  /** Every related `ApplicationUserSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ApplicationUserSessionFilter>;
  /** No related `ApplicationUserSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ApplicationUserSessionFilter>;
  /** Some related `ApplicationUserSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ApplicationUserSessionFilter>;
};

/** A filter to be used against many `CodeFile` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyCodeFileFilter = {
  /** Every related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CodeFileFilter>;
  /** No related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CodeFileFilter>;
  /** Some related `CodeFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CodeFileFilter>;
};

/** A filter to be used against many `Command` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyCommandFilter = {
  /** Every related `Command` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CommandFilter>;
  /** No related `Command` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CommandFilter>;
  /** Some related `Command` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CommandFilter>;
};

/** A filter to be used against many `ContainerImage` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyContainerImageFilter = {
  /** Every related `ContainerImage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContainerImageFilter>;
  /** No related `ContainerImage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContainerImageFilter>;
  /** Some related `ContainerImage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContainerImageFilter>;
};

/** A filter to be used against many `ContainerImageRepository` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyContainerImageRepositoryFilter = {
  /** Every related `ContainerImageRepository` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ContainerImageRepositoryFilter>;
  /** No related `ContainerImageRepository` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ContainerImageRepositoryFilter>;
  /** Some related `ContainerImageRepository` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ContainerImageRepositoryFilter>;
};

/** A filter to be used against many `Cost` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyCostFilter = {
  /** Every related `Cost` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CostFilter>;
  /** No related `Cost` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CostFilter>;
  /** Some related `Cost` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CostFilter>;
};

/** A filter to be used against many `FeatureFlagsTenant` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyFeatureFlagsTenantFilter = {
  /** Every related `FeatureFlagsTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FeatureFlagsTenantFilter>;
  /** No related `FeatureFlagsTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FeatureFlagsTenantFilter>;
  /** Some related `FeatureFlagsTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FeatureFlagsTenantFilter>;
};

/** A filter to be used against many `FileActivity` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyFileActivityFilter = {
  /** Every related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileActivityFilter>;
  /** No related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileActivityFilter>;
  /** Some related `FileActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileActivityFilter>;
};

/** A filter to be used against many `File` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyFileFilter = {
  /** Every related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileFilter>;
  /** No related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileFilter>;
  /** Some related `File` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileFilter>;
};

/** A filter to be used against many `FileMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyFileMetadatumFilter = {
  /** Every related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileMetadatumFilter>;
  /** No related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileMetadatumFilter>;
  /** Some related `FileMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileMetadatumFilter>;
};

/** A filter to be used against many `FileOutputGroup` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyFileOutputGroupFilter = {
  /** Every related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileOutputGroupFilter>;
  /** No related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileOutputGroupFilter>;
  /** Some related `FileOutputGroup` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileOutputGroupFilter>;
};

/** A filter to be used against many `FileOutputGroupMetadatum` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyFileOutputGroupMetadatumFilter = {
  /** Every related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** No related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FileOutputGroupMetadatumFilter>;
  /** Some related `FileOutputGroupMetadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FileOutputGroupMetadatumFilter>;
};

/** A filter to be used against many `MetadataValue` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyMetadataValueFilter = {
  /** Every related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MetadataValueFilter>;
  /** No related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MetadataValueFilter>;
  /** Some related `MetadataValue` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MetadataValueFilter>;
};

/** A filter to be used against many `Metadatum` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyMetadatumFilter = {
  /** Every related `Metadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MetadatumFilter>;
  /** No related `Metadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MetadatumFilter>;
  /** Some related `Metadatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MetadatumFilter>;
};

/** A filter to be used against many `Project` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyProjectFilter = {
  /** Every related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ProjectFilter>;
  /** No related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ProjectFilter>;
  /** Some related `Project` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ProjectFilter>;
};

/** A filter to be used against many `RoleChangeNotification` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyRoleChangeNotificationFilter = {
  /** Every related `RoleChangeNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RoleChangeNotificationFilter>;
  /** No related `RoleChangeNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RoleChangeNotificationFilter>;
  /** Some related `RoleChangeNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RoleChangeNotificationFilter>;
};

/** A filter to be used against many `Run` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyRunFilter = {
  /** Every related `Run` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RunFilter>;
  /** No related `Run` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RunFilter>;
  /** Some related `Run` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RunFilter>;
};

/** A filter to be used against many `Task` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyTaskFilter = {
  /** Every related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskFilter>;
  /** No related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskFilter>;
  /** Some related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskFilter>;
};

/** A filter to be used against many `TenantContract` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyTenantContractFilter = {
  /** Every related `TenantContract` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TenantContractFilter>;
  /** No related `TenantContract` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TenantContractFilter>;
  /** Some related `TenantContract` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TenantContractFilter>;
};

/** A filter to be used against many `TenantMonthlyConsumedResource` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyTenantMonthlyConsumedResourceFilter = {
  /** Every related `TenantMonthlyConsumedResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TenantMonthlyConsumedResourceFilter>;
  /** No related `TenantMonthlyConsumedResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TenantMonthlyConsumedResourceFilter>;
  /** Some related `TenantMonthlyConsumedResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TenantMonthlyConsumedResourceFilter>;
};

/** A filter to be used against many `TenantUserMembershipNotification` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyTenantUserMembershipNotificationFilter = {
  /** Every related `TenantUserMembershipNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TenantUserMembershipNotificationFilter>;
  /** No related `TenantUserMembershipNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TenantUserMembershipNotificationFilter>;
  /** Some related `TenantUserMembershipNotification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TenantUserMembershipNotificationFilter>;
};

/** A filter to be used against many `Tool` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyToolFilter = {
  /** Every related `Tool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolFilter>;
  /** No related `Tool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolFilter>;
  /** Some related `Tool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolFilter>;
};

/** A filter to be used against many `ToolTenant` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyToolTenantFilter = {
  /** Every related `ToolTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolTenantFilter>;
  /** No related `ToolTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolTenantFilter>;
  /** Some related `ToolTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolTenantFilter>;
};

/** A filter to be used against many `ToolVersion` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyToolVersionFilter = {
  /** Every related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolVersionFilter>;
  /** No related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolVersionFilter>;
  /** Some related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolVersionFilter>;
};

/** A filter to be used against many `ToolboxTenant` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyToolboxTenantFilter = {
  /** Every related `ToolboxTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolboxTenantFilter>;
  /** No related `ToolboxTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolboxTenantFilter>;
  /** Some related `ToolboxTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolboxTenantFilter>;
};

/** A filter to be used against many `Workflow` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyWorkflowFilter = {
  /** Every related `Workflow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkflowFilter>;
  /** No related `Workflow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkflowFilter>;
  /** Some related `Workflow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkflowFilter>;
};

/** Input for the nested mutation of `notification` in the `TenantUserMembershipNotificationInput` mutation. */
export type TenantUserMembershId10Affa8DFkNotificatInput = {
  /** The primary key(s) for `notification` for the far side of the relationship. */
  connectById?: InputMaybe<NotificationNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `notification` for the far side of the relationship. */
  updateById?: InputMaybe<NotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingNotificationPkeyUpdate>;
};

/** Input for the nested mutation of `tenantUserMembershipNotification` in the `NotificationInput` mutation. */
export type TenantUserMembershId10Affa8DFkNotificatInverseInput = {
  /** The primary key(s) for `tenantUserMembershipNotification` for the far side of the relationship. */
  connectById?: InputMaybe<TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect>;
  /** The primary key(s) and patch data for `tenantUserMembershipNotification` for the far side of the relationship. */
  updateById?: InputMaybe<TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingTenantUserMembershipNotificationPkeyUpdate>;
};

/** The `applicationUser` to be created by this mutation. */
export type TenantUserMembershInviterId29476E5EFkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `TenantUserMembershipNotificationInput` mutation. */
export type TenantUserMembershInviterId29476E5EFkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `tenantUserMembershipNotification` in the `ApplicationUserInput` mutation. */
export type TenantUserMembershInviterId29476E5EFkApplicatiInverseInput = {
  /** The primary key(s) for `tenantUserMembershipNotification` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect>
  >;
  /** The primary key(s) and patch data for `tenantUserMembershipNotification` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate>
  >;
};

/** Input for the nested mutation of `tenant` in the `TenantUserMembershipNotificationInput` mutation. */
export type TenantUserMembershTenantIdC67818C5FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `tenantUserMembershipNotification` in the `TenantInput` mutation. */
export type TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput = {
  /** The primary key(s) for `tenantUserMembershipNotification` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect>
  >;
  /** The primary key(s) and patch data for `tenantUserMembershipNotification` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantUserMembershipNotificationPkeyUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type TenantUserMembershTenantIdC67818C5FkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** The `applicationUser` to be created by this mutation. */
export type TenantUserMembershUserId2B78E8A0FkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `TenantUserMembershipNotificationInput` mutation. */
export type TenantUserMembershUserId2B78E8A0FkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `tenantUserMembershipNotification` in the `ApplicationUserInput` mutation. */
export type TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput = {
  /** The primary key(s) for `tenantUserMembershipNotification` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect>
  >;
  /** The primary key(s) and patch data for `tenantUserMembershipNotification` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate>
  >;
};

export type TenantUserMembershipNotification = {
  __typename: "TenantUserMembershipNotification";
  /** Reads a single `ApplicationUser` that is related to this `TenantUserMembershipNotification`. */
  applicationUserByInviterId: Maybe<ApplicationUser>;
  /** Reads a single `ApplicationUser` that is related to this `TenantUserMembershipNotification`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  id: Scalars["UUID"]["output"];
  inviterId: Scalars["UUID"]["output"];
  /** Reads a single `Notification` that is related to this `TenantUserMembershipNotification`. */
  notificationById: Maybe<Notification>;
  /** Reads a single `Tenant` that is related to this `TenantUserMembershipNotification`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
  userId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `TenantUserMembershipNotification` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type TenantUserMembershipNotificationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `inviterId` field. */
  inviterId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `TenantUserMembershipNotification` object types. All fields are combined with a logical ‘and.’ */
export type TenantUserMembershipNotificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TenantUserMembershipNotificationFilter>>;
  /** Filter by the object’s `applicationUserByInviterId` relation. */
  applicationUserByInviterId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `inviterId` field. */
  inviterId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TenantUserMembershipNotificationFilter>;
  /** Filter by the object’s `notificationById` relation. */
  notificationById?: InputMaybe<NotificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TenantUserMembershipNotificationFilter>>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** The fields on `tenantUserMembershipNotification` to look up the row to update. */
export type TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingTenantUserMembershipNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `tenantUserMembershipNotification` being updated. */
    tenantUserMembershipNotificationPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch;
  };

/** The fields on `tenantUserMembershipNotification` to look up the row to update. */
export type TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `tenantUserMembershipNotification` being updated. */
    tenantUserMembershipNotificationPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
  };

/** The fields on `tenantUserMembershipNotification` to look up the row to update. */
export type TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantUserMembershipNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `tenantUserMembershipNotification` being updated. */
    tenantUserMembershipNotificationPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
  };

/** The fields on `tenantUserMembershipNotification` to look up the row to update. */
export type TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `tenantUserMembershipNotification` being updated. */
    tenantUserMembershipNotificationPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
  };

/** The fields on `tenantUserMembershipNotification` to look up the row to connect. */
export type TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** A connection to a list of `TenantUserMembershipNotification` values. */
export type TenantUserMembershipNotificationsConnection = {
  __typename: "TenantUserMembershipNotificationsConnection";
  /** A list of edges which contains the `TenantUserMembershipNotification` and cursor to aid in pagination. */
  edges: Array<TenantUserMembershipNotificationsEdge>;
  /** A list of `TenantUserMembershipNotification` objects. */
  nodes: Array<TenantUserMembershipNotification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TenantUserMembershipNotification` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `TenantUserMembershipNotification` edge in the connection. */
export type TenantUserMembershipNotificationsEdge = {
  __typename: "TenantUserMembershipNotificationsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `TenantUserMembershipNotification` at the end of the edge. */
  node: TenantUserMembershipNotification;
};

/** Methods to use when ordering `TenantUserMembershipNotification`. */
export enum TenantUserMembershipNotificationsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  InviterIdAsc = "INVITER_ID_ASC",
  InviterIdDesc = "INVITER_ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

export type TenantUserexecutor = {
  __typename: "TenantUserexecutor";
  /** Reads a single `AwsCognitoUser` that is related to this `TenantUserexecutor`. */
  awsCognitoUserByUserexecutorPtrId: Maybe<AwsCognitoUser>;
  /**
   * Reads and enables pagination through a set of `AwsCognitoUser`.
   * @deprecated Please use awsCognitoUserByUserexecutorPtrId instead
   */
  awsCognitoUsersByUserexecutorPtrId: AwsCognitoUsersConnection;
  /** Reads a single `DjangoContentType` that is related to this `TenantUserexecutor`. */
  djangoContentTypeByPolymorphicCtypeId: Maybe<DjangoContentType>;
  id: Scalars["Int"]["output"];
  polymorphicCtypeId: Maybe<Scalars["Int"]["output"]>;
  /** Reads a single `TenantMockuserexecutor` that is related to this `TenantUserexecutor`. */
  tenantMockuserexecutorByUserexecutorPtrId: Maybe<TenantMockuserexecutor>;
  /**
   * Reads and enables pagination through a set of `TenantMockuserexecutor`.
   * @deprecated Please use tenantMockuserexecutorByUserexecutorPtrId instead
   */
  tenantMockuserexecutorsByUserexecutorPtrId: TenantMockuserexecutorsConnection;
};

export type TenantUserexecutorAwsCognitoUsersByUserexecutorPtrIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsCognitoUserCondition>;
  filter?: InputMaybe<AwsCognitoUserFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsCognitoUsersOrderBy>>;
};

export type TenantUserexecutorTenantMockuserexecutorsByUserexecutorPtrIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TenantMockuserexecutorCondition>;
  filter?: InputMaybe<TenantMockuserexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TenantMockuserexecutorsOrderBy>>;
};

/**
 * A condition to be used against `TenantUserexecutor` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TenantUserexecutorCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `polymorphicCtypeId` field. */
  polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `TenantUserexecutor` object types. All fields are combined with a logical ‘and.’ */
export type TenantUserexecutorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TenantUserexecutorFilter>>;
  /** Filter by the object’s `awsCognitoUserByUserexecutorPtrId` relation. */
  awsCognitoUserByUserexecutorPtrId?: InputMaybe<AwsCognitoUserFilter>;
  /** A related `awsCognitoUserByUserexecutorPtrId` exists. */
  awsCognitoUserByUserexecutorPtrIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `djangoContentTypeByPolymorphicCtypeId` relation. */
  djangoContentTypeByPolymorphicCtypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** A related `djangoContentTypeByPolymorphicCtypeId` exists. */
  djangoContentTypeByPolymorphicCtypeIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TenantUserexecutorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TenantUserexecutorFilter>>;
  /** Filter by the object’s `polymorphicCtypeId` field. */
  polymorphicCtypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantMockuserexecutorByUserexecutorPtrId` relation. */
  tenantMockuserexecutorByUserexecutorPtrId?: InputMaybe<TenantMockuserexecutorFilter>;
  /** A related `tenantMockuserexecutorByUserexecutorPtrId` exists. */
  tenantMockuserexecutorByUserexecutorPtrIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

/** An input for mutations affecting `TenantUserexecutor` */
export type TenantUserexecutorInput = {
  applicationUserUsingId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInverseInput>;
  awsCognitoUserUsingId?: InputMaybe<AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInverseInput>;
  djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantMockuserexecutorUsingId?: InputMaybe<TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInverseInput>;
};

/** The fields on `tenantUserexecutor` to look up the row to update. */
export type TenantUserexecutorOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsUsingTenantUserexecutorPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenantUserexecutor` being updated. */
    tenantUserexecutorPatch: UpdateTenantUserexecutorOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsPatch;
  };

/** The fields on `tenantUserexecutor` to look up the row to update. */
export type TenantUserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsUsingTenantUserexecutorPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenantUserexecutor` being updated. */
    tenantUserexecutorPatch: UpdateTenantUserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsPatch;
  };

/** The fields on `tenantUserexecutor` to look up the row to update. */
export type TenantUserexecutorOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingTenantUserexecutorPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tenantUserexecutor` being updated. */
    tenantUserexecutorPatch: UpdateTenantUserexecutorOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoPatch;
  };

/** Represents an update to a `TenantUserexecutor`. Fields that are set will be updated. */
export type TenantUserexecutorPatch = {
  applicationUserUsingId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInverseInput>;
  awsCognitoUserUsingId?: InputMaybe<AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInverseInput>;
  djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantMockuserexecutorUsingId?: InputMaybe<TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInverseInput>;
};

/** The `djangoContentType` to be created by this mutation. */
export type TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `TenantUserexecutorInput` mutation. */
export type TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `tenantUserexecutor` in the `DjangoContentTypeInput` mutation. */
export type TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput =
  {
    /** The primary key(s) for `tenantUserexecutor` for the far side of the relationship. */
    connectById?: InputMaybe<
      Array<TenantUserexecutorTenantUserexecutorPkeyConnect>
    >;
    /** A `TenantUserexecutorInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoTenantUserexecutorCreateInput>
    >;
    /** The primary key(s) for `tenantUserexecutor` for the far side of the relationship. */
    deleteById?: InputMaybe<
      Array<TenantUserexecutorTenantUserexecutorPkeyDelete>
    >;
    /** Flag indicating whether all other `tenantUserexecutor` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The primary key(s) and patch data for `tenantUserexecutor` for the far side of the relationship. */
    updateById?: InputMaybe<
      Array<TenantUserexecutorOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingTenantUserexecutorPkeyUpdate>
    >;
  };

/** The `tenantUserexecutor` to be created by this mutation. */
export type TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoTenantUserexecutorCreateInput =
  {
    applicationUserUsingId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInverseInput>;
    awsCognitoUserUsingId?: InputMaybe<AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    tenantMockuserexecutorUsingId?: InputMaybe<TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInverseInput>;
  };

/** The fields on `tenantUserexecutor` to look up the row to connect. */
export type TenantUserexecutorTenantUserexecutorPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `tenantUserexecutor` to look up the row to delete. */
export type TenantUserexecutorTenantUserexecutorPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** A connection to a list of `TenantUserexecutor` values. */
export type TenantUserexecutorsConnection = {
  __typename: "TenantUserexecutorsConnection";
  /** A list of edges which contains the `TenantUserexecutor` and cursor to aid in pagination. */
  edges: Array<TenantUserexecutorsEdge>;
  /** A list of `TenantUserexecutor` objects. */
  nodes: Array<TenantUserexecutor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TenantUserexecutor` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `TenantUserexecutor` edge in the connection. */
export type TenantUserexecutorsEdge = {
  __typename: "TenantUserexecutorsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `TenantUserexecutor` at the end of the edge. */
  node: TenantUserexecutor;
};

/** Methods to use when ordering `TenantUserexecutor`. */
export enum TenantUserexecutorsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PolymorphicCtypeIdAsc = "POLYMORPHIC_CTYPE_ID_ASC",
  PolymorphicCtypeIdDesc = "POLYMORPHIC_CTYPE_ID_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

/** A `Tenant` edge in the connection. */
export type TenantsEdge = {
  __typename: "TenantsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `Tenant` at the end of the edge. */
  node: Tenant;
};

/** Methods to use when ordering `Tenant`. */
export enum TenantsOrderBy {
  CreatedAsc = "CREATED_ASC",
  CreatedDesc = "CREATED_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  InternalAsc = "INTERNAL_ASC",
  InternalDesc = "INTERNAL_DESC",
  KeyAsc = "KEY_ASC",
  KeyDesc = "KEY_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  RepositoryNameAsc = "REPOSITORY_NAME_ASC",
  RepositoryNameDesc = "REPOSITORY_NAME_DESC",
  SfidAsc = "SFID_ASC",
  SfidDesc = "SFID_DESC",
  StatusAsc = "STATUS_ASC",
  StatusDesc = "STATUS_DESC",
  TenantTypeAsc = "TENANT_TYPE_ASC",
  TenantTypeDesc = "TENANT_TYPE_DESC",
}

/** The `djangoContentType` to be created by this mutation. */
export type TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `TesContainerimageexecutorInput` mutation. */
export type TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `tesContainerimageexecutor` in the `DjangoContentTypeInput` mutation. */
export type TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput =
  {
    /** The primary key(s) for `tesContainerimageexecutor` for the far side of the relationship. */
    connectById?: InputMaybe<
      Array<TesContainerimageexecutorTesContainerimageexecutorPkeyConnect>
    >;
    /** A `TesContainerimageexecutorInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoTesContainerimageexecutorCreateInput>
    >;
    /** The primary key(s) for `tesContainerimageexecutor` for the far side of the relationship. */
    deleteById?: InputMaybe<
      Array<TesContainerimageexecutorTesContainerimageexecutorPkeyDelete>
    >;
    /** Flag indicating whether all other `tesContainerimageexecutor` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The primary key(s) and patch data for `tesContainerimageexecutor` for the far side of the relationship. */
    updateById?: InputMaybe<
      Array<TesContainerimageexecutorOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingTesContainerimageexecutorPkeyUpdate>
    >;
  };

/** The `tesContainerimageexecutor` to be created by this mutation. */
export type TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoTesContainerimageexecutorCreateInput =
  {
    awsEcrImageUsingId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInverseInput>;
    containerImageUsingId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInverseInput>;
    distributionRegistryImageUsingId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    tesMockcontainerimageexecutorUsingId?: InputMaybe<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInverseInput>;
  };

export type TesContainerimageexecutor = {
  __typename: "TesContainerimageexecutor";
  /** Reads a single `AwsEcrImage` that is related to this `TesContainerimageexecutor`. */
  awsEcrImageByContainerimageexecutorPtrId: Maybe<AwsEcrImage>;
  /**
   * Reads and enables pagination through a set of `AwsEcrImage`.
   * @deprecated Please use awsEcrImageByContainerimageexecutorPtrId instead
   */
  awsEcrImagesByContainerimageexecutorPtrId: AwsEcrImagesConnection;
  /** Reads a single `ContainerImage` that is related to this `TesContainerimageexecutor`. */
  containerImageByExecutorId: Maybe<ContainerImage>;
  /**
   * Reads and enables pagination through a set of `ContainerImage`.
   * @deprecated Please use containerImageByExecutorId instead
   */
  containerImagesByExecutorId: ContainerImagesConnection;
  /** Reads a single `DistributionRegistryImage` that is related to this `TesContainerimageexecutor`. */
  distributionRegistryImageByContainerimageexecutorPtrId: Maybe<DistributionRegistryImage>;
  /**
   * Reads and enables pagination through a set of `DistributionRegistryImage`.
   * @deprecated Please use distributionRegistryImageByContainerimageexecutorPtrId instead
   */
  distributionRegistryImagesByContainerimageexecutorPtrId: DistributionRegistryImagesConnection;
  /** Reads a single `DjangoContentType` that is related to this `TesContainerimageexecutor`. */
  djangoContentTypeByPolymorphicCtypeId: Maybe<DjangoContentType>;
  id: Scalars["Int"]["output"];
  polymorphicCtypeId: Maybe<Scalars["Int"]["output"]>;
  /** Reads a single `TesMockcontainerimageexecutor` that is related to this `TesContainerimageexecutor`. */
  tesMockcontainerimageexecutorByContainerimageexecutorPtrId: Maybe<TesMockcontainerimageexecutor>;
  /**
   * Reads and enables pagination through a set of `TesMockcontainerimageexecutor`.
   * @deprecated Please use tesMockcontainerimageexecutorByContainerimageexecutorPtrId instead
   */
  tesMockcontainerimageexecutorsByContainerimageexecutorPtrId: TesMockcontainerimageexecutorsConnection;
};

export type TesContainerimageexecutorAwsEcrImagesByContainerimageexecutorPtrIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<AwsEcrImageCondition>;
    filter?: InputMaybe<AwsEcrImageFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<AwsEcrImagesOrderBy>>;
  };

export type TesContainerimageexecutorContainerImagesByExecutorIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ContainerImageCondition>;
  filter?: InputMaybe<ContainerImageFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContainerImagesOrderBy>>;
};

export type TesContainerimageexecutorDistributionRegistryImagesByContainerimageexecutorPtrIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<DistributionRegistryImageCondition>;
    filter?: InputMaybe<DistributionRegistryImageFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<DistributionRegistryImagesOrderBy>>;
  };

export type TesContainerimageexecutorTesMockcontainerimageexecutorsByContainerimageexecutorPtrIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<TesMockcontainerimageexecutorCondition>;
    filter?: InputMaybe<TesMockcontainerimageexecutorFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<TesMockcontainerimageexecutorsOrderBy>>;
  };

/**
 * A condition to be used against `TesContainerimageexecutor` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type TesContainerimageexecutorCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `polymorphicCtypeId` field. */
  polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `TesContainerimageexecutor` object types. All fields are combined with a logical ‘and.’ */
export type TesContainerimageexecutorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TesContainerimageexecutorFilter>>;
  /** Filter by the object’s `awsEcrImageByContainerimageexecutorPtrId` relation. */
  awsEcrImageByContainerimageexecutorPtrId?: InputMaybe<AwsEcrImageFilter>;
  /** A related `awsEcrImageByContainerimageexecutorPtrId` exists. */
  awsEcrImageByContainerimageexecutorPtrIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `containerImageByExecutorId` relation. */
  containerImageByExecutorId?: InputMaybe<ContainerImageFilter>;
  /** A related `containerImageByExecutorId` exists. */
  containerImageByExecutorIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `distributionRegistryImageByContainerimageexecutorPtrId` relation. */
  distributionRegistryImageByContainerimageexecutorPtrId?: InputMaybe<DistributionRegistryImageFilter>;
  /** A related `distributionRegistryImageByContainerimageexecutorPtrId` exists. */
  distributionRegistryImageByContainerimageexecutorPtrIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `djangoContentTypeByPolymorphicCtypeId` relation. */
  djangoContentTypeByPolymorphicCtypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** A related `djangoContentTypeByPolymorphicCtypeId` exists. */
  djangoContentTypeByPolymorphicCtypeIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TesContainerimageexecutorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TesContainerimageexecutorFilter>>;
  /** Filter by the object’s `polymorphicCtypeId` field. */
  polymorphicCtypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tesMockcontainerimageexecutorByContainerimageexecutorPtrId` relation. */
  tesMockcontainerimageexecutorByContainerimageexecutorPtrId?: InputMaybe<TesMockcontainerimageexecutorFilter>;
  /** A related `tesMockcontainerimageexecutorByContainerimageexecutorPtrId` exists. */
  tesMockcontainerimageexecutorByContainerimageexecutorPtrIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

/** An input for mutations affecting `TesContainerimageexecutor` */
export type TesContainerimageexecutorInput = {
  awsEcrImageUsingId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInverseInput>;
  containerImageUsingId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInverseInput>;
  distributionRegistryImageUsingId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInverseInput>;
  djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
  tesMockcontainerimageexecutorUsingId?: InputMaybe<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInverseInput>;
};

/** The fields on `tesContainerimageexecutor` to look up the row to update. */
export type TesContainerimageexecutorOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaUsingTesContainerimageexecutorPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tesContainerimageexecutor` being updated. */
    tesContainerimageexecutorPatch: UpdateTesContainerimageexecutorOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaPatch;
  };

/** The fields on `tesContainerimageexecutor` to look up the row to update. */
export type TesContainerimageexecutorOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingTesContainerimageexecutorPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tesContainerimageexecutor` being updated. */
    tesContainerimageexecutorPatch: UpdateTesContainerimageexecutorOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaPatch;
  };

/** The fields on `tesContainerimageexecutor` to look up the row to update. */
export type TesContainerimageexecutorOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaUsingTesContainerimageexecutorPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tesContainerimageexecutor` being updated. */
    tesContainerimageexecutorPatch: UpdateTesContainerimageexecutorOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaPatch;
  };

/** The fields on `tesContainerimageexecutor` to look up the row to update. */
export type TesContainerimageexecutorOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingTesContainerimageexecutorPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tesContainerimageexecutor` being updated. */
    tesContainerimageexecutorPatch: UpdateTesContainerimageexecutorOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoPatch;
  };

/** The fields on `tesContainerimageexecutor` to look up the row to update. */
export type TesContainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaUsingTesContainerimageexecutorPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tesContainerimageexecutor` being updated. */
    tesContainerimageexecutorPatch: UpdateTesContainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaPatch;
  };

/** Represents an update to a `TesContainerimageexecutor`. Fields that are set will be updated. */
export type TesContainerimageexecutorPatch = {
  awsEcrImageUsingId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInverseInput>;
  containerImageUsingId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInverseInput>;
  distributionRegistryImageUsingId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInverseInput>;
  djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
  tesMockcontainerimageexecutorUsingId?: InputMaybe<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInverseInput>;
};

/** The fields on `tesContainerimageexecutor` to look up the row to connect. */
export type TesContainerimageexecutorTesContainerimageexecutorPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `tesContainerimageexecutor` to look up the row to delete. */
export type TesContainerimageexecutorTesContainerimageexecutorPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** A connection to a list of `TesContainerimageexecutor` values. */
export type TesContainerimageexecutorsConnection = {
  __typename: "TesContainerimageexecutorsConnection";
  /** A list of edges which contains the `TesContainerimageexecutor` and cursor to aid in pagination. */
  edges: Array<TesContainerimageexecutorsEdge>;
  /** A list of `TesContainerimageexecutor` objects. */
  nodes: Array<TesContainerimageexecutor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TesContainerimageexecutor` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `TesContainerimageexecutor` edge in the connection. */
export type TesContainerimageexecutorsEdge = {
  __typename: "TesContainerimageexecutorsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `TesContainerimageexecutor` at the end of the edge. */
  node: TesContainerimageexecutor;
};

/** Methods to use when ordering `TesContainerimageexecutor`. */
export enum TesContainerimageexecutorsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PolymorphicCtypeIdAsc = "POLYMORPHIC_CTYPE_ID_ASC",
  PolymorphicCtypeIdDesc = "POLYMORPHIC_CTYPE_ID_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

/** Input for the nested mutation of `tesContainerimageexecutor` in the `TesMockcontainerimageexecutorInput` mutation. */
export type TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInput = {
  /** The primary key(s) for `tesContainerimageexecutor` for the far side of the relationship. */
  connectById?: InputMaybe<TesContainerimageexecutorTesContainerimageexecutorPkeyConnect>;
  /** A `TesContainerimageexecutorInput` object that will be created and connected to this object. */
  create?: InputMaybe<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaTesContainerimageexecutorCreateInput>;
  /** The primary key(s) for `tesContainerimageexecutor` for the far side of the relationship. */
  deleteById?: InputMaybe<TesContainerimageexecutorTesContainerimageexecutorPkeyDelete>;
  /** The primary key(s) and patch data for `tesContainerimageexecutor` for the far side of the relationship. */
  updateById?: InputMaybe<TesContainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaUsingTesContainerimageexecutorPkeyUpdate>;
};

/** Input for the nested mutation of `tesMockcontainerimageexecutor` in the `TesContainerimageexecutorInput` mutation. */
export type TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInverseInput =
  {
    /** The primary key(s) for `tesMockcontainerimageexecutor` for the far side of the relationship. */
    connectByContainerimageexecutorPtrId?: InputMaybe<TesMockcontainerimageexecutorTesMockcontainerimageexecutorPkeyConnect>;
    /** A `TesMockcontainerimageexecutorInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaTesMockcontainerimageexecutorCreateInput>
    >;
    /** The primary key(s) for `tesMockcontainerimageexecutor` for the far side of the relationship. */
    deleteByContainerimageexecutorPtrId?: InputMaybe<TesMockcontainerimageexecutorTesMockcontainerimageexecutorPkeyDelete>;
    /** Flag indicating whether all other `tesMockcontainerimageexecutor` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The primary key(s) and patch data for `tesMockcontainerimageexecutor` for the far side of the relationship. */
    updateByContainerimageexecutorPtrId?: InputMaybe<TesMockcontainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaUsingTesMockcontainerimageexecutorPkeyUpdate>;
  };

/** The `tesContainerimageexecutor` to be created by this mutation. */
export type TesMockcontainerimaContainerimageexecut4Eced924FkTesContaTesContainerimageexecutorCreateInput =
  {
    awsEcrImageUsingId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInverseInput>;
    containerImageUsingId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInverseInput>;
    distributionRegistryImageUsingId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    tesMockcontainerimageexecutorUsingId?: InputMaybe<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInverseInput>;
  };

/** The `tesMockcontainerimageexecutor` to be created by this mutation. */
export type TesMockcontainerimaContainerimageexecut4Eced924FkTesContaTesMockcontainerimageexecutorCreateInput =
  {
    tesContainerimageexecutorToContainerimageexecutorPtrId?: InputMaybe<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInput>;
  };

export type TesMockcontainerimageexecutor = {
  __typename: "TesMockcontainerimageexecutor";
  containerimageexecutorPtrId: Scalars["Int"]["output"];
  /** Reads a single `TesContainerimageexecutor` that is related to this `TesMockcontainerimageexecutor`. */
  tesContainerimageexecutorByContainerimageexecutorPtrId: Maybe<TesContainerimageexecutor>;
};

/**
 * A condition to be used against `TesMockcontainerimageexecutor` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type TesMockcontainerimageexecutorCondition = {
  /** Checks for equality with the object’s `containerimageexecutorPtrId` field. */
  containerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `TesMockcontainerimageexecutor` object types. All fields are combined with a logical ‘and.’ */
export type TesMockcontainerimageexecutorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TesMockcontainerimageexecutorFilter>>;
  /** Filter by the object’s `containerimageexecutorPtrId` field. */
  containerimageexecutorPtrId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TesMockcontainerimageexecutorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TesMockcontainerimageexecutorFilter>>;
  /** Filter by the object’s `tesContainerimageexecutorByContainerimageexecutorPtrId` relation. */
  tesContainerimageexecutorByContainerimageexecutorPtrId?: InputMaybe<TesContainerimageexecutorFilter>;
};

/** An input for mutations affecting `TesMockcontainerimageexecutor` */
export type TesMockcontainerimageexecutorInput = {
  containerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
  tesContainerimageexecutorToContainerimageexecutorPtrId?: InputMaybe<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInput>;
};

/** The fields on `tesMockcontainerimageexecutor` to look up the row to update. */
export type TesMockcontainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaUsingTesMockcontainerimageexecutorPkeyUpdate =
  {
    containerimageexecutorPtrId: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tesMockcontainerimageexecutor` being updated. */
    tesMockcontainerimageexecutorPatch: UpdateTesMockcontainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaPatch;
  };

/** Represents an update to a `TesMockcontainerimageexecutor`. Fields that are set will be updated. */
export type TesMockcontainerimageexecutorPatch = {
  containerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
  tesContainerimageexecutorToContainerimageexecutorPtrId?: InputMaybe<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInput>;
};

/** The fields on `tesMockcontainerimageexecutor` to look up the row to connect. */
export type TesMockcontainerimageexecutorTesMockcontainerimageexecutorPkeyConnect =
  {
    containerimageexecutorPtrId: Scalars["Int"]["input"];
  };

/** The fields on `tesMockcontainerimageexecutor` to look up the row to delete. */
export type TesMockcontainerimageexecutorTesMockcontainerimageexecutorPkeyDelete =
  {
    containerimageexecutorPtrId: Scalars["Int"]["input"];
  };

/** A connection to a list of `TesMockcontainerimageexecutor` values. */
export type TesMockcontainerimageexecutorsConnection = {
  __typename: "TesMockcontainerimageexecutorsConnection";
  /** A list of edges which contains the `TesMockcontainerimageexecutor` and cursor to aid in pagination. */
  edges: Array<TesMockcontainerimageexecutorsEdge>;
  /** A list of `TesMockcontainerimageexecutor` objects. */
  nodes: Array<TesMockcontainerimageexecutor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TesMockcontainerimageexecutor` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `TesMockcontainerimageexecutor` edge in the connection. */
export type TesMockcontainerimageexecutorsEdge = {
  __typename: "TesMockcontainerimageexecutorsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `TesMockcontainerimageexecutor` at the end of the edge. */
  node: TesMockcontainerimageexecutor;
};

/** Methods to use when ordering `TesMockcontainerimageexecutor`. */
export enum TesMockcontainerimageexecutorsOrderBy {
  ContainerimageexecutorPtrIdAsc = "CONTAINERIMAGEEXECUTOR_PTR_ID_ASC",
  ContainerimageexecutorPtrIdDesc = "CONTAINERIMAGEEXECUTOR_PTR_ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type TesMocktaskexecutor = {
  __typename: "TesMocktaskexecutor";
  taskexecutorPtrId: Scalars["UUID"]["output"];
  /** Reads a single `TesTaskexecutor` that is related to this `TesMocktaskexecutor`. */
  tesTaskexecutorByTaskexecutorPtrId: Maybe<TesTaskexecutor>;
};

/**
 * A condition to be used against `TesMocktaskexecutor` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type TesMocktaskexecutorCondition = {
  /** Checks for equality with the object’s `taskexecutorPtrId` field. */
  taskexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `TesMocktaskexecutor` object types. All fields are combined with a logical ‘and.’ */
export type TesMocktaskexecutorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TesMocktaskexecutorFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<TesMocktaskexecutorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TesMocktaskexecutorFilter>>;
  /** Filter by the object’s `taskexecutorPtrId` field. */
  taskexecutorPtrId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tesTaskexecutorByTaskexecutorPtrId` relation. */
  tesTaskexecutorByTaskexecutorPtrId?: InputMaybe<TesTaskexecutorFilter>;
};

/** An input for mutations affecting `TesMocktaskexecutor` */
export type TesMocktaskexecutorInput = {
  taskexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
  tesTaskexecutorToTaskexecutorPtrId?: InputMaybe<TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInput>;
};

/** The fields on `tesMocktaskexecutor` to look up the row to update. */
export type TesMocktaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeUsingTesMocktaskexecutorPkeyUpdate =
  {
    taskexecutorPtrId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `tesMocktaskexecutor` being updated. */
    tesMocktaskexecutorPatch: UpdateTesMocktaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskePatch;
  };

/** Represents an update to a `TesMocktaskexecutor`. Fields that are set will be updated. */
export type TesMocktaskexecutorPatch = {
  taskexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
  tesTaskexecutorToTaskexecutorPtrId?: InputMaybe<TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInput>;
};

/** Input for the nested mutation of `tesTaskexecutor` in the `TesMocktaskexecutorInput` mutation. */
export type TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInput = {
  /** The primary key(s) for `tesTaskexecutor` for the far side of the relationship. */
  connectById?: InputMaybe<TesTaskexecutorTesTaskexecutorPkeyConnect>;
  /** A `TesTaskexecutorInput` object that will be created and connected to this object. */
  create?: InputMaybe<TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeTesTaskexecutorCreateInput>;
  /** The primary key(s) for `tesTaskexecutor` for the far side of the relationship. */
  deleteById?: InputMaybe<TesTaskexecutorTesTaskexecutorPkeyDelete>;
  /** The primary key(s) and patch data for `tesTaskexecutor` for the far side of the relationship. */
  updateById?: InputMaybe<TesTaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeUsingTesTaskexecutorPkeyUpdate>;
};

/** Input for the nested mutation of `tesMocktaskexecutor` in the `TesTaskexecutorInput` mutation. */
export type TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInverseInput =
  {
    /** The primary key(s) for `tesMocktaskexecutor` for the far side of the relationship. */
    connectByTaskexecutorPtrId?: InputMaybe<TesMocktaskexecutorTesMocktaskexecutorPkeyConnect>;
    /** A `TesMocktaskexecutorInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeTesMocktaskexecutorCreateInput>
    >;
    /** The primary key(s) for `tesMocktaskexecutor` for the far side of the relationship. */
    deleteByTaskexecutorPtrId?: InputMaybe<TesMocktaskexecutorTesMocktaskexecutorPkeyDelete>;
    /** Flag indicating whether all other `tesMocktaskexecutor` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The primary key(s) and patch data for `tesMocktaskexecutor` for the far side of the relationship. */
    updateByTaskexecutorPtrId?: InputMaybe<TesMocktaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeUsingTesMocktaskexecutorPkeyUpdate>;
  };

/** The `tesMocktaskexecutor` to be created by this mutation. */
export type TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeTesMocktaskexecutorCreateInput =
  {
    tesTaskexecutorToTaskexecutorPtrId?: InputMaybe<TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInput>;
  };

/** The `tesTaskexecutor` to be created by this mutation. */
export type TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeTesTaskexecutorCreateInput =
  {
    awsBatchTaskUsingId?: InputMaybe<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInput>;
    id: Scalars["UUID"]["input"];
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    taskUsingId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInverseInput>;
    tesMocktaskexecutorUsingId?: InputMaybe<TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInverseInput>;
  };

/** The fields on `tesMocktaskexecutor` to look up the row to connect. */
export type TesMocktaskexecutorTesMocktaskexecutorPkeyConnect = {
  taskexecutorPtrId: Scalars["UUID"]["input"];
};

/** The fields on `tesMocktaskexecutor` to look up the row to delete. */
export type TesMocktaskexecutorTesMocktaskexecutorPkeyDelete = {
  taskexecutorPtrId: Scalars["UUID"]["input"];
};

/** A connection to a list of `TesMocktaskexecutor` values. */
export type TesMocktaskexecutorsConnection = {
  __typename: "TesMocktaskexecutorsConnection";
  /** A list of edges which contains the `TesMocktaskexecutor` and cursor to aid in pagination. */
  edges: Array<TesMocktaskexecutorsEdge>;
  /** A list of `TesMocktaskexecutor` objects. */
  nodes: Array<TesMocktaskexecutor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TesMocktaskexecutor` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `TesMocktaskexecutor` edge in the connection. */
export type TesMocktaskexecutorsEdge = {
  __typename: "TesMocktaskexecutorsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `TesMocktaskexecutor` at the end of the edge. */
  node: TesMocktaskexecutor;
};

/** Methods to use when ordering `TesMocktaskexecutor`. */
export enum TesMocktaskexecutorsOrderBy {
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  TaskexecutorPtrIdAsc = "TASKEXECUTOR_PTR_ID_ASC",
  TaskexecutorPtrIdDesc = "TASKEXECUTOR_PTR_ID_DESC",
}

export type TesTaskexecutor = {
  __typename: "TesTaskexecutor";
  /** Reads a single `AwsBatchTask` that is related to this `TesTaskexecutor`. */
  awsBatchTaskByTaskexecutorPtrId: Maybe<AwsBatchTask>;
  /**
   * Reads and enables pagination through a set of `AwsBatchTask`.
   * @deprecated Please use awsBatchTaskByTaskexecutorPtrId instead
   */
  awsBatchTasksByTaskexecutorPtrId: AwsBatchTasksConnection;
  /** Reads a single `DjangoContentType` that is related to this `TesTaskexecutor`. */
  djangoContentTypeByPolymorphicCtypeId: Maybe<DjangoContentType>;
  id: Scalars["UUID"]["output"];
  polymorphicCtypeId: Maybe<Scalars["Int"]["output"]>;
  /** Reads a single `Task` that is related to this `TesTaskexecutor`. */
  taskByExecutorId: Maybe<Task>;
  /**
   * Reads and enables pagination through a set of `Task`.
   * @deprecated Please use taskByExecutorId instead
   */
  tasksByExecutorId: TasksConnection;
  /** Reads a single `TesMocktaskexecutor` that is related to this `TesTaskexecutor`. */
  tesMocktaskexecutorByTaskexecutorPtrId: Maybe<TesMocktaskexecutor>;
  /**
   * Reads and enables pagination through a set of `TesMocktaskexecutor`.
   * @deprecated Please use tesMocktaskexecutorByTaskexecutorPtrId instead
   */
  tesMocktaskexecutorsByTaskexecutorPtrId: TesMocktaskexecutorsConnection;
};

export type TesTaskexecutorAwsBatchTasksByTaskexecutorPtrIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<AwsBatchTaskCondition>;
  filter?: InputMaybe<AwsBatchTaskFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<AwsBatchTasksOrderBy>>;
};

export type TesTaskexecutorTasksByExecutorIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

export type TesTaskexecutorTesMocktaskexecutorsByTaskexecutorPtrIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TesMocktaskexecutorCondition>;
  filter?: InputMaybe<TesMocktaskexecutorFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TesMocktaskexecutorsOrderBy>>;
};

/**
 * A condition to be used against `TesTaskexecutor` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TesTaskexecutorCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `polymorphicCtypeId` field. */
  polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `TesTaskexecutor` object types. All fields are combined with a logical ‘and.’ */
export type TesTaskexecutorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TesTaskexecutorFilter>>;
  /** Filter by the object’s `awsBatchTaskByTaskexecutorPtrId` relation. */
  awsBatchTaskByTaskexecutorPtrId?: InputMaybe<AwsBatchTaskFilter>;
  /** A related `awsBatchTaskByTaskexecutorPtrId` exists. */
  awsBatchTaskByTaskexecutorPtrIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `djangoContentTypeByPolymorphicCtypeId` relation. */
  djangoContentTypeByPolymorphicCtypeId?: InputMaybe<DjangoContentTypeFilter>;
  /** A related `djangoContentTypeByPolymorphicCtypeId` exists. */
  djangoContentTypeByPolymorphicCtypeIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TesTaskexecutorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TesTaskexecutorFilter>>;
  /** Filter by the object’s `polymorphicCtypeId` field. */
  polymorphicCtypeId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `taskByExecutorId` relation. */
  taskByExecutorId?: InputMaybe<TaskFilter>;
  /** A related `taskByExecutorId` exists. */
  taskByExecutorIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `tesMocktaskexecutorByTaskexecutorPtrId` relation. */
  tesMocktaskexecutorByTaskexecutorPtrId?: InputMaybe<TesMocktaskexecutorFilter>;
  /** A related `tesMocktaskexecutorByTaskexecutorPtrId` exists. */
  tesMocktaskexecutorByTaskexecutorPtrIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

/** An input for mutations affecting `TesTaskexecutor` */
export type TesTaskexecutorInput = {
  awsBatchTaskUsingId?: InputMaybe<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInverseInput>;
  djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInput>;
  id: Scalars["UUID"]["input"];
  polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
  taskUsingId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInverseInput>;
  tesMocktaskexecutorUsingId?: InputMaybe<TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInverseInput>;
};

/** The fields on `tesTaskexecutor` to look up the row to update. */
export type TesTaskexecutorOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeUsingTesTaskexecutorPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `tesTaskexecutor` being updated. */
    tesTaskexecutorPatch: UpdateTesTaskexecutorOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskePatch;
  };

/** The fields on `tesTaskexecutor` to look up the row to update. */
export type TesTaskexecutorOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTesTaskexecutorPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `tesTaskexecutor` being updated. */
    tesTaskexecutorPatch: UpdateTesTaskexecutorOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdPatch;
  };

/** The fields on `tesTaskexecutor` to look up the row to update. */
export type TesTaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeUsingTesTaskexecutorPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `tesTaskexecutor` being updated. */
    tesTaskexecutorPatch: UpdateTesTaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskePatch;
  };

/** The fields on `tesTaskexecutor` to look up the row to update. */
export type TesTaskexecutorOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingTesTaskexecutorPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `tesTaskexecutor` being updated. */
    tesTaskexecutorPatch: UpdateTesTaskexecutorOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoPatch;
  };

/** Represents an update to a `TesTaskexecutor`. Fields that are set will be updated. */
export type TesTaskexecutorPatch = {
  awsBatchTaskUsingId?: InputMaybe<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInverseInput>;
  djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
  taskUsingId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInverseInput>;
  tesMocktaskexecutorUsingId?: InputMaybe<TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInverseInput>;
};

/** The `djangoContentType` to be created by this mutation. */
export type TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoDjangoContentTypeCreateInput =
  {
    appLabel: Scalars["String"]["input"];
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model: Scalars["String"]["input"];
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** Input for the nested mutation of `djangoContentType` in the `TesTaskexecutorInput` mutation. */
export type TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInput = {
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  connectById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyConnect>;
  /** A `DjangoContentTypeInput` object that will be created and connected to this object. */
  create?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoDjangoContentTypeCreateInput>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteByAppLabelAndModel?: InputMaybe<DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete>;
  /** The primary key(s) for `djangoContentType` for the far side of the relationship. */
  deleteById?: InputMaybe<DjangoContentTypeDjangoContentTypePkeyDelete>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateByAppLabelAndModel?: InputMaybe<DjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate>;
  /** The primary key(s) and patch data for `djangoContentType` for the far side of the relationship. */
  updateById?: InputMaybe<DjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingDjangoContentTypePkeyUpdate>;
};

/** Input for the nested mutation of `tesTaskexecutor` in the `DjangoContentTypeInput` mutation. */
export type TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput = {
  /** The primary key(s) for `tesTaskexecutor` for the far side of the relationship. */
  connectById?: InputMaybe<Array<TesTaskexecutorTesTaskexecutorPkeyConnect>>;
  /** A `TesTaskexecutorInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoTesTaskexecutorCreateInput>
  >;
  /** The primary key(s) for `tesTaskexecutor` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<TesTaskexecutorTesTaskexecutorPkeyDelete>>;
  /** Flag indicating whether all other `tesTaskexecutor` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `tesTaskexecutor` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<TesTaskexecutorOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingTesTaskexecutorPkeyUpdate>
  >;
};

/** The `tesTaskexecutor` to be created by this mutation. */
export type TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoTesTaskexecutorCreateInput =
  {
    awsBatchTaskUsingId?: InputMaybe<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInput>;
    id: Scalars["UUID"]["input"];
    taskUsingId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInverseInput>;
    tesMocktaskexecutorUsingId?: InputMaybe<TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInverseInput>;
  };

/** The fields on `tesTaskexecutor` to look up the row to connect. */
export type TesTaskexecutorTesTaskexecutorPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `tesTaskexecutor` to look up the row to delete. */
export type TesTaskexecutorTesTaskexecutorPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** A connection to a list of `TesTaskexecutor` values. */
export type TesTaskexecutorsConnection = {
  __typename: "TesTaskexecutorsConnection";
  /** A list of edges which contains the `TesTaskexecutor` and cursor to aid in pagination. */
  edges: Array<TesTaskexecutorsEdge>;
  /** A list of `TesTaskexecutor` objects. */
  nodes: Array<TesTaskexecutor>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TesTaskexecutor` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `TesTaskexecutor` edge in the connection. */
export type TesTaskexecutorsEdge = {
  __typename: "TesTaskexecutorsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `TesTaskexecutor` at the end of the edge. */
  node: TesTaskexecutor;
};

/** Methods to use when ordering `TesTaskexecutor`. */
export enum TesTaskexecutorsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PolymorphicCtypeIdAsc = "POLYMORPHIC_CTYPE_ID_ASC",
  PolymorphicCtypeIdDesc = "POLYMORPHIC_CTYPE_ID_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type Tool = {
  __typename: "Tool";
  /** Reads a single `ApplicationUser` that is related to this `Tool`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  codeLink: Maybe<Scalars["String"]["output"]>;
  created: Maybe<Scalars["Datetime"]["output"]>;
  dateCreated: Scalars["Datetime"]["output"];
  docsLink: Maybe<Scalars["String"]["output"]>;
  helpText: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  key: Scalars["String"]["output"];
  maturity: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `PinnedTool`. */
  pinnedToolsByToolId: PinnedToolsConnection;
  /** Reads a single `Project` that is related to this `Tool`. */
  projectByProjectId: Maybe<Project>;
  projectId: Maybe<Scalars["UUID"]["output"]>;
  searchTerms: Maybe<Scalars["JSON"]["output"]>;
  status: Scalars["Int"]["output"];
  tags: Array<Maybe<Scalars["String"]["output"]>>;
  /** Reads a single `Tenant` that is related to this `Tool`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Maybe<Scalars["Int"]["output"]>;
  /** Reads and enables pagination through a set of `ToolTenant`. */
  toolTenantsByToolId: ToolTenantsConnection;
  /** Reads and enables pagination through a set of `ToolVersion`. */
  toolVersionsByToolId: ToolVersionsConnection;
  /** Reads a single `Toolbox` that is related to this `Tool`. */
  toolboxByToolboxId: Maybe<Toolbox>;
  toolboxId: Maybe<Scalars["Int"]["output"]>;
  userId: Maybe<Scalars["UUID"]["output"]>;
  visibility: Scalars["Int"]["output"];
};

export type ToolPinnedToolsByToolIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<PinnedToolCondition>;
  filter?: InputMaybe<PinnedToolFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<PinnedToolsOrderBy>>;
};

export type ToolToolTenantsByToolIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolTenantCondition>;
  filter?: InputMaybe<ToolTenantFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolTenantsOrderBy>>;
};

export type ToolToolVersionsByToolIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolVersionCondition>;
  filter?: InputMaybe<ToolVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolVersionsOrderBy>>;
};

/** A condition to be used against `Tool` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ToolCondition = {
  /** Checks for equality with the object’s `codeLink` field. */
  codeLink?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `docsLink` field. */
  docsLink?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `helpText` field. */
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `maturity` field. */
  maturity?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `searchTerms` field. */
  searchTerms?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `tags` field. */
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `toolboxId` field. */
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `visibility` field. */
  visibility?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `Tool` object types. All fields are combined with a logical ‘and.’ */
export type ToolFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ToolFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `codeLink` field. */
  codeLink?: InputMaybe<StringFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `docsLink` field. */
  docsLink?: InputMaybe<StringFilter>;
  /** Filter by the object’s `helpText` field. */
  helpText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `maturity` field. */
  maturity?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ToolFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ToolFilter>>;
  /** Filter by the object’s `pinnedToolsByToolId` relation. */
  pinnedToolsByToolId?: InputMaybe<ToolToManyPinnedToolFilter>;
  /** Some related `pinnedToolsByToolId` exist. */
  pinnedToolsByToolIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `projectByProjectId` relation. */
  projectByProjectId?: InputMaybe<ProjectFilter>;
  /** A related `projectByProjectId` exists. */
  projectByProjectIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `searchTerms` field. */
  searchTerms?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** A related `tenantByTenantId` exists. */
  tenantByTenantIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toolTenantsByToolId` relation. */
  toolTenantsByToolId?: InputMaybe<ToolToManyToolTenantFilter>;
  /** Some related `toolTenantsByToolId` exist. */
  toolTenantsByToolIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `toolVersionsByToolId` relation. */
  toolVersionsByToolId?: InputMaybe<ToolToManyToolVersionFilter>;
  /** Some related `toolVersionsByToolId` exist. */
  toolVersionsByToolIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `toolboxByToolboxId` relation. */
  toolboxByToolboxId?: InputMaybe<ToolboxFilter>;
  /** A related `toolboxByToolboxId` exists. */
  toolboxByToolboxIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `toolboxId` field. */
  toolboxId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `visibility` field. */
  visibility?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `Tool` */
export type ToolInput = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  codeLink?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  docsLink?: InputMaybe<Scalars["String"]["input"]>;
  helpText: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key: Scalars["String"]["input"];
  maturity: Scalars["Int"]["input"];
  name: Scalars["String"]["input"];
  pinnedToolsUsingId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  searchTerms?: InputMaybe<Scalars["JSON"]["input"]>;
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
  toolboxToToolboxId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  visibility: Scalars["Int"]["input"];
};

/** The fields on `tool` to look up the row to update. */
export type ToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingToolPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tool` being updated. */
    toolPatch: UpdateToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdPatch;
  };

/** The fields on `tool` to look up the row to update. */
export type ToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingToolProjectIdKeyUpdate =
  {
    projectId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `tool` being updated. */
    toolPatch: UpdateToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdPatch;
  };

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolPkeyUpdate = {
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `tool` being updated. */
  toolPatch: UpdateToolOnToolForToolProjectId20A84210FkProjectIdPatch;
};

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolProjectIdKeyUpdate =
  {
    projectId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `tool` being updated. */
    toolPatch: UpdateToolOnToolForToolProjectId20A84210FkProjectIdPatch;
  };

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolPkeyUpdate = {
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `tool` being updated. */
  toolPatch: UpdateToolOnToolForToolTenantId1Baab08EFkTenantIdPatch;
};

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolProjectIdKeyUpdate =
  {
    projectId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `tool` being updated. */
    toolPatch: UpdateToolOnToolForToolTenantId1Baab08EFkTenantIdPatch;
  };

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolPkeyUpdate = {
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `tool` being updated. */
  toolPatch: UpdateToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdPatch;
};

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolProjectIdKeyUpdate =
  {
    projectId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `tool` being updated. */
    toolPatch: UpdateToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdPatch;
  };

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tool` being updated. */
    toolPatch: UpdateToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
  };

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolProjectIdKeyUpdate =
  {
    projectId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `tool` being updated. */
    toolPatch: UpdateToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
  };

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tool` being updated. */
    toolPatch: UpdateToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch;
  };

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolProjectIdKeyUpdate =
  {
    projectId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `tool` being updated. */
    toolPatch: UpdateToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch;
  };

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `tool` being updated. */
    toolPatch: UpdateToolOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch;
  };

/** The fields on `tool` to look up the row to update. */
export type ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolProjectIdKeyUpdate =
  {
    projectId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `tool` being updated. */
    toolPatch: UpdateToolOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch;
  };

export type ToolParameter = {
  __typename: "ToolParameter";
  default: Maybe<Scalars["JSON"]["output"]>;
  helpText: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  options: Maybe<Scalars["JSON"]["output"]>;
  required: Scalars["Boolean"]["output"];
  /** Reads a single `ToolVersion` that is related to this `ToolParameter`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
  toolVersionId: Scalars["Int"]["output"];
  unit: Maybe<Scalars["String"]["output"]>;
};

/**
 * A condition to be used against `ToolParameter` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ToolParameterCondition = {
  /** Checks for equality with the object’s `default` field. */
  default?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `helpText` field. */
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `options` field. */
  options?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `required` field. */
  required?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `unit` field. */
  unit?: InputMaybe<Scalars["String"]["input"]>;
};

/** A filter to be used against `ToolParameter` object types. All fields are combined with a logical ‘and.’ */
export type ToolParameterFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ToolParameterFilter>>;
  /** Filter by the object’s `default` field. */
  default?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `helpText` field. */
  helpText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ToolParameterFilter>;
  /** Filter by the object’s `options` field. */
  options?: InputMaybe<JsonFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ToolParameterFilter>>;
  /** Filter by the object’s `required` field. */
  required?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `toolVersionByToolVersionId` relation. */
  toolVersionByToolVersionId?: InputMaybe<ToolVersionFilter>;
  /** Filter by the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `unit` field. */
  unit?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `ToolParameter` */
export type ToolParameterInput = {
  default?: InputMaybe<Scalars["JSON"]["input"]>;
  helpText: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  options?: InputMaybe<Scalars["JSON"]["input"]>;
  required: Scalars["Boolean"]["input"];
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInput>;
  unit?: InputMaybe<Scalars["String"]["input"]>;
};

/** The fields on `toolParameter` to look up the row to update. */
export type ToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolParameterPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolParameter` being updated. */
    toolParameterPatch: UpdateToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch;
  };

/** Represents an update to a `ToolParameter`. Fields that are set will be updated. */
export type ToolParameterPatch = {
  default?: InputMaybe<Scalars["JSON"]["input"]>;
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  options?: InputMaybe<Scalars["JSON"]["input"]>;
  required?: InputMaybe<Scalars["Boolean"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInput>;
  unit?: InputMaybe<Scalars["String"]["input"]>;
};

/** The fields on `toolParameter` to look up the row to connect. */
export type ToolParameterToolParameterPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `toolParameter` to look up the row to delete. */
export type ToolParameterToolParameterPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** Input for the nested mutation of `toolVersion` in the `ToolParameterInput` mutation. */
export type ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<ToolVersionToolVersionPkeyConnect>;
  /** A `ToolVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdToolVersionCreateInput>;
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<ToolVersionToolVersionPkeyDelete>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<ToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolVersionPkeyUpdate>;
};

/** Input for the nested mutation of `toolParameter` in the `ToolVersionInput` mutation. */
export type ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput = {
  /** The primary key(s) for `toolParameter` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolParameterToolParameterPkeyConnect>>;
  /** A `ToolParameterInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdToolParameterCreateInput>
  >;
  /** The primary key(s) for `toolParameter` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ToolParameterToolParameterPkeyDelete>>;
  /** Flag indicating whether all other `toolParameter` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `toolParameter` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolParameterPkeyUpdate>
  >;
};

/** The `toolParameter` to be created by this mutation. */
export type ToolParameterToolVersionIdC3A0Df75FkToolVersionIdToolParameterCreateInput =
  {
    default?: InputMaybe<Scalars["JSON"]["input"]>;
    helpText: Scalars["String"]["input"];
    id?: InputMaybe<Scalars["Int"]["input"]>;
    key: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    options?: InputMaybe<Scalars["JSON"]["input"]>;
    required: Scalars["Boolean"]["input"];
    toolVersionToToolVersionId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInput>;
    unit?: InputMaybe<Scalars["String"]["input"]>;
  };

/** The `toolVersion` to be created by this mutation. */
export type ToolParameterToolVersionIdC3A0Df75FkToolVersionIdToolVersionCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible: Scalars["Boolean"]["input"];
    isUpgradableToNextVersion: Scalars["Boolean"]["input"];
    maturity: Scalars["Int"]["input"];
    status: Scalars["Int"]["input"];
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion: Scalars["Int"]["input"];
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version: Scalars["String"]["input"];
    visibility: Scalars["Int"]["input"];
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** A connection to a list of `ToolParameter` values. */
export type ToolParametersConnection = {
  __typename: "ToolParametersConnection";
  /** A list of edges which contains the `ToolParameter` and cursor to aid in pagination. */
  edges: Array<ToolParametersEdge>;
  /** A list of `ToolParameter` objects. */
  nodes: Array<ToolParameter>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ToolParameter` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ToolParameter` edge in the connection. */
export type ToolParametersEdge = {
  __typename: "ToolParametersEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ToolParameter` at the end of the edge. */
  node: ToolParameter;
};

/** Methods to use when ordering `ToolParameter`. */
export enum ToolParametersOrderBy {
  DefaultAsc = "DEFAULT_ASC",
  DefaultDesc = "DEFAULT_DESC",
  HelpTextAsc = "HELP_TEXT_ASC",
  HelpTextDesc = "HELP_TEXT_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  KeyAsc = "KEY_ASC",
  KeyDesc = "KEY_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  OptionsAsc = "OPTIONS_ASC",
  OptionsDesc = "OPTIONS_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  RequiredAsc = "REQUIRED_ASC",
  RequiredDesc = "REQUIRED_DESC",
  ToolVersionIdAsc = "TOOL_VERSION_ID_ASC",
  ToolVersionIdDesc = "TOOL_VERSION_ID_DESC",
  UnitAsc = "UNIT_ASC",
  UnitDesc = "UNIT_DESC",
}

/** Represents an update to a `Tool`. Fields that are set will be updated. */
export type ToolPatch = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  codeLink?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  docsLink?: InputMaybe<Scalars["String"]["input"]>;
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  maturity?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  pinnedToolsUsingId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  searchTerms?: InputMaybe<Scalars["JSON"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
  toolboxToToolboxId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  visibility?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input for the nested mutation of `project` in the `ToolInput` mutation. */
export type ToolProjectId20A84210FkProjectIdInput = {
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectById?: InputMaybe<ProjectProjectPkeyConnect>;
  /** The primary key(s) for `project` for the far side of the relationship. */
  connectByKeyAndTenantId?: InputMaybe<ProjectProjectKeyTenantUniqueConnect>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateById?: InputMaybe<ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectPkeyUpdate>;
  /** The primary key(s) and patch data for `project` for the far side of the relationship. */
  updateByKeyAndTenantId?: InputMaybe<ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectKeyTenantUniqueUpdate>;
};

/** Input for the nested mutation of `tool` in the `ProjectInput` mutation. */
export type ToolProjectId20A84210FkProjectIdInverseInput = {
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectById?: InputMaybe<ToolToolPkeyConnect>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectByProjectId?: InputMaybe<ToolToolProjectIdKeyConnect>;
  /** A `ToolInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ToolProjectId20A84210FkProjectIdToolCreateInput>>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  deleteById?: InputMaybe<ToolToolPkeyDelete>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  deleteByProjectId?: InputMaybe<ToolToolProjectIdKeyDelete>;
  /** Flag indicating whether all other `tool` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateById?: InputMaybe<ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolPkeyUpdate>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateByProjectId?: InputMaybe<ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolProjectIdKeyUpdate>;
};

/** The `tool` to be created by this mutation. */
export type ToolProjectId20A84210FkProjectIdToolCreateInput = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  codeLink?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  docsLink?: InputMaybe<Scalars["String"]["input"]>;
  helpText: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key: Scalars["String"]["input"];
  maturity: Scalars["Int"]["input"];
  name: Scalars["String"]["input"];
  pinnedToolsUsingId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInverseInput>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  searchTerms?: InputMaybe<Scalars["JSON"]["input"]>;
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
  toolboxToToolboxId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  visibility: Scalars["Int"]["input"];
};

export type ToolResource = {
  __typename: "ToolResource";
  id: Scalars["Int"]["output"];
  /** Reads a single `ToolVersion` that is related to this `ToolResource`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
  toolVersionId: Scalars["Int"]["output"];
  type: Scalars["Int"]["output"];
  value: Scalars["Int"]["output"];
};

/**
 * A condition to be used against `ToolResource` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ToolResourceCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `ToolResource` object types. All fields are combined with a logical ‘and.’ */
export type ToolResourceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ToolResourceFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ToolResourceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ToolResourceFilter>>;
  /** Filter by the object’s `toolVersionByToolVersionId` relation. */
  toolVersionByToolVersionId?: InputMaybe<ToolVersionFilter>;
  /** Filter by the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<IntFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ToolResource` */
export type ToolResourceInput = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInput>;
  type: Scalars["Int"]["input"];
  value: Scalars["Int"]["input"];
};

/** The fields on `toolResource` to look up the row to update. */
export type ToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingReqTypeToolVersionUniqueUpdate =
  {
    /** An object where the defined keys will be set on the `toolResource` being updated. */
    toolResourcePatch: UpdateToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdPatch;
    toolVersionId: Scalars["Int"]["input"];
    type: Scalars["Int"]["input"];
  };

/** The fields on `toolResource` to look up the row to update. */
export type ToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingToolResourcePkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolResource` being updated. */
    toolResourcePatch: UpdateToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdPatch;
  };

/** Represents an update to a `ToolResource`. Fields that are set will be updated. */
export type ToolResourcePatch = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInput>;
  type?: InputMaybe<Scalars["Int"]["input"]>;
  value?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The fields on `toolResource` to look up the row to connect. */
export type ToolResourceReqTypeToolVersionUniqueConnect = {
  toolVersionId: Scalars["Int"]["input"];
  type: Scalars["Int"]["input"];
};

/** The fields on `toolResource` to look up the row to delete. */
export type ToolResourceReqTypeToolVersionUniqueDelete = {
  toolVersionId: Scalars["Int"]["input"];
  type: Scalars["Int"]["input"];
};

/** The fields on `toolResource` to look up the row to connect. */
export type ToolResourceToolResourcePkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `toolResource` to look up the row to delete. */
export type ToolResourceToolResourcePkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** Input for the nested mutation of `toolVersion` in the `ToolResourceInput` mutation. */
export type ToolResourceToolVersionId5E21979DFkToolVersionIdInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<ToolVersionToolVersionPkeyConnect>;
  /** A `ToolVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdToolVersionCreateInput>;
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<ToolVersionToolVersionPkeyDelete>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<ToolVersionOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingToolVersionPkeyUpdate>;
};

/** Input for the nested mutation of `toolResource` in the `ToolVersionInput` mutation. */
export type ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput = {
  /** The primary key(s) for `toolResource` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolResourceToolResourcePkeyConnect>>;
  /** The primary key(s) for `toolResource` for the far side of the relationship. */
  connectByTypeAndToolVersionId?: InputMaybe<
    Array<ToolResourceReqTypeToolVersionUniqueConnect>
  >;
  /** A `ToolResourceInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ToolResourceToolVersionId5E21979DFkToolVersionIdToolResourceCreateInput>
  >;
  /** The primary key(s) for `toolResource` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ToolResourceToolResourcePkeyDelete>>;
  /** The primary key(s) for `toolResource` for the far side of the relationship. */
  deleteByTypeAndToolVersionId?: InputMaybe<
    Array<ToolResourceReqTypeToolVersionUniqueDelete>
  >;
  /** Flag indicating whether all other `toolResource` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `toolResource` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingToolResourcePkeyUpdate>
  >;
  /** The primary key(s) and patch data for `toolResource` for the far side of the relationship. */
  updateByTypeAndToolVersionId?: InputMaybe<
    Array<ToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingReqTypeToolVersionUniqueUpdate>
  >;
};

/** The `toolResource` to be created by this mutation. */
export type ToolResourceToolVersionId5E21979DFkToolVersionIdToolResourceCreateInput =
  {
    id?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInput>;
    type: Scalars["Int"]["input"];
    value: Scalars["Int"]["input"];
  };

/** The `toolVersion` to be created by this mutation. */
export type ToolResourceToolVersionId5E21979DFkToolVersionIdToolVersionCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible: Scalars["Boolean"]["input"];
    isUpgradableToNextVersion: Scalars["Boolean"]["input"];
    maturity: Scalars["Int"]["input"];
    status: Scalars["Int"]["input"];
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion: Scalars["Int"]["input"];
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version: Scalars["String"]["input"];
    visibility: Scalars["Int"]["input"];
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** A connection to a list of `ToolResource` values. */
export type ToolResourcesConnection = {
  __typename: "ToolResourcesConnection";
  /** A list of edges which contains the `ToolResource` and cursor to aid in pagination. */
  edges: Array<ToolResourcesEdge>;
  /** A list of `ToolResource` objects. */
  nodes: Array<ToolResource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ToolResource` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ToolResource` edge in the connection. */
export type ToolResourcesEdge = {
  __typename: "ToolResourcesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ToolResource` at the end of the edge. */
  node: ToolResource;
};

/** Methods to use when ordering `ToolResource`. */
export enum ToolResourcesOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ToolVersionIdAsc = "TOOL_VERSION_ID_ASC",
  ToolVersionIdDesc = "TOOL_VERSION_ID_DESC",
  TypeAsc = "TYPE_ASC",
  TypeDesc = "TYPE_DESC",
  ValueAsc = "VALUE_ASC",
  ValueDesc = "VALUE_DESC",
}

export type ToolResult = {
  __typename: "ToolResult";
  fileFormats: Maybe<Scalars["JSON"]["output"]>;
  helpText: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  required: Scalars["Boolean"]["output"];
  /** Reads a single `ToolVersion` that is related to this `ToolResult`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
  toolVersionId: Scalars["Int"]["output"];
};

/**
 * A condition to be used against `ToolResult` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ToolResultCondition = {
  /** Checks for equality with the object’s `fileFormats` field. */
  fileFormats?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `helpText` field. */
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `required` field. */
  required?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `ToolResult` object types. All fields are combined with a logical ‘and.’ */
export type ToolResultFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ToolResultFilter>>;
  /** Filter by the object’s `fileFormats` field. */
  fileFormats?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `helpText` field. */
  helpText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ToolResultFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ToolResultFilter>>;
  /** Filter by the object’s `required` field. */
  required?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `toolVersionByToolVersionId` relation. */
  toolVersionByToolVersionId?: InputMaybe<ToolVersionFilter>;
  /** Filter by the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ToolResult` */
export type ToolResultInput = {
  fileFormats?: InputMaybe<Scalars["JSON"]["input"]>;
  helpText: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  required: Scalars["Boolean"]["input"];
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInput>;
};

/** The fields on `toolResult` to look up the row to update. */
export type ToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolResultPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolResult` being updated. */
    toolResultPatch: UpdateToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch;
  };

/** Represents an update to a `ToolResult`. Fields that are set will be updated. */
export type ToolResultPatch = {
  fileFormats?: InputMaybe<Scalars["JSON"]["input"]>;
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  required?: InputMaybe<Scalars["Boolean"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInput>;
};

/** The fields on `toolResult` to look up the row to connect. */
export type ToolResultToolResultPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `toolResult` to look up the row to delete. */
export type ToolResultToolResultPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** Input for the nested mutation of `toolVersion` in the `ToolResultInput` mutation. */
export type ToolResultToolVersionId41Fb163EFkToolVersionIdInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<ToolVersionToolVersionPkeyConnect>;
  /** A `ToolVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdToolVersionCreateInput>;
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<ToolVersionToolVersionPkeyDelete>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<ToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolVersionPkeyUpdate>;
};

/** Input for the nested mutation of `toolResult` in the `ToolVersionInput` mutation. */
export type ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput = {
  /** The primary key(s) for `toolResult` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolResultToolResultPkeyConnect>>;
  /** A `ToolResultInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ToolResultToolVersionId41Fb163EFkToolVersionIdToolResultCreateInput>
  >;
  /** The primary key(s) for `toolResult` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ToolResultToolResultPkeyDelete>>;
  /** Flag indicating whether all other `toolResult` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `toolResult` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolResultPkeyUpdate>
  >;
};

/** The `toolResult` to be created by this mutation. */
export type ToolResultToolVersionId41Fb163EFkToolVersionIdToolResultCreateInput =
  {
    fileFormats?: InputMaybe<Scalars["JSON"]["input"]>;
    helpText: Scalars["String"]["input"];
    id?: InputMaybe<Scalars["Int"]["input"]>;
    key: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    required: Scalars["Boolean"]["input"];
    toolVersionToToolVersionId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInput>;
  };

/** The `toolVersion` to be created by this mutation. */
export type ToolResultToolVersionId41Fb163EFkToolVersionIdToolVersionCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible: Scalars["Boolean"]["input"];
    isUpgradableToNextVersion: Scalars["Boolean"]["input"];
    maturity: Scalars["Int"]["input"];
    status: Scalars["Int"]["input"];
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion: Scalars["Int"]["input"];
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version: Scalars["String"]["input"];
    visibility: Scalars["Int"]["input"];
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** A connection to a list of `ToolResult` values. */
export type ToolResultsConnection = {
  __typename: "ToolResultsConnection";
  /** A list of edges which contains the `ToolResult` and cursor to aid in pagination. */
  edges: Array<ToolResultsEdge>;
  /** A list of `ToolResult` objects. */
  nodes: Array<ToolResult>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ToolResult` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ToolResult` edge in the connection. */
export type ToolResultsEdge = {
  __typename: "ToolResultsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ToolResult` at the end of the edge. */
  node: ToolResult;
};

/** Methods to use when ordering `ToolResult`. */
export enum ToolResultsOrderBy {
  FileFormatsAsc = "FILE_FORMATS_ASC",
  FileFormatsDesc = "FILE_FORMATS_DESC",
  HelpTextAsc = "HELP_TEXT_ASC",
  HelpTextDesc = "HELP_TEXT_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  KeyAsc = "KEY_ASC",
  KeyDesc = "KEY_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  RequiredAsc = "REQUIRED_ASC",
  RequiredDesc = "REQUIRED_DESC",
  ToolVersionIdAsc = "TOOL_VERSION_ID_ASC",
  ToolVersionIdDesc = "TOOL_VERSION_ID_DESC",
}

export type ToolSecret = {
  __typename: "ToolSecret";
  helpText: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  required: Scalars["Boolean"]["output"];
  /** Reads a single `ToolVersion` that is related to this `ToolSecret`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
  toolVersionId: Scalars["Int"]["output"];
};

/**
 * A condition to be used against `ToolSecret` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ToolSecretCondition = {
  /** Checks for equality with the object’s `helpText` field. */
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `required` field. */
  required?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `ToolSecret` object types. All fields are combined with a logical ‘and.’ */
export type ToolSecretFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ToolSecretFilter>>;
  /** Filter by the object’s `helpText` field. */
  helpText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ToolSecretFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ToolSecretFilter>>;
  /** Filter by the object’s `required` field. */
  required?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `toolVersionByToolVersionId` relation. */
  toolVersionByToolVersionId?: InputMaybe<ToolVersionFilter>;
  /** Filter by the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ToolSecret` */
export type ToolSecretInput = {
  helpText: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  required: Scalars["Boolean"]["input"];
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInput>;
};

/** The fields on `toolSecret` to look up the row to update. */
export type ToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolSecretPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolSecret` being updated. */
    toolSecretPatch: UpdateToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch;
  };

/** Represents an update to a `ToolSecret`. Fields that are set will be updated. */
export type ToolSecretPatch = {
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  required?: InputMaybe<Scalars["Boolean"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInput>;
};

/** The fields on `toolSecret` to look up the row to connect. */
export type ToolSecretToolSecretPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `toolSecret` to look up the row to delete. */
export type ToolSecretToolSecretPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** Input for the nested mutation of `toolVersion` in the `ToolSecretInput` mutation. */
export type ToolSecretToolVersionId92Dc8FadFkToolVersionIdInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<ToolVersionToolVersionPkeyConnect>;
  /** A `ToolVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdToolVersionCreateInput>;
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<ToolVersionToolVersionPkeyDelete>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<ToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolVersionPkeyUpdate>;
};

/** Input for the nested mutation of `toolSecret` in the `ToolVersionInput` mutation. */
export type ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput = {
  /** The primary key(s) for `toolSecret` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolSecretToolSecretPkeyConnect>>;
  /** A `ToolSecretInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ToolSecretToolVersionId92Dc8FadFkToolVersionIdToolSecretCreateInput>
  >;
  /** The primary key(s) for `toolSecret` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ToolSecretToolSecretPkeyDelete>>;
  /** Flag indicating whether all other `toolSecret` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `toolSecret` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolSecretPkeyUpdate>
  >;
};

/** The `toolSecret` to be created by this mutation. */
export type ToolSecretToolVersionId92Dc8FadFkToolVersionIdToolSecretCreateInput =
  {
    helpText: Scalars["String"]["input"];
    id?: InputMaybe<Scalars["Int"]["input"]>;
    key: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    required: Scalars["Boolean"]["input"];
    toolVersionToToolVersionId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInput>;
  };

/** The `toolVersion` to be created by this mutation. */
export type ToolSecretToolVersionId92Dc8FadFkToolVersionIdToolVersionCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible: Scalars["Boolean"]["input"];
    isUpgradableToNextVersion: Scalars["Boolean"]["input"];
    maturity: Scalars["Int"]["input"];
    status: Scalars["Int"]["input"];
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion: Scalars["Int"]["input"];
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version: Scalars["String"]["input"];
    visibility: Scalars["Int"]["input"];
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** A connection to a list of `ToolSecret` values. */
export type ToolSecretsConnection = {
  __typename: "ToolSecretsConnection";
  /** A list of edges which contains the `ToolSecret` and cursor to aid in pagination. */
  edges: Array<ToolSecretsEdge>;
  /** A list of `ToolSecret` objects. */
  nodes: Array<ToolSecret>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ToolSecret` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ToolSecret` edge in the connection. */
export type ToolSecretsEdge = {
  __typename: "ToolSecretsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ToolSecret` at the end of the edge. */
  node: ToolSecret;
};

/** Methods to use when ordering `ToolSecret`. */
export enum ToolSecretsOrderBy {
  HelpTextAsc = "HELP_TEXT_ASC",
  HelpTextDesc = "HELP_TEXT_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  KeyAsc = "KEY_ASC",
  KeyDesc = "KEY_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  RequiredAsc = "REQUIRED_ASC",
  RequiredDesc = "REQUIRED_DESC",
  ToolVersionIdAsc = "TOOL_VERSION_ID_ASC",
  ToolVersionIdDesc = "TOOL_VERSION_ID_DESC",
}

export type ToolSource = {
  __typename: "ToolSource";
  fileFormats: Maybe<Scalars["JSON"]["output"]>;
  helpText: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  key: Scalars["String"]["output"];
  multiple: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  required: Scalars["Boolean"]["output"];
  /** Reads and enables pagination through a set of `TaskSource`. */
  taskSourcesByToolSourceId: TaskSourcesConnection;
  /** Reads a single `ToolVersion` that is related to this `ToolSource`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
  toolVersionId: Scalars["Int"]["output"];
};

export type ToolSourceTaskSourcesByToolSourceIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskSourceCondition>;
  filter?: InputMaybe<TaskSourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TaskSourcesOrderBy>>;
};

/**
 * A condition to be used against `ToolSource` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ToolSourceCondition = {
  /** Checks for equality with the object’s `fileFormats` field. */
  fileFormats?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `helpText` field. */
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `multiple` field. */
  multiple?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `required` field. */
  required?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `ToolSource` object types. All fields are combined with a logical ‘and.’ */
export type ToolSourceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ToolSourceFilter>>;
  /** Filter by the object’s `fileFormats` field. */
  fileFormats?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `helpText` field. */
  helpText?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `multiple` field. */
  multiple?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ToolSourceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ToolSourceFilter>>;
  /** Filter by the object’s `required` field. */
  required?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `taskSourcesByToolSourceId` relation. */
  taskSourcesByToolSourceId?: InputMaybe<ToolSourceToManyTaskSourceFilter>;
  /** Some related `taskSourcesByToolSourceId` exist. */
  taskSourcesByToolSourceIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `toolVersionByToolVersionId` relation. */
  toolVersionByToolVersionId?: InputMaybe<ToolVersionFilter>;
  /** Filter by the object’s `toolVersionId` field. */
  toolVersionId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ToolSource` */
export type ToolSourceInput = {
  fileFormats?: InputMaybe<Scalars["JSON"]["input"]>;
  helpText: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key: Scalars["String"]["input"];
  multiple: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
  required: Scalars["Boolean"]["input"];
  taskSourcesUsingId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput>;
};

/** The fields on `toolSource` to look up the row to update. */
export type ToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingToolSourcePkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolSource` being updated. */
    toolSourcePatch: UpdateToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch;
  };

/** The fields on `toolSource` to look up the row to update. */
export type ToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolSourcePkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolSource` being updated. */
    toolSourcePatch: UpdateToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch;
  };

/** Represents an update to a `ToolSource`. Fields that are set will be updated. */
export type ToolSourcePatch = {
  fileFormats?: InputMaybe<Scalars["JSON"]["input"]>;
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  multiple?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  required?: InputMaybe<Scalars["Boolean"]["input"]>;
  taskSourcesUsingId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput>;
};

/** A filter to be used against many `TaskSource` object types. All fields are combined with a logical ‘and.’ */
export type ToolSourceToManyTaskSourceFilter = {
  /** Every related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskSourceFilter>;
  /** No related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskSourceFilter>;
  /** Some related `TaskSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskSourceFilter>;
};

/** The fields on `toolSource` to look up the row to connect. */
export type ToolSourceToolSourcePkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `toolSource` to look up the row to delete. */
export type ToolSourceToolSourcePkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** Input for the nested mutation of `toolVersion` in the `ToolSourceInput` mutation. */
export type ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<ToolVersionToolVersionPkeyConnect>;
  /** A `ToolVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdToolVersionCreateInput>;
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<ToolVersionToolVersionPkeyDelete>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<ToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolVersionPkeyUpdate>;
};

/** Input for the nested mutation of `toolSource` in the `ToolVersionInput` mutation. */
export type ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput = {
  /** The primary key(s) for `toolSource` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolSourceToolSourcePkeyConnect>>;
  /** A `ToolSourceInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ToolSourceToolVersionId9Ac27A25FkToolVersionIdToolSourceCreateInput>
  >;
  /** The primary key(s) for `toolSource` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ToolSourceToolSourcePkeyDelete>>;
  /** Flag indicating whether all other `toolSource` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `toolSource` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolSourcePkeyUpdate>
  >;
};

/** The `toolSource` to be created by this mutation. */
export type ToolSourceToolVersionId9Ac27A25FkToolVersionIdToolSourceCreateInput =
  {
    fileFormats?: InputMaybe<Scalars["JSON"]["input"]>;
    helpText: Scalars["String"]["input"];
    id?: InputMaybe<Scalars["Int"]["input"]>;
    key: Scalars["String"]["input"];
    multiple: Scalars["Boolean"]["input"];
    name: Scalars["String"]["input"];
    required: Scalars["Boolean"]["input"];
    taskSourcesUsingId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput>;
    toolVersionToToolVersionId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput>;
  };

/** The `toolVersion` to be created by this mutation. */
export type ToolSourceToolVersionId9Ac27A25FkToolVersionIdToolVersionCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible: Scalars["Boolean"]["input"];
    isUpgradableToNextVersion: Scalars["Boolean"]["input"];
    maturity: Scalars["Int"]["input"];
    status: Scalars["Int"]["input"];
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion: Scalars["Int"]["input"];
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version: Scalars["String"]["input"];
    visibility: Scalars["Int"]["input"];
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** A connection to a list of `ToolSource` values. */
export type ToolSourcesConnection = {
  __typename: "ToolSourcesConnection";
  /** A list of edges which contains the `ToolSource` and cursor to aid in pagination. */
  edges: Array<ToolSourcesEdge>;
  /** A list of `ToolSource` objects. */
  nodes: Array<ToolSource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ToolSource` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ToolSource` edge in the connection. */
export type ToolSourcesEdge = {
  __typename: "ToolSourcesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ToolSource` at the end of the edge. */
  node: ToolSource;
};

/** Methods to use when ordering `ToolSource`. */
export enum ToolSourcesOrderBy {
  FileFormatsAsc = "FILE_FORMATS_ASC",
  FileFormatsDesc = "FILE_FORMATS_DESC",
  HelpTextAsc = "HELP_TEXT_ASC",
  HelpTextDesc = "HELP_TEXT_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  KeyAsc = "KEY_ASC",
  KeyDesc = "KEY_DESC",
  MultipleAsc = "MULTIPLE_ASC",
  MultipleDesc = "MULTIPLE_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  RequiredAsc = "REQUIRED_ASC",
  RequiredDesc = "REQUIRED_DESC",
  ToolVersionIdAsc = "TOOL_VERSION_ID_ASC",
  ToolVersionIdDesc = "TOOL_VERSION_ID_DESC",
}

export type ToolTenant = {
  __typename: "ToolTenant";
  id: Scalars["BigInt"]["output"];
  /** Reads a single `Tenant` that is related to this `ToolTenant`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
  /** Reads a single `Tool` that is related to this `ToolTenant`. */
  toolByToolId: Maybe<Tool>;
  toolId: Scalars["Int"]["output"];
};

/**
 * A condition to be used against `ToolTenant` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ToolTenantCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `toolId` field. */
  toolId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `ToolTenant` object types. All fields are combined with a logical ‘and.’ */
export type ToolTenantFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ToolTenantFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ToolTenantFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ToolTenantFilter>>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toolByToolId` relation. */
  toolByToolId?: InputMaybe<ToolFilter>;
  /** Filter by the object’s `toolId` field. */
  toolId?: InputMaybe<IntFilter>;
};

/** Input for the nested mutation of `tenant` in the `ToolInput` mutation. */
export type ToolTenantId1Baab08EFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<ToolTenantId1Baab08EFkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `tool` in the `TenantInput` mutation. */
export type ToolTenantId1Baab08EFkTenantIdInverseInput = {
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolToolPkeyConnect>>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectByProjectId?: InputMaybe<Array<ToolToolProjectIdKeyConnect>>;
  /** A `ToolInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ToolTenantId1Baab08EFkTenantIdToolCreateInput>>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ToolToolPkeyDelete>>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  deleteByProjectId?: InputMaybe<Array<ToolToolProjectIdKeyDelete>>;
  /** Flag indicating whether all other `tool` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateByProjectId?: InputMaybe<
    Array<ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolProjectIdKeyUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type ToolTenantId1Baab08EFkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** The `tool` to be created by this mutation. */
export type ToolTenantId1Baab08EFkTenantIdToolCreateInput = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  codeLink?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  docsLink?: InputMaybe<Scalars["String"]["input"]>;
  helpText: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key: Scalars["String"]["input"];
  maturity: Scalars["Int"]["input"];
  name: Scalars["String"]["input"];
  pinnedToolsUsingId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  searchTerms?: InputMaybe<Scalars["JSON"]["input"]>;
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
  toolboxToToolboxId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  visibility: Scalars["Int"]["input"];
};

/** An input for mutations affecting `ToolTenant` */
export type ToolTenantInput = {
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInput>;
  toolId?: InputMaybe<Scalars["Int"]["input"]>;
  toolToToolId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInput>;
};

/** The fields on `toolTenant` to look up the row to update. */
export type ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsPkeyUpdate =
  {
    id: Scalars["BigInt"]["input"];
    /** An object where the defined keys will be set on the `toolTenant` being updated. */
    toolTenantPatch: UpdateToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
  };

/** The fields on `toolTenant` to look up the row to update. */
export type ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate =
  {
    tenantId: Scalars["Int"]["input"];
    toolId: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolTenant` being updated. */
    toolTenantPatch: UpdateToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
  };

/** The fields on `toolTenant` to look up the row to update. */
export type ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsPkeyUpdate =
  {
    id: Scalars["BigInt"]["input"];
    /** An object where the defined keys will be set on the `toolTenant` being updated. */
    toolTenantPatch: UpdateToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch;
  };

/** The fields on `toolTenant` to look up the row to update. */
export type ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate =
  {
    tenantId: Scalars["Int"]["input"];
    toolId: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolTenant` being updated. */
    toolTenantPatch: UpdateToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch;
  };

/** Represents an update to a `ToolTenant`. Fields that are set will be updated. */
export type ToolTenantPatch = {
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInput>;
  toolId?: InputMaybe<Scalars["Int"]["input"]>;
  toolToToolId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInput>;
};

/** The fields on `toolTenant` to look up the row to connect. */
export type ToolTenantToolTenantsPkeyConnect = {
  id: Scalars["BigInt"]["input"];
};

/** The fields on `toolTenant` to look up the row to delete. */
export type ToolTenantToolTenantsPkeyDelete = {
  id: Scalars["BigInt"]["input"];
};

/** The fields on `toolTenant` to look up the row to connect. */
export type ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqConnect = {
  tenantId: Scalars["Int"]["input"];
  toolId: Scalars["Int"]["input"];
};

/** The fields on `toolTenant` to look up the row to delete. */
export type ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqDelete = {
  tenantId: Scalars["Int"]["input"];
  toolId: Scalars["Int"]["input"];
};

/** A connection to a list of `ToolTenant` values. */
export type ToolTenantsConnection = {
  __typename: "ToolTenantsConnection";
  /** A list of edges which contains the `ToolTenant` and cursor to aid in pagination. */
  edges: Array<ToolTenantsEdge>;
  /** A list of `ToolTenant` objects. */
  nodes: Array<ToolTenant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ToolTenant` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ToolTenant` edge in the connection. */
export type ToolTenantsEdge = {
  __typename: "ToolTenantsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ToolTenant` at the end of the edge. */
  node: ToolTenant;
};

/** Methods to use when ordering `ToolTenant`. */
export enum ToolTenantsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  ToolIdAsc = "TOOL_ID_ASC",
  ToolIdDesc = "TOOL_ID_DESC",
}

/** Input for the nested mutation of `tenant` in the `ToolTenantInput` mutation. */
export type ToolTenantsTenantId9C4A54FeFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `toolTenant` in the `TenantInput` mutation. */
export type ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput = {
  /** The primary key(s) for `toolTenant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolTenantToolTenantsPkeyConnect>>;
  /** The primary key(s) for `toolTenant` for the far side of the relationship. */
  connectByToolIdAndTenantId?: InputMaybe<
    Array<ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqConnect>
  >;
  /** A `ToolTenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ToolTenantsTenantId9C4A54FeFkTenantIdToolTenantsCreateInput>
  >;
  /** The primary key(s) for `toolTenant` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ToolTenantToolTenantsPkeyDelete>>;
  /** The primary key(s) for `toolTenant` for the far side of the relationship. */
  deleteByToolIdAndTenantId?: InputMaybe<
    Array<ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqDelete>
  >;
  /** Flag indicating whether all other `toolTenant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `toolTenant` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `toolTenant` for the far side of the relationship. */
  updateByToolIdAndTenantId?: InputMaybe<
    Array<ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type ToolTenantsTenantId9C4A54FeFkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** The `toolTenant` to be created by this mutation. */
export type ToolTenantsTenantId9C4A54FeFkTenantIdToolTenantsCreateInput = {
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInput>;
  toolId?: InputMaybe<Scalars["Int"]["input"]>;
  toolToToolId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInput>;
};

/** Input for the nested mutation of `tool` in the `ToolTenantInput` mutation. */
export type ToolTenantsToolIdF77Ef6F7FkToolIdInput = {
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectById?: InputMaybe<ToolToolPkeyConnect>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectByProjectId?: InputMaybe<ToolToolProjectIdKeyConnect>;
  /** A `ToolInput` object that will be created and connected to this object. */
  create?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdToolCreateInput>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  deleteById?: InputMaybe<ToolToolPkeyDelete>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  deleteByProjectId?: InputMaybe<ToolToolProjectIdKeyDelete>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateById?: InputMaybe<ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolPkeyUpdate>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateByProjectId?: InputMaybe<ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolProjectIdKeyUpdate>;
};

/** Input for the nested mutation of `toolTenant` in the `ToolInput` mutation. */
export type ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput = {
  /** The primary key(s) for `toolTenant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolTenantToolTenantsPkeyConnect>>;
  /** The primary key(s) for `toolTenant` for the far side of the relationship. */
  connectByToolIdAndTenantId?: InputMaybe<
    Array<ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqConnect>
  >;
  /** A `ToolTenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ToolTenantsToolIdF77Ef6F7FkToolIdToolTenantsCreateInput>
  >;
  /** The primary key(s) for `toolTenant` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ToolTenantToolTenantsPkeyDelete>>;
  /** The primary key(s) for `toolTenant` for the far side of the relationship. */
  deleteByToolIdAndTenantId?: InputMaybe<
    Array<ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqDelete>
  >;
  /** Flag indicating whether all other `toolTenant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `toolTenant` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `toolTenant` for the far side of the relationship. */
  updateByToolIdAndTenantId?: InputMaybe<
    Array<ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate>
  >;
};

/** The `tool` to be created by this mutation. */
export type ToolTenantsToolIdF77Ef6F7FkToolIdToolCreateInput = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  codeLink?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  docsLink?: InputMaybe<Scalars["String"]["input"]>;
  helpText: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key: Scalars["String"]["input"];
  maturity: Scalars["Int"]["input"];
  name: Scalars["String"]["input"];
  pinnedToolsUsingId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  searchTerms?: InputMaybe<Scalars["JSON"]["input"]>;
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
  toolboxToToolboxId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  visibility: Scalars["Int"]["input"];
};

/** The `toolTenant` to be created by this mutation. */
export type ToolTenantsToolIdF77Ef6F7FkToolIdToolTenantsCreateInput = {
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInput>;
  toolToToolId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInput>;
};

/** A filter to be used against many `PinnedTool` object types. All fields are combined with a logical ‘and.’ */
export type ToolToManyPinnedToolFilter = {
  /** Every related `PinnedTool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PinnedToolFilter>;
  /** No related `PinnedTool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PinnedToolFilter>;
  /** Some related `PinnedTool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PinnedToolFilter>;
};

/** A filter to be used against many `ToolTenant` object types. All fields are combined with a logical ‘and.’ */
export type ToolToManyToolTenantFilter = {
  /** Every related `ToolTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolTenantFilter>;
  /** No related `ToolTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolTenantFilter>;
  /** Some related `ToolTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolTenantFilter>;
};

/** A filter to be used against many `ToolVersion` object types. All fields are combined with a logical ‘and.’ */
export type ToolToManyToolVersionFilter = {
  /** Every related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolVersionFilter>;
  /** No related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolVersionFilter>;
  /** Some related `ToolVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolVersionFilter>;
};

/** The fields on `tool` to look up the row to connect. */
export type ToolToolPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `tool` to look up the row to delete. */
export type ToolToolPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** The fields on `tool` to look up the row to connect. */
export type ToolToolProjectIdKeyConnect = {
  projectId: Scalars["UUID"]["input"];
};

/** The fields on `tool` to look up the row to delete. */
export type ToolToolProjectIdKeyDelete = {
  projectId: Scalars["UUID"]["input"];
};

/** Input for the nested mutation of `toolbox` in the `ToolInput` mutation. */
export type ToolToolboxId7B1Eebf3FkToolboxIdInput = {
  /** The primary key(s) for `toolbox` for the far side of the relationship. */
  connectById?: InputMaybe<ToolboxToolboxPkeyConnect>;
  /** The primary key(s) for `toolbox` for the far side of the relationship. */
  connectByKey?: InputMaybe<ToolboxToolboxKeyKeyConnect>;
  /** A `ToolboxInput` object that will be created and connected to this object. */
  create?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdToolboxCreateInput>;
  /** The primary key(s) for `toolbox` for the far side of the relationship. */
  deleteById?: InputMaybe<ToolboxToolboxPkeyDelete>;
  /** The primary key(s) for `toolbox` for the far side of the relationship. */
  deleteByKey?: InputMaybe<ToolboxToolboxKeyKeyDelete>;
  /** The primary key(s) and patch data for `toolbox` for the far side of the relationship. */
  updateById?: InputMaybe<ToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolboxPkeyUpdate>;
  /** The primary key(s) and patch data for `toolbox` for the far side of the relationship. */
  updateByKey?: InputMaybe<ToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolboxKeyKeyUpdate>;
};

/** Input for the nested mutation of `tool` in the `ToolboxInput` mutation. */
export type ToolToolboxId7B1Eebf3FkToolboxIdInverseInput = {
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolToolPkeyConnect>>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectByProjectId?: InputMaybe<Array<ToolToolProjectIdKeyConnect>>;
  /** A `ToolInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ToolToolboxId7B1Eebf3FkToolboxIdToolCreateInput>>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ToolToolPkeyDelete>>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  deleteByProjectId?: InputMaybe<Array<ToolToolProjectIdKeyDelete>>;
  /** Flag indicating whether all other `tool` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateByProjectId?: InputMaybe<
    Array<ToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolProjectIdKeyUpdate>
  >;
};

/** The `tool` to be created by this mutation. */
export type ToolToolboxId7B1Eebf3FkToolboxIdToolCreateInput = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  codeLink?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  docsLink?: InputMaybe<Scalars["String"]["input"]>;
  helpText: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key: Scalars["String"]["input"];
  maturity: Scalars["Int"]["input"];
  name: Scalars["String"]["input"];
  pinnedToolsUsingId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  searchTerms?: InputMaybe<Scalars["JSON"]["input"]>;
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  toolboxToToolboxId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  visibility: Scalars["Int"]["input"];
};

/** The `toolbox` to be created by this mutation. */
export type ToolToolboxId7B1Eebf3FkToolboxIdToolboxCreateInput = {
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsToolboxId9D553881FkToolboxIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInverseInput>;
};

/** The `applicationUser` to be created by this mutation. */
export type ToolUserIdFd36Dfa4FkApplicationUserIdApplicationUserCreateInput = {
  applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
  applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
  applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
  auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
  avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
  cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
  commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
  dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
  dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
  dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
  email: Scalars["String"]["input"];
  emailMarketingConsent: Scalars["Boolean"]["input"];
  eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
  executorId?: InputMaybe<Scalars["Int"]["input"]>;
  featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
  filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
  firstName: Scalars["String"]["input"];
  gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
  gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
  globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
  homeRegion?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  internal: Scalars["Boolean"]["input"];
  isActive: Scalars["Boolean"]["input"];
  isStaff: Scalars["Boolean"]["input"];
  isSuperuser: Scalars["Boolean"]["input"];
  lastName: Scalars["String"]["input"];
  metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
  notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
  personalRegion?: InputMaybe<Scalars["String"]["input"]>;
  pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
  projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
  projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
  projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
  projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
  tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
  tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
  tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
  userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
  userOrigin: Scalars["String"]["input"];
  userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
  username: Scalars["String"]["input"];
  workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
};

/** Input for the nested mutation of `applicationUser` in the `ToolInput` mutation. */
export type ToolUserIdFd36Dfa4FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `tool` in the `ApplicationUserInput` mutation. */
export type ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolToolPkeyConnect>>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectByProjectId?: InputMaybe<Array<ToolToolProjectIdKeyConnect>>;
  /** A `ToolInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ToolUserIdFd36Dfa4FkApplicationUserIdToolCreateInput>
  >;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ToolToolPkeyDelete>>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  deleteByProjectId?: InputMaybe<Array<ToolToolProjectIdKeyDelete>>;
  /** Flag indicating whether all other `tool` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateByProjectId?: InputMaybe<
    Array<ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolProjectIdKeyUpdate>
  >;
};

/** The `tool` to be created by this mutation. */
export type ToolUserIdFd36Dfa4FkApplicationUserIdToolCreateInput = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  codeLink?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  docsLink?: InputMaybe<Scalars["String"]["input"]>;
  helpText: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key: Scalars["String"]["input"];
  maturity: Scalars["Int"]["input"];
  name: Scalars["String"]["input"];
  pinnedToolsUsingId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  searchTerms?: InputMaybe<Scalars["JSON"]["input"]>;
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
  toolboxToToolboxId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInput>;
  visibility: Scalars["Int"]["input"];
};

export type ToolVersion = {
  __typename: "ToolVersion";
  /** Reads a single `ApplicationUser` that is related to this `ToolVersion`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  changelog: Maybe<Scalars["String"]["output"]>;
  command: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Command` that is related to this `ToolVersion`. */
  commandByToolVersionId: Maybe<Command>;
  /**
   * Reads and enables pagination through a set of `Command`.
   * @deprecated Please use commandByToolVersionId instead
   */
  commandsByToolVersionId: CommandsConnection;
  /** Reads and enables pagination through a set of `ToolVersion`. */
  compatibleVersions: ToolVersionsConnection;
  /** Reads a single `ContainerImage` that is related to this `ToolVersion`. */
  containerImageByContainerImageId: Maybe<ContainerImage>;
  containerImageId: Maybe<Scalars["Int"]["output"]>;
  created: Maybe<Scalars["Datetime"]["output"]>;
  credits: Maybe<Scalars["Float"]["output"]>;
  dateCreated: Scalars["Datetime"]["output"];
  draftToolSpec: Maybe<Scalars["JSON"]["output"]>;
  /** Reads and enables pagination through a set of `GdtAnalysisTableRow`. */
  gdtAnalysisTableRowsByToolVersionId: GdtAnalysisTableRowsConnection;
  /** Reads and enables pagination through a set of `GdtAnalysisTable`. */
  gdtAnalysisTablesByToolVersionId: GdtAnalysisTablesConnection;
  id: Scalars["Int"]["output"];
  isToolSpecForwardsCompatible: Scalars["Boolean"]["output"];
  isUpgradableToNextVersion: Scalars["Boolean"]["output"];
  maturity: Scalars["Int"]["output"];
  status: Scalars["Int"]["output"];
  /** Reads and enables pagination through a set of `Task`. */
  tasksByToolVersionId: TasksConnection;
  /** Reads a single `Tenant` that is related to this `ToolVersion`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Maybe<Scalars["Int"]["output"]>;
  /** Reads a single `Tool` that is related to this `ToolVersion`. */
  toolByToolId: Maybe<Tool>;
  toolId: Scalars["Int"]["output"];
  /** Reads and enables pagination through a set of `ToolParameter`. */
  toolParametersByToolVersionId: ToolParametersConnection;
  /** Reads and enables pagination through a set of `ToolResource`. */
  toolResourcesByToolVersionId: ToolResourcesConnection;
  /** Reads and enables pagination through a set of `ToolResult`. */
  toolResultsByToolVersionId: ToolResultsConnection;
  /** Reads and enables pagination through a set of `ToolSecret`. */
  toolSecretsByToolVersionId: ToolSecretsConnection;
  /** Reads and enables pagination through a set of `ToolSource`. */
  toolSourcesByToolVersionId: ToolSourcesConnection;
  toolSpec: Maybe<Scalars["JSON"]["output"]>;
  toolSpecVersion: Scalars["Int"]["output"];
  userId: Maybe<Scalars["UUID"]["output"]>;
  version: Scalars["String"]["output"];
  visibility: Scalars["Int"]["output"];
  /** Reads and enables pagination through a set of `WorkflowSectionBlock`. */
  workflowSectionBlocksByToolId: WorkflowSectionBlocksConnection;
};

export type ToolVersionCommandsByToolVersionIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<CommandCondition>;
  filter?: InputMaybe<CommandFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CommandsOrderBy>>;
};

export type ToolVersionCompatibleVersionsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ToolVersionGdtAnalysisTableRowsByToolVersionIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableRowCondition>;
  filter?: InputMaybe<GdtAnalysisTableRowFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTableRowsOrderBy>>;
};

export type ToolVersionGdtAnalysisTablesByToolVersionIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<GdtAnalysisTableCondition>;
  filter?: InputMaybe<GdtAnalysisTableFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<GdtAnalysisTablesOrderBy>>;
};

export type ToolVersionTasksByToolVersionIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

export type ToolVersionToolParametersByToolVersionIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolParameterCondition>;
  filter?: InputMaybe<ToolParameterFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolParametersOrderBy>>;
};

export type ToolVersionToolResourcesByToolVersionIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolResourceCondition>;
  filter?: InputMaybe<ToolResourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolResourcesOrderBy>>;
};

export type ToolVersionToolResultsByToolVersionIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolResultCondition>;
  filter?: InputMaybe<ToolResultFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolResultsOrderBy>>;
};

export type ToolVersionToolSecretsByToolVersionIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolSecretCondition>;
  filter?: InputMaybe<ToolSecretFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolSecretsOrderBy>>;
};

export type ToolVersionToolSourcesByToolVersionIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolSourceCondition>;
  filter?: InputMaybe<ToolSourceFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolSourcesOrderBy>>;
};

export type ToolVersionWorkflowSectionBlocksByToolIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSectionBlockCondition>;
  filter?: InputMaybe<WorkflowSectionBlockFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSectionBlocksOrderBy>>;
};

/**
 * A condition to be used against `ToolVersion` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ToolVersionCondition = {
  /** Checks for equality with the object’s `changelog` field. */
  changelog?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `command` field. */
  command?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `containerImageId` field. */
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `credits` field. */
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `draftToolSpec` field. */
  draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `isToolSpecForwardsCompatible` field. */
  isToolSpecForwardsCompatible?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `isUpgradableToNextVersion` field. */
  isUpgradableToNextVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `maturity` field. */
  maturity?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `toolId` field. */
  toolId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `toolSpec` field. */
  toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `toolSpecVersion` field. */
  toolSpecVersion?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `visibility` field. */
  visibility?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The `containerImage` to be created by this mutation. */
export type ToolVersionContainerImageId32D92A94FkContainerImageIdContainerImageCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
    containerImageRepositoryId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    label: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    readme?: InputMaybe<Scalars["String"]["input"]>;
    size: Scalars["BigInt"]["input"];
    spec?: InputMaybe<Scalars["JSON"]["input"]>;
    status: Scalars["Int"]["input"];
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
    tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
  };

/** Input for the nested mutation of `containerImage` in the `ToolVersionInput` mutation. */
export type ToolVersionContainerImageId32D92A94FkContainerImageIdInput = {
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<ContainerImageContainerImageExecutorIdKeyConnect>;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  connectById?: InputMaybe<ContainerImageContainerImagePkeyConnect>;
  /** A `ContainerImageInput` object that will be created and connected to this object. */
  create?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdContainerImageCreateInput>;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<ContainerImageContainerImageExecutorIdKeyDelete>;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  deleteById?: InputMaybe<ContainerImageContainerImagePkeyDelete>;
  /** The primary key(s) and patch data for `containerImage` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<ContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `containerImage` for the far side of the relationship. */
  updateById?: InputMaybe<ContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingContainerImagePkeyUpdate>;
};

/** Input for the nested mutation of `toolVersion` in the `ContainerImageInput` mutation. */
export type ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput =
  {
    /** The primary key(s) for `toolVersion` for the far side of the relationship. */
    connectById?: InputMaybe<Array<ToolVersionToolVersionPkeyConnect>>;
    /** A `ToolVersionInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<ToolVersionContainerImageId32D92A94FkContainerImageIdToolVersionCreateInput>
    >;
    /** The primary key(s) for `toolVersion` for the far side of the relationship. */
    deleteById?: InputMaybe<Array<ToolVersionToolVersionPkeyDelete>>;
    /** Flag indicating whether all other `toolVersion` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
    updateById?: InputMaybe<
      Array<ToolVersionOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingToolVersionPkeyUpdate>
    >;
  };

/** The `toolVersion` to be created by this mutation. */
export type ToolVersionContainerImageId32D92A94FkContainerImageIdToolVersionCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible: Scalars["Boolean"]["input"];
    isUpgradableToNextVersion: Scalars["Boolean"]["input"];
    maturity: Scalars["Int"]["input"];
    status: Scalars["Int"]["input"];
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion: Scalars["Int"]["input"];
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version: Scalars["String"]["input"];
    visibility: Scalars["Int"]["input"];
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** A filter to be used against `ToolVersion` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ToolVersionFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `changelog` field. */
  changelog?: InputMaybe<StringFilter>;
  /** Filter by the object’s `command` field. */
  command?: InputMaybe<StringFilter>;
  /** Filter by the object’s `commandByToolVersionId` relation. */
  commandByToolVersionId?: InputMaybe<CommandFilter>;
  /** A related `commandByToolVersionId` exists. */
  commandByToolVersionIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `containerImageByContainerImageId` relation. */
  containerImageByContainerImageId?: InputMaybe<ContainerImageFilter>;
  /** A related `containerImageByContainerImageId` exists. */
  containerImageByContainerImageIdExists?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `containerImageId` field. */
  containerImageId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `credits` field. */
  credits?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `draftToolSpec` field. */
  draftToolSpec?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `gdtAnalysisTableRowsByToolVersionId` relation. */
  gdtAnalysisTableRowsByToolVersionId?: InputMaybe<ToolVersionToManyGdtAnalysisTableRowFilter>;
  /** Some related `gdtAnalysisTableRowsByToolVersionId` exist. */
  gdtAnalysisTableRowsByToolVersionIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `gdtAnalysisTablesByToolVersionId` relation. */
  gdtAnalysisTablesByToolVersionId?: InputMaybe<ToolVersionToManyGdtAnalysisTableFilter>;
  /** Some related `gdtAnalysisTablesByToolVersionId` exist. */
  gdtAnalysisTablesByToolVersionIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isToolSpecForwardsCompatible` field. */
  isToolSpecForwardsCompatible?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isUpgradableToNextVersion` field. */
  isUpgradableToNextVersion?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `maturity` field. */
  maturity?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ToolVersionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ToolVersionFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tasksByToolVersionId` relation. */
  tasksByToolVersionId?: InputMaybe<ToolVersionToManyTaskFilter>;
  /** Some related `tasksByToolVersionId` exist. */
  tasksByToolVersionIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** A related `tenantByTenantId` exists. */
  tenantByTenantIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toolByToolId` relation. */
  toolByToolId?: InputMaybe<ToolFilter>;
  /** Filter by the object’s `toolId` field. */
  toolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toolParametersByToolVersionId` relation. */
  toolParametersByToolVersionId?: InputMaybe<ToolVersionToManyToolParameterFilter>;
  /** Some related `toolParametersByToolVersionId` exist. */
  toolParametersByToolVersionIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `toolResourcesByToolVersionId` relation. */
  toolResourcesByToolVersionId?: InputMaybe<ToolVersionToManyToolResourceFilter>;
  /** Some related `toolResourcesByToolVersionId` exist. */
  toolResourcesByToolVersionIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `toolResultsByToolVersionId` relation. */
  toolResultsByToolVersionId?: InputMaybe<ToolVersionToManyToolResultFilter>;
  /** Some related `toolResultsByToolVersionId` exist. */
  toolResultsByToolVersionIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `toolSecretsByToolVersionId` relation. */
  toolSecretsByToolVersionId?: InputMaybe<ToolVersionToManyToolSecretFilter>;
  /** Some related `toolSecretsByToolVersionId` exist. */
  toolSecretsByToolVersionIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `toolSourcesByToolVersionId` relation. */
  toolSourcesByToolVersionId?: InputMaybe<ToolVersionToManyToolSourceFilter>;
  /** Some related `toolSourcesByToolVersionId` exist. */
  toolSourcesByToolVersionIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `toolSpec` field. */
  toolSpec?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `toolSpecVersion` field. */
  toolSpecVersion?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<StringFilter>;
  /** Filter by the object’s `visibility` field. */
  visibility?: InputMaybe<IntFilter>;
  /** Filter by the object’s `workflowSectionBlocksByToolId` relation. */
  workflowSectionBlocksByToolId?: InputMaybe<ToolVersionToManyWorkflowSectionBlockFilter>;
  /** Some related `workflowSectionBlocksByToolId` exist. */
  workflowSectionBlocksByToolIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** An input for mutations affecting `ToolVersion` */
export type ToolVersionInput = {
  applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
  changelog?: InputMaybe<Scalars["String"]["input"]>;
  command?: InputMaybe<Scalars["String"]["input"]>;
  commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  isToolSpecForwardsCompatible: Scalars["Boolean"]["input"];
  isUpgradableToNextVersion: Scalars["Boolean"]["input"];
  maturity: Scalars["Int"]["input"];
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
  toolId?: InputMaybe<Scalars["Int"]["input"]>;
  toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
  toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
  toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
  toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
  toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
  toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
  toolSpecVersion: Scalars["Int"]["input"];
  toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  version: Scalars["String"]["input"];
  visibility: Scalars["Int"]["input"];
  workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
};

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingToolVersionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolVersion` being updated. */
    toolVersionPatch: UpdateToolVersionOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdPatch;
  };

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingToolVersionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolVersion` being updated. */
    toolVersionPatch: UpdateToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch;
  };

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingToolVersionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolVersion` being updated. */
    toolVersionPatch: UpdateToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch;
  };

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingToolVersionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolVersion` being updated. */
    toolVersionPatch: UpdateToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch;
  };

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolVersionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolVersion` being updated. */
    toolVersionPatch: UpdateToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch;
  };

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingToolVersionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolVersion` being updated. */
    toolVersionPatch: UpdateToolVersionOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdPatch;
  };

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolVersionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolVersion` being updated. */
    toolVersionPatch: UpdateToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch;
  };

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolVersionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolVersion` being updated. */
    toolVersionPatch: UpdateToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch;
  };

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolVersionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolVersion` being updated. */
    toolVersionPatch: UpdateToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch;
  };

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingToolVersionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolVersion` being updated. */
    toolVersionPatch: UpdateToolVersionOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdPatch;
  };

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingToolVersionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolVersion` being updated. */
    toolVersionPatch: UpdateToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
  };

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolVersionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolVersion` being updated. */
    toolVersionPatch: UpdateToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch;
  };

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingToolVersionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolVersion` being updated. */
    toolVersionPatch: UpdateToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
  };

/** The fields on `toolVersion` to look up the row to update. */
export type ToolVersionOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdUsingToolVersionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolVersion` being updated. */
    toolVersionPatch: UpdateToolVersionOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdPatch;
  };

/** Represents an update to a `ToolVersion`. Fields that are set will be updated. */
export type ToolVersionPatch = {
  applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
  changelog?: InputMaybe<Scalars["String"]["input"]>;
  command?: InputMaybe<Scalars["String"]["input"]>;
  commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  isToolSpecForwardsCompatible?: InputMaybe<Scalars["Boolean"]["input"]>;
  isUpgradableToNextVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
  maturity?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
  toolId?: InputMaybe<Scalars["Int"]["input"]>;
  toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
  toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
  toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
  toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
  toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
  toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
  toolSpecVersion?: InputMaybe<Scalars["Int"]["input"]>;
  toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  version?: InputMaybe<Scalars["String"]["input"]>;
  visibility?: InputMaybe<Scalars["Int"]["input"]>;
  workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
};

/** Input for the nested mutation of `tenant` in the `ToolVersionInput` mutation. */
export type ToolVersionTenantId03A60B0CFkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `toolVersion` in the `TenantInput` mutation. */
export type ToolVersionTenantId03A60B0CFkTenantIdInverseInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolVersionToolVersionPkeyConnect>>;
  /** A `ToolVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ToolVersionTenantId03A60B0CFkTenantIdToolVersionCreateInput>
  >;
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ToolVersionToolVersionPkeyDelete>>;
  /** Flag indicating whether all other `toolVersion` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingToolVersionPkeyUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type ToolVersionTenantId03A60B0CFkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** The `toolVersion` to be created by this mutation. */
export type ToolVersionTenantId03A60B0CFkTenantIdToolVersionCreateInput = {
  applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
  changelog?: InputMaybe<Scalars["String"]["input"]>;
  command?: InputMaybe<Scalars["String"]["input"]>;
  commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  isToolSpecForwardsCompatible: Scalars["Boolean"]["input"];
  isUpgradableToNextVersion: Scalars["Boolean"]["input"];
  maturity: Scalars["Int"]["input"];
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
  tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
  toolId?: InputMaybe<Scalars["Int"]["input"]>;
  toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
  toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
  toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
  toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
  toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
  toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
  toolSpecVersion: Scalars["Int"]["input"];
  toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  version: Scalars["String"]["input"];
  visibility: Scalars["Int"]["input"];
  workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
};

/** A filter to be used against many `GdtAnalysisTable` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionToManyGdtAnalysisTableFilter = {
  /** Every related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableFilter>;
  /** No related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableFilter>;
  /** Some related `GdtAnalysisTable` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableFilter>;
};

/** A filter to be used against many `GdtAnalysisTableRow` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionToManyGdtAnalysisTableRowFilter = {
  /** Every related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** No related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GdtAnalysisTableRowFilter>;
  /** Some related `GdtAnalysisTableRow` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GdtAnalysisTableRowFilter>;
};

/** A filter to be used against many `Task` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionToManyTaskFilter = {
  /** Every related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TaskFilter>;
  /** No related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TaskFilter>;
  /** Some related `Task` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TaskFilter>;
};

/** A filter to be used against many `ToolParameter` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionToManyToolParameterFilter = {
  /** Every related `ToolParameter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolParameterFilter>;
  /** No related `ToolParameter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolParameterFilter>;
  /** Some related `ToolParameter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolParameterFilter>;
};

/** A filter to be used against many `ToolResource` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionToManyToolResourceFilter = {
  /** Every related `ToolResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolResourceFilter>;
  /** No related `ToolResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolResourceFilter>;
  /** Some related `ToolResource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolResourceFilter>;
};

/** A filter to be used against many `ToolResult` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionToManyToolResultFilter = {
  /** Every related `ToolResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolResultFilter>;
  /** No related `ToolResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolResultFilter>;
  /** Some related `ToolResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolResultFilter>;
};

/** A filter to be used against many `ToolSecret` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionToManyToolSecretFilter = {
  /** Every related `ToolSecret` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolSecretFilter>;
  /** No related `ToolSecret` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolSecretFilter>;
  /** Some related `ToolSecret` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolSecretFilter>;
};

/** A filter to be used against many `ToolSource` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionToManyToolSourceFilter = {
  /** Every related `ToolSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolSourceFilter>;
  /** No related `ToolSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolSourceFilter>;
  /** Some related `ToolSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolSourceFilter>;
};

/** A filter to be used against many `WorkflowSectionBlock` object types. All fields are combined with a logical ‘and.’ */
export type ToolVersionToManyWorkflowSectionBlockFilter = {
  /** Every related `WorkflowSectionBlock` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkflowSectionBlockFilter>;
  /** No related `WorkflowSectionBlock` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkflowSectionBlockFilter>;
  /** Some related `WorkflowSectionBlock` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkflowSectionBlockFilter>;
};

/** Input for the nested mutation of `tool` in the `ToolVersionInput` mutation. */
export type ToolVersionToolId3B396B22FkToolIdInput = {
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectById?: InputMaybe<ToolToolPkeyConnect>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  connectByProjectId?: InputMaybe<ToolToolProjectIdKeyConnect>;
  /** A `ToolInput` object that will be created and connected to this object. */
  create?: InputMaybe<ToolVersionToolId3B396B22FkToolIdToolCreateInput>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  deleteById?: InputMaybe<ToolToolPkeyDelete>;
  /** The primary key(s) for `tool` for the far side of the relationship. */
  deleteByProjectId?: InputMaybe<ToolToolProjectIdKeyDelete>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateById?: InputMaybe<ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolPkeyUpdate>;
  /** The primary key(s) and patch data for `tool` for the far side of the relationship. */
  updateByProjectId?: InputMaybe<ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolProjectIdKeyUpdate>;
};

/** Input for the nested mutation of `toolVersion` in the `ToolInput` mutation. */
export type ToolVersionToolId3B396B22FkToolIdInverseInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolVersionToolVersionPkeyConnect>>;
  /** A `ToolVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ToolVersionToolId3B396B22FkToolIdToolVersionCreateInput>
  >;
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ToolVersionToolVersionPkeyDelete>>;
  /** Flag indicating whether all other `toolVersion` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolVersionPkeyUpdate>
  >;
};

/** The `tool` to be created by this mutation. */
export type ToolVersionToolId3B396B22FkToolIdToolCreateInput = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  codeLink?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  docsLink?: InputMaybe<Scalars["String"]["input"]>;
  helpText: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key: Scalars["String"]["input"];
  maturity: Scalars["Int"]["input"];
  name: Scalars["String"]["input"];
  pinnedToolsUsingId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  searchTerms?: InputMaybe<Scalars["JSON"]["input"]>;
  status: Scalars["Int"]["input"];
  tags: Array<InputMaybe<Scalars["String"]["input"]>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
  toolboxToToolboxId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  visibility: Scalars["Int"]["input"];
};

/** The `toolVersion` to be created by this mutation. */
export type ToolVersionToolId3B396B22FkToolIdToolVersionCreateInput = {
  applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
  changelog?: InputMaybe<Scalars["String"]["input"]>;
  command?: InputMaybe<Scalars["String"]["input"]>;
  commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  isToolSpecForwardsCompatible: Scalars["Boolean"]["input"];
  isUpgradableToNextVersion: Scalars["Boolean"]["input"];
  maturity: Scalars["Int"]["input"];
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
  toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
  toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
  toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
  toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
  toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
  toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
  toolSpecVersion: Scalars["Int"]["input"];
  toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  version: Scalars["String"]["input"];
  visibility: Scalars["Int"]["input"];
  workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
};

/** The fields on `toolVersion` to look up the row to connect. */
export type ToolVersionToolVersionPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `toolVersion` to look up the row to delete. */
export type ToolVersionToolVersionPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** The `applicationUser` to be created by this mutation. */
export type ToolVersionUserId68A75E07FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `ToolVersionInput` mutation. */
export type ToolVersionUserId68A75E07FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `toolVersion` in the `ApplicationUserInput` mutation. */
export type ToolVersionUserId68A75E07FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolVersionToolVersionPkeyConnect>>;
  /** A `ToolVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ToolVersionUserId68A75E07FkApplicationUserIdToolVersionCreateInput>
  >;
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ToolVersionToolVersionPkeyDelete>>;
  /** Flag indicating whether all other `toolVersion` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingToolVersionPkeyUpdate>
  >;
};

/** The `toolVersion` to be created by this mutation. */
export type ToolVersionUserId68A75E07FkApplicationUserIdToolVersionCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible: Scalars["Boolean"]["input"];
    isUpgradableToNextVersion: Scalars["Boolean"]["input"];
    maturity: Scalars["Int"]["input"];
    status: Scalars["Int"]["input"];
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion: Scalars["Int"]["input"];
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    version: Scalars["String"]["input"];
    visibility: Scalars["Int"]["input"];
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** A connection to a list of `ToolVersion` values. */
export type ToolVersionsConnection = {
  __typename: "ToolVersionsConnection";
  /** A list of edges which contains the `ToolVersion` and cursor to aid in pagination. */
  edges: Array<ToolVersionsEdge>;
  /** A list of `ToolVersion` objects. */
  nodes: Array<ToolVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ToolVersion` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ToolVersion` edge in the connection. */
export type ToolVersionsEdge = {
  __typename: "ToolVersionsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ToolVersion` at the end of the edge. */
  node: ToolVersion;
};

/** Methods to use when ordering `ToolVersion`. */
export enum ToolVersionsOrderBy {
  ChangelogAsc = "CHANGELOG_ASC",
  ChangelogDesc = "CHANGELOG_DESC",
  CommandAsc = "COMMAND_ASC",
  CommandDesc = "COMMAND_DESC",
  ContainerImageIdAsc = "CONTAINER_IMAGE_ID_ASC",
  ContainerImageIdDesc = "CONTAINER_IMAGE_ID_DESC",
  CreatedAsc = "CREATED_ASC",
  CreatedDesc = "CREATED_DESC",
  CreditsAsc = "CREDITS_ASC",
  CreditsDesc = "CREDITS_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DraftToolSpecAsc = "DRAFT_TOOL_SPEC_ASC",
  DraftToolSpecDesc = "DRAFT_TOOL_SPEC_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  IsToolSpecForwardsCompatibleAsc = "IS_TOOL_SPEC_FORWARDS_COMPATIBLE_ASC",
  IsToolSpecForwardsCompatibleDesc = "IS_TOOL_SPEC_FORWARDS_COMPATIBLE_DESC",
  IsUpgradableToNextVersionAsc = "IS_UPGRADABLE_TO_NEXT_VERSION_ASC",
  IsUpgradableToNextVersionDesc = "IS_UPGRADABLE_TO_NEXT_VERSION_DESC",
  MaturityAsc = "MATURITY_ASC",
  MaturityDesc = "MATURITY_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  StatusAsc = "STATUS_ASC",
  StatusDesc = "STATUS_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  ToolIdAsc = "TOOL_ID_ASC",
  ToolIdDesc = "TOOL_ID_DESC",
  ToolSpecAsc = "TOOL_SPEC_ASC",
  ToolSpecDesc = "TOOL_SPEC_DESC",
  ToolSpecVersionAsc = "TOOL_SPEC_VERSION_ASC",
  ToolSpecVersionDesc = "TOOL_SPEC_VERSION_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
  VersionAsc = "VERSION_ASC",
  VersionDesc = "VERSION_DESC",
  VisibilityAsc = "VISIBILITY_ASC",
  VisibilityDesc = "VISIBILITY_DESC",
}

export type Toolbox = {
  __typename: "Toolbox";
  created: Maybe<Scalars["Datetime"]["output"]>;
  dateCreated: Scalars["Datetime"]["output"];
  id: Scalars["Int"]["output"];
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  /** Reads and enables pagination through a set of `ToolboxTenant`. */
  toolboxTenantsByToolboxId: ToolboxTenantsConnection;
  /** Reads and enables pagination through a set of `Tool`. */
  toolsByToolboxId: ToolsConnection;
};

export type ToolboxToolboxTenantsByToolboxIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolboxTenantCondition>;
  filter?: InputMaybe<ToolboxTenantFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolboxTenantsOrderBy>>;
};

export type ToolboxToolsByToolboxIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<ToolCondition>;
  filter?: InputMaybe<ToolFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ToolsOrderBy>>;
};

/** A condition to be used against `Toolbox` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ToolboxCondition = {
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** A filter to be used against `Toolbox` object types. All fields are combined with a logical ‘and.’ */
export type ToolboxFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ToolboxFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ToolboxFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ToolboxFilter>>;
  /** Filter by the object’s `toolboxTenantsByToolboxId` relation. */
  toolboxTenantsByToolboxId?: InputMaybe<ToolboxToManyToolboxTenantFilter>;
  /** Some related `toolboxTenantsByToolboxId` exist. */
  toolboxTenantsByToolboxIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `toolsByToolboxId` relation. */
  toolsByToolboxId?: InputMaybe<ToolboxToManyToolFilter>;
  /** Some related `toolsByToolboxId` exist. */
  toolsByToolboxIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** An input for mutations affecting `Toolbox` */
export type ToolboxInput = {
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsToolboxId9D553881FkToolboxIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInverseInput>;
};

/** The fields on `toolbox` to look up the row to update. */
export type ToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolboxKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `toolbox` being updated. */
    toolboxPatch: UpdateToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdPatch;
  };

/** The fields on `toolbox` to look up the row to update. */
export type ToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolboxPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolbox` being updated. */
    toolboxPatch: UpdateToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdPatch;
  };

/** The fields on `toolbox` to look up the row to update. */
export type ToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxKeyKeyUpdate =
  {
    key: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `toolbox` being updated. */
    toolboxPatch: UpdateToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdPatch;
  };

/** The fields on `toolbox` to look up the row to update. */
export type ToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolbox` being updated. */
    toolboxPatch: UpdateToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdPatch;
  };

/** Represents an update to a `Toolbox`. Fields that are set will be updated. */
export type ToolboxPatch = {
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsToolboxId9D553881FkToolboxIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInverseInput>;
};

export type ToolboxTenant = {
  __typename: "ToolboxTenant";
  id: Scalars["BigInt"]["output"];
  /** Reads a single `Tenant` that is related to this `ToolboxTenant`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
  /** Reads a single `Toolbox` that is related to this `ToolboxTenant`. */
  toolboxByToolboxId: Maybe<Toolbox>;
  toolboxId: Scalars["Int"]["output"];
};

/**
 * A condition to be used against `ToolboxTenant` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ToolboxTenantCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `toolboxId` field. */
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `ToolboxTenant` object types. All fields are combined with a logical ‘and.’ */
export type ToolboxTenantFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ToolboxTenantFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ToolboxTenantFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ToolboxTenantFilter>>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toolboxByToolboxId` relation. */
  toolboxByToolboxId?: InputMaybe<ToolboxFilter>;
  /** Filter by the object’s `toolboxId` field. */
  toolboxId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `ToolboxTenant` */
export type ToolboxTenantInput = {
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInput>;
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
  toolboxToToolboxId?: InputMaybe<ToolboxTenantsToolboxId9D553881FkToolboxIdInput>;
};

/** The fields on `toolboxTenant` to look up the row to update. */
export type ToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingToolboxTenantsPkeyUpdate =
  {
    id: Scalars["BigInt"]["input"];
    /** An object where the defined keys will be set on the `toolboxTenant` being updated. */
    toolboxTenantPatch: UpdateToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdPatch;
  };

/** The fields on `toolboxTenant` to look up the row to update. */
export type ToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingToolboxTenantsToolboxIdTenantId171F711CUniqUpdate =
  {
    tenantId: Scalars["Int"]["input"];
    toolboxId: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolboxTenant` being updated. */
    toolboxTenantPatch: UpdateToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdPatch;
  };

/** The fields on `toolboxTenant` to look up the row to update. */
export type ToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxTenantsPkeyUpdate =
  {
    id: Scalars["BigInt"]["input"];
    /** An object where the defined keys will be set on the `toolboxTenant` being updated. */
    toolboxTenantPatch: UpdateToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdPatch;
  };

/** The fields on `toolboxTenant` to look up the row to update. */
export type ToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxTenantsToolboxIdTenantId171F711CUniqUpdate =
  {
    tenantId: Scalars["Int"]["input"];
    toolboxId: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `toolboxTenant` being updated. */
    toolboxTenantPatch: UpdateToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdPatch;
  };

/** Represents an update to a `ToolboxTenant`. Fields that are set will be updated. */
export type ToolboxTenantPatch = {
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInput>;
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
  toolboxToToolboxId?: InputMaybe<ToolboxTenantsToolboxId9D553881FkToolboxIdInput>;
};

/** The fields on `toolboxTenant` to look up the row to connect. */
export type ToolboxTenantToolboxTenantsPkeyConnect = {
  id: Scalars["BigInt"]["input"];
};

/** The fields on `toolboxTenant` to look up the row to delete. */
export type ToolboxTenantToolboxTenantsPkeyDelete = {
  id: Scalars["BigInt"]["input"];
};

/** The fields on `toolboxTenant` to look up the row to connect. */
export type ToolboxTenantToolboxTenantsToolboxIdTenantId171F711CUniqConnect = {
  tenantId: Scalars["Int"]["input"];
  toolboxId: Scalars["Int"]["input"];
};

/** The fields on `toolboxTenant` to look up the row to delete. */
export type ToolboxTenantToolboxTenantsToolboxIdTenantId171F711CUniqDelete = {
  tenantId: Scalars["Int"]["input"];
  toolboxId: Scalars["Int"]["input"];
};

/** A connection to a list of `ToolboxTenant` values. */
export type ToolboxTenantsConnection = {
  __typename: "ToolboxTenantsConnection";
  /** A list of edges which contains the `ToolboxTenant` and cursor to aid in pagination. */
  edges: Array<ToolboxTenantsEdge>;
  /** A list of `ToolboxTenant` objects. */
  nodes: Array<ToolboxTenant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ToolboxTenant` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `ToolboxTenant` edge in the connection. */
export type ToolboxTenantsEdge = {
  __typename: "ToolboxTenantsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `ToolboxTenant` at the end of the edge. */
  node: ToolboxTenant;
};

/** Methods to use when ordering `ToolboxTenant`. */
export enum ToolboxTenantsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  ToolboxIdAsc = "TOOLBOX_ID_ASC",
  ToolboxIdDesc = "TOOLBOX_ID_DESC",
}

/** Input for the nested mutation of `tenant` in the `ToolboxTenantInput` mutation. */
export type ToolboxTenantsTenantId5D0A40E4FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `toolboxTenant` in the `TenantInput` mutation. */
export type ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput = {
  /** The primary key(s) for `toolboxTenant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolboxTenantToolboxTenantsPkeyConnect>>;
  /** The primary key(s) for `toolboxTenant` for the far side of the relationship. */
  connectByToolboxIdAndTenantId?: InputMaybe<
    Array<ToolboxTenantToolboxTenantsToolboxIdTenantId171F711CUniqConnect>
  >;
  /** A `ToolboxTenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ToolboxTenantsTenantId5D0A40E4FkTenantIdToolboxTenantsCreateInput>
  >;
  /** The primary key(s) for `toolboxTenant` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ToolboxTenantToolboxTenantsPkeyDelete>>;
  /** The primary key(s) for `toolboxTenant` for the far side of the relationship. */
  deleteByToolboxIdAndTenantId?: InputMaybe<
    Array<ToolboxTenantToolboxTenantsToolboxIdTenantId171F711CUniqDelete>
  >;
  /** Flag indicating whether all other `toolboxTenant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `toolboxTenant` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingToolboxTenantsPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `toolboxTenant` for the far side of the relationship. */
  updateByToolboxIdAndTenantId?: InputMaybe<
    Array<ToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingToolboxTenantsToolboxIdTenantId171F711CUniqUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type ToolboxTenantsTenantId5D0A40E4FkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** The `toolboxTenant` to be created by this mutation. */
export type ToolboxTenantsTenantId5D0A40E4FkTenantIdToolboxTenantsCreateInput =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInput>;
    toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
    toolboxToToolboxId?: InputMaybe<ToolboxTenantsToolboxId9D553881FkToolboxIdInput>;
  };

/** Input for the nested mutation of `toolbox` in the `ToolboxTenantInput` mutation. */
export type ToolboxTenantsToolboxId9D553881FkToolboxIdInput = {
  /** The primary key(s) for `toolbox` for the far side of the relationship. */
  connectById?: InputMaybe<ToolboxToolboxPkeyConnect>;
  /** The primary key(s) for `toolbox` for the far side of the relationship. */
  connectByKey?: InputMaybe<ToolboxToolboxKeyKeyConnect>;
  /** A `ToolboxInput` object that will be created and connected to this object. */
  create?: InputMaybe<ToolboxTenantsToolboxId9D553881FkToolboxIdToolboxCreateInput>;
  /** The primary key(s) for `toolbox` for the far side of the relationship. */
  deleteById?: InputMaybe<ToolboxToolboxPkeyDelete>;
  /** The primary key(s) for `toolbox` for the far side of the relationship. */
  deleteByKey?: InputMaybe<ToolboxToolboxKeyKeyDelete>;
  /** The primary key(s) and patch data for `toolbox` for the far side of the relationship. */
  updateById?: InputMaybe<ToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxPkeyUpdate>;
  /** The primary key(s) and patch data for `toolbox` for the far side of the relationship. */
  updateByKey?: InputMaybe<ToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxKeyKeyUpdate>;
};

/** Input for the nested mutation of `toolboxTenant` in the `ToolboxInput` mutation. */
export type ToolboxTenantsToolboxId9D553881FkToolboxIdInverseInput = {
  /** The primary key(s) for `toolboxTenant` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ToolboxTenantToolboxTenantsPkeyConnect>>;
  /** The primary key(s) for `toolboxTenant` for the far side of the relationship. */
  connectByToolboxIdAndTenantId?: InputMaybe<
    Array<ToolboxTenantToolboxTenantsToolboxIdTenantId171F711CUniqConnect>
  >;
  /** A `ToolboxTenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<ToolboxTenantsToolboxId9D553881FkToolboxIdToolboxTenantsCreateInput>
  >;
  /** The primary key(s) for `toolboxTenant` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ToolboxTenantToolboxTenantsPkeyDelete>>;
  /** The primary key(s) for `toolboxTenant` for the far side of the relationship. */
  deleteByToolboxIdAndTenantId?: InputMaybe<
    Array<ToolboxTenantToolboxTenantsToolboxIdTenantId171F711CUniqDelete>
  >;
  /** Flag indicating whether all other `toolboxTenant` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `toolboxTenant` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxTenantsPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `toolboxTenant` for the far side of the relationship. */
  updateByToolboxIdAndTenantId?: InputMaybe<
    Array<ToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxTenantsToolboxIdTenantId171F711CUniqUpdate>
  >;
};

/** The `toolbox` to be created by this mutation. */
export type ToolboxTenantsToolboxId9D553881FkToolboxIdToolboxCreateInput = {
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsToolboxId9D553881FkToolboxIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInverseInput>;
};

/** The `toolboxTenant` to be created by this mutation. */
export type ToolboxTenantsToolboxId9D553881FkToolboxIdToolboxTenantsCreateInput =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInput>;
    toolboxToToolboxId?: InputMaybe<ToolboxTenantsToolboxId9D553881FkToolboxIdInput>;
  };

/** A filter to be used against many `Tool` object types. All fields are combined with a logical ‘and.’ */
export type ToolboxToManyToolFilter = {
  /** Every related `Tool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolFilter>;
  /** No related `Tool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolFilter>;
  /** Some related `Tool` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolFilter>;
};

/** A filter to be used against many `ToolboxTenant` object types. All fields are combined with a logical ‘and.’ */
export type ToolboxToManyToolboxTenantFilter = {
  /** Every related `ToolboxTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ToolboxTenantFilter>;
  /** No related `ToolboxTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ToolboxTenantFilter>;
  /** Some related `ToolboxTenant` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ToolboxTenantFilter>;
};

/** The fields on `toolbox` to look up the row to connect. */
export type ToolboxToolboxKeyKeyConnect = {
  key: Scalars["String"]["input"];
};

/** The fields on `toolbox` to look up the row to delete. */
export type ToolboxToolboxKeyKeyDelete = {
  key: Scalars["String"]["input"];
};

/** The fields on `toolbox` to look up the row to connect. */
export type ToolboxToolboxPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `toolbox` to look up the row to delete. */
export type ToolboxToolboxPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** A connection to a list of `Toolbox` values. */
export type ToolboxesConnection = {
  __typename: "ToolboxesConnection";
  /** A list of edges which contains the `Toolbox` and cursor to aid in pagination. */
  edges: Array<ToolboxesEdge>;
  /** A list of `Toolbox` objects. */
  nodes: Array<Toolbox>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Toolbox` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `Toolbox` edge in the connection. */
export type ToolboxesEdge = {
  __typename: "ToolboxesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `Toolbox` at the end of the edge. */
  node: Toolbox;
};

/** Methods to use when ordering `Toolbox`. */
export enum ToolboxesOrderBy {
  CreatedAsc = "CREATED_ASC",
  CreatedDesc = "CREATED_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  KeyAsc = "KEY_ASC",
  KeyDesc = "KEY_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

/** A connection to a list of `Tool` values. */
export type ToolsConnection = {
  __typename: "ToolsConnection";
  /** A list of edges which contains the `Tool` and cursor to aid in pagination. */
  edges: Array<ToolsEdge>;
  /** A list of `Tool` objects. */
  nodes: Array<Tool>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Tool` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `Tool` edge in the connection. */
export type ToolsEdge = {
  __typename: "ToolsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `Tool` at the end of the edge. */
  node: Tool;
};

/** Methods to use when ordering `Tool`. */
export enum ToolsOrderBy {
  CodeLinkAsc = "CODE_LINK_ASC",
  CodeLinkDesc = "CODE_LINK_DESC",
  CreatedAsc = "CREATED_ASC",
  CreatedDesc = "CREATED_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DocsLinkAsc = "DOCS_LINK_ASC",
  DocsLinkDesc = "DOCS_LINK_DESC",
  HelpTextAsc = "HELP_TEXT_ASC",
  HelpTextDesc = "HELP_TEXT_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  KeyAsc = "KEY_ASC",
  KeyDesc = "KEY_DESC",
  MaturityAsc = "MATURITY_ASC",
  MaturityDesc = "MATURITY_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  SearchTermsAsc = "SEARCH_TERMS_ASC",
  SearchTermsDesc = "SEARCH_TERMS_DESC",
  StatusAsc = "STATUS_ASC",
  StatusDesc = "STATUS_DESC",
  TagsAsc = "TAGS_ASC",
  TagsDesc = "TAGS_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  ToolboxIdAsc = "TOOLBOX_ID_ASC",
  ToolboxIdDesc = "TOOLBOX_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
  VisibilityAsc = "VISIBILITY_ASC",
  VisibilityDesc = "VISIBILITY_DESC",
}

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
};

/** All input for the `updateApplicationUserByEmail` mutation. */
export type UpdateApplicationUserByEmailInput = {
  /** An object where the defined keys will be set on the `ApplicationUser` being updated. */
  applicationUserPatch: ApplicationUserPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
};

/** All input for the `updateApplicationUserByGlobalUserId` mutation. */
export type UpdateApplicationUserByGlobalUserIdInput = {
  /** An object where the defined keys will be set on the `ApplicationUser` being updated. */
  applicationUserPatch: ApplicationUserPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  globalUserId: Scalars["UUID"]["input"];
};

/** All input for the `updateApplicationUserById` mutation. */
export type UpdateApplicationUserByIdInput = {
  /** An object where the defined keys will be set on the `ApplicationUser` being updated. */
  applicationUserPatch: ApplicationUserPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** All input for the `updateApplicationUserByUsername` mutation. */
export type UpdateApplicationUserByUsernameInput = {
  /** An object where the defined keys will be set on the `ApplicationUser` being updated. */
  applicationUserPatch: ApplicationUserPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  username: Scalars["String"]["input"];
};

/** All input for the `updateApplicationUserGroupById` mutation. */
export type UpdateApplicationUserGroupByIdInput = {
  /** An object where the defined keys will be set on the `ApplicationUserGroup` being updated. */
  applicationUserGroupPatch: ApplicationUserGroupPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** All input for the `updateApplicationUserGroupByUserIdAndGroupId` mutation. */
export type UpdateApplicationUserGroupByUserIdAndGroupIdInput = {
  /** An object where the defined keys will be set on the `ApplicationUserGroup` being updated. */
  applicationUserGroupPatch: ApplicationUserGroupPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  groupId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The output of our update `ApplicationUserGroup` mutation. */
export type UpdateApplicationUserGroupPayload = {
  __typename: "UpdateApplicationUserGroupPayload";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserGroup`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserGroup` that was updated by this mutation. */
  applicationUserGroup: Maybe<ApplicationUserGroup>;
  /** An edge for our `ApplicationUserGroup`. May be used by Relay 1. */
  applicationUserGroupEdge: Maybe<ApplicationUserGroupsEdge>;
  /** Reads a single `AuthGroup` that is related to this `ApplicationUserGroup`. */
  authGroupByGroupId: Maybe<AuthGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `ApplicationUserGroup` mutation. */
export type UpdateApplicationUserGroupPayloadApplicationUserGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ApplicationUserGroupsOrderBy>>;
};

/** All input for the `updateApplicationUserMembershipById` mutation. */
export type UpdateApplicationUserMembershipByIdInput = {
  /** An object where the defined keys will be set on the `ApplicationUserMembership` being updated. */
  applicationUserMembershipPatch: ApplicationUserMembershipPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `updateApplicationUserMembershipByUserIdAndTenantId` mutation. */
export type UpdateApplicationUserMembershipByUserIdAndTenantIdInput = {
  /** An object where the defined keys will be set on the `ApplicationUserMembership` being updated. */
  applicationUserMembershipPatch: ApplicationUserMembershipPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  tenantId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The output of our update `ApplicationUserMembership` mutation. */
export type UpdateApplicationUserMembershipPayload = {
  __typename: "UpdateApplicationUserMembershipPayload";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserMembership`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserMembership` that was updated by this mutation. */
  applicationUserMembership: Maybe<ApplicationUserMembership>;
  /** An edge for our `ApplicationUserMembership`. May be used by Relay 1. */
  applicationUserMembershipEdge: Maybe<ApplicationUserMembershipsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ApplicationUserMembership`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our update `ApplicationUserMembership` mutation. */
export type UpdateApplicationUserMembershipPayloadApplicationUserMembershipEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ApplicationUserMembershipsOrderBy>>;
  };

/** All input for the `updateApplicationUserMetadatumById` mutation. */
export type UpdateApplicationUserMetadatumByIdInput = {
  /** An object where the defined keys will be set on the `ApplicationUserMetadatum` being updated. */
  applicationUserMetadatumPatch: ApplicationUserMetadatumPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `updateApplicationUserMetadatumByUserIdAndKey` mutation. */
export type UpdateApplicationUserMetadatumByUserIdAndKeyInput = {
  /** An object where the defined keys will be set on the `ApplicationUserMetadatum` being updated. */
  applicationUserMetadatumPatch: ApplicationUserMetadatumPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  key: Scalars["String"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The output of our update `ApplicationUserMetadatum` mutation. */
export type UpdateApplicationUserMetadatumPayload = {
  __typename: "UpdateApplicationUserMetadatumPayload";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserMetadatum`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserMetadatum` that was updated by this mutation. */
  applicationUserMetadatum: Maybe<ApplicationUserMetadatum>;
  /** An edge for our `ApplicationUserMetadatum`. May be used by Relay 1. */
  applicationUserMetadatumEdge: Maybe<ApplicationUserMetadataEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `ApplicationUserMetadatum` mutation. */
export type UpdateApplicationUserMetadatumPayloadApplicationUserMetadatumEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ApplicationUserMetadataOrderBy>>;
  };

/** The output of our update `ApplicationUser` mutation. */
export type UpdateApplicationUserPayload = {
  __typename: "UpdateApplicationUserPayload";
  /** The `ApplicationUser` that was updated by this mutation. */
  applicationUser: Maybe<ApplicationUser>;
  /** An edge for our `ApplicationUser`. May be used by Relay 1. */
  applicationUserEdge: Maybe<ApplicationUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `ApplicationUser` mutation. */
export type UpdateApplicationUserPayloadApplicationUserEdgeArgs = {
  orderBy?: InputMaybe<Array<ApplicationUsersOrderBy>>;
};

/** All input for the `updateApplicationUserSessionById` mutation. */
export type UpdateApplicationUserSessionByIdInput = {
  /** An object where the defined keys will be set on the `ApplicationUserSession` being updated. */
  applicationUserSessionPatch: ApplicationUserSessionPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
};

/** The output of our update `ApplicationUserSession` mutation. */
export type UpdateApplicationUserSessionPayload = {
  __typename: "UpdateApplicationUserSessionPayload";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserSession`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserSession` that was updated by this mutation. */
  applicationUserSession: Maybe<ApplicationUserSession>;
  /** An edge for our `ApplicationUserSession`. May be used by Relay 1. */
  applicationUserSessionEdge: Maybe<ApplicationUserSessionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ApplicationUserSession`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our update `ApplicationUserSession` mutation. */
export type UpdateApplicationUserSessionPayloadApplicationUserSessionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ApplicationUserSessionsOrderBy>>;
  };

/** All input for the `updateApplicationUserUserPermissionById` mutation. */
export type UpdateApplicationUserUserPermissionByIdInput = {
  /** An object where the defined keys will be set on the `ApplicationUserUserPermission` being updated. */
  applicationUserUserPermissionPatch: ApplicationUserUserPermissionPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** All input for the `updateApplicationUserUserPermissionByUserIdAndPermissionId` mutation. */
export type UpdateApplicationUserUserPermissionByUserIdAndPermissionIdInput = {
  /** An object where the defined keys will be set on the `ApplicationUserUserPermission` being updated. */
  applicationUserUserPermissionPatch: ApplicationUserUserPermissionPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  permissionId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The output of our update `ApplicationUserUserPermission` mutation. */
export type UpdateApplicationUserUserPermissionPayload = {
  __typename: "UpdateApplicationUserUserPermissionPayload";
  /** Reads a single `ApplicationUser` that is related to this `ApplicationUserUserPermission`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `ApplicationUserUserPermission` that was updated by this mutation. */
  applicationUserUserPermission: Maybe<ApplicationUserUserPermission>;
  /** An edge for our `ApplicationUserUserPermission`. May be used by Relay 1. */
  applicationUserUserPermissionEdge: Maybe<ApplicationUserUserPermissionsEdge>;
  /** Reads a single `AuthPermission` that is related to this `ApplicationUserUserPermission`. */
  authPermissionByPermissionId: Maybe<AuthPermission>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `ApplicationUserUserPermission` mutation. */
export type UpdateApplicationUserUserPermissionPayloadApplicationUserUserPermissionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ApplicationUserUserPermissionsOrderBy>>;
  };

/** All input for the `updateAuditlogLogentryById` mutation. */
export type UpdateAuditlogLogentryByIdInput = {
  /** An object where the defined keys will be set on the `AuditlogLogentry` being updated. */
  auditlogLogentryPatch: AuditlogLogentryPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our update `AuditlogLogentry` mutation. */
export type UpdateAuditlogLogentryPayload = {
  __typename: "UpdateAuditlogLogentryPayload";
  /** Reads a single `ApplicationUser` that is related to this `AuditlogLogentry`. */
  applicationUserByActorId: Maybe<ApplicationUser>;
  /** The `AuditlogLogentry` that was updated by this mutation. */
  auditlogLogentry: Maybe<AuditlogLogentry>;
  /** An edge for our `AuditlogLogentry`. May be used by Relay 1. */
  auditlogLogentryEdge: Maybe<AuditlogLogentriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `AuditlogLogentry`. */
  djangoContentTypeByContentTypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `AuditlogLogentry` mutation. */
export type UpdateAuditlogLogentryPayloadAuditlogLogentryEdgeArgs = {
  orderBy?: InputMaybe<Array<AuditlogLogentriesOrderBy>>;
};

/** All input for the `updateAuthGroupById` mutation. */
export type UpdateAuthGroupByIdInput = {
  /** An object where the defined keys will be set on the `AuthGroup` being updated. */
  authGroupPatch: AuthGroupPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** All input for the `updateAuthGroupByName` mutation. */
export type UpdateAuthGroupByNameInput = {
  /** An object where the defined keys will be set on the `AuthGroup` being updated. */
  authGroupPatch: AuthGroupPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

/** The output of our update `AuthGroup` mutation. */
export type UpdateAuthGroupPayload = {
  __typename: "UpdateAuthGroupPayload";
  /** The `AuthGroup` that was updated by this mutation. */
  authGroup: Maybe<AuthGroup>;
  /** An edge for our `AuthGroup`. May be used by Relay 1. */
  authGroupEdge: Maybe<AuthGroupsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `AuthGroup` mutation. */
export type UpdateAuthGroupPayloadAuthGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<AuthGroupsOrderBy>>;
};

/** All input for the `updateAuthGroupPermissionByGroupIdAndPermissionId` mutation. */
export type UpdateAuthGroupPermissionByGroupIdAndPermissionIdInput = {
  /** An object where the defined keys will be set on the `AuthGroupPermission` being updated. */
  authGroupPermissionPatch: AuthGroupPermissionPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  groupId: Scalars["Int"]["input"];
  permissionId: Scalars["Int"]["input"];
};

/** All input for the `updateAuthGroupPermissionById` mutation. */
export type UpdateAuthGroupPermissionByIdInput = {
  /** An object where the defined keys will be set on the `AuthGroupPermission` being updated. */
  authGroupPermissionPatch: AuthGroupPermissionPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** The output of our update `AuthGroupPermission` mutation. */
export type UpdateAuthGroupPermissionPayload = {
  __typename: "UpdateAuthGroupPermissionPayload";
  /** Reads a single `AuthGroup` that is related to this `AuthGroupPermission`. */
  authGroupByGroupId: Maybe<AuthGroup>;
  /** The `AuthGroupPermission` that was updated by this mutation. */
  authGroupPermission: Maybe<AuthGroupPermission>;
  /** An edge for our `AuthGroupPermission`. May be used by Relay 1. */
  authGroupPermissionEdge: Maybe<AuthGroupPermissionsEdge>;
  /** Reads a single `AuthPermission` that is related to this `AuthGroupPermission`. */
  authPermissionByPermissionId: Maybe<AuthPermission>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `AuthGroupPermission` mutation. */
export type UpdateAuthGroupPermissionPayloadAuthGroupPermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<AuthGroupPermissionsOrderBy>>;
};

/** All input for the `updateAuthPermissionByContentTypeIdAndCodename` mutation. */
export type UpdateAuthPermissionByContentTypeIdAndCodenameInput = {
  /** An object where the defined keys will be set on the `AuthPermission` being updated. */
  authPermissionPatch: AuthPermissionPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  codename: Scalars["String"]["input"];
  contentTypeId: Scalars["Int"]["input"];
};

/** All input for the `updateAuthPermissionById` mutation. */
export type UpdateAuthPermissionByIdInput = {
  /** An object where the defined keys will be set on the `AuthPermission` being updated. */
  authPermissionPatch: AuthPermissionPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
};

/** The output of our update `AuthPermission` mutation. */
export type UpdateAuthPermissionPayload = {
  __typename: "UpdateAuthPermissionPayload";
  /** The `AuthPermission` that was updated by this mutation. */
  authPermission: Maybe<AuthPermission>;
  /** An edge for our `AuthPermission`. May be used by Relay 1. */
  authPermissionEdge: Maybe<AuthPermissionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `AuthPermission`. */
  djangoContentTypeByContentTypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `AuthPermission` mutation. */
export type UpdateAuthPermissionPayloadAuthPermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<AuthPermissionsOrderBy>>;
};

/** All input for the `updateAvatarById` mutation. */
export type UpdateAvatarByIdInput = {
  /** An object where the defined keys will be set on the `Avatar` being updated. */
  avatarPatch: AvatarPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
};

/** All input for the `updateAvatarByUserId` mutation. */
export type UpdateAvatarByUserIdInput = {
  /** An object where the defined keys will be set on the `Avatar` being updated. */
  avatarPatch: AvatarPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  userId: Scalars["UUID"]["input"];
};

/** The output of our update `Avatar` mutation. */
export type UpdateAvatarPayload = {
  __typename: "UpdateAvatarPayload";
  /** Reads a single `ApplicationUser` that is related to this `Avatar`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /** The `Avatar` that was updated by this mutation. */
  avatar: Maybe<Avatar>;
  /** An edge for our `Avatar`. May be used by Relay 1. */
  avatarEdge: Maybe<AvatarsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `Avatar` mutation. */
export type UpdateAvatarPayloadAvatarEdgeArgs = {
  orderBy?: InputMaybe<Array<AvatarsOrderBy>>;
};

/** All input for the `updateAwsBatchTaskByTaskexecutorPtrId` mutation. */
export type UpdateAwsBatchTaskByTaskexecutorPtrIdInput = {
  /** An object where the defined keys will be set on the `AwsBatchTask` being updated. */
  awsBatchTaskPatch: AwsBatchTaskPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  taskexecutorPtrId: Scalars["UUID"]["input"];
};

/** The output of our update `AwsBatchTask` mutation. */
export type UpdateAwsBatchTaskPayload = {
  __typename: "UpdateAwsBatchTaskPayload";
  /** The `AwsBatchTask` that was updated by this mutation. */
  awsBatchTask: Maybe<AwsBatchTask>;
  /** An edge for our `AwsBatchTask`. May be used by Relay 1. */
  awsBatchTaskEdge: Maybe<AwsBatchTasksEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TesTaskexecutor` that is related to this `AwsBatchTask`. */
  tesTaskexecutorByTaskexecutorPtrId: Maybe<TesTaskexecutor>;
};

/** The output of our update `AwsBatchTask` mutation. */
export type UpdateAwsBatchTaskPayloadAwsBatchTaskEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsBatchTasksOrderBy>>;
};

/** All input for the `updateAwsCognitoUserByUserexecutorPtrId` mutation. */
export type UpdateAwsCognitoUserByUserexecutorPtrIdInput = {
  /** An object where the defined keys will be set on the `AwsCognitoUser` being updated. */
  awsCognitoUserPatch: AwsCognitoUserPatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  userexecutorPtrId: Scalars["Int"]["input"];
};

/** The output of our update `AwsCognitoUser` mutation. */
export type UpdateAwsCognitoUserPayload = {
  __typename: "UpdateAwsCognitoUserPayload";
  /** The `AwsCognitoUser` that was updated by this mutation. */
  awsCognitoUser: Maybe<AwsCognitoUser>;
  /** An edge for our `AwsCognitoUser`. May be used by Relay 1. */
  awsCognitoUserEdge: Maybe<AwsCognitoUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TenantUserexecutor` that is related to this `AwsCognitoUser`. */
  tenantUserexecutorByUserexecutorPtrId: Maybe<TenantUserexecutor>;
};

/** The output of our update `AwsCognitoUser` mutation. */
export type UpdateAwsCognitoUserPayloadAwsCognitoUserEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsCognitoUsersOrderBy>>;
};

/** All input for the `updateAwsEcrImageByContainerimageexecutorPtrId` mutation. */
export type UpdateAwsEcrImageByContainerimageexecutorPtrIdInput = {
  /** An object where the defined keys will be set on the `AwsEcrImage` being updated. */
  awsEcrImagePatch: AwsEcrImagePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  containerimageexecutorPtrId: Scalars["Int"]["input"];
};

/** The output of our update `AwsEcrImage` mutation. */
export type UpdateAwsEcrImagePayload = {
  __typename: "UpdateAwsEcrImagePayload";
  /** The `AwsEcrImage` that was updated by this mutation. */
  awsEcrImage: Maybe<AwsEcrImage>;
  /** An edge for our `AwsEcrImage`. May be used by Relay 1. */
  awsEcrImageEdge: Maybe<AwsEcrImagesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TesContainerimageexecutor` that is related to this `AwsEcrImage`. */
  tesContainerimageexecutorByContainerimageexecutorPtrId: Maybe<TesContainerimageexecutor>;
};

/** The output of our update `AwsEcrImage` mutation. */
export type UpdateAwsEcrImagePayloadAwsEcrImageEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsEcrImagesOrderBy>>;
};

/** All input for the `updateAwsMockBatchTaskByAwstaskexecutorPtrId` mutation. */
export type UpdateAwsMockBatchTaskByAwstaskexecutorPtrIdInput = {
  /** An object where the defined keys will be set on the `AwsMockBatchTask` being updated. */
  awsMockBatchTaskPatch: AwsMockBatchTaskPatch;
  awstaskexecutorPtrId: Scalars["UUID"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our update `AwsMockBatchTask` mutation. */
export type UpdateAwsMockBatchTaskPayload = {
  __typename: "UpdateAwsMockBatchTaskPayload";
  /** Reads a single `AwsBatchTask` that is related to this `AwsMockBatchTask`. */
  awsBatchTaskByAwstaskexecutorPtrId: Maybe<AwsBatchTask>;
  /** The `AwsMockBatchTask` that was updated by this mutation. */
  awsMockBatchTask: Maybe<AwsMockBatchTask>;
  /** An edge for our `AwsMockBatchTask`. May be used by Relay 1. */
  awsMockBatchTaskEdge: Maybe<AwsMockBatchTasksEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `AwsMockBatchTask` mutation. */
export type UpdateAwsMockBatchTaskPayloadAwsMockBatchTaskEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsMockBatchTasksOrderBy>>;
};

/** All input for the `updateAwsMockDistributionImageByDistributioncontainerimageexecutorPtrId` mutation. */
export type UpdateAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdInput =
  {
    /** An object where the defined keys will be set on the `AwsMockDistributionImage` being updated. */
    awsMockDistributionImagePatch: AwsMockDistributionImagePatch;
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    distributioncontainerimageexecutorPtrId: Scalars["Int"]["input"];
  };

/** The output of our update `AwsMockDistributionImage` mutation. */
export type UpdateAwsMockDistributionImagePayload = {
  __typename: "UpdateAwsMockDistributionImagePayload";
  /** The `AwsMockDistributionImage` that was updated by this mutation. */
  awsMockDistributionImage: Maybe<AwsMockDistributionImage>;
  /** An edge for our `AwsMockDistributionImage`. May be used by Relay 1. */
  awsMockDistributionImageEdge: Maybe<AwsMockDistributionImagesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DistributionRegistryImage` that is related to this `AwsMockDistributionImage`. */
  distributionRegistryImageByDistributioncontainerimageexecutorPtrId: Maybe<DistributionRegistryImage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `AwsMockDistributionImage` mutation. */
export type UpdateAwsMockDistributionImagePayloadAwsMockDistributionImageEdgeArgs =
  {
    orderBy?: InputMaybe<Array<AwsMockDistributionImagesOrderBy>>;
  };

/** All input for the `updateAwsMockEcrImageByAwscontainerimageexecutorPtrId` mutation. */
export type UpdateAwsMockEcrImageByAwscontainerimageexecutorPtrIdInput = {
  /** An object where the defined keys will be set on the `AwsMockEcrImage` being updated. */
  awsMockEcrImagePatch: AwsMockEcrImagePatch;
  awscontainerimageexecutorPtrId: Scalars["Int"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our update `AwsMockEcrImage` mutation. */
export type UpdateAwsMockEcrImagePayload = {
  __typename: "UpdateAwsMockEcrImagePayload";
  /** Reads a single `AwsEcrImage` that is related to this `AwsMockEcrImage`. */
  awsEcrImageByAwscontainerimageexecutorPtrId: Maybe<AwsEcrImage>;
  /** The `AwsMockEcrImage` that was updated by this mutation. */
  awsMockEcrImage: Maybe<AwsMockEcrImage>;
  /** An edge for our `AwsMockEcrImage`. May be used by Relay 1. */
  awsMockEcrImageEdge: Maybe<AwsMockEcrImagesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `AwsMockEcrImage` mutation. */
export type UpdateAwsMockEcrImagePayloadAwsMockEcrImageEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsMockEcrImagesOrderBy>>;
};

/** All input for the `updateAwsMockIamUserByAwsuserexecutorPtrId` mutation. */
export type UpdateAwsMockIamUserByAwsuserexecutorPtrIdInput = {
  /** An object where the defined keys will be set on the `AwsMockIamUser` being updated. */
  awsMockIamUserPatch: AwsMockIamUserPatch;
  awsuserexecutorPtrId: Scalars["Int"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our update `AwsMockIamUser` mutation. */
export type UpdateAwsMockIamUserPayload = {
  __typename: "UpdateAwsMockIamUserPayload";
  /** Reads a single `AwsCognitoUser` that is related to this `AwsMockIamUser`. */
  awsCognitoUserByAwsuserexecutorPtrId: Maybe<AwsCognitoUser>;
  /** The `AwsMockIamUser` that was updated by this mutation. */
  awsMockIamUser: Maybe<AwsMockIamUser>;
  /** An edge for our `AwsMockIamUser`. May be used by Relay 1. */
  awsMockIamUserEdge: Maybe<AwsMockIamUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `AwsMockIamUser` mutation. */
export type UpdateAwsMockIamUserPayloadAwsMockIamUserEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsMockIamUsersOrderBy>>;
};

/** All input for the `updateAwsMockS3FileByAwsfileexecutorPtrId` mutation. */
export type UpdateAwsMockS3FileByAwsfileexecutorPtrIdInput = {
  /** An object where the defined keys will be set on the `AwsMockS3File` being updated. */
  awsMockS3FilePatch: AwsMockS3FilePatch;
  awsfileexecutorPtrId: Scalars["UUID"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The output of our update `AwsMockS3File` mutation. */
export type UpdateAwsMockS3FilePayload = {
  __typename: "UpdateAwsMockS3FilePayload";
  /** The `AwsMockS3File` that was updated by this mutation. */
  awsMockS3File: Maybe<AwsMockS3File>;
  /** An edge for our `AwsMockS3File`. May be used by Relay 1. */
  awsMockS3FileEdge: Maybe<AwsMockS3FilesEdge>;
  /** Reads a single `AwsS3File` that is related to this `AwsMockS3File`. */
  awsS3FileByAwsfileexecutorPtrId: Maybe<AwsS3File>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `AwsMockS3File` mutation. */
export type UpdateAwsMockS3FilePayloadAwsMockS3FileEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsMockS3FilesOrderBy>>;
};

/** All input for the `updateAwsS3FileByFileexecutorPtrId` mutation. */
export type UpdateAwsS3FileByFileexecutorPtrIdInput = {
  /** An object where the defined keys will be set on the `AwsS3File` being updated. */
  awsS3FilePatch: AwsS3FilePatch;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  fileexecutorPtrId: Scalars["UUID"]["input"];
};

/** The output of our update `AwsS3File` mutation. */
export type UpdateAwsS3FilePayload = {
  __typename: "UpdateAwsS3FilePayload";
  /** The `AwsS3File` that was updated by this mutation. */
  awsS3File: Maybe<AwsS3File>;
  /** An edge for our `AwsS3File`. May be used by Relay 1. */
  awsS3FileEdge: Maybe<AwsS3FilesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DrsFileexecutor` that is related to this `AwsS3File`. */
  drsFileexecutorByFileexecutorPtrId: Maybe<DrsFileexecutor>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `AwsS3File` mutation. */
export type UpdateAwsS3FilePayloadAwsS3FileEdgeArgs = {
  orderBy?: InputMaybe<Array<AwsS3FilesOrderBy>>;
};

/** All input for the `updateCodeFileById` mutation. */
export type UpdateCodeFileByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `CodeFile` being updated. */
  codeFilePatch: CodeFilePatch;
  id: Scalars["UUID"]["input"];
};

/** The output of our update `CodeFile` mutation. */
export type UpdateCodeFilePayload = {
  __typename: "UpdateCodeFilePayload";
  /** Reads a single `ApplicationUser` that is related to this `CodeFile`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `CodeFile` that was updated by this mutation. */
  codeFile: Maybe<CodeFile>;
  /** Reads a single `CodeFile` that is related to this `CodeFile`. */
  codeFileBySeriesParentId: Maybe<CodeFile>;
  /** An edge for our `CodeFile`. May be used by Relay 1. */
  codeFileEdge: Maybe<CodeFilesEdge>;
  /** Reads a single `DrsFileexecutor` that is related to this `CodeFile`. */
  drsFileexecutorByExecutorId: Maybe<DrsFileexecutor>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `CodeFile`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our update `CodeFile` mutation. */
export type UpdateCodeFilePayloadCodeFileEdgeArgs = {
  orderBy?: InputMaybe<Array<CodeFilesOrderBy>>;
};

/** All input for the `updateCommandById` mutation. */
export type UpdateCommandByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `Command` being updated. */
  commandPatch: CommandPatch;
  id: Scalars["UUID"]["input"];
};

/** All input for the `updateCommandByToolVersionIdAndCodeFileId` mutation. */
export type UpdateCommandByToolVersionIdAndCodeFileIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  codeFileId: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `Command` being updated. */
  commandPatch: CommandPatch;
  toolVersionId: Scalars["Int"]["input"];
};

/** All input for the `updateCommandByToolVersionId` mutation. */
export type UpdateCommandByToolVersionIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `Command` being updated. */
  commandPatch: CommandPatch;
  toolVersionId: Scalars["Int"]["input"];
};

/** The output of our update `Command` mutation. */
export type UpdateCommandPayload = {
  __typename: "UpdateCommandPayload";
  /** Reads a single `ApplicationUser` that is related to this `Command`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `CodeFile` that is related to this `Command`. */
  codeFileByCodeFileId: Maybe<CodeFile>;
  /** The `Command` that was updated by this mutation. */
  command: Maybe<Command>;
  /** An edge for our `Command`. May be used by Relay 1. */
  commandEdge: Maybe<CommandsEdge>;
  /** Reads a single `ContainerImage` that is related to this `Command`. */
  containerImageByContainerImageId: Maybe<ContainerImage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Command`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `ToolVersion` that is related to this `Command`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our update `Command` mutation. */
export type UpdateCommandPayloadCommandEdgeArgs = {
  orderBy?: InputMaybe<Array<CommandsOrderBy>>;
};

/** All input for the `updateContainerImageByExecutorId` mutation. */
export type UpdateContainerImageByExecutorIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `ContainerImage` being updated. */
  containerImagePatch: ContainerImagePatch;
  executorId: Scalars["Int"]["input"];
};

/** All input for the `updateContainerImageById` mutation. */
export type UpdateContainerImageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `ContainerImage` being updated. */
  containerImagePatch: ContainerImagePatch;
  id: Scalars["Int"]["input"];
};

/** The output of our update `ContainerImage` mutation. */
export type UpdateContainerImagePayload = {
  __typename: "UpdateContainerImagePayload";
  /** Reads a single `ApplicationUser` that is related to this `ContainerImage`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `ContainerImage` that was updated by this mutation. */
  containerImage: Maybe<ContainerImage>;
  /** An edge for our `ContainerImage`. May be used by Relay 1. */
  containerImageEdge: Maybe<ContainerImagesEdge>;
  /** Reads a single `ContainerImageRepository` that is related to this `ContainerImage`. */
  containerImageRepositoryByContainerImageRepositoryId: Maybe<ContainerImageRepository>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ContainerImage`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `TesContainerimageexecutor` that is related to this `ContainerImage`. */
  tesContainerimageexecutorByExecutorId: Maybe<TesContainerimageexecutor>;
};

/** The output of our update `ContainerImage` mutation. */
export type UpdateContainerImagePayloadContainerImageEdgeArgs = {
  orderBy?: InputMaybe<Array<ContainerImagesOrderBy>>;
};

/** All input for the `updateContainerImageRepositoryById` mutation. */
export type UpdateContainerImageRepositoryByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `ContainerImageRepository` being updated. */
  containerImageRepositoryPatch: ContainerImageRepositoryPatch;
  id: Scalars["Int"]["input"];
};

/** All input for the `updateContainerImageRepositoryByNameAndTenantIdAndRegistryType` mutation. */
export type UpdateContainerImageRepositoryByNameAndTenantIdAndRegistryTypeInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    /** An object where the defined keys will be set on the `ContainerImageRepository` being updated. */
    containerImageRepositoryPatch: ContainerImageRepositoryPatch;
    name: Scalars["String"]["input"];
    registryType: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
  };

/** All input for the `updateContainerImageRepositoryByRepository` mutation. */
export type UpdateContainerImageRepositoryByRepositoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `ContainerImageRepository` being updated. */
  containerImageRepositoryPatch: ContainerImageRepositoryPatch;
  repository: Scalars["String"]["input"];
};

/** The output of our update `ContainerImageRepository` mutation. */
export type UpdateContainerImageRepositoryPayload = {
  __typename: "UpdateContainerImageRepositoryPayload";
  /** Reads a single `ApplicationUser` that is related to this `ContainerImageRepository`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `ContainerImageRepository` that was updated by this mutation. */
  containerImageRepository: Maybe<ContainerImageRepository>;
  /** An edge for our `ContainerImageRepository`. May be used by Relay 1. */
  containerImageRepositoryEdge: Maybe<ContainerImageRepositoriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ContainerImageRepository`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our update `ContainerImageRepository` mutation. */
export type UpdateContainerImageRepositoryPayloadContainerImageRepositoryEdgeArgs =
  {
    orderBy?: InputMaybe<Array<ContainerImageRepositoriesOrderBy>>;
  };

/** All input for the `updateCostById` mutation. */
export type UpdateCostByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `Cost` being updated. */
  costPatch: CostPatch;
  id: Scalars["BigInt"]["input"];
};

/** The output of our update `Cost` mutation. */
export type UpdateCostPayload = {
  __typename: "UpdateCostPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `Cost` that was updated by this mutation. */
  cost: Maybe<Cost>;
  /** An edge for our `Cost`. May be used by Relay 1. */
  costEdge: Maybe<CostsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Cost`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our update `Cost` mutation. */
export type UpdateCostPayloadCostEdgeArgs = {
  orderBy?: InputMaybe<Array<CostsOrderBy>>;
};

/** All input for the `updateDistributionRegistryImageByContainerimageexecutorPtrId` mutation. */
export type UpdateDistributionRegistryImageByContainerimageexecutorPtrIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    containerimageexecutorPtrId: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `DistributionRegistryImage` being updated. */
    distributionRegistryImagePatch: DistributionRegistryImagePatch;
  };

/** The output of our update `DistributionRegistryImage` mutation. */
export type UpdateDistributionRegistryImagePayload = {
  __typename: "UpdateDistributionRegistryImagePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `DistributionRegistryImage` that was updated by this mutation. */
  distributionRegistryImage: Maybe<DistributionRegistryImage>;
  /** An edge for our `DistributionRegistryImage`. May be used by Relay 1. */
  distributionRegistryImageEdge: Maybe<DistributionRegistryImagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TesContainerimageexecutor` that is related to this `DistributionRegistryImage`. */
  tesContainerimageexecutorByContainerimageexecutorPtrId: Maybe<TesContainerimageexecutor>;
};

/** The output of our update `DistributionRegistryImage` mutation. */
export type UpdateDistributionRegistryImagePayloadDistributionRegistryImageEdgeArgs =
  {
    orderBy?: InputMaybe<Array<DistributionRegistryImagesOrderBy>>;
  };

/** All input for the `updateDjangoAdminLogById` mutation. */
export type UpdateDjangoAdminLogByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `DjangoAdminLog` being updated. */
  djangoAdminLogPatch: DjangoAdminLogPatch;
  id: Scalars["Int"]["input"];
};

/** The output of our update `DjangoAdminLog` mutation. */
export type UpdateDjangoAdminLogPayload = {
  __typename: "UpdateDjangoAdminLogPayload";
  /** Reads a single `ApplicationUser` that is related to this `DjangoAdminLog`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `DjangoAdminLog` that was updated by this mutation. */
  djangoAdminLog: Maybe<DjangoAdminLog>;
  /** An edge for our `DjangoAdminLog`. May be used by Relay 1. */
  djangoAdminLogEdge: Maybe<DjangoAdminLogsEdge>;
  /** Reads a single `DjangoContentType` that is related to this `DjangoAdminLog`. */
  djangoContentTypeByContentTypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `DjangoAdminLog` mutation. */
export type UpdateDjangoAdminLogPayloadDjangoAdminLogEdgeArgs = {
  orderBy?: InputMaybe<Array<DjangoAdminLogsOrderBy>>;
};

/** All input for the `updateDjangoContentTypeByAppLabelAndModel` mutation. */
export type UpdateDjangoContentTypeByAppLabelAndModelInput = {
  appLabel: Scalars["String"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `DjangoContentType` being updated. */
  djangoContentTypePatch: DjangoContentTypePatch;
  model: Scalars["String"]["input"];
};

/** All input for the `updateDjangoContentTypeById` mutation. */
export type UpdateDjangoContentTypeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `DjangoContentType` being updated. */
  djangoContentTypePatch: DjangoContentTypePatch;
  id: Scalars["Int"]["input"];
};

/** The output of our update `DjangoContentType` mutation. */
export type UpdateDjangoContentTypePayload = {
  __typename: "UpdateDjangoContentTypePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `DjangoContentType` that was updated by this mutation. */
  djangoContentType: Maybe<DjangoContentType>;
  /** An edge for our `DjangoContentType`. May be used by Relay 1. */
  djangoContentTypeEdge: Maybe<DjangoContentTypesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `DjangoContentType` mutation. */
export type UpdateDjangoContentTypePayloadDjangoContentTypeEdgeArgs = {
  orderBy?: InputMaybe<Array<DjangoContentTypesOrderBy>>;
};

/** All input for the `updateDjangoMigrationById` mutation. */
export type UpdateDjangoMigrationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `DjangoMigration` being updated. */
  djangoMigrationPatch: DjangoMigrationPatch;
  id: Scalars["BigInt"]["input"];
};

/** The output of our update `DjangoMigration` mutation. */
export type UpdateDjangoMigrationPayload = {
  __typename: "UpdateDjangoMigrationPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `DjangoMigration` that was updated by this mutation. */
  djangoMigration: Maybe<DjangoMigration>;
  /** An edge for our `DjangoMigration`. May be used by Relay 1. */
  djangoMigrationEdge: Maybe<DjangoMigrationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `DjangoMigration` mutation. */
export type UpdateDjangoMigrationPayloadDjangoMigrationEdgeArgs = {
  orderBy?: InputMaybe<Array<DjangoMigrationsOrderBy>>;
};

/** All input for the `updateDjangoSesBlacklistedemailByEmail` mutation. */
export type UpdateDjangoSesBlacklistedemailByEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `DjangoSesBlacklistedemail` being updated. */
  djangoSesBlacklistedemailPatch: DjangoSesBlacklistedemailPatch;
  email: Scalars["String"]["input"];
};

/** All input for the `updateDjangoSesBlacklistedemailById` mutation. */
export type UpdateDjangoSesBlacklistedemailByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `DjangoSesBlacklistedemail` being updated. */
  djangoSesBlacklistedemailPatch: DjangoSesBlacklistedemailPatch;
  id: Scalars["Int"]["input"];
};

/** The output of our update `DjangoSesBlacklistedemail` mutation. */
export type UpdateDjangoSesBlacklistedemailPayload = {
  __typename: "UpdateDjangoSesBlacklistedemailPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `DjangoSesBlacklistedemail` that was updated by this mutation. */
  djangoSesBlacklistedemail: Maybe<DjangoSesBlacklistedemail>;
  /** An edge for our `DjangoSesBlacklistedemail`. May be used by Relay 1. */
  djangoSesBlacklistedemailEdge: Maybe<DjangoSesBlacklistedemailsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `DjangoSesBlacklistedemail` mutation. */
export type UpdateDjangoSesBlacklistedemailPayloadDjangoSesBlacklistedemailEdgeArgs =
  {
    orderBy?: InputMaybe<Array<DjangoSesBlacklistedemailsOrderBy>>;
  };

/** All input for the `updateDjangoSesSesstatByDate` mutation. */
export type UpdateDjangoSesSesstatByDateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  date: Scalars["Date"]["input"];
  /** An object where the defined keys will be set on the `DjangoSesSesstat` being updated. */
  djangoSesSesstatPatch: DjangoSesSesstatPatch;
};

/** All input for the `updateDjangoSesSesstatById` mutation. */
export type UpdateDjangoSesSesstatByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `DjangoSesSesstat` being updated. */
  djangoSesSesstatPatch: DjangoSesSesstatPatch;
  id: Scalars["Int"]["input"];
};

/** The output of our update `DjangoSesSesstat` mutation. */
export type UpdateDjangoSesSesstatPayload = {
  __typename: "UpdateDjangoSesSesstatPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `DjangoSesSesstat` that was updated by this mutation. */
  djangoSesSesstat: Maybe<DjangoSesSesstat>;
  /** An edge for our `DjangoSesSesstat`. May be used by Relay 1. */
  djangoSesSesstatEdge: Maybe<DjangoSesSesstatsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `DjangoSesSesstat` mutation. */
export type UpdateDjangoSesSesstatPayloadDjangoSesSesstatEdgeArgs = {
  orderBy?: InputMaybe<Array<DjangoSesSesstatsOrderBy>>;
};

/** All input for the `updateDjangoSessionBySessionKey` mutation. */
export type UpdateDjangoSessionBySessionKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `DjangoSession` being updated. */
  djangoSessionPatch: DjangoSessionPatch;
  sessionKey: Scalars["String"]["input"];
};

/** The output of our update `DjangoSession` mutation. */
export type UpdateDjangoSessionPayload = {
  __typename: "UpdateDjangoSessionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `DjangoSession` that was updated by this mutation. */
  djangoSession: Maybe<DjangoSession>;
  /** An edge for our `DjangoSession`. May be used by Relay 1. */
  djangoSessionEdge: Maybe<DjangoSessionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `DjangoSession` mutation. */
export type UpdateDjangoSessionPayloadDjangoSessionEdgeArgs = {
  orderBy?: InputMaybe<Array<DjangoSessionsOrderBy>>;
};

/** All input for the `updateDrsFileexecutorById` mutation. */
export type UpdateDrsFileexecutorByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `DrsFileexecutor` being updated. */
  drsFileexecutorPatch: DrsFileexecutorPatch;
  id: Scalars["UUID"]["input"];
};

/** The output of our update `DrsFileexecutor` mutation. */
export type UpdateDrsFileexecutorPayload = {
  __typename: "UpdateDrsFileexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `DrsFileexecutor`. */
  djangoContentTypeByPolymorphicCtypeId: Maybe<DjangoContentType>;
  /** The `DrsFileexecutor` that was updated by this mutation. */
  drsFileexecutor: Maybe<DrsFileexecutor>;
  /** An edge for our `DrsFileexecutor`. May be used by Relay 1. */
  drsFileexecutorEdge: Maybe<DrsFileexecutorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `DrsFileexecutor` mutation. */
export type UpdateDrsFileexecutorPayloadDrsFileexecutorEdgeArgs = {
  orderBy?: InputMaybe<Array<DrsFileexecutorsOrderBy>>;
};

/** All input for the `updateDrsMockfileexecutorByFileexecutorPtrId` mutation. */
export type UpdateDrsMockfileexecutorByFileexecutorPtrIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `DrsMockfileexecutor` being updated. */
  drsMockfileexecutorPatch: DrsMockfileexecutorPatch;
  fileexecutorPtrId: Scalars["UUID"]["input"];
};

/** The output of our update `DrsMockfileexecutor` mutation. */
export type UpdateDrsMockfileexecutorPayload = {
  __typename: "UpdateDrsMockfileexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DrsFileexecutor` that is related to this `DrsMockfileexecutor`. */
  drsFileexecutorByFileexecutorPtrId: Maybe<DrsFileexecutor>;
  /** The `DrsMockfileexecutor` that was updated by this mutation. */
  drsMockfileexecutor: Maybe<DrsMockfileexecutor>;
  /** An edge for our `DrsMockfileexecutor`. May be used by Relay 1. */
  drsMockfileexecutorEdge: Maybe<DrsMockfileexecutorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `DrsMockfileexecutor` mutation. */
export type UpdateDrsMockfileexecutorPayloadDrsMockfileexecutorEdgeArgs = {
  orderBy?: InputMaybe<Array<DrsMockfileexecutorsOrderBy>>;
};

/** All input for the `updateEulaVersionById` mutation. */
export type UpdateEulaVersionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `EulaVersion` being updated. */
  eulaVersionPatch: EulaVersionPatch;
  id: Scalars["Int"]["input"];
};

/** All input for the `updateEulaVersionByVersion` mutation. */
export type UpdateEulaVersionByVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `EulaVersion` being updated. */
  eulaVersionPatch: EulaVersionPatch;
  version: Scalars["String"]["input"];
};

/** The output of our update `EulaVersion` mutation. */
export type UpdateEulaVersionPayload = {
  __typename: "UpdateEulaVersionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `EulaVersion` that was updated by this mutation. */
  eulaVersion: Maybe<EulaVersion>;
  /** An edge for our `EulaVersion`. May be used by Relay 1. */
  eulaVersionEdge: Maybe<EulaVersionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `EulaVersion` mutation. */
export type UpdateEulaVersionPayloadEulaVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<EulaVersionsOrderBy>>;
};

/** All input for the `updateEulaVersionUserAcceptanceById` mutation. */
export type UpdateEulaVersionUserAcceptanceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `EulaVersionUserAcceptance` being updated. */
  eulaVersionUserAcceptancePatch: EulaVersionUserAcceptancePatch;
  id: Scalars["UUID"]["input"];
};

/** All input for the `updateEulaVersionUserAcceptanceByUserIdAndEulaVersionId` mutation. */
export type UpdateEulaVersionUserAcceptanceByUserIdAndEulaVersionIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  eulaVersionId: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `EulaVersionUserAcceptance` being updated. */
  eulaVersionUserAcceptancePatch: EulaVersionUserAcceptancePatch;
  userId: Scalars["UUID"]["input"];
};

/** The output of our update `EulaVersionUserAcceptance` mutation. */
export type UpdateEulaVersionUserAcceptancePayload = {
  __typename: "UpdateEulaVersionUserAcceptancePayload";
  /** Reads a single `ApplicationUser` that is related to this `EulaVersionUserAcceptance`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `EulaVersion` that is related to this `EulaVersionUserAcceptance`. */
  eulaVersionByEulaVersionId: Maybe<EulaVersion>;
  /** The `EulaVersionUserAcceptance` that was updated by this mutation. */
  eulaVersionUserAcceptance: Maybe<EulaVersionUserAcceptance>;
  /** An edge for our `EulaVersionUserAcceptance`. May be used by Relay 1. */
  eulaVersionUserAcceptanceEdge: Maybe<EulaVersionUserAcceptancesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `EulaVersionUserAcceptance` mutation. */
export type UpdateEulaVersionUserAcceptancePayloadEulaVersionUserAcceptanceEdgeArgs =
  {
    orderBy?: InputMaybe<Array<EulaVersionUserAcceptancesOrderBy>>;
  };

/** All input for the `updateFeatureFlagById` mutation. */
export type UpdateFeatureFlagByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `FeatureFlag` being updated. */
  featureFlagPatch: FeatureFlagPatch;
  id: Scalars["BigInt"]["input"];
};

/** All input for the `updateFeatureFlagByName` mutation. */
export type UpdateFeatureFlagByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `FeatureFlag` being updated. */
  featureFlagPatch: FeatureFlagPatch;
  name: Scalars["String"]["input"];
};

/** The output of our update `FeatureFlag` mutation. */
export type UpdateFeatureFlagPayload = {
  __typename: "UpdateFeatureFlagPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `FeatureFlag` that was updated by this mutation. */
  featureFlag: Maybe<FeatureFlag>;
  /** An edge for our `FeatureFlag`. May be used by Relay 1. */
  featureFlagEdge: Maybe<FeatureFlagsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `FeatureFlag` mutation. */
export type UpdateFeatureFlagPayloadFeatureFlagEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureFlagsOrderBy>>;
};

/** All input for the `updateFeatureFlagsGroupByFeatureflagIdAndGroupId` mutation. */
export type UpdateFeatureFlagsGroupByFeatureflagIdAndGroupIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `FeatureFlagsGroup` being updated. */
  featureFlagsGroupPatch: FeatureFlagsGroupPatch;
  featureflagId: Scalars["BigInt"]["input"];
  groupId: Scalars["Int"]["input"];
};

/** All input for the `updateFeatureFlagsGroupById` mutation. */
export type UpdateFeatureFlagsGroupByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `FeatureFlagsGroup` being updated. */
  featureFlagsGroupPatch: FeatureFlagsGroupPatch;
  id: Scalars["BigInt"]["input"];
};

/** The output of our update `FeatureFlagsGroup` mutation. */
export type UpdateFeatureFlagsGroupPayload = {
  __typename: "UpdateFeatureFlagsGroupPayload";
  /** Reads a single `AuthGroup` that is related to this `FeatureFlagsGroup`. */
  authGroupByGroupId: Maybe<AuthGroup>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `FeatureFlag` that is related to this `FeatureFlagsGroup`. */
  featureFlagByFeatureflagId: Maybe<FeatureFlag>;
  /** The `FeatureFlagsGroup` that was updated by this mutation. */
  featureFlagsGroup: Maybe<FeatureFlagsGroup>;
  /** An edge for our `FeatureFlagsGroup`. May be used by Relay 1. */
  featureFlagsGroupEdge: Maybe<FeatureFlagsGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `FeatureFlagsGroup` mutation. */
export type UpdateFeatureFlagsGroupPayloadFeatureFlagsGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureFlagsGroupsOrderBy>>;
};

/** All input for the `updateFeatureFlagsTenantByFeatureflagIdAndTenantId` mutation. */
export type UpdateFeatureFlagsTenantByFeatureflagIdAndTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `FeatureFlagsTenant` being updated. */
  featureFlagsTenantPatch: FeatureFlagsTenantPatch;
  featureflagId: Scalars["BigInt"]["input"];
  tenantId: Scalars["Int"]["input"];
};

/** All input for the `updateFeatureFlagsTenantById` mutation. */
export type UpdateFeatureFlagsTenantByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `FeatureFlagsTenant` being updated. */
  featureFlagsTenantPatch: FeatureFlagsTenantPatch;
  id: Scalars["BigInt"]["input"];
};

/** The output of our update `FeatureFlagsTenant` mutation. */
export type UpdateFeatureFlagsTenantPayload = {
  __typename: "UpdateFeatureFlagsTenantPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `FeatureFlag` that is related to this `FeatureFlagsTenant`. */
  featureFlagByFeatureflagId: Maybe<FeatureFlag>;
  /** The `FeatureFlagsTenant` that was updated by this mutation. */
  featureFlagsTenant: Maybe<FeatureFlagsTenant>;
  /** An edge for our `FeatureFlagsTenant`. May be used by Relay 1. */
  featureFlagsTenantEdge: Maybe<FeatureFlagsTenantsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `FeatureFlagsTenant`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our update `FeatureFlagsTenant` mutation. */
export type UpdateFeatureFlagsTenantPayloadFeatureFlagsTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureFlagsTenantsOrderBy>>;
};

/** All input for the `updateFeatureFlagsUserByFeatureflagIdAndUserId` mutation. */
export type UpdateFeatureFlagsUserByFeatureflagIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `FeatureFlagsUser` being updated. */
  featureFlagsUserPatch: FeatureFlagsUserPatch;
  featureflagId: Scalars["BigInt"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** All input for the `updateFeatureFlagsUserById` mutation. */
export type UpdateFeatureFlagsUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `FeatureFlagsUser` being updated. */
  featureFlagsUserPatch: FeatureFlagsUserPatch;
  id: Scalars["BigInt"]["input"];
};

/** The output of our update `FeatureFlagsUser` mutation. */
export type UpdateFeatureFlagsUserPayload = {
  __typename: "UpdateFeatureFlagsUserPayload";
  /** Reads a single `ApplicationUser` that is related to this `FeatureFlagsUser`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `FeatureFlag` that is related to this `FeatureFlagsUser`. */
  featureFlagByFeatureflagId: Maybe<FeatureFlag>;
  /** The `FeatureFlagsUser` that was updated by this mutation. */
  featureFlagsUser: Maybe<FeatureFlagsUser>;
  /** An edge for our `FeatureFlagsUser`. May be used by Relay 1. */
  featureFlagsUserEdge: Maybe<FeatureFlagsUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `FeatureFlagsUser` mutation. */
export type UpdateFeatureFlagsUserPayloadFeatureFlagsUserEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureFlagsUsersOrderBy>>;
};

/** All input for the `updateFileActivityById` mutation. */
export type UpdateFileActivityByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `FileActivity` being updated. */
  fileActivityPatch: FileActivityPatch;
  id: Scalars["Int"]["input"];
};

/** The output of our update `FileActivity` mutation. */
export type UpdateFileActivityPayload = {
  __typename: "UpdateFileActivityPayload";
  /** Reads a single `ApplicationUser` that is related to this `FileActivity`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Cost` that is related to this `FileActivity`. */
  costByCostId: Maybe<Cost>;
  /** Reads a single `DjangoContentType` that is related to this `FileActivity`. */
  djangoContentTypeByContentTypeId: Maybe<DjangoContentType>;
  /** The `FileActivity` that was updated by this mutation. */
  fileActivity: Maybe<FileActivity>;
  /** An edge for our `FileActivity`. May be used by Relay 1. */
  fileActivityEdge: Maybe<FileActivitiesEdge>;
  /** Reads a single `File` that is related to this `FileActivity`. */
  fileByFileId: Maybe<File>;
  /** Reads a single `Project` that is related to this `FileActivity`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `FileActivity`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our update `FileActivity` mutation. */
export type UpdateFileActivityPayloadFileActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<FileActivitiesOrderBy>>;
};

/** All input for the `updateFileById` mutation. */
export type UpdateFileByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `File` being updated. */
  filePatch: FilePatch;
  id: Scalars["UUID"]["input"];
};

/** All input for the `updateFileByProjectIdAndReferenceId` mutation. */
export type UpdateFileByProjectIdAndReferenceIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `File` being updated. */
  filePatch: FilePatch;
  projectId: Scalars["UUID"]["input"];
  referenceId: Scalars["UUID"]["input"];
};

/** All input for the `updateFileMetadatumById` mutation. */
export type UpdateFileMetadatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `FileMetadatum` being updated. */
  fileMetadatumPatch: FileMetadatumPatch;
  id: Scalars["UUID"]["input"];
};

/** The output of our update `FileMetadatum` mutation. */
export type UpdateFileMetadatumPayload = {
  __typename: "UpdateFileMetadatumPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `File` that is related to this `FileMetadatum`. */
  fileByFileId: Maybe<File>;
  /** The `FileMetadatum` that was updated by this mutation. */
  fileMetadatum: Maybe<FileMetadatum>;
  /** An edge for our `FileMetadatum`. May be used by Relay 1. */
  fileMetadatumEdge: Maybe<FileMetadataEdge>;
  /** Reads a single `Metadatum` that is related to this `FileMetadatum`. */
  metadatumByMetadataId: Maybe<Metadatum>;
  /** Reads a single `Project` that is related to this `FileMetadatum`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `FileMetadatum`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our update `FileMetadatum` mutation. */
export type UpdateFileMetadatumPayloadFileMetadatumEdgeArgs = {
  orderBy?: InputMaybe<Array<FileMetadataOrderBy>>;
};

/** All input for the `updateFileOutputGroupById` mutation. */
export type UpdateFileOutputGroupByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `FileOutputGroup` being updated. */
  fileOutputGroupPatch: FileOutputGroupPatch;
  id: Scalars["UUID"]["input"];
};

/** All input for the `updateFileOutputGroupByTaskId` mutation. */
export type UpdateFileOutputGroupByTaskIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `FileOutputGroup` being updated. */
  fileOutputGroupPatch: FileOutputGroupPatch;
  taskId: Scalars["UUID"]["input"];
};

/** All input for the `updateFileOutputGroupMetadatumById` mutation. */
export type UpdateFileOutputGroupMetadatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `FileOutputGroupMetadatum` being updated. */
  fileOutputGroupMetadatumPatch: FileOutputGroupMetadatumPatch;
  id: Scalars["UUID"]["input"];
};

/** The output of our update `FileOutputGroupMetadatum` mutation. */
export type UpdateFileOutputGroupMetadatumPayload = {
  __typename: "UpdateFileOutputGroupMetadatumPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `FileOutputGroup` that is related to this `FileOutputGroupMetadatum`. */
  fileOutputGroupByFileOutputGroupId: Maybe<FileOutputGroup>;
  /** The `FileOutputGroupMetadatum` that was updated by this mutation. */
  fileOutputGroupMetadatum: Maybe<FileOutputGroupMetadatum>;
  /** An edge for our `FileOutputGroupMetadatum`. May be used by Relay 1. */
  fileOutputGroupMetadatumEdge: Maybe<FileOutputGroupMetadataEdge>;
  /** Reads a single `Metadatum` that is related to this `FileOutputGroupMetadatum`. */
  metadatumByMetadataId: Maybe<Metadatum>;
  /** Reads a single `Project` that is related to this `FileOutputGroupMetadatum`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `FileOutputGroupMetadatum`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our update `FileOutputGroupMetadatum` mutation. */
export type UpdateFileOutputGroupMetadatumPayloadFileOutputGroupMetadatumEdgeArgs =
  {
    orderBy?: InputMaybe<Array<FileOutputGroupMetadataOrderBy>>;
  };

/** The output of our update `FileOutputGroup` mutation. */
export type UpdateFileOutputGroupPayload = {
  __typename: "UpdateFileOutputGroupPayload";
  /** Reads a single `ApplicationUser` that is related to this `FileOutputGroup`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `FileOutputGroup` that was updated by this mutation. */
  fileOutputGroup: Maybe<FileOutputGroup>;
  /** An edge for our `FileOutputGroup`. May be used by Relay 1. */
  fileOutputGroupEdge: Maybe<FileOutputGroupsEdge>;
  /** Reads a single `Project` that is related to this `FileOutputGroup`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `FileOutputGroup`. */
  taskByTaskId: Maybe<Task>;
  /** Reads a single `Tenant` that is related to this `FileOutputGroup`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our update `FileOutputGroup` mutation. */
export type UpdateFileOutputGroupPayloadFileOutputGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<FileOutputGroupsOrderBy>>;
};

/** The output of our update `File` mutation. */
export type UpdateFilePayload = {
  __typename: "UpdateFilePayload";
  /** Reads a single `ApplicationUser` that is related to this `File`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `File` that was updated by this mutation. */
  file: Maybe<File>;
  /** Reads a single `File` that is related to this `File`. */
  fileBySeriesParentId: Maybe<File>;
  /** An edge for our `File`. May be used by Relay 1. */
  fileEdge: Maybe<FilesEdge>;
  /** Reads a single `Project` that is related to this `File`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `File`. */
  taskByTaskId: Maybe<Task>;
  /** Reads a single `Tenant` that is related to this `File`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our update `File` mutation. */
export type UpdateFilePayloadFileEdgeArgs = {
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};

/** All input for the `updateMetadataValueById` mutation. */
export type UpdateMetadataValueByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `MetadataValue` being updated. */
  metadataValuePatch: MetadataValuePatch;
};

/** The output of our update `MetadataValue` mutation. */
export type UpdateMetadataValuePayload = {
  __typename: "UpdateMetadataValuePayload";
  /** Reads a single `ApplicationUser` that is related to this `MetadataValue`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `MetadataValue` that was updated by this mutation. */
  metadataValue: Maybe<MetadataValue>;
  /** An edge for our `MetadataValue`. May be used by Relay 1. */
  metadataValueEdge: Maybe<MetadataValuesEdge>;
  /** Reads a single `Metadatum` that is related to this `MetadataValue`. */
  metadatumByMetadataId: Maybe<Metadatum>;
  /** Reads a single `Project` that is related to this `MetadataValue`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `MetadataValue`. */
  taskByTaskId: Maybe<Task>;
  /** Reads a single `Tenant` that is related to this `MetadataValue`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our update `MetadataValue` mutation. */
export type UpdateMetadataValuePayloadMetadataValueEdgeArgs = {
  orderBy?: InputMaybe<Array<MetadataValuesOrderBy>>;
};

/** All input for the `updateMetadatumById` mutation. */
export type UpdateMetadatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `Metadatum` being updated. */
  metadatumPatch: MetadatumPatch;
};

/** The output of our update `Metadatum` mutation. */
export type UpdateMetadatumPayload = {
  __typename: "UpdateMetadatumPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `Metadatum` that was updated by this mutation. */
  metadatum: Maybe<Metadatum>;
  /** An edge for our `Metadatum`. May be used by Relay 1. */
  metadatumEdge: Maybe<MetadataEdge>;
  /** Reads a single `Project` that is related to this `Metadatum`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Metadatum`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our update `Metadatum` mutation. */
export type UpdateMetadatumPayloadMetadatumEdgeArgs = {
  orderBy?: InputMaybe<Array<MetadataOrderBy>>;
};

/** All input for the `updateNotificationById` mutation. */
export type UpdateNotificationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `Notification` being updated. */
  notificationPatch: NotificationPatch;
};

/** The output of our update `Notification` mutation. */
export type UpdateNotificationPayload = {
  __typename: "UpdateNotificationPayload";
  /** Reads a single `ApplicationUser` that is related to this `Notification`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `Notification` that was updated by this mutation. */
  notification: Maybe<Notification>;
  /** An edge for our `Notification`. May be used by Relay 1. */
  notificationEdge: Maybe<NotificationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `Notification` mutation. */
export type UpdateNotificationPayloadNotificationEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** All input for the `updateOutputGroupFileById` mutation. */
export type UpdateOutputGroupFileByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `OutputGroupFile` being updated. */
  outputGroupFilePatch: OutputGroupFilePatch;
};

/** The output of our update `OutputGroupFile` mutation. */
export type UpdateOutputGroupFilePayload = {
  __typename: "UpdateOutputGroupFilePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `File` that is related to this `OutputGroupFile`. */
  fileByFileId: Maybe<File>;
  /** Reads a single `FileOutputGroup` that is related to this `OutputGroupFile`. */
  fileOutputGroupByFileOutputGroupId: Maybe<FileOutputGroup>;
  /** The `OutputGroupFile` that was updated by this mutation. */
  outputGroupFile: Maybe<OutputGroupFile>;
  /** An edge for our `OutputGroupFile`. May be used by Relay 1. */
  outputGroupFileEdge: Maybe<OutputGroupFilesEdge>;
  /** Reads a single `Project` that is related to this `OutputGroupFile`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `OutputGroupFile` mutation. */
export type UpdateOutputGroupFilePayloadOutputGroupFileEdgeArgs = {
  orderBy?: InputMaybe<Array<OutputGroupFilesOrderBy>>;
};

/** All input for the `updatePinnedToolById` mutation. */
export type UpdatePinnedToolByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
  /** An object where the defined keys will be set on the `PinnedTool` being updated. */
  pinnedToolPatch: PinnedToolPatch;
};

/** All input for the `updatePinnedToolByUserIdAndToolId` mutation. */
export type UpdatePinnedToolByUserIdAndToolIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `PinnedTool` being updated. */
  pinnedToolPatch: PinnedToolPatch;
  toolId: Scalars["Int"]["input"];
  userId: Scalars["UUID"]["input"];
};

/** The output of our update `PinnedTool` mutation. */
export type UpdatePinnedToolPayload = {
  __typename: "UpdatePinnedToolPayload";
  /** Reads a single `ApplicationUser` that is related to this `PinnedTool`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** The `PinnedTool` that was updated by this mutation. */
  pinnedTool: Maybe<PinnedTool>;
  /** An edge for our `PinnedTool`. May be used by Relay 1. */
  pinnedToolEdge: Maybe<PinnedToolsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tool` that is related to this `PinnedTool`. */
  toolByToolId: Maybe<Tool>;
};

/** The output of our update `PinnedTool` mutation. */
export type UpdatePinnedToolPayloadPinnedToolEdgeArgs = {
  orderBy?: InputMaybe<Array<PinnedToolsOrderBy>>;
};

/** All input for the `updateProjectFolderById` mutation. */
export type UpdateProjectFolderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `ProjectFolder` being updated. */
  projectFolderPatch: ProjectFolderPatch;
};

/** The output of our update `ProjectFolder` mutation. */
export type UpdateProjectFolderPayload = {
  __typename: "UpdateProjectFolderPayload";
  /** Reads a single `ApplicationUser` that is related to this `ProjectFolder`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Project` that is related to this `ProjectFolder`. */
  projectByProjectId: Maybe<Project>;
  /** The `ProjectFolder` that was updated by this mutation. */
  projectFolder: Maybe<ProjectFolder>;
  /** An edge for our `ProjectFolder`. May be used by Relay 1. */
  projectFolderEdge: Maybe<ProjectFoldersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `ProjectFolder` mutation. */
export type UpdateProjectFolderPayloadProjectFolderEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectFoldersOrderBy>>;
};

/** All input for the `updateProjectTagById` mutation. */
export type UpdateProjectTagByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `ProjectTag` being updated. */
  projectTagPatch: ProjectTagPatch;
};

/** The output of our update `ProjectTag` mutation. */
export type UpdateProjectTagPayload = {
  __typename: "UpdateProjectTagPayload";
  /** Reads a single `ApplicationUser` that is related to this `ProjectTag`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Project` that is related to this `ProjectTag`. */
  projectByProjectId: Maybe<Project>;
  /** The `ProjectTag` that was updated by this mutation. */
  projectTag: Maybe<ProjectTag>;
  /** An edge for our `ProjectTag`. May be used by Relay 1. */
  projectTagEdge: Maybe<ProjectTagsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our update `ProjectTag` mutation. */
export type UpdateProjectTagPayloadProjectTagEdgeArgs = {
  orderBy?: InputMaybe<Array<ProjectTagsOrderBy>>;
};

/** All input for the `updateRunById` mutation. */
export type UpdateRunByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `Run` being updated. */
  runPatch: RunPatch;
};

/** The output of our update `Run` mutation. */
export type UpdateRunPayload = {
  __typename: "UpdateRunPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Run` that was updated by this mutation. */
  run: Maybe<Run>;
  /** An edge for our `Run`. May be used by Relay 1. */
  runEdge: Maybe<RunsEdge>;
  /** Reads a single `Tenant` that is related to this `Run`. */
  tenantByTenantId: Maybe<Tenant>;
};

/** The output of our update `Run` mutation. */
export type UpdateRunPayloadRunEdgeArgs = {
  orderBy?: InputMaybe<Array<RunsOrderBy>>;
};

/** All input for the `updateTaskActivityById` mutation. */
export type UpdateTaskActivityByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `TaskActivity` being updated. */
  taskActivityPatch: TaskActivityPatch;
};

/** All input for the `updateTaskActivityByTaskId` mutation. */
export type UpdateTaskActivityByTaskIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `TaskActivity` being updated. */
  taskActivityPatch: TaskActivityPatch;
  taskId: Scalars["UUID"]["input"];
};

/** The output of our update `TaskActivity` mutation. */
export type UpdateTaskActivityPayload = {
  __typename: "UpdateTaskActivityPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Cost` that is related to this `TaskActivity`. */
  costByCostId: Maybe<Cost>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TaskActivity` that was updated by this mutation. */
  taskActivity: Maybe<TaskActivity>;
  /** An edge for our `TaskActivity`. May be used by Relay 1. */
  taskActivityEdge: Maybe<TaskActivitiesEdge>;
  /** Reads a single `Task` that is related to this `TaskActivity`. */
  taskByTaskId: Maybe<Task>;
};

/** The output of our update `TaskActivity` mutation. */
export type UpdateTaskActivityPayloadTaskActivityEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskActivitiesOrderBy>>;
};

/** All input for the `updateTaskByExecutorId` mutation. */
export type UpdateTaskByExecutorIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  executorId: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `Task` being updated. */
  taskPatch: TaskPatch;
};

/** All input for the `updateTaskById` mutation. */
export type UpdateTaskByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `Task` being updated. */
  taskPatch: TaskPatch;
};

/** The output of our update `Task` mutation. */
export type UpdateTaskPayload = {
  __typename: "UpdateTaskPayload";
  /** Reads a single `ApplicationUser` that is related to this `Task`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `ContainerImage` that is related to this `Task`. */
  containerImageByContainerImageId: Maybe<ContainerImage>;
  /** Reads a single `Project` that is related to this `Task`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Task` that was updated by this mutation. */
  task: Maybe<Task>;
  /** An edge for our `Task`. May be used by Relay 1. */
  taskEdge: Maybe<TasksEdge>;
  /** Reads a single `Tenant` that is related to this `Task`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `TesTaskexecutor` that is related to this `Task`. */
  tesTaskexecutorByExecutorId: Maybe<TesTaskexecutor>;
  /** Reads a single `ToolVersion` that is related to this `Task`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our update `Task` mutation. */
export type UpdateTaskPayloadTaskEdgeArgs = {
  orderBy?: InputMaybe<Array<TasksOrderBy>>;
};

/** All input for the `updateTaskResourceById` mutation. */
export type UpdateTaskResourceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `TaskResource` being updated. */
  taskResourcePatch: TaskResourcePatch;
};

/** The output of our update `TaskResource` mutation. */
export type UpdateTaskResourcePayload = {
  __typename: "UpdateTaskResourcePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `TaskResource`. */
  taskByTaskId: Maybe<Task>;
  /** The `TaskResource` that was updated by this mutation. */
  taskResource: Maybe<TaskResource>;
  /** An edge for our `TaskResource`. May be used by Relay 1. */
  taskResourceEdge: Maybe<TaskResourcesEdge>;
};

/** The output of our update `TaskResource` mutation. */
export type UpdateTaskResourcePayloadTaskResourceEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskResourcesOrderBy>>;
};

/** All input for the `updateTaskResourceUsageById` mutation. */
export type UpdateTaskResourceUsageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `TaskResourceUsage` being updated. */
  taskResourceUsagePatch: TaskResourceUsagePatch;
};

/** All input for the `updateTaskResourceUsageByTaskId` mutation. */
export type UpdateTaskResourceUsageByTaskIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  taskId: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `TaskResourceUsage` being updated. */
  taskResourceUsagePatch: TaskResourceUsagePatch;
};

/** The output of our update `TaskResourceUsage` mutation. */
export type UpdateTaskResourceUsagePayload = {
  __typename: "UpdateTaskResourceUsagePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `TaskResourceUsage`. */
  taskByTaskId: Maybe<Task>;
  /** The `TaskResourceUsage` that was updated by this mutation. */
  taskResourceUsage: Maybe<TaskResourceUsage>;
  /** An edge for our `TaskResourceUsage`. May be used by Relay 1. */
  taskResourceUsageEdge: Maybe<TaskResourceUsagesEdge>;
};

/** The output of our update `TaskResourceUsage` mutation. */
export type UpdateTaskResourceUsagePayloadTaskResourceUsageEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskResourceUsagesOrderBy>>;
};

/** All input for the `updateTaskSourceById` mutation. */
export type UpdateTaskSourceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `TaskSource` being updated. */
  taskSourcePatch: TaskSourcePatch;
};

/** The output of our update `TaskSource` mutation. */
export type UpdateTaskSourcePayload = {
  __typename: "UpdateTaskSourcePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `File` that is related to this `TaskSource`. */
  fileByFileId: Maybe<File>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `TaskSource`. */
  taskByTaskId: Maybe<Task>;
  /** The `TaskSource` that was updated by this mutation. */
  taskSource: Maybe<TaskSource>;
  /** An edge for our `TaskSource`. May be used by Relay 1. */
  taskSourceEdge: Maybe<TaskSourcesEdge>;
  /** Reads a single `ToolSource` that is related to this `TaskSource`. */
  toolSourceByToolSourceId: Maybe<ToolSource>;
};

/** The output of our update `TaskSource` mutation. */
export type UpdateTaskSourcePayloadTaskSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskSourcesOrderBy>>;
};

/** All input for the `updateTaskStatusLogById` mutation. */
export type UpdateTaskStatusLogByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `TaskStatusLog` being updated. */
  taskStatusLogPatch: TaskStatusLogPatch;
};

/** All input for the `updateTaskStatusLogByTaskIdAndStatus` mutation. */
export type UpdateTaskStatusLogByTaskIdAndStatusInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  taskId: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `TaskStatusLog` being updated. */
  taskStatusLogPatch: TaskStatusLogPatch;
};

/** The output of our update `TaskStatusLog` mutation. */
export type UpdateTaskStatusLogPayload = {
  __typename: "UpdateTaskStatusLogPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Task` that is related to this `TaskStatusLog`. */
  taskByTaskId: Maybe<Task>;
  /** The `TaskStatusLog` that was updated by this mutation. */
  taskStatusLog: Maybe<TaskStatusLog>;
  /** An edge for our `TaskStatusLog`. May be used by Relay 1. */
  taskStatusLogEdge: Maybe<TaskStatusLogsEdge>;
};

/** The output of our update `TaskStatusLog` mutation. */
export type UpdateTaskStatusLogPayloadTaskStatusLogEdgeArgs = {
  orderBy?: InputMaybe<Array<TaskStatusLogsOrderBy>>;
};

/** All input for the `updateTenantById` mutation. */
export type UpdateTenantByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `Tenant` being updated. */
  tenantPatch: TenantPatch;
};

/** All input for the `updateTenantByKey` mutation. */
export type UpdateTenantByKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  key: Scalars["String"]["input"];
  /** An object where the defined keys will be set on the `Tenant` being updated. */
  tenantPatch: TenantPatch;
};

/** All input for the `updateTenantByRepositoryName` mutation. */
export type UpdateTenantByRepositoryNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  repositoryName: Scalars["String"]["input"];
  /** An object where the defined keys will be set on the `Tenant` being updated. */
  tenantPatch: TenantPatch;
};

/** All input for the `updateTenantBySfid` mutation. */
export type UpdateTenantBySfidInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  sfid: Scalars["String"]["input"];
  /** An object where the defined keys will be set on the `Tenant` being updated. */
  tenantPatch: TenantPatch;
};

/** All input for the `updateTenantContractAllowanceById` mutation. */
export type UpdateTenantContractAllowanceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `TenantContractAllowance` being updated. */
  tenantContractAllowancePatch: TenantContractAllowancePatch;
};

/** All input for the `updateTenantContractAllowanceByTenantContractTransactionIdAndQuotaType` mutation. */
export type UpdateTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    quotaType: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `TenantContractAllowance` being updated. */
    tenantContractAllowancePatch: TenantContractAllowancePatch;
    tenantContractTransactionId: Scalars["Int"]["input"];
  };

/** The output of our update `TenantContractAllowance` mutation. */
export type UpdateTenantContractAllowancePayload = {
  __typename: "UpdateTenantContractAllowancePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TenantContractAllowance` that was updated by this mutation. */
  tenantContractAllowance: Maybe<TenantContractAllowance>;
  /** An edge for our `TenantContractAllowance`. May be used by Relay 1. */
  tenantContractAllowanceEdge: Maybe<TenantContractAllowancesEdge>;
  /** Reads a single `TenantContractTransaction` that is related to this `TenantContractAllowance`. */
  tenantContractTransactionByTenantContractTransactionId: Maybe<TenantContractTransaction>;
};

/** The output of our update `TenantContractAllowance` mutation. */
export type UpdateTenantContractAllowancePayloadTenantContractAllowanceEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TenantContractAllowancesOrderBy>>;
  };

/** All input for the `updateTenantContractById` mutation. */
export type UpdateTenantContractByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `TenantContract` being updated. */
  tenantContractPatch: TenantContractPatch;
};

/** All input for the `updateTenantContractByName` mutation. */
export type UpdateTenantContractByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  /** An object where the defined keys will be set on the `TenantContract` being updated. */
  tenantContractPatch: TenantContractPatch;
};

/** All input for the `updateTenantContractBySfid` mutation. */
export type UpdateTenantContractBySfidInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  sfid: Scalars["String"]["input"];
  /** An object where the defined keys will be set on the `TenantContract` being updated. */
  tenantContractPatch: TenantContractPatch;
};

/** The output of our update `TenantContract` mutation. */
export type UpdateTenantContractPayload = {
  __typename: "UpdateTenantContractPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `TenantContract`. */
  tenantByTenantId: Maybe<Tenant>;
  /** The `TenantContract` that was updated by this mutation. */
  tenantContract: Maybe<TenantContract>;
  /** An edge for our `TenantContract`. May be used by Relay 1. */
  tenantContractEdge: Maybe<TenantContractsEdge>;
};

/** The output of our update `TenantContract` mutation. */
export type UpdateTenantContractPayloadTenantContractEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantContractsOrderBy>>;
};

/** All input for the `updateTenantContractTransactionById` mutation. */
export type UpdateTenantContractTransactionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `TenantContractTransaction` being updated. */
  tenantContractTransactionPatch: TenantContractTransactionPatch;
};

/** The output of our update `TenantContractTransaction` mutation. */
export type UpdateTenantContractTransactionPayload = {
  __typename: "UpdateTenantContractTransactionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TenantContract` that is related to this `TenantContractTransaction`. */
  tenantContractByTenantContractId: Maybe<TenantContract>;
  /** The `TenantContractTransaction` that was updated by this mutation. */
  tenantContractTransaction: Maybe<TenantContractTransaction>;
  /** An edge for our `TenantContractTransaction`. May be used by Relay 1. */
  tenantContractTransactionEdge: Maybe<TenantContractTransactionsEdge>;
};

/** The output of our update `TenantContractTransaction` mutation. */
export type UpdateTenantContractTransactionPayloadTenantContractTransactionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TenantContractTransactionsOrderBy>>;
  };

/** All input for the `updateTenantMockuserexecutorByUserexecutorPtrId` mutation. */
export type UpdateTenantMockuserexecutorByUserexecutorPtrIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `TenantMockuserexecutor` being updated. */
  tenantMockuserexecutorPatch: TenantMockuserexecutorPatch;
  userexecutorPtrId: Scalars["Int"]["input"];
};

/** The output of our update `TenantMockuserexecutor` mutation. */
export type UpdateTenantMockuserexecutorPayload = {
  __typename: "UpdateTenantMockuserexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TenantMockuserexecutor` that was updated by this mutation. */
  tenantMockuserexecutor: Maybe<TenantMockuserexecutor>;
  /** An edge for our `TenantMockuserexecutor`. May be used by Relay 1. */
  tenantMockuserexecutorEdge: Maybe<TenantMockuserexecutorsEdge>;
  /** Reads a single `TenantUserexecutor` that is related to this `TenantMockuserexecutor`. */
  tenantUserexecutorByUserexecutorPtrId: Maybe<TenantUserexecutor>;
};

/** The output of our update `TenantMockuserexecutor` mutation. */
export type UpdateTenantMockuserexecutorPayloadTenantMockuserexecutorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TenantMockuserexecutorsOrderBy>>;
  };

/** All input for the `updateTenantMonthlyConsumedResourceById` mutation. */
export type UpdateTenantMonthlyConsumedResourceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `TenantMonthlyConsumedResource` being updated. */
  tenantMonthlyConsumedResourcePatch: TenantMonthlyConsumedResourcePatch;
};

/** All input for the `updateTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract` mutation. */
export type UpdateTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    month: Scalars["Date"]["input"];
    monthInActiveContract: Scalars["Int"]["input"];
    quotaType: Scalars["Int"]["input"];
    tenantContractId: Scalars["Int"]["input"];
    tenantId: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `TenantMonthlyConsumedResource` being updated. */
    tenantMonthlyConsumedResourcePatch: TenantMonthlyConsumedResourcePatch;
    userId: Scalars["UUID"]["input"];
  };

/** The output of our update `TenantMonthlyConsumedResource` mutation. */
export type UpdateTenantMonthlyConsumedResourcePayload = {
  __typename: "UpdateTenantMonthlyConsumedResourcePayload";
  /** Reads a single `ApplicationUser` that is related to this `TenantMonthlyConsumedResource`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `TenantMonthlyConsumedResource`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `TenantContract` that is related to this `TenantMonthlyConsumedResource`. */
  tenantContractByTenantContractId: Maybe<TenantContract>;
  /** The `TenantMonthlyConsumedResource` that was updated by this mutation. */
  tenantMonthlyConsumedResource: Maybe<TenantMonthlyConsumedResource>;
  /** An edge for our `TenantMonthlyConsumedResource`. May be used by Relay 1. */
  tenantMonthlyConsumedResourceEdge: Maybe<TenantMonthlyConsumedResourcesEdge>;
};

/** The output of our update `TenantMonthlyConsumedResource` mutation. */
export type UpdateTenantMonthlyConsumedResourcePayloadTenantMonthlyConsumedResourceEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TenantMonthlyConsumedResourcesOrderBy>>;
  };

/** The output of our update `Tenant` mutation. */
export type UpdateTenantPayload = {
  __typename: "UpdateTenantPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Tenant` that was updated by this mutation. */
  tenant: Maybe<Tenant>;
  /** An edge for our `Tenant`. May be used by Relay 1. */
  tenantEdge: Maybe<TenantsEdge>;
};

/** The output of our update `Tenant` mutation. */
export type UpdateTenantPayloadTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
};

/** All input for the `updateTenantUserexecutorById` mutation. */
export type UpdateTenantUserexecutorByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `TenantUserexecutor` being updated. */
  tenantUserexecutorPatch: TenantUserexecutorPatch;
};

/** The output of our update `TenantUserexecutor` mutation. */
export type UpdateTenantUserexecutorPayload = {
  __typename: "UpdateTenantUserexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `TenantUserexecutor`. */
  djangoContentTypeByPolymorphicCtypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TenantUserexecutor` that was updated by this mutation. */
  tenantUserexecutor: Maybe<TenantUserexecutor>;
  /** An edge for our `TenantUserexecutor`. May be used by Relay 1. */
  tenantUserexecutorEdge: Maybe<TenantUserexecutorsEdge>;
};

/** The output of our update `TenantUserexecutor` mutation. */
export type UpdateTenantUserexecutorPayloadTenantUserexecutorEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantUserexecutorsOrderBy>>;
};

/** All input for the `updateTesContainerimageexecutorById` mutation. */
export type UpdateTesContainerimageexecutorByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `TesContainerimageexecutor` being updated. */
  tesContainerimageexecutorPatch: TesContainerimageexecutorPatch;
};

/** The output of our update `TesContainerimageexecutor` mutation. */
export type UpdateTesContainerimageexecutorPayload = {
  __typename: "UpdateTesContainerimageexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `TesContainerimageexecutor`. */
  djangoContentTypeByPolymorphicCtypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TesContainerimageexecutor` that was updated by this mutation. */
  tesContainerimageexecutor: Maybe<TesContainerimageexecutor>;
  /** An edge for our `TesContainerimageexecutor`. May be used by Relay 1. */
  tesContainerimageexecutorEdge: Maybe<TesContainerimageexecutorsEdge>;
};

/** The output of our update `TesContainerimageexecutor` mutation. */
export type UpdateTesContainerimageexecutorPayloadTesContainerimageexecutorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TesContainerimageexecutorsOrderBy>>;
  };

/** All input for the `updateTesMockcontainerimageexecutorByContainerimageexecutorPtrId` mutation. */
export type UpdateTesMockcontainerimageexecutorByContainerimageexecutorPtrIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    containerimageexecutorPtrId: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `TesMockcontainerimageexecutor` being updated. */
    tesMockcontainerimageexecutorPatch: TesMockcontainerimageexecutorPatch;
  };

/** The output of our update `TesMockcontainerimageexecutor` mutation. */
export type UpdateTesMockcontainerimageexecutorPayload = {
  __typename: "UpdateTesMockcontainerimageexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `TesContainerimageexecutor` that is related to this `TesMockcontainerimageexecutor`. */
  tesContainerimageexecutorByContainerimageexecutorPtrId: Maybe<TesContainerimageexecutor>;
  /** The `TesMockcontainerimageexecutor` that was updated by this mutation. */
  tesMockcontainerimageexecutor: Maybe<TesMockcontainerimageexecutor>;
  /** An edge for our `TesMockcontainerimageexecutor`. May be used by Relay 1. */
  tesMockcontainerimageexecutorEdge: Maybe<TesMockcontainerimageexecutorsEdge>;
};

/** The output of our update `TesMockcontainerimageexecutor` mutation. */
export type UpdateTesMockcontainerimageexecutorPayloadTesMockcontainerimageexecutorEdgeArgs =
  {
    orderBy?: InputMaybe<Array<TesMockcontainerimageexecutorsOrderBy>>;
  };

/** All input for the `updateTesMocktaskexecutorByTaskexecutorPtrId` mutation. */
export type UpdateTesMocktaskexecutorByTaskexecutorPtrIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  taskexecutorPtrId: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `TesMocktaskexecutor` being updated. */
  tesMocktaskexecutorPatch: TesMocktaskexecutorPatch;
};

/** The output of our update `TesMocktaskexecutor` mutation. */
export type UpdateTesMocktaskexecutorPayload = {
  __typename: "UpdateTesMocktaskexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TesMocktaskexecutor` that was updated by this mutation. */
  tesMocktaskexecutor: Maybe<TesMocktaskexecutor>;
  /** An edge for our `TesMocktaskexecutor`. May be used by Relay 1. */
  tesMocktaskexecutorEdge: Maybe<TesMocktaskexecutorsEdge>;
  /** Reads a single `TesTaskexecutor` that is related to this `TesMocktaskexecutor`. */
  tesTaskexecutorByTaskexecutorPtrId: Maybe<TesTaskexecutor>;
};

/** The output of our update `TesMocktaskexecutor` mutation. */
export type UpdateTesMocktaskexecutorPayloadTesMocktaskexecutorEdgeArgs = {
  orderBy?: InputMaybe<Array<TesMocktaskexecutorsOrderBy>>;
};

/** All input for the `updateTesTaskexecutorById` mutation. */
export type UpdateTesTaskexecutorByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `TesTaskexecutor` being updated. */
  tesTaskexecutorPatch: TesTaskexecutorPatch;
};

/** The output of our update `TesTaskexecutor` mutation. */
export type UpdateTesTaskexecutorPayload = {
  __typename: "UpdateTesTaskexecutorPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `DjangoContentType` that is related to this `TesTaskexecutor`. */
  djangoContentTypeByPolymorphicCtypeId: Maybe<DjangoContentType>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `TesTaskexecutor` that was updated by this mutation. */
  tesTaskexecutor: Maybe<TesTaskexecutor>;
  /** An edge for our `TesTaskexecutor`. May be used by Relay 1. */
  tesTaskexecutorEdge: Maybe<TesTaskexecutorsEdge>;
};

/** The output of our update `TesTaskexecutor` mutation. */
export type UpdateTesTaskexecutorPayloadTesTaskexecutorEdgeArgs = {
  orderBy?: InputMaybe<Array<TesTaskexecutorsOrderBy>>;
};

/** All input for the `updateToolById` mutation. */
export type UpdateToolByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `Tool` being updated. */
  toolPatch: ToolPatch;
};

/** All input for the `updateToolByProjectId` mutation. */
export type UpdateToolByProjectIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  projectId: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `Tool` being updated. */
  toolPatch: ToolPatch;
};

/** All input for the `updateToolParameterById` mutation. */
export type UpdateToolParameterByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `ToolParameter` being updated. */
  toolParameterPatch: ToolParameterPatch;
};

/** The output of our update `ToolParameter` mutation. */
export type UpdateToolParameterPayload = {
  __typename: "UpdateToolParameterPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ToolParameter` that was updated by this mutation. */
  toolParameter: Maybe<ToolParameter>;
  /** An edge for our `ToolParameter`. May be used by Relay 1. */
  toolParameterEdge: Maybe<ToolParametersEdge>;
  /** Reads a single `ToolVersion` that is related to this `ToolParameter`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our update `ToolParameter` mutation. */
export type UpdateToolParameterPayloadToolParameterEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolParametersOrderBy>>;
};

/** The output of our update `Tool` mutation. */
export type UpdateToolPayload = {
  __typename: "UpdateToolPayload";
  /** Reads a single `ApplicationUser` that is related to this `Tool`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `Project` that is related to this `Tool`. */
  projectByProjectId: Maybe<Project>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Tool`. */
  tenantByTenantId: Maybe<Tenant>;
  /** The `Tool` that was updated by this mutation. */
  tool: Maybe<Tool>;
  /** An edge for our `Tool`. May be used by Relay 1. */
  toolEdge: Maybe<ToolsEdge>;
  /** Reads a single `Toolbox` that is related to this `Tool`. */
  toolboxByToolboxId: Maybe<Toolbox>;
};

/** The output of our update `Tool` mutation. */
export type UpdateToolPayloadToolEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolsOrderBy>>;
};

/** All input for the `updateToolResourceById` mutation. */
export type UpdateToolResourceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `ToolResource` being updated. */
  toolResourcePatch: ToolResourcePatch;
};

/** All input for the `updateToolResourceByTypeAndToolVersionId` mutation. */
export type UpdateToolResourceByTypeAndToolVersionIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** An object where the defined keys will be set on the `ToolResource` being updated. */
  toolResourcePatch: ToolResourcePatch;
  toolVersionId: Scalars["Int"]["input"];
  type: Scalars["Int"]["input"];
};

/** The output of our update `ToolResource` mutation. */
export type UpdateToolResourcePayload = {
  __typename: "UpdateToolResourcePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ToolResource` that was updated by this mutation. */
  toolResource: Maybe<ToolResource>;
  /** An edge for our `ToolResource`. May be used by Relay 1. */
  toolResourceEdge: Maybe<ToolResourcesEdge>;
  /** Reads a single `ToolVersion` that is related to this `ToolResource`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our update `ToolResource` mutation. */
export type UpdateToolResourcePayloadToolResourceEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolResourcesOrderBy>>;
};

/** All input for the `updateToolResultById` mutation. */
export type UpdateToolResultByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `ToolResult` being updated. */
  toolResultPatch: ToolResultPatch;
};

/** The output of our update `ToolResult` mutation. */
export type UpdateToolResultPayload = {
  __typename: "UpdateToolResultPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ToolResult` that was updated by this mutation. */
  toolResult: Maybe<ToolResult>;
  /** An edge for our `ToolResult`. May be used by Relay 1. */
  toolResultEdge: Maybe<ToolResultsEdge>;
  /** Reads a single `ToolVersion` that is related to this `ToolResult`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our update `ToolResult` mutation. */
export type UpdateToolResultPayloadToolResultEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolResultsOrderBy>>;
};

/** All input for the `updateToolSecretById` mutation. */
export type UpdateToolSecretByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `ToolSecret` being updated. */
  toolSecretPatch: ToolSecretPatch;
};

/** The output of our update `ToolSecret` mutation. */
export type UpdateToolSecretPayload = {
  __typename: "UpdateToolSecretPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ToolSecret` that was updated by this mutation. */
  toolSecret: Maybe<ToolSecret>;
  /** An edge for our `ToolSecret`. May be used by Relay 1. */
  toolSecretEdge: Maybe<ToolSecretsEdge>;
  /** Reads a single `ToolVersion` that is related to this `ToolSecret`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our update `ToolSecret` mutation. */
export type UpdateToolSecretPayloadToolSecretEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolSecretsOrderBy>>;
};

/** All input for the `updateToolSourceById` mutation. */
export type UpdateToolSourceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `ToolSource` being updated. */
  toolSourcePatch: ToolSourcePatch;
};

/** The output of our update `ToolSource` mutation. */
export type UpdateToolSourcePayload = {
  __typename: "UpdateToolSourcePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ToolSource` that was updated by this mutation. */
  toolSource: Maybe<ToolSource>;
  /** An edge for our `ToolSource`. May be used by Relay 1. */
  toolSourceEdge: Maybe<ToolSourcesEdge>;
  /** Reads a single `ToolVersion` that is related to this `ToolSource`. */
  toolVersionByToolVersionId: Maybe<ToolVersion>;
};

/** The output of our update `ToolSource` mutation. */
export type UpdateToolSourcePayloadToolSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolSourcesOrderBy>>;
};

/** All input for the `updateToolTenantById` mutation. */
export type UpdateToolTenantByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
  /** An object where the defined keys will be set on the `ToolTenant` being updated. */
  toolTenantPatch: ToolTenantPatch;
};

/** All input for the `updateToolTenantByToolIdAndTenantId` mutation. */
export type UpdateToolTenantByToolIdAndTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  tenantId: Scalars["Int"]["input"];
  toolId: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `ToolTenant` being updated. */
  toolTenantPatch: ToolTenantPatch;
};

/** The output of our update `ToolTenant` mutation. */
export type UpdateToolTenantPayload = {
  __typename: "UpdateToolTenantPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ToolTenant`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `Tool` that is related to this `ToolTenant`. */
  toolByToolId: Maybe<Tool>;
  /** The `ToolTenant` that was updated by this mutation. */
  toolTenant: Maybe<ToolTenant>;
  /** An edge for our `ToolTenant`. May be used by Relay 1. */
  toolTenantEdge: Maybe<ToolTenantsEdge>;
};

/** The output of our update `ToolTenant` mutation. */
export type UpdateToolTenantPayloadToolTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolTenantsOrderBy>>;
};

/** All input for the `updateToolVersionById` mutation. */
export type UpdateToolVersionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `ToolVersion` being updated. */
  toolVersionPatch: ToolVersionPatch;
};

/** The output of our update `ToolVersion` mutation. */
export type UpdateToolVersionPayload = {
  __typename: "UpdateToolVersionPayload";
  /** Reads a single `ApplicationUser` that is related to this `ToolVersion`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `ContainerImage` that is related to this `ToolVersion`. */
  containerImageByContainerImageId: Maybe<ContainerImage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ToolVersion`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `Tool` that is related to this `ToolVersion`. */
  toolByToolId: Maybe<Tool>;
  /** The `ToolVersion` that was updated by this mutation. */
  toolVersion: Maybe<ToolVersion>;
  /** An edge for our `ToolVersion`. May be used by Relay 1. */
  toolVersionEdge: Maybe<ToolVersionsEdge>;
};

/** The output of our update `ToolVersion` mutation. */
export type UpdateToolVersionPayloadToolVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolVersionsOrderBy>>;
};

/** All input for the `updateToolboxById` mutation. */
export type UpdateToolboxByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `Toolbox` being updated. */
  toolboxPatch: ToolboxPatch;
};

/** All input for the `updateToolboxByKey` mutation. */
export type UpdateToolboxByKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  key: Scalars["String"]["input"];
  /** An object where the defined keys will be set on the `Toolbox` being updated. */
  toolboxPatch: ToolboxPatch;
};

/** The output of our update `Toolbox` mutation. */
export type UpdateToolboxPayload = {
  __typename: "UpdateToolboxPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Toolbox` that was updated by this mutation. */
  toolbox: Maybe<Toolbox>;
  /** An edge for our `Toolbox`. May be used by Relay 1. */
  toolboxEdge: Maybe<ToolboxesEdge>;
};

/** The output of our update `Toolbox` mutation. */
export type UpdateToolboxPayloadToolboxEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolboxesOrderBy>>;
};

/** All input for the `updateToolboxTenantById` mutation. */
export type UpdateToolboxTenantByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
  /** An object where the defined keys will be set on the `ToolboxTenant` being updated. */
  toolboxTenantPatch: ToolboxTenantPatch;
};

/** All input for the `updateToolboxTenantByToolboxIdAndTenantId` mutation. */
export type UpdateToolboxTenantByToolboxIdAndTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  tenantId: Scalars["Int"]["input"];
  toolboxId: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `ToolboxTenant` being updated. */
  toolboxTenantPatch: ToolboxTenantPatch;
};

/** The output of our update `ToolboxTenant` mutation. */
export type UpdateToolboxTenantPayload = {
  __typename: "UpdateToolboxTenantPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `ToolboxTenant`. */
  tenantByTenantId: Maybe<Tenant>;
  /** Reads a single `Toolbox` that is related to this `ToolboxTenant`. */
  toolboxByToolboxId: Maybe<Toolbox>;
  /** The `ToolboxTenant` that was updated by this mutation. */
  toolboxTenant: Maybe<ToolboxTenant>;
  /** An edge for our `ToolboxTenant`. May be used by Relay 1. */
  toolboxTenantEdge: Maybe<ToolboxTenantsEdge>;
};

/** The output of our update `ToolboxTenant` mutation. */
export type UpdateToolboxTenantPayloadToolboxTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<ToolboxTenantsOrderBy>>;
};

/** All input for the `updateUserPersonalSpaceRequestById` mutation. */
export type UpdateUserPersonalSpaceRequestByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `UserPersonalSpaceRequest` being updated. */
  userPersonalSpaceRequestPatch: UserPersonalSpaceRequestPatch;
};

/** The output of our update `UserPersonalSpaceRequest` mutation. */
export type UpdateUserPersonalSpaceRequestPayload = {
  __typename: "UpdateUserPersonalSpaceRequestPayload";
  /** Reads a single `ApplicationUser` that is related to this `UserPersonalSpaceRequest`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `UserPersonalSpaceRequest` that was updated by this mutation. */
  userPersonalSpaceRequest: Maybe<UserPersonalSpaceRequest>;
  /** An edge for our `UserPersonalSpaceRequest`. May be used by Relay 1. */
  userPersonalSpaceRequestEdge: Maybe<UserPersonalSpaceRequestsEdge>;
};

/** The output of our update `UserPersonalSpaceRequest` mutation. */
export type UpdateUserPersonalSpaceRequestPayloadUserPersonalSpaceRequestEdgeArgs =
  {
    orderBy?: InputMaybe<Array<UserPersonalSpaceRequestsOrderBy>>;
  };

/** All input for the `updateWaffleFlagById` mutation. */
export type UpdateWaffleFlagByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `WaffleFlag` being updated. */
  waffleFlagPatch: WaffleFlagPatch;
};

/** All input for the `updateWaffleFlagByName` mutation. */
export type UpdateWaffleFlagByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  /** An object where the defined keys will be set on the `WaffleFlag` being updated. */
  waffleFlagPatch: WaffleFlagPatch;
};

/** The output of our update `WaffleFlag` mutation. */
export type UpdateWaffleFlagPayload = {
  __typename: "UpdateWaffleFlagPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WaffleFlag` that was updated by this mutation. */
  waffleFlag: Maybe<WaffleFlag>;
  /** An edge for our `WaffleFlag`. May be used by Relay 1. */
  waffleFlagEdge: Maybe<WaffleFlagsEdge>;
};

/** The output of our update `WaffleFlag` mutation. */
export type UpdateWaffleFlagPayloadWaffleFlagEdgeArgs = {
  orderBy?: InputMaybe<Array<WaffleFlagsOrderBy>>;
};

/** All input for the `updateWaffleSampleById` mutation. */
export type UpdateWaffleSampleByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `WaffleSample` being updated. */
  waffleSamplePatch: WaffleSamplePatch;
};

/** All input for the `updateWaffleSampleByName` mutation. */
export type UpdateWaffleSampleByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  /** An object where the defined keys will be set on the `WaffleSample` being updated. */
  waffleSamplePatch: WaffleSamplePatch;
};

/** The output of our update `WaffleSample` mutation. */
export type UpdateWaffleSamplePayload = {
  __typename: "UpdateWaffleSamplePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WaffleSample` that was updated by this mutation. */
  waffleSample: Maybe<WaffleSample>;
  /** An edge for our `WaffleSample`. May be used by Relay 1. */
  waffleSampleEdge: Maybe<WaffleSamplesEdge>;
};

/** The output of our update `WaffleSample` mutation. */
export type UpdateWaffleSamplePayloadWaffleSampleEdgeArgs = {
  orderBy?: InputMaybe<Array<WaffleSamplesOrderBy>>;
};

/** All input for the `updateWaffleSwitchById` mutation. */
export type UpdateWaffleSwitchByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  /** An object where the defined keys will be set on the `WaffleSwitch` being updated. */
  waffleSwitchPatch: WaffleSwitchPatch;
};

/** All input for the `updateWaffleSwitchByName` mutation. */
export type UpdateWaffleSwitchByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  /** An object where the defined keys will be set on the `WaffleSwitch` being updated. */
  waffleSwitchPatch: WaffleSwitchPatch;
};

/** The output of our update `WaffleSwitch` mutation. */
export type UpdateWaffleSwitchPayload = {
  __typename: "UpdateWaffleSwitchPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WaffleSwitch` that was updated by this mutation. */
  waffleSwitch: Maybe<WaffleSwitch>;
  /** An edge for our `WaffleSwitch`. May be used by Relay 1. */
  waffleSwitchEdge: Maybe<WaffleSwitchesEdge>;
};

/** The output of our update `WaffleSwitch` mutation. */
export type UpdateWaffleSwitchPayloadWaffleSwitchEdgeArgs = {
  orderBy?: InputMaybe<Array<WaffleSwitchesOrderBy>>;
};

/** All input for the `updateWorkflowById` mutation. */
export type UpdateWorkflowByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `Workflow` being updated. */
  workflowPatch: WorkflowPatch;
};

/** All input for the `updateWorkflowDatumById` mutation. */
export type UpdateWorkflowDatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `WorkflowDatum` being updated. */
  workflowDatumPatch: WorkflowDatumPatch;
};

/** The output of our update `WorkflowDatum` mutation. */
export type UpdateWorkflowDatumPayload = {
  __typename: "UpdateWorkflowDatumPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WorkflowDatum` that was updated by this mutation. */
  workflowDatum: Maybe<WorkflowDatum>;
  /** An edge for our `WorkflowDatum`. May be used by Relay 1. */
  workflowDatumEdge: Maybe<WorkflowDataEdge>;
};

/** The output of our update `WorkflowDatum` mutation. */
export type UpdateWorkflowDatumPayloadWorkflowDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowDataOrderBy>>;
};

/** The output of our update `Workflow` mutation. */
export type UpdateWorkflowPayload = {
  __typename: "UpdateWorkflowPayload";
  /** Reads a single `ApplicationUser` that is related to this `Workflow`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `ContainerImage` that is related to this `Workflow`. */
  containerImageByContainerId: Maybe<ContainerImage>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Workflow`. */
  tenantByTenantId: Maybe<Tenant>;
  /** The `Workflow` that was updated by this mutation. */
  workflow: Maybe<Workflow>;
  /** An edge for our `Workflow`. May be used by Relay 1. */
  workflowEdge: Maybe<WorkflowsEdge>;
};

/** The output of our update `Workflow` mutation. */
export type UpdateWorkflowPayloadWorkflowEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowsOrderBy>>;
};

/** All input for the `updateWorkflowResultById` mutation. */
export type UpdateWorkflowResultByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `WorkflowResult` being updated. */
  workflowResultPatch: WorkflowResultPatch;
};

/** The output of our update `WorkflowResult` mutation. */
export type UpdateWorkflowResultPayload = {
  __typename: "UpdateWorkflowResultPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WorkflowDatum` that is related to this `WorkflowResult`. */
  workflowDatumByObjectId: Maybe<WorkflowDatum>;
  /** The `WorkflowResult` that was updated by this mutation. */
  workflowResult: Maybe<WorkflowResult>;
  /** An edge for our `WorkflowResult`. May be used by Relay 1. */
  workflowResultEdge: Maybe<WorkflowResultsEdge>;
};

/** The output of our update `WorkflowResult` mutation. */
export type UpdateWorkflowResultPayloadWorkflowResultEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowResultsOrderBy>>;
};

/** All input for the `updateWorkflowResultWorkflowVersionById` mutation. */
export type UpdateWorkflowResultWorkflowVersionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
  /** An object where the defined keys will be set on the `WorkflowResultWorkflowVersion` being updated. */
  workflowResultWorkflowVersionPatch: WorkflowResultWorkflowVersionPatch;
};

/** All input for the `updateWorkflowResultWorkflowVersionByResultIdAndWorkflowversionId` mutation. */
export type UpdateWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    resultId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `WorkflowResultWorkflowVersion` being updated. */
    workflowResultWorkflowVersionPatch: WorkflowResultWorkflowVersionPatch;
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The output of our update `WorkflowResultWorkflowVersion` mutation. */
export type UpdateWorkflowResultWorkflowVersionPayload = {
  __typename: "UpdateWorkflowResultWorkflowVersionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WorkflowResult` that is related to this `WorkflowResultWorkflowVersion`. */
  workflowResultByResultId: Maybe<WorkflowResult>;
  /** The `WorkflowResultWorkflowVersion` that was updated by this mutation. */
  workflowResultWorkflowVersion: Maybe<WorkflowResultWorkflowVersion>;
  /** An edge for our `WorkflowResultWorkflowVersion`. May be used by Relay 1. */
  workflowResultWorkflowVersionEdge: Maybe<WorkflowResultWorkflowVersionsEdge>;
  /** Reads a single `WorkflowVersion` that is related to this `WorkflowResultWorkflowVersion`. */
  workflowVersionByWorkflowversionId: Maybe<WorkflowVersion>;
};

/** The output of our update `WorkflowResultWorkflowVersion` mutation. */
export type UpdateWorkflowResultWorkflowVersionPayloadWorkflowResultWorkflowVersionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<WorkflowResultWorkflowVersionsOrderBy>>;
  };

/** All input for the `updateWorkflowSectionBlockById` mutation. */
export type UpdateWorkflowSectionBlockByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `WorkflowSectionBlock` being updated. */
  workflowSectionBlockPatch: WorkflowSectionBlockPatch;
};

/** The output of our update `WorkflowSectionBlock` mutation. */
export type UpdateWorkflowSectionBlockPayload = {
  __typename: "UpdateWorkflowSectionBlockPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `ToolVersion` that is related to this `WorkflowSectionBlock`. */
  toolVersionByToolId: Maybe<ToolVersion>;
  /** Reads a single `WorkflowDatum` that is related to this `WorkflowSectionBlock`. */
  workflowDatumByObjectId: Maybe<WorkflowDatum>;
  /** The `WorkflowSectionBlock` that was updated by this mutation. */
  workflowSectionBlock: Maybe<WorkflowSectionBlock>;
  /** An edge for our `WorkflowSectionBlock`. May be used by Relay 1. */
  workflowSectionBlockEdge: Maybe<WorkflowSectionBlocksEdge>;
};

/** The output of our update `WorkflowSectionBlock` mutation. */
export type UpdateWorkflowSectionBlockPayloadWorkflowSectionBlockEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowSectionBlocksOrderBy>>;
};

/** All input for the `updateWorkflowSectionBlockSectionByBlockIdAndSectionId` mutation. */
export type UpdateWorkflowSectionBlockSectionByBlockIdAndSectionIdInput = {
  blockId: Scalars["UUID"]["input"];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  sectionId: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `WorkflowSectionBlockSection` being updated. */
  workflowSectionBlockSectionPatch: WorkflowSectionBlockSectionPatch;
};

/** All input for the `updateWorkflowSectionBlockSectionById` mutation. */
export type UpdateWorkflowSectionBlockSectionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
  /** An object where the defined keys will be set on the `WorkflowSectionBlockSection` being updated. */
  workflowSectionBlockSectionPatch: WorkflowSectionBlockSectionPatch;
};

/** The output of our update `WorkflowSectionBlockSection` mutation. */
export type UpdateWorkflowSectionBlockSectionPayload = {
  __typename: "UpdateWorkflowSectionBlockSectionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WorkflowSectionBlock` that is related to this `WorkflowSectionBlockSection`. */
  workflowSectionBlockByBlockId: Maybe<WorkflowSectionBlock>;
  /** The `WorkflowSectionBlockSection` that was updated by this mutation. */
  workflowSectionBlockSection: Maybe<WorkflowSectionBlockSection>;
  /** An edge for our `WorkflowSectionBlockSection`. May be used by Relay 1. */
  workflowSectionBlockSectionEdge: Maybe<WorkflowSectionBlockSectionsEdge>;
  /** Reads a single `WorkflowSection` that is related to this `WorkflowSectionBlockSection`. */
  workflowSectionBySectionId: Maybe<WorkflowSection>;
};

/** The output of our update `WorkflowSectionBlockSection` mutation. */
export type UpdateWorkflowSectionBlockSectionPayloadWorkflowSectionBlockSectionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<WorkflowSectionBlockSectionsOrderBy>>;
  };

/** All input for the `updateWorkflowSectionById` mutation. */
export type UpdateWorkflowSectionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `WorkflowSection` being updated. */
  workflowSectionPatch: WorkflowSectionPatch;
};

/** The output of our update `WorkflowSection` mutation. */
export type UpdateWorkflowSectionPayload = {
  __typename: "UpdateWorkflowSectionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WorkflowSection` that was updated by this mutation. */
  workflowSection: Maybe<WorkflowSection>;
  /** An edge for our `WorkflowSection`. May be used by Relay 1. */
  workflowSectionEdge: Maybe<WorkflowSectionsEdge>;
};

/** The output of our update `WorkflowSection` mutation. */
export type UpdateWorkflowSectionPayloadWorkflowSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowSectionsOrderBy>>;
};

/** All input for the `updateWorkflowSectionWorkflowVersionById` mutation. */
export type UpdateWorkflowSectionWorkflowVersionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
  /** An object where the defined keys will be set on the `WorkflowSectionWorkflowVersion` being updated. */
  workflowSectionWorkflowVersionPatch: WorkflowSectionWorkflowVersionPatch;
};

/** All input for the `updateWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionId` mutation. */
export type UpdateWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    sectionId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `WorkflowSectionWorkflowVersion` being updated. */
    workflowSectionWorkflowVersionPatch: WorkflowSectionWorkflowVersionPatch;
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The output of our update `WorkflowSectionWorkflowVersion` mutation. */
export type UpdateWorkflowSectionWorkflowVersionPayload = {
  __typename: "UpdateWorkflowSectionWorkflowVersionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WorkflowSection` that is related to this `WorkflowSectionWorkflowVersion`. */
  workflowSectionBySectionId: Maybe<WorkflowSection>;
  /** The `WorkflowSectionWorkflowVersion` that was updated by this mutation. */
  workflowSectionWorkflowVersion: Maybe<WorkflowSectionWorkflowVersion>;
  /** An edge for our `WorkflowSectionWorkflowVersion`. May be used by Relay 1. */
  workflowSectionWorkflowVersionEdge: Maybe<WorkflowSectionWorkflowVersionsEdge>;
  /** Reads a single `WorkflowVersion` that is related to this `WorkflowSectionWorkflowVersion`. */
  workflowVersionByWorkflowversionId: Maybe<WorkflowVersion>;
};

/** The output of our update `WorkflowSectionWorkflowVersion` mutation. */
export type UpdateWorkflowSectionWorkflowVersionPayloadWorkflowSectionWorkflowVersionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<WorkflowSectionWorkflowVersionsOrderBy>>;
  };

/** All input for the `updateWorkflowSourceById` mutation. */
export type UpdateWorkflowSourceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `WorkflowSource` being updated. */
  workflowSourcePatch: WorkflowSourcePatch;
};

/** The output of our update `WorkflowSource` mutation. */
export type UpdateWorkflowSourcePayload = {
  __typename: "UpdateWorkflowSourcePayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `WorkflowSource` that was updated by this mutation. */
  workflowSource: Maybe<WorkflowSource>;
  /** An edge for our `WorkflowSource`. May be used by Relay 1. */
  workflowSourceEdge: Maybe<WorkflowSourcesEdge>;
};

/** The output of our update `WorkflowSource` mutation. */
export type UpdateWorkflowSourcePayloadWorkflowSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowSourcesOrderBy>>;
};

/** All input for the `updateWorkflowSourceWorkflowVersionById` mutation. */
export type UpdateWorkflowSourceWorkflowVersionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["BigInt"]["input"];
  /** An object where the defined keys will be set on the `WorkflowSourceWorkflowVersion` being updated. */
  workflowSourceWorkflowVersionPatch: WorkflowSourceWorkflowVersionPatch;
};

/** All input for the `updateWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionId` mutation. */
export type UpdateWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdInput =
  {
    /**
     * An arbitrary string value with no semantic meaning. Will be included in the
     * payload verbatim. May be used to track mutations by the client.
     */
    clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
    sourceId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `WorkflowSourceWorkflowVersion` being updated. */
    workflowSourceWorkflowVersionPatch: WorkflowSourceWorkflowVersionPatch;
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The output of our update `WorkflowSourceWorkflowVersion` mutation. */
export type UpdateWorkflowSourceWorkflowVersionPayload = {
  __typename: "UpdateWorkflowSourceWorkflowVersionPayload";
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `WorkflowSource` that is related to this `WorkflowSourceWorkflowVersion`. */
  workflowSourceBySourceId: Maybe<WorkflowSource>;
  /** The `WorkflowSourceWorkflowVersion` that was updated by this mutation. */
  workflowSourceWorkflowVersion: Maybe<WorkflowSourceWorkflowVersion>;
  /** An edge for our `WorkflowSourceWorkflowVersion`. May be used by Relay 1. */
  workflowSourceWorkflowVersionEdge: Maybe<WorkflowSourceWorkflowVersionsEdge>;
  /** Reads a single `WorkflowVersion` that is related to this `WorkflowSourceWorkflowVersion`. */
  workflowVersionByWorkflowversionId: Maybe<WorkflowVersion>;
};

/** The output of our update `WorkflowSourceWorkflowVersion` mutation. */
export type UpdateWorkflowSourceWorkflowVersionPayloadWorkflowSourceWorkflowVersionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<WorkflowSourceWorkflowVersionsOrderBy>>;
  };

/** All input for the `updateWorkflowVersionById` mutation. */
export type UpdateWorkflowVersionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  /** An object where the defined keys will be set on the `WorkflowVersion` being updated. */
  workflowVersionPatch: WorkflowVersionPatch;
};

/** The output of our update `WorkflowVersion` mutation. */
export type UpdateWorkflowVersionPayload = {
  __typename: "UpdateWorkflowVersionPayload";
  /** Reads a single `ApplicationUser` that is related to this `WorkflowVersion`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars["String"]["output"]>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Workflow` that is related to this `WorkflowVersion`. */
  workflowByWorkflowId: Maybe<Workflow>;
  /** The `WorkflowVersion` that was updated by this mutation. */
  workflowVersion: Maybe<WorkflowVersion>;
  /** An edge for our `WorkflowVersion`. May be used by Relay 1. */
  workflowVersionEdge: Maybe<WorkflowVersionsEdge>;
};

/** The output of our update `WorkflowVersion` mutation. */
export type UpdateWorkflowVersionPayloadWorkflowVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkflowVersionsOrderBy>>;
};

export type UserAccessToProject = {
  __typename: "UserAccessToProject";
  edit: Maybe<Scalars["Boolean"]["output"]>;
  grantAccess: Maybe<Scalars["Boolean"]["output"]>;
  projectId: Maybe<Scalars["UUID"]["output"]>;
  userId: Maybe<Scalars["UUID"]["output"]>;
  view: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * A condition to be used against `UserAccessToProject` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type UserAccessToProjectCondition = {
  /** Checks for equality with the object’s `edit` field. */
  edit?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `grantAccess` field. */
  grantAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `view` field. */
  view?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** A filter to be used against `UserAccessToProject` object types. All fields are combined with a logical ‘and.’ */
export type UserAccessToProjectFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserAccessToProjectFilter>>;
  /** Filter by the object’s `edit` field. */
  edit?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `grantAccess` field. */
  grantAccess?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserAccessToProjectFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserAccessToProjectFilter>>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `view` field. */
  view?: InputMaybe<BooleanFilter>;
};

/** A connection to a list of `UserAccessToProject` values. */
export type UserAccessToProjectsConnection = {
  __typename: "UserAccessToProjectsConnection";
  /** A list of edges which contains the `UserAccessToProject` and cursor to aid in pagination. */
  edges: Array<UserAccessToProjectsEdge>;
  /** A list of `UserAccessToProject` objects. */
  nodes: Array<UserAccessToProject>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserAccessToProject` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `UserAccessToProject` edge in the connection. */
export type UserAccessToProjectsEdge = {
  __typename: "UserAccessToProjectsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `UserAccessToProject` at the end of the edge. */
  node: UserAccessToProject;
};

/** Methods to use when ordering `UserAccessToProject`. */
export enum UserAccessToProjectsOrderBy {
  EditAsc = "EDIT_ASC",
  EditDesc = "EDIT_DESC",
  GrantAccessAsc = "GRANT_ACCESS_ASC",
  GrantAccessDesc = "GRANT_ACCESS_DESC",
  Natural = "NATURAL",
  ProjectIdAsc = "PROJECT_ID_ASC",
  ProjectIdDesc = "PROJECT_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
  ViewAsc = "VIEW_ASC",
  ViewDesc = "VIEW_DESC",
}

/** Input for the nested mutation of `userOnboardingQuestion` in the `UserOnboardingQuestionResponseInput` mutation. */
export type UserOnboardingQuesQuestionId65Ae6E1FFkUserOnboInput = {
  /** The primary key(s) for `userOnboardingQuestion` for the far side of the relationship. */
  connectByCode?: InputMaybe<UserOnboardingQuestionUserOnboardingQuestionCodeKeyConnect>;
  /** The primary key(s) for `userOnboardingQuestion` for the far side of the relationship. */
  connectById?: InputMaybe<UserOnboardingQuestionUserOnboardingQuestionPkeyConnect>;
  /** The primary key(s) and patch data for `userOnboardingQuestion` for the far side of the relationship. */
  updateByCode?: InputMaybe<UserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionCodeKeyUpdate>;
  /** The primary key(s) and patch data for `userOnboardingQuestion` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionPkeyUpdate>;
};

/** Input for the nested mutation of `userOnboardingQuestionResponse` in the `UserOnboardingQuestionInput` mutation. */
export type UserOnboardingQuesQuestionId65Ae6E1FFkUserOnboInverseInput = {
  /** The primary key(s) for `userOnboardingQuestionResponse` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<UserOnboardingQuestionResponseUserOnboardingQuestionResponsePkeyConnect>
  >;
  /** The primary key(s) and patch data for `userOnboardingQuestionResponse` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<UserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionResponsePkeyUpdate>
  >;
};

/** Input for the nested mutation of `userOnboardingQuestion` in the `UserOnboardingQuestionAnswerInput` mutation. */
export type UserOnboardingQuesQuestionIdC28D2284FkUserOnboInput = {
  /** The primary key(s) for `userOnboardingQuestion` for the far side of the relationship. */
  connectByCode?: InputMaybe<UserOnboardingQuestionUserOnboardingQuestionCodeKeyConnect>;
  /** The primary key(s) for `userOnboardingQuestion` for the far side of the relationship. */
  connectById?: InputMaybe<UserOnboardingQuestionUserOnboardingQuestionPkeyConnect>;
  /** The primary key(s) and patch data for `userOnboardingQuestion` for the far side of the relationship. */
  updateByCode?: InputMaybe<UserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionCodeKeyUpdate>;
  /** The primary key(s) and patch data for `userOnboardingQuestion` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionPkeyUpdate>;
};

/** Input for the nested mutation of `userOnboardingQuestionAnswer` in the `UserOnboardingQuestionInput` mutation. */
export type UserOnboardingQuesQuestionIdC28D2284FkUserOnboInverseInput = {
  /** The primary key(s) for `userOnboardingQuestionAnswer` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<UserOnboardingQuestionAnswerUserOnboardingQuestionAnswerPkeyConnect>
  >;
  /** The primary key(s) and patch data for `userOnboardingQuestionAnswer` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<UserOnboardingQuestionAnswerOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionAnswerPkeyUpdate>
  >;
};

/** The `applicationUser` to be created by this mutation. */
export type UserOnboardingQuesUserId72Eee3DfFkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `UserOnboardingQuestionResponseInput` mutation. */
export type UserOnboardingQuesUserId72Eee3DfFkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `userOnboardingQuestionResponse` in the `ApplicationUserInput` mutation. */
export type UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput = {
  /** The primary key(s) for `userOnboardingQuestionResponse` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<UserOnboardingQuestionResponseUserOnboardingQuestionResponsePkeyConnect>
  >;
  /** The primary key(s) and patch data for `userOnboardingQuestionResponse` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<UserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingUserOnboardingQuestionResponsePkeyUpdate>
  >;
};

export type UserOnboardingQuestion = {
  __typename: "UserOnboardingQuestion";
  category: Scalars["Int"]["output"];
  code: Scalars["String"]["output"];
  concatenateResponse: Scalars["Boolean"]["output"];
  dateCreated: Scalars["Datetime"]["output"];
  deprecated: Scalars["Boolean"]["output"];
  id: Scalars["Int"]["output"];
  multiAnswer: Scalars["Boolean"]["output"];
  optional: Scalars["Boolean"]["output"];
  order: Scalars["Int"]["output"];
  question: Scalars["String"]["output"];
  salesforceLeadAttributes: Scalars["String"]["output"];
  salesforceMultiAttribute: Scalars["Boolean"]["output"];
  /** Reads and enables pagination through a set of `UserOnboardingQuestionAnswer`. */
  userOnboardingQuestionAnswersByQuestionId: UserOnboardingQuestionAnswersConnection;
  /** Reads and enables pagination through a set of `UserOnboardingQuestionResponse`. */
  userOnboardingQuestionResponsesByQuestionId: UserOnboardingQuestionResponsesConnection;
};

export type UserOnboardingQuestionUserOnboardingQuestionAnswersByQuestionIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<UserOnboardingQuestionAnswerCondition>;
    filter?: InputMaybe<UserOnboardingQuestionAnswerFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<UserOnboardingQuestionAnswersOrderBy>>;
  };

export type UserOnboardingQuestionUserOnboardingQuestionResponsesByQuestionIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<UserOnboardingQuestionResponseCondition>;
    filter?: InputMaybe<UserOnboardingQuestionResponseFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<UserOnboardingQuestionResponsesOrderBy>>;
  };

export type UserOnboardingQuestionAnswer = {
  __typename: "UserOnboardingQuestionAnswer";
  answerType: Scalars["Int"]["output"];
  dateCreated: Scalars["Datetime"]["output"];
  id: Scalars["Int"]["output"];
  maxLen: Maybe<Scalars["Int"]["output"]>;
  option: Maybe<Scalars["String"]["output"]>;
  questionId: Scalars["Int"]["output"];
  salesforceOption: Maybe<Scalars["String"]["output"]>;
  /** Reads a single `UserOnboardingQuestion` that is related to this `UserOnboardingQuestionAnswer`. */
  userOnboardingQuestionByQuestionId: Maybe<UserOnboardingQuestion>;
};

/**
 * A condition to be used against `UserOnboardingQuestionAnswer` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type UserOnboardingQuestionAnswerCondition = {
  /** Checks for equality with the object’s `answerType` field. */
  answerType?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `maxLen` field. */
  maxLen?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `option` field. */
  option?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `questionId` field. */
  questionId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `salesforceOption` field. */
  salesforceOption?: InputMaybe<Scalars["String"]["input"]>;
};

/** A filter to be used against `UserOnboardingQuestionAnswer` object types. All fields are combined with a logical ‘and.’ */
export type UserOnboardingQuestionAnswerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserOnboardingQuestionAnswerFilter>>;
  /** Filter by the object’s `answerType` field. */
  answerType?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `maxLen` field. */
  maxLen?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserOnboardingQuestionAnswerFilter>;
  /** Filter by the object’s `option` field. */
  option?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserOnboardingQuestionAnswerFilter>>;
  /** Filter by the object’s `questionId` field. */
  questionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `salesforceOption` field. */
  salesforceOption?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userOnboardingQuestionByQuestionId` relation. */
  userOnboardingQuestionByQuestionId?: InputMaybe<UserOnboardingQuestionFilter>;
};

/** The fields on `userOnboardingQuestionAnswer` to look up the row to update. */
export type UserOnboardingQuestionAnswerOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionAnswerPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `userOnboardingQuestionAnswer` being updated. */
    userOnboardingQuestionAnswerPatch: UpdateUserOnboardingQuestionAnswerOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboPatch;
  };

/** The fields on `userOnboardingQuestionAnswer` to look up the row to connect. */
export type UserOnboardingQuestionAnswerUserOnboardingQuestionAnswerPkeyConnect =
  {
    id: Scalars["Int"]["input"];
  };

/** A connection to a list of `UserOnboardingQuestionAnswer` values. */
export type UserOnboardingQuestionAnswersConnection = {
  __typename: "UserOnboardingQuestionAnswersConnection";
  /** A list of edges which contains the `UserOnboardingQuestionAnswer` and cursor to aid in pagination. */
  edges: Array<UserOnboardingQuestionAnswersEdge>;
  /** A list of `UserOnboardingQuestionAnswer` objects. */
  nodes: Array<UserOnboardingQuestionAnswer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserOnboardingQuestionAnswer` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `UserOnboardingQuestionAnswer` edge in the connection. */
export type UserOnboardingQuestionAnswersEdge = {
  __typename: "UserOnboardingQuestionAnswersEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `UserOnboardingQuestionAnswer` at the end of the edge. */
  node: UserOnboardingQuestionAnswer;
};

/** Methods to use when ordering `UserOnboardingQuestionAnswer`. */
export enum UserOnboardingQuestionAnswersOrderBy {
  AnswerTypeAsc = "ANSWER_TYPE_ASC",
  AnswerTypeDesc = "ANSWER_TYPE_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  MaxLenAsc = "MAX_LEN_ASC",
  MaxLenDesc = "MAX_LEN_DESC",
  Natural = "NATURAL",
  OptionAsc = "OPTION_ASC",
  OptionDesc = "OPTION_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  QuestionIdAsc = "QUESTION_ID_ASC",
  QuestionIdDesc = "QUESTION_ID_DESC",
  SalesforceOptionAsc = "SALESFORCE_OPTION_ASC",
  SalesforceOptionDesc = "SALESFORCE_OPTION_DESC",
}

/**
 * A condition to be used against `UserOnboardingQuestion` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type UserOnboardingQuestionCondition = {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `code` field. */
  code?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `concatenateResponse` field. */
  concatenateResponse?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `deprecated` field. */
  deprecated?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `multiAnswer` field. */
  multiAnswer?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `optional` field. */
  optional?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `question` field. */
  question?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `salesforceLeadAttributes` field. */
  salesforceLeadAttributes?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `salesforceMultiAttribute` field. */
  salesforceMultiAttribute?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** A filter to be used against `UserOnboardingQuestion` object types. All fields are combined with a logical ‘and.’ */
export type UserOnboardingQuestionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserOnboardingQuestionFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<IntFilter>;
  /** Filter by the object’s `code` field. */
  code?: InputMaybe<StringFilter>;
  /** Filter by the object’s `concatenateResponse` field. */
  concatenateResponse?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deprecated` field. */
  deprecated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `multiAnswer` field. */
  multiAnswer?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserOnboardingQuestionFilter>;
  /** Filter by the object’s `optional` field. */
  optional?: InputMaybe<BooleanFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserOnboardingQuestionFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `question` field. */
  question?: InputMaybe<StringFilter>;
  /** Filter by the object’s `salesforceLeadAttributes` field. */
  salesforceLeadAttributes?: InputMaybe<StringFilter>;
  /** Filter by the object’s `salesforceMultiAttribute` field. */
  salesforceMultiAttribute?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `userOnboardingQuestionAnswersByQuestionId` relation. */
  userOnboardingQuestionAnswersByQuestionId?: InputMaybe<UserOnboardingQuestionToManyUserOnboardingQuestionAnswerFilter>;
  /** Some related `userOnboardingQuestionAnswersByQuestionId` exist. */
  userOnboardingQuestionAnswersByQuestionIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `userOnboardingQuestionResponsesByQuestionId` relation. */
  userOnboardingQuestionResponsesByQuestionId?: InputMaybe<UserOnboardingQuestionToManyUserOnboardingQuestionResponseFilter>;
  /** Some related `userOnboardingQuestionResponsesByQuestionId` exist. */
  userOnboardingQuestionResponsesByQuestionIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

/** The fields on `userOnboardingQuestion` to look up the row to update. */
export type UserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionCodeKeyUpdate =
  {
    code: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `userOnboardingQuestion` being updated. */
    userOnboardingQuestionPatch: UpdateUserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboPatch;
  };

/** The fields on `userOnboardingQuestion` to look up the row to update. */
export type UserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `userOnboardingQuestion` being updated. */
    userOnboardingQuestionPatch: UpdateUserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboPatch;
  };

/** The fields on `userOnboardingQuestion` to look up the row to update. */
export type UserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionCodeKeyUpdate =
  {
    code: Scalars["String"]["input"];
    /** An object where the defined keys will be set on the `userOnboardingQuestion` being updated. */
    userOnboardingQuestionPatch: UpdateUserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboPatch;
  };

/** The fields on `userOnboardingQuestion` to look up the row to update. */
export type UserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `userOnboardingQuestion` being updated. */
    userOnboardingQuestionPatch: UpdateUserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboPatch;
  };

export type UserOnboardingQuestionResponse = {
  __typename: "UserOnboardingQuestionResponse";
  /** Reads a single `ApplicationUser` that is related to this `UserOnboardingQuestionResponse`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateCreated: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  questionId: Scalars["Int"]["output"];
  salesforceSynced: Scalars["Boolean"]["output"];
  text: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["UUID"]["output"];
  /** Reads a single `UserOnboardingQuestion` that is related to this `UserOnboardingQuestionResponse`. */
  userOnboardingQuestionByQuestionId: Maybe<UserOnboardingQuestion>;
};

/**
 * A condition to be used against `UserOnboardingQuestionResponse` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type UserOnboardingQuestionResponseCondition = {
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `questionId` field. */
  questionId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `salesforceSynced` field. */
  salesforceSynced?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `text` field. */
  text?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `UserOnboardingQuestionResponse` object types. All fields are combined with a logical ‘and.’ */
export type UserOnboardingQuestionResponseFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserOnboardingQuestionResponseFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserOnboardingQuestionResponseFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserOnboardingQuestionResponseFilter>>;
  /** Filter by the object’s `questionId` field. */
  questionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `salesforceSynced` field. */
  salesforceSynced?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `text` field. */
  text?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userOnboardingQuestionByQuestionId` relation. */
  userOnboardingQuestionByQuestionId?: InputMaybe<UserOnboardingQuestionFilter>;
};

/** The fields on `userOnboardingQuestionResponse` to look up the row to update. */
export type UserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionResponsePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `userOnboardingQuestionResponse` being updated. */
    userOnboardingQuestionResponsePatch: UpdateUserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboPatch;
  };

/** The fields on `userOnboardingQuestionResponse` to look up the row to update. */
export type UserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingUserOnboardingQuestionResponsePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `userOnboardingQuestionResponse` being updated. */
    userOnboardingQuestionResponsePatch: UpdateUserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiPatch;
  };

/** The fields on `userOnboardingQuestionResponse` to look up the row to connect. */
export type UserOnboardingQuestionResponseUserOnboardingQuestionResponsePkeyConnect =
  {
    id: Scalars["UUID"]["input"];
  };

/** A connection to a list of `UserOnboardingQuestionResponse` values. */
export type UserOnboardingQuestionResponsesConnection = {
  __typename: "UserOnboardingQuestionResponsesConnection";
  /** A list of edges which contains the `UserOnboardingQuestionResponse` and cursor to aid in pagination. */
  edges: Array<UserOnboardingQuestionResponsesEdge>;
  /** A list of `UserOnboardingQuestionResponse` objects. */
  nodes: Array<UserOnboardingQuestionResponse>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserOnboardingQuestionResponse` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `UserOnboardingQuestionResponse` edge in the connection. */
export type UserOnboardingQuestionResponsesEdge = {
  __typename: "UserOnboardingQuestionResponsesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `UserOnboardingQuestionResponse` at the end of the edge. */
  node: UserOnboardingQuestionResponse;
};

/** Methods to use when ordering `UserOnboardingQuestionResponse`. */
export enum UserOnboardingQuestionResponsesOrderBy {
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  QuestionIdAsc = "QUESTION_ID_ASC",
  QuestionIdDesc = "QUESTION_ID_DESC",
  SalesforceSyncedAsc = "SALESFORCE_SYNCED_ASC",
  SalesforceSyncedDesc = "SALESFORCE_SYNCED_DESC",
  TextAsc = "TEXT_ASC",
  TextDesc = "TEXT_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** A filter to be used against many `UserOnboardingQuestionAnswer` object types. All fields are combined with a logical ‘and.’ */
export type UserOnboardingQuestionToManyUserOnboardingQuestionAnswerFilter = {
  /** Every related `UserOnboardingQuestionAnswer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserOnboardingQuestionAnswerFilter>;
  /** No related `UserOnboardingQuestionAnswer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserOnboardingQuestionAnswerFilter>;
  /** Some related `UserOnboardingQuestionAnswer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserOnboardingQuestionAnswerFilter>;
};

/** A filter to be used against many `UserOnboardingQuestionResponse` object types. All fields are combined with a logical ‘and.’ */
export type UserOnboardingQuestionToManyUserOnboardingQuestionResponseFilter = {
  /** Every related `UserOnboardingQuestionResponse` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserOnboardingQuestionResponseFilter>;
  /** No related `UserOnboardingQuestionResponse` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserOnboardingQuestionResponseFilter>;
  /** Some related `UserOnboardingQuestionResponse` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserOnboardingQuestionResponseFilter>;
};

/** The fields on `userOnboardingQuestion` to look up the row to connect. */
export type UserOnboardingQuestionUserOnboardingQuestionCodeKeyConnect = {
  code: Scalars["String"]["input"];
};

/** The fields on `userOnboardingQuestion` to look up the row to connect. */
export type UserOnboardingQuestionUserOnboardingQuestionPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** A connection to a list of `UserOnboardingQuestion` values. */
export type UserOnboardingQuestionsConnection = {
  __typename: "UserOnboardingQuestionsConnection";
  /** A list of edges which contains the `UserOnboardingQuestion` and cursor to aid in pagination. */
  edges: Array<UserOnboardingQuestionsEdge>;
  /** A list of `UserOnboardingQuestion` objects. */
  nodes: Array<UserOnboardingQuestion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserOnboardingQuestion` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `UserOnboardingQuestion` edge in the connection. */
export type UserOnboardingQuestionsEdge = {
  __typename: "UserOnboardingQuestionsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `UserOnboardingQuestion` at the end of the edge. */
  node: UserOnboardingQuestion;
};

/** Methods to use when ordering `UserOnboardingQuestion`. */
export enum UserOnboardingQuestionsOrderBy {
  CategoryAsc = "CATEGORY_ASC",
  CategoryDesc = "CATEGORY_DESC",
  CodeAsc = "CODE_ASC",
  CodeDesc = "CODE_DESC",
  ConcatenateResponseAsc = "CONCATENATE_RESPONSE_ASC",
  ConcatenateResponseDesc = "CONCATENATE_RESPONSE_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DeprecatedAsc = "DEPRECATED_ASC",
  DeprecatedDesc = "DEPRECATED_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  MultiAnswerAsc = "MULTI_ANSWER_ASC",
  MultiAnswerDesc = "MULTI_ANSWER_DESC",
  Natural = "NATURAL",
  OptionalAsc = "OPTIONAL_ASC",
  OptionalDesc = "OPTIONAL_DESC",
  OrderAsc = "ORDER_ASC",
  OrderDesc = "ORDER_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  QuestionAsc = "QUESTION_ASC",
  QuestionDesc = "QUESTION_DESC",
  SalesforceLeadAttributesAsc = "SALESFORCE_LEAD_ATTRIBUTES_ASC",
  SalesforceLeadAttributesDesc = "SALESFORCE_LEAD_ATTRIBUTES_DESC",
  SalesforceMultiAttributeAsc = "SALESFORCE_MULTI_ATTRIBUTE_ASC",
  SalesforceMultiAttributeDesc = "SALESFORCE_MULTI_ATTRIBUTE_DESC",
}

export type UserPersonalSpaceRequest = {
  __typename: "UserPersonalSpaceRequest";
  /** Reads a single `ApplicationUser` that is related to this `UserPersonalSpaceRequest`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  dateActivated: Maybe<Scalars["Datetime"]["output"]>;
  dateRequested: Scalars["Datetime"]["output"];
  id: Scalars["Int"]["output"];
  status: Scalars["Int"]["output"];
  synchronizeHome: Scalars["Boolean"]["output"];
  userId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `UserPersonalSpaceRequest` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type UserPersonalSpaceRequestCondition = {
  /** Checks for equality with the object’s `dateActivated` field. */
  dateActivated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `dateRequested` field. */
  dateRequested?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `synchronizeHome` field. */
  synchronizeHome?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `UserPersonalSpaceRequest` object types. All fields are combined with a logical ‘and.’ */
export type UserPersonalSpaceRequestFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserPersonalSpaceRequestFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** Filter by the object’s `dateActivated` field. */
  dateActivated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `dateRequested` field. */
  dateRequested?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserPersonalSpaceRequestFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserPersonalSpaceRequestFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<IntFilter>;
  /** Filter by the object’s `synchronizeHome` field. */
  synchronizeHome?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `UserPersonalSpaceRequest` */
export type UserPersonalSpaceRequestInput = {
  applicationUserToUserId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInput>;
  dateActivated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateRequested?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  status: Scalars["Int"]["input"];
  synchronizeHome: Scalars["Boolean"]["input"];
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `userPersonalSpaceRequest` to look up the row to update. */
export type UserPersonalSpaceRequestOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingUserPersonalSpaceRequestPkeyUpdate =
  {
    id: Scalars["Int"]["input"];
    /** An object where the defined keys will be set on the `userPersonalSpaceRequest` being updated. */
    userPersonalSpaceRequestPatch: UpdateUserPersonalSpaceRequestOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiPatch;
  };

/** Represents an update to a `UserPersonalSpaceRequest`. Fields that are set will be updated. */
export type UserPersonalSpaceRequestPatch = {
  applicationUserToUserId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInput>;
  dateActivated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateRequested?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  synchronizeHome?: InputMaybe<Scalars["Boolean"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `userPersonalSpaceRequest` to look up the row to connect. */
export type UserPersonalSpaceRequestUserPersonalSpaceRequestPkeyConnect = {
  id: Scalars["Int"]["input"];
};

/** The fields on `userPersonalSpaceRequest` to look up the row to delete. */
export type UserPersonalSpaceRequestUserPersonalSpaceRequestPkeyDelete = {
  id: Scalars["Int"]["input"];
};

/** A connection to a list of `UserPersonalSpaceRequest` values. */
export type UserPersonalSpaceRequestsConnection = {
  __typename: "UserPersonalSpaceRequestsConnection";
  /** A list of edges which contains the `UserPersonalSpaceRequest` and cursor to aid in pagination. */
  edges: Array<UserPersonalSpaceRequestsEdge>;
  /** A list of `UserPersonalSpaceRequest` objects. */
  nodes: Array<UserPersonalSpaceRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserPersonalSpaceRequest` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `UserPersonalSpaceRequest` edge in the connection. */
export type UserPersonalSpaceRequestsEdge = {
  __typename: "UserPersonalSpaceRequestsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `UserPersonalSpaceRequest` at the end of the edge. */
  node: UserPersonalSpaceRequest;
};

/** Methods to use when ordering `UserPersonalSpaceRequest`. */
export enum UserPersonalSpaceRequestsOrderBy {
  DateActivatedAsc = "DATE_ACTIVATED_ASC",
  DateActivatedDesc = "DATE_ACTIVATED_DESC",
  DateRequestedAsc = "DATE_REQUESTED_ASC",
  DateRequestedDesc = "DATE_REQUESTED_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  StatusAsc = "STATUS_ASC",
  StatusDesc = "STATUS_DESC",
  SynchronizeHomeAsc = "SYNCHRONIZE_HOME_ASC",
  SynchronizeHomeDesc = "SYNCHRONIZE_HOME_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** The `applicationUser` to be created by this mutation. */
export type UserPersonalSpaceUserId71D37C1EFkApplicatiApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `UserPersonalSpaceRequestInput` mutation. */
export type UserPersonalSpaceUserId71D37C1EFkApplicatiInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `userPersonalSpaceRequest` in the `ApplicationUserInput` mutation. */
export type UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput = {
  /** The primary key(s) for `userPersonalSpaceRequest` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<UserPersonalSpaceRequestUserPersonalSpaceRequestPkeyConnect>
  >;
  /** A `UserPersonalSpaceRequestInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<UserPersonalSpaceUserId71D37C1EFkApplicatiUserPersonalSpaceRequestCreateInput>
  >;
  /** The primary key(s) for `userPersonalSpaceRequest` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<UserPersonalSpaceRequestUserPersonalSpaceRequestPkeyDelete>
  >;
  /** Flag indicating whether all other `userPersonalSpaceRequest` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `userPersonalSpaceRequest` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<UserPersonalSpaceRequestOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingUserPersonalSpaceRequestPkeyUpdate>
  >;
};

/** The `userPersonalSpaceRequest` to be created by this mutation. */
export type UserPersonalSpaceUserId71D37C1EFkApplicatiUserPersonalSpaceRequestCreateInput =
  {
    applicationUserToUserId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInput>;
    dateActivated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateRequested?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    status: Scalars["Int"]["input"];
    synchronizeHome: Scalars["Boolean"]["input"];
  };

export type WaffleFlag = {
  __typename: "WaffleFlag";
  authenticated: Scalars["Boolean"]["output"];
  created: Scalars["Datetime"]["output"];
  everyone: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["Int"]["output"];
  languages: Scalars["String"]["output"];
  modified: Scalars["Datetime"]["output"];
  name: Scalars["String"]["output"];
  note: Scalars["String"]["output"];
  percent: Maybe<Scalars["BigFloat"]["output"]>;
  rollout: Scalars["Boolean"]["output"];
  staff: Scalars["Boolean"]["output"];
  superusers: Scalars["Boolean"]["output"];
  testing: Scalars["Boolean"]["output"];
};

/**
 * A condition to be used against `WaffleFlag` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type WaffleFlagCondition = {
  /** Checks for equality with the object’s `authenticated` field. */
  authenticated?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `everyone` field. */
  everyone?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `languages` field. */
  languages?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `modified` field. */
  modified?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `percent` field. */
  percent?: InputMaybe<Scalars["BigFloat"]["input"]>;
  /** Checks for equality with the object’s `rollout` field. */
  rollout?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `staff` field. */
  staff?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `superusers` field. */
  superusers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `testing` field. */
  testing?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** A filter to be used against `WaffleFlag` object types. All fields are combined with a logical ‘and.’ */
export type WaffleFlagFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WaffleFlagFilter>>;
  /** Filter by the object’s `authenticated` field. */
  authenticated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `everyone` field. */
  everyone?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `languages` field. */
  languages?: InputMaybe<StringFilter>;
  /** Filter by the object’s `modified` field. */
  modified?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WaffleFlagFilter>;
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WaffleFlagFilter>>;
  /** Filter by the object’s `percent` field. */
  percent?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `rollout` field. */
  rollout?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `staff` field. */
  staff?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `superusers` field. */
  superusers?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `testing` field. */
  testing?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `WaffleFlag` */
export type WaffleFlagInput = {
  authenticated: Scalars["Boolean"]["input"];
  created: Scalars["Datetime"]["input"];
  everyone?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  languages: Scalars["String"]["input"];
  modified: Scalars["Datetime"]["input"];
  name: Scalars["String"]["input"];
  note: Scalars["String"]["input"];
  percent?: InputMaybe<Scalars["BigFloat"]["input"]>;
  rollout: Scalars["Boolean"]["input"];
  staff: Scalars["Boolean"]["input"];
  superusers: Scalars["Boolean"]["input"];
  testing: Scalars["Boolean"]["input"];
};

/** Represents an update to a `WaffleFlag`. Fields that are set will be updated. */
export type WaffleFlagPatch = {
  authenticated?: InputMaybe<Scalars["Boolean"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  everyone?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  languages?: InputMaybe<Scalars["String"]["input"]>;
  modified?: InputMaybe<Scalars["Datetime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  percent?: InputMaybe<Scalars["BigFloat"]["input"]>;
  rollout?: InputMaybe<Scalars["Boolean"]["input"]>;
  staff?: InputMaybe<Scalars["Boolean"]["input"]>;
  superusers?: InputMaybe<Scalars["Boolean"]["input"]>;
  testing?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** A connection to a list of `WaffleFlag` values. */
export type WaffleFlagsConnection = {
  __typename: "WaffleFlagsConnection";
  /** A list of edges which contains the `WaffleFlag` and cursor to aid in pagination. */
  edges: Array<WaffleFlagsEdge>;
  /** A list of `WaffleFlag` objects. */
  nodes: Array<WaffleFlag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WaffleFlag` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `WaffleFlag` edge in the connection. */
export type WaffleFlagsEdge = {
  __typename: "WaffleFlagsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `WaffleFlag` at the end of the edge. */
  node: WaffleFlag;
};

/** Methods to use when ordering `WaffleFlag`. */
export enum WaffleFlagsOrderBy {
  AuthenticatedAsc = "AUTHENTICATED_ASC",
  AuthenticatedDesc = "AUTHENTICATED_DESC",
  CreatedAsc = "CREATED_ASC",
  CreatedDesc = "CREATED_DESC",
  EveryoneAsc = "EVERYONE_ASC",
  EveryoneDesc = "EVERYONE_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  LanguagesAsc = "LANGUAGES_ASC",
  LanguagesDesc = "LANGUAGES_DESC",
  ModifiedAsc = "MODIFIED_ASC",
  ModifiedDesc = "MODIFIED_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  NoteAsc = "NOTE_ASC",
  NoteDesc = "NOTE_DESC",
  PercentAsc = "PERCENT_ASC",
  PercentDesc = "PERCENT_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  RolloutAsc = "ROLLOUT_ASC",
  RolloutDesc = "ROLLOUT_DESC",
  StaffAsc = "STAFF_ASC",
  StaffDesc = "STAFF_DESC",
  SuperusersAsc = "SUPERUSERS_ASC",
  SuperusersDesc = "SUPERUSERS_DESC",
  TestingAsc = "TESTING_ASC",
  TestingDesc = "TESTING_DESC",
}

export type WaffleSample = {
  __typename: "WaffleSample";
  created: Scalars["Datetime"]["output"];
  id: Scalars["Int"]["output"];
  modified: Scalars["Datetime"]["output"];
  name: Scalars["String"]["output"];
  note: Scalars["String"]["output"];
  percent: Scalars["BigFloat"]["output"];
};

/**
 * A condition to be used against `WaffleSample` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type WaffleSampleCondition = {
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `modified` field. */
  modified?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `percent` field. */
  percent?: InputMaybe<Scalars["BigFloat"]["input"]>;
};

/** A filter to be used against `WaffleSample` object types. All fields are combined with a logical ‘and.’ */
export type WaffleSampleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WaffleSampleFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modified` field. */
  modified?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WaffleSampleFilter>;
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WaffleSampleFilter>>;
  /** Filter by the object’s `percent` field. */
  percent?: InputMaybe<BigFloatFilter>;
};

/** An input for mutations affecting `WaffleSample` */
export type WaffleSampleInput = {
  created: Scalars["Datetime"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  modified: Scalars["Datetime"]["input"];
  name: Scalars["String"]["input"];
  note: Scalars["String"]["input"];
  percent: Scalars["BigFloat"]["input"];
};

/** Represents an update to a `WaffleSample`. Fields that are set will be updated. */
export type WaffleSamplePatch = {
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  modified?: InputMaybe<Scalars["Datetime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  percent?: InputMaybe<Scalars["BigFloat"]["input"]>;
};

/** A connection to a list of `WaffleSample` values. */
export type WaffleSamplesConnection = {
  __typename: "WaffleSamplesConnection";
  /** A list of edges which contains the `WaffleSample` and cursor to aid in pagination. */
  edges: Array<WaffleSamplesEdge>;
  /** A list of `WaffleSample` objects. */
  nodes: Array<WaffleSample>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WaffleSample` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `WaffleSample` edge in the connection. */
export type WaffleSamplesEdge = {
  __typename: "WaffleSamplesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `WaffleSample` at the end of the edge. */
  node: WaffleSample;
};

/** Methods to use when ordering `WaffleSample`. */
export enum WaffleSamplesOrderBy {
  CreatedAsc = "CREATED_ASC",
  CreatedDesc = "CREATED_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  ModifiedAsc = "MODIFIED_ASC",
  ModifiedDesc = "MODIFIED_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  NoteAsc = "NOTE_ASC",
  NoteDesc = "NOTE_DESC",
  PercentAsc = "PERCENT_ASC",
  PercentDesc = "PERCENT_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type WaffleSwitch = {
  __typename: "WaffleSwitch";
  active: Scalars["Boolean"]["output"];
  created: Scalars["Datetime"]["output"];
  id: Scalars["Int"]["output"];
  modified: Scalars["Datetime"]["output"];
  name: Scalars["String"]["output"];
  note: Scalars["String"]["output"];
};

/**
 * A condition to be used against `WaffleSwitch` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type WaffleSwitchCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `modified` field. */
  modified?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars["String"]["input"]>;
};

/** A filter to be used against `WaffleSwitch` object types. All fields are combined with a logical ‘and.’ */
export type WaffleSwitchFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WaffleSwitchFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `modified` field. */
  modified?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WaffleSwitchFilter>;
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WaffleSwitchFilter>>;
};

/** An input for mutations affecting `WaffleSwitch` */
export type WaffleSwitchInput = {
  active: Scalars["Boolean"]["input"];
  created: Scalars["Datetime"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  modified: Scalars["Datetime"]["input"];
  name: Scalars["String"]["input"];
  note: Scalars["String"]["input"];
};

/** Represents an update to a `WaffleSwitch`. Fields that are set will be updated. */
export type WaffleSwitchPatch = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  modified?: InputMaybe<Scalars["Datetime"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
};

/** A connection to a list of `WaffleSwitch` values. */
export type WaffleSwitchesConnection = {
  __typename: "WaffleSwitchesConnection";
  /** A list of edges which contains the `WaffleSwitch` and cursor to aid in pagination. */
  edges: Array<WaffleSwitchesEdge>;
  /** A list of `WaffleSwitch` objects. */
  nodes: Array<WaffleSwitch>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WaffleSwitch` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `WaffleSwitch` edge in the connection. */
export type WaffleSwitchesEdge = {
  __typename: "WaffleSwitchesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `WaffleSwitch` at the end of the edge. */
  node: WaffleSwitch;
};

/** Methods to use when ordering `WaffleSwitch`. */
export enum WaffleSwitchesOrderBy {
  ActiveAsc = "ACTIVE_ASC",
  ActiveDesc = "ACTIVE_DESC",
  CreatedAsc = "CREATED_ASC",
  CreatedDesc = "CREATED_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  ModifiedAsc = "MODIFIED_ASC",
  ModifiedDesc = "MODIFIED_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  NoteAsc = "NOTE_ASC",
  NoteDesc = "NOTE_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type Workflow = {
  __typename: "Workflow";
  /** Reads a single `ApplicationUser` that is related to this `Workflow`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  containerId: Maybe<Scalars["Int"]["output"]>;
  /** Reads a single `ContainerImage` that is related to this `Workflow`. */
  containerImageByContainerId: Maybe<ContainerImage>;
  dateCreated: Scalars["Datetime"]["output"];
  description: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  /** Reads a single `Tenant` that is related to this `Workflow`. */
  tenantByTenantId: Maybe<Tenant>;
  tenantId: Scalars["Int"]["output"];
  userId: Maybe<Scalars["UUID"]["output"]>;
  /** Reads and enables pagination through a set of `WorkflowVersion`. */
  workflowVersionsByWorkflowId: WorkflowVersionsConnection;
};

export type WorkflowWorkflowVersionsByWorkflowIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowVersionCondition>;
  filter?: InputMaybe<WorkflowVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowVersionsOrderBy>>;
};

/**
 * A condition to be used against `Workflow` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type WorkflowCondition = {
  /** Checks for equality with the object’s `containerId` field. */
  containerId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The `containerImage` to be created by this mutation. */
export type WorkflowContainerIdE73A96E5FkContainerImageIdContainerImageCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
    containerImageRepositoryId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    label: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    readme?: InputMaybe<Scalars["String"]["input"]>;
    size: Scalars["BigInt"]["input"];
    spec?: InputMaybe<Scalars["JSON"]["input"]>;
    status: Scalars["Int"]["input"];
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
    tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
  };

/** Input for the nested mutation of `containerImage` in the `WorkflowInput` mutation. */
export type WorkflowContainerIdE73A96E5FkContainerImageIdInput = {
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  connectByExecutorId?: InputMaybe<ContainerImageContainerImageExecutorIdKeyConnect>;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  connectById?: InputMaybe<ContainerImageContainerImagePkeyConnect>;
  /** A `ContainerImageInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdContainerImageCreateInput>;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  deleteByExecutorId?: InputMaybe<ContainerImageContainerImageExecutorIdKeyDelete>;
  /** The primary key(s) for `containerImage` for the far side of the relationship. */
  deleteById?: InputMaybe<ContainerImageContainerImagePkeyDelete>;
  /** The primary key(s) and patch data for `containerImage` for the far side of the relationship. */
  updateByExecutorId?: InputMaybe<ContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate>;
  /** The primary key(s) and patch data for `containerImage` for the far side of the relationship. */
  updateById?: InputMaybe<ContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingContainerImagePkeyUpdate>;
};

/** Input for the nested mutation of `workflow` in the `ContainerImageInput` mutation. */
export type WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput = {
  /** The primary key(s) for `workflow` for the far side of the relationship. */
  connectById?: InputMaybe<Array<WorkflowWorkflowPkeyConnect>>;
  /** A `WorkflowInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<WorkflowContainerIdE73A96E5FkContainerImageIdWorkflowCreateInput>
  >;
  /** The primary key(s) for `workflow` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<WorkflowWorkflowPkeyDelete>>;
  /** Flag indicating whether all other `workflow` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `workflow` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<WorkflowOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingWorkflowPkeyUpdate>
  >;
};

/** The `workflow` to be created by this mutation. */
export type WorkflowContainerIdE73A96E5FkContainerImageIdWorkflowCreateInput = {
  applicationUserToUserId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInput>;
  containerImageToContainerId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  name: Scalars["String"]["input"];
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowVersionsUsingId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInverseInput>;
};

/** A connection to a list of `WorkflowDatum` values. */
export type WorkflowDataConnection = {
  __typename: "WorkflowDataConnection";
  /** A list of edges which contains the `WorkflowDatum` and cursor to aid in pagination. */
  edges: Array<WorkflowDataEdge>;
  /** A list of `WorkflowDatum` objects. */
  nodes: Array<WorkflowDatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorkflowDatum` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `WorkflowDatum` edge in the connection. */
export type WorkflowDataEdge = {
  __typename: "WorkflowDataEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `WorkflowDatum` at the end of the edge. */
  node: WorkflowDatum;
};

/** Methods to use when ordering `WorkflowDatum`. */
export enum WorkflowDataOrderBy {
  FreshAsc = "FRESH_ASC",
  FreshDesc = "FRESH_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type WorkflowDatum = {
  __typename: "WorkflowDatum";
  fresh: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  /** Reads and enables pagination through a set of `WorkflowResult`. */
  workflowResultsByObjectId: WorkflowResultsConnection;
  /** Reads and enables pagination through a set of `WorkflowSectionBlock`. */
  workflowSectionBlocksByObjectId: WorkflowSectionBlocksConnection;
};

export type WorkflowDatumWorkflowResultsByObjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowResultCondition>;
  filter?: InputMaybe<WorkflowResultFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowResultsOrderBy>>;
};

export type WorkflowDatumWorkflowSectionBlocksByObjectIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSectionBlockCondition>;
  filter?: InputMaybe<WorkflowSectionBlockFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSectionBlocksOrderBy>>;
};

/**
 * A condition to be used against `WorkflowDatum` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type WorkflowDatumCondition = {
  /** Checks for equality with the object’s `fresh` field. */
  fresh?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `WorkflowDatum` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowDatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkflowDatumFilter>>;
  /** Filter by the object’s `fresh` field. */
  fresh?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkflowDatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkflowDatumFilter>>;
  /** Filter by the object’s `workflowResultsByObjectId` relation. */
  workflowResultsByObjectId?: InputMaybe<WorkflowDatumToManyWorkflowResultFilter>;
  /** Some related `workflowResultsByObjectId` exist. */
  workflowResultsByObjectIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `workflowSectionBlocksByObjectId` relation. */
  workflowSectionBlocksByObjectId?: InputMaybe<WorkflowDatumToManyWorkflowSectionBlockFilter>;
  /** Some related `workflowSectionBlocksByObjectId` exist. */
  workflowSectionBlocksByObjectIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

/** An input for mutations affecting `WorkflowDatum` */
export type WorkflowDatumInput = {
  fresh: Scalars["Boolean"]["input"];
  id: Scalars["UUID"]["input"];
  workflowResultsUsingId?: InputMaybe<WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInverseInput>;
  workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInverseInput>;
};

/** The fields on `workflowDatum` to look up the row to update. */
export type WorkflowDatumOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdUsingWorkflowDataPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowDatum` being updated. */
    workflowDatumPatch: UpdateWorkflowDatumOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdPatch;
  };

/** The fields on `workflowDatum` to look up the row to update. */
export type WorkflowDatumOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdUsingWorkflowDataPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowDatum` being updated. */
    workflowDatumPatch: UpdateWorkflowDatumOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdPatch;
  };

/** Represents an update to a `WorkflowDatum`. Fields that are set will be updated. */
export type WorkflowDatumPatch = {
  fresh?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowResultsUsingId?: InputMaybe<WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInverseInput>;
  workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInverseInput>;
};

/** A filter to be used against many `WorkflowResult` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowDatumToManyWorkflowResultFilter = {
  /** Every related `WorkflowResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkflowResultFilter>;
  /** No related `WorkflowResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkflowResultFilter>;
  /** Some related `WorkflowResult` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkflowResultFilter>;
};

/** A filter to be used against many `WorkflowSectionBlock` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowDatumToManyWorkflowSectionBlockFilter = {
  /** Every related `WorkflowSectionBlock` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkflowSectionBlockFilter>;
  /** No related `WorkflowSectionBlock` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkflowSectionBlockFilter>;
  /** Some related `WorkflowSectionBlock` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkflowSectionBlockFilter>;
};

/** The fields on `workflowDatum` to look up the row to connect. */
export type WorkflowDatumWorkflowDataPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `workflowDatum` to look up the row to delete. */
export type WorkflowDatumWorkflowDataPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** A filter to be used against `Workflow` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkflowFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `containerId` field. */
  containerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `containerImageByContainerId` relation. */
  containerImageByContainerId?: InputMaybe<ContainerImageFilter>;
  /** A related `containerImageByContainerId` exists. */
  containerImageByContainerIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkflowFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkflowFilter>>;
  /** Filter by the object’s `tenantByTenantId` relation. */
  tenantByTenantId?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `workflowVersionsByWorkflowId` relation. */
  workflowVersionsByWorkflowId?: InputMaybe<WorkflowToManyWorkflowVersionFilter>;
  /** Some related `workflowVersionsByWorkflowId` exist. */
  workflowVersionsByWorkflowIdExist?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** An input for mutations affecting `Workflow` */
export type WorkflowInput = {
  applicationUserToUserId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInput>;
  containerId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  name: Scalars["String"]["input"];
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowVersionsUsingId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInverseInput>;
};

/** The fields on `workflow` to look up the row to update. */
export type WorkflowOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingWorkflowPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflow` being updated. */
    workflowPatch: UpdateWorkflowOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdPatch;
  };

/** The fields on `workflow` to look up the row to update. */
export type WorkflowOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingWorkflowPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflow` being updated. */
    workflowPatch: UpdateWorkflowOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdPatch;
  };

/** The fields on `workflow` to look up the row to update. */
export type WorkflowOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingWorkflowPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflow` being updated. */
    workflowPatch: UpdateWorkflowOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdPatch;
  };

/** The fields on `workflow` to look up the row to update. */
export type WorkflowOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdUsingWorkflowPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflow` being updated. */
    workflowPatch: UpdateWorkflowOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdPatch;
  };

/** Represents an update to a `Workflow`. Fields that are set will be updated. */
export type WorkflowPatch = {
  applicationUserToUserId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInput>;
  containerId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowVersionsUsingId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInverseInput>;
};

export type WorkflowResult = {
  __typename: "WorkflowResult";
  id: Scalars["UUID"]["output"];
  objectId: Scalars["UUID"]["output"];
  /** Reads a single `WorkflowDatum` that is related to this `WorkflowResult`. */
  workflowDatumByObjectId: Maybe<WorkflowDatum>;
  /** Reads and enables pagination through a set of `WorkflowResultWorkflowVersion`. */
  workflowResultWorkflowVersionsByResultId: WorkflowResultWorkflowVersionsConnection;
};

export type WorkflowResultWorkflowResultWorkflowVersionsByResultIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowResultWorkflowVersionCondition>;
  filter?: InputMaybe<WorkflowResultWorkflowVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowResultWorkflowVersionsOrderBy>>;
};

/**
 * A condition to be used against `WorkflowResult` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type WorkflowResultCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `objectId` field. */
  objectId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `WorkflowResult` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowResultFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkflowResultFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkflowResultFilter>;
  /** Filter by the object’s `objectId` field. */
  objectId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkflowResultFilter>>;
  /** Filter by the object’s `workflowDatumByObjectId` relation. */
  workflowDatumByObjectId?: InputMaybe<WorkflowDatumFilter>;
  /** Filter by the object’s `workflowResultWorkflowVersionsByResultId` relation. */
  workflowResultWorkflowVersionsByResultId?: InputMaybe<WorkflowResultToManyWorkflowResultWorkflowVersionFilter>;
  /** Some related `workflowResultWorkflowVersionsByResultId` exist. */
  workflowResultWorkflowVersionsByResultIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

/** An input for mutations affecting `WorkflowResult` */
export type WorkflowResultInput = {
  id: Scalars["UUID"]["input"];
  objectId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowDatumToObjectId?: InputMaybe<WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInput>;
  workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkResultId50F959E2FkWorkflowInverseInput>;
};

/** Input for the nested mutation of `workflowDatum` in the `WorkflowResultInput` mutation. */
export type WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInput = {
  /** The primary key(s) for `workflowDatum` for the far side of the relationship. */
  connectById?: InputMaybe<WorkflowDatumWorkflowDataPkeyConnect>;
  /** A `WorkflowDatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkflowResultObjectIdC561D1C5FkWorkflowDataIdWorkflowDataCreateInput>;
  /** The primary key(s) for `workflowDatum` for the far side of the relationship. */
  deleteById?: InputMaybe<WorkflowDatumWorkflowDataPkeyDelete>;
  /** The primary key(s) and patch data for `workflowDatum` for the far side of the relationship. */
  updateById?: InputMaybe<WorkflowDatumOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdUsingWorkflowDataPkeyUpdate>;
};

/** Input for the nested mutation of `workflowResult` in the `WorkflowDatumInput` mutation. */
export type WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInverseInput = {
  /** The primary key(s) for `workflowResult` for the far side of the relationship. */
  connectById?: InputMaybe<Array<WorkflowResultWorkflowResultPkeyConnect>>;
  /** A `WorkflowResultInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<WorkflowResultObjectIdC561D1C5FkWorkflowDataIdWorkflowResultCreateInput>
  >;
  /** The primary key(s) for `workflowResult` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<WorkflowResultWorkflowResultPkeyDelete>>;
  /** Flag indicating whether all other `workflowResult` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `workflowResult` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<WorkflowResultOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdUsingWorkflowResultPkeyUpdate>
  >;
};

/** The `workflowDatum` to be created by this mutation. */
export type WorkflowResultObjectIdC561D1C5FkWorkflowDataIdWorkflowDataCreateInput =
  {
    fresh: Scalars["Boolean"]["input"];
    id: Scalars["UUID"]["input"];
    workflowResultsUsingId?: InputMaybe<WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInverseInput>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInverseInput>;
  };

/** The `workflowResult` to be created by this mutation. */
export type WorkflowResultObjectIdC561D1C5FkWorkflowDataIdWorkflowResultCreateInput =
  {
    id: Scalars["UUID"]["input"];
    workflowDatumToObjectId?: InputMaybe<WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInput>;
    workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkResultId50F959E2FkWorkflowInverseInput>;
  };

/** The fields on `workflowResult` to look up the row to update. */
export type WorkflowResultOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdUsingWorkflowResultPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowResult` being updated. */
    workflowResultPatch: UpdateWorkflowResultOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdPatch;
  };

/** The fields on `workflowResult` to look up the row to update. */
export type WorkflowResultOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowResult` being updated. */
    workflowResultPatch: UpdateWorkflowResultOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowPatch;
  };

/** Represents an update to a `WorkflowResult`. Fields that are set will be updated. */
export type WorkflowResultPatch = {
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  objectId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowDatumToObjectId?: InputMaybe<WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInput>;
  workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkResultId50F959E2FkWorkflowInverseInput>;
};

/** A filter to be used against many `WorkflowResultWorkflowVersion` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowResultToManyWorkflowResultWorkflowVersionFilter = {
  /** Every related `WorkflowResultWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkflowResultWorkflowVersionFilter>;
  /** No related `WorkflowResultWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkflowResultWorkflowVersionFilter>;
  /** Some related `WorkflowResultWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkflowResultWorkflowVersionFilter>;
};

/** Input for the nested mutation of `workflowResult` in the `WorkflowResultWorkflowVersionInput` mutation. */
export type WorkflowResultWorkResultId50F959E2FkWorkflowInput = {
  /** The primary key(s) for `workflowResult` for the far side of the relationship. */
  connectById?: InputMaybe<WorkflowResultWorkflowResultPkeyConnect>;
  /** A `WorkflowResultInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkflowResultWorkResultId50F959E2FkWorkflowWorkflowResultCreateInput>;
  /** The primary key(s) for `workflowResult` for the far side of the relationship. */
  deleteById?: InputMaybe<WorkflowResultWorkflowResultPkeyDelete>;
  /** The primary key(s) and patch data for `workflowResult` for the far side of the relationship. */
  updateById?: InputMaybe<WorkflowResultOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultPkeyUpdate>;
};

/** Input for the nested mutation of `workflowResultWorkflowVersion` in the `WorkflowResultInput` mutation. */
export type WorkflowResultWorkResultId50F959E2FkWorkflowInverseInput = {
  /** The primary key(s) for `workflowResultWorkflowVersion` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<WorkflowResultWorkflowVersionWorkflowResultWorkflowVersionsPkeyConnect>
  >;
  /** The primary key(s) for `workflowResultWorkflowVersion` for the far side of the relationship. */
  connectByResultIdAndWorkflowversionId?: InputMaybe<
    Array<WorkflowResultWorkflowVersionWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqConnect>
  >;
  /** A `WorkflowResultWorkflowVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<WorkflowResultWorkResultId50F959E2FkWorkflowWorkflowResultWorkflowVersionsCreateInput>
  >;
  /** The primary key(s) for `workflowResultWorkflowVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<WorkflowResultWorkflowVersionWorkflowResultWorkflowVersionsPkeyDelete>
  >;
  /** The primary key(s) for `workflowResultWorkflowVersion` for the far side of the relationship. */
  deleteByResultIdAndWorkflowversionId?: InputMaybe<
    Array<WorkflowResultWorkflowVersionWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqDelete>
  >;
  /** Flag indicating whether all other `workflowResultWorkflowVersion` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `workflowResultWorkflowVersion` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultWorkflowVersionsPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `workflowResultWorkflowVersion` for the far side of the relationship. */
  updateByResultIdAndWorkflowversionId?: InputMaybe<
    Array<WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqUpdate>
  >;
};

/** The `workflowResult` to be created by this mutation. */
export type WorkflowResultWorkResultId50F959E2FkWorkflowWorkflowResultCreateInput =
  {
    id: Scalars["UUID"]["input"];
    objectId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowDatumToObjectId?: InputMaybe<WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInput>;
    workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkResultId50F959E2FkWorkflowInverseInput>;
  };

/** The `workflowResultWorkflowVersion` to be created by this mutation. */
export type WorkflowResultWorkResultId50F959E2FkWorkflowWorkflowResultWorkflowVersionsCreateInput =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    workflowResultToResultId?: InputMaybe<WorkflowResultWorkResultId50F959E2FkWorkflowInput>;
    workflowVersionToWorkflowversionId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInput>;
    workflowversionId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** Input for the nested mutation of `workflowVersion` in the `WorkflowResultWorkflowVersionInput` mutation. */
export type WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInput = {
  /** The primary key(s) for `workflowVersion` for the far side of the relationship. */
  connectById?: InputMaybe<WorkflowVersionWorkflowVersionPkeyConnect>;
  /** A `WorkflowVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowWorkflowVersionCreateInput>;
  /** The primary key(s) for `workflowVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<WorkflowVersionWorkflowVersionPkeyDelete>;
  /** The primary key(s) and patch data for `workflowVersion` for the far side of the relationship. */
  updateById?: InputMaybe<WorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowVersionPkeyUpdate>;
};

/** Input for the nested mutation of `workflowResultWorkflowVersion` in the `WorkflowVersionInput` mutation. */
export type WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInverseInput =
  {
    /** The primary key(s) for `workflowResultWorkflowVersion` for the far side of the relationship. */
    connectById?: InputMaybe<
      Array<WorkflowResultWorkflowVersionWorkflowResultWorkflowVersionsPkeyConnect>
    >;
    /** The primary key(s) for `workflowResultWorkflowVersion` for the far side of the relationship. */
    connectByResultIdAndWorkflowversionId?: InputMaybe<
      Array<WorkflowResultWorkflowVersionWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqConnect>
    >;
    /** A `WorkflowResultWorkflowVersionInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowWorkflowResultWorkflowVersionsCreateInput>
    >;
    /** The primary key(s) for `workflowResultWorkflowVersion` for the far side of the relationship. */
    deleteById?: InputMaybe<
      Array<WorkflowResultWorkflowVersionWorkflowResultWorkflowVersionsPkeyDelete>
    >;
    /** The primary key(s) for `workflowResultWorkflowVersion` for the far side of the relationship. */
    deleteByResultIdAndWorkflowversionId?: InputMaybe<
      Array<WorkflowResultWorkflowVersionWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqDelete>
    >;
    /** Flag indicating whether all other `workflowResultWorkflowVersion` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The primary key(s) and patch data for `workflowResultWorkflowVersion` for the far side of the relationship. */
    updateById?: InputMaybe<
      Array<WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowResultWorkflowVersionsPkeyUpdate>
    >;
    /** The primary key(s) and patch data for `workflowResultWorkflowVersion` for the far side of the relationship. */
    updateByResultIdAndWorkflowversionId?: InputMaybe<
      Array<WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqUpdate>
    >;
  };

/** The `workflowResultWorkflowVersion` to be created by this mutation. */
export type WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowWorkflowResultWorkflowVersionsCreateInput =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    resultId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowResultToResultId?: InputMaybe<WorkflowResultWorkResultId50F959E2FkWorkflowInput>;
    workflowVersionToWorkflowversionId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInput>;
  };

/** The `workflowVersion` to be created by this mutation. */
export type WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowWorkflowVersionCreateInput =
  {
    applicationUserToUserId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInput>;
    autoGenerated: Scalars["Boolean"]["input"];
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    draft: Scalars["Boolean"]["input"];
    id: Scalars["UUID"]["input"];
    name: Scalars["String"]["input"];
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInverseInput>;
    workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInverseInput>;
    workflowSourceWorkflowVersionsUsingId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInverseInput>;
    workflowToWorkflowId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInput>;
  };

/** The fields on `workflowResult` to look up the row to connect. */
export type WorkflowResultWorkflowResultPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `workflowResult` to look up the row to delete. */
export type WorkflowResultWorkflowResultPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

export type WorkflowResultWorkflowVersion = {
  __typename: "WorkflowResultWorkflowVersion";
  id: Scalars["BigInt"]["output"];
  resultId: Scalars["UUID"]["output"];
  /** Reads a single `WorkflowResult` that is related to this `WorkflowResultWorkflowVersion`. */
  workflowResultByResultId: Maybe<WorkflowResult>;
  /** Reads a single `WorkflowVersion` that is related to this `WorkflowResultWorkflowVersion`. */
  workflowVersionByWorkflowversionId: Maybe<WorkflowVersion>;
  workflowversionId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `WorkflowResultWorkflowVersion` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type WorkflowResultWorkflowVersionCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `resultId` field. */
  resultId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `workflowversionId` field. */
  workflowversionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `WorkflowResultWorkflowVersion` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowResultWorkflowVersionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkflowResultWorkflowVersionFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkflowResultWorkflowVersionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkflowResultWorkflowVersionFilter>>;
  /** Filter by the object’s `resultId` field. */
  resultId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `workflowResultByResultId` relation. */
  workflowResultByResultId?: InputMaybe<WorkflowResultFilter>;
  /** Filter by the object’s `workflowVersionByWorkflowversionId` relation. */
  workflowVersionByWorkflowversionId?: InputMaybe<WorkflowVersionFilter>;
  /** Filter by the object’s `workflowversionId` field. */
  workflowversionId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `WorkflowResultWorkflowVersion` */
export type WorkflowResultWorkflowVersionInput = {
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  resultId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowResultToResultId?: InputMaybe<WorkflowResultWorkResultId50F959E2FkWorkflowInput>;
  workflowVersionToWorkflowversionId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInput>;
  workflowversionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `workflowResultWorkflowVersion` to look up the row to update. */
export type WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqUpdate =
  {
    resultId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowResultWorkflowVersion` being updated. */
    workflowResultWorkflowVersionPatch: UpdateWorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowPatch;
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The fields on `workflowResultWorkflowVersion` to look up the row to update. */
export type WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultWorkflowVersionsPkeyUpdate =
  {
    id: Scalars["BigInt"]["input"];
    /** An object where the defined keys will be set on the `workflowResultWorkflowVersion` being updated. */
    workflowResultWorkflowVersionPatch: UpdateWorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowPatch;
  };

/** The fields on `workflowResultWorkflowVersion` to look up the row to update. */
export type WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqUpdate =
  {
    resultId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowResultWorkflowVersion` being updated. */
    workflowResultWorkflowVersionPatch: UpdateWorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowPatch;
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The fields on `workflowResultWorkflowVersion` to look up the row to update. */
export type WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowResultWorkflowVersionsPkeyUpdate =
  {
    id: Scalars["BigInt"]["input"];
    /** An object where the defined keys will be set on the `workflowResultWorkflowVersion` being updated. */
    workflowResultWorkflowVersionPatch: UpdateWorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowPatch;
  };

/** Represents an update to a `WorkflowResultWorkflowVersion`. Fields that are set will be updated. */
export type WorkflowResultWorkflowVersionPatch = {
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  resultId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowResultToResultId?: InputMaybe<WorkflowResultWorkResultId50F959E2FkWorkflowInput>;
  workflowVersionToWorkflowversionId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInput>;
  workflowversionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `workflowResultWorkflowVersion` to look up the row to connect. */
export type WorkflowResultWorkflowVersionWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqConnect =
  {
    resultId: Scalars["UUID"]["input"];
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The fields on `workflowResultWorkflowVersion` to look up the row to delete. */
export type WorkflowResultWorkflowVersionWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqDelete =
  {
    resultId: Scalars["UUID"]["input"];
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The fields on `workflowResultWorkflowVersion` to look up the row to connect. */
export type WorkflowResultWorkflowVersionWorkflowResultWorkflowVersionsPkeyConnect =
  {
    id: Scalars["BigInt"]["input"];
  };

/** The fields on `workflowResultWorkflowVersion` to look up the row to delete. */
export type WorkflowResultWorkflowVersionWorkflowResultWorkflowVersionsPkeyDelete =
  {
    id: Scalars["BigInt"]["input"];
  };

/** A connection to a list of `WorkflowResultWorkflowVersion` values. */
export type WorkflowResultWorkflowVersionsConnection = {
  __typename: "WorkflowResultWorkflowVersionsConnection";
  /** A list of edges which contains the `WorkflowResultWorkflowVersion` and cursor to aid in pagination. */
  edges: Array<WorkflowResultWorkflowVersionsEdge>;
  /** A list of `WorkflowResultWorkflowVersion` objects. */
  nodes: Array<WorkflowResultWorkflowVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorkflowResultWorkflowVersion` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `WorkflowResultWorkflowVersion` edge in the connection. */
export type WorkflowResultWorkflowVersionsEdge = {
  __typename: "WorkflowResultWorkflowVersionsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `WorkflowResultWorkflowVersion` at the end of the edge. */
  node: WorkflowResultWorkflowVersion;
};

/** Methods to use when ordering `WorkflowResultWorkflowVersion`. */
export enum WorkflowResultWorkflowVersionsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ResultIdAsc = "RESULT_ID_ASC",
  ResultIdDesc = "RESULT_ID_DESC",
  WorkflowversionIdAsc = "WORKFLOWVERSION_ID_ASC",
  WorkflowversionIdDesc = "WORKFLOWVERSION_ID_DESC",
}

/** A connection to a list of `WorkflowResult` values. */
export type WorkflowResultsConnection = {
  __typename: "WorkflowResultsConnection";
  /** A list of edges which contains the `WorkflowResult` and cursor to aid in pagination. */
  edges: Array<WorkflowResultsEdge>;
  /** A list of `WorkflowResult` objects. */
  nodes: Array<WorkflowResult>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorkflowResult` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `WorkflowResult` edge in the connection. */
export type WorkflowResultsEdge = {
  __typename: "WorkflowResultsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `WorkflowResult` at the end of the edge. */
  node: WorkflowResult;
};

/** Methods to use when ordering `WorkflowResult`. */
export enum WorkflowResultsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  ObjectIdAsc = "OBJECT_ID_ASC",
  ObjectIdDesc = "OBJECT_ID_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

export type WorkflowSection = {
  __typename: "WorkflowSection";
  description: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  order: Scalars["Int"]["output"];
  title: Maybe<Scalars["String"]["output"]>;
  /** Reads and enables pagination through a set of `WorkflowSectionBlockSection`. */
  workflowSectionBlockSectionsBySectionId: WorkflowSectionBlockSectionsConnection;
  /** Reads and enables pagination through a set of `WorkflowSectionWorkflowVersion`. */
  workflowSectionWorkflowVersionsBySectionId: WorkflowSectionWorkflowVersionsConnection;
};

export type WorkflowSectionWorkflowSectionBlockSectionsBySectionIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSectionBlockSectionCondition>;
  filter?: InputMaybe<WorkflowSectionBlockSectionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSectionBlockSectionsOrderBy>>;
};

export type WorkflowSectionWorkflowSectionWorkflowVersionsBySectionIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSectionWorkflowVersionCondition>;
  filter?: InputMaybe<WorkflowSectionWorkflowVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSectionWorkflowVersionsOrderBy>>;
};

/** Input for the nested mutation of `workflowSectionBlock` in the `WorkflowSectionBlockSectionInput` mutation. */
export type WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInput = {
  /** The primary key(s) for `workflowSectionBlock` for the far side of the relationship. */
  connectById?: InputMaybe<WorkflowSectionBlockWorkflowSectionBlockPkeyConnect>;
  /** A `WorkflowSectionBlockInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowWorkflowSectionBlockCreateInput>;
  /** The primary key(s) for `workflowSectionBlock` for the far side of the relationship. */
  deleteById?: InputMaybe<WorkflowSectionBlockWorkflowSectionBlockPkeyDelete>;
  /** The primary key(s) and patch data for `workflowSectionBlock` for the far side of the relationship. */
  updateById?: InputMaybe<WorkflowSectionBlockOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockPkeyUpdate>;
};

/** Input for the nested mutation of `workflowSectionBlockSection` in the `WorkflowSectionBlockInput` mutation. */
export type WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInverseInput = {
  /** The primary key(s) for `workflowSectionBlockSection` for the far side of the relationship. */
  connectByBlockIdAndSectionId?: InputMaybe<
    Array<WorkflowSectionBlockSectionWorkflowSectionBlockSBlockIdSectionId2F785D93UniqConnect>
  >;
  /** The primary key(s) for `workflowSectionBlockSection` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<WorkflowSectionBlockSectionWorkflowSectionBlockSectionsPkeyConnect>
  >;
  /** A `WorkflowSectionBlockSectionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowWorkflowSectionBlockSectionsCreateInput>
  >;
  /** The primary key(s) for `workflowSectionBlockSection` for the far side of the relationship. */
  deleteByBlockIdAndSectionId?: InputMaybe<
    Array<WorkflowSectionBlockSectionWorkflowSectionBlockSBlockIdSectionId2F785D93UniqDelete>
  >;
  /** The primary key(s) for `workflowSectionBlockSection` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<WorkflowSectionBlockSectionWorkflowSectionBlockSectionsPkeyDelete>
  >;
  /** Flag indicating whether all other `workflowSectionBlockSection` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `workflowSectionBlockSection` for the far side of the relationship. */
  updateByBlockIdAndSectionId?: InputMaybe<
    Array<WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockSBlockIdSectionId2F785D93UniqUpdate>
  >;
  /** The primary key(s) and patch data for `workflowSectionBlockSection` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockSectionsPkeyUpdate>
  >;
};

/** The `workflowSectionBlock` to be created by this mutation. */
export type WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowWorkflowSectionBlockCreateInput =
  {
    columns: Scalars["Int"]["input"];
    id: Scalars["UUID"]["input"];
    markdown?: InputMaybe<Scalars["String"]["input"]>;
    objectId?: InputMaybe<Scalars["UUID"]["input"]>;
    order: Scalars["Int"]["input"];
    parameters?: InputMaybe<Scalars["JSON"]["input"]>;
    results?: InputMaybe<Scalars["JSON"]["input"]>;
    sources?: InputMaybe<Scalars["JSON"]["input"]>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInput>;
    workflowDatumToObjectId?: InputMaybe<WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInput>;
    workflowSectionBlockSectionsUsingId?: InputMaybe<WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInverseInput>;
  };

/** The `workflowSectionBlockSection` to be created by this mutation. */
export type WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowWorkflowSectionBlockSectionsCreateInput =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    sectionId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowSectionBlockToBlockId?: InputMaybe<WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInput>;
    workflowSectionToSectionId?: InputMaybe<WorkflowSectionBloSectionId817C1C77FkWorkflowInput>;
  };

/** Input for the nested mutation of `workflowSection` in the `WorkflowSectionBlockSectionInput` mutation. */
export type WorkflowSectionBloSectionId817C1C77FkWorkflowInput = {
  /** The primary key(s) for `workflowSection` for the far side of the relationship. */
  connectById?: InputMaybe<WorkflowSectionWorkflowSectionPkeyConnect>;
  /** A `WorkflowSectionInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkflowSectionBloSectionId817C1C77FkWorkflowWorkflowSectionCreateInput>;
  /** The primary key(s) for `workflowSection` for the far side of the relationship. */
  deleteById?: InputMaybe<WorkflowSectionWorkflowSectionPkeyDelete>;
  /** The primary key(s) and patch data for `workflowSection` for the far side of the relationship. */
  updateById?: InputMaybe<WorkflowSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionPkeyUpdate>;
};

/** Input for the nested mutation of `workflowSectionBlockSection` in the `WorkflowSectionInput` mutation. */
export type WorkflowSectionBloSectionId817C1C77FkWorkflowInverseInput = {
  /** The primary key(s) for `workflowSectionBlockSection` for the far side of the relationship. */
  connectByBlockIdAndSectionId?: InputMaybe<
    Array<WorkflowSectionBlockSectionWorkflowSectionBlockSBlockIdSectionId2F785D93UniqConnect>
  >;
  /** The primary key(s) for `workflowSectionBlockSection` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<WorkflowSectionBlockSectionWorkflowSectionBlockSectionsPkeyConnect>
  >;
  /** A `WorkflowSectionBlockSectionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<WorkflowSectionBloSectionId817C1C77FkWorkflowWorkflowSectionBlockSectionsCreateInput>
  >;
  /** The primary key(s) for `workflowSectionBlockSection` for the far side of the relationship. */
  deleteByBlockIdAndSectionId?: InputMaybe<
    Array<WorkflowSectionBlockSectionWorkflowSectionBlockSBlockIdSectionId2F785D93UniqDelete>
  >;
  /** The primary key(s) for `workflowSectionBlockSection` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<WorkflowSectionBlockSectionWorkflowSectionBlockSectionsPkeyDelete>
  >;
  /** Flag indicating whether all other `workflowSectionBlockSection` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `workflowSectionBlockSection` for the far side of the relationship. */
  updateByBlockIdAndSectionId?: InputMaybe<
    Array<WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionBlockSBlockIdSectionId2F785D93UniqUpdate>
  >;
  /** The primary key(s) and patch data for `workflowSectionBlockSection` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionBlockSectionsPkeyUpdate>
  >;
};

/** The `workflowSectionBlockSection` to be created by this mutation. */
export type WorkflowSectionBloSectionId817C1C77FkWorkflowWorkflowSectionBlockSectionsCreateInput =
  {
    blockId?: InputMaybe<Scalars["UUID"]["input"]>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    workflowSectionBlockToBlockId?: InputMaybe<WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInput>;
    workflowSectionToSectionId?: InputMaybe<WorkflowSectionBloSectionId817C1C77FkWorkflowInput>;
  };

/** The `workflowSection` to be created by this mutation. */
export type WorkflowSectionBloSectionId817C1C77FkWorkflowWorkflowSectionCreateInput =
  {
    description?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    order: Scalars["Int"]["input"];
    title?: InputMaybe<Scalars["String"]["input"]>;
    workflowSectionBlockSectionsUsingId?: InputMaybe<WorkflowSectionBloSectionId817C1C77FkWorkflowInverseInput>;
    workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorSectionId1D5C2D63FkWorkflowInverseInput>;
  };

export type WorkflowSectionBlock = {
  __typename: "WorkflowSectionBlock";
  columns: Scalars["Int"]["output"];
  id: Scalars["UUID"]["output"];
  markdown: Maybe<Scalars["String"]["output"]>;
  objectId: Maybe<Scalars["UUID"]["output"]>;
  order: Scalars["Int"]["output"];
  parameters: Maybe<Scalars["JSON"]["output"]>;
  results: Maybe<Scalars["JSON"]["output"]>;
  sources: Maybe<Scalars["JSON"]["output"]>;
  toolId: Maybe<Scalars["Int"]["output"]>;
  /** Reads a single `ToolVersion` that is related to this `WorkflowSectionBlock`. */
  toolVersionByToolId: Maybe<ToolVersion>;
  /** Reads a single `WorkflowDatum` that is related to this `WorkflowSectionBlock`. */
  workflowDatumByObjectId: Maybe<WorkflowDatum>;
  /** Reads and enables pagination through a set of `WorkflowSectionBlockSection`. */
  workflowSectionBlockSectionsByBlockId: WorkflowSectionBlockSectionsConnection;
};

export type WorkflowSectionBlockWorkflowSectionBlockSectionsByBlockIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSectionBlockSectionCondition>;
  filter?: InputMaybe<WorkflowSectionBlockSectionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSectionBlockSectionsOrderBy>>;
};

/**
 * A condition to be used against `WorkflowSectionBlock` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type WorkflowSectionBlockCondition = {
  /** Checks for equality with the object’s `columns` field. */
  columns?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `markdown` field. */
  markdown?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `objectId` field. */
  objectId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `parameters` field. */
  parameters?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `results` field. */
  results?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `sources` field. */
  sources?: InputMaybe<Scalars["JSON"]["input"]>;
  /** Checks for equality with the object’s `toolId` field. */
  toolId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A filter to be used against `WorkflowSectionBlock` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowSectionBlockFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkflowSectionBlockFilter>>;
  /** Filter by the object’s `columns` field. */
  columns?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `markdown` field. */
  markdown?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkflowSectionBlockFilter>;
  /** Filter by the object’s `objectId` field. */
  objectId?: InputMaybe<UuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkflowSectionBlockFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `parameters` field. */
  parameters?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `results` field. */
  results?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `sources` field. */
  sources?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `toolId` field. */
  toolId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `toolVersionByToolId` relation. */
  toolVersionByToolId?: InputMaybe<ToolVersionFilter>;
  /** A related `toolVersionByToolId` exists. */
  toolVersionByToolIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `workflowDatumByObjectId` relation. */
  workflowDatumByObjectId?: InputMaybe<WorkflowDatumFilter>;
  /** A related `workflowDatumByObjectId` exists. */
  workflowDatumByObjectIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `workflowSectionBlockSectionsByBlockId` relation. */
  workflowSectionBlockSectionsByBlockId?: InputMaybe<WorkflowSectionBlockToManyWorkflowSectionBlockSectionFilter>;
  /** Some related `workflowSectionBlockSectionsByBlockId` exist. */
  workflowSectionBlockSectionsByBlockIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

/** An input for mutations affecting `WorkflowSectionBlock` */
export type WorkflowSectionBlockInput = {
  columns: Scalars["Int"]["input"];
  id: Scalars["UUID"]["input"];
  markdown?: InputMaybe<Scalars["String"]["input"]>;
  objectId?: InputMaybe<Scalars["UUID"]["input"]>;
  order: Scalars["Int"]["input"];
  parameters?: InputMaybe<Scalars["JSON"]["input"]>;
  results?: InputMaybe<Scalars["JSON"]["input"]>;
  sources?: InputMaybe<Scalars["JSON"]["input"]>;
  toolId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInput>;
  workflowDatumToObjectId?: InputMaybe<WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInput>;
  workflowSectionBlockSectionsUsingId?: InputMaybe<WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInverseInput>;
};

/** Input for the nested mutation of `workflowDatum` in the `WorkflowSectionBlockInput` mutation. */
export type WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInput = {
  /** The primary key(s) for `workflowDatum` for the far side of the relationship. */
  connectById?: InputMaybe<WorkflowDatumWorkflowDataPkeyConnect>;
  /** A `WorkflowDatumInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdWorkflowDataCreateInput>;
  /** The primary key(s) for `workflowDatum` for the far side of the relationship. */
  deleteById?: InputMaybe<WorkflowDatumWorkflowDataPkeyDelete>;
  /** The primary key(s) and patch data for `workflowDatum` for the far side of the relationship. */
  updateById?: InputMaybe<WorkflowDatumOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdUsingWorkflowDataPkeyUpdate>;
};

/** Input for the nested mutation of `workflowSectionBlock` in the `WorkflowDatumInput` mutation. */
export type WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInverseInput = {
  /** The primary key(s) for `workflowSectionBlock` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<WorkflowSectionBlockWorkflowSectionBlockPkeyConnect>
  >;
  /** A `WorkflowSectionBlockInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdWorkflowSectionBlockCreateInput>
  >;
  /** The primary key(s) for `workflowSectionBlock` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<WorkflowSectionBlockWorkflowSectionBlockPkeyDelete>
  >;
  /** Flag indicating whether all other `workflowSectionBlock` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `workflowSectionBlock` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<WorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdUsingWorkflowSectionBlockPkeyUpdate>
  >;
};

/** The `workflowDatum` to be created by this mutation. */
export type WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdWorkflowDataCreateInput =
  {
    fresh: Scalars["Boolean"]["input"];
    id: Scalars["UUID"]["input"];
    workflowResultsUsingId?: InputMaybe<WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInverseInput>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInverseInput>;
  };

/** The `workflowSectionBlock` to be created by this mutation. */
export type WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdWorkflowSectionBlockCreateInput =
  {
    columns: Scalars["Int"]["input"];
    id: Scalars["UUID"]["input"];
    markdown?: InputMaybe<Scalars["String"]["input"]>;
    order: Scalars["Int"]["input"];
    parameters?: InputMaybe<Scalars["JSON"]["input"]>;
    results?: InputMaybe<Scalars["JSON"]["input"]>;
    sources?: InputMaybe<Scalars["JSON"]["input"]>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInput>;
    workflowDatumToObjectId?: InputMaybe<WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInput>;
    workflowSectionBlockSectionsUsingId?: InputMaybe<WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInverseInput>;
  };

/** The fields on `workflowSectionBlock` to look up the row to update. */
export type WorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdUsingWorkflowSectionBlockPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowSectionBlock` being updated. */
    workflowSectionBlockPatch: UpdateWorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdPatch;
  };

/** The fields on `workflowSectionBlock` to look up the row to update. */
export type WorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdUsingWorkflowSectionBlockPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowSectionBlock` being updated. */
    workflowSectionBlockPatch: UpdateWorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdPatch;
  };

/** The fields on `workflowSectionBlock` to look up the row to update. */
export type WorkflowSectionBlockOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowSectionBlock` being updated. */
    workflowSectionBlockPatch: UpdateWorkflowSectionBlockOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowPatch;
  };

/** Represents an update to a `WorkflowSectionBlock`. Fields that are set will be updated. */
export type WorkflowSectionBlockPatch = {
  columns?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  markdown?: InputMaybe<Scalars["String"]["input"]>;
  objectId?: InputMaybe<Scalars["UUID"]["input"]>;
  order?: InputMaybe<Scalars["Int"]["input"]>;
  parameters?: InputMaybe<Scalars["JSON"]["input"]>;
  results?: InputMaybe<Scalars["JSON"]["input"]>;
  sources?: InputMaybe<Scalars["JSON"]["input"]>;
  toolId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInput>;
  workflowDatumToObjectId?: InputMaybe<WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInput>;
  workflowSectionBlockSectionsUsingId?: InputMaybe<WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInverseInput>;
};

export type WorkflowSectionBlockSection = {
  __typename: "WorkflowSectionBlockSection";
  blockId: Scalars["UUID"]["output"];
  id: Scalars["BigInt"]["output"];
  sectionId: Scalars["UUID"]["output"];
  /** Reads a single `WorkflowSectionBlock` that is related to this `WorkflowSectionBlockSection`. */
  workflowSectionBlockByBlockId: Maybe<WorkflowSectionBlock>;
  /** Reads a single `WorkflowSection` that is related to this `WorkflowSectionBlockSection`. */
  workflowSectionBySectionId: Maybe<WorkflowSection>;
};

/**
 * A condition to be used against `WorkflowSectionBlockSection` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type WorkflowSectionBlockSectionCondition = {
  /** Checks for equality with the object’s `blockId` field. */
  blockId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `sectionId` field. */
  sectionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `WorkflowSectionBlockSection` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowSectionBlockSectionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkflowSectionBlockSectionFilter>>;
  /** Filter by the object’s `blockId` field. */
  blockId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkflowSectionBlockSectionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkflowSectionBlockSectionFilter>>;
  /** Filter by the object’s `sectionId` field. */
  sectionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `workflowSectionBlockByBlockId` relation. */
  workflowSectionBlockByBlockId?: InputMaybe<WorkflowSectionBlockFilter>;
  /** Filter by the object’s `workflowSectionBySectionId` relation. */
  workflowSectionBySectionId?: InputMaybe<WorkflowSectionFilter>;
};

/** An input for mutations affecting `WorkflowSectionBlockSection` */
export type WorkflowSectionBlockSectionInput = {
  blockId?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  sectionId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowSectionBlockToBlockId?: InputMaybe<WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInput>;
  workflowSectionToSectionId?: InputMaybe<WorkflowSectionBloSectionId817C1C77FkWorkflowInput>;
};

/** The fields on `workflowSectionBlockSection` to look up the row to update. */
export type WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockSBlockIdSectionId2F785D93UniqUpdate =
  {
    blockId: Scalars["UUID"]["input"];
    sectionId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowSectionBlockSection` being updated. */
    workflowSectionBlockSectionPatch: UpdateWorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowPatch;
  };

/** The fields on `workflowSectionBlockSection` to look up the row to update. */
export type WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockSectionsPkeyUpdate =
  {
    id: Scalars["BigInt"]["input"];
    /** An object where the defined keys will be set on the `workflowSectionBlockSection` being updated. */
    workflowSectionBlockSectionPatch: UpdateWorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowPatch;
  };

/** The fields on `workflowSectionBlockSection` to look up the row to update. */
export type WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionBlockSBlockIdSectionId2F785D93UniqUpdate =
  {
    blockId: Scalars["UUID"]["input"];
    sectionId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowSectionBlockSection` being updated. */
    workflowSectionBlockSectionPatch: UpdateWorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowPatch;
  };

/** The fields on `workflowSectionBlockSection` to look up the row to update. */
export type WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionBlockSectionsPkeyUpdate =
  {
    id: Scalars["BigInt"]["input"];
    /** An object where the defined keys will be set on the `workflowSectionBlockSection` being updated. */
    workflowSectionBlockSectionPatch: UpdateWorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowPatch;
  };

/** Represents an update to a `WorkflowSectionBlockSection`. Fields that are set will be updated. */
export type WorkflowSectionBlockSectionPatch = {
  blockId?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  sectionId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowSectionBlockToBlockId?: InputMaybe<WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInput>;
  workflowSectionToSectionId?: InputMaybe<WorkflowSectionBloSectionId817C1C77FkWorkflowInput>;
};

/** The fields on `workflowSectionBlockSection` to look up the row to connect. */
export type WorkflowSectionBlockSectionWorkflowSectionBlockSBlockIdSectionId2F785D93UniqConnect =
  {
    blockId: Scalars["UUID"]["input"];
    sectionId: Scalars["UUID"]["input"];
  };

/** The fields on `workflowSectionBlockSection` to look up the row to delete. */
export type WorkflowSectionBlockSectionWorkflowSectionBlockSBlockIdSectionId2F785D93UniqDelete =
  {
    blockId: Scalars["UUID"]["input"];
    sectionId: Scalars["UUID"]["input"];
  };

/** The fields on `workflowSectionBlockSection` to look up the row to connect. */
export type WorkflowSectionBlockSectionWorkflowSectionBlockSectionsPkeyConnect =
  {
    id: Scalars["BigInt"]["input"];
  };

/** The fields on `workflowSectionBlockSection` to look up the row to delete. */
export type WorkflowSectionBlockSectionWorkflowSectionBlockSectionsPkeyDelete =
  {
    id: Scalars["BigInt"]["input"];
  };

/** A connection to a list of `WorkflowSectionBlockSection` values. */
export type WorkflowSectionBlockSectionsConnection = {
  __typename: "WorkflowSectionBlockSectionsConnection";
  /** A list of edges which contains the `WorkflowSectionBlockSection` and cursor to aid in pagination. */
  edges: Array<WorkflowSectionBlockSectionsEdge>;
  /** A list of `WorkflowSectionBlockSection` objects. */
  nodes: Array<WorkflowSectionBlockSection>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorkflowSectionBlockSection` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `WorkflowSectionBlockSection` edge in the connection. */
export type WorkflowSectionBlockSectionsEdge = {
  __typename: "WorkflowSectionBlockSectionsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `WorkflowSectionBlockSection` at the end of the edge. */
  node: WorkflowSectionBlockSection;
};

/** Methods to use when ordering `WorkflowSectionBlockSection`. */
export enum WorkflowSectionBlockSectionsOrderBy {
  BlockIdAsc = "BLOCK_ID_ASC",
  BlockIdDesc = "BLOCK_ID_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  SectionIdAsc = "SECTION_ID_ASC",
  SectionIdDesc = "SECTION_ID_DESC",
}

/** A filter to be used against many `WorkflowSectionBlockSection` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowSectionBlockToManyWorkflowSectionBlockSectionFilter = {
  /** Every related `WorkflowSectionBlockSection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkflowSectionBlockSectionFilter>;
  /** No related `WorkflowSectionBlockSection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkflowSectionBlockSectionFilter>;
  /** Some related `WorkflowSectionBlockSection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkflowSectionBlockSectionFilter>;
};

/** Input for the nested mutation of `toolVersion` in the `WorkflowSectionBlockInput` mutation. */
export type WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInput = {
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  connectById?: InputMaybe<ToolVersionToolVersionPkeyConnect>;
  /** A `ToolVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdToolVersionCreateInput>;
  /** The primary key(s) for `toolVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<ToolVersionToolVersionPkeyDelete>;
  /** The primary key(s) and patch data for `toolVersion` for the far side of the relationship. */
  updateById?: InputMaybe<ToolVersionOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdUsingToolVersionPkeyUpdate>;
};

/** Input for the nested mutation of `workflowSectionBlock` in the `ToolVersionInput` mutation. */
export type WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput = {
  /** The primary key(s) for `workflowSectionBlock` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<WorkflowSectionBlockWorkflowSectionBlockPkeyConnect>
  >;
  /** A `WorkflowSectionBlockInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdWorkflowSectionBlockCreateInput>
  >;
  /** The primary key(s) for `workflowSectionBlock` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<WorkflowSectionBlockWorkflowSectionBlockPkeyDelete>
  >;
  /** Flag indicating whether all other `workflowSectionBlock` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `workflowSectionBlock` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<WorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdUsingWorkflowSectionBlockPkeyUpdate>
  >;
};

/** The `toolVersion` to be created by this mutation. */
export type WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdToolVersionCreateInput =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible: Scalars["Boolean"]["input"];
    isUpgradableToNextVersion: Scalars["Boolean"]["input"];
    maturity: Scalars["Int"]["input"];
    status: Scalars["Int"]["input"];
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion: Scalars["Int"]["input"];
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version: Scalars["String"]["input"];
    visibility: Scalars["Int"]["input"];
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** The `workflowSectionBlock` to be created by this mutation. */
export type WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdWorkflowSectionBlockCreateInput =
  {
    columns: Scalars["Int"]["input"];
    id: Scalars["UUID"]["input"];
    markdown?: InputMaybe<Scalars["String"]["input"]>;
    objectId?: InputMaybe<Scalars["UUID"]["input"]>;
    order: Scalars["Int"]["input"];
    parameters?: InputMaybe<Scalars["JSON"]["input"]>;
    results?: InputMaybe<Scalars["JSON"]["input"]>;
    sources?: InputMaybe<Scalars["JSON"]["input"]>;
    toolVersionToToolId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInput>;
    workflowDatumToObjectId?: InputMaybe<WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInput>;
    workflowSectionBlockSectionsUsingId?: InputMaybe<WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInverseInput>;
  };

/** The fields on `workflowSectionBlock` to look up the row to connect. */
export type WorkflowSectionBlockWorkflowSectionBlockPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `workflowSectionBlock` to look up the row to delete. */
export type WorkflowSectionBlockWorkflowSectionBlockPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** A connection to a list of `WorkflowSectionBlock` values. */
export type WorkflowSectionBlocksConnection = {
  __typename: "WorkflowSectionBlocksConnection";
  /** A list of edges which contains the `WorkflowSectionBlock` and cursor to aid in pagination. */
  edges: Array<WorkflowSectionBlocksEdge>;
  /** A list of `WorkflowSectionBlock` objects. */
  nodes: Array<WorkflowSectionBlock>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorkflowSectionBlock` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `WorkflowSectionBlock` edge in the connection. */
export type WorkflowSectionBlocksEdge = {
  __typename: "WorkflowSectionBlocksEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `WorkflowSectionBlock` at the end of the edge. */
  node: WorkflowSectionBlock;
};

/** Methods to use when ordering `WorkflowSectionBlock`. */
export enum WorkflowSectionBlocksOrderBy {
  ColumnsAsc = "COLUMNS_ASC",
  ColumnsDesc = "COLUMNS_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  MarkdownAsc = "MARKDOWN_ASC",
  MarkdownDesc = "MARKDOWN_DESC",
  Natural = "NATURAL",
  ObjectIdAsc = "OBJECT_ID_ASC",
  ObjectIdDesc = "OBJECT_ID_DESC",
  OrderAsc = "ORDER_ASC",
  OrderDesc = "ORDER_DESC",
  ParametersAsc = "PARAMETERS_ASC",
  ParametersDesc = "PARAMETERS_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  ResultsAsc = "RESULTS_ASC",
  ResultsDesc = "RESULTS_DESC",
  SourcesAsc = "SOURCES_ASC",
  SourcesDesc = "SOURCES_DESC",
  ToolIdAsc = "TOOL_ID_ASC",
  ToolIdDesc = "TOOL_ID_DESC",
}

/**
 * A condition to be used against `WorkflowSection` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type WorkflowSectionCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars["Int"]["input"]>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars["String"]["input"]>;
};

/** A filter to be used against `WorkflowSection` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowSectionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkflowSectionFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkflowSectionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkflowSectionFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `workflowSectionBlockSectionsBySectionId` relation. */
  workflowSectionBlockSectionsBySectionId?: InputMaybe<WorkflowSectionToManyWorkflowSectionBlockSectionFilter>;
  /** Some related `workflowSectionBlockSectionsBySectionId` exist. */
  workflowSectionBlockSectionsBySectionIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `workflowSectionWorkflowVersionsBySectionId` relation. */
  workflowSectionWorkflowVersionsBySectionId?: InputMaybe<WorkflowSectionToManyWorkflowSectionWorkflowVersionFilter>;
  /** Some related `workflowSectionWorkflowVersionsBySectionId` exist. */
  workflowSectionWorkflowVersionsBySectionIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

/** An input for mutations affecting `WorkflowSection` */
export type WorkflowSectionInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  order: Scalars["Int"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
  workflowSectionBlockSectionsUsingId?: InputMaybe<WorkflowSectionBloSectionId817C1C77FkWorkflowInverseInput>;
  workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorSectionId1D5C2D63FkWorkflowInverseInput>;
};

/** The fields on `workflowSection` to look up the row to update. */
export type WorkflowSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowSection` being updated. */
    workflowSectionPatch: UpdateWorkflowSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowPatch;
  };

/** The fields on `workflowSection` to look up the row to update. */
export type WorkflowSectionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowSection` being updated. */
    workflowSectionPatch: UpdateWorkflowSectionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowPatch;
  };

/** Represents an update to a `WorkflowSection`. Fields that are set will be updated. */
export type WorkflowSectionPatch = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  order?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  workflowSectionBlockSectionsUsingId?: InputMaybe<WorkflowSectionBloSectionId817C1C77FkWorkflowInverseInput>;
  workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorSectionId1D5C2D63FkWorkflowInverseInput>;
};

/** A filter to be used against many `WorkflowSectionBlockSection` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowSectionToManyWorkflowSectionBlockSectionFilter = {
  /** Every related `WorkflowSectionBlockSection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkflowSectionBlockSectionFilter>;
  /** No related `WorkflowSectionBlockSection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkflowSectionBlockSectionFilter>;
  /** Some related `WorkflowSectionBlockSection` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkflowSectionBlockSectionFilter>;
};

/** A filter to be used against many `WorkflowSectionWorkflowVersion` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowSectionToManyWorkflowSectionWorkflowVersionFilter = {
  /** Every related `WorkflowSectionWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkflowSectionWorkflowVersionFilter>;
  /** No related `WorkflowSectionWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkflowSectionWorkflowVersionFilter>;
  /** Some related `WorkflowSectionWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkflowSectionWorkflowVersionFilter>;
};

/** Input for the nested mutation of `workflowSection` in the `WorkflowSectionWorkflowVersionInput` mutation. */
export type WorkflowSectionWorSectionId1D5C2D63FkWorkflowInput = {
  /** The primary key(s) for `workflowSection` for the far side of the relationship. */
  connectById?: InputMaybe<WorkflowSectionWorkflowSectionPkeyConnect>;
  /** A `WorkflowSectionInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkflowSectionWorSectionId1D5C2D63FkWorkflowWorkflowSectionCreateInput>;
  /** The primary key(s) for `workflowSection` for the far side of the relationship. */
  deleteById?: InputMaybe<WorkflowSectionWorkflowSectionPkeyDelete>;
  /** The primary key(s) and patch data for `workflowSection` for the far side of the relationship. */
  updateById?: InputMaybe<WorkflowSectionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionPkeyUpdate>;
};

/** Input for the nested mutation of `workflowSectionWorkflowVersion` in the `WorkflowSectionInput` mutation. */
export type WorkflowSectionWorSectionId1D5C2D63FkWorkflowInverseInput = {
  /** The primary key(s) for `workflowSectionWorkflowVersion` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<WorkflowSectionWorkflowVersionWorkflowSectionWorkflowVersionsPkeyConnect>
  >;
  /** The primary key(s) for `workflowSectionWorkflowVersion` for the far side of the relationship. */
  connectBySectionIdAndWorkflowversionId?: InputMaybe<
    Array<WorkflowSectionWorkflowVersionWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqConnect>
  >;
  /** A `WorkflowSectionWorkflowVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<WorkflowSectionWorSectionId1D5C2D63FkWorkflowWorkflowSectionWorkflowVersionsCreateInput>
  >;
  /** The primary key(s) for `workflowSectionWorkflowVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<WorkflowSectionWorkflowVersionWorkflowSectionWorkflowVersionsPkeyDelete>
  >;
  /** The primary key(s) for `workflowSectionWorkflowVersion` for the far side of the relationship. */
  deleteBySectionIdAndWorkflowversionId?: InputMaybe<
    Array<WorkflowSectionWorkflowVersionWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqDelete>
  >;
  /** Flag indicating whether all other `workflowSectionWorkflowVersion` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `workflowSectionWorkflowVersion` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionWorkflowVersionsPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `workflowSectionWorkflowVersion` for the far side of the relationship. */
  updateBySectionIdAndWorkflowversionId?: InputMaybe<
    Array<WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqUpdate>
  >;
};

/** The `workflowSection` to be created by this mutation. */
export type WorkflowSectionWorSectionId1D5C2D63FkWorkflowWorkflowSectionCreateInput =
  {
    description?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    order: Scalars["Int"]["input"];
    title?: InputMaybe<Scalars["String"]["input"]>;
    workflowSectionBlockSectionsUsingId?: InputMaybe<WorkflowSectionBloSectionId817C1C77FkWorkflowInverseInput>;
    workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorSectionId1D5C2D63FkWorkflowInverseInput>;
  };

/** The `workflowSectionWorkflowVersion` to be created by this mutation. */
export type WorkflowSectionWorSectionId1D5C2D63FkWorkflowWorkflowSectionWorkflowVersionsCreateInput =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    workflowSectionToSectionId?: InputMaybe<WorkflowSectionWorSectionId1D5C2D63FkWorkflowInput>;
    workflowVersionToWorkflowversionId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInput>;
    workflowversionId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** Input for the nested mutation of `workflowVersion` in the `WorkflowSectionWorkflowVersionInput` mutation. */
export type WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInput = {
  /** The primary key(s) for `workflowVersion` for the far side of the relationship. */
  connectById?: InputMaybe<WorkflowVersionWorkflowVersionPkeyConnect>;
  /** A `WorkflowVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowWorkflowVersionCreateInput>;
  /** The primary key(s) for `workflowVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<WorkflowVersionWorkflowVersionPkeyDelete>;
  /** The primary key(s) and patch data for `workflowVersion` for the far side of the relationship. */
  updateById?: InputMaybe<WorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowVersionPkeyUpdate>;
};

/** Input for the nested mutation of `workflowSectionWorkflowVersion` in the `WorkflowVersionInput` mutation. */
export type WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInverseInput =
  {
    /** The primary key(s) for `workflowSectionWorkflowVersion` for the far side of the relationship. */
    connectById?: InputMaybe<
      Array<WorkflowSectionWorkflowVersionWorkflowSectionWorkflowVersionsPkeyConnect>
    >;
    /** The primary key(s) for `workflowSectionWorkflowVersion` for the far side of the relationship. */
    connectBySectionIdAndWorkflowversionId?: InputMaybe<
      Array<WorkflowSectionWorkflowVersionWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqConnect>
    >;
    /** A `WorkflowSectionWorkflowVersionInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowWorkflowSectionWorkflowVersionsCreateInput>
    >;
    /** The primary key(s) for `workflowSectionWorkflowVersion` for the far side of the relationship. */
    deleteById?: InputMaybe<
      Array<WorkflowSectionWorkflowVersionWorkflowSectionWorkflowVersionsPkeyDelete>
    >;
    /** The primary key(s) for `workflowSectionWorkflowVersion` for the far side of the relationship. */
    deleteBySectionIdAndWorkflowversionId?: InputMaybe<
      Array<WorkflowSectionWorkflowVersionWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqDelete>
    >;
    /** Flag indicating whether all other `workflowSectionWorkflowVersion` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The primary key(s) and patch data for `workflowSectionWorkflowVersion` for the far side of the relationship. */
    updateById?: InputMaybe<
      Array<WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowSectionWorkflowVersionsPkeyUpdate>
    >;
    /** The primary key(s) and patch data for `workflowSectionWorkflowVersion` for the far side of the relationship. */
    updateBySectionIdAndWorkflowversionId?: InputMaybe<
      Array<WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqUpdate>
    >;
  };

/** The `workflowSectionWorkflowVersion` to be created by this mutation. */
export type WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowWorkflowSectionWorkflowVersionsCreateInput =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    sectionId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowSectionToSectionId?: InputMaybe<WorkflowSectionWorSectionId1D5C2D63FkWorkflowInput>;
    workflowVersionToWorkflowversionId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInput>;
  };

/** The `workflowVersion` to be created by this mutation. */
export type WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowWorkflowVersionCreateInput =
  {
    applicationUserToUserId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInput>;
    autoGenerated: Scalars["Boolean"]["input"];
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    draft: Scalars["Boolean"]["input"];
    id: Scalars["UUID"]["input"];
    name: Scalars["String"]["input"];
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInverseInput>;
    workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInverseInput>;
    workflowSourceWorkflowVersionsUsingId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInverseInput>;
    workflowToWorkflowId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInput>;
  };

/** The fields on `workflowSection` to look up the row to connect. */
export type WorkflowSectionWorkflowSectionPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `workflowSection` to look up the row to delete. */
export type WorkflowSectionWorkflowSectionPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

export type WorkflowSectionWorkflowVersion = {
  __typename: "WorkflowSectionWorkflowVersion";
  id: Scalars["BigInt"]["output"];
  sectionId: Scalars["UUID"]["output"];
  /** Reads a single `WorkflowSection` that is related to this `WorkflowSectionWorkflowVersion`. */
  workflowSectionBySectionId: Maybe<WorkflowSection>;
  /** Reads a single `WorkflowVersion` that is related to this `WorkflowSectionWorkflowVersion`. */
  workflowVersionByWorkflowversionId: Maybe<WorkflowVersion>;
  workflowversionId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `WorkflowSectionWorkflowVersion` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type WorkflowSectionWorkflowVersionCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `sectionId` field. */
  sectionId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `workflowversionId` field. */
  workflowversionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `WorkflowSectionWorkflowVersion` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowSectionWorkflowVersionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkflowSectionWorkflowVersionFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkflowSectionWorkflowVersionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkflowSectionWorkflowVersionFilter>>;
  /** Filter by the object’s `sectionId` field. */
  sectionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `workflowSectionBySectionId` relation. */
  workflowSectionBySectionId?: InputMaybe<WorkflowSectionFilter>;
  /** Filter by the object’s `workflowVersionByWorkflowversionId` relation. */
  workflowVersionByWorkflowversionId?: InputMaybe<WorkflowVersionFilter>;
  /** Filter by the object’s `workflowversionId` field. */
  workflowversionId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `WorkflowSectionWorkflowVersion` */
export type WorkflowSectionWorkflowVersionInput = {
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  sectionId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowSectionToSectionId?: InputMaybe<WorkflowSectionWorSectionId1D5C2D63FkWorkflowInput>;
  workflowVersionToWorkflowversionId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInput>;
  workflowversionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `workflowSectionWorkflowVersion` to look up the row to update. */
export type WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqUpdate =
  {
    sectionId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowSectionWorkflowVersion` being updated. */
    workflowSectionWorkflowVersionPatch: UpdateWorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowPatch;
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The fields on `workflowSectionWorkflowVersion` to look up the row to update. */
export type WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionWorkflowVersionsPkeyUpdate =
  {
    id: Scalars["BigInt"]["input"];
    /** An object where the defined keys will be set on the `workflowSectionWorkflowVersion` being updated. */
    workflowSectionWorkflowVersionPatch: UpdateWorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowPatch;
  };

/** The fields on `workflowSectionWorkflowVersion` to look up the row to update. */
export type WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqUpdate =
  {
    sectionId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowSectionWorkflowVersion` being updated. */
    workflowSectionWorkflowVersionPatch: UpdateWorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowPatch;
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The fields on `workflowSectionWorkflowVersion` to look up the row to update. */
export type WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowSectionWorkflowVersionsPkeyUpdate =
  {
    id: Scalars["BigInt"]["input"];
    /** An object where the defined keys will be set on the `workflowSectionWorkflowVersion` being updated. */
    workflowSectionWorkflowVersionPatch: UpdateWorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowPatch;
  };

/** Represents an update to a `WorkflowSectionWorkflowVersion`. Fields that are set will be updated. */
export type WorkflowSectionWorkflowVersionPatch = {
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  sectionId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowSectionToSectionId?: InputMaybe<WorkflowSectionWorSectionId1D5C2D63FkWorkflowInput>;
  workflowVersionToWorkflowversionId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInput>;
  workflowversionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `workflowSectionWorkflowVersion` to look up the row to connect. */
export type WorkflowSectionWorkflowVersionWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqConnect =
  {
    sectionId: Scalars["UUID"]["input"];
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The fields on `workflowSectionWorkflowVersion` to look up the row to delete. */
export type WorkflowSectionWorkflowVersionWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqDelete =
  {
    sectionId: Scalars["UUID"]["input"];
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The fields on `workflowSectionWorkflowVersion` to look up the row to connect. */
export type WorkflowSectionWorkflowVersionWorkflowSectionWorkflowVersionsPkeyConnect =
  {
    id: Scalars["BigInt"]["input"];
  };

/** The fields on `workflowSectionWorkflowVersion` to look up the row to delete. */
export type WorkflowSectionWorkflowVersionWorkflowSectionWorkflowVersionsPkeyDelete =
  {
    id: Scalars["BigInt"]["input"];
  };

/** A connection to a list of `WorkflowSectionWorkflowVersion` values. */
export type WorkflowSectionWorkflowVersionsConnection = {
  __typename: "WorkflowSectionWorkflowVersionsConnection";
  /** A list of edges which contains the `WorkflowSectionWorkflowVersion` and cursor to aid in pagination. */
  edges: Array<WorkflowSectionWorkflowVersionsEdge>;
  /** A list of `WorkflowSectionWorkflowVersion` objects. */
  nodes: Array<WorkflowSectionWorkflowVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorkflowSectionWorkflowVersion` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `WorkflowSectionWorkflowVersion` edge in the connection. */
export type WorkflowSectionWorkflowVersionsEdge = {
  __typename: "WorkflowSectionWorkflowVersionsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `WorkflowSectionWorkflowVersion` at the end of the edge. */
  node: WorkflowSectionWorkflowVersion;
};

/** Methods to use when ordering `WorkflowSectionWorkflowVersion`. */
export enum WorkflowSectionWorkflowVersionsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  SectionIdAsc = "SECTION_ID_ASC",
  SectionIdDesc = "SECTION_ID_DESC",
  WorkflowversionIdAsc = "WORKFLOWVERSION_ID_ASC",
  WorkflowversionIdDesc = "WORKFLOWVERSION_ID_DESC",
}

/** A connection to a list of `WorkflowSection` values. */
export type WorkflowSectionsConnection = {
  __typename: "WorkflowSectionsConnection";
  /** A list of edges which contains the `WorkflowSection` and cursor to aid in pagination. */
  edges: Array<WorkflowSectionsEdge>;
  /** A list of `WorkflowSection` objects. */
  nodes: Array<WorkflowSection>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorkflowSection` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `WorkflowSection` edge in the connection. */
export type WorkflowSectionsEdge = {
  __typename: "WorkflowSectionsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `WorkflowSection` at the end of the edge. */
  node: WorkflowSection;
};

/** Methods to use when ordering `WorkflowSection`. */
export enum WorkflowSectionsOrderBy {
  DescriptionAsc = "DESCRIPTION_ASC",
  DescriptionDesc = "DESCRIPTION_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  OrderAsc = "ORDER_ASC",
  OrderDesc = "ORDER_DESC",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  TitleAsc = "TITLE_ASC",
  TitleDesc = "TITLE_DESC",
}

export type WorkflowSource = {
  __typename: "WorkflowSource";
  id: Scalars["UUID"]["output"];
  /** Reads and enables pagination through a set of `WorkflowSourceWorkflowVersion`. */
  workflowSourceWorkflowVersionsBySourceId: WorkflowSourceWorkflowVersionsConnection;
};

export type WorkflowSourceWorkflowSourceWorkflowVersionsBySourceIdArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  condition?: InputMaybe<WorkflowSourceWorkflowVersionCondition>;
  filter?: InputMaybe<WorkflowSourceWorkflowVersionFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<WorkflowSourceWorkflowVersionsOrderBy>>;
};

/**
 * A condition to be used against `WorkflowSource` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type WorkflowSourceCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `WorkflowSource` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowSourceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkflowSourceFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkflowSourceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkflowSourceFilter>>;
  /** Filter by the object’s `workflowSourceWorkflowVersionsBySourceId` relation. */
  workflowSourceWorkflowVersionsBySourceId?: InputMaybe<WorkflowSourceToManyWorkflowSourceWorkflowVersionFilter>;
  /** Some related `workflowSourceWorkflowVersionsBySourceId` exist. */
  workflowSourceWorkflowVersionsBySourceIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

/** An input for mutations affecting `WorkflowSource` */
export type WorkflowSourceInput = {
  id: Scalars["UUID"]["input"];
  workflowSourceWorkflowVersionsUsingId?: InputMaybe<WorkflowSourceWorkSourceId608A289DFkWorkflowInverseInput>;
};

/** The fields on `workflowSource` to look up the row to update. */
export type WorkflowSourceOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourcePkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowSource` being updated. */
    workflowSourcePatch: UpdateWorkflowSourceOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowPatch;
  };

/** Represents an update to a `WorkflowSource`. Fields that are set will be updated. */
export type WorkflowSourcePatch = {
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowSourceWorkflowVersionsUsingId?: InputMaybe<WorkflowSourceWorkSourceId608A289DFkWorkflowInverseInput>;
};

/** A filter to be used against many `WorkflowSourceWorkflowVersion` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowSourceToManyWorkflowSourceWorkflowVersionFilter = {
  /** Every related `WorkflowSourceWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkflowSourceWorkflowVersionFilter>;
  /** No related `WorkflowSourceWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkflowSourceWorkflowVersionFilter>;
  /** Some related `WorkflowSourceWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkflowSourceWorkflowVersionFilter>;
};

/** Input for the nested mutation of `workflowSource` in the `WorkflowSourceWorkflowVersionInput` mutation. */
export type WorkflowSourceWorkSourceId608A289DFkWorkflowInput = {
  /** The primary key(s) for `workflowSource` for the far side of the relationship. */
  connectById?: InputMaybe<WorkflowSourceWorkflowSourcePkeyConnect>;
  /** A `WorkflowSourceInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkflowSourceWorkSourceId608A289DFkWorkflowWorkflowSourceCreateInput>;
  /** The primary key(s) for `workflowSource` for the far side of the relationship. */
  deleteById?: InputMaybe<WorkflowSourceWorkflowSourcePkeyDelete>;
  /** The primary key(s) and patch data for `workflowSource` for the far side of the relationship. */
  updateById?: InputMaybe<WorkflowSourceOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourcePkeyUpdate>;
};

/** Input for the nested mutation of `workflowSourceWorkflowVersion` in the `WorkflowSourceInput` mutation. */
export type WorkflowSourceWorkSourceId608A289DFkWorkflowInverseInput = {
  /** The primary key(s) for `workflowSourceWorkflowVersion` for the far side of the relationship. */
  connectById?: InputMaybe<
    Array<WorkflowSourceWorkflowVersionWorkflowSourceWorkflowVersionsPkeyConnect>
  >;
  /** The primary key(s) for `workflowSourceWorkflowVersion` for the far side of the relationship. */
  connectBySourceIdAndWorkflowversionId?: InputMaybe<
    Array<WorkflowSourceWorkflowVersionWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqConnect>
  >;
  /** A `WorkflowSourceWorkflowVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<WorkflowSourceWorkSourceId608A289DFkWorkflowWorkflowSourceWorkflowVersionsCreateInput>
  >;
  /** The primary key(s) for `workflowSourceWorkflowVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<
    Array<WorkflowSourceWorkflowVersionWorkflowSourceWorkflowVersionsPkeyDelete>
  >;
  /** The primary key(s) for `workflowSourceWorkflowVersion` for the far side of the relationship. */
  deleteBySourceIdAndWorkflowversionId?: InputMaybe<
    Array<WorkflowSourceWorkflowVersionWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqDelete>
  >;
  /** Flag indicating whether all other `workflowSourceWorkflowVersion` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `workflowSourceWorkflowVersion` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourceWorkflowVersionsPkeyUpdate>
  >;
  /** The primary key(s) and patch data for `workflowSourceWorkflowVersion` for the far side of the relationship. */
  updateBySourceIdAndWorkflowversionId?: InputMaybe<
    Array<WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqUpdate>
  >;
};

/** The `workflowSource` to be created by this mutation. */
export type WorkflowSourceWorkSourceId608A289DFkWorkflowWorkflowSourceCreateInput =
  {
    id: Scalars["UUID"]["input"];
    workflowSourceWorkflowVersionsUsingId?: InputMaybe<WorkflowSourceWorkSourceId608A289DFkWorkflowInverseInput>;
  };

/** The `workflowSourceWorkflowVersion` to be created by this mutation. */
export type WorkflowSourceWorkSourceId608A289DFkWorkflowWorkflowSourceWorkflowVersionsCreateInput =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    workflowSourceToSourceId?: InputMaybe<WorkflowSourceWorkSourceId608A289DFkWorkflowInput>;
    workflowVersionToWorkflowversionId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInput>;
    workflowversionId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** Input for the nested mutation of `workflowVersion` in the `WorkflowSourceWorkflowVersionInput` mutation. */
export type WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInput = {
  /** The primary key(s) for `workflowVersion` for the far side of the relationship. */
  connectById?: InputMaybe<WorkflowVersionWorkflowVersionPkeyConnect>;
  /** A `WorkflowVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowWorkflowVersionCreateInput>;
  /** The primary key(s) for `workflowVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<WorkflowVersionWorkflowVersionPkeyDelete>;
  /** The primary key(s) and patch data for `workflowVersion` for the far side of the relationship. */
  updateById?: InputMaybe<WorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowVersionPkeyUpdate>;
};

/** Input for the nested mutation of `workflowSourceWorkflowVersion` in the `WorkflowVersionInput` mutation. */
export type WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInverseInput =
  {
    /** The primary key(s) for `workflowSourceWorkflowVersion` for the far side of the relationship. */
    connectById?: InputMaybe<
      Array<WorkflowSourceWorkflowVersionWorkflowSourceWorkflowVersionsPkeyConnect>
    >;
    /** The primary key(s) for `workflowSourceWorkflowVersion` for the far side of the relationship. */
    connectBySourceIdAndWorkflowversionId?: InputMaybe<
      Array<WorkflowSourceWorkflowVersionWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqConnect>
    >;
    /** A `WorkflowSourceWorkflowVersionInput` object that will be created and connected to this object. */
    create?: InputMaybe<
      Array<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowWorkflowSourceWorkflowVersionsCreateInput>
    >;
    /** The primary key(s) for `workflowSourceWorkflowVersion` for the far side of the relationship. */
    deleteById?: InputMaybe<
      Array<WorkflowSourceWorkflowVersionWorkflowSourceWorkflowVersionsPkeyDelete>
    >;
    /** The primary key(s) for `workflowSourceWorkflowVersion` for the far side of the relationship. */
    deleteBySourceIdAndWorkflowversionId?: InputMaybe<
      Array<WorkflowSourceWorkflowVersionWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqDelete>
    >;
    /** Flag indicating whether all other `workflowSourceWorkflowVersion` records that match this relationship should be removed. */
    deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The primary key(s) and patch data for `workflowSourceWorkflowVersion` for the far side of the relationship. */
    updateById?: InputMaybe<
      Array<WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowSourceWorkflowVersionsPkeyUpdate>
    >;
    /** The primary key(s) and patch data for `workflowSourceWorkflowVersion` for the far side of the relationship. */
    updateBySourceIdAndWorkflowversionId?: InputMaybe<
      Array<WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqUpdate>
    >;
  };

/** The `workflowSourceWorkflowVersion` to be created by this mutation. */
export type WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowWorkflowSourceWorkflowVersionsCreateInput =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    sourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowSourceToSourceId?: InputMaybe<WorkflowSourceWorkSourceId608A289DFkWorkflowInput>;
    workflowVersionToWorkflowversionId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInput>;
  };

/** The `workflowVersion` to be created by this mutation. */
export type WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowWorkflowVersionCreateInput =
  {
    applicationUserToUserId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInput>;
    autoGenerated: Scalars["Boolean"]["input"];
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    draft: Scalars["Boolean"]["input"];
    id: Scalars["UUID"]["input"];
    name: Scalars["String"]["input"];
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInverseInput>;
    workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInverseInput>;
    workflowSourceWorkflowVersionsUsingId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInverseInput>;
    workflowToWorkflowId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInput>;
  };

/** The fields on `workflowSource` to look up the row to connect. */
export type WorkflowSourceWorkflowSourcePkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `workflowSource` to look up the row to delete. */
export type WorkflowSourceWorkflowSourcePkeyDelete = {
  id: Scalars["UUID"]["input"];
};

export type WorkflowSourceWorkflowVersion = {
  __typename: "WorkflowSourceWorkflowVersion";
  id: Scalars["BigInt"]["output"];
  sourceId: Scalars["UUID"]["output"];
  /** Reads a single `WorkflowSource` that is related to this `WorkflowSourceWorkflowVersion`. */
  workflowSourceBySourceId: Maybe<WorkflowSource>;
  /** Reads a single `WorkflowVersion` that is related to this `WorkflowSourceWorkflowVersion`. */
  workflowVersionByWorkflowversionId: Maybe<WorkflowVersion>;
  workflowversionId: Scalars["UUID"]["output"];
};

/**
 * A condition to be used against `WorkflowSourceWorkflowVersion` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type WorkflowSourceWorkflowVersionCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  /** Checks for equality with the object’s `sourceId` field. */
  sourceId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `workflowversionId` field. */
  workflowversionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `WorkflowSourceWorkflowVersion` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowSourceWorkflowVersionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkflowSourceWorkflowVersionFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkflowSourceWorkflowVersionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkflowSourceWorkflowVersionFilter>>;
  /** Filter by the object’s `sourceId` field. */
  sourceId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `workflowSourceBySourceId` relation. */
  workflowSourceBySourceId?: InputMaybe<WorkflowSourceFilter>;
  /** Filter by the object’s `workflowVersionByWorkflowversionId` relation. */
  workflowVersionByWorkflowversionId?: InputMaybe<WorkflowVersionFilter>;
  /** Filter by the object’s `workflowversionId` field. */
  workflowversionId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `WorkflowSourceWorkflowVersion` */
export type WorkflowSourceWorkflowVersionInput = {
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  sourceId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowSourceToSourceId?: InputMaybe<WorkflowSourceWorkSourceId608A289DFkWorkflowInput>;
  workflowVersionToWorkflowversionId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInput>;
  workflowversionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `workflowSourceWorkflowVersion` to look up the row to update. */
export type WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqUpdate =
  {
    sourceId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowSourceWorkflowVersion` being updated. */
    workflowSourceWorkflowVersionPatch: UpdateWorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowPatch;
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The fields on `workflowSourceWorkflowVersion` to look up the row to update. */
export type WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourceWorkflowVersionsPkeyUpdate =
  {
    id: Scalars["BigInt"]["input"];
    /** An object where the defined keys will be set on the `workflowSourceWorkflowVersion` being updated. */
    workflowSourceWorkflowVersionPatch: UpdateWorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowPatch;
  };

/** The fields on `workflowSourceWorkflowVersion` to look up the row to update. */
export type WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqUpdate =
  {
    sourceId: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowSourceWorkflowVersion` being updated. */
    workflowSourceWorkflowVersionPatch: UpdateWorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowPatch;
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The fields on `workflowSourceWorkflowVersion` to look up the row to update. */
export type WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowSourceWorkflowVersionsPkeyUpdate =
  {
    id: Scalars["BigInt"]["input"];
    /** An object where the defined keys will be set on the `workflowSourceWorkflowVersion` being updated. */
    workflowSourceWorkflowVersionPatch: UpdateWorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowPatch;
  };

/** Represents an update to a `WorkflowSourceWorkflowVersion`. Fields that are set will be updated. */
export type WorkflowSourceWorkflowVersionPatch = {
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  sourceId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowSourceToSourceId?: InputMaybe<WorkflowSourceWorkSourceId608A289DFkWorkflowInput>;
  workflowVersionToWorkflowversionId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInput>;
  workflowversionId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** The fields on `workflowSourceWorkflowVersion` to look up the row to connect. */
export type WorkflowSourceWorkflowVersionWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqConnect =
  {
    sourceId: Scalars["UUID"]["input"];
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The fields on `workflowSourceWorkflowVersion` to look up the row to delete. */
export type WorkflowSourceWorkflowVersionWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqDelete =
  {
    sourceId: Scalars["UUID"]["input"];
    workflowversionId: Scalars["UUID"]["input"];
  };

/** The fields on `workflowSourceWorkflowVersion` to look up the row to connect. */
export type WorkflowSourceWorkflowVersionWorkflowSourceWorkflowVersionsPkeyConnect =
  {
    id: Scalars["BigInt"]["input"];
  };

/** The fields on `workflowSourceWorkflowVersion` to look up the row to delete. */
export type WorkflowSourceWorkflowVersionWorkflowSourceWorkflowVersionsPkeyDelete =
  {
    id: Scalars["BigInt"]["input"];
  };

/** A connection to a list of `WorkflowSourceWorkflowVersion` values. */
export type WorkflowSourceWorkflowVersionsConnection = {
  __typename: "WorkflowSourceWorkflowVersionsConnection";
  /** A list of edges which contains the `WorkflowSourceWorkflowVersion` and cursor to aid in pagination. */
  edges: Array<WorkflowSourceWorkflowVersionsEdge>;
  /** A list of `WorkflowSourceWorkflowVersion` objects. */
  nodes: Array<WorkflowSourceWorkflowVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorkflowSourceWorkflowVersion` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `WorkflowSourceWorkflowVersion` edge in the connection. */
export type WorkflowSourceWorkflowVersionsEdge = {
  __typename: "WorkflowSourceWorkflowVersionsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `WorkflowSourceWorkflowVersion` at the end of the edge. */
  node: WorkflowSourceWorkflowVersion;
};

/** Methods to use when ordering `WorkflowSourceWorkflowVersion`. */
export enum WorkflowSourceWorkflowVersionsOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  SourceIdAsc = "SOURCE_ID_ASC",
  SourceIdDesc = "SOURCE_ID_DESC",
  WorkflowversionIdAsc = "WORKFLOWVERSION_ID_ASC",
  WorkflowversionIdDesc = "WORKFLOWVERSION_ID_DESC",
}

/** A connection to a list of `WorkflowSource` values. */
export type WorkflowSourcesConnection = {
  __typename: "WorkflowSourcesConnection";
  /** A list of edges which contains the `WorkflowSource` and cursor to aid in pagination. */
  edges: Array<WorkflowSourcesEdge>;
  /** A list of `WorkflowSource` objects. */
  nodes: Array<WorkflowSource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorkflowSource` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `WorkflowSource` edge in the connection. */
export type WorkflowSourcesEdge = {
  __typename: "WorkflowSourcesEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `WorkflowSource` at the end of the edge. */
  node: WorkflowSource;
};

/** Methods to use when ordering `WorkflowSource`. */
export enum WorkflowSourcesOrderBy {
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
}

/** Input for the nested mutation of `tenant` in the `WorkflowInput` mutation. */
export type WorkflowTenantId9469Ff84FkTenantIdInput = {
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectById?: InputMaybe<TenantTenantPkeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByKey?: InputMaybe<TenantTenantKeyKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyConnect>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  connectBySfid?: InputMaybe<TenantTenantSfidKeyConnect>;
  /** A `TenantInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdTenantCreateInput>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteById?: InputMaybe<TenantTenantPkeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByKey?: InputMaybe<TenantTenantKeyKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteByRepositoryName?: InputMaybe<TenantTenantRepositoryNameKeyDelete>;
  /** The primary key(s) for `tenant` for the far side of the relationship. */
  deleteBySfid?: InputMaybe<TenantTenantSfidKeyDelete>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateById?: InputMaybe<TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantPkeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByKey?: InputMaybe<TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantKeyKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateByRepositoryName?: InputMaybe<TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantRepositoryNameKeyUpdate>;
  /** The primary key(s) and patch data for `tenant` for the far side of the relationship. */
  updateBySfid?: InputMaybe<TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantSfidKeyUpdate>;
};

/** Input for the nested mutation of `workflow` in the `TenantInput` mutation. */
export type WorkflowTenantId9469Ff84FkTenantIdInverseInput = {
  /** The primary key(s) for `workflow` for the far side of the relationship. */
  connectById?: InputMaybe<Array<WorkflowWorkflowPkeyConnect>>;
  /** A `WorkflowInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<WorkflowTenantId9469Ff84FkTenantIdWorkflowCreateInput>
  >;
  /** The primary key(s) for `workflow` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<WorkflowWorkflowPkeyDelete>>;
  /** Flag indicating whether all other `workflow` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `workflow` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<WorkflowOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingWorkflowPkeyUpdate>
  >;
};

/** The `tenant` to be created by this mutation. */
export type WorkflowTenantId9469Ff84FkTenantIdTenantCreateInput = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal: Scalars["Boolean"]["input"];
  key: Scalars["String"]["input"];
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name: Scalars["String"]["input"];
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName: Scalars["String"]["input"];
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status: Scalars["Int"]["input"];
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType: Scalars["Int"]["input"];
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** The `workflow` to be created by this mutation. */
export type WorkflowTenantId9469Ff84FkTenantIdWorkflowCreateInput = {
  applicationUserToUserId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInput>;
  containerId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  name: Scalars["String"]["input"];
  tenantToTenantId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowVersionsUsingId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInverseInput>;
};

/** A filter to be used against many `WorkflowVersion` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowToManyWorkflowVersionFilter = {
  /** Every related `WorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkflowVersionFilter>;
  /** No related `WorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkflowVersionFilter>;
  /** Some related `WorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkflowVersionFilter>;
};

/** The `applicationUser` to be created by this mutation. */
export type WorkflowUserId121C1967FkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `WorkflowInput` mutation. */
export type WorkflowUserId121C1967FkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `workflow` in the `ApplicationUserInput` mutation. */
export type WorkflowUserId121C1967FkApplicationUserIdInverseInput = {
  /** The primary key(s) for `workflow` for the far side of the relationship. */
  connectById?: InputMaybe<Array<WorkflowWorkflowPkeyConnect>>;
  /** A `WorkflowInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<WorkflowUserId121C1967FkApplicationUserIdWorkflowCreateInput>
  >;
  /** The primary key(s) for `workflow` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<WorkflowWorkflowPkeyDelete>>;
  /** Flag indicating whether all other `workflow` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `workflow` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<WorkflowOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingWorkflowPkeyUpdate>
  >;
};

/** The `workflow` to be created by this mutation. */
export type WorkflowUserId121C1967FkApplicationUserIdWorkflowCreateInput = {
  applicationUserToUserId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInput>;
  containerId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  name: Scalars["String"]["input"];
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInput>;
  workflowVersionsUsingId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInverseInput>;
};

export type WorkflowVersion = {
  __typename: "WorkflowVersion";
  /** Reads a single `ApplicationUser` that is related to this `WorkflowVersion`. */
  applicationUserByUserId: Maybe<ApplicationUser>;
  autoGenerated: Scalars["Boolean"]["output"];
  dateCreated: Scalars["Datetime"]["output"];
  description: Maybe<Scalars["String"]["output"]>;
  draft: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  userId: Maybe<Scalars["UUID"]["output"]>;
  /** Reads a single `Workflow` that is related to this `WorkflowVersion`. */
  workflowByWorkflowId: Maybe<Workflow>;
  workflowId: Scalars["UUID"]["output"];
  /** Reads and enables pagination through a set of `WorkflowResultWorkflowVersion`. */
  workflowResultWorkflowVersionsByWorkflowversionId: WorkflowResultWorkflowVersionsConnection;
  /** Reads and enables pagination through a set of `WorkflowSectionWorkflowVersion`. */
  workflowSectionWorkflowVersionsByWorkflowversionId: WorkflowSectionWorkflowVersionsConnection;
  /** Reads and enables pagination through a set of `WorkflowSourceWorkflowVersion`. */
  workflowSourceWorkflowVersionsByWorkflowversionId: WorkflowSourceWorkflowVersionsConnection;
};

export type WorkflowVersionWorkflowResultWorkflowVersionsByWorkflowversionIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<WorkflowResultWorkflowVersionCondition>;
    filter?: InputMaybe<WorkflowResultWorkflowVersionFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<WorkflowResultWorkflowVersionsOrderBy>>;
  };

export type WorkflowVersionWorkflowSectionWorkflowVersionsByWorkflowversionIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<WorkflowSectionWorkflowVersionCondition>;
    filter?: InputMaybe<WorkflowSectionWorkflowVersionFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<WorkflowSectionWorkflowVersionsOrderBy>>;
  };

export type WorkflowVersionWorkflowSourceWorkflowVersionsByWorkflowversionIdArgs =
  {
    after?: InputMaybe<Scalars["Cursor"]["input"]>;
    before?: InputMaybe<Scalars["Cursor"]["input"]>;
    condition?: InputMaybe<WorkflowSourceWorkflowVersionCondition>;
    filter?: InputMaybe<WorkflowSourceWorkflowVersionFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Array<WorkflowSourceWorkflowVersionsOrderBy>>;
  };

/**
 * A condition to be used against `WorkflowVersion` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type WorkflowVersionCondition = {
  /** Checks for equality with the object’s `autoGenerated` field. */
  autoGenerated?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `draft` field. */
  draft?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  /** Checks for equality with the object’s `workflowId` field. */
  workflowId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** A filter to be used against `WorkflowVersion` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowVersionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkflowVersionFilter>>;
  /** Filter by the object’s `applicationUserByUserId` relation. */
  applicationUserByUserId?: InputMaybe<ApplicationUserFilter>;
  /** A related `applicationUserByUserId` exists. */
  applicationUserByUserIdExists?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by the object’s `autoGenerated` field. */
  autoGenerated?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `dateCreated` field. */
  dateCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `draft` field. */
  draft?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkflowVersionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkflowVersionFilter>>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `workflowByWorkflowId` relation. */
  workflowByWorkflowId?: InputMaybe<WorkflowFilter>;
  /** Filter by the object’s `workflowId` field. */
  workflowId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `workflowResultWorkflowVersionsByWorkflowversionId` relation. */
  workflowResultWorkflowVersionsByWorkflowversionId?: InputMaybe<WorkflowVersionToManyWorkflowResultWorkflowVersionFilter>;
  /** Some related `workflowResultWorkflowVersionsByWorkflowversionId` exist. */
  workflowResultWorkflowVersionsByWorkflowversionIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `workflowSectionWorkflowVersionsByWorkflowversionId` relation. */
  workflowSectionWorkflowVersionsByWorkflowversionId?: InputMaybe<WorkflowVersionToManyWorkflowSectionWorkflowVersionFilter>;
  /** Some related `workflowSectionWorkflowVersionsByWorkflowversionId` exist. */
  workflowSectionWorkflowVersionsByWorkflowversionIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  /** Filter by the object’s `workflowSourceWorkflowVersionsByWorkflowversionId` relation. */
  workflowSourceWorkflowVersionsByWorkflowversionId?: InputMaybe<WorkflowVersionToManyWorkflowSourceWorkflowVersionFilter>;
  /** Some related `workflowSourceWorkflowVersionsByWorkflowversionId` exist. */
  workflowSourceWorkflowVersionsByWorkflowversionIdExist?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
};

/** An input for mutations affecting `WorkflowVersion` */
export type WorkflowVersionInput = {
  applicationUserToUserId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInput>;
  autoGenerated: Scalars["Boolean"]["input"];
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  draft: Scalars["Boolean"]["input"];
  id: Scalars["UUID"]["input"];
  name: Scalars["String"]["input"];
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInverseInput>;
  workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInverseInput>;
  workflowSourceWorkflowVersionsUsingId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInverseInput>;
  workflowToWorkflowId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInput>;
};

/** The fields on `workflowVersion` to look up the row to update. */
export type WorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowVersionPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowVersion` being updated. */
    workflowVersionPatch: UpdateWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowPatch;
  };

/** The fields on `workflowVersion` to look up the row to update. */
export type WorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowVersionPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowVersion` being updated. */
    workflowVersionPatch: UpdateWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowPatch;
  };

/** The fields on `workflowVersion` to look up the row to update. */
export type WorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowVersionPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowVersion` being updated. */
    workflowVersionPatch: UpdateWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowPatch;
  };

/** The fields on `workflowVersion` to look up the row to update. */
export type WorkflowVersionOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingWorkflowVersionPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowVersion` being updated. */
    workflowVersionPatch: UpdateWorkflowVersionOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdPatch;
  };

/** The fields on `workflowVersion` to look up the row to update. */
export type WorkflowVersionOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdUsingWorkflowVersionPkeyUpdate =
  {
    id: Scalars["UUID"]["input"];
    /** An object where the defined keys will be set on the `workflowVersion` being updated. */
    workflowVersionPatch: UpdateWorkflowVersionOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdPatch;
  };

/** Represents an update to a `WorkflowVersion`. Fields that are set will be updated. */
export type WorkflowVersionPatch = {
  applicationUserToUserId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInput>;
  autoGenerated?: InputMaybe<Scalars["Boolean"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  draft?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInverseInput>;
  workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInverseInput>;
  workflowSourceWorkflowVersionsUsingId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInverseInput>;
  workflowToWorkflowId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInput>;
};

/** A filter to be used against many `WorkflowResultWorkflowVersion` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowVersionToManyWorkflowResultWorkflowVersionFilter = {
  /** Every related `WorkflowResultWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkflowResultWorkflowVersionFilter>;
  /** No related `WorkflowResultWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkflowResultWorkflowVersionFilter>;
  /** Some related `WorkflowResultWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkflowResultWorkflowVersionFilter>;
};

/** A filter to be used against many `WorkflowSectionWorkflowVersion` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowVersionToManyWorkflowSectionWorkflowVersionFilter = {
  /** Every related `WorkflowSectionWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkflowSectionWorkflowVersionFilter>;
  /** No related `WorkflowSectionWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkflowSectionWorkflowVersionFilter>;
  /** Some related `WorkflowSectionWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkflowSectionWorkflowVersionFilter>;
};

/** A filter to be used against many `WorkflowSourceWorkflowVersion` object types. All fields are combined with a logical ‘and.’ */
export type WorkflowVersionToManyWorkflowSourceWorkflowVersionFilter = {
  /** Every related `WorkflowSourceWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WorkflowSourceWorkflowVersionFilter>;
  /** No related `WorkflowSourceWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WorkflowSourceWorkflowVersionFilter>;
  /** Some related `WorkflowSourceWorkflowVersion` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WorkflowSourceWorkflowVersionFilter>;
};

/** The `applicationUser` to be created by this mutation. */
export type WorkflowVersionUserId00C0F62FFkApplicationUserIdApplicationUserCreateInput =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email: Scalars["String"]["input"];
    emailMarketingConsent: Scalars["Boolean"]["input"];
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName: Scalars["String"]["input"];
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["UUID"]["input"];
    internal: Scalars["Boolean"]["input"];
    isActive: Scalars["Boolean"]["input"];
    isStaff: Scalars["Boolean"]["input"];
    isSuperuser: Scalars["Boolean"]["input"];
    lastName: Scalars["String"]["input"];
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin: Scalars["String"]["input"];
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username: Scalars["String"]["input"];
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** Input for the nested mutation of `applicationUser` in the `WorkflowVersionInput` mutation. */
export type WorkflowVersionUserId00C0F62FFkApplicationUserIdInput = {
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectById?: InputMaybe<ApplicationUserApplicationUserPkeyConnect>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  connectByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyConnect>;
  /** A `ApplicationUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdApplicationUserCreateInput>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByEmail?: InputMaybe<ApplicationUserApplicationUserEmailKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByGlobalUserId?: InputMaybe<ApplicationUserApplicationUserGlobalUserIdKeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteById?: InputMaybe<ApplicationUserApplicationUserPkeyDelete>;
  /** The primary key(s) for `applicationUser` for the far side of the relationship. */
  deleteByUsername?: InputMaybe<ApplicationUserApplicationUserUsernameKeyDelete>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByEmail?: InputMaybe<ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserEmailKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByGlobalUserId?: InputMaybe<ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateById?: InputMaybe<ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserPkeyUpdate>;
  /** The primary key(s) and patch data for `applicationUser` for the far side of the relationship. */
  updateByUsername?: InputMaybe<ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate>;
};

/** Input for the nested mutation of `workflowVersion` in the `ApplicationUserInput` mutation. */
export type WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput = {
  /** The primary key(s) for `workflowVersion` for the far side of the relationship. */
  connectById?: InputMaybe<Array<WorkflowVersionWorkflowVersionPkeyConnect>>;
  /** A `WorkflowVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<WorkflowVersionUserId00C0F62FFkApplicationUserIdWorkflowVersionCreateInput>
  >;
  /** The primary key(s) for `workflowVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<WorkflowVersionWorkflowVersionPkeyDelete>>;
  /** Flag indicating whether all other `workflowVersion` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `workflowVersion` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<WorkflowVersionOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingWorkflowVersionPkeyUpdate>
  >;
};

/** The `workflowVersion` to be created by this mutation. */
export type WorkflowVersionUserId00C0F62FFkApplicationUserIdWorkflowVersionCreateInput =
  {
    applicationUserToUserId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInput>;
    autoGenerated: Scalars["Boolean"]["input"];
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    draft: Scalars["Boolean"]["input"];
    id: Scalars["UUID"]["input"];
    name: Scalars["String"]["input"];
    workflowId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInverseInput>;
    workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInverseInput>;
    workflowSourceWorkflowVersionsUsingId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInverseInput>;
    workflowToWorkflowId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInput>;
  };

/** Input for the nested mutation of `workflow` in the `WorkflowVersionInput` mutation. */
export type WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInput = {
  /** The primary key(s) for `workflow` for the far side of the relationship. */
  connectById?: InputMaybe<WorkflowWorkflowPkeyConnect>;
  /** A `WorkflowInput` object that will be created and connected to this object. */
  create?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdWorkflowCreateInput>;
  /** The primary key(s) for `workflow` for the far side of the relationship. */
  deleteById?: InputMaybe<WorkflowWorkflowPkeyDelete>;
  /** The primary key(s) and patch data for `workflow` for the far side of the relationship. */
  updateById?: InputMaybe<WorkflowOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdUsingWorkflowPkeyUpdate>;
};

/** Input for the nested mutation of `workflowVersion` in the `WorkflowInput` mutation. */
export type WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInverseInput = {
  /** The primary key(s) for `workflowVersion` for the far side of the relationship. */
  connectById?: InputMaybe<Array<WorkflowVersionWorkflowVersionPkeyConnect>>;
  /** A `WorkflowVersionInput` object that will be created and connected to this object. */
  create?: InputMaybe<
    Array<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdWorkflowVersionCreateInput>
  >;
  /** The primary key(s) for `workflowVersion` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<WorkflowVersionWorkflowVersionPkeyDelete>>;
  /** Flag indicating whether all other `workflowVersion` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** The primary key(s) and patch data for `workflowVersion` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<WorkflowVersionOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdUsingWorkflowVersionPkeyUpdate>
  >;
};

/** The `workflow` to be created by this mutation. */
export type WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdWorkflowCreateInput = {
  applicationUserToUserId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInput>;
  containerId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInput>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["UUID"]["input"];
  name: Scalars["String"]["input"];
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  workflowVersionsUsingId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInverseInput>;
};

/** The `workflowVersion` to be created by this mutation. */
export type WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdWorkflowVersionCreateInput =
  {
    applicationUserToUserId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInput>;
    autoGenerated: Scalars["Boolean"]["input"];
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    draft: Scalars["Boolean"]["input"];
    id: Scalars["UUID"]["input"];
    name: Scalars["String"]["input"];
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInverseInput>;
    workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInverseInput>;
    workflowSourceWorkflowVersionsUsingId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInverseInput>;
    workflowToWorkflowId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInput>;
  };

/** The fields on `workflowVersion` to look up the row to connect. */
export type WorkflowVersionWorkflowVersionPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `workflowVersion` to look up the row to delete. */
export type WorkflowVersionWorkflowVersionPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** A connection to a list of `WorkflowVersion` values. */
export type WorkflowVersionsConnection = {
  __typename: "WorkflowVersionsConnection";
  /** A list of edges which contains the `WorkflowVersion` and cursor to aid in pagination. */
  edges: Array<WorkflowVersionsEdge>;
  /** A list of `WorkflowVersion` objects. */
  nodes: Array<WorkflowVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorkflowVersion` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `WorkflowVersion` edge in the connection. */
export type WorkflowVersionsEdge = {
  __typename: "WorkflowVersionsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `WorkflowVersion` at the end of the edge. */
  node: WorkflowVersion;
};

/** Methods to use when ordering `WorkflowVersion`. */
export enum WorkflowVersionsOrderBy {
  AutoGeneratedAsc = "AUTO_GENERATED_ASC",
  AutoGeneratedDesc = "AUTO_GENERATED_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DescriptionAsc = "DESCRIPTION_ASC",
  DescriptionDesc = "DESCRIPTION_DESC",
  DraftAsc = "DRAFT_ASC",
  DraftDesc = "DRAFT_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
  WorkflowIdAsc = "WORKFLOW_ID_ASC",
  WorkflowIdDesc = "WORKFLOW_ID_DESC",
}

/** The fields on `workflow` to look up the row to connect. */
export type WorkflowWorkflowPkeyConnect = {
  id: Scalars["UUID"]["input"];
};

/** The fields on `workflow` to look up the row to delete. */
export type WorkflowWorkflowPkeyDelete = {
  id: Scalars["UUID"]["input"];
};

/** A connection to a list of `Workflow` values. */
export type WorkflowsConnection = {
  __typename: "WorkflowsConnection";
  /** A list of edges which contains the `Workflow` and cursor to aid in pagination. */
  edges: Array<WorkflowsEdge>;
  /** A list of `Workflow` objects. */
  nodes: Array<Workflow>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Workflow` you could get from the connection. */
  totalCount: Scalars["Int"]["output"];
};

/** A `Workflow` edge in the connection. */
export type WorkflowsEdge = {
  __typename: "WorkflowsEdge";
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars["Cursor"]["output"]>;
  /** The `Workflow` at the end of the edge. */
  node: Workflow;
};

/** Methods to use when ordering `Workflow`. */
export enum WorkflowsOrderBy {
  ContainerIdAsc = "CONTAINER_ID_ASC",
  ContainerIdDesc = "CONTAINER_ID_DESC",
  DateCreatedAsc = "DATE_CREATED_ASC",
  DateCreatedDesc = "DATE_CREATED_DESC",
  DescriptionAsc = "DESCRIPTION_ASC",
  DescriptionDesc = "DESCRIPTION_DESC",
  IdAsc = "ID_ASC",
  IdDesc = "ID_DESC",
  NameAsc = "NAME_ASC",
  NameDesc = "NAME_DESC",
  Natural = "NATURAL",
  PrimaryKeyAsc = "PRIMARY_KEY_ASC",
  PrimaryKeyDesc = "PRIMARY_KEY_DESC",
  TenantIdAsc = "TENANT_ID_ASC",
  TenantIdDesc = "TENANT_ID_DESC",
  UserIdAsc = "USER_ID_ASC",
  UserIdDesc = "USER_ID_DESC",
}

/** An object where the defined keys will be set on the `applicationUserGroup` being updated. */
export type UpdateApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInput>;
    authGroupToGroupId?: InputMaybe<ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `applicationUserGroup` being updated. */
export type UpdateApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInput>;
    authGroupToGroupId?: InputMaybe<ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInput>;
    groupId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
  };

/** An object where the defined keys will be set on the `applicationUserMembership` being updated. */
export type UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch =
  {
    applicationUserToUserId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    role?: InputMaybe<Scalars["Int"]["input"]>;
    sfLeadCreated?: InputMaybe<Scalars["Boolean"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `applicationUserMembership` being updated. */
export type UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    role?: InputMaybe<Scalars["Int"]["input"]>;
    sfLeadCreated?: InputMaybe<Scalars["Boolean"]["input"]>;
    tenantToTenantId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `applicationUserMetadatum` being updated. */
export type UpdateApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch =
  {
    applicationUserToUserId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    value?: InputMaybe<Scalars["String"]["input"]>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUser` being updated. */
export type UpdateApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput>;
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput>;
    applicationUserMetadataUsingId?: InputMaybe<ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput>;
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInverseInput>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput>;
    avatarUsingId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput>;
    cognitoTenantKey?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    emailMarketingConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInverseInput>;
    filesUsingId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInverseInput>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput>;
    globalUserId?: InputMaybe<Scalars["UUID"]["input"]>;
    homeRegion?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
    isStaff?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSuperuser?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput>;
    notificationsUsingId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInverseInput>;
    personalRegion?: InputMaybe<Scalars["String"]["input"]>;
    pinnedToolsUsingId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInverseInput>;
    projectClonedNotificationsUsingId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput>;
    projectSharedNotificationsToSharerIdUsingId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput>;
    projectSharedNotificationsToUserIdUsingId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInverseInput>;
    projectsUsingId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput>;
    tasksUsingId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToInviterIdUsingId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInverseInput>;
    tenantUserMembershipNotificationsToUserIdUsingId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput>;
    tenantUserexecutorToExecutorId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput>;
    userOrigin?: InputMaybe<Scalars["String"]["input"]>;
    userPersonalSpaceRequestsUsingId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInverseInput>;
  };

/** An object where the defined keys will be set on the `applicationUserSession` being updated. */
export type UpdateApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch =
  {
    active?: InputMaybe<Scalars["Boolean"]["input"]>;
    applicationUserToUserId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInput>;
    datetimeLastActive?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    lastPath?: InputMaybe<Scalars["String"]["input"]>;
    state?: InputMaybe<Scalars["JSON"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `applicationUserSession` being updated. */
export type UpdateApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch =
  {
    active?: InputMaybe<Scalars["Boolean"]["input"]>;
    applicationUserToUserId?: InputMaybe<ApplicationUserSesUserId2Fb30D0CFkApplicatiInput>;
    datetimeLastActive?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    lastPath?: InputMaybe<Scalars["String"]["input"]>;
    state?: InputMaybe<Scalars["JSON"]["input"]>;
    tenantToTenantId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `applicationUserUserPermission` being updated. */
export type UpdateApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermPatch =
  {
    applicationUserToUserId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInput>;
    authPermissionToPermissionId?: InputMaybe<ApplicationUserUsePermissionIdDbf9693DFkAuthPermInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `applicationUserUserPermission` being updated. */
export type UpdateApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiPatch =
  {
    applicationUserToUserId?: InputMaybe<ApplicationUserUseUserIdE643F548FkApplicatiInput>;
    authPermissionToPermissionId?: InputMaybe<ApplicationUserUsePermissionIdDbf9693DFkAuthPermInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    permissionId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditlogLogentry` being updated. */
export type UpdateAuditlogLogentryOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdPatch =
  {
    action?: InputMaybe<Scalars["Int"]["input"]>;
    actorEmail?: InputMaybe<Scalars["String"]["input"]>;
    additionalData?: InputMaybe<Scalars["JSON"]["input"]>;
    applicationUserToActorId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInput>;
    changes?: InputMaybe<Scalars["JSON"]["input"]>;
    changesText?: InputMaybe<Scalars["String"]["input"]>;
    cid?: InputMaybe<Scalars["String"]["input"]>;
    contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    objectId?: InputMaybe<Scalars["BigInt"]["input"]>;
    objectPk?: InputMaybe<Scalars["String"]["input"]>;
    objectRepr?: InputMaybe<Scalars["String"]["input"]>;
    remoteAddr?: InputMaybe<Scalars["InternetAddress"]["input"]>;
    remotePort?: InputMaybe<Scalars["Int"]["input"]>;
    serializedData?: InputMaybe<Scalars["JSON"]["input"]>;
    timestamp?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `auditlogLogentry` being updated. */
export type UpdateAuditlogLogentryOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoPatch =
  {
    action?: InputMaybe<Scalars["Int"]["input"]>;
    actorEmail?: InputMaybe<Scalars["String"]["input"]>;
    actorId?: InputMaybe<Scalars["UUID"]["input"]>;
    additionalData?: InputMaybe<Scalars["JSON"]["input"]>;
    applicationUserToActorId?: InputMaybe<AuditlogLogentryActorId959271D2FkApplicationUserIdInput>;
    changes?: InputMaybe<Scalars["JSON"]["input"]>;
    changesText?: InputMaybe<Scalars["String"]["input"]>;
    cid?: InputMaybe<Scalars["String"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    objectId?: InputMaybe<Scalars["BigInt"]["input"]>;
    objectPk?: InputMaybe<Scalars["String"]["input"]>;
    objectRepr?: InputMaybe<Scalars["String"]["input"]>;
    remoteAddr?: InputMaybe<Scalars["InternetAddress"]["input"]>;
    remotePort?: InputMaybe<Scalars["Int"]["input"]>;
    serializedData?: InputMaybe<Scalars["JSON"]["input"]>;
    timestamp?: InputMaybe<Scalars["Datetime"]["input"]>;
  };

/** An object where the defined keys will be set on the `authGroup` being updated. */
export type UpdateAuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInverseInput>;
    authGroupPermissionsUsingId?: InputMaybe<AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInverseInput>;
    featureFlagsGroupsUsingId?: InputMaybe<FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
  };

/** An object where the defined keys will be set on the `authGroup` being updated. */
export type UpdateAuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInverseInput>;
    authGroupPermissionsUsingId?: InputMaybe<AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInverseInput>;
    featureFlagsGroupsUsingId?: InputMaybe<FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
  };

/** An object where the defined keys will be set on the `authGroup` being updated. */
export type UpdateAuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdPatch =
  {
    applicationUserGroupsUsingId?: InputMaybe<ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInverseInput>;
    authGroupPermissionsUsingId?: InputMaybe<AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInverseInput>;
    featureFlagsGroupsUsingId?: InputMaybe<FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
  };

/** An object where the defined keys will be set on the `authGroupPermission` being updated. */
export type UpdateAuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermPatch =
  {
    authGroupToGroupId?: InputMaybe<AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInput>;
    authPermissionToPermissionId?: InputMaybe<AuthGroupPermissioPermissionId84C5C92EFkAuthPermInput>;
    groupId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
  };

/** An object where the defined keys will be set on the `authGroupPermission` being updated. */
export type UpdateAuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdPatch =
  {
    authGroupToGroupId?: InputMaybe<AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInput>;
    authPermissionToPermissionId?: InputMaybe<AuthGroupPermissioPermissionId84C5C92EFkAuthPermInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    permissionId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `authPermission` being updated. */
export type UpdateAuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermPatch =
  {
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUsePermissionIdDbf9693DFkAuthPermInverseInput>;
    authGroupPermissionsUsingId?: InputMaybe<AuthGroupPermissioPermissionId84C5C92EFkAuthPermInverseInput>;
    codename?: InputMaybe<Scalars["String"]["input"]>;
    contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
  };

/** An object where the defined keys will be set on the `authPermission` being updated. */
export type UpdateAuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermPatch =
  {
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUsePermissionIdDbf9693DFkAuthPermInverseInput>;
    authGroupPermissionsUsingId?: InputMaybe<AuthGroupPermissioPermissionId84C5C92EFkAuthPermInverseInput>;
    codename?: InputMaybe<Scalars["String"]["input"]>;
    contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
  };

/** An object where the defined keys will be set on the `authPermission` being updated. */
export type UpdateAuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoPatch =
  {
    applicationUserUserPermissionsUsingId?: InputMaybe<ApplicationUserUsePermissionIdDbf9693DFkAuthPermInverseInput>;
    authGroupPermissionsUsingId?: InputMaybe<AuthGroupPermissioPermissionId84C5C92EFkAuthPermInverseInput>;
    codename?: InputMaybe<Scalars["String"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
  };

/** An object where the defined keys will be set on the `avatar` being updated. */
export type UpdateAvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<AvatarUserId771332F2FkApplicationUserIdInput>;
    color?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    imageBase64?: InputMaybe<Scalars["String"]["input"]>;
    initials?: InputMaybe<Scalars["String"]["input"]>;
    useImage?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

/** An object where the defined keys will be set on the `awsBatchTask` being updated. */
export type UpdateAwsBatchTaskOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskePatch =
  {
    awsDataBucketName?: InputMaybe<Scalars["String"]["input"]>;
    awsInstanceId?: InputMaybe<Scalars["String"]["input"]>;
    awsInstanceMemory?: InputMaybe<Scalars["Int"]["input"]>;
    awsInstanceType?: InputMaybe<Scalars["String"]["input"]>;
    awsInstanceVcpus?: InputMaybe<Scalars["Int"]["input"]>;
    awsJobId?: InputMaybe<Scalars["String"]["input"]>;
    awsJobQueue?: InputMaybe<Scalars["String"]["input"]>;
    awsJobStatus?: InputMaybe<Scalars["Int"]["input"]>;
    awsJobStatusReason?: InputMaybe<Scalars["String"]["input"]>;
    awsMockBatchTaskUsingTaskexecutorPtrId?: InputMaybe<AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInverseInput>;
    awsRegion?: InputMaybe<Scalars["String"]["input"]>;
    awsTaskPath?: InputMaybe<Scalars["String"]["input"]>;
    exitcode?: InputMaybe<Scalars["Int"]["input"]>;
    resultsProcessed?: InputMaybe<Scalars["Boolean"]["input"]>;
    tesTaskexecutorToTaskexecutorPtrId?: InputMaybe<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInput>;
  };

/** An object where the defined keys will be set on the `awsBatchTask` being updated. */
export type UpdateAwsBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchPatch =
  {
    awsDataBucketName?: InputMaybe<Scalars["String"]["input"]>;
    awsInstanceId?: InputMaybe<Scalars["String"]["input"]>;
    awsInstanceMemory?: InputMaybe<Scalars["Int"]["input"]>;
    awsInstanceType?: InputMaybe<Scalars["String"]["input"]>;
    awsInstanceVcpus?: InputMaybe<Scalars["Int"]["input"]>;
    awsJobId?: InputMaybe<Scalars["String"]["input"]>;
    awsJobQueue?: InputMaybe<Scalars["String"]["input"]>;
    awsJobStatus?: InputMaybe<Scalars["Int"]["input"]>;
    awsJobStatusReason?: InputMaybe<Scalars["String"]["input"]>;
    awsMockBatchTaskUsingTaskexecutorPtrId?: InputMaybe<AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInverseInput>;
    awsRegion?: InputMaybe<Scalars["String"]["input"]>;
    awsTaskPath?: InputMaybe<Scalars["String"]["input"]>;
    exitcode?: InputMaybe<Scalars["Int"]["input"]>;
    resultsProcessed?: InputMaybe<Scalars["Boolean"]["input"]>;
    taskexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
    tesTaskexecutorToTaskexecutorPtrId?: InputMaybe<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInput>;
  };

/** An object where the defined keys will be set on the `awsCognitoUser` being updated. */
export type UpdateAwsCognitoUserOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsPatch =
  {
    awsMockIamUserUsingUserexecutorPtrId?: InputMaybe<AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInverseInput>;
    tenantUserexecutorToUserexecutorPtrId?: InputMaybe<AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInput>;
  };

/** An object where the defined keys will be set on the `awsCognitoUser` being updated. */
export type UpdateAwsCognitoUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniPatch =
  {
    awsMockIamUserUsingUserexecutorPtrId?: InputMaybe<AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInverseInput>;
    tenantUserexecutorToUserexecutorPtrId?: InputMaybe<AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInput>;
    userexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `awsEcrImage` being updated. */
export type UpdateAwsEcrImageOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaPatch =
  {
    awsMockEcrImageUsingContainerimageexecutorPtrId?: InputMaybe<AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInverseInput>;
    jobDefinitionName?: InputMaybe<Scalars["String"]["input"]>;
    jobDefinitionRevision?: InputMaybe<Scalars["Int"]["input"]>;
    repositoryArn?: InputMaybe<Scalars["String"]["input"]>;
    tesContainerimageexecutorToContainerimageexecutorPtrId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInput>;
  };

/** An object where the defined keys will be set on the `awsEcrImage` being updated. */
export type UpdateAwsEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIPatch =
  {
    awsMockEcrImageUsingContainerimageexecutorPtrId?: InputMaybe<AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInverseInput>;
    containerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
    jobDefinitionName?: InputMaybe<Scalars["String"]["input"]>;
    jobDefinitionRevision?: InputMaybe<Scalars["Int"]["input"]>;
    repositoryArn?: InputMaybe<Scalars["String"]["input"]>;
    tesContainerimageexecutorToContainerimageexecutorPtrId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInput>;
  };

/** An object where the defined keys will be set on the `awsMockBatchTask` being updated. */
export type UpdateAwsMockBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchPatch =
  {
    awsBatchTaskToAwstaskexecutorPtrId?: InputMaybe<AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInput>;
    containerName?: InputMaybe<Scalars["String"]["input"]>;
  };

/** An object where the defined keys will be set on the `awsMockDistributionImage` being updated. */
export type UpdateAwsMockDistributionImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributPatch =
  {
    distributionRegistryImageToDistributioncontainerimageexecutorPtrId?: InputMaybe<AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInput>;
  };

/** An object where the defined keys will be set on the `awsMockEcrImage` being updated. */
export type UpdateAwsMockEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIPatch =
  {
    awsEcrImageToAwscontainerimageexecutorPtrId?: InputMaybe<AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInput>;
  };

/** An object where the defined keys will be set on the `awsMockIamUser` being updated. */
export type UpdateAwsMockIamUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniPatch =
  {
    awsCognitoUserToAwsuserexecutorPtrId?: InputMaybe<AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInput>;
  };

/** An object where the defined keys will be set on the `awsMockS3File` being updated. */
export type UpdateAwsMockS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiPatch =
  {
    awsS3FileToAwsfileexecutorPtrId?: InputMaybe<AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInput>;
  };

/** An object where the defined keys will be set on the `awsS3File` being updated. */
export type UpdateAwsS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiPatch =
  {
    awsMockS3FileUsingFileexecutorPtrId?: InputMaybe<AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInverseInput>;
    awsUploadPath?: InputMaybe<Scalars["String"]["input"]>;
    drsFileexecutorToFileexecutorPtrId?: InputMaybe<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInput>;
    fileexecutorPtrId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `awsS3File` being updated. */
export type UpdateAwsS3FileOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdPatch =
  {
    awsMockS3FileUsingFileexecutorPtrId?: InputMaybe<AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInverseInput>;
    awsUploadPath?: InputMaybe<Scalars["String"]["input"]>;
    drsFileexecutorToFileexecutorPtrId?: InputMaybe<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInput>;
  };

/** An object where the defined keys will be set on the `codeFile` being updated. */
export type UpdateCodeFileOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdPatch =
  {
    applicationUserToUserId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    codeFileToSeriesParentId?: InputMaybe<CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput>;
    commandsUsingId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInverseInput>;
    compressed?: InputMaybe<Scalars["Boolean"]["input"]>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    drsFileexecutorToExecutorId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInput>;
    fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
    fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
    fileType?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    location?: InputMaybe<Scalars["String"]["input"]>;
    multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    originalName?: InputMaybe<Scalars["String"]["input"]>;
    partSize?: InputMaybe<Scalars["Int"]["input"]>;
    seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
    signal?: InputMaybe<Scalars["Int"]["input"]>;
    size?: InputMaybe<Scalars["BigInt"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInput>;
    uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `codeFile` being updated. */
export type UpdateCodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdPatch =
  {
    applicationUserToUserId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    codeFileToSeriesParentId?: InputMaybe<CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput>;
    commandsUsingId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInverseInput>;
    compressed?: InputMaybe<Scalars["Boolean"]["input"]>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    drsFileexecutorToExecutorId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInput>;
    executorId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
    fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
    fileType?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    location?: InputMaybe<Scalars["String"]["input"]>;
    multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    originalName?: InputMaybe<Scalars["String"]["input"]>;
    partSize?: InputMaybe<Scalars["Int"]["input"]>;
    signal?: InputMaybe<Scalars["Int"]["input"]>;
    size?: InputMaybe<Scalars["BigInt"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInput>;
    uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `codeFile` being updated. */
export type UpdateCodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch =
  {
    applicationUserToUserId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    codeFileToSeriesParentId?: InputMaybe<CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput>;
    commandsUsingId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInverseInput>;
    compressed?: InputMaybe<Scalars["Boolean"]["input"]>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    drsFileexecutorToExecutorId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInput>;
    executorId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
    fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
    fileType?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    location?: InputMaybe<Scalars["String"]["input"]>;
    multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    originalName?: InputMaybe<Scalars["String"]["input"]>;
    partSize?: InputMaybe<Scalars["Int"]["input"]>;
    seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
    signal?: InputMaybe<Scalars["Int"]["input"]>;
    size?: InputMaybe<Scalars["BigInt"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tenantToTenantId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInput>;
    uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `codeFile` being updated. */
export type UpdateCodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    codeFileToSeriesParentId?: InputMaybe<CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput>;
    commandsUsingId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInverseInput>;
    compressed?: InputMaybe<Scalars["Boolean"]["input"]>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    drsFileexecutorToExecutorId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInput>;
    executorId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
    fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
    fileType?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    location?: InputMaybe<Scalars["String"]["input"]>;
    multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    originalName?: InputMaybe<Scalars["String"]["input"]>;
    partSize?: InputMaybe<Scalars["Int"]["input"]>;
    seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
    signal?: InputMaybe<Scalars["Int"]["input"]>;
    size?: InputMaybe<Scalars["BigInt"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInput>;
    uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `codeFile` being updated. */
export type UpdateCodeFileOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdPatch =
  {
    applicationUserToUserId?: InputMaybe<CodeFileUserIdAb9E5143FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    codeFileToSeriesParentId?: InputMaybe<CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput>;
    commandsUsingId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInverseInput>;
    compressed?: InputMaybe<Scalars["Boolean"]["input"]>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    drsFileexecutorToExecutorId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInput>;
    executorId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
    fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
    fileType?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    location?: InputMaybe<Scalars["String"]["input"]>;
    multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    originalName?: InputMaybe<Scalars["String"]["input"]>;
    partSize?: InputMaybe<Scalars["Int"]["input"]>;
    seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
    signal?: InputMaybe<Scalars["Int"]["input"]>;
    size?: InputMaybe<Scalars["BigInt"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInput>;
    uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `command` being updated. */
export type UpdateCommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdPatch =
  {
    applicationUserToUserId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInput>;
    codeFileToCodeFileId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInput>;
    entryPoint?: InputMaybe<Scalars["String"]["input"]>;
    filePath?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    originalToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    programType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `command` being updated. */
export type UpdateCommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdPatch =
  {
    applicationUserToUserId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInput>;
    codeFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    codeFileToCodeFileId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInput>;
    containerImageToContainerImageId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInput>;
    entryPoint?: InputMaybe<Scalars["String"]["input"]>;
    filePath?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    originalToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    programType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `command` being updated. */
export type UpdateCommandOnCommandForCommandTenantId36F95C3CFkTenantIdPatch = {
  applicationUserToUserId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInput>;
  codeFileId?: InputMaybe<Scalars["UUID"]["input"]>;
  codeFileToCodeFileId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInput>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInput>;
  entryPoint?: InputMaybe<Scalars["String"]["input"]>;
  filePath?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  originalToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
  programType?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInput>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** An object where the defined keys will be set on the `command` being updated. */
export type UpdateCommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdPatch =
  {
    applicationUserToUserId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInput>;
    codeFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    codeFileToCodeFileId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInput>;
    entryPoint?: InputMaybe<Scalars["String"]["input"]>;
    filePath?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    originalToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    programType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInput>;
    toolVersionToToolVersionId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `command` being updated. */
export type UpdateCommandOnCommandForCommandUserId4A445414FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<CommandUserId4A445414FkApplicationUserIdInput>;
    codeFileId?: InputMaybe<Scalars["UUID"]["input"]>;
    codeFileToCodeFileId?: InputMaybe<CommandCodeFileIdE6Dc0F85FkCodeFileIdInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInput>;
    entryPoint?: InputMaybe<Scalars["String"]["input"]>;
    filePath?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    originalToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    programType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInput>;
  };

/** An object where the defined keys will be set on the `containerImage` being updated. */
export type UpdateContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
    containerImageRepositoryId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    label?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    readme?: InputMaybe<Scalars["String"]["input"]>;
    size?: InputMaybe<Scalars["BigInt"]["input"]>;
    spec?: InputMaybe<Scalars["JSON"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
    tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
  };

/** An object where the defined keys will be set on the `containerImage` being updated. */
export type UpdateContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerPatch =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
    containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    label?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    readme?: InputMaybe<Scalars["String"]["input"]>;
    size?: InputMaybe<Scalars["BigInt"]["input"]>;
    spec?: InputMaybe<Scalars["JSON"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
    tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
  };

/** An object where the defined keys will be set on the `containerImage` being updated. */
export type UpdateContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaPatch =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
    containerImageRepositoryId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    label?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    readme?: InputMaybe<Scalars["String"]["input"]>;
    size?: InputMaybe<Scalars["BigInt"]["input"]>;
    spec?: InputMaybe<Scalars["JSON"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
    tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
  };

/** An object where the defined keys will be set on the `containerImage` being updated. */
export type UpdateContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
    containerImageRepositoryId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    label?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    readme?: InputMaybe<Scalars["String"]["input"]>;
    size?: InputMaybe<Scalars["BigInt"]["input"]>;
    spec?: InputMaybe<Scalars["JSON"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
    tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
    tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
  };

/** An object where the defined keys will be set on the `containerImage` being updated. */
export type UpdateContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
    containerImageRepositoryId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    label?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    readme?: InputMaybe<Scalars["String"]["input"]>;
    size?: InputMaybe<Scalars["BigInt"]["input"]>;
    spec?: InputMaybe<Scalars["JSON"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
    tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
  };

/** An object where the defined keys will be set on the `containerImage` being updated. */
export type UpdateContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
    containerImageRepositoryId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    label?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    readme?: InputMaybe<Scalars["String"]["input"]>;
    size?: InputMaybe<Scalars["BigInt"]["input"]>;
    spec?: InputMaybe<Scalars["JSON"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
    tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
  };

/** An object where the defined keys will be set on the `containerImage` being updated. */
export type UpdateContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
    containerImageRepositoryId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    label?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    readme?: InputMaybe<Scalars["String"]["input"]>;
    size?: InputMaybe<Scalars["BigInt"]["input"]>;
    spec?: InputMaybe<Scalars["JSON"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
    tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
  };

/** An object where the defined keys will be set on the `containerImage` being updated. */
export type UpdateContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageUserId3919E673FkApplicationUserIdInput>;
    checksum?: InputMaybe<Scalars["String"]["input"]>;
    commandsUsingId?: InputMaybe<CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput>;
    containerImageRepositoryId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageRepositoryToContainerImageRepositoryId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateUpdated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    executorId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    label?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    readme?: InputMaybe<Scalars["String"]["input"]>;
    size?: InputMaybe<Scalars["BigInt"]["input"]>;
    spec?: InputMaybe<Scalars["JSON"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    tasksUsingId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInput>;
    tesContainerimageexecutorToExecutorId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowsUsingId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput>;
  };

/** An object where the defined keys will be set on the `containerImageRepository` being updated. */
export type UpdateContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerPatch =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    registryType?: InputMaybe<Scalars["Int"]["input"]>;
    repository?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    visibility?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `containerImageRepository` being updated. */
export type UpdateContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiPatch =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    registryType?: InputMaybe<Scalars["Int"]["input"]>;
    repository?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInput>;
    visibility?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `containerImageRepository` being updated. */
export type UpdateContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ContainerImageRepoUserIdAf9751AfFkApplicatiInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageContainerImageRepoBe6Ba4A8FkContainerInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    registryType?: InputMaybe<Scalars["Int"]["input"]>;
    repository?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    visibility?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `cost` being updated. */
export type UpdateCostOnCostForCostTenantId7Dcd58A7FkTenantIdPatch = {
  costType?: InputMaybe<Scalars["Int"]["input"]>;
  currency?: InputMaybe<Scalars["Int"]["input"]>;
  date?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInverseInput>;
  id?: InputMaybe<Scalars["BigInt"]["input"]>;
  platform?: InputMaybe<Scalars["Int"]["input"]>;
  rateCode?: InputMaybe<Scalars["String"]["input"]>;
  taskActivitiesUsingId?: InputMaybe<TaskActivityCostId49E66058FkCostIdInverseInput>;
  tenantToTenantId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInput>;
  value?: InputMaybe<Scalars["BigFloat"]["input"]>;
};

/** An object where the defined keys will be set on the `cost` being updated. */
export type UpdateCostOnFileActivityForFileActivityCostId2A88D90AFkCostIdPatch =
  {
    costType?: InputMaybe<Scalars["Int"]["input"]>;
    currency?: InputMaybe<Scalars["Int"]["input"]>;
    date?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInverseInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    platform?: InputMaybe<Scalars["Int"]["input"]>;
    rateCode?: InputMaybe<Scalars["String"]["input"]>;
    taskActivitiesUsingId?: InputMaybe<TaskActivityCostId49E66058FkCostIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInput>;
    value?: InputMaybe<Scalars["BigFloat"]["input"]>;
  };

/** An object where the defined keys will be set on the `cost` being updated. */
export type UpdateCostOnTaskActivityForTaskActivityCostId49E66058FkCostIdPatch =
  {
    costType?: InputMaybe<Scalars["Int"]["input"]>;
    currency?: InputMaybe<Scalars["Int"]["input"]>;
    date?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInverseInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    platform?: InputMaybe<Scalars["Int"]["input"]>;
    rateCode?: InputMaybe<Scalars["String"]["input"]>;
    taskActivitiesUsingId?: InputMaybe<TaskActivityCostId49E66058FkCostIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInput>;
    value?: InputMaybe<Scalars["BigFloat"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableCell` being updated. */
export type UpdateDataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdPatch =
  {
    dataTableColumnToColumnId?: InputMaybe<DataTableCellColumnId9A5117BdFkDataTableColumnIdInput>;
    dataTableRowToRowId?: InputMaybe<DataTableCellRowId3A3C7567FkDataTableRowIdInput>;
    dataTableToTableId?: InputMaybe<DataTableCellTableId12E87426FkDataTableIdInput>;
    formula?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInput>;
    rowId?: InputMaybe<Scalars["UUID"]["input"]>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableCell` being updated. */
export type UpdateDataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdPatch =
  {
    columnId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableColumnToColumnId?: InputMaybe<DataTableCellColumnId9A5117BdFkDataTableColumnIdInput>;
    dataTableRowToRowId?: InputMaybe<DataTableCellRowId3A3C7567FkDataTableRowIdInput>;
    dataTableToTableId?: InputMaybe<DataTableCellTableId12E87426FkDataTableIdInput>;
    formula?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInput>;
    rowId?: InputMaybe<Scalars["UUID"]["input"]>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableCell` being updated. */
export type UpdateDataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdPatch =
  {
    columnId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableColumnToColumnId?: InputMaybe<DataTableCellColumnId9A5117BdFkDataTableColumnIdInput>;
    dataTableRowToRowId?: InputMaybe<DataTableCellRowId3A3C7567FkDataTableRowIdInput>;
    dataTableToTableId?: InputMaybe<DataTableCellTableId12E87426FkDataTableIdInput>;
    formula?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableCell` being updated. */
export type UpdateDataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdPatch =
  {
    columnId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableColumnToColumnId?: InputMaybe<DataTableCellColumnId9A5117BdFkDataTableColumnIdInput>;
    dataTableRowToRowId?: InputMaybe<DataTableCellRowId3A3C7567FkDataTableRowIdInput>;
    dataTableToTableId?: InputMaybe<DataTableCellTableId12E87426FkDataTableIdInput>;
    formula?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInput>;
    rowId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionBoolean` being updated. */
export type UpdateDataTableColumnDefinitionBooleanOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIPatch =
  {
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInput>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionCellStatus` being updated. */
export type UpdateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoPatch =
  {
    cellSetFileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    djangoContentTypeToCellSetFileColumnTypeId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInput>;
    djangoContentTypeToEventSetFileColumnTypeId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInput>;
    djangoContentTypeToQcReportFileColumnTypeId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInput>;
    eventSetFileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    eventSetFileColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInput>;
    qcReportFileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    qcReportFileColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionCellStatus` being updated. */
export type UpdateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoPatch =
  {
    cellSetFileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    cellSetFileColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToCellSetFileColumnTypeId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInput>;
    djangoContentTypeToEventSetFileColumnTypeId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInput>;
    djangoContentTypeToQcReportFileColumnTypeId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInput>;
    eventSetFileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInput>;
    qcReportFileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    qcReportFileColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionCellStatus` being updated. */
export type UpdateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIPatch =
  {
    cellSetFileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    cellSetFileColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToCellSetFileColumnTypeId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInput>;
    djangoContentTypeToEventSetFileColumnTypeId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInput>;
    djangoContentTypeToQcReportFileColumnTypeId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInput>;
    eventSetFileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    eventSetFileColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInput>;
    qcReportFileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    qcReportFileColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionCellStatus` being updated. */
export type UpdateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoPatch =
  {
    cellSetFileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    cellSetFileColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToCellSetFileColumnTypeId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInput>;
    djangoContentTypeToEventSetFileColumnTypeId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInput>;
    djangoContentTypeToQcReportFileColumnTypeId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInput>;
    eventSetFileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    eventSetFileColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInput>;
    qcReportFileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionChoice` being updated. */
export type UpdateDataTableColumnDefinitionChoiceOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIPatch =
  {
    choices?: InputMaybe<Scalars["JSON"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInput>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionDate` being updated. */
export type UpdateDataTableColumnDefinitionDateOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIPatch =
  {
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInput>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionFile` being updated. */
export type UpdateDataTableColumnDefinitionFileOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIPatch =
  {
    fileFormats?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    fileTypes?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    multiple?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInput>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionFloat` being updated. */
export type UpdateDataTableColumnDefinitionFloatOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIPatch =
  {
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    max?: InputMaybe<Scalars["Float"]["input"]>;
    min?: InputMaybe<Scalars["Float"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInput>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionIdentifier` being updated. */
export type UpdateDataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIPatch =
  {
    djangoContentTypeToTableTypeId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    tableTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionIdentifier` being updated. */
export type UpdateDataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoPatch =
  {
    djangoContentTypeToTableTypeId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionInteger` being updated. */
export type UpdateDataTableColumnDefinitionIntegerOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIPatch =
  {
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    max?: InputMaybe<Scalars["BigInt"]["input"]>;
    min?: InputMaybe<Scalars["BigInt"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInput>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionJoin` being updated. */
export type UpdateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoPatch =
  {
    djangoContentTypeToLeftColumnTypeId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInput>;
    djangoContentTypeToRightColumnTypeId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInput>;
    djangoContentTypeToSourceColumnTypeId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    leftColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInput>;
    rightColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    rightColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    sourceColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    sourceColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionJoin` being updated. */
export type UpdateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIPatch =
  {
    djangoContentTypeToLeftColumnTypeId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInput>;
    djangoContentTypeToRightColumnTypeId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInput>;
    djangoContentTypeToSourceColumnTypeId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    leftColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    leftColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInput>;
    rightColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    rightColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    sourceColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    sourceColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionJoin` being updated. */
export type UpdateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoPatch =
  {
    djangoContentTypeToLeftColumnTypeId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInput>;
    djangoContentTypeToRightColumnTypeId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInput>;
    djangoContentTypeToSourceColumnTypeId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    leftColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    leftColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInput>;
    rightColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    sourceColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    sourceColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionJoin` being updated. */
export type UpdateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoPatch =
  {
    djangoContentTypeToLeftColumnTypeId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInput>;
    djangoContentTypeToRightColumnTypeId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInput>;
    djangoContentTypeToSourceColumnTypeId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    leftColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    leftColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInput>;
    rightColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    rightColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    sourceColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionMetadatum` being updated. */
export type UpdateDataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoPatch =
  {
    djangoContentTypeToFileColumnTypeId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInput>;
    fileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumKey?: InputMaybe<Scalars["String"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInput>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionMetadatum` being updated. */
export type UpdateDataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIPatch =
  {
    djangoContentTypeToFileColumnTypeId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInput>;
    fileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumKey?: InputMaybe<Scalars["String"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInput>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionRoiFrame` being updated. */
export type UpdateDataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoPatch =
  {
    boundingBox?: InputMaybe<Scalars["JSON"]["input"]>;
    djangoContentTypeToFileColumnTypeId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInput>;
    fileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    groups?: InputMaybe<Scalars["JSON"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    overlap?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInput>;
    sourceFileData?: InputMaybe<Scalars["JSON"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionRoiFrame` being updated. */
export type UpdateDataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIPatch =
  {
    boundingBox?: InputMaybe<Scalars["JSON"]["input"]>;
    djangoContentTypeToFileColumnTypeId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInput>;
    fileColumnId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileColumnTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    groups?: InputMaybe<Scalars["JSON"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    overlap?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInput>;
    sourceFileData?: InputMaybe<Scalars["JSON"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnDefinitionText` being updated. */
export type UpdateDataTableColumnDefinitionTextOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIPatch =
  {
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    maxLength?: InputMaybe<Scalars["Int"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInput>;
  };

/** An object where the defined keys will be set on the `dataTableColumnGroupDefinitionJoin` being updated. */
export type UpdateDataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIPatch =
  {
    djangoContentTypeToTableTypeId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    tableTypeId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnGroupDefinitionJoin` being updated. */
export type UpdateDataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoPatch =
  {
    djangoContentTypeToTableTypeId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnGroupDefinitionSource` being updated. */
export type UpdateDataTableColumnGroupDefinitionSourceOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIPatch =
  {
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInput>;
  };

/** An object where the defined keys will be set on the `dataTableColumnGroup` being updated. */
export type UpdateDataTableColumnGroupOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnGroupIdAbcd4Ec0FkDataTablInverseInput>;
    dataTableToTableId?: InputMaybe<DataTableColumnGroupTableId46C58CccFkDataTableIdInput>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnGroup` being updated. */
export type UpdateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnGroupIdAbcd4Ec0FkDataTablInverseInput>;
    dataTableToTableId?: InputMaybe<DataTableColumnGroupTableId46C58CccFkDataTableIdInput>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnGroup` being updated. */
export type UpdateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnGroupIdAbcd4Ec0FkDataTablInverseInput>;
    dataTableToTableId?: InputMaybe<DataTableColumnGroupTableId46C58CccFkDataTableIdInput>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnGroup` being updated. */
export type UpdateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnGroupIdAbcd4Ec0FkDataTablInverseInput>;
    dataTableToTableId?: InputMaybe<DataTableColumnGroupTableId46C58CccFkDataTableIdInput>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumnGroup` being updated. */
export type UpdateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnGroupIdAbcd4Ec0FkDataTablInverseInput>;
    dataTableToTableId?: InputMaybe<DataTableColumnGroupTableId46C58CccFkDataTableIdInput>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumn` being updated. */
export type UpdateDataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellColumnId9A5117BdFkDataTableColumnIdInverseInput>;
    dataTableColumnGroupToGroupId?: InputMaybe<DataTableColumnGroupIdAbcd4Ec0FkDataTablInput>;
    dataTableToTableId?: InputMaybe<DataTableColumnTableIdF295C823FkDataTableIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    deletable?: InputMaybe<Scalars["Boolean"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInput>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    groupId?: InputMaybe<Scalars["UUID"]["input"]>;
    helpText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    identifierPosition?: InputMaybe<Scalars["Int"]["input"]>;
    isIdColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    pinned?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    width?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumn` being updated. */
export type UpdateDataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellColumnId9A5117BdFkDataTableColumnIdInverseInput>;
    dataTableColumnGroupToGroupId?: InputMaybe<DataTableColumnGroupIdAbcd4Ec0FkDataTablInput>;
    dataTableToTableId?: InputMaybe<DataTableColumnTableIdF295C823FkDataTableIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    deletable?: InputMaybe<Scalars["Boolean"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInput>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    groupId?: InputMaybe<Scalars["UUID"]["input"]>;
    helpText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    identifierPosition?: InputMaybe<Scalars["Int"]["input"]>;
    isIdColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    pinned?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    width?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumn` being updated. */
export type UpdateDataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellColumnId9A5117BdFkDataTableColumnIdInverseInput>;
    dataTableColumnGroupToGroupId?: InputMaybe<DataTableColumnGroupIdAbcd4Ec0FkDataTablInput>;
    dataTableToTableId?: InputMaybe<DataTableColumnTableIdF295C823FkDataTableIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    deletable?: InputMaybe<Scalars["Boolean"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInput>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    helpText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    identifierPosition?: InputMaybe<Scalars["Int"]["input"]>;
    isIdColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    pinned?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    width?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumn` being updated. */
export type UpdateDataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellColumnId9A5117BdFkDataTableColumnIdInverseInput>;
    dataTableColumnGroupToGroupId?: InputMaybe<DataTableColumnGroupIdAbcd4Ec0FkDataTablInput>;
    dataTableToTableId?: InputMaybe<DataTableColumnTableIdF295C823FkDataTableIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    deletable?: InputMaybe<Scalars["Boolean"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInput>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    groupId?: InputMaybe<Scalars["UUID"]["input"]>;
    helpText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    identifierPosition?: InputMaybe<Scalars["Int"]["input"]>;
    isIdColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    pinned?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    width?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumn` being updated. */
export type UpdateDataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellColumnId9A5117BdFkDataTableColumnIdInverseInput>;
    dataTableColumnGroupToGroupId?: InputMaybe<DataTableColumnGroupIdAbcd4Ec0FkDataTablInput>;
    dataTableToTableId?: InputMaybe<DataTableColumnTableIdF295C823FkDataTableIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    deletable?: InputMaybe<Scalars["Boolean"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInput>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    groupId?: InputMaybe<Scalars["UUID"]["input"]>;
    helpText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    identifierPosition?: InputMaybe<Scalars["Int"]["input"]>;
    isIdColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    pinned?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    width?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableColumn` being updated. */
export type UpdateDataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableColumnUserId57054882FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellColumnId9A5117BdFkDataTableColumnIdInverseInput>;
    dataTableColumnGroupToGroupId?: InputMaybe<DataTableColumnGroupIdAbcd4Ec0FkDataTablInput>;
    dataTableToTableId?: InputMaybe<DataTableColumnTableIdF295C823FkDataTableIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    deletable?: InputMaybe<Scalars["Boolean"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInput>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    groupId?: InputMaybe<Scalars["UUID"]["input"]>;
    helpText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    identifierPosition?: InputMaybe<Scalars["Int"]["input"]>;
    isIdColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    pinned?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    width?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTable` being updated. */
export type UpdateDataTableOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellTableId12E87426FkDataTableIdInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupTableId46C58CccFkDataTableIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnTableIdF295C823FkDataTableIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowTableIdF77C2D36FkDataTableIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    folderId?: InputMaybe<Scalars["UUID"]["input"]>;
    hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectFolderToFolderId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTable` being updated. */
export type UpdateDataTableOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellTableId12E87426FkDataTableIdInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupTableId46C58CccFkDataTableIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnTableIdF295C823FkDataTableIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowTableIdF77C2D36FkDataTableIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    folderId?: InputMaybe<Scalars["UUID"]["input"]>;
    hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectFolderToFolderId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTable` being updated. */
export type UpdateDataTableOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellTableId12E87426FkDataTableIdInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupTableId46C58CccFkDataTableIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnTableIdF295C823FkDataTableIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowTableIdF77C2D36FkDataTableIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    folderId?: InputMaybe<Scalars["UUID"]["input"]>;
    hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectFolderToFolderId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTable` being updated. */
export type UpdateDataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellTableId12E87426FkDataTableIdInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupTableId46C58CccFkDataTableIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnTableIdF295C823FkDataTableIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowTableIdF77C2D36FkDataTableIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectFolderToFolderId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTable` being updated. */
export type UpdateDataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellTableId12E87426FkDataTableIdInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupTableId46C58CccFkDataTableIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnTableIdF295C823FkDataTableIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowTableIdF77C2D36FkDataTableIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    folderId?: InputMaybe<Scalars["UUID"]["input"]>;
    hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectFolderToFolderId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInput>;
    projectToProjectId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTable` being updated. */
export type UpdateDataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellTableId12E87426FkDataTableIdInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupTableId46C58CccFkDataTableIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnTableIdF295C823FkDataTableIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowTableIdF77C2D36FkDataTableIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    folderId?: InputMaybe<Scalars["UUID"]["input"]>;
    hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectFolderToFolderId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInput>;
  };

/** An object where the defined keys will be set on the `dataTable` being updated. */
export type UpdateDataTableOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableUserIdAb79B056FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellTableId12E87426FkDataTableIdInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupTableId46C58CccFkDataTableIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnTableIdF295C823FkDataTableIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowTableIdF77C2D36FkDataTableIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    folderId?: InputMaybe<Scalars["UUID"]["input"]>;
    hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectFolderToFolderId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableRow` being updated. */
export type UpdateDataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellRowId3A3C7567FkDataTableRowIdInverseInput>;
    dataTableToTableId?: InputMaybe<DataTableRowTableIdF77C2D36FkDataTableIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    index?: InputMaybe<Scalars["Int"]["input"]>;
    joinable?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableRow` being updated. */
export type UpdateDataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellRowId3A3C7567FkDataTableRowIdInverseInput>;
    dataTableToTableId?: InputMaybe<DataTableRowTableIdF77C2D36FkDataTableIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    index?: InputMaybe<Scalars["Int"]["input"]>;
    joinable?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableRow` being updated. */
export type UpdateDataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellRowId3A3C7567FkDataTableRowIdInverseInput>;
    dataTableToTableId?: InputMaybe<DataTableRowTableIdF77C2D36FkDataTableIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    index?: InputMaybe<Scalars["Int"]["input"]>;
    joinable?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `dataTableRow` being updated. */
export type UpdateDataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<DataTableRowUserId3C5E98E5FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellRowId3A3C7567FkDataTableRowIdInverseInput>;
    dataTableToTableId?: InputMaybe<DataTableRowTableIdF77C2D36FkDataTableIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    index?: InputMaybe<Scalars["Int"]["input"]>;
    joinable?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `distributionRegistryImage` being updated. */
export type UpdateDistributionRegistryImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributPatch =
  {
    awsMockDistributionImageUsingContainerimageexecutorPtrId?: InputMaybe<AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInverseInput>;
    containerimageexecutorPtrId?: InputMaybe<Scalars["Int"]["input"]>;
    jobDefinitionName?: InputMaybe<Scalars["String"]["input"]>;
    jobDefinitionRevision?: InputMaybe<Scalars["Int"]["input"]>;
    tesContainerimageexecutorToContainerimageexecutorPtrId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInput>;
  };

/** An object where the defined keys will be set on the `distributionRegistryImage` being updated. */
export type UpdateDistributionRegistryImageOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaPatch =
  {
    awsMockDistributionImageUsingContainerimageexecutorPtrId?: InputMaybe<AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInverseInput>;
    jobDefinitionName?: InputMaybe<Scalars["String"]["input"]>;
    jobDefinitionRevision?: InputMaybe<Scalars["Int"]["input"]>;
    tesContainerimageexecutorToContainerimageexecutorPtrId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInput>;
  };

/** An object where the defined keys will be set on the `djangoAdminLog` being updated. */
export type UpdateDjangoAdminLogOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoPatch =
  {
    actionFlag?: InputMaybe<Scalars["Int"]["input"]>;
    actionTime?: InputMaybe<Scalars["Datetime"]["input"]>;
    applicationUserToUserId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInput>;
    changeMessage?: InputMaybe<Scalars["String"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    objectId?: InputMaybe<Scalars["String"]["input"]>;
    objectRepr?: InputMaybe<Scalars["String"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `djangoAdminLog` being updated. */
export type UpdateDjangoAdminLogOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdPatch =
  {
    actionFlag?: InputMaybe<Scalars["Int"]["input"]>;
    actionTime?: InputMaybe<Scalars["Datetime"]["input"]>;
    applicationUserToUserId?: InputMaybe<DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInput>;
    changeMessage?: InputMaybe<Scalars["String"]["input"]>;
    contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    objectId?: InputMaybe<Scalars["String"]["input"]>;
    objectRepr?: InputMaybe<Scalars["String"]["input"]>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `djangoContentType` being updated. */
export type UpdateDjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoPatch =
  {
    appLabel?: InputMaybe<Scalars["String"]["input"]>;
    auditlogLogentriesUsingId?: InputMaybe<AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput>;
    authPermissionsUsingId?: InputMaybe<AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToCellSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToEventSetFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput>;
    dataTableColumnDefinitionCellStatusesToQcReportFileColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToLeftColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToRightColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionJoinsToSourceColumnTypeIdUsingId?: InputMaybe<DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput>;
    djangoAdminLogsUsingId?: InputMaybe<DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput>;
    drsFileexecutorsUsingId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
    tenantUserexecutorsUsingId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput>;
    tesContainerimageexecutorsUsingId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput>;
    tesTaskexecutorsUsingId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput>;
  };

/** An object where the defined keys will be set on the `drsFileexecutor` being updated. */
export type UpdateDrsFileexecutorOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdPatch =
  {
    awsS3FileUsingId?: InputMaybe<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInput>;
    drsMockfileexecutorUsingId?: InputMaybe<DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInverseInput>;
    filesUsingId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `drsFileexecutor` being updated. */
export type UpdateDrsFileexecutorOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdPatch =
  {
    awsS3FileUsingId?: InputMaybe<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInput>;
    drsMockfileexecutorUsingId?: InputMaybe<DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInverseInput>;
    filesUsingId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `drsFileexecutor` being updated. */
export type UpdateDrsFileexecutorOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoPatch =
  {
    awsS3FileUsingId?: InputMaybe<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInput>;
    drsMockfileexecutorUsingId?: InputMaybe<DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInverseInput>;
    filesUsingId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `drsFileexecutor` being updated. */
export type UpdateDrsFileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileePatch =
  {
    awsS3FileUsingId?: InputMaybe<AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInput>;
    drsMockfileexecutorUsingId?: InputMaybe<DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInverseInput>;
    filesUsingId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `drsMockfileexecutor` being updated. */
export type UpdateDrsMockfileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileePatch =
  {
    drsFileexecutorToFileexecutorPtrId?: InputMaybe<DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInput>;
  };

/** An object where the defined keys will be set on the `eulaVersion` being updated. */
export type UpdateEulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch =
  {
    content?: InputMaybe<Scalars["String"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateVersion?: InputMaybe<Scalars["Datetime"]["input"]>;
    eulaVersionUserAcceptancesUsingId?: InputMaybe<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    version?: InputMaybe<Scalars["String"]["input"]>;
  };

/** An object where the defined keys will be set on the `eulaVersionUserAcceptance` being updated. */
export type UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch =
  {
    accepted?: InputMaybe<Scalars["Boolean"]["input"]>;
    applicationUserToUserId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput>;
    dateReviewed?: InputMaybe<Scalars["Datetime"]["input"]>;
    eulaVersionToEulaVersionId?: InputMaybe<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `eulaVersionUserAcceptance` being updated. */
export type UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch =
  {
    accepted?: InputMaybe<Scalars["Boolean"]["input"]>;
    applicationUserToUserId?: InputMaybe<EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput>;
    dateReviewed?: InputMaybe<Scalars["Datetime"]["input"]>;
    eulaVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    eulaVersionToEulaVersionId?: InputMaybe<EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `featureFlag` being updated. */
export type UpdateFeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFPatch =
  {
    authenticated?: InputMaybe<Scalars["Boolean"]["input"]>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    everyone?: InputMaybe<Scalars["Boolean"]["input"]>;
    featureFlagsGroupsUsingId?: InputMaybe<FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInverseInput>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInverseInput>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInverseInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    languages?: InputMaybe<Scalars["String"]["input"]>;
    modified?: InputMaybe<Scalars["Datetime"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    note?: InputMaybe<Scalars["String"]["input"]>;
    percent?: InputMaybe<Scalars["BigFloat"]["input"]>;
    rollout?: InputMaybe<Scalars["Boolean"]["input"]>;
    staff?: InputMaybe<Scalars["Boolean"]["input"]>;
    superusers?: InputMaybe<Scalars["Boolean"]["input"]>;
    testing?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

/** An object where the defined keys will be set on the `featureFlag` being updated. */
export type UpdateFeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFPatch =
  {
    authenticated?: InputMaybe<Scalars["Boolean"]["input"]>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    everyone?: InputMaybe<Scalars["Boolean"]["input"]>;
    featureFlagsGroupsUsingId?: InputMaybe<FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInverseInput>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInverseInput>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInverseInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    languages?: InputMaybe<Scalars["String"]["input"]>;
    modified?: InputMaybe<Scalars["Datetime"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    note?: InputMaybe<Scalars["String"]["input"]>;
    percent?: InputMaybe<Scalars["BigFloat"]["input"]>;
    rollout?: InputMaybe<Scalars["Boolean"]["input"]>;
    staff?: InputMaybe<Scalars["Boolean"]["input"]>;
    superusers?: InputMaybe<Scalars["Boolean"]["input"]>;
    testing?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

/** An object where the defined keys will be set on the `featureFlag` being updated. */
export type UpdateFeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdPatch =
  {
    authenticated?: InputMaybe<Scalars["Boolean"]["input"]>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    everyone?: InputMaybe<Scalars["Boolean"]["input"]>;
    featureFlagsGroupsUsingId?: InputMaybe<FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInverseInput>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInverseInput>;
    featureFlagsUsersUsingId?: InputMaybe<FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInverseInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    languages?: InputMaybe<Scalars["String"]["input"]>;
    modified?: InputMaybe<Scalars["Datetime"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    note?: InputMaybe<Scalars["String"]["input"]>;
    percent?: InputMaybe<Scalars["BigFloat"]["input"]>;
    rollout?: InputMaybe<Scalars["Boolean"]["input"]>;
    staff?: InputMaybe<Scalars["Boolean"]["input"]>;
    superusers?: InputMaybe<Scalars["Boolean"]["input"]>;
    testing?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

/** An object where the defined keys will be set on the `featureFlagsGroup` being updated. */
export type UpdateFeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFPatch =
  {
    authGroupToGroupId?: InputMaybe<FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInput>;
    featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInput>;
    groupId?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
  };

/** An object where the defined keys will be set on the `featureFlagsGroup` being updated. */
export type UpdateFeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdPatch =
  {
    authGroupToGroupId?: InputMaybe<FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInput>;
    featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInput>;
    featureflagId?: InputMaybe<Scalars["BigInt"]["input"]>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
  };

/** An object where the defined keys will be set on the `featureFlagsTenant` being updated. */
export type UpdateFeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFPatch =
  {
    featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `featureFlagsTenant` being updated. */
export type UpdateFeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdPatch =
  {
    featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInput>;
    featureflagId?: InputMaybe<Scalars["BigInt"]["input"]>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    tenantToTenantId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `featureFlagsUser` being updated. */
export type UpdateFeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdPatch =
  {
    applicationUserToUserId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInput>;
    featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `featureFlagsUser` being updated. */
export type UpdateFeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInput>;
    featureFlagToFeatureflagId?: InputMaybe<FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInput>;
    featureflagId?: InputMaybe<Scalars["BigInt"]["input"]>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
  };

/** An object where the defined keys will be set on the `fileActivity` being updated. */
export type UpdateFileActivityOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoPatch =
  {
    activityType?: InputMaybe<Scalars["Int"]["input"]>;
    applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
    bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
    comment?: InputMaybe<Scalars["String"]["input"]>;
    costId?: InputMaybe<Scalars["BigInt"]["input"]>;
    costToCostId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInput>;
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    objectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `fileActivity` being updated. */
export type UpdateFileActivityOnFileActivityForFileActivityCostId2A88D90AFkCostIdPatch =
  {
    activityType?: InputMaybe<Scalars["Int"]["input"]>;
    applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
    bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
    comment?: InputMaybe<Scalars["String"]["input"]>;
    contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    costToCostId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInput>;
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    objectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `fileActivity` being updated. */
export type UpdateFileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdPatch =
  {
    activityType?: InputMaybe<Scalars["Int"]["input"]>;
    applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
    bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
    comment?: InputMaybe<Scalars["String"]["input"]>;
    contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    costId?: InputMaybe<Scalars["BigInt"]["input"]>;
    costToCostId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInput>;
    fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    objectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `fileActivity` being updated. */
export type UpdateFileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch =
  {
    activityType?: InputMaybe<Scalars["Int"]["input"]>;
    applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
    bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
    comment?: InputMaybe<Scalars["String"]["input"]>;
    contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    costId?: InputMaybe<Scalars["BigInt"]["input"]>;
    costToCostId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInput>;
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    objectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `fileActivity` being updated. */
export type UpdateFileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch =
  {
    activityType?: InputMaybe<Scalars["Int"]["input"]>;
    applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
    bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
    comment?: InputMaybe<Scalars["String"]["input"]>;
    contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    costId?: InputMaybe<Scalars["BigInt"]["input"]>;
    costToCostId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInput>;
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    objectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
    tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `fileActivity` being updated. */
export type UpdateFileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch =
  {
    activityType?: InputMaybe<Scalars["Int"]["input"]>;
    applicationUserToUserId?: InputMaybe<FileActivityUserId868Ad8A9FkApplicationUserIdInput>;
    bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
    comment?: InputMaybe<Scalars["String"]["input"]>;
    contentTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    costId?: InputMaybe<Scalars["BigInt"]["input"]>;
    costToCostId?: InputMaybe<FileActivityCostId2A88D90AFkCostIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    djangoContentTypeToContentTypeId?: InputMaybe<FileActivityContentTypeIdD010Fc58FkDjangoCoInput>;
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileToFileId?: InputMaybe<FileActivityFileId015763A9FkFileIdInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    objectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `fileMetadatum` being updated. */
export type UpdateFileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileToFileId?: InputMaybe<FileMetadataFileId78256936FkFileIdInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `fileMetadatum` being updated. */
export type UpdateFileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileToFileId?: InputMaybe<FileMetadataFileId78256936FkFileIdInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `fileMetadatum` being updated. */
export type UpdateFileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileToFileId?: InputMaybe<FileMetadataFileId78256936FkFileIdInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInput>;
    projectToProjectId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `fileMetadatum` being updated. */
export type UpdateFileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileToFileId?: InputMaybe<FileMetadataFileId78256936FkFileIdInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInput>;
    tenantToTenantId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnFileActivityForFileActivityFileId015763A9FkFileIdPatch =
  {
    applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
    executorId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
    fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
    fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
    fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
    fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
    fileType?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    location?: InputMaybe<Scalars["String"]["input"]>;
    multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    originalName?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
    parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
    partSize?: InputMaybe<Scalars["Int"]["input"]>;
    preview?: InputMaybe<Scalars["JSON"]["input"]>;
    processingStatus?: InputMaybe<Scalars["Int"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
    referenceId?: InputMaybe<Scalars["UUID"]["input"]>;
    seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
    seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
    signal?: InputMaybe<Scalars["Int"]["input"]>;
    size?: InputMaybe<Scalars["BigInt"]["input"]>;
    source?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
    taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
    uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnFileForFileProjectId3Ecca975FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  originalName?: InputMaybe<Scalars["String"]["input"]>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus?: InputMaybe<Scalars["Int"]["input"]>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId?: InputMaybe<Scalars["UUID"]["input"]>;
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnFileForFileSeriesParentIdF7A07E20FkFileIdPatch = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  originalName?: InputMaybe<Scalars["String"]["input"]>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus?: InputMaybe<Scalars["Int"]["input"]>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId?: InputMaybe<Scalars["UUID"]["input"]>;
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnFileForFileTaskIdE4Da87AeFkTaskIdPatch = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  originalName?: InputMaybe<Scalars["String"]["input"]>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus?: InputMaybe<Scalars["Int"]["input"]>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId?: InputMaybe<Scalars["UUID"]["input"]>;
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnFileForFileTenantId61625016FkTenantIdPatch = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  originalName?: InputMaybe<Scalars["String"]["input"]>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus?: InputMaybe<Scalars["Int"]["input"]>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId?: InputMaybe<Scalars["UUID"]["input"]>;
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnFileForFileUserId01D90B53FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  originalName?: InputMaybe<Scalars["String"]["input"]>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus?: InputMaybe<Scalars["Int"]["input"]>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId?: InputMaybe<Scalars["UUID"]["input"]>;
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch =
  {
    applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
    executorId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
    fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
    fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
    fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
    fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
    fileType?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    location?: InputMaybe<Scalars["String"]["input"]>;
    multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    originalName?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
    parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
    partSize?: InputMaybe<Scalars["Int"]["input"]>;
    preview?: InputMaybe<Scalars["JSON"]["input"]>;
    processingStatus?: InputMaybe<Scalars["Int"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
    referenceId?: InputMaybe<Scalars["UUID"]["input"]>;
    seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
    seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
    signal?: InputMaybe<Scalars["Int"]["input"]>;
    size?: InputMaybe<Scalars["BigInt"]["input"]>;
    source?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
    taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
    uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch =
  {
    applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
    executorId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
    fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
    fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
    fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
    fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
    fileType?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    location?: InputMaybe<Scalars["String"]["input"]>;
    multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    originalName?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
    parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
    partSize?: InputMaybe<Scalars["Int"]["input"]>;
    preview?: InputMaybe<Scalars["JSON"]["input"]>;
    processingStatus?: InputMaybe<Scalars["Int"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
    referenceId?: InputMaybe<Scalars["UUID"]["input"]>;
    seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
    seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
    signal?: InputMaybe<Scalars["Int"]["input"]>;
    size?: InputMaybe<Scalars["BigInt"]["input"]>;
    source?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
    taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
    uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch =
  {
    applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
    executorId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
    fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
    fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
    fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
    fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
    fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
    fileType?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    location?: InputMaybe<Scalars["String"]["input"]>;
    multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    originalName?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
    parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
    partSize?: InputMaybe<Scalars["Int"]["input"]>;
    preview?: InputMaybe<Scalars["JSON"]["input"]>;
    processingStatus?: InputMaybe<Scalars["Int"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
    referenceId?: InputMaybe<Scalars["UUID"]["input"]>;
    seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
    seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
    signal?: InputMaybe<Scalars["Int"]["input"]>;
    size?: InputMaybe<Scalars["BigInt"]["input"]>;
    source?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
    taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
    uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `file` being updated. */
export type UpdateFileOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch = {
  applicationUserToUserId?: InputMaybe<FileUserId01D90B53FkApplicationUserIdInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  drsFileexecutorToExecutorId?: InputMaybe<FileExecutorId819Da590FkDrsFileexecutorIdInput>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityFileId015763A9FkFileIdInverseInput>;
  fileFormat?: InputMaybe<Scalars["Int"]["input"]>;
  fileMetadataUsingId?: InputMaybe<FileMetadataFileId78256936FkFileIdInverseInput>;
  fileProcessingNotificationsUsingId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInverseInput>;
  fileStructure?: InputMaybe<Scalars["Int"]["input"]>;
  fileToSeriesParentId?: InputMaybe<FileSeriesParentIdF7A07E20FkFileIdInput>;
  fileType?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isSeries?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  multipartUploadId?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  originalName?: InputMaybe<Scalars["String"]["input"]>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput>;
  parentIds?: InputMaybe<Scalars["JSON"]["input"]>;
  partSize?: InputMaybe<Scalars["Int"]["input"]>;
  preview?: InputMaybe<Scalars["JSON"]["input"]>;
  processingStatus?: InputMaybe<Scalars["Int"]["input"]>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInput>;
  referenceId?: InputMaybe<Scalars["UUID"]["input"]>;
  seriesOrder?: InputMaybe<Scalars["Int"]["input"]>;
  seriesParentId?: InputMaybe<Scalars["UUID"]["input"]>;
  signal?: InputMaybe<Scalars["Int"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  taskId?: InputMaybe<Scalars["UUID"]["input"]>;
  taskSourcesUsingId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInverseInput>;
  taskToTaskId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<FileTenantId61625016FkTenantIdInput>;
  uploadStatus?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** An object where the defined keys will be set on the `fileOutputGroupMetadatum` being updated. */
export type UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileOutputGroupToFileOutputGroupId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `fileOutputGroupMetadatum` being updated. */
export type UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileOutputGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupToFileOutputGroupId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `fileOutputGroupMetadatum` being updated. */
export type UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileOutputGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupToFileOutputGroupId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput>;
    projectToProjectId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `fileOutputGroupMetadatum` being updated. */
export type UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileOutputGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupToFileOutputGroupId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput>;
    tenantToTenantId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
export type UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput>;
    groupType?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput>;
    projectToProjectId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInput>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
export type UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch =
  {
    applicationUserToUserId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput>;
    groupType?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInput>;
    taskToTaskId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
export type UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch =
  {
    applicationUserToUserId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput>;
    groupType?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInput>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInput>;
    tenantToTenantId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
export type UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput>;
    groupType?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInput>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
export type UpdateFileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch =
  {
    applicationUserToUserId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput>;
    groupType?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInput>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `fileOutputGroup` being updated. */
export type UpdateFileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch =
  {
    applicationUserToUserId?: InputMaybe<FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput>;
    groupType?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInput>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `fileProcessingNotification` being updated. */
export type UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch =
  {
    applicationUserToUserId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInput>;
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileToFileId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    notificationToId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInput>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `fileProcessingNotification` being updated. */
export type UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch =
  {
    applicationUserToUserId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInput>;
    fileToFileId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    notificationToId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInput>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `fileProcessingNotification` being updated. */
export type UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch =
  {
    applicationUserToUserId?: InputMaybe<FileProcessingNotiUserId08265156FkApplicatiInput>;
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileToFileId?: InputMaybe<FileProcessingNotificationFileId717B514EFkFileIdInput>;
    notificationToId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInput>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableCell` being updated. */
export type UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyPatch =
  {
    formula?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnToColumnId?: InputMaybe<GdtAnalysisTableCColumnId54344A43FkGdtAnalyInput>;
    gdtAnalysisTableRowToRowId?: InputMaybe<GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInput>;
    rowId?: InputMaybe<Scalars["UUID"]["input"]>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableCell` being updated. */
export type UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyPatch =
  {
    columnId?: InputMaybe<Scalars["UUID"]["input"]>;
    formula?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnToColumnId?: InputMaybe<GdtAnalysisTableCColumnId54344A43FkGdtAnalyInput>;
    gdtAnalysisTableRowToRowId?: InputMaybe<GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableCell` being updated. */
export type UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyPatch =
  {
    columnId?: InputMaybe<Scalars["UUID"]["input"]>;
    formula?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnToColumnId?: InputMaybe<GdtAnalysisTableCColumnId54344A43FkGdtAnalyInput>;
    gdtAnalysisTableRowToRowId?: InputMaybe<GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInput>;
    rowId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableCell` being updated. */
export type UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdPatch =
  {
    columnId?: InputMaybe<Scalars["UUID"]["input"]>;
    formula?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableColumnToColumnId?: InputMaybe<GdtAnalysisTableCColumnId54344A43FkGdtAnalyInput>;
    gdtAnalysisTableRowToRowId?: InputMaybe<GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInput>;
    rowId?: InputMaybe<Scalars["UUID"]["input"]>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableColumnGroup` being updated. */
export type UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInput>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInverseInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableColumnGroup` being updated. */
export type UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInput>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInverseInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableColumnGroup` being updated. */
export type UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInput>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInverseInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableColumnGroup` being updated. */
export type UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInput>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInverseInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableColumnGroup` being updated. */
export type UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableCUserId8709Cf1FFkApplicatiInput>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInverseInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInput>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
export type UpdateGdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInput>;
    customDefaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    deletable?: InputMaybe<Scalars["Boolean"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInput>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCColumnId54344A43FkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnGroupToGroupId?: InputMaybe<GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInput>;
    groupId?: InputMaybe<Scalars["UUID"]["input"]>;
    helpText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    identifierPosition?: InputMaybe<Scalars["Int"]["input"]>;
    isIdColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
    isResult?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    pinned?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInput>;
    required?: InputMaybe<Scalars["Boolean"]["input"]>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    width?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
export type UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInput>;
    customDefaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    deletable?: InputMaybe<Scalars["Boolean"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInput>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCColumnId54344A43FkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnGroupToGroupId?: InputMaybe<GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInput>;
    groupId?: InputMaybe<Scalars["UUID"]["input"]>;
    helpText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    identifierPosition?: InputMaybe<Scalars["Int"]["input"]>;
    isIdColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
    isResult?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    pinned?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInput>;
    required?: InputMaybe<Scalars["Boolean"]["input"]>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    width?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
export type UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInput>;
    customDefaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    deletable?: InputMaybe<Scalars["Boolean"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInput>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCColumnId54344A43FkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnGroupToGroupId?: InputMaybe<GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInput>;
    helpText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    identifierPosition?: InputMaybe<Scalars["Int"]["input"]>;
    isIdColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
    isResult?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    pinned?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInput>;
    required?: InputMaybe<Scalars["Boolean"]["input"]>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    width?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
export type UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInput>;
    customDefaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    deletable?: InputMaybe<Scalars["Boolean"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInput>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCColumnId54344A43FkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnGroupToGroupId?: InputMaybe<GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInput>;
    groupId?: InputMaybe<Scalars["UUID"]["input"]>;
    helpText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    identifierPosition?: InputMaybe<Scalars["Int"]["input"]>;
    isIdColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
    isResult?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    pinned?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInput>;
    required?: InputMaybe<Scalars["Boolean"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    width?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
export type UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInput>;
    customDefaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    deletable?: InputMaybe<Scalars["Boolean"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInput>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCColumnId54344A43FkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnGroupToGroupId?: InputMaybe<GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInput>;
    groupId?: InputMaybe<Scalars["UUID"]["input"]>;
    helpText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    identifierPosition?: InputMaybe<Scalars["Int"]["input"]>;
    isIdColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
    isResult?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    pinned?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInput>;
    required?: InputMaybe<Scalars["Boolean"]["input"]>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    width?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableColumn` being updated. */
export type UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableCUserId75C939B7FkApplicatiInput>;
    customDefaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultFormula?: InputMaybe<Scalars["String"]["input"]>;
    definitionId?: InputMaybe<Scalars["UUID"]["input"]>;
    definitionTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    deletable?: InputMaybe<Scalars["Boolean"]["input"]>;
    djangoContentTypeToDefinitionTypeId?: InputMaybe<GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInput>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCColumnId54344A43FkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnGroupToGroupId?: InputMaybe<GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInput>;
    groupId?: InputMaybe<Scalars["UUID"]["input"]>;
    helpText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    identifierPosition?: InputMaybe<Scalars["Int"]["input"]>;
    isIdColumn?: InputMaybe<Scalars["Boolean"]["input"]>;
    isResult?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    pinned?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInput>;
    required?: InputMaybe<Scalars["Boolean"]["input"]>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    width?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
export type UpdateGdtAnalysisTableOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    folderId?: InputMaybe<Scalars["UUID"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput>;
    hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectFolderToFolderId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
export type UpdateGdtAnalysisTableOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    folderId?: InputMaybe<Scalars["UUID"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput>;
    hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectFolderToFolderId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
export type UpdateGdtAnalysisTableOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    folderId?: InputMaybe<Scalars["UUID"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput>;
    hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectFolderToFolderId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
export type UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput>;
    hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectFolderToFolderId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
export type UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    folderId?: InputMaybe<Scalars["UUID"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput>;
    hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectFolderToFolderId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
export type UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    folderId?: InputMaybe<Scalars["UUID"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput>;
    hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectFolderToFolderId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInput>;
    toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
export type UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    folderId?: InputMaybe<Scalars["UUID"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput>;
    hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectFolderToFolderId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTable` being updated. */
export type UpdateGdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    folderId?: InputMaybe<Scalars["UUID"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput>;
    hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectFolderToFolderId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
export type UpdateGdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInverseInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    index?: InputMaybe<Scalars["Int"]["input"]>;
    joinable?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput>;
    resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
export type UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInverseInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    index?: InputMaybe<Scalars["Int"]["input"]>;
    joinable?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput>;
    resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
export type UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInverseInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    index?: InputMaybe<Scalars["Int"]["input"]>;
    joinable?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput>;
    resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput>;
    toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
export type UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInverseInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    index?: InputMaybe<Scalars["Int"]["input"]>;
    joinable?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput>;
    resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
export type UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInverseInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    index?: InputMaybe<Scalars["Int"]["input"]>;
    joinable?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput>;
    resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `gdtAnalysisTableRow` being updated. */
export type UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    editable?: InputMaybe<Scalars["Boolean"]["input"]>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInverseInput>;
    gdtAnalysisTableToTableId?: InputMaybe<GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    index?: InputMaybe<Scalars["Int"]["input"]>;
    joinable?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput>;
    resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
    tableId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput>;
  };

/** An object where the defined keys will be set on the `metadataValue` being updated. */
export type UpdateMetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch =
  {
    applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    value?: InputMaybe<Scalars["JSON"]["input"]>;
  };

/** An object where the defined keys will be set on the `metadataValue` being updated. */
export type UpdateMetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
    projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    value?: InputMaybe<Scalars["JSON"]["input"]>;
  };

/** An object where the defined keys will be set on the `metadataValue` being updated. */
export type UpdateMetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch =
  {
    applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
    taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    value?: InputMaybe<Scalars["JSON"]["input"]>;
  };

/** An object where the defined keys will be set on the `metadataValue` being updated. */
export type UpdateMetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch =
  {
    applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
    tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    value?: InputMaybe<Scalars["JSON"]["input"]>;
  };

/** An object where the defined keys will be set on the `metadataValue` being updated. */
export type UpdateMetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    metadataId?: InputMaybe<Scalars["UUID"]["input"]>;
    metadatumToMetadataId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInput>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInput>;
    value?: InputMaybe<Scalars["JSON"]["input"]>;
  };

/** An object where the defined keys will be set on the `metadatum` being updated. */
export type UpdateMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch =
  {
    displayName?: InputMaybe<Scalars["String"]["input"]>;
    fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `metadatum` being updated. */
export type UpdateMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch =
  {
    displayName?: InputMaybe<Scalars["String"]["input"]>;
    fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `metadatum` being updated. */
export type UpdateMetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch =
  {
    displayName?: InputMaybe<Scalars["String"]["input"]>;
    fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `metadatum` being updated. */
export type UpdateMetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch =
  {
    displayName?: InputMaybe<Scalars["String"]["input"]>;
    fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
    projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `metadatum` being updated. */
export type UpdateMetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch =
  {
    displayName?: InputMaybe<Scalars["String"]["input"]>;
    fileMetadataUsingId?: InputMaybe<FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueMetadataId063A53B6FkMetadataIdInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInput>;
    tenantToTenantId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch =
  {
    applicationUserToUserId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileProcessingNotificationUsingId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInverseInput>;
    hasSeen?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectClonedNotificationUsingId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput>;
    projectSharedNotificationUsingId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput>;
    roleChangeNotificationUsingId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInverseInput>;
    tenantUserMembershipNotificationUsingId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileProcessingNotificationUsingId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInverseInput>;
    hasSeen?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectClonedNotificationUsingId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput>;
    projectSharedNotificationUsingId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput>;
    roleChangeNotificationUsingId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInverseInput>;
    tenantUserMembershipNotificationUsingId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInverseInput>;
  };

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch =
  {
    applicationUserToUserId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileProcessingNotificationUsingId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInverseInput>;
    hasSeen?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectClonedNotificationUsingId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput>;
    projectSharedNotificationUsingId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput>;
    roleChangeNotificationUsingId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInverseInput>;
    tenantUserMembershipNotificationUsingId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch =
  {
    applicationUserToUserId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileProcessingNotificationUsingId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInverseInput>;
    hasSeen?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectClonedNotificationUsingId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput>;
    projectSharedNotificationUsingId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput>;
    roleChangeNotificationUsingId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInverseInput>;
    tenantUserMembershipNotificationUsingId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch =
  {
    applicationUserToUserId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileProcessingNotificationUsingId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInverseInput>;
    hasSeen?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectClonedNotificationUsingId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput>;
    projectSharedNotificationUsingId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput>;
    roleChangeNotificationUsingId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInverseInput>;
    tenantUserMembershipNotificationUsingId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `notification` being updated. */
export type UpdateNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch =
  {
    applicationUserToUserId?: InputMaybe<NotificationUserId1002Fc38FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileProcessingNotificationUsingId?: InputMaybe<FileProcessingNotificationId630E6495FkNotificationIdInverseInput>;
    hasSeen?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectClonedNotificationUsingId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput>;
    projectSharedNotificationUsingId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput>;
    roleChangeNotificationUsingId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInverseInput>;
    tenantUserMembershipNotificationUsingId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInverseInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `outputGroupFile` being updated. */
export type UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileOutputGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupToFileOutputGroupId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput>;
    fileToFileId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInput>;
  };

/** An object where the defined keys will be set on the `outputGroupFile` being updated. */
export type UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupToFileOutputGroupId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput>;
    fileToFileId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInput>;
  };

/** An object where the defined keys will be set on the `outputGroupFile` being updated. */
export type UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch =
  {
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupToFileOutputGroupId?: InputMaybe<OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput>;
    fileToFileId?: InputMaybe<OutputGroupFilesFileIdEdeabb23FkFileIdInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInput>;
  };

/** An object where the defined keys will be set on the `pinnedTool` being updated. */
export type UpdatePinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdPatch =
  {
    applicationUserToUserId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    toolToToolId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `pinnedTool` being updated. */
export type UpdatePinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<PinnedToolUserId59D3492DFkApplicationUserIdInput>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolToToolId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInput>;
  };

/** An object where the defined keys will be set on the `projectClonedNotification` being updated. */
export type UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    notificationToId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectName?: InputMaybe<Scalars["String"]["input"]>;
    projectToProjectId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInput>;
    projectToSrcProjectId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput>;
    succeeded?: InputMaybe<Scalars["Boolean"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `projectClonedNotification` being updated. */
export type UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    notificationToId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectName?: InputMaybe<Scalars["String"]["input"]>;
    projectToProjectId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInput>;
    projectToSrcProjectId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput>;
    srcProjectId?: InputMaybe<Scalars["UUID"]["input"]>;
    succeeded?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

/** An object where the defined keys will be set on the `projectClonedNotification` being updated. */
export type UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInput>;
    notificationToId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectName?: InputMaybe<Scalars["String"]["input"]>;
    projectToProjectId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInput>;
    projectToSrcProjectId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput>;
    srcProjectId?: InputMaybe<Scalars["UUID"]["input"]>;
    succeeded?: InputMaybe<Scalars["Boolean"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `projectClonedNotification` being updated. */
export type UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectClonedNotifUserId4Fd693D7FkApplicatiInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    notificationToId?: InputMaybe<ProjectClonedNotificationIdD235A018FkNotificationIdInput>;
    projectName?: InputMaybe<Scalars["String"]["input"]>;
    projectToProjectId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInput>;
    projectToSrcProjectId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput>;
    srcProjectId?: InputMaybe<Scalars["UUID"]["input"]>;
    succeeded?: InputMaybe<Scalars["Boolean"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `projectFolder` being updated. */
export type UpdateProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInput>;
    color?: InputMaybe<Scalars["String"]["input"]>;
    dataTablesUsingId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `projectFolder` being updated. */
export type UpdateProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInput>;
    color?: InputMaybe<Scalars["String"]["input"]>;
    dataTablesUsingId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `projectFolder` being updated. */
export type UpdateProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInput>;
    color?: InputMaybe<Scalars["String"]["input"]>;
    dataTablesUsingId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectToProjectId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `projectFolder` being updated. */
export type UpdateProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectFolderUserIdF2E16179FkApplicationUserIdInput>;
    color?: InputMaybe<Scalars["String"]["input"]>;
    dataTablesUsingId?: InputMaybe<DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInput>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnFileForFileProjectId3Ecca975FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
  dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
  dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
  dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
  dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
  dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
  dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
  dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
  dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
  dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
  dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
  dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
  dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
  dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
  dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
  dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
  dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
  dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
  dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
  gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
  gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  icon?: InputMaybe<Scalars["String"]["input"]>;
  iconColor?: InputMaybe<Scalars["String"]["input"]>;
  iconText?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
  isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  shortDescription?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  tourType?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
  dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
  dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
  dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
  dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
  dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
  dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
  dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
  dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
  dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
  dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
  dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
  dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
  dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
  dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
  dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
  dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
  dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
  dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
  gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
  gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  icon?: InputMaybe<Scalars["String"]["input"]>;
  iconColor?: InputMaybe<Scalars["String"]["input"]>;
  iconText?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
  isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  shortDescription?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  tourType?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
    cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
    dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
    dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
    dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
    dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
    dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
    dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
    dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
    dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
    dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
    dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
    dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
    dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
    dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
    dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
    dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
    dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
    dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
    dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
    dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
    defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
    filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
    gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
    gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
    gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    iconColor?: InputMaybe<Scalars["String"]["input"]>;
    iconText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
    isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
    prefix?: InputMaybe<Scalars["String"]["input"]>;
    projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
    projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
    projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
    projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
    projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
    projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
    shortDescription?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
    toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
    tourType?: InputMaybe<Scalars["Int"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnTaskForTaskProjectId963D6354FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
  dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
  dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
  dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
  dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
  dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
  dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
  dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
  dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
  dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
  dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
  dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
  dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
  dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
  dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
  dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
  dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
  dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
  dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
  gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
  gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  icon?: InputMaybe<Scalars["String"]["input"]>;
  iconColor?: InputMaybe<Scalars["String"]["input"]>;
  iconText?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
  isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  shortDescription?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  tourType?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** An object where the defined keys will be set on the `project` being updated. */
export type UpdateProjectOnToolForToolProjectId20A84210FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ProjectUserIdB5Fbb914FkApplicationUserIdInput>;
  cloneSourceId?: InputMaybe<Scalars["UUID"]["input"]>;
  dataTableCellsUsingId?: InputMaybe<DataTableCellProjectIdEf5721A0FkProjectIdInverseInput>;
  dataTableColumnDefinitionBooleansUsingId?: InputMaybe<DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput>;
  dataTableColumnDefinitionCellStatusesUsingId?: InputMaybe<DataTableColumnDeProjectId33688488FkProjectIInverseInput>;
  dataTableColumnDefinitionChoicesUsingId?: InputMaybe<DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput>;
  dataTableColumnDefinitionDatesUsingId?: InputMaybe<DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput>;
  dataTableColumnDefinitionFilesUsingId?: InputMaybe<DataTableColumnDeProjectId433Daf03FkProjectIInverseInput>;
  dataTableColumnDefinitionFloatsUsingId?: InputMaybe<DataTableColumnDeProjectId869397AfFkProjectIInverseInput>;
  dataTableColumnDefinitionIdentifiersUsingId?: InputMaybe<DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput>;
  dataTableColumnDefinitionIntegersUsingId?: InputMaybe<DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput>;
  dataTableColumnDefinitionJoinsUsingId?: InputMaybe<DataTableColumnDeProjectId7732E962FkProjectIInverseInput>;
  dataTableColumnDefinitionMetadataUsingId?: InputMaybe<DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput>;
  dataTableColumnDefinitionRoiFramesUsingId?: InputMaybe<DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput>;
  dataTableColumnDefinitionTextsUsingId?: InputMaybe<DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput>;
  dataTableColumnGroupDefinitionJoinsUsingId?: InputMaybe<DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput>;
  dataTableColumnGroupDefinitionSourcesUsingId?: InputMaybe<DataTableColumnGrProjectId7376573CFkProjectIInverseInput>;
  dataTableColumnGroupsUsingId?: InputMaybe<DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput>;
  dataTableColumnsUsingId?: InputMaybe<DataTableColumnProjectId91C18F88FkProjectIdInverseInput>;
  dataTableRowsUsingId?: InputMaybe<DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput>;
  dataTablesUsingId?: InputMaybe<DataTableProjectId59F60EaeFkProjectIdInverseInput>;
  dateArchived?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDataDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateDeleted?: InputMaybe<Scalars["Datetime"]["input"]>;
  defaultUserAccessLevel?: InputMaybe<Scalars["Int"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  fileActivitiesUsingId?: InputMaybe<FileActivityProjectId6F35B8CcFkProjectIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataProjectId3474994EFkProjectIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput>;
  filesUsingId?: InputMaybe<FileProjectId3Ecca975FkProjectIdInverseInput>;
  gdtAnalysisTableCellsUsingId?: InputMaybe<GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput>;
  gdtAnalysisTableColumnGroupsUsingId?: InputMaybe<GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput>;
  gdtAnalysisTableColumnsUsingId?: InputMaybe<GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput>;
  gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput>;
  gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput>;
  icon?: InputMaybe<Scalars["String"]["input"]>;
  iconColor?: InputMaybe<Scalars["String"]["input"]>;
  iconText?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  isDemo?: InputMaybe<Scalars["Boolean"]["input"]>;
  isToolProject?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  metadataUsingId?: InputMaybe<MetadataProjectId3333C2AdFkProjectIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueProjectId87227D96FkProjectIdInverseInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  outputGroupFilesUsingId?: InputMaybe<OutputGroupFilesProjectId8709B561FkProjectIdInverseInput>;
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  projectClonedNotificationsToProjectIdUsingId?: InputMaybe<ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput>;
  projectClonedNotificationsToSrcProjectIdUsingId?: InputMaybe<ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput>;
  projectFoldersUsingId?: InputMaybe<ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput>;
  projectSharedNotificationsUsingId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput>;
  projectTagsUsingId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInverseInput>;
  projectToCloneSourceId?: InputMaybe<ProjectCloneSourceId92Ccacf5FkProjectIdInput>;
  shortDescription?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tasksUsingId?: InputMaybe<TaskProjectId963D6354FkProjectIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInput>;
  toolUsingId?: InputMaybe<ToolProjectId20A84210FkProjectIdInverseInput>;
  tourType?: InputMaybe<Scalars["Int"]["input"]>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** An object where the defined keys will be set on the `projectSharedNotification` being updated. */
export type UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch =
  {
    accessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    applicationUserToSharerId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput>;
    applicationUserToUserId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    notificationToId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `projectSharedNotification` being updated. */
export type UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch =
  {
    accessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    applicationUserToSharerId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput>;
    applicationUserToUserId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    notificationToId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput>;
    sharerId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `projectSharedNotification` being updated. */
export type UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch =
  {
    accessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    applicationUserToSharerId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput>;
    applicationUserToUserId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInput>;
    notificationToId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput>;
    sharerId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `projectSharedNotification` being updated. */
export type UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch =
  {
    accessLevel?: InputMaybe<Scalars["Int"]["input"]>;
    applicationUserToSharerId?: InputMaybe<ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput>;
    applicationUserToUserId?: InputMaybe<ProjectSharedNotifUserId9A19122FFkApplicatiInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    notificationToId?: InputMaybe<ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput>;
    projectToProjectId?: InputMaybe<ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput>;
    sharerId?: InputMaybe<Scalars["UUID"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `projectTag` being updated. */
export type UpdateProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    label?: InputMaybe<Scalars["String"]["input"]>;
    projectToProjectId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `projectTag` being updated. */
export type UpdateProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ProjectTagUserId780C8348FkApplicationUserIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    label?: InputMaybe<Scalars["String"]["input"]>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<ProjectTagProjectId5Ab280C9FkProjectIdInput>;
  };

/** An object where the defined keys will be set on the `roleChangeNotification` being updated. */
export type UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch =
  {
    applicationUserToUserId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    notificationToId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInput>;
    role?: InputMaybe<Scalars["Int"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `roleChangeNotification` being updated. */
export type UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch =
  {
    applicationUserToUserId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInput>;
    notificationToId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInput>;
    role?: InputMaybe<Scalars["Int"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `roleChangeNotification` being updated. */
export type UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch =
  {
    applicationUserToUserId?: InputMaybe<RoleChangeNotificaUserId879Bd49AFkApplicatiInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    notificationToId?: InputMaybe<RoleChangeNotificationIdD576A528FkNotificationIdInput>;
    role?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `run` being updated. */
export type UpdateRunOnRunForRunTenantId73Fbd8D9FkTenantIdPatch = {
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInput>;
};

/** An object where the defined keys will be set on the `taskActivity` being updated. */
export type UpdateTaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdPatch =
  {
    cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
    costToCostId?: InputMaybe<TaskActivityCostId49E66058FkCostIdInput>;
    date?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    duration?: InputMaybe<IntervalInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    instanceType?: InputMaybe<Scalars["String"]["input"]>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInput>;
  };

/** An object where the defined keys will be set on the `taskActivity` being updated. */
export type UpdateTaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch =
  {
    cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
    costId?: InputMaybe<Scalars["BigInt"]["input"]>;
    costToCostId?: InputMaybe<TaskActivityCostId49E66058FkCostIdInput>;
    date?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    duration?: InputMaybe<IntervalInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    instanceType?: InputMaybe<Scalars["String"]["input"]>;
    taskToTaskId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInput>;
  };

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnFileForFileTaskIdE4Da87AeFkTaskIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  inputsHash?: InputMaybe<Scalars["String"]["input"]>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch =
  {
    applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
    cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    executorId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
    filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
    gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    inputsHash?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
    resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
    taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
    taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
    taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
    taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
    taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
    tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
    toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
    toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch =
  {
    applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
    cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    executorId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
    filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
    gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    inputsHash?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
    resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
    taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
    taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
    taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
    taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
    taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
    tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
    toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
    toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch =
  {
    applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
    cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    executorId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
    filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
    gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    inputsHash?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
    resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
    taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
    taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
    taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
    taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
    taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
    tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
    toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
    toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch =
  {
    applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
    cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    executorId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
    filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
    gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    inputsHash?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
    resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
    taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
    taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
    taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
    taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
    taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
    tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
    toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
    toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdPatch =
  {
    applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
    cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    executorId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
    filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
    gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    inputsHash?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
    resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
    taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
    taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
    taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
    taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
    taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
    tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
    toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
    toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdPatch =
  {
    applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
    cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
    filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
    gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    inputsHash?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
    resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
    taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
    taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
    taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
    taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
    taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
    tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
    toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
    toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskProjectId963D6354FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  inputsHash?: InputMaybe<Scalars["String"]["input"]>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskTenantId148E90DaFkTenantIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  inputsHash?: InputMaybe<Scalars["String"]["input"]>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  inputsHash?: InputMaybe<Scalars["String"]["input"]>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  inputsHash?: InputMaybe<Scalars["String"]["input"]>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch =
  {
    applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
    cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    executorId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
    filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
    gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    inputsHash?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
    resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
    taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
    taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
    taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
    taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
    taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
    tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
    toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
    toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch =
  {
    applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
    cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    executorId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
    filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
    gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    inputsHash?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
    resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
    taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
    taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
    taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
    taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
    taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
    tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
    toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
    toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch = {
  applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
  cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
  containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
  containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  credits?: InputMaybe<Scalars["Float"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  executorId?: InputMaybe<Scalars["UUID"]["input"]>;
  fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
  filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
  gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  inputsHash?: InputMaybe<Scalars["String"]["input"]>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
  resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
  taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
  taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
  taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
  taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
  taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
  tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
  toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
  toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
  toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
  toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** An object where the defined keys will be set on the `task` being updated. */
export type UpdateTaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdPatch =
  {
    applicationUserToUserId?: InputMaybe<TaskUserId270D0Bb2FkApplicationUserIdInput>;
    cloned?: InputMaybe<Scalars["Boolean"]["input"]>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<TaskContainerImageId92Ed2DaeFkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    errorDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    executorId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileOutputGroupUsingId?: InputMaybe<FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput>;
    filesUsingId?: InputMaybe<FileTaskIdE4Da87AeFkTaskIdInverseInput>;
    gdtAnalysisTableRowUsingId?: InputMaybe<GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    inputsHash?: InputMaybe<Scalars["String"]["input"]>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTaskId3D37D135FkTaskIdInverseInput>;
    projectId?: InputMaybe<Scalars["UUID"]["input"]>;
    projectToProjectId?: InputMaybe<TaskProjectId963D6354FkProjectIdInput>;
    resourceTier?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    taskActivityUsingId?: InputMaybe<TaskActivityTaskIdC451Ae92FkTaskIdInverseInput>;
    taskParameters?: InputMaybe<Scalars["JSON"]["input"]>;
    taskResourceUsageUsingId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput>;
    taskResourcesUsingId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInverseInput>;
    taskSourcesUsingId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInverseInput>;
    taskStatusLogsUsingId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInput>;
    tesTaskexecutorToExecutorId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInput>;
    toolExitcode?: InputMaybe<Scalars["String"]["input"]>;
    toolExitcodeDescription?: InputMaybe<Scalars["JSON"]["input"]>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `taskResource` being updated. */
export type UpdateTaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch =
  {
    id?: InputMaybe<Scalars["Int"]["input"]>;
    taskToTaskId?: InputMaybe<TaskResourceTaskId73Fcabc0FkTaskIdInput>;
    type?: InputMaybe<Scalars["Int"]["input"]>;
    value?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `taskResourceUsage` being updated. */
export type UpdateTaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch =
  {
    cpuMax?: InputMaybe<Scalars["Float"]["input"]>;
    cpuMean?: InputMaybe<Scalars["Float"]["input"]>;
    cpuMedian?: InputMaybe<Scalars["Float"]["input"]>;
    cpuMin?: InputMaybe<Scalars["Float"]["input"]>;
    cpuStd?: InputMaybe<Scalars["Float"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    memoryMax?: InputMaybe<Scalars["Float"]["input"]>;
    memoryMean?: InputMaybe<Scalars["Float"]["input"]>;
    memoryMedian?: InputMaybe<Scalars["Float"]["input"]>;
    memoryMin?: InputMaybe<Scalars["Float"]["input"]>;
    memoryStd?: InputMaybe<Scalars["Float"]["input"]>;
    storageMax?: InputMaybe<Scalars["Float"]["input"]>;
    storageMean?: InputMaybe<Scalars["Float"]["input"]>;
    storageMedian?: InputMaybe<Scalars["Float"]["input"]>;
    storageMin?: InputMaybe<Scalars["Float"]["input"]>;
    storageStd?: InputMaybe<Scalars["Float"]["input"]>;
    taskToTaskId?: InputMaybe<TaskResourceUsageTaskIdA28F1580FkTaskIdInput>;
  };

/** An object where the defined keys will be set on the `taskSource` being updated. */
export type UpdateTaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch =
  {
    fileToFileId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInput>;
    toolSourceId?: InputMaybe<Scalars["Int"]["input"]>;
    toolSourceToToolSourceId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInput>;
  };

/** An object where the defined keys will be set on the `taskSource` being updated. */
export type UpdateTaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch =
  {
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileToFileId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    taskToTaskId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInput>;
    toolSourceId?: InputMaybe<Scalars["Int"]["input"]>;
    toolSourceToToolSourceId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInput>;
  };

/** An object where the defined keys will be set on the `taskSource` being updated. */
export type UpdateTaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch =
  {
    fileId?: InputMaybe<Scalars["UUID"]["input"]>;
    fileToFileId?: InputMaybe<TaskSourceFileId2F628862FkFileIdInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    taskId?: InputMaybe<Scalars["UUID"]["input"]>;
    taskToTaskId?: InputMaybe<TaskSourceTaskIdF241BaedFkTaskIdInput>;
    toolSourceToToolSourceId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInput>;
  };

/** An object where the defined keys will be set on the `taskStatusLog` being updated. */
export type UpdateTaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdPatch =
  {
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    taskToTaskId?: InputMaybe<TaskStatusLogTaskIdFe1B9D0BFkTaskIdInput>;
  };

/** An object where the defined keys will be set on the `tenantContractAllowance` being updated. */
export type UpdateTenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch =
  {
    id?: InputMaybe<Scalars["Int"]["input"]>;
    quotaType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantContractTransactionToTenantContractTransactionId?: InputMaybe<TenantContractAlloTenantContractTran29C19B1CFkTenantCoInput>;
    value?: InputMaybe<Scalars["String"]["input"]>;
  };

/** An object where the defined keys will be set on the `tenantContract` being updated. */
export type UpdateTenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch =
  {
    contractType?: InputMaybe<Scalars["Int"]["input"]>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    endDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    startDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    tenantContractTransactionsUsingId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantContractId681267CeFkTenantCoInverseInput>;
    tenantToTenantId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `tenantContract` being updated. */
export type UpdateTenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch =
  {
    contractType?: InputMaybe<Scalars["Int"]["input"]>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    endDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    startDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    tenantContractTransactionsUsingId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantContractId681267CeFkTenantCoInverseInput>;
    tenantToTenantId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `tenantContract` being updated. */
export type UpdateTenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoPatch =
  {
    contractType?: InputMaybe<Scalars["Int"]["input"]>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    endDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    startDate?: InputMaybe<Scalars["Datetime"]["input"]>;
    tenantContractTransactionsUsingId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantContractId681267CeFkTenantCoInverseInput>;
    tenantToTenantId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `tenantContractTransaction` being updated. */
export type UpdateTenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch =
  {
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    currency?: InputMaybe<Scalars["Int"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    price?: InputMaybe<Scalars["BigFloat"]["input"]>;
    tenantContractAllowancesUsingId?: InputMaybe<TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput>;
    tenantContractId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantContractToTenantContractId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInput>;
  };

/** An object where the defined keys will be set on the `tenantContractTransaction` being updated. */
export type UpdateTenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch =
  {
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    currency?: InputMaybe<Scalars["Int"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    price?: InputMaybe<Scalars["BigFloat"]["input"]>;
    tenantContractAllowancesUsingId?: InputMaybe<TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput>;
    tenantContractToTenantContractId?: InputMaybe<TenantContractTranTenantContractId1E374993FkTenantCoInput>;
  };

/** An object where the defined keys will be set on the `tenantMockuserexecutor` being updated. */
export type UpdateTenantMockuserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsPatch =
  {
    tenantUserexecutorToUserexecutorPtrId?: InputMaybe<TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInput>;
  };

/** An object where the defined keys will be set on the `tenantMonthlyConsumedResource` being updated. */
export type UpdateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoPatch =
  {
    applicationUserToUserId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    month?: InputMaybe<Scalars["Date"]["input"]>;
    monthInActiveContract?: InputMaybe<Scalars["Int"]["input"]>;
    percentage?: InputMaybe<Scalars["Float"]["input"]>;
    quotaType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantContractToTenantContractId?: InputMaybe<TenantMonthlyConsuTenantContractId681267CeFkTenantCoInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    value?: InputMaybe<Scalars["String"]["input"]>;
  };

/** An object where the defined keys will be set on the `tenantMonthlyConsumedResource` being updated. */
export type UpdateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdPatch =
  {
    applicationUserToUserId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    month?: InputMaybe<Scalars["Date"]["input"]>;
    monthInActiveContract?: InputMaybe<Scalars["Int"]["input"]>;
    percentage?: InputMaybe<Scalars["Float"]["input"]>;
    quotaType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantContractId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantContractToTenantContractId?: InputMaybe<TenantMonthlyConsuTenantContractId681267CeFkTenantCoInput>;
    tenantToTenantId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    value?: InputMaybe<Scalars["String"]["input"]>;
  };

/** An object where the defined keys will be set on the `tenantMonthlyConsumedResource` being updated. */
export type UpdateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiPatch =
  {
    applicationUserToUserId?: InputMaybe<TenantMonthlyConsuUserIdF7210F55FkApplicatiInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    month?: InputMaybe<Scalars["Date"]["input"]>;
    monthInActiveContract?: InputMaybe<Scalars["Int"]["input"]>;
    percentage?: InputMaybe<Scalars["Float"]["input"]>;
    quotaType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantContractId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantContractToTenantContractId?: InputMaybe<TenantMonthlyConsuTenantContractId681267CeFkTenantCoInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInput>;
    value?: InputMaybe<Scalars["String"]["input"]>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName?: InputMaybe<Scalars["String"]["input"]>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType?: InputMaybe<Scalars["Int"]["input"]>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnCommandForCommandTenantId36F95C3CFkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName?: InputMaybe<Scalars["String"]["input"]>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType?: InputMaybe<Scalars["Int"]["input"]>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnCostForCostTenantId7Dcd58A7FkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName?: InputMaybe<Scalars["String"]["input"]>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType?: InputMaybe<Scalars["Int"]["input"]>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnFileForFileTenantId61625016FkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName?: InputMaybe<Scalars["String"]["input"]>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType?: InputMaybe<Scalars["Int"]["input"]>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName?: InputMaybe<Scalars["String"]["input"]>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType?: InputMaybe<Scalars["Int"]["input"]>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnRunForRunTenantId73Fbd8D9FkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName?: InputMaybe<Scalars["String"]["input"]>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType?: InputMaybe<Scalars["Int"]["input"]>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName?: InputMaybe<Scalars["String"]["input"]>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType?: InputMaybe<Scalars["Int"]["input"]>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName?: InputMaybe<Scalars["String"]["input"]>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType?: InputMaybe<Scalars["Int"]["input"]>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdPatch =
  {
    applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
    applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
    codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
    commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
    containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
    containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
    costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
    fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
    fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
    fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
    fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
    filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    internal?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
    metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
    repositoryName?: InputMaybe<Scalars["String"]["input"]>;
    roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
    runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
    sfid?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
    tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
    tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
    tenantType?: InputMaybe<Scalars["Int"]["input"]>;
    tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
    toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
    toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
    workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
  };

/** An object where the defined keys will be set on the `tenant` being updated. */
export type UpdateTenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdPatch = {
  applicationUserMembershipsUsingId?: InputMaybe<ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput>;
  applicationUserSessionsUsingId?: InputMaybe<ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput>;
  codeFilesUsingId?: InputMaybe<CodeFileTenantIdC35D8B4EFkTenantIdInverseInput>;
  commandsUsingId?: InputMaybe<CommandTenantId36F95C3CFkTenantIdInverseInput>;
  containerImageRepositoriesUsingId?: InputMaybe<ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput>;
  containerImagesUsingId?: InputMaybe<ContainerImageTenantIdD0Beb309FkTenantIdInverseInput>;
  costsUsingId?: InputMaybe<CostTenantId7Dcd58A7FkTenantIdInverseInput>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  featureFlagsTenantsUsingId?: InputMaybe<FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput>;
  fileActivitiesUsingId?: InputMaybe<FileActivityTenantIdC46A4F01FkTenantIdInverseInput>;
  fileMetadataUsingId?: InputMaybe<FileMetadataTenantId79Fe438BFkTenantIdInverseInput>;
  fileOutputGroupMetadataUsingId?: InputMaybe<FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput>;
  fileOutputGroupsUsingId?: InputMaybe<FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput>;
  filesUsingId?: InputMaybe<FileTenantId61625016FkTenantIdInverseInput>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  metadataUsingId?: InputMaybe<MetadataTenantIdC1D8772DFkTenantIdInverseInput>;
  metadataValuesUsingId?: InputMaybe<MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  projectsUsingId?: InputMaybe<ProjectTenantId03F0Ca53FkTenantIdInverseInput>;
  repositoryName?: InputMaybe<Scalars["String"]["input"]>;
  roleChangeNotificationsUsingId?: InputMaybe<RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput>;
  runsUsingId?: InputMaybe<RunTenantId73Fbd8D9FkTenantIdInverseInput>;
  sfid?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tasksUsingId?: InputMaybe<TaskTenantId148E90DaFkTenantIdInverseInput>;
  tenantContractsUsingId?: InputMaybe<TenantContractTenantIdBa8Ac167FkTenantIdInverseInput>;
  tenantMonthlyConsumedResourcesUsingId?: InputMaybe<TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput>;
  tenantType?: InputMaybe<Scalars["Int"]["input"]>;
  tenantUserMembershipNotificationsUsingId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInverseInput>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInverseInput>;
  workflowsUsingId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInverseInput>;
};

/** An object where the defined keys will be set on the `tenantUserMembershipNotification` being updated. */
export type UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch =
  {
    applicationUserToInviterId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInput>;
    applicationUserToUserId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInput>;
    inviterId?: InputMaybe<Scalars["UUID"]["input"]>;
    notificationToId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `tenantUserMembershipNotification` being updated. */
export type UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch =
  {
    applicationUserToInviterId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInput>;
    applicationUserToUserId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    notificationToId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `tenantUserMembershipNotification` being updated. */
export type UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch =
  {
    applicationUserToInviterId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInput>;
    applicationUserToUserId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    inviterId?: InputMaybe<Scalars["UUID"]["input"]>;
    notificationToId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInput>;
    tenantToTenantId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `tenantUserMembershipNotification` being updated. */
export type UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch =
  {
    applicationUserToInviterId?: InputMaybe<TenantUserMembershInviterId29476E5EFkApplicatiInput>;
    applicationUserToUserId?: InputMaybe<TenantUserMembershUserId2B78E8A0FkApplicatiInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    inviterId?: InputMaybe<Scalars["UUID"]["input"]>;
    notificationToId?: InputMaybe<TenantUserMembershId10Affa8DFkNotificatInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<TenantUserMembershTenantIdC67818C5FkTenantIdInput>;
  };

/** An object where the defined keys will be set on the `tenantUserexecutor` being updated. */
export type UpdateTenantUserexecutorOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsPatch =
  {
    applicationUserUsingId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInverseInput>;
    awsCognitoUserUsingId?: InputMaybe<AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantMockuserexecutorUsingId?: InputMaybe<TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInverseInput>;
  };

/** An object where the defined keys will be set on the `tenantUserexecutor` being updated. */
export type UpdateTenantUserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsPatch =
  {
    applicationUserUsingId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInverseInput>;
    awsCognitoUserUsingId?: InputMaybe<AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantMockuserexecutorUsingId?: InputMaybe<TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInverseInput>;
  };

/** An object where the defined keys will be set on the `tenantUserexecutor` being updated. */
export type UpdateTenantUserexecutorOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoPatch =
  {
    applicationUserUsingId?: InputMaybe<ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInverseInput>;
    awsCognitoUserUsingId?: InputMaybe<AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    tenantMockuserexecutorUsingId?: InputMaybe<TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInverseInput>;
  };

/** An object where the defined keys will be set on the `tesContainerimageexecutor` being updated. */
export type UpdateTesContainerimageexecutorOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaPatch =
  {
    awsEcrImageUsingId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInverseInput>;
    containerImageUsingId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInverseInput>;
    distributionRegistryImageUsingId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    tesMockcontainerimageexecutorUsingId?: InputMaybe<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInverseInput>;
  };

/** An object where the defined keys will be set on the `tesContainerimageexecutor` being updated. */
export type UpdateTesContainerimageexecutorOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaPatch =
  {
    awsEcrImageUsingId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInverseInput>;
    containerImageUsingId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInverseInput>;
    distributionRegistryImageUsingId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    tesMockcontainerimageexecutorUsingId?: InputMaybe<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInverseInput>;
  };

/** An object where the defined keys will be set on the `tesContainerimageexecutor` being updated. */
export type UpdateTesContainerimageexecutorOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaPatch =
  {
    awsEcrImageUsingId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInverseInput>;
    containerImageUsingId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInverseInput>;
    distributionRegistryImageUsingId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    tesMockcontainerimageexecutorUsingId?: InputMaybe<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInverseInput>;
  };

/** An object where the defined keys will be set on the `tesContainerimageexecutor` being updated. */
export type UpdateTesContainerimageexecutorOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoPatch =
  {
    awsEcrImageUsingId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInverseInput>;
    containerImageUsingId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInverseInput>;
    distributionRegistryImageUsingId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    tesMockcontainerimageexecutorUsingId?: InputMaybe<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInverseInput>;
  };

/** An object where the defined keys will be set on the `tesContainerimageexecutor` being updated. */
export type UpdateTesContainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaPatch =
  {
    awsEcrImageUsingId?: InputMaybe<AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInverseInput>;
    containerImageUsingId?: InputMaybe<ContainerImageExecutorId68979Fb6FkTesContaInverseInput>;
    distributionRegistryImageUsingId?: InputMaybe<DistributionRegistrContainerimageexecut830E7Af5FkTesContaInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    tesMockcontainerimageexecutorUsingId?: InputMaybe<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInverseInput>;
  };

/** An object where the defined keys will be set on the `tesMockcontainerimageexecutor` being updated. */
export type UpdateTesMockcontainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaPatch =
  {
    tesContainerimageexecutorToContainerimageexecutorPtrId?: InputMaybe<TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInput>;
  };

/** An object where the defined keys will be set on the `tesMocktaskexecutor` being updated. */
export type UpdateTesMocktaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskePatch =
  {
    tesTaskexecutorToTaskexecutorPtrId?: InputMaybe<TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInput>;
  };

/** An object where the defined keys will be set on the `tesTaskexecutor` being updated. */
export type UpdateTesTaskexecutorOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskePatch =
  {
    awsBatchTaskUsingId?: InputMaybe<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    taskUsingId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInverseInput>;
    tesMocktaskexecutorUsingId?: InputMaybe<TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInverseInput>;
  };

/** An object where the defined keys will be set on the `tesTaskexecutor` being updated. */
export type UpdateTesTaskexecutorOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdPatch =
  {
    awsBatchTaskUsingId?: InputMaybe<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    taskUsingId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInverseInput>;
    tesMocktaskexecutorUsingId?: InputMaybe<TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInverseInput>;
  };

/** An object where the defined keys will be set on the `tesTaskexecutor` being updated. */
export type UpdateTesTaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskePatch =
  {
    awsBatchTaskUsingId?: InputMaybe<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    polymorphicCtypeId?: InputMaybe<Scalars["Int"]["input"]>;
    taskUsingId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInverseInput>;
    tesMocktaskexecutorUsingId?: InputMaybe<TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInverseInput>;
  };

/** An object where the defined keys will be set on the `tesTaskexecutor` being updated. */
export type UpdateTesTaskexecutorOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoPatch =
  {
    awsBatchTaskUsingId?: InputMaybe<AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInverseInput>;
    djangoContentTypeToPolymorphicCtypeId?: InputMaybe<TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInput>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    taskUsingId?: InputMaybe<TaskExecutorId24A67329FkTesTaskexecutorIdInverseInput>;
    tesMocktaskexecutorUsingId?: InputMaybe<TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInverseInput>;
  };

/** An object where the defined keys will be set on the `tool` being updated. */
export type UpdateToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  codeLink?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  docsLink?: InputMaybe<Scalars["String"]["input"]>;
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  maturity?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  pinnedToolsUsingId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  searchTerms?: InputMaybe<Scalars["JSON"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
  toolboxToToolboxId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  visibility?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An object where the defined keys will be set on the `tool` being updated. */
export type UpdateToolOnToolForToolProjectId20A84210FkProjectIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  codeLink?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  docsLink?: InputMaybe<Scalars["String"]["input"]>;
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  maturity?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  pinnedToolsUsingId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInverseInput>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  searchTerms?: InputMaybe<Scalars["JSON"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
  toolboxToToolboxId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  visibility?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An object where the defined keys will be set on the `tool` being updated. */
export type UpdateToolOnToolForToolTenantId1Baab08EFkTenantIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  codeLink?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  docsLink?: InputMaybe<Scalars["String"]["input"]>;
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  maturity?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  pinnedToolsUsingId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  searchTerms?: InputMaybe<Scalars["JSON"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
  toolboxToToolboxId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  visibility?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An object where the defined keys will be set on the `tool` being updated. */
export type UpdateToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  codeLink?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  docsLink?: InputMaybe<Scalars["String"]["input"]>;
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  maturity?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  pinnedToolsUsingId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  searchTerms?: InputMaybe<Scalars["JSON"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  toolboxToToolboxId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  visibility?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An object where the defined keys will be set on the `tool` being updated. */
export type UpdateToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  codeLink?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  docsLink?: InputMaybe<Scalars["String"]["input"]>;
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  maturity?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  pinnedToolsUsingId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  searchTerms?: InputMaybe<Scalars["JSON"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
  toolboxToToolboxId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInput>;
  visibility?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An object where the defined keys will be set on the `tool` being updated. */
export type UpdateToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  codeLink?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  docsLink?: InputMaybe<Scalars["String"]["input"]>;
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  maturity?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  pinnedToolsUsingId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  searchTerms?: InputMaybe<Scalars["JSON"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
  toolboxToToolboxId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  visibility?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An object where the defined keys will be set on the `tool` being updated. */
export type UpdateToolOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch = {
  applicationUserToUserId?: InputMaybe<ToolUserIdFd36Dfa4FkApplicationUserIdInput>;
  codeLink?: InputMaybe<Scalars["String"]["input"]>;
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  docsLink?: InputMaybe<Scalars["String"]["input"]>;
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  maturity?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  pinnedToolsUsingId?: InputMaybe<PinnedToolToolId7Ba143DfFkToolIdInverseInput>;
  projectId?: InputMaybe<Scalars["UUID"]["input"]>;
  projectToProjectId?: InputMaybe<ToolProjectId20A84210FkProjectIdInput>;
  searchTerms?: InputMaybe<Scalars["JSON"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  tenantId?: InputMaybe<Scalars["Int"]["input"]>;
  tenantToTenantId?: InputMaybe<ToolTenantId1Baab08EFkTenantIdInput>;
  toolTenantsUsingId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput>;
  toolVersionsUsingId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInverseInput>;
  toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
  toolboxToToolboxId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInput>;
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  visibility?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An object where the defined keys will be set on the `toolParameter` being updated. */
export type UpdateToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch =
  {
    default?: InputMaybe<Scalars["JSON"]["input"]>;
    helpText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    options?: InputMaybe<Scalars["JSON"]["input"]>;
    required?: InputMaybe<Scalars["Boolean"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInput>;
    unit?: InputMaybe<Scalars["String"]["input"]>;
  };

/** An object where the defined keys will be set on the `toolResource` being updated. */
export type UpdateToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdPatch =
  {
    id?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInput>;
    type?: InputMaybe<Scalars["Int"]["input"]>;
    value?: InputMaybe<Scalars["Int"]["input"]>;
  };

/** An object where the defined keys will be set on the `toolResult` being updated. */
export type UpdateToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch =
  {
    fileFormats?: InputMaybe<Scalars["JSON"]["input"]>;
    helpText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    required?: InputMaybe<Scalars["Boolean"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInput>;
  };

/** An object where the defined keys will be set on the `toolSecret` being updated. */
export type UpdateToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch =
  {
    helpText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    required?: InputMaybe<Scalars["Boolean"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInput>;
  };

/** An object where the defined keys will be set on the `toolSource` being updated. */
export type UpdateToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch =
  {
    fileFormats?: InputMaybe<Scalars["JSON"]["input"]>;
    helpText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    multiple?: InputMaybe<Scalars["Boolean"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    required?: InputMaybe<Scalars["Boolean"]["input"]>;
    taskSourcesUsingId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput>;
    toolVersionId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolVersionId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput>;
  };

/** An object where the defined keys will be set on the `toolSource` being updated. */
export type UpdateToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch =
  {
    fileFormats?: InputMaybe<Scalars["JSON"]["input"]>;
    helpText?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    multiple?: InputMaybe<Scalars["Boolean"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    required?: InputMaybe<Scalars["Boolean"]["input"]>;
    taskSourcesUsingId?: InputMaybe<TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput>;
    toolVersionToToolVersionId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput>;
  };

/** An object where the defined keys will be set on the `toolTenant` being updated. */
export type UpdateToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolToToolId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInput>;
  };

/** An object where the defined keys will be set on the `toolTenant` being updated. */
export type UpdateToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolTenantsTenantId9C4A54FeFkTenantIdInput>;
    toolToToolId?: InputMaybe<ToolTenantsToolIdF77Ef6F7FkToolIdInput>;
  };

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible?: InputMaybe<Scalars["Boolean"]["input"]>;
    isUpgradableToNextVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
    maturity?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion?: InputMaybe<Scalars["Int"]["input"]>;
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<Scalars["Int"]["input"]>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible?: InputMaybe<Scalars["Boolean"]["input"]>;
    isUpgradableToNextVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
    maturity?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion?: InputMaybe<Scalars["Int"]["input"]>;
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<Scalars["Int"]["input"]>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible?: InputMaybe<Scalars["Boolean"]["input"]>;
    isUpgradableToNextVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
    maturity?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion?: InputMaybe<Scalars["Int"]["input"]>;
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<Scalars["Int"]["input"]>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible?: InputMaybe<Scalars["Boolean"]["input"]>;
    isUpgradableToNextVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
    maturity?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion?: InputMaybe<Scalars["Int"]["input"]>;
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<Scalars["Int"]["input"]>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible?: InputMaybe<Scalars["Boolean"]["input"]>;
    isUpgradableToNextVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
    maturity?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion?: InputMaybe<Scalars["Int"]["input"]>;
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<Scalars["Int"]["input"]>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible?: InputMaybe<Scalars["Boolean"]["input"]>;
    isUpgradableToNextVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
    maturity?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion?: InputMaybe<Scalars["Int"]["input"]>;
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<Scalars["Int"]["input"]>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible?: InputMaybe<Scalars["Boolean"]["input"]>;
    isUpgradableToNextVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
    maturity?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion?: InputMaybe<Scalars["Int"]["input"]>;
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<Scalars["Int"]["input"]>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible?: InputMaybe<Scalars["Boolean"]["input"]>;
    isUpgradableToNextVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
    maturity?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion?: InputMaybe<Scalars["Int"]["input"]>;
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<Scalars["Int"]["input"]>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible?: InputMaybe<Scalars["Boolean"]["input"]>;
    isUpgradableToNextVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
    maturity?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion?: InputMaybe<Scalars["Int"]["input"]>;
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<Scalars["Int"]["input"]>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible?: InputMaybe<Scalars["Boolean"]["input"]>;
    isUpgradableToNextVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
    maturity?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion?: InputMaybe<Scalars["Int"]["input"]>;
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<Scalars["Int"]["input"]>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible?: InputMaybe<Scalars["Boolean"]["input"]>;
    isUpgradableToNextVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
    maturity?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion?: InputMaybe<Scalars["Int"]["input"]>;
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<Scalars["Int"]["input"]>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible?: InputMaybe<Scalars["Boolean"]["input"]>;
    isUpgradableToNextVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
    maturity?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion?: InputMaybe<Scalars["Int"]["input"]>;
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<Scalars["Int"]["input"]>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible?: InputMaybe<Scalars["Boolean"]["input"]>;
    isUpgradableToNextVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
    maturity?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion?: InputMaybe<Scalars["Int"]["input"]>;
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    version?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<Scalars["Int"]["input"]>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** An object where the defined keys will be set on the `toolVersion` being updated. */
export type UpdateToolVersionOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdPatch =
  {
    applicationUserToUserId?: InputMaybe<ToolVersionUserId68A75E07FkApplicationUserIdInput>;
    changelog?: InputMaybe<Scalars["String"]["input"]>;
    command?: InputMaybe<Scalars["String"]["input"]>;
    commandUsingId?: InputMaybe<CommandToolVersionId9DbddabaFkToolVersionIdInverseInput>;
    containerImageId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerImageId?: InputMaybe<ToolVersionContainerImageId32D92A94FkContainerImageIdInput>;
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    credits?: InputMaybe<Scalars["Float"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    draftToolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    gdtAnalysisTableRowsUsingId?: InputMaybe<GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput>;
    gdtAnalysisTablesUsingId?: InputMaybe<GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    isToolSpecForwardsCompatible?: InputMaybe<Scalars["Boolean"]["input"]>;
    isUpgradableToNextVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
    maturity?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    tasksUsingId?: InputMaybe<TaskToolVersionId14506837FkToolVersionIdInverseInput>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolVersionTenantId03A60B0CFkTenantIdInput>;
    toolParametersUsingId?: InputMaybe<ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput>;
    toolResourcesUsingId?: InputMaybe<ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput>;
    toolResultsUsingId?: InputMaybe<ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput>;
    toolSecretsUsingId?: InputMaybe<ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput>;
    toolSourcesUsingId?: InputMaybe<ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput>;
    toolSpec?: InputMaybe<Scalars["JSON"]["input"]>;
    toolSpecVersion?: InputMaybe<Scalars["Int"]["input"]>;
    toolToToolId?: InputMaybe<ToolVersionToolId3B396B22FkToolIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    version?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<Scalars["Int"]["input"]>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput>;
  };

/** An object where the defined keys will be set on the `toolbox` being updated. */
export type UpdateToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdPatch = {
  created?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsToolboxId9D553881FkToolboxIdInverseInput>;
  toolsUsingId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInverseInput>;
};

/** An object where the defined keys will be set on the `toolbox` being updated. */
export type UpdateToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdPatch =
  {
    created?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    toolboxTenantsUsingId?: InputMaybe<ToolboxTenantsToolboxId9D553881FkToolboxIdInverseInput>;
    toolsUsingId?: InputMaybe<ToolToolboxId7B1Eebf3FkToolboxIdInverseInput>;
  };

/** An object where the defined keys will be set on the `toolboxTenant` being updated. */
export type UpdateToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdPatch =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInput>;
    toolboxId?: InputMaybe<Scalars["Int"]["input"]>;
    toolboxToToolboxId?: InputMaybe<ToolboxTenantsToolboxId9D553881FkToolboxIdInput>;
  };

/** An object where the defined keys will be set on the `toolboxTenant` being updated. */
export type UpdateToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdPatch =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<ToolboxTenantsTenantId5D0A40E4FkTenantIdInput>;
    toolboxToToolboxId?: InputMaybe<ToolboxTenantsToolboxId9D553881FkToolboxIdInput>;
  };

/** An object where the defined keys will be set on the `userOnboardingQuestionAnswer` being updated. */
export type UpdateUserOnboardingQuestionAnswerOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboPatch =
  {
    answerType?: InputMaybe<Scalars["Int"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    maxLen?: InputMaybe<Scalars["Int"]["input"]>;
    option?: InputMaybe<Scalars["String"]["input"]>;
    salesforceOption?: InputMaybe<Scalars["String"]["input"]>;
    userOnboardingQuestionToQuestionId?: InputMaybe<UserOnboardingQuesQuestionIdC28D2284FkUserOnboInput>;
  };

/** An object where the defined keys will be set on the `userOnboardingQuestion` being updated. */
export type UpdateUserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboPatch =
  {
    category?: InputMaybe<Scalars["Int"]["input"]>;
    code?: InputMaybe<Scalars["String"]["input"]>;
    concatenateResponse?: InputMaybe<Scalars["Boolean"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    deprecated?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    multiAnswer?: InputMaybe<Scalars["Boolean"]["input"]>;
    optional?: InputMaybe<Scalars["Boolean"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    question?: InputMaybe<Scalars["String"]["input"]>;
    salesforceLeadAttributes?: InputMaybe<Scalars["String"]["input"]>;
    salesforceMultiAttribute?: InputMaybe<Scalars["Boolean"]["input"]>;
    userOnboardingQuestionAnswersUsingId?: InputMaybe<UserOnboardingQuesQuestionIdC28D2284FkUserOnboInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesQuestionId65Ae6E1FFkUserOnboInverseInput>;
  };

/** An object where the defined keys will be set on the `userOnboardingQuestion` being updated. */
export type UpdateUserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboPatch =
  {
    category?: InputMaybe<Scalars["Int"]["input"]>;
    code?: InputMaybe<Scalars["String"]["input"]>;
    concatenateResponse?: InputMaybe<Scalars["Boolean"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    deprecated?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    multiAnswer?: InputMaybe<Scalars["Boolean"]["input"]>;
    optional?: InputMaybe<Scalars["Boolean"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    question?: InputMaybe<Scalars["String"]["input"]>;
    salesforceLeadAttributes?: InputMaybe<Scalars["String"]["input"]>;
    salesforceMultiAttribute?: InputMaybe<Scalars["Boolean"]["input"]>;
    userOnboardingQuestionAnswersUsingId?: InputMaybe<UserOnboardingQuesQuestionIdC28D2284FkUserOnboInverseInput>;
    userOnboardingQuestionResponsesUsingId?: InputMaybe<UserOnboardingQuesQuestionId65Ae6E1FFkUserOnboInverseInput>;
  };

/** An object where the defined keys will be set on the `userOnboardingQuestionResponse` being updated. */
export type UpdateUserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboPatch =
  {
    applicationUserToUserId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    salesforceSynced?: InputMaybe<Scalars["Boolean"]["input"]>;
    text?: InputMaybe<Scalars["String"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    userOnboardingQuestionToQuestionId?: InputMaybe<UserOnboardingQuesQuestionId65Ae6E1FFkUserOnboInput>;
  };

/** An object where the defined keys will be set on the `userOnboardingQuestionResponse` being updated. */
export type UpdateUserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiPatch =
  {
    applicationUserToUserId?: InputMaybe<UserOnboardingQuesUserId72Eee3DfFkApplicatiInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    questionId?: InputMaybe<Scalars["Int"]["input"]>;
    salesforceSynced?: InputMaybe<Scalars["Boolean"]["input"]>;
    text?: InputMaybe<Scalars["String"]["input"]>;
    userOnboardingQuestionToQuestionId?: InputMaybe<UserOnboardingQuesQuestionId65Ae6E1FFkUserOnboInput>;
  };

/** An object where the defined keys will be set on the `userPersonalSpaceRequest` being updated. */
export type UpdateUserPersonalSpaceRequestOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiPatch =
  {
    applicationUserToUserId?: InputMaybe<UserPersonalSpaceUserId71D37C1EFkApplicatiInput>;
    dateActivated?: InputMaybe<Scalars["Datetime"]["input"]>;
    dateRequested?: InputMaybe<Scalars["Datetime"]["input"]>;
    id?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Scalars["Int"]["input"]>;
    synchronizeHome?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

/** An object where the defined keys will be set on the `workflowDatum` being updated. */
export type UpdateWorkflowDatumOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdPatch =
  {
    fresh?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowResultsUsingId?: InputMaybe<WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInverseInput>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInverseInput>;
  };

/** An object where the defined keys will be set on the `workflowDatum` being updated. */
export type UpdateWorkflowDatumOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdPatch =
  {
    fresh?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowResultsUsingId?: InputMaybe<WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInverseInput>;
    workflowSectionBlocksUsingId?: InputMaybe<WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInverseInput>;
  };

/** An object where the defined keys will be set on the `workflow` being updated. */
export type UpdateWorkflowOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdPatch =
  {
    applicationUserToUserId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInput>;
    containerImageToContainerId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInverseInput>;
  };

/** An object where the defined keys will be set on the `workflow` being updated. */
export type UpdateWorkflowOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdPatch =
  {
    applicationUserToUserId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInput>;
    containerId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    tenantToTenantId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInverseInput>;
  };

/** An object where the defined keys will be set on the `workflow` being updated. */
export type UpdateWorkflowOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInput>;
    containerId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInput>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInverseInput>;
  };

/** An object where the defined keys will be set on the `workflow` being updated. */
export type UpdateWorkflowOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdPatch =
  {
    applicationUserToUserId?: InputMaybe<WorkflowUserId121C1967FkApplicationUserIdInput>;
    containerId?: InputMaybe<Scalars["Int"]["input"]>;
    containerImageToContainerId?: InputMaybe<WorkflowContainerIdE73A96E5FkContainerImageIdInput>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    tenantId?: InputMaybe<Scalars["Int"]["input"]>;
    tenantToTenantId?: InputMaybe<WorkflowTenantId9469Ff84FkTenantIdInput>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowVersionsUsingId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInverseInput>;
  };

/** An object where the defined keys will be set on the `workflowResult` being updated. */
export type UpdateWorkflowResultOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdPatch =
  {
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowDatumToObjectId?: InputMaybe<WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInput>;
    workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkResultId50F959E2FkWorkflowInverseInput>;
  };

/** An object where the defined keys will be set on the `workflowResult` being updated. */
export type UpdateWorkflowResultOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowPatch =
  {
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    objectId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowDatumToObjectId?: InputMaybe<WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInput>;
    workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkResultId50F959E2FkWorkflowInverseInput>;
  };

/** An object where the defined keys will be set on the `workflowResultWorkflowVersion` being updated. */
export type UpdateWorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowPatch =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    workflowResultToResultId?: InputMaybe<WorkflowResultWorkResultId50F959E2FkWorkflowInput>;
    workflowVersionToWorkflowversionId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInput>;
    workflowversionId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `workflowResultWorkflowVersion` being updated. */
export type UpdateWorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowPatch =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    resultId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowResultToResultId?: InputMaybe<WorkflowResultWorkResultId50F959E2FkWorkflowInput>;
    workflowVersionToWorkflowversionId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInput>;
  };

/** An object where the defined keys will be set on the `workflowSectionBlock` being updated. */
export type UpdateWorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdPatch =
  {
    columns?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    markdown?: InputMaybe<Scalars["String"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    parameters?: InputMaybe<Scalars["JSON"]["input"]>;
    results?: InputMaybe<Scalars["JSON"]["input"]>;
    sources?: InputMaybe<Scalars["JSON"]["input"]>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInput>;
    workflowDatumToObjectId?: InputMaybe<WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInput>;
    workflowSectionBlockSectionsUsingId?: InputMaybe<WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInverseInput>;
  };

/** An object where the defined keys will be set on the `workflowSectionBlock` being updated. */
export type UpdateWorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdPatch =
  {
    columns?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    markdown?: InputMaybe<Scalars["String"]["input"]>;
    objectId?: InputMaybe<Scalars["UUID"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    parameters?: InputMaybe<Scalars["JSON"]["input"]>;
    results?: InputMaybe<Scalars["JSON"]["input"]>;
    sources?: InputMaybe<Scalars["JSON"]["input"]>;
    toolVersionToToolId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInput>;
    workflowDatumToObjectId?: InputMaybe<WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInput>;
    workflowSectionBlockSectionsUsingId?: InputMaybe<WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInverseInput>;
  };

/** An object where the defined keys will be set on the `workflowSectionBlock` being updated. */
export type UpdateWorkflowSectionBlockOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowPatch =
  {
    columns?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    markdown?: InputMaybe<Scalars["String"]["input"]>;
    objectId?: InputMaybe<Scalars["UUID"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    parameters?: InputMaybe<Scalars["JSON"]["input"]>;
    results?: InputMaybe<Scalars["JSON"]["input"]>;
    sources?: InputMaybe<Scalars["JSON"]["input"]>;
    toolId?: InputMaybe<Scalars["Int"]["input"]>;
    toolVersionToToolId?: InputMaybe<WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInput>;
    workflowDatumToObjectId?: InputMaybe<WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInput>;
    workflowSectionBlockSectionsUsingId?: InputMaybe<WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInverseInput>;
  };

/** An object where the defined keys will be set on the `workflowSectionBlockSection` being updated. */
export type UpdateWorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowPatch =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    sectionId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowSectionBlockToBlockId?: InputMaybe<WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInput>;
    workflowSectionToSectionId?: InputMaybe<WorkflowSectionBloSectionId817C1C77FkWorkflowInput>;
  };

/** An object where the defined keys will be set on the `workflowSectionBlockSection` being updated. */
export type UpdateWorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowPatch =
  {
    blockId?: InputMaybe<Scalars["UUID"]["input"]>;
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    workflowSectionBlockToBlockId?: InputMaybe<WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInput>;
    workflowSectionToSectionId?: InputMaybe<WorkflowSectionBloSectionId817C1C77FkWorkflowInput>;
  };

/** An object where the defined keys will be set on the `workflowSection` being updated. */
export type UpdateWorkflowSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowPatch =
  {
    description?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    workflowSectionBlockSectionsUsingId?: InputMaybe<WorkflowSectionBloSectionId817C1C77FkWorkflowInverseInput>;
    workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorSectionId1D5C2D63FkWorkflowInverseInput>;
  };

/** An object where the defined keys will be set on the `workflowSection` being updated. */
export type UpdateWorkflowSectionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowPatch =
  {
    description?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    workflowSectionBlockSectionsUsingId?: InputMaybe<WorkflowSectionBloSectionId817C1C77FkWorkflowInverseInput>;
    workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorSectionId1D5C2D63FkWorkflowInverseInput>;
  };

/** An object where the defined keys will be set on the `workflowSectionWorkflowVersion` being updated. */
export type UpdateWorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowPatch =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    workflowSectionToSectionId?: InputMaybe<WorkflowSectionWorSectionId1D5C2D63FkWorkflowInput>;
    workflowVersionToWorkflowversionId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInput>;
    workflowversionId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `workflowSectionWorkflowVersion` being updated. */
export type UpdateWorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowPatch =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    sectionId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowSectionToSectionId?: InputMaybe<WorkflowSectionWorSectionId1D5C2D63FkWorkflowInput>;
    workflowVersionToWorkflowversionId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInput>;
  };

/** An object where the defined keys will be set on the `workflowSource` being updated. */
export type UpdateWorkflowSourceOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowPatch =
  {
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowSourceWorkflowVersionsUsingId?: InputMaybe<WorkflowSourceWorkSourceId608A289DFkWorkflowInverseInput>;
  };

/** An object where the defined keys will be set on the `workflowSourceWorkflowVersion` being updated. */
export type UpdateWorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowPatch =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    workflowSourceToSourceId?: InputMaybe<WorkflowSourceWorkSourceId608A289DFkWorkflowInput>;
    workflowVersionToWorkflowversionId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInput>;
    workflowversionId?: InputMaybe<Scalars["UUID"]["input"]>;
  };

/** An object where the defined keys will be set on the `workflowSourceWorkflowVersion` being updated. */
export type UpdateWorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowPatch =
  {
    id?: InputMaybe<Scalars["BigInt"]["input"]>;
    sourceId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowSourceToSourceId?: InputMaybe<WorkflowSourceWorkSourceId608A289DFkWorkflowInput>;
    workflowVersionToWorkflowversionId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInput>;
  };

/** An object where the defined keys will be set on the `workflowVersion` being updated. */
export type UpdateWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowPatch =
  {
    applicationUserToUserId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInput>;
    autoGenerated?: InputMaybe<Scalars["Boolean"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    draft?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInverseInput>;
    workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInverseInput>;
    workflowSourceWorkflowVersionsUsingId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInverseInput>;
    workflowToWorkflowId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInput>;
  };

/** An object where the defined keys will be set on the `workflowVersion` being updated. */
export type UpdateWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowPatch =
  {
    applicationUserToUserId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInput>;
    autoGenerated?: InputMaybe<Scalars["Boolean"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    draft?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInverseInput>;
    workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInverseInput>;
    workflowSourceWorkflowVersionsUsingId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInverseInput>;
    workflowToWorkflowId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInput>;
  };

/** An object where the defined keys will be set on the `workflowVersion` being updated. */
export type UpdateWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowPatch =
  {
    applicationUserToUserId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInput>;
    autoGenerated?: InputMaybe<Scalars["Boolean"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    draft?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInverseInput>;
    workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInverseInput>;
    workflowSourceWorkflowVersionsUsingId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInverseInput>;
    workflowToWorkflowId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInput>;
  };

/** An object where the defined keys will be set on the `workflowVersion` being updated. */
export type UpdateWorkflowVersionOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdPatch =
  {
    applicationUserToUserId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInput>;
    autoGenerated?: InputMaybe<Scalars["Boolean"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    draft?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    workflowId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInverseInput>;
    workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInverseInput>;
    workflowSourceWorkflowVersionsUsingId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInverseInput>;
    workflowToWorkflowId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInput>;
  };

/** An object where the defined keys will be set on the `workflowVersion` being updated. */
export type UpdateWorkflowVersionOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdPatch =
  {
    applicationUserToUserId?: InputMaybe<WorkflowVersionUserId00C0F62FFkApplicationUserIdInput>;
    autoGenerated?: InputMaybe<Scalars["Boolean"]["input"]>;
    dateCreated?: InputMaybe<Scalars["Datetime"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    draft?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    userId?: InputMaybe<Scalars["UUID"]["input"]>;
    workflowResultWorkflowVersionsUsingId?: InputMaybe<WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInverseInput>;
    workflowSectionWorkflowVersionsUsingId?: InputMaybe<WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInverseInput>;
    workflowSourceWorkflowVersionsUsingId?: InputMaybe<WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInverseInput>;
    workflowToWorkflowId?: InputMaybe<WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInput>;
  };

export type GetTaskResourceUsageByTaskIdQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetTaskResourceUsageByTaskIdQuery = { __typename: "Query" } & {
  task: Maybe<
    { __typename: "Task" } & Pick<Task, "id" | "resourceTier"> & {
        resourceUsage: Maybe<
          { __typename: "TaskResourceUsage" } & Pick<
            TaskResourceUsage,
            | "id"
            | "cpuMin"
            | "cpuMax"
            | "memoryMin"
            | "memoryMax"
            | "storageMin"
            | "storageMax"
          >
        >;
        toolVersion: Maybe<
          { __typename: "ToolVersion" } & Pick<ToolVersion, "id" | "toolSpec">
        >;
      }
  >;
};

export type CreateEulaVersionUserAcceptanceMutationVariables = Exact<{
  input: CreateEulaVersionUserAcceptanceInput;
}>;

export type CreateEulaVersionUserAcceptanceMutation = {
  __typename: "Mutation";
} & {
  createEulaVersionUserAcceptance: Maybe<
    { __typename: "CreateEulaVersionUserAcceptancePayload" } & {
      applicationUserByUserId: Maybe<
        { __typename: "ApplicationUser" } & Pick<ApplicationUser, "id">
      >;
    }
  >;
};

export type GetAllEulaVersionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllEulaVersionsQuery = { __typename: "Query" } & {
  allEulaVersions: Maybe<
    { __typename: "EulaVersionsConnection" } & {
      nodes: Array<
        { __typename: "EulaVersion" } & Pick<EulaVersion, "id" | "content">
      >;
    }
  >;
};

export type FileBrowserDetailRendererAnalysisResultQueryVariables = Exact<{
  drsFileId: Scalars["UUID"]["input"];
}>;

export type FileBrowserDetailRendererAnalysisResultQuery = {
  __typename: "Query";
} & {
  drsFile: Maybe<
    { __typename: "File" } & Pick<File, "id"> & {
        project: Maybe<{ __typename: "Project" } & Pick<Project, "id" | "key">>;
        outputGroupFiles: { __typename: "OutputGroupFilesConnection" } & {
          nodes: Array<
            { __typename: "OutputGroupFile" } & Pick<OutputGroupFile, "id"> & {
                fileOutputGroup: Maybe<
                  { __typename: "FileOutputGroup" } & Pick<
                    FileOutputGroup,
                    "id"
                  > & {
                      task: Maybe<
                        { __typename: "Task" } & Pick<
                          Task,
                          "id" | "userId" | "status" | "created"
                        > & {
                            analysisTableRow: Maybe<
                              { __typename: "GdtAnalysisTableRow" } & Pick<
                                GdtAnalysisTableRow,
                                "id"
                              > & {
                                  analysisTable: Maybe<
                                    { __typename: "GdtAnalysisTable" } & Pick<
                                      GdtAnalysisTable,
                                      "id" | "name" | "key"
                                    >
                                  >;
                                }
                            >;
                          }
                      >;
                    }
                >;
              }
          >;
        };
      }
  >;
};

export type FlyoutDrsFileInfoQueryVariables = Exact<{
  drsFileId: Scalars["UUID"]["input"];
}>;

export type FlyoutDrsFileInfoQuery = { __typename: "Query" } & {
  drsFile: Maybe<
    { __typename: "File" } & Pick<
      File,
      | "preview"
      | "id"
      | "referenceId"
      | "dateArchived"
      | "dateCreated"
      | "dateDataDeleted"
      | "dateDeleted"
      | "fileType"
      | "tags"
      | "fileFormat"
      | "fileStructure"
      | "key"
      | "location"
      | "multipartUploadId"
      | "name"
      | "parentIds"
      | "partSize"
      | "projectId"
      | "signal"
      | "size"
      | "status"
      | "source"
      | "tenantId"
      | "uploadStatus"
      | "userId"
      | "originalName"
      | "seriesParentId"
      | "isSeries"
      | "seriesOrder"
      | "processingStatus"
    > & {
        seriesFiles: { __typename: "FilesConnection" } & {
          nodes: Array<
            { __typename: "File" } & Pick<
              File,
              | "preview"
              | "id"
              | "referenceId"
              | "dateArchived"
              | "dateCreated"
              | "dateDataDeleted"
              | "dateDeleted"
              | "fileType"
              | "tags"
              | "fileFormat"
              | "fileStructure"
              | "key"
              | "location"
              | "multipartUploadId"
              | "name"
              | "parentIds"
              | "partSize"
              | "projectId"
              | "signal"
              | "size"
              | "status"
              | "source"
              | "tenantId"
              | "uploadStatus"
              | "userId"
              | "originalName"
              | "seriesParentId"
              | "isSeries"
              | "seriesOrder"
              | "processingStatus"
            >
          >;
        };
        outputGroupFiles: { __typename: "OutputGroupFilesConnection" } & {
          nodes: Array<
            { __typename: "OutputGroupFile" } & Pick<OutputGroupFile, "id"> & {
                outputGroup: Maybe<
                  { __typename: "FileOutputGroup" } & Pick<
                    FileOutputGroup,
                    "id"
                  > & {
                      task: Maybe<
                        { __typename: "Task" } & Pick<
                          Task,
                          "id" | "userId" | "status" | "created"
                        > & {
                            analysisTableRow: Maybe<
                              { __typename: "GdtAnalysisTableRow" } & Pick<
                                GdtAnalysisTableRow,
                                "id"
                              > & {
                                  analysisTable: Maybe<
                                    { __typename: "GdtAnalysisTable" } & Pick<
                                      GdtAnalysisTable,
                                      "id" | "name" | "key"
                                    >
                                  >;
                                }
                            >;
                          }
                      >;
                    }
                >;
              }
          >;
        };
      }
  >;
};

export type FlyoutFilesGdtQueryVariables = Exact<{
  projectKey: Scalars["String"]["input"];
  tenantId: Scalars["Int"]["input"];
}>;

export type FlyoutFilesGdtQuery = { __typename: "Query" } & {
  project: Maybe<
    { __typename: "Project" } & Pick<
      Project,
      "id" | "key" | "name" | "tenantId"
    > & {
        files: { __typename: "FilesConnection" } & {
          nodes: Array<
            { __typename: "File" } & Pick<
              File,
              | "id"
              | "name"
              | "fileType"
              | "fileFormat"
              | "fileStructure"
              | "status"
              | "dateCreated"
              | "uploadStatus"
              | "projectId"
              | "size"
              | "seriesParentId"
              | "processingStatus"
              | "originalName"
              | "source"
              | "isSeries"
              | "tags"
              | "referenceId"
            > & {
                seriesFiles: { __typename: "FilesConnection" } & {
                  nodes: Array<
                    { __typename: "File" } & Pick<
                      File,
                      | "id"
                      | "name"
                      | "fileType"
                      | "fileFormat"
                      | "fileStructure"
                      | "status"
                      | "dateCreated"
                      | "uploadStatus"
                      | "projectId"
                      | "size"
                      | "seriesParentId"
                      | "processingStatus"
                      | "originalName"
                      | "tags"
                    >
                  >;
                };
                user: Maybe<
                  { __typename: "ApplicationUser" } & Pick<
                    ApplicationUser,
                    "id" | "firstName" | "lastName"
                  >
                >;
              }
          >;
        };
      }
  >;
};

export type ModalCreateSeriesQueryVariables = Exact<{
  drsFileIds: Array<Scalars["UUID"]["input"]> | Scalars["UUID"]["input"];
  metadataKeys: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type ModalCreateSeriesQuery = { __typename: "Query" } & {
  drsFiles: Maybe<
    { __typename: "FilesConnection" } & {
      nodes: Array<
        { __typename: "File" } & Pick<
          File,
          | "id"
          | "name"
          | "status"
          | "isSeries"
          | "seriesParentId"
          | "fileType"
          | "fileFormat"
          | "fileStructure"
          | "size"
        > & {
            metadata: { __typename: "FileMetadataConnection" } & {
              nodes: Array<
                { __typename: "FileMetadatum" } & Pick<FileMetadatum, "id"> & {
                    metadatum: Maybe<
                      { __typename: "Metadatum" } & Pick<
                        Metadatum,
                        "id" | "key" | "activeValue"
                      >
                    >;
                  }
              >;
            };
          }
      >;
    }
  >;
};

export type NotificationsFeedBodyQueryVariables = Exact<{
  condition?: InputMaybe<NotificationCondition>;
  notificationIds: Array<Scalars["UUID"]["input"]> | Scalars["UUID"]["input"];
}>;

export type NotificationsFeedBodyQuery = { __typename: "Query" } & {
  notifications: Maybe<
    { __typename: "NotificationsConnection" } & {
      nodes: Array<
        { __typename: "Notification" } & Pick<
          Notification,
          "id" | "dateCreated" | "hasSeen"
        > & {
            projectSharedNotification: Maybe<
              { __typename: "ProjectSharedNotification" } & Pick<
                ProjectSharedNotification,
                "id" | "accessLevel"
              > & {
                  project: Maybe<
                    { __typename: "Project" } & Pick<
                      Project,
                      "id" | "name" | "key"
                    > & {
                        tenant: Maybe<
                          { __typename: "Tenant" } & Pick<Tenant, "id" | "key">
                        >;
                      }
                  >;
                  sharer: Maybe<
                    { __typename: "ApplicationUser" } & Pick<
                      ApplicationUser,
                      "id" | "firstName" | "lastName"
                    >
                  >;
                }
            >;
            fileProcessingNotification: Maybe<
              { __typename: "FileProcessingNotification" } & Pick<
                FileProcessingNotification,
                "id" | "status" | "fileId" | "userId"
              > & {
                  file: Maybe<
                    { __typename: "File" } & Pick<
                      File,
                      | "id"
                      | "name"
                      | "status"
                      | "fileType"
                      | "isSeries"
                      | "source"
                      | "processingStatus"
                      | "seriesParentId"
                    > & {
                        project: Maybe<
                          { __typename: "Project" } & Pick<
                            Project,
                            "id" | "name" | "key"
                          > & {
                              tenant: Maybe<
                                { __typename: "Tenant" } & Pick<
                                  Tenant,
                                  "id" | "key"
                                >
                              >;
                            }
                        >;
                      }
                  >;
                  user: Maybe<
                    { __typename: "ApplicationUser" } & Pick<
                      ApplicationUser,
                      "id"
                    >
                  >;
                }
            >;
            projectClonedNotification: Maybe<
              { __typename: "ProjectClonedNotification" } & Pick<
                ProjectClonedNotification,
                "id" | "projectName" | "succeeded"
              > & {
                  project: Maybe<
                    { __typename: "Project" } & Pick<
                      Project,
                      "id" | "name" | "key" | "status"
                    > & {
                        tenant: Maybe<
                          { __typename: "Tenant" } & Pick<Tenant, "id" | "key">
                        >;
                      }
                  >;
                  srcProject: Maybe<
                    { __typename: "Project" } & Pick<
                      Project,
                      "id" | "name" | "key"
                    > & {
                        tenant: Maybe<
                          { __typename: "Tenant" } & Pick<Tenant, "id" | "key">
                        >;
                      }
                  >;
                }
            >;
            tenantUserMembershipNotification: Maybe<
              { __typename: "TenantUserMembershipNotification" } & Pick<
                TenantUserMembershipNotification,
                "id"
              > & {
                  inviter: Maybe<
                    { __typename: "ApplicationUser" } & Pick<
                      ApplicationUser,
                      "id" | "firstName" | "lastName"
                    >
                  >;
                  tenant: Maybe<
                    { __typename: "Tenant" } & Pick<
                      Tenant,
                      "id" | "key" | "name"
                    >
                  >;
                }
            >;
            roleChangeNotification: Maybe<
              { __typename: "RoleChangeNotification" } & Pick<
                RoleChangeNotification,
                "id" | "role"
              > & {
                  tenant: Maybe<
                    { __typename: "Tenant" } & Pick<
                      Tenant,
                      "id" | "key" | "name"
                    >
                  >;
                  user: Maybe<
                    { __typename: "ApplicationUser" } & Pick<
                      ApplicationUser,
                      "id"
                    >
                  >;
                }
            >;
          }
      >;
    }
  >;
};

export type PopoverFileUploadFragment = { __typename: "File" } & Pick<
  File,
  | "id"
  | "name"
  | "status"
  | "fileType"
  | "source"
  | "processingStatus"
  | "seriesParentId"
>;

export type ProjectInfoQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type ProjectInfoQuery = { __typename: "Query" } & {
  project: Maybe<
    { __typename: "Project" } & Pick<
      Project,
      "id" | "dateCreated" | "dateLastActive" | "key"
    > & {
        user: Maybe<
          { __typename: "ApplicationUser" } & Pick<
            ApplicationUser,
            "id" | "firstName" | "lastName"
          >
        >;
        tenant: Maybe<{ __typename: "Tenant" } & Pick<Tenant, "id" | "key">>;
        cloneSource: Maybe<
          { __typename: "Project" } & Pick<Project, "id" | "name" | "key"> & {
              tenant: Maybe<
                { __typename: "Tenant" } & Pick<Tenant, "id" | "key">
              >;
            }
        >;
      }
  >;
};

export type MetadataTableFileQueryVariables = Exact<{
  fileIds?: InputMaybe<
    Array<Scalars["UUID"]["input"]> | Scalars["UUID"]["input"]
  >;
  metadatumKeys?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type MetadataTableFileQuery = { __typename: "Query" } & {
  fileMetadata: Maybe<
    { __typename: "FileMetadataConnection" } & {
      nodes: Array<
        { __typename: "FileMetadatum" } & Pick<FileMetadatum, "id"> & {
            file: Maybe<{ __typename: "File" } & Pick<File, "id" | "fileType">>;
            metadatum: Maybe<
              { __typename: "Metadatum" } & Pick<
                Metadatum,
                "id" | "key" | "activeValue"
              >
            >;
          }
      >;
    }
  >;
};

export type ModalToolCellStatusParamQueryVariables = Exact<{
  fileIds: Array<Scalars["UUID"]["input"]> | Scalars["UUID"]["input"];
  metadatumKeys: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type ModalToolCellStatusParamQuery = { __typename: "Query" } & {
  files: Maybe<
    { __typename: "FilesConnection" } & {
      nodes: Array<
        { __typename: "File" } & Pick<
          File,
          "id" | "name" | "source" | "isSeries" | "fileType"
        > & {
            metadata: { __typename: "FileMetadataConnection" } & {
              nodes: Array<
                { __typename: "FileMetadatum" } & Pick<FileMetadatum, "id"> & {
                    metadatum: Maybe<
                      { __typename: "Metadatum" } & Pick<
                        Metadatum,
                        "id" | "key"
                      > & { value: Metadatum["activeValue"] }
                    >;
                  }
              >;
            };
            seriesMembers: { __typename: "FilesConnection" } & {
              nodes: Array<
                { __typename: "File" } & Pick<
                  File,
                  "id" | "name" | "source" | "fileType"
                > & {
                    metadata: { __typename: "FileMetadataConnection" } & {
                      nodes: Array<
                        { __typename: "FileMetadatum" } & Pick<
                          FileMetadatum,
                          "id"
                        > & {
                            metadatum: Maybe<
                              { __typename: "Metadatum" } & Pick<
                                Metadatum,
                                "id" | "key"
                              > & { value: Metadatum["activeValue"] }
                            >;
                          }
                      >;
                    };
                  }
              >;
            };
          }
      >;
    }
  >;
};

export type ModalToolRoiFrameParamQueryVariables = Exact<{
  fileIds: Array<Scalars["UUID"]["input"]> | Scalars["UUID"]["input"];
  metadatumKeys: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type ModalToolRoiFrameParamQuery = { __typename: "Query" } & {
  files: Maybe<
    { __typename: "FilesConnection" } & {
      nodes: Array<
        { __typename: "File" } & Pick<
          File,
          "id" | "name" | "source" | "isSeries"
        > & {
            metadata: { __typename: "FileMetadataConnection" } & {
              nodes: Array<
                { __typename: "FileMetadatum" } & Pick<FileMetadatum, "id"> & {
                    metadatum: Maybe<
                      { __typename: "Metadatum" } & Pick<
                        Metadatum,
                        "id" | "key"
                      > & { value: Metadatum["activeValue"] }
                    >;
                  }
              >;
            };
            seriesParent: Maybe<
              { __typename: "File" } & Pick<File, "id"> & {
                  metadata: { __typename: "FileMetadataConnection" } & {
                    nodes: Array<
                      { __typename: "FileMetadatum" } & Pick<
                        FileMetadatum,
                        "id"
                      > & {
                          metadatum: Maybe<
                            { __typename: "Metadatum" } & Pick<
                              Metadatum,
                              "id" | "key"
                            > & { value: Metadatum["activeValue"] }
                          >;
                        }
                    >;
                  };
                }
            >;
            seriesMembers: { __typename: "FilesConnection" } & {
              nodes: Array<
                { __typename: "File" } & Pick<
                  File,
                  "id" | "name" | "source"
                > & {
                    metadata: { __typename: "FileMetadataConnection" } & {
                      nodes: Array<
                        { __typename: "FileMetadatum" } & Pick<
                          FileMetadatum,
                          "id"
                        > & {
                            metadatum: Maybe<
                              { __typename: "Metadatum" } & Pick<
                                Metadatum,
                                "id" | "key"
                              > & { value: Metadatum["activeValue"] }
                            >;
                          }
                      >;
                    };
                  }
              >;
            };
          }
      >;
    }
  >;
};

export type UserAvatarFieldsFragment = { __typename: "ApplicationUser" } & Pick<
  ApplicationUser,
  "id" | "firstName" | "lastName"
> & {
    avatar: Maybe<
      { __typename: "Avatar" } & Pick<
        Avatar,
        "id" | "imageBase64" | "initials" | "useImage" | "color"
      >
    >;
  };

export type UserAvatarQueryVariables = Exact<{
  userId: Scalars["UUID"]["input"];
}>;

export type UserAvatarQuery = { __typename: "Query" } & {
  user: Maybe<
    { __typename: "ApplicationUser" } & Pick<
      ApplicationUser,
      "id" | "firstName" | "lastName"
    > & {
        avatar: Maybe<
          { __typename: "Avatar" } & Pick<
            Avatar,
            "id" | "imageBase64" | "initials" | "useImage" | "color"
          >
        >;
      }
  >;
};

export type ApplicationUserMembershipCacheFragment = {
  __typename: "ApplicationUserMembership";
} & Pick<ApplicationUserMembership, "id" | "role" | "tenantId" | "userId"> & {
    user: Maybe<
      { __typename: "ApplicationUser" } & Pick<ApplicationUser, "id">
    >;
    tenant: Maybe<{ __typename: "Tenant" } & Pick<Tenant, "id">>;
  };

export type FileCacheFragment = { __typename: "File" } & Pick<
  File,
  | "id"
  | "referenceId"
  | "dateArchived"
  | "dateCreated"
  | "dateDataDeleted"
  | "dateDeleted"
  | "fileFormat"
  | "fileStructure"
  | "fileType"
  | "tags"
  | "key"
  | "isSeries"
  | "location"
  | "multipartUploadId"
  | "name"
  | "parentIds"
  | "partSize"
  | "preview"
  | "projectId"
  | "signal"
  | "size"
  | "status"
  | "source"
  | "tenantId"
  | "uploadStatus"
  | "userId"
  | "originalName"
  | "seriesParentId"
  | "seriesOrder"
  | "processingStatus"
> & {
    fileBySeriesParentId: Maybe<{ __typename: "File" } & Pick<File, "id">>;
    seriesFiles: { __typename: "FilesConnection" } & {
      nodes: Array<{ __typename: "File" } & Pick<File, "id">>;
    };
    fileMetadata: { __typename: "FileMetadataConnection" } & {
      nodes: Array<{ __typename: "FileMetadatum" } & Pick<FileMetadatum, "id">>;
    };
    taskSources: { __typename: "TaskSourcesConnection" } & {
      nodes: Array<{ __typename: "TaskSource" } & Pick<TaskSource, "id">>;
    };
    tenant: Maybe<{ __typename: "Tenant" } & Pick<Tenant, "id">>;
    user: Maybe<
      { __typename: "ApplicationUser" } & Pick<ApplicationUser, "id">
    >;
    fileActivities: { __typename: "FileActivitiesConnection" } & {
      nodes: Array<{ __typename: "FileActivity" } & Pick<FileActivity, "id">>;
    };
    project: Maybe<{ __typename: "Project" } & Pick<Project, "id">>;
    outputGroupFiles: { __typename: "OutputGroupFilesConnection" } & {
      nodes: Array<
        { __typename: "OutputGroupFile" } & Pick<OutputGroupFile, "id">
      >;
    };
    fileProcessingNotifications: {
      __typename: "FileProcessingNotificationsConnection";
    } & {
      nodes: Array<
        { __typename: "FileProcessingNotification" } & Pick<
          FileProcessingNotification,
          "id"
        >
      >;
    };
  };

export type MetadatumCacheFragment = { __typename: "Metadatum" } & Pick<
  Metadatum,
  "id" | "activeValue" | "displayName" | "key" | "projectId" | "tenantId"
> & {
    fileMetadata: { __typename: "FileMetadataConnection" } & {
      nodes: Array<{ __typename: "FileMetadatum" } & Pick<FileMetadatum, "id">>;
    };
    fileOutputGroupMetadata: {
      __typename: "FileOutputGroupMetadataConnection";
    } & {
      nodes: Array<
        { __typename: "FileOutputGroupMetadatum" } & Pick<
          FileOutputGroupMetadatum,
          "id"
        >
      >;
    };
    metadataValues: { __typename: "MetadataValuesConnection" } & {
      nodes: Array<{ __typename: "MetadataValue" } & Pick<MetadataValue, "id">>;
    };
    project: Maybe<{ __typename: "Project" } & Pick<Project, "id">>;
    tenant: Maybe<{ __typename: "Tenant" } & Pick<Tenant, "id">>;
  };

export type NotificationCacheFragment = { __typename: "Notification" } & Pick<
  Notification,
  "id" | "dateCreated" | "hasSeen" | "userId"
> & {
    user: Maybe<
      { __typename: "ApplicationUser" } & Pick<ApplicationUser, "id">
    >;
    projectSharedNotification: Maybe<
      { __typename: "ProjectSharedNotification" } & Pick<
        ProjectSharedNotification,
        "id"
      >
    >;
    projectSharedNotifications: {
      __typename: "ProjectSharedNotificationsConnection";
    } & {
      nodes: Array<
        { __typename: "ProjectSharedNotification" } & Pick<
          ProjectSharedNotification,
          "id"
        >
      >;
    };
    tenantMembershipNotification: Maybe<
      { __typename: "TenantUserMembershipNotification" } & Pick<
        TenantUserMembershipNotification,
        "id"
      >
    >;
    tenantMembershipNotifications: {
      __typename: "TenantUserMembershipNotificationsConnection";
    } & {
      nodes: Array<
        { __typename: "TenantUserMembershipNotification" } & Pick<
          TenantUserMembershipNotification,
          "id"
        >
      >;
    };
    fileProcessingNotifications: {
      __typename: "FileProcessingNotificationsConnection";
    } & {
      nodes: Array<
        { __typename: "FileProcessingNotification" } & Pick<
          FileProcessingNotification,
          "id"
        >
      >;
    };
    fileProcessingNotification: Maybe<
      { __typename: "FileProcessingNotification" } & Pick<
        FileProcessingNotification,
        "id"
      >
    >;
    roleChangeNotifications: {
      __typename: "RoleChangeNotificationsConnection";
    } & {
      nodes: Array<
        { __typename: "RoleChangeNotification" } & Pick<
          RoleChangeNotification,
          "id"
        >
      >;
    };
    roleChangeNotification: Maybe<
      { __typename: "RoleChangeNotification" } & Pick<
        RoleChangeNotification,
        "id"
      >
    >;
    projectClonedNotifications: {
      __typename: "ProjectClonedNotificationsConnection";
    } & {
      nodes: Array<
        { __typename: "ProjectClonedNotification" } & Pick<
          ProjectClonedNotification,
          "id"
        >
      >;
    };
    projectClonedNotification: Maybe<
      { __typename: "ProjectClonedNotification" } & Pick<
        ProjectClonedNotification,
        "id"
      >
    >;
  };

export type ProjectCacheFragment = { __typename: "Project" } & Pick<
  Project,
  | "cloneSourceId"
  | "id"
  | "key"
  | "name"
  | "shortDescription"
  | "status"
  | "iconText"
  | "iconColor"
  | "icon"
  | "description"
  | "dateDeleted"
  | "dateDataDeleted"
  | "dateCreated"
  | "dateArchived"
  | "archivedStorageSize"
  | "activeStorageSize"
  | "tenantId"
  | "prefix"
  | "userId"
  | "defaultUserAccessLevel"
  | "usedCredits"
  | "pinned"
  | "dateLastActive"
> & {
    tenant: Maybe<{ __typename: "Tenant" } & Pick<Tenant, "id">>;
    activeFiles: { __typename: "FilesConnection" } & {
      nodes: Array<{ __typename: "File" } & Pick<File, "id">>;
    };
    user: Maybe<
      { __typename: "ApplicationUser" } & Pick<ApplicationUser, "id">
    >;
    files: { __typename: "FilesConnection" } & {
      nodes: Array<{ __typename: "File" } & Pick<File, "id">>;
    };
    tasks: { __typename: "TasksConnection" } & {
      nodes: Array<{ __typename: "Task" } & Pick<Task, "id">>;
    };
    fileActivities: { __typename: "FileActivitiesConnection" } & {
      nodes: Array<{ __typename: "FileActivity" } & Pick<FileActivity, "id">>;
    };
    fileMetadata: { __typename: "FileMetadataConnection" } & {
      nodes: Array<{ __typename: "FileMetadatum" } & Pick<FileMetadatum, "id">>;
    };
    fileOutputGroupMetadata: {
      __typename: "FileOutputGroupMetadataConnection";
    } & {
      nodes: Array<
        { __typename: "FileOutputGroupMetadatum" } & Pick<
          FileOutputGroupMetadatum,
          "id"
        >
      >;
    };
    fileOutputGroups: { __typename: "FileOutputGroupsConnection" } & {
      nodes: Array<
        { __typename: "FileOutputGroup" } & Pick<FileOutputGroup, "id">
      >;
    };
    metadata: { __typename: "MetadataConnection" } & {
      nodes: Array<{ __typename: "Metadatum" } & Pick<Metadatum, "id">>;
    };
    metadataValues: { __typename: "MetadataValuesConnection" } & {
      nodes: Array<{ __typename: "MetadataValue" } & Pick<MetadataValue, "id">>;
    };
    outputGroupFiles: { __typename: "OutputGroupFilesConnection" } & {
      nodes: Array<
        { __typename: "OutputGroupFile" } & Pick<OutputGroupFile, "id">
      >;
    };
    projectSharedNotifications: {
      __typename: "ProjectSharedNotificationsConnection";
    } & {
      nodes: Array<
        { __typename: "ProjectSharedNotification" } & Pick<
          ProjectSharedNotification,
          "id"
        >
      >;
    };
    projectByCloneSourceId: Maybe<
      { __typename: "Project" } & Pick<Project, "id">
    >;
    projectClonedNotifications: {
      __typename: "ProjectClonedNotificationsConnection";
    } & {
      nodes: Array<
        { __typename: "ProjectClonedNotification" } & Pick<
          ProjectClonedNotification,
          "id"
        >
      >;
    };
    projectClonedNotificationsBySrcProjectId: {
      __typename: "ProjectClonedNotificationsConnection";
    } & {
      nodes: Array<
        { __typename: "ProjectClonedNotification" } & Pick<
          ProjectClonedNotification,
          "id"
        >
      >;
    };
    projectTags: { __typename: "ProjectTagsConnection" } & {
      nodes: Array<{ __typename: "ProjectTag" } & Pick<ProjectTag, "id">>;
    };
  };

export type AvatarFieldsFragment = { __typename: "Avatar" } & Pick<
  Avatar,
  "id" | "color" | "initials" | "useImage" | "imageBase64"
>;

export type FileFieldsFragment = { __typename: "File" } & Pick<
  File,
  | "id"
  | "referenceId"
  | "dateArchived"
  | "dateCreated"
  | "dateDataDeleted"
  | "dateDeleted"
  | "fileType"
  | "tags"
  | "fileFormat"
  | "fileStructure"
  | "key"
  | "location"
  | "multipartUploadId"
  | "name"
  | "parentIds"
  | "partSize"
  | "projectId"
  | "signal"
  | "size"
  | "status"
  | "source"
  | "tenantId"
  | "uploadStatus"
  | "userId"
  | "originalName"
  | "seriesParentId"
  | "isSeries"
  | "seriesOrder"
  | "processingStatus"
>;

export type MetadataValueFieldsFragment = {
  __typename: "MetadataValue";
} & Pick<
  MetadataValue,
  | "id"
  | "value"
  | "dateCreated"
  | "metadataId"
  | "taskId"
  | "userId"
  | "tenantId"
  | "projectId"
>;

export type MetadatumFieldsFragment = { __typename: "Metadatum" } & Pick<
  Metadatum,
  "id" | "key" | "displayName" | "tenantId"
>;

export type FileOutputGroupFieldsFragment = {
  __typename: "FileOutputGroup";
} & Pick<
  FileOutputGroup,
  "id" | "dateCreated" | "taskId" | "tenantId" | "userId" | "groupType"
>;

export type ProjectFieldsFragment = { __typename: "Project" } & Pick<
  Project,
  | "id"
  | "key"
  | "name"
  | "shortDescription"
  | "description"
  | "icon"
  | "iconColor"
  | "iconText"
  | "isDemo"
  | "dateCreated"
  | "tenantId"
  | "userId"
  | "dateArchived"
  | "dateDeleted"
  | "dateDataDeleted"
  | "status"
  | "activeStorageSize"
  | "archivedStorageSize"
  | "defaultUserAccessLevel"
  | "pinned"
  | "usedCredits"
  | "dateLastActive"
>;

export type TaskFieldsFragment = { __typename: "Task" } & Pick<
  Task,
  | "id"
  | "taskParameters"
  | "toolExitcode"
  | "toolExitcodeDescription"
  | "created"
  | "tenantId"
  | "toolVersionId"
  | "userId"
  | "status"
  | "credits"
  | "cloned"
  | "projectId"
>;

export type TenantContractAllowanceFieldsFragment = {
  __typename: "TenantContractAllowance";
} & Pick<TenantContractAllowance, "id" | "quotaType" | "value">;

export type TenantContractFieldsFragment = {
  __typename: "TenantContract";
} & Pick<TenantContract, "id" | "name" | "created" | "startDate" | "endDate">;

export type TenantContractTransactionFieldsFragment = {
  __typename: "TenantContractTransaction";
} & Pick<TenantContractTransaction, "id" | "created" | "currency" | "price">;

export type TenantFieldsFragment = { __typename: "Tenant" } & Pick<
  Tenant,
  "id" | "name" | "key"
>;

export type ToolFieldsFragment = { __typename: "Tool" } & Pick<
  Tool,
  "id" | "name" | "key" | "helpText" | "created"
>;

export type ToolParameterFieldsFragment = {
  __typename: "ToolParameter";
} & Pick<
  ToolParameter,
  | "id"
  | "name"
  | "toolVersionId"
  | "helpText"
  | "default"
  | "options"
  | "unit"
  | "key"
>;

export type ToolResultFieldsFragment = { __typename: "ToolResult" } & Pick<
  ToolResult,
  "id" | "key" | "name" | "toolVersionId" | "helpText"
>;

export type ToolSourceFieldsFragment = { __typename: "ToolSource" } & Pick<
  ToolSource,
  "id" | "key" | "name" | "toolVersionId" | "required" | "helpText"
>;

export type ToolVersionFieldsFragment = { __typename: "ToolVersion" } & Pick<
  ToolVersion,
  "id" | "version" | "created" | "status" | "maturity" | "credits"
> & {
    tool: Maybe<
      { __typename: "Tool" } & Pick<
        Tool,
        "id" | "name" | "key" | "helpText" | "created"
      >
    >;
  };

export type UserFieldsFragment = { __typename: "ApplicationUser" } & Pick<
  ApplicationUser,
  | "id"
  | "username"
  | "firstName"
  | "lastName"
  | "email"
  | "internal"
  | "isActive"
>;

export type UserMetadatumFieldsFragment = {
  __typename: "ApplicationUserMetadatum";
} & Pick<ApplicationUserMetadatum, "id" | "userId" | "key" | "value">;

export type UserSessionFieldsFragment = {
  __typename: "ApplicationUserSession";
} & Pick<
  ApplicationUserSession,
  | "id"
  | "userId"
  | "tenantId"
  | "active"
  | "lastPath"
  | "state"
  | "datetimeLastActive"
>;

export type CreateMetadataValueMutationVariables = Exact<{
  metadataValue: MetadataValueInput;
}>;

export type CreateMetadataValueMutation = { __typename: "Mutation" } & {
  createMetadataValue: Maybe<
    { __typename: "CreateMetadataValuePayload" } & Pick<
      CreateMetadataValuePayload,
      "clientMutationId"
    > & {
        metadataValue: Maybe<
          { __typename: "MetadataValue" } & Pick<
            MetadataValue,
            | "id"
            | "value"
            | "dateCreated"
            | "metadataId"
            | "taskId"
            | "userId"
            | "tenantId"
            | "projectId"
          >
        >;
      }
  >;
};

export type CreateMetadatumMutationVariables = Exact<{
  metadata: MetadatumInput;
}>;

export type CreateMetadatumMutation = { __typename: "Mutation" } & {
  createMetadata: Maybe<
    { __typename: "CreateMetadatumPayload" } & Pick<
      CreateMetadatumPayload,
      "clientMutationId"
    > & {
        metadata: Maybe<
          { __typename: "Metadatum" } & Pick<
            Metadatum,
            "id" | "key" | "displayName" | "tenantId"
          >
        >;
      }
  >;
};

export type CreateUserMetadatumMutationVariables = Exact<{
  userMetadatum: ApplicationUserMetadatumInput;
}>;

export type CreateUserMetadatumMutation = { __typename: "Mutation" } & {
  createUserMetadatum: Maybe<
    { __typename: "CreateApplicationUserMetadatumPayload" } & Pick<
      CreateApplicationUserMetadatumPayload,
      "clientMutationId"
    > & {
        userMetadatum: Maybe<
          { __typename: "ApplicationUserMetadatum" } & Pick<
            ApplicationUserMetadatum,
            "id" | "userId" | "key" | "value"
          >
        >;
      }
  >;
};

export type CreateUserSessionMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  userid: Scalars["UUID"]["input"];
  tenant?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type CreateUserSessionMutation = { __typename: "Mutation" } & {
  createUserSession: Maybe<
    { __typename: "CreateSessionPayload" } & Pick<
      CreateSessionPayload,
      "clientMutationId"
    > & {
        userSession: Maybe<
          { __typename: "ApplicationUserSession" } & Pick<
            ApplicationUserSession,
            | "id"
            | "userId"
            | "tenantId"
            | "active"
            | "lastPath"
            | "state"
            | "datetimeLastActive"
          >
        >;
      }
  >;
};

export type UpdateApplicationUserByIdMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  patch: ApplicationUserPatch;
}>;

export type UpdateApplicationUserByIdMutation = { __typename: "Mutation" } & {
  updateApplicationUserById: Maybe<
    { __typename: "UpdateApplicationUserPayload" } & Pick<
      UpdateApplicationUserPayload,
      "clientMutationId"
    > & {
        applicationUser: Maybe<
          { __typename: "ApplicationUser" } & Pick<
            ApplicationUser,
            | "id"
            | "username"
            | "firstName"
            | "lastName"
            | "email"
            | "internal"
            | "isActive"
          > & {
              metadata: { __typename: "ApplicationUserMetadataConnection" } & {
                nodes: Array<
                  { __typename: "ApplicationUserMetadatum" } & Pick<
                    ApplicationUserMetadatum,
                    "id" | "userId" | "key" | "value"
                  >
                >;
              };
            }
        >;
      }
  >;
};

export type UpdateAvatarByIdMutationVariables = Exact<{
  id: Scalars["BigInt"]["input"];
  patch: AvatarPatch;
}>;

export type UpdateAvatarByIdMutation = { __typename: "Mutation" } & {
  updateAvatarById: Maybe<
    { __typename: "UpdateAvatarPayload" } & Pick<
      UpdateAvatarPayload,
      "clientMutationId"
    > & {
        avatar: Maybe<
          { __typename: "Avatar" } & Pick<
            Avatar,
            "id" | "color" | "initials" | "useImage" | "imageBase64"
          >
        >;
      }
  >;
};

export type UpdateUserMetadatumByIdMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
  patch: ApplicationUserMetadatumPatch;
}>;

export type UpdateUserMetadatumByIdMutation = { __typename: "Mutation" } & {
  updateUserMetadatumById: Maybe<
    { __typename: "UpdateApplicationUserMetadatumPayload" } & Pick<
      UpdateApplicationUserMetadatumPayload,
      "clientMutationId"
    > & {
        userMetadatum: Maybe<
          { __typename: "ApplicationUserMetadatum" } & Pick<
            ApplicationUserMetadatum,
            "id" | "userId" | "key" | "value"
          >
        >;
      }
  >;
};

export type GetAllTasksQueryVariables = Exact<{
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
}>;

export type GetAllTasksQuery = { __typename: "Query" } & {
  tasks: Maybe<
    { __typename: "TasksConnection" } & {
      nodes: Array<
        { __typename: "Task" } & Pick<
          Task,
          | "id"
          | "taskParameters"
          | "toolExitcode"
          | "toolExitcodeDescription"
          | "created"
          | "tenantId"
          | "toolVersionId"
          | "userId"
          | "status"
          | "credits"
          | "cloned"
          | "projectId"
        > & {
            toolVersion: Maybe<
              { __typename: "ToolVersion" } & Pick<
                ToolVersion,
                "id" | "version" | "created" | "status" | "maturity" | "credits"
              > & {
                  tool: Maybe<
                    { __typename: "Tool" } & Pick<
                      Tool,
                      "id" | "name" | "key" | "helpText" | "created"
                    >
                  >;
                }
            >;
            outputGroup: Maybe<
              { __typename: "FileOutputGroup" } & Pick<
                FileOutputGroup,
                | "id"
                | "dateCreated"
                | "taskId"
                | "tenantId"
                | "userId"
                | "groupType"
              > & {
                  task: Maybe<
                    { __typename: "Task" } & Pick<
                      Task,
                      "id" | "status" | "created"
                    >
                  >;
                  outputGroupFiles: {
                    __typename: "OutputGroupFilesConnection";
                  } & {
                    nodes: Array<
                      { __typename: "OutputGroupFile" } & Pick<
                        OutputGroupFile,
                        "id"
                      > & {
                          drsFile: Maybe<
                            { __typename: "File" } & Pick<
                              File,
                              | "id"
                              | "referenceId"
                              | "dateArchived"
                              | "dateCreated"
                              | "dateDataDeleted"
                              | "dateDeleted"
                              | "fileFormat"
                              | "fileStructure"
                              | "fileType"
                              | "tags"
                              | "key"
                              | "isSeries"
                              | "location"
                              | "multipartUploadId"
                              | "name"
                              | "parentIds"
                              | "partSize"
                              | "preview"
                              | "projectId"
                              | "signal"
                              | "size"
                              | "status"
                              | "source"
                              | "tenantId"
                              | "uploadStatus"
                              | "userId"
                              | "originalName"
                              | "seriesParentId"
                              | "seriesOrder"
                              | "processingStatus"
                            > & {
                                fileMetadata: {
                                  __typename: "FileMetadataConnection";
                                } & {
                                  nodes: Array<
                                    { __typename: "FileMetadatum" } & Pick<
                                      FileMetadatum,
                                      "id"
                                    > & {
                                        metadata: Maybe<
                                          { __typename: "Metadatum" } & Pick<
                                            Metadatum,
                                            "id" | "key" | "activeValue"
                                          >
                                        >;
                                      }
                                  >;
                                };
                                fileBySeriesParentId: Maybe<
                                  { __typename: "File" } & Pick<File, "id">
                                >;
                                seriesFiles: {
                                  __typename: "FilesConnection";
                                } & {
                                  nodes: Array<
                                    { __typename: "File" } & Pick<File, "id">
                                  >;
                                };
                                taskSources: {
                                  __typename: "TaskSourcesConnection";
                                } & {
                                  nodes: Array<
                                    { __typename: "TaskSource" } & Pick<
                                      TaskSource,
                                      "id"
                                    >
                                  >;
                                };
                                tenant: Maybe<
                                  { __typename: "Tenant" } & Pick<Tenant, "id">
                                >;
                                user: Maybe<
                                  { __typename: "ApplicationUser" } & Pick<
                                    ApplicationUser,
                                    "id"
                                  >
                                >;
                                fileActivities: {
                                  __typename: "FileActivitiesConnection";
                                } & {
                                  nodes: Array<
                                    { __typename: "FileActivity" } & Pick<
                                      FileActivity,
                                      "id"
                                    >
                                  >;
                                };
                                project: Maybe<
                                  { __typename: "Project" } & Pick<
                                    Project,
                                    "id"
                                  >
                                >;
                                outputGroupFiles: {
                                  __typename: "OutputGroupFilesConnection";
                                } & {
                                  nodes: Array<
                                    { __typename: "OutputGroupFile" } & Pick<
                                      OutputGroupFile,
                                      "id"
                                    >
                                  >;
                                };
                                fileProcessingNotifications: {
                                  __typename: "FileProcessingNotificationsConnection";
                                } & {
                                  nodes: Array<
                                    {
                                      __typename: "FileProcessingNotification";
                                    } & Pick<FileProcessingNotification, "id">
                                  >;
                                };
                              }
                          >;
                        }
                    >;
                  };
                  metadata: {
                    __typename: "FileOutputGroupMetadataConnection";
                  } & {
                    nodes: Array<
                      { __typename: "FileOutputGroupMetadatum" } & Pick<
                        FileOutputGroupMetadatum,
                        "id"
                      > & {
                          metadatum: Maybe<
                            { __typename: "Metadatum" } & Pick<
                              Metadatum,
                              "id" | "key" | "displayName" | "tenantId"
                            > & {
                                values: {
                                  __typename: "MetadataValuesConnection";
                                } & {
                                  nodes: Array<
                                    { __typename: "MetadataValue" } & Pick<
                                      MetadataValue,
                                      | "id"
                                      | "value"
                                      | "dateCreated"
                                      | "metadataId"
                                      | "taskId"
                                      | "userId"
                                      | "tenantId"
                                      | "projectId"
                                    >
                                  >;
                                };
                              }
                          >;
                        }
                    >;
                  };
                }
            >;
            user: Maybe<
              { __typename: "ApplicationUser" } & Pick<
                ApplicationUser,
                | "id"
                | "username"
                | "firstName"
                | "lastName"
                | "email"
                | "internal"
                | "isActive"
              >
            >;
            taskActivityByTaskId: Maybe<
              { __typename: "TaskActivity" } & Pick<TaskActivity, "id"> & {
                  duration: { __typename: "Interval" } & Pick<
                    Interval,
                    | "hours"
                    | "seconds"
                    | "minutes"
                    | "days"
                    | "years"
                    | "months"
                  >;
                }
            >;
            taskResourcesByTaskId: { __typename: "TaskResourcesConnection" } & {
              nodes: Array<
                { __typename: "TaskResource" } & Pick<
                  TaskResource,
                  "id" | "type" | "value"
                >
              >;
            };
          }
      >;
    }
  >;
};

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentUserQuery = { __typename: "Query" } & {
  currentUser: Maybe<
    { __typename: "ApplicationUser" } & Pick<
      ApplicationUser,
      | "id"
      | "username"
      | "firstName"
      | "lastName"
      | "email"
      | "internal"
      | "isActive"
    > & {
        metadata: { __typename: "ApplicationUserMetadataConnection" } & {
          nodes: Array<
            { __typename: "ApplicationUserMetadatum" } & Pick<
              ApplicationUserMetadatum,
              "id" | "userId" | "key" | "value"
            >
          >;
        };
        memberships: { __typename: "ApplicationUserMembershipsConnection" } & {
          nodes: Array<
            { __typename: "ApplicationUserMembership" } & Pick<
              ApplicationUserMembership,
              "id"
            > & {
                tenant: Maybe<
                  { __typename: "Tenant" } & Pick<Tenant, "id" | "name" | "key">
                >;
              }
          >;
        };
      }
  >;
};

export type GetFileMetadataByFileIdQueryVariables = Exact<{
  drsFileId: Scalars["UUID"]["input"];
  metadataFilter?: InputMaybe<FileMetadatumFilter>;
}>;

export type GetFileMetadataByFileIdQuery = { __typename: "Query" } & {
  drsFile: Maybe<
    { __typename: "File" } & Pick<File, "id"> & {
        metadata: { __typename: "FileMetadataConnection" } & {
          nodes: Array<
            { __typename: "FileMetadatum" } & Pick<FileMetadatum, "id"> & {
                metadatum: Maybe<
                  { __typename: "Metadatum" } & Pick<
                    Metadatum,
                    "activeValue" | "id" | "key" | "displayName" | "tenantId"
                  >
                >;
              }
          >;
        };
        seriesParentFile: Maybe<
          { __typename: "File" } & Pick<File, "id"> & {
              metadata: { __typename: "FileMetadataConnection" } & {
                nodes: Array<
                  { __typename: "FileMetadatum" } & Pick<
                    FileMetadatum,
                    "id"
                  > & {
                      metadatum: Maybe<
                        { __typename: "Metadatum" } & Pick<
                          Metadatum,
                          | "activeValue"
                          | "id"
                          | "key"
                          | "displayName"
                          | "tenantId"
                        >
                      >;
                    }
                >;
              };
            }
        >;
      }
  >;
};

export type GetProjectByIdQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetProjectByIdQuery = { __typename: "Query" } & {
  projectById: Maybe<
    { __typename: "Project" } & Pick<
      Project,
      | "id"
      | "key"
      | "name"
      | "shortDescription"
      | "description"
      | "icon"
      | "iconColor"
      | "iconText"
      | "isDemo"
      | "dateCreated"
      | "tenantId"
      | "userId"
      | "dateArchived"
      | "dateDeleted"
      | "dateDataDeleted"
      | "status"
      | "activeStorageSize"
      | "archivedStorageSize"
      | "defaultUserAccessLevel"
      | "pinned"
      | "usedCredits"
      | "dateLastActive"
    >
  >;
};

export type GetTaskByIdQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetTaskByIdQuery = { __typename: "Query" } & {
  task: Maybe<
    { __typename: "Task" } & Pick<
      Task,
      | "id"
      | "taskParameters"
      | "toolExitcode"
      | "toolExitcodeDescription"
      | "created"
      | "tenantId"
      | "toolVersionId"
      | "userId"
      | "status"
      | "credits"
      | "cloned"
      | "projectId"
    >
  >;
};

export type GetToolVersionsByToolIdAndVersionsQueryVariables = Exact<{
  toolId: Scalars["Int"]["input"];
  versions: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type GetToolVersionsByToolIdAndVersionsQuery = {
  __typename: "Query";
} & {
  toolVersions: Maybe<
    { __typename: "ToolVersionsConnection" } & {
      nodes: Array<
        { __typename: "ToolVersion" } & Pick<
          ToolVersion,
          "id" | "version" | "created" | "status" | "maturity" | "credits"
        > & {
            toolSources: { __typename: "ToolSourcesConnection" } & {
              nodes: Array<
                { __typename: "ToolSource" } & Pick<
                  ToolSource,
                  | "id"
                  | "key"
                  | "name"
                  | "toolVersionId"
                  | "required"
                  | "helpText"
                >
              >;
            };
            toolParameters: { __typename: "ToolParametersConnection" } & {
              nodes: Array<
                { __typename: "ToolParameter" } & Pick<
                  ToolParameter,
                  | "id"
                  | "name"
                  | "toolVersionId"
                  | "helpText"
                  | "default"
                  | "options"
                  | "unit"
                  | "key"
                >
              >;
            };
            toolResults: { __typename: "ToolResultsConnection" } & {
              nodes: Array<
                { __typename: "ToolResult" } & Pick<
                  ToolResult,
                  "id" | "key" | "name" | "toolVersionId" | "helpText"
                >
              >;
            };
            tool: Maybe<
              { __typename: "Tool" } & Pick<
                Tool,
                "id" | "name" | "key" | "helpText" | "created"
              >
            >;
          }
      >;
    }
  >;
};

export type GetUserSessionByIdQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetUserSessionByIdQuery = { __typename: "Query" } & {
  userSession: Maybe<
    { __typename: "ApplicationUserSession" } & Pick<
      ApplicationUserSession,
      | "id"
      | "userId"
      | "tenantId"
      | "active"
      | "lastPath"
      | "state"
      | "datetimeLastActive"
    >
  >;
};

export type ExportToDandiToolInfoQueryVariables = Exact<{
  activeStatus?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ExportToDandiToolInfoQuery = { __typename: "Query" } & {
  allTools: Maybe<
    { __typename: "ToolsConnection" } & {
      nodes: Array<
        { __typename: "Tool" } & Pick<Tool, "id"> & {
            toolVersions: { __typename: "ToolVersionsConnection" } & {
              nodes: Array<
                { __typename: "ToolVersion" } & Pick<ToolVersion, "id"> & {
                    toolSources: { __typename: "ToolSourcesConnection" } & {
                      nodes: Array<
                        { __typename: "ToolSource" } & Pick<
                          ToolSource,
                          "id" | "key"
                        >
                      >;
                    };
                    toolParameters: {
                      __typename: "ToolParametersConnection";
                    } & {
                      nodes: Array<
                        { __typename: "ToolParameter" } & Pick<
                          ToolParameter,
                          "id" | "key"
                        >
                      >;
                    };
                    toolSecrets: { __typename: "ToolSecretsConnection" } & {
                      nodes: Array<
                        { __typename: "ToolSecret" } & Pick<
                          ToolSecret,
                          "id" | "key"
                        >
                      >;
                    };
                  }
              >;
            };
          }
      >;
    }
  >;
};

export type GetProcessingStatusQueryVariables = Exact<{
  drsFileIds: Array<Scalars["UUID"]["input"]> | Scalars["UUID"]["input"];
}>;

export type GetProcessingStatusQuery = { __typename: "Query" } & {
  files: Maybe<
    { __typename: "FilesConnection" } & {
      nodes: Array<
        { __typename: "File" } & Pick<File, "id" | "processingStatus">
      >;
    }
  >;
};

export type ProcessingStatusFragment = { __typename: "File" } & Pick<
  File,
  "id" | "processingStatus" | "isSeries"
>;

export type GetExternalTenantsQueryVariables = Exact<{ [key: string]: never }>;

export type GetExternalTenantsQuery = { __typename: "Query" } & {
  currentUser: Maybe<
    { __typename: "ApplicationUser" } & Pick<ApplicationUser, "id"> & {
        memberships: { __typename: "ApplicationUserMembershipsConnection" } & {
          nodes: Array<
            { __typename: "ApplicationUserMembership" } & Pick<
              ApplicationUserMembership,
              "id"
            > & {
                tenant: Maybe<
                  { __typename: "Tenant" } & Pick<
                    Tenant,
                    "id" | "key" | "name" | "tenantType"
                  >
                >;
              }
          >;
        };
      }
  >;
};

export type GetFileProcessTasksQueryVariables = Exact<{
  drsFileId: Scalars["UUID"]["input"];
  failedStatuses: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"];
}>;

export type GetFileProcessTasksQuery = { __typename: "Query" } & {
  file: Maybe<
    { __typename: "File" } & Pick<File, "id"> & {
        taskSources: { __typename: "TaskSourcesConnection" } & {
          nodes: Array<
            { __typename: "TaskSource" } & Pick<TaskSource, "id"> & {
                task: Maybe<
                  { __typename: "Task" } & Pick<
                    Task,
                    "id" | "status" | "errorDescription" | "created"
                  > & {
                      toolVersion: Maybe<
                        { __typename: "ToolVersion" } & Pick<
                          ToolVersion,
                          "id"
                        > & {
                            tool: Maybe<
                              { __typename: "Tool" } & Pick<
                                Tool,
                                "id" | "name" | "key"
                              >
                            >;
                          }
                      >;
                    }
                >;
              }
          >;
        };
      }
  >;
};

export type CellEditorFileQueryVariables = Exact<{
  projectId: Scalars["UUID"]["input"];
}>;

export type CellEditorFileQuery = { __typename: "Query" } & {
  project: Maybe<
    { __typename: "Project" } & Pick<Project, "id" | "isToolProject"> & {
        files: { __typename: "FilesConnection" } & {
          nodes: Array<
            { __typename: "File" } & Pick<
              File,
              | "id"
              | "referenceId"
              | "name"
              | "fileType"
              | "tags"
              | "source"
              | "isSeries"
              | "originalName"
              | "status"
              | "fileFormat"
              | "processingStatus"
              | "seriesParentId"
              | "projectId"
            > & {
                seriesFiles: { __typename: "FilesConnection" } & {
                  nodes: Array<
                    { __typename: "File" } & Pick<File, "id" | "name">
                  >;
                };
              }
          >;
        };
      }
  >;
};

export type CellEditorToolVersionQueryVariables = Exact<{
  toolVersionId: Scalars["Int"]["input"];
}>;

export type CellEditorToolVersionQuery = { __typename: "Query" } & {
  toolVersion: Maybe<
    { __typename: "ToolVersion" } & Pick<ToolVersion, "id"> & {
        compatibleVersions: { __typename: "ToolVersionsConnection" } & {
          nodes: Array<
            { __typename: "ToolVersion" } & Pick<
              ToolVersion,
              "id" | "version" | "toolSpec" | "credits" | "status"
            >
          >;
        };
      }
  >;
};

export type CellValueRendererFileFieldsFragment = { __typename: "File" } & Pick<
  File,
  | "id"
  | "name"
  | "originalName"
  | "status"
  | "fileFormat"
  | "fileType"
  | "tags"
  | "isSeries"
  | "source"
  | "processingStatus"
  | "seriesParentId"
  | "projectId"
  | "referenceId"
>;

export type DataTableUpgradeButtonQueryVariables = Exact<{
  toolVersionId: Scalars["Int"]["input"];
}>;

export type DataTableUpgradeButtonQuery = { __typename: "Query" } & {
  toolVersion: Maybe<
    { __typename: "ToolVersion" } & Pick<ToolVersion, "id"> & {
        tool: Maybe<
          { __typename: "Tool" } & Pick<Tool, "id"> & {
              toolVersions: { __typename: "ToolVersionsConnection" } & {
                nodes: Array<
                  { __typename: "ToolVersion" } & Pick<ToolVersion, "id">
                >;
              };
            }
        >;
      }
  >;
};

export type ModalMapAnalysisParametersQueryVariables = Exact<{
  toolVersionId: Scalars["Int"]["input"];
}>;

export type ModalMapAnalysisParametersQuery = { __typename: "Query" } & {
  toolVersion: Maybe<
    { __typename: "ToolVersion" } & Pick<ToolVersion, "id" | "toolSpec">
  >;
};

export type PageProjectQueryVariables = Exact<{
  projectKey: Scalars["String"]["input"];
  tenantId: Scalars["Int"]["input"];
}>;

export type PageProjectQuery = { __typename: "Query" } & {
  project: Maybe<
    { __typename: "Project" } & Pick<
      Project,
      | "isToolProject"
      | "dateLastActive"
      | "id"
      | "key"
      | "name"
      | "shortDescription"
      | "description"
      | "icon"
      | "iconColor"
      | "iconText"
      | "isDemo"
      | "dateCreated"
      | "tenantId"
      | "userId"
      | "dateArchived"
      | "dateDeleted"
      | "dateDataDeleted"
      | "status"
      | "activeStorageSize"
      | "archivedStorageSize"
      | "defaultUserAccessLevel"
      | "pinned"
      | "usedCredits"
    >
  >;
};

export type GetDrsFilesQueryVariables = Exact<{
  ids: Array<Scalars["UUID"]["input"]> | Scalars["UUID"]["input"];
}>;

export type GetDrsFilesQuery = { __typename: "Query" } & {
  drsFiles: Maybe<
    { __typename: "FilesConnection" } & {
      nodes: Array<
        { __typename: "File" } & Pick<
          File,
          | "id"
          | "referenceId"
          | "dateArchived"
          | "dateCreated"
          | "dateDataDeleted"
          | "dateDeleted"
          | "fileFormat"
          | "fileStructure"
          | "fileType"
          | "tags"
          | "key"
          | "isSeries"
          | "location"
          | "multipartUploadId"
          | "name"
          | "parentIds"
          | "partSize"
          | "preview"
          | "projectId"
          | "signal"
          | "size"
          | "status"
          | "source"
          | "tenantId"
          | "uploadStatus"
          | "userId"
          | "originalName"
          | "seriesParentId"
          | "seriesOrder"
          | "processingStatus"
        > & {
            fileBySeriesParentId: Maybe<
              { __typename: "File" } & Pick<File, "id">
            >;
            seriesFiles: { __typename: "FilesConnection" } & {
              nodes: Array<{ __typename: "File" } & Pick<File, "id">>;
            };
            fileMetadata: { __typename: "FileMetadataConnection" } & {
              nodes: Array<
                { __typename: "FileMetadatum" } & Pick<FileMetadatum, "id">
              >;
            };
            taskSources: { __typename: "TaskSourcesConnection" } & {
              nodes: Array<
                { __typename: "TaskSource" } & Pick<TaskSource, "id">
              >;
            };
            tenant: Maybe<{ __typename: "Tenant" } & Pick<Tenant, "id">>;
            user: Maybe<
              { __typename: "ApplicationUser" } & Pick<ApplicationUser, "id">
            >;
            fileActivities: { __typename: "FileActivitiesConnection" } & {
              nodes: Array<
                { __typename: "FileActivity" } & Pick<FileActivity, "id">
              >;
            };
            project: Maybe<{ __typename: "Project" } & Pick<Project, "id">>;
            outputGroupFiles: { __typename: "OutputGroupFilesConnection" } & {
              nodes: Array<
                { __typename: "OutputGroupFile" } & Pick<OutputGroupFile, "id">
              >;
            };
            fileProcessingNotifications: {
              __typename: "FileProcessingNotificationsConnection";
            } & {
              nodes: Array<
                { __typename: "FileProcessingNotification" } & Pick<
                  FileProcessingNotification,
                  "id"
                >
              >;
            };
          }
      >;
    }
  >;
};

export type TasksTableGdtQueryVariables = Exact<{
  condition?: InputMaybe<TaskCondition>;
  filter?: InputMaybe<TaskFilter>;
}>;

export type TasksTableGdtQuery = { __typename: "Query" } & {
  allTasks: Maybe<
    { __typename: "TasksConnection" } & {
      nodes: Array<
        { __typename: "Task" } & Pick<
          Task,
          "id" | "credits" | "cloned" | "status" | "created"
        > & {
            analysisTableRow: Maybe<
              { __typename: "GdtAnalysisTableRow" } & Pick<
                GdtAnalysisTableRow,
                "id" | "index" | "dateDeleted"
              > & {
                  table: Maybe<
                    { __typename: "GdtAnalysisTable" } & Pick<
                      GdtAnalysisTable,
                      "id" | "name" | "key" | "dateDeleted"
                    >
                  >;
                }
            >;
            toolVersion: Maybe<
              { __typename: "ToolVersion" } & Pick<
                ToolVersion,
                "id" | "toolSpec" | "visibility"
              > & {
                  tool: Maybe<
                    { __typename: "Tool" } & Pick<Tool, "id" | "key">
                  >;
                }
            >;
            taskActivityByTaskId: Maybe<
              { __typename: "TaskActivity" } & Pick<TaskActivity, "id"> & {
                  duration: { __typename: "Interval" } & Pick<
                    Interval,
                    | "hours"
                    | "seconds"
                    | "minutes"
                    | "days"
                    | "years"
                    | "months"
                  >;
                }
            >;
            user: Maybe<
              { __typename: "ApplicationUser" } & Pick<
                ApplicationUser,
                "id" | "firstName" | "lastName"
              >
            >;
            outputGroup: Maybe<
              { __typename: "FileOutputGroup" } & Pick<
                FileOutputGroup,
                "id"
              > & {
                  outputGroupFiles: {
                    __typename: "OutputGroupFilesConnection";
                  } & {
                    nodes: Array<
                      { __typename: "OutputGroupFile" } & Pick<
                        OutputGroupFile,
                        "id"
                      > & {
                          drsFile: Maybe<
                            { __typename: "File" } & Pick<
                              File,
                              "id" | "name" | "isSeries" | "status" | "key"
                            >
                          >;
                        }
                    >;
                  };
                }
            >;
          }
      >;
    }
  >;
};

export type TenantProviderQueryVariables = Exact<{
  tenantKey: Scalars["String"]["input"];
}>;

export type TenantProviderQuery = { __typename: "Query" } & {
  tenant: Maybe<
    { __typename: "Tenant" } & Pick<
      Tenant,
      "id" | "name" | "key" | "internal" | "tenantType"
    > & {
        memberships: { __typename: "ApplicationUserMembershipsConnection" } & {
          nodes: Array<
            { __typename: "ApplicationUserMembership" } & Pick<
              ApplicationUserMembership,
              "id" | "role"
            > & {
                user: Maybe<
                  { __typename: "ApplicationUser" } & Pick<
                    ApplicationUser,
                    | "id"
                    | "firstName"
                    | "lastName"
                    | "email"
                    | "username"
                    | "internal"
                    | "isActive"
                  > & {
                      avatar: Maybe<
                        { __typename: "Avatar" } & Pick<
                          Avatar,
                          | "id"
                          | "color"
                          | "initials"
                          | "useImage"
                          | "imageBase64"
                        >
                      >;
                      metadata: {
                        __typename: "ApplicationUserMetadataConnection";
                      } & {
                        nodes: Array<
                          { __typename: "ApplicationUserMetadatum" } & Pick<
                            ApplicationUserMetadatum,
                            "id" | "key" | "value"
                          >
                        >;
                      };
                    }
                >;
              }
          >;
        };
      }
  >;
};

export type UserProviderQueryVariables = Exact<{ [key: string]: never }>;

export type UserProviderQuery = { __typename: "Query" } & {
  currentUser: Maybe<
    { __typename: "ApplicationUser" } & Pick<
      ApplicationUser,
      | "id"
      | "firstName"
      | "lastName"
      | "email"
      | "username"
      | "internal"
      | "isActive"
    > & {
        metadata: { __typename: "ApplicationUserMetadataConnection" } & {
          nodes: Array<
            { __typename: "ApplicationUserMetadatum" } & Pick<
              ApplicationUserMetadatum,
              "id" | "key" | "value"
            >
          >;
        };
        eula: { __typename: "EulaVersionUserAcceptancesConnection" } & {
          nodes: Array<
            { __typename: "EulaVersionUserAcceptance" } & Pick<
              EulaVersionUserAcceptance,
              "id" | "accepted"
            >
          >;
        };
        memberships: { __typename: "ApplicationUserMembershipsConnection" } & {
          nodes: Array<
            { __typename: "ApplicationUserMembership" } & Pick<
              ApplicationUserMembership,
              "id" | "role"
            > & {
                tenant: Maybe<
                  { __typename: "Tenant" } & Pick<
                    Tenant,
                    "id" | "key" | "name" | "tenantType"
                  >
                >;
              }
          >;
        };
        avatar: Maybe<
          { __typename: "Avatar" } & Pick<
            Avatar,
            "id" | "imageBase64" | "initials" | "useImage" | "color"
          >
        >;
      }
  >;
};

export const PopoverFileUploadFragmentDoc = gql`
  fragment PopoverFileUpload on File {
    id
    name
    status
    fileType
    source
    processingStatus
    seriesParentId
  }
`;
export const UserAvatarFieldsFragmentDoc = gql`
  fragment UserAvatarFields on ApplicationUser {
    id
    firstName
    lastName
    avatar: avatarByUserId {
      id
      imageBase64
      initials
      useImage
      color
    }
  }
`;
export const ApplicationUserMembershipCacheFragmentDoc = gql`
  fragment ApplicationUserMembershipCache on ApplicationUserMembership {
    id
    role
    tenantId
    userId
    user: applicationUserByUserId {
      id
    }
    tenant: tenantByTenantId {
      id
    }
  }
`;
export const FileCacheFragmentDoc = gql`
  fragment FileCache on File {
    id
    referenceId
    dateArchived
    dateCreated
    dateDataDeleted
    dateDeleted
    fileFormat
    fileStructure
    fileType
    tags
    key
    isSeries
    location
    multipartUploadId
    name
    parentIds
    partSize
    preview
    projectId
    signal
    size
    status
    source
    tenantId
    uploadStatus
    userId
    originalName
    seriesParentId
    seriesOrder
    processingStatus
    fileBySeriesParentId {
      id
    }
    seriesFiles: filesBySeriesParentId {
      nodes {
        id
      }
    }
    fileMetadata: fileMetadataByFileId {
      nodes {
        id
      }
    }
    taskSources: taskSourcesByFileId {
      nodes {
        id
      }
    }
    tenant: tenantByTenantId {
      id
    }
    user: applicationUserByUserId {
      id
    }
    fileActivities: fileActivitiesByFileId {
      nodes {
        id
      }
    }
    project: projectByProjectId {
      id
    }
    seriesFiles: filesBySeriesParentId {
      nodes {
        id
      }
    }
    user: applicationUserByUserId {
      id
    }
    outputGroupFiles: outputGroupFilesByFileId {
      nodes {
        id
      }
    }
    fileMetadata: fileMetadataByFileId {
      nodes {
        id
      }
    }
    taskSources: taskSourcesByFileId {
      nodes {
        id
      }
    }
    fileProcessingNotifications: fileProcessingNotificationsByFileId {
      nodes {
        id
      }
    }
  }
`;
export const MetadatumCacheFragmentDoc = gql`
  fragment MetadatumCache on Metadatum {
    id
    activeValue
    displayName
    fileMetadata: fileMetadataByMetadataId {
      nodes {
        id
      }
    }
    fileOutputGroupMetadata: fileOutputGroupMetadataByMetadataId {
      nodes {
        id
      }
    }
    id
    key
    metadataValues: metadataValuesByMetadataId {
      nodes {
        id
      }
    }
    project: projectByProjectId {
      id
    }
    projectId
    tenant: tenantByTenantId {
      id
    }
    tenantId
  }
`;
export const NotificationCacheFragmentDoc = gql`
  fragment NotificationCache on Notification {
    id
    dateCreated
    hasSeen
    userId
    user: applicationUserByUserId {
      id
    }
    projectSharedNotification: projectSharedNotificationById {
      id
    }
    projectSharedNotifications: projectSharedNotificationsById {
      nodes {
        id
      }
    }
    tenantMembershipNotification: tenantUserMembershipNotificationById {
      id
    }
    tenantMembershipNotifications: tenantUserMembershipNotificationsById {
      nodes {
        id
      }
    }
    fileProcessingNotifications: fileProcessingNotificationsById {
      nodes {
        id
      }
    }
    fileProcessingNotification: fileProcessingNotificationById {
      id
    }
    roleChangeNotifications: roleChangeNotificationsById {
      nodes {
        id
      }
    }
    roleChangeNotification: roleChangeNotificationById {
      id
    }
    projectClonedNotifications: projectClonedNotificationsById {
      nodes {
        id
      }
    }
    projectClonedNotification: projectClonedNotificationById {
      id
    }
  }
`;
export const ProjectCacheFragmentDoc = gql`
  fragment ProjectCache on Project {
    cloneSourceId
    id
    key
    name
    shortDescription
    status
    iconText
    iconColor
    icon
    description
    dateDeleted
    dateDataDeleted
    dateCreated
    dateArchived
    archivedStorageSize
    activeStorageSize
    tenantId
    prefix
    userId
    defaultUserAccessLevel
    usedCredits
    pinned
    dateLastActive
    tenant: tenantByTenantId {
      id
    }
    activeFiles {
      nodes {
        id
      }
    }
    user: applicationUserByUserId {
      id
    }
    files: filesByProjectId {
      nodes {
        id
      }
    }
    tasks: tasksByProjectId {
      nodes {
        id
      }
    }
    fileActivities: fileActivitiesByProjectId {
      nodes {
        id
      }
    }
    fileMetadata: fileMetadataByProjectId {
      nodes {
        id
      }
    }
    fileOutputGroupMetadata: fileOutputGroupMetadataByProjectId {
      nodes {
        id
      }
    }
    fileOutputGroups: fileOutputGroupsByProjectId {
      nodes {
        id
      }
    }
    metadata: metadataByProjectId {
      nodes {
        id
      }
    }
    metadataValues: metadataValuesByProjectId {
      nodes {
        id
      }
    }
    outputGroupFiles: outputGroupFilesByProjectId {
      nodes {
        id
      }
    }
    projectSharedNotifications: projectSharedNotificationsByProjectId {
      nodes {
        id
      }
    }
    projectByCloneSourceId {
      id
    }
    projectClonedNotifications: projectClonedNotificationsByProjectId {
      nodes {
        id
      }
    }
    projectClonedNotificationsBySrcProjectId {
      nodes {
        id
      }
    }
    projectTags: projectTagsByProjectId {
      nodes {
        id
      }
    }
  }
`;
export const AvatarFieldsFragmentDoc = gql`
  fragment AvatarFields on Avatar {
    id
    color
    initials
    useImage
    imageBase64
  }
`;
export const FileFieldsFragmentDoc = gql`
  fragment FileFields on File {
    id
    referenceId
    dateArchived
    dateCreated
    dateDataDeleted
    dateDeleted
    fileType
    tags
    fileFormat
    fileStructure
    key
    location
    multipartUploadId
    name
    parentIds
    partSize
    projectId
    signal
    size
    status
    source
    tenantId
    uploadStatus
    userId
    originalName
    seriesParentId
    isSeries
    seriesOrder
    processingStatus
    tags
  }
`;
export const MetadataValueFieldsFragmentDoc = gql`
  fragment MetadataValueFields on MetadataValue {
    id
    value
    dateCreated
    metadataId
    taskId
    userId
    tenantId
    projectId
  }
`;
export const MetadatumFieldsFragmentDoc = gql`
  fragment MetadatumFields on Metadatum {
    id
    key
    displayName
    tenantId
  }
`;
export const FileOutputGroupFieldsFragmentDoc = gql`
  fragment FileOutputGroupFields on FileOutputGroup {
    id
    dateCreated
    taskId
    tenantId
    userId
    groupType
  }
`;
export const ProjectFieldsFragmentDoc = gql`
  fragment ProjectFields on Project {
    id
    key
    name
    shortDescription
    description
    icon
    iconColor
    iconText
    isDemo
    dateCreated
    tenantId
    userId
    dateArchived
    dateDeleted
    dateDataDeleted
    status
    activeStorageSize
    archivedStorageSize
    defaultUserAccessLevel
    pinned
    usedCredits
    dateLastActive
  }
`;
export const TaskFieldsFragmentDoc = gql`
  fragment TaskFields on Task {
    id
    taskParameters
    toolExitcode
    toolExitcodeDescription
    created
    tenantId
    toolVersionId
    userId
    status
    credits
    cloned
    projectId
  }
`;
export const TenantContractAllowanceFieldsFragmentDoc = gql`
  fragment TenantContractAllowanceFields on TenantContractAllowance {
    id
    quotaType
    value
  }
`;
export const TenantContractFieldsFragmentDoc = gql`
  fragment TenantContractFields on TenantContract {
    id
    name
    created
    startDate
    endDate
  }
`;
export const TenantContractTransactionFieldsFragmentDoc = gql`
  fragment TenantContractTransactionFields on TenantContractTransaction {
    id
    created
    currency
    price
  }
`;
export const TenantFieldsFragmentDoc = gql`
  fragment TenantFields on Tenant {
    id
    name
    key
  }
`;
export const ToolParameterFieldsFragmentDoc = gql`
  fragment ToolParameterFields on ToolParameter {
    id
    name
    toolVersionId
    helpText
    default
    options
    unit
    key
  }
`;
export const ToolResultFieldsFragmentDoc = gql`
  fragment ToolResultFields on ToolResult {
    id
    key
    name
    toolVersionId
    helpText
  }
`;
export const ToolSourceFieldsFragmentDoc = gql`
  fragment ToolSourceFields on ToolSource {
    id
    key
    name
    toolVersionId
    required
    helpText
  }
`;
export const ToolFieldsFragmentDoc = gql`
  fragment ToolFields on Tool {
    id
    name
    key
    helpText
    created
  }
`;
export const ToolVersionFieldsFragmentDoc = gql`
  fragment ToolVersionFields on ToolVersion {
    id
    version
    created
    status
    maturity
    credits
    tool: toolByToolId {
      ...ToolFields
    }
  }
  ${ToolFieldsFragmentDoc}
`;
export const UserFieldsFragmentDoc = gql`
  fragment UserFields on ApplicationUser {
    id
    username
    firstName
    lastName
    email
    internal
    isActive
  }
`;
export const UserMetadatumFieldsFragmentDoc = gql`
  fragment UserMetadatumFields on ApplicationUserMetadatum {
    id
    userId
    key
    value
  }
`;
export const UserSessionFieldsFragmentDoc = gql`
  fragment UserSessionFields on ApplicationUserSession {
    id
    userId
    tenantId
    active
    lastPath
    state
    datetimeLastActive
  }
`;
export const ProcessingStatusFragmentDoc = gql`
  fragment ProcessingStatus on File {
    id
    processingStatus
    isSeries
  }
`;
export const CellValueRendererFileFieldsFragmentDoc = gql`
  fragment CellValueRendererFileFields on File {
    id
    name
    originalName
    status
    fileFormat
    fileType
    tags
    isSeries
    source
    processingStatus
    seriesParentId
    projectId
    referenceId
  }
`;
export const GetTaskResourceUsageByTaskIdDocument = gql`
  query GetTaskResourceUsageByTaskId($id: UUID!) {
    task: taskById(id: $id) {
      id
      resourceUsage: taskResourceUsageByTaskId {
        id
        cpuMin
        cpuMax
        memoryMin
        memoryMax
        storageMin
        storageMax
      }
      toolVersion: toolVersionByToolVersionId {
        id
        toolSpec
      }
      resourceTier
    }
  }
`;

/**
 * __useGetTaskResourceUsageByTaskIdQuery__
 *
 * To run a query within a React component, call `useGetTaskResourceUsageByTaskIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskResourceUsageByTaskIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskResourceUsageByTaskIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskResourceUsageByTaskIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTaskResourceUsageByTaskIdQuery,
    GetTaskResourceUsageByTaskIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTaskResourceUsageByTaskIdQuery,
    GetTaskResourceUsageByTaskIdQueryVariables
  >(GetTaskResourceUsageByTaskIdDocument, options);
}
export function useGetTaskResourceUsageByTaskIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTaskResourceUsageByTaskIdQuery,
    GetTaskResourceUsageByTaskIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTaskResourceUsageByTaskIdQuery,
    GetTaskResourceUsageByTaskIdQueryVariables
  >(GetTaskResourceUsageByTaskIdDocument, options);
}
export type GetTaskResourceUsageByTaskIdQueryHookResult = ReturnType<
  typeof useGetTaskResourceUsageByTaskIdQuery
>;
export type GetTaskResourceUsageByTaskIdLazyQueryHookResult = ReturnType<
  typeof useGetTaskResourceUsageByTaskIdLazyQuery
>;
export type GetTaskResourceUsageByTaskIdQueryResult = Apollo.QueryResult<
  GetTaskResourceUsageByTaskIdQuery,
  GetTaskResourceUsageByTaskIdQueryVariables
>;
export const CreateEulaVersionUserAcceptanceDocument = gql`
  mutation CreateEulaVersionUserAcceptance(
    $input: CreateEulaVersionUserAcceptanceInput!
  ) {
    createEulaVersionUserAcceptance(input: $input) {
      applicationUserByUserId {
        id
      }
    }
  }
`;
export type CreateEulaVersionUserAcceptanceMutationFn = Apollo.MutationFunction<
  CreateEulaVersionUserAcceptanceMutation,
  CreateEulaVersionUserAcceptanceMutationVariables
>;

/**
 * __useCreateEulaVersionUserAcceptanceMutation__
 *
 * To run a mutation, you first call `useCreateEulaVersionUserAcceptanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEulaVersionUserAcceptanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEulaVersionUserAcceptanceMutation, { data, loading, error }] = useCreateEulaVersionUserAcceptanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEulaVersionUserAcceptanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEulaVersionUserAcceptanceMutation,
    CreateEulaVersionUserAcceptanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateEulaVersionUserAcceptanceMutation,
    CreateEulaVersionUserAcceptanceMutationVariables
  >(CreateEulaVersionUserAcceptanceDocument, options);
}
export type CreateEulaVersionUserAcceptanceMutationHookResult = ReturnType<
  typeof useCreateEulaVersionUserAcceptanceMutation
>;
export type CreateEulaVersionUserAcceptanceMutationResult =
  Apollo.MutationResult<CreateEulaVersionUserAcceptanceMutation>;
export type CreateEulaVersionUserAcceptanceMutationOptions =
  Apollo.BaseMutationOptions<
    CreateEulaVersionUserAcceptanceMutation,
    CreateEulaVersionUserAcceptanceMutationVariables
  >;
export const GetAllEulaVersionsDocument = gql`
  query GetAllEulaVersions {
    allEulaVersions(first: 1, orderBy: VERSION_DESC) {
      nodes {
        id
        content
      }
    }
  }
`;

/**
 * __useGetAllEulaVersionsQuery__
 *
 * To run a query within a React component, call `useGetAllEulaVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEulaVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEulaVersionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEulaVersionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllEulaVersionsQuery,
    GetAllEulaVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllEulaVersionsQuery,
    GetAllEulaVersionsQueryVariables
  >(GetAllEulaVersionsDocument, options);
}
export function useGetAllEulaVersionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllEulaVersionsQuery,
    GetAllEulaVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllEulaVersionsQuery,
    GetAllEulaVersionsQueryVariables
  >(GetAllEulaVersionsDocument, options);
}
export type GetAllEulaVersionsQueryHookResult = ReturnType<
  typeof useGetAllEulaVersionsQuery
>;
export type GetAllEulaVersionsLazyQueryHookResult = ReturnType<
  typeof useGetAllEulaVersionsLazyQuery
>;
export type GetAllEulaVersionsQueryResult = Apollo.QueryResult<
  GetAllEulaVersionsQuery,
  GetAllEulaVersionsQueryVariables
>;
export const FileBrowserDetailRendererAnalysisResultDocument = gql`
  query FileBrowserDetailRendererAnalysisResult($drsFileId: UUID!) {
    drsFile: fileById(id: $drsFileId) {
      id
      project: projectByProjectId {
        id
        key
      }
      outputGroupFiles: outputGroupFilesByFileId {
        nodes {
          id
          fileOutputGroup: fileOutputGroupByFileOutputGroupId {
            id
            task: taskByTaskId {
              id
              userId
              status
              created
              analysisTableRow: gdtAnalysisTableRowByTaskId {
                id
                analysisTable: gdtAnalysisTableByTableId {
                  id
                  name
                  key
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useFileBrowserDetailRendererAnalysisResultQuery__
 *
 * To run a query within a React component, call `useFileBrowserDetailRendererAnalysisResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileBrowserDetailRendererAnalysisResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileBrowserDetailRendererAnalysisResultQuery({
 *   variables: {
 *      drsFileId: // value for 'drsFileId'
 *   },
 * });
 */
export function useFileBrowserDetailRendererAnalysisResultQuery(
  baseOptions: Apollo.QueryHookOptions<
    FileBrowserDetailRendererAnalysisResultQuery,
    FileBrowserDetailRendererAnalysisResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FileBrowserDetailRendererAnalysisResultQuery,
    FileBrowserDetailRendererAnalysisResultQueryVariables
  >(FileBrowserDetailRendererAnalysisResultDocument, options);
}
export function useFileBrowserDetailRendererAnalysisResultLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FileBrowserDetailRendererAnalysisResultQuery,
    FileBrowserDetailRendererAnalysisResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FileBrowserDetailRendererAnalysisResultQuery,
    FileBrowserDetailRendererAnalysisResultQueryVariables
  >(FileBrowserDetailRendererAnalysisResultDocument, options);
}
export type FileBrowserDetailRendererAnalysisResultQueryHookResult = ReturnType<
  typeof useFileBrowserDetailRendererAnalysisResultQuery
>;
export type FileBrowserDetailRendererAnalysisResultLazyQueryHookResult =
  ReturnType<typeof useFileBrowserDetailRendererAnalysisResultLazyQuery>;
export type FileBrowserDetailRendererAnalysisResultQueryResult =
  Apollo.QueryResult<
    FileBrowserDetailRendererAnalysisResultQuery,
    FileBrowserDetailRendererAnalysisResultQueryVariables
  >;
export const FlyoutDrsFileInfoDocument = gql`
  query FlyoutDrsFileInfo($drsFileId: UUID!) {
    drsFile: fileById(id: $drsFileId) {
      ...FileFields
      preview
      seriesFiles: filesBySeriesParentId(
        orderBy: [SERIES_ORDER_ASC, NAME_ASC]
      ) {
        nodes {
          ...FileFields
          preview
        }
      }
      outputGroupFiles: outputGroupFilesByFileId {
        nodes {
          id
          outputGroup: fileOutputGroupByFileOutputGroupId {
            id
            task: taskByTaskId {
              id
              userId
              status
              created
              analysisTableRow: gdtAnalysisTableRowByTaskId {
                id
                analysisTable: gdtAnalysisTableByTableId {
                  id
                  name
                  key
                }
              }
            }
          }
        }
      }
    }
  }
  ${FileFieldsFragmentDoc}
`;

/**
 * __useFlyoutDrsFileInfoQuery__
 *
 * To run a query within a React component, call `useFlyoutDrsFileInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlyoutDrsFileInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlyoutDrsFileInfoQuery({
 *   variables: {
 *      drsFileId: // value for 'drsFileId'
 *   },
 * });
 */
export function useFlyoutDrsFileInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    FlyoutDrsFileInfoQuery,
    FlyoutDrsFileInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FlyoutDrsFileInfoQuery,
    FlyoutDrsFileInfoQueryVariables
  >(FlyoutDrsFileInfoDocument, options);
}
export function useFlyoutDrsFileInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FlyoutDrsFileInfoQuery,
    FlyoutDrsFileInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FlyoutDrsFileInfoQuery,
    FlyoutDrsFileInfoQueryVariables
  >(FlyoutDrsFileInfoDocument, options);
}
export type FlyoutDrsFileInfoQueryHookResult = ReturnType<
  typeof useFlyoutDrsFileInfoQuery
>;
export type FlyoutDrsFileInfoLazyQueryHookResult = ReturnType<
  typeof useFlyoutDrsFileInfoLazyQuery
>;
export type FlyoutDrsFileInfoQueryResult = Apollo.QueryResult<
  FlyoutDrsFileInfoQuery,
  FlyoutDrsFileInfoQueryVariables
>;
export const FlyoutFilesGdtDocument = gql`
  query FlyoutFilesGDT($projectKey: String!, $tenantId: Int!) {
    project: projectByKeyAndTenantId(key: $projectKey, tenantId: $tenantId) {
      id
      key
      name
      tenantId
      files: filesByProjectId {
        nodes {
          ...CellValueRendererFileFields
          id
          name
          fileType
          fileFormat
          fileStructure
          status
          dateCreated
          uploadStatus
          projectId
          size
          seriesParentId
          processingStatus
          fileFormat
          originalName
          source
          isSeries
          tags
          seriesFiles: filesBySeriesParentId {
            nodes {
              id
              name
              fileType
              fileFormat
              fileStructure
              status
              dateCreated
              uploadStatus
              projectId
              size
              seriesParentId
              processingStatus
              fileFormat
              originalName
              tags
            }
          }
          user: applicationUserByUserId {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
  ${CellValueRendererFileFieldsFragmentDoc}
`;

/**
 * __useFlyoutFilesGdtQuery__
 *
 * To run a query within a React component, call `useFlyoutFilesGdtQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlyoutFilesGdtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlyoutFilesGdtQuery({
 *   variables: {
 *      projectKey: // value for 'projectKey'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useFlyoutFilesGdtQuery(
  baseOptions: Apollo.QueryHookOptions<
    FlyoutFilesGdtQuery,
    FlyoutFilesGdtQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FlyoutFilesGdtQuery, FlyoutFilesGdtQueryVariables>(
    FlyoutFilesGdtDocument,
    options,
  );
}
export function useFlyoutFilesGdtLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FlyoutFilesGdtQuery,
    FlyoutFilesGdtQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FlyoutFilesGdtQuery, FlyoutFilesGdtQueryVariables>(
    FlyoutFilesGdtDocument,
    options,
  );
}
export type FlyoutFilesGdtQueryHookResult = ReturnType<
  typeof useFlyoutFilesGdtQuery
>;
export type FlyoutFilesGdtLazyQueryHookResult = ReturnType<
  typeof useFlyoutFilesGdtLazyQuery
>;
export type FlyoutFilesGdtQueryResult = Apollo.QueryResult<
  FlyoutFilesGdtQuery,
  FlyoutFilesGdtQueryVariables
>;
export const ModalCreateSeriesDocument = gql`
  query ModalCreateSeries($drsFileIds: [UUID!]!, $metadataKeys: [String!]!) {
    drsFiles: allFiles(filter: { id: { in: $drsFileIds } }) {
      nodes {
        id
        name
        status
        isSeries
        seriesParentId
        fileType
        fileFormat
        fileStructure
        size
        metadata: fileMetadataByFileId(
          orderBy: ID_DESC
          filter: { metadatumByMetadataId: { key: { in: $metadataKeys } } }
        ) {
          nodes {
            id
            metadatum: metadatumByMetadataId {
              id
              key
              activeValue
            }
          }
        }
      }
    }
  }
`;

/**
 * __useModalCreateSeriesQuery__
 *
 * To run a query within a React component, call `useModalCreateSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalCreateSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalCreateSeriesQuery({
 *   variables: {
 *      drsFileIds: // value for 'drsFileIds'
 *      metadataKeys: // value for 'metadataKeys'
 *   },
 * });
 */
export function useModalCreateSeriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ModalCreateSeriesQuery,
    ModalCreateSeriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ModalCreateSeriesQuery,
    ModalCreateSeriesQueryVariables
  >(ModalCreateSeriesDocument, options);
}
export function useModalCreateSeriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ModalCreateSeriesQuery,
    ModalCreateSeriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ModalCreateSeriesQuery,
    ModalCreateSeriesQueryVariables
  >(ModalCreateSeriesDocument, options);
}
export type ModalCreateSeriesQueryHookResult = ReturnType<
  typeof useModalCreateSeriesQuery
>;
export type ModalCreateSeriesLazyQueryHookResult = ReturnType<
  typeof useModalCreateSeriesLazyQuery
>;
export type ModalCreateSeriesQueryResult = Apollo.QueryResult<
  ModalCreateSeriesQuery,
  ModalCreateSeriesQueryVariables
>;
export const NotificationsFeedBodyDocument = gql`
  query NotificationsFeedBody(
    $condition: NotificationCondition
    $notificationIds: [UUID!]!
  ) {
    notifications: allNotifications(
      orderBy: DATE_CREATED_DESC
      condition: $condition
      filter: { id: { in: $notificationIds } }
    ) {
      nodes {
        id
        dateCreated
        hasSeen
        projectSharedNotification: projectSharedNotificationById {
          id
          project: projectByProjectId {
            id
            name
            key
            tenant: tenantByTenantId {
              id
              key
            }
          }
          sharer: applicationUserBySharerId {
            id
            firstName
            lastName
          }
          accessLevel
        }
        fileProcessingNotification: fileProcessingNotificationById {
          id
          status
          fileId
          userId
          file: fileByFileId {
            id
            name
            status
            fileType
            isSeries
            source
            processingStatus
            seriesParentId
            project: projectByProjectId {
              id
              name
              key
              tenant: tenantByTenantId {
                id
                key
              }
            }
          }
          user: applicationUserByUserId {
            id
          }
        }
        projectClonedNotification: projectClonedNotificationById {
          id
          project: projectByProjectId {
            id
            name
            key
            status
            tenant: tenantByTenantId {
              id
              key
            }
          }
          srcProject: projectBySrcProjectId {
            id
            name
            key
            tenant: tenantByTenantId {
              id
              key
            }
          }
          projectName
          succeeded
        }
        tenantUserMembershipNotification: tenantUserMembershipNotificationById {
          id
          inviter: applicationUserByInviterId {
            id
            firstName
            lastName
          }
          tenant: tenantByTenantId {
            id
            key
            name
          }
        }
        roleChangeNotification: roleChangeNotificationById {
          id
          role
          tenant: tenantByTenantId {
            id
            key
            name
          }
          user: applicationUserByUserId {
            id
          }
        }
      }
    }
  }
`;

/**
 * __useNotificationsFeedBodyQuery__
 *
 * To run a query within a React component, call `useNotificationsFeedBodyQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsFeedBodyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsFeedBodyQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *      notificationIds: // value for 'notificationIds'
 *   },
 * });
 */
export function useNotificationsFeedBodyQuery(
  baseOptions: Apollo.QueryHookOptions<
    NotificationsFeedBodyQuery,
    NotificationsFeedBodyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    NotificationsFeedBodyQuery,
    NotificationsFeedBodyQueryVariables
  >(NotificationsFeedBodyDocument, options);
}
export function useNotificationsFeedBodyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NotificationsFeedBodyQuery,
    NotificationsFeedBodyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NotificationsFeedBodyQuery,
    NotificationsFeedBodyQueryVariables
  >(NotificationsFeedBodyDocument, options);
}
export type NotificationsFeedBodyQueryHookResult = ReturnType<
  typeof useNotificationsFeedBodyQuery
>;
export type NotificationsFeedBodyLazyQueryHookResult = ReturnType<
  typeof useNotificationsFeedBodyLazyQuery
>;
export type NotificationsFeedBodyQueryResult = Apollo.QueryResult<
  NotificationsFeedBodyQuery,
  NotificationsFeedBodyQueryVariables
>;
export const ProjectInfoDocument = gql`
  query ProjectInfo($id: UUID!) {
    project: projectById(id: $id) {
      id
      dateCreated
      dateLastActive
      key
      user: applicationUserByUserId {
        id
        firstName
        lastName
      }
      tenant: tenantByTenantId {
        id
        key
      }
      cloneSource: projectByCloneSourceId {
        id
        name
        key
        tenant: tenantByTenantId {
          id
          key
        }
      }
    }
  }
`;

/**
 * __useProjectInfoQuery__
 *
 * To run a query within a React component, call `useProjectInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProjectInfoQuery,
    ProjectInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProjectInfoQuery, ProjectInfoQueryVariables>(
    ProjectInfoDocument,
    options,
  );
}
export function useProjectInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectInfoQuery,
    ProjectInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProjectInfoQuery, ProjectInfoQueryVariables>(
    ProjectInfoDocument,
    options,
  );
}
export type ProjectInfoQueryHookResult = ReturnType<typeof useProjectInfoQuery>;
export type ProjectInfoLazyQueryHookResult = ReturnType<
  typeof useProjectInfoLazyQuery
>;
export type ProjectInfoQueryResult = Apollo.QueryResult<
  ProjectInfoQuery,
  ProjectInfoQueryVariables
>;
export const MetadataTableFileDocument = gql`
  query MetadataTableFile($fileIds: [UUID!], $metadatumKeys: [String!]) {
    fileMetadata: allFileMetadata(
      filter: {
        fileId: { in: $fileIds }
        metadatumByMetadataId: { key: { in: $metadatumKeys } }
      }
    ) {
      nodes {
        id
        file: fileByFileId {
          id
          fileType
        }
        metadatum: metadatumByMetadataId {
          id
          key
          activeValue
        }
      }
    }
  }
`;

/**
 * __useMetadataTableFileQuery__
 *
 * To run a query within a React component, call `useMetadataTableFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetadataTableFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetadataTableFileQuery({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *      metadatumKeys: // value for 'metadatumKeys'
 *   },
 * });
 */
export function useMetadataTableFileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MetadataTableFileQuery,
    MetadataTableFileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MetadataTableFileQuery,
    MetadataTableFileQueryVariables
  >(MetadataTableFileDocument, options);
}
export function useMetadataTableFileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MetadataTableFileQuery,
    MetadataTableFileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MetadataTableFileQuery,
    MetadataTableFileQueryVariables
  >(MetadataTableFileDocument, options);
}
export type MetadataTableFileQueryHookResult = ReturnType<
  typeof useMetadataTableFileQuery
>;
export type MetadataTableFileLazyQueryHookResult = ReturnType<
  typeof useMetadataTableFileLazyQuery
>;
export type MetadataTableFileQueryResult = Apollo.QueryResult<
  MetadataTableFileQuery,
  MetadataTableFileQueryVariables
>;
export const ModalToolCellStatusParamDocument = gql`
  query ModalToolCellStatusParam(
    $fileIds: [UUID!]!
    $metadatumKeys: [String!]!
  ) {
    files: allFiles(filter: { id: { in: $fileIds } }) {
      nodes {
        id
        name
        source
        isSeries
        fileType
        metadata: fileMetadataByFileId(
          filter: { metadatumByMetadataId: { key: { in: $metadatumKeys } } }
        ) {
          nodes {
            id
            metadatum: metadatumByMetadataId {
              id
              key
              value: activeValue
            }
          }
        }
        seriesMembers: filesBySeriesParentId {
          nodes {
            id
            name
            source
            fileType
            metadata: fileMetadataByFileId(
              filter: { metadatumByMetadataId: { key: { in: $metadatumKeys } } }
            ) {
              nodes {
                id
                metadatum: metadatumByMetadataId {
                  id
                  key
                  value: activeValue
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useModalToolCellStatusParamQuery__
 *
 * To run a query within a React component, call `useModalToolCellStatusParamQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalToolCellStatusParamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalToolCellStatusParamQuery({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *      metadatumKeys: // value for 'metadatumKeys'
 *   },
 * });
 */
export function useModalToolCellStatusParamQuery(
  baseOptions: Apollo.QueryHookOptions<
    ModalToolCellStatusParamQuery,
    ModalToolCellStatusParamQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ModalToolCellStatusParamQuery,
    ModalToolCellStatusParamQueryVariables
  >(ModalToolCellStatusParamDocument, options);
}
export function useModalToolCellStatusParamLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ModalToolCellStatusParamQuery,
    ModalToolCellStatusParamQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ModalToolCellStatusParamQuery,
    ModalToolCellStatusParamQueryVariables
  >(ModalToolCellStatusParamDocument, options);
}
export type ModalToolCellStatusParamQueryHookResult = ReturnType<
  typeof useModalToolCellStatusParamQuery
>;
export type ModalToolCellStatusParamLazyQueryHookResult = ReturnType<
  typeof useModalToolCellStatusParamLazyQuery
>;
export type ModalToolCellStatusParamQueryResult = Apollo.QueryResult<
  ModalToolCellStatusParamQuery,
  ModalToolCellStatusParamQueryVariables
>;
export const ModalToolRoiFrameParamDocument = gql`
  query ModalToolRoiFrameParam($fileIds: [UUID!]!, $metadatumKeys: [String!]!) {
    files: allFiles(filter: { id: { in: $fileIds } }) {
      nodes {
        id
        name
        source
        isSeries
        metadata: fileMetadataByFileId(
          filter: { metadatumByMetadataId: { key: { in: $metadatumKeys } } }
        ) {
          nodes {
            id
            metadatum: metadatumByMetadataId {
              id
              key
              value: activeValue
            }
          }
        }
        seriesParent: fileBySeriesParentId {
          id
          metadata: fileMetadataByFileId(
            filter: { metadatumByMetadataId: { key: { in: $metadatumKeys } } }
          ) {
            nodes {
              id
              metadatum: metadatumByMetadataId {
                id
                key
                value: activeValue
              }
            }
          }
        }
        seriesMembers: filesBySeriesParentId {
          nodes {
            id
            name
            source
            metadata: fileMetadataByFileId(
              filter: { metadatumByMetadataId: { key: { in: $metadatumKeys } } }
            ) {
              nodes {
                id
                metadatum: metadatumByMetadataId {
                  id
                  key
                  value: activeValue
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useModalToolRoiFrameParamQuery__
 *
 * To run a query within a React component, call `useModalToolRoiFrameParamQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalToolRoiFrameParamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalToolRoiFrameParamQuery({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *      metadatumKeys: // value for 'metadatumKeys'
 *   },
 * });
 */
export function useModalToolRoiFrameParamQuery(
  baseOptions: Apollo.QueryHookOptions<
    ModalToolRoiFrameParamQuery,
    ModalToolRoiFrameParamQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ModalToolRoiFrameParamQuery,
    ModalToolRoiFrameParamQueryVariables
  >(ModalToolRoiFrameParamDocument, options);
}
export function useModalToolRoiFrameParamLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ModalToolRoiFrameParamQuery,
    ModalToolRoiFrameParamQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ModalToolRoiFrameParamQuery,
    ModalToolRoiFrameParamQueryVariables
  >(ModalToolRoiFrameParamDocument, options);
}
export type ModalToolRoiFrameParamQueryHookResult = ReturnType<
  typeof useModalToolRoiFrameParamQuery
>;
export type ModalToolRoiFrameParamLazyQueryHookResult = ReturnType<
  typeof useModalToolRoiFrameParamLazyQuery
>;
export type ModalToolRoiFrameParamQueryResult = Apollo.QueryResult<
  ModalToolRoiFrameParamQuery,
  ModalToolRoiFrameParamQueryVariables
>;
export const UserAvatarDocument = gql`
  query UserAvatar($userId: UUID!) {
    user: applicationUserById(id: $userId) {
      ...UserAvatarFields
    }
  }
  ${UserAvatarFieldsFragmentDoc}
`;

/**
 * __useUserAvatarQuery__
 *
 * To run a query within a React component, call `useUserAvatarQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAvatarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAvatarQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserAvatarQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserAvatarQuery,
    UserAvatarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserAvatarQuery, UserAvatarQueryVariables>(
    UserAvatarDocument,
    options,
  );
}
export function useUserAvatarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserAvatarQuery,
    UserAvatarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserAvatarQuery, UserAvatarQueryVariables>(
    UserAvatarDocument,
    options,
  );
}
export type UserAvatarQueryHookResult = ReturnType<typeof useUserAvatarQuery>;
export type UserAvatarLazyQueryHookResult = ReturnType<
  typeof useUserAvatarLazyQuery
>;
export type UserAvatarQueryResult = Apollo.QueryResult<
  UserAvatarQuery,
  UserAvatarQueryVariables
>;
export const CreateMetadataValueDocument = gql`
  mutation CreateMetadataValue($metadataValue: MetadataValueInput!) {
    createMetadataValue(input: { metadataValue: $metadataValue }) {
      clientMutationId
      metadataValue {
        ...MetadataValueFields
      }
    }
  }
  ${MetadataValueFieldsFragmentDoc}
`;
export type CreateMetadataValueMutationFn = Apollo.MutationFunction<
  CreateMetadataValueMutation,
  CreateMetadataValueMutationVariables
>;

/**
 * __useCreateMetadataValueMutation__
 *
 * To run a mutation, you first call `useCreateMetadataValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetadataValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetadataValueMutation, { data, loading, error }] = useCreateMetadataValueMutation({
 *   variables: {
 *      metadataValue: // value for 'metadataValue'
 *   },
 * });
 */
export function useCreateMetadataValueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMetadataValueMutation,
    CreateMetadataValueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMetadataValueMutation,
    CreateMetadataValueMutationVariables
  >(CreateMetadataValueDocument, options);
}
export type CreateMetadataValueMutationHookResult = ReturnType<
  typeof useCreateMetadataValueMutation
>;
export type CreateMetadataValueMutationResult =
  Apollo.MutationResult<CreateMetadataValueMutation>;
export type CreateMetadataValueMutationOptions = Apollo.BaseMutationOptions<
  CreateMetadataValueMutation,
  CreateMetadataValueMutationVariables
>;
export const CreateMetadatumDocument = gql`
  mutation CreateMetadatum($metadata: MetadatumInput!) {
    createMetadata: createMetadatum(input: { metadatum: $metadata }) {
      clientMutationId
      metadata: metadatum {
        ...MetadatumFields
      }
    }
  }
  ${MetadatumFieldsFragmentDoc}
`;
export type CreateMetadatumMutationFn = Apollo.MutationFunction<
  CreateMetadatumMutation,
  CreateMetadatumMutationVariables
>;

/**
 * __useCreateMetadatumMutation__
 *
 * To run a mutation, you first call `useCreateMetadatumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetadatumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetadatumMutation, { data, loading, error }] = useCreateMetadatumMutation({
 *   variables: {
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useCreateMetadatumMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMetadatumMutation,
    CreateMetadatumMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMetadatumMutation,
    CreateMetadatumMutationVariables
  >(CreateMetadatumDocument, options);
}
export type CreateMetadatumMutationHookResult = ReturnType<
  typeof useCreateMetadatumMutation
>;
export type CreateMetadatumMutationResult =
  Apollo.MutationResult<CreateMetadatumMutation>;
export type CreateMetadatumMutationOptions = Apollo.BaseMutationOptions<
  CreateMetadatumMutation,
  CreateMetadatumMutationVariables
>;
export const CreateUserMetadatumDocument = gql`
  mutation CreateUserMetadatum($userMetadatum: ApplicationUserMetadatumInput!) {
    createUserMetadatum: createApplicationUserMetadatum(
      input: { applicationUserMetadatum: $userMetadatum }
    ) {
      clientMutationId
      userMetadatum: applicationUserMetadatum {
        ...UserMetadatumFields
      }
    }
  }
  ${UserMetadatumFieldsFragmentDoc}
`;
export type CreateUserMetadatumMutationFn = Apollo.MutationFunction<
  CreateUserMetadatumMutation,
  CreateUserMetadatumMutationVariables
>;

/**
 * __useCreateUserMetadatumMutation__
 *
 * To run a mutation, you first call `useCreateUserMetadatumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMetadatumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMetadatumMutation, { data, loading, error }] = useCreateUserMetadatumMutation({
 *   variables: {
 *      userMetadatum: // value for 'userMetadatum'
 *   },
 * });
 */
export function useCreateUserMetadatumMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserMetadatumMutation,
    CreateUserMetadatumMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateUserMetadatumMutation,
    CreateUserMetadatumMutationVariables
  >(CreateUserMetadatumDocument, options);
}
export type CreateUserMetadatumMutationHookResult = ReturnType<
  typeof useCreateUserMetadatumMutation
>;
export type CreateUserMetadatumMutationResult =
  Apollo.MutationResult<CreateUserMetadatumMutation>;
export type CreateUserMetadatumMutationOptions = Apollo.BaseMutationOptions<
  CreateUserMetadatumMutation,
  CreateUserMetadatumMutationVariables
>;
export const CreateUserSessionDocument = gql`
  mutation CreateUserSession($id: UUID!, $userid: UUID!, $tenant: Int) {
    createUserSession: createSession(
      input: { id: $id, userid: $userid, tenant: $tenant }
    ) {
      clientMutationId
      userSession: applicationUserSession {
        ...UserSessionFields
      }
    }
  }
  ${UserSessionFieldsFragmentDoc}
`;
export type CreateUserSessionMutationFn = Apollo.MutationFunction<
  CreateUserSessionMutation,
  CreateUserSessionMutationVariables
>;

/**
 * __useCreateUserSessionMutation__
 *
 * To run a mutation, you first call `useCreateUserSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserSessionMutation, { data, loading, error }] = useCreateUserSessionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userid: // value for 'userid'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useCreateUserSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserSessionMutation,
    CreateUserSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateUserSessionMutation,
    CreateUserSessionMutationVariables
  >(CreateUserSessionDocument, options);
}
export type CreateUserSessionMutationHookResult = ReturnType<
  typeof useCreateUserSessionMutation
>;
export type CreateUserSessionMutationResult =
  Apollo.MutationResult<CreateUserSessionMutation>;
export type CreateUserSessionMutationOptions = Apollo.BaseMutationOptions<
  CreateUserSessionMutation,
  CreateUserSessionMutationVariables
>;
export const UpdateApplicationUserByIdDocument = gql`
  mutation UpdateApplicationUserById(
    $id: UUID!
    $patch: ApplicationUserPatch!
  ) {
    updateApplicationUserById(
      input: { id: $id, applicationUserPatch: $patch }
    ) {
      clientMutationId
      applicationUser {
        ...UserFields
        metadata: applicationUserMetadataByUserId {
          nodes {
            ...UserMetadatumFields
          }
        }
      }
    }
  }
  ${UserFieldsFragmentDoc}
  ${UserMetadatumFieldsFragmentDoc}
`;
export type UpdateApplicationUserByIdMutationFn = Apollo.MutationFunction<
  UpdateApplicationUserByIdMutation,
  UpdateApplicationUserByIdMutationVariables
>;

/**
 * __useUpdateApplicationUserByIdMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationUserByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationUserByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationUserByIdMutation, { data, loading, error }] = useUpdateApplicationUserByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateApplicationUserByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateApplicationUserByIdMutation,
    UpdateApplicationUserByIdMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateApplicationUserByIdMutation,
    UpdateApplicationUserByIdMutationVariables
  >(UpdateApplicationUserByIdDocument, options);
}
export type UpdateApplicationUserByIdMutationHookResult = ReturnType<
  typeof useUpdateApplicationUserByIdMutation
>;
export type UpdateApplicationUserByIdMutationResult =
  Apollo.MutationResult<UpdateApplicationUserByIdMutation>;
export type UpdateApplicationUserByIdMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateApplicationUserByIdMutation,
    UpdateApplicationUserByIdMutationVariables
  >;
export const UpdateAvatarByIdDocument = gql`
  mutation UpdateAvatarById($id: BigInt!, $patch: AvatarPatch!) {
    updateAvatarById(input: { id: $id, avatarPatch: $patch }) {
      clientMutationId
      avatar {
        ...AvatarFields
      }
    }
  }
  ${AvatarFieldsFragmentDoc}
`;
export type UpdateAvatarByIdMutationFn = Apollo.MutationFunction<
  UpdateAvatarByIdMutation,
  UpdateAvatarByIdMutationVariables
>;

/**
 * __useUpdateAvatarByIdMutation__
 *
 * To run a mutation, you first call `useUpdateAvatarByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvatarByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAvatarByIdMutation, { data, loading, error }] = useUpdateAvatarByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateAvatarByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAvatarByIdMutation,
    UpdateAvatarByIdMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAvatarByIdMutation,
    UpdateAvatarByIdMutationVariables
  >(UpdateAvatarByIdDocument, options);
}
export type UpdateAvatarByIdMutationHookResult = ReturnType<
  typeof useUpdateAvatarByIdMutation
>;
export type UpdateAvatarByIdMutationResult =
  Apollo.MutationResult<UpdateAvatarByIdMutation>;
export type UpdateAvatarByIdMutationOptions = Apollo.BaseMutationOptions<
  UpdateAvatarByIdMutation,
  UpdateAvatarByIdMutationVariables
>;
export const UpdateUserMetadatumByIdDocument = gql`
  mutation UpdateUserMetadatumById(
    $id: Int!
    $patch: ApplicationUserMetadatumPatch!
  ) {
    updateUserMetadatumById: updateApplicationUserMetadatumById(
      input: { id: $id, applicationUserMetadatumPatch: $patch }
    ) {
      clientMutationId
      userMetadatum: applicationUserMetadatum {
        ...UserMetadatumFields
      }
    }
  }
  ${UserMetadatumFieldsFragmentDoc}
`;
export type UpdateUserMetadatumByIdMutationFn = Apollo.MutationFunction<
  UpdateUserMetadatumByIdMutation,
  UpdateUserMetadatumByIdMutationVariables
>;

/**
 * __useUpdateUserMetadatumByIdMutation__
 *
 * To run a mutation, you first call `useUpdateUserMetadatumByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMetadatumByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMetadatumByIdMutation, { data, loading, error }] = useUpdateUserMetadatumByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      patch: // value for 'patch'
 *   },
 * });
 */
export function useUpdateUserMetadatumByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserMetadatumByIdMutation,
    UpdateUserMetadatumByIdMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserMetadatumByIdMutation,
    UpdateUserMetadatumByIdMutationVariables
  >(UpdateUserMetadatumByIdDocument, options);
}
export type UpdateUserMetadatumByIdMutationHookResult = ReturnType<
  typeof useUpdateUserMetadatumByIdMutation
>;
export type UpdateUserMetadatumByIdMutationResult =
  Apollo.MutationResult<UpdateUserMetadatumByIdMutation>;
export type UpdateUserMetadatumByIdMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMetadatumByIdMutation,
  UpdateUserMetadatumByIdMutationVariables
>;
export const GetAllTasksDocument = gql`
  query GetAllTasks($condition: TaskCondition, $filter: TaskFilter) {
    tasks: allTasks(
      condition: $condition
      filter: $filter
      orderBy: CREATED_DESC
    ) {
      nodes {
        id
        toolVersion: toolVersionByToolVersionId {
          ...ToolVersionFields
        }
        outputGroup: fileOutputGroupByTaskId {
          ...FileOutputGroupFields
          task: taskByTaskId {
            id
            status
            created
          }
          outputGroupFiles: outputGroupFilesByFileOutputGroupId {
            nodes {
              id
              drsFile: fileByFileId {
                ...FileCache
                fileMetadata: fileMetadataByFileId {
                  nodes {
                    id
                    metadata: metadatumByMetadataId {
                      id
                      key
                      activeValue
                    }
                  }
                }
              }
            }
          }
          metadata: fileOutputGroupMetadataByFileOutputGroupId {
            nodes {
              id
              metadatum: metadatumByMetadataId {
                ...MetadatumFields
                values: metadataValuesByMetadataId(
                  orderBy: DATE_CREATED_ASC
                  last: 1
                ) {
                  nodes {
                    ...MetadataValueFields
                  }
                }
              }
            }
          }
        }
        user: applicationUserByUserId {
          ...UserFields
        }
        ...TaskFields
        taskActivityByTaskId {
          id
          duration {
            hours
            seconds
            minutes
            days
            years
            months
          }
        }
        taskResourcesByTaskId {
          nodes {
            id
            type
            value
          }
        }
      }
    }
  }
  ${ToolVersionFieldsFragmentDoc}
  ${FileOutputGroupFieldsFragmentDoc}
  ${FileCacheFragmentDoc}
  ${MetadatumFieldsFragmentDoc}
  ${MetadataValueFieldsFragmentDoc}
  ${UserFieldsFragmentDoc}
  ${TaskFieldsFragmentDoc}
`;

/**
 * __useGetAllTasksQuery__
 *
 * To run a query within a React component, call `useGetAllTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTasksQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllTasksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllTasksQuery,
    GetAllTasksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllTasksQuery, GetAllTasksQueryVariables>(
    GetAllTasksDocument,
    options,
  );
}
export function useGetAllTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllTasksQuery,
    GetAllTasksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllTasksQuery, GetAllTasksQueryVariables>(
    GetAllTasksDocument,
    options,
  );
}
export type GetAllTasksQueryHookResult = ReturnType<typeof useGetAllTasksQuery>;
export type GetAllTasksLazyQueryHookResult = ReturnType<
  typeof useGetAllTasksLazyQuery
>;
export type GetAllTasksQueryResult = Apollo.QueryResult<
  GetAllTasksQuery,
  GetAllTasksQueryVariables
>;
export const GetCurrentUserDocument = gql`
  query GetCurrentUser {
    currentUser: getCurrentUser {
      ...UserFields
      metadata: applicationUserMetadataByUserId {
        nodes {
          ...UserMetadatumFields
        }
      }
      memberships: applicationUserMembershipsByUserId {
        nodes {
          id
          tenant: tenantByTenantId {
            ...TenantFields
          }
        }
      }
    }
  }
  ${UserFieldsFragmentDoc}
  ${UserMetadatumFieldsFragmentDoc}
  ${TenantFieldsFragmentDoc}
`;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCurrentUserQuery,
    GetCurrentUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(
    GetCurrentUserDocument,
    options,
  );
}
export function useGetCurrentUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentUserQuery,
    GetCurrentUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(
    GetCurrentUserDocument,
    options,
  );
}
export type GetCurrentUserQueryHookResult = ReturnType<
  typeof useGetCurrentUserQuery
>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<
  typeof useGetCurrentUserLazyQuery
>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<
  GetCurrentUserQuery,
  GetCurrentUserQueryVariables
>;
export const GetFileMetadataByFileIdDocument = gql`
  query GetFileMetadataByFileId(
    $drsFileId: UUID!
    $metadataFilter: FileMetadatumFilter
  ) {
    drsFile: fileById(id: $drsFileId) {
      id
      metadata: fileMetadataByFileId(
        orderBy: ID_DESC
        filter: $metadataFilter
      ) {
        nodes {
          id
          metadatum: metadatumByMetadataId {
            ...MetadatumFields
            activeValue
          }
        }
      }
      seriesParentFile: fileBySeriesParentId {
        id
        metadata: fileMetadataByFileId(
          orderBy: ID_DESC
          filter: $metadataFilter
        ) {
          nodes {
            id
            metadatum: metadatumByMetadataId {
              ...MetadatumFields
              activeValue
            }
          }
        }
      }
    }
  }
  ${MetadatumFieldsFragmentDoc}
`;

/**
 * __useGetFileMetadataByFileIdQuery__
 *
 * To run a query within a React component, call `useGetFileMetadataByFileIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileMetadataByFileIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileMetadataByFileIdQuery({
 *   variables: {
 *      drsFileId: // value for 'drsFileId'
 *      metadataFilter: // value for 'metadataFilter'
 *   },
 * });
 */
export function useGetFileMetadataByFileIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFileMetadataByFileIdQuery,
    GetFileMetadataByFileIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFileMetadataByFileIdQuery,
    GetFileMetadataByFileIdQueryVariables
  >(GetFileMetadataByFileIdDocument, options);
}
export function useGetFileMetadataByFileIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFileMetadataByFileIdQuery,
    GetFileMetadataByFileIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFileMetadataByFileIdQuery,
    GetFileMetadataByFileIdQueryVariables
  >(GetFileMetadataByFileIdDocument, options);
}
export type GetFileMetadataByFileIdQueryHookResult = ReturnType<
  typeof useGetFileMetadataByFileIdQuery
>;
export type GetFileMetadataByFileIdLazyQueryHookResult = ReturnType<
  typeof useGetFileMetadataByFileIdLazyQuery
>;
export type GetFileMetadataByFileIdQueryResult = Apollo.QueryResult<
  GetFileMetadataByFileIdQuery,
  GetFileMetadataByFileIdQueryVariables
>;
export const GetProjectByIdDocument = gql`
  query GetProjectById($id: UUID!) {
    projectById(id: $id) {
      ...ProjectFields
    }
  }
  ${ProjectFieldsFragmentDoc}
`;

/**
 * __useGetProjectByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProjectByIdQuery,
    GetProjectByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProjectByIdQuery, GetProjectByIdQueryVariables>(
    GetProjectByIdDocument,
    options,
  );
}
export function useGetProjectByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProjectByIdQuery,
    GetProjectByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProjectByIdQuery, GetProjectByIdQueryVariables>(
    GetProjectByIdDocument,
    options,
  );
}
export type GetProjectByIdQueryHookResult = ReturnType<
  typeof useGetProjectByIdQuery
>;
export type GetProjectByIdLazyQueryHookResult = ReturnType<
  typeof useGetProjectByIdLazyQuery
>;
export type GetProjectByIdQueryResult = Apollo.QueryResult<
  GetProjectByIdQuery,
  GetProjectByIdQueryVariables
>;
export const GetTaskByIdDocument = gql`
  query GetTaskById($id: UUID!) {
    task: taskById(id: $id) {
      ...TaskFields
    }
  }
  ${TaskFieldsFragmentDoc}
`;

/**
 * __useGetTaskByIdQuery__
 *
 * To run a query within a React component, call `useGetTaskByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTaskByIdQuery,
    GetTaskByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTaskByIdQuery, GetTaskByIdQueryVariables>(
    GetTaskByIdDocument,
    options,
  );
}
export function useGetTaskByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTaskByIdQuery,
    GetTaskByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTaskByIdQuery, GetTaskByIdQueryVariables>(
    GetTaskByIdDocument,
    options,
  );
}
export type GetTaskByIdQueryHookResult = ReturnType<typeof useGetTaskByIdQuery>;
export type GetTaskByIdLazyQueryHookResult = ReturnType<
  typeof useGetTaskByIdLazyQuery
>;
export type GetTaskByIdQueryResult = Apollo.QueryResult<
  GetTaskByIdQuery,
  GetTaskByIdQueryVariables
>;
export const GetToolVersionsByToolIdAndVersionsDocument = gql`
  query GetToolVersionsByToolIdAndVersions(
    $toolId: Int!
    $versions: [String!]!
  ) {
    toolVersions: allToolVersions(
      filter: {
        and: [{ toolId: { equalTo: $toolId } }, { version: { in: $versions } }]
      }
    ) {
      nodes {
        ...ToolVersionFields
        toolSources: toolSourcesByToolVersionId {
          nodes {
            ...ToolSourceFields
          }
        }
        toolParameters: toolParametersByToolVersionId {
          nodes {
            ...ToolParameterFields
          }
        }
        toolResults: toolResultsByToolVersionId {
          nodes {
            ...ToolResultFields
          }
        }
      }
    }
  }
  ${ToolVersionFieldsFragmentDoc}
  ${ToolSourceFieldsFragmentDoc}
  ${ToolParameterFieldsFragmentDoc}
  ${ToolResultFieldsFragmentDoc}
`;

/**
 * __useGetToolVersionsByToolIdAndVersionsQuery__
 *
 * To run a query within a React component, call `useGetToolVersionsByToolIdAndVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetToolVersionsByToolIdAndVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetToolVersionsByToolIdAndVersionsQuery({
 *   variables: {
 *      toolId: // value for 'toolId'
 *      versions: // value for 'versions'
 *   },
 * });
 */
export function useGetToolVersionsByToolIdAndVersionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetToolVersionsByToolIdAndVersionsQuery,
    GetToolVersionsByToolIdAndVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetToolVersionsByToolIdAndVersionsQuery,
    GetToolVersionsByToolIdAndVersionsQueryVariables
  >(GetToolVersionsByToolIdAndVersionsDocument, options);
}
export function useGetToolVersionsByToolIdAndVersionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetToolVersionsByToolIdAndVersionsQuery,
    GetToolVersionsByToolIdAndVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetToolVersionsByToolIdAndVersionsQuery,
    GetToolVersionsByToolIdAndVersionsQueryVariables
  >(GetToolVersionsByToolIdAndVersionsDocument, options);
}
export type GetToolVersionsByToolIdAndVersionsQueryHookResult = ReturnType<
  typeof useGetToolVersionsByToolIdAndVersionsQuery
>;
export type GetToolVersionsByToolIdAndVersionsLazyQueryHookResult = ReturnType<
  typeof useGetToolVersionsByToolIdAndVersionsLazyQuery
>;
export type GetToolVersionsByToolIdAndVersionsQueryResult = Apollo.QueryResult<
  GetToolVersionsByToolIdAndVersionsQuery,
  GetToolVersionsByToolIdAndVersionsQueryVariables
>;
export const GetUserSessionByIdDocument = gql`
  query GetUserSessionById($id: UUID!) {
    userSession: applicationUserSessionById(id: $id) {
      ...UserSessionFields
    }
  }
  ${UserSessionFieldsFragmentDoc}
`;

/**
 * __useGetUserSessionByIdQuery__
 *
 * To run a query within a React component, call `useGetUserSessionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSessionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSessionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserSessionByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserSessionByIdQuery,
    GetUserSessionByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserSessionByIdQuery,
    GetUserSessionByIdQueryVariables
  >(GetUserSessionByIdDocument, options);
}
export function useGetUserSessionByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserSessionByIdQuery,
    GetUserSessionByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserSessionByIdQuery,
    GetUserSessionByIdQueryVariables
  >(GetUserSessionByIdDocument, options);
}
export type GetUserSessionByIdQueryHookResult = ReturnType<
  typeof useGetUserSessionByIdQuery
>;
export type GetUserSessionByIdLazyQueryHookResult = ReturnType<
  typeof useGetUserSessionByIdLazyQuery
>;
export type GetUserSessionByIdQueryResult = Apollo.QueryResult<
  GetUserSessionByIdQuery,
  GetUserSessionByIdQueryVariables
>;
export const ExportToDandiToolInfoDocument = gql`
  query ExportToDandiToolInfo($activeStatus: Int) {
    allTools(
      filter: {
        status: { equalTo: $activeStatus }
        key: { equalTo: "export_to_dandi" }
      }
    ) {
      nodes {
        id
        toolVersions: toolVersionsByToolId(orderBy: VERSION_ASC, last: 1) {
          nodes {
            id
            toolSources: toolSourcesByToolVersionId {
              nodes {
                id
                key
              }
            }
            toolParameters: toolParametersByToolVersionId {
              nodes {
                id
                key
              }
            }
            toolSecrets: toolSecretsByToolVersionId {
              nodes {
                id
                key
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useExportToDandiToolInfoQuery__
 *
 * To run a query within a React component, call `useExportToDandiToolInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportToDandiToolInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportToDandiToolInfoQuery({
 *   variables: {
 *      activeStatus: // value for 'activeStatus'
 *   },
 * });
 */
export function useExportToDandiToolInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ExportToDandiToolInfoQuery,
    ExportToDandiToolInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ExportToDandiToolInfoQuery,
    ExportToDandiToolInfoQueryVariables
  >(ExportToDandiToolInfoDocument, options);
}
export function useExportToDandiToolInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportToDandiToolInfoQuery,
    ExportToDandiToolInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExportToDandiToolInfoQuery,
    ExportToDandiToolInfoQueryVariables
  >(ExportToDandiToolInfoDocument, options);
}
export type ExportToDandiToolInfoQueryHookResult = ReturnType<
  typeof useExportToDandiToolInfoQuery
>;
export type ExportToDandiToolInfoLazyQueryHookResult = ReturnType<
  typeof useExportToDandiToolInfoLazyQuery
>;
export type ExportToDandiToolInfoQueryResult = Apollo.QueryResult<
  ExportToDandiToolInfoQuery,
  ExportToDandiToolInfoQueryVariables
>;
export const GetProcessingStatusDocument = gql`
  query GetProcessingStatus($drsFileIds: [UUID!]!) {
    files: allFiles(filter: { id: { in: $drsFileIds } }) {
      nodes {
        id
        processingStatus
      }
    }
  }
`;

/**
 * __useGetProcessingStatusQuery__
 *
 * To run a query within a React component, call `useGetProcessingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessingStatusQuery({
 *   variables: {
 *      drsFileIds: // value for 'drsFileIds'
 *   },
 * });
 */
export function useGetProcessingStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProcessingStatusQuery,
    GetProcessingStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProcessingStatusQuery,
    GetProcessingStatusQueryVariables
  >(GetProcessingStatusDocument, options);
}
export function useGetProcessingStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProcessingStatusQuery,
    GetProcessingStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProcessingStatusQuery,
    GetProcessingStatusQueryVariables
  >(GetProcessingStatusDocument, options);
}
export type GetProcessingStatusQueryHookResult = ReturnType<
  typeof useGetProcessingStatusQuery
>;
export type GetProcessingStatusLazyQueryHookResult = ReturnType<
  typeof useGetProcessingStatusLazyQuery
>;
export type GetProcessingStatusQueryResult = Apollo.QueryResult<
  GetProcessingStatusQuery,
  GetProcessingStatusQueryVariables
>;
export const GetExternalTenantsDocument = gql`
  query GetExternalTenants {
    currentUser: getCurrentUser {
      id
      memberships: applicationUserMembershipsByUserId {
        nodes {
          id
          tenant: tenantByTenantId {
            id
            key
            name
            tenantType
          }
        }
      }
    }
  }
`;

/**
 * __useGetExternalTenantsQuery__
 *
 * To run a query within a React component, call `useGetExternalTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalTenantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExternalTenantsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetExternalTenantsQuery,
    GetExternalTenantsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetExternalTenantsQuery,
    GetExternalTenantsQueryVariables
  >(GetExternalTenantsDocument, options);
}
export function useGetExternalTenantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetExternalTenantsQuery,
    GetExternalTenantsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetExternalTenantsQuery,
    GetExternalTenantsQueryVariables
  >(GetExternalTenantsDocument, options);
}
export type GetExternalTenantsQueryHookResult = ReturnType<
  typeof useGetExternalTenantsQuery
>;
export type GetExternalTenantsLazyQueryHookResult = ReturnType<
  typeof useGetExternalTenantsLazyQuery
>;
export type GetExternalTenantsQueryResult = Apollo.QueryResult<
  GetExternalTenantsQuery,
  GetExternalTenantsQueryVariables
>;
export const GetFileProcessTasksDocument = gql`
  query GetFileProcessTasks($drsFileId: UUID!, $failedStatuses: [Int!]!) {
    file: fileById(id: $drsFileId) {
      id
      taskSources: taskSourcesByFileId(
        filter: {
          taskByTaskId: {
            and: [
              {
                toolVersionByToolVersionId: {
                  toolByToolId: { key: { equalTo: "process_file" } }
                }
              }
              { status: { in: $failedStatuses } }
            ]
          }
        }
      ) {
        nodes {
          id
          task: taskByTaskId {
            id
            status
            errorDescription
            created
            toolVersion: toolVersionByToolVersionId {
              id
              tool: toolByToolId {
                id
                name
                key
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetFileProcessTasksQuery__
 *
 * To run a query within a React component, call `useGetFileProcessTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileProcessTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileProcessTasksQuery({
 *   variables: {
 *      drsFileId: // value for 'drsFileId'
 *      failedStatuses: // value for 'failedStatuses'
 *   },
 * });
 */
export function useGetFileProcessTasksQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFileProcessTasksQuery,
    GetFileProcessTasksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFileProcessTasksQuery,
    GetFileProcessTasksQueryVariables
  >(GetFileProcessTasksDocument, options);
}
export function useGetFileProcessTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFileProcessTasksQuery,
    GetFileProcessTasksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFileProcessTasksQuery,
    GetFileProcessTasksQueryVariables
  >(GetFileProcessTasksDocument, options);
}
export type GetFileProcessTasksQueryHookResult = ReturnType<
  typeof useGetFileProcessTasksQuery
>;
export type GetFileProcessTasksLazyQueryHookResult = ReturnType<
  typeof useGetFileProcessTasksLazyQuery
>;
export type GetFileProcessTasksQueryResult = Apollo.QueryResult<
  GetFileProcessTasksQuery,
  GetFileProcessTasksQueryVariables
>;
export const CellEditorFileDocument = gql`
  query CellEditorFile($projectId: UUID!) {
    project: projectById(id: $projectId) {
      id
      isToolProject
      files: filesByProjectId(
        filter: {
          dateDeleted: { isNull: true }
          dateDataDeleted: { isNull: true }
          seriesParentId: { isNull: true }
        }
      ) {
        nodes {
          id
          referenceId
          name
          fileType
          tags
          source
          isSeries
          seriesFiles: filesBySeriesParentId(
            orderBy: [SERIES_ORDER_ASC, NAME_ASC]
          ) {
            nodes {
              id
              name
            }
          }
          ...CellValueRendererFileFields
        }
      }
    }
  }
  ${CellValueRendererFileFieldsFragmentDoc}
`;

/**
 * __useCellEditorFileQuery__
 *
 * To run a query within a React component, call `useCellEditorFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useCellEditorFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCellEditorFileQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCellEditorFileQuery(
  baseOptions: Apollo.QueryHookOptions<
    CellEditorFileQuery,
    CellEditorFileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CellEditorFileQuery, CellEditorFileQueryVariables>(
    CellEditorFileDocument,
    options,
  );
}
export function useCellEditorFileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CellEditorFileQuery,
    CellEditorFileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CellEditorFileQuery, CellEditorFileQueryVariables>(
    CellEditorFileDocument,
    options,
  );
}
export type CellEditorFileQueryHookResult = ReturnType<
  typeof useCellEditorFileQuery
>;
export type CellEditorFileLazyQueryHookResult = ReturnType<
  typeof useCellEditorFileLazyQuery
>;
export type CellEditorFileQueryResult = Apollo.QueryResult<
  CellEditorFileQuery,
  CellEditorFileQueryVariables
>;
export const CellEditorToolVersionDocument = gql`
  query CellEditorToolVersion($toolVersionId: Int!) {
    toolVersion: toolVersionById(id: $toolVersionId) {
      id
      compatibleVersions {
        nodes {
          id
          version
          toolSpec
          credits
          status
        }
      }
    }
  }
`;

/**
 * __useCellEditorToolVersionQuery__
 *
 * To run a query within a React component, call `useCellEditorToolVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCellEditorToolVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCellEditorToolVersionQuery({
 *   variables: {
 *      toolVersionId: // value for 'toolVersionId'
 *   },
 * });
 */
export function useCellEditorToolVersionQuery(
  baseOptions: Apollo.QueryHookOptions<
    CellEditorToolVersionQuery,
    CellEditorToolVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CellEditorToolVersionQuery,
    CellEditorToolVersionQueryVariables
  >(CellEditorToolVersionDocument, options);
}
export function useCellEditorToolVersionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CellEditorToolVersionQuery,
    CellEditorToolVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CellEditorToolVersionQuery,
    CellEditorToolVersionQueryVariables
  >(CellEditorToolVersionDocument, options);
}
export type CellEditorToolVersionQueryHookResult = ReturnType<
  typeof useCellEditorToolVersionQuery
>;
export type CellEditorToolVersionLazyQueryHookResult = ReturnType<
  typeof useCellEditorToolVersionLazyQuery
>;
export type CellEditorToolVersionQueryResult = Apollo.QueryResult<
  CellEditorToolVersionQuery,
  CellEditorToolVersionQueryVariables
>;
export const DataTableUpgradeButtonDocument = gql`
  query DataTableUpgradeButton($toolVersionId: Int!) {
    toolVersion: toolVersionById(id: $toolVersionId) {
      id
      tool: toolByToolId {
        id
        toolVersions: toolVersionsByToolId(orderBy: CREATED_ASC, last: 1) {
          nodes {
            id
          }
        }
      }
    }
  }
`;

/**
 * __useDataTableUpgradeButtonQuery__
 *
 * To run a query within a React component, call `useDataTableUpgradeButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataTableUpgradeButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataTableUpgradeButtonQuery({
 *   variables: {
 *      toolVersionId: // value for 'toolVersionId'
 *   },
 * });
 */
export function useDataTableUpgradeButtonQuery(
  baseOptions: Apollo.QueryHookOptions<
    DataTableUpgradeButtonQuery,
    DataTableUpgradeButtonQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DataTableUpgradeButtonQuery,
    DataTableUpgradeButtonQueryVariables
  >(DataTableUpgradeButtonDocument, options);
}
export function useDataTableUpgradeButtonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DataTableUpgradeButtonQuery,
    DataTableUpgradeButtonQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DataTableUpgradeButtonQuery,
    DataTableUpgradeButtonQueryVariables
  >(DataTableUpgradeButtonDocument, options);
}
export type DataTableUpgradeButtonQueryHookResult = ReturnType<
  typeof useDataTableUpgradeButtonQuery
>;
export type DataTableUpgradeButtonLazyQueryHookResult = ReturnType<
  typeof useDataTableUpgradeButtonLazyQuery
>;
export type DataTableUpgradeButtonQueryResult = Apollo.QueryResult<
  DataTableUpgradeButtonQuery,
  DataTableUpgradeButtonQueryVariables
>;
export const ModalMapAnalysisParametersDocument = gql`
  query ModalMapAnalysisParameters($toolVersionId: Int!) {
    toolVersion: toolVersionById(id: $toolVersionId) {
      id
      toolSpec
    }
  }
`;

/**
 * __useModalMapAnalysisParametersQuery__
 *
 * To run a query within a React component, call `useModalMapAnalysisParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useModalMapAnalysisParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModalMapAnalysisParametersQuery({
 *   variables: {
 *      toolVersionId: // value for 'toolVersionId'
 *   },
 * });
 */
export function useModalMapAnalysisParametersQuery(
  baseOptions: Apollo.QueryHookOptions<
    ModalMapAnalysisParametersQuery,
    ModalMapAnalysisParametersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ModalMapAnalysisParametersQuery,
    ModalMapAnalysisParametersQueryVariables
  >(ModalMapAnalysisParametersDocument, options);
}
export function useModalMapAnalysisParametersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ModalMapAnalysisParametersQuery,
    ModalMapAnalysisParametersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ModalMapAnalysisParametersQuery,
    ModalMapAnalysisParametersQueryVariables
  >(ModalMapAnalysisParametersDocument, options);
}
export type ModalMapAnalysisParametersQueryHookResult = ReturnType<
  typeof useModalMapAnalysisParametersQuery
>;
export type ModalMapAnalysisParametersLazyQueryHookResult = ReturnType<
  typeof useModalMapAnalysisParametersLazyQuery
>;
export type ModalMapAnalysisParametersQueryResult = Apollo.QueryResult<
  ModalMapAnalysisParametersQuery,
  ModalMapAnalysisParametersQueryVariables
>;
export const PageProjectDocument = gql`
  query PageProject($projectKey: String!, $tenantId: Int!) {
    project: projectByKeyAndTenantId(key: $projectKey, tenantId: $tenantId) {
      ...ProjectFields
      isToolProject
      dateLastActive
    }
  }
  ${ProjectFieldsFragmentDoc}
`;

/**
 * __usePageProjectQuery__
 *
 * To run a query within a React component, call `usePageProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageProjectQuery({
 *   variables: {
 *      projectKey: // value for 'projectKey'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function usePageProjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    PageProjectQuery,
    PageProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PageProjectQuery, PageProjectQueryVariables>(
    PageProjectDocument,
    options,
  );
}
export function usePageProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PageProjectQuery,
    PageProjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PageProjectQuery, PageProjectQueryVariables>(
    PageProjectDocument,
    options,
  );
}
export type PageProjectQueryHookResult = ReturnType<typeof usePageProjectQuery>;
export type PageProjectLazyQueryHookResult = ReturnType<
  typeof usePageProjectLazyQuery
>;
export type PageProjectQueryResult = Apollo.QueryResult<
  PageProjectQuery,
  PageProjectQueryVariables
>;
export const GetDrsFilesDocument = gql`
  query GetDrsFiles($ids: [UUID!]!) {
    drsFiles: allFiles(filter: { id: { in: $ids } }) {
      nodes {
        ...FileCache
      }
    }
  }
  ${FileCacheFragmentDoc}
`;

/**
 * __useGetDrsFilesQuery__
 *
 * To run a query within a React component, call `useGetDrsFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDrsFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDrsFilesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetDrsFilesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDrsFilesQuery,
    GetDrsFilesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDrsFilesQuery, GetDrsFilesQueryVariables>(
    GetDrsFilesDocument,
    options,
  );
}
export function useGetDrsFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDrsFilesQuery,
    GetDrsFilesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDrsFilesQuery, GetDrsFilesQueryVariables>(
    GetDrsFilesDocument,
    options,
  );
}
export type GetDrsFilesQueryHookResult = ReturnType<typeof useGetDrsFilesQuery>;
export type GetDrsFilesLazyQueryHookResult = ReturnType<
  typeof useGetDrsFilesLazyQuery
>;
export type GetDrsFilesQueryResult = Apollo.QueryResult<
  GetDrsFilesQuery,
  GetDrsFilesQueryVariables
>;
export const TasksTableGdtDocument = gql`
  query TasksTableGdt($condition: TaskCondition, $filter: TaskFilter) {
    allTasks: allTasks(condition: $condition, filter: $filter) {
      nodes {
        analysisTableRow: gdtAnalysisTableRowByTaskId {
          id
          index
          dateDeleted
          table: gdtAnalysisTableByTableId {
            id
            name
            key
            dateDeleted
          }
        }
        id
        credits
        cloned
        status
        created
        toolVersion: toolVersionByToolVersionId {
          id
          tool: toolByToolId {
            id
            key
          }
          toolSpec
          visibility
        }
        taskActivityByTaskId {
          id
          duration {
            hours
            seconds
            minutes
            days
            years
            months
          }
        }
        user: applicationUserByUserId {
          id
          firstName
          lastName
        }
        outputGroup: fileOutputGroupByTaskId {
          id
          outputGroupFiles: outputGroupFilesByFileOutputGroupId {
            nodes {
              id
              drsFile: fileByFileId {
                id
                name
                isSeries
                status
                key
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useTasksTableGdtQuery__
 *
 * To run a query within a React component, call `useTasksTableGdtQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksTableGdtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksTableGdtQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTasksTableGdtQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TasksTableGdtQuery,
    TasksTableGdtQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TasksTableGdtQuery, TasksTableGdtQueryVariables>(
    TasksTableGdtDocument,
    options,
  );
}
export function useTasksTableGdtLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TasksTableGdtQuery,
    TasksTableGdtQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TasksTableGdtQuery, TasksTableGdtQueryVariables>(
    TasksTableGdtDocument,
    options,
  );
}
export type TasksTableGdtQueryHookResult = ReturnType<
  typeof useTasksTableGdtQuery
>;
export type TasksTableGdtLazyQueryHookResult = ReturnType<
  typeof useTasksTableGdtLazyQuery
>;
export type TasksTableGdtQueryResult = Apollo.QueryResult<
  TasksTableGdtQuery,
  TasksTableGdtQueryVariables
>;
export const TenantProviderDocument = gql`
  query TenantProvider($tenantKey: String!) {
    tenant: tenantByKey(key: $tenantKey) {
      id
      name
      key
      internal
      tenantType
      memberships: applicationUserMembershipsByTenantId {
        nodes {
          id
          role
          user: applicationUserByUserId {
            id
            firstName
            lastName
            email
            username
            internal
            isActive
            avatar: avatarByUserId {
              id
              color
              initials
              useImage
              imageBase64
            }
            metadata: applicationUserMetadataByUserId {
              nodes {
                id
                key
                value
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useTenantProviderQuery__
 *
 * To run a query within a React component, call `useTenantProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantProviderQuery({
 *   variables: {
 *      tenantKey: // value for 'tenantKey'
 *   },
 * });
 */
export function useTenantProviderQuery(
  baseOptions: Apollo.QueryHookOptions<
    TenantProviderQuery,
    TenantProviderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TenantProviderQuery, TenantProviderQueryVariables>(
    TenantProviderDocument,
    options,
  );
}
export function useTenantProviderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TenantProviderQuery,
    TenantProviderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TenantProviderQuery, TenantProviderQueryVariables>(
    TenantProviderDocument,
    options,
  );
}
export type TenantProviderQueryHookResult = ReturnType<
  typeof useTenantProviderQuery
>;
export type TenantProviderLazyQueryHookResult = ReturnType<
  typeof useTenantProviderLazyQuery
>;
export type TenantProviderQueryResult = Apollo.QueryResult<
  TenantProviderQuery,
  TenantProviderQueryVariables
>;
export const UserProviderDocument = gql`
  query UserProvider {
    currentUser: getCurrentUser {
      id
      firstName
      lastName
      email
      username
      internal
      isActive
      metadata: applicationUserMetadataByUserId {
        nodes {
          id
          key
          value
        }
      }
      eula: eulaVersionUserAcceptancesByUserId {
        nodes {
          id
          accepted
        }
      }
      ...UserAvatarFields
      memberships: applicationUserMembershipsByUserId {
        nodes {
          id
          role
          tenant: tenantByTenantId {
            id
            key
            name
            tenantType
          }
        }
      }
    }
  }
  ${UserAvatarFieldsFragmentDoc}
`;

/**
 * __useUserProviderQuery__
 *
 * To run a query within a React component, call `useUserProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserProviderQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserProviderQuery,
    UserProviderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserProviderQuery, UserProviderQueryVariables>(
    UserProviderDocument,
    options,
  );
}
export function useUserProviderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserProviderQuery,
    UserProviderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserProviderQuery, UserProviderQueryVariables>(
    UserProviderDocument,
    options,
  );
}
export type UserProviderQueryHookResult = ReturnType<
  typeof useUserProviderQuery
>;
export type UserProviderLazyQueryHookResult = ReturnType<
  typeof useUserProviderLazyQuery
>;
export type UserProviderQueryResult = Apollo.QueryResult<
  UserProviderQuery,
  UserProviderQueryVariables
>;

export type ResolverTypeWrapper<T> = Promise<T> | T;

export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> {
  subscribe: SubscriptionSubscribeFn<
    { [key in TKey]: TResult },
    TParent,
    TContext,
    TArgs
  >;
  resolve?: SubscriptionResolveFn<
    TResult,
    { [key in TKey]: TResult },
    TContext,
    TArgs
  >;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<
  TResult,
  TKey extends string,
  TParent = {},
  TContext = {},
  TArgs = {},
> =
  | ((
      ...args: any[]
    ) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo,
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo,
) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<
  TResult = {},
  TParent = {},
  TContext = {},
  TArgs = {},
> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AdminProject: ResolverTypeWrapper<AdminProject>;
  AdminProjectCondition: AdminProjectCondition;
  AdminProjectFilter: AdminProjectFilter;
  AdminProjectInput: AdminProjectInput;
  AdminProjectsConnection: ResolverTypeWrapper<AdminProjectsConnection>;
  AdminProjectsEdge: ResolverTypeWrapper<AdminProjectsEdge>;
  AdminProjectsOrderBy: AdminProjectsOrderBy;
  ApplicationUser: ResolverTypeWrapper<ApplicationUser>;
  ApplicationUserApplicationUserEmailKeyConnect: ApplicationUserApplicationUserEmailKeyConnect;
  ApplicationUserApplicationUserEmailKeyDelete: ApplicationUserApplicationUserEmailKeyDelete;
  ApplicationUserApplicationUserGlobalUserIdKeyConnect: ApplicationUserApplicationUserGlobalUserIdKeyConnect;
  ApplicationUserApplicationUserGlobalUserIdKeyDelete: ApplicationUserApplicationUserGlobalUserIdKeyDelete;
  ApplicationUserApplicationUserPkeyConnect: ApplicationUserApplicationUserPkeyConnect;
  ApplicationUserApplicationUserPkeyDelete: ApplicationUserApplicationUserPkeyDelete;
  ApplicationUserApplicationUserUsernameKeyConnect: ApplicationUserApplicationUserUsernameKeyConnect;
  ApplicationUserApplicationUserUsernameKeyDelete: ApplicationUserApplicationUserUsernameKeyDelete;
  ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput: ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput;
  ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInverseInput: ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInverseInput;
  ApplicationUserFilter: ApplicationUserFilter;
  ApplicationUserGroup: ResolverTypeWrapper<ApplicationUserGroup>;
  ApplicationUserGroupApplicationUserGroupsPkeyConnect: ApplicationUserGroupApplicationUserGroupsPkeyConnect;
  ApplicationUserGroupApplicationUserGroupsPkeyDelete: ApplicationUserGroupApplicationUserGroupsPkeyDelete;
  ApplicationUserGroupApplicationUserGroupsUserIdGroupId3A20Ace4UniqConnect: ApplicationUserGroupApplicationUserGroupsUserIdGroupId3A20Ace4UniqConnect;
  ApplicationUserGroupApplicationUserGroupsUserIdGroupId3A20Ace4UniqDelete: ApplicationUserGroupApplicationUserGroupsUserIdGroupId3A20Ace4UniqDelete;
  ApplicationUserGroupCondition: ApplicationUserGroupCondition;
  ApplicationUserGroupFilter: ApplicationUserGroupFilter;
  ApplicationUserGroupInput: ApplicationUserGroupInput;
  ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingApplicationUserGroupsPkeyUpdate: ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingApplicationUserGroupsPkeyUpdate;
  ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingApplicationUserGroupsUserIdGroupId3A20Ace4UniqUpdate: ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingApplicationUserGroupsUserIdGroupId3A20Ace4UniqUpdate;
  ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGroupsPkeyUpdate: ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGroupsPkeyUpdate;
  ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGroupsUserIdGroupId3A20Ace4UniqUpdate: ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGroupsUserIdGroupId3A20Ace4UniqUpdate;
  ApplicationUserGroupPatch: ApplicationUserGroupPatch;
  ApplicationUserGroupsConnection: ResolverTypeWrapper<ApplicationUserGroupsConnection>;
  ApplicationUserGroupsEdge: ResolverTypeWrapper<ApplicationUserGroupsEdge>;
  ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdApplicationUserGroupsCreateInput: ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdApplicationUserGroupsCreateInput;
  ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdAuthGroupCreateInput: ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdAuthGroupCreateInput;
  ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInput: ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInput;
  ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInverseInput: ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInverseInput;
  ApplicationUserGroupsOrderBy: ApplicationUserGroupsOrderBy;
  ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdApplicationUserCreateInput: ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdApplicationUserCreateInput;
  ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdApplicationUserGroupsCreateInput: ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdApplicationUserGroupsCreateInput;
  ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInput: ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInput;
  ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput: ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput;
  ApplicationUserInput: ApplicationUserInput;
  ApplicationUserMemUserId631Fddc5FkApplicatiApplicationUserCreateInput: ApplicationUserMemUserId631Fddc5FkApplicatiApplicationUserCreateInput;
  ApplicationUserMemUserId631Fddc5FkApplicatiApplicationUserMembershipCreateInput: ApplicationUserMemUserId631Fddc5FkApplicatiApplicationUserMembershipCreateInput;
  ApplicationUserMemUserId631Fddc5FkApplicatiInput: ApplicationUserMemUserId631Fddc5FkApplicatiInput;
  ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput: ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput;
  ApplicationUserMembership: ResolverTypeWrapper<ApplicationUserMembership>;
  ApplicationUserMembershipApplicationUserMembershipPkeyConnect: ApplicationUserMembershipApplicationUserMembershipPkeyConnect;
  ApplicationUserMembershipApplicationUserMembershipPkeyDelete: ApplicationUserMembershipApplicationUserMembershipPkeyDelete;
  ApplicationUserMembershipCondition: ApplicationUserMembershipCondition;
  ApplicationUserMembershipFilter: ApplicationUserMembershipFilter;
  ApplicationUserMembershipInput: ApplicationUserMembershipInput;
  ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserMembershipPkeyUpdate: ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserMembershipPkeyUpdate;
  ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingUserTenantUniqueUpdate: ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingUserTenantUniqueUpdate;
  ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingApplicationUserMembershipPkeyUpdate: ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingApplicationUserMembershipPkeyUpdate;
  ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingUserTenantUniqueUpdate: ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingUserTenantUniqueUpdate;
  ApplicationUserMembershipPatch: ApplicationUserMembershipPatch;
  ApplicationUserMembershipTenantId5E54Da7AFkTenantIdApplicationUserMembershipCreateInput: ApplicationUserMembershipTenantId5E54Da7AFkTenantIdApplicationUserMembershipCreateInput;
  ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput: ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput;
  ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput: ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput;
  ApplicationUserMembershipTenantId5E54Da7AFkTenantIdTenantCreateInput: ApplicationUserMembershipTenantId5E54Da7AFkTenantIdTenantCreateInput;
  ApplicationUserMembershipUserTenantUniqueConnect: ApplicationUserMembershipUserTenantUniqueConnect;
  ApplicationUserMembershipUserTenantUniqueDelete: ApplicationUserMembershipUserTenantUniqueDelete;
  ApplicationUserMembershipsConnection: ResolverTypeWrapper<ApplicationUserMembershipsConnection>;
  ApplicationUserMembershipsEdge: ResolverTypeWrapper<ApplicationUserMembershipsEdge>;
  ApplicationUserMembershipsOrderBy: ApplicationUserMembershipsOrderBy;
  ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserCreateInput: ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserCreateInput;
  ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserMetadataCreateInput: ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserMetadataCreateInput;
  ApplicationUserMetUserId897Fbde1FkApplicatiInput: ApplicationUserMetUserId897Fbde1FkApplicatiInput;
  ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput: ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput;
  ApplicationUserMetadataConnection: ResolverTypeWrapper<ApplicationUserMetadataConnection>;
  ApplicationUserMetadataEdge: ResolverTypeWrapper<ApplicationUserMetadataEdge>;
  ApplicationUserMetadataOrderBy: ApplicationUserMetadataOrderBy;
  ApplicationUserMetadatum: ResolverTypeWrapper<ApplicationUserMetadatum>;
  ApplicationUserMetadatumApplicationUserMetadataPkeyConnect: ApplicationUserMetadatumApplicationUserMetadataPkeyConnect;
  ApplicationUserMetadatumApplicationUserMetadataPkeyDelete: ApplicationUserMetadatumApplicationUserMetadataPkeyDelete;
  ApplicationUserMetadatumCondition: ApplicationUserMetadatumCondition;
  ApplicationUserMetadatumFilter: ApplicationUserMetadatumFilter;
  ApplicationUserMetadatumInput: ApplicationUserMetadatumInput;
  ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserMetadataPkeyUpdate: ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserMetadataPkeyUpdate;
  ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingUserKeyUpdate: ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingUserKeyUpdate;
  ApplicationUserMetadatumPatch: ApplicationUserMetadatumPatch;
  ApplicationUserMetadatumUserKeyConnect: ApplicationUserMetadatumUserKeyConnect;
  ApplicationUserMetadatumUserKeyDelete: ApplicationUserMetadatumUserKeyDelete;
  ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserPatch: ApplicationUserPatch;
  ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserCreateInput: ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserCreateInput;
  ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserSessionCreateInput: ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserSessionCreateInput;
  ApplicationUserSesUserId2Fb30D0CFkApplicatiInput: ApplicationUserSesUserId2Fb30D0CFkApplicatiInput;
  ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput: ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput;
  ApplicationUserSession: ResolverTypeWrapper<ApplicationUserSession>;
  ApplicationUserSessionApplicationUserSessionPkeyConnect: ApplicationUserSessionApplicationUserSessionPkeyConnect;
  ApplicationUserSessionApplicationUserSessionPkeyDelete: ApplicationUserSessionApplicationUserSessionPkeyDelete;
  ApplicationUserSessionCondition: ApplicationUserSessionCondition;
  ApplicationUserSessionFilter: ApplicationUserSessionFilter;
  ApplicationUserSessionInput: ApplicationUserSessionInput;
  ApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserSessionPkeyUpdate: ApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserSessionPkeyUpdate;
  ApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingApplicationUserSessionPkeyUpdate: ApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingApplicationUserSessionPkeyUpdate;
  ApplicationUserSessionPatch: ApplicationUserSessionPatch;
  ApplicationUserSessionTenantId00A81Cc5FkTenantIdApplicationUserSessionCreateInput: ApplicationUserSessionTenantId00A81Cc5FkTenantIdApplicationUserSessionCreateInput;
  ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput: ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput;
  ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput: ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput;
  ApplicationUserSessionTenantId00A81Cc5FkTenantIdTenantCreateInput: ApplicationUserSessionTenantId00A81Cc5FkTenantIdTenantCreateInput;
  ApplicationUserSessionsConnection: ResolverTypeWrapper<ApplicationUserSessionsConnection>;
  ApplicationUserSessionsEdge: ResolverTypeWrapper<ApplicationUserSessionsEdge>;
  ApplicationUserSessionsOrderBy: ApplicationUserSessionsOrderBy;
  ApplicationUserToManyApplicationUserGroupFilter: ApplicationUserToManyApplicationUserGroupFilter;
  ApplicationUserToManyApplicationUserMembershipFilter: ApplicationUserToManyApplicationUserMembershipFilter;
  ApplicationUserToManyApplicationUserMetadatumFilter: ApplicationUserToManyApplicationUserMetadatumFilter;
  ApplicationUserToManyApplicationUserSessionFilter: ApplicationUserToManyApplicationUserSessionFilter;
  ApplicationUserToManyApplicationUserUserPermissionFilter: ApplicationUserToManyApplicationUserUserPermissionFilter;
  ApplicationUserToManyAuditlogLogentryFilter: ApplicationUserToManyAuditlogLogentryFilter;
  ApplicationUserToManyCodeFileFilter: ApplicationUserToManyCodeFileFilter;
  ApplicationUserToManyCommandFilter: ApplicationUserToManyCommandFilter;
  ApplicationUserToManyContainerImageFilter: ApplicationUserToManyContainerImageFilter;
  ApplicationUserToManyContainerImageRepositoryFilter: ApplicationUserToManyContainerImageRepositoryFilter;
  ApplicationUserToManyDataTableColumnFilter: ApplicationUserToManyDataTableColumnFilter;
  ApplicationUserToManyDataTableColumnGroupFilter: ApplicationUserToManyDataTableColumnGroupFilter;
  ApplicationUserToManyDataTableFilter: ApplicationUserToManyDataTableFilter;
  ApplicationUserToManyDataTableRowFilter: ApplicationUserToManyDataTableRowFilter;
  ApplicationUserToManyDjangoAdminLogFilter: ApplicationUserToManyDjangoAdminLogFilter;
  ApplicationUserToManyEulaVersionUserAcceptanceFilter: ApplicationUserToManyEulaVersionUserAcceptanceFilter;
  ApplicationUserToManyFeatureFlagsUserFilter: ApplicationUserToManyFeatureFlagsUserFilter;
  ApplicationUserToManyFileActivityFilter: ApplicationUserToManyFileActivityFilter;
  ApplicationUserToManyFileFilter: ApplicationUserToManyFileFilter;
  ApplicationUserToManyFileOutputGroupFilter: ApplicationUserToManyFileOutputGroupFilter;
  ApplicationUserToManyFileProcessingNotificationFilter: ApplicationUserToManyFileProcessingNotificationFilter;
  ApplicationUserToManyGdtAnalysisTableColumnFilter: ApplicationUserToManyGdtAnalysisTableColumnFilter;
  ApplicationUserToManyGdtAnalysisTableColumnGroupFilter: ApplicationUserToManyGdtAnalysisTableColumnGroupFilter;
  ApplicationUserToManyGdtAnalysisTableFilter: ApplicationUserToManyGdtAnalysisTableFilter;
  ApplicationUserToManyGdtAnalysisTableRowFilter: ApplicationUserToManyGdtAnalysisTableRowFilter;
  ApplicationUserToManyMetadataValueFilter: ApplicationUserToManyMetadataValueFilter;
  ApplicationUserToManyNotificationFilter: ApplicationUserToManyNotificationFilter;
  ApplicationUserToManyPinnedToolFilter: ApplicationUserToManyPinnedToolFilter;
  ApplicationUserToManyProjectClonedNotificationFilter: ApplicationUserToManyProjectClonedNotificationFilter;
  ApplicationUserToManyProjectFilter: ApplicationUserToManyProjectFilter;
  ApplicationUserToManyProjectFolderFilter: ApplicationUserToManyProjectFolderFilter;
  ApplicationUserToManyProjectSharedNotificationFilter: ApplicationUserToManyProjectSharedNotificationFilter;
  ApplicationUserToManyProjectTagFilter: ApplicationUserToManyProjectTagFilter;
  ApplicationUserToManyRoleChangeNotificationFilter: ApplicationUserToManyRoleChangeNotificationFilter;
  ApplicationUserToManyTaskFilter: ApplicationUserToManyTaskFilter;
  ApplicationUserToManyTenantMonthlyConsumedResourceFilter: ApplicationUserToManyTenantMonthlyConsumedResourceFilter;
  ApplicationUserToManyTenantUserMembershipNotificationFilter: ApplicationUserToManyTenantUserMembershipNotificationFilter;
  ApplicationUserToManyToolFilter: ApplicationUserToManyToolFilter;
  ApplicationUserToManyToolVersionFilter: ApplicationUserToManyToolVersionFilter;
  ApplicationUserToManyUserOnboardingQuestionResponseFilter: ApplicationUserToManyUserOnboardingQuestionResponseFilter;
  ApplicationUserToManyUserPersonalSpaceRequestFilter: ApplicationUserToManyUserPersonalSpaceRequestFilter;
  ApplicationUserToManyWorkflowFilter: ApplicationUserToManyWorkflowFilter;
  ApplicationUserToManyWorkflowVersionFilter: ApplicationUserToManyWorkflowVersionFilter;
  ApplicationUserUsePermissionIdDbf9693DFkAuthPermApplicationUserUserPermissionsCreateInput: ApplicationUserUsePermissionIdDbf9693DFkAuthPermApplicationUserUserPermissionsCreateInput;
  ApplicationUserUsePermissionIdDbf9693DFkAuthPermAuthPermissionCreateInput: ApplicationUserUsePermissionIdDbf9693DFkAuthPermAuthPermissionCreateInput;
  ApplicationUserUsePermissionIdDbf9693DFkAuthPermInput: ApplicationUserUsePermissionIdDbf9693DFkAuthPermInput;
  ApplicationUserUsePermissionIdDbf9693DFkAuthPermInverseInput: ApplicationUserUsePermissionIdDbf9693DFkAuthPermInverseInput;
  ApplicationUserUseUserIdE643F548FkApplicatiApplicationUserCreateInput: ApplicationUserUseUserIdE643F548FkApplicatiApplicationUserCreateInput;
  ApplicationUserUseUserIdE643F548FkApplicatiApplicationUserUserPermissionsCreateInput: ApplicationUserUseUserIdE643F548FkApplicatiApplicationUserUserPermissionsCreateInput;
  ApplicationUserUseUserIdE643F548FkApplicatiInput: ApplicationUserUseUserIdE643F548FkApplicatiInput;
  ApplicationUserUseUserIdE643F548FkApplicatiInverseInput: ApplicationUserUseUserIdE643F548FkApplicatiInverseInput;
  ApplicationUserUserPermission: ResolverTypeWrapper<ApplicationUserUserPermission>;
  ApplicationUserUserPermissionApplicationUserUserPeUserIdPermissionId52D58A70UniqConnect: ApplicationUserUserPermissionApplicationUserUserPeUserIdPermissionId52D58A70UniqConnect;
  ApplicationUserUserPermissionApplicationUserUserPeUserIdPermissionId52D58A70UniqDelete: ApplicationUserUserPermissionApplicationUserUserPeUserIdPermissionId52D58A70UniqDelete;
  ApplicationUserUserPermissionApplicationUserUserPermissionsPkeyConnect: ApplicationUserUserPermissionApplicationUserUserPermissionsPkeyConnect;
  ApplicationUserUserPermissionApplicationUserUserPermissionsPkeyDelete: ApplicationUserUserPermissionApplicationUserUserPermissionsPkeyDelete;
  ApplicationUserUserPermissionCondition: ApplicationUserUserPermissionCondition;
  ApplicationUserUserPermissionFilter: ApplicationUserUserPermissionFilter;
  ApplicationUserUserPermissionInput: ApplicationUserUserPermissionInput;
  ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingApplicationUserUserPeUserIdPermissionId52D58A70UniqUpdate: ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingApplicationUserUserPeUserIdPermissionId52D58A70UniqUpdate;
  ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingApplicationUserUserPermissionsPkeyUpdate: ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingApplicationUserUserPermissionsPkeyUpdate;
  ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUserPeUserIdPermissionId52D58A70UniqUpdate: ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUserPeUserIdPermissionId52D58A70UniqUpdate;
  ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUserPermissionsPkeyUpdate: ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUserPermissionsPkeyUpdate;
  ApplicationUserUserPermissionPatch: ApplicationUserUserPermissionPatch;
  ApplicationUserUserPermissionsConnection: ResolverTypeWrapper<ApplicationUserUserPermissionsConnection>;
  ApplicationUserUserPermissionsEdge: ResolverTypeWrapper<ApplicationUserUserPermissionsEdge>;
  ApplicationUserUserPermissionsOrderBy: ApplicationUserUserPermissionsOrderBy;
  ApplicationUsersEdge: ResolverTypeWrapper<ApplicationUsersEdge>;
  ApplicationUsersOrderBy: ApplicationUsersOrderBy;
  AuditlogLogentriesConnection: ResolverTypeWrapper<AuditlogLogentriesConnection>;
  AuditlogLogentriesEdge: ResolverTypeWrapper<AuditlogLogentriesEdge>;
  AuditlogLogentriesOrderBy: AuditlogLogentriesOrderBy;
  AuditlogLogentry: ResolverTypeWrapper<AuditlogLogentry>;
  AuditlogLogentryActorId959271D2FkApplicationUserIdApplicationUserCreateInput: AuditlogLogentryActorId959271D2FkApplicationUserIdApplicationUserCreateInput;
  AuditlogLogentryActorId959271D2FkApplicationUserIdAuditlogLogentryCreateInput: AuditlogLogentryActorId959271D2FkApplicationUserIdAuditlogLogentryCreateInput;
  AuditlogLogentryActorId959271D2FkApplicationUserIdInput: AuditlogLogentryActorId959271D2FkApplicationUserIdInput;
  AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput: AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput;
  AuditlogLogentryAuditlogLogentryPkeyConnect: AuditlogLogentryAuditlogLogentryPkeyConnect;
  AuditlogLogentryAuditlogLogentryPkeyDelete: AuditlogLogentryAuditlogLogentryPkeyDelete;
  AuditlogLogentryCondition: AuditlogLogentryCondition;
  AuditlogLogentryContentTypeId75830218FkDjangoCoAuditlogLogentryCreateInput: AuditlogLogentryContentTypeId75830218FkDjangoCoAuditlogLogentryCreateInput;
  AuditlogLogentryContentTypeId75830218FkDjangoCoDjangoContentTypeCreateInput: AuditlogLogentryContentTypeId75830218FkDjangoCoDjangoContentTypeCreateInput;
  AuditlogLogentryContentTypeId75830218FkDjangoCoInput: AuditlogLogentryContentTypeId75830218FkDjangoCoInput;
  AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput: AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput;
  AuditlogLogentryFilter: AuditlogLogentryFilter;
  AuditlogLogentryInput: AuditlogLogentryInput;
  AuditlogLogentryOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingAuditlogLogentryPkeyUpdate: AuditlogLogentryOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingAuditlogLogentryPkeyUpdate;
  AuditlogLogentryOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingAuditlogLogentryPkeyUpdate: AuditlogLogentryOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingAuditlogLogentryPkeyUpdate;
  AuditlogLogentryPatch: AuditlogLogentryPatch;
  AuthGroup: ResolverTypeWrapper<AuthGroup>;
  AuthGroupAuthGroupNameKeyConnect: AuthGroupAuthGroupNameKeyConnect;
  AuthGroupAuthGroupNameKeyDelete: AuthGroupAuthGroupNameKeyDelete;
  AuthGroupAuthGroupPkeyConnect: AuthGroupAuthGroupPkeyConnect;
  AuthGroupAuthGroupPkeyDelete: AuthGroupAuthGroupPkeyDelete;
  AuthGroupCondition: AuthGroupCondition;
  AuthGroupFilter: AuthGroupFilter;
  AuthGroupInput: AuthGroupInput;
  AuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingAuthGroupNameKeyUpdate: AuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingAuthGroupNameKeyUpdate;
  AuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingAuthGroupPkeyUpdate: AuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingAuthGroupPkeyUpdate;
  AuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupNameKeyUpdate: AuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupNameKeyUpdate;
  AuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPkeyUpdate: AuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPkeyUpdate;
  AuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingAuthGroupNameKeyUpdate: AuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingAuthGroupNameKeyUpdate;
  AuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingAuthGroupPkeyUpdate: AuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingAuthGroupPkeyUpdate;
  AuthGroupPatch: AuthGroupPatch;
  AuthGroupPermissioPermissionId84C5C92EFkAuthPermAuthGroupPermissionsCreateInput: AuthGroupPermissioPermissionId84C5C92EFkAuthPermAuthGroupPermissionsCreateInput;
  AuthGroupPermissioPermissionId84C5C92EFkAuthPermAuthPermissionCreateInput: AuthGroupPermissioPermissionId84C5C92EFkAuthPermAuthPermissionCreateInput;
  AuthGroupPermissioPermissionId84C5C92EFkAuthPermInput: AuthGroupPermissioPermissionId84C5C92EFkAuthPermInput;
  AuthGroupPermissioPermissionId84C5C92EFkAuthPermInverseInput: AuthGroupPermissioPermissionId84C5C92EFkAuthPermInverseInput;
  AuthGroupPermission: ResolverTypeWrapper<AuthGroupPermission>;
  AuthGroupPermissionAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqConnect: AuthGroupPermissionAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqConnect;
  AuthGroupPermissionAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqDelete: AuthGroupPermissionAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqDelete;
  AuthGroupPermissionAuthGroupPermissionsPkeyConnect: AuthGroupPermissionAuthGroupPermissionsPkeyConnect;
  AuthGroupPermissionAuthGroupPermissionsPkeyDelete: AuthGroupPermissionAuthGroupPermissionsPkeyDelete;
  AuthGroupPermissionCondition: AuthGroupPermissionCondition;
  AuthGroupPermissionFilter: AuthGroupPermissionFilter;
  AuthGroupPermissionInput: AuthGroupPermissionInput;
  AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqUpdate: AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqUpdate;
  AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthGroupPermissionsPkeyUpdate: AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthGroupPermissionsPkeyUpdate;
  AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqUpdate: AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqUpdate;
  AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPermissionsPkeyUpdate: AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPermissionsPkeyUpdate;
  AuthGroupPermissionPatch: AuthGroupPermissionPatch;
  AuthGroupPermissionsConnection: ResolverTypeWrapper<AuthGroupPermissionsConnection>;
  AuthGroupPermissionsEdge: ResolverTypeWrapper<AuthGroupPermissionsEdge>;
  AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdAuthGroupCreateInput: AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdAuthGroupCreateInput;
  AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdAuthGroupPermissionsCreateInput: AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdAuthGroupPermissionsCreateInput;
  AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInput: AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInput;
  AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInverseInput: AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInverseInput;
  AuthGroupPermissionsOrderBy: AuthGroupPermissionsOrderBy;
  AuthGroupToManyApplicationUserGroupFilter: AuthGroupToManyApplicationUserGroupFilter;
  AuthGroupToManyAuthGroupPermissionFilter: AuthGroupToManyAuthGroupPermissionFilter;
  AuthGroupToManyFeatureFlagsGroupFilter: AuthGroupToManyFeatureFlagsGroupFilter;
  AuthGroupsConnection: ResolverTypeWrapper<AuthGroupsConnection>;
  AuthGroupsEdge: ResolverTypeWrapper<AuthGroupsEdge>;
  AuthGroupsOrderBy: AuthGroupsOrderBy;
  AuthPermission: ResolverTypeWrapper<AuthPermission>;
  AuthPermissionAuthPermissionContentTypeIdCodename01Ab375AUniqConnect: AuthPermissionAuthPermissionContentTypeIdCodename01Ab375AUniqConnect;
  AuthPermissionAuthPermissionContentTypeIdCodename01Ab375AUniqDelete: AuthPermissionAuthPermissionContentTypeIdCodename01Ab375AUniqDelete;
  AuthPermissionAuthPermissionPkeyConnect: AuthPermissionAuthPermissionPkeyConnect;
  AuthPermissionAuthPermissionPkeyDelete: AuthPermissionAuthPermissionPkeyDelete;
  AuthPermissionCondition: AuthPermissionCondition;
  AuthPermissionContentTypeId2F476E4BFkDjangoCoAuthPermissionCreateInput: AuthPermissionContentTypeId2F476E4BFkDjangoCoAuthPermissionCreateInput;
  AuthPermissionContentTypeId2F476E4BFkDjangoCoDjangoContentTypeCreateInput: AuthPermissionContentTypeId2F476E4BFkDjangoCoDjangoContentTypeCreateInput;
  AuthPermissionContentTypeId2F476E4BFkDjangoCoInput: AuthPermissionContentTypeId2F476E4BFkDjangoCoInput;
  AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput: AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput;
  AuthPermissionFilter: AuthPermissionFilter;
  AuthPermissionInput: AuthPermissionInput;
  AuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate: AuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate;
  AuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingAuthPermissionPkeyUpdate: AuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingAuthPermissionPkeyUpdate;
  AuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate: AuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate;
  AuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthPermissionPkeyUpdate: AuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthPermissionPkeyUpdate;
  AuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate: AuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate;
  AuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingAuthPermissionPkeyUpdate: AuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingAuthPermissionPkeyUpdate;
  AuthPermissionPatch: AuthPermissionPatch;
  AuthPermissionToManyApplicationUserUserPermissionFilter: AuthPermissionToManyApplicationUserUserPermissionFilter;
  AuthPermissionToManyAuthGroupPermissionFilter: AuthPermissionToManyAuthGroupPermissionFilter;
  AuthPermissionsConnection: ResolverTypeWrapper<AuthPermissionsConnection>;
  AuthPermissionsEdge: ResolverTypeWrapper<AuthPermissionsEdge>;
  AuthPermissionsOrderBy: AuthPermissionsOrderBy;
  AvailableNonRestrictedProject: ResolverTypeWrapper<AvailableNonRestrictedProject>;
  AvailableNonRestrictedProjectCondition: AvailableNonRestrictedProjectCondition;
  AvailableNonRestrictedProjectFilter: AvailableNonRestrictedProjectFilter;
  AvailableNonRestrictedProjectInput: AvailableNonRestrictedProjectInput;
  AvailableNonRestrictedProjectsConnection: ResolverTypeWrapper<AvailableNonRestrictedProjectsConnection>;
  AvailableNonRestrictedProjectsEdge: ResolverTypeWrapper<AvailableNonRestrictedProjectsEdge>;
  AvailableNonRestrictedProjectsOrderBy: AvailableNonRestrictedProjectsOrderBy;
  Avatar: ResolverTypeWrapper<Avatar>;
  AvatarAvatarPkeyConnect: AvatarAvatarPkeyConnect;
  AvatarAvatarPkeyDelete: AvatarAvatarPkeyDelete;
  AvatarAvatarUserIdKeyConnect: AvatarAvatarUserIdKeyConnect;
  AvatarAvatarUserIdKeyDelete: AvatarAvatarUserIdKeyDelete;
  AvatarCondition: AvatarCondition;
  AvatarFilter: AvatarFilter;
  AvatarInput: AvatarInput;
  AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarPkeyUpdate: AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarPkeyUpdate;
  AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarUserIdKeyUpdate: AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarUserIdKeyUpdate;
  AvatarPatch: AvatarPatch;
  AvatarUserId771332F2FkApplicationUserIdApplicationUserCreateInput: AvatarUserId771332F2FkApplicationUserIdApplicationUserCreateInput;
  AvatarUserId771332F2FkApplicationUserIdAvatarCreateInput: AvatarUserId771332F2FkApplicationUserIdAvatarCreateInput;
  AvatarUserId771332F2FkApplicationUserIdInput: AvatarUserId771332F2FkApplicationUserIdInput;
  AvatarUserId771332F2FkApplicationUserIdInverseInput: AvatarUserId771332F2FkApplicationUserIdInverseInput;
  AvatarsConnection: ResolverTypeWrapper<AvatarsConnection>;
  AvatarsEdge: ResolverTypeWrapper<AvatarsEdge>;
  AvatarsOrderBy: AvatarsOrderBy;
  AwsBatchTask: ResolverTypeWrapper<AwsBatchTask>;
  AwsBatchTaskAwsBatchTaskPkeyConnect: AwsBatchTaskAwsBatchTaskPkeyConnect;
  AwsBatchTaskAwsBatchTaskPkeyDelete: AwsBatchTaskAwsBatchTaskPkeyDelete;
  AwsBatchTaskCondition: AwsBatchTaskCondition;
  AwsBatchTaskFilter: AwsBatchTaskFilter;
  AwsBatchTaskInput: AwsBatchTaskInput;
  AwsBatchTaskOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeUsingAwsBatchTaskPkeyUpdate: AwsBatchTaskOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeUsingAwsBatchTaskPkeyUpdate;
  AwsBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchUsingAwsBatchTaskPkeyUpdate: AwsBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchUsingAwsBatchTaskPkeyUpdate;
  AwsBatchTaskPatch: AwsBatchTaskPatch;
  AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeAwsBatchTaskCreateInput: AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeAwsBatchTaskCreateInput;
  AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInput: AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInput;
  AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInverseInput: AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInverseInput;
  AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeTesTaskexecutorCreateInput: AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeTesTaskexecutorCreateInput;
  AwsBatchTasksConnection: ResolverTypeWrapper<AwsBatchTasksConnection>;
  AwsBatchTasksEdge: ResolverTypeWrapper<AwsBatchTasksEdge>;
  AwsBatchTasksOrderBy: AwsBatchTasksOrderBy;
  AwsCognitoUser: ResolverTypeWrapper<AwsCognitoUser>;
  AwsCognitoUserAwsCognitoUserPkeyConnect: AwsCognitoUserAwsCognitoUserPkeyConnect;
  AwsCognitoUserAwsCognitoUserPkeyDelete: AwsCognitoUserAwsCognitoUserPkeyDelete;
  AwsCognitoUserCondition: AwsCognitoUserCondition;
  AwsCognitoUserFilter: AwsCognitoUserFilter;
  AwsCognitoUserInput: AwsCognitoUserInput;
  AwsCognitoUserOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsUsingAwsCognitoUserPkeyUpdate: AwsCognitoUserOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsUsingAwsCognitoUserPkeyUpdate;
  AwsCognitoUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniUsingAwsCognitoUserPkeyUpdate: AwsCognitoUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniUsingAwsCognitoUserPkeyUpdate;
  AwsCognitoUserPatch: AwsCognitoUserPatch;
  AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsAwsCognitoUserCreateInput: AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsAwsCognitoUserCreateInput;
  AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInput: AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInput;
  AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInverseInput: AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInverseInput;
  AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsTenantUserexecutorCreateInput: AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsTenantUserexecutorCreateInput;
  AwsCognitoUsersConnection: ResolverTypeWrapper<AwsCognitoUsersConnection>;
  AwsCognitoUsersEdge: ResolverTypeWrapper<AwsCognitoUsersEdge>;
  AwsCognitoUsersOrderBy: AwsCognitoUsersOrderBy;
  AwsEcrImage: ResolverTypeWrapper<AwsEcrImage>;
  AwsEcrImageAwsEcrImagePkeyConnect: AwsEcrImageAwsEcrImagePkeyConnect;
  AwsEcrImageAwsEcrImagePkeyDelete: AwsEcrImageAwsEcrImagePkeyDelete;
  AwsEcrImageCondition: AwsEcrImageCondition;
  AwsEcrImageContainerimageexecutAabe4FdbFkTesContaAwsEcrImageCreateInput: AwsEcrImageContainerimageexecutAabe4FdbFkTesContaAwsEcrImageCreateInput;
  AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInput: AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInput;
  AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInverseInput: AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInverseInput;
  AwsEcrImageContainerimageexecutAabe4FdbFkTesContaTesContainerimageexecutorCreateInput: AwsEcrImageContainerimageexecutAabe4FdbFkTesContaTesContainerimageexecutorCreateInput;
  AwsEcrImageFilter: AwsEcrImageFilter;
  AwsEcrImageInput: AwsEcrImageInput;
  AwsEcrImageOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaUsingAwsEcrImagePkeyUpdate: AwsEcrImageOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaUsingAwsEcrImagePkeyUpdate;
  AwsEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIUsingAwsEcrImagePkeyUpdate: AwsEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIUsingAwsEcrImagePkeyUpdate;
  AwsEcrImagePatch: AwsEcrImagePatch;
  AwsEcrImagesConnection: ResolverTypeWrapper<AwsEcrImagesConnection>;
  AwsEcrImagesEdge: ResolverTypeWrapper<AwsEcrImagesEdge>;
  AwsEcrImagesOrderBy: AwsEcrImagesOrderBy;
  AwsMockBatchTask: ResolverTypeWrapper<AwsMockBatchTask>;
  AwsMockBatchTaskAwsMockBatchTaskPkeyConnect: AwsMockBatchTaskAwsMockBatchTaskPkeyConnect;
  AwsMockBatchTaskAwsMockBatchTaskPkeyDelete: AwsMockBatchTaskAwsMockBatchTaskPkeyDelete;
  AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchAwsBatchTaskCreateInput: AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchAwsBatchTaskCreateInput;
  AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchAwsMockBatchTaskCreateInput: AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchAwsMockBatchTaskCreateInput;
  AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInput: AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInput;
  AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInverseInput: AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInverseInput;
  AwsMockBatchTaskCondition: AwsMockBatchTaskCondition;
  AwsMockBatchTaskFilter: AwsMockBatchTaskFilter;
  AwsMockBatchTaskInput: AwsMockBatchTaskInput;
  AwsMockBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchUsingAwsMockBatchTaskPkeyUpdate: AwsMockBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchUsingAwsMockBatchTaskPkeyUpdate;
  AwsMockBatchTaskPatch: AwsMockBatchTaskPatch;
  AwsMockBatchTasksConnection: ResolverTypeWrapper<AwsMockBatchTasksConnection>;
  AwsMockBatchTasksEdge: ResolverTypeWrapper<AwsMockBatchTasksEdge>;
  AwsMockBatchTasksOrderBy: AwsMockBatchTasksOrderBy;
  AwsMockDistributioDistributioncontaineD5Bda68DFkDistributAwsMockDistributionImageCreateInput: AwsMockDistributioDistributioncontaineD5Bda68DFkDistributAwsMockDistributionImageCreateInput;
  AwsMockDistributioDistributioncontaineD5Bda68DFkDistributDistributionRegistryImageCreateInput: AwsMockDistributioDistributioncontaineD5Bda68DFkDistributDistributionRegistryImageCreateInput;
  AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInput: AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInput;
  AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInverseInput: AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInverseInput;
  AwsMockDistributionImage: ResolverTypeWrapper<AwsMockDistributionImage>;
  AwsMockDistributionImageAwsMockDistributionImagePkeyConnect: AwsMockDistributionImageAwsMockDistributionImagePkeyConnect;
  AwsMockDistributionImageAwsMockDistributionImagePkeyDelete: AwsMockDistributionImageAwsMockDistributionImagePkeyDelete;
  AwsMockDistributionImageCondition: AwsMockDistributionImageCondition;
  AwsMockDistributionImageFilter: AwsMockDistributionImageFilter;
  AwsMockDistributionImageInput: AwsMockDistributionImageInput;
  AwsMockDistributionImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributUsingAwsMockDistributionImagePkeyUpdate: AwsMockDistributionImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributUsingAwsMockDistributionImagePkeyUpdate;
  AwsMockDistributionImagePatch: AwsMockDistributionImagePatch;
  AwsMockDistributionImagesConnection: ResolverTypeWrapper<AwsMockDistributionImagesConnection>;
  AwsMockDistributionImagesEdge: ResolverTypeWrapper<AwsMockDistributionImagesEdge>;
  AwsMockDistributionImagesOrderBy: AwsMockDistributionImagesOrderBy;
  AwsMockEcrImage: ResolverTypeWrapper<AwsMockEcrImage>;
  AwsMockEcrImageAwsMockEcrImagePkeyConnect: AwsMockEcrImageAwsMockEcrImagePkeyConnect;
  AwsMockEcrImageAwsMockEcrImagePkeyDelete: AwsMockEcrImageAwsMockEcrImagePkeyDelete;
  AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIAwsEcrImageCreateInput: AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIAwsEcrImageCreateInput;
  AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIAwsMockEcrImageCreateInput: AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIAwsMockEcrImageCreateInput;
  AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInput: AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInput;
  AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInverseInput: AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInverseInput;
  AwsMockEcrImageCondition: AwsMockEcrImageCondition;
  AwsMockEcrImageFilter: AwsMockEcrImageFilter;
  AwsMockEcrImageInput: AwsMockEcrImageInput;
  AwsMockEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIUsingAwsMockEcrImagePkeyUpdate: AwsMockEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIUsingAwsMockEcrImagePkeyUpdate;
  AwsMockEcrImagePatch: AwsMockEcrImagePatch;
  AwsMockEcrImagesConnection: ResolverTypeWrapper<AwsMockEcrImagesConnection>;
  AwsMockEcrImagesEdge: ResolverTypeWrapper<AwsMockEcrImagesEdge>;
  AwsMockEcrImagesOrderBy: AwsMockEcrImagesOrderBy;
  AwsMockIamUser: ResolverTypeWrapper<AwsMockIamUser>;
  AwsMockIamUserAwsMockIamUserPkeyConnect: AwsMockIamUserAwsMockIamUserPkeyConnect;
  AwsMockIamUserAwsMockIamUserPkeyDelete: AwsMockIamUserAwsMockIamUserPkeyDelete;
  AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniAwsCognitoUserCreateInput: AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniAwsCognitoUserCreateInput;
  AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniAwsMockIamUserCreateInput: AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniAwsMockIamUserCreateInput;
  AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInput: AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInput;
  AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInverseInput: AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInverseInput;
  AwsMockIamUserCondition: AwsMockIamUserCondition;
  AwsMockIamUserFilter: AwsMockIamUserFilter;
  AwsMockIamUserInput: AwsMockIamUserInput;
  AwsMockIamUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniUsingAwsMockIamUserPkeyUpdate: AwsMockIamUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniUsingAwsMockIamUserPkeyUpdate;
  AwsMockIamUserPatch: AwsMockIamUserPatch;
  AwsMockIamUsersConnection: ResolverTypeWrapper<AwsMockIamUsersConnection>;
  AwsMockIamUsersEdge: ResolverTypeWrapper<AwsMockIamUsersEdge>;
  AwsMockIamUsersOrderBy: AwsMockIamUsersOrderBy;
  AwsMockS3File: ResolverTypeWrapper<AwsMockS3File>;
  AwsMockS3FileAwsMockS3FilePkeyConnect: AwsMockS3FileAwsMockS3FilePkeyConnect;
  AwsMockS3FileAwsMockS3FilePkeyDelete: AwsMockS3FileAwsMockS3FilePkeyDelete;
  AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiAwsMockS3FileCreateInput: AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiAwsMockS3FileCreateInput;
  AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiAwsS3FileCreateInput: AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiAwsS3FileCreateInput;
  AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInput: AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInput;
  AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInverseInput: AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInverseInput;
  AwsMockS3FileCondition: AwsMockS3FileCondition;
  AwsMockS3FileFilter: AwsMockS3FileFilter;
  AwsMockS3FileInput: AwsMockS3FileInput;
  AwsMockS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiUsingAwsMockS3FilePkeyUpdate: AwsMockS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiUsingAwsMockS3FilePkeyUpdate;
  AwsMockS3FilePatch: AwsMockS3FilePatch;
  AwsMockS3FilesConnection: ResolverTypeWrapper<AwsMockS3FilesConnection>;
  AwsMockS3FilesEdge: ResolverTypeWrapper<AwsMockS3FilesEdge>;
  AwsMockS3FilesOrderBy: AwsMockS3FilesOrderBy;
  AwsS3File: ResolverTypeWrapper<AwsS3File>;
  AwsS3FileAwsS3FilePkeyConnect: AwsS3FileAwsS3FilePkeyConnect;
  AwsS3FileAwsS3FilePkeyDelete: AwsS3FileAwsS3FilePkeyDelete;
  AwsS3FileCondition: AwsS3FileCondition;
  AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdAwsS3FileCreateInput: AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdAwsS3FileCreateInput;
  AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdDrsFileexecutorCreateInput: AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdDrsFileexecutorCreateInput;
  AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInput: AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInput;
  AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInverseInput: AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInverseInput;
  AwsS3FileFilter: AwsS3FileFilter;
  AwsS3FileInput: AwsS3FileInput;
  AwsS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiUsingAwsS3FilePkeyUpdate: AwsS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiUsingAwsS3FilePkeyUpdate;
  AwsS3FileOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdUsingAwsS3FilePkeyUpdate: AwsS3FileOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdUsingAwsS3FilePkeyUpdate;
  AwsS3FilePatch: AwsS3FilePatch;
  AwsS3FilesConnection: ResolverTypeWrapper<AwsS3FilesConnection>;
  AwsS3FilesEdge: ResolverTypeWrapper<AwsS3FilesEdge>;
  AwsS3FilesOrderBy: AwsS3FilesOrderBy;
  BigFloat: ResolverTypeWrapper<Scalars["BigFloat"]["output"]>;
  BigFloatFilter: BigFloatFilter;
  BigInt: ResolverTypeWrapper<Scalars["BigInt"]["output"]>;
  BigIntFilter: BigIntFilter;
  Boolean: ResolverTypeWrapper<Scalars["Boolean"]["output"]>;
  BooleanFilter: BooleanFilter;
  ChangeUserSessionInput: ChangeUserSessionInput;
  ChangeUserSessionPayload: ResolverTypeWrapper<ChangeUserSessionPayload>;
  CodeFile: ResolverTypeWrapper<CodeFile>;
  CodeFileCodeFilePkeyConnect: CodeFileCodeFilePkeyConnect;
  CodeFileCodeFilePkeyDelete: CodeFileCodeFilePkeyDelete;
  CodeFileCondition: CodeFileCondition;
  CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdCodeFileCreateInput: CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdCodeFileCreateInput;
  CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdDrsFileexecutorCreateInput: CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdDrsFileexecutorCreateInput;
  CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInput: CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInput;
  CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInverseInput: CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInverseInput;
  CodeFileFilter: CodeFileFilter;
  CodeFileInput: CodeFileInput;
  CodeFileOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdUsingCodeFilePkeyUpdate: CodeFileOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdUsingCodeFilePkeyUpdate;
  CodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdUsingCodeFilePkeyUpdate: CodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdUsingCodeFilePkeyUpdate;
  CodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingCodeFilePkeyUpdate: CodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingCodeFilePkeyUpdate;
  CodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingCodeFilePkeyUpdate: CodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingCodeFilePkeyUpdate;
  CodeFileOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCodeFilePkeyUpdate: CodeFileOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCodeFilePkeyUpdate;
  CodeFilePatch: CodeFilePatch;
  CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdCodeFileCreateInput: CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdCodeFileCreateInput;
  CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput: CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput;
  CodeFileTenantIdC35D8B4EFkTenantIdCodeFileCreateInput: CodeFileTenantIdC35D8B4EFkTenantIdCodeFileCreateInput;
  CodeFileTenantIdC35D8B4EFkTenantIdInput: CodeFileTenantIdC35D8B4EFkTenantIdInput;
  CodeFileTenantIdC35D8B4EFkTenantIdInverseInput: CodeFileTenantIdC35D8B4EFkTenantIdInverseInput;
  CodeFileTenantIdC35D8B4EFkTenantIdTenantCreateInput: CodeFileTenantIdC35D8B4EFkTenantIdTenantCreateInput;
  CodeFileToManyCodeFileFilter: CodeFileToManyCodeFileFilter;
  CodeFileToManyCommandFilter: CodeFileToManyCommandFilter;
  CodeFileUserIdAb9E5143FkApplicationUserIdApplicationUserCreateInput: CodeFileUserIdAb9E5143FkApplicationUserIdApplicationUserCreateInput;
  CodeFileUserIdAb9E5143FkApplicationUserIdCodeFileCreateInput: CodeFileUserIdAb9E5143FkApplicationUserIdCodeFileCreateInput;
  CodeFileUserIdAb9E5143FkApplicationUserIdInput: CodeFileUserIdAb9E5143FkApplicationUserIdInput;
  CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput: CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput;
  CodeFilesConnection: ResolverTypeWrapper<CodeFilesConnection>;
  CodeFilesEdge: ResolverTypeWrapper<CodeFilesEdge>;
  CodeFilesOrderBy: CodeFilesOrderBy;
  Command: ResolverTypeWrapper<Command>;
  CommandCodeFileIdE6Dc0F85FkCodeFileIdCodeFileCreateInput: CommandCodeFileIdE6Dc0F85FkCodeFileIdCodeFileCreateInput;
  CommandCodeFileIdE6Dc0F85FkCodeFileIdCommandCreateInput: CommandCodeFileIdE6Dc0F85FkCodeFileIdCommandCreateInput;
  CommandCodeFileIdE6Dc0F85FkCodeFileIdInput: CommandCodeFileIdE6Dc0F85FkCodeFileIdInput;
  CommandCodeFileIdE6Dc0F85FkCodeFileIdInverseInput: CommandCodeFileIdE6Dc0F85FkCodeFileIdInverseInput;
  CommandCommandPkeyConnect: CommandCommandPkeyConnect;
  CommandCommandPkeyDelete: CommandCommandPkeyDelete;
  CommandCommandToolVersionId9DbddabaUniqConnect: CommandCommandToolVersionId9DbddabaUniqConnect;
  CommandCommandToolVersionId9DbddabaUniqDelete: CommandCommandToolVersionId9DbddabaUniqDelete;
  CommandCondition: CommandCondition;
  CommandContainerImageId447E7Cb3FkContainerImageIdCommandCreateInput: CommandContainerImageId447E7Cb3FkContainerImageIdCommandCreateInput;
  CommandContainerImageId447E7Cb3FkContainerImageIdContainerImageCreateInput: CommandContainerImageId447E7Cb3FkContainerImageIdContainerImageCreateInput;
  CommandContainerImageId447E7Cb3FkContainerImageIdInput: CommandContainerImageId447E7Cb3FkContainerImageIdInput;
  CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput: CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput;
  CommandFilter: CommandFilter;
  CommandInput: CommandInput;
  CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCommandPkeyUpdate: CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCommandPkeyUpdate;
  CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCommandToolVersionId9DbddabaUniqUpdate: CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCommandToolVersionId9DbddabaUniqUpdate;
  CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingToolVersionCodeFileUniqueOnCommandUpdate: CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingToolVersionCodeFileUniqueOnCommandUpdate;
  CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingCommandPkeyUpdate: CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingCommandPkeyUpdate;
  CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingCommandToolVersionId9DbddabaUniqUpdate: CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingCommandToolVersionId9DbddabaUniqUpdate;
  CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingToolVersionCodeFileUniqueOnCommandUpdate: CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingToolVersionCodeFileUniqueOnCommandUpdate;
  CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingCommandPkeyUpdate: CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingCommandPkeyUpdate;
  CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingCommandToolVersionId9DbddabaUniqUpdate: CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingCommandToolVersionId9DbddabaUniqUpdate;
  CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingToolVersionCodeFileUniqueOnCommandUpdate: CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingToolVersionCodeFileUniqueOnCommandUpdate;
  CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingCommandPkeyUpdate: CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingCommandPkeyUpdate;
  CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingCommandToolVersionId9DbddabaUniqUpdate: CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingCommandToolVersionId9DbddabaUniqUpdate;
  CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingToolVersionCodeFileUniqueOnCommandUpdate: CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingToolVersionCodeFileUniqueOnCommandUpdate;
  CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingCommandPkeyUpdate: CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingCommandPkeyUpdate;
  CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingCommandToolVersionId9DbddabaUniqUpdate: CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingCommandToolVersionId9DbddabaUniqUpdate;
  CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingToolVersionCodeFileUniqueOnCommandUpdate: CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingToolVersionCodeFileUniqueOnCommandUpdate;
  CommandPatch: CommandPatch;
  CommandTenantId36F95C3CFkTenantIdCommandCreateInput: CommandTenantId36F95C3CFkTenantIdCommandCreateInput;
  CommandTenantId36F95C3CFkTenantIdInput: CommandTenantId36F95C3CFkTenantIdInput;
  CommandTenantId36F95C3CFkTenantIdInverseInput: CommandTenantId36F95C3CFkTenantIdInverseInput;
  CommandTenantId36F95C3CFkTenantIdTenantCreateInput: CommandTenantId36F95C3CFkTenantIdTenantCreateInput;
  CommandToolVersionCodeFileUniqueOnCommandConnect: CommandToolVersionCodeFileUniqueOnCommandConnect;
  CommandToolVersionCodeFileUniqueOnCommandDelete: CommandToolVersionCodeFileUniqueOnCommandDelete;
  CommandToolVersionId9DbddabaFkToolVersionIdCommandCreateInput: CommandToolVersionId9DbddabaFkToolVersionIdCommandCreateInput;
  CommandToolVersionId9DbddabaFkToolVersionIdInput: CommandToolVersionId9DbddabaFkToolVersionIdInput;
  CommandToolVersionId9DbddabaFkToolVersionIdInverseInput: CommandToolVersionId9DbddabaFkToolVersionIdInverseInput;
  CommandToolVersionId9DbddabaFkToolVersionIdToolVersionCreateInput: CommandToolVersionId9DbddabaFkToolVersionIdToolVersionCreateInput;
  CommandUserId4A445414FkApplicationUserIdApplicationUserCreateInput: CommandUserId4A445414FkApplicationUserIdApplicationUserCreateInput;
  CommandUserId4A445414FkApplicationUserIdCommandCreateInput: CommandUserId4A445414FkApplicationUserIdCommandCreateInput;
  CommandUserId4A445414FkApplicationUserIdInput: CommandUserId4A445414FkApplicationUserIdInput;
  CommandUserId4A445414FkApplicationUserIdInverseInput: CommandUserId4A445414FkApplicationUserIdInverseInput;
  CommandsConnection: ResolverTypeWrapper<CommandsConnection>;
  CommandsEdge: ResolverTypeWrapper<CommandsEdge>;
  CommandsOrderBy: CommandsOrderBy;
  ContainerImage: ResolverTypeWrapper<ContainerImage>;
  ContainerImageCondition: ContainerImageCondition;
  ContainerImageContainerImageExecutorIdKeyConnect: ContainerImageContainerImageExecutorIdKeyConnect;
  ContainerImageContainerImageExecutorIdKeyDelete: ContainerImageContainerImageExecutorIdKeyDelete;
  ContainerImageContainerImagePkeyConnect: ContainerImageContainerImagePkeyConnect;
  ContainerImageContainerImagePkeyDelete: ContainerImageContainerImagePkeyDelete;
  ContainerImageContainerImageRepoBe6Ba4A8FkContainerContainerImageCreateInput: ContainerImageContainerImageRepoBe6Ba4A8FkContainerContainerImageCreateInput;
  ContainerImageContainerImageRepoBe6Ba4A8FkContainerContainerImageRepositoryCreateInput: ContainerImageContainerImageRepoBe6Ba4A8FkContainerContainerImageRepositoryCreateInput;
  ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput: ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput;
  ContainerImageContainerImageRepoBe6Ba4A8FkContainerInverseInput: ContainerImageContainerImageRepoBe6Ba4A8FkContainerInverseInput;
  ContainerImageExecutorId68979Fb6FkTesContaContainerImageCreateInput: ContainerImageExecutorId68979Fb6FkTesContaContainerImageCreateInput;
  ContainerImageExecutorId68979Fb6FkTesContaInput: ContainerImageExecutorId68979Fb6FkTesContaInput;
  ContainerImageExecutorId68979Fb6FkTesContaInverseInput: ContainerImageExecutorId68979Fb6FkTesContaInverseInput;
  ContainerImageExecutorId68979Fb6FkTesContaTesContainerimageexecutorCreateInput: ContainerImageExecutorId68979Fb6FkTesContaTesContainerimageexecutorCreateInput;
  ContainerImageFilter: ContainerImageFilter;
  ContainerImageInput: ContainerImageInput;
  ContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate: ContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate;
  ContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingContainerImagePkeyUpdate: ContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingContainerImagePkeyUpdate;
  ContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageExecutorIdKeyUpdate: ContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageExecutorIdKeyUpdate;
  ContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImagePkeyUpdate: ContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImagePkeyUpdate;
  ContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingContainerImageExecutorIdKeyUpdate: ContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingContainerImageExecutorIdKeyUpdate;
  ContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingContainerImagePkeyUpdate: ContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingContainerImagePkeyUpdate;
  ContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingContainerImageExecutorIdKeyUpdate: ContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingContainerImageExecutorIdKeyUpdate;
  ContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingContainerImagePkeyUpdate: ContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingContainerImagePkeyUpdate;
  ContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingContainerImageExecutorIdKeyUpdate: ContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingContainerImageExecutorIdKeyUpdate;
  ContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingContainerImagePkeyUpdate: ContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingContainerImagePkeyUpdate;
  ContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingContainerImageExecutorIdKeyUpdate: ContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingContainerImageExecutorIdKeyUpdate;
  ContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingContainerImagePkeyUpdate: ContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingContainerImagePkeyUpdate;
  ContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate: ContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate;
  ContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingContainerImagePkeyUpdate: ContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingContainerImagePkeyUpdate;
  ContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate: ContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate;
  ContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingContainerImagePkeyUpdate: ContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingContainerImagePkeyUpdate;
  ContainerImagePatch: ContainerImagePatch;
  ContainerImageRepoUserIdAf9751AfFkApplicatiApplicationUserCreateInput: ContainerImageRepoUserIdAf9751AfFkApplicatiApplicationUserCreateInput;
  ContainerImageRepoUserIdAf9751AfFkApplicatiContainerImageRepositoryCreateInput: ContainerImageRepoUserIdAf9751AfFkApplicatiContainerImageRepositoryCreateInput;
  ContainerImageRepoUserIdAf9751AfFkApplicatiInput: ContainerImageRepoUserIdAf9751AfFkApplicatiInput;
  ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput: ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput;
  ContainerImageRepositoriesConnection: ResolverTypeWrapper<ContainerImageRepositoriesConnection>;
  ContainerImageRepositoriesEdge: ResolverTypeWrapper<ContainerImageRepositoriesEdge>;
  ContainerImageRepositoriesOrderBy: ContainerImageRepositoriesOrderBy;
  ContainerImageRepository: ResolverTypeWrapper<ContainerImageRepository>;
  ContainerImageRepositoryCondition: ContainerImageRepositoryCondition;
  ContainerImageRepositoryContainerImageRepositoryNameTenantTypeUniqueConnect: ContainerImageRepositoryContainerImageRepositoryNameTenantTypeUniqueConnect;
  ContainerImageRepositoryContainerImageRepositoryNameTenantTypeUniqueDelete: ContainerImageRepositoryContainerImageRepositoryNameTenantTypeUniqueDelete;
  ContainerImageRepositoryContainerImageRepositoryPkeyConnect: ContainerImageRepositoryContainerImageRepositoryPkeyConnect;
  ContainerImageRepositoryContainerImageRepositoryPkeyDelete: ContainerImageRepositoryContainerImageRepositoryPkeyDelete;
  ContainerImageRepositoryContainerImageRepositoryRepositoryKeyConnect: ContainerImageRepositoryContainerImageRepositoryRepositoryKeyConnect;
  ContainerImageRepositoryContainerImageRepositoryRepositoryKeyDelete: ContainerImageRepositoryContainerImageRepositoryRepositoryKeyDelete;
  ContainerImageRepositoryFilter: ContainerImageRepositoryFilter;
  ContainerImageRepositoryInput: ContainerImageRepositoryInput;
  ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryNameTenantTypeUniqueUpdate: ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryNameTenantTypeUniqueUpdate;
  ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryPkeyUpdate: ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryPkeyUpdate;
  ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryRepositoryKeyUpdate: ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryRepositoryKeyUpdate;
  ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryNameTenantTypeUniqueUpdate: ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryNameTenantTypeUniqueUpdate;
  ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryPkeyUpdate: ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryPkeyUpdate;
  ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryRepositoryKeyUpdate: ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryRepositoryKeyUpdate;
  ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryNameTenantTypeUniqueUpdate: ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryNameTenantTypeUniqueUpdate;
  ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryPkeyUpdate: ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryPkeyUpdate;
  ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryRepositoryKeyUpdate: ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryRepositoryKeyUpdate;
  ContainerImageRepositoryPatch: ContainerImageRepositoryPatch;
  ContainerImageRepositoryTenantId217F4E90FkTenantIdContainerImageRepositoryCreateInput: ContainerImageRepositoryTenantId217F4E90FkTenantIdContainerImageRepositoryCreateInput;
  ContainerImageRepositoryTenantId217F4E90FkTenantIdInput: ContainerImageRepositoryTenantId217F4E90FkTenantIdInput;
  ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput: ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput;
  ContainerImageRepositoryTenantId217F4E90FkTenantIdTenantCreateInput: ContainerImageRepositoryTenantId217F4E90FkTenantIdTenantCreateInput;
  ContainerImageRepositoryToManyContainerImageFilter: ContainerImageRepositoryToManyContainerImageFilter;
  ContainerImageTenantIdD0Beb309FkTenantIdContainerImageCreateInput: ContainerImageTenantIdD0Beb309FkTenantIdContainerImageCreateInput;
  ContainerImageTenantIdD0Beb309FkTenantIdInput: ContainerImageTenantIdD0Beb309FkTenantIdInput;
  ContainerImageTenantIdD0Beb309FkTenantIdInverseInput: ContainerImageTenantIdD0Beb309FkTenantIdInverseInput;
  ContainerImageTenantIdD0Beb309FkTenantIdTenantCreateInput: ContainerImageTenantIdD0Beb309FkTenantIdTenantCreateInput;
  ContainerImageToManyCommandFilter: ContainerImageToManyCommandFilter;
  ContainerImageToManyTaskFilter: ContainerImageToManyTaskFilter;
  ContainerImageToManyToolVersionFilter: ContainerImageToManyToolVersionFilter;
  ContainerImageToManyWorkflowFilter: ContainerImageToManyWorkflowFilter;
  ContainerImageUserId3919E673FkApplicationUserIdApplicationUserCreateInput: ContainerImageUserId3919E673FkApplicationUserIdApplicationUserCreateInput;
  ContainerImageUserId3919E673FkApplicationUserIdContainerImageCreateInput: ContainerImageUserId3919E673FkApplicationUserIdContainerImageCreateInput;
  ContainerImageUserId3919E673FkApplicationUserIdInput: ContainerImageUserId3919E673FkApplicationUserIdInput;
  ContainerImageUserId3919E673FkApplicationUserIdInverseInput: ContainerImageUserId3919E673FkApplicationUserIdInverseInput;
  ContainerImagesConnection: ResolverTypeWrapper<ContainerImagesConnection>;
  ContainerImagesEdge: ResolverTypeWrapper<ContainerImagesEdge>;
  ContainerImagesOrderBy: ContainerImagesOrderBy;
  Cost: ResolverTypeWrapper<Cost>;
  CostCondition: CostCondition;
  CostCostPkeyConnect: CostCostPkeyConnect;
  CostCostPkeyDelete: CostCostPkeyDelete;
  CostFilter: CostFilter;
  CostInput: CostInput;
  CostOnCostForCostTenantId7Dcd58A7FkTenantIdUsingCostPkeyUpdate: CostOnCostForCostTenantId7Dcd58A7FkTenantIdUsingCostPkeyUpdate;
  CostOnFileActivityForFileActivityCostId2A88D90AFkCostIdUsingCostPkeyUpdate: CostOnFileActivityForFileActivityCostId2A88D90AFkCostIdUsingCostPkeyUpdate;
  CostOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingCostPkeyUpdate: CostOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingCostPkeyUpdate;
  CostPatch: CostPatch;
  CostTenantId7Dcd58A7FkTenantIdCostCreateInput: CostTenantId7Dcd58A7FkTenantIdCostCreateInput;
  CostTenantId7Dcd58A7FkTenantIdInput: CostTenantId7Dcd58A7FkTenantIdInput;
  CostTenantId7Dcd58A7FkTenantIdInverseInput: CostTenantId7Dcd58A7FkTenantIdInverseInput;
  CostTenantId7Dcd58A7FkTenantIdTenantCreateInput: CostTenantId7Dcd58A7FkTenantIdTenantCreateInput;
  CostToManyFileActivityFilter: CostToManyFileActivityFilter;
  CostToManyTaskActivityFilter: CostToManyTaskActivityFilter;
  CostsConnection: ResolverTypeWrapper<CostsConnection>;
  CostsEdge: ResolverTypeWrapper<CostsEdge>;
  CostsOrderBy: CostsOrderBy;
  CreateAdminProjectInput: CreateAdminProjectInput;
  CreateAdminProjectPayload: ResolverTypeWrapper<CreateAdminProjectPayload>;
  CreateApplicationUserGroupInput: CreateApplicationUserGroupInput;
  CreateApplicationUserGroupPayload: ResolverTypeWrapper<CreateApplicationUserGroupPayload>;
  CreateApplicationUserInput: CreateApplicationUserInput;
  CreateApplicationUserMembershipInput: CreateApplicationUserMembershipInput;
  CreateApplicationUserMembershipPayload: ResolverTypeWrapper<CreateApplicationUserMembershipPayload>;
  CreateApplicationUserMetadatumInput: CreateApplicationUserMetadatumInput;
  CreateApplicationUserMetadatumPayload: ResolverTypeWrapper<CreateApplicationUserMetadatumPayload>;
  CreateApplicationUserPayload: ResolverTypeWrapper<CreateApplicationUserPayload>;
  CreateApplicationUserSessionInput: CreateApplicationUserSessionInput;
  CreateApplicationUserSessionPayload: ResolverTypeWrapper<CreateApplicationUserSessionPayload>;
  CreateApplicationUserUserPermissionInput: CreateApplicationUserUserPermissionInput;
  CreateApplicationUserUserPermissionPayload: ResolverTypeWrapper<CreateApplicationUserUserPermissionPayload>;
  CreateAuditlogLogentryInput: CreateAuditlogLogentryInput;
  CreateAuditlogLogentryPayload: ResolverTypeWrapper<CreateAuditlogLogentryPayload>;
  CreateAuthGroupInput: CreateAuthGroupInput;
  CreateAuthGroupPayload: ResolverTypeWrapper<CreateAuthGroupPayload>;
  CreateAuthGroupPermissionInput: CreateAuthGroupPermissionInput;
  CreateAuthGroupPermissionPayload: ResolverTypeWrapper<CreateAuthGroupPermissionPayload>;
  CreateAuthPermissionInput: CreateAuthPermissionInput;
  CreateAuthPermissionPayload: ResolverTypeWrapper<CreateAuthPermissionPayload>;
  CreateAvailableNonRestrictedProjectInput: CreateAvailableNonRestrictedProjectInput;
  CreateAvailableNonRestrictedProjectPayload: ResolverTypeWrapper<CreateAvailableNonRestrictedProjectPayload>;
  CreateAvatarInput: CreateAvatarInput;
  CreateAvatarPayload: ResolverTypeWrapper<CreateAvatarPayload>;
  CreateAwsBatchTaskInput: CreateAwsBatchTaskInput;
  CreateAwsBatchTaskPayload: ResolverTypeWrapper<CreateAwsBatchTaskPayload>;
  CreateAwsCognitoUserInput: CreateAwsCognitoUserInput;
  CreateAwsCognitoUserPayload: ResolverTypeWrapper<CreateAwsCognitoUserPayload>;
  CreateAwsEcrImageInput: CreateAwsEcrImageInput;
  CreateAwsEcrImagePayload: ResolverTypeWrapper<CreateAwsEcrImagePayload>;
  CreateAwsMockBatchTaskInput: CreateAwsMockBatchTaskInput;
  CreateAwsMockBatchTaskPayload: ResolverTypeWrapper<CreateAwsMockBatchTaskPayload>;
  CreateAwsMockDistributionImageInput: CreateAwsMockDistributionImageInput;
  CreateAwsMockDistributionImagePayload: ResolverTypeWrapper<CreateAwsMockDistributionImagePayload>;
  CreateAwsMockEcrImageInput: CreateAwsMockEcrImageInput;
  CreateAwsMockEcrImagePayload: ResolverTypeWrapper<CreateAwsMockEcrImagePayload>;
  CreateAwsMockIamUserInput: CreateAwsMockIamUserInput;
  CreateAwsMockIamUserPayload: ResolverTypeWrapper<CreateAwsMockIamUserPayload>;
  CreateAwsMockS3FileInput: CreateAwsMockS3FileInput;
  CreateAwsMockS3FilePayload: ResolverTypeWrapper<CreateAwsMockS3FilePayload>;
  CreateAwsS3FileInput: CreateAwsS3FileInput;
  CreateAwsS3FilePayload: ResolverTypeWrapper<CreateAwsS3FilePayload>;
  CreateCodeFileInput: CreateCodeFileInput;
  CreateCodeFilePayload: ResolverTypeWrapper<CreateCodeFilePayload>;
  CreateCommandInput: CreateCommandInput;
  CreateCommandPayload: ResolverTypeWrapper<CreateCommandPayload>;
  CreateContainerImageInput: CreateContainerImageInput;
  CreateContainerImagePayload: ResolverTypeWrapper<CreateContainerImagePayload>;
  CreateContainerImageRepositoryInput: CreateContainerImageRepositoryInput;
  CreateContainerImageRepositoryPayload: ResolverTypeWrapper<CreateContainerImageRepositoryPayload>;
  CreateCostInput: CreateCostInput;
  CreateCostPayload: ResolverTypeWrapper<CreateCostPayload>;
  CreateCurrentApplicationUserInput: CreateCurrentApplicationUserInput;
  CreateCurrentApplicationUserPayload: ResolverTypeWrapper<CreateCurrentApplicationUserPayload>;
  CreateDistributionRegistryImageInput: CreateDistributionRegistryImageInput;
  CreateDistributionRegistryImagePayload: ResolverTypeWrapper<CreateDistributionRegistryImagePayload>;
  CreateDjangoAdminLogInput: CreateDjangoAdminLogInput;
  CreateDjangoAdminLogPayload: ResolverTypeWrapper<CreateDjangoAdminLogPayload>;
  CreateDjangoContentTypeInput: CreateDjangoContentTypeInput;
  CreateDjangoContentTypePayload: ResolverTypeWrapper<CreateDjangoContentTypePayload>;
  CreateDjangoMigrationInput: CreateDjangoMigrationInput;
  CreateDjangoMigrationPayload: ResolverTypeWrapper<CreateDjangoMigrationPayload>;
  CreateDjangoSesBlacklistedemailInput: CreateDjangoSesBlacklistedemailInput;
  CreateDjangoSesBlacklistedemailPayload: ResolverTypeWrapper<CreateDjangoSesBlacklistedemailPayload>;
  CreateDjangoSesSesstatInput: CreateDjangoSesSesstatInput;
  CreateDjangoSesSesstatPayload: ResolverTypeWrapper<CreateDjangoSesSesstatPayload>;
  CreateDjangoSessionInput: CreateDjangoSessionInput;
  CreateDjangoSessionPayload: ResolverTypeWrapper<CreateDjangoSessionPayload>;
  CreateDrsFileexecutorInput: CreateDrsFileexecutorInput;
  CreateDrsFileexecutorPayload: ResolverTypeWrapper<CreateDrsFileexecutorPayload>;
  CreateDrsMockfileexecutorInput: CreateDrsMockfileexecutorInput;
  CreateDrsMockfileexecutorPayload: ResolverTypeWrapper<CreateDrsMockfileexecutorPayload>;
  CreateEulaVersionInput: CreateEulaVersionInput;
  CreateEulaVersionPayload: ResolverTypeWrapper<CreateEulaVersionPayload>;
  CreateEulaVersionUserAcceptanceInput: CreateEulaVersionUserAcceptanceInput;
  CreateEulaVersionUserAcceptancePayload: ResolverTypeWrapper<CreateEulaVersionUserAcceptancePayload>;
  CreateFeatureFlagInput: CreateFeatureFlagInput;
  CreateFeatureFlagPayload: ResolverTypeWrapper<CreateFeatureFlagPayload>;
  CreateFeatureFlagsGroupInput: CreateFeatureFlagsGroupInput;
  CreateFeatureFlagsGroupPayload: ResolverTypeWrapper<CreateFeatureFlagsGroupPayload>;
  CreateFeatureFlagsTenantInput: CreateFeatureFlagsTenantInput;
  CreateFeatureFlagsTenantPayload: ResolverTypeWrapper<CreateFeatureFlagsTenantPayload>;
  CreateFeatureFlagsUserInput: CreateFeatureFlagsUserInput;
  CreateFeatureFlagsUserPayload: ResolverTypeWrapper<CreateFeatureFlagsUserPayload>;
  CreateFileActivityInput: CreateFileActivityInput;
  CreateFileActivityPayload: ResolverTypeWrapper<CreateFileActivityPayload>;
  CreateFileInput: CreateFileInput;
  CreateFileMetadatumInput: CreateFileMetadatumInput;
  CreateFileMetadatumPayload: ResolverTypeWrapper<CreateFileMetadatumPayload>;
  CreateFileOutputGroupMetadatumInput: CreateFileOutputGroupMetadatumInput;
  CreateFileOutputGroupMetadatumPayload: ResolverTypeWrapper<CreateFileOutputGroupMetadatumPayload>;
  CreateFilePayload: ResolverTypeWrapper<CreateFilePayload>;
  CreateFilesByExecutorInput: CreateFilesByExecutorInput;
  CreateFilesByExecutorPayload: ResolverTypeWrapper<CreateFilesByExecutorPayload>;
  CreateMetadataValueInput: CreateMetadataValueInput;
  CreateMetadataValuePayload: ResolverTypeWrapper<CreateMetadataValuePayload>;
  CreateMetadatumInput: CreateMetadatumInput;
  CreateMetadatumPayload: ResolverTypeWrapper<CreateMetadatumPayload>;
  CreateOutputGroupFileInput: CreateOutputGroupFileInput;
  CreateOutputGroupFilePayload: ResolverTypeWrapper<CreateOutputGroupFilePayload>;
  CreatePinnedToolInput: CreatePinnedToolInput;
  CreatePinnedToolPayload: ResolverTypeWrapper<CreatePinnedToolPayload>;
  CreateProjectFolderInput: CreateProjectFolderInput;
  CreateProjectFolderPayload: ResolverTypeWrapper<CreateProjectFolderPayload>;
  CreateProjectTagInput: CreateProjectTagInput;
  CreateProjectTagPayload: ResolverTypeWrapper<CreateProjectTagPayload>;
  CreateRoleInput: CreateRoleInput;
  CreateRolePayload: ResolverTypeWrapper<CreateRolePayload>;
  CreateRunInput: CreateRunInput;
  CreateRunPayload: ResolverTypeWrapper<CreateRunPayload>;
  CreateSessionInput: CreateSessionInput;
  CreateSessionPayload: ResolverTypeWrapper<CreateSessionPayload>;
  CreateTaskActivityInput: CreateTaskActivityInput;
  CreateTaskActivityPayload: ResolverTypeWrapper<CreateTaskActivityPayload>;
  CreateTaskInput: CreateTaskInput;
  CreateTaskPayload: ResolverTypeWrapper<CreateTaskPayload>;
  CreateTaskResourceInput: CreateTaskResourceInput;
  CreateTaskResourcePayload: ResolverTypeWrapper<CreateTaskResourcePayload>;
  CreateTaskResourceUsageInput: CreateTaskResourceUsageInput;
  CreateTaskResourceUsagePayload: ResolverTypeWrapper<CreateTaskResourceUsagePayload>;
  CreateTaskSourceInput: CreateTaskSourceInput;
  CreateTaskSourcePayload: ResolverTypeWrapper<CreateTaskSourcePayload>;
  CreateTaskStatusLogInput: CreateTaskStatusLogInput;
  CreateTaskStatusLogPayload: ResolverTypeWrapper<CreateTaskStatusLogPayload>;
  CreateTenantContractAllowanceInput: CreateTenantContractAllowanceInput;
  CreateTenantContractAllowancePayload: ResolverTypeWrapper<CreateTenantContractAllowancePayload>;
  CreateTenantContractInput: CreateTenantContractInput;
  CreateTenantContractPayload: ResolverTypeWrapper<CreateTenantContractPayload>;
  CreateTenantContractTransactionInput: CreateTenantContractTransactionInput;
  CreateTenantContractTransactionPayload: ResolverTypeWrapper<CreateTenantContractTransactionPayload>;
  CreateTenantInput: CreateTenantInput;
  CreateTenantMockuserexecutorInput: CreateTenantMockuserexecutorInput;
  CreateTenantMockuserexecutorPayload: ResolverTypeWrapper<CreateTenantMockuserexecutorPayload>;
  CreateTenantMonthlyConsumedResourceInput: CreateTenantMonthlyConsumedResourceInput;
  CreateTenantMonthlyConsumedResourcePayload: ResolverTypeWrapper<CreateTenantMonthlyConsumedResourcePayload>;
  CreateTenantPayload: ResolverTypeWrapper<CreateTenantPayload>;
  CreateTenantUserexecutorInput: CreateTenantUserexecutorInput;
  CreateTenantUserexecutorPayload: ResolverTypeWrapper<CreateTenantUserexecutorPayload>;
  CreateTesContainerimageexecutorInput: CreateTesContainerimageexecutorInput;
  CreateTesContainerimageexecutorPayload: ResolverTypeWrapper<CreateTesContainerimageexecutorPayload>;
  CreateTesMockcontainerimageexecutorInput: CreateTesMockcontainerimageexecutorInput;
  CreateTesMockcontainerimageexecutorPayload: ResolverTypeWrapper<CreateTesMockcontainerimageexecutorPayload>;
  CreateTesMocktaskexecutorInput: CreateTesMocktaskexecutorInput;
  CreateTesMocktaskexecutorPayload: ResolverTypeWrapper<CreateTesMocktaskexecutorPayload>;
  CreateTesTaskexecutorInput: CreateTesTaskexecutorInput;
  CreateTesTaskexecutorPayload: ResolverTypeWrapper<CreateTesTaskexecutorPayload>;
  CreateToolInput: CreateToolInput;
  CreateToolParameterInput: CreateToolParameterInput;
  CreateToolParameterPayload: ResolverTypeWrapper<CreateToolParameterPayload>;
  CreateToolPayload: ResolverTypeWrapper<CreateToolPayload>;
  CreateToolResourceInput: CreateToolResourceInput;
  CreateToolResourcePayload: ResolverTypeWrapper<CreateToolResourcePayload>;
  CreateToolResultInput: CreateToolResultInput;
  CreateToolResultPayload: ResolverTypeWrapper<CreateToolResultPayload>;
  CreateToolSecretInput: CreateToolSecretInput;
  CreateToolSecretPayload: ResolverTypeWrapper<CreateToolSecretPayload>;
  CreateToolSourceInput: CreateToolSourceInput;
  CreateToolSourcePayload: ResolverTypeWrapper<CreateToolSourcePayload>;
  CreateToolTenantInput: CreateToolTenantInput;
  CreateToolTenantPayload: ResolverTypeWrapper<CreateToolTenantPayload>;
  CreateToolVersionInput: CreateToolVersionInput;
  CreateToolVersionPayload: ResolverTypeWrapper<CreateToolVersionPayload>;
  CreateToolboxInput: CreateToolboxInput;
  CreateToolboxPayload: ResolverTypeWrapper<CreateToolboxPayload>;
  CreateToolboxTenantInput: CreateToolboxTenantInput;
  CreateToolboxTenantPayload: ResolverTypeWrapper<CreateToolboxTenantPayload>;
  CreateUserPersonalSpaceRequestInput: CreateUserPersonalSpaceRequestInput;
  CreateUserPersonalSpaceRequestPayload: ResolverTypeWrapper<CreateUserPersonalSpaceRequestPayload>;
  CreateWaffleFlagInput: CreateWaffleFlagInput;
  CreateWaffleFlagPayload: ResolverTypeWrapper<CreateWaffleFlagPayload>;
  CreateWaffleSampleInput: CreateWaffleSampleInput;
  CreateWaffleSamplePayload: ResolverTypeWrapper<CreateWaffleSamplePayload>;
  CreateWaffleSwitchInput: CreateWaffleSwitchInput;
  CreateWaffleSwitchPayload: ResolverTypeWrapper<CreateWaffleSwitchPayload>;
  CreateWorkflowDatumInput: CreateWorkflowDatumInput;
  CreateWorkflowDatumPayload: ResolverTypeWrapper<CreateWorkflowDatumPayload>;
  CreateWorkflowInput: CreateWorkflowInput;
  CreateWorkflowPayload: ResolverTypeWrapper<CreateWorkflowPayload>;
  CreateWorkflowResultInput: CreateWorkflowResultInput;
  CreateWorkflowResultPayload: ResolverTypeWrapper<CreateWorkflowResultPayload>;
  CreateWorkflowResultWorkflowVersionInput: CreateWorkflowResultWorkflowVersionInput;
  CreateWorkflowResultWorkflowVersionPayload: ResolverTypeWrapper<CreateWorkflowResultWorkflowVersionPayload>;
  CreateWorkflowSectionBlockInput: CreateWorkflowSectionBlockInput;
  CreateWorkflowSectionBlockPayload: ResolverTypeWrapper<CreateWorkflowSectionBlockPayload>;
  CreateWorkflowSectionBlockSectionInput: CreateWorkflowSectionBlockSectionInput;
  CreateWorkflowSectionBlockSectionPayload: ResolverTypeWrapper<CreateWorkflowSectionBlockSectionPayload>;
  CreateWorkflowSectionInput: CreateWorkflowSectionInput;
  CreateWorkflowSectionPayload: ResolverTypeWrapper<CreateWorkflowSectionPayload>;
  CreateWorkflowSectionWorkflowVersionInput: CreateWorkflowSectionWorkflowVersionInput;
  CreateWorkflowSectionWorkflowVersionPayload: ResolverTypeWrapper<CreateWorkflowSectionWorkflowVersionPayload>;
  CreateWorkflowSourceInput: CreateWorkflowSourceInput;
  CreateWorkflowSourcePayload: ResolverTypeWrapper<CreateWorkflowSourcePayload>;
  CreateWorkflowSourceWorkflowVersionInput: CreateWorkflowSourceWorkflowVersionInput;
  CreateWorkflowSourceWorkflowVersionPayload: ResolverTypeWrapper<CreateWorkflowSourceWorkflowVersionPayload>;
  CreateWorkflowVersionInput: CreateWorkflowVersionInput;
  CreateWorkflowVersionPayload: ResolverTypeWrapper<CreateWorkflowVersionPayload>;
  CurrentApplicationUser: ResolverTypeWrapper<CurrentApplicationUser>;
  CurrentApplicationUserCondition: CurrentApplicationUserCondition;
  CurrentApplicationUserFilter: CurrentApplicationUserFilter;
  CurrentApplicationUserInput: CurrentApplicationUserInput;
  CurrentApplicationUsersConnection: ResolverTypeWrapper<CurrentApplicationUsersConnection>;
  CurrentApplicationUsersEdge: ResolverTypeWrapper<CurrentApplicationUsersEdge>;
  CurrentApplicationUsersOrderBy: CurrentApplicationUsersOrderBy;
  CurrentUserMembership: ResolverTypeWrapper<CurrentUserMembership>;
  CurrentUserMembershipCondition: CurrentUserMembershipCondition;
  CurrentUserMembershipFilter: CurrentUserMembershipFilter;
  CurrentUserMembershipsConnection: ResolverTypeWrapper<CurrentUserMembershipsConnection>;
  CurrentUserMembershipsEdge: ResolverTypeWrapper<CurrentUserMembershipsEdge>;
  CurrentUserMembershipsOrderBy: CurrentUserMembershipsOrderBy;
  Cursor: ResolverTypeWrapper<Scalars["Cursor"]["output"]>;
  DataTable: ResolverTypeWrapper<DataTable>;
  DataTableCell: ResolverTypeWrapper<DataTableCell>;
  DataTableCellColumnId9A5117BdFkDataTableColumnIdInput: DataTableCellColumnId9A5117BdFkDataTableColumnIdInput;
  DataTableCellColumnId9A5117BdFkDataTableColumnIdInverseInput: DataTableCellColumnId9A5117BdFkDataTableColumnIdInverseInput;
  DataTableCellCondition: DataTableCellCondition;
  DataTableCellDataTableCellPkeyConnect: DataTableCellDataTableCellPkeyConnect;
  DataTableCellDataTableCellUniqueConnect: DataTableCellDataTableCellUniqueConnect;
  DataTableCellFilter: DataTableCellFilter;
  DataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableCellPkeyUpdate: DataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableCellPkeyUpdate;
  DataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableCellUniqueUpdate: DataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableCellUniqueUpdate;
  DataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingDataTableCellPkeyUpdate: DataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingDataTableCellPkeyUpdate;
  DataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingDataTableCellUniqueUpdate: DataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingDataTableCellUniqueUpdate;
  DataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableCellPkeyUpdate: DataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableCellPkeyUpdate;
  DataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableCellUniqueUpdate: DataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableCellUniqueUpdate;
  DataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTableCellPkeyUpdate: DataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTableCellPkeyUpdate;
  DataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTableCellUniqueUpdate: DataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTableCellUniqueUpdate;
  DataTableCellProjectIdEf5721A0FkProjectIdInput: DataTableCellProjectIdEf5721A0FkProjectIdInput;
  DataTableCellProjectIdEf5721A0FkProjectIdInverseInput: DataTableCellProjectIdEf5721A0FkProjectIdInverseInput;
  DataTableCellRowId3A3C7567FkDataTableRowIdInput: DataTableCellRowId3A3C7567FkDataTableRowIdInput;
  DataTableCellRowId3A3C7567FkDataTableRowIdInverseInput: DataTableCellRowId3A3C7567FkDataTableRowIdInverseInput;
  DataTableCellTableId12E87426FkDataTableIdInput: DataTableCellTableId12E87426FkDataTableIdInput;
  DataTableCellTableId12E87426FkDataTableIdInverseInput: DataTableCellTableId12E87426FkDataTableIdInverseInput;
  DataTableCellsConnection: ResolverTypeWrapper<DataTableCellsConnection>;
  DataTableCellsEdge: ResolverTypeWrapper<DataTableCellsEdge>;
  DataTableCellsOrderBy: DataTableCellsOrderBy;
  DataTableColumn: ResolverTypeWrapper<DataTableColumn>;
  DataTableColumnCondition: DataTableColumnCondition;
  DataTableColumnDataTableColumnOrderUniqueConnect: DataTableColumnDataTableColumnOrderUniqueConnect;
  DataTableColumnDataTableColumnPkeyConnect: DataTableColumnDataTableColumnPkeyConnect;
  DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInput: DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInput;
  DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput: DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput;
  DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInput: DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInput;
  DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput: DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput;
  DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInput: DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInput;
  DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput: DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput;
  DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInput: DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInput;
  DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput: DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput;
  DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInput: DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInput;
  DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput: DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput;
  DataTableColumnDeProjectId3A701Ad3FkProjectIInput: DataTableColumnDeProjectId3A701Ad3FkProjectIInput;
  DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput: DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput;
  DataTableColumnDeProjectId8E855Eb8FkProjectIInput: DataTableColumnDeProjectId8E855Eb8FkProjectIInput;
  DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput: DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput;
  DataTableColumnDeProjectId29F0D38FFkProjectIInput: DataTableColumnDeProjectId29F0D38FFkProjectIInput;
  DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput: DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput;
  DataTableColumnDeProjectId433Daf03FkProjectIInput: DataTableColumnDeProjectId433Daf03FkProjectIInput;
  DataTableColumnDeProjectId433Daf03FkProjectIInverseInput: DataTableColumnDeProjectId433Daf03FkProjectIInverseInput;
  DataTableColumnDeProjectId2487E0EbFkProjectIInput: DataTableColumnDeProjectId2487E0EbFkProjectIInput;
  DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput: DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput;
  DataTableColumnDeProjectId7732E962FkProjectIInput: DataTableColumnDeProjectId7732E962FkProjectIInput;
  DataTableColumnDeProjectId7732E962FkProjectIInverseInput: DataTableColumnDeProjectId7732E962FkProjectIInverseInput;
  DataTableColumnDeProjectId869397AfFkProjectIInput: DataTableColumnDeProjectId869397AfFkProjectIInput;
  DataTableColumnDeProjectId869397AfFkProjectIInverseInput: DataTableColumnDeProjectId869397AfFkProjectIInverseInput;
  DataTableColumnDeProjectId33688488FkProjectIInput: DataTableColumnDeProjectId33688488FkProjectIInput;
  DataTableColumnDeProjectId33688488FkProjectIInverseInput: DataTableColumnDeProjectId33688488FkProjectIInverseInput;
  DataTableColumnDeProjectIdBc4Cdb01FkProjectIInput: DataTableColumnDeProjectIdBc4Cdb01FkProjectIInput;
  DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput: DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput;
  DataTableColumnDeProjectIdC5C8B765FkProjectIInput: DataTableColumnDeProjectIdC5C8B765FkProjectIInput;
  DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput: DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput;
  DataTableColumnDeProjectIdC7B1D7FbFkProjectIInput: DataTableColumnDeProjectIdC7B1D7FbFkProjectIInput;
  DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput: DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput;
  DataTableColumnDeProjectIdE2A11292FkProjectIInput: DataTableColumnDeProjectIdE2A11292FkProjectIInput;
  DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput: DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput;
  DataTableColumnDeQcReportFileColum864C112DFkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeQcReportFileColum864C112DFkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInput: DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInput;
  DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput: DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput;
  DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInput: DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInput;
  DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput: DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput;
  DataTableColumnDeSourceColumnTypeIE4E5D06AFkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeSourceColumnTypeIE4E5D06AFkDjangoCoInput: DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInput;
  DataTableColumnDeSourceColumnTypeIE4E5D06AFkDjangoCoInverseInput: DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput;
  DataTableColumnDeTableTypeId6A986C02FkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeTableTypeId6A986C02FkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeTableTypeId6A986C02FkDjangoCoInput: DataTableColumnDeTableTypeId6A986C02FkDjangoCoInput;
  DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput: DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput;
  DataTableColumnDefinitionBoolean: ResolverTypeWrapper<DataTableColumnDefinitionBoolean>;
  DataTableColumnDefinitionBooleanCondition: DataTableColumnDefinitionBooleanCondition;
  DataTableColumnDefinitionBooleanDataTableColumnDefinitionBooleanPkeyConnect: DataTableColumnDefinitionBooleanDataTableColumnDefinitionBooleanPkeyConnect;
  DataTableColumnDefinitionBooleanFilter: DataTableColumnDefinitionBooleanFilter;
  DataTableColumnDefinitionBooleanOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingDataTableColumnDefinitionBooleanPkeyUpdate: DataTableColumnDefinitionBooleanOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingDataTableColumnDefinitionBooleanPkeyUpdate;
  DataTableColumnDefinitionBooleansConnection: ResolverTypeWrapper<DataTableColumnDefinitionBooleansConnection>;
  DataTableColumnDefinitionBooleansEdge: ResolverTypeWrapper<DataTableColumnDefinitionBooleansEdge>;
  DataTableColumnDefinitionBooleansOrderBy: DataTableColumnDefinitionBooleansOrderBy;
  DataTableColumnDefinitionCellStatus: ResolverTypeWrapper<DataTableColumnDefinitionCellStatus>;
  DataTableColumnDefinitionCellStatusCondition: DataTableColumnDefinitionCellStatusCondition;
  DataTableColumnDefinitionCellStatusDataTableColumnDefinitionCellStatusPkeyConnect: DataTableColumnDefinitionCellStatusDataTableColumnDefinitionCellStatusPkeyConnect;
  DataTableColumnDefinitionCellStatusFilter: DataTableColumnDefinitionCellStatusFilter;
  DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate: DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate;
  DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate: DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate;
  DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingDataTableColumnDefinitionCellStatusPkeyUpdate: DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingDataTableColumnDefinitionCellStatusPkeyUpdate;
  DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate: DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate;
  DataTableColumnDefinitionCellStatusesConnection: ResolverTypeWrapper<DataTableColumnDefinitionCellStatusesConnection>;
  DataTableColumnDefinitionCellStatusesEdge: ResolverTypeWrapper<DataTableColumnDefinitionCellStatusesEdge>;
  DataTableColumnDefinitionCellStatusesOrderBy: DataTableColumnDefinitionCellStatusesOrderBy;
  DataTableColumnDefinitionChoice: ResolverTypeWrapper<DataTableColumnDefinitionChoice>;
  DataTableColumnDefinitionChoiceCondition: DataTableColumnDefinitionChoiceCondition;
  DataTableColumnDefinitionChoiceDataTableColumnDefinitionChoicePkeyConnect: DataTableColumnDefinitionChoiceDataTableColumnDefinitionChoicePkeyConnect;
  DataTableColumnDefinitionChoiceFilter: DataTableColumnDefinitionChoiceFilter;
  DataTableColumnDefinitionChoiceOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingDataTableColumnDefinitionChoicePkeyUpdate: DataTableColumnDefinitionChoiceOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingDataTableColumnDefinitionChoicePkeyUpdate;
  DataTableColumnDefinitionChoicesConnection: ResolverTypeWrapper<DataTableColumnDefinitionChoicesConnection>;
  DataTableColumnDefinitionChoicesEdge: ResolverTypeWrapper<DataTableColumnDefinitionChoicesEdge>;
  DataTableColumnDefinitionChoicesOrderBy: DataTableColumnDefinitionChoicesOrderBy;
  DataTableColumnDefinitionDate: ResolverTypeWrapper<DataTableColumnDefinitionDate>;
  DataTableColumnDefinitionDateCondition: DataTableColumnDefinitionDateCondition;
  DataTableColumnDefinitionDateDataTableColumnDefinitionDatePkeyConnect: DataTableColumnDefinitionDateDataTableColumnDefinitionDatePkeyConnect;
  DataTableColumnDefinitionDateFilter: DataTableColumnDefinitionDateFilter;
  DataTableColumnDefinitionDateOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingDataTableColumnDefinitionDatePkeyUpdate: DataTableColumnDefinitionDateOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingDataTableColumnDefinitionDatePkeyUpdate;
  DataTableColumnDefinitionDatesConnection: ResolverTypeWrapper<DataTableColumnDefinitionDatesConnection>;
  DataTableColumnDefinitionDatesEdge: ResolverTypeWrapper<DataTableColumnDefinitionDatesEdge>;
  DataTableColumnDefinitionDatesOrderBy: DataTableColumnDefinitionDatesOrderBy;
  DataTableColumnDefinitionFile: ResolverTypeWrapper<DataTableColumnDefinitionFile>;
  DataTableColumnDefinitionFileCondition: DataTableColumnDefinitionFileCondition;
  DataTableColumnDefinitionFileDataTableColumnDefinitionFilePkeyConnect: DataTableColumnDefinitionFileDataTableColumnDefinitionFilePkeyConnect;
  DataTableColumnDefinitionFileFilter: DataTableColumnDefinitionFileFilter;
  DataTableColumnDefinitionFileOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingDataTableColumnDefinitionFilePkeyUpdate: DataTableColumnDefinitionFileOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingDataTableColumnDefinitionFilePkeyUpdate;
  DataTableColumnDefinitionFilesConnection: ResolverTypeWrapper<DataTableColumnDefinitionFilesConnection>;
  DataTableColumnDefinitionFilesEdge: ResolverTypeWrapper<DataTableColumnDefinitionFilesEdge>;
  DataTableColumnDefinitionFilesOrderBy: DataTableColumnDefinitionFilesOrderBy;
  DataTableColumnDefinitionFloat: ResolverTypeWrapper<DataTableColumnDefinitionFloat>;
  DataTableColumnDefinitionFloatCondition: DataTableColumnDefinitionFloatCondition;
  DataTableColumnDefinitionFloatDataTableColumnDefinitionFloatPkeyConnect: DataTableColumnDefinitionFloatDataTableColumnDefinitionFloatPkeyConnect;
  DataTableColumnDefinitionFloatFilter: DataTableColumnDefinitionFloatFilter;
  DataTableColumnDefinitionFloatOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingDataTableColumnDefinitionFloatPkeyUpdate: DataTableColumnDefinitionFloatOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingDataTableColumnDefinitionFloatPkeyUpdate;
  DataTableColumnDefinitionFloatsConnection: ResolverTypeWrapper<DataTableColumnDefinitionFloatsConnection>;
  DataTableColumnDefinitionFloatsEdge: ResolverTypeWrapper<DataTableColumnDefinitionFloatsEdge>;
  DataTableColumnDefinitionFloatsOrderBy: DataTableColumnDefinitionFloatsOrderBy;
  DataTableColumnDefinitionIdentifier: ResolverTypeWrapper<DataTableColumnDefinitionIdentifier>;
  DataTableColumnDefinitionIdentifierCondition: DataTableColumnDefinitionIdentifierCondition;
  DataTableColumnDefinitionIdentifierDataTableColumnDefinitionIdentifierPkeyConnect: DataTableColumnDefinitionIdentifierDataTableColumnDefinitionIdentifierPkeyConnect;
  DataTableColumnDefinitionIdentifierFilter: DataTableColumnDefinitionIdentifierFilter;
  DataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingDataTableColumnDefinitionIdentifierPkeyUpdate: DataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingDataTableColumnDefinitionIdentifierPkeyUpdate;
  DataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDataTableColumnDefinitionIdentifierPkeyUpdate: DataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDataTableColumnDefinitionIdentifierPkeyUpdate;
  DataTableColumnDefinitionIdentifiersConnection: ResolverTypeWrapper<DataTableColumnDefinitionIdentifiersConnection>;
  DataTableColumnDefinitionIdentifiersEdge: ResolverTypeWrapper<DataTableColumnDefinitionIdentifiersEdge>;
  DataTableColumnDefinitionIdentifiersOrderBy: DataTableColumnDefinitionIdentifiersOrderBy;
  DataTableColumnDefinitionInteger: ResolverTypeWrapper<DataTableColumnDefinitionInteger>;
  DataTableColumnDefinitionIntegerCondition: DataTableColumnDefinitionIntegerCondition;
  DataTableColumnDefinitionIntegerDataTableColumnDefinitionIntegerPkeyConnect: DataTableColumnDefinitionIntegerDataTableColumnDefinitionIntegerPkeyConnect;
  DataTableColumnDefinitionIntegerFilter: DataTableColumnDefinitionIntegerFilter;
  DataTableColumnDefinitionIntegerOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingDataTableColumnDefinitionIntegerPkeyUpdate: DataTableColumnDefinitionIntegerOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingDataTableColumnDefinitionIntegerPkeyUpdate;
  DataTableColumnDefinitionIntegersConnection: ResolverTypeWrapper<DataTableColumnDefinitionIntegersConnection>;
  DataTableColumnDefinitionIntegersEdge: ResolverTypeWrapper<DataTableColumnDefinitionIntegersEdge>;
  DataTableColumnDefinitionIntegersOrderBy: DataTableColumnDefinitionIntegersOrderBy;
  DataTableColumnDefinitionJoin: ResolverTypeWrapper<DataTableColumnDefinitionJoin>;
  DataTableColumnDefinitionJoinCondition: DataTableColumnDefinitionJoinCondition;
  DataTableColumnDefinitionJoinDataTableColumnDefinitionJoinPkeyConnect: DataTableColumnDefinitionJoinDataTableColumnDefinitionJoinPkeyConnect;
  DataTableColumnDefinitionJoinFilter: DataTableColumnDefinitionJoinFilter;
  DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate: DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate;
  DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingDataTableColumnDefinitionJoinPkeyUpdate: DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingDataTableColumnDefinitionJoinPkeyUpdate;
  DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate: DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate;
  DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIE4E5D06AFkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate: DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate;
  DataTableColumnDefinitionJoinsConnection: ResolverTypeWrapper<DataTableColumnDefinitionJoinsConnection>;
  DataTableColumnDefinitionJoinsEdge: ResolverTypeWrapper<DataTableColumnDefinitionJoinsEdge>;
  DataTableColumnDefinitionJoinsOrderBy: DataTableColumnDefinitionJoinsOrderBy;
  DataTableColumnDefinitionMetadataConnection: ResolverTypeWrapper<DataTableColumnDefinitionMetadataConnection>;
  DataTableColumnDefinitionMetadataEdge: ResolverTypeWrapper<DataTableColumnDefinitionMetadataEdge>;
  DataTableColumnDefinitionMetadataOrderBy: DataTableColumnDefinitionMetadataOrderBy;
  DataTableColumnDefinitionMetadatum: ResolverTypeWrapper<DataTableColumnDefinitionMetadatum>;
  DataTableColumnDefinitionMetadatumCondition: DataTableColumnDefinitionMetadatumCondition;
  DataTableColumnDefinitionMetadatumDataTableColumnDefinitionMetadatumPkeyConnect: DataTableColumnDefinitionMetadatumDataTableColumnDefinitionMetadatumPkeyConnect;
  DataTableColumnDefinitionMetadatumFilter: DataTableColumnDefinitionMetadatumFilter;
  DataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDataTableColumnDefinitionMetadatumPkeyUpdate: DataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDataTableColumnDefinitionMetadatumPkeyUpdate;
  DataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingDataTableColumnDefinitionMetadatumPkeyUpdate: DataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingDataTableColumnDefinitionMetadatumPkeyUpdate;
  DataTableColumnDefinitionRoiFrame: ResolverTypeWrapper<DataTableColumnDefinitionRoiFrame>;
  DataTableColumnDefinitionRoiFrameCondition: DataTableColumnDefinitionRoiFrameCondition;
  DataTableColumnDefinitionRoiFrameDataTableColumnDefinitionRoiFramePkeyConnect: DataTableColumnDefinitionRoiFrameDataTableColumnDefinitionRoiFramePkeyConnect;
  DataTableColumnDefinitionRoiFrameFilter: DataTableColumnDefinitionRoiFrameFilter;
  DataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDataTableColumnDefinitionRoiFramePkeyUpdate: DataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDataTableColumnDefinitionRoiFramePkeyUpdate;
  DataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingDataTableColumnDefinitionRoiFramePkeyUpdate: DataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingDataTableColumnDefinitionRoiFramePkeyUpdate;
  DataTableColumnDefinitionRoiFramesConnection: ResolverTypeWrapper<DataTableColumnDefinitionRoiFramesConnection>;
  DataTableColumnDefinitionRoiFramesEdge: ResolverTypeWrapper<DataTableColumnDefinitionRoiFramesEdge>;
  DataTableColumnDefinitionRoiFramesOrderBy: DataTableColumnDefinitionRoiFramesOrderBy;
  DataTableColumnDefinitionText: ResolverTypeWrapper<DataTableColumnDefinitionText>;
  DataTableColumnDefinitionTextCondition: DataTableColumnDefinitionTextCondition;
  DataTableColumnDefinitionTextDataTableColumnDefinitionTextPkeyConnect: DataTableColumnDefinitionTextDataTableColumnDefinitionTextPkeyConnect;
  DataTableColumnDefinitionTextFilter: DataTableColumnDefinitionTextFilter;
  DataTableColumnDefinitionTextOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingDataTableColumnDefinitionTextPkeyUpdate: DataTableColumnDefinitionTextOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingDataTableColumnDefinitionTextPkeyUpdate;
  DataTableColumnDefinitionTextsConnection: ResolverTypeWrapper<DataTableColumnDefinitionTextsConnection>;
  DataTableColumnDefinitionTextsEdge: ResolverTypeWrapper<DataTableColumnDefinitionTextsEdge>;
  DataTableColumnDefinitionTextsOrderBy: DataTableColumnDefinitionTextsOrderBy;
  DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInput: DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInput;
  DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput: DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput;
  DataTableColumnFilter: DataTableColumnFilter;
  DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoDjangoContentTypeCreateInput: DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInput: DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInput;
  DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput: DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput;
  DataTableColumnGrProjectId2Af8Cd7EFkProjectIInput: DataTableColumnGrProjectId2Af8Cd7EFkProjectIInput;
  DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput: DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput;
  DataTableColumnGrProjectId7376573CFkProjectIInput: DataTableColumnGrProjectId7376573CFkProjectIInput;
  DataTableColumnGrProjectId7376573CFkProjectIInverseInput: DataTableColumnGrProjectId7376573CFkProjectIInverseInput;
  DataTableColumnGrTableTypeId70D51D68FkDjangoCoDjangoContentTypeCreateInput: DataTableColumnGrTableTypeId70D51D68FkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnGrTableTypeId70D51D68FkDjangoCoInput: DataTableColumnGrTableTypeId70D51D68FkDjangoCoInput;
  DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput: DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput;
  DataTableColumnGroup: ResolverTypeWrapper<DataTableColumnGroup>;
  DataTableColumnGroupCondition: DataTableColumnGroupCondition;
  DataTableColumnGroupDataTableColumnGroupPkeyConnect: DataTableColumnGroupDataTableColumnGroupPkeyConnect;
  DataTableColumnGroupDefinitionJoin: ResolverTypeWrapper<DataTableColumnGroupDefinitionJoin>;
  DataTableColumnGroupDefinitionJoinCondition: DataTableColumnGroupDefinitionJoinCondition;
  DataTableColumnGroupDefinitionJoinDataTableColumnGroupDefinitionJoinPkeyConnect: DataTableColumnGroupDefinitionJoinDataTableColumnGroupDefinitionJoinPkeyConnect;
  DataTableColumnGroupDefinitionJoinFilter: DataTableColumnGroupDefinitionJoinFilter;
  DataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingDataTableColumnGroupDefinitionJoinPkeyUpdate: DataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingDataTableColumnGroupDefinitionJoinPkeyUpdate;
  DataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDataTableColumnGroupDefinitionJoinPkeyUpdate: DataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDataTableColumnGroupDefinitionJoinPkeyUpdate;
  DataTableColumnGroupDefinitionJoinsConnection: ResolverTypeWrapper<DataTableColumnGroupDefinitionJoinsConnection>;
  DataTableColumnGroupDefinitionJoinsEdge: ResolverTypeWrapper<DataTableColumnGroupDefinitionJoinsEdge>;
  DataTableColumnGroupDefinitionJoinsOrderBy: DataTableColumnGroupDefinitionJoinsOrderBy;
  DataTableColumnGroupDefinitionSource: ResolverTypeWrapper<DataTableColumnGroupDefinitionSource>;
  DataTableColumnGroupDefinitionSourceCondition: DataTableColumnGroupDefinitionSourceCondition;
  DataTableColumnGroupDefinitionSourceDataTableColumnGroupDefinitionSourcesPkeyConnect: DataTableColumnGroupDefinitionSourceDataTableColumnGroupDefinitionSourcesPkeyConnect;
  DataTableColumnGroupDefinitionSourceFilter: DataTableColumnGroupDefinitionSourceFilter;
  DataTableColumnGroupDefinitionSourceOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingDataTableColumnGroupDefinitionSourcesPkeyUpdate: DataTableColumnGroupDefinitionSourceOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingDataTableColumnGroupDefinitionSourcesPkeyUpdate;
  DataTableColumnGroupDefinitionSourcesConnection: ResolverTypeWrapper<DataTableColumnGroupDefinitionSourcesConnection>;
  DataTableColumnGroupDefinitionSourcesEdge: ResolverTypeWrapper<DataTableColumnGroupDefinitionSourcesEdge>;
  DataTableColumnGroupDefinitionSourcesOrderBy: DataTableColumnGroupDefinitionSourcesOrderBy;
  DataTableColumnGroupFilter: DataTableColumnGroupFilter;
  DataTableColumnGroupIdAbcd4Ec0FkDataTablInput: DataTableColumnGroupIdAbcd4Ec0FkDataTablInput;
  DataTableColumnGroupIdAbcd4Ec0FkDataTablInverseInput: DataTableColumnGroupIdAbcd4Ec0FkDataTablInverseInput;
  DataTableColumnGroupOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnGroupPkeyUpdate: DataTableColumnGroupOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnGroupPkeyUpdate;
  DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDataTableColumnGroupPkeyUpdate: DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDataTableColumnGroupPkeyUpdate;
  DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingDataTableColumnGroupPkeyUpdate: DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingDataTableColumnGroupPkeyUpdate;
  DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdUsingDataTableColumnGroupPkeyUpdate: DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdUsingDataTableColumnGroupPkeyUpdate;
  DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingDataTableColumnGroupPkeyUpdate: DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingDataTableColumnGroupPkeyUpdate;
  DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInput: DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInput;
  DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput: DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput;
  DataTableColumnGroupTableId46C58CccFkDataTableIdInput: DataTableColumnGroupTableId46C58CccFkDataTableIdInput;
  DataTableColumnGroupTableId46C58CccFkDataTableIdInverseInput: DataTableColumnGroupTableId46C58CccFkDataTableIdInverseInput;
  DataTableColumnGroupToManyDataTableColumnFilter: DataTableColumnGroupToManyDataTableColumnFilter;
  DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdApplicationUserCreateInput: DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdApplicationUserCreateInput;
  DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInput: DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInput;
  DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput: DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput;
  DataTableColumnGroupsConnection: ResolverTypeWrapper<DataTableColumnGroupsConnection>;
  DataTableColumnGroupsEdge: ResolverTypeWrapper<DataTableColumnGroupsEdge>;
  DataTableColumnGroupsOrderBy: DataTableColumnGroupsOrderBy;
  DataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableColumnOrderUniqueUpdate: DataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableColumnOrderUniqueUpdate;
  DataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableColumnPkeyUpdate: DataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableColumnPkeyUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDataTableColumnOrderUniqueUpdate: DataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDataTableColumnOrderUniqueUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDataTableColumnPkeyUpdate: DataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDataTableColumnPkeyUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnOrderUniqueUpdate: DataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnOrderUniqueUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnPkeyUpdate: DataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnPkeyUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingDataTableColumnOrderUniqueUpdate: DataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingDataTableColumnOrderUniqueUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingDataTableColumnPkeyUpdate: DataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingDataTableColumnPkeyUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTableColumnOrderUniqueUpdate: DataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTableColumnOrderUniqueUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTableColumnPkeyUpdate: DataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTableColumnPkeyUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingDataTableColumnOrderUniqueUpdate: DataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingDataTableColumnOrderUniqueUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingDataTableColumnPkeyUpdate: DataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingDataTableColumnPkeyUpdate;
  DataTableColumnProjectId91C18F88FkProjectIdInput: DataTableColumnProjectId91C18F88FkProjectIdInput;
  DataTableColumnProjectId91C18F88FkProjectIdInverseInput: DataTableColumnProjectId91C18F88FkProjectIdInverseInput;
  DataTableColumnTableIdF295C823FkDataTableIdInput: DataTableColumnTableIdF295C823FkDataTableIdInput;
  DataTableColumnTableIdF295C823FkDataTableIdInverseInput: DataTableColumnTableIdF295C823FkDataTableIdInverseInput;
  DataTableColumnToManyDataTableCellFilter: DataTableColumnToManyDataTableCellFilter;
  DataTableColumnUserId57054882FkApplicationUserIdApplicationUserCreateInput: DataTableColumnUserId57054882FkApplicationUserIdApplicationUserCreateInput;
  DataTableColumnUserId57054882FkApplicationUserIdInput: DataTableColumnUserId57054882FkApplicationUserIdInput;
  DataTableColumnUserId57054882FkApplicationUserIdInverseInput: DataTableColumnUserId57054882FkApplicationUserIdInverseInput;
  DataTableColumnsConnection: ResolverTypeWrapper<DataTableColumnsConnection>;
  DataTableColumnsEdge: ResolverTypeWrapper<DataTableColumnsEdge>;
  DataTableColumnsOrderBy: DataTableColumnsOrderBy;
  DataTableCondition: DataTableCondition;
  DataTableDataTablePkeyConnect: DataTableDataTablePkeyConnect;
  DataTableFilter: DataTableFilter;
  DataTableFolderId4Fe6C7FeFkProjectFolderIdInput: DataTableFolderId4Fe6C7FeFkProjectFolderIdInput;
  DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput: DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput;
  DataTableFolderId4Fe6C7FeFkProjectFolderIdProjectFolderCreateInput: DataTableFolderId4Fe6C7FeFkProjectFolderIdProjectFolderCreateInput;
  DataTableOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTablePkeyUpdate: DataTableOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTablePkeyUpdate;
  DataTableOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTablePkeyUpdate: DataTableOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTablePkeyUpdate;
  DataTableOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdUsingDataTablePkeyUpdate: DataTableOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdUsingDataTablePkeyUpdate;
  DataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingDataTablePkeyUpdate: DataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingDataTablePkeyUpdate;
  DataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingDataTablePkeyUpdate: DataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingDataTablePkeyUpdate;
  DataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingDataTablePkeyUpdate: DataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingDataTablePkeyUpdate;
  DataTableOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTablePkeyUpdate: DataTableOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTablePkeyUpdate;
  DataTableProjectId59F60EaeFkProjectIdInput: DataTableProjectId59F60EaeFkProjectIdInput;
  DataTableProjectId59F60EaeFkProjectIdInverseInput: DataTableProjectId59F60EaeFkProjectIdInverseInput;
  DataTableRow: ResolverTypeWrapper<DataTableRow>;
  DataTableRowCondition: DataTableRowCondition;
  DataTableRowDataTableRowPkeyConnect: DataTableRowDataTableRowPkeyConnect;
  DataTableRowDataTableRowUniqueConnect: DataTableRowDataTableRowUniqueConnect;
  DataTableRowFilter: DataTableRowFilter;
  DataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableRowPkeyUpdate: DataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableRowPkeyUpdate;
  DataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableRowUniqueUpdate: DataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableRowUniqueUpdate;
  DataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingDataTableRowPkeyUpdate: DataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingDataTableRowPkeyUpdate;
  DataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingDataTableRowUniqueUpdate: DataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingDataTableRowUniqueUpdate;
  DataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTableRowPkeyUpdate: DataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTableRowPkeyUpdate;
  DataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTableRowUniqueUpdate: DataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTableRowUniqueUpdate;
  DataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingDataTableRowPkeyUpdate: DataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingDataTableRowPkeyUpdate;
  DataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingDataTableRowUniqueUpdate: DataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingDataTableRowUniqueUpdate;
  DataTableRowProjectId43Bf0Ab0FkProjectIdInput: DataTableRowProjectId43Bf0Ab0FkProjectIdInput;
  DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput: DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput;
  DataTableRowTableIdF77C2D36FkDataTableIdInput: DataTableRowTableIdF77C2D36FkDataTableIdInput;
  DataTableRowTableIdF77C2D36FkDataTableIdInverseInput: DataTableRowTableIdF77C2D36FkDataTableIdInverseInput;
  DataTableRowToManyDataTableCellFilter: DataTableRowToManyDataTableCellFilter;
  DataTableRowUserId3C5E98E5FkApplicationUserIdApplicationUserCreateInput: DataTableRowUserId3C5E98E5FkApplicationUserIdApplicationUserCreateInput;
  DataTableRowUserId3C5E98E5FkApplicationUserIdInput: DataTableRowUserId3C5E98E5FkApplicationUserIdInput;
  DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput: DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput;
  DataTableRowsConnection: ResolverTypeWrapper<DataTableRowsConnection>;
  DataTableRowsEdge: ResolverTypeWrapper<DataTableRowsEdge>;
  DataTableRowsOrderBy: DataTableRowsOrderBy;
  DataTableToManyDataTableCellFilter: DataTableToManyDataTableCellFilter;
  DataTableToManyDataTableColumnFilter: DataTableToManyDataTableColumnFilter;
  DataTableToManyDataTableColumnGroupFilter: DataTableToManyDataTableColumnGroupFilter;
  DataTableToManyDataTableRowFilter: DataTableToManyDataTableRowFilter;
  DataTableUserIdAb79B056FkApplicationUserIdApplicationUserCreateInput: DataTableUserIdAb79B056FkApplicationUserIdApplicationUserCreateInput;
  DataTableUserIdAb79B056FkApplicationUserIdInput: DataTableUserIdAb79B056FkApplicationUserIdInput;
  DataTableUserIdAb79B056FkApplicationUserIdInverseInput: DataTableUserIdAb79B056FkApplicationUserIdInverseInput;
  DataTablesConnection: ResolverTypeWrapper<DataTablesConnection>;
  DataTablesEdge: ResolverTypeWrapper<DataTablesEdge>;
  DataTablesOrderBy: DataTablesOrderBy;
  Date: ResolverTypeWrapper<Scalars["Date"]["output"]>;
  DateFilter: DateFilter;
  Datetime: ResolverTypeWrapper<Scalars["Datetime"]["output"]>;
  DatetimeFilter: DatetimeFilter;
  DeleteApplicationUserByEmailInput: DeleteApplicationUserByEmailInput;
  DeleteApplicationUserByGlobalUserIdInput: DeleteApplicationUserByGlobalUserIdInput;
  DeleteApplicationUserByIdInput: DeleteApplicationUserByIdInput;
  DeleteApplicationUserByUsernameInput: DeleteApplicationUserByUsernameInput;
  DeleteApplicationUserGroupByIdInput: DeleteApplicationUserGroupByIdInput;
  DeleteApplicationUserGroupByUserIdAndGroupIdInput: DeleteApplicationUserGroupByUserIdAndGroupIdInput;
  DeleteApplicationUserGroupPayload: ResolverTypeWrapper<DeleteApplicationUserGroupPayload>;
  DeleteApplicationUserMembershipByIdInput: DeleteApplicationUserMembershipByIdInput;
  DeleteApplicationUserMembershipByUserIdAndTenantIdInput: DeleteApplicationUserMembershipByUserIdAndTenantIdInput;
  DeleteApplicationUserMembershipPayload: ResolverTypeWrapper<DeleteApplicationUserMembershipPayload>;
  DeleteApplicationUserMetadatumByIdInput: DeleteApplicationUserMetadatumByIdInput;
  DeleteApplicationUserMetadatumByUserIdAndKeyInput: DeleteApplicationUserMetadatumByUserIdAndKeyInput;
  DeleteApplicationUserMetadatumPayload: ResolverTypeWrapper<DeleteApplicationUserMetadatumPayload>;
  DeleteApplicationUserPayload: ResolverTypeWrapper<DeleteApplicationUserPayload>;
  DeleteApplicationUserSessionByIdInput: DeleteApplicationUserSessionByIdInput;
  DeleteApplicationUserSessionPayload: ResolverTypeWrapper<DeleteApplicationUserSessionPayload>;
  DeleteApplicationUserUserPermissionByIdInput: DeleteApplicationUserUserPermissionByIdInput;
  DeleteApplicationUserUserPermissionByUserIdAndPermissionIdInput: DeleteApplicationUserUserPermissionByUserIdAndPermissionIdInput;
  DeleteApplicationUserUserPermissionPayload: ResolverTypeWrapper<DeleteApplicationUserUserPermissionPayload>;
  DeleteAuditlogLogentryByIdInput: DeleteAuditlogLogentryByIdInput;
  DeleteAuditlogLogentryPayload: ResolverTypeWrapper<DeleteAuditlogLogentryPayload>;
  DeleteAuthGroupByIdInput: DeleteAuthGroupByIdInput;
  DeleteAuthGroupByNameInput: DeleteAuthGroupByNameInput;
  DeleteAuthGroupPayload: ResolverTypeWrapper<DeleteAuthGroupPayload>;
  DeleteAuthGroupPermissionByGroupIdAndPermissionIdInput: DeleteAuthGroupPermissionByGroupIdAndPermissionIdInput;
  DeleteAuthGroupPermissionByIdInput: DeleteAuthGroupPermissionByIdInput;
  DeleteAuthGroupPermissionPayload: ResolverTypeWrapper<DeleteAuthGroupPermissionPayload>;
  DeleteAuthPermissionByContentTypeIdAndCodenameInput: DeleteAuthPermissionByContentTypeIdAndCodenameInput;
  DeleteAuthPermissionByIdInput: DeleteAuthPermissionByIdInput;
  DeleteAuthPermissionPayload: ResolverTypeWrapper<DeleteAuthPermissionPayload>;
  DeleteAvatarByIdInput: DeleteAvatarByIdInput;
  DeleteAvatarByUserIdInput: DeleteAvatarByUserIdInput;
  DeleteAvatarPayload: ResolverTypeWrapper<DeleteAvatarPayload>;
  DeleteAwsBatchTaskByTaskexecutorPtrIdInput: DeleteAwsBatchTaskByTaskexecutorPtrIdInput;
  DeleteAwsBatchTaskPayload: ResolverTypeWrapper<DeleteAwsBatchTaskPayload>;
  DeleteAwsCognitoUserByUserexecutorPtrIdInput: DeleteAwsCognitoUserByUserexecutorPtrIdInput;
  DeleteAwsCognitoUserPayload: ResolverTypeWrapper<DeleteAwsCognitoUserPayload>;
  DeleteAwsEcrImageByContainerimageexecutorPtrIdInput: DeleteAwsEcrImageByContainerimageexecutorPtrIdInput;
  DeleteAwsEcrImagePayload: ResolverTypeWrapper<DeleteAwsEcrImagePayload>;
  DeleteAwsMockBatchTaskByAwstaskexecutorPtrIdInput: DeleteAwsMockBatchTaskByAwstaskexecutorPtrIdInput;
  DeleteAwsMockBatchTaskPayload: ResolverTypeWrapper<DeleteAwsMockBatchTaskPayload>;
  DeleteAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdInput: DeleteAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdInput;
  DeleteAwsMockDistributionImagePayload: ResolverTypeWrapper<DeleteAwsMockDistributionImagePayload>;
  DeleteAwsMockEcrImageByAwscontainerimageexecutorPtrIdInput: DeleteAwsMockEcrImageByAwscontainerimageexecutorPtrIdInput;
  DeleteAwsMockEcrImagePayload: ResolverTypeWrapper<DeleteAwsMockEcrImagePayload>;
  DeleteAwsMockIamUserByAwsuserexecutorPtrIdInput: DeleteAwsMockIamUserByAwsuserexecutorPtrIdInput;
  DeleteAwsMockIamUserPayload: ResolverTypeWrapper<DeleteAwsMockIamUserPayload>;
  DeleteAwsMockS3FileByAwsfileexecutorPtrIdInput: DeleteAwsMockS3FileByAwsfileexecutorPtrIdInput;
  DeleteAwsMockS3FilePayload: ResolverTypeWrapper<DeleteAwsMockS3FilePayload>;
  DeleteAwsS3FileByFileexecutorPtrIdInput: DeleteAwsS3FileByFileexecutorPtrIdInput;
  DeleteAwsS3FilePayload: ResolverTypeWrapper<DeleteAwsS3FilePayload>;
  DeleteCodeFileByIdInput: DeleteCodeFileByIdInput;
  DeleteCodeFilePayload: ResolverTypeWrapper<DeleteCodeFilePayload>;
  DeleteCommandByIdInput: DeleteCommandByIdInput;
  DeleteCommandByToolVersionIdAndCodeFileIdInput: DeleteCommandByToolVersionIdAndCodeFileIdInput;
  DeleteCommandByToolVersionIdInput: DeleteCommandByToolVersionIdInput;
  DeleteCommandPayload: ResolverTypeWrapper<DeleteCommandPayload>;
  DeleteContainerImageByExecutorIdInput: DeleteContainerImageByExecutorIdInput;
  DeleteContainerImageByIdInput: DeleteContainerImageByIdInput;
  DeleteContainerImagePayload: ResolverTypeWrapper<DeleteContainerImagePayload>;
  DeleteContainerImageRepositoryByIdInput: DeleteContainerImageRepositoryByIdInput;
  DeleteContainerImageRepositoryByNameAndTenantIdAndRegistryTypeInput: DeleteContainerImageRepositoryByNameAndTenantIdAndRegistryTypeInput;
  DeleteContainerImageRepositoryByRepositoryInput: DeleteContainerImageRepositoryByRepositoryInput;
  DeleteContainerImageRepositoryPayload: ResolverTypeWrapper<DeleteContainerImageRepositoryPayload>;
  DeleteCostByIdInput: DeleteCostByIdInput;
  DeleteCostPayload: ResolverTypeWrapper<DeleteCostPayload>;
  DeleteDistributionRegistryImageByContainerimageexecutorPtrIdInput: DeleteDistributionRegistryImageByContainerimageexecutorPtrIdInput;
  DeleteDistributionRegistryImagePayload: ResolverTypeWrapper<DeleteDistributionRegistryImagePayload>;
  DeleteDjangoAdminLogByIdInput: DeleteDjangoAdminLogByIdInput;
  DeleteDjangoAdminLogPayload: ResolverTypeWrapper<DeleteDjangoAdminLogPayload>;
  DeleteDjangoContentTypeByAppLabelAndModelInput: DeleteDjangoContentTypeByAppLabelAndModelInput;
  DeleteDjangoContentTypeByIdInput: DeleteDjangoContentTypeByIdInput;
  DeleteDjangoContentTypePayload: ResolverTypeWrapper<DeleteDjangoContentTypePayload>;
  DeleteDjangoMigrationByIdInput: DeleteDjangoMigrationByIdInput;
  DeleteDjangoMigrationPayload: ResolverTypeWrapper<DeleteDjangoMigrationPayload>;
  DeleteDjangoSesBlacklistedemailByEmailInput: DeleteDjangoSesBlacklistedemailByEmailInput;
  DeleteDjangoSesBlacklistedemailByIdInput: DeleteDjangoSesBlacklistedemailByIdInput;
  DeleteDjangoSesBlacklistedemailPayload: ResolverTypeWrapper<DeleteDjangoSesBlacklistedemailPayload>;
  DeleteDjangoSesSesstatByDateInput: DeleteDjangoSesSesstatByDateInput;
  DeleteDjangoSesSesstatByIdInput: DeleteDjangoSesSesstatByIdInput;
  DeleteDjangoSesSesstatPayload: ResolverTypeWrapper<DeleteDjangoSesSesstatPayload>;
  DeleteDjangoSessionBySessionKeyInput: DeleteDjangoSessionBySessionKeyInput;
  DeleteDjangoSessionPayload: ResolverTypeWrapper<DeleteDjangoSessionPayload>;
  DeleteDrsFileexecutorByIdInput: DeleteDrsFileexecutorByIdInput;
  DeleteDrsFileexecutorPayload: ResolverTypeWrapper<DeleteDrsFileexecutorPayload>;
  DeleteDrsMockfileexecutorByFileexecutorPtrIdInput: DeleteDrsMockfileexecutorByFileexecutorPtrIdInput;
  DeleteDrsMockfileexecutorPayload: ResolverTypeWrapper<DeleteDrsMockfileexecutorPayload>;
  DeleteEulaVersionByIdInput: DeleteEulaVersionByIdInput;
  DeleteEulaVersionByVersionInput: DeleteEulaVersionByVersionInput;
  DeleteEulaVersionPayload: ResolverTypeWrapper<DeleteEulaVersionPayload>;
  DeleteEulaVersionUserAcceptanceByIdInput: DeleteEulaVersionUserAcceptanceByIdInput;
  DeleteEulaVersionUserAcceptanceByUserIdAndEulaVersionIdInput: DeleteEulaVersionUserAcceptanceByUserIdAndEulaVersionIdInput;
  DeleteEulaVersionUserAcceptancePayload: ResolverTypeWrapper<DeleteEulaVersionUserAcceptancePayload>;
  DeleteFeatureFlagByIdInput: DeleteFeatureFlagByIdInput;
  DeleteFeatureFlagByNameInput: DeleteFeatureFlagByNameInput;
  DeleteFeatureFlagPayload: ResolverTypeWrapper<DeleteFeatureFlagPayload>;
  DeleteFeatureFlagsGroupByFeatureflagIdAndGroupIdInput: DeleteFeatureFlagsGroupByFeatureflagIdAndGroupIdInput;
  DeleteFeatureFlagsGroupByIdInput: DeleteFeatureFlagsGroupByIdInput;
  DeleteFeatureFlagsGroupPayload: ResolverTypeWrapper<DeleteFeatureFlagsGroupPayload>;
  DeleteFeatureFlagsTenantByFeatureflagIdAndTenantIdInput: DeleteFeatureFlagsTenantByFeatureflagIdAndTenantIdInput;
  DeleteFeatureFlagsTenantByIdInput: DeleteFeatureFlagsTenantByIdInput;
  DeleteFeatureFlagsTenantPayload: ResolverTypeWrapper<DeleteFeatureFlagsTenantPayload>;
  DeleteFeatureFlagsUserByFeatureflagIdAndUserIdInput: DeleteFeatureFlagsUserByFeatureflagIdAndUserIdInput;
  DeleteFeatureFlagsUserByIdInput: DeleteFeatureFlagsUserByIdInput;
  DeleteFeatureFlagsUserPayload: ResolverTypeWrapper<DeleteFeatureFlagsUserPayload>;
  DeleteFileActivityByIdInput: DeleteFileActivityByIdInput;
  DeleteFileActivityPayload: ResolverTypeWrapper<DeleteFileActivityPayload>;
  DeleteFileByIdInput: DeleteFileByIdInput;
  DeleteFileByProjectIdAndReferenceIdInput: DeleteFileByProjectIdAndReferenceIdInput;
  DeleteFileMetadatumByIdInput: DeleteFileMetadatumByIdInput;
  DeleteFileMetadatumPayload: ResolverTypeWrapper<DeleteFileMetadatumPayload>;
  DeleteFileOutputGroupByIdInput: DeleteFileOutputGroupByIdInput;
  DeleteFileOutputGroupByTaskIdInput: DeleteFileOutputGroupByTaskIdInput;
  DeleteFileOutputGroupMetadatumByIdInput: DeleteFileOutputGroupMetadatumByIdInput;
  DeleteFileOutputGroupMetadatumPayload: ResolverTypeWrapper<DeleteFileOutputGroupMetadatumPayload>;
  DeleteFileOutputGroupPayload: ResolverTypeWrapper<DeleteFileOutputGroupPayload>;
  DeleteFilePayload: ResolverTypeWrapper<DeleteFilePayload>;
  DeleteMetadataValueByIdInput: DeleteMetadataValueByIdInput;
  DeleteMetadataValuePayload: ResolverTypeWrapper<DeleteMetadataValuePayload>;
  DeleteMetadatumByIdInput: DeleteMetadatumByIdInput;
  DeleteMetadatumPayload: ResolverTypeWrapper<DeleteMetadatumPayload>;
  DeleteOutputGroupFileByIdInput: DeleteOutputGroupFileByIdInput;
  DeleteOutputGroupFilePayload: ResolverTypeWrapper<DeleteOutputGroupFilePayload>;
  DeletePinnedToolByIdInput: DeletePinnedToolByIdInput;
  DeletePinnedToolByUserIdAndToolIdInput: DeletePinnedToolByUserIdAndToolIdInput;
  DeletePinnedToolPayload: ResolverTypeWrapper<DeletePinnedToolPayload>;
  DeleteProjectFolderByIdInput: DeleteProjectFolderByIdInput;
  DeleteProjectFolderPayload: ResolverTypeWrapper<DeleteProjectFolderPayload>;
  DeleteProjectTagByIdInput: DeleteProjectTagByIdInput;
  DeleteProjectTagPayload: ResolverTypeWrapper<DeleteProjectTagPayload>;
  DeleteRunByIdInput: DeleteRunByIdInput;
  DeleteRunPayload: ResolverTypeWrapper<DeleteRunPayload>;
  DeleteSessionInput: DeleteSessionInput;
  DeleteSessionPayload: ResolverTypeWrapper<DeleteSessionPayload>;
  DeleteTaskActivityByIdInput: DeleteTaskActivityByIdInput;
  DeleteTaskActivityByTaskIdInput: DeleteTaskActivityByTaskIdInput;
  DeleteTaskActivityPayload: ResolverTypeWrapper<DeleteTaskActivityPayload>;
  DeleteTaskByExecutorIdInput: DeleteTaskByExecutorIdInput;
  DeleteTaskByIdInput: DeleteTaskByIdInput;
  DeleteTaskPayload: ResolverTypeWrapper<DeleteTaskPayload>;
  DeleteTaskResourceByIdInput: DeleteTaskResourceByIdInput;
  DeleteTaskResourcePayload: ResolverTypeWrapper<DeleteTaskResourcePayload>;
  DeleteTaskResourceUsageByIdInput: DeleteTaskResourceUsageByIdInput;
  DeleteTaskResourceUsageByTaskIdInput: DeleteTaskResourceUsageByTaskIdInput;
  DeleteTaskResourceUsagePayload: ResolverTypeWrapper<DeleteTaskResourceUsagePayload>;
  DeleteTaskSourceByIdInput: DeleteTaskSourceByIdInput;
  DeleteTaskSourcePayload: ResolverTypeWrapper<DeleteTaskSourcePayload>;
  DeleteTaskStatusLogByIdInput: DeleteTaskStatusLogByIdInput;
  DeleteTaskStatusLogByTaskIdAndStatusInput: DeleteTaskStatusLogByTaskIdAndStatusInput;
  DeleteTaskStatusLogPayload: ResolverTypeWrapper<DeleteTaskStatusLogPayload>;
  DeleteTenantByIdInput: DeleteTenantByIdInput;
  DeleteTenantByKeyInput: DeleteTenantByKeyInput;
  DeleteTenantByRepositoryNameInput: DeleteTenantByRepositoryNameInput;
  DeleteTenantBySfidInput: DeleteTenantBySfidInput;
  DeleteTenantContractAllowanceByIdInput: DeleteTenantContractAllowanceByIdInput;
  DeleteTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeInput: DeleteTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeInput;
  DeleteTenantContractAllowancePayload: ResolverTypeWrapper<DeleteTenantContractAllowancePayload>;
  DeleteTenantContractByIdInput: DeleteTenantContractByIdInput;
  DeleteTenantContractByNameInput: DeleteTenantContractByNameInput;
  DeleteTenantContractBySfidInput: DeleteTenantContractBySfidInput;
  DeleteTenantContractPayload: ResolverTypeWrapper<DeleteTenantContractPayload>;
  DeleteTenantContractTransactionByIdInput: DeleteTenantContractTransactionByIdInput;
  DeleteTenantContractTransactionPayload: ResolverTypeWrapper<DeleteTenantContractTransactionPayload>;
  DeleteTenantMockuserexecutorByUserexecutorPtrIdInput: DeleteTenantMockuserexecutorByUserexecutorPtrIdInput;
  DeleteTenantMockuserexecutorPayload: ResolverTypeWrapper<DeleteTenantMockuserexecutorPayload>;
  DeleteTenantMonthlyConsumedResourceByIdInput: DeleteTenantMonthlyConsumedResourceByIdInput;
  DeleteTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractInput: DeleteTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractInput;
  DeleteTenantMonthlyConsumedResourcePayload: ResolverTypeWrapper<DeleteTenantMonthlyConsumedResourcePayload>;
  DeleteTenantPayload: ResolverTypeWrapper<DeleteTenantPayload>;
  DeleteTenantUserexecutorByIdInput: DeleteTenantUserexecutorByIdInput;
  DeleteTenantUserexecutorPayload: ResolverTypeWrapper<DeleteTenantUserexecutorPayload>;
  DeleteTesContainerimageexecutorByIdInput: DeleteTesContainerimageexecutorByIdInput;
  DeleteTesContainerimageexecutorPayload: ResolverTypeWrapper<DeleteTesContainerimageexecutorPayload>;
  DeleteTesMockcontainerimageexecutorByContainerimageexecutorPtrIdInput: DeleteTesMockcontainerimageexecutorByContainerimageexecutorPtrIdInput;
  DeleteTesMockcontainerimageexecutorPayload: ResolverTypeWrapper<DeleteTesMockcontainerimageexecutorPayload>;
  DeleteTesMocktaskexecutorByTaskexecutorPtrIdInput: DeleteTesMocktaskexecutorByTaskexecutorPtrIdInput;
  DeleteTesMocktaskexecutorPayload: ResolverTypeWrapper<DeleteTesMocktaskexecutorPayload>;
  DeleteTesTaskexecutorByIdInput: DeleteTesTaskexecutorByIdInput;
  DeleteTesTaskexecutorPayload: ResolverTypeWrapper<DeleteTesTaskexecutorPayload>;
  DeleteToolByIdInput: DeleteToolByIdInput;
  DeleteToolByProjectIdInput: DeleteToolByProjectIdInput;
  DeleteToolParameterByIdInput: DeleteToolParameterByIdInput;
  DeleteToolParameterPayload: ResolverTypeWrapper<DeleteToolParameterPayload>;
  DeleteToolPayload: ResolverTypeWrapper<DeleteToolPayload>;
  DeleteToolResourceByIdInput: DeleteToolResourceByIdInput;
  DeleteToolResourceByTypeAndToolVersionIdInput: DeleteToolResourceByTypeAndToolVersionIdInput;
  DeleteToolResourcePayload: ResolverTypeWrapper<DeleteToolResourcePayload>;
  DeleteToolResultByIdInput: DeleteToolResultByIdInput;
  DeleteToolResultPayload: ResolverTypeWrapper<DeleteToolResultPayload>;
  DeleteToolSecretByIdInput: DeleteToolSecretByIdInput;
  DeleteToolSecretPayload: ResolverTypeWrapper<DeleteToolSecretPayload>;
  DeleteToolSourceByIdInput: DeleteToolSourceByIdInput;
  DeleteToolSourcePayload: ResolverTypeWrapper<DeleteToolSourcePayload>;
  DeleteToolTenantByIdInput: DeleteToolTenantByIdInput;
  DeleteToolTenantByToolIdAndTenantIdInput: DeleteToolTenantByToolIdAndTenantIdInput;
  DeleteToolTenantPayload: ResolverTypeWrapper<DeleteToolTenantPayload>;
  DeleteToolVersionByIdInput: DeleteToolVersionByIdInput;
  DeleteToolVersionPayload: ResolverTypeWrapper<DeleteToolVersionPayload>;
  DeleteToolboxByIdInput: DeleteToolboxByIdInput;
  DeleteToolboxByKeyInput: DeleteToolboxByKeyInput;
  DeleteToolboxPayload: ResolverTypeWrapper<DeleteToolboxPayload>;
  DeleteToolboxTenantByIdInput: DeleteToolboxTenantByIdInput;
  DeleteToolboxTenantByToolboxIdAndTenantIdInput: DeleteToolboxTenantByToolboxIdAndTenantIdInput;
  DeleteToolboxTenantPayload: ResolverTypeWrapper<DeleteToolboxTenantPayload>;
  DeleteUserPersonalSpaceRequestByIdInput: DeleteUserPersonalSpaceRequestByIdInput;
  DeleteUserPersonalSpaceRequestPayload: ResolverTypeWrapper<DeleteUserPersonalSpaceRequestPayload>;
  DeleteWaffleFlagByIdInput: DeleteWaffleFlagByIdInput;
  DeleteWaffleFlagByNameInput: DeleteWaffleFlagByNameInput;
  DeleteWaffleFlagPayload: ResolverTypeWrapper<DeleteWaffleFlagPayload>;
  DeleteWaffleSampleByIdInput: DeleteWaffleSampleByIdInput;
  DeleteWaffleSampleByNameInput: DeleteWaffleSampleByNameInput;
  DeleteWaffleSamplePayload: ResolverTypeWrapper<DeleteWaffleSamplePayload>;
  DeleteWaffleSwitchByIdInput: DeleteWaffleSwitchByIdInput;
  DeleteWaffleSwitchByNameInput: DeleteWaffleSwitchByNameInput;
  DeleteWaffleSwitchPayload: ResolverTypeWrapper<DeleteWaffleSwitchPayload>;
  DeleteWorkflowByIdInput: DeleteWorkflowByIdInput;
  DeleteWorkflowDatumByIdInput: DeleteWorkflowDatumByIdInput;
  DeleteWorkflowDatumPayload: ResolverTypeWrapper<DeleteWorkflowDatumPayload>;
  DeleteWorkflowPayload: ResolverTypeWrapper<DeleteWorkflowPayload>;
  DeleteWorkflowResultByIdInput: DeleteWorkflowResultByIdInput;
  DeleteWorkflowResultPayload: ResolverTypeWrapper<DeleteWorkflowResultPayload>;
  DeleteWorkflowResultWorkflowVersionByIdInput: DeleteWorkflowResultWorkflowVersionByIdInput;
  DeleteWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdInput: DeleteWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdInput;
  DeleteWorkflowResultWorkflowVersionPayload: ResolverTypeWrapper<DeleteWorkflowResultWorkflowVersionPayload>;
  DeleteWorkflowSectionBlockByIdInput: DeleteWorkflowSectionBlockByIdInput;
  DeleteWorkflowSectionBlockPayload: ResolverTypeWrapper<DeleteWorkflowSectionBlockPayload>;
  DeleteWorkflowSectionBlockSectionByBlockIdAndSectionIdInput: DeleteWorkflowSectionBlockSectionByBlockIdAndSectionIdInput;
  DeleteWorkflowSectionBlockSectionByIdInput: DeleteWorkflowSectionBlockSectionByIdInput;
  DeleteWorkflowSectionBlockSectionPayload: ResolverTypeWrapper<DeleteWorkflowSectionBlockSectionPayload>;
  DeleteWorkflowSectionByIdInput: DeleteWorkflowSectionByIdInput;
  DeleteWorkflowSectionPayload: ResolverTypeWrapper<DeleteWorkflowSectionPayload>;
  DeleteWorkflowSectionWorkflowVersionByIdInput: DeleteWorkflowSectionWorkflowVersionByIdInput;
  DeleteWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdInput: DeleteWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdInput;
  DeleteWorkflowSectionWorkflowVersionPayload: ResolverTypeWrapper<DeleteWorkflowSectionWorkflowVersionPayload>;
  DeleteWorkflowSourceByIdInput: DeleteWorkflowSourceByIdInput;
  DeleteWorkflowSourcePayload: ResolverTypeWrapper<DeleteWorkflowSourcePayload>;
  DeleteWorkflowSourceWorkflowVersionByIdInput: DeleteWorkflowSourceWorkflowVersionByIdInput;
  DeleteWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdInput: DeleteWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdInput;
  DeleteWorkflowSourceWorkflowVersionPayload: ResolverTypeWrapper<DeleteWorkflowSourceWorkflowVersionPayload>;
  DeleteWorkflowVersionByIdInput: DeleteWorkflowVersionByIdInput;
  DeleteWorkflowVersionPayload: ResolverTypeWrapper<DeleteWorkflowVersionPayload>;
  DistributionRegistrContainerimageexecut830E7Af5FkTesContaDistributionRegistryImageCreateInput: DistributionRegistrContainerimageexecut830E7Af5FkTesContaDistributionRegistryImageCreateInput;
  DistributionRegistrContainerimageexecut830E7Af5FkTesContaInput: DistributionRegistrContainerimageexecut830E7Af5FkTesContaInput;
  DistributionRegistrContainerimageexecut830E7Af5FkTesContaInverseInput: DistributionRegistrContainerimageexecut830E7Af5FkTesContaInverseInput;
  DistributionRegistrContainerimageexecut830E7Af5FkTesContaTesContainerimageexecutorCreateInput: DistributionRegistrContainerimageexecut830E7Af5FkTesContaTesContainerimageexecutorCreateInput;
  DistributionRegistryImage: ResolverTypeWrapper<DistributionRegistryImage>;
  DistributionRegistryImageCondition: DistributionRegistryImageCondition;
  DistributionRegistryImageDistributionRegistryImagePkeyConnect: DistributionRegistryImageDistributionRegistryImagePkeyConnect;
  DistributionRegistryImageDistributionRegistryImagePkeyDelete: DistributionRegistryImageDistributionRegistryImagePkeyDelete;
  DistributionRegistryImageFilter: DistributionRegistryImageFilter;
  DistributionRegistryImageInput: DistributionRegistryImageInput;
  DistributionRegistryImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributUsingDistributionRegistryImagePkeyUpdate: DistributionRegistryImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributUsingDistributionRegistryImagePkeyUpdate;
  DistributionRegistryImageOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaUsingDistributionRegistryImagePkeyUpdate: DistributionRegistryImageOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaUsingDistributionRegistryImagePkeyUpdate;
  DistributionRegistryImagePatch: DistributionRegistryImagePatch;
  DistributionRegistryImagesConnection: ResolverTypeWrapper<DistributionRegistryImagesConnection>;
  DistributionRegistryImagesEdge: ResolverTypeWrapper<DistributionRegistryImagesEdge>;
  DistributionRegistryImagesOrderBy: DistributionRegistryImagesOrderBy;
  DjangoAdminLog: ResolverTypeWrapper<DjangoAdminLog>;
  DjangoAdminLogCondition: DjangoAdminLogCondition;
  DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoDjangoAdminLogCreateInput: DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoDjangoAdminLogCreateInput;
  DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoDjangoContentTypeCreateInput: DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoDjangoContentTypeCreateInput;
  DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInput: DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInput;
  DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput: DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput;
  DjangoAdminLogDjangoAdminLogPkeyConnect: DjangoAdminLogDjangoAdminLogPkeyConnect;
  DjangoAdminLogDjangoAdminLogPkeyDelete: DjangoAdminLogDjangoAdminLogPkeyDelete;
  DjangoAdminLogFilter: DjangoAdminLogFilter;
  DjangoAdminLogInput: DjangoAdminLogInput;
  DjangoAdminLogOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoAdminLogPkeyUpdate: DjangoAdminLogOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoAdminLogPkeyUpdate;
  DjangoAdminLogOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingDjangoAdminLogPkeyUpdate: DjangoAdminLogOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingDjangoAdminLogPkeyUpdate;
  DjangoAdminLogPatch: DjangoAdminLogPatch;
  DjangoAdminLogUserIdC564Eba6FkApplicationUserIdApplicationUserCreateInput: DjangoAdminLogUserIdC564Eba6FkApplicationUserIdApplicationUserCreateInput;
  DjangoAdminLogUserIdC564Eba6FkApplicationUserIdDjangoAdminLogCreateInput: DjangoAdminLogUserIdC564Eba6FkApplicationUserIdDjangoAdminLogCreateInput;
  DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInput: DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInput;
  DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput: DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput;
  DjangoAdminLogsConnection: ResolverTypeWrapper<DjangoAdminLogsConnection>;
  DjangoAdminLogsEdge: ResolverTypeWrapper<DjangoAdminLogsEdge>;
  DjangoAdminLogsOrderBy: DjangoAdminLogsOrderBy;
  DjangoContentType: ResolverTypeWrapper<DjangoContentType>;
  DjangoContentTypeCondition: DjangoContentTypeCondition;
  DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect: DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect;
  DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete: DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete;
  DjangoContentTypeDjangoContentTypePkeyConnect: DjangoContentTypeDjangoContentTypePkeyConnect;
  DjangoContentTypeDjangoContentTypePkeyDelete: DjangoContentTypeDjangoContentTypePkeyDelete;
  DjangoContentTypeFilter: DjangoContentTypeFilter;
  DjangoContentTypeInput: DjangoContentTypeInput;
  DjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIE4E5D06AFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIE4E5D06AFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypePatch: DjangoContentTypePatch;
  DjangoContentTypeToManyAuditlogLogentryFilter: DjangoContentTypeToManyAuditlogLogentryFilter;
  DjangoContentTypeToManyAuthPermissionFilter: DjangoContentTypeToManyAuthPermissionFilter;
  DjangoContentTypeToManyDataTableColumnDefinitionCellStatusFilter: DjangoContentTypeToManyDataTableColumnDefinitionCellStatusFilter;
  DjangoContentTypeToManyDataTableColumnDefinitionIdentifierFilter: DjangoContentTypeToManyDataTableColumnDefinitionIdentifierFilter;
  DjangoContentTypeToManyDataTableColumnDefinitionJoinFilter: DjangoContentTypeToManyDataTableColumnDefinitionJoinFilter;
  DjangoContentTypeToManyDataTableColumnDefinitionMetadatumFilter: DjangoContentTypeToManyDataTableColumnDefinitionMetadatumFilter;
  DjangoContentTypeToManyDataTableColumnDefinitionRoiFrameFilter: DjangoContentTypeToManyDataTableColumnDefinitionRoiFrameFilter;
  DjangoContentTypeToManyDataTableColumnFilter: DjangoContentTypeToManyDataTableColumnFilter;
  DjangoContentTypeToManyDataTableColumnGroupDefinitionJoinFilter: DjangoContentTypeToManyDataTableColumnGroupDefinitionJoinFilter;
  DjangoContentTypeToManyDataTableColumnGroupFilter: DjangoContentTypeToManyDataTableColumnGroupFilter;
  DjangoContentTypeToManyDjangoAdminLogFilter: DjangoContentTypeToManyDjangoAdminLogFilter;
  DjangoContentTypeToManyDrsFileexecutorFilter: DjangoContentTypeToManyDrsFileexecutorFilter;
  DjangoContentTypeToManyFileActivityFilter: DjangoContentTypeToManyFileActivityFilter;
  DjangoContentTypeToManyGdtAnalysisTableColumnFilter: DjangoContentTypeToManyGdtAnalysisTableColumnFilter;
  DjangoContentTypeToManyGdtAnalysisTableColumnGroupFilter: DjangoContentTypeToManyGdtAnalysisTableColumnGroupFilter;
  DjangoContentTypeToManyTenantUserexecutorFilter: DjangoContentTypeToManyTenantUserexecutorFilter;
  DjangoContentTypeToManyTesContainerimageexecutorFilter: DjangoContentTypeToManyTesContainerimageexecutorFilter;
  DjangoContentTypeToManyTesTaskexecutorFilter: DjangoContentTypeToManyTesTaskexecutorFilter;
  DjangoContentTypesConnection: ResolverTypeWrapper<DjangoContentTypesConnection>;
  DjangoContentTypesEdge: ResolverTypeWrapper<DjangoContentTypesEdge>;
  DjangoContentTypesOrderBy: DjangoContentTypesOrderBy;
  DjangoMigration: ResolverTypeWrapper<DjangoMigration>;
  DjangoMigrationCondition: DjangoMigrationCondition;
  DjangoMigrationFilter: DjangoMigrationFilter;
  DjangoMigrationInput: DjangoMigrationInput;
  DjangoMigrationPatch: DjangoMigrationPatch;
  DjangoMigrationsConnection: ResolverTypeWrapper<DjangoMigrationsConnection>;
  DjangoMigrationsEdge: ResolverTypeWrapper<DjangoMigrationsEdge>;
  DjangoMigrationsOrderBy: DjangoMigrationsOrderBy;
  DjangoSesBlacklistedemail: ResolverTypeWrapper<DjangoSesBlacklistedemail>;
  DjangoSesBlacklistedemailCondition: DjangoSesBlacklistedemailCondition;
  DjangoSesBlacklistedemailFilter: DjangoSesBlacklistedemailFilter;
  DjangoSesBlacklistedemailInput: DjangoSesBlacklistedemailInput;
  DjangoSesBlacklistedemailPatch: DjangoSesBlacklistedemailPatch;
  DjangoSesBlacklistedemailsConnection: ResolverTypeWrapper<DjangoSesBlacklistedemailsConnection>;
  DjangoSesBlacklistedemailsEdge: ResolverTypeWrapper<DjangoSesBlacklistedemailsEdge>;
  DjangoSesBlacklistedemailsOrderBy: DjangoSesBlacklistedemailsOrderBy;
  DjangoSesSesstat: ResolverTypeWrapper<DjangoSesSesstat>;
  DjangoSesSesstatCondition: DjangoSesSesstatCondition;
  DjangoSesSesstatFilter: DjangoSesSesstatFilter;
  DjangoSesSesstatInput: DjangoSesSesstatInput;
  DjangoSesSesstatPatch: DjangoSesSesstatPatch;
  DjangoSesSesstatsConnection: ResolverTypeWrapper<DjangoSesSesstatsConnection>;
  DjangoSesSesstatsEdge: ResolverTypeWrapper<DjangoSesSesstatsEdge>;
  DjangoSesSesstatsOrderBy: DjangoSesSesstatsOrderBy;
  DjangoSession: ResolverTypeWrapper<DjangoSession>;
  DjangoSessionCondition: DjangoSessionCondition;
  DjangoSessionFilter: DjangoSessionFilter;
  DjangoSessionInput: DjangoSessionInput;
  DjangoSessionPatch: DjangoSessionPatch;
  DjangoSessionsConnection: ResolverTypeWrapper<DjangoSessionsConnection>;
  DjangoSessionsEdge: ResolverTypeWrapper<DjangoSessionsEdge>;
  DjangoSessionsOrderBy: DjangoSessionsOrderBy;
  DrsFileexecutor: ResolverTypeWrapper<DrsFileexecutor>;
  DrsFileexecutorCondition: DrsFileexecutorCondition;
  DrsFileexecutorDrsFileexecutorPkeyConnect: DrsFileexecutorDrsFileexecutorPkeyConnect;
  DrsFileexecutorDrsFileexecutorPkeyDelete: DrsFileexecutorDrsFileexecutorPkeyDelete;
  DrsFileexecutorFilter: DrsFileexecutorFilter;
  DrsFileexecutorInput: DrsFileexecutorInput;
  DrsFileexecutorOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdUsingDrsFileexecutorPkeyUpdate: DrsFileexecutorOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdUsingDrsFileexecutorPkeyUpdate;
  DrsFileexecutorOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdUsingDrsFileexecutorPkeyUpdate: DrsFileexecutorOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdUsingDrsFileexecutorPkeyUpdate;
  DrsFileexecutorOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDrsFileexecutorPkeyUpdate: DrsFileexecutorOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDrsFileexecutorPkeyUpdate;
  DrsFileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeUsingDrsFileexecutorPkeyUpdate: DrsFileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeUsingDrsFileexecutorPkeyUpdate;
  DrsFileexecutorPatch: DrsFileexecutorPatch;
  DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoDjangoContentTypeCreateInput: DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoDjangoContentTypeCreateInput;
  DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoDrsFileexecutorCreateInput: DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoDrsFileexecutorCreateInput;
  DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInput: DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInput;
  DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput: DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput;
  DrsFileexecutorToManyCodeFileFilter: DrsFileexecutorToManyCodeFileFilter;
  DrsFileexecutorsConnection: ResolverTypeWrapper<DrsFileexecutorsConnection>;
  DrsFileexecutorsEdge: ResolverTypeWrapper<DrsFileexecutorsEdge>;
  DrsFileexecutorsOrderBy: DrsFileexecutorsOrderBy;
  DrsMockfileexecutor: ResolverTypeWrapper<DrsMockfileexecutor>;
  DrsMockfileexecutorCondition: DrsMockfileexecutorCondition;
  DrsMockfileexecutorDrsMockfileexecutorPkeyConnect: DrsMockfileexecutorDrsMockfileexecutorPkeyConnect;
  DrsMockfileexecutorDrsMockfileexecutorPkeyDelete: DrsMockfileexecutorDrsMockfileexecutorPkeyDelete;
  DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeDrsFileexecutorCreateInput: DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeDrsFileexecutorCreateInput;
  DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeDrsMockfileexecutorCreateInput: DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeDrsMockfileexecutorCreateInput;
  DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInput: DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInput;
  DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInverseInput: DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInverseInput;
  DrsMockfileexecutorFilter: DrsMockfileexecutorFilter;
  DrsMockfileexecutorInput: DrsMockfileexecutorInput;
  DrsMockfileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeUsingDrsMockfileexecutorPkeyUpdate: DrsMockfileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeUsingDrsMockfileexecutorPkeyUpdate;
  DrsMockfileexecutorPatch: DrsMockfileexecutorPatch;
  DrsMockfileexecutorsConnection: ResolverTypeWrapper<DrsMockfileexecutorsConnection>;
  DrsMockfileexecutorsEdge: ResolverTypeWrapper<DrsMockfileexecutorsEdge>;
  DrsMockfileexecutorsOrderBy: DrsMockfileexecutorsOrderBy;
  EulaVersion: ResolverTypeWrapper<EulaVersion>;
  EulaVersionCondition: EulaVersionCondition;
  EulaVersionEulaVersionPkeyConnect: EulaVersionEulaVersionPkeyConnect;
  EulaVersionEulaVersionPkeyDelete: EulaVersionEulaVersionPkeyDelete;
  EulaVersionEulaVersionVersionKeyConnect: EulaVersionEulaVersionVersionKeyConnect;
  EulaVersionEulaVersionVersionKeyDelete: EulaVersionEulaVersionVersionKeyDelete;
  EulaVersionFilter: EulaVersionFilter;
  EulaVersionInput: EulaVersionInput;
  EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionPkeyUpdate: EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionPkeyUpdate;
  EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionVersionKeyUpdate: EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionVersionKeyUpdate;
  EulaVersionPatch: EulaVersionPatch;
  EulaVersionToManyEulaVersionUserAcceptanceFilter: EulaVersionToManyEulaVersionUserAcceptanceFilter;
  EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionCreateInput: EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionCreateInput;
  EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionUserAcceptanceCreateInput: EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionUserAcceptanceCreateInput;
  EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput: EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput;
  EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInverseInput: EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInverseInput;
  EulaVersionUserAcUserIdB72Ed9C5FkApplicatiApplicationUserCreateInput: EulaVersionUserAcUserIdB72Ed9C5FkApplicatiApplicationUserCreateInput;
  EulaVersionUserAcUserIdB72Ed9C5FkApplicatiEulaVersionUserAcceptanceCreateInput: EulaVersionUserAcUserIdB72Ed9C5FkApplicatiEulaVersionUserAcceptanceCreateInput;
  EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput: EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput;
  EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput: EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput;
  EulaVersionUserAcceptance: ResolverTypeWrapper<EulaVersionUserAcceptance>;
  EulaVersionUserAcceptanceCondition: EulaVersionUserAcceptanceCondition;
  EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyConnect: EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyConnect;
  EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyDelete: EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyDelete;
  EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueConnect: EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueConnect;
  EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueDelete: EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueDelete;
  EulaVersionUserAcceptanceFilter: EulaVersionUserAcceptanceFilter;
  EulaVersionUserAcceptanceInput: EulaVersionUserAcceptanceInput;
  EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptancePkeyUpdate: EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptancePkeyUpdate;
  EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptanceUniqueUpdate: EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptanceUniqueUpdate;
  EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptancePkeyUpdate: EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptancePkeyUpdate;
  EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptanceUniqueUpdate: EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptanceUniqueUpdate;
  EulaVersionUserAcceptancePatch: EulaVersionUserAcceptancePatch;
  EulaVersionUserAcceptancesConnection: ResolverTypeWrapper<EulaVersionUserAcceptancesConnection>;
  EulaVersionUserAcceptancesEdge: ResolverTypeWrapper<EulaVersionUserAcceptancesEdge>;
  EulaVersionUserAcceptancesOrderBy: EulaVersionUserAcceptancesOrderBy;
  EulaVersionsConnection: ResolverTypeWrapper<EulaVersionsConnection>;
  EulaVersionsEdge: ResolverTypeWrapper<EulaVersionsEdge>;
  EulaVersionsOrderBy: EulaVersionsOrderBy;
  FeatureFlag: ResolverTypeWrapper<FeatureFlag>;
  FeatureFlagCondition: FeatureFlagCondition;
  FeatureFlagFeatureFlagsNameKeyConnect: FeatureFlagFeatureFlagsNameKeyConnect;
  FeatureFlagFeatureFlagsNameKeyDelete: FeatureFlagFeatureFlagsNameKeyDelete;
  FeatureFlagFeatureFlagsPkeyConnect: FeatureFlagFeatureFlagsPkeyConnect;
  FeatureFlagFeatureFlagsPkeyDelete: FeatureFlagFeatureFlagsPkeyDelete;
  FeatureFlagFilter: FeatureFlagFilter;
  FeatureFlagInput: FeatureFlagInput;
  FeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsNameKeyUpdate: FeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsNameKeyUpdate;
  FeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsPkeyUpdate: FeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsPkeyUpdate;
  FeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsNameKeyUpdate: FeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsNameKeyUpdate;
  FeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsPkeyUpdate: FeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsPkeyUpdate;
  FeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsNameKeyUpdate: FeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsNameKeyUpdate;
  FeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsPkeyUpdate: FeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsPkeyUpdate;
  FeatureFlagPatch: FeatureFlagPatch;
  FeatureFlagToManyFeatureFlagsGroupFilter: FeatureFlagToManyFeatureFlagsGroupFilter;
  FeatureFlagToManyFeatureFlagsTenantFilter: FeatureFlagToManyFeatureFlagsTenantFilter;
  FeatureFlagToManyFeatureFlagsUserFilter: FeatureFlagToManyFeatureFlagsUserFilter;
  FeatureFlagsConnection: ResolverTypeWrapper<FeatureFlagsConnection>;
  FeatureFlagsEdge: ResolverTypeWrapper<FeatureFlagsEdge>;
  FeatureFlagsGroup: ResolverTypeWrapper<FeatureFlagsGroup>;
  FeatureFlagsGroupCondition: FeatureFlagsGroupCondition;
  FeatureFlagsGroupFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqConnect: FeatureFlagsGroupFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqConnect;
  FeatureFlagsGroupFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqDelete: FeatureFlagsGroupFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqDelete;
  FeatureFlagsGroupFeatureFlagsGroupsPkeyConnect: FeatureFlagsGroupFeatureFlagsGroupsPkeyConnect;
  FeatureFlagsGroupFeatureFlagsGroupsPkeyDelete: FeatureFlagsGroupFeatureFlagsGroupsPkeyDelete;
  FeatureFlagsGroupFilter: FeatureFlagsGroupFilter;
  FeatureFlagsGroupInput: FeatureFlagsGroupInput;
  FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqUpdate: FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqUpdate;
  FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsGroupsPkeyUpdate: FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsGroupsPkeyUpdate;
  FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqUpdate: FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqUpdate;
  FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingFeatureFlagsGroupsPkeyUpdate: FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingFeatureFlagsGroupsPkeyUpdate;
  FeatureFlagsGroupPatch: FeatureFlagsGroupPatch;
  FeatureFlagsGroupsConnection: ResolverTypeWrapper<FeatureFlagsGroupsConnection>;
  FeatureFlagsGroupsEdge: ResolverTypeWrapper<FeatureFlagsGroupsEdge>;
  FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFFeatureFlagsCreateInput: FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFFeatureFlagsCreateInput;
  FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFFeatureFlagsGroupsCreateInput: FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFFeatureFlagsGroupsCreateInput;
  FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInput: FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInput;
  FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInverseInput: FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInverseInput;
  FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdAuthGroupCreateInput: FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdAuthGroupCreateInput;
  FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdFeatureFlagsGroupsCreateInput: FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdFeatureFlagsGroupsCreateInput;
  FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInput: FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInput;
  FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInverseInput: FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInverseInput;
  FeatureFlagsGroupsOrderBy: FeatureFlagsGroupsOrderBy;
  FeatureFlagsOrderBy: FeatureFlagsOrderBy;
  FeatureFlagsTenant: ResolverTypeWrapper<FeatureFlagsTenant>;
  FeatureFlagsTenantCondition: FeatureFlagsTenantCondition;
  FeatureFlagsTenantFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqConnect: FeatureFlagsTenantFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqConnect;
  FeatureFlagsTenantFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqDelete: FeatureFlagsTenantFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqDelete;
  FeatureFlagsTenantFeatureFlagsTenantsPkeyConnect: FeatureFlagsTenantFeatureFlagsTenantsPkeyConnect;
  FeatureFlagsTenantFeatureFlagsTenantsPkeyDelete: FeatureFlagsTenantFeatureFlagsTenantsPkeyDelete;
  FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFFeatureFlagsCreateInput: FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFFeatureFlagsCreateInput;
  FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFFeatureFlagsTenantsCreateInput: FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFFeatureFlagsTenantsCreateInput;
  FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInput: FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInput;
  FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInverseInput: FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInverseInput;
  FeatureFlagsTenantFilter: FeatureFlagsTenantFilter;
  FeatureFlagsTenantInput: FeatureFlagsTenantInput;
  FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqUpdate: FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqUpdate;
  FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsTenantsPkeyUpdate: FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsTenantsPkeyUpdate;
  FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqUpdate: FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqUpdate;
  FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingFeatureFlagsTenantsPkeyUpdate: FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingFeatureFlagsTenantsPkeyUpdate;
  FeatureFlagsTenantPatch: FeatureFlagsTenantPatch;
  FeatureFlagsTenantsConnection: ResolverTypeWrapper<FeatureFlagsTenantsConnection>;
  FeatureFlagsTenantsEdge: ResolverTypeWrapper<FeatureFlagsTenantsEdge>;
  FeatureFlagsTenantsOrderBy: FeatureFlagsTenantsOrderBy;
  FeatureFlagsTenantsTenantId6D718C42FkTenantIdFeatureFlagsTenantsCreateInput: FeatureFlagsTenantsTenantId6D718C42FkTenantIdFeatureFlagsTenantsCreateInput;
  FeatureFlagsTenantsTenantId6D718C42FkTenantIdInput: FeatureFlagsTenantsTenantId6D718C42FkTenantIdInput;
  FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput: FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput;
  FeatureFlagsTenantsTenantId6D718C42FkTenantIdTenantCreateInput: FeatureFlagsTenantsTenantId6D718C42FkTenantIdTenantCreateInput;
  FeatureFlagsUser: ResolverTypeWrapper<FeatureFlagsUser>;
  FeatureFlagsUserCondition: FeatureFlagsUserCondition;
  FeatureFlagsUserFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqConnect: FeatureFlagsUserFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqConnect;
  FeatureFlagsUserFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqDelete: FeatureFlagsUserFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqDelete;
  FeatureFlagsUserFeatureFlagsUsersPkeyConnect: FeatureFlagsUserFeatureFlagsUsersPkeyConnect;
  FeatureFlagsUserFeatureFlagsUsersPkeyDelete: FeatureFlagsUserFeatureFlagsUsersPkeyDelete;
  FeatureFlagsUserFilter: FeatureFlagsUserFilter;
  FeatureFlagsUserInput: FeatureFlagsUserInput;
  FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqUpdate: FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqUpdate;
  FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsUsersPkeyUpdate: FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsUsersPkeyUpdate;
  FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqUpdate: FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqUpdate;
  FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingFeatureFlagsUsersPkeyUpdate: FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingFeatureFlagsUsersPkeyUpdate;
  FeatureFlagsUserPatch: FeatureFlagsUserPatch;
  FeatureFlagsUsersConnection: ResolverTypeWrapper<FeatureFlagsUsersConnection>;
  FeatureFlagsUsersEdge: ResolverTypeWrapper<FeatureFlagsUsersEdge>;
  FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdFeatureFlagsCreateInput: FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdFeatureFlagsCreateInput;
  FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdFeatureFlagsUsersCreateInput: FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdFeatureFlagsUsersCreateInput;
  FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInput: FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInput;
  FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInverseInput: FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInverseInput;
  FeatureFlagsUsersOrderBy: FeatureFlagsUsersOrderBy;
  FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdApplicationUserCreateInput: FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdApplicationUserCreateInput;
  FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdFeatureFlagsUsersCreateInput: FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdFeatureFlagsUsersCreateInput;
  FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInput: FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInput;
  FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput: FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput;
  File: ResolverTypeWrapper<File>;
  FileActivitiesConnection: ResolverTypeWrapper<FileActivitiesConnection>;
  FileActivitiesEdge: ResolverTypeWrapper<FileActivitiesEdge>;
  FileActivitiesOrderBy: FileActivitiesOrderBy;
  FileActivity: ResolverTypeWrapper<FileActivity>;
  FileActivityCondition: FileActivityCondition;
  FileActivityContentTypeIdD010Fc58FkDjangoCoDjangoContentTypeCreateInput: FileActivityContentTypeIdD010Fc58FkDjangoCoDjangoContentTypeCreateInput;
  FileActivityContentTypeIdD010Fc58FkDjangoCoFileActivityCreateInput: FileActivityContentTypeIdD010Fc58FkDjangoCoFileActivityCreateInput;
  FileActivityContentTypeIdD010Fc58FkDjangoCoInput: FileActivityContentTypeIdD010Fc58FkDjangoCoInput;
  FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput: FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput;
  FileActivityCostId2A88D90AFkCostIdCostCreateInput: FileActivityCostId2A88D90AFkCostIdCostCreateInput;
  FileActivityCostId2A88D90AFkCostIdFileActivityCreateInput: FileActivityCostId2A88D90AFkCostIdFileActivityCreateInput;
  FileActivityCostId2A88D90AFkCostIdInput: FileActivityCostId2A88D90AFkCostIdInput;
  FileActivityCostId2A88D90AFkCostIdInverseInput: FileActivityCostId2A88D90AFkCostIdInverseInput;
  FileActivityFileActivityPkeyConnect: FileActivityFileActivityPkeyConnect;
  FileActivityFileActivityPkeyDelete: FileActivityFileActivityPkeyDelete;
  FileActivityFileId015763A9FkFileIdFileActivityCreateInput: FileActivityFileId015763A9FkFileIdFileActivityCreateInput;
  FileActivityFileId015763A9FkFileIdFileCreateInput: FileActivityFileId015763A9FkFileIdFileCreateInput;
  FileActivityFileId015763A9FkFileIdInput: FileActivityFileId015763A9FkFileIdInput;
  FileActivityFileId015763A9FkFileIdInverseInput: FileActivityFileId015763A9FkFileIdInverseInput;
  FileActivityFilter: FileActivityFilter;
  FileActivityInput: FileActivityInput;
  FileActivityOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingFileActivityPkeyUpdate;
  FileActivityOnFileActivityForFileActivityCostId2A88D90AFkCostIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityCostId2A88D90AFkCostIdUsingFileActivityPkeyUpdate;
  FileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFileActivityPkeyUpdate;
  FileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingFileActivityPkeyUpdate;
  FileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingFileActivityPkeyUpdate;
  FileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingFileActivityPkeyUpdate;
  FileActivityPatch: FileActivityPatch;
  FileActivityProjectId6F35B8CcFkProjectIdFileActivityCreateInput: FileActivityProjectId6F35B8CcFkProjectIdFileActivityCreateInput;
  FileActivityProjectId6F35B8CcFkProjectIdInput: FileActivityProjectId6F35B8CcFkProjectIdInput;
  FileActivityProjectId6F35B8CcFkProjectIdInverseInput: FileActivityProjectId6F35B8CcFkProjectIdInverseInput;
  FileActivityTenantIdC46A4F01FkTenantIdFileActivityCreateInput: FileActivityTenantIdC46A4F01FkTenantIdFileActivityCreateInput;
  FileActivityTenantIdC46A4F01FkTenantIdInput: FileActivityTenantIdC46A4F01FkTenantIdInput;
  FileActivityTenantIdC46A4F01FkTenantIdInverseInput: FileActivityTenantIdC46A4F01FkTenantIdInverseInput;
  FileActivityTenantIdC46A4F01FkTenantIdTenantCreateInput: FileActivityTenantIdC46A4F01FkTenantIdTenantCreateInput;
  FileActivityUserId868Ad8A9FkApplicationUserIdApplicationUserCreateInput: FileActivityUserId868Ad8A9FkApplicationUserIdApplicationUserCreateInput;
  FileActivityUserId868Ad8A9FkApplicationUserIdFileActivityCreateInput: FileActivityUserId868Ad8A9FkApplicationUserIdFileActivityCreateInput;
  FileActivityUserId868Ad8A9FkApplicationUserIdInput: FileActivityUserId868Ad8A9FkApplicationUserIdInput;
  FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput: FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput;
  FileCondition: FileCondition;
  FileExecutorId819Da590FkDrsFileexecutorIdInput: FileExecutorId819Da590FkDrsFileexecutorIdInput;
  FileExecutorId819Da590FkDrsFileexecutorIdInverseInput: FileExecutorId819Da590FkDrsFileexecutorIdInverseInput;
  FileFilePkeyConnect: FileFilePkeyConnect;
  FileFilePkeyDelete: FileFilePkeyDelete;
  FileFilter: FileFilter;
  FileInput: FileInput;
  FileMetadataConnection: ResolverTypeWrapper<FileMetadataConnection>;
  FileMetadataEdge: ResolverTypeWrapper<FileMetadataEdge>;
  FileMetadataFileId78256936FkFileIdFileCreateInput: FileMetadataFileId78256936FkFileIdFileCreateInput;
  FileMetadataFileId78256936FkFileIdFileMetadataCreateInput: FileMetadataFileId78256936FkFileIdFileMetadataCreateInput;
  FileMetadataFileId78256936FkFileIdInput: FileMetadataFileId78256936FkFileIdInput;
  FileMetadataFileId78256936FkFileIdInverseInput: FileMetadataFileId78256936FkFileIdInverseInput;
  FileMetadataMetadataIdFefc0061FkMetadataIdFileMetadataCreateInput: FileMetadataMetadataIdFefc0061FkMetadataIdFileMetadataCreateInput;
  FileMetadataMetadataIdFefc0061FkMetadataIdInput: FileMetadataMetadataIdFefc0061FkMetadataIdInput;
  FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput: FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput;
  FileMetadataMetadataIdFefc0061FkMetadataIdMetadataCreateInput: FileMetadataMetadataIdFefc0061FkMetadataIdMetadataCreateInput;
  FileMetadataOrderBy: FileMetadataOrderBy;
  FileMetadataProjectId3474994EFkProjectIdFileMetadataCreateInput: FileMetadataProjectId3474994EFkProjectIdFileMetadataCreateInput;
  FileMetadataProjectId3474994EFkProjectIdInput: FileMetadataProjectId3474994EFkProjectIdInput;
  FileMetadataProjectId3474994EFkProjectIdInverseInput: FileMetadataProjectId3474994EFkProjectIdInverseInput;
  FileMetadataTenantId79Fe438BFkTenantIdFileMetadataCreateInput: FileMetadataTenantId79Fe438BFkTenantIdFileMetadataCreateInput;
  FileMetadataTenantId79Fe438BFkTenantIdInput: FileMetadataTenantId79Fe438BFkTenantIdInput;
  FileMetadataTenantId79Fe438BFkTenantIdInverseInput: FileMetadataTenantId79Fe438BFkTenantIdInverseInput;
  FileMetadataTenantId79Fe438BFkTenantIdTenantCreateInput: FileMetadataTenantId79Fe438BFkTenantIdTenantCreateInput;
  FileMetadatum: ResolverTypeWrapper<FileMetadatum>;
  FileMetadatumCondition: FileMetadatumCondition;
  FileMetadatumFileMetadataPkeyConnect: FileMetadatumFileMetadataPkeyConnect;
  FileMetadatumFileMetadataPkeyDelete: FileMetadatumFileMetadataPkeyDelete;
  FileMetadatumFilter: FileMetadatumFilter;
  FileMetadatumInput: FileMetadatumInput;
  FileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFileMetadataPkeyUpdate: FileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFileMetadataPkeyUpdate;
  FileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingFileMetadataPkeyUpdate: FileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingFileMetadataPkeyUpdate;
  FileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingFileMetadataPkeyUpdate: FileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingFileMetadataPkeyUpdate;
  FileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingFileMetadataPkeyUpdate: FileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingFileMetadataPkeyUpdate;
  FileMetadatumPatch: FileMetadatumPatch;
  FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFilePkeyUpdate: FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFilePkeyUpdate;
  FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileProjectId3Ecca975FkProjectIdUsingFilePkeyUpdate: FileOnFileForFileProjectId3Ecca975FkProjectIdUsingFilePkeyUpdate;
  FileOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingFilePkeyUpdate: FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingFilePkeyUpdate;
  FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingFilePkeyUpdate: FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingFilePkeyUpdate;
  FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileTenantId61625016FkTenantIdUsingFilePkeyUpdate: FileOnFileForFileTenantId61625016FkTenantIdUsingFilePkeyUpdate;
  FileOnFileForFileTenantId61625016FkTenantIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileTenantId61625016FkTenantIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingFilePkeyUpdate: FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingFilePkeyUpdate;
  FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFilePkeyUpdate: FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFilePkeyUpdate;
  FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFilePkeyUpdate: FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFilePkeyUpdate;
  FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingFilePkeyUpdate: FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingFilePkeyUpdate;
  FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingFilePkeyUpdate: FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingFilePkeyUpdate;
  FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOutputGroup: ResolverTypeWrapper<FileOutputGroup>;
  FileOutputGroupCondition: FileOutputGroupCondition;
  FileOutputGroupFileOutputGroupPkeyConnect: FileOutputGroupFileOutputGroupPkeyConnect;
  FileOutputGroupFileOutputGroupPkeyDelete: FileOutputGroupFileOutputGroupPkeyDelete;
  FileOutputGroupFileOutputGroupTaskIdKeyConnect: FileOutputGroupFileOutputGroupTaskIdKeyConnect;
  FileOutputGroupFileOutputGroupTaskIdKeyDelete: FileOutputGroupFileOutputGroupTaskIdKeyDelete;
  FileOutputGroupFilter: FileOutputGroupFilter;
  FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpFileOutputGroupMetadataCreateInput: FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpFileOutputGroupMetadataCreateInput;
  FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput: FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput;
  FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput: FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput;
  FileOutputGroupMetadataConnection: ResolverTypeWrapper<FileOutputGroupMetadataConnection>;
  FileOutputGroupMetadataEdge: ResolverTypeWrapper<FileOutputGroupMetadataEdge>;
  FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdFileOutputGroupMetadataCreateInput: FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdFileOutputGroupMetadataCreateInput;
  FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput: FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput;
  FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput: FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput;
  FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdMetadataCreateInput: FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdMetadataCreateInput;
  FileOutputGroupMetadataOrderBy: FileOutputGroupMetadataOrderBy;
  FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdFileOutputGroupMetadataCreateInput: FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdFileOutputGroupMetadataCreateInput;
  FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput: FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput;
  FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput: FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput;
  FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdFileOutputGroupMetadataCreateInput: FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdFileOutputGroupMetadataCreateInput;
  FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput: FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput;
  FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput: FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput;
  FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdTenantCreateInput: FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdTenantCreateInput;
  FileOutputGroupMetadatum: ResolverTypeWrapper<FileOutputGroupMetadatum>;
  FileOutputGroupMetadatumCondition: FileOutputGroupMetadatumCondition;
  FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect: FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect;
  FileOutputGroupMetadatumFileOutputGroupMetadataPkeyDelete: FileOutputGroupMetadatumFileOutputGroupMetadataPkeyDelete;
  FileOutputGroupMetadatumFilter: FileOutputGroupMetadatumFilter;
  FileOutputGroupMetadatumInput: FileOutputGroupMetadatumInput;
  FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupMetadataPkeyUpdate: FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupMetadataPkeyUpdate;
  FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingFileOutputGroupMetadataPkeyUpdate: FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingFileOutputGroupMetadataPkeyUpdate;
  FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingFileOutputGroupMetadataPkeyUpdate: FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingFileOutputGroupMetadataPkeyUpdate;
  FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingFileOutputGroupMetadataPkeyUpdate: FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingFileOutputGroupMetadataPkeyUpdate;
  FileOutputGroupMetadatumPatch: FileOutputGroupMetadatumPatch;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupPatch: FileOutputGroupPatch;
  FileOutputGroupProjectId908Fb9FfFkProjectIdInput: FileOutputGroupProjectId908Fb9FfFkProjectIdInput;
  FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput: FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput;
  FileOutputGroupTaskId2B1Df6A1FkTaskIdInput: FileOutputGroupTaskId2B1Df6A1FkTaskIdInput;
  FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput: FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput;
  FileOutputGroupTaskId2B1Df6A1FkTaskIdTaskCreateInput: FileOutputGroupTaskId2B1Df6A1FkTaskIdTaskCreateInput;
  FileOutputGroupTenantId3Fa46D44FkTenantIdInput: FileOutputGroupTenantId3Fa46D44FkTenantIdInput;
  FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput: FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput;
  FileOutputGroupTenantId3Fa46D44FkTenantIdTenantCreateInput: FileOutputGroupTenantId3Fa46D44FkTenantIdTenantCreateInput;
  FileOutputGroupToManyFileOutputGroupMetadatumFilter: FileOutputGroupToManyFileOutputGroupMetadatumFilter;
  FileOutputGroupToManyOutputGroupFileFilter: FileOutputGroupToManyOutputGroupFileFilter;
  FileOutputGroupUserIdB22Ec436FkApplicationUserIdApplicationUserCreateInput: FileOutputGroupUserIdB22Ec436FkApplicationUserIdApplicationUserCreateInput;
  FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput: FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput;
  FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput: FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput;
  FileOutputGroupsConnection: ResolverTypeWrapper<FileOutputGroupsConnection>;
  FileOutputGroupsEdge: ResolverTypeWrapper<FileOutputGroupsEdge>;
  FileOutputGroupsOrderBy: FileOutputGroupsOrderBy;
  FilePatch: FilePatch;
  FileProcessingNotiUserId08265156FkApplicatiApplicationUserCreateInput: FileProcessingNotiUserId08265156FkApplicatiApplicationUserCreateInput;
  FileProcessingNotiUserId08265156FkApplicatiInput: FileProcessingNotiUserId08265156FkApplicatiInput;
  FileProcessingNotiUserId08265156FkApplicatiInverseInput: FileProcessingNotiUserId08265156FkApplicatiInverseInput;
  FileProcessingNotification: ResolverTypeWrapper<FileProcessingNotification>;
  FileProcessingNotificationCondition: FileProcessingNotificationCondition;
  FileProcessingNotificationFileId717B514EFkFileIdFileCreateInput: FileProcessingNotificationFileId717B514EFkFileIdFileCreateInput;
  FileProcessingNotificationFileId717B514EFkFileIdInput: FileProcessingNotificationFileId717B514EFkFileIdInput;
  FileProcessingNotificationFileId717B514EFkFileIdInverseInput: FileProcessingNotificationFileId717B514EFkFileIdInverseInput;
  FileProcessingNotificationFileProcessingNotificationPkeyConnect: FileProcessingNotificationFileProcessingNotificationPkeyConnect;
  FileProcessingNotificationFilter: FileProcessingNotificationFilter;
  FileProcessingNotificationId630E6495FkNotificationIdInput: FileProcessingNotificationId630E6495FkNotificationIdInput;
  FileProcessingNotificationId630E6495FkNotificationIdInverseInput: FileProcessingNotificationId630E6495FkNotificationIdInverseInput;
  FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingFileProcessingNotificationPkeyUpdate: FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingFileProcessingNotificationPkeyUpdate;
  FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFileProcessingNotificationPkeyUpdate: FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFileProcessingNotificationPkeyUpdate;
  FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingFileProcessingNotificationPkeyUpdate: FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingFileProcessingNotificationPkeyUpdate;
  FileProcessingNotificationsConnection: ResolverTypeWrapper<FileProcessingNotificationsConnection>;
  FileProcessingNotificationsEdge: ResolverTypeWrapper<FileProcessingNotificationsEdge>;
  FileProcessingNotificationsOrderBy: FileProcessingNotificationsOrderBy;
  FileProjectId3Ecca975FkProjectIdFileCreateInput: FileProjectId3Ecca975FkProjectIdFileCreateInput;
  FileProjectId3Ecca975FkProjectIdInput: FileProjectId3Ecca975FkProjectIdInput;
  FileProjectId3Ecca975FkProjectIdInverseInput: FileProjectId3Ecca975FkProjectIdInverseInput;
  FileProjectReferenceIdUniqueConnect: FileProjectReferenceIdUniqueConnect;
  FileProjectReferenceIdUniqueDelete: FileProjectReferenceIdUniqueDelete;
  FileSeriesParentIdF7A07E20FkFileIdFileCreateInput: FileSeriesParentIdF7A07E20FkFileIdFileCreateInput;
  FileSeriesParentIdF7A07E20FkFileIdInput: FileSeriesParentIdF7A07E20FkFileIdInput;
  FileTaskIdE4Da87AeFkTaskIdFileCreateInput: FileTaskIdE4Da87AeFkTaskIdFileCreateInput;
  FileTaskIdE4Da87AeFkTaskIdInput: FileTaskIdE4Da87AeFkTaskIdInput;
  FileTaskIdE4Da87AeFkTaskIdInverseInput: FileTaskIdE4Da87AeFkTaskIdInverseInput;
  FileTaskIdE4Da87AeFkTaskIdTaskCreateInput: FileTaskIdE4Da87AeFkTaskIdTaskCreateInput;
  FileTenantId61625016FkTenantIdFileCreateInput: FileTenantId61625016FkTenantIdFileCreateInput;
  FileTenantId61625016FkTenantIdInput: FileTenantId61625016FkTenantIdInput;
  FileTenantId61625016FkTenantIdInverseInput: FileTenantId61625016FkTenantIdInverseInput;
  FileTenantId61625016FkTenantIdTenantCreateInput: FileTenantId61625016FkTenantIdTenantCreateInput;
  FileToManyFileActivityFilter: FileToManyFileActivityFilter;
  FileToManyFileFilter: FileToManyFileFilter;
  FileToManyFileMetadatumFilter: FileToManyFileMetadatumFilter;
  FileToManyFileProcessingNotificationFilter: FileToManyFileProcessingNotificationFilter;
  FileToManyOutputGroupFileFilter: FileToManyOutputGroupFileFilter;
  FileToManyTaskSourceFilter: FileToManyTaskSourceFilter;
  FileUserId01D90B53FkApplicationUserIdApplicationUserCreateInput: FileUserId01D90B53FkApplicationUserIdApplicationUserCreateInput;
  FileUserId01D90B53FkApplicationUserIdFileCreateInput: FileUserId01D90B53FkApplicationUserIdFileCreateInput;
  FileUserId01D90B53FkApplicationUserIdInput: FileUserId01D90B53FkApplicationUserIdInput;
  FileUserId01D90B53FkApplicationUserIdInverseInput: FileUserId01D90B53FkApplicationUserIdInverseInput;
  FilesByExecutor: ResolverTypeWrapper<FilesByExecutor>;
  FilesByExecutorCondition: FilesByExecutorCondition;
  FilesByExecutorFilter: FilesByExecutorFilter;
  FilesByExecutorInput: FilesByExecutorInput;
  FilesByExecutorsConnection: ResolverTypeWrapper<FilesByExecutorsConnection>;
  FilesByExecutorsEdge: ResolverTypeWrapper<FilesByExecutorsEdge>;
  FilesByExecutorsOrderBy: FilesByExecutorsOrderBy;
  FilesConnection: ResolverTypeWrapper<FilesConnection>;
  FilesEdge: ResolverTypeWrapper<FilesEdge>;
  FilesOrderBy: FilesOrderBy;
  Float: ResolverTypeWrapper<Scalars["Float"]["output"]>;
  FloatFilter: FloatFilter;
  GdtAnalysisTable: ResolverTypeWrapper<GdtAnalysisTable>;
  GdtAnalysisTableCColumnId54344A43FkGdtAnalyInput: GdtAnalysisTableCColumnId54344A43FkGdtAnalyInput;
  GdtAnalysisTableCColumnId54344A43FkGdtAnalyInverseInput: GdtAnalysisTableCColumnId54344A43FkGdtAnalyInverseInput;
  GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoDjangoContentTypeCreateInput: GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoDjangoContentTypeCreateInput;
  GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInput: GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInput;
  GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput: GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput;
  GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoDjangoContentTypeCreateInput: GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoDjangoContentTypeCreateInput;
  GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInput: GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInput;
  GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput: GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput;
  GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInput: GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInput;
  GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInverseInput: GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInverseInput;
  GdtAnalysisTableCProjectId77B86B06FkProjectIInput: GdtAnalysisTableCProjectId77B86B06FkProjectIInput;
  GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput: GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput;
  GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInput: GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInput;
  GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInverseInput: GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInverseInput;
  GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInput: GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInput;
  GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInverseInput: GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInverseInput;
  GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInput: GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInput;
  GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInverseInput: GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInverseInput;
  GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInput: GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInput;
  GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInverseInput: GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInverseInput;
  GdtAnalysisTableCUserId75C939B7FkApplicatiApplicationUserCreateInput: GdtAnalysisTableCUserId75C939B7FkApplicatiApplicationUserCreateInput;
  GdtAnalysisTableCUserId75C939B7FkApplicatiInput: GdtAnalysisTableCUserId75C939B7FkApplicatiInput;
  GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput: GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput;
  GdtAnalysisTableCUserId8709Cf1FFkApplicatiApplicationUserCreateInput: GdtAnalysisTableCUserId8709Cf1FFkApplicatiApplicationUserCreateInput;
  GdtAnalysisTableCUserId8709Cf1FFkApplicatiInput: GdtAnalysisTableCUserId8709Cf1FFkApplicatiInput;
  GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput: GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput;
  GdtAnalysisTableCell: ResolverTypeWrapper<GdtAnalysisTableCell>;
  GdtAnalysisTableCellCondition: GdtAnalysisTableCellCondition;
  GdtAnalysisTableCellFilter: GdtAnalysisTableCellFilter;
  GdtAnalysisTableCellGdtAnalysisTableCellPkeyConnect: GdtAnalysisTableCellGdtAnalysisTableCellPkeyConnect;
  GdtAnalysisTableCellGdtAnalysisTableCellUniqueConnect: GdtAnalysisTableCellGdtAnalysisTableCellUniqueConnect;
  GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate: GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate;
  GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate: GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate;
  GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate: GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate;
  GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate: GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate;
  GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate: GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate;
  GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate: GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate;
  GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingGdtAnalysisTableCellPkeyUpdate: GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingGdtAnalysisTableCellPkeyUpdate;
  GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingGdtAnalysisTableCellUniqueUpdate: GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingGdtAnalysisTableCellUniqueUpdate;
  GdtAnalysisTableCellProjectId57B70FedFkProjectIdInput: GdtAnalysisTableCellProjectId57B70FedFkProjectIdInput;
  GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput: GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput;
  GdtAnalysisTableCellsConnection: ResolverTypeWrapper<GdtAnalysisTableCellsConnection>;
  GdtAnalysisTableCellsEdge: ResolverTypeWrapper<GdtAnalysisTableCellsEdge>;
  GdtAnalysisTableCellsOrderBy: GdtAnalysisTableCellsOrderBy;
  GdtAnalysisTableColumn: ResolverTypeWrapper<GdtAnalysisTableColumn>;
  GdtAnalysisTableColumnCondition: GdtAnalysisTableColumnCondition;
  GdtAnalysisTableColumnFilter: GdtAnalysisTableColumnFilter;
  GdtAnalysisTableColumnGdtAnalysisTableColumnPkeyConnect: GdtAnalysisTableColumnGdtAnalysisTableColumnPkeyConnect;
  GdtAnalysisTableColumnGdtAnalysisTableColumnUniqueConnect: GdtAnalysisTableColumnGdtAnalysisTableColumnUniqueConnect;
  GdtAnalysisTableColumnGroup: ResolverTypeWrapper<GdtAnalysisTableColumnGroup>;
  GdtAnalysisTableColumnGroupCondition: GdtAnalysisTableColumnGroupCondition;
  GdtAnalysisTableColumnGroupFilter: GdtAnalysisTableColumnGroupFilter;
  GdtAnalysisTableColumnGroupGdtAnalysisTableColumnGroupPkeyConnect: GdtAnalysisTableColumnGroupGdtAnalysisTableColumnGroupPkeyConnect;
  GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnGroupPkeyUpdate: GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnGroupPkeyUpdate;
  GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingGdtAnalysisTableColumnGroupPkeyUpdate: GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingGdtAnalysisTableColumnGroupPkeyUpdate;
  GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingGdtAnalysisTableColumnGroupPkeyUpdate: GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingGdtAnalysisTableColumnGroupPkeyUpdate;
  GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyUsingGdtAnalysisTableColumnGroupPkeyUpdate: GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyUsingGdtAnalysisTableColumnGroupPkeyUpdate;
  GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingGdtAnalysisTableColumnGroupPkeyUpdate: GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingGdtAnalysisTableColumnGroupPkeyUpdate;
  GdtAnalysisTableColumnGroupToManyGdtAnalysisTableColumnFilter: GdtAnalysisTableColumnGroupToManyGdtAnalysisTableColumnFilter;
  GdtAnalysisTableColumnGroupsConnection: ResolverTypeWrapper<GdtAnalysisTableColumnGroupsConnection>;
  GdtAnalysisTableColumnGroupsEdge: ResolverTypeWrapper<GdtAnalysisTableColumnGroupsEdge>;
  GdtAnalysisTableColumnGroupsOrderBy: GdtAnalysisTableColumnGroupsOrderBy;
  GdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingGdtAnalysisTableColumnPkeyUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingGdtAnalysisTableColumnPkeyUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingGdtAnalysisTableColumnUniqueUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingGdtAnalysisTableColumnUniqueUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingGdtAnalysisTableColumnPkeyUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingGdtAnalysisTableColumnPkeyUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingGdtAnalysisTableColumnUniqueUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingGdtAnalysisTableColumnUniqueUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingGdtAnalysisTableColumnPkeyUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingGdtAnalysisTableColumnPkeyUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingGdtAnalysisTableColumnUniqueUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingGdtAnalysisTableColumnUniqueUpdate;
  GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInput: GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInput;
  GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput: GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput;
  GdtAnalysisTableColumnToManyGdtAnalysisTableCellFilter: GdtAnalysisTableColumnToManyGdtAnalysisTableCellFilter;
  GdtAnalysisTableColumnsConnection: ResolverTypeWrapper<GdtAnalysisTableColumnsConnection>;
  GdtAnalysisTableColumnsEdge: ResolverTypeWrapper<GdtAnalysisTableColumnsEdge>;
  GdtAnalysisTableColumnsOrderBy: GdtAnalysisTableColumnsOrderBy;
  GdtAnalysisTableCondition: GdtAnalysisTableCondition;
  GdtAnalysisTableFilter: GdtAnalysisTableFilter;
  GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput: GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput;
  GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput: GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput;
  GdtAnalysisTableFolderId6A997B49FkProjectFolderIdProjectFolderCreateInput: GdtAnalysisTableFolderId6A997B49FkProjectFolderIdProjectFolderCreateInput;
  GdtAnalysisTableGdtAnalysisTablePkeyConnect: GdtAnalysisTableGdtAnalysisTablePkeyConnect;
  GdtAnalysisTableOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableProjectId544B76D9FkProjectIdInput: GdtAnalysisTableProjectId544B76D9FkProjectIdInput;
  GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput: GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput;
  GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput: GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput;
  GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput: GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput;
  GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput: GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput;
  GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput: GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput;
  GdtAnalysisTableRToolVersionId0050D5BdFkToolVersToolVersionCreateInput: GdtAnalysisTableRToolVersionId0050D5BdFkToolVersToolVersionCreateInput;
  GdtAnalysisTableRow: ResolverTypeWrapper<GdtAnalysisTableRow>;
  GdtAnalysisTableRowCondition: GdtAnalysisTableRowCondition;
  GdtAnalysisTableRowFilter: GdtAnalysisTableRowFilter;
  GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect: GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect;
  GdtAnalysisTableRowGdtAnalysisTableRowTaskIdKeyConnect: GdtAnalysisTableRowGdtAnalysisTableRowTaskIdKeyConnect;
  GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect: GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect;
  GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowTaskIdKeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowTaskIdKeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowTaskIdKeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowTaskIdKeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowTaskIdKeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowTaskIdKeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowTaskIdKeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowTaskIdKeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowTaskIdKeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowTaskIdKeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowTaskIdKeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowTaskIdKeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput: GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput;
  GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput: GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput;
  GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput: GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput;
  GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput: GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput;
  GdtAnalysisTableRowTaskId14Ab233FFkTaskIdTaskCreateInput: GdtAnalysisTableRowTaskId14Ab233FFkTaskIdTaskCreateInput;
  GdtAnalysisTableRowToManyGdtAnalysisTableCellFilter: GdtAnalysisTableRowToManyGdtAnalysisTableCellFilter;
  GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdApplicationUserCreateInput: GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdApplicationUserCreateInput;
  GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput: GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput;
  GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput: GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput;
  GdtAnalysisTableRowsConnection: ResolverTypeWrapper<GdtAnalysisTableRowsConnection>;
  GdtAnalysisTableRowsEdge: ResolverTypeWrapper<GdtAnalysisTableRowsEdge>;
  GdtAnalysisTableRowsOrderBy: GdtAnalysisTableRowsOrderBy;
  GdtAnalysisTableToManyGdtAnalysisTableCellFilter: GdtAnalysisTableToManyGdtAnalysisTableCellFilter;
  GdtAnalysisTableToManyGdtAnalysisTableColumnFilter: GdtAnalysisTableToManyGdtAnalysisTableColumnFilter;
  GdtAnalysisTableToManyGdtAnalysisTableColumnGroupFilter: GdtAnalysisTableToManyGdtAnalysisTableColumnGroupFilter;
  GdtAnalysisTableToManyGdtAnalysisTableRowFilter: GdtAnalysisTableToManyGdtAnalysisTableRowFilter;
  GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput: GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput;
  GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput: GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput;
  GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdToolVersionCreateInput: GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdToolVersionCreateInput;
  GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdApplicationUserCreateInput: GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdApplicationUserCreateInput;
  GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput: GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput;
  GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput: GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput;
  GdtAnalysisTablesConnection: ResolverTypeWrapper<GdtAnalysisTablesConnection>;
  GdtAnalysisTablesEdge: ResolverTypeWrapper<GdtAnalysisTablesEdge>;
  GdtAnalysisTablesOrderBy: GdtAnalysisTablesOrderBy;
  ID: ResolverTypeWrapper<Scalars["ID"]["output"]>;
  Int: ResolverTypeWrapper<Scalars["Int"]["output"]>;
  IntFilter: IntFilter;
  InternetAddress: ResolverTypeWrapper<Scalars["InternetAddress"]["output"]>;
  InternetAddressFilter: InternetAddressFilter;
  Interval: ResolverTypeWrapper<Interval>;
  IntervalFilter: IntervalFilter;
  IntervalInput: IntervalInput;
  JSON: ResolverTypeWrapper<Scalars["JSON"]["output"]>;
  JSONFilter: JsonFilter;
  MetadataConnection: ResolverTypeWrapper<MetadataConnection>;
  MetadataEdge: ResolverTypeWrapper<MetadataEdge>;
  MetadataOrderBy: MetadataOrderBy;
  MetadataProjectId3333C2AdFkProjectIdInput: MetadataProjectId3333C2AdFkProjectIdInput;
  MetadataProjectId3333C2AdFkProjectIdInverseInput: MetadataProjectId3333C2AdFkProjectIdInverseInput;
  MetadataProjectId3333C2AdFkProjectIdMetadataCreateInput: MetadataProjectId3333C2AdFkProjectIdMetadataCreateInput;
  MetadataTenantIdC1D8772DFkTenantIdInput: MetadataTenantIdC1D8772DFkTenantIdInput;
  MetadataTenantIdC1D8772DFkTenantIdInverseInput: MetadataTenantIdC1D8772DFkTenantIdInverseInput;
  MetadataTenantIdC1D8772DFkTenantIdMetadataCreateInput: MetadataTenantIdC1D8772DFkTenantIdMetadataCreateInput;
  MetadataTenantIdC1D8772DFkTenantIdTenantCreateInput: MetadataTenantIdC1D8772DFkTenantIdTenantCreateInput;
  MetadataValue: ResolverTypeWrapper<MetadataValue>;
  MetadataValueCondition: MetadataValueCondition;
  MetadataValueFilter: MetadataValueFilter;
  MetadataValueInput: MetadataValueInput;
  MetadataValueMetadataId063A53B6FkMetadataIdInput: MetadataValueMetadataId063A53B6FkMetadataIdInput;
  MetadataValueMetadataId063A53B6FkMetadataIdInverseInput: MetadataValueMetadataId063A53B6FkMetadataIdInverseInput;
  MetadataValueMetadataId063A53B6FkMetadataIdMetadataCreateInput: MetadataValueMetadataId063A53B6FkMetadataIdMetadataCreateInput;
  MetadataValueMetadataId063A53B6FkMetadataIdMetadataValueCreateInput: MetadataValueMetadataId063A53B6FkMetadataIdMetadataValueCreateInput;
  MetadataValueMetadataValuePkeyConnect: MetadataValueMetadataValuePkeyConnect;
  MetadataValueMetadataValuePkeyDelete: MetadataValueMetadataValuePkeyDelete;
  MetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataValuePkeyUpdate;
  MetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingMetadataValuePkeyUpdate;
  MetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingMetadataValuePkeyUpdate;
  MetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingMetadataValuePkeyUpdate;
  MetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingMetadataValuePkeyUpdate;
  MetadataValuePatch: MetadataValuePatch;
  MetadataValueProjectId87227D96FkProjectIdInput: MetadataValueProjectId87227D96FkProjectIdInput;
  MetadataValueProjectId87227D96FkProjectIdInverseInput: MetadataValueProjectId87227D96FkProjectIdInverseInput;
  MetadataValueProjectId87227D96FkProjectIdMetadataValueCreateInput: MetadataValueProjectId87227D96FkProjectIdMetadataValueCreateInput;
  MetadataValueTaskId3D37D135FkTaskIdInput: MetadataValueTaskId3D37D135FkTaskIdInput;
  MetadataValueTaskId3D37D135FkTaskIdInverseInput: MetadataValueTaskId3D37D135FkTaskIdInverseInput;
  MetadataValueTaskId3D37D135FkTaskIdMetadataValueCreateInput: MetadataValueTaskId3D37D135FkTaskIdMetadataValueCreateInput;
  MetadataValueTaskId3D37D135FkTaskIdTaskCreateInput: MetadataValueTaskId3D37D135FkTaskIdTaskCreateInput;
  MetadataValueTenantIdB4C2D5D6FkTenantIdInput: MetadataValueTenantIdB4C2D5D6FkTenantIdInput;
  MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput: MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput;
  MetadataValueTenantIdB4C2D5D6FkTenantIdMetadataValueCreateInput: MetadataValueTenantIdB4C2D5D6FkTenantIdMetadataValueCreateInput;
  MetadataValueTenantIdB4C2D5D6FkTenantIdTenantCreateInput: MetadataValueTenantIdB4C2D5D6FkTenantIdTenantCreateInput;
  MetadataValueUserIdB2Bb45AeFkApplicationUserIdApplicationUserCreateInput: MetadataValueUserIdB2Bb45AeFkApplicationUserIdApplicationUserCreateInput;
  MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput: MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput;
  MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput: MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput;
  MetadataValueUserIdB2Bb45AeFkApplicationUserIdMetadataValueCreateInput: MetadataValueUserIdB2Bb45AeFkApplicationUserIdMetadataValueCreateInput;
  MetadataValuesConnection: ResolverTypeWrapper<MetadataValuesConnection>;
  MetadataValuesEdge: ResolverTypeWrapper<MetadataValuesEdge>;
  MetadataValuesOrderBy: MetadataValuesOrderBy;
  Metadatum: ResolverTypeWrapper<Metadatum>;
  MetadatumCondition: MetadatumCondition;
  MetadatumFilter: MetadatumFilter;
  MetadatumInput: MetadatumInput;
  MetadatumMetadataPkeyConnect: MetadatumMetadataPkeyConnect;
  MetadatumMetadataPkeyDelete: MetadatumMetadataPkeyDelete;
  MetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingMetadataPkeyUpdate: MetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingMetadataPkeyUpdate;
  MetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingMetadataPkeyUpdate: MetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingMetadataPkeyUpdate;
  MetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataPkeyUpdate: MetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataPkeyUpdate;
  MetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingMetadataPkeyUpdate: MetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingMetadataPkeyUpdate;
  MetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingMetadataPkeyUpdate: MetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingMetadataPkeyUpdate;
  MetadatumPatch: MetadatumPatch;
  MetadatumToManyFileMetadatumFilter: MetadatumToManyFileMetadatumFilter;
  MetadatumToManyFileOutputGroupMetadatumFilter: MetadatumToManyFileOutputGroupMetadatumFilter;
  MetadatumToManyMetadataValueFilter: MetadatumToManyMetadataValueFilter;
  Mutation: ResolverTypeWrapper<{}>;
  Notification: ResolverTypeWrapper<Notification>;
  NotificationCondition: NotificationCondition;
  NotificationFilter: NotificationFilter;
  NotificationNotificationPkeyConnect: NotificationNotificationPkeyConnect;
  NotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingNotificationPkeyUpdate: NotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingNotificationPkeyUpdate;
  NotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingNotificationPkeyUpdate: NotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingNotificationPkeyUpdate;
  NotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingNotificationPkeyUpdate: NotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingNotificationPkeyUpdate;
  NotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingNotificationPkeyUpdate: NotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingNotificationPkeyUpdate;
  NotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingNotificationPkeyUpdate: NotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingNotificationPkeyUpdate;
  NotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingNotificationPkeyUpdate: NotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingNotificationPkeyUpdate;
  NotificationPatch: NotificationPatch;
  NotificationUserId1002Fc38FkApplicationUserIdApplicationUserCreateInput: NotificationUserId1002Fc38FkApplicationUserIdApplicationUserCreateInput;
  NotificationUserId1002Fc38FkApplicationUserIdInput: NotificationUserId1002Fc38FkApplicationUserIdInput;
  NotificationUserId1002Fc38FkApplicationUserIdInverseInput: NotificationUserId1002Fc38FkApplicationUserIdInverseInput;
  NotificationsConnection: ResolverTypeWrapper<NotificationsConnection>;
  NotificationsEdge: ResolverTypeWrapper<NotificationsEdge>;
  NotificationsOrderBy: NotificationsOrderBy;
  OutputGroupFile: ResolverTypeWrapper<OutputGroupFile>;
  OutputGroupFileCondition: OutputGroupFileCondition;
  OutputGroupFileFilter: OutputGroupFileFilter;
  OutputGroupFileInput: OutputGroupFileInput;
  OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingOutputGroupFilesPkeyUpdate: OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingOutputGroupFilesPkeyUpdate;
  OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingOutputGroupFilesPkeyUpdate: OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingOutputGroupFilesPkeyUpdate;
  OutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingOutputGroupFilesPkeyUpdate: OutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingOutputGroupFilesPkeyUpdate;
  OutputGroupFileOutputGroupFilesPkeyConnect: OutputGroupFileOutputGroupFilesPkeyConnect;
  OutputGroupFileOutputGroupFilesPkeyDelete: OutputGroupFileOutputGroupFilesPkeyDelete;
  OutputGroupFilePatch: OutputGroupFilePatch;
  OutputGroupFilesConnection: ResolverTypeWrapper<OutputGroupFilesConnection>;
  OutputGroupFilesEdge: ResolverTypeWrapper<OutputGroupFilesEdge>;
  OutputGroupFilesFileIdEdeabb23FkFileIdFileCreateInput: OutputGroupFilesFileIdEdeabb23FkFileIdFileCreateInput;
  OutputGroupFilesFileIdEdeabb23FkFileIdInput: OutputGroupFilesFileIdEdeabb23FkFileIdInput;
  OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput: OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput;
  OutputGroupFilesFileIdEdeabb23FkFileIdOutputGroupFilesCreateInput: OutputGroupFilesFileIdEdeabb23FkFileIdOutputGroupFilesCreateInput;
  OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput: OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput;
  OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput: OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput;
  OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpOutputGroupFilesCreateInput: OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpOutputGroupFilesCreateInput;
  OutputGroupFilesOrderBy: OutputGroupFilesOrderBy;
  OutputGroupFilesProjectId8709B561FkProjectIdInput: OutputGroupFilesProjectId8709B561FkProjectIdInput;
  OutputGroupFilesProjectId8709B561FkProjectIdInverseInput: OutputGroupFilesProjectId8709B561FkProjectIdInverseInput;
  OutputGroupFilesProjectId8709B561FkProjectIdOutputGroupFilesCreateInput: OutputGroupFilesProjectId8709B561FkProjectIdOutputGroupFilesCreateInput;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  PinnedTool: ResolverTypeWrapper<PinnedTool>;
  PinnedToolCondition: PinnedToolCondition;
  PinnedToolFilter: PinnedToolFilter;
  PinnedToolInput: PinnedToolInput;
  PinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingPinnedToolPkeyUpdate: PinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingPinnedToolPkeyUpdate;
  PinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingPinnedToolUniqueUpdate: PinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingPinnedToolUniqueUpdate;
  PinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingPinnedToolPkeyUpdate: PinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingPinnedToolPkeyUpdate;
  PinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingPinnedToolUniqueUpdate: PinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingPinnedToolUniqueUpdate;
  PinnedToolPatch: PinnedToolPatch;
  PinnedToolPinnedToolPkeyConnect: PinnedToolPinnedToolPkeyConnect;
  PinnedToolPinnedToolPkeyDelete: PinnedToolPinnedToolPkeyDelete;
  PinnedToolPinnedToolUniqueConnect: PinnedToolPinnedToolUniqueConnect;
  PinnedToolPinnedToolUniqueDelete: PinnedToolPinnedToolUniqueDelete;
  PinnedToolToolId7Ba143DfFkToolIdInput: PinnedToolToolId7Ba143DfFkToolIdInput;
  PinnedToolToolId7Ba143DfFkToolIdInverseInput: PinnedToolToolId7Ba143DfFkToolIdInverseInput;
  PinnedToolToolId7Ba143DfFkToolIdPinnedToolCreateInput: PinnedToolToolId7Ba143DfFkToolIdPinnedToolCreateInput;
  PinnedToolToolId7Ba143DfFkToolIdToolCreateInput: PinnedToolToolId7Ba143DfFkToolIdToolCreateInput;
  PinnedToolUserId59D3492DFkApplicationUserIdApplicationUserCreateInput: PinnedToolUserId59D3492DFkApplicationUserIdApplicationUserCreateInput;
  PinnedToolUserId59D3492DFkApplicationUserIdInput: PinnedToolUserId59D3492DFkApplicationUserIdInput;
  PinnedToolUserId59D3492DFkApplicationUserIdInverseInput: PinnedToolUserId59D3492DFkApplicationUserIdInverseInput;
  PinnedToolUserId59D3492DFkApplicationUserIdPinnedToolCreateInput: PinnedToolUserId59D3492DFkApplicationUserIdPinnedToolCreateInput;
  PinnedToolsConnection: ResolverTypeWrapper<PinnedToolsConnection>;
  PinnedToolsEdge: ResolverTypeWrapper<PinnedToolsEdge>;
  PinnedToolsOrderBy: PinnedToolsOrderBy;
  Project: ResolverTypeWrapper<Project>;
  ProjectCloneSourceId92Ccacf5FkProjectIdInput: ProjectCloneSourceId92Ccacf5FkProjectIdInput;
  ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput: ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput;
  ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput: ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput;
  ProjectClonedNotifUserId4Fd693D7FkApplicatiApplicationUserCreateInput: ProjectClonedNotifUserId4Fd693D7FkApplicatiApplicationUserCreateInput;
  ProjectClonedNotifUserId4Fd693D7FkApplicatiInput: ProjectClonedNotifUserId4Fd693D7FkApplicatiInput;
  ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput: ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput;
  ProjectClonedNotification: ResolverTypeWrapper<ProjectClonedNotification>;
  ProjectClonedNotificationCondition: ProjectClonedNotificationCondition;
  ProjectClonedNotificationFilter: ProjectClonedNotificationFilter;
  ProjectClonedNotificationIdD235A018FkNotificationIdInput: ProjectClonedNotificationIdD235A018FkNotificationIdInput;
  ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput: ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput;
  ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectClonedNotificationPkeyUpdate: ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectClonedNotificationPkeyUpdate;
  ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingProjectClonedNotificationPkeyUpdate: ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingProjectClonedNotificationPkeyUpdate;
  ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingProjectClonedNotificationPkeyUpdate: ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingProjectClonedNotificationPkeyUpdate;
  ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectClonedNotificationPkeyUpdate: ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectClonedNotificationPkeyUpdate;
  ProjectClonedNotificationProjectClonedNotificationPkeyConnect: ProjectClonedNotificationProjectClonedNotificationPkeyConnect;
  ProjectClonedNotificationProjectIdF6267374FkProjectIdInput: ProjectClonedNotificationProjectIdF6267374FkProjectIdInput;
  ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput: ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput;
  ProjectClonedNotificationsConnection: ResolverTypeWrapper<ProjectClonedNotificationsConnection>;
  ProjectClonedNotificationsEdge: ResolverTypeWrapper<ProjectClonedNotificationsEdge>;
  ProjectClonedNotificationsOrderBy: ProjectClonedNotificationsOrderBy;
  ProjectCondition: ProjectCondition;
  ProjectFilter: ProjectFilter;
  ProjectFolder: ResolverTypeWrapper<ProjectFolder>;
  ProjectFolderCondition: ProjectFolderCondition;
  ProjectFolderFilter: ProjectFolderFilter;
  ProjectFolderInput: ProjectFolderInput;
  ProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingProjectFolderPkeyUpdate: ProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingProjectFolderPkeyUpdate;
  ProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingProjectFolderPkeyUpdate: ProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingProjectFolderPkeyUpdate;
  ProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectFolderPkeyUpdate: ProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectFolderPkeyUpdate;
  ProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingProjectFolderPkeyUpdate: ProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingProjectFolderPkeyUpdate;
  ProjectFolderPatch: ProjectFolderPatch;
  ProjectFolderProjectFolderPkeyConnect: ProjectFolderProjectFolderPkeyConnect;
  ProjectFolderProjectFolderPkeyDelete: ProjectFolderProjectFolderPkeyDelete;
  ProjectFolderProjectIdEf44DadfFkProjectIdInput: ProjectFolderProjectIdEf44DadfFkProjectIdInput;
  ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput: ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput;
  ProjectFolderProjectIdEf44DadfFkProjectIdProjectFolderCreateInput: ProjectFolderProjectIdEf44DadfFkProjectIdProjectFolderCreateInput;
  ProjectFolderToManyDataTableFilter: ProjectFolderToManyDataTableFilter;
  ProjectFolderToManyGdtAnalysisTableFilter: ProjectFolderToManyGdtAnalysisTableFilter;
  ProjectFolderUserIdF2E16179FkApplicationUserIdApplicationUserCreateInput: ProjectFolderUserIdF2E16179FkApplicationUserIdApplicationUserCreateInput;
  ProjectFolderUserIdF2E16179FkApplicationUserIdInput: ProjectFolderUserIdF2E16179FkApplicationUserIdInput;
  ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput: ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput;
  ProjectFolderUserIdF2E16179FkApplicationUserIdProjectFolderCreateInput: ProjectFolderUserIdF2E16179FkApplicationUserIdProjectFolderCreateInput;
  ProjectFoldersConnection: ResolverTypeWrapper<ProjectFoldersConnection>;
  ProjectFoldersEdge: ResolverTypeWrapper<ProjectFoldersEdge>;
  ProjectFoldersOrderBy: ProjectFoldersOrderBy;
  ProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingProjectPkeyUpdate: ProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingProjectPkeyUpdate: ProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingProjectPkeyUpdate: ProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectPkeyUpdate: ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingProjectPkeyUpdate: ProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectPkeyUpdate: ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectPkeyUpdate: ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectPkeyUpdate: ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectPkeyUpdate: ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectPkeyUpdate: ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingProjectPkeyUpdate: ProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingProjectPkeyUpdate: ProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingProjectPkeyUpdate: ProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingProjectPkeyUpdate;
  ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectPkeyUpdate: ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectPkeyUpdate: ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectPkeyUpdate: ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectPkeyUpdate: ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectPkeyUpdate: ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectPkeyUpdate: ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectPkeyUpdate;
  ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectPkeyUpdate: ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectPkeyUpdate;
  ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectPkeyUpdate: ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectPkeyUpdate;
  ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectPkeyUpdate: ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectPkeyUpdate: ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectPkeyUpdate;
  ProjectProjectKeyTenantUniqueConnect: ProjectProjectKeyTenantUniqueConnect;
  ProjectProjectPkeyConnect: ProjectProjectPkeyConnect;
  ProjectSharedNotifSharerIdAbe16C5BFkApplicatiApplicationUserCreateInput: ProjectSharedNotifSharerIdAbe16C5BFkApplicatiApplicationUserCreateInput;
  ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput: ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput;
  ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput: ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput;
  ProjectSharedNotifUserId9A19122FFkApplicatiApplicationUserCreateInput: ProjectSharedNotifUserId9A19122FFkApplicatiApplicationUserCreateInput;
  ProjectSharedNotifUserId9A19122FFkApplicatiInput: ProjectSharedNotifUserId9A19122FFkApplicatiInput;
  ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput: ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput;
  ProjectSharedNotification: ResolverTypeWrapper<ProjectSharedNotification>;
  ProjectSharedNotificationCondition: ProjectSharedNotificationCondition;
  ProjectSharedNotificationFilter: ProjectSharedNotificationFilter;
  ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput: ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput;
  ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput: ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput;
  ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingProjectSharedNotificationPkeyUpdate: ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingProjectSharedNotificationPkeyUpdate;
  ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingProjectSharedNotificationPkeyUpdate: ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingProjectSharedNotificationPkeyUpdate;
  ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingProjectSharedNotificationPkeyUpdate: ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingProjectSharedNotificationPkeyUpdate;
  ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectSharedNotificationPkeyUpdate: ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectSharedNotificationPkeyUpdate;
  ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput: ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput;
  ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput: ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput;
  ProjectSharedNotificationProjectSharedNotificationPkeyConnect: ProjectSharedNotificationProjectSharedNotificationPkeyConnect;
  ProjectSharedNotificationsConnection: ResolverTypeWrapper<ProjectSharedNotificationsConnection>;
  ProjectSharedNotificationsEdge: ResolverTypeWrapper<ProjectSharedNotificationsEdge>;
  ProjectSharedNotificationsOrderBy: ProjectSharedNotificationsOrderBy;
  ProjectTag: ResolverTypeWrapper<ProjectTag>;
  ProjectTagCondition: ProjectTagCondition;
  ProjectTagFilter: ProjectTagFilter;
  ProjectTagInput: ProjectTagInput;
  ProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectTagPkeyUpdate: ProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectTagPkeyUpdate;
  ProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingProjectTagPkeyUpdate: ProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingProjectTagPkeyUpdate;
  ProjectTagPatch: ProjectTagPatch;
  ProjectTagProjectId5Ab280C9FkProjectIdInput: ProjectTagProjectId5Ab280C9FkProjectIdInput;
  ProjectTagProjectId5Ab280C9FkProjectIdInverseInput: ProjectTagProjectId5Ab280C9FkProjectIdInverseInput;
  ProjectTagProjectId5Ab280C9FkProjectIdProjectTagCreateInput: ProjectTagProjectId5Ab280C9FkProjectIdProjectTagCreateInput;
  ProjectTagProjectTagPkeyConnect: ProjectTagProjectTagPkeyConnect;
  ProjectTagProjectTagPkeyDelete: ProjectTagProjectTagPkeyDelete;
  ProjectTagUserId780C8348FkApplicationUserIdApplicationUserCreateInput: ProjectTagUserId780C8348FkApplicationUserIdApplicationUserCreateInput;
  ProjectTagUserId780C8348FkApplicationUserIdInput: ProjectTagUserId780C8348FkApplicationUserIdInput;
  ProjectTagUserId780C8348FkApplicationUserIdInverseInput: ProjectTagUserId780C8348FkApplicationUserIdInverseInput;
  ProjectTagUserId780C8348FkApplicationUserIdProjectTagCreateInput: ProjectTagUserId780C8348FkApplicationUserIdProjectTagCreateInput;
  ProjectTagsConnection: ResolverTypeWrapper<ProjectTagsConnection>;
  ProjectTagsEdge: ResolverTypeWrapper<ProjectTagsEdge>;
  ProjectTagsOrderBy: ProjectTagsOrderBy;
  ProjectTenantId03F0Ca53FkTenantIdInput: ProjectTenantId03F0Ca53FkTenantIdInput;
  ProjectTenantId03F0Ca53FkTenantIdInverseInput: ProjectTenantId03F0Ca53FkTenantIdInverseInput;
  ProjectTenantId03F0Ca53FkTenantIdTenantCreateInput: ProjectTenantId03F0Ca53FkTenantIdTenantCreateInput;
  ProjectToManyDataTableCellFilter: ProjectToManyDataTableCellFilter;
  ProjectToManyDataTableColumnDefinitionBooleanFilter: ProjectToManyDataTableColumnDefinitionBooleanFilter;
  ProjectToManyDataTableColumnDefinitionCellStatusFilter: ProjectToManyDataTableColumnDefinitionCellStatusFilter;
  ProjectToManyDataTableColumnDefinitionChoiceFilter: ProjectToManyDataTableColumnDefinitionChoiceFilter;
  ProjectToManyDataTableColumnDefinitionDateFilter: ProjectToManyDataTableColumnDefinitionDateFilter;
  ProjectToManyDataTableColumnDefinitionFileFilter: ProjectToManyDataTableColumnDefinitionFileFilter;
  ProjectToManyDataTableColumnDefinitionFloatFilter: ProjectToManyDataTableColumnDefinitionFloatFilter;
  ProjectToManyDataTableColumnDefinitionIdentifierFilter: ProjectToManyDataTableColumnDefinitionIdentifierFilter;
  ProjectToManyDataTableColumnDefinitionIntegerFilter: ProjectToManyDataTableColumnDefinitionIntegerFilter;
  ProjectToManyDataTableColumnDefinitionJoinFilter: ProjectToManyDataTableColumnDefinitionJoinFilter;
  ProjectToManyDataTableColumnDefinitionMetadatumFilter: ProjectToManyDataTableColumnDefinitionMetadatumFilter;
  ProjectToManyDataTableColumnDefinitionRoiFrameFilter: ProjectToManyDataTableColumnDefinitionRoiFrameFilter;
  ProjectToManyDataTableColumnDefinitionTextFilter: ProjectToManyDataTableColumnDefinitionTextFilter;
  ProjectToManyDataTableColumnFilter: ProjectToManyDataTableColumnFilter;
  ProjectToManyDataTableColumnGroupDefinitionJoinFilter: ProjectToManyDataTableColumnGroupDefinitionJoinFilter;
  ProjectToManyDataTableColumnGroupDefinitionSourceFilter: ProjectToManyDataTableColumnGroupDefinitionSourceFilter;
  ProjectToManyDataTableColumnGroupFilter: ProjectToManyDataTableColumnGroupFilter;
  ProjectToManyDataTableFilter: ProjectToManyDataTableFilter;
  ProjectToManyDataTableRowFilter: ProjectToManyDataTableRowFilter;
  ProjectToManyFileActivityFilter: ProjectToManyFileActivityFilter;
  ProjectToManyFileFilter: ProjectToManyFileFilter;
  ProjectToManyFileMetadatumFilter: ProjectToManyFileMetadatumFilter;
  ProjectToManyFileOutputGroupFilter: ProjectToManyFileOutputGroupFilter;
  ProjectToManyFileOutputGroupMetadatumFilter: ProjectToManyFileOutputGroupMetadatumFilter;
  ProjectToManyGdtAnalysisTableCellFilter: ProjectToManyGdtAnalysisTableCellFilter;
  ProjectToManyGdtAnalysisTableColumnFilter: ProjectToManyGdtAnalysisTableColumnFilter;
  ProjectToManyGdtAnalysisTableColumnGroupFilter: ProjectToManyGdtAnalysisTableColumnGroupFilter;
  ProjectToManyGdtAnalysisTableFilter: ProjectToManyGdtAnalysisTableFilter;
  ProjectToManyGdtAnalysisTableRowFilter: ProjectToManyGdtAnalysisTableRowFilter;
  ProjectToManyMetadataValueFilter: ProjectToManyMetadataValueFilter;
  ProjectToManyMetadatumFilter: ProjectToManyMetadatumFilter;
  ProjectToManyOutputGroupFileFilter: ProjectToManyOutputGroupFileFilter;
  ProjectToManyProjectClonedNotificationFilter: ProjectToManyProjectClonedNotificationFilter;
  ProjectToManyProjectFilter: ProjectToManyProjectFilter;
  ProjectToManyProjectFolderFilter: ProjectToManyProjectFolderFilter;
  ProjectToManyProjectSharedNotificationFilter: ProjectToManyProjectSharedNotificationFilter;
  ProjectToManyProjectTagFilter: ProjectToManyProjectTagFilter;
  ProjectToManyTaskFilter: ProjectToManyTaskFilter;
  ProjectUserIdB5Fbb914FkApplicationUserIdApplicationUserCreateInput: ProjectUserIdB5Fbb914FkApplicationUserIdApplicationUserCreateInput;
  ProjectUserIdB5Fbb914FkApplicationUserIdInput: ProjectUserIdB5Fbb914FkApplicationUserIdInput;
  ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput: ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput;
  ProjectsConnection: ResolverTypeWrapper<ProjectsConnection>;
  ProjectsEdge: ResolverTypeWrapper<ProjectsEdge>;
  ProjectsOrderBy: ProjectsOrderBy;
  Query: ResolverTypeWrapper<{}>;
  RoleChangeNotificaUserId879Bd49AFkApplicatiApplicationUserCreateInput: RoleChangeNotificaUserId879Bd49AFkApplicatiApplicationUserCreateInput;
  RoleChangeNotificaUserId879Bd49AFkApplicatiInput: RoleChangeNotificaUserId879Bd49AFkApplicatiInput;
  RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput: RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput;
  RoleChangeNotification: ResolverTypeWrapper<RoleChangeNotification>;
  RoleChangeNotificationCondition: RoleChangeNotificationCondition;
  RoleChangeNotificationFilter: RoleChangeNotificationFilter;
  RoleChangeNotificationIdD576A528FkNotificationIdInput: RoleChangeNotificationIdD576A528FkNotificationIdInput;
  RoleChangeNotificationIdD576A528FkNotificationIdInverseInput: RoleChangeNotificationIdD576A528FkNotificationIdInverseInput;
  RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingRoleChangeNotificationPkeyUpdate: RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingRoleChangeNotificationPkeyUpdate;
  RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingRoleChangeNotificationPkeyUpdate: RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingRoleChangeNotificationPkeyUpdate;
  RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingRoleChangeNotificationPkeyUpdate: RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingRoleChangeNotificationPkeyUpdate;
  RoleChangeNotificationRoleChangeNotificationPkeyConnect: RoleChangeNotificationRoleChangeNotificationPkeyConnect;
  RoleChangeNotificationTenantId36852Ce9FkTenantIdInput: RoleChangeNotificationTenantId36852Ce9FkTenantIdInput;
  RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput: RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput;
  RoleChangeNotificationTenantId36852Ce9FkTenantIdTenantCreateInput: RoleChangeNotificationTenantId36852Ce9FkTenantIdTenantCreateInput;
  RoleChangeNotificationsConnection: ResolverTypeWrapper<RoleChangeNotificationsConnection>;
  RoleChangeNotificationsEdge: ResolverTypeWrapper<RoleChangeNotificationsEdge>;
  RoleChangeNotificationsOrderBy: RoleChangeNotificationsOrderBy;
  Run: ResolverTypeWrapper<Run>;
  RunCondition: RunCondition;
  RunFilter: RunFilter;
  RunInput: RunInput;
  RunOnRunForRunTenantId73Fbd8D9FkTenantIdUsingRunPkeyUpdate: RunOnRunForRunTenantId73Fbd8D9FkTenantIdUsingRunPkeyUpdate;
  RunPatch: RunPatch;
  RunRunPkeyConnect: RunRunPkeyConnect;
  RunRunPkeyDelete: RunRunPkeyDelete;
  RunTenantId73Fbd8D9FkTenantIdInput: RunTenantId73Fbd8D9FkTenantIdInput;
  RunTenantId73Fbd8D9FkTenantIdInverseInput: RunTenantId73Fbd8D9FkTenantIdInverseInput;
  RunTenantId73Fbd8D9FkTenantIdRunCreateInput: RunTenantId73Fbd8D9FkTenantIdRunCreateInput;
  RunTenantId73Fbd8D9FkTenantIdTenantCreateInput: RunTenantId73Fbd8D9FkTenantIdTenantCreateInput;
  RunsConnection: ResolverTypeWrapper<RunsConnection>;
  RunsEdge: ResolverTypeWrapper<RunsEdge>;
  RunsOrderBy: RunsOrderBy;
  String: ResolverTypeWrapper<Scalars["String"]["output"]>;
  StringFilter: StringFilter;
  Subscription: ResolverTypeWrapper<{}>;
  Task: ResolverTypeWrapper<Task>;
  TaskActivitiesConnection: ResolverTypeWrapper<TaskActivitiesConnection>;
  TaskActivitiesEdge: ResolverTypeWrapper<TaskActivitiesEdge>;
  TaskActivitiesOrderBy: TaskActivitiesOrderBy;
  TaskActivity: ResolverTypeWrapper<TaskActivity>;
  TaskActivityCondition: TaskActivityCondition;
  TaskActivityCostId49E66058FkCostIdCostCreateInput: TaskActivityCostId49E66058FkCostIdCostCreateInput;
  TaskActivityCostId49E66058FkCostIdInput: TaskActivityCostId49E66058FkCostIdInput;
  TaskActivityCostId49E66058FkCostIdInverseInput: TaskActivityCostId49E66058FkCostIdInverseInput;
  TaskActivityCostId49E66058FkCostIdTaskActivityCreateInput: TaskActivityCostId49E66058FkCostIdTaskActivityCreateInput;
  TaskActivityFilter: TaskActivityFilter;
  TaskActivityInput: TaskActivityInput;
  TaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingTaskActivityPkeyUpdate: TaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingTaskActivityPkeyUpdate;
  TaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingTaskActivityTaskIdKeyUpdate: TaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingTaskActivityTaskIdKeyUpdate;
  TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityPkeyUpdate: TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityPkeyUpdate;
  TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityTaskIdKeyUpdate: TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityTaskIdKeyUpdate;
  TaskActivityPatch: TaskActivityPatch;
  TaskActivityTaskActivityPkeyConnect: TaskActivityTaskActivityPkeyConnect;
  TaskActivityTaskActivityPkeyDelete: TaskActivityTaskActivityPkeyDelete;
  TaskActivityTaskActivityTaskIdKeyConnect: TaskActivityTaskActivityTaskIdKeyConnect;
  TaskActivityTaskActivityTaskIdKeyDelete: TaskActivityTaskActivityTaskIdKeyDelete;
  TaskActivityTaskIdC451Ae92FkTaskIdInput: TaskActivityTaskIdC451Ae92FkTaskIdInput;
  TaskActivityTaskIdC451Ae92FkTaskIdInverseInput: TaskActivityTaskIdC451Ae92FkTaskIdInverseInput;
  TaskActivityTaskIdC451Ae92FkTaskIdTaskActivityCreateInput: TaskActivityTaskIdC451Ae92FkTaskIdTaskActivityCreateInput;
  TaskActivityTaskIdC451Ae92FkTaskIdTaskCreateInput: TaskActivityTaskIdC451Ae92FkTaskIdTaskCreateInput;
  TaskCondition: TaskCondition;
  TaskContainerImageId92Ed2DaeFkContainerImageIdContainerImageCreateInput: TaskContainerImageId92Ed2DaeFkContainerImageIdContainerImageCreateInput;
  TaskContainerImageId92Ed2DaeFkContainerImageIdInput: TaskContainerImageId92Ed2DaeFkContainerImageIdInput;
  TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput: TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput;
  TaskContainerImageId92Ed2DaeFkContainerImageIdTaskCreateInput: TaskContainerImageId92Ed2DaeFkContainerImageIdTaskCreateInput;
  TaskExecutorId24A67329FkTesTaskexecutorIdInput: TaskExecutorId24A67329FkTesTaskexecutorIdInput;
  TaskExecutorId24A67329FkTesTaskexecutorIdInverseInput: TaskExecutorId24A67329FkTesTaskexecutorIdInverseInput;
  TaskExecutorId24A67329FkTesTaskexecutorIdTaskCreateInput: TaskExecutorId24A67329FkTesTaskexecutorIdTaskCreateInput;
  TaskExecutorId24A67329FkTesTaskexecutorIdTesTaskexecutorCreateInput: TaskExecutorId24A67329FkTesTaskexecutorIdTesTaskexecutorCreateInput;
  TaskFilter: TaskFilter;
  TaskInput: TaskInput;
  TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskPkeyUpdate: TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskPkeyUpdate;
  TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskPkeyUpdate: TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskPkeyUpdate;
  TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskPkeyUpdate: TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskPkeyUpdate;
  TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskPkeyUpdate: TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskPkeyUpdate: TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingTaskPkeyUpdate: TaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTaskPkeyUpdate: TaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskPkeyUpdate: TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskPkeyUpdate: TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskPkeyUpdate: TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskPkeyUpdate: TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskPkeyUpdate;
  TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskPkeyUpdate: TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskPkeyUpdate: TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskPkeyUpdate: TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskPkeyUpdate: TaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskPkeyUpdate;
  TaskPatch: TaskPatch;
  TaskProjectId963D6354FkProjectIdInput: TaskProjectId963D6354FkProjectIdInput;
  TaskProjectId963D6354FkProjectIdInverseInput: TaskProjectId963D6354FkProjectIdInverseInput;
  TaskProjectId963D6354FkProjectIdTaskCreateInput: TaskProjectId963D6354FkProjectIdTaskCreateInput;
  TaskResource: ResolverTypeWrapper<TaskResource>;
  TaskResourceCondition: TaskResourceCondition;
  TaskResourceFilter: TaskResourceFilter;
  TaskResourceInput: TaskResourceInput;
  TaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskResourcePkeyUpdate: TaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskResourcePkeyUpdate;
  TaskResourcePatch: TaskResourcePatch;
  TaskResourceTaskId73Fcabc0FkTaskIdInput: TaskResourceTaskId73Fcabc0FkTaskIdInput;
  TaskResourceTaskId73Fcabc0FkTaskIdInverseInput: TaskResourceTaskId73Fcabc0FkTaskIdInverseInput;
  TaskResourceTaskId73Fcabc0FkTaskIdTaskCreateInput: TaskResourceTaskId73Fcabc0FkTaskIdTaskCreateInput;
  TaskResourceTaskId73Fcabc0FkTaskIdTaskResourceCreateInput: TaskResourceTaskId73Fcabc0FkTaskIdTaskResourceCreateInput;
  TaskResourceTaskResourcePkeyConnect: TaskResourceTaskResourcePkeyConnect;
  TaskResourceTaskResourcePkeyDelete: TaskResourceTaskResourcePkeyDelete;
  TaskResourceUsage: ResolverTypeWrapper<TaskResourceUsage>;
  TaskResourceUsageCondition: TaskResourceUsageCondition;
  TaskResourceUsageFilter: TaskResourceUsageFilter;
  TaskResourceUsageInput: TaskResourceUsageInput;
  TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsagePkeyUpdate: TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsagePkeyUpdate;
  TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsageTaskIdKeyUpdate: TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsageTaskIdKeyUpdate;
  TaskResourceUsagePatch: TaskResourceUsagePatch;
  TaskResourceUsageTaskIdA28F1580FkTaskIdInput: TaskResourceUsageTaskIdA28F1580FkTaskIdInput;
  TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput: TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput;
  TaskResourceUsageTaskIdA28F1580FkTaskIdTaskCreateInput: TaskResourceUsageTaskIdA28F1580FkTaskIdTaskCreateInput;
  TaskResourceUsageTaskIdA28F1580FkTaskIdTaskResourceUsageCreateInput: TaskResourceUsageTaskIdA28F1580FkTaskIdTaskResourceUsageCreateInput;
  TaskResourceUsageTaskResourceUsagePkeyConnect: TaskResourceUsageTaskResourceUsagePkeyConnect;
  TaskResourceUsageTaskResourceUsagePkeyDelete: TaskResourceUsageTaskResourceUsagePkeyDelete;
  TaskResourceUsageTaskResourceUsageTaskIdKeyConnect: TaskResourceUsageTaskResourceUsageTaskIdKeyConnect;
  TaskResourceUsageTaskResourceUsageTaskIdKeyDelete: TaskResourceUsageTaskResourceUsageTaskIdKeyDelete;
  TaskResourceUsagesConnection: ResolverTypeWrapper<TaskResourceUsagesConnection>;
  TaskResourceUsagesEdge: ResolverTypeWrapper<TaskResourceUsagesEdge>;
  TaskResourceUsagesOrderBy: TaskResourceUsagesOrderBy;
  TaskResourcesConnection: ResolverTypeWrapper<TaskResourcesConnection>;
  TaskResourcesEdge: ResolverTypeWrapper<TaskResourcesEdge>;
  TaskResourcesOrderBy: TaskResourcesOrderBy;
  TaskSource: ResolverTypeWrapper<TaskSource>;
  TaskSourceCondition: TaskSourceCondition;
  TaskSourceFileId2F628862FkFileIdFileCreateInput: TaskSourceFileId2F628862FkFileIdFileCreateInput;
  TaskSourceFileId2F628862FkFileIdInput: TaskSourceFileId2F628862FkFileIdInput;
  TaskSourceFileId2F628862FkFileIdInverseInput: TaskSourceFileId2F628862FkFileIdInverseInput;
  TaskSourceFileId2F628862FkFileIdTaskSourceCreateInput: TaskSourceFileId2F628862FkFileIdTaskSourceCreateInput;
  TaskSourceFilter: TaskSourceFilter;
  TaskSourceInput: TaskSourceInput;
  TaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingTaskSourcePkeyUpdate: TaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingTaskSourcePkeyUpdate;
  TaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskSourcePkeyUpdate: TaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskSourcePkeyUpdate;
  TaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingTaskSourcePkeyUpdate: TaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingTaskSourcePkeyUpdate;
  TaskSourcePatch: TaskSourcePatch;
  TaskSourceTaskIdF241BaedFkTaskIdInput: TaskSourceTaskIdF241BaedFkTaskIdInput;
  TaskSourceTaskIdF241BaedFkTaskIdInverseInput: TaskSourceTaskIdF241BaedFkTaskIdInverseInput;
  TaskSourceTaskIdF241BaedFkTaskIdTaskCreateInput: TaskSourceTaskIdF241BaedFkTaskIdTaskCreateInput;
  TaskSourceTaskIdF241BaedFkTaskIdTaskSourceCreateInput: TaskSourceTaskIdF241BaedFkTaskIdTaskSourceCreateInput;
  TaskSourceTaskSourcePkeyConnect: TaskSourceTaskSourcePkeyConnect;
  TaskSourceTaskSourcePkeyDelete: TaskSourceTaskSourcePkeyDelete;
  TaskSourceToolSourceId14453EdbFkToolSourceIdInput: TaskSourceToolSourceId14453EdbFkToolSourceIdInput;
  TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput: TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput;
  TaskSourceToolSourceId14453EdbFkToolSourceIdTaskSourceCreateInput: TaskSourceToolSourceId14453EdbFkToolSourceIdTaskSourceCreateInput;
  TaskSourceToolSourceId14453EdbFkToolSourceIdToolSourceCreateInput: TaskSourceToolSourceId14453EdbFkToolSourceIdToolSourceCreateInput;
  TaskSourcesConnection: ResolverTypeWrapper<TaskSourcesConnection>;
  TaskSourcesEdge: ResolverTypeWrapper<TaskSourcesEdge>;
  TaskSourcesOrderBy: TaskSourcesOrderBy;
  TaskStatusLog: ResolverTypeWrapper<TaskStatusLog>;
  TaskStatusLogCondition: TaskStatusLogCondition;
  TaskStatusLogFilter: TaskStatusLogFilter;
  TaskStatusLogInput: TaskStatusLogInput;
  TaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskStatusLogPkeyUpdate: TaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskStatusLogPkeyUpdate;
  TaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskStatusLogUniqueStatusPerTaskUpdate: TaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskStatusLogUniqueStatusPerTaskUpdate;
  TaskStatusLogPatch: TaskStatusLogPatch;
  TaskStatusLogTaskIdFe1B9D0BFkTaskIdInput: TaskStatusLogTaskIdFe1B9D0BFkTaskIdInput;
  TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput: TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput;
  TaskStatusLogTaskIdFe1B9D0BFkTaskIdTaskCreateInput: TaskStatusLogTaskIdFe1B9D0BFkTaskIdTaskCreateInput;
  TaskStatusLogTaskIdFe1B9D0BFkTaskIdTaskStatusLogCreateInput: TaskStatusLogTaskIdFe1B9D0BFkTaskIdTaskStatusLogCreateInput;
  TaskStatusLogTaskStatusLogPkeyConnect: TaskStatusLogTaskStatusLogPkeyConnect;
  TaskStatusLogTaskStatusLogPkeyDelete: TaskStatusLogTaskStatusLogPkeyDelete;
  TaskStatusLogTaskStatusLogUniqueStatusPerTaskConnect: TaskStatusLogTaskStatusLogUniqueStatusPerTaskConnect;
  TaskStatusLogTaskStatusLogUniqueStatusPerTaskDelete: TaskStatusLogTaskStatusLogUniqueStatusPerTaskDelete;
  TaskStatusLogsConnection: ResolverTypeWrapper<TaskStatusLogsConnection>;
  TaskStatusLogsEdge: ResolverTypeWrapper<TaskStatusLogsEdge>;
  TaskStatusLogsOrderBy: TaskStatusLogsOrderBy;
  TaskTaskExecutorIdKeyConnect: TaskTaskExecutorIdKeyConnect;
  TaskTaskExecutorIdKeyDelete: TaskTaskExecutorIdKeyDelete;
  TaskTaskPkeyConnect: TaskTaskPkeyConnect;
  TaskTaskPkeyDelete: TaskTaskPkeyDelete;
  TaskTenantId148E90DaFkTenantIdInput: TaskTenantId148E90DaFkTenantIdInput;
  TaskTenantId148E90DaFkTenantIdInverseInput: TaskTenantId148E90DaFkTenantIdInverseInput;
  TaskTenantId148E90DaFkTenantIdTaskCreateInput: TaskTenantId148E90DaFkTenantIdTaskCreateInput;
  TaskTenantId148E90DaFkTenantIdTenantCreateInput: TaskTenantId148E90DaFkTenantIdTenantCreateInput;
  TaskToManyFileFilter: TaskToManyFileFilter;
  TaskToManyMetadataValueFilter: TaskToManyMetadataValueFilter;
  TaskToManyTaskResourceFilter: TaskToManyTaskResourceFilter;
  TaskToManyTaskSourceFilter: TaskToManyTaskSourceFilter;
  TaskToManyTaskStatusLogFilter: TaskToManyTaskStatusLogFilter;
  TaskToolVersionId14506837FkToolVersionIdInput: TaskToolVersionId14506837FkToolVersionIdInput;
  TaskToolVersionId14506837FkToolVersionIdInverseInput: TaskToolVersionId14506837FkToolVersionIdInverseInput;
  TaskToolVersionId14506837FkToolVersionIdTaskCreateInput: TaskToolVersionId14506837FkToolVersionIdTaskCreateInput;
  TaskToolVersionId14506837FkToolVersionIdToolVersionCreateInput: TaskToolVersionId14506837FkToolVersionIdToolVersionCreateInput;
  TaskUserId270D0Bb2FkApplicationUserIdApplicationUserCreateInput: TaskUserId270D0Bb2FkApplicationUserIdApplicationUserCreateInput;
  TaskUserId270D0Bb2FkApplicationUserIdInput: TaskUserId270D0Bb2FkApplicationUserIdInput;
  TaskUserId270D0Bb2FkApplicationUserIdInverseInput: TaskUserId270D0Bb2FkApplicationUserIdInverseInput;
  TaskUserId270D0Bb2FkApplicationUserIdTaskCreateInput: TaskUserId270D0Bb2FkApplicationUserIdTaskCreateInput;
  TasksConnection: ResolverTypeWrapper<TasksConnection>;
  TasksEdge: ResolverTypeWrapper<TasksEdge>;
  TasksOrderBy: TasksOrderBy;
  Tenant: ResolverTypeWrapper<Tenant>;
  TenantContract: ResolverTypeWrapper<TenantContract>;
  TenantContractAlloTenantContractTran29C19B1CFkTenantCoInput: TenantContractAlloTenantContractTran29C19B1CFkTenantCoInput;
  TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput: TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput;
  TenantContractAlloTenantContractTran29C19B1CFkTenantCoTenantContractAllowanceCreateInput: TenantContractAlloTenantContractTran29C19B1CFkTenantCoTenantContractAllowanceCreateInput;
  TenantContractAlloTenantContractTran29C19B1CFkTenantCoTenantContractTransactionCreateInput: TenantContractAlloTenantContractTran29C19B1CFkTenantCoTenantContractTransactionCreateInput;
  TenantContractAllowance: ResolverTypeWrapper<TenantContractAllowance>;
  TenantContractAllowanceCondition: TenantContractAllowanceCondition;
  TenantContractAllowanceFilter: TenantContractAllowanceFilter;
  TenantContractAllowanceInput: TenantContractAllowanceInput;
  TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractAllowancePkeyUpdate: TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractAllowancePkeyUpdate;
  TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionQuotaTypeUniqueUpdate: TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionQuotaTypeUniqueUpdate;
  TenantContractAllowancePatch: TenantContractAllowancePatch;
  TenantContractAllowanceTenantContractAllowancePkeyConnect: TenantContractAllowanceTenantContractAllowancePkeyConnect;
  TenantContractAllowanceTenantContractAllowancePkeyDelete: TenantContractAllowanceTenantContractAllowancePkeyDelete;
  TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueConnect: TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueConnect;
  TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueDelete: TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueDelete;
  TenantContractAllowancesConnection: ResolverTypeWrapper<TenantContractAllowancesConnection>;
  TenantContractAllowancesEdge: ResolverTypeWrapper<TenantContractAllowancesEdge>;
  TenantContractAllowancesOrderBy: TenantContractAllowancesOrderBy;
  TenantContractCondition: TenantContractCondition;
  TenantContractFilter: TenantContractFilter;
  TenantContractInput: TenantContractInput;
  TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractNameKeyUpdate: TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractNameKeyUpdate;
  TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractPkeyUpdate: TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractPkeyUpdate;
  TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractSfidKeyUpdate: TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractSfidKeyUpdate;
  TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractNameKeyUpdate: TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractNameKeyUpdate;
  TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractPkeyUpdate: TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractPkeyUpdate;
  TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractSfidKeyUpdate: TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractSfidKeyUpdate;
  TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractNameKeyUpdate: TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractNameKeyUpdate;
  TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractPkeyUpdate: TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractPkeyUpdate;
  TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractSfidKeyUpdate: TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractSfidKeyUpdate;
  TenantContractPatch: TenantContractPatch;
  TenantContractTenantContractNameKeyConnect: TenantContractTenantContractNameKeyConnect;
  TenantContractTenantContractNameKeyDelete: TenantContractTenantContractNameKeyDelete;
  TenantContractTenantContractPkeyConnect: TenantContractTenantContractPkeyConnect;
  TenantContractTenantContractPkeyDelete: TenantContractTenantContractPkeyDelete;
  TenantContractTenantContractSfidKeyConnect: TenantContractTenantContractSfidKeyConnect;
  TenantContractTenantContractSfidKeyDelete: TenantContractTenantContractSfidKeyDelete;
  TenantContractTenantIdBa8Ac167FkTenantIdInput: TenantContractTenantIdBa8Ac167FkTenantIdInput;
  TenantContractTenantIdBa8Ac167FkTenantIdInverseInput: TenantContractTenantIdBa8Ac167FkTenantIdInverseInput;
  TenantContractTenantIdBa8Ac167FkTenantIdTenantContractCreateInput: TenantContractTenantIdBa8Ac167FkTenantIdTenantContractCreateInput;
  TenantContractTenantIdBa8Ac167FkTenantIdTenantCreateInput: TenantContractTenantIdBa8Ac167FkTenantIdTenantCreateInput;
  TenantContractToManyTenantContractTransactionFilter: TenantContractToManyTenantContractTransactionFilter;
  TenantContractToManyTenantMonthlyConsumedResourceFilter: TenantContractToManyTenantMonthlyConsumedResourceFilter;
  TenantContractTranTenantContractId1E374993FkTenantCoInput: TenantContractTranTenantContractId1E374993FkTenantCoInput;
  TenantContractTranTenantContractId1E374993FkTenantCoInverseInput: TenantContractTranTenantContractId1E374993FkTenantCoInverseInput;
  TenantContractTranTenantContractId1E374993FkTenantCoTenantContractCreateInput: TenantContractTranTenantContractId1E374993FkTenantCoTenantContractCreateInput;
  TenantContractTranTenantContractId1E374993FkTenantCoTenantContractTransactionCreateInput: TenantContractTranTenantContractId1E374993FkTenantCoTenantContractTransactionCreateInput;
  TenantContractTransaction: ResolverTypeWrapper<TenantContractTransaction>;
  TenantContractTransactionCondition: TenantContractTransactionCondition;
  TenantContractTransactionFilter: TenantContractTransactionFilter;
  TenantContractTransactionInput: TenantContractTransactionInput;
  TenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionPkeyUpdate: TenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionPkeyUpdate;
  TenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractTransactionPkeyUpdate: TenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractTransactionPkeyUpdate;
  TenantContractTransactionPatch: TenantContractTransactionPatch;
  TenantContractTransactionTenantContractTransactionPkeyConnect: TenantContractTransactionTenantContractTransactionPkeyConnect;
  TenantContractTransactionTenantContractTransactionPkeyDelete: TenantContractTransactionTenantContractTransactionPkeyDelete;
  TenantContractTransactionToManyTenantContractAllowanceFilter: TenantContractTransactionToManyTenantContractAllowanceFilter;
  TenantContractTransactionsConnection: ResolverTypeWrapper<TenantContractTransactionsConnection>;
  TenantContractTransactionsEdge: ResolverTypeWrapper<TenantContractTransactionsEdge>;
  TenantContractTransactionsOrderBy: TenantContractTransactionsOrderBy;
  TenantContractsConnection: ResolverTypeWrapper<TenantContractsConnection>;
  TenantContractsEdge: ResolverTypeWrapper<TenantContractsEdge>;
  TenantContractsOrderBy: TenantContractsOrderBy;
  TenantFilter: TenantFilter;
  TenantInput: TenantInput;
  TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInput: TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInput;
  TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInverseInput: TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInverseInput;
  TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsTenantMockuserexecutorCreateInput: TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsTenantMockuserexecutorCreateInput;
  TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsTenantUserexecutorCreateInput: TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsTenantUserexecutorCreateInput;
  TenantMockuserexecutor: ResolverTypeWrapper<TenantMockuserexecutor>;
  TenantMockuserexecutorCondition: TenantMockuserexecutorCondition;
  TenantMockuserexecutorFilter: TenantMockuserexecutorFilter;
  TenantMockuserexecutorInput: TenantMockuserexecutorInput;
  TenantMockuserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsUsingTenantMockuserexecutorPkeyUpdate: TenantMockuserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsUsingTenantMockuserexecutorPkeyUpdate;
  TenantMockuserexecutorPatch: TenantMockuserexecutorPatch;
  TenantMockuserexecutorTenantMockuserexecutorPkeyConnect: TenantMockuserexecutorTenantMockuserexecutorPkeyConnect;
  TenantMockuserexecutorTenantMockuserexecutorPkeyDelete: TenantMockuserexecutorTenantMockuserexecutorPkeyDelete;
  TenantMockuserexecutorsConnection: ResolverTypeWrapper<TenantMockuserexecutorsConnection>;
  TenantMockuserexecutorsEdge: ResolverTypeWrapper<TenantMockuserexecutorsEdge>;
  TenantMockuserexecutorsOrderBy: TenantMockuserexecutorsOrderBy;
  TenantMonthlyConsuTenantContractId681267CeFkTenantCoInput: TenantMonthlyConsuTenantContractId681267CeFkTenantCoInput;
  TenantMonthlyConsuTenantContractId681267CeFkTenantCoInverseInput: TenantMonthlyConsuTenantContractId681267CeFkTenantCoInverseInput;
  TenantMonthlyConsuTenantContractId681267CeFkTenantCoTenantContractCreateInput: TenantMonthlyConsuTenantContractId681267CeFkTenantCoTenantContractCreateInput;
  TenantMonthlyConsuTenantContractId681267CeFkTenantCoTenantMonthlyConsumedResourcesCreateInput: TenantMonthlyConsuTenantContractId681267CeFkTenantCoTenantMonthlyConsumedResourcesCreateInput;
  TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInput: TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInput;
  TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput: TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput;
  TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdTenantCreateInput: TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdTenantCreateInput;
  TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdTenantMonthlyConsumedResourcesCreateInput: TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdTenantMonthlyConsumedResourcesCreateInput;
  TenantMonthlyConsuUserIdF7210F55FkApplicatiApplicationUserCreateInput: TenantMonthlyConsuUserIdF7210F55FkApplicatiApplicationUserCreateInput;
  TenantMonthlyConsuUserIdF7210F55FkApplicatiInput: TenantMonthlyConsuUserIdF7210F55FkApplicatiInput;
  TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput: TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput;
  TenantMonthlyConsuUserIdF7210F55FkApplicatiTenantMonthlyConsumedResourcesCreateInput: TenantMonthlyConsuUserIdF7210F55FkApplicatiTenantMonthlyConsumedResourcesCreateInput;
  TenantMonthlyConsumedResource: ResolverTypeWrapper<TenantMonthlyConsumedResource>;
  TenantMonthlyConsumedResourceCondition: TenantMonthlyConsumedResourceCondition;
  TenantMonthlyConsumedResourceFilter: TenantMonthlyConsumedResourceFilter;
  TenantMonthlyConsumedResourceInput: TenantMonthlyConsumedResourceInput;
  TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantMonthlyConsumedResourcesPkeyUpdate: TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantMonthlyConsumedResourcesPkeyUpdate;
  TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantMonthlyConsumedResourcesUniqueUpdate: TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantMonthlyConsumedResourcesUniqueUpdate;
  TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantMonthlyConsumedResourcesPkeyUpdate: TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantMonthlyConsumedResourcesPkeyUpdate;
  TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantMonthlyConsumedResourcesUniqueUpdate: TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantMonthlyConsumedResourcesUniqueUpdate;
  TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingTenantMonthlyConsumedResourcesPkeyUpdate: TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingTenantMonthlyConsumedResourcesPkeyUpdate;
  TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingTenantMonthlyConsumedResourcesUniqueUpdate: TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingTenantMonthlyConsumedResourcesUniqueUpdate;
  TenantMonthlyConsumedResourcePatch: TenantMonthlyConsumedResourcePatch;
  TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesPkeyConnect: TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesPkeyConnect;
  TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesPkeyDelete: TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesPkeyDelete;
  TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesUniqueConnect: TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesUniqueConnect;
  TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesUniqueDelete: TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesUniqueDelete;
  TenantMonthlyConsumedResourcesConnection: ResolverTypeWrapper<TenantMonthlyConsumedResourcesConnection>;
  TenantMonthlyConsumedResourcesEdge: ResolverTypeWrapper<TenantMonthlyConsumedResourcesEdge>;
  TenantMonthlyConsumedResourcesOrderBy: TenantMonthlyConsumedResourcesOrderBy;
  TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantKeyKeyUpdate: TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantPkeyUpdate: TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantPkeyUpdate;
  TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantSfidKeyUpdate: TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantKeyKeyUpdate: TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantPkeyUpdate: TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantPkeyUpdate;
  TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantSfidKeyUpdate: TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantKeyKeyUpdate: TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantPkeyUpdate: TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantPkeyUpdate;
  TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantSfidKeyUpdate: TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantKeyKeyUpdate: TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantPkeyUpdate: TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantPkeyUpdate;
  TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantSfidKeyUpdate: TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantKeyKeyUpdate: TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantPkeyUpdate: TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantPkeyUpdate;
  TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantSfidKeyUpdate: TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantKeyKeyUpdate: TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantPkeyUpdate: TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantPkeyUpdate;
  TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantSfidKeyUpdate: TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantKeyKeyUpdate: TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantPkeyUpdate: TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantPkeyUpdate;
  TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantSfidKeyUpdate: TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantKeyKeyUpdate: TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantPkeyUpdate: TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantPkeyUpdate;
  TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantSfidKeyUpdate: TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantPkeyUpdate: TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantPkeyUpdate: TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantPkeyUpdate: TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantPkeyUpdate: TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantPkeyUpdate: TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantKeyKeyUpdate: TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantPkeyUpdate: TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantPkeyUpdate;
  TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantSfidKeyUpdate: TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantKeyKeyUpdate: TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantPkeyUpdate: TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantPkeyUpdate;
  TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantSfidKeyUpdate: TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantKeyKeyUpdate: TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantPkeyUpdate: TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantPkeyUpdate;
  TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantSfidKeyUpdate: TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantKeyKeyUpdate: TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantPkeyUpdate: TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantPkeyUpdate;
  TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantSfidKeyUpdate: TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantKeyKeyUpdate: TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantPkeyUpdate: TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantPkeyUpdate;
  TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantSfidKeyUpdate: TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantKeyKeyUpdate: TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantPkeyUpdate: TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantPkeyUpdate;
  TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantSfidKeyUpdate: TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantKeyKeyUpdate: TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantPkeyUpdate: TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantPkeyUpdate;
  TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantSfidKeyUpdate: TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantKeyKeyUpdate: TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantPkeyUpdate: TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantPkeyUpdate;
  TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantSfidKeyUpdate: TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantKeyKeyUpdate: TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantPkeyUpdate: TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantPkeyUpdate;
  TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantSfidKeyUpdate: TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantKeyKeyUpdate: TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantPkeyUpdate: TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantPkeyUpdate;
  TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantSfidKeyUpdate: TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantKeyKeyUpdate: TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantPkeyUpdate: TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantPkeyUpdate;
  TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantSfidKeyUpdate: TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantKeyKeyUpdate: TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantPkeyUpdate: TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantPkeyUpdate;
  TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantSfidKeyUpdate: TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantKeyKeyUpdate: TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantPkeyUpdate: TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantPkeyUpdate;
  TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantSfidKeyUpdate: TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantKeyKeyUpdate: TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantPkeyUpdate: TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantPkeyUpdate;
  TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantSfidKeyUpdate: TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantSfidKeyUpdate;
  TenantPatch: TenantPatch;
  TenantTenantKeyKeyConnect: TenantTenantKeyKeyConnect;
  TenantTenantKeyKeyDelete: TenantTenantKeyKeyDelete;
  TenantTenantPkeyConnect: TenantTenantPkeyConnect;
  TenantTenantPkeyDelete: TenantTenantPkeyDelete;
  TenantTenantRepositoryNameKeyConnect: TenantTenantRepositoryNameKeyConnect;
  TenantTenantRepositoryNameKeyDelete: TenantTenantRepositoryNameKeyDelete;
  TenantTenantSfidKeyConnect: TenantTenantSfidKeyConnect;
  TenantTenantSfidKeyDelete: TenantTenantSfidKeyDelete;
  TenantToManyApplicationUserMembershipFilter: TenantToManyApplicationUserMembershipFilter;
  TenantToManyApplicationUserSessionFilter: TenantToManyApplicationUserSessionFilter;
  TenantToManyCodeFileFilter: TenantToManyCodeFileFilter;
  TenantToManyCommandFilter: TenantToManyCommandFilter;
  TenantToManyContainerImageFilter: TenantToManyContainerImageFilter;
  TenantToManyContainerImageRepositoryFilter: TenantToManyContainerImageRepositoryFilter;
  TenantToManyCostFilter: TenantToManyCostFilter;
  TenantToManyFeatureFlagsTenantFilter: TenantToManyFeatureFlagsTenantFilter;
  TenantToManyFileActivityFilter: TenantToManyFileActivityFilter;
  TenantToManyFileFilter: TenantToManyFileFilter;
  TenantToManyFileMetadatumFilter: TenantToManyFileMetadatumFilter;
  TenantToManyFileOutputGroupFilter: TenantToManyFileOutputGroupFilter;
  TenantToManyFileOutputGroupMetadatumFilter: TenantToManyFileOutputGroupMetadatumFilter;
  TenantToManyMetadataValueFilter: TenantToManyMetadataValueFilter;
  TenantToManyMetadatumFilter: TenantToManyMetadatumFilter;
  TenantToManyProjectFilter: TenantToManyProjectFilter;
  TenantToManyRoleChangeNotificationFilter: TenantToManyRoleChangeNotificationFilter;
  TenantToManyRunFilter: TenantToManyRunFilter;
  TenantToManyTaskFilter: TenantToManyTaskFilter;
  TenantToManyTenantContractFilter: TenantToManyTenantContractFilter;
  TenantToManyTenantMonthlyConsumedResourceFilter: TenantToManyTenantMonthlyConsumedResourceFilter;
  TenantToManyTenantUserMembershipNotificationFilter: TenantToManyTenantUserMembershipNotificationFilter;
  TenantToManyToolFilter: TenantToManyToolFilter;
  TenantToManyToolTenantFilter: TenantToManyToolTenantFilter;
  TenantToManyToolVersionFilter: TenantToManyToolVersionFilter;
  TenantToManyToolboxTenantFilter: TenantToManyToolboxTenantFilter;
  TenantToManyWorkflowFilter: TenantToManyWorkflowFilter;
  TenantUserMembershId10Affa8DFkNotificatInput: TenantUserMembershId10Affa8DFkNotificatInput;
  TenantUserMembershId10Affa8DFkNotificatInverseInput: TenantUserMembershId10Affa8DFkNotificatInverseInput;
  TenantUserMembershInviterId29476E5EFkApplicatiApplicationUserCreateInput: TenantUserMembershInviterId29476E5EFkApplicatiApplicationUserCreateInput;
  TenantUserMembershInviterId29476E5EFkApplicatiInput: TenantUserMembershInviterId29476E5EFkApplicatiInput;
  TenantUserMembershInviterId29476E5EFkApplicatiInverseInput: TenantUserMembershInviterId29476E5EFkApplicatiInverseInput;
  TenantUserMembershTenantIdC67818C5FkTenantIdInput: TenantUserMembershTenantIdC67818C5FkTenantIdInput;
  TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput: TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput;
  TenantUserMembershTenantIdC67818C5FkTenantIdTenantCreateInput: TenantUserMembershTenantIdC67818C5FkTenantIdTenantCreateInput;
  TenantUserMembershUserId2B78E8A0FkApplicatiApplicationUserCreateInput: TenantUserMembershUserId2B78E8A0FkApplicatiApplicationUserCreateInput;
  TenantUserMembershUserId2B78E8A0FkApplicatiInput: TenantUserMembershUserId2B78E8A0FkApplicatiInput;
  TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput: TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput;
  TenantUserMembershipNotification: ResolverTypeWrapper<TenantUserMembershipNotification>;
  TenantUserMembershipNotificationCondition: TenantUserMembershipNotificationCondition;
  TenantUserMembershipNotificationFilter: TenantUserMembershipNotificationFilter;
  TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingTenantUserMembershipNotificationPkeyUpdate: TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingTenantUserMembershipNotificationPkeyUpdate;
  TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate: TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate;
  TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantUserMembershipNotificationPkeyUpdate: TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantUserMembershipNotificationPkeyUpdate;
  TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate: TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate;
  TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect: TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect;
  TenantUserMembershipNotificationsConnection: ResolverTypeWrapper<TenantUserMembershipNotificationsConnection>;
  TenantUserMembershipNotificationsEdge: ResolverTypeWrapper<TenantUserMembershipNotificationsEdge>;
  TenantUserMembershipNotificationsOrderBy: TenantUserMembershipNotificationsOrderBy;
  TenantUserexecutor: ResolverTypeWrapper<TenantUserexecutor>;
  TenantUserexecutorCondition: TenantUserexecutorCondition;
  TenantUserexecutorFilter: TenantUserexecutorFilter;
  TenantUserexecutorInput: TenantUserexecutorInput;
  TenantUserexecutorOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsUsingTenantUserexecutorPkeyUpdate: TenantUserexecutorOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsUsingTenantUserexecutorPkeyUpdate;
  TenantUserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsUsingTenantUserexecutorPkeyUpdate: TenantUserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsUsingTenantUserexecutorPkeyUpdate;
  TenantUserexecutorOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingTenantUserexecutorPkeyUpdate: TenantUserexecutorOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingTenantUserexecutorPkeyUpdate;
  TenantUserexecutorPatch: TenantUserexecutorPatch;
  TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoDjangoContentTypeCreateInput: TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoDjangoContentTypeCreateInput;
  TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInput: TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInput;
  TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput: TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput;
  TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoTenantUserexecutorCreateInput: TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoTenantUserexecutorCreateInput;
  TenantUserexecutorTenantUserexecutorPkeyConnect: TenantUserexecutorTenantUserexecutorPkeyConnect;
  TenantUserexecutorTenantUserexecutorPkeyDelete: TenantUserexecutorTenantUserexecutorPkeyDelete;
  TenantUserexecutorsConnection: ResolverTypeWrapper<TenantUserexecutorsConnection>;
  TenantUserexecutorsEdge: ResolverTypeWrapper<TenantUserexecutorsEdge>;
  TenantUserexecutorsOrderBy: TenantUserexecutorsOrderBy;
  TenantsEdge: ResolverTypeWrapper<TenantsEdge>;
  TenantsOrderBy: TenantsOrderBy;
  TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoDjangoContentTypeCreateInput: TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoDjangoContentTypeCreateInput;
  TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInput: TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInput;
  TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput: TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput;
  TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoTesContainerimageexecutorCreateInput: TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoTesContainerimageexecutorCreateInput;
  TesContainerimageexecutor: ResolverTypeWrapper<TesContainerimageexecutor>;
  TesContainerimageexecutorCondition: TesContainerimageexecutorCondition;
  TesContainerimageexecutorFilter: TesContainerimageexecutorFilter;
  TesContainerimageexecutorInput: TesContainerimageexecutorInput;
  TesContainerimageexecutorOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaUsingTesContainerimageexecutorPkeyUpdate: TesContainerimageexecutorOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaUsingTesContainerimageexecutorPkeyUpdate;
  TesContainerimageexecutorOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingTesContainerimageexecutorPkeyUpdate: TesContainerimageexecutorOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingTesContainerimageexecutorPkeyUpdate;
  TesContainerimageexecutorOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaUsingTesContainerimageexecutorPkeyUpdate: TesContainerimageexecutorOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaUsingTesContainerimageexecutorPkeyUpdate;
  TesContainerimageexecutorOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingTesContainerimageexecutorPkeyUpdate: TesContainerimageexecutorOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingTesContainerimageexecutorPkeyUpdate;
  TesContainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaUsingTesContainerimageexecutorPkeyUpdate: TesContainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaUsingTesContainerimageexecutorPkeyUpdate;
  TesContainerimageexecutorPatch: TesContainerimageexecutorPatch;
  TesContainerimageexecutorTesContainerimageexecutorPkeyConnect: TesContainerimageexecutorTesContainerimageexecutorPkeyConnect;
  TesContainerimageexecutorTesContainerimageexecutorPkeyDelete: TesContainerimageexecutorTesContainerimageexecutorPkeyDelete;
  TesContainerimageexecutorsConnection: ResolverTypeWrapper<TesContainerimageexecutorsConnection>;
  TesContainerimageexecutorsEdge: ResolverTypeWrapper<TesContainerimageexecutorsEdge>;
  TesContainerimageexecutorsOrderBy: TesContainerimageexecutorsOrderBy;
  TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInput: TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInput;
  TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInverseInput: TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInverseInput;
  TesMockcontainerimaContainerimageexecut4Eced924FkTesContaTesContainerimageexecutorCreateInput: TesMockcontainerimaContainerimageexecut4Eced924FkTesContaTesContainerimageexecutorCreateInput;
  TesMockcontainerimaContainerimageexecut4Eced924FkTesContaTesMockcontainerimageexecutorCreateInput: TesMockcontainerimaContainerimageexecut4Eced924FkTesContaTesMockcontainerimageexecutorCreateInput;
  TesMockcontainerimageexecutor: ResolverTypeWrapper<TesMockcontainerimageexecutor>;
  TesMockcontainerimageexecutorCondition: TesMockcontainerimageexecutorCondition;
  TesMockcontainerimageexecutorFilter: TesMockcontainerimageexecutorFilter;
  TesMockcontainerimageexecutorInput: TesMockcontainerimageexecutorInput;
  TesMockcontainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaUsingTesMockcontainerimageexecutorPkeyUpdate: TesMockcontainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaUsingTesMockcontainerimageexecutorPkeyUpdate;
  TesMockcontainerimageexecutorPatch: TesMockcontainerimageexecutorPatch;
  TesMockcontainerimageexecutorTesMockcontainerimageexecutorPkeyConnect: TesMockcontainerimageexecutorTesMockcontainerimageexecutorPkeyConnect;
  TesMockcontainerimageexecutorTesMockcontainerimageexecutorPkeyDelete: TesMockcontainerimageexecutorTesMockcontainerimageexecutorPkeyDelete;
  TesMockcontainerimageexecutorsConnection: ResolverTypeWrapper<TesMockcontainerimageexecutorsConnection>;
  TesMockcontainerimageexecutorsEdge: ResolverTypeWrapper<TesMockcontainerimageexecutorsEdge>;
  TesMockcontainerimageexecutorsOrderBy: TesMockcontainerimageexecutorsOrderBy;
  TesMocktaskexecutor: ResolverTypeWrapper<TesMocktaskexecutor>;
  TesMocktaskexecutorCondition: TesMocktaskexecutorCondition;
  TesMocktaskexecutorFilter: TesMocktaskexecutorFilter;
  TesMocktaskexecutorInput: TesMocktaskexecutorInput;
  TesMocktaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeUsingTesMocktaskexecutorPkeyUpdate: TesMocktaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeUsingTesMocktaskexecutorPkeyUpdate;
  TesMocktaskexecutorPatch: TesMocktaskexecutorPatch;
  TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInput: TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInput;
  TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInverseInput: TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInverseInput;
  TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeTesMocktaskexecutorCreateInput: TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeTesMocktaskexecutorCreateInput;
  TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeTesTaskexecutorCreateInput: TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeTesTaskexecutorCreateInput;
  TesMocktaskexecutorTesMocktaskexecutorPkeyConnect: TesMocktaskexecutorTesMocktaskexecutorPkeyConnect;
  TesMocktaskexecutorTesMocktaskexecutorPkeyDelete: TesMocktaskexecutorTesMocktaskexecutorPkeyDelete;
  TesMocktaskexecutorsConnection: ResolverTypeWrapper<TesMocktaskexecutorsConnection>;
  TesMocktaskexecutorsEdge: ResolverTypeWrapper<TesMocktaskexecutorsEdge>;
  TesMocktaskexecutorsOrderBy: TesMocktaskexecutorsOrderBy;
  TesTaskexecutor: ResolverTypeWrapper<TesTaskexecutor>;
  TesTaskexecutorCondition: TesTaskexecutorCondition;
  TesTaskexecutorFilter: TesTaskexecutorFilter;
  TesTaskexecutorInput: TesTaskexecutorInput;
  TesTaskexecutorOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeUsingTesTaskexecutorPkeyUpdate: TesTaskexecutorOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeUsingTesTaskexecutorPkeyUpdate;
  TesTaskexecutorOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTesTaskexecutorPkeyUpdate: TesTaskexecutorOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTesTaskexecutorPkeyUpdate;
  TesTaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeUsingTesTaskexecutorPkeyUpdate: TesTaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeUsingTesTaskexecutorPkeyUpdate;
  TesTaskexecutorOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingTesTaskexecutorPkeyUpdate: TesTaskexecutorOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingTesTaskexecutorPkeyUpdate;
  TesTaskexecutorPatch: TesTaskexecutorPatch;
  TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoDjangoContentTypeCreateInput: TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoDjangoContentTypeCreateInput;
  TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInput: TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInput;
  TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput: TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput;
  TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoTesTaskexecutorCreateInput: TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoTesTaskexecutorCreateInput;
  TesTaskexecutorTesTaskexecutorPkeyConnect: TesTaskexecutorTesTaskexecutorPkeyConnect;
  TesTaskexecutorTesTaskexecutorPkeyDelete: TesTaskexecutorTesTaskexecutorPkeyDelete;
  TesTaskexecutorsConnection: ResolverTypeWrapper<TesTaskexecutorsConnection>;
  TesTaskexecutorsEdge: ResolverTypeWrapper<TesTaskexecutorsEdge>;
  TesTaskexecutorsOrderBy: TesTaskexecutorsOrderBy;
  Tool: ResolverTypeWrapper<Tool>;
  ToolCondition: ToolCondition;
  ToolFilter: ToolFilter;
  ToolInput: ToolInput;
  ToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingToolPkeyUpdate: ToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingToolPkeyUpdate;
  ToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingToolProjectIdKeyUpdate: ToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingToolProjectIdKeyUpdate;
  ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolPkeyUpdate: ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolPkeyUpdate;
  ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolProjectIdKeyUpdate: ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolProjectIdKeyUpdate;
  ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolPkeyUpdate: ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolPkeyUpdate;
  ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolProjectIdKeyUpdate: ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolProjectIdKeyUpdate;
  ToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolPkeyUpdate: ToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolPkeyUpdate;
  ToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolProjectIdKeyUpdate: ToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolProjectIdKeyUpdate;
  ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolPkeyUpdate: ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolPkeyUpdate;
  ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolProjectIdKeyUpdate: ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolProjectIdKeyUpdate;
  ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolPkeyUpdate: ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolPkeyUpdate;
  ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolProjectIdKeyUpdate: ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolProjectIdKeyUpdate;
  ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolPkeyUpdate: ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolPkeyUpdate;
  ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolProjectIdKeyUpdate: ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolProjectIdKeyUpdate;
  ToolParameter: ResolverTypeWrapper<ToolParameter>;
  ToolParameterCondition: ToolParameterCondition;
  ToolParameterFilter: ToolParameterFilter;
  ToolParameterInput: ToolParameterInput;
  ToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolParameterPkeyUpdate: ToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolParameterPkeyUpdate;
  ToolParameterPatch: ToolParameterPatch;
  ToolParameterToolParameterPkeyConnect: ToolParameterToolParameterPkeyConnect;
  ToolParameterToolParameterPkeyDelete: ToolParameterToolParameterPkeyDelete;
  ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInput: ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInput;
  ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput: ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput;
  ToolParameterToolVersionIdC3A0Df75FkToolVersionIdToolParameterCreateInput: ToolParameterToolVersionIdC3A0Df75FkToolVersionIdToolParameterCreateInput;
  ToolParameterToolVersionIdC3A0Df75FkToolVersionIdToolVersionCreateInput: ToolParameterToolVersionIdC3A0Df75FkToolVersionIdToolVersionCreateInput;
  ToolParametersConnection: ResolverTypeWrapper<ToolParametersConnection>;
  ToolParametersEdge: ResolverTypeWrapper<ToolParametersEdge>;
  ToolParametersOrderBy: ToolParametersOrderBy;
  ToolPatch: ToolPatch;
  ToolProjectId20A84210FkProjectIdInput: ToolProjectId20A84210FkProjectIdInput;
  ToolProjectId20A84210FkProjectIdInverseInput: ToolProjectId20A84210FkProjectIdInverseInput;
  ToolProjectId20A84210FkProjectIdToolCreateInput: ToolProjectId20A84210FkProjectIdToolCreateInput;
  ToolResource: ResolverTypeWrapper<ToolResource>;
  ToolResourceCondition: ToolResourceCondition;
  ToolResourceFilter: ToolResourceFilter;
  ToolResourceInput: ToolResourceInput;
  ToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingReqTypeToolVersionUniqueUpdate: ToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingReqTypeToolVersionUniqueUpdate;
  ToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingToolResourcePkeyUpdate: ToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingToolResourcePkeyUpdate;
  ToolResourcePatch: ToolResourcePatch;
  ToolResourceReqTypeToolVersionUniqueConnect: ToolResourceReqTypeToolVersionUniqueConnect;
  ToolResourceReqTypeToolVersionUniqueDelete: ToolResourceReqTypeToolVersionUniqueDelete;
  ToolResourceToolResourcePkeyConnect: ToolResourceToolResourcePkeyConnect;
  ToolResourceToolResourcePkeyDelete: ToolResourceToolResourcePkeyDelete;
  ToolResourceToolVersionId5E21979DFkToolVersionIdInput: ToolResourceToolVersionId5E21979DFkToolVersionIdInput;
  ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput: ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput;
  ToolResourceToolVersionId5E21979DFkToolVersionIdToolResourceCreateInput: ToolResourceToolVersionId5E21979DFkToolVersionIdToolResourceCreateInput;
  ToolResourceToolVersionId5E21979DFkToolVersionIdToolVersionCreateInput: ToolResourceToolVersionId5E21979DFkToolVersionIdToolVersionCreateInput;
  ToolResourcesConnection: ResolverTypeWrapper<ToolResourcesConnection>;
  ToolResourcesEdge: ResolverTypeWrapper<ToolResourcesEdge>;
  ToolResourcesOrderBy: ToolResourcesOrderBy;
  ToolResult: ResolverTypeWrapper<ToolResult>;
  ToolResultCondition: ToolResultCondition;
  ToolResultFilter: ToolResultFilter;
  ToolResultInput: ToolResultInput;
  ToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolResultPkeyUpdate: ToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolResultPkeyUpdate;
  ToolResultPatch: ToolResultPatch;
  ToolResultToolResultPkeyConnect: ToolResultToolResultPkeyConnect;
  ToolResultToolResultPkeyDelete: ToolResultToolResultPkeyDelete;
  ToolResultToolVersionId41Fb163EFkToolVersionIdInput: ToolResultToolVersionId41Fb163EFkToolVersionIdInput;
  ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput: ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput;
  ToolResultToolVersionId41Fb163EFkToolVersionIdToolResultCreateInput: ToolResultToolVersionId41Fb163EFkToolVersionIdToolResultCreateInput;
  ToolResultToolVersionId41Fb163EFkToolVersionIdToolVersionCreateInput: ToolResultToolVersionId41Fb163EFkToolVersionIdToolVersionCreateInput;
  ToolResultsConnection: ResolverTypeWrapper<ToolResultsConnection>;
  ToolResultsEdge: ResolverTypeWrapper<ToolResultsEdge>;
  ToolResultsOrderBy: ToolResultsOrderBy;
  ToolSecret: ResolverTypeWrapper<ToolSecret>;
  ToolSecretCondition: ToolSecretCondition;
  ToolSecretFilter: ToolSecretFilter;
  ToolSecretInput: ToolSecretInput;
  ToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolSecretPkeyUpdate: ToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolSecretPkeyUpdate;
  ToolSecretPatch: ToolSecretPatch;
  ToolSecretToolSecretPkeyConnect: ToolSecretToolSecretPkeyConnect;
  ToolSecretToolSecretPkeyDelete: ToolSecretToolSecretPkeyDelete;
  ToolSecretToolVersionId92Dc8FadFkToolVersionIdInput: ToolSecretToolVersionId92Dc8FadFkToolVersionIdInput;
  ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput: ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput;
  ToolSecretToolVersionId92Dc8FadFkToolVersionIdToolSecretCreateInput: ToolSecretToolVersionId92Dc8FadFkToolVersionIdToolSecretCreateInput;
  ToolSecretToolVersionId92Dc8FadFkToolVersionIdToolVersionCreateInput: ToolSecretToolVersionId92Dc8FadFkToolVersionIdToolVersionCreateInput;
  ToolSecretsConnection: ResolverTypeWrapper<ToolSecretsConnection>;
  ToolSecretsEdge: ResolverTypeWrapper<ToolSecretsEdge>;
  ToolSecretsOrderBy: ToolSecretsOrderBy;
  ToolSource: ResolverTypeWrapper<ToolSource>;
  ToolSourceCondition: ToolSourceCondition;
  ToolSourceFilter: ToolSourceFilter;
  ToolSourceInput: ToolSourceInput;
  ToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingToolSourcePkeyUpdate: ToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingToolSourcePkeyUpdate;
  ToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolSourcePkeyUpdate: ToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolSourcePkeyUpdate;
  ToolSourcePatch: ToolSourcePatch;
  ToolSourceToManyTaskSourceFilter: ToolSourceToManyTaskSourceFilter;
  ToolSourceToolSourcePkeyConnect: ToolSourceToolSourcePkeyConnect;
  ToolSourceToolSourcePkeyDelete: ToolSourceToolSourcePkeyDelete;
  ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput: ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput;
  ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput: ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput;
  ToolSourceToolVersionId9Ac27A25FkToolVersionIdToolSourceCreateInput: ToolSourceToolVersionId9Ac27A25FkToolVersionIdToolSourceCreateInput;
  ToolSourceToolVersionId9Ac27A25FkToolVersionIdToolVersionCreateInput: ToolSourceToolVersionId9Ac27A25FkToolVersionIdToolVersionCreateInput;
  ToolSourcesConnection: ResolverTypeWrapper<ToolSourcesConnection>;
  ToolSourcesEdge: ResolverTypeWrapper<ToolSourcesEdge>;
  ToolSourcesOrderBy: ToolSourcesOrderBy;
  ToolTenant: ResolverTypeWrapper<ToolTenant>;
  ToolTenantCondition: ToolTenantCondition;
  ToolTenantFilter: ToolTenantFilter;
  ToolTenantId1Baab08EFkTenantIdInput: ToolTenantId1Baab08EFkTenantIdInput;
  ToolTenantId1Baab08EFkTenantIdInverseInput: ToolTenantId1Baab08EFkTenantIdInverseInput;
  ToolTenantId1Baab08EFkTenantIdTenantCreateInput: ToolTenantId1Baab08EFkTenantIdTenantCreateInput;
  ToolTenantId1Baab08EFkTenantIdToolCreateInput: ToolTenantId1Baab08EFkTenantIdToolCreateInput;
  ToolTenantInput: ToolTenantInput;
  ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsPkeyUpdate: ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsPkeyUpdate;
  ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate: ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate;
  ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsPkeyUpdate: ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsPkeyUpdate;
  ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate: ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate;
  ToolTenantPatch: ToolTenantPatch;
  ToolTenantToolTenantsPkeyConnect: ToolTenantToolTenantsPkeyConnect;
  ToolTenantToolTenantsPkeyDelete: ToolTenantToolTenantsPkeyDelete;
  ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqConnect: ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqConnect;
  ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqDelete: ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqDelete;
  ToolTenantsConnection: ResolverTypeWrapper<ToolTenantsConnection>;
  ToolTenantsEdge: ResolverTypeWrapper<ToolTenantsEdge>;
  ToolTenantsOrderBy: ToolTenantsOrderBy;
  ToolTenantsTenantId9C4A54FeFkTenantIdInput: ToolTenantsTenantId9C4A54FeFkTenantIdInput;
  ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput: ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput;
  ToolTenantsTenantId9C4A54FeFkTenantIdTenantCreateInput: ToolTenantsTenantId9C4A54FeFkTenantIdTenantCreateInput;
  ToolTenantsTenantId9C4A54FeFkTenantIdToolTenantsCreateInput: ToolTenantsTenantId9C4A54FeFkTenantIdToolTenantsCreateInput;
  ToolTenantsToolIdF77Ef6F7FkToolIdInput: ToolTenantsToolIdF77Ef6F7FkToolIdInput;
  ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput: ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput;
  ToolTenantsToolIdF77Ef6F7FkToolIdToolCreateInput: ToolTenantsToolIdF77Ef6F7FkToolIdToolCreateInput;
  ToolTenantsToolIdF77Ef6F7FkToolIdToolTenantsCreateInput: ToolTenantsToolIdF77Ef6F7FkToolIdToolTenantsCreateInput;
  ToolToManyPinnedToolFilter: ToolToManyPinnedToolFilter;
  ToolToManyToolTenantFilter: ToolToManyToolTenantFilter;
  ToolToManyToolVersionFilter: ToolToManyToolVersionFilter;
  ToolToolPkeyConnect: ToolToolPkeyConnect;
  ToolToolPkeyDelete: ToolToolPkeyDelete;
  ToolToolProjectIdKeyConnect: ToolToolProjectIdKeyConnect;
  ToolToolProjectIdKeyDelete: ToolToolProjectIdKeyDelete;
  ToolToolboxId7B1Eebf3FkToolboxIdInput: ToolToolboxId7B1Eebf3FkToolboxIdInput;
  ToolToolboxId7B1Eebf3FkToolboxIdInverseInput: ToolToolboxId7B1Eebf3FkToolboxIdInverseInput;
  ToolToolboxId7B1Eebf3FkToolboxIdToolCreateInput: ToolToolboxId7B1Eebf3FkToolboxIdToolCreateInput;
  ToolToolboxId7B1Eebf3FkToolboxIdToolboxCreateInput: ToolToolboxId7B1Eebf3FkToolboxIdToolboxCreateInput;
  ToolUserIdFd36Dfa4FkApplicationUserIdApplicationUserCreateInput: ToolUserIdFd36Dfa4FkApplicationUserIdApplicationUserCreateInput;
  ToolUserIdFd36Dfa4FkApplicationUserIdInput: ToolUserIdFd36Dfa4FkApplicationUserIdInput;
  ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput: ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput;
  ToolUserIdFd36Dfa4FkApplicationUserIdToolCreateInput: ToolUserIdFd36Dfa4FkApplicationUserIdToolCreateInput;
  ToolVersion: ResolverTypeWrapper<ToolVersion>;
  ToolVersionCondition: ToolVersionCondition;
  ToolVersionContainerImageId32D92A94FkContainerImageIdContainerImageCreateInput: ToolVersionContainerImageId32D92A94FkContainerImageIdContainerImageCreateInput;
  ToolVersionContainerImageId32D92A94FkContainerImageIdInput: ToolVersionContainerImageId32D92A94FkContainerImageIdInput;
  ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput: ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput;
  ToolVersionContainerImageId32D92A94FkContainerImageIdToolVersionCreateInput: ToolVersionContainerImageId32D92A94FkContainerImageIdToolVersionCreateInput;
  ToolVersionFilter: ToolVersionFilter;
  ToolVersionInput: ToolVersionInput;
  ToolVersionOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingToolVersionPkeyUpdate: ToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingToolVersionPkeyUpdate;
  ToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingToolVersionPkeyUpdate: ToolVersionOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingToolVersionPkeyUpdate: ToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolVersionPkeyUpdate: ToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingToolVersionPkeyUpdate: ToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingToolVersionPkeyUpdate;
  ToolVersionOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionPatch: ToolVersionPatch;
  ToolVersionTenantId03A60B0CFkTenantIdInput: ToolVersionTenantId03A60B0CFkTenantIdInput;
  ToolVersionTenantId03A60B0CFkTenantIdInverseInput: ToolVersionTenantId03A60B0CFkTenantIdInverseInput;
  ToolVersionTenantId03A60B0CFkTenantIdTenantCreateInput: ToolVersionTenantId03A60B0CFkTenantIdTenantCreateInput;
  ToolVersionTenantId03A60B0CFkTenantIdToolVersionCreateInput: ToolVersionTenantId03A60B0CFkTenantIdToolVersionCreateInput;
  ToolVersionToManyGdtAnalysisTableFilter: ToolVersionToManyGdtAnalysisTableFilter;
  ToolVersionToManyGdtAnalysisTableRowFilter: ToolVersionToManyGdtAnalysisTableRowFilter;
  ToolVersionToManyTaskFilter: ToolVersionToManyTaskFilter;
  ToolVersionToManyToolParameterFilter: ToolVersionToManyToolParameterFilter;
  ToolVersionToManyToolResourceFilter: ToolVersionToManyToolResourceFilter;
  ToolVersionToManyToolResultFilter: ToolVersionToManyToolResultFilter;
  ToolVersionToManyToolSecretFilter: ToolVersionToManyToolSecretFilter;
  ToolVersionToManyToolSourceFilter: ToolVersionToManyToolSourceFilter;
  ToolVersionToManyWorkflowSectionBlockFilter: ToolVersionToManyWorkflowSectionBlockFilter;
  ToolVersionToolId3B396B22FkToolIdInput: ToolVersionToolId3B396B22FkToolIdInput;
  ToolVersionToolId3B396B22FkToolIdInverseInput: ToolVersionToolId3B396B22FkToolIdInverseInput;
  ToolVersionToolId3B396B22FkToolIdToolCreateInput: ToolVersionToolId3B396B22FkToolIdToolCreateInput;
  ToolVersionToolId3B396B22FkToolIdToolVersionCreateInput: ToolVersionToolId3B396B22FkToolIdToolVersionCreateInput;
  ToolVersionToolVersionPkeyConnect: ToolVersionToolVersionPkeyConnect;
  ToolVersionToolVersionPkeyDelete: ToolVersionToolVersionPkeyDelete;
  ToolVersionUserId68A75E07FkApplicationUserIdApplicationUserCreateInput: ToolVersionUserId68A75E07FkApplicationUserIdApplicationUserCreateInput;
  ToolVersionUserId68A75E07FkApplicationUserIdInput: ToolVersionUserId68A75E07FkApplicationUserIdInput;
  ToolVersionUserId68A75E07FkApplicationUserIdInverseInput: ToolVersionUserId68A75E07FkApplicationUserIdInverseInput;
  ToolVersionUserId68A75E07FkApplicationUserIdToolVersionCreateInput: ToolVersionUserId68A75E07FkApplicationUserIdToolVersionCreateInput;
  ToolVersionsConnection: ResolverTypeWrapper<ToolVersionsConnection>;
  ToolVersionsEdge: ResolverTypeWrapper<ToolVersionsEdge>;
  ToolVersionsOrderBy: ToolVersionsOrderBy;
  Toolbox: ResolverTypeWrapper<Toolbox>;
  ToolboxCondition: ToolboxCondition;
  ToolboxFilter: ToolboxFilter;
  ToolboxInput: ToolboxInput;
  ToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolboxKeyKeyUpdate: ToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolboxKeyKeyUpdate;
  ToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolboxPkeyUpdate: ToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolboxPkeyUpdate;
  ToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxKeyKeyUpdate: ToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxKeyKeyUpdate;
  ToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxPkeyUpdate: ToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxPkeyUpdate;
  ToolboxPatch: ToolboxPatch;
  ToolboxTenant: ResolverTypeWrapper<ToolboxTenant>;
  ToolboxTenantCondition: ToolboxTenantCondition;
  ToolboxTenantFilter: ToolboxTenantFilter;
  ToolboxTenantInput: ToolboxTenantInput;
  ToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingToolboxTenantsPkeyUpdate: ToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingToolboxTenantsPkeyUpdate;
  ToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingToolboxTenantsToolboxIdTenantId171F711CUniqUpdate: ToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingToolboxTenantsToolboxIdTenantId171F711CUniqUpdate;
  ToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxTenantsPkeyUpdate: ToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxTenantsPkeyUpdate;
  ToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxTenantsToolboxIdTenantId171F711CUniqUpdate: ToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxTenantsToolboxIdTenantId171F711CUniqUpdate;
  ToolboxTenantPatch: ToolboxTenantPatch;
  ToolboxTenantToolboxTenantsPkeyConnect: ToolboxTenantToolboxTenantsPkeyConnect;
  ToolboxTenantToolboxTenantsPkeyDelete: ToolboxTenantToolboxTenantsPkeyDelete;
  ToolboxTenantToolboxTenantsToolboxIdTenantId171F711CUniqConnect: ToolboxTenantToolboxTenantsToolboxIdTenantId171F711CUniqConnect;
  ToolboxTenantToolboxTenantsToolboxIdTenantId171F711CUniqDelete: ToolboxTenantToolboxTenantsToolboxIdTenantId171F711CUniqDelete;
  ToolboxTenantsConnection: ResolverTypeWrapper<ToolboxTenantsConnection>;
  ToolboxTenantsEdge: ResolverTypeWrapper<ToolboxTenantsEdge>;
  ToolboxTenantsOrderBy: ToolboxTenantsOrderBy;
  ToolboxTenantsTenantId5D0A40E4FkTenantIdInput: ToolboxTenantsTenantId5D0A40E4FkTenantIdInput;
  ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput: ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput;
  ToolboxTenantsTenantId5D0A40E4FkTenantIdTenantCreateInput: ToolboxTenantsTenantId5D0A40E4FkTenantIdTenantCreateInput;
  ToolboxTenantsTenantId5D0A40E4FkTenantIdToolboxTenantsCreateInput: ToolboxTenantsTenantId5D0A40E4FkTenantIdToolboxTenantsCreateInput;
  ToolboxTenantsToolboxId9D553881FkToolboxIdInput: ToolboxTenantsToolboxId9D553881FkToolboxIdInput;
  ToolboxTenantsToolboxId9D553881FkToolboxIdInverseInput: ToolboxTenantsToolboxId9D553881FkToolboxIdInverseInput;
  ToolboxTenantsToolboxId9D553881FkToolboxIdToolboxCreateInput: ToolboxTenantsToolboxId9D553881FkToolboxIdToolboxCreateInput;
  ToolboxTenantsToolboxId9D553881FkToolboxIdToolboxTenantsCreateInput: ToolboxTenantsToolboxId9D553881FkToolboxIdToolboxTenantsCreateInput;
  ToolboxToManyToolFilter: ToolboxToManyToolFilter;
  ToolboxToManyToolboxTenantFilter: ToolboxToManyToolboxTenantFilter;
  ToolboxToolboxKeyKeyConnect: ToolboxToolboxKeyKeyConnect;
  ToolboxToolboxKeyKeyDelete: ToolboxToolboxKeyKeyDelete;
  ToolboxToolboxPkeyConnect: ToolboxToolboxPkeyConnect;
  ToolboxToolboxPkeyDelete: ToolboxToolboxPkeyDelete;
  ToolboxesConnection: ResolverTypeWrapper<ToolboxesConnection>;
  ToolboxesEdge: ResolverTypeWrapper<ToolboxesEdge>;
  ToolboxesOrderBy: ToolboxesOrderBy;
  ToolsConnection: ResolverTypeWrapper<ToolsConnection>;
  ToolsEdge: ResolverTypeWrapper<ToolsEdge>;
  ToolsOrderBy: ToolsOrderBy;
  UUID: ResolverTypeWrapper<Scalars["UUID"]["output"]>;
  UUIDFilter: UuidFilter;
  UpdateApplicationUserByEmailInput: UpdateApplicationUserByEmailInput;
  UpdateApplicationUserByGlobalUserIdInput: UpdateApplicationUserByGlobalUserIdInput;
  UpdateApplicationUserByIdInput: UpdateApplicationUserByIdInput;
  UpdateApplicationUserByUsernameInput: UpdateApplicationUserByUsernameInput;
  UpdateApplicationUserGroupByIdInput: UpdateApplicationUserGroupByIdInput;
  UpdateApplicationUserGroupByUserIdAndGroupIdInput: UpdateApplicationUserGroupByUserIdAndGroupIdInput;
  UpdateApplicationUserGroupPayload: ResolverTypeWrapper<UpdateApplicationUserGroupPayload>;
  UpdateApplicationUserMembershipByIdInput: UpdateApplicationUserMembershipByIdInput;
  UpdateApplicationUserMembershipByUserIdAndTenantIdInput: UpdateApplicationUserMembershipByUserIdAndTenantIdInput;
  UpdateApplicationUserMembershipPayload: ResolverTypeWrapper<UpdateApplicationUserMembershipPayload>;
  UpdateApplicationUserMetadatumByIdInput: UpdateApplicationUserMetadatumByIdInput;
  UpdateApplicationUserMetadatumByUserIdAndKeyInput: UpdateApplicationUserMetadatumByUserIdAndKeyInput;
  UpdateApplicationUserMetadatumPayload: ResolverTypeWrapper<UpdateApplicationUserMetadatumPayload>;
  UpdateApplicationUserPayload: ResolverTypeWrapper<UpdateApplicationUserPayload>;
  UpdateApplicationUserSessionByIdInput: UpdateApplicationUserSessionByIdInput;
  UpdateApplicationUserSessionPayload: ResolverTypeWrapper<UpdateApplicationUserSessionPayload>;
  UpdateApplicationUserUserPermissionByIdInput: UpdateApplicationUserUserPermissionByIdInput;
  UpdateApplicationUserUserPermissionByUserIdAndPermissionIdInput: UpdateApplicationUserUserPermissionByUserIdAndPermissionIdInput;
  UpdateApplicationUserUserPermissionPayload: ResolverTypeWrapper<UpdateApplicationUserUserPermissionPayload>;
  UpdateAuditlogLogentryByIdInput: UpdateAuditlogLogentryByIdInput;
  UpdateAuditlogLogentryPayload: ResolverTypeWrapper<UpdateAuditlogLogentryPayload>;
  UpdateAuthGroupByIdInput: UpdateAuthGroupByIdInput;
  UpdateAuthGroupByNameInput: UpdateAuthGroupByNameInput;
  UpdateAuthGroupPayload: ResolverTypeWrapper<UpdateAuthGroupPayload>;
  UpdateAuthGroupPermissionByGroupIdAndPermissionIdInput: UpdateAuthGroupPermissionByGroupIdAndPermissionIdInput;
  UpdateAuthGroupPermissionByIdInput: UpdateAuthGroupPermissionByIdInput;
  UpdateAuthGroupPermissionPayload: ResolverTypeWrapper<UpdateAuthGroupPermissionPayload>;
  UpdateAuthPermissionByContentTypeIdAndCodenameInput: UpdateAuthPermissionByContentTypeIdAndCodenameInput;
  UpdateAuthPermissionByIdInput: UpdateAuthPermissionByIdInput;
  UpdateAuthPermissionPayload: ResolverTypeWrapper<UpdateAuthPermissionPayload>;
  UpdateAvatarByIdInput: UpdateAvatarByIdInput;
  UpdateAvatarByUserIdInput: UpdateAvatarByUserIdInput;
  UpdateAvatarPayload: ResolverTypeWrapper<UpdateAvatarPayload>;
  UpdateAwsBatchTaskByTaskexecutorPtrIdInput: UpdateAwsBatchTaskByTaskexecutorPtrIdInput;
  UpdateAwsBatchTaskPayload: ResolverTypeWrapper<UpdateAwsBatchTaskPayload>;
  UpdateAwsCognitoUserByUserexecutorPtrIdInput: UpdateAwsCognitoUserByUserexecutorPtrIdInput;
  UpdateAwsCognitoUserPayload: ResolverTypeWrapper<UpdateAwsCognitoUserPayload>;
  UpdateAwsEcrImageByContainerimageexecutorPtrIdInput: UpdateAwsEcrImageByContainerimageexecutorPtrIdInput;
  UpdateAwsEcrImagePayload: ResolverTypeWrapper<UpdateAwsEcrImagePayload>;
  UpdateAwsMockBatchTaskByAwstaskexecutorPtrIdInput: UpdateAwsMockBatchTaskByAwstaskexecutorPtrIdInput;
  UpdateAwsMockBatchTaskPayload: ResolverTypeWrapper<UpdateAwsMockBatchTaskPayload>;
  UpdateAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdInput: UpdateAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdInput;
  UpdateAwsMockDistributionImagePayload: ResolverTypeWrapper<UpdateAwsMockDistributionImagePayload>;
  UpdateAwsMockEcrImageByAwscontainerimageexecutorPtrIdInput: UpdateAwsMockEcrImageByAwscontainerimageexecutorPtrIdInput;
  UpdateAwsMockEcrImagePayload: ResolverTypeWrapper<UpdateAwsMockEcrImagePayload>;
  UpdateAwsMockIamUserByAwsuserexecutorPtrIdInput: UpdateAwsMockIamUserByAwsuserexecutorPtrIdInput;
  UpdateAwsMockIamUserPayload: ResolverTypeWrapper<UpdateAwsMockIamUserPayload>;
  UpdateAwsMockS3FileByAwsfileexecutorPtrIdInput: UpdateAwsMockS3FileByAwsfileexecutorPtrIdInput;
  UpdateAwsMockS3FilePayload: ResolverTypeWrapper<UpdateAwsMockS3FilePayload>;
  UpdateAwsS3FileByFileexecutorPtrIdInput: UpdateAwsS3FileByFileexecutorPtrIdInput;
  UpdateAwsS3FilePayload: ResolverTypeWrapper<UpdateAwsS3FilePayload>;
  UpdateCodeFileByIdInput: UpdateCodeFileByIdInput;
  UpdateCodeFilePayload: ResolverTypeWrapper<UpdateCodeFilePayload>;
  UpdateCommandByIdInput: UpdateCommandByIdInput;
  UpdateCommandByToolVersionIdAndCodeFileIdInput: UpdateCommandByToolVersionIdAndCodeFileIdInput;
  UpdateCommandByToolVersionIdInput: UpdateCommandByToolVersionIdInput;
  UpdateCommandPayload: ResolverTypeWrapper<UpdateCommandPayload>;
  UpdateContainerImageByExecutorIdInput: UpdateContainerImageByExecutorIdInput;
  UpdateContainerImageByIdInput: UpdateContainerImageByIdInput;
  UpdateContainerImagePayload: ResolverTypeWrapper<UpdateContainerImagePayload>;
  UpdateContainerImageRepositoryByIdInput: UpdateContainerImageRepositoryByIdInput;
  UpdateContainerImageRepositoryByNameAndTenantIdAndRegistryTypeInput: UpdateContainerImageRepositoryByNameAndTenantIdAndRegistryTypeInput;
  UpdateContainerImageRepositoryByRepositoryInput: UpdateContainerImageRepositoryByRepositoryInput;
  UpdateContainerImageRepositoryPayload: ResolverTypeWrapper<UpdateContainerImageRepositoryPayload>;
  UpdateCostByIdInput: UpdateCostByIdInput;
  UpdateCostPayload: ResolverTypeWrapper<UpdateCostPayload>;
  UpdateDistributionRegistryImageByContainerimageexecutorPtrIdInput: UpdateDistributionRegistryImageByContainerimageexecutorPtrIdInput;
  UpdateDistributionRegistryImagePayload: ResolverTypeWrapper<UpdateDistributionRegistryImagePayload>;
  UpdateDjangoAdminLogByIdInput: UpdateDjangoAdminLogByIdInput;
  UpdateDjangoAdminLogPayload: ResolverTypeWrapper<UpdateDjangoAdminLogPayload>;
  UpdateDjangoContentTypeByAppLabelAndModelInput: UpdateDjangoContentTypeByAppLabelAndModelInput;
  UpdateDjangoContentTypeByIdInput: UpdateDjangoContentTypeByIdInput;
  UpdateDjangoContentTypePayload: ResolverTypeWrapper<UpdateDjangoContentTypePayload>;
  UpdateDjangoMigrationByIdInput: UpdateDjangoMigrationByIdInput;
  UpdateDjangoMigrationPayload: ResolverTypeWrapper<UpdateDjangoMigrationPayload>;
  UpdateDjangoSesBlacklistedemailByEmailInput: UpdateDjangoSesBlacklistedemailByEmailInput;
  UpdateDjangoSesBlacklistedemailByIdInput: UpdateDjangoSesBlacklistedemailByIdInput;
  UpdateDjangoSesBlacklistedemailPayload: ResolverTypeWrapper<UpdateDjangoSesBlacklistedemailPayload>;
  UpdateDjangoSesSesstatByDateInput: UpdateDjangoSesSesstatByDateInput;
  UpdateDjangoSesSesstatByIdInput: UpdateDjangoSesSesstatByIdInput;
  UpdateDjangoSesSesstatPayload: ResolverTypeWrapper<UpdateDjangoSesSesstatPayload>;
  UpdateDjangoSessionBySessionKeyInput: UpdateDjangoSessionBySessionKeyInput;
  UpdateDjangoSessionPayload: ResolverTypeWrapper<UpdateDjangoSessionPayload>;
  UpdateDrsFileexecutorByIdInput: UpdateDrsFileexecutorByIdInput;
  UpdateDrsFileexecutorPayload: ResolverTypeWrapper<UpdateDrsFileexecutorPayload>;
  UpdateDrsMockfileexecutorByFileexecutorPtrIdInput: UpdateDrsMockfileexecutorByFileexecutorPtrIdInput;
  UpdateDrsMockfileexecutorPayload: ResolverTypeWrapper<UpdateDrsMockfileexecutorPayload>;
  UpdateEulaVersionByIdInput: UpdateEulaVersionByIdInput;
  UpdateEulaVersionByVersionInput: UpdateEulaVersionByVersionInput;
  UpdateEulaVersionPayload: ResolverTypeWrapper<UpdateEulaVersionPayload>;
  UpdateEulaVersionUserAcceptanceByIdInput: UpdateEulaVersionUserAcceptanceByIdInput;
  UpdateEulaVersionUserAcceptanceByUserIdAndEulaVersionIdInput: UpdateEulaVersionUserAcceptanceByUserIdAndEulaVersionIdInput;
  UpdateEulaVersionUserAcceptancePayload: ResolverTypeWrapper<UpdateEulaVersionUserAcceptancePayload>;
  UpdateFeatureFlagByIdInput: UpdateFeatureFlagByIdInput;
  UpdateFeatureFlagByNameInput: UpdateFeatureFlagByNameInput;
  UpdateFeatureFlagPayload: ResolverTypeWrapper<UpdateFeatureFlagPayload>;
  UpdateFeatureFlagsGroupByFeatureflagIdAndGroupIdInput: UpdateFeatureFlagsGroupByFeatureflagIdAndGroupIdInput;
  UpdateFeatureFlagsGroupByIdInput: UpdateFeatureFlagsGroupByIdInput;
  UpdateFeatureFlagsGroupPayload: ResolverTypeWrapper<UpdateFeatureFlagsGroupPayload>;
  UpdateFeatureFlagsTenantByFeatureflagIdAndTenantIdInput: UpdateFeatureFlagsTenantByFeatureflagIdAndTenantIdInput;
  UpdateFeatureFlagsTenantByIdInput: UpdateFeatureFlagsTenantByIdInput;
  UpdateFeatureFlagsTenantPayload: ResolverTypeWrapper<UpdateFeatureFlagsTenantPayload>;
  UpdateFeatureFlagsUserByFeatureflagIdAndUserIdInput: UpdateFeatureFlagsUserByFeatureflagIdAndUserIdInput;
  UpdateFeatureFlagsUserByIdInput: UpdateFeatureFlagsUserByIdInput;
  UpdateFeatureFlagsUserPayload: ResolverTypeWrapper<UpdateFeatureFlagsUserPayload>;
  UpdateFileActivityByIdInput: UpdateFileActivityByIdInput;
  UpdateFileActivityPayload: ResolverTypeWrapper<UpdateFileActivityPayload>;
  UpdateFileByIdInput: UpdateFileByIdInput;
  UpdateFileByProjectIdAndReferenceIdInput: UpdateFileByProjectIdAndReferenceIdInput;
  UpdateFileMetadatumByIdInput: UpdateFileMetadatumByIdInput;
  UpdateFileMetadatumPayload: ResolverTypeWrapper<UpdateFileMetadatumPayload>;
  UpdateFileOutputGroupByIdInput: UpdateFileOutputGroupByIdInput;
  UpdateFileOutputGroupByTaskIdInput: UpdateFileOutputGroupByTaskIdInput;
  UpdateFileOutputGroupMetadatumByIdInput: UpdateFileOutputGroupMetadatumByIdInput;
  UpdateFileOutputGroupMetadatumPayload: ResolverTypeWrapper<UpdateFileOutputGroupMetadatumPayload>;
  UpdateFileOutputGroupPayload: ResolverTypeWrapper<UpdateFileOutputGroupPayload>;
  UpdateFilePayload: ResolverTypeWrapper<UpdateFilePayload>;
  UpdateMetadataValueByIdInput: UpdateMetadataValueByIdInput;
  UpdateMetadataValuePayload: ResolverTypeWrapper<UpdateMetadataValuePayload>;
  UpdateMetadatumByIdInput: UpdateMetadatumByIdInput;
  UpdateMetadatumPayload: ResolverTypeWrapper<UpdateMetadatumPayload>;
  UpdateNotificationByIdInput: UpdateNotificationByIdInput;
  UpdateNotificationPayload: ResolverTypeWrapper<UpdateNotificationPayload>;
  UpdateOutputGroupFileByIdInput: UpdateOutputGroupFileByIdInput;
  UpdateOutputGroupFilePayload: ResolverTypeWrapper<UpdateOutputGroupFilePayload>;
  UpdatePinnedToolByIdInput: UpdatePinnedToolByIdInput;
  UpdatePinnedToolByUserIdAndToolIdInput: UpdatePinnedToolByUserIdAndToolIdInput;
  UpdatePinnedToolPayload: ResolverTypeWrapper<UpdatePinnedToolPayload>;
  UpdateProjectFolderByIdInput: UpdateProjectFolderByIdInput;
  UpdateProjectFolderPayload: ResolverTypeWrapper<UpdateProjectFolderPayload>;
  UpdateProjectTagByIdInput: UpdateProjectTagByIdInput;
  UpdateProjectTagPayload: ResolverTypeWrapper<UpdateProjectTagPayload>;
  UpdateRunByIdInput: UpdateRunByIdInput;
  UpdateRunPayload: ResolverTypeWrapper<UpdateRunPayload>;
  UpdateTaskActivityByIdInput: UpdateTaskActivityByIdInput;
  UpdateTaskActivityByTaskIdInput: UpdateTaskActivityByTaskIdInput;
  UpdateTaskActivityPayload: ResolverTypeWrapper<UpdateTaskActivityPayload>;
  UpdateTaskByExecutorIdInput: UpdateTaskByExecutorIdInput;
  UpdateTaskByIdInput: UpdateTaskByIdInput;
  UpdateTaskPayload: ResolverTypeWrapper<UpdateTaskPayload>;
  UpdateTaskResourceByIdInput: UpdateTaskResourceByIdInput;
  UpdateTaskResourcePayload: ResolverTypeWrapper<UpdateTaskResourcePayload>;
  UpdateTaskResourceUsageByIdInput: UpdateTaskResourceUsageByIdInput;
  UpdateTaskResourceUsageByTaskIdInput: UpdateTaskResourceUsageByTaskIdInput;
  UpdateTaskResourceUsagePayload: ResolverTypeWrapper<UpdateTaskResourceUsagePayload>;
  UpdateTaskSourceByIdInput: UpdateTaskSourceByIdInput;
  UpdateTaskSourcePayload: ResolverTypeWrapper<UpdateTaskSourcePayload>;
  UpdateTaskStatusLogByIdInput: UpdateTaskStatusLogByIdInput;
  UpdateTaskStatusLogByTaskIdAndStatusInput: UpdateTaskStatusLogByTaskIdAndStatusInput;
  UpdateTaskStatusLogPayload: ResolverTypeWrapper<UpdateTaskStatusLogPayload>;
  UpdateTenantByIdInput: UpdateTenantByIdInput;
  UpdateTenantByKeyInput: UpdateTenantByKeyInput;
  UpdateTenantByRepositoryNameInput: UpdateTenantByRepositoryNameInput;
  UpdateTenantBySfidInput: UpdateTenantBySfidInput;
  UpdateTenantContractAllowanceByIdInput: UpdateTenantContractAllowanceByIdInput;
  UpdateTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeInput: UpdateTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeInput;
  UpdateTenantContractAllowancePayload: ResolverTypeWrapper<UpdateTenantContractAllowancePayload>;
  UpdateTenantContractByIdInput: UpdateTenantContractByIdInput;
  UpdateTenantContractByNameInput: UpdateTenantContractByNameInput;
  UpdateTenantContractBySfidInput: UpdateTenantContractBySfidInput;
  UpdateTenantContractPayload: ResolverTypeWrapper<UpdateTenantContractPayload>;
  UpdateTenantContractTransactionByIdInput: UpdateTenantContractTransactionByIdInput;
  UpdateTenantContractTransactionPayload: ResolverTypeWrapper<UpdateTenantContractTransactionPayload>;
  UpdateTenantMockuserexecutorByUserexecutorPtrIdInput: UpdateTenantMockuserexecutorByUserexecutorPtrIdInput;
  UpdateTenantMockuserexecutorPayload: ResolverTypeWrapper<UpdateTenantMockuserexecutorPayload>;
  UpdateTenantMonthlyConsumedResourceByIdInput: UpdateTenantMonthlyConsumedResourceByIdInput;
  UpdateTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractInput: UpdateTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractInput;
  UpdateTenantMonthlyConsumedResourcePayload: ResolverTypeWrapper<UpdateTenantMonthlyConsumedResourcePayload>;
  UpdateTenantPayload: ResolverTypeWrapper<UpdateTenantPayload>;
  UpdateTenantUserexecutorByIdInput: UpdateTenantUserexecutorByIdInput;
  UpdateTenantUserexecutorPayload: ResolverTypeWrapper<UpdateTenantUserexecutorPayload>;
  UpdateTesContainerimageexecutorByIdInput: UpdateTesContainerimageexecutorByIdInput;
  UpdateTesContainerimageexecutorPayload: ResolverTypeWrapper<UpdateTesContainerimageexecutorPayload>;
  UpdateTesMockcontainerimageexecutorByContainerimageexecutorPtrIdInput: UpdateTesMockcontainerimageexecutorByContainerimageexecutorPtrIdInput;
  UpdateTesMockcontainerimageexecutorPayload: ResolverTypeWrapper<UpdateTesMockcontainerimageexecutorPayload>;
  UpdateTesMocktaskexecutorByTaskexecutorPtrIdInput: UpdateTesMocktaskexecutorByTaskexecutorPtrIdInput;
  UpdateTesMocktaskexecutorPayload: ResolverTypeWrapper<UpdateTesMocktaskexecutorPayload>;
  UpdateTesTaskexecutorByIdInput: UpdateTesTaskexecutorByIdInput;
  UpdateTesTaskexecutorPayload: ResolverTypeWrapper<UpdateTesTaskexecutorPayload>;
  UpdateToolByIdInput: UpdateToolByIdInput;
  UpdateToolByProjectIdInput: UpdateToolByProjectIdInput;
  UpdateToolParameterByIdInput: UpdateToolParameterByIdInput;
  UpdateToolParameterPayload: ResolverTypeWrapper<UpdateToolParameterPayload>;
  UpdateToolPayload: ResolverTypeWrapper<UpdateToolPayload>;
  UpdateToolResourceByIdInput: UpdateToolResourceByIdInput;
  UpdateToolResourceByTypeAndToolVersionIdInput: UpdateToolResourceByTypeAndToolVersionIdInput;
  UpdateToolResourcePayload: ResolverTypeWrapper<UpdateToolResourcePayload>;
  UpdateToolResultByIdInput: UpdateToolResultByIdInput;
  UpdateToolResultPayload: ResolverTypeWrapper<UpdateToolResultPayload>;
  UpdateToolSecretByIdInput: UpdateToolSecretByIdInput;
  UpdateToolSecretPayload: ResolverTypeWrapper<UpdateToolSecretPayload>;
  UpdateToolSourceByIdInput: UpdateToolSourceByIdInput;
  UpdateToolSourcePayload: ResolverTypeWrapper<UpdateToolSourcePayload>;
  UpdateToolTenantByIdInput: UpdateToolTenantByIdInput;
  UpdateToolTenantByToolIdAndTenantIdInput: UpdateToolTenantByToolIdAndTenantIdInput;
  UpdateToolTenantPayload: ResolverTypeWrapper<UpdateToolTenantPayload>;
  UpdateToolVersionByIdInput: UpdateToolVersionByIdInput;
  UpdateToolVersionPayload: ResolverTypeWrapper<UpdateToolVersionPayload>;
  UpdateToolboxByIdInput: UpdateToolboxByIdInput;
  UpdateToolboxByKeyInput: UpdateToolboxByKeyInput;
  UpdateToolboxPayload: ResolverTypeWrapper<UpdateToolboxPayload>;
  UpdateToolboxTenantByIdInput: UpdateToolboxTenantByIdInput;
  UpdateToolboxTenantByToolboxIdAndTenantIdInput: UpdateToolboxTenantByToolboxIdAndTenantIdInput;
  UpdateToolboxTenantPayload: ResolverTypeWrapper<UpdateToolboxTenantPayload>;
  UpdateUserPersonalSpaceRequestByIdInput: UpdateUserPersonalSpaceRequestByIdInput;
  UpdateUserPersonalSpaceRequestPayload: ResolverTypeWrapper<UpdateUserPersonalSpaceRequestPayload>;
  UpdateWaffleFlagByIdInput: UpdateWaffleFlagByIdInput;
  UpdateWaffleFlagByNameInput: UpdateWaffleFlagByNameInput;
  UpdateWaffleFlagPayload: ResolverTypeWrapper<UpdateWaffleFlagPayload>;
  UpdateWaffleSampleByIdInput: UpdateWaffleSampleByIdInput;
  UpdateWaffleSampleByNameInput: UpdateWaffleSampleByNameInput;
  UpdateWaffleSamplePayload: ResolverTypeWrapper<UpdateWaffleSamplePayload>;
  UpdateWaffleSwitchByIdInput: UpdateWaffleSwitchByIdInput;
  UpdateWaffleSwitchByNameInput: UpdateWaffleSwitchByNameInput;
  UpdateWaffleSwitchPayload: ResolverTypeWrapper<UpdateWaffleSwitchPayload>;
  UpdateWorkflowByIdInput: UpdateWorkflowByIdInput;
  UpdateWorkflowDatumByIdInput: UpdateWorkflowDatumByIdInput;
  UpdateWorkflowDatumPayload: ResolverTypeWrapper<UpdateWorkflowDatumPayload>;
  UpdateWorkflowPayload: ResolverTypeWrapper<UpdateWorkflowPayload>;
  UpdateWorkflowResultByIdInput: UpdateWorkflowResultByIdInput;
  UpdateWorkflowResultPayload: ResolverTypeWrapper<UpdateWorkflowResultPayload>;
  UpdateWorkflowResultWorkflowVersionByIdInput: UpdateWorkflowResultWorkflowVersionByIdInput;
  UpdateWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdInput: UpdateWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdInput;
  UpdateWorkflowResultWorkflowVersionPayload: ResolverTypeWrapper<UpdateWorkflowResultWorkflowVersionPayload>;
  UpdateWorkflowSectionBlockByIdInput: UpdateWorkflowSectionBlockByIdInput;
  UpdateWorkflowSectionBlockPayload: ResolverTypeWrapper<UpdateWorkflowSectionBlockPayload>;
  UpdateWorkflowSectionBlockSectionByBlockIdAndSectionIdInput: UpdateWorkflowSectionBlockSectionByBlockIdAndSectionIdInput;
  UpdateWorkflowSectionBlockSectionByIdInput: UpdateWorkflowSectionBlockSectionByIdInput;
  UpdateWorkflowSectionBlockSectionPayload: ResolverTypeWrapper<UpdateWorkflowSectionBlockSectionPayload>;
  UpdateWorkflowSectionByIdInput: UpdateWorkflowSectionByIdInput;
  UpdateWorkflowSectionPayload: ResolverTypeWrapper<UpdateWorkflowSectionPayload>;
  UpdateWorkflowSectionWorkflowVersionByIdInput: UpdateWorkflowSectionWorkflowVersionByIdInput;
  UpdateWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdInput: UpdateWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdInput;
  UpdateWorkflowSectionWorkflowVersionPayload: ResolverTypeWrapper<UpdateWorkflowSectionWorkflowVersionPayload>;
  UpdateWorkflowSourceByIdInput: UpdateWorkflowSourceByIdInput;
  UpdateWorkflowSourcePayload: ResolverTypeWrapper<UpdateWorkflowSourcePayload>;
  UpdateWorkflowSourceWorkflowVersionByIdInput: UpdateWorkflowSourceWorkflowVersionByIdInput;
  UpdateWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdInput: UpdateWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdInput;
  UpdateWorkflowSourceWorkflowVersionPayload: ResolverTypeWrapper<UpdateWorkflowSourceWorkflowVersionPayload>;
  UpdateWorkflowVersionByIdInput: UpdateWorkflowVersionByIdInput;
  UpdateWorkflowVersionPayload: ResolverTypeWrapper<UpdateWorkflowVersionPayload>;
  UserAccessToProject: ResolverTypeWrapper<UserAccessToProject>;
  UserAccessToProjectCondition: UserAccessToProjectCondition;
  UserAccessToProjectFilter: UserAccessToProjectFilter;
  UserAccessToProjectsConnection: ResolverTypeWrapper<UserAccessToProjectsConnection>;
  UserAccessToProjectsEdge: ResolverTypeWrapper<UserAccessToProjectsEdge>;
  UserAccessToProjectsOrderBy: UserAccessToProjectsOrderBy;
  UserOnboardingQuesQuestionId65Ae6E1FFkUserOnboInput: UserOnboardingQuesQuestionId65Ae6E1FFkUserOnboInput;
  UserOnboardingQuesQuestionId65Ae6E1FFkUserOnboInverseInput: UserOnboardingQuesQuestionId65Ae6E1FFkUserOnboInverseInput;
  UserOnboardingQuesQuestionIdC28D2284FkUserOnboInput: UserOnboardingQuesQuestionIdC28D2284FkUserOnboInput;
  UserOnboardingQuesQuestionIdC28D2284FkUserOnboInverseInput: UserOnboardingQuesQuestionIdC28D2284FkUserOnboInverseInput;
  UserOnboardingQuesUserId72Eee3DfFkApplicatiApplicationUserCreateInput: UserOnboardingQuesUserId72Eee3DfFkApplicatiApplicationUserCreateInput;
  UserOnboardingQuesUserId72Eee3DfFkApplicatiInput: UserOnboardingQuesUserId72Eee3DfFkApplicatiInput;
  UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput: UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput;
  UserOnboardingQuestion: ResolverTypeWrapper<UserOnboardingQuestion>;
  UserOnboardingQuestionAnswer: ResolverTypeWrapper<UserOnboardingQuestionAnswer>;
  UserOnboardingQuestionAnswerCondition: UserOnboardingQuestionAnswerCondition;
  UserOnboardingQuestionAnswerFilter: UserOnboardingQuestionAnswerFilter;
  UserOnboardingQuestionAnswerOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionAnswerPkeyUpdate: UserOnboardingQuestionAnswerOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionAnswerPkeyUpdate;
  UserOnboardingQuestionAnswerUserOnboardingQuestionAnswerPkeyConnect: UserOnboardingQuestionAnswerUserOnboardingQuestionAnswerPkeyConnect;
  UserOnboardingQuestionAnswersConnection: ResolverTypeWrapper<UserOnboardingQuestionAnswersConnection>;
  UserOnboardingQuestionAnswersEdge: ResolverTypeWrapper<UserOnboardingQuestionAnswersEdge>;
  UserOnboardingQuestionAnswersOrderBy: UserOnboardingQuestionAnswersOrderBy;
  UserOnboardingQuestionCondition: UserOnboardingQuestionCondition;
  UserOnboardingQuestionFilter: UserOnboardingQuestionFilter;
  UserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionCodeKeyUpdate: UserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionCodeKeyUpdate;
  UserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionPkeyUpdate: UserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionPkeyUpdate;
  UserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionCodeKeyUpdate: UserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionCodeKeyUpdate;
  UserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionPkeyUpdate: UserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionPkeyUpdate;
  UserOnboardingQuestionResponse: ResolverTypeWrapper<UserOnboardingQuestionResponse>;
  UserOnboardingQuestionResponseCondition: UserOnboardingQuestionResponseCondition;
  UserOnboardingQuestionResponseFilter: UserOnboardingQuestionResponseFilter;
  UserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionResponsePkeyUpdate: UserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionResponsePkeyUpdate;
  UserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingUserOnboardingQuestionResponsePkeyUpdate: UserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingUserOnboardingQuestionResponsePkeyUpdate;
  UserOnboardingQuestionResponseUserOnboardingQuestionResponsePkeyConnect: UserOnboardingQuestionResponseUserOnboardingQuestionResponsePkeyConnect;
  UserOnboardingQuestionResponsesConnection: ResolverTypeWrapper<UserOnboardingQuestionResponsesConnection>;
  UserOnboardingQuestionResponsesEdge: ResolverTypeWrapper<UserOnboardingQuestionResponsesEdge>;
  UserOnboardingQuestionResponsesOrderBy: UserOnboardingQuestionResponsesOrderBy;
  UserOnboardingQuestionToManyUserOnboardingQuestionAnswerFilter: UserOnboardingQuestionToManyUserOnboardingQuestionAnswerFilter;
  UserOnboardingQuestionToManyUserOnboardingQuestionResponseFilter: UserOnboardingQuestionToManyUserOnboardingQuestionResponseFilter;
  UserOnboardingQuestionUserOnboardingQuestionCodeKeyConnect: UserOnboardingQuestionUserOnboardingQuestionCodeKeyConnect;
  UserOnboardingQuestionUserOnboardingQuestionPkeyConnect: UserOnboardingQuestionUserOnboardingQuestionPkeyConnect;
  UserOnboardingQuestionsConnection: ResolverTypeWrapper<UserOnboardingQuestionsConnection>;
  UserOnboardingQuestionsEdge: ResolverTypeWrapper<UserOnboardingQuestionsEdge>;
  UserOnboardingQuestionsOrderBy: UserOnboardingQuestionsOrderBy;
  UserPersonalSpaceRequest: ResolverTypeWrapper<UserPersonalSpaceRequest>;
  UserPersonalSpaceRequestCondition: UserPersonalSpaceRequestCondition;
  UserPersonalSpaceRequestFilter: UserPersonalSpaceRequestFilter;
  UserPersonalSpaceRequestInput: UserPersonalSpaceRequestInput;
  UserPersonalSpaceRequestOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingUserPersonalSpaceRequestPkeyUpdate: UserPersonalSpaceRequestOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingUserPersonalSpaceRequestPkeyUpdate;
  UserPersonalSpaceRequestPatch: UserPersonalSpaceRequestPatch;
  UserPersonalSpaceRequestUserPersonalSpaceRequestPkeyConnect: UserPersonalSpaceRequestUserPersonalSpaceRequestPkeyConnect;
  UserPersonalSpaceRequestUserPersonalSpaceRequestPkeyDelete: UserPersonalSpaceRequestUserPersonalSpaceRequestPkeyDelete;
  UserPersonalSpaceRequestsConnection: ResolverTypeWrapper<UserPersonalSpaceRequestsConnection>;
  UserPersonalSpaceRequestsEdge: ResolverTypeWrapper<UserPersonalSpaceRequestsEdge>;
  UserPersonalSpaceRequestsOrderBy: UserPersonalSpaceRequestsOrderBy;
  UserPersonalSpaceUserId71D37C1EFkApplicatiApplicationUserCreateInput: UserPersonalSpaceUserId71D37C1EFkApplicatiApplicationUserCreateInput;
  UserPersonalSpaceUserId71D37C1EFkApplicatiInput: UserPersonalSpaceUserId71D37C1EFkApplicatiInput;
  UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput: UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput;
  UserPersonalSpaceUserId71D37C1EFkApplicatiUserPersonalSpaceRequestCreateInput: UserPersonalSpaceUserId71D37C1EFkApplicatiUserPersonalSpaceRequestCreateInput;
  WaffleFlag: ResolverTypeWrapper<WaffleFlag>;
  WaffleFlagCondition: WaffleFlagCondition;
  WaffleFlagFilter: WaffleFlagFilter;
  WaffleFlagInput: WaffleFlagInput;
  WaffleFlagPatch: WaffleFlagPatch;
  WaffleFlagsConnection: ResolverTypeWrapper<WaffleFlagsConnection>;
  WaffleFlagsEdge: ResolverTypeWrapper<WaffleFlagsEdge>;
  WaffleFlagsOrderBy: WaffleFlagsOrderBy;
  WaffleSample: ResolverTypeWrapper<WaffleSample>;
  WaffleSampleCondition: WaffleSampleCondition;
  WaffleSampleFilter: WaffleSampleFilter;
  WaffleSampleInput: WaffleSampleInput;
  WaffleSamplePatch: WaffleSamplePatch;
  WaffleSamplesConnection: ResolverTypeWrapper<WaffleSamplesConnection>;
  WaffleSamplesEdge: ResolverTypeWrapper<WaffleSamplesEdge>;
  WaffleSamplesOrderBy: WaffleSamplesOrderBy;
  WaffleSwitch: ResolverTypeWrapper<WaffleSwitch>;
  WaffleSwitchCondition: WaffleSwitchCondition;
  WaffleSwitchFilter: WaffleSwitchFilter;
  WaffleSwitchInput: WaffleSwitchInput;
  WaffleSwitchPatch: WaffleSwitchPatch;
  WaffleSwitchesConnection: ResolverTypeWrapper<WaffleSwitchesConnection>;
  WaffleSwitchesEdge: ResolverTypeWrapper<WaffleSwitchesEdge>;
  WaffleSwitchesOrderBy: WaffleSwitchesOrderBy;
  Workflow: ResolverTypeWrapper<Workflow>;
  WorkflowCondition: WorkflowCondition;
  WorkflowContainerIdE73A96E5FkContainerImageIdContainerImageCreateInput: WorkflowContainerIdE73A96E5FkContainerImageIdContainerImageCreateInput;
  WorkflowContainerIdE73A96E5FkContainerImageIdInput: WorkflowContainerIdE73A96E5FkContainerImageIdInput;
  WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput: WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput;
  WorkflowContainerIdE73A96E5FkContainerImageIdWorkflowCreateInput: WorkflowContainerIdE73A96E5FkContainerImageIdWorkflowCreateInput;
  WorkflowDataConnection: ResolverTypeWrapper<WorkflowDataConnection>;
  WorkflowDataEdge: ResolverTypeWrapper<WorkflowDataEdge>;
  WorkflowDataOrderBy: WorkflowDataOrderBy;
  WorkflowDatum: ResolverTypeWrapper<WorkflowDatum>;
  WorkflowDatumCondition: WorkflowDatumCondition;
  WorkflowDatumFilter: WorkflowDatumFilter;
  WorkflowDatumInput: WorkflowDatumInput;
  WorkflowDatumOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdUsingWorkflowDataPkeyUpdate: WorkflowDatumOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdUsingWorkflowDataPkeyUpdate;
  WorkflowDatumOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdUsingWorkflowDataPkeyUpdate: WorkflowDatumOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdUsingWorkflowDataPkeyUpdate;
  WorkflowDatumPatch: WorkflowDatumPatch;
  WorkflowDatumToManyWorkflowResultFilter: WorkflowDatumToManyWorkflowResultFilter;
  WorkflowDatumToManyWorkflowSectionBlockFilter: WorkflowDatumToManyWorkflowSectionBlockFilter;
  WorkflowDatumWorkflowDataPkeyConnect: WorkflowDatumWorkflowDataPkeyConnect;
  WorkflowDatumWorkflowDataPkeyDelete: WorkflowDatumWorkflowDataPkeyDelete;
  WorkflowFilter: WorkflowFilter;
  WorkflowInput: WorkflowInput;
  WorkflowOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingWorkflowPkeyUpdate: WorkflowOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingWorkflowPkeyUpdate;
  WorkflowOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingWorkflowPkeyUpdate: WorkflowOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingWorkflowPkeyUpdate;
  WorkflowOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingWorkflowPkeyUpdate: WorkflowOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingWorkflowPkeyUpdate;
  WorkflowOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdUsingWorkflowPkeyUpdate: WorkflowOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdUsingWorkflowPkeyUpdate;
  WorkflowPatch: WorkflowPatch;
  WorkflowResult: ResolverTypeWrapper<WorkflowResult>;
  WorkflowResultCondition: WorkflowResultCondition;
  WorkflowResultFilter: WorkflowResultFilter;
  WorkflowResultInput: WorkflowResultInput;
  WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInput: WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInput;
  WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInverseInput: WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInverseInput;
  WorkflowResultObjectIdC561D1C5FkWorkflowDataIdWorkflowDataCreateInput: WorkflowResultObjectIdC561D1C5FkWorkflowDataIdWorkflowDataCreateInput;
  WorkflowResultObjectIdC561D1C5FkWorkflowDataIdWorkflowResultCreateInput: WorkflowResultObjectIdC561D1C5FkWorkflowDataIdWorkflowResultCreateInput;
  WorkflowResultOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdUsingWorkflowResultPkeyUpdate: WorkflowResultOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdUsingWorkflowResultPkeyUpdate;
  WorkflowResultOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultPkeyUpdate: WorkflowResultOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultPkeyUpdate;
  WorkflowResultPatch: WorkflowResultPatch;
  WorkflowResultToManyWorkflowResultWorkflowVersionFilter: WorkflowResultToManyWorkflowResultWorkflowVersionFilter;
  WorkflowResultWorkResultId50F959E2FkWorkflowInput: WorkflowResultWorkResultId50F959E2FkWorkflowInput;
  WorkflowResultWorkResultId50F959E2FkWorkflowInverseInput: WorkflowResultWorkResultId50F959E2FkWorkflowInverseInput;
  WorkflowResultWorkResultId50F959E2FkWorkflowWorkflowResultCreateInput: WorkflowResultWorkResultId50F959E2FkWorkflowWorkflowResultCreateInput;
  WorkflowResultWorkResultId50F959E2FkWorkflowWorkflowResultWorkflowVersionsCreateInput: WorkflowResultWorkResultId50F959E2FkWorkflowWorkflowResultWorkflowVersionsCreateInput;
  WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInput: WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInput;
  WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInverseInput: WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInverseInput;
  WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowWorkflowResultWorkflowVersionsCreateInput: WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowWorkflowResultWorkflowVersionsCreateInput;
  WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowWorkflowVersionCreateInput: WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowWorkflowVersionCreateInput;
  WorkflowResultWorkflowResultPkeyConnect: WorkflowResultWorkflowResultPkeyConnect;
  WorkflowResultWorkflowResultPkeyDelete: WorkflowResultWorkflowResultPkeyDelete;
  WorkflowResultWorkflowVersion: ResolverTypeWrapper<WorkflowResultWorkflowVersion>;
  WorkflowResultWorkflowVersionCondition: WorkflowResultWorkflowVersionCondition;
  WorkflowResultWorkflowVersionFilter: WorkflowResultWorkflowVersionFilter;
  WorkflowResultWorkflowVersionInput: WorkflowResultWorkflowVersionInput;
  WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqUpdate: WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqUpdate;
  WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultWorkflowVersionsPkeyUpdate: WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultWorkflowVersionsPkeyUpdate;
  WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqUpdate: WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqUpdate;
  WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowResultWorkflowVersionsPkeyUpdate: WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowResultWorkflowVersionsPkeyUpdate;
  WorkflowResultWorkflowVersionPatch: WorkflowResultWorkflowVersionPatch;
  WorkflowResultWorkflowVersionWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqConnect: WorkflowResultWorkflowVersionWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqConnect;
  WorkflowResultWorkflowVersionWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqDelete: WorkflowResultWorkflowVersionWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqDelete;
  WorkflowResultWorkflowVersionWorkflowResultWorkflowVersionsPkeyConnect: WorkflowResultWorkflowVersionWorkflowResultWorkflowVersionsPkeyConnect;
  WorkflowResultWorkflowVersionWorkflowResultWorkflowVersionsPkeyDelete: WorkflowResultWorkflowVersionWorkflowResultWorkflowVersionsPkeyDelete;
  WorkflowResultWorkflowVersionsConnection: ResolverTypeWrapper<WorkflowResultWorkflowVersionsConnection>;
  WorkflowResultWorkflowVersionsEdge: ResolverTypeWrapper<WorkflowResultWorkflowVersionsEdge>;
  WorkflowResultWorkflowVersionsOrderBy: WorkflowResultWorkflowVersionsOrderBy;
  WorkflowResultsConnection: ResolverTypeWrapper<WorkflowResultsConnection>;
  WorkflowResultsEdge: ResolverTypeWrapper<WorkflowResultsEdge>;
  WorkflowResultsOrderBy: WorkflowResultsOrderBy;
  WorkflowSection: ResolverTypeWrapper<WorkflowSection>;
  WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInput: WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInput;
  WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInverseInput: WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInverseInput;
  WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowWorkflowSectionBlockCreateInput: WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowWorkflowSectionBlockCreateInput;
  WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowWorkflowSectionBlockSectionsCreateInput: WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowWorkflowSectionBlockSectionsCreateInput;
  WorkflowSectionBloSectionId817C1C77FkWorkflowInput: WorkflowSectionBloSectionId817C1C77FkWorkflowInput;
  WorkflowSectionBloSectionId817C1C77FkWorkflowInverseInput: WorkflowSectionBloSectionId817C1C77FkWorkflowInverseInput;
  WorkflowSectionBloSectionId817C1C77FkWorkflowWorkflowSectionBlockSectionsCreateInput: WorkflowSectionBloSectionId817C1C77FkWorkflowWorkflowSectionBlockSectionsCreateInput;
  WorkflowSectionBloSectionId817C1C77FkWorkflowWorkflowSectionCreateInput: WorkflowSectionBloSectionId817C1C77FkWorkflowWorkflowSectionCreateInput;
  WorkflowSectionBlock: ResolverTypeWrapper<WorkflowSectionBlock>;
  WorkflowSectionBlockCondition: WorkflowSectionBlockCondition;
  WorkflowSectionBlockFilter: WorkflowSectionBlockFilter;
  WorkflowSectionBlockInput: WorkflowSectionBlockInput;
  WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInput: WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInput;
  WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInverseInput: WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInverseInput;
  WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdWorkflowDataCreateInput: WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdWorkflowDataCreateInput;
  WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdWorkflowSectionBlockCreateInput: WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdWorkflowSectionBlockCreateInput;
  WorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdUsingWorkflowSectionBlockPkeyUpdate: WorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdUsingWorkflowSectionBlockPkeyUpdate;
  WorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdUsingWorkflowSectionBlockPkeyUpdate: WorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdUsingWorkflowSectionBlockPkeyUpdate;
  WorkflowSectionBlockOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockPkeyUpdate: WorkflowSectionBlockOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockPkeyUpdate;
  WorkflowSectionBlockPatch: WorkflowSectionBlockPatch;
  WorkflowSectionBlockSection: ResolverTypeWrapper<WorkflowSectionBlockSection>;
  WorkflowSectionBlockSectionCondition: WorkflowSectionBlockSectionCondition;
  WorkflowSectionBlockSectionFilter: WorkflowSectionBlockSectionFilter;
  WorkflowSectionBlockSectionInput: WorkflowSectionBlockSectionInput;
  WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockSBlockIdSectionId2F785D93UniqUpdate: WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockSBlockIdSectionId2F785D93UniqUpdate;
  WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockSectionsPkeyUpdate: WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockSectionsPkeyUpdate;
  WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionBlockSBlockIdSectionId2F785D93UniqUpdate: WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionBlockSBlockIdSectionId2F785D93UniqUpdate;
  WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionBlockSectionsPkeyUpdate: WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionBlockSectionsPkeyUpdate;
  WorkflowSectionBlockSectionPatch: WorkflowSectionBlockSectionPatch;
  WorkflowSectionBlockSectionWorkflowSectionBlockSBlockIdSectionId2F785D93UniqConnect: WorkflowSectionBlockSectionWorkflowSectionBlockSBlockIdSectionId2F785D93UniqConnect;
  WorkflowSectionBlockSectionWorkflowSectionBlockSBlockIdSectionId2F785D93UniqDelete: WorkflowSectionBlockSectionWorkflowSectionBlockSBlockIdSectionId2F785D93UniqDelete;
  WorkflowSectionBlockSectionWorkflowSectionBlockSectionsPkeyConnect: WorkflowSectionBlockSectionWorkflowSectionBlockSectionsPkeyConnect;
  WorkflowSectionBlockSectionWorkflowSectionBlockSectionsPkeyDelete: WorkflowSectionBlockSectionWorkflowSectionBlockSectionsPkeyDelete;
  WorkflowSectionBlockSectionsConnection: ResolverTypeWrapper<WorkflowSectionBlockSectionsConnection>;
  WorkflowSectionBlockSectionsEdge: ResolverTypeWrapper<WorkflowSectionBlockSectionsEdge>;
  WorkflowSectionBlockSectionsOrderBy: WorkflowSectionBlockSectionsOrderBy;
  WorkflowSectionBlockToManyWorkflowSectionBlockSectionFilter: WorkflowSectionBlockToManyWorkflowSectionBlockSectionFilter;
  WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInput: WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInput;
  WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput: WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput;
  WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdToolVersionCreateInput: WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdToolVersionCreateInput;
  WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdWorkflowSectionBlockCreateInput: WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdWorkflowSectionBlockCreateInput;
  WorkflowSectionBlockWorkflowSectionBlockPkeyConnect: WorkflowSectionBlockWorkflowSectionBlockPkeyConnect;
  WorkflowSectionBlockWorkflowSectionBlockPkeyDelete: WorkflowSectionBlockWorkflowSectionBlockPkeyDelete;
  WorkflowSectionBlocksConnection: ResolverTypeWrapper<WorkflowSectionBlocksConnection>;
  WorkflowSectionBlocksEdge: ResolverTypeWrapper<WorkflowSectionBlocksEdge>;
  WorkflowSectionBlocksOrderBy: WorkflowSectionBlocksOrderBy;
  WorkflowSectionCondition: WorkflowSectionCondition;
  WorkflowSectionFilter: WorkflowSectionFilter;
  WorkflowSectionInput: WorkflowSectionInput;
  WorkflowSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionPkeyUpdate: WorkflowSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionPkeyUpdate;
  WorkflowSectionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionPkeyUpdate: WorkflowSectionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionPkeyUpdate;
  WorkflowSectionPatch: WorkflowSectionPatch;
  WorkflowSectionToManyWorkflowSectionBlockSectionFilter: WorkflowSectionToManyWorkflowSectionBlockSectionFilter;
  WorkflowSectionToManyWorkflowSectionWorkflowVersionFilter: WorkflowSectionToManyWorkflowSectionWorkflowVersionFilter;
  WorkflowSectionWorSectionId1D5C2D63FkWorkflowInput: WorkflowSectionWorSectionId1D5C2D63FkWorkflowInput;
  WorkflowSectionWorSectionId1D5C2D63FkWorkflowInverseInput: WorkflowSectionWorSectionId1D5C2D63FkWorkflowInverseInput;
  WorkflowSectionWorSectionId1D5C2D63FkWorkflowWorkflowSectionCreateInput: WorkflowSectionWorSectionId1D5C2D63FkWorkflowWorkflowSectionCreateInput;
  WorkflowSectionWorSectionId1D5C2D63FkWorkflowWorkflowSectionWorkflowVersionsCreateInput: WorkflowSectionWorSectionId1D5C2D63FkWorkflowWorkflowSectionWorkflowVersionsCreateInput;
  WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInput: WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInput;
  WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInverseInput: WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInverseInput;
  WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowWorkflowSectionWorkflowVersionsCreateInput: WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowWorkflowSectionWorkflowVersionsCreateInput;
  WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowWorkflowVersionCreateInput: WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowWorkflowVersionCreateInput;
  WorkflowSectionWorkflowSectionPkeyConnect: WorkflowSectionWorkflowSectionPkeyConnect;
  WorkflowSectionWorkflowSectionPkeyDelete: WorkflowSectionWorkflowSectionPkeyDelete;
  WorkflowSectionWorkflowVersion: ResolverTypeWrapper<WorkflowSectionWorkflowVersion>;
  WorkflowSectionWorkflowVersionCondition: WorkflowSectionWorkflowVersionCondition;
  WorkflowSectionWorkflowVersionFilter: WorkflowSectionWorkflowVersionFilter;
  WorkflowSectionWorkflowVersionInput: WorkflowSectionWorkflowVersionInput;
  WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqUpdate: WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqUpdate;
  WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionWorkflowVersionsPkeyUpdate: WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionWorkflowVersionsPkeyUpdate;
  WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqUpdate: WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqUpdate;
  WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowSectionWorkflowVersionsPkeyUpdate: WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowSectionWorkflowVersionsPkeyUpdate;
  WorkflowSectionWorkflowVersionPatch: WorkflowSectionWorkflowVersionPatch;
  WorkflowSectionWorkflowVersionWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqConnect: WorkflowSectionWorkflowVersionWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqConnect;
  WorkflowSectionWorkflowVersionWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqDelete: WorkflowSectionWorkflowVersionWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqDelete;
  WorkflowSectionWorkflowVersionWorkflowSectionWorkflowVersionsPkeyConnect: WorkflowSectionWorkflowVersionWorkflowSectionWorkflowVersionsPkeyConnect;
  WorkflowSectionWorkflowVersionWorkflowSectionWorkflowVersionsPkeyDelete: WorkflowSectionWorkflowVersionWorkflowSectionWorkflowVersionsPkeyDelete;
  WorkflowSectionWorkflowVersionsConnection: ResolverTypeWrapper<WorkflowSectionWorkflowVersionsConnection>;
  WorkflowSectionWorkflowVersionsEdge: ResolverTypeWrapper<WorkflowSectionWorkflowVersionsEdge>;
  WorkflowSectionWorkflowVersionsOrderBy: WorkflowSectionWorkflowVersionsOrderBy;
  WorkflowSectionsConnection: ResolverTypeWrapper<WorkflowSectionsConnection>;
  WorkflowSectionsEdge: ResolverTypeWrapper<WorkflowSectionsEdge>;
  WorkflowSectionsOrderBy: WorkflowSectionsOrderBy;
  WorkflowSource: ResolverTypeWrapper<WorkflowSource>;
  WorkflowSourceCondition: WorkflowSourceCondition;
  WorkflowSourceFilter: WorkflowSourceFilter;
  WorkflowSourceInput: WorkflowSourceInput;
  WorkflowSourceOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourcePkeyUpdate: WorkflowSourceOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourcePkeyUpdate;
  WorkflowSourcePatch: WorkflowSourcePatch;
  WorkflowSourceToManyWorkflowSourceWorkflowVersionFilter: WorkflowSourceToManyWorkflowSourceWorkflowVersionFilter;
  WorkflowSourceWorkSourceId608A289DFkWorkflowInput: WorkflowSourceWorkSourceId608A289DFkWorkflowInput;
  WorkflowSourceWorkSourceId608A289DFkWorkflowInverseInput: WorkflowSourceWorkSourceId608A289DFkWorkflowInverseInput;
  WorkflowSourceWorkSourceId608A289DFkWorkflowWorkflowSourceCreateInput: WorkflowSourceWorkSourceId608A289DFkWorkflowWorkflowSourceCreateInput;
  WorkflowSourceWorkSourceId608A289DFkWorkflowWorkflowSourceWorkflowVersionsCreateInput: WorkflowSourceWorkSourceId608A289DFkWorkflowWorkflowSourceWorkflowVersionsCreateInput;
  WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInput: WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInput;
  WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInverseInput: WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInverseInput;
  WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowWorkflowSourceWorkflowVersionsCreateInput: WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowWorkflowSourceWorkflowVersionsCreateInput;
  WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowWorkflowVersionCreateInput: WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowWorkflowVersionCreateInput;
  WorkflowSourceWorkflowSourcePkeyConnect: WorkflowSourceWorkflowSourcePkeyConnect;
  WorkflowSourceWorkflowSourcePkeyDelete: WorkflowSourceWorkflowSourcePkeyDelete;
  WorkflowSourceWorkflowVersion: ResolverTypeWrapper<WorkflowSourceWorkflowVersion>;
  WorkflowSourceWorkflowVersionCondition: WorkflowSourceWorkflowVersionCondition;
  WorkflowSourceWorkflowVersionFilter: WorkflowSourceWorkflowVersionFilter;
  WorkflowSourceWorkflowVersionInput: WorkflowSourceWorkflowVersionInput;
  WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqUpdate: WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqUpdate;
  WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourceWorkflowVersionsPkeyUpdate: WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourceWorkflowVersionsPkeyUpdate;
  WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqUpdate: WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqUpdate;
  WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowSourceWorkflowVersionsPkeyUpdate: WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowSourceWorkflowVersionsPkeyUpdate;
  WorkflowSourceWorkflowVersionPatch: WorkflowSourceWorkflowVersionPatch;
  WorkflowSourceWorkflowVersionWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqConnect: WorkflowSourceWorkflowVersionWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqConnect;
  WorkflowSourceWorkflowVersionWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqDelete: WorkflowSourceWorkflowVersionWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqDelete;
  WorkflowSourceWorkflowVersionWorkflowSourceWorkflowVersionsPkeyConnect: WorkflowSourceWorkflowVersionWorkflowSourceWorkflowVersionsPkeyConnect;
  WorkflowSourceWorkflowVersionWorkflowSourceWorkflowVersionsPkeyDelete: WorkflowSourceWorkflowVersionWorkflowSourceWorkflowVersionsPkeyDelete;
  WorkflowSourceWorkflowVersionsConnection: ResolverTypeWrapper<WorkflowSourceWorkflowVersionsConnection>;
  WorkflowSourceWorkflowVersionsEdge: ResolverTypeWrapper<WorkflowSourceWorkflowVersionsEdge>;
  WorkflowSourceWorkflowVersionsOrderBy: WorkflowSourceWorkflowVersionsOrderBy;
  WorkflowSourcesConnection: ResolverTypeWrapper<WorkflowSourcesConnection>;
  WorkflowSourcesEdge: ResolverTypeWrapper<WorkflowSourcesEdge>;
  WorkflowSourcesOrderBy: WorkflowSourcesOrderBy;
  WorkflowTenantId9469Ff84FkTenantIdInput: WorkflowTenantId9469Ff84FkTenantIdInput;
  WorkflowTenantId9469Ff84FkTenantIdInverseInput: WorkflowTenantId9469Ff84FkTenantIdInverseInput;
  WorkflowTenantId9469Ff84FkTenantIdTenantCreateInput: WorkflowTenantId9469Ff84FkTenantIdTenantCreateInput;
  WorkflowTenantId9469Ff84FkTenantIdWorkflowCreateInput: WorkflowTenantId9469Ff84FkTenantIdWorkflowCreateInput;
  WorkflowToManyWorkflowVersionFilter: WorkflowToManyWorkflowVersionFilter;
  WorkflowUserId121C1967FkApplicationUserIdApplicationUserCreateInput: WorkflowUserId121C1967FkApplicationUserIdApplicationUserCreateInput;
  WorkflowUserId121C1967FkApplicationUserIdInput: WorkflowUserId121C1967FkApplicationUserIdInput;
  WorkflowUserId121C1967FkApplicationUserIdInverseInput: WorkflowUserId121C1967FkApplicationUserIdInverseInput;
  WorkflowUserId121C1967FkApplicationUserIdWorkflowCreateInput: WorkflowUserId121C1967FkApplicationUserIdWorkflowCreateInput;
  WorkflowVersion: ResolverTypeWrapper<WorkflowVersion>;
  WorkflowVersionCondition: WorkflowVersionCondition;
  WorkflowVersionFilter: WorkflowVersionFilter;
  WorkflowVersionInput: WorkflowVersionInput;
  WorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowVersionPkeyUpdate: WorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowVersionPkeyUpdate;
  WorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowVersionPkeyUpdate: WorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowVersionPkeyUpdate;
  WorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowVersionPkeyUpdate: WorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowVersionPkeyUpdate;
  WorkflowVersionOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingWorkflowVersionPkeyUpdate: WorkflowVersionOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingWorkflowVersionPkeyUpdate;
  WorkflowVersionOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdUsingWorkflowVersionPkeyUpdate: WorkflowVersionOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdUsingWorkflowVersionPkeyUpdate;
  WorkflowVersionPatch: WorkflowVersionPatch;
  WorkflowVersionToManyWorkflowResultWorkflowVersionFilter: WorkflowVersionToManyWorkflowResultWorkflowVersionFilter;
  WorkflowVersionToManyWorkflowSectionWorkflowVersionFilter: WorkflowVersionToManyWorkflowSectionWorkflowVersionFilter;
  WorkflowVersionToManyWorkflowSourceWorkflowVersionFilter: WorkflowVersionToManyWorkflowSourceWorkflowVersionFilter;
  WorkflowVersionUserId00C0F62FFkApplicationUserIdApplicationUserCreateInput: WorkflowVersionUserId00C0F62FFkApplicationUserIdApplicationUserCreateInput;
  WorkflowVersionUserId00C0F62FFkApplicationUserIdInput: WorkflowVersionUserId00C0F62FFkApplicationUserIdInput;
  WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput: WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput;
  WorkflowVersionUserId00C0F62FFkApplicationUserIdWorkflowVersionCreateInput: WorkflowVersionUserId00C0F62FFkApplicationUserIdWorkflowVersionCreateInput;
  WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInput: WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInput;
  WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInverseInput: WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInverseInput;
  WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdWorkflowCreateInput: WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdWorkflowCreateInput;
  WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdWorkflowVersionCreateInput: WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdWorkflowVersionCreateInput;
  WorkflowVersionWorkflowVersionPkeyConnect: WorkflowVersionWorkflowVersionPkeyConnect;
  WorkflowVersionWorkflowVersionPkeyDelete: WorkflowVersionWorkflowVersionPkeyDelete;
  WorkflowVersionsConnection: ResolverTypeWrapper<WorkflowVersionsConnection>;
  WorkflowVersionsEdge: ResolverTypeWrapper<WorkflowVersionsEdge>;
  WorkflowVersionsOrderBy: WorkflowVersionsOrderBy;
  WorkflowWorkflowPkeyConnect: WorkflowWorkflowPkeyConnect;
  WorkflowWorkflowPkeyDelete: WorkflowWorkflowPkeyDelete;
  WorkflowsConnection: ResolverTypeWrapper<WorkflowsConnection>;
  WorkflowsEdge: ResolverTypeWrapper<WorkflowsEdge>;
  WorkflowsOrderBy: WorkflowsOrderBy;
  updateApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdPatch: UpdateApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdPatch;
  updateApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdPatch: UpdateApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdPatch;
  updateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch: UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
  updateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch: UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
  updateApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch: UpdateApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
  updateApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdPatch: UpdateApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdPatch;
  updateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch: UpdateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
  updateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch: UpdateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
  updateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch: UpdateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
  updateApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiPatch: UpdateApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiPatch;
  updateApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdPatch: UpdateApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdPatch;
  updateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch: UpdateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
  updateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch: UpdateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
  updateApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdPatch: UpdateApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdPatch;
  updateApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdPatch: UpdateApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdPatch;
  updateApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiPatch: UpdateApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiPatch;
  updateApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdPatch: UpdateApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdPatch;
  updateApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdPatch: UpdateApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdPatch;
  updateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch: UpdateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
  updateApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdPatch: UpdateApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdPatch;
  updateApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdPatch: UpdateApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdPatch;
  updateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch: UpdateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
  updateApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdPatch: UpdateApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdPatch;
  updateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch: UpdateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
  updateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch: UpdateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
  updateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch: UpdateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
  updateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch: UpdateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
  updateApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiPatch: UpdateApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiPatch;
  updateApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiPatch: UpdateApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiPatch;
  updateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch: UpdateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
  updateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch: UpdateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
  updateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch: UpdateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
  updateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch: UpdateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
  updateApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdPatch: UpdateApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdPatch;
  updateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch: UpdateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
  updateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch: UpdateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
  updateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch: UpdateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
  updateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
  updateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
  updateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch: UpdateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
  updateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch: UpdateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
  updateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch: UpdateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
  updateApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiPatch: UpdateApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiPatch;
  updateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
  updateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
  updateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch: UpdateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
  updateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch: UpdateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
  updateApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiPatch: UpdateApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiPatch;
  updateApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiPatch: UpdateApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiPatch;
  updateApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdPatch: UpdateApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdPatch;
  updateApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdPatch: UpdateApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdPatch;
  updateApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch: UpdateApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
  updateApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch: UpdateApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
  updateApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermPatch: UpdateApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermPatch;
  updateApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiPatch: UpdateApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiPatch;
  updateAuditlogLogentryOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdPatch: UpdateAuditlogLogentryOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdPatch;
  updateAuditlogLogentryOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoPatch: UpdateAuditlogLogentryOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoPatch;
  updateAuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdPatch: UpdateAuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdPatch;
  updateAuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdPatch: UpdateAuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdPatch;
  updateAuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdPatch: UpdateAuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdPatch;
  updateAuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermPatch: UpdateAuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermPatch;
  updateAuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdPatch: UpdateAuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdPatch;
  updateAuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermPatch: UpdateAuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermPatch;
  updateAuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermPatch: UpdateAuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermPatch;
  updateAuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoPatch: UpdateAuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoPatch;
  updateAvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch: UpdateAvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
  updateAwsBatchTaskOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskePatch: UpdateAwsBatchTaskOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskePatch;
  updateAwsBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchPatch: UpdateAwsBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchPatch;
  updateAwsCognitoUserOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsPatch: UpdateAwsCognitoUserOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsPatch;
  updateAwsCognitoUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniPatch: UpdateAwsCognitoUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniPatch;
  updateAwsEcrImageOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaPatch: UpdateAwsEcrImageOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaPatch;
  updateAwsEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIPatch: UpdateAwsEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIPatch;
  updateAwsMockBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchPatch: UpdateAwsMockBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchPatch;
  updateAwsMockDistributionImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributPatch: UpdateAwsMockDistributionImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributPatch;
  updateAwsMockEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIPatch: UpdateAwsMockEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIPatch;
  updateAwsMockIamUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniPatch: UpdateAwsMockIamUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniPatch;
  updateAwsMockS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiPatch: UpdateAwsMockS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiPatch;
  updateAwsS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiPatch: UpdateAwsS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiPatch;
  updateAwsS3FileOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdPatch: UpdateAwsS3FileOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdPatch;
  updateCodeFileOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdPatch: UpdateCodeFileOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdPatch;
  updateCodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdPatch: UpdateCodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdPatch;
  updateCodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch: UpdateCodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
  updateCodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch: UpdateCodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
  updateCodeFileOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdPatch: UpdateCodeFileOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdPatch;
  updateCommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdPatch: UpdateCommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdPatch;
  updateCommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdPatch: UpdateCommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdPatch;
  updateCommandOnCommandForCommandTenantId36F95C3CFkTenantIdPatch: UpdateCommandOnCommandForCommandTenantId36F95C3CFkTenantIdPatch;
  updateCommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdPatch: UpdateCommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdPatch;
  updateCommandOnCommandForCommandUserId4A445414FkApplicationUserIdPatch: UpdateCommandOnCommandForCommandUserId4A445414FkApplicationUserIdPatch;
  updateContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdPatch: UpdateContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdPatch;
  updateContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerPatch: UpdateContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerPatch;
  updateContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaPatch: UpdateContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaPatch;
  updateContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdPatch: UpdateContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdPatch;
  updateContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdPatch: UpdateContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdPatch;
  updateContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdPatch: UpdateContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdPatch;
  updateContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdPatch: UpdateContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdPatch;
  updateContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdPatch: UpdateContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdPatch;
  updateContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerPatch: UpdateContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerPatch;
  updateContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiPatch: UpdateContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiPatch;
  updateContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdPatch: UpdateContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdPatch;
  updateCostOnCostForCostTenantId7Dcd58A7FkTenantIdPatch: UpdateCostOnCostForCostTenantId7Dcd58A7FkTenantIdPatch;
  updateCostOnFileActivityForFileActivityCostId2A88D90AFkCostIdPatch: UpdateCostOnFileActivityForFileActivityCostId2A88D90AFkCostIdPatch;
  updateCostOnTaskActivityForTaskActivityCostId49E66058FkCostIdPatch: UpdateCostOnTaskActivityForTaskActivityCostId49E66058FkCostIdPatch;
  updateDataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdPatch: UpdateDataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdPatch;
  updateDataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdPatch: UpdateDataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdPatch;
  updateDataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdPatch: UpdateDataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdPatch;
  updateDataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdPatch: UpdateDataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdPatch;
  updateDataTableColumnDefinitionBooleanOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIPatch: UpdateDataTableColumnDefinitionBooleanOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIPatch;
  updateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoPatch: UpdateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoPatch;
  updateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoPatch: UpdateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoPatch;
  updateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIPatch: UpdateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIPatch;
  updateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoPatch: UpdateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoPatch;
  updateDataTableColumnDefinitionChoiceOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIPatch: UpdateDataTableColumnDefinitionChoiceOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIPatch;
  updateDataTableColumnDefinitionDateOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIPatch: UpdateDataTableColumnDefinitionDateOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIPatch;
  updateDataTableColumnDefinitionFileOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIPatch: UpdateDataTableColumnDefinitionFileOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIPatch;
  updateDataTableColumnDefinitionFloatOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIPatch: UpdateDataTableColumnDefinitionFloatOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIPatch;
  updateDataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIPatch: UpdateDataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIPatch;
  updateDataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoPatch: UpdateDataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoPatch;
  updateDataTableColumnDefinitionIntegerOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIPatch: UpdateDataTableColumnDefinitionIntegerOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIPatch;
  updateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoPatch: UpdateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoPatch;
  updateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIPatch: UpdateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIPatch;
  updateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoPatch: UpdateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoPatch;
  updateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIE4E5D06AFkDjangoCoPatch: UpdateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoPatch;
  updateDataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoPatch: UpdateDataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoPatch;
  updateDataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIPatch: UpdateDataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIPatch;
  updateDataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoPatch: UpdateDataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoPatch;
  updateDataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIPatch: UpdateDataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIPatch;
  updateDataTableColumnDefinitionTextOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIPatch: UpdateDataTableColumnDefinitionTextOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIPatch;
  updateDataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIPatch: UpdateDataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIPatch;
  updateDataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoPatch: UpdateDataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoPatch;
  updateDataTableColumnGroupDefinitionSourceOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIPatch: UpdateDataTableColumnGroupDefinitionSourceOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIPatch;
  updateDataTableColumnGroupOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablPatch: UpdateDataTableColumnGroupOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablPatch;
  updateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoPatch: UpdateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoPatch;
  updateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdPatch: UpdateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdPatch;
  updateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdPatch: UpdateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdPatch;
  updateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdPatch: UpdateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdPatch;
  updateDataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdPatch: UpdateDataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdPatch;
  updateDataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoPatch;
  updateDataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablPatch;
  updateDataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdPatch;
  updateDataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdPatch;
  updateDataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdPatch;
  updateDataTableOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdPatch: UpdateDataTableOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdPatch;
  updateDataTableOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdPatch: UpdateDataTableOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdPatch;
  updateDataTableOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdPatch: UpdateDataTableOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdPatch;
  updateDataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch: UpdateDataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch;
  updateDataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch: UpdateDataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch;
  updateDataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch: UpdateDataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
  updateDataTableOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdPatch: UpdateDataTableOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdPatch;
  updateDataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdPatch: UpdateDataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdPatch;
  updateDataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdPatch: UpdateDataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdPatch;
  updateDataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdPatch: UpdateDataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdPatch;
  updateDataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdPatch: UpdateDataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdPatch;
  updateDistributionRegistryImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributPatch: UpdateDistributionRegistryImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributPatch;
  updateDistributionRegistryImageOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaPatch: UpdateDistributionRegistryImageOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaPatch;
  updateDjangoAdminLogOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoPatch: UpdateDjangoAdminLogOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoPatch;
  updateDjangoAdminLogOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdPatch: UpdateDjangoAdminLogOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdPatch;
  updateDjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoPatch: UpdateDjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoPatch;
  updateDjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoPatch: UpdateDjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIE4E5D06AFkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoPatch;
  updateDjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoPatch: UpdateDjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoPatch;
  updateDjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoPatch: UpdateDjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoPatch;
  updateDjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoPatch: UpdateDjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoPatch;
  updateDjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoPatch: UpdateDjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoPatch;
  updateDjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoPatch: UpdateDjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoPatch;
  updateDjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoPatch: UpdateDjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoPatch;
  updateDjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoPatch: UpdateDjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoPatch;
  updateDjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoPatch: UpdateDjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoPatch;
  updateDrsFileexecutorOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdPatch: UpdateDrsFileexecutorOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdPatch;
  updateDrsFileexecutorOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdPatch: UpdateDrsFileexecutorOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdPatch;
  updateDrsFileexecutorOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoPatch: UpdateDrsFileexecutorOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoPatch;
  updateDrsFileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileePatch: UpdateDrsFileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileePatch;
  updateDrsMockfileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileePatch: UpdateDrsMockfileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileePatch;
  updateEulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch: UpdateEulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch;
  updateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch: UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch;
  updateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch: UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
  updateFeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFPatch: UpdateFeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFPatch;
  updateFeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFPatch: UpdateFeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFPatch;
  updateFeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdPatch: UpdateFeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdPatch;
  updateFeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFPatch: UpdateFeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFPatch;
  updateFeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdPatch: UpdateFeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdPatch;
  updateFeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFPatch: UpdateFeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFPatch;
  updateFeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdPatch: UpdateFeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdPatch;
  updateFeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdPatch: UpdateFeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdPatch;
  updateFeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdPatch: UpdateFeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdPatch;
  updateFileActivityOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoPatch: UpdateFileActivityOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoPatch;
  updateFileActivityOnFileActivityForFileActivityCostId2A88D90AFkCostIdPatch: UpdateFileActivityOnFileActivityForFileActivityCostId2A88D90AFkCostIdPatch;
  updateFileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdPatch: UpdateFileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdPatch;
  updateFileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch: UpdateFileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch;
  updateFileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch: UpdateFileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
  updateFileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch: UpdateFileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
  updateFileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch;
  updateFileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch;
  updateFileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch;
  updateFileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
  updateFileOnFileActivityForFileActivityFileId015763A9FkFileIdPatch: UpdateFileOnFileActivityForFileActivityFileId015763A9FkFileIdPatch;
  updateFileOnFileForFileProjectId3Ecca975FkProjectIdPatch: UpdateFileOnFileForFileProjectId3Ecca975FkProjectIdPatch;
  updateFileOnFileForFileSeriesParentIdF7A07E20FkFileIdPatch: UpdateFileOnFileForFileSeriesParentIdF7A07E20FkFileIdPatch;
  updateFileOnFileForFileTaskIdE4Da87AeFkTaskIdPatch: UpdateFileOnFileForFileTaskIdE4Da87AeFkTaskIdPatch;
  updateFileOnFileForFileTenantId61625016FkTenantIdPatch: UpdateFileOnFileForFileTenantId61625016FkTenantIdPatch;
  updateFileOnFileForFileUserId01D90B53FkApplicationUserIdPatch: UpdateFileOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
  updateFileOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch: UpdateFileOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch;
  updateFileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch: UpdateFileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch;
  updateFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch: UpdateFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch;
  updateFileOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch: UpdateFileOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch;
  updateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch;
  updateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch;
  updateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch;
  updateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
  updateFileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch;
  updateFileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch;
  updateFileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
  updateFileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
  updateFileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch: UpdateFileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch;
  updateFileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch: UpdateFileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch;
  updateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
  updateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch;
  updateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch;
  updateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyPatch: UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyPatch;
  updateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyPatch: UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyPatch;
  updateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyPatch: UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyPatch;
  updateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdPatch: UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdPatch;
  updateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyPatch: UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyPatch;
  updateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoPatch: UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoPatch;
  updateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIPatch: UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIPatch;
  updateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyPatch: UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyPatch;
  updateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiPatch: UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiPatch;
  updateGdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyPatch;
  updateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoPatch;
  updateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyPatch;
  updateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyPatch;
  updateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiPatch;
  updateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
  updateMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch: UpdateMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch;
  updateMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch: UpdateMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch;
  updateMetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch: UpdateMetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch;
  updateMetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch: UpdateMetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch;
  updateMetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch: UpdateMetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
  updateNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch: UpdateNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch;
  updateNotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch: UpdateNotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
  updateNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch: UpdateNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch;
  updateNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch: UpdateNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch;
  updateNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch: UpdateNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch;
  updateNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch: UpdateNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch;
  updateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch;
  updateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch;
  updateOutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch;
  updatePinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdPatch: UpdatePinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdPatch;
  updatePinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdPatch: UpdatePinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdPatch;
  updateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch;
  updateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
  updateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch;
  updateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch;
  updateProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch: UpdateProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch;
  updateProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch: UpdateProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch;
  updateProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch: UpdateProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch;
  updateProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch: UpdateProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
  updateProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdPatch: UpdateProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdPatch;
  updateProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIPatch;
  updateProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdPatch: UpdateProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdPatch;
  updateProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIPatch: UpdateProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIPatch;
  updateProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIPatch: UpdateProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIPatch;
  updateProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdPatch: UpdateProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdPatch;
  updateProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch: UpdateProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch;
  updateProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdPatch: UpdateProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdPatch;
  updateProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch: UpdateProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch;
  updateProjectOnFileForFileProjectId3Ecca975FkProjectIdPatch: UpdateProjectOnFileForFileProjectId3Ecca975FkProjectIdPatch;
  updateProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch: UpdateProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch;
  updateProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch: UpdateProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch;
  updateProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch: UpdateProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch;
  updateProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdPatch: UpdateProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdPatch;
  updateProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdPatch: UpdateProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdPatch;
  updateProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIPatch: UpdateProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIPatch;
  updateProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch: UpdateProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch;
  updateProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch: UpdateProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
  updateProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch: UpdateProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch;
  updateProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch: UpdateProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch;
  updateProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch: UpdateProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch;
  updateProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch: UpdateProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch;
  updateProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch: UpdateProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch;
  updateProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch: UpdateProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch;
  updateProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdPatch: UpdateProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdPatch;
  updateProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch: UpdateProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
  updateProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch: UpdateProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
  updateProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch: UpdateProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch;
  updateProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch: UpdateProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch;
  updateProjectOnTaskForTaskProjectId963D6354FkProjectIdPatch: UpdateProjectOnTaskForTaskProjectId963D6354FkProjectIdPatch;
  updateProjectOnToolForToolProjectId20A84210FkProjectIdPatch: UpdateProjectOnToolForToolProjectId20A84210FkProjectIdPatch;
  updateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
  updateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
  updateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch;
  updateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch;
  updateProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch: UpdateProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch;
  updateProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch: UpdateProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
  updateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
  updateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch;
  updateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
  updateRunOnRunForRunTenantId73Fbd8D9FkTenantIdPatch: UpdateRunOnRunForRunTenantId73Fbd8D9FkTenantIdPatch;
  updateTaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdPatch: UpdateTaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdPatch;
  updateTaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch: UpdateTaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch;
  updateTaskOnFileForFileTaskIdE4Da87AeFkTaskIdPatch: UpdateTaskOnFileForFileTaskIdE4Da87AeFkTaskIdPatch;
  updateTaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch: UpdateTaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch;
  updateTaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch: UpdateTaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
  updateTaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch: UpdateTaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch;
  updateTaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch: UpdateTaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch;
  updateTaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdPatch: UpdateTaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdPatch;
  updateTaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdPatch: UpdateTaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdPatch;
  updateTaskOnTaskForTaskProjectId963D6354FkProjectIdPatch: UpdateTaskOnTaskForTaskProjectId963D6354FkProjectIdPatch;
  updateTaskOnTaskForTaskTenantId148E90DaFkTenantIdPatch: UpdateTaskOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
  updateTaskOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch: UpdateTaskOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch;
  updateTaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch: UpdateTaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
  updateTaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch: UpdateTaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch;
  updateTaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch: UpdateTaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch;
  updateTaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch: UpdateTaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch;
  updateTaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdPatch: UpdateTaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdPatch;
  updateTaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch: UpdateTaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch;
  updateTaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch: UpdateTaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch;
  updateTaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch: UpdateTaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch;
  updateTaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch: UpdateTaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch;
  updateTaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch: UpdateTaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch;
  updateTaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdPatch: UpdateTaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdPatch;
  updateTenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch: UpdateTenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch;
  updateTenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch: UpdateTenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
  updateTenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch: UpdateTenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch;
  updateTenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoPatch: UpdateTenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoPatch;
  updateTenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch: UpdateTenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch;
  updateTenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch: UpdateTenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch;
  updateTenantMockuserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsPatch: UpdateTenantMockuserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsPatch;
  updateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoPatch: UpdateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoPatch;
  updateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdPatch: UpdateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdPatch;
  updateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiPatch: UpdateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiPatch;
  updateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch: UpdateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
  updateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch: UpdateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
  updateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch: UpdateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
  updateTenantOnCommandForCommandTenantId36F95C3CFkTenantIdPatch: UpdateTenantOnCommandForCommandTenantId36F95C3CFkTenantIdPatch;
  updateTenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdPatch: UpdateTenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdPatch;
  updateTenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdPatch: UpdateTenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdPatch;
  updateTenantOnCostForCostTenantId7Dcd58A7FkTenantIdPatch: UpdateTenantOnCostForCostTenantId7Dcd58A7FkTenantIdPatch;
  updateTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdPatch: UpdateTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdPatch;
  updateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch: UpdateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
  updateTenantOnFileForFileTenantId61625016FkTenantIdPatch: UpdateTenantOnFileForFileTenantId61625016FkTenantIdPatch;
  updateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch: UpdateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
  updateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch: UpdateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
  updateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch: UpdateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
  updateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch: UpdateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
  updateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch: UpdateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
  updateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch: UpdateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
  updateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch: UpdateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
  updateTenantOnRunForRunTenantId73Fbd8D9FkTenantIdPatch: UpdateTenantOnRunForRunTenantId73Fbd8D9FkTenantIdPatch;
  updateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch: UpdateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
  updateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch: UpdateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
  updateTenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdPatch: UpdateTenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdPatch;
  updateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch: UpdateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
  updateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch: UpdateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch;
  updateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch: UpdateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
  updateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch: UpdateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
  updateTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdPatch: UpdateTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdPatch;
  updateTenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdPatch: UpdateTenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdPatch;
  updateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch;
  updateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
  updateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
  updateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
  updateTenantUserexecutorOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsPatch: UpdateTenantUserexecutorOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsPatch;
  updateTenantUserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsPatch: UpdateTenantUserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsPatch;
  updateTenantUserexecutorOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoPatch: UpdateTenantUserexecutorOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoPatch;
  updateTesContainerimageexecutorOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaPatch: UpdateTesContainerimageexecutorOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaPatch;
  updateTesContainerimageexecutorOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaPatch: UpdateTesContainerimageexecutorOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaPatch;
  updateTesContainerimageexecutorOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaPatch: UpdateTesContainerimageexecutorOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaPatch;
  updateTesContainerimageexecutorOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoPatch: UpdateTesContainerimageexecutorOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoPatch;
  updateTesContainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaPatch: UpdateTesContainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaPatch;
  updateTesMockcontainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaPatch: UpdateTesMockcontainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaPatch;
  updateTesMocktaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskePatch: UpdateTesMocktaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskePatch;
  updateTesTaskexecutorOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskePatch: UpdateTesTaskexecutorOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskePatch;
  updateTesTaskexecutorOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdPatch: UpdateTesTaskexecutorOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdPatch;
  updateTesTaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskePatch: UpdateTesTaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskePatch;
  updateTesTaskexecutorOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoPatch: UpdateTesTaskexecutorOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoPatch;
  updateToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdPatch: UpdateToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdPatch;
  updateToolOnToolForToolProjectId20A84210FkProjectIdPatch: UpdateToolOnToolForToolProjectId20A84210FkProjectIdPatch;
  updateToolOnToolForToolTenantId1Baab08EFkTenantIdPatch: UpdateToolOnToolForToolTenantId1Baab08EFkTenantIdPatch;
  updateToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdPatch: UpdateToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdPatch;
  updateToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch: UpdateToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
  updateToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch: UpdateToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch;
  updateToolOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch: UpdateToolOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch;
  updateToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch: UpdateToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch;
  updateToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdPatch: UpdateToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdPatch;
  updateToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch: UpdateToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch;
  updateToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch: UpdateToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch;
  updateToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch: UpdateToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch;
  updateToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch: UpdateToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch;
  updateToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch: UpdateToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
  updateToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch: UpdateToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch;
  updateToolVersionOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdPatch: UpdateToolVersionOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdPatch;
  updateToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch: UpdateToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch;
  updateToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch: UpdateToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch;
  updateToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch: UpdateToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch;
  updateToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch: UpdateToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch;
  updateToolVersionOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdPatch: UpdateToolVersionOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdPatch;
  updateToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch: UpdateToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch;
  updateToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch: UpdateToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch;
  updateToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch: UpdateToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch;
  updateToolVersionOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdPatch: UpdateToolVersionOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdPatch;
  updateToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch: UpdateToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
  updateToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch: UpdateToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch;
  updateToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch: UpdateToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
  updateToolVersionOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdPatch: UpdateToolVersionOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdPatch;
  updateToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdPatch: UpdateToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdPatch;
  updateToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdPatch: UpdateToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdPatch;
  updateToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdPatch: UpdateToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdPatch;
  updateToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdPatch: UpdateToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdPatch;
  updateUserOnboardingQuestionAnswerOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboPatch: UpdateUserOnboardingQuestionAnswerOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboPatch;
  updateUserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboPatch: UpdateUserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboPatch;
  updateUserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboPatch: UpdateUserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboPatch;
  updateUserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboPatch: UpdateUserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboPatch;
  updateUserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiPatch: UpdateUserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiPatch;
  updateUserPersonalSpaceRequestOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiPatch: UpdateUserPersonalSpaceRequestOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiPatch;
  updateWorkflowDatumOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdPatch: UpdateWorkflowDatumOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdPatch;
  updateWorkflowDatumOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdPatch: UpdateWorkflowDatumOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdPatch;
  updateWorkflowOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdPatch: UpdateWorkflowOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdPatch;
  updateWorkflowOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdPatch: UpdateWorkflowOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdPatch;
  updateWorkflowOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdPatch: UpdateWorkflowOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdPatch;
  updateWorkflowOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdPatch: UpdateWorkflowOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdPatch;
  updateWorkflowResultOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdPatch: UpdateWorkflowResultOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdPatch;
  updateWorkflowResultOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowPatch: UpdateWorkflowResultOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowPatch;
  updateWorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowPatch: UpdateWorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowPatch;
  updateWorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowPatch: UpdateWorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowPatch;
  updateWorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdPatch: UpdateWorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdPatch;
  updateWorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdPatch: UpdateWorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdPatch;
  updateWorkflowSectionBlockOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowPatch: UpdateWorkflowSectionBlockOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowPatch;
  updateWorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowPatch: UpdateWorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowPatch;
  updateWorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowPatch: UpdateWorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowPatch;
  updateWorkflowSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowPatch: UpdateWorkflowSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowPatch;
  updateWorkflowSectionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowPatch: UpdateWorkflowSectionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowPatch;
  updateWorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowPatch: UpdateWorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowPatch;
  updateWorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowPatch: UpdateWorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowPatch;
  updateWorkflowSourceOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowPatch: UpdateWorkflowSourceOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowPatch;
  updateWorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowPatch: UpdateWorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowPatch;
  updateWorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowPatch: UpdateWorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowPatch;
  updateWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowPatch: UpdateWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowPatch;
  updateWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowPatch: UpdateWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowPatch;
  updateWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowPatch: UpdateWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowPatch;
  updateWorkflowVersionOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdPatch: UpdateWorkflowVersionOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdPatch;
  updateWorkflowVersionOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdPatch: UpdateWorkflowVersionOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdPatch;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AdminProject: AdminProject;
  AdminProjectCondition: AdminProjectCondition;
  AdminProjectFilter: AdminProjectFilter;
  AdminProjectInput: AdminProjectInput;
  AdminProjectsConnection: AdminProjectsConnection;
  AdminProjectsEdge: AdminProjectsEdge;
  ApplicationUser: ApplicationUser;
  ApplicationUserApplicationUserEmailKeyConnect: ApplicationUserApplicationUserEmailKeyConnect;
  ApplicationUserApplicationUserEmailKeyDelete: ApplicationUserApplicationUserEmailKeyDelete;
  ApplicationUserApplicationUserGlobalUserIdKeyConnect: ApplicationUserApplicationUserGlobalUserIdKeyConnect;
  ApplicationUserApplicationUserGlobalUserIdKeyDelete: ApplicationUserApplicationUserGlobalUserIdKeyDelete;
  ApplicationUserApplicationUserPkeyConnect: ApplicationUserApplicationUserPkeyConnect;
  ApplicationUserApplicationUserPkeyDelete: ApplicationUserApplicationUserPkeyDelete;
  ApplicationUserApplicationUserUsernameKeyConnect: ApplicationUserApplicationUserUsernameKeyConnect;
  ApplicationUserApplicationUserUsernameKeyDelete: ApplicationUserApplicationUserUsernameKeyDelete;
  ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput: ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInput;
  ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInverseInput: ApplicationUserExecutorId69B7Cb94FkTenantUserexecutorIdInverseInput;
  ApplicationUserFilter: ApplicationUserFilter;
  ApplicationUserGroup: ApplicationUserGroup;
  ApplicationUserGroupApplicationUserGroupsPkeyConnect: ApplicationUserGroupApplicationUserGroupsPkeyConnect;
  ApplicationUserGroupApplicationUserGroupsPkeyDelete: ApplicationUserGroupApplicationUserGroupsPkeyDelete;
  ApplicationUserGroupApplicationUserGroupsUserIdGroupId3A20Ace4UniqConnect: ApplicationUserGroupApplicationUserGroupsUserIdGroupId3A20Ace4UniqConnect;
  ApplicationUserGroupApplicationUserGroupsUserIdGroupId3A20Ace4UniqDelete: ApplicationUserGroupApplicationUserGroupsUserIdGroupId3A20Ace4UniqDelete;
  ApplicationUserGroupCondition: ApplicationUserGroupCondition;
  ApplicationUserGroupFilter: ApplicationUserGroupFilter;
  ApplicationUserGroupInput: ApplicationUserGroupInput;
  ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingApplicationUserGroupsPkeyUpdate: ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingApplicationUserGroupsPkeyUpdate;
  ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingApplicationUserGroupsUserIdGroupId3A20Ace4UniqUpdate: ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingApplicationUserGroupsUserIdGroupId3A20Ace4UniqUpdate;
  ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGroupsPkeyUpdate: ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGroupsPkeyUpdate;
  ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGroupsUserIdGroupId3A20Ace4UniqUpdate: ApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGroupsUserIdGroupId3A20Ace4UniqUpdate;
  ApplicationUserGroupPatch: ApplicationUserGroupPatch;
  ApplicationUserGroupsConnection: ApplicationUserGroupsConnection;
  ApplicationUserGroupsEdge: ApplicationUserGroupsEdge;
  ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdApplicationUserGroupsCreateInput: ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdApplicationUserGroupsCreateInput;
  ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdAuthGroupCreateInput: ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdAuthGroupCreateInput;
  ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInput: ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInput;
  ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInverseInput: ApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdInverseInput;
  ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdApplicationUserCreateInput: ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdApplicationUserCreateInput;
  ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdApplicationUserGroupsCreateInput: ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdApplicationUserGroupsCreateInput;
  ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInput: ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInput;
  ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput: ApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdInverseInput;
  ApplicationUserInput: ApplicationUserInput;
  ApplicationUserMemUserId631Fddc5FkApplicatiApplicationUserCreateInput: ApplicationUserMemUserId631Fddc5FkApplicatiApplicationUserCreateInput;
  ApplicationUserMemUserId631Fddc5FkApplicatiApplicationUserMembershipCreateInput: ApplicationUserMemUserId631Fddc5FkApplicatiApplicationUserMembershipCreateInput;
  ApplicationUserMemUserId631Fddc5FkApplicatiInput: ApplicationUserMemUserId631Fddc5FkApplicatiInput;
  ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput: ApplicationUserMemUserId631Fddc5FkApplicatiInverseInput;
  ApplicationUserMembership: ApplicationUserMembership;
  ApplicationUserMembershipApplicationUserMembershipPkeyConnect: ApplicationUserMembershipApplicationUserMembershipPkeyConnect;
  ApplicationUserMembershipApplicationUserMembershipPkeyDelete: ApplicationUserMembershipApplicationUserMembershipPkeyDelete;
  ApplicationUserMembershipCondition: ApplicationUserMembershipCondition;
  ApplicationUserMembershipFilter: ApplicationUserMembershipFilter;
  ApplicationUserMembershipInput: ApplicationUserMembershipInput;
  ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserMembershipPkeyUpdate: ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserMembershipPkeyUpdate;
  ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingUserTenantUniqueUpdate: ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingUserTenantUniqueUpdate;
  ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingApplicationUserMembershipPkeyUpdate: ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingApplicationUserMembershipPkeyUpdate;
  ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingUserTenantUniqueUpdate: ApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingUserTenantUniqueUpdate;
  ApplicationUserMembershipPatch: ApplicationUserMembershipPatch;
  ApplicationUserMembershipTenantId5E54Da7AFkTenantIdApplicationUserMembershipCreateInput: ApplicationUserMembershipTenantId5E54Da7AFkTenantIdApplicationUserMembershipCreateInput;
  ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput: ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInput;
  ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput: ApplicationUserMembershipTenantId5E54Da7AFkTenantIdInverseInput;
  ApplicationUserMembershipTenantId5E54Da7AFkTenantIdTenantCreateInput: ApplicationUserMembershipTenantId5E54Da7AFkTenantIdTenantCreateInput;
  ApplicationUserMembershipUserTenantUniqueConnect: ApplicationUserMembershipUserTenantUniqueConnect;
  ApplicationUserMembershipUserTenantUniqueDelete: ApplicationUserMembershipUserTenantUniqueDelete;
  ApplicationUserMembershipsConnection: ApplicationUserMembershipsConnection;
  ApplicationUserMembershipsEdge: ApplicationUserMembershipsEdge;
  ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserCreateInput: ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserCreateInput;
  ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserMetadataCreateInput: ApplicationUserMetUserId897Fbde1FkApplicatiApplicationUserMetadataCreateInput;
  ApplicationUserMetUserId897Fbde1FkApplicatiInput: ApplicationUserMetUserId897Fbde1FkApplicatiInput;
  ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput: ApplicationUserMetUserId897Fbde1FkApplicatiInverseInput;
  ApplicationUserMetadataConnection: ApplicationUserMetadataConnection;
  ApplicationUserMetadataEdge: ApplicationUserMetadataEdge;
  ApplicationUserMetadatum: ApplicationUserMetadatum;
  ApplicationUserMetadatumApplicationUserMetadataPkeyConnect: ApplicationUserMetadatumApplicationUserMetadataPkeyConnect;
  ApplicationUserMetadatumApplicationUserMetadataPkeyDelete: ApplicationUserMetadatumApplicationUserMetadataPkeyDelete;
  ApplicationUserMetadatumCondition: ApplicationUserMetadatumCondition;
  ApplicationUserMetadatumFilter: ApplicationUserMetadatumFilter;
  ApplicationUserMetadatumInput: ApplicationUserMetadatumInput;
  ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserMetadataPkeyUpdate: ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserMetadataPkeyUpdate;
  ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingUserKeyUpdate: ApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingUserKeyUpdate;
  ApplicationUserMetadatumPatch: ApplicationUserMetadatumPatch;
  ApplicationUserMetadatumUserKeyConnect: ApplicationUserMetadatumUserKeyConnect;
  ApplicationUserMetadatumUserKeyDelete: ApplicationUserMetadatumUserKeyDelete;
  ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserEmailKeyUpdate: ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserPkeyUpdate: ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserPkeyUpdate;
  ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserEmailKeyUpdate: ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserEmailKeyUpdate;
  ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate: ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserGlobalUserIdKeyUpdate;
  ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserPkeyUpdate: ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserPkeyUpdate;
  ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate: ApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingApplicationUserUsernameKeyUpdate;
  ApplicationUserPatch: ApplicationUserPatch;
  ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserCreateInput: ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserCreateInput;
  ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserSessionCreateInput: ApplicationUserSesUserId2Fb30D0CFkApplicatiApplicationUserSessionCreateInput;
  ApplicationUserSesUserId2Fb30D0CFkApplicatiInput: ApplicationUserSesUserId2Fb30D0CFkApplicatiInput;
  ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput: ApplicationUserSesUserId2Fb30D0CFkApplicatiInverseInput;
  ApplicationUserSession: ApplicationUserSession;
  ApplicationUserSessionApplicationUserSessionPkeyConnect: ApplicationUserSessionApplicationUserSessionPkeyConnect;
  ApplicationUserSessionApplicationUserSessionPkeyDelete: ApplicationUserSessionApplicationUserSessionPkeyDelete;
  ApplicationUserSessionCondition: ApplicationUserSessionCondition;
  ApplicationUserSessionFilter: ApplicationUserSessionFilter;
  ApplicationUserSessionInput: ApplicationUserSessionInput;
  ApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserSessionPkeyUpdate: ApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiUsingApplicationUserSessionPkeyUpdate;
  ApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingApplicationUserSessionPkeyUpdate: ApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingApplicationUserSessionPkeyUpdate;
  ApplicationUserSessionPatch: ApplicationUserSessionPatch;
  ApplicationUserSessionTenantId00A81Cc5FkTenantIdApplicationUserSessionCreateInput: ApplicationUserSessionTenantId00A81Cc5FkTenantIdApplicationUserSessionCreateInput;
  ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput: ApplicationUserSessionTenantId00A81Cc5FkTenantIdInput;
  ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput: ApplicationUserSessionTenantId00A81Cc5FkTenantIdInverseInput;
  ApplicationUserSessionTenantId00A81Cc5FkTenantIdTenantCreateInput: ApplicationUserSessionTenantId00A81Cc5FkTenantIdTenantCreateInput;
  ApplicationUserSessionsConnection: ApplicationUserSessionsConnection;
  ApplicationUserSessionsEdge: ApplicationUserSessionsEdge;
  ApplicationUserToManyApplicationUserGroupFilter: ApplicationUserToManyApplicationUserGroupFilter;
  ApplicationUserToManyApplicationUserMembershipFilter: ApplicationUserToManyApplicationUserMembershipFilter;
  ApplicationUserToManyApplicationUserMetadatumFilter: ApplicationUserToManyApplicationUserMetadatumFilter;
  ApplicationUserToManyApplicationUserSessionFilter: ApplicationUserToManyApplicationUserSessionFilter;
  ApplicationUserToManyApplicationUserUserPermissionFilter: ApplicationUserToManyApplicationUserUserPermissionFilter;
  ApplicationUserToManyAuditlogLogentryFilter: ApplicationUserToManyAuditlogLogentryFilter;
  ApplicationUserToManyCodeFileFilter: ApplicationUserToManyCodeFileFilter;
  ApplicationUserToManyCommandFilter: ApplicationUserToManyCommandFilter;
  ApplicationUserToManyContainerImageFilter: ApplicationUserToManyContainerImageFilter;
  ApplicationUserToManyContainerImageRepositoryFilter: ApplicationUserToManyContainerImageRepositoryFilter;
  ApplicationUserToManyDataTableColumnFilter: ApplicationUserToManyDataTableColumnFilter;
  ApplicationUserToManyDataTableColumnGroupFilter: ApplicationUserToManyDataTableColumnGroupFilter;
  ApplicationUserToManyDataTableFilter: ApplicationUserToManyDataTableFilter;
  ApplicationUserToManyDataTableRowFilter: ApplicationUserToManyDataTableRowFilter;
  ApplicationUserToManyDjangoAdminLogFilter: ApplicationUserToManyDjangoAdminLogFilter;
  ApplicationUserToManyEulaVersionUserAcceptanceFilter: ApplicationUserToManyEulaVersionUserAcceptanceFilter;
  ApplicationUserToManyFeatureFlagsUserFilter: ApplicationUserToManyFeatureFlagsUserFilter;
  ApplicationUserToManyFileActivityFilter: ApplicationUserToManyFileActivityFilter;
  ApplicationUserToManyFileFilter: ApplicationUserToManyFileFilter;
  ApplicationUserToManyFileOutputGroupFilter: ApplicationUserToManyFileOutputGroupFilter;
  ApplicationUserToManyFileProcessingNotificationFilter: ApplicationUserToManyFileProcessingNotificationFilter;
  ApplicationUserToManyGdtAnalysisTableColumnFilter: ApplicationUserToManyGdtAnalysisTableColumnFilter;
  ApplicationUserToManyGdtAnalysisTableColumnGroupFilter: ApplicationUserToManyGdtAnalysisTableColumnGroupFilter;
  ApplicationUserToManyGdtAnalysisTableFilter: ApplicationUserToManyGdtAnalysisTableFilter;
  ApplicationUserToManyGdtAnalysisTableRowFilter: ApplicationUserToManyGdtAnalysisTableRowFilter;
  ApplicationUserToManyMetadataValueFilter: ApplicationUserToManyMetadataValueFilter;
  ApplicationUserToManyNotificationFilter: ApplicationUserToManyNotificationFilter;
  ApplicationUserToManyPinnedToolFilter: ApplicationUserToManyPinnedToolFilter;
  ApplicationUserToManyProjectClonedNotificationFilter: ApplicationUserToManyProjectClonedNotificationFilter;
  ApplicationUserToManyProjectFilter: ApplicationUserToManyProjectFilter;
  ApplicationUserToManyProjectFolderFilter: ApplicationUserToManyProjectFolderFilter;
  ApplicationUserToManyProjectSharedNotificationFilter: ApplicationUserToManyProjectSharedNotificationFilter;
  ApplicationUserToManyProjectTagFilter: ApplicationUserToManyProjectTagFilter;
  ApplicationUserToManyRoleChangeNotificationFilter: ApplicationUserToManyRoleChangeNotificationFilter;
  ApplicationUserToManyTaskFilter: ApplicationUserToManyTaskFilter;
  ApplicationUserToManyTenantMonthlyConsumedResourceFilter: ApplicationUserToManyTenantMonthlyConsumedResourceFilter;
  ApplicationUserToManyTenantUserMembershipNotificationFilter: ApplicationUserToManyTenantUserMembershipNotificationFilter;
  ApplicationUserToManyToolFilter: ApplicationUserToManyToolFilter;
  ApplicationUserToManyToolVersionFilter: ApplicationUserToManyToolVersionFilter;
  ApplicationUserToManyUserOnboardingQuestionResponseFilter: ApplicationUserToManyUserOnboardingQuestionResponseFilter;
  ApplicationUserToManyUserPersonalSpaceRequestFilter: ApplicationUserToManyUserPersonalSpaceRequestFilter;
  ApplicationUserToManyWorkflowFilter: ApplicationUserToManyWorkflowFilter;
  ApplicationUserToManyWorkflowVersionFilter: ApplicationUserToManyWorkflowVersionFilter;
  ApplicationUserUsePermissionIdDbf9693DFkAuthPermApplicationUserUserPermissionsCreateInput: ApplicationUserUsePermissionIdDbf9693DFkAuthPermApplicationUserUserPermissionsCreateInput;
  ApplicationUserUsePermissionIdDbf9693DFkAuthPermAuthPermissionCreateInput: ApplicationUserUsePermissionIdDbf9693DFkAuthPermAuthPermissionCreateInput;
  ApplicationUserUsePermissionIdDbf9693DFkAuthPermInput: ApplicationUserUsePermissionIdDbf9693DFkAuthPermInput;
  ApplicationUserUsePermissionIdDbf9693DFkAuthPermInverseInput: ApplicationUserUsePermissionIdDbf9693DFkAuthPermInverseInput;
  ApplicationUserUseUserIdE643F548FkApplicatiApplicationUserCreateInput: ApplicationUserUseUserIdE643F548FkApplicatiApplicationUserCreateInput;
  ApplicationUserUseUserIdE643F548FkApplicatiApplicationUserUserPermissionsCreateInput: ApplicationUserUseUserIdE643F548FkApplicatiApplicationUserUserPermissionsCreateInput;
  ApplicationUserUseUserIdE643F548FkApplicatiInput: ApplicationUserUseUserIdE643F548FkApplicatiInput;
  ApplicationUserUseUserIdE643F548FkApplicatiInverseInput: ApplicationUserUseUserIdE643F548FkApplicatiInverseInput;
  ApplicationUserUserPermission: ApplicationUserUserPermission;
  ApplicationUserUserPermissionApplicationUserUserPeUserIdPermissionId52D58A70UniqConnect: ApplicationUserUserPermissionApplicationUserUserPeUserIdPermissionId52D58A70UniqConnect;
  ApplicationUserUserPermissionApplicationUserUserPeUserIdPermissionId52D58A70UniqDelete: ApplicationUserUserPermissionApplicationUserUserPeUserIdPermissionId52D58A70UniqDelete;
  ApplicationUserUserPermissionApplicationUserUserPermissionsPkeyConnect: ApplicationUserUserPermissionApplicationUserUserPermissionsPkeyConnect;
  ApplicationUserUserPermissionApplicationUserUserPermissionsPkeyDelete: ApplicationUserUserPermissionApplicationUserUserPermissionsPkeyDelete;
  ApplicationUserUserPermissionCondition: ApplicationUserUserPermissionCondition;
  ApplicationUserUserPermissionFilter: ApplicationUserUserPermissionFilter;
  ApplicationUserUserPermissionInput: ApplicationUserUserPermissionInput;
  ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingApplicationUserUserPeUserIdPermissionId52D58A70UniqUpdate: ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingApplicationUserUserPeUserIdPermissionId52D58A70UniqUpdate;
  ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingApplicationUserUserPermissionsPkeyUpdate: ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingApplicationUserUserPermissionsPkeyUpdate;
  ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUserPeUserIdPermissionId52D58A70UniqUpdate: ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUserPeUserIdPermissionId52D58A70UniqUpdate;
  ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUserPermissionsPkeyUpdate: ApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiUsingApplicationUserUserPermissionsPkeyUpdate;
  ApplicationUserUserPermissionPatch: ApplicationUserUserPermissionPatch;
  ApplicationUserUserPermissionsConnection: ApplicationUserUserPermissionsConnection;
  ApplicationUserUserPermissionsEdge: ApplicationUserUserPermissionsEdge;
  ApplicationUsersEdge: ApplicationUsersEdge;
  AuditlogLogentriesConnection: AuditlogLogentriesConnection;
  AuditlogLogentriesEdge: AuditlogLogentriesEdge;
  AuditlogLogentry: AuditlogLogentry;
  AuditlogLogentryActorId959271D2FkApplicationUserIdApplicationUserCreateInput: AuditlogLogentryActorId959271D2FkApplicationUserIdApplicationUserCreateInput;
  AuditlogLogentryActorId959271D2FkApplicationUserIdAuditlogLogentryCreateInput: AuditlogLogentryActorId959271D2FkApplicationUserIdAuditlogLogentryCreateInput;
  AuditlogLogentryActorId959271D2FkApplicationUserIdInput: AuditlogLogentryActorId959271D2FkApplicationUserIdInput;
  AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput: AuditlogLogentryActorId959271D2FkApplicationUserIdInverseInput;
  AuditlogLogentryAuditlogLogentryPkeyConnect: AuditlogLogentryAuditlogLogentryPkeyConnect;
  AuditlogLogentryAuditlogLogentryPkeyDelete: AuditlogLogentryAuditlogLogentryPkeyDelete;
  AuditlogLogentryCondition: AuditlogLogentryCondition;
  AuditlogLogentryContentTypeId75830218FkDjangoCoAuditlogLogentryCreateInput: AuditlogLogentryContentTypeId75830218FkDjangoCoAuditlogLogentryCreateInput;
  AuditlogLogentryContentTypeId75830218FkDjangoCoDjangoContentTypeCreateInput: AuditlogLogentryContentTypeId75830218FkDjangoCoDjangoContentTypeCreateInput;
  AuditlogLogentryContentTypeId75830218FkDjangoCoInput: AuditlogLogentryContentTypeId75830218FkDjangoCoInput;
  AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput: AuditlogLogentryContentTypeId75830218FkDjangoCoInverseInput;
  AuditlogLogentryFilter: AuditlogLogentryFilter;
  AuditlogLogentryInput: AuditlogLogentryInput;
  AuditlogLogentryOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingAuditlogLogentryPkeyUpdate: AuditlogLogentryOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdUsingAuditlogLogentryPkeyUpdate;
  AuditlogLogentryOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingAuditlogLogentryPkeyUpdate: AuditlogLogentryOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingAuditlogLogentryPkeyUpdate;
  AuditlogLogentryPatch: AuditlogLogentryPatch;
  AuthGroup: AuthGroup;
  AuthGroupAuthGroupNameKeyConnect: AuthGroupAuthGroupNameKeyConnect;
  AuthGroupAuthGroupNameKeyDelete: AuthGroupAuthGroupNameKeyDelete;
  AuthGroupAuthGroupPkeyConnect: AuthGroupAuthGroupPkeyConnect;
  AuthGroupAuthGroupPkeyDelete: AuthGroupAuthGroupPkeyDelete;
  AuthGroupCondition: AuthGroupCondition;
  AuthGroupFilter: AuthGroupFilter;
  AuthGroupInput: AuthGroupInput;
  AuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingAuthGroupNameKeyUpdate: AuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingAuthGroupNameKeyUpdate;
  AuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingAuthGroupPkeyUpdate: AuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdUsingAuthGroupPkeyUpdate;
  AuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupNameKeyUpdate: AuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupNameKeyUpdate;
  AuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPkeyUpdate: AuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPkeyUpdate;
  AuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingAuthGroupNameKeyUpdate: AuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingAuthGroupNameKeyUpdate;
  AuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingAuthGroupPkeyUpdate: AuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingAuthGroupPkeyUpdate;
  AuthGroupPatch: AuthGroupPatch;
  AuthGroupPermissioPermissionId84C5C92EFkAuthPermAuthGroupPermissionsCreateInput: AuthGroupPermissioPermissionId84C5C92EFkAuthPermAuthGroupPermissionsCreateInput;
  AuthGroupPermissioPermissionId84C5C92EFkAuthPermAuthPermissionCreateInput: AuthGroupPermissioPermissionId84C5C92EFkAuthPermAuthPermissionCreateInput;
  AuthGroupPermissioPermissionId84C5C92EFkAuthPermInput: AuthGroupPermissioPermissionId84C5C92EFkAuthPermInput;
  AuthGroupPermissioPermissionId84C5C92EFkAuthPermInverseInput: AuthGroupPermissioPermissionId84C5C92EFkAuthPermInverseInput;
  AuthGroupPermission: AuthGroupPermission;
  AuthGroupPermissionAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqConnect: AuthGroupPermissionAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqConnect;
  AuthGroupPermissionAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqDelete: AuthGroupPermissionAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqDelete;
  AuthGroupPermissionAuthGroupPermissionsPkeyConnect: AuthGroupPermissionAuthGroupPermissionsPkeyConnect;
  AuthGroupPermissionAuthGroupPermissionsPkeyDelete: AuthGroupPermissionAuthGroupPermissionsPkeyDelete;
  AuthGroupPermissionCondition: AuthGroupPermissionCondition;
  AuthGroupPermissionFilter: AuthGroupPermissionFilter;
  AuthGroupPermissionInput: AuthGroupPermissionInput;
  AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqUpdate: AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqUpdate;
  AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthGroupPermissionsPkeyUpdate: AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthGroupPermissionsPkeyUpdate;
  AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqUpdate: AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPermissionsGroupIdPermissionId0Cd325B0UniqUpdate;
  AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPermissionsPkeyUpdate: AuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdUsingAuthGroupPermissionsPkeyUpdate;
  AuthGroupPermissionPatch: AuthGroupPermissionPatch;
  AuthGroupPermissionsConnection: AuthGroupPermissionsConnection;
  AuthGroupPermissionsEdge: AuthGroupPermissionsEdge;
  AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdAuthGroupCreateInput: AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdAuthGroupCreateInput;
  AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdAuthGroupPermissionsCreateInput: AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdAuthGroupPermissionsCreateInput;
  AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInput: AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInput;
  AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInverseInput: AuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdInverseInput;
  AuthGroupToManyApplicationUserGroupFilter: AuthGroupToManyApplicationUserGroupFilter;
  AuthGroupToManyAuthGroupPermissionFilter: AuthGroupToManyAuthGroupPermissionFilter;
  AuthGroupToManyFeatureFlagsGroupFilter: AuthGroupToManyFeatureFlagsGroupFilter;
  AuthGroupsConnection: AuthGroupsConnection;
  AuthGroupsEdge: AuthGroupsEdge;
  AuthPermission: AuthPermission;
  AuthPermissionAuthPermissionContentTypeIdCodename01Ab375AUniqConnect: AuthPermissionAuthPermissionContentTypeIdCodename01Ab375AUniqConnect;
  AuthPermissionAuthPermissionContentTypeIdCodename01Ab375AUniqDelete: AuthPermissionAuthPermissionContentTypeIdCodename01Ab375AUniqDelete;
  AuthPermissionAuthPermissionPkeyConnect: AuthPermissionAuthPermissionPkeyConnect;
  AuthPermissionAuthPermissionPkeyDelete: AuthPermissionAuthPermissionPkeyDelete;
  AuthPermissionCondition: AuthPermissionCondition;
  AuthPermissionContentTypeId2F476E4BFkDjangoCoAuthPermissionCreateInput: AuthPermissionContentTypeId2F476E4BFkDjangoCoAuthPermissionCreateInput;
  AuthPermissionContentTypeId2F476E4BFkDjangoCoDjangoContentTypeCreateInput: AuthPermissionContentTypeId2F476E4BFkDjangoCoDjangoContentTypeCreateInput;
  AuthPermissionContentTypeId2F476E4BFkDjangoCoInput: AuthPermissionContentTypeId2F476E4BFkDjangoCoInput;
  AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput: AuthPermissionContentTypeId2F476E4BFkDjangoCoInverseInput;
  AuthPermissionFilter: AuthPermissionFilter;
  AuthPermissionInput: AuthPermissionInput;
  AuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate: AuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate;
  AuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingAuthPermissionPkeyUpdate: AuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermUsingAuthPermissionPkeyUpdate;
  AuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate: AuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate;
  AuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthPermissionPkeyUpdate: AuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermUsingAuthPermissionPkeyUpdate;
  AuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate: AuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingAuthPermissionContentTypeIdCodename01Ab375AUniqUpdate;
  AuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingAuthPermissionPkeyUpdate: AuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingAuthPermissionPkeyUpdate;
  AuthPermissionPatch: AuthPermissionPatch;
  AuthPermissionToManyApplicationUserUserPermissionFilter: AuthPermissionToManyApplicationUserUserPermissionFilter;
  AuthPermissionToManyAuthGroupPermissionFilter: AuthPermissionToManyAuthGroupPermissionFilter;
  AuthPermissionsConnection: AuthPermissionsConnection;
  AuthPermissionsEdge: AuthPermissionsEdge;
  AvailableNonRestrictedProject: AvailableNonRestrictedProject;
  AvailableNonRestrictedProjectCondition: AvailableNonRestrictedProjectCondition;
  AvailableNonRestrictedProjectFilter: AvailableNonRestrictedProjectFilter;
  AvailableNonRestrictedProjectInput: AvailableNonRestrictedProjectInput;
  AvailableNonRestrictedProjectsConnection: AvailableNonRestrictedProjectsConnection;
  AvailableNonRestrictedProjectsEdge: AvailableNonRestrictedProjectsEdge;
  Avatar: Avatar;
  AvatarAvatarPkeyConnect: AvatarAvatarPkeyConnect;
  AvatarAvatarPkeyDelete: AvatarAvatarPkeyDelete;
  AvatarAvatarUserIdKeyConnect: AvatarAvatarUserIdKeyConnect;
  AvatarAvatarUserIdKeyDelete: AvatarAvatarUserIdKeyDelete;
  AvatarCondition: AvatarCondition;
  AvatarFilter: AvatarFilter;
  AvatarInput: AvatarInput;
  AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarPkeyUpdate: AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarPkeyUpdate;
  AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarUserIdKeyUpdate: AvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdUsingAvatarUserIdKeyUpdate;
  AvatarPatch: AvatarPatch;
  AvatarUserId771332F2FkApplicationUserIdApplicationUserCreateInput: AvatarUserId771332F2FkApplicationUserIdApplicationUserCreateInput;
  AvatarUserId771332F2FkApplicationUserIdAvatarCreateInput: AvatarUserId771332F2FkApplicationUserIdAvatarCreateInput;
  AvatarUserId771332F2FkApplicationUserIdInput: AvatarUserId771332F2FkApplicationUserIdInput;
  AvatarUserId771332F2FkApplicationUserIdInverseInput: AvatarUserId771332F2FkApplicationUserIdInverseInput;
  AvatarsConnection: AvatarsConnection;
  AvatarsEdge: AvatarsEdge;
  AwsBatchTask: AwsBatchTask;
  AwsBatchTaskAwsBatchTaskPkeyConnect: AwsBatchTaskAwsBatchTaskPkeyConnect;
  AwsBatchTaskAwsBatchTaskPkeyDelete: AwsBatchTaskAwsBatchTaskPkeyDelete;
  AwsBatchTaskCondition: AwsBatchTaskCondition;
  AwsBatchTaskFilter: AwsBatchTaskFilter;
  AwsBatchTaskInput: AwsBatchTaskInput;
  AwsBatchTaskOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeUsingAwsBatchTaskPkeyUpdate: AwsBatchTaskOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeUsingAwsBatchTaskPkeyUpdate;
  AwsBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchUsingAwsBatchTaskPkeyUpdate: AwsBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchUsingAwsBatchTaskPkeyUpdate;
  AwsBatchTaskPatch: AwsBatchTaskPatch;
  AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeAwsBatchTaskCreateInput: AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeAwsBatchTaskCreateInput;
  AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInput: AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInput;
  AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInverseInput: AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeInverseInput;
  AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeTesTaskexecutorCreateInput: AwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeTesTaskexecutorCreateInput;
  AwsBatchTasksConnection: AwsBatchTasksConnection;
  AwsBatchTasksEdge: AwsBatchTasksEdge;
  AwsCognitoUser: AwsCognitoUser;
  AwsCognitoUserAwsCognitoUserPkeyConnect: AwsCognitoUserAwsCognitoUserPkeyConnect;
  AwsCognitoUserAwsCognitoUserPkeyDelete: AwsCognitoUserAwsCognitoUserPkeyDelete;
  AwsCognitoUserCondition: AwsCognitoUserCondition;
  AwsCognitoUserFilter: AwsCognitoUserFilter;
  AwsCognitoUserInput: AwsCognitoUserInput;
  AwsCognitoUserOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsUsingAwsCognitoUserPkeyUpdate: AwsCognitoUserOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsUsingAwsCognitoUserPkeyUpdate;
  AwsCognitoUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniUsingAwsCognitoUserPkeyUpdate: AwsCognitoUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniUsingAwsCognitoUserPkeyUpdate;
  AwsCognitoUserPatch: AwsCognitoUserPatch;
  AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsAwsCognitoUserCreateInput: AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsAwsCognitoUserCreateInput;
  AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInput: AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInput;
  AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInverseInput: AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsInverseInput;
  AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsTenantUserexecutorCreateInput: AwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsTenantUserexecutorCreateInput;
  AwsCognitoUsersConnection: AwsCognitoUsersConnection;
  AwsCognitoUsersEdge: AwsCognitoUsersEdge;
  AwsEcrImage: AwsEcrImage;
  AwsEcrImageAwsEcrImagePkeyConnect: AwsEcrImageAwsEcrImagePkeyConnect;
  AwsEcrImageAwsEcrImagePkeyDelete: AwsEcrImageAwsEcrImagePkeyDelete;
  AwsEcrImageCondition: AwsEcrImageCondition;
  AwsEcrImageContainerimageexecutAabe4FdbFkTesContaAwsEcrImageCreateInput: AwsEcrImageContainerimageexecutAabe4FdbFkTesContaAwsEcrImageCreateInput;
  AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInput: AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInput;
  AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInverseInput: AwsEcrImageContainerimageexecutAabe4FdbFkTesContaInverseInput;
  AwsEcrImageContainerimageexecutAabe4FdbFkTesContaTesContainerimageexecutorCreateInput: AwsEcrImageContainerimageexecutAabe4FdbFkTesContaTesContainerimageexecutorCreateInput;
  AwsEcrImageFilter: AwsEcrImageFilter;
  AwsEcrImageInput: AwsEcrImageInput;
  AwsEcrImageOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaUsingAwsEcrImagePkeyUpdate: AwsEcrImageOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaUsingAwsEcrImagePkeyUpdate;
  AwsEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIUsingAwsEcrImagePkeyUpdate: AwsEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIUsingAwsEcrImagePkeyUpdate;
  AwsEcrImagePatch: AwsEcrImagePatch;
  AwsEcrImagesConnection: AwsEcrImagesConnection;
  AwsEcrImagesEdge: AwsEcrImagesEdge;
  AwsMockBatchTask: AwsMockBatchTask;
  AwsMockBatchTaskAwsMockBatchTaskPkeyConnect: AwsMockBatchTaskAwsMockBatchTaskPkeyConnect;
  AwsMockBatchTaskAwsMockBatchTaskPkeyDelete: AwsMockBatchTaskAwsMockBatchTaskPkeyDelete;
  AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchAwsBatchTaskCreateInput: AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchAwsBatchTaskCreateInput;
  AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchAwsMockBatchTaskCreateInput: AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchAwsMockBatchTaskCreateInput;
  AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInput: AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInput;
  AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInverseInput: AwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchInverseInput;
  AwsMockBatchTaskCondition: AwsMockBatchTaskCondition;
  AwsMockBatchTaskFilter: AwsMockBatchTaskFilter;
  AwsMockBatchTaskInput: AwsMockBatchTaskInput;
  AwsMockBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchUsingAwsMockBatchTaskPkeyUpdate: AwsMockBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchUsingAwsMockBatchTaskPkeyUpdate;
  AwsMockBatchTaskPatch: AwsMockBatchTaskPatch;
  AwsMockBatchTasksConnection: AwsMockBatchTasksConnection;
  AwsMockBatchTasksEdge: AwsMockBatchTasksEdge;
  AwsMockDistributioDistributioncontaineD5Bda68DFkDistributAwsMockDistributionImageCreateInput: AwsMockDistributioDistributioncontaineD5Bda68DFkDistributAwsMockDistributionImageCreateInput;
  AwsMockDistributioDistributioncontaineD5Bda68DFkDistributDistributionRegistryImageCreateInput: AwsMockDistributioDistributioncontaineD5Bda68DFkDistributDistributionRegistryImageCreateInput;
  AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInput: AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInput;
  AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInverseInput: AwsMockDistributioDistributioncontaineD5Bda68DFkDistributInverseInput;
  AwsMockDistributionImage: AwsMockDistributionImage;
  AwsMockDistributionImageAwsMockDistributionImagePkeyConnect: AwsMockDistributionImageAwsMockDistributionImagePkeyConnect;
  AwsMockDistributionImageAwsMockDistributionImagePkeyDelete: AwsMockDistributionImageAwsMockDistributionImagePkeyDelete;
  AwsMockDistributionImageCondition: AwsMockDistributionImageCondition;
  AwsMockDistributionImageFilter: AwsMockDistributionImageFilter;
  AwsMockDistributionImageInput: AwsMockDistributionImageInput;
  AwsMockDistributionImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributUsingAwsMockDistributionImagePkeyUpdate: AwsMockDistributionImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributUsingAwsMockDistributionImagePkeyUpdate;
  AwsMockDistributionImagePatch: AwsMockDistributionImagePatch;
  AwsMockDistributionImagesConnection: AwsMockDistributionImagesConnection;
  AwsMockDistributionImagesEdge: AwsMockDistributionImagesEdge;
  AwsMockEcrImage: AwsMockEcrImage;
  AwsMockEcrImageAwsMockEcrImagePkeyConnect: AwsMockEcrImageAwsMockEcrImagePkeyConnect;
  AwsMockEcrImageAwsMockEcrImagePkeyDelete: AwsMockEcrImageAwsMockEcrImagePkeyDelete;
  AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIAwsEcrImageCreateInput: AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIAwsEcrImageCreateInput;
  AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIAwsMockEcrImageCreateInput: AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIAwsMockEcrImageCreateInput;
  AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInput: AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInput;
  AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInverseInput: AwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIInverseInput;
  AwsMockEcrImageCondition: AwsMockEcrImageCondition;
  AwsMockEcrImageFilter: AwsMockEcrImageFilter;
  AwsMockEcrImageInput: AwsMockEcrImageInput;
  AwsMockEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIUsingAwsMockEcrImagePkeyUpdate: AwsMockEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIUsingAwsMockEcrImagePkeyUpdate;
  AwsMockEcrImagePatch: AwsMockEcrImagePatch;
  AwsMockEcrImagesConnection: AwsMockEcrImagesConnection;
  AwsMockEcrImagesEdge: AwsMockEcrImagesEdge;
  AwsMockIamUser: AwsMockIamUser;
  AwsMockIamUserAwsMockIamUserPkeyConnect: AwsMockIamUserAwsMockIamUserPkeyConnect;
  AwsMockIamUserAwsMockIamUserPkeyDelete: AwsMockIamUserAwsMockIamUserPkeyDelete;
  AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniAwsCognitoUserCreateInput: AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniAwsCognitoUserCreateInput;
  AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniAwsMockIamUserCreateInput: AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniAwsMockIamUserCreateInput;
  AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInput: AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInput;
  AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInverseInput: AwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniInverseInput;
  AwsMockIamUserCondition: AwsMockIamUserCondition;
  AwsMockIamUserFilter: AwsMockIamUserFilter;
  AwsMockIamUserInput: AwsMockIamUserInput;
  AwsMockIamUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniUsingAwsMockIamUserPkeyUpdate: AwsMockIamUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniUsingAwsMockIamUserPkeyUpdate;
  AwsMockIamUserPatch: AwsMockIamUserPatch;
  AwsMockIamUsersConnection: AwsMockIamUsersConnection;
  AwsMockIamUsersEdge: AwsMockIamUsersEdge;
  AwsMockS3File: AwsMockS3File;
  AwsMockS3FileAwsMockS3FilePkeyConnect: AwsMockS3FileAwsMockS3FilePkeyConnect;
  AwsMockS3FileAwsMockS3FilePkeyDelete: AwsMockS3FileAwsMockS3FilePkeyDelete;
  AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiAwsMockS3FileCreateInput: AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiAwsMockS3FileCreateInput;
  AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiAwsS3FileCreateInput: AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiAwsS3FileCreateInput;
  AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInput: AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInput;
  AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInverseInput: AwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiInverseInput;
  AwsMockS3FileCondition: AwsMockS3FileCondition;
  AwsMockS3FileFilter: AwsMockS3FileFilter;
  AwsMockS3FileInput: AwsMockS3FileInput;
  AwsMockS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiUsingAwsMockS3FilePkeyUpdate: AwsMockS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiUsingAwsMockS3FilePkeyUpdate;
  AwsMockS3FilePatch: AwsMockS3FilePatch;
  AwsMockS3FilesConnection: AwsMockS3FilesConnection;
  AwsMockS3FilesEdge: AwsMockS3FilesEdge;
  AwsS3File: AwsS3File;
  AwsS3FileAwsS3FilePkeyConnect: AwsS3FileAwsS3FilePkeyConnect;
  AwsS3FileAwsS3FilePkeyDelete: AwsS3FileAwsS3FilePkeyDelete;
  AwsS3FileCondition: AwsS3FileCondition;
  AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdAwsS3FileCreateInput: AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdAwsS3FileCreateInput;
  AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdDrsFileexecutorCreateInput: AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdDrsFileexecutorCreateInput;
  AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInput: AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInput;
  AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInverseInput: AwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdInverseInput;
  AwsS3FileFilter: AwsS3FileFilter;
  AwsS3FileInput: AwsS3FileInput;
  AwsS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiUsingAwsS3FilePkeyUpdate: AwsS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiUsingAwsS3FilePkeyUpdate;
  AwsS3FileOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdUsingAwsS3FilePkeyUpdate: AwsS3FileOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdUsingAwsS3FilePkeyUpdate;
  AwsS3FilePatch: AwsS3FilePatch;
  AwsS3FilesConnection: AwsS3FilesConnection;
  AwsS3FilesEdge: AwsS3FilesEdge;
  BigFloat: Scalars["BigFloat"]["output"];
  BigFloatFilter: BigFloatFilter;
  BigInt: Scalars["BigInt"]["output"];
  BigIntFilter: BigIntFilter;
  Boolean: Scalars["Boolean"]["output"];
  BooleanFilter: BooleanFilter;
  ChangeUserSessionInput: ChangeUserSessionInput;
  ChangeUserSessionPayload: ChangeUserSessionPayload;
  CodeFile: CodeFile;
  CodeFileCodeFilePkeyConnect: CodeFileCodeFilePkeyConnect;
  CodeFileCodeFilePkeyDelete: CodeFileCodeFilePkeyDelete;
  CodeFileCondition: CodeFileCondition;
  CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdCodeFileCreateInput: CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdCodeFileCreateInput;
  CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdDrsFileexecutorCreateInput: CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdDrsFileexecutorCreateInput;
  CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInput: CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInput;
  CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInverseInput: CodeFileExecutorId5A9A5C72FkDrsFileexecutorIdInverseInput;
  CodeFileFilter: CodeFileFilter;
  CodeFileInput: CodeFileInput;
  CodeFileOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdUsingCodeFilePkeyUpdate: CodeFileOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdUsingCodeFilePkeyUpdate;
  CodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdUsingCodeFilePkeyUpdate: CodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdUsingCodeFilePkeyUpdate;
  CodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingCodeFilePkeyUpdate: CodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingCodeFilePkeyUpdate;
  CodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingCodeFilePkeyUpdate: CodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdUsingCodeFilePkeyUpdate;
  CodeFileOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCodeFilePkeyUpdate: CodeFileOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCodeFilePkeyUpdate;
  CodeFilePatch: CodeFilePatch;
  CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdCodeFileCreateInput: CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdCodeFileCreateInput;
  CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput: CodeFileSeriesParentIdE5Ea16D4FkCodeFileIdInput;
  CodeFileTenantIdC35D8B4EFkTenantIdCodeFileCreateInput: CodeFileTenantIdC35D8B4EFkTenantIdCodeFileCreateInput;
  CodeFileTenantIdC35D8B4EFkTenantIdInput: CodeFileTenantIdC35D8B4EFkTenantIdInput;
  CodeFileTenantIdC35D8B4EFkTenantIdInverseInput: CodeFileTenantIdC35D8B4EFkTenantIdInverseInput;
  CodeFileTenantIdC35D8B4EFkTenantIdTenantCreateInput: CodeFileTenantIdC35D8B4EFkTenantIdTenantCreateInput;
  CodeFileToManyCodeFileFilter: CodeFileToManyCodeFileFilter;
  CodeFileToManyCommandFilter: CodeFileToManyCommandFilter;
  CodeFileUserIdAb9E5143FkApplicationUserIdApplicationUserCreateInput: CodeFileUserIdAb9E5143FkApplicationUserIdApplicationUserCreateInput;
  CodeFileUserIdAb9E5143FkApplicationUserIdCodeFileCreateInput: CodeFileUserIdAb9E5143FkApplicationUserIdCodeFileCreateInput;
  CodeFileUserIdAb9E5143FkApplicationUserIdInput: CodeFileUserIdAb9E5143FkApplicationUserIdInput;
  CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput: CodeFileUserIdAb9E5143FkApplicationUserIdInverseInput;
  CodeFilesConnection: CodeFilesConnection;
  CodeFilesEdge: CodeFilesEdge;
  Command: Command;
  CommandCodeFileIdE6Dc0F85FkCodeFileIdCodeFileCreateInput: CommandCodeFileIdE6Dc0F85FkCodeFileIdCodeFileCreateInput;
  CommandCodeFileIdE6Dc0F85FkCodeFileIdCommandCreateInput: CommandCodeFileIdE6Dc0F85FkCodeFileIdCommandCreateInput;
  CommandCodeFileIdE6Dc0F85FkCodeFileIdInput: CommandCodeFileIdE6Dc0F85FkCodeFileIdInput;
  CommandCodeFileIdE6Dc0F85FkCodeFileIdInverseInput: CommandCodeFileIdE6Dc0F85FkCodeFileIdInverseInput;
  CommandCommandPkeyConnect: CommandCommandPkeyConnect;
  CommandCommandPkeyDelete: CommandCommandPkeyDelete;
  CommandCommandToolVersionId9DbddabaUniqConnect: CommandCommandToolVersionId9DbddabaUniqConnect;
  CommandCommandToolVersionId9DbddabaUniqDelete: CommandCommandToolVersionId9DbddabaUniqDelete;
  CommandCondition: CommandCondition;
  CommandContainerImageId447E7Cb3FkContainerImageIdCommandCreateInput: CommandContainerImageId447E7Cb3FkContainerImageIdCommandCreateInput;
  CommandContainerImageId447E7Cb3FkContainerImageIdContainerImageCreateInput: CommandContainerImageId447E7Cb3FkContainerImageIdContainerImageCreateInput;
  CommandContainerImageId447E7Cb3FkContainerImageIdInput: CommandContainerImageId447E7Cb3FkContainerImageIdInput;
  CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput: CommandContainerImageId447E7Cb3FkContainerImageIdInverseInput;
  CommandFilter: CommandFilter;
  CommandInput: CommandInput;
  CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCommandPkeyUpdate: CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCommandPkeyUpdate;
  CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCommandToolVersionId9DbddabaUniqUpdate: CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingCommandToolVersionId9DbddabaUniqUpdate;
  CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingToolVersionCodeFileUniqueOnCommandUpdate: CommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdUsingToolVersionCodeFileUniqueOnCommandUpdate;
  CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingCommandPkeyUpdate: CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingCommandPkeyUpdate;
  CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingCommandToolVersionId9DbddabaUniqUpdate: CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingCommandToolVersionId9DbddabaUniqUpdate;
  CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingToolVersionCodeFileUniqueOnCommandUpdate: CommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingToolVersionCodeFileUniqueOnCommandUpdate;
  CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingCommandPkeyUpdate: CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingCommandPkeyUpdate;
  CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingCommandToolVersionId9DbddabaUniqUpdate: CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingCommandToolVersionId9DbddabaUniqUpdate;
  CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingToolVersionCodeFileUniqueOnCommandUpdate: CommandOnCommandForCommandTenantId36F95C3CFkTenantIdUsingToolVersionCodeFileUniqueOnCommandUpdate;
  CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingCommandPkeyUpdate: CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingCommandPkeyUpdate;
  CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingCommandToolVersionId9DbddabaUniqUpdate: CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingCommandToolVersionId9DbddabaUniqUpdate;
  CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingToolVersionCodeFileUniqueOnCommandUpdate: CommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingToolVersionCodeFileUniqueOnCommandUpdate;
  CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingCommandPkeyUpdate: CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingCommandPkeyUpdate;
  CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingCommandToolVersionId9DbddabaUniqUpdate: CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingCommandToolVersionId9DbddabaUniqUpdate;
  CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingToolVersionCodeFileUniqueOnCommandUpdate: CommandOnCommandForCommandUserId4A445414FkApplicationUserIdUsingToolVersionCodeFileUniqueOnCommandUpdate;
  CommandPatch: CommandPatch;
  CommandTenantId36F95C3CFkTenantIdCommandCreateInput: CommandTenantId36F95C3CFkTenantIdCommandCreateInput;
  CommandTenantId36F95C3CFkTenantIdInput: CommandTenantId36F95C3CFkTenantIdInput;
  CommandTenantId36F95C3CFkTenantIdInverseInput: CommandTenantId36F95C3CFkTenantIdInverseInput;
  CommandTenantId36F95C3CFkTenantIdTenantCreateInput: CommandTenantId36F95C3CFkTenantIdTenantCreateInput;
  CommandToolVersionCodeFileUniqueOnCommandConnect: CommandToolVersionCodeFileUniqueOnCommandConnect;
  CommandToolVersionCodeFileUniqueOnCommandDelete: CommandToolVersionCodeFileUniqueOnCommandDelete;
  CommandToolVersionId9DbddabaFkToolVersionIdCommandCreateInput: CommandToolVersionId9DbddabaFkToolVersionIdCommandCreateInput;
  CommandToolVersionId9DbddabaFkToolVersionIdInput: CommandToolVersionId9DbddabaFkToolVersionIdInput;
  CommandToolVersionId9DbddabaFkToolVersionIdInverseInput: CommandToolVersionId9DbddabaFkToolVersionIdInverseInput;
  CommandToolVersionId9DbddabaFkToolVersionIdToolVersionCreateInput: CommandToolVersionId9DbddabaFkToolVersionIdToolVersionCreateInput;
  CommandUserId4A445414FkApplicationUserIdApplicationUserCreateInput: CommandUserId4A445414FkApplicationUserIdApplicationUserCreateInput;
  CommandUserId4A445414FkApplicationUserIdCommandCreateInput: CommandUserId4A445414FkApplicationUserIdCommandCreateInput;
  CommandUserId4A445414FkApplicationUserIdInput: CommandUserId4A445414FkApplicationUserIdInput;
  CommandUserId4A445414FkApplicationUserIdInverseInput: CommandUserId4A445414FkApplicationUserIdInverseInput;
  CommandsConnection: CommandsConnection;
  CommandsEdge: CommandsEdge;
  ContainerImage: ContainerImage;
  ContainerImageCondition: ContainerImageCondition;
  ContainerImageContainerImageExecutorIdKeyConnect: ContainerImageContainerImageExecutorIdKeyConnect;
  ContainerImageContainerImageExecutorIdKeyDelete: ContainerImageContainerImageExecutorIdKeyDelete;
  ContainerImageContainerImagePkeyConnect: ContainerImageContainerImagePkeyConnect;
  ContainerImageContainerImagePkeyDelete: ContainerImageContainerImagePkeyDelete;
  ContainerImageContainerImageRepoBe6Ba4A8FkContainerContainerImageCreateInput: ContainerImageContainerImageRepoBe6Ba4A8FkContainerContainerImageCreateInput;
  ContainerImageContainerImageRepoBe6Ba4A8FkContainerContainerImageRepositoryCreateInput: ContainerImageContainerImageRepoBe6Ba4A8FkContainerContainerImageRepositoryCreateInput;
  ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput: ContainerImageContainerImageRepoBe6Ba4A8FkContainerInput;
  ContainerImageContainerImageRepoBe6Ba4A8FkContainerInverseInput: ContainerImageContainerImageRepoBe6Ba4A8FkContainerInverseInput;
  ContainerImageExecutorId68979Fb6FkTesContaContainerImageCreateInput: ContainerImageExecutorId68979Fb6FkTesContaContainerImageCreateInput;
  ContainerImageExecutorId68979Fb6FkTesContaInput: ContainerImageExecutorId68979Fb6FkTesContaInput;
  ContainerImageExecutorId68979Fb6FkTesContaInverseInput: ContainerImageExecutorId68979Fb6FkTesContaInverseInput;
  ContainerImageExecutorId68979Fb6FkTesContaTesContainerimageexecutorCreateInput: ContainerImageExecutorId68979Fb6FkTesContaTesContainerimageexecutorCreateInput;
  ContainerImageFilter: ContainerImageFilter;
  ContainerImageInput: ContainerImageInput;
  ContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate: ContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate;
  ContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingContainerImagePkeyUpdate: ContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdUsingContainerImagePkeyUpdate;
  ContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageExecutorIdKeyUpdate: ContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageExecutorIdKeyUpdate;
  ContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImagePkeyUpdate: ContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImagePkeyUpdate;
  ContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingContainerImageExecutorIdKeyUpdate: ContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingContainerImageExecutorIdKeyUpdate;
  ContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingContainerImagePkeyUpdate: ContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingContainerImagePkeyUpdate;
  ContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingContainerImageExecutorIdKeyUpdate: ContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingContainerImageExecutorIdKeyUpdate;
  ContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingContainerImagePkeyUpdate: ContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingContainerImagePkeyUpdate;
  ContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingContainerImageExecutorIdKeyUpdate: ContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingContainerImageExecutorIdKeyUpdate;
  ContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingContainerImagePkeyUpdate: ContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdUsingContainerImagePkeyUpdate;
  ContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingContainerImageExecutorIdKeyUpdate: ContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingContainerImageExecutorIdKeyUpdate;
  ContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingContainerImagePkeyUpdate: ContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingContainerImagePkeyUpdate;
  ContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate: ContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate;
  ContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingContainerImagePkeyUpdate: ContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingContainerImagePkeyUpdate;
  ContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate: ContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingContainerImageExecutorIdKeyUpdate;
  ContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingContainerImagePkeyUpdate: ContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingContainerImagePkeyUpdate;
  ContainerImagePatch: ContainerImagePatch;
  ContainerImageRepoUserIdAf9751AfFkApplicatiApplicationUserCreateInput: ContainerImageRepoUserIdAf9751AfFkApplicatiApplicationUserCreateInput;
  ContainerImageRepoUserIdAf9751AfFkApplicatiContainerImageRepositoryCreateInput: ContainerImageRepoUserIdAf9751AfFkApplicatiContainerImageRepositoryCreateInput;
  ContainerImageRepoUserIdAf9751AfFkApplicatiInput: ContainerImageRepoUserIdAf9751AfFkApplicatiInput;
  ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput: ContainerImageRepoUserIdAf9751AfFkApplicatiInverseInput;
  ContainerImageRepositoriesConnection: ContainerImageRepositoriesConnection;
  ContainerImageRepositoriesEdge: ContainerImageRepositoriesEdge;
  ContainerImageRepository: ContainerImageRepository;
  ContainerImageRepositoryCondition: ContainerImageRepositoryCondition;
  ContainerImageRepositoryContainerImageRepositoryNameTenantTypeUniqueConnect: ContainerImageRepositoryContainerImageRepositoryNameTenantTypeUniqueConnect;
  ContainerImageRepositoryContainerImageRepositoryNameTenantTypeUniqueDelete: ContainerImageRepositoryContainerImageRepositoryNameTenantTypeUniqueDelete;
  ContainerImageRepositoryContainerImageRepositoryPkeyConnect: ContainerImageRepositoryContainerImageRepositoryPkeyConnect;
  ContainerImageRepositoryContainerImageRepositoryPkeyDelete: ContainerImageRepositoryContainerImageRepositoryPkeyDelete;
  ContainerImageRepositoryContainerImageRepositoryRepositoryKeyConnect: ContainerImageRepositoryContainerImageRepositoryRepositoryKeyConnect;
  ContainerImageRepositoryContainerImageRepositoryRepositoryKeyDelete: ContainerImageRepositoryContainerImageRepositoryRepositoryKeyDelete;
  ContainerImageRepositoryFilter: ContainerImageRepositoryFilter;
  ContainerImageRepositoryInput: ContainerImageRepositoryInput;
  ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryNameTenantTypeUniqueUpdate: ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryNameTenantTypeUniqueUpdate;
  ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryPkeyUpdate: ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryPkeyUpdate;
  ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryRepositoryKeyUpdate: ContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerUsingContainerImageRepositoryRepositoryKeyUpdate;
  ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryNameTenantTypeUniqueUpdate: ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryNameTenantTypeUniqueUpdate;
  ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryPkeyUpdate: ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryPkeyUpdate;
  ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryRepositoryKeyUpdate: ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiUsingContainerImageRepositoryRepositoryKeyUpdate;
  ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryNameTenantTypeUniqueUpdate: ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryNameTenantTypeUniqueUpdate;
  ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryPkeyUpdate: ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryPkeyUpdate;
  ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryRepositoryKeyUpdate: ContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingContainerImageRepositoryRepositoryKeyUpdate;
  ContainerImageRepositoryPatch: ContainerImageRepositoryPatch;
  ContainerImageRepositoryTenantId217F4E90FkTenantIdContainerImageRepositoryCreateInput: ContainerImageRepositoryTenantId217F4E90FkTenantIdContainerImageRepositoryCreateInput;
  ContainerImageRepositoryTenantId217F4E90FkTenantIdInput: ContainerImageRepositoryTenantId217F4E90FkTenantIdInput;
  ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput: ContainerImageRepositoryTenantId217F4E90FkTenantIdInverseInput;
  ContainerImageRepositoryTenantId217F4E90FkTenantIdTenantCreateInput: ContainerImageRepositoryTenantId217F4E90FkTenantIdTenantCreateInput;
  ContainerImageRepositoryToManyContainerImageFilter: ContainerImageRepositoryToManyContainerImageFilter;
  ContainerImageTenantIdD0Beb309FkTenantIdContainerImageCreateInput: ContainerImageTenantIdD0Beb309FkTenantIdContainerImageCreateInput;
  ContainerImageTenantIdD0Beb309FkTenantIdInput: ContainerImageTenantIdD0Beb309FkTenantIdInput;
  ContainerImageTenantIdD0Beb309FkTenantIdInverseInput: ContainerImageTenantIdD0Beb309FkTenantIdInverseInput;
  ContainerImageTenantIdD0Beb309FkTenantIdTenantCreateInput: ContainerImageTenantIdD0Beb309FkTenantIdTenantCreateInput;
  ContainerImageToManyCommandFilter: ContainerImageToManyCommandFilter;
  ContainerImageToManyTaskFilter: ContainerImageToManyTaskFilter;
  ContainerImageToManyToolVersionFilter: ContainerImageToManyToolVersionFilter;
  ContainerImageToManyWorkflowFilter: ContainerImageToManyWorkflowFilter;
  ContainerImageUserId3919E673FkApplicationUserIdApplicationUserCreateInput: ContainerImageUserId3919E673FkApplicationUserIdApplicationUserCreateInput;
  ContainerImageUserId3919E673FkApplicationUserIdContainerImageCreateInput: ContainerImageUserId3919E673FkApplicationUserIdContainerImageCreateInput;
  ContainerImageUserId3919E673FkApplicationUserIdInput: ContainerImageUserId3919E673FkApplicationUserIdInput;
  ContainerImageUserId3919E673FkApplicationUserIdInverseInput: ContainerImageUserId3919E673FkApplicationUserIdInverseInput;
  ContainerImagesConnection: ContainerImagesConnection;
  ContainerImagesEdge: ContainerImagesEdge;
  Cost: Cost;
  CostCondition: CostCondition;
  CostCostPkeyConnect: CostCostPkeyConnect;
  CostCostPkeyDelete: CostCostPkeyDelete;
  CostFilter: CostFilter;
  CostInput: CostInput;
  CostOnCostForCostTenantId7Dcd58A7FkTenantIdUsingCostPkeyUpdate: CostOnCostForCostTenantId7Dcd58A7FkTenantIdUsingCostPkeyUpdate;
  CostOnFileActivityForFileActivityCostId2A88D90AFkCostIdUsingCostPkeyUpdate: CostOnFileActivityForFileActivityCostId2A88D90AFkCostIdUsingCostPkeyUpdate;
  CostOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingCostPkeyUpdate: CostOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingCostPkeyUpdate;
  CostPatch: CostPatch;
  CostTenantId7Dcd58A7FkTenantIdCostCreateInput: CostTenantId7Dcd58A7FkTenantIdCostCreateInput;
  CostTenantId7Dcd58A7FkTenantIdInput: CostTenantId7Dcd58A7FkTenantIdInput;
  CostTenantId7Dcd58A7FkTenantIdInverseInput: CostTenantId7Dcd58A7FkTenantIdInverseInput;
  CostTenantId7Dcd58A7FkTenantIdTenantCreateInput: CostTenantId7Dcd58A7FkTenantIdTenantCreateInput;
  CostToManyFileActivityFilter: CostToManyFileActivityFilter;
  CostToManyTaskActivityFilter: CostToManyTaskActivityFilter;
  CostsConnection: CostsConnection;
  CostsEdge: CostsEdge;
  CreateAdminProjectInput: CreateAdminProjectInput;
  CreateAdminProjectPayload: CreateAdminProjectPayload;
  CreateApplicationUserGroupInput: CreateApplicationUserGroupInput;
  CreateApplicationUserGroupPayload: CreateApplicationUserGroupPayload;
  CreateApplicationUserInput: CreateApplicationUserInput;
  CreateApplicationUserMembershipInput: CreateApplicationUserMembershipInput;
  CreateApplicationUserMembershipPayload: CreateApplicationUserMembershipPayload;
  CreateApplicationUserMetadatumInput: CreateApplicationUserMetadatumInput;
  CreateApplicationUserMetadatumPayload: CreateApplicationUserMetadatumPayload;
  CreateApplicationUserPayload: CreateApplicationUserPayload;
  CreateApplicationUserSessionInput: CreateApplicationUserSessionInput;
  CreateApplicationUserSessionPayload: CreateApplicationUserSessionPayload;
  CreateApplicationUserUserPermissionInput: CreateApplicationUserUserPermissionInput;
  CreateApplicationUserUserPermissionPayload: CreateApplicationUserUserPermissionPayload;
  CreateAuditlogLogentryInput: CreateAuditlogLogentryInput;
  CreateAuditlogLogentryPayload: CreateAuditlogLogentryPayload;
  CreateAuthGroupInput: CreateAuthGroupInput;
  CreateAuthGroupPayload: CreateAuthGroupPayload;
  CreateAuthGroupPermissionInput: CreateAuthGroupPermissionInput;
  CreateAuthGroupPermissionPayload: CreateAuthGroupPermissionPayload;
  CreateAuthPermissionInput: CreateAuthPermissionInput;
  CreateAuthPermissionPayload: CreateAuthPermissionPayload;
  CreateAvailableNonRestrictedProjectInput: CreateAvailableNonRestrictedProjectInput;
  CreateAvailableNonRestrictedProjectPayload: CreateAvailableNonRestrictedProjectPayload;
  CreateAvatarInput: CreateAvatarInput;
  CreateAvatarPayload: CreateAvatarPayload;
  CreateAwsBatchTaskInput: CreateAwsBatchTaskInput;
  CreateAwsBatchTaskPayload: CreateAwsBatchTaskPayload;
  CreateAwsCognitoUserInput: CreateAwsCognitoUserInput;
  CreateAwsCognitoUserPayload: CreateAwsCognitoUserPayload;
  CreateAwsEcrImageInput: CreateAwsEcrImageInput;
  CreateAwsEcrImagePayload: CreateAwsEcrImagePayload;
  CreateAwsMockBatchTaskInput: CreateAwsMockBatchTaskInput;
  CreateAwsMockBatchTaskPayload: CreateAwsMockBatchTaskPayload;
  CreateAwsMockDistributionImageInput: CreateAwsMockDistributionImageInput;
  CreateAwsMockDistributionImagePayload: CreateAwsMockDistributionImagePayload;
  CreateAwsMockEcrImageInput: CreateAwsMockEcrImageInput;
  CreateAwsMockEcrImagePayload: CreateAwsMockEcrImagePayload;
  CreateAwsMockIamUserInput: CreateAwsMockIamUserInput;
  CreateAwsMockIamUserPayload: CreateAwsMockIamUserPayload;
  CreateAwsMockS3FileInput: CreateAwsMockS3FileInput;
  CreateAwsMockS3FilePayload: CreateAwsMockS3FilePayload;
  CreateAwsS3FileInput: CreateAwsS3FileInput;
  CreateAwsS3FilePayload: CreateAwsS3FilePayload;
  CreateCodeFileInput: CreateCodeFileInput;
  CreateCodeFilePayload: CreateCodeFilePayload;
  CreateCommandInput: CreateCommandInput;
  CreateCommandPayload: CreateCommandPayload;
  CreateContainerImageInput: CreateContainerImageInput;
  CreateContainerImagePayload: CreateContainerImagePayload;
  CreateContainerImageRepositoryInput: CreateContainerImageRepositoryInput;
  CreateContainerImageRepositoryPayload: CreateContainerImageRepositoryPayload;
  CreateCostInput: CreateCostInput;
  CreateCostPayload: CreateCostPayload;
  CreateCurrentApplicationUserInput: CreateCurrentApplicationUserInput;
  CreateCurrentApplicationUserPayload: CreateCurrentApplicationUserPayload;
  CreateDistributionRegistryImageInput: CreateDistributionRegistryImageInput;
  CreateDistributionRegistryImagePayload: CreateDistributionRegistryImagePayload;
  CreateDjangoAdminLogInput: CreateDjangoAdminLogInput;
  CreateDjangoAdminLogPayload: CreateDjangoAdminLogPayload;
  CreateDjangoContentTypeInput: CreateDjangoContentTypeInput;
  CreateDjangoContentTypePayload: CreateDjangoContentTypePayload;
  CreateDjangoMigrationInput: CreateDjangoMigrationInput;
  CreateDjangoMigrationPayload: CreateDjangoMigrationPayload;
  CreateDjangoSesBlacklistedemailInput: CreateDjangoSesBlacklistedemailInput;
  CreateDjangoSesBlacklistedemailPayload: CreateDjangoSesBlacklistedemailPayload;
  CreateDjangoSesSesstatInput: CreateDjangoSesSesstatInput;
  CreateDjangoSesSesstatPayload: CreateDjangoSesSesstatPayload;
  CreateDjangoSessionInput: CreateDjangoSessionInput;
  CreateDjangoSessionPayload: CreateDjangoSessionPayload;
  CreateDrsFileexecutorInput: CreateDrsFileexecutorInput;
  CreateDrsFileexecutorPayload: CreateDrsFileexecutorPayload;
  CreateDrsMockfileexecutorInput: CreateDrsMockfileexecutorInput;
  CreateDrsMockfileexecutorPayload: CreateDrsMockfileexecutorPayload;
  CreateEulaVersionInput: CreateEulaVersionInput;
  CreateEulaVersionPayload: CreateEulaVersionPayload;
  CreateEulaVersionUserAcceptanceInput: CreateEulaVersionUserAcceptanceInput;
  CreateEulaVersionUserAcceptancePayload: CreateEulaVersionUserAcceptancePayload;
  CreateFeatureFlagInput: CreateFeatureFlagInput;
  CreateFeatureFlagPayload: CreateFeatureFlagPayload;
  CreateFeatureFlagsGroupInput: CreateFeatureFlagsGroupInput;
  CreateFeatureFlagsGroupPayload: CreateFeatureFlagsGroupPayload;
  CreateFeatureFlagsTenantInput: CreateFeatureFlagsTenantInput;
  CreateFeatureFlagsTenantPayload: CreateFeatureFlagsTenantPayload;
  CreateFeatureFlagsUserInput: CreateFeatureFlagsUserInput;
  CreateFeatureFlagsUserPayload: CreateFeatureFlagsUserPayload;
  CreateFileActivityInput: CreateFileActivityInput;
  CreateFileActivityPayload: CreateFileActivityPayload;
  CreateFileInput: CreateFileInput;
  CreateFileMetadatumInput: CreateFileMetadatumInput;
  CreateFileMetadatumPayload: CreateFileMetadatumPayload;
  CreateFileOutputGroupMetadatumInput: CreateFileOutputGroupMetadatumInput;
  CreateFileOutputGroupMetadatumPayload: CreateFileOutputGroupMetadatumPayload;
  CreateFilePayload: CreateFilePayload;
  CreateFilesByExecutorInput: CreateFilesByExecutorInput;
  CreateFilesByExecutorPayload: CreateFilesByExecutorPayload;
  CreateMetadataValueInput: CreateMetadataValueInput;
  CreateMetadataValuePayload: CreateMetadataValuePayload;
  CreateMetadatumInput: CreateMetadatumInput;
  CreateMetadatumPayload: CreateMetadatumPayload;
  CreateOutputGroupFileInput: CreateOutputGroupFileInput;
  CreateOutputGroupFilePayload: CreateOutputGroupFilePayload;
  CreatePinnedToolInput: CreatePinnedToolInput;
  CreatePinnedToolPayload: CreatePinnedToolPayload;
  CreateProjectFolderInput: CreateProjectFolderInput;
  CreateProjectFolderPayload: CreateProjectFolderPayload;
  CreateProjectTagInput: CreateProjectTagInput;
  CreateProjectTagPayload: CreateProjectTagPayload;
  CreateRoleInput: CreateRoleInput;
  CreateRolePayload: CreateRolePayload;
  CreateRunInput: CreateRunInput;
  CreateRunPayload: CreateRunPayload;
  CreateSessionInput: CreateSessionInput;
  CreateSessionPayload: CreateSessionPayload;
  CreateTaskActivityInput: CreateTaskActivityInput;
  CreateTaskActivityPayload: CreateTaskActivityPayload;
  CreateTaskInput: CreateTaskInput;
  CreateTaskPayload: CreateTaskPayload;
  CreateTaskResourceInput: CreateTaskResourceInput;
  CreateTaskResourcePayload: CreateTaskResourcePayload;
  CreateTaskResourceUsageInput: CreateTaskResourceUsageInput;
  CreateTaskResourceUsagePayload: CreateTaskResourceUsagePayload;
  CreateTaskSourceInput: CreateTaskSourceInput;
  CreateTaskSourcePayload: CreateTaskSourcePayload;
  CreateTaskStatusLogInput: CreateTaskStatusLogInput;
  CreateTaskStatusLogPayload: CreateTaskStatusLogPayload;
  CreateTenantContractAllowanceInput: CreateTenantContractAllowanceInput;
  CreateTenantContractAllowancePayload: CreateTenantContractAllowancePayload;
  CreateTenantContractInput: CreateTenantContractInput;
  CreateTenantContractPayload: CreateTenantContractPayload;
  CreateTenantContractTransactionInput: CreateTenantContractTransactionInput;
  CreateTenantContractTransactionPayload: CreateTenantContractTransactionPayload;
  CreateTenantInput: CreateTenantInput;
  CreateTenantMockuserexecutorInput: CreateTenantMockuserexecutorInput;
  CreateTenantMockuserexecutorPayload: CreateTenantMockuserexecutorPayload;
  CreateTenantMonthlyConsumedResourceInput: CreateTenantMonthlyConsumedResourceInput;
  CreateTenantMonthlyConsumedResourcePayload: CreateTenantMonthlyConsumedResourcePayload;
  CreateTenantPayload: CreateTenantPayload;
  CreateTenantUserexecutorInput: CreateTenantUserexecutorInput;
  CreateTenantUserexecutorPayload: CreateTenantUserexecutorPayload;
  CreateTesContainerimageexecutorInput: CreateTesContainerimageexecutorInput;
  CreateTesContainerimageexecutorPayload: CreateTesContainerimageexecutorPayload;
  CreateTesMockcontainerimageexecutorInput: CreateTesMockcontainerimageexecutorInput;
  CreateTesMockcontainerimageexecutorPayload: CreateTesMockcontainerimageexecutorPayload;
  CreateTesMocktaskexecutorInput: CreateTesMocktaskexecutorInput;
  CreateTesMocktaskexecutorPayload: CreateTesMocktaskexecutorPayload;
  CreateTesTaskexecutorInput: CreateTesTaskexecutorInput;
  CreateTesTaskexecutorPayload: CreateTesTaskexecutorPayload;
  CreateToolInput: CreateToolInput;
  CreateToolParameterInput: CreateToolParameterInput;
  CreateToolParameterPayload: CreateToolParameterPayload;
  CreateToolPayload: CreateToolPayload;
  CreateToolResourceInput: CreateToolResourceInput;
  CreateToolResourcePayload: CreateToolResourcePayload;
  CreateToolResultInput: CreateToolResultInput;
  CreateToolResultPayload: CreateToolResultPayload;
  CreateToolSecretInput: CreateToolSecretInput;
  CreateToolSecretPayload: CreateToolSecretPayload;
  CreateToolSourceInput: CreateToolSourceInput;
  CreateToolSourcePayload: CreateToolSourcePayload;
  CreateToolTenantInput: CreateToolTenantInput;
  CreateToolTenantPayload: CreateToolTenantPayload;
  CreateToolVersionInput: CreateToolVersionInput;
  CreateToolVersionPayload: CreateToolVersionPayload;
  CreateToolboxInput: CreateToolboxInput;
  CreateToolboxPayload: CreateToolboxPayload;
  CreateToolboxTenantInput: CreateToolboxTenantInput;
  CreateToolboxTenantPayload: CreateToolboxTenantPayload;
  CreateUserPersonalSpaceRequestInput: CreateUserPersonalSpaceRequestInput;
  CreateUserPersonalSpaceRequestPayload: CreateUserPersonalSpaceRequestPayload;
  CreateWaffleFlagInput: CreateWaffleFlagInput;
  CreateWaffleFlagPayload: CreateWaffleFlagPayload;
  CreateWaffleSampleInput: CreateWaffleSampleInput;
  CreateWaffleSamplePayload: CreateWaffleSamplePayload;
  CreateWaffleSwitchInput: CreateWaffleSwitchInput;
  CreateWaffleSwitchPayload: CreateWaffleSwitchPayload;
  CreateWorkflowDatumInput: CreateWorkflowDatumInput;
  CreateWorkflowDatumPayload: CreateWorkflowDatumPayload;
  CreateWorkflowInput: CreateWorkflowInput;
  CreateWorkflowPayload: CreateWorkflowPayload;
  CreateWorkflowResultInput: CreateWorkflowResultInput;
  CreateWorkflowResultPayload: CreateWorkflowResultPayload;
  CreateWorkflowResultWorkflowVersionInput: CreateWorkflowResultWorkflowVersionInput;
  CreateWorkflowResultWorkflowVersionPayload: CreateWorkflowResultWorkflowVersionPayload;
  CreateWorkflowSectionBlockInput: CreateWorkflowSectionBlockInput;
  CreateWorkflowSectionBlockPayload: CreateWorkflowSectionBlockPayload;
  CreateWorkflowSectionBlockSectionInput: CreateWorkflowSectionBlockSectionInput;
  CreateWorkflowSectionBlockSectionPayload: CreateWorkflowSectionBlockSectionPayload;
  CreateWorkflowSectionInput: CreateWorkflowSectionInput;
  CreateWorkflowSectionPayload: CreateWorkflowSectionPayload;
  CreateWorkflowSectionWorkflowVersionInput: CreateWorkflowSectionWorkflowVersionInput;
  CreateWorkflowSectionWorkflowVersionPayload: CreateWorkflowSectionWorkflowVersionPayload;
  CreateWorkflowSourceInput: CreateWorkflowSourceInput;
  CreateWorkflowSourcePayload: CreateWorkflowSourcePayload;
  CreateWorkflowSourceWorkflowVersionInput: CreateWorkflowSourceWorkflowVersionInput;
  CreateWorkflowSourceWorkflowVersionPayload: CreateWorkflowSourceWorkflowVersionPayload;
  CreateWorkflowVersionInput: CreateWorkflowVersionInput;
  CreateWorkflowVersionPayload: CreateWorkflowVersionPayload;
  CurrentApplicationUser: CurrentApplicationUser;
  CurrentApplicationUserCondition: CurrentApplicationUserCondition;
  CurrentApplicationUserFilter: CurrentApplicationUserFilter;
  CurrentApplicationUserInput: CurrentApplicationUserInput;
  CurrentApplicationUsersConnection: CurrentApplicationUsersConnection;
  CurrentApplicationUsersEdge: CurrentApplicationUsersEdge;
  CurrentUserMembership: CurrentUserMembership;
  CurrentUserMembershipCondition: CurrentUserMembershipCondition;
  CurrentUserMembershipFilter: CurrentUserMembershipFilter;
  CurrentUserMembershipsConnection: CurrentUserMembershipsConnection;
  CurrentUserMembershipsEdge: CurrentUserMembershipsEdge;
  Cursor: Scalars["Cursor"]["output"];
  DataTable: DataTable;
  DataTableCell: DataTableCell;
  DataTableCellColumnId9A5117BdFkDataTableColumnIdInput: DataTableCellColumnId9A5117BdFkDataTableColumnIdInput;
  DataTableCellColumnId9A5117BdFkDataTableColumnIdInverseInput: DataTableCellColumnId9A5117BdFkDataTableColumnIdInverseInput;
  DataTableCellCondition: DataTableCellCondition;
  DataTableCellDataTableCellPkeyConnect: DataTableCellDataTableCellPkeyConnect;
  DataTableCellDataTableCellUniqueConnect: DataTableCellDataTableCellUniqueConnect;
  DataTableCellFilter: DataTableCellFilter;
  DataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableCellPkeyUpdate: DataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableCellPkeyUpdate;
  DataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableCellUniqueUpdate: DataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableCellUniqueUpdate;
  DataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingDataTableCellPkeyUpdate: DataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingDataTableCellPkeyUpdate;
  DataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingDataTableCellUniqueUpdate: DataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingDataTableCellUniqueUpdate;
  DataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableCellPkeyUpdate: DataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableCellPkeyUpdate;
  DataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableCellUniqueUpdate: DataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableCellUniqueUpdate;
  DataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTableCellPkeyUpdate: DataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTableCellPkeyUpdate;
  DataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTableCellUniqueUpdate: DataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTableCellUniqueUpdate;
  DataTableCellProjectIdEf5721A0FkProjectIdInput: DataTableCellProjectIdEf5721A0FkProjectIdInput;
  DataTableCellProjectIdEf5721A0FkProjectIdInverseInput: DataTableCellProjectIdEf5721A0FkProjectIdInverseInput;
  DataTableCellRowId3A3C7567FkDataTableRowIdInput: DataTableCellRowId3A3C7567FkDataTableRowIdInput;
  DataTableCellRowId3A3C7567FkDataTableRowIdInverseInput: DataTableCellRowId3A3C7567FkDataTableRowIdInverseInput;
  DataTableCellTableId12E87426FkDataTableIdInput: DataTableCellTableId12E87426FkDataTableIdInput;
  DataTableCellTableId12E87426FkDataTableIdInverseInput: DataTableCellTableId12E87426FkDataTableIdInverseInput;
  DataTableCellsConnection: DataTableCellsConnection;
  DataTableCellsEdge: DataTableCellsEdge;
  DataTableColumn: DataTableColumn;
  DataTableColumnCondition: DataTableColumnCondition;
  DataTableColumnDataTableColumnOrderUniqueConnect: DataTableColumnDataTableColumnOrderUniqueConnect;
  DataTableColumnDataTableColumnPkeyConnect: DataTableColumnDataTableColumnPkeyConnect;
  DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInput: DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInput;
  DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput: DataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoInverseInput;
  DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInput: DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInput;
  DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput: DataTableColumnDeEventSetFileColumAb691C45FkDjangoCoInverseInput;
  DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInput: DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInput;
  DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput: DataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoInverseInput;
  DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInput: DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInput;
  DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput: DataTableColumnDeFileColumnTypeId8167165CFkDjangoCoInverseInput;
  DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInput: DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInput;
  DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput: DataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoInverseInput;
  DataTableColumnDeProjectId3A701Ad3FkProjectIInput: DataTableColumnDeProjectId3A701Ad3FkProjectIInput;
  DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput: DataTableColumnDeProjectId3A701Ad3FkProjectIInverseInput;
  DataTableColumnDeProjectId8E855Eb8FkProjectIInput: DataTableColumnDeProjectId8E855Eb8FkProjectIInput;
  DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput: DataTableColumnDeProjectId8E855Eb8FkProjectIInverseInput;
  DataTableColumnDeProjectId29F0D38FFkProjectIInput: DataTableColumnDeProjectId29F0D38FFkProjectIInput;
  DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput: DataTableColumnDeProjectId29F0D38FFkProjectIInverseInput;
  DataTableColumnDeProjectId433Daf03FkProjectIInput: DataTableColumnDeProjectId433Daf03FkProjectIInput;
  DataTableColumnDeProjectId433Daf03FkProjectIInverseInput: DataTableColumnDeProjectId433Daf03FkProjectIInverseInput;
  DataTableColumnDeProjectId2487E0EbFkProjectIInput: DataTableColumnDeProjectId2487E0EbFkProjectIInput;
  DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput: DataTableColumnDeProjectId2487E0EbFkProjectIInverseInput;
  DataTableColumnDeProjectId7732E962FkProjectIInput: DataTableColumnDeProjectId7732E962FkProjectIInput;
  DataTableColumnDeProjectId7732E962FkProjectIInverseInput: DataTableColumnDeProjectId7732E962FkProjectIInverseInput;
  DataTableColumnDeProjectId869397AfFkProjectIInput: DataTableColumnDeProjectId869397AfFkProjectIInput;
  DataTableColumnDeProjectId869397AfFkProjectIInverseInput: DataTableColumnDeProjectId869397AfFkProjectIInverseInput;
  DataTableColumnDeProjectId33688488FkProjectIInput: DataTableColumnDeProjectId33688488FkProjectIInput;
  DataTableColumnDeProjectId33688488FkProjectIInverseInput: DataTableColumnDeProjectId33688488FkProjectIInverseInput;
  DataTableColumnDeProjectIdBc4Cdb01FkProjectIInput: DataTableColumnDeProjectIdBc4Cdb01FkProjectIInput;
  DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput: DataTableColumnDeProjectIdBc4Cdb01FkProjectIInverseInput;
  DataTableColumnDeProjectIdC5C8B765FkProjectIInput: DataTableColumnDeProjectIdC5C8B765FkProjectIInput;
  DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput: DataTableColumnDeProjectIdC5C8B765FkProjectIInverseInput;
  DataTableColumnDeProjectIdC7B1D7FbFkProjectIInput: DataTableColumnDeProjectIdC7B1D7FbFkProjectIInput;
  DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput: DataTableColumnDeProjectIdC7B1D7FbFkProjectIInverseInput;
  DataTableColumnDeProjectIdE2A11292FkProjectIInput: DataTableColumnDeProjectIdE2A11292FkProjectIInput;
  DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput: DataTableColumnDeProjectIdE2A11292FkProjectIInverseInput;
  DataTableColumnDeQcReportFileColum864C112DFkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeQcReportFileColum864C112DFkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInput: DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInput;
  DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput: DataTableColumnDeQcReportFileColum864C112DFkDjangoCoInverseInput;
  DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInput: DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInput;
  DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput: DataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoInverseInput;
  DataTableColumnDeSourceColumnTypeIE4E5D06AFkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeSourceColumnTypeIE4E5D06AFkDjangoCoInput: DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInput;
  DataTableColumnDeSourceColumnTypeIE4E5D06AFkDjangoCoInverseInput: DataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoInverseInput;
  DataTableColumnDeTableTypeId6A986C02FkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDeTableTypeId6A986C02FkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDeTableTypeId6A986C02FkDjangoCoInput: DataTableColumnDeTableTypeId6A986C02FkDjangoCoInput;
  DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput: DataTableColumnDeTableTypeId6A986C02FkDjangoCoInverseInput;
  DataTableColumnDefinitionBoolean: DataTableColumnDefinitionBoolean;
  DataTableColumnDefinitionBooleanCondition: DataTableColumnDefinitionBooleanCondition;
  DataTableColumnDefinitionBooleanDataTableColumnDefinitionBooleanPkeyConnect: DataTableColumnDefinitionBooleanDataTableColumnDefinitionBooleanPkeyConnect;
  DataTableColumnDefinitionBooleanFilter: DataTableColumnDefinitionBooleanFilter;
  DataTableColumnDefinitionBooleanOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingDataTableColumnDefinitionBooleanPkeyUpdate: DataTableColumnDefinitionBooleanOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingDataTableColumnDefinitionBooleanPkeyUpdate;
  DataTableColumnDefinitionBooleansConnection: DataTableColumnDefinitionBooleansConnection;
  DataTableColumnDefinitionBooleansEdge: DataTableColumnDefinitionBooleansEdge;
  DataTableColumnDefinitionCellStatus: DataTableColumnDefinitionCellStatus;
  DataTableColumnDefinitionCellStatusCondition: DataTableColumnDefinitionCellStatusCondition;
  DataTableColumnDefinitionCellStatusDataTableColumnDefinitionCellStatusPkeyConnect: DataTableColumnDefinitionCellStatusDataTableColumnDefinitionCellStatusPkeyConnect;
  DataTableColumnDefinitionCellStatusFilter: DataTableColumnDefinitionCellStatusFilter;
  DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate: DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate;
  DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate: DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate;
  DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingDataTableColumnDefinitionCellStatusPkeyUpdate: DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingDataTableColumnDefinitionCellStatusPkeyUpdate;
  DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate: DataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDataTableColumnDefinitionCellStatusPkeyUpdate;
  DataTableColumnDefinitionCellStatusesConnection: DataTableColumnDefinitionCellStatusesConnection;
  DataTableColumnDefinitionCellStatusesEdge: DataTableColumnDefinitionCellStatusesEdge;
  DataTableColumnDefinitionChoice: DataTableColumnDefinitionChoice;
  DataTableColumnDefinitionChoiceCondition: DataTableColumnDefinitionChoiceCondition;
  DataTableColumnDefinitionChoiceDataTableColumnDefinitionChoicePkeyConnect: DataTableColumnDefinitionChoiceDataTableColumnDefinitionChoicePkeyConnect;
  DataTableColumnDefinitionChoiceFilter: DataTableColumnDefinitionChoiceFilter;
  DataTableColumnDefinitionChoiceOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingDataTableColumnDefinitionChoicePkeyUpdate: DataTableColumnDefinitionChoiceOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingDataTableColumnDefinitionChoicePkeyUpdate;
  DataTableColumnDefinitionChoicesConnection: DataTableColumnDefinitionChoicesConnection;
  DataTableColumnDefinitionChoicesEdge: DataTableColumnDefinitionChoicesEdge;
  DataTableColumnDefinitionDate: DataTableColumnDefinitionDate;
  DataTableColumnDefinitionDateCondition: DataTableColumnDefinitionDateCondition;
  DataTableColumnDefinitionDateDataTableColumnDefinitionDatePkeyConnect: DataTableColumnDefinitionDateDataTableColumnDefinitionDatePkeyConnect;
  DataTableColumnDefinitionDateFilter: DataTableColumnDefinitionDateFilter;
  DataTableColumnDefinitionDateOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingDataTableColumnDefinitionDatePkeyUpdate: DataTableColumnDefinitionDateOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingDataTableColumnDefinitionDatePkeyUpdate;
  DataTableColumnDefinitionDatesConnection: DataTableColumnDefinitionDatesConnection;
  DataTableColumnDefinitionDatesEdge: DataTableColumnDefinitionDatesEdge;
  DataTableColumnDefinitionFile: DataTableColumnDefinitionFile;
  DataTableColumnDefinitionFileCondition: DataTableColumnDefinitionFileCondition;
  DataTableColumnDefinitionFileDataTableColumnDefinitionFilePkeyConnect: DataTableColumnDefinitionFileDataTableColumnDefinitionFilePkeyConnect;
  DataTableColumnDefinitionFileFilter: DataTableColumnDefinitionFileFilter;
  DataTableColumnDefinitionFileOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingDataTableColumnDefinitionFilePkeyUpdate: DataTableColumnDefinitionFileOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingDataTableColumnDefinitionFilePkeyUpdate;
  DataTableColumnDefinitionFilesConnection: DataTableColumnDefinitionFilesConnection;
  DataTableColumnDefinitionFilesEdge: DataTableColumnDefinitionFilesEdge;
  DataTableColumnDefinitionFloat: DataTableColumnDefinitionFloat;
  DataTableColumnDefinitionFloatCondition: DataTableColumnDefinitionFloatCondition;
  DataTableColumnDefinitionFloatDataTableColumnDefinitionFloatPkeyConnect: DataTableColumnDefinitionFloatDataTableColumnDefinitionFloatPkeyConnect;
  DataTableColumnDefinitionFloatFilter: DataTableColumnDefinitionFloatFilter;
  DataTableColumnDefinitionFloatOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingDataTableColumnDefinitionFloatPkeyUpdate: DataTableColumnDefinitionFloatOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingDataTableColumnDefinitionFloatPkeyUpdate;
  DataTableColumnDefinitionFloatsConnection: DataTableColumnDefinitionFloatsConnection;
  DataTableColumnDefinitionFloatsEdge: DataTableColumnDefinitionFloatsEdge;
  DataTableColumnDefinitionIdentifier: DataTableColumnDefinitionIdentifier;
  DataTableColumnDefinitionIdentifierCondition: DataTableColumnDefinitionIdentifierCondition;
  DataTableColumnDefinitionIdentifierDataTableColumnDefinitionIdentifierPkeyConnect: DataTableColumnDefinitionIdentifierDataTableColumnDefinitionIdentifierPkeyConnect;
  DataTableColumnDefinitionIdentifierFilter: DataTableColumnDefinitionIdentifierFilter;
  DataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingDataTableColumnDefinitionIdentifierPkeyUpdate: DataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingDataTableColumnDefinitionIdentifierPkeyUpdate;
  DataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDataTableColumnDefinitionIdentifierPkeyUpdate: DataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDataTableColumnDefinitionIdentifierPkeyUpdate;
  DataTableColumnDefinitionIdentifiersConnection: DataTableColumnDefinitionIdentifiersConnection;
  DataTableColumnDefinitionIdentifiersEdge: DataTableColumnDefinitionIdentifiersEdge;
  DataTableColumnDefinitionInteger: DataTableColumnDefinitionInteger;
  DataTableColumnDefinitionIntegerCondition: DataTableColumnDefinitionIntegerCondition;
  DataTableColumnDefinitionIntegerDataTableColumnDefinitionIntegerPkeyConnect: DataTableColumnDefinitionIntegerDataTableColumnDefinitionIntegerPkeyConnect;
  DataTableColumnDefinitionIntegerFilter: DataTableColumnDefinitionIntegerFilter;
  DataTableColumnDefinitionIntegerOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingDataTableColumnDefinitionIntegerPkeyUpdate: DataTableColumnDefinitionIntegerOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingDataTableColumnDefinitionIntegerPkeyUpdate;
  DataTableColumnDefinitionIntegersConnection: DataTableColumnDefinitionIntegersConnection;
  DataTableColumnDefinitionIntegersEdge: DataTableColumnDefinitionIntegersEdge;
  DataTableColumnDefinitionJoin: DataTableColumnDefinitionJoin;
  DataTableColumnDefinitionJoinCondition: DataTableColumnDefinitionJoinCondition;
  DataTableColumnDefinitionJoinDataTableColumnDefinitionJoinPkeyConnect: DataTableColumnDefinitionJoinDataTableColumnDefinitionJoinPkeyConnect;
  DataTableColumnDefinitionJoinFilter: DataTableColumnDefinitionJoinFilter;
  DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate: DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate;
  DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingDataTableColumnDefinitionJoinPkeyUpdate: DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingDataTableColumnDefinitionJoinPkeyUpdate;
  DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate: DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate;
  DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIE4E5D06AFkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate: DataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoUsingDataTableColumnDefinitionJoinPkeyUpdate;
  DataTableColumnDefinitionJoinsConnection: DataTableColumnDefinitionJoinsConnection;
  DataTableColumnDefinitionJoinsEdge: DataTableColumnDefinitionJoinsEdge;
  DataTableColumnDefinitionMetadataConnection: DataTableColumnDefinitionMetadataConnection;
  DataTableColumnDefinitionMetadataEdge: DataTableColumnDefinitionMetadataEdge;
  DataTableColumnDefinitionMetadatum: DataTableColumnDefinitionMetadatum;
  DataTableColumnDefinitionMetadatumCondition: DataTableColumnDefinitionMetadatumCondition;
  DataTableColumnDefinitionMetadatumDataTableColumnDefinitionMetadatumPkeyConnect: DataTableColumnDefinitionMetadatumDataTableColumnDefinitionMetadatumPkeyConnect;
  DataTableColumnDefinitionMetadatumFilter: DataTableColumnDefinitionMetadatumFilter;
  DataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDataTableColumnDefinitionMetadatumPkeyUpdate: DataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDataTableColumnDefinitionMetadatumPkeyUpdate;
  DataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingDataTableColumnDefinitionMetadatumPkeyUpdate: DataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingDataTableColumnDefinitionMetadatumPkeyUpdate;
  DataTableColumnDefinitionRoiFrame: DataTableColumnDefinitionRoiFrame;
  DataTableColumnDefinitionRoiFrameCondition: DataTableColumnDefinitionRoiFrameCondition;
  DataTableColumnDefinitionRoiFrameDataTableColumnDefinitionRoiFramePkeyConnect: DataTableColumnDefinitionRoiFrameDataTableColumnDefinitionRoiFramePkeyConnect;
  DataTableColumnDefinitionRoiFrameFilter: DataTableColumnDefinitionRoiFrameFilter;
  DataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDataTableColumnDefinitionRoiFramePkeyUpdate: DataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDataTableColumnDefinitionRoiFramePkeyUpdate;
  DataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingDataTableColumnDefinitionRoiFramePkeyUpdate: DataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingDataTableColumnDefinitionRoiFramePkeyUpdate;
  DataTableColumnDefinitionRoiFramesConnection: DataTableColumnDefinitionRoiFramesConnection;
  DataTableColumnDefinitionRoiFramesEdge: DataTableColumnDefinitionRoiFramesEdge;
  DataTableColumnDefinitionText: DataTableColumnDefinitionText;
  DataTableColumnDefinitionTextCondition: DataTableColumnDefinitionTextCondition;
  DataTableColumnDefinitionTextDataTableColumnDefinitionTextPkeyConnect: DataTableColumnDefinitionTextDataTableColumnDefinitionTextPkeyConnect;
  DataTableColumnDefinitionTextFilter: DataTableColumnDefinitionTextFilter;
  DataTableColumnDefinitionTextOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingDataTableColumnDefinitionTextPkeyUpdate: DataTableColumnDefinitionTextOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingDataTableColumnDefinitionTextPkeyUpdate;
  DataTableColumnDefinitionTextsConnection: DataTableColumnDefinitionTextsConnection;
  DataTableColumnDefinitionTextsEdge: DataTableColumnDefinitionTextsEdge;
  DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoDjangoContentTypeCreateInput: DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInput: DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInput;
  DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput: DataTableColumnDefinitionTypeId9C22C97DFkDjangoCoInverseInput;
  DataTableColumnFilter: DataTableColumnFilter;
  DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoDjangoContentTypeCreateInput: DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInput: DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInput;
  DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput: DataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoInverseInput;
  DataTableColumnGrProjectId2Af8Cd7EFkProjectIInput: DataTableColumnGrProjectId2Af8Cd7EFkProjectIInput;
  DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput: DataTableColumnGrProjectId2Af8Cd7EFkProjectIInverseInput;
  DataTableColumnGrProjectId7376573CFkProjectIInput: DataTableColumnGrProjectId7376573CFkProjectIInput;
  DataTableColumnGrProjectId7376573CFkProjectIInverseInput: DataTableColumnGrProjectId7376573CFkProjectIInverseInput;
  DataTableColumnGrTableTypeId70D51D68FkDjangoCoDjangoContentTypeCreateInput: DataTableColumnGrTableTypeId70D51D68FkDjangoCoDjangoContentTypeCreateInput;
  DataTableColumnGrTableTypeId70D51D68FkDjangoCoInput: DataTableColumnGrTableTypeId70D51D68FkDjangoCoInput;
  DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput: DataTableColumnGrTableTypeId70D51D68FkDjangoCoInverseInput;
  DataTableColumnGroup: DataTableColumnGroup;
  DataTableColumnGroupCondition: DataTableColumnGroupCondition;
  DataTableColumnGroupDataTableColumnGroupPkeyConnect: DataTableColumnGroupDataTableColumnGroupPkeyConnect;
  DataTableColumnGroupDefinitionJoin: DataTableColumnGroupDefinitionJoin;
  DataTableColumnGroupDefinitionJoinCondition: DataTableColumnGroupDefinitionJoinCondition;
  DataTableColumnGroupDefinitionJoinDataTableColumnGroupDefinitionJoinPkeyConnect: DataTableColumnGroupDefinitionJoinDataTableColumnGroupDefinitionJoinPkeyConnect;
  DataTableColumnGroupDefinitionJoinFilter: DataTableColumnGroupDefinitionJoinFilter;
  DataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingDataTableColumnGroupDefinitionJoinPkeyUpdate: DataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingDataTableColumnGroupDefinitionJoinPkeyUpdate;
  DataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDataTableColumnGroupDefinitionJoinPkeyUpdate: DataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDataTableColumnGroupDefinitionJoinPkeyUpdate;
  DataTableColumnGroupDefinitionJoinsConnection: DataTableColumnGroupDefinitionJoinsConnection;
  DataTableColumnGroupDefinitionJoinsEdge: DataTableColumnGroupDefinitionJoinsEdge;
  DataTableColumnGroupDefinitionSource: DataTableColumnGroupDefinitionSource;
  DataTableColumnGroupDefinitionSourceCondition: DataTableColumnGroupDefinitionSourceCondition;
  DataTableColumnGroupDefinitionSourceDataTableColumnGroupDefinitionSourcesPkeyConnect: DataTableColumnGroupDefinitionSourceDataTableColumnGroupDefinitionSourcesPkeyConnect;
  DataTableColumnGroupDefinitionSourceFilter: DataTableColumnGroupDefinitionSourceFilter;
  DataTableColumnGroupDefinitionSourceOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingDataTableColumnGroupDefinitionSourcesPkeyUpdate: DataTableColumnGroupDefinitionSourceOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingDataTableColumnGroupDefinitionSourcesPkeyUpdate;
  DataTableColumnGroupDefinitionSourcesConnection: DataTableColumnGroupDefinitionSourcesConnection;
  DataTableColumnGroupDefinitionSourcesEdge: DataTableColumnGroupDefinitionSourcesEdge;
  DataTableColumnGroupFilter: DataTableColumnGroupFilter;
  DataTableColumnGroupIdAbcd4Ec0FkDataTablInput: DataTableColumnGroupIdAbcd4Ec0FkDataTablInput;
  DataTableColumnGroupIdAbcd4Ec0FkDataTablInverseInput: DataTableColumnGroupIdAbcd4Ec0FkDataTablInverseInput;
  DataTableColumnGroupOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnGroupPkeyUpdate: DataTableColumnGroupOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnGroupPkeyUpdate;
  DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDataTableColumnGroupPkeyUpdate: DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDataTableColumnGroupPkeyUpdate;
  DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingDataTableColumnGroupPkeyUpdate: DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingDataTableColumnGroupPkeyUpdate;
  DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdUsingDataTableColumnGroupPkeyUpdate: DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdUsingDataTableColumnGroupPkeyUpdate;
  DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingDataTableColumnGroupPkeyUpdate: DataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdUsingDataTableColumnGroupPkeyUpdate;
  DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInput: DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInput;
  DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput: DataTableColumnGroupProjectIdE5Cb2883FkProjectIdInverseInput;
  DataTableColumnGroupTableId46C58CccFkDataTableIdInput: DataTableColumnGroupTableId46C58CccFkDataTableIdInput;
  DataTableColumnGroupTableId46C58CccFkDataTableIdInverseInput: DataTableColumnGroupTableId46C58CccFkDataTableIdInverseInput;
  DataTableColumnGroupToManyDataTableColumnFilter: DataTableColumnGroupToManyDataTableColumnFilter;
  DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdApplicationUserCreateInput: DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdApplicationUserCreateInput;
  DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInput: DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInput;
  DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput: DataTableColumnGroupUserId0F35Bde1FkApplicationUserIdInverseInput;
  DataTableColumnGroupsConnection: DataTableColumnGroupsConnection;
  DataTableColumnGroupsEdge: DataTableColumnGroupsEdge;
  DataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableColumnOrderUniqueUpdate: DataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableColumnOrderUniqueUpdate;
  DataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableColumnPkeyUpdate: DataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdUsingDataTableColumnPkeyUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDataTableColumnOrderUniqueUpdate: DataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDataTableColumnOrderUniqueUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDataTableColumnPkeyUpdate: DataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDataTableColumnPkeyUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnOrderUniqueUpdate: DataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnOrderUniqueUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnPkeyUpdate: DataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablUsingDataTableColumnPkeyUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingDataTableColumnOrderUniqueUpdate: DataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingDataTableColumnOrderUniqueUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingDataTableColumnPkeyUpdate: DataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingDataTableColumnPkeyUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTableColumnOrderUniqueUpdate: DataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTableColumnOrderUniqueUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTableColumnPkeyUpdate: DataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTableColumnPkeyUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingDataTableColumnOrderUniqueUpdate: DataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingDataTableColumnOrderUniqueUpdate;
  DataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingDataTableColumnPkeyUpdate: DataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdUsingDataTableColumnPkeyUpdate;
  DataTableColumnProjectId91C18F88FkProjectIdInput: DataTableColumnProjectId91C18F88FkProjectIdInput;
  DataTableColumnProjectId91C18F88FkProjectIdInverseInput: DataTableColumnProjectId91C18F88FkProjectIdInverseInput;
  DataTableColumnTableIdF295C823FkDataTableIdInput: DataTableColumnTableIdF295C823FkDataTableIdInput;
  DataTableColumnTableIdF295C823FkDataTableIdInverseInput: DataTableColumnTableIdF295C823FkDataTableIdInverseInput;
  DataTableColumnToManyDataTableCellFilter: DataTableColumnToManyDataTableCellFilter;
  DataTableColumnUserId57054882FkApplicationUserIdApplicationUserCreateInput: DataTableColumnUserId57054882FkApplicationUserIdApplicationUserCreateInput;
  DataTableColumnUserId57054882FkApplicationUserIdInput: DataTableColumnUserId57054882FkApplicationUserIdInput;
  DataTableColumnUserId57054882FkApplicationUserIdInverseInput: DataTableColumnUserId57054882FkApplicationUserIdInverseInput;
  DataTableColumnsConnection: DataTableColumnsConnection;
  DataTableColumnsEdge: DataTableColumnsEdge;
  DataTableCondition: DataTableCondition;
  DataTableDataTablePkeyConnect: DataTableDataTablePkeyConnect;
  DataTableFilter: DataTableFilter;
  DataTableFolderId4Fe6C7FeFkProjectFolderIdInput: DataTableFolderId4Fe6C7FeFkProjectFolderIdInput;
  DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput: DataTableFolderId4Fe6C7FeFkProjectFolderIdInverseInput;
  DataTableFolderId4Fe6C7FeFkProjectFolderIdProjectFolderCreateInput: DataTableFolderId4Fe6C7FeFkProjectFolderIdProjectFolderCreateInput;
  DataTableOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTablePkeyUpdate: DataTableOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdUsingDataTablePkeyUpdate;
  DataTableOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTablePkeyUpdate: DataTableOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdUsingDataTablePkeyUpdate;
  DataTableOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdUsingDataTablePkeyUpdate: DataTableOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdUsingDataTablePkeyUpdate;
  DataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingDataTablePkeyUpdate: DataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingDataTablePkeyUpdate;
  DataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingDataTablePkeyUpdate: DataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingDataTablePkeyUpdate;
  DataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingDataTablePkeyUpdate: DataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdUsingDataTablePkeyUpdate;
  DataTableOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTablePkeyUpdate: DataTableOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTablePkeyUpdate;
  DataTableProjectId59F60EaeFkProjectIdInput: DataTableProjectId59F60EaeFkProjectIdInput;
  DataTableProjectId59F60EaeFkProjectIdInverseInput: DataTableProjectId59F60EaeFkProjectIdInverseInput;
  DataTableRow: DataTableRow;
  DataTableRowCondition: DataTableRowCondition;
  DataTableRowDataTableRowPkeyConnect: DataTableRowDataTableRowPkeyConnect;
  DataTableRowDataTableRowUniqueConnect: DataTableRowDataTableRowUniqueConnect;
  DataTableRowFilter: DataTableRowFilter;
  DataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableRowPkeyUpdate: DataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableRowPkeyUpdate;
  DataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableRowUniqueUpdate: DataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdUsingDataTableRowUniqueUpdate;
  DataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingDataTableRowPkeyUpdate: DataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingDataTableRowPkeyUpdate;
  DataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingDataTableRowUniqueUpdate: DataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingDataTableRowUniqueUpdate;
  DataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTableRowPkeyUpdate: DataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTableRowPkeyUpdate;
  DataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTableRowUniqueUpdate: DataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdUsingDataTableRowUniqueUpdate;
  DataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingDataTableRowPkeyUpdate: DataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingDataTableRowPkeyUpdate;
  DataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingDataTableRowUniqueUpdate: DataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdUsingDataTableRowUniqueUpdate;
  DataTableRowProjectId43Bf0Ab0FkProjectIdInput: DataTableRowProjectId43Bf0Ab0FkProjectIdInput;
  DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput: DataTableRowProjectId43Bf0Ab0FkProjectIdInverseInput;
  DataTableRowTableIdF77C2D36FkDataTableIdInput: DataTableRowTableIdF77C2D36FkDataTableIdInput;
  DataTableRowTableIdF77C2D36FkDataTableIdInverseInput: DataTableRowTableIdF77C2D36FkDataTableIdInverseInput;
  DataTableRowToManyDataTableCellFilter: DataTableRowToManyDataTableCellFilter;
  DataTableRowUserId3C5E98E5FkApplicationUserIdApplicationUserCreateInput: DataTableRowUserId3C5E98E5FkApplicationUserIdApplicationUserCreateInput;
  DataTableRowUserId3C5E98E5FkApplicationUserIdInput: DataTableRowUserId3C5E98E5FkApplicationUserIdInput;
  DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput: DataTableRowUserId3C5E98E5FkApplicationUserIdInverseInput;
  DataTableRowsConnection: DataTableRowsConnection;
  DataTableRowsEdge: DataTableRowsEdge;
  DataTableToManyDataTableCellFilter: DataTableToManyDataTableCellFilter;
  DataTableToManyDataTableColumnFilter: DataTableToManyDataTableColumnFilter;
  DataTableToManyDataTableColumnGroupFilter: DataTableToManyDataTableColumnGroupFilter;
  DataTableToManyDataTableRowFilter: DataTableToManyDataTableRowFilter;
  DataTableUserIdAb79B056FkApplicationUserIdApplicationUserCreateInput: DataTableUserIdAb79B056FkApplicationUserIdApplicationUserCreateInput;
  DataTableUserIdAb79B056FkApplicationUserIdInput: DataTableUserIdAb79B056FkApplicationUserIdInput;
  DataTableUserIdAb79B056FkApplicationUserIdInverseInput: DataTableUserIdAb79B056FkApplicationUserIdInverseInput;
  DataTablesConnection: DataTablesConnection;
  DataTablesEdge: DataTablesEdge;
  Date: Scalars["Date"]["output"];
  DateFilter: DateFilter;
  Datetime: Scalars["Datetime"]["output"];
  DatetimeFilter: DatetimeFilter;
  DeleteApplicationUserByEmailInput: DeleteApplicationUserByEmailInput;
  DeleteApplicationUserByGlobalUserIdInput: DeleteApplicationUserByGlobalUserIdInput;
  DeleteApplicationUserByIdInput: DeleteApplicationUserByIdInput;
  DeleteApplicationUserByUsernameInput: DeleteApplicationUserByUsernameInput;
  DeleteApplicationUserGroupByIdInput: DeleteApplicationUserGroupByIdInput;
  DeleteApplicationUserGroupByUserIdAndGroupIdInput: DeleteApplicationUserGroupByUserIdAndGroupIdInput;
  DeleteApplicationUserGroupPayload: DeleteApplicationUserGroupPayload;
  DeleteApplicationUserMembershipByIdInput: DeleteApplicationUserMembershipByIdInput;
  DeleteApplicationUserMembershipByUserIdAndTenantIdInput: DeleteApplicationUserMembershipByUserIdAndTenantIdInput;
  DeleteApplicationUserMembershipPayload: DeleteApplicationUserMembershipPayload;
  DeleteApplicationUserMetadatumByIdInput: DeleteApplicationUserMetadatumByIdInput;
  DeleteApplicationUserMetadatumByUserIdAndKeyInput: DeleteApplicationUserMetadatumByUserIdAndKeyInput;
  DeleteApplicationUserMetadatumPayload: DeleteApplicationUserMetadatumPayload;
  DeleteApplicationUserPayload: DeleteApplicationUserPayload;
  DeleteApplicationUserSessionByIdInput: DeleteApplicationUserSessionByIdInput;
  DeleteApplicationUserSessionPayload: DeleteApplicationUserSessionPayload;
  DeleteApplicationUserUserPermissionByIdInput: DeleteApplicationUserUserPermissionByIdInput;
  DeleteApplicationUserUserPermissionByUserIdAndPermissionIdInput: DeleteApplicationUserUserPermissionByUserIdAndPermissionIdInput;
  DeleteApplicationUserUserPermissionPayload: DeleteApplicationUserUserPermissionPayload;
  DeleteAuditlogLogentryByIdInput: DeleteAuditlogLogentryByIdInput;
  DeleteAuditlogLogentryPayload: DeleteAuditlogLogentryPayload;
  DeleteAuthGroupByIdInput: DeleteAuthGroupByIdInput;
  DeleteAuthGroupByNameInput: DeleteAuthGroupByNameInput;
  DeleteAuthGroupPayload: DeleteAuthGroupPayload;
  DeleteAuthGroupPermissionByGroupIdAndPermissionIdInput: DeleteAuthGroupPermissionByGroupIdAndPermissionIdInput;
  DeleteAuthGroupPermissionByIdInput: DeleteAuthGroupPermissionByIdInput;
  DeleteAuthGroupPermissionPayload: DeleteAuthGroupPermissionPayload;
  DeleteAuthPermissionByContentTypeIdAndCodenameInput: DeleteAuthPermissionByContentTypeIdAndCodenameInput;
  DeleteAuthPermissionByIdInput: DeleteAuthPermissionByIdInput;
  DeleteAuthPermissionPayload: DeleteAuthPermissionPayload;
  DeleteAvatarByIdInput: DeleteAvatarByIdInput;
  DeleteAvatarByUserIdInput: DeleteAvatarByUserIdInput;
  DeleteAvatarPayload: DeleteAvatarPayload;
  DeleteAwsBatchTaskByTaskexecutorPtrIdInput: DeleteAwsBatchTaskByTaskexecutorPtrIdInput;
  DeleteAwsBatchTaskPayload: DeleteAwsBatchTaskPayload;
  DeleteAwsCognitoUserByUserexecutorPtrIdInput: DeleteAwsCognitoUserByUserexecutorPtrIdInput;
  DeleteAwsCognitoUserPayload: DeleteAwsCognitoUserPayload;
  DeleteAwsEcrImageByContainerimageexecutorPtrIdInput: DeleteAwsEcrImageByContainerimageexecutorPtrIdInput;
  DeleteAwsEcrImagePayload: DeleteAwsEcrImagePayload;
  DeleteAwsMockBatchTaskByAwstaskexecutorPtrIdInput: DeleteAwsMockBatchTaskByAwstaskexecutorPtrIdInput;
  DeleteAwsMockBatchTaskPayload: DeleteAwsMockBatchTaskPayload;
  DeleteAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdInput: DeleteAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdInput;
  DeleteAwsMockDistributionImagePayload: DeleteAwsMockDistributionImagePayload;
  DeleteAwsMockEcrImageByAwscontainerimageexecutorPtrIdInput: DeleteAwsMockEcrImageByAwscontainerimageexecutorPtrIdInput;
  DeleteAwsMockEcrImagePayload: DeleteAwsMockEcrImagePayload;
  DeleteAwsMockIamUserByAwsuserexecutorPtrIdInput: DeleteAwsMockIamUserByAwsuserexecutorPtrIdInput;
  DeleteAwsMockIamUserPayload: DeleteAwsMockIamUserPayload;
  DeleteAwsMockS3FileByAwsfileexecutorPtrIdInput: DeleteAwsMockS3FileByAwsfileexecutorPtrIdInput;
  DeleteAwsMockS3FilePayload: DeleteAwsMockS3FilePayload;
  DeleteAwsS3FileByFileexecutorPtrIdInput: DeleteAwsS3FileByFileexecutorPtrIdInput;
  DeleteAwsS3FilePayload: DeleteAwsS3FilePayload;
  DeleteCodeFileByIdInput: DeleteCodeFileByIdInput;
  DeleteCodeFilePayload: DeleteCodeFilePayload;
  DeleteCommandByIdInput: DeleteCommandByIdInput;
  DeleteCommandByToolVersionIdAndCodeFileIdInput: DeleteCommandByToolVersionIdAndCodeFileIdInput;
  DeleteCommandByToolVersionIdInput: DeleteCommandByToolVersionIdInput;
  DeleteCommandPayload: DeleteCommandPayload;
  DeleteContainerImageByExecutorIdInput: DeleteContainerImageByExecutorIdInput;
  DeleteContainerImageByIdInput: DeleteContainerImageByIdInput;
  DeleteContainerImagePayload: DeleteContainerImagePayload;
  DeleteContainerImageRepositoryByIdInput: DeleteContainerImageRepositoryByIdInput;
  DeleteContainerImageRepositoryByNameAndTenantIdAndRegistryTypeInput: DeleteContainerImageRepositoryByNameAndTenantIdAndRegistryTypeInput;
  DeleteContainerImageRepositoryByRepositoryInput: DeleteContainerImageRepositoryByRepositoryInput;
  DeleteContainerImageRepositoryPayload: DeleteContainerImageRepositoryPayload;
  DeleteCostByIdInput: DeleteCostByIdInput;
  DeleteCostPayload: DeleteCostPayload;
  DeleteDistributionRegistryImageByContainerimageexecutorPtrIdInput: DeleteDistributionRegistryImageByContainerimageexecutorPtrIdInput;
  DeleteDistributionRegistryImagePayload: DeleteDistributionRegistryImagePayload;
  DeleteDjangoAdminLogByIdInput: DeleteDjangoAdminLogByIdInput;
  DeleteDjangoAdminLogPayload: DeleteDjangoAdminLogPayload;
  DeleteDjangoContentTypeByAppLabelAndModelInput: DeleteDjangoContentTypeByAppLabelAndModelInput;
  DeleteDjangoContentTypeByIdInput: DeleteDjangoContentTypeByIdInput;
  DeleteDjangoContentTypePayload: DeleteDjangoContentTypePayload;
  DeleteDjangoMigrationByIdInput: DeleteDjangoMigrationByIdInput;
  DeleteDjangoMigrationPayload: DeleteDjangoMigrationPayload;
  DeleteDjangoSesBlacklistedemailByEmailInput: DeleteDjangoSesBlacklistedemailByEmailInput;
  DeleteDjangoSesBlacklistedemailByIdInput: DeleteDjangoSesBlacklistedemailByIdInput;
  DeleteDjangoSesBlacklistedemailPayload: DeleteDjangoSesBlacklistedemailPayload;
  DeleteDjangoSesSesstatByDateInput: DeleteDjangoSesSesstatByDateInput;
  DeleteDjangoSesSesstatByIdInput: DeleteDjangoSesSesstatByIdInput;
  DeleteDjangoSesSesstatPayload: DeleteDjangoSesSesstatPayload;
  DeleteDjangoSessionBySessionKeyInput: DeleteDjangoSessionBySessionKeyInput;
  DeleteDjangoSessionPayload: DeleteDjangoSessionPayload;
  DeleteDrsFileexecutorByIdInput: DeleteDrsFileexecutorByIdInput;
  DeleteDrsFileexecutorPayload: DeleteDrsFileexecutorPayload;
  DeleteDrsMockfileexecutorByFileexecutorPtrIdInput: DeleteDrsMockfileexecutorByFileexecutorPtrIdInput;
  DeleteDrsMockfileexecutorPayload: DeleteDrsMockfileexecutorPayload;
  DeleteEulaVersionByIdInput: DeleteEulaVersionByIdInput;
  DeleteEulaVersionByVersionInput: DeleteEulaVersionByVersionInput;
  DeleteEulaVersionPayload: DeleteEulaVersionPayload;
  DeleteEulaVersionUserAcceptanceByIdInput: DeleteEulaVersionUserAcceptanceByIdInput;
  DeleteEulaVersionUserAcceptanceByUserIdAndEulaVersionIdInput: DeleteEulaVersionUserAcceptanceByUserIdAndEulaVersionIdInput;
  DeleteEulaVersionUserAcceptancePayload: DeleteEulaVersionUserAcceptancePayload;
  DeleteFeatureFlagByIdInput: DeleteFeatureFlagByIdInput;
  DeleteFeatureFlagByNameInput: DeleteFeatureFlagByNameInput;
  DeleteFeatureFlagPayload: DeleteFeatureFlagPayload;
  DeleteFeatureFlagsGroupByFeatureflagIdAndGroupIdInput: DeleteFeatureFlagsGroupByFeatureflagIdAndGroupIdInput;
  DeleteFeatureFlagsGroupByIdInput: DeleteFeatureFlagsGroupByIdInput;
  DeleteFeatureFlagsGroupPayload: DeleteFeatureFlagsGroupPayload;
  DeleteFeatureFlagsTenantByFeatureflagIdAndTenantIdInput: DeleteFeatureFlagsTenantByFeatureflagIdAndTenantIdInput;
  DeleteFeatureFlagsTenantByIdInput: DeleteFeatureFlagsTenantByIdInput;
  DeleteFeatureFlagsTenantPayload: DeleteFeatureFlagsTenantPayload;
  DeleteFeatureFlagsUserByFeatureflagIdAndUserIdInput: DeleteFeatureFlagsUserByFeatureflagIdAndUserIdInput;
  DeleteFeatureFlagsUserByIdInput: DeleteFeatureFlagsUserByIdInput;
  DeleteFeatureFlagsUserPayload: DeleteFeatureFlagsUserPayload;
  DeleteFileActivityByIdInput: DeleteFileActivityByIdInput;
  DeleteFileActivityPayload: DeleteFileActivityPayload;
  DeleteFileByIdInput: DeleteFileByIdInput;
  DeleteFileByProjectIdAndReferenceIdInput: DeleteFileByProjectIdAndReferenceIdInput;
  DeleteFileMetadatumByIdInput: DeleteFileMetadatumByIdInput;
  DeleteFileMetadatumPayload: DeleteFileMetadatumPayload;
  DeleteFileOutputGroupByIdInput: DeleteFileOutputGroupByIdInput;
  DeleteFileOutputGroupByTaskIdInput: DeleteFileOutputGroupByTaskIdInput;
  DeleteFileOutputGroupMetadatumByIdInput: DeleteFileOutputGroupMetadatumByIdInput;
  DeleteFileOutputGroupMetadatumPayload: DeleteFileOutputGroupMetadatumPayload;
  DeleteFileOutputGroupPayload: DeleteFileOutputGroupPayload;
  DeleteFilePayload: DeleteFilePayload;
  DeleteMetadataValueByIdInput: DeleteMetadataValueByIdInput;
  DeleteMetadataValuePayload: DeleteMetadataValuePayload;
  DeleteMetadatumByIdInput: DeleteMetadatumByIdInput;
  DeleteMetadatumPayload: DeleteMetadatumPayload;
  DeleteOutputGroupFileByIdInput: DeleteOutputGroupFileByIdInput;
  DeleteOutputGroupFilePayload: DeleteOutputGroupFilePayload;
  DeletePinnedToolByIdInput: DeletePinnedToolByIdInput;
  DeletePinnedToolByUserIdAndToolIdInput: DeletePinnedToolByUserIdAndToolIdInput;
  DeletePinnedToolPayload: DeletePinnedToolPayload;
  DeleteProjectFolderByIdInput: DeleteProjectFolderByIdInput;
  DeleteProjectFolderPayload: DeleteProjectFolderPayload;
  DeleteProjectTagByIdInput: DeleteProjectTagByIdInput;
  DeleteProjectTagPayload: DeleteProjectTagPayload;
  DeleteRunByIdInput: DeleteRunByIdInput;
  DeleteRunPayload: DeleteRunPayload;
  DeleteSessionInput: DeleteSessionInput;
  DeleteSessionPayload: DeleteSessionPayload;
  DeleteTaskActivityByIdInput: DeleteTaskActivityByIdInput;
  DeleteTaskActivityByTaskIdInput: DeleteTaskActivityByTaskIdInput;
  DeleteTaskActivityPayload: DeleteTaskActivityPayload;
  DeleteTaskByExecutorIdInput: DeleteTaskByExecutorIdInput;
  DeleteTaskByIdInput: DeleteTaskByIdInput;
  DeleteTaskPayload: DeleteTaskPayload;
  DeleteTaskResourceByIdInput: DeleteTaskResourceByIdInput;
  DeleteTaskResourcePayload: DeleteTaskResourcePayload;
  DeleteTaskResourceUsageByIdInput: DeleteTaskResourceUsageByIdInput;
  DeleteTaskResourceUsageByTaskIdInput: DeleteTaskResourceUsageByTaskIdInput;
  DeleteTaskResourceUsagePayload: DeleteTaskResourceUsagePayload;
  DeleteTaskSourceByIdInput: DeleteTaskSourceByIdInput;
  DeleteTaskSourcePayload: DeleteTaskSourcePayload;
  DeleteTaskStatusLogByIdInput: DeleteTaskStatusLogByIdInput;
  DeleteTaskStatusLogByTaskIdAndStatusInput: DeleteTaskStatusLogByTaskIdAndStatusInput;
  DeleteTaskStatusLogPayload: DeleteTaskStatusLogPayload;
  DeleteTenantByIdInput: DeleteTenantByIdInput;
  DeleteTenantByKeyInput: DeleteTenantByKeyInput;
  DeleteTenantByRepositoryNameInput: DeleteTenantByRepositoryNameInput;
  DeleteTenantBySfidInput: DeleteTenantBySfidInput;
  DeleteTenantContractAllowanceByIdInput: DeleteTenantContractAllowanceByIdInput;
  DeleteTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeInput: DeleteTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeInput;
  DeleteTenantContractAllowancePayload: DeleteTenantContractAllowancePayload;
  DeleteTenantContractByIdInput: DeleteTenantContractByIdInput;
  DeleteTenantContractByNameInput: DeleteTenantContractByNameInput;
  DeleteTenantContractBySfidInput: DeleteTenantContractBySfidInput;
  DeleteTenantContractPayload: DeleteTenantContractPayload;
  DeleteTenantContractTransactionByIdInput: DeleteTenantContractTransactionByIdInput;
  DeleteTenantContractTransactionPayload: DeleteTenantContractTransactionPayload;
  DeleteTenantMockuserexecutorByUserexecutorPtrIdInput: DeleteTenantMockuserexecutorByUserexecutorPtrIdInput;
  DeleteTenantMockuserexecutorPayload: DeleteTenantMockuserexecutorPayload;
  DeleteTenantMonthlyConsumedResourceByIdInput: DeleteTenantMonthlyConsumedResourceByIdInput;
  DeleteTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractInput: DeleteTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractInput;
  DeleteTenantMonthlyConsumedResourcePayload: DeleteTenantMonthlyConsumedResourcePayload;
  DeleteTenantPayload: DeleteTenantPayload;
  DeleteTenantUserexecutorByIdInput: DeleteTenantUserexecutorByIdInput;
  DeleteTenantUserexecutorPayload: DeleteTenantUserexecutorPayload;
  DeleteTesContainerimageexecutorByIdInput: DeleteTesContainerimageexecutorByIdInput;
  DeleteTesContainerimageexecutorPayload: DeleteTesContainerimageexecutorPayload;
  DeleteTesMockcontainerimageexecutorByContainerimageexecutorPtrIdInput: DeleteTesMockcontainerimageexecutorByContainerimageexecutorPtrIdInput;
  DeleteTesMockcontainerimageexecutorPayload: DeleteTesMockcontainerimageexecutorPayload;
  DeleteTesMocktaskexecutorByTaskexecutorPtrIdInput: DeleteTesMocktaskexecutorByTaskexecutorPtrIdInput;
  DeleteTesMocktaskexecutorPayload: DeleteTesMocktaskexecutorPayload;
  DeleteTesTaskexecutorByIdInput: DeleteTesTaskexecutorByIdInput;
  DeleteTesTaskexecutorPayload: DeleteTesTaskexecutorPayload;
  DeleteToolByIdInput: DeleteToolByIdInput;
  DeleteToolByProjectIdInput: DeleteToolByProjectIdInput;
  DeleteToolParameterByIdInput: DeleteToolParameterByIdInput;
  DeleteToolParameterPayload: DeleteToolParameterPayload;
  DeleteToolPayload: DeleteToolPayload;
  DeleteToolResourceByIdInput: DeleteToolResourceByIdInput;
  DeleteToolResourceByTypeAndToolVersionIdInput: DeleteToolResourceByTypeAndToolVersionIdInput;
  DeleteToolResourcePayload: DeleteToolResourcePayload;
  DeleteToolResultByIdInput: DeleteToolResultByIdInput;
  DeleteToolResultPayload: DeleteToolResultPayload;
  DeleteToolSecretByIdInput: DeleteToolSecretByIdInput;
  DeleteToolSecretPayload: DeleteToolSecretPayload;
  DeleteToolSourceByIdInput: DeleteToolSourceByIdInput;
  DeleteToolSourcePayload: DeleteToolSourcePayload;
  DeleteToolTenantByIdInput: DeleteToolTenantByIdInput;
  DeleteToolTenantByToolIdAndTenantIdInput: DeleteToolTenantByToolIdAndTenantIdInput;
  DeleteToolTenantPayload: DeleteToolTenantPayload;
  DeleteToolVersionByIdInput: DeleteToolVersionByIdInput;
  DeleteToolVersionPayload: DeleteToolVersionPayload;
  DeleteToolboxByIdInput: DeleteToolboxByIdInput;
  DeleteToolboxByKeyInput: DeleteToolboxByKeyInput;
  DeleteToolboxPayload: DeleteToolboxPayload;
  DeleteToolboxTenantByIdInput: DeleteToolboxTenantByIdInput;
  DeleteToolboxTenantByToolboxIdAndTenantIdInput: DeleteToolboxTenantByToolboxIdAndTenantIdInput;
  DeleteToolboxTenantPayload: DeleteToolboxTenantPayload;
  DeleteUserPersonalSpaceRequestByIdInput: DeleteUserPersonalSpaceRequestByIdInput;
  DeleteUserPersonalSpaceRequestPayload: DeleteUserPersonalSpaceRequestPayload;
  DeleteWaffleFlagByIdInput: DeleteWaffleFlagByIdInput;
  DeleteWaffleFlagByNameInput: DeleteWaffleFlagByNameInput;
  DeleteWaffleFlagPayload: DeleteWaffleFlagPayload;
  DeleteWaffleSampleByIdInput: DeleteWaffleSampleByIdInput;
  DeleteWaffleSampleByNameInput: DeleteWaffleSampleByNameInput;
  DeleteWaffleSamplePayload: DeleteWaffleSamplePayload;
  DeleteWaffleSwitchByIdInput: DeleteWaffleSwitchByIdInput;
  DeleteWaffleSwitchByNameInput: DeleteWaffleSwitchByNameInput;
  DeleteWaffleSwitchPayload: DeleteWaffleSwitchPayload;
  DeleteWorkflowByIdInput: DeleteWorkflowByIdInput;
  DeleteWorkflowDatumByIdInput: DeleteWorkflowDatumByIdInput;
  DeleteWorkflowDatumPayload: DeleteWorkflowDatumPayload;
  DeleteWorkflowPayload: DeleteWorkflowPayload;
  DeleteWorkflowResultByIdInput: DeleteWorkflowResultByIdInput;
  DeleteWorkflowResultPayload: DeleteWorkflowResultPayload;
  DeleteWorkflowResultWorkflowVersionByIdInput: DeleteWorkflowResultWorkflowVersionByIdInput;
  DeleteWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdInput: DeleteWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdInput;
  DeleteWorkflowResultWorkflowVersionPayload: DeleteWorkflowResultWorkflowVersionPayload;
  DeleteWorkflowSectionBlockByIdInput: DeleteWorkflowSectionBlockByIdInput;
  DeleteWorkflowSectionBlockPayload: DeleteWorkflowSectionBlockPayload;
  DeleteWorkflowSectionBlockSectionByBlockIdAndSectionIdInput: DeleteWorkflowSectionBlockSectionByBlockIdAndSectionIdInput;
  DeleteWorkflowSectionBlockSectionByIdInput: DeleteWorkflowSectionBlockSectionByIdInput;
  DeleteWorkflowSectionBlockSectionPayload: DeleteWorkflowSectionBlockSectionPayload;
  DeleteWorkflowSectionByIdInput: DeleteWorkflowSectionByIdInput;
  DeleteWorkflowSectionPayload: DeleteWorkflowSectionPayload;
  DeleteWorkflowSectionWorkflowVersionByIdInput: DeleteWorkflowSectionWorkflowVersionByIdInput;
  DeleteWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdInput: DeleteWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdInput;
  DeleteWorkflowSectionWorkflowVersionPayload: DeleteWorkflowSectionWorkflowVersionPayload;
  DeleteWorkflowSourceByIdInput: DeleteWorkflowSourceByIdInput;
  DeleteWorkflowSourcePayload: DeleteWorkflowSourcePayload;
  DeleteWorkflowSourceWorkflowVersionByIdInput: DeleteWorkflowSourceWorkflowVersionByIdInput;
  DeleteWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdInput: DeleteWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdInput;
  DeleteWorkflowSourceWorkflowVersionPayload: DeleteWorkflowSourceWorkflowVersionPayload;
  DeleteWorkflowVersionByIdInput: DeleteWorkflowVersionByIdInput;
  DeleteWorkflowVersionPayload: DeleteWorkflowVersionPayload;
  DistributionRegistrContainerimageexecut830E7Af5FkTesContaDistributionRegistryImageCreateInput: DistributionRegistrContainerimageexecut830E7Af5FkTesContaDistributionRegistryImageCreateInput;
  DistributionRegistrContainerimageexecut830E7Af5FkTesContaInput: DistributionRegistrContainerimageexecut830E7Af5FkTesContaInput;
  DistributionRegistrContainerimageexecut830E7Af5FkTesContaInverseInput: DistributionRegistrContainerimageexecut830E7Af5FkTesContaInverseInput;
  DistributionRegistrContainerimageexecut830E7Af5FkTesContaTesContainerimageexecutorCreateInput: DistributionRegistrContainerimageexecut830E7Af5FkTesContaTesContainerimageexecutorCreateInput;
  DistributionRegistryImage: DistributionRegistryImage;
  DistributionRegistryImageCondition: DistributionRegistryImageCondition;
  DistributionRegistryImageDistributionRegistryImagePkeyConnect: DistributionRegistryImageDistributionRegistryImagePkeyConnect;
  DistributionRegistryImageDistributionRegistryImagePkeyDelete: DistributionRegistryImageDistributionRegistryImagePkeyDelete;
  DistributionRegistryImageFilter: DistributionRegistryImageFilter;
  DistributionRegistryImageInput: DistributionRegistryImageInput;
  DistributionRegistryImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributUsingDistributionRegistryImagePkeyUpdate: DistributionRegistryImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributUsingDistributionRegistryImagePkeyUpdate;
  DistributionRegistryImageOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaUsingDistributionRegistryImagePkeyUpdate: DistributionRegistryImageOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaUsingDistributionRegistryImagePkeyUpdate;
  DistributionRegistryImagePatch: DistributionRegistryImagePatch;
  DistributionRegistryImagesConnection: DistributionRegistryImagesConnection;
  DistributionRegistryImagesEdge: DistributionRegistryImagesEdge;
  DjangoAdminLog: DjangoAdminLog;
  DjangoAdminLogCondition: DjangoAdminLogCondition;
  DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoDjangoAdminLogCreateInput: DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoDjangoAdminLogCreateInput;
  DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoDjangoContentTypeCreateInput: DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoDjangoContentTypeCreateInput;
  DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInput: DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInput;
  DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput: DjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoInverseInput;
  DjangoAdminLogDjangoAdminLogPkeyConnect: DjangoAdminLogDjangoAdminLogPkeyConnect;
  DjangoAdminLogDjangoAdminLogPkeyDelete: DjangoAdminLogDjangoAdminLogPkeyDelete;
  DjangoAdminLogFilter: DjangoAdminLogFilter;
  DjangoAdminLogInput: DjangoAdminLogInput;
  DjangoAdminLogOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoAdminLogPkeyUpdate: DjangoAdminLogOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoAdminLogPkeyUpdate;
  DjangoAdminLogOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingDjangoAdminLogPkeyUpdate: DjangoAdminLogOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdUsingDjangoAdminLogPkeyUpdate;
  DjangoAdminLogPatch: DjangoAdminLogPatch;
  DjangoAdminLogUserIdC564Eba6FkApplicationUserIdApplicationUserCreateInput: DjangoAdminLogUserIdC564Eba6FkApplicationUserIdApplicationUserCreateInput;
  DjangoAdminLogUserIdC564Eba6FkApplicationUserIdDjangoAdminLogCreateInput: DjangoAdminLogUserIdC564Eba6FkApplicationUserIdDjangoAdminLogCreateInput;
  DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInput: DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInput;
  DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput: DjangoAdminLogUserIdC564Eba6FkApplicationUserIdInverseInput;
  DjangoAdminLogsConnection: DjangoAdminLogsConnection;
  DjangoAdminLogsEdge: DjangoAdminLogsEdge;
  DjangoContentType: DjangoContentType;
  DjangoContentTypeCondition: DjangoContentTypeCondition;
  DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect: DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqConnect;
  DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete: DjangoContentTypeDjangoContentTypeAppLabelModel76Bd3D3BUniqDelete;
  DjangoContentTypeDjangoContentTypePkeyConnect: DjangoContentTypeDjangoContentTypePkeyConnect;
  DjangoContentTypeDjangoContentTypePkeyDelete: DjangoContentTypeDjangoContentTypePkeyDelete;
  DjangoContentTypeFilter: DjangoContentTypeFilter;
  DjangoContentTypeInput: DjangoContentTypeInput;
  DjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIE4E5D06AFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIE4E5D06AFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate: DjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingDjangoContentTypeAppLabelModel76Bd3D3BUniqUpdate;
  DjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingDjangoContentTypePkeyUpdate: DjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingDjangoContentTypePkeyUpdate;
  DjangoContentTypePatch: DjangoContentTypePatch;
  DjangoContentTypeToManyAuditlogLogentryFilter: DjangoContentTypeToManyAuditlogLogentryFilter;
  DjangoContentTypeToManyAuthPermissionFilter: DjangoContentTypeToManyAuthPermissionFilter;
  DjangoContentTypeToManyDataTableColumnDefinitionCellStatusFilter: DjangoContentTypeToManyDataTableColumnDefinitionCellStatusFilter;
  DjangoContentTypeToManyDataTableColumnDefinitionIdentifierFilter: DjangoContentTypeToManyDataTableColumnDefinitionIdentifierFilter;
  DjangoContentTypeToManyDataTableColumnDefinitionJoinFilter: DjangoContentTypeToManyDataTableColumnDefinitionJoinFilter;
  DjangoContentTypeToManyDataTableColumnDefinitionMetadatumFilter: DjangoContentTypeToManyDataTableColumnDefinitionMetadatumFilter;
  DjangoContentTypeToManyDataTableColumnDefinitionRoiFrameFilter: DjangoContentTypeToManyDataTableColumnDefinitionRoiFrameFilter;
  DjangoContentTypeToManyDataTableColumnFilter: DjangoContentTypeToManyDataTableColumnFilter;
  DjangoContentTypeToManyDataTableColumnGroupDefinitionJoinFilter: DjangoContentTypeToManyDataTableColumnGroupDefinitionJoinFilter;
  DjangoContentTypeToManyDataTableColumnGroupFilter: DjangoContentTypeToManyDataTableColumnGroupFilter;
  DjangoContentTypeToManyDjangoAdminLogFilter: DjangoContentTypeToManyDjangoAdminLogFilter;
  DjangoContentTypeToManyDrsFileexecutorFilter: DjangoContentTypeToManyDrsFileexecutorFilter;
  DjangoContentTypeToManyFileActivityFilter: DjangoContentTypeToManyFileActivityFilter;
  DjangoContentTypeToManyGdtAnalysisTableColumnFilter: DjangoContentTypeToManyGdtAnalysisTableColumnFilter;
  DjangoContentTypeToManyGdtAnalysisTableColumnGroupFilter: DjangoContentTypeToManyGdtAnalysisTableColumnGroupFilter;
  DjangoContentTypeToManyTenantUserexecutorFilter: DjangoContentTypeToManyTenantUserexecutorFilter;
  DjangoContentTypeToManyTesContainerimageexecutorFilter: DjangoContentTypeToManyTesContainerimageexecutorFilter;
  DjangoContentTypeToManyTesTaskexecutorFilter: DjangoContentTypeToManyTesTaskexecutorFilter;
  DjangoContentTypesConnection: DjangoContentTypesConnection;
  DjangoContentTypesEdge: DjangoContentTypesEdge;
  DjangoMigration: DjangoMigration;
  DjangoMigrationCondition: DjangoMigrationCondition;
  DjangoMigrationFilter: DjangoMigrationFilter;
  DjangoMigrationInput: DjangoMigrationInput;
  DjangoMigrationPatch: DjangoMigrationPatch;
  DjangoMigrationsConnection: DjangoMigrationsConnection;
  DjangoMigrationsEdge: DjangoMigrationsEdge;
  DjangoSesBlacklistedemail: DjangoSesBlacklistedemail;
  DjangoSesBlacklistedemailCondition: DjangoSesBlacklistedemailCondition;
  DjangoSesBlacklistedemailFilter: DjangoSesBlacklistedemailFilter;
  DjangoSesBlacklistedemailInput: DjangoSesBlacklistedemailInput;
  DjangoSesBlacklistedemailPatch: DjangoSesBlacklistedemailPatch;
  DjangoSesBlacklistedemailsConnection: DjangoSesBlacklistedemailsConnection;
  DjangoSesBlacklistedemailsEdge: DjangoSesBlacklistedemailsEdge;
  DjangoSesSesstat: DjangoSesSesstat;
  DjangoSesSesstatCondition: DjangoSesSesstatCondition;
  DjangoSesSesstatFilter: DjangoSesSesstatFilter;
  DjangoSesSesstatInput: DjangoSesSesstatInput;
  DjangoSesSesstatPatch: DjangoSesSesstatPatch;
  DjangoSesSesstatsConnection: DjangoSesSesstatsConnection;
  DjangoSesSesstatsEdge: DjangoSesSesstatsEdge;
  DjangoSession: DjangoSession;
  DjangoSessionCondition: DjangoSessionCondition;
  DjangoSessionFilter: DjangoSessionFilter;
  DjangoSessionInput: DjangoSessionInput;
  DjangoSessionPatch: DjangoSessionPatch;
  DjangoSessionsConnection: DjangoSessionsConnection;
  DjangoSessionsEdge: DjangoSessionsEdge;
  DrsFileexecutor: DrsFileexecutor;
  DrsFileexecutorCondition: DrsFileexecutorCondition;
  DrsFileexecutorDrsFileexecutorPkeyConnect: DrsFileexecutorDrsFileexecutorPkeyConnect;
  DrsFileexecutorDrsFileexecutorPkeyDelete: DrsFileexecutorDrsFileexecutorPkeyDelete;
  DrsFileexecutorFilter: DrsFileexecutorFilter;
  DrsFileexecutorInput: DrsFileexecutorInput;
  DrsFileexecutorOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdUsingDrsFileexecutorPkeyUpdate: DrsFileexecutorOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdUsingDrsFileexecutorPkeyUpdate;
  DrsFileexecutorOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdUsingDrsFileexecutorPkeyUpdate: DrsFileexecutorOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdUsingDrsFileexecutorPkeyUpdate;
  DrsFileexecutorOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDrsFileexecutorPkeyUpdate: DrsFileexecutorOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoUsingDrsFileexecutorPkeyUpdate;
  DrsFileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeUsingDrsFileexecutorPkeyUpdate: DrsFileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeUsingDrsFileexecutorPkeyUpdate;
  DrsFileexecutorPatch: DrsFileexecutorPatch;
  DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoDjangoContentTypeCreateInput: DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoDjangoContentTypeCreateInput;
  DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoDrsFileexecutorCreateInput: DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoDrsFileexecutorCreateInput;
  DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInput: DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInput;
  DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput: DrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoInverseInput;
  DrsFileexecutorToManyCodeFileFilter: DrsFileexecutorToManyCodeFileFilter;
  DrsFileexecutorsConnection: DrsFileexecutorsConnection;
  DrsFileexecutorsEdge: DrsFileexecutorsEdge;
  DrsMockfileexecutor: DrsMockfileexecutor;
  DrsMockfileexecutorCondition: DrsMockfileexecutorCondition;
  DrsMockfileexecutorDrsMockfileexecutorPkeyConnect: DrsMockfileexecutorDrsMockfileexecutorPkeyConnect;
  DrsMockfileexecutorDrsMockfileexecutorPkeyDelete: DrsMockfileexecutorDrsMockfileexecutorPkeyDelete;
  DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeDrsFileexecutorCreateInput: DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeDrsFileexecutorCreateInput;
  DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeDrsMockfileexecutorCreateInput: DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeDrsMockfileexecutorCreateInput;
  DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInput: DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInput;
  DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInverseInput: DrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeInverseInput;
  DrsMockfileexecutorFilter: DrsMockfileexecutorFilter;
  DrsMockfileexecutorInput: DrsMockfileexecutorInput;
  DrsMockfileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeUsingDrsMockfileexecutorPkeyUpdate: DrsMockfileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileeUsingDrsMockfileexecutorPkeyUpdate;
  DrsMockfileexecutorPatch: DrsMockfileexecutorPatch;
  DrsMockfileexecutorsConnection: DrsMockfileexecutorsConnection;
  DrsMockfileexecutorsEdge: DrsMockfileexecutorsEdge;
  EulaVersion: EulaVersion;
  EulaVersionCondition: EulaVersionCondition;
  EulaVersionEulaVersionPkeyConnect: EulaVersionEulaVersionPkeyConnect;
  EulaVersionEulaVersionPkeyDelete: EulaVersionEulaVersionPkeyDelete;
  EulaVersionEulaVersionVersionKeyConnect: EulaVersionEulaVersionVersionKeyConnect;
  EulaVersionEulaVersionVersionKeyDelete: EulaVersionEulaVersionVersionKeyDelete;
  EulaVersionFilter: EulaVersionFilter;
  EulaVersionInput: EulaVersionInput;
  EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionPkeyUpdate: EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionPkeyUpdate;
  EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionVersionKeyUpdate: EulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionVersionKeyUpdate;
  EulaVersionPatch: EulaVersionPatch;
  EulaVersionToManyEulaVersionUserAcceptanceFilter: EulaVersionToManyEulaVersionUserAcceptanceFilter;
  EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionCreateInput: EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionCreateInput;
  EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionUserAcceptanceCreateInput: EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersEulaVersionUserAcceptanceCreateInput;
  EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput: EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInput;
  EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInverseInput: EulaVersionUserAcEulaVersionIdD2635C45FkEulaVersInverseInput;
  EulaVersionUserAcUserIdB72Ed9C5FkApplicatiApplicationUserCreateInput: EulaVersionUserAcUserIdB72Ed9C5FkApplicatiApplicationUserCreateInput;
  EulaVersionUserAcUserIdB72Ed9C5FkApplicatiEulaVersionUserAcceptanceCreateInput: EulaVersionUserAcUserIdB72Ed9C5FkApplicatiEulaVersionUserAcceptanceCreateInput;
  EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput: EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInput;
  EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput: EulaVersionUserAcUserIdB72Ed9C5FkApplicatiInverseInput;
  EulaVersionUserAcceptance: EulaVersionUserAcceptance;
  EulaVersionUserAcceptanceCondition: EulaVersionUserAcceptanceCondition;
  EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyConnect: EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyConnect;
  EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyDelete: EulaVersionUserAcceptanceEulaVersionUserAcceptancePkeyDelete;
  EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueConnect: EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueConnect;
  EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueDelete: EulaVersionUserAcceptanceEulaVersionUserAcceptanceUniqueDelete;
  EulaVersionUserAcceptanceFilter: EulaVersionUserAcceptanceFilter;
  EulaVersionUserAcceptanceInput: EulaVersionUserAcceptanceInput;
  EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptancePkeyUpdate: EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptancePkeyUpdate;
  EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptanceUniqueUpdate: EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersUsingEulaVersionUserAcceptanceUniqueUpdate;
  EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptancePkeyUpdate: EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptancePkeyUpdate;
  EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptanceUniqueUpdate: EulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiUsingEulaVersionUserAcceptanceUniqueUpdate;
  EulaVersionUserAcceptancePatch: EulaVersionUserAcceptancePatch;
  EulaVersionUserAcceptancesConnection: EulaVersionUserAcceptancesConnection;
  EulaVersionUserAcceptancesEdge: EulaVersionUserAcceptancesEdge;
  EulaVersionsConnection: EulaVersionsConnection;
  EulaVersionsEdge: EulaVersionsEdge;
  FeatureFlag: FeatureFlag;
  FeatureFlagCondition: FeatureFlagCondition;
  FeatureFlagFeatureFlagsNameKeyConnect: FeatureFlagFeatureFlagsNameKeyConnect;
  FeatureFlagFeatureFlagsNameKeyDelete: FeatureFlagFeatureFlagsNameKeyDelete;
  FeatureFlagFeatureFlagsPkeyConnect: FeatureFlagFeatureFlagsPkeyConnect;
  FeatureFlagFeatureFlagsPkeyDelete: FeatureFlagFeatureFlagsPkeyDelete;
  FeatureFlagFilter: FeatureFlagFilter;
  FeatureFlagInput: FeatureFlagInput;
  FeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsNameKeyUpdate: FeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsNameKeyUpdate;
  FeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsPkeyUpdate: FeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsPkeyUpdate;
  FeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsNameKeyUpdate: FeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsNameKeyUpdate;
  FeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsPkeyUpdate: FeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsPkeyUpdate;
  FeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsNameKeyUpdate: FeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsNameKeyUpdate;
  FeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsPkeyUpdate: FeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsPkeyUpdate;
  FeatureFlagPatch: FeatureFlagPatch;
  FeatureFlagToManyFeatureFlagsGroupFilter: FeatureFlagToManyFeatureFlagsGroupFilter;
  FeatureFlagToManyFeatureFlagsTenantFilter: FeatureFlagToManyFeatureFlagsTenantFilter;
  FeatureFlagToManyFeatureFlagsUserFilter: FeatureFlagToManyFeatureFlagsUserFilter;
  FeatureFlagsConnection: FeatureFlagsConnection;
  FeatureFlagsEdge: FeatureFlagsEdge;
  FeatureFlagsGroup: FeatureFlagsGroup;
  FeatureFlagsGroupCondition: FeatureFlagsGroupCondition;
  FeatureFlagsGroupFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqConnect: FeatureFlagsGroupFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqConnect;
  FeatureFlagsGroupFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqDelete: FeatureFlagsGroupFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqDelete;
  FeatureFlagsGroupFeatureFlagsGroupsPkeyConnect: FeatureFlagsGroupFeatureFlagsGroupsPkeyConnect;
  FeatureFlagsGroupFeatureFlagsGroupsPkeyDelete: FeatureFlagsGroupFeatureFlagsGroupsPkeyDelete;
  FeatureFlagsGroupFilter: FeatureFlagsGroupFilter;
  FeatureFlagsGroupInput: FeatureFlagsGroupInput;
  FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqUpdate: FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqUpdate;
  FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsGroupsPkeyUpdate: FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFUsingFeatureFlagsGroupsPkeyUpdate;
  FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqUpdate: FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingFeatureFlagsGroupsFeatureflagIdGroupIdEef56C5BUniqUpdate;
  FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingFeatureFlagsGroupsPkeyUpdate: FeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdUsingFeatureFlagsGroupsPkeyUpdate;
  FeatureFlagsGroupPatch: FeatureFlagsGroupPatch;
  FeatureFlagsGroupsConnection: FeatureFlagsGroupsConnection;
  FeatureFlagsGroupsEdge: FeatureFlagsGroupsEdge;
  FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFFeatureFlagsCreateInput: FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFFeatureFlagsCreateInput;
  FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFFeatureFlagsGroupsCreateInput: FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFFeatureFlagsGroupsCreateInput;
  FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInput: FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInput;
  FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInverseInput: FeatureFlagsGroupsFeatureflagId4319112AFkFeatureFInverseInput;
  FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdAuthGroupCreateInput: FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdAuthGroupCreateInput;
  FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdFeatureFlagsGroupsCreateInput: FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdFeatureFlagsGroupsCreateInput;
  FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInput: FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInput;
  FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInverseInput: FeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdInverseInput;
  FeatureFlagsTenant: FeatureFlagsTenant;
  FeatureFlagsTenantCondition: FeatureFlagsTenantCondition;
  FeatureFlagsTenantFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqConnect: FeatureFlagsTenantFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqConnect;
  FeatureFlagsTenantFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqDelete: FeatureFlagsTenantFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqDelete;
  FeatureFlagsTenantFeatureFlagsTenantsPkeyConnect: FeatureFlagsTenantFeatureFlagsTenantsPkeyConnect;
  FeatureFlagsTenantFeatureFlagsTenantsPkeyDelete: FeatureFlagsTenantFeatureFlagsTenantsPkeyDelete;
  FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFFeatureFlagsCreateInput: FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFFeatureFlagsCreateInput;
  FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFFeatureFlagsTenantsCreateInput: FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFFeatureFlagsTenantsCreateInput;
  FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInput: FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInput;
  FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInverseInput: FeatureFlagsTenantFeatureflagIdBd940441FkFeatureFInverseInput;
  FeatureFlagsTenantFilter: FeatureFlagsTenantFilter;
  FeatureFlagsTenantInput: FeatureFlagsTenantInput;
  FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqUpdate: FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqUpdate;
  FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsTenantsPkeyUpdate: FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFUsingFeatureFlagsTenantsPkeyUpdate;
  FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqUpdate: FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingFeatureFlagsTenantsFeatureflagIdTenantId17769678UniqUpdate;
  FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingFeatureFlagsTenantsPkeyUpdate: FeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingFeatureFlagsTenantsPkeyUpdate;
  FeatureFlagsTenantPatch: FeatureFlagsTenantPatch;
  FeatureFlagsTenantsConnection: FeatureFlagsTenantsConnection;
  FeatureFlagsTenantsEdge: FeatureFlagsTenantsEdge;
  FeatureFlagsTenantsTenantId6D718C42FkTenantIdFeatureFlagsTenantsCreateInput: FeatureFlagsTenantsTenantId6D718C42FkTenantIdFeatureFlagsTenantsCreateInput;
  FeatureFlagsTenantsTenantId6D718C42FkTenantIdInput: FeatureFlagsTenantsTenantId6D718C42FkTenantIdInput;
  FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput: FeatureFlagsTenantsTenantId6D718C42FkTenantIdInverseInput;
  FeatureFlagsTenantsTenantId6D718C42FkTenantIdTenantCreateInput: FeatureFlagsTenantsTenantId6D718C42FkTenantIdTenantCreateInput;
  FeatureFlagsUser: FeatureFlagsUser;
  FeatureFlagsUserCondition: FeatureFlagsUserCondition;
  FeatureFlagsUserFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqConnect: FeatureFlagsUserFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqConnect;
  FeatureFlagsUserFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqDelete: FeatureFlagsUserFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqDelete;
  FeatureFlagsUserFeatureFlagsUsersPkeyConnect: FeatureFlagsUserFeatureFlagsUsersPkeyConnect;
  FeatureFlagsUserFeatureFlagsUsersPkeyDelete: FeatureFlagsUserFeatureFlagsUsersPkeyDelete;
  FeatureFlagsUserFilter: FeatureFlagsUserFilter;
  FeatureFlagsUserInput: FeatureFlagsUserInput;
  FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqUpdate: FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqUpdate;
  FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsUsersPkeyUpdate: FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdUsingFeatureFlagsUsersPkeyUpdate;
  FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqUpdate: FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingFeatureFlagsUsersFeatureflagIdUserId3Cf64752UniqUpdate;
  FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingFeatureFlagsUsersPkeyUpdate: FeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdUsingFeatureFlagsUsersPkeyUpdate;
  FeatureFlagsUserPatch: FeatureFlagsUserPatch;
  FeatureFlagsUsersConnection: FeatureFlagsUsersConnection;
  FeatureFlagsUsersEdge: FeatureFlagsUsersEdge;
  FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdFeatureFlagsCreateInput: FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdFeatureFlagsCreateInput;
  FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdFeatureFlagsUsersCreateInput: FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdFeatureFlagsUsersCreateInput;
  FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInput: FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInput;
  FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInverseInput: FeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdInverseInput;
  FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdApplicationUserCreateInput: FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdApplicationUserCreateInput;
  FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdFeatureFlagsUsersCreateInput: FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdFeatureFlagsUsersCreateInput;
  FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInput: FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInput;
  FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput: FeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdInverseInput;
  File: File;
  FileActivitiesConnection: FileActivitiesConnection;
  FileActivitiesEdge: FileActivitiesEdge;
  FileActivity: FileActivity;
  FileActivityCondition: FileActivityCondition;
  FileActivityContentTypeIdD010Fc58FkDjangoCoDjangoContentTypeCreateInput: FileActivityContentTypeIdD010Fc58FkDjangoCoDjangoContentTypeCreateInput;
  FileActivityContentTypeIdD010Fc58FkDjangoCoFileActivityCreateInput: FileActivityContentTypeIdD010Fc58FkDjangoCoFileActivityCreateInput;
  FileActivityContentTypeIdD010Fc58FkDjangoCoInput: FileActivityContentTypeIdD010Fc58FkDjangoCoInput;
  FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput: FileActivityContentTypeIdD010Fc58FkDjangoCoInverseInput;
  FileActivityCostId2A88D90AFkCostIdCostCreateInput: FileActivityCostId2A88D90AFkCostIdCostCreateInput;
  FileActivityCostId2A88D90AFkCostIdFileActivityCreateInput: FileActivityCostId2A88D90AFkCostIdFileActivityCreateInput;
  FileActivityCostId2A88D90AFkCostIdInput: FileActivityCostId2A88D90AFkCostIdInput;
  FileActivityCostId2A88D90AFkCostIdInverseInput: FileActivityCostId2A88D90AFkCostIdInverseInput;
  FileActivityFileActivityPkeyConnect: FileActivityFileActivityPkeyConnect;
  FileActivityFileActivityPkeyDelete: FileActivityFileActivityPkeyDelete;
  FileActivityFileId015763A9FkFileIdFileActivityCreateInput: FileActivityFileId015763A9FkFileIdFileActivityCreateInput;
  FileActivityFileId015763A9FkFileIdFileCreateInput: FileActivityFileId015763A9FkFileIdFileCreateInput;
  FileActivityFileId015763A9FkFileIdInput: FileActivityFileId015763A9FkFileIdInput;
  FileActivityFileId015763A9FkFileIdInverseInput: FileActivityFileId015763A9FkFileIdInverseInput;
  FileActivityFilter: FileActivityFilter;
  FileActivityInput: FileActivityInput;
  FileActivityOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoUsingFileActivityPkeyUpdate;
  FileActivityOnFileActivityForFileActivityCostId2A88D90AFkCostIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityCostId2A88D90AFkCostIdUsingFileActivityPkeyUpdate;
  FileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFileActivityPkeyUpdate;
  FileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingFileActivityPkeyUpdate;
  FileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingFileActivityPkeyUpdate;
  FileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingFileActivityPkeyUpdate: FileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdUsingFileActivityPkeyUpdate;
  FileActivityPatch: FileActivityPatch;
  FileActivityProjectId6F35B8CcFkProjectIdFileActivityCreateInput: FileActivityProjectId6F35B8CcFkProjectIdFileActivityCreateInput;
  FileActivityProjectId6F35B8CcFkProjectIdInput: FileActivityProjectId6F35B8CcFkProjectIdInput;
  FileActivityProjectId6F35B8CcFkProjectIdInverseInput: FileActivityProjectId6F35B8CcFkProjectIdInverseInput;
  FileActivityTenantIdC46A4F01FkTenantIdFileActivityCreateInput: FileActivityTenantIdC46A4F01FkTenantIdFileActivityCreateInput;
  FileActivityTenantIdC46A4F01FkTenantIdInput: FileActivityTenantIdC46A4F01FkTenantIdInput;
  FileActivityTenantIdC46A4F01FkTenantIdInverseInput: FileActivityTenantIdC46A4F01FkTenantIdInverseInput;
  FileActivityTenantIdC46A4F01FkTenantIdTenantCreateInput: FileActivityTenantIdC46A4F01FkTenantIdTenantCreateInput;
  FileActivityUserId868Ad8A9FkApplicationUserIdApplicationUserCreateInput: FileActivityUserId868Ad8A9FkApplicationUserIdApplicationUserCreateInput;
  FileActivityUserId868Ad8A9FkApplicationUserIdFileActivityCreateInput: FileActivityUserId868Ad8A9FkApplicationUserIdFileActivityCreateInput;
  FileActivityUserId868Ad8A9FkApplicationUserIdInput: FileActivityUserId868Ad8A9FkApplicationUserIdInput;
  FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput: FileActivityUserId868Ad8A9FkApplicationUserIdInverseInput;
  FileCondition: FileCondition;
  FileExecutorId819Da590FkDrsFileexecutorIdInput: FileExecutorId819Da590FkDrsFileexecutorIdInput;
  FileExecutorId819Da590FkDrsFileexecutorIdInverseInput: FileExecutorId819Da590FkDrsFileexecutorIdInverseInput;
  FileFilePkeyConnect: FileFilePkeyConnect;
  FileFilePkeyDelete: FileFilePkeyDelete;
  FileFilter: FileFilter;
  FileInput: FileInput;
  FileMetadataConnection: FileMetadataConnection;
  FileMetadataEdge: FileMetadataEdge;
  FileMetadataFileId78256936FkFileIdFileCreateInput: FileMetadataFileId78256936FkFileIdFileCreateInput;
  FileMetadataFileId78256936FkFileIdFileMetadataCreateInput: FileMetadataFileId78256936FkFileIdFileMetadataCreateInput;
  FileMetadataFileId78256936FkFileIdInput: FileMetadataFileId78256936FkFileIdInput;
  FileMetadataFileId78256936FkFileIdInverseInput: FileMetadataFileId78256936FkFileIdInverseInput;
  FileMetadataMetadataIdFefc0061FkMetadataIdFileMetadataCreateInput: FileMetadataMetadataIdFefc0061FkMetadataIdFileMetadataCreateInput;
  FileMetadataMetadataIdFefc0061FkMetadataIdInput: FileMetadataMetadataIdFefc0061FkMetadataIdInput;
  FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput: FileMetadataMetadataIdFefc0061FkMetadataIdInverseInput;
  FileMetadataMetadataIdFefc0061FkMetadataIdMetadataCreateInput: FileMetadataMetadataIdFefc0061FkMetadataIdMetadataCreateInput;
  FileMetadataProjectId3474994EFkProjectIdFileMetadataCreateInput: FileMetadataProjectId3474994EFkProjectIdFileMetadataCreateInput;
  FileMetadataProjectId3474994EFkProjectIdInput: FileMetadataProjectId3474994EFkProjectIdInput;
  FileMetadataProjectId3474994EFkProjectIdInverseInput: FileMetadataProjectId3474994EFkProjectIdInverseInput;
  FileMetadataTenantId79Fe438BFkTenantIdFileMetadataCreateInput: FileMetadataTenantId79Fe438BFkTenantIdFileMetadataCreateInput;
  FileMetadataTenantId79Fe438BFkTenantIdInput: FileMetadataTenantId79Fe438BFkTenantIdInput;
  FileMetadataTenantId79Fe438BFkTenantIdInverseInput: FileMetadataTenantId79Fe438BFkTenantIdInverseInput;
  FileMetadataTenantId79Fe438BFkTenantIdTenantCreateInput: FileMetadataTenantId79Fe438BFkTenantIdTenantCreateInput;
  FileMetadatum: FileMetadatum;
  FileMetadatumCondition: FileMetadatumCondition;
  FileMetadatumFileMetadataPkeyConnect: FileMetadatumFileMetadataPkeyConnect;
  FileMetadatumFileMetadataPkeyDelete: FileMetadatumFileMetadataPkeyDelete;
  FileMetadatumFilter: FileMetadatumFilter;
  FileMetadatumInput: FileMetadatumInput;
  FileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFileMetadataPkeyUpdate: FileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFileMetadataPkeyUpdate;
  FileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingFileMetadataPkeyUpdate: FileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingFileMetadataPkeyUpdate;
  FileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingFileMetadataPkeyUpdate: FileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingFileMetadataPkeyUpdate;
  FileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingFileMetadataPkeyUpdate: FileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingFileMetadataPkeyUpdate;
  FileMetadatumPatch: FileMetadatumPatch;
  FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFilePkeyUpdate: FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingFilePkeyUpdate;
  FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnFileActivityForFileActivityFileId015763A9FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileProjectId3Ecca975FkProjectIdUsingFilePkeyUpdate: FileOnFileForFileProjectId3Ecca975FkProjectIdUsingFilePkeyUpdate;
  FileOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingFilePkeyUpdate: FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingFilePkeyUpdate;
  FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileSeriesParentIdF7A07E20FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingFilePkeyUpdate: FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingFilePkeyUpdate;
  FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileTaskIdE4Da87AeFkTaskIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileTenantId61625016FkTenantIdUsingFilePkeyUpdate: FileOnFileForFileTenantId61625016FkTenantIdUsingFilePkeyUpdate;
  FileOnFileForFileTenantId61625016FkTenantIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileTenantId61625016FkTenantIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingFilePkeyUpdate: FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingFilePkeyUpdate;
  FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingProjectReferenceIdUniqueUpdate: FileOnFileForFileUserId01D90B53FkApplicationUserIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFilePkeyUpdate: FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingFilePkeyUpdate;
  FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnFileMetadatumForFileMetadataFileId78256936FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFilePkeyUpdate: FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFilePkeyUpdate;
  FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingFilePkeyUpdate: FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingFilePkeyUpdate;
  FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingFilePkeyUpdate: FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingFilePkeyUpdate;
  FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingProjectReferenceIdUniqueUpdate: FileOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingProjectReferenceIdUniqueUpdate;
  FileOutputGroup: FileOutputGroup;
  FileOutputGroupCondition: FileOutputGroupCondition;
  FileOutputGroupFileOutputGroupPkeyConnect: FileOutputGroupFileOutputGroupPkeyConnect;
  FileOutputGroupFileOutputGroupPkeyDelete: FileOutputGroupFileOutputGroupPkeyDelete;
  FileOutputGroupFileOutputGroupTaskIdKeyConnect: FileOutputGroupFileOutputGroupTaskIdKeyConnect;
  FileOutputGroupFileOutputGroupTaskIdKeyDelete: FileOutputGroupFileOutputGroupTaskIdKeyDelete;
  FileOutputGroupFilter: FileOutputGroupFilter;
  FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpFileOutputGroupMetadataCreateInput: FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpFileOutputGroupMetadataCreateInput;
  FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput: FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInput;
  FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput: FileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpInverseInput;
  FileOutputGroupMetadataConnection: FileOutputGroupMetadataConnection;
  FileOutputGroupMetadataEdge: FileOutputGroupMetadataEdge;
  FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdFileOutputGroupMetadataCreateInput: FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdFileOutputGroupMetadataCreateInput;
  FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput: FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInput;
  FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput: FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdInverseInput;
  FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdMetadataCreateInput: FileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdMetadataCreateInput;
  FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdFileOutputGroupMetadataCreateInput: FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdFileOutputGroupMetadataCreateInput;
  FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput: FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInput;
  FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput: FileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdInverseInput;
  FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdFileOutputGroupMetadataCreateInput: FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdFileOutputGroupMetadataCreateInput;
  FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput: FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInput;
  FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput: FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdInverseInput;
  FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdTenantCreateInput: FileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdTenantCreateInput;
  FileOutputGroupMetadatum: FileOutputGroupMetadatum;
  FileOutputGroupMetadatumCondition: FileOutputGroupMetadatumCondition;
  FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect: FileOutputGroupMetadatumFileOutputGroupMetadataPkeyConnect;
  FileOutputGroupMetadatumFileOutputGroupMetadataPkeyDelete: FileOutputGroupMetadatumFileOutputGroupMetadataPkeyDelete;
  FileOutputGroupMetadatumFilter: FileOutputGroupMetadatumFilter;
  FileOutputGroupMetadatumInput: FileOutputGroupMetadatumInput;
  FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupMetadataPkeyUpdate: FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupMetadataPkeyUpdate;
  FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingFileOutputGroupMetadataPkeyUpdate: FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingFileOutputGroupMetadataPkeyUpdate;
  FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingFileOutputGroupMetadataPkeyUpdate: FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingFileOutputGroupMetadataPkeyUpdate;
  FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingFileOutputGroupMetadataPkeyUpdate: FileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingFileOutputGroupMetadataPkeyUpdate;
  FileOutputGroupMetadatumPatch: FileOutputGroupMetadatumPatch;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupPkeyUpdate: FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupPkeyUpdate;
  FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate: FileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingFileOutputGroupTaskIdKeyUpdate;
  FileOutputGroupPatch: FileOutputGroupPatch;
  FileOutputGroupProjectId908Fb9FfFkProjectIdInput: FileOutputGroupProjectId908Fb9FfFkProjectIdInput;
  FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput: FileOutputGroupProjectId908Fb9FfFkProjectIdInverseInput;
  FileOutputGroupTaskId2B1Df6A1FkTaskIdInput: FileOutputGroupTaskId2B1Df6A1FkTaskIdInput;
  FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput: FileOutputGroupTaskId2B1Df6A1FkTaskIdInverseInput;
  FileOutputGroupTaskId2B1Df6A1FkTaskIdTaskCreateInput: FileOutputGroupTaskId2B1Df6A1FkTaskIdTaskCreateInput;
  FileOutputGroupTenantId3Fa46D44FkTenantIdInput: FileOutputGroupTenantId3Fa46D44FkTenantIdInput;
  FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput: FileOutputGroupTenantId3Fa46D44FkTenantIdInverseInput;
  FileOutputGroupTenantId3Fa46D44FkTenantIdTenantCreateInput: FileOutputGroupTenantId3Fa46D44FkTenantIdTenantCreateInput;
  FileOutputGroupToManyFileOutputGroupMetadatumFilter: FileOutputGroupToManyFileOutputGroupMetadatumFilter;
  FileOutputGroupToManyOutputGroupFileFilter: FileOutputGroupToManyOutputGroupFileFilter;
  FileOutputGroupUserIdB22Ec436FkApplicationUserIdApplicationUserCreateInput: FileOutputGroupUserIdB22Ec436FkApplicationUserIdApplicationUserCreateInput;
  FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput: FileOutputGroupUserIdB22Ec436FkApplicationUserIdInput;
  FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput: FileOutputGroupUserIdB22Ec436FkApplicationUserIdInverseInput;
  FileOutputGroupsConnection: FileOutputGroupsConnection;
  FileOutputGroupsEdge: FileOutputGroupsEdge;
  FilePatch: FilePatch;
  FileProcessingNotiUserId08265156FkApplicatiApplicationUserCreateInput: FileProcessingNotiUserId08265156FkApplicatiApplicationUserCreateInput;
  FileProcessingNotiUserId08265156FkApplicatiInput: FileProcessingNotiUserId08265156FkApplicatiInput;
  FileProcessingNotiUserId08265156FkApplicatiInverseInput: FileProcessingNotiUserId08265156FkApplicatiInverseInput;
  FileProcessingNotification: FileProcessingNotification;
  FileProcessingNotificationCondition: FileProcessingNotificationCondition;
  FileProcessingNotificationFileId717B514EFkFileIdFileCreateInput: FileProcessingNotificationFileId717B514EFkFileIdFileCreateInput;
  FileProcessingNotificationFileId717B514EFkFileIdInput: FileProcessingNotificationFileId717B514EFkFileIdInput;
  FileProcessingNotificationFileId717B514EFkFileIdInverseInput: FileProcessingNotificationFileId717B514EFkFileIdInverseInput;
  FileProcessingNotificationFileProcessingNotificationPkeyConnect: FileProcessingNotificationFileProcessingNotificationPkeyConnect;
  FileProcessingNotificationFilter: FileProcessingNotificationFilter;
  FileProcessingNotificationId630E6495FkNotificationIdInput: FileProcessingNotificationId630E6495FkNotificationIdInput;
  FileProcessingNotificationId630E6495FkNotificationIdInverseInput: FileProcessingNotificationId630E6495FkNotificationIdInverseInput;
  FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingFileProcessingNotificationPkeyUpdate: FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiUsingFileProcessingNotificationPkeyUpdate;
  FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFileProcessingNotificationPkeyUpdate: FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdUsingFileProcessingNotificationPkeyUpdate;
  FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingFileProcessingNotificationPkeyUpdate: FileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingFileProcessingNotificationPkeyUpdate;
  FileProcessingNotificationsConnection: FileProcessingNotificationsConnection;
  FileProcessingNotificationsEdge: FileProcessingNotificationsEdge;
  FileProjectId3Ecca975FkProjectIdFileCreateInput: FileProjectId3Ecca975FkProjectIdFileCreateInput;
  FileProjectId3Ecca975FkProjectIdInput: FileProjectId3Ecca975FkProjectIdInput;
  FileProjectId3Ecca975FkProjectIdInverseInput: FileProjectId3Ecca975FkProjectIdInverseInput;
  FileProjectReferenceIdUniqueConnect: FileProjectReferenceIdUniqueConnect;
  FileProjectReferenceIdUniqueDelete: FileProjectReferenceIdUniqueDelete;
  FileSeriesParentIdF7A07E20FkFileIdFileCreateInput: FileSeriesParentIdF7A07E20FkFileIdFileCreateInput;
  FileSeriesParentIdF7A07E20FkFileIdInput: FileSeriesParentIdF7A07E20FkFileIdInput;
  FileTaskIdE4Da87AeFkTaskIdFileCreateInput: FileTaskIdE4Da87AeFkTaskIdFileCreateInput;
  FileTaskIdE4Da87AeFkTaskIdInput: FileTaskIdE4Da87AeFkTaskIdInput;
  FileTaskIdE4Da87AeFkTaskIdInverseInput: FileTaskIdE4Da87AeFkTaskIdInverseInput;
  FileTaskIdE4Da87AeFkTaskIdTaskCreateInput: FileTaskIdE4Da87AeFkTaskIdTaskCreateInput;
  FileTenantId61625016FkTenantIdFileCreateInput: FileTenantId61625016FkTenantIdFileCreateInput;
  FileTenantId61625016FkTenantIdInput: FileTenantId61625016FkTenantIdInput;
  FileTenantId61625016FkTenantIdInverseInput: FileTenantId61625016FkTenantIdInverseInput;
  FileTenantId61625016FkTenantIdTenantCreateInput: FileTenantId61625016FkTenantIdTenantCreateInput;
  FileToManyFileActivityFilter: FileToManyFileActivityFilter;
  FileToManyFileFilter: FileToManyFileFilter;
  FileToManyFileMetadatumFilter: FileToManyFileMetadatumFilter;
  FileToManyFileProcessingNotificationFilter: FileToManyFileProcessingNotificationFilter;
  FileToManyOutputGroupFileFilter: FileToManyOutputGroupFileFilter;
  FileToManyTaskSourceFilter: FileToManyTaskSourceFilter;
  FileUserId01D90B53FkApplicationUserIdApplicationUserCreateInput: FileUserId01D90B53FkApplicationUserIdApplicationUserCreateInput;
  FileUserId01D90B53FkApplicationUserIdFileCreateInput: FileUserId01D90B53FkApplicationUserIdFileCreateInput;
  FileUserId01D90B53FkApplicationUserIdInput: FileUserId01D90B53FkApplicationUserIdInput;
  FileUserId01D90B53FkApplicationUserIdInverseInput: FileUserId01D90B53FkApplicationUserIdInverseInput;
  FilesByExecutor: FilesByExecutor;
  FilesByExecutorCondition: FilesByExecutorCondition;
  FilesByExecutorFilter: FilesByExecutorFilter;
  FilesByExecutorInput: FilesByExecutorInput;
  FilesByExecutorsConnection: FilesByExecutorsConnection;
  FilesByExecutorsEdge: FilesByExecutorsEdge;
  FilesConnection: FilesConnection;
  FilesEdge: FilesEdge;
  Float: Scalars["Float"]["output"];
  FloatFilter: FloatFilter;
  GdtAnalysisTable: GdtAnalysisTable;
  GdtAnalysisTableCColumnId54344A43FkGdtAnalyInput: GdtAnalysisTableCColumnId54344A43FkGdtAnalyInput;
  GdtAnalysisTableCColumnId54344A43FkGdtAnalyInverseInput: GdtAnalysisTableCColumnId54344A43FkGdtAnalyInverseInput;
  GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoDjangoContentTypeCreateInput: GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoDjangoContentTypeCreateInput;
  GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInput: GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInput;
  GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput: GdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoInverseInput;
  GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoDjangoContentTypeCreateInput: GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoDjangoContentTypeCreateInput;
  GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInput: GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInput;
  GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput: GdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoInverseInput;
  GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInput: GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInput;
  GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInverseInput: GdtAnalysisTableCGroupIdE356CdffFkGdtAnalyInverseInput;
  GdtAnalysisTableCProjectId77B86B06FkProjectIInput: GdtAnalysisTableCProjectId77B86B06FkProjectIInput;
  GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput: GdtAnalysisTableCProjectId77B86B06FkProjectIInverseInput;
  GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInput: GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInput;
  GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInverseInput: GdtAnalysisTableCRowIdEeacbde2FkGdtAnalyInverseInput;
  GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInput: GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInput;
  GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInverseInput: GdtAnalysisTableCTableId2788Fb29FkGdtAnalyInverseInput;
  GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInput: GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInput;
  GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInverseInput: GdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyInverseInput;
  GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInput: GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInput;
  GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInverseInput: GdtAnalysisTableCTableIdE0C756BaFkGdtAnalyInverseInput;
  GdtAnalysisTableCUserId75C939B7FkApplicatiApplicationUserCreateInput: GdtAnalysisTableCUserId75C939B7FkApplicatiApplicationUserCreateInput;
  GdtAnalysisTableCUserId75C939B7FkApplicatiInput: GdtAnalysisTableCUserId75C939B7FkApplicatiInput;
  GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput: GdtAnalysisTableCUserId75C939B7FkApplicatiInverseInput;
  GdtAnalysisTableCUserId8709Cf1FFkApplicatiApplicationUserCreateInput: GdtAnalysisTableCUserId8709Cf1FFkApplicatiApplicationUserCreateInput;
  GdtAnalysisTableCUserId8709Cf1FFkApplicatiInput: GdtAnalysisTableCUserId8709Cf1FFkApplicatiInput;
  GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput: GdtAnalysisTableCUserId8709Cf1FFkApplicatiInverseInput;
  GdtAnalysisTableCell: GdtAnalysisTableCell;
  GdtAnalysisTableCellCondition: GdtAnalysisTableCellCondition;
  GdtAnalysisTableCellFilter: GdtAnalysisTableCellFilter;
  GdtAnalysisTableCellGdtAnalysisTableCellPkeyConnect: GdtAnalysisTableCellGdtAnalysisTableCellPkeyConnect;
  GdtAnalysisTableCellGdtAnalysisTableCellUniqueConnect: GdtAnalysisTableCellGdtAnalysisTableCellUniqueConnect;
  GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate: GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate;
  GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate: GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate;
  GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate: GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate;
  GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate: GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate;
  GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate: GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTableCellPkeyUpdate;
  GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate: GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTableCellUniqueUpdate;
  GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingGdtAnalysisTableCellPkeyUpdate: GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingGdtAnalysisTableCellPkeyUpdate;
  GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingGdtAnalysisTableCellUniqueUpdate: GdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingGdtAnalysisTableCellUniqueUpdate;
  GdtAnalysisTableCellProjectId57B70FedFkProjectIdInput: GdtAnalysisTableCellProjectId57B70FedFkProjectIdInput;
  GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput: GdtAnalysisTableCellProjectId57B70FedFkProjectIdInverseInput;
  GdtAnalysisTableCellsConnection: GdtAnalysisTableCellsConnection;
  GdtAnalysisTableCellsEdge: GdtAnalysisTableCellsEdge;
  GdtAnalysisTableColumn: GdtAnalysisTableColumn;
  GdtAnalysisTableColumnCondition: GdtAnalysisTableColumnCondition;
  GdtAnalysisTableColumnFilter: GdtAnalysisTableColumnFilter;
  GdtAnalysisTableColumnGdtAnalysisTableColumnPkeyConnect: GdtAnalysisTableColumnGdtAnalysisTableColumnPkeyConnect;
  GdtAnalysisTableColumnGdtAnalysisTableColumnUniqueConnect: GdtAnalysisTableColumnGdtAnalysisTableColumnUniqueConnect;
  GdtAnalysisTableColumnGroup: GdtAnalysisTableColumnGroup;
  GdtAnalysisTableColumnGroupCondition: GdtAnalysisTableColumnGroupCondition;
  GdtAnalysisTableColumnGroupFilter: GdtAnalysisTableColumnGroupFilter;
  GdtAnalysisTableColumnGroupGdtAnalysisTableColumnGroupPkeyConnect: GdtAnalysisTableColumnGroupGdtAnalysisTableColumnGroupPkeyConnect;
  GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnGroupPkeyUpdate: GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnGroupPkeyUpdate;
  GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingGdtAnalysisTableColumnGroupPkeyUpdate: GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoUsingGdtAnalysisTableColumnGroupPkeyUpdate;
  GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingGdtAnalysisTableColumnGroupPkeyUpdate: GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingGdtAnalysisTableColumnGroupPkeyUpdate;
  GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyUsingGdtAnalysisTableColumnGroupPkeyUpdate: GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyUsingGdtAnalysisTableColumnGroupPkeyUpdate;
  GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingGdtAnalysisTableColumnGroupPkeyUpdate: GdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiUsingGdtAnalysisTableColumnGroupPkeyUpdate;
  GdtAnalysisTableColumnGroupToManyGdtAnalysisTableColumnFilter: GdtAnalysisTableColumnGroupToManyGdtAnalysisTableColumnFilter;
  GdtAnalysisTableColumnGroupsConnection: GdtAnalysisTableColumnGroupsConnection;
  GdtAnalysisTableColumnGroupsEdge: GdtAnalysisTableColumnGroupsEdge;
  GdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingGdtAnalysisTableColumnPkeyUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingGdtAnalysisTableColumnPkeyUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingGdtAnalysisTableColumnUniqueUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoUsingGdtAnalysisTableColumnUniqueUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTableColumnPkeyUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTableColumnUniqueUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingGdtAnalysisTableColumnPkeyUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingGdtAnalysisTableColumnPkeyUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingGdtAnalysisTableColumnUniqueUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiUsingGdtAnalysisTableColumnUniqueUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingGdtAnalysisTableColumnPkeyUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingGdtAnalysisTableColumnPkeyUpdate;
  GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingGdtAnalysisTableColumnUniqueUpdate: GdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingGdtAnalysisTableColumnUniqueUpdate;
  GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInput: GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInput;
  GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput: GdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdInverseInput;
  GdtAnalysisTableColumnToManyGdtAnalysisTableCellFilter: GdtAnalysisTableColumnToManyGdtAnalysisTableCellFilter;
  GdtAnalysisTableColumnsConnection: GdtAnalysisTableColumnsConnection;
  GdtAnalysisTableColumnsEdge: GdtAnalysisTableColumnsEdge;
  GdtAnalysisTableCondition: GdtAnalysisTableCondition;
  GdtAnalysisTableFilter: GdtAnalysisTableFilter;
  GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput: GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInput;
  GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput: GdtAnalysisTableFolderId6A997B49FkProjectFolderIdInverseInput;
  GdtAnalysisTableFolderId6A997B49FkProjectFolderIdProjectFolderCreateInput: GdtAnalysisTableFolderId6A997B49FkProjectFolderIdProjectFolderCreateInput;
  GdtAnalysisTableGdtAnalysisTablePkeyConnect: GdtAnalysisTableGdtAnalysisTablePkeyConnect;
  GdtAnalysisTableOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate: GdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTablePkeyUpdate;
  GdtAnalysisTableProjectId544B76D9FkProjectIdInput: GdtAnalysisTableProjectId544B76D9FkProjectIdInput;
  GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput: GdtAnalysisTableProjectId544B76D9FkProjectIdInverseInput;
  GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput: GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInput;
  GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput: GdtAnalysisTableRTableIdAf79B47BFkGdtAnalyInverseInput;
  GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput: GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInput;
  GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput: GdtAnalysisTableRToolVersionId0050D5BdFkToolVersInverseInput;
  GdtAnalysisTableRToolVersionId0050D5BdFkToolVersToolVersionCreateInput: GdtAnalysisTableRToolVersionId0050D5BdFkToolVersToolVersionCreateInput;
  GdtAnalysisTableRow: GdtAnalysisTableRow;
  GdtAnalysisTableRowCondition: GdtAnalysisTableRowCondition;
  GdtAnalysisTableRowFilter: GdtAnalysisTableRowFilter;
  GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect: GdtAnalysisTableRowGdtAnalysisTableRowPkeyConnect;
  GdtAnalysisTableRowGdtAnalysisTableRowTaskIdKeyConnect: GdtAnalysisTableRowGdtAnalysisTableRowTaskIdKeyConnect;
  GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect: GdtAnalysisTableRowGdtAnalysisTableRowUniqueConnect;
  GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowTaskIdKeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowTaskIdKeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowTaskIdKeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowTaskIdKeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowTaskIdKeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowTaskIdKeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowTaskIdKeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowTaskIdKeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowTaskIdKeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowTaskIdKeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowPkeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowPkeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowTaskIdKeyUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowTaskIdKeyUpdate;
  GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowUniqueUpdate: GdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdUsingGdtAnalysisTableRowUniqueUpdate;
  GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput: GdtAnalysisTableRowProjectIdF415C371FkProjectIdInput;
  GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput: GdtAnalysisTableRowProjectIdF415C371FkProjectIdInverseInput;
  GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput: GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInput;
  GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput: GdtAnalysisTableRowTaskId14Ab233FFkTaskIdInverseInput;
  GdtAnalysisTableRowTaskId14Ab233FFkTaskIdTaskCreateInput: GdtAnalysisTableRowTaskId14Ab233FFkTaskIdTaskCreateInput;
  GdtAnalysisTableRowToManyGdtAnalysisTableCellFilter: GdtAnalysisTableRowToManyGdtAnalysisTableCellFilter;
  GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdApplicationUserCreateInput: GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdApplicationUserCreateInput;
  GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput: GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInput;
  GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput: GdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdInverseInput;
  GdtAnalysisTableRowsConnection: GdtAnalysisTableRowsConnection;
  GdtAnalysisTableRowsEdge: GdtAnalysisTableRowsEdge;
  GdtAnalysisTableToManyGdtAnalysisTableCellFilter: GdtAnalysisTableToManyGdtAnalysisTableCellFilter;
  GdtAnalysisTableToManyGdtAnalysisTableColumnFilter: GdtAnalysisTableToManyGdtAnalysisTableColumnFilter;
  GdtAnalysisTableToManyGdtAnalysisTableColumnGroupFilter: GdtAnalysisTableToManyGdtAnalysisTableColumnGroupFilter;
  GdtAnalysisTableToManyGdtAnalysisTableRowFilter: GdtAnalysisTableToManyGdtAnalysisTableRowFilter;
  GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput: GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInput;
  GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput: GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdInverseInput;
  GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdToolVersionCreateInput: GdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdToolVersionCreateInput;
  GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdApplicationUserCreateInput: GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdApplicationUserCreateInput;
  GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput: GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInput;
  GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput: GdtAnalysisTableUserId1E9A1A36FkApplicationUserIdInverseInput;
  GdtAnalysisTablesConnection: GdtAnalysisTablesConnection;
  GdtAnalysisTablesEdge: GdtAnalysisTablesEdge;
  ID: Scalars["ID"]["output"];
  Int: Scalars["Int"]["output"];
  IntFilter: IntFilter;
  InternetAddress: Scalars["InternetAddress"]["output"];
  InternetAddressFilter: InternetAddressFilter;
  Interval: Interval;
  IntervalFilter: IntervalFilter;
  IntervalInput: IntervalInput;
  JSON: Scalars["JSON"]["output"];
  JSONFilter: JsonFilter;
  MetadataConnection: MetadataConnection;
  MetadataEdge: MetadataEdge;
  MetadataProjectId3333C2AdFkProjectIdInput: MetadataProjectId3333C2AdFkProjectIdInput;
  MetadataProjectId3333C2AdFkProjectIdInverseInput: MetadataProjectId3333C2AdFkProjectIdInverseInput;
  MetadataProjectId3333C2AdFkProjectIdMetadataCreateInput: MetadataProjectId3333C2AdFkProjectIdMetadataCreateInput;
  MetadataTenantIdC1D8772DFkTenantIdInput: MetadataTenantIdC1D8772DFkTenantIdInput;
  MetadataTenantIdC1D8772DFkTenantIdInverseInput: MetadataTenantIdC1D8772DFkTenantIdInverseInput;
  MetadataTenantIdC1D8772DFkTenantIdMetadataCreateInput: MetadataTenantIdC1D8772DFkTenantIdMetadataCreateInput;
  MetadataTenantIdC1D8772DFkTenantIdTenantCreateInput: MetadataTenantIdC1D8772DFkTenantIdTenantCreateInput;
  MetadataValue: MetadataValue;
  MetadataValueCondition: MetadataValueCondition;
  MetadataValueFilter: MetadataValueFilter;
  MetadataValueInput: MetadataValueInput;
  MetadataValueMetadataId063A53B6FkMetadataIdInput: MetadataValueMetadataId063A53B6FkMetadataIdInput;
  MetadataValueMetadataId063A53B6FkMetadataIdInverseInput: MetadataValueMetadataId063A53B6FkMetadataIdInverseInput;
  MetadataValueMetadataId063A53B6FkMetadataIdMetadataCreateInput: MetadataValueMetadataId063A53B6FkMetadataIdMetadataCreateInput;
  MetadataValueMetadataId063A53B6FkMetadataIdMetadataValueCreateInput: MetadataValueMetadataId063A53B6FkMetadataIdMetadataValueCreateInput;
  MetadataValueMetadataValuePkeyConnect: MetadataValueMetadataValuePkeyConnect;
  MetadataValueMetadataValuePkeyDelete: MetadataValueMetadataValuePkeyDelete;
  MetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataValuePkeyUpdate;
  MetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingMetadataValuePkeyUpdate;
  MetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingMetadataValuePkeyUpdate;
  MetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingMetadataValuePkeyUpdate;
  MetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingMetadataValuePkeyUpdate: MetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdUsingMetadataValuePkeyUpdate;
  MetadataValuePatch: MetadataValuePatch;
  MetadataValueProjectId87227D96FkProjectIdInput: MetadataValueProjectId87227D96FkProjectIdInput;
  MetadataValueProjectId87227D96FkProjectIdInverseInput: MetadataValueProjectId87227D96FkProjectIdInverseInput;
  MetadataValueProjectId87227D96FkProjectIdMetadataValueCreateInput: MetadataValueProjectId87227D96FkProjectIdMetadataValueCreateInput;
  MetadataValueTaskId3D37D135FkTaskIdInput: MetadataValueTaskId3D37D135FkTaskIdInput;
  MetadataValueTaskId3D37D135FkTaskIdInverseInput: MetadataValueTaskId3D37D135FkTaskIdInverseInput;
  MetadataValueTaskId3D37D135FkTaskIdMetadataValueCreateInput: MetadataValueTaskId3D37D135FkTaskIdMetadataValueCreateInput;
  MetadataValueTaskId3D37D135FkTaskIdTaskCreateInput: MetadataValueTaskId3D37D135FkTaskIdTaskCreateInput;
  MetadataValueTenantIdB4C2D5D6FkTenantIdInput: MetadataValueTenantIdB4C2D5D6FkTenantIdInput;
  MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput: MetadataValueTenantIdB4C2D5D6FkTenantIdInverseInput;
  MetadataValueTenantIdB4C2D5D6FkTenantIdMetadataValueCreateInput: MetadataValueTenantIdB4C2D5D6FkTenantIdMetadataValueCreateInput;
  MetadataValueTenantIdB4C2D5D6FkTenantIdTenantCreateInput: MetadataValueTenantIdB4C2D5D6FkTenantIdTenantCreateInput;
  MetadataValueUserIdB2Bb45AeFkApplicationUserIdApplicationUserCreateInput: MetadataValueUserIdB2Bb45AeFkApplicationUserIdApplicationUserCreateInput;
  MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput: MetadataValueUserIdB2Bb45AeFkApplicationUserIdInput;
  MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput: MetadataValueUserIdB2Bb45AeFkApplicationUserIdInverseInput;
  MetadataValueUserIdB2Bb45AeFkApplicationUserIdMetadataValueCreateInput: MetadataValueUserIdB2Bb45AeFkApplicationUserIdMetadataValueCreateInput;
  MetadataValuesConnection: MetadataValuesConnection;
  MetadataValuesEdge: MetadataValuesEdge;
  Metadatum: Metadatum;
  MetadatumCondition: MetadatumCondition;
  MetadatumFilter: MetadatumFilter;
  MetadatumInput: MetadatumInput;
  MetadatumMetadataPkeyConnect: MetadatumMetadataPkeyConnect;
  MetadatumMetadataPkeyDelete: MetadatumMetadataPkeyDelete;
  MetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingMetadataPkeyUpdate: MetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdUsingMetadataPkeyUpdate;
  MetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingMetadataPkeyUpdate: MetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdUsingMetadataPkeyUpdate;
  MetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataPkeyUpdate: MetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdUsingMetadataPkeyUpdate;
  MetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingMetadataPkeyUpdate: MetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingMetadataPkeyUpdate;
  MetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingMetadataPkeyUpdate: MetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingMetadataPkeyUpdate;
  MetadatumPatch: MetadatumPatch;
  MetadatumToManyFileMetadatumFilter: MetadatumToManyFileMetadatumFilter;
  MetadatumToManyFileOutputGroupMetadatumFilter: MetadatumToManyFileOutputGroupMetadatumFilter;
  MetadatumToManyMetadataValueFilter: MetadatumToManyMetadataValueFilter;
  Mutation: {};
  Notification: Notification;
  NotificationCondition: NotificationCondition;
  NotificationFilter: NotificationFilter;
  NotificationNotificationPkeyConnect: NotificationNotificationPkeyConnect;
  NotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingNotificationPkeyUpdate: NotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdUsingNotificationPkeyUpdate;
  NotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingNotificationPkeyUpdate: NotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdUsingNotificationPkeyUpdate;
  NotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingNotificationPkeyUpdate: NotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingNotificationPkeyUpdate;
  NotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingNotificationPkeyUpdate: NotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingNotificationPkeyUpdate;
  NotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingNotificationPkeyUpdate: NotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingNotificationPkeyUpdate;
  NotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingNotificationPkeyUpdate: NotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingNotificationPkeyUpdate;
  NotificationPatch: NotificationPatch;
  NotificationUserId1002Fc38FkApplicationUserIdApplicationUserCreateInput: NotificationUserId1002Fc38FkApplicationUserIdApplicationUserCreateInput;
  NotificationUserId1002Fc38FkApplicationUserIdInput: NotificationUserId1002Fc38FkApplicationUserIdInput;
  NotificationUserId1002Fc38FkApplicationUserIdInverseInput: NotificationUserId1002Fc38FkApplicationUserIdInverseInput;
  NotificationsConnection: NotificationsConnection;
  NotificationsEdge: NotificationsEdge;
  OutputGroupFile: OutputGroupFile;
  OutputGroupFileCondition: OutputGroupFileCondition;
  OutputGroupFileFilter: OutputGroupFileFilter;
  OutputGroupFileInput: OutputGroupFileInput;
  OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingOutputGroupFilesPkeyUpdate: OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdUsingOutputGroupFilesPkeyUpdate;
  OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingOutputGroupFilesPkeyUpdate: OutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpUsingOutputGroupFilesPkeyUpdate;
  OutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingOutputGroupFilesPkeyUpdate: OutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingOutputGroupFilesPkeyUpdate;
  OutputGroupFileOutputGroupFilesPkeyConnect: OutputGroupFileOutputGroupFilesPkeyConnect;
  OutputGroupFileOutputGroupFilesPkeyDelete: OutputGroupFileOutputGroupFilesPkeyDelete;
  OutputGroupFilePatch: OutputGroupFilePatch;
  OutputGroupFilesConnection: OutputGroupFilesConnection;
  OutputGroupFilesEdge: OutputGroupFilesEdge;
  OutputGroupFilesFileIdEdeabb23FkFileIdFileCreateInput: OutputGroupFilesFileIdEdeabb23FkFileIdFileCreateInput;
  OutputGroupFilesFileIdEdeabb23FkFileIdInput: OutputGroupFilesFileIdEdeabb23FkFileIdInput;
  OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput: OutputGroupFilesFileIdEdeabb23FkFileIdInverseInput;
  OutputGroupFilesFileIdEdeabb23FkFileIdOutputGroupFilesCreateInput: OutputGroupFilesFileIdEdeabb23FkFileIdOutputGroupFilesCreateInput;
  OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput: OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInput;
  OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput: OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpInverseInput;
  OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpOutputGroupFilesCreateInput: OutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpOutputGroupFilesCreateInput;
  OutputGroupFilesProjectId8709B561FkProjectIdInput: OutputGroupFilesProjectId8709B561FkProjectIdInput;
  OutputGroupFilesProjectId8709B561FkProjectIdInverseInput: OutputGroupFilesProjectId8709B561FkProjectIdInverseInput;
  OutputGroupFilesProjectId8709B561FkProjectIdOutputGroupFilesCreateInput: OutputGroupFilesProjectId8709B561FkProjectIdOutputGroupFilesCreateInput;
  PageInfo: PageInfo;
  PinnedTool: PinnedTool;
  PinnedToolCondition: PinnedToolCondition;
  PinnedToolFilter: PinnedToolFilter;
  PinnedToolInput: PinnedToolInput;
  PinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingPinnedToolPkeyUpdate: PinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingPinnedToolPkeyUpdate;
  PinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingPinnedToolUniqueUpdate: PinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingPinnedToolUniqueUpdate;
  PinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingPinnedToolPkeyUpdate: PinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingPinnedToolPkeyUpdate;
  PinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingPinnedToolUniqueUpdate: PinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdUsingPinnedToolUniqueUpdate;
  PinnedToolPatch: PinnedToolPatch;
  PinnedToolPinnedToolPkeyConnect: PinnedToolPinnedToolPkeyConnect;
  PinnedToolPinnedToolPkeyDelete: PinnedToolPinnedToolPkeyDelete;
  PinnedToolPinnedToolUniqueConnect: PinnedToolPinnedToolUniqueConnect;
  PinnedToolPinnedToolUniqueDelete: PinnedToolPinnedToolUniqueDelete;
  PinnedToolToolId7Ba143DfFkToolIdInput: PinnedToolToolId7Ba143DfFkToolIdInput;
  PinnedToolToolId7Ba143DfFkToolIdInverseInput: PinnedToolToolId7Ba143DfFkToolIdInverseInput;
  PinnedToolToolId7Ba143DfFkToolIdPinnedToolCreateInput: PinnedToolToolId7Ba143DfFkToolIdPinnedToolCreateInput;
  PinnedToolToolId7Ba143DfFkToolIdToolCreateInput: PinnedToolToolId7Ba143DfFkToolIdToolCreateInput;
  PinnedToolUserId59D3492DFkApplicationUserIdApplicationUserCreateInput: PinnedToolUserId59D3492DFkApplicationUserIdApplicationUserCreateInput;
  PinnedToolUserId59D3492DFkApplicationUserIdInput: PinnedToolUserId59D3492DFkApplicationUserIdInput;
  PinnedToolUserId59D3492DFkApplicationUserIdInverseInput: PinnedToolUserId59D3492DFkApplicationUserIdInverseInput;
  PinnedToolUserId59D3492DFkApplicationUserIdPinnedToolCreateInput: PinnedToolUserId59D3492DFkApplicationUserIdPinnedToolCreateInput;
  PinnedToolsConnection: PinnedToolsConnection;
  PinnedToolsEdge: PinnedToolsEdge;
  Project: Project;
  ProjectCloneSourceId92Ccacf5FkProjectIdInput: ProjectCloneSourceId92Ccacf5FkProjectIdInput;
  ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput: ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInput;
  ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput: ProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIInverseInput;
  ProjectClonedNotifUserId4Fd693D7FkApplicatiApplicationUserCreateInput: ProjectClonedNotifUserId4Fd693D7FkApplicatiApplicationUserCreateInput;
  ProjectClonedNotifUserId4Fd693D7FkApplicatiInput: ProjectClonedNotifUserId4Fd693D7FkApplicatiInput;
  ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput: ProjectClonedNotifUserId4Fd693D7FkApplicatiInverseInput;
  ProjectClonedNotification: ProjectClonedNotification;
  ProjectClonedNotificationCondition: ProjectClonedNotificationCondition;
  ProjectClonedNotificationFilter: ProjectClonedNotificationFilter;
  ProjectClonedNotificationIdD235A018FkNotificationIdInput: ProjectClonedNotificationIdD235A018FkNotificationIdInput;
  ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput: ProjectClonedNotificationIdD235A018FkNotificationIdInverseInput;
  ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectClonedNotificationPkeyUpdate: ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectClonedNotificationPkeyUpdate;
  ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingProjectClonedNotificationPkeyUpdate: ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiUsingProjectClonedNotificationPkeyUpdate;
  ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingProjectClonedNotificationPkeyUpdate: ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdUsingProjectClonedNotificationPkeyUpdate;
  ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectClonedNotificationPkeyUpdate: ProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectClonedNotificationPkeyUpdate;
  ProjectClonedNotificationProjectClonedNotificationPkeyConnect: ProjectClonedNotificationProjectClonedNotificationPkeyConnect;
  ProjectClonedNotificationProjectIdF6267374FkProjectIdInput: ProjectClonedNotificationProjectIdF6267374FkProjectIdInput;
  ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput: ProjectClonedNotificationProjectIdF6267374FkProjectIdInverseInput;
  ProjectClonedNotificationsConnection: ProjectClonedNotificationsConnection;
  ProjectClonedNotificationsEdge: ProjectClonedNotificationsEdge;
  ProjectCondition: ProjectCondition;
  ProjectFilter: ProjectFilter;
  ProjectFolder: ProjectFolder;
  ProjectFolderCondition: ProjectFolderCondition;
  ProjectFolderFilter: ProjectFolderFilter;
  ProjectFolderInput: ProjectFolderInput;
  ProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingProjectFolderPkeyUpdate: ProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdUsingProjectFolderPkeyUpdate;
  ProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingProjectFolderPkeyUpdate: ProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdUsingProjectFolderPkeyUpdate;
  ProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectFolderPkeyUpdate: ProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectFolderPkeyUpdate;
  ProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingProjectFolderPkeyUpdate: ProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdUsingProjectFolderPkeyUpdate;
  ProjectFolderPatch: ProjectFolderPatch;
  ProjectFolderProjectFolderPkeyConnect: ProjectFolderProjectFolderPkeyConnect;
  ProjectFolderProjectFolderPkeyDelete: ProjectFolderProjectFolderPkeyDelete;
  ProjectFolderProjectIdEf44DadfFkProjectIdInput: ProjectFolderProjectIdEf44DadfFkProjectIdInput;
  ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput: ProjectFolderProjectIdEf44DadfFkProjectIdInverseInput;
  ProjectFolderProjectIdEf44DadfFkProjectIdProjectFolderCreateInput: ProjectFolderProjectIdEf44DadfFkProjectIdProjectFolderCreateInput;
  ProjectFolderToManyDataTableFilter: ProjectFolderToManyDataTableFilter;
  ProjectFolderToManyGdtAnalysisTableFilter: ProjectFolderToManyGdtAnalysisTableFilter;
  ProjectFolderUserIdF2E16179FkApplicationUserIdApplicationUserCreateInput: ProjectFolderUserIdF2E16179FkApplicationUserIdApplicationUserCreateInput;
  ProjectFolderUserIdF2E16179FkApplicationUserIdInput: ProjectFolderUserIdF2E16179FkApplicationUserIdInput;
  ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput: ProjectFolderUserIdF2E16179FkApplicationUserIdInverseInput;
  ProjectFolderUserIdF2E16179FkApplicationUserIdProjectFolderCreateInput: ProjectFolderUserIdF2E16179FkApplicationUserIdProjectFolderCreateInput;
  ProjectFoldersConnection: ProjectFoldersConnection;
  ProjectFoldersEdge: ProjectFoldersEdge;
  ProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingProjectPkeyUpdate: ProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingProjectPkeyUpdate: ProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingProjectPkeyUpdate: ProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIUsingProjectPkeyUpdate;
  ProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingProjectPkeyUpdate: ProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectPkeyUpdate: ProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingProjectPkeyUpdate: ProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectPkeyUpdate: ProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectPkeyUpdate: ProjectOnFileForFileProjectId3Ecca975FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectPkeyUpdate: ProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectPkeyUpdate: ProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectPkeyUpdate: ProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingProjectPkeyUpdate: ProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingProjectPkeyUpdate: ProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingProjectPkeyUpdate: ProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIUsingProjectPkeyUpdate;
  ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectPkeyUpdate: ProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectPkeyUpdate: ProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectPkeyUpdate: ProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectPkeyUpdate: ProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectPkeyUpdate: ProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectPkeyUpdate: ProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIUsingProjectPkeyUpdate;
  ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectPkeyUpdate: ProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingProjectPkeyUpdate;
  ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectPkeyUpdate: ProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdUsingProjectPkeyUpdate;
  ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectPkeyUpdate;
  ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectPkeyUpdate: ProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectPkeyUpdate: ProjectOnTaskForTaskProjectId963D6354FkProjectIdUsingProjectPkeyUpdate;
  ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectKeyTenantUniqueUpdate: ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectKeyTenantUniqueUpdate;
  ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectPkeyUpdate: ProjectOnToolForToolProjectId20A84210FkProjectIdUsingProjectPkeyUpdate;
  ProjectProjectKeyTenantUniqueConnect: ProjectProjectKeyTenantUniqueConnect;
  ProjectProjectPkeyConnect: ProjectProjectPkeyConnect;
  ProjectSharedNotifSharerIdAbe16C5BFkApplicatiApplicationUserCreateInput: ProjectSharedNotifSharerIdAbe16C5BFkApplicatiApplicationUserCreateInput;
  ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput: ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInput;
  ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput: ProjectSharedNotifSharerIdAbe16C5BFkApplicatiInverseInput;
  ProjectSharedNotifUserId9A19122FFkApplicatiApplicationUserCreateInput: ProjectSharedNotifUserId9A19122FFkApplicatiApplicationUserCreateInput;
  ProjectSharedNotifUserId9A19122FFkApplicatiInput: ProjectSharedNotifUserId9A19122FFkApplicatiInput;
  ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput: ProjectSharedNotifUserId9A19122FFkApplicatiInverseInput;
  ProjectSharedNotification: ProjectSharedNotification;
  ProjectSharedNotificationCondition: ProjectSharedNotificationCondition;
  ProjectSharedNotificationFilter: ProjectSharedNotificationFilter;
  ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput: ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInput;
  ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput: ProjectSharedNotificationIdD5Cd7E61FkNotificationIdInverseInput;
  ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingProjectSharedNotificationPkeyUpdate: ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiUsingProjectSharedNotificationPkeyUpdate;
  ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingProjectSharedNotificationPkeyUpdate: ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiUsingProjectSharedNotificationPkeyUpdate;
  ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingProjectSharedNotificationPkeyUpdate: ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdUsingProjectSharedNotificationPkeyUpdate;
  ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectSharedNotificationPkeyUpdate: ProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdUsingProjectSharedNotificationPkeyUpdate;
  ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput: ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInput;
  ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput: ProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdInverseInput;
  ProjectSharedNotificationProjectSharedNotificationPkeyConnect: ProjectSharedNotificationProjectSharedNotificationPkeyConnect;
  ProjectSharedNotificationsConnection: ProjectSharedNotificationsConnection;
  ProjectSharedNotificationsEdge: ProjectSharedNotificationsEdge;
  ProjectTag: ProjectTag;
  ProjectTagCondition: ProjectTagCondition;
  ProjectTagFilter: ProjectTagFilter;
  ProjectTagInput: ProjectTagInput;
  ProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectTagPkeyUpdate: ProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdUsingProjectTagPkeyUpdate;
  ProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingProjectTagPkeyUpdate: ProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdUsingProjectTagPkeyUpdate;
  ProjectTagPatch: ProjectTagPatch;
  ProjectTagProjectId5Ab280C9FkProjectIdInput: ProjectTagProjectId5Ab280C9FkProjectIdInput;
  ProjectTagProjectId5Ab280C9FkProjectIdInverseInput: ProjectTagProjectId5Ab280C9FkProjectIdInverseInput;
  ProjectTagProjectId5Ab280C9FkProjectIdProjectTagCreateInput: ProjectTagProjectId5Ab280C9FkProjectIdProjectTagCreateInput;
  ProjectTagProjectTagPkeyConnect: ProjectTagProjectTagPkeyConnect;
  ProjectTagProjectTagPkeyDelete: ProjectTagProjectTagPkeyDelete;
  ProjectTagUserId780C8348FkApplicationUserIdApplicationUserCreateInput: ProjectTagUserId780C8348FkApplicationUserIdApplicationUserCreateInput;
  ProjectTagUserId780C8348FkApplicationUserIdInput: ProjectTagUserId780C8348FkApplicationUserIdInput;
  ProjectTagUserId780C8348FkApplicationUserIdInverseInput: ProjectTagUserId780C8348FkApplicationUserIdInverseInput;
  ProjectTagUserId780C8348FkApplicationUserIdProjectTagCreateInput: ProjectTagUserId780C8348FkApplicationUserIdProjectTagCreateInput;
  ProjectTagsConnection: ProjectTagsConnection;
  ProjectTagsEdge: ProjectTagsEdge;
  ProjectTenantId03F0Ca53FkTenantIdInput: ProjectTenantId03F0Ca53FkTenantIdInput;
  ProjectTenantId03F0Ca53FkTenantIdInverseInput: ProjectTenantId03F0Ca53FkTenantIdInverseInput;
  ProjectTenantId03F0Ca53FkTenantIdTenantCreateInput: ProjectTenantId03F0Ca53FkTenantIdTenantCreateInput;
  ProjectToManyDataTableCellFilter: ProjectToManyDataTableCellFilter;
  ProjectToManyDataTableColumnDefinitionBooleanFilter: ProjectToManyDataTableColumnDefinitionBooleanFilter;
  ProjectToManyDataTableColumnDefinitionCellStatusFilter: ProjectToManyDataTableColumnDefinitionCellStatusFilter;
  ProjectToManyDataTableColumnDefinitionChoiceFilter: ProjectToManyDataTableColumnDefinitionChoiceFilter;
  ProjectToManyDataTableColumnDefinitionDateFilter: ProjectToManyDataTableColumnDefinitionDateFilter;
  ProjectToManyDataTableColumnDefinitionFileFilter: ProjectToManyDataTableColumnDefinitionFileFilter;
  ProjectToManyDataTableColumnDefinitionFloatFilter: ProjectToManyDataTableColumnDefinitionFloatFilter;
  ProjectToManyDataTableColumnDefinitionIdentifierFilter: ProjectToManyDataTableColumnDefinitionIdentifierFilter;
  ProjectToManyDataTableColumnDefinitionIntegerFilter: ProjectToManyDataTableColumnDefinitionIntegerFilter;
  ProjectToManyDataTableColumnDefinitionJoinFilter: ProjectToManyDataTableColumnDefinitionJoinFilter;
  ProjectToManyDataTableColumnDefinitionMetadatumFilter: ProjectToManyDataTableColumnDefinitionMetadatumFilter;
  ProjectToManyDataTableColumnDefinitionRoiFrameFilter: ProjectToManyDataTableColumnDefinitionRoiFrameFilter;
  ProjectToManyDataTableColumnDefinitionTextFilter: ProjectToManyDataTableColumnDefinitionTextFilter;
  ProjectToManyDataTableColumnFilter: ProjectToManyDataTableColumnFilter;
  ProjectToManyDataTableColumnGroupDefinitionJoinFilter: ProjectToManyDataTableColumnGroupDefinitionJoinFilter;
  ProjectToManyDataTableColumnGroupDefinitionSourceFilter: ProjectToManyDataTableColumnGroupDefinitionSourceFilter;
  ProjectToManyDataTableColumnGroupFilter: ProjectToManyDataTableColumnGroupFilter;
  ProjectToManyDataTableFilter: ProjectToManyDataTableFilter;
  ProjectToManyDataTableRowFilter: ProjectToManyDataTableRowFilter;
  ProjectToManyFileActivityFilter: ProjectToManyFileActivityFilter;
  ProjectToManyFileFilter: ProjectToManyFileFilter;
  ProjectToManyFileMetadatumFilter: ProjectToManyFileMetadatumFilter;
  ProjectToManyFileOutputGroupFilter: ProjectToManyFileOutputGroupFilter;
  ProjectToManyFileOutputGroupMetadatumFilter: ProjectToManyFileOutputGroupMetadatumFilter;
  ProjectToManyGdtAnalysisTableCellFilter: ProjectToManyGdtAnalysisTableCellFilter;
  ProjectToManyGdtAnalysisTableColumnFilter: ProjectToManyGdtAnalysisTableColumnFilter;
  ProjectToManyGdtAnalysisTableColumnGroupFilter: ProjectToManyGdtAnalysisTableColumnGroupFilter;
  ProjectToManyGdtAnalysisTableFilter: ProjectToManyGdtAnalysisTableFilter;
  ProjectToManyGdtAnalysisTableRowFilter: ProjectToManyGdtAnalysisTableRowFilter;
  ProjectToManyMetadataValueFilter: ProjectToManyMetadataValueFilter;
  ProjectToManyMetadatumFilter: ProjectToManyMetadatumFilter;
  ProjectToManyOutputGroupFileFilter: ProjectToManyOutputGroupFileFilter;
  ProjectToManyProjectClonedNotificationFilter: ProjectToManyProjectClonedNotificationFilter;
  ProjectToManyProjectFilter: ProjectToManyProjectFilter;
  ProjectToManyProjectFolderFilter: ProjectToManyProjectFolderFilter;
  ProjectToManyProjectSharedNotificationFilter: ProjectToManyProjectSharedNotificationFilter;
  ProjectToManyProjectTagFilter: ProjectToManyProjectTagFilter;
  ProjectToManyTaskFilter: ProjectToManyTaskFilter;
  ProjectUserIdB5Fbb914FkApplicationUserIdApplicationUserCreateInput: ProjectUserIdB5Fbb914FkApplicationUserIdApplicationUserCreateInput;
  ProjectUserIdB5Fbb914FkApplicationUserIdInput: ProjectUserIdB5Fbb914FkApplicationUserIdInput;
  ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput: ProjectUserIdB5Fbb914FkApplicationUserIdInverseInput;
  ProjectsConnection: ProjectsConnection;
  ProjectsEdge: ProjectsEdge;
  Query: {};
  RoleChangeNotificaUserId879Bd49AFkApplicatiApplicationUserCreateInput: RoleChangeNotificaUserId879Bd49AFkApplicatiApplicationUserCreateInput;
  RoleChangeNotificaUserId879Bd49AFkApplicatiInput: RoleChangeNotificaUserId879Bd49AFkApplicatiInput;
  RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput: RoleChangeNotificaUserId879Bd49AFkApplicatiInverseInput;
  RoleChangeNotification: RoleChangeNotification;
  RoleChangeNotificationCondition: RoleChangeNotificationCondition;
  RoleChangeNotificationFilter: RoleChangeNotificationFilter;
  RoleChangeNotificationIdD576A528FkNotificationIdInput: RoleChangeNotificationIdD576A528FkNotificationIdInput;
  RoleChangeNotificationIdD576A528FkNotificationIdInverseInput: RoleChangeNotificationIdD576A528FkNotificationIdInverseInput;
  RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingRoleChangeNotificationPkeyUpdate: RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiUsingRoleChangeNotificationPkeyUpdate;
  RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingRoleChangeNotificationPkeyUpdate: RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdUsingRoleChangeNotificationPkeyUpdate;
  RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingRoleChangeNotificationPkeyUpdate: RoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingRoleChangeNotificationPkeyUpdate;
  RoleChangeNotificationRoleChangeNotificationPkeyConnect: RoleChangeNotificationRoleChangeNotificationPkeyConnect;
  RoleChangeNotificationTenantId36852Ce9FkTenantIdInput: RoleChangeNotificationTenantId36852Ce9FkTenantIdInput;
  RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput: RoleChangeNotificationTenantId36852Ce9FkTenantIdInverseInput;
  RoleChangeNotificationTenantId36852Ce9FkTenantIdTenantCreateInput: RoleChangeNotificationTenantId36852Ce9FkTenantIdTenantCreateInput;
  RoleChangeNotificationsConnection: RoleChangeNotificationsConnection;
  RoleChangeNotificationsEdge: RoleChangeNotificationsEdge;
  Run: Run;
  RunCondition: RunCondition;
  RunFilter: RunFilter;
  RunInput: RunInput;
  RunOnRunForRunTenantId73Fbd8D9FkTenantIdUsingRunPkeyUpdate: RunOnRunForRunTenantId73Fbd8D9FkTenantIdUsingRunPkeyUpdate;
  RunPatch: RunPatch;
  RunRunPkeyConnect: RunRunPkeyConnect;
  RunRunPkeyDelete: RunRunPkeyDelete;
  RunTenantId73Fbd8D9FkTenantIdInput: RunTenantId73Fbd8D9FkTenantIdInput;
  RunTenantId73Fbd8D9FkTenantIdInverseInput: RunTenantId73Fbd8D9FkTenantIdInverseInput;
  RunTenantId73Fbd8D9FkTenantIdRunCreateInput: RunTenantId73Fbd8D9FkTenantIdRunCreateInput;
  RunTenantId73Fbd8D9FkTenantIdTenantCreateInput: RunTenantId73Fbd8D9FkTenantIdTenantCreateInput;
  RunsConnection: RunsConnection;
  RunsEdge: RunsEdge;
  String: Scalars["String"]["output"];
  StringFilter: StringFilter;
  Subscription: {};
  Task: Task;
  TaskActivitiesConnection: TaskActivitiesConnection;
  TaskActivitiesEdge: TaskActivitiesEdge;
  TaskActivity: TaskActivity;
  TaskActivityCondition: TaskActivityCondition;
  TaskActivityCostId49E66058FkCostIdCostCreateInput: TaskActivityCostId49E66058FkCostIdCostCreateInput;
  TaskActivityCostId49E66058FkCostIdInput: TaskActivityCostId49E66058FkCostIdInput;
  TaskActivityCostId49E66058FkCostIdInverseInput: TaskActivityCostId49E66058FkCostIdInverseInput;
  TaskActivityCostId49E66058FkCostIdTaskActivityCreateInput: TaskActivityCostId49E66058FkCostIdTaskActivityCreateInput;
  TaskActivityFilter: TaskActivityFilter;
  TaskActivityInput: TaskActivityInput;
  TaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingTaskActivityPkeyUpdate: TaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingTaskActivityPkeyUpdate;
  TaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingTaskActivityTaskIdKeyUpdate: TaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdUsingTaskActivityTaskIdKeyUpdate;
  TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityPkeyUpdate: TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityPkeyUpdate;
  TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityTaskIdKeyUpdate: TaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskActivityTaskIdKeyUpdate;
  TaskActivityPatch: TaskActivityPatch;
  TaskActivityTaskActivityPkeyConnect: TaskActivityTaskActivityPkeyConnect;
  TaskActivityTaskActivityPkeyDelete: TaskActivityTaskActivityPkeyDelete;
  TaskActivityTaskActivityTaskIdKeyConnect: TaskActivityTaskActivityTaskIdKeyConnect;
  TaskActivityTaskActivityTaskIdKeyDelete: TaskActivityTaskActivityTaskIdKeyDelete;
  TaskActivityTaskIdC451Ae92FkTaskIdInput: TaskActivityTaskIdC451Ae92FkTaskIdInput;
  TaskActivityTaskIdC451Ae92FkTaskIdInverseInput: TaskActivityTaskIdC451Ae92FkTaskIdInverseInput;
  TaskActivityTaskIdC451Ae92FkTaskIdTaskActivityCreateInput: TaskActivityTaskIdC451Ae92FkTaskIdTaskActivityCreateInput;
  TaskActivityTaskIdC451Ae92FkTaskIdTaskCreateInput: TaskActivityTaskIdC451Ae92FkTaskIdTaskCreateInput;
  TaskCondition: TaskCondition;
  TaskContainerImageId92Ed2DaeFkContainerImageIdContainerImageCreateInput: TaskContainerImageId92Ed2DaeFkContainerImageIdContainerImageCreateInput;
  TaskContainerImageId92Ed2DaeFkContainerImageIdInput: TaskContainerImageId92Ed2DaeFkContainerImageIdInput;
  TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput: TaskContainerImageId92Ed2DaeFkContainerImageIdInverseInput;
  TaskContainerImageId92Ed2DaeFkContainerImageIdTaskCreateInput: TaskContainerImageId92Ed2DaeFkContainerImageIdTaskCreateInput;
  TaskExecutorId24A67329FkTesTaskexecutorIdInput: TaskExecutorId24A67329FkTesTaskexecutorIdInput;
  TaskExecutorId24A67329FkTesTaskexecutorIdInverseInput: TaskExecutorId24A67329FkTesTaskexecutorIdInverseInput;
  TaskExecutorId24A67329FkTesTaskexecutorIdTaskCreateInput: TaskExecutorId24A67329FkTesTaskexecutorIdTaskCreateInput;
  TaskExecutorId24A67329FkTesTaskexecutorIdTesTaskexecutorCreateInput: TaskExecutorId24A67329FkTesTaskexecutorIdTesTaskexecutorCreateInput;
  TaskFilter: TaskFilter;
  TaskInput: TaskInput;
  TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskPkeyUpdate: TaskOnFileForFileTaskIdE4Da87AeFkTaskIdUsingTaskPkeyUpdate;
  TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskPkeyUpdate: TaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdUsingTaskPkeyUpdate;
  TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskPkeyUpdate: TaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdUsingTaskPkeyUpdate;
  TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskPkeyUpdate: TaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskPkeyUpdate: TaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingTaskPkeyUpdate: TaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTaskPkeyUpdate: TaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskPkeyUpdate: TaskOnTaskForTaskProjectId963D6354FkProjectIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskPkeyUpdate: TaskOnTaskForTaskTenantId148E90DaFkTenantIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskPkeyUpdate: TaskOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingTaskPkeyUpdate;
  TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskPkeyUpdate: TaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdUsingTaskPkeyUpdate;
  TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskPkeyUpdate: TaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskPkeyUpdate: TaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskPkeyUpdate: TaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskPkeyUpdate;
  TaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskExecutorIdKeyUpdate: TaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskExecutorIdKeyUpdate;
  TaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskPkeyUpdate: TaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskPkeyUpdate;
  TaskPatch: TaskPatch;
  TaskProjectId963D6354FkProjectIdInput: TaskProjectId963D6354FkProjectIdInput;
  TaskProjectId963D6354FkProjectIdInverseInput: TaskProjectId963D6354FkProjectIdInverseInput;
  TaskProjectId963D6354FkProjectIdTaskCreateInput: TaskProjectId963D6354FkProjectIdTaskCreateInput;
  TaskResource: TaskResource;
  TaskResourceCondition: TaskResourceCondition;
  TaskResourceFilter: TaskResourceFilter;
  TaskResourceInput: TaskResourceInput;
  TaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskResourcePkeyUpdate: TaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdUsingTaskResourcePkeyUpdate;
  TaskResourcePatch: TaskResourcePatch;
  TaskResourceTaskId73Fcabc0FkTaskIdInput: TaskResourceTaskId73Fcabc0FkTaskIdInput;
  TaskResourceTaskId73Fcabc0FkTaskIdInverseInput: TaskResourceTaskId73Fcabc0FkTaskIdInverseInput;
  TaskResourceTaskId73Fcabc0FkTaskIdTaskCreateInput: TaskResourceTaskId73Fcabc0FkTaskIdTaskCreateInput;
  TaskResourceTaskId73Fcabc0FkTaskIdTaskResourceCreateInput: TaskResourceTaskId73Fcabc0FkTaskIdTaskResourceCreateInput;
  TaskResourceTaskResourcePkeyConnect: TaskResourceTaskResourcePkeyConnect;
  TaskResourceTaskResourcePkeyDelete: TaskResourceTaskResourcePkeyDelete;
  TaskResourceUsage: TaskResourceUsage;
  TaskResourceUsageCondition: TaskResourceUsageCondition;
  TaskResourceUsageFilter: TaskResourceUsageFilter;
  TaskResourceUsageInput: TaskResourceUsageInput;
  TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsagePkeyUpdate: TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsagePkeyUpdate;
  TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsageTaskIdKeyUpdate: TaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdUsingTaskResourceUsageTaskIdKeyUpdate;
  TaskResourceUsagePatch: TaskResourceUsagePatch;
  TaskResourceUsageTaskIdA28F1580FkTaskIdInput: TaskResourceUsageTaskIdA28F1580FkTaskIdInput;
  TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput: TaskResourceUsageTaskIdA28F1580FkTaskIdInverseInput;
  TaskResourceUsageTaskIdA28F1580FkTaskIdTaskCreateInput: TaskResourceUsageTaskIdA28F1580FkTaskIdTaskCreateInput;
  TaskResourceUsageTaskIdA28F1580FkTaskIdTaskResourceUsageCreateInput: TaskResourceUsageTaskIdA28F1580FkTaskIdTaskResourceUsageCreateInput;
  TaskResourceUsageTaskResourceUsagePkeyConnect: TaskResourceUsageTaskResourceUsagePkeyConnect;
  TaskResourceUsageTaskResourceUsagePkeyDelete: TaskResourceUsageTaskResourceUsagePkeyDelete;
  TaskResourceUsageTaskResourceUsageTaskIdKeyConnect: TaskResourceUsageTaskResourceUsageTaskIdKeyConnect;
  TaskResourceUsageTaskResourceUsageTaskIdKeyDelete: TaskResourceUsageTaskResourceUsageTaskIdKeyDelete;
  TaskResourceUsagesConnection: TaskResourceUsagesConnection;
  TaskResourceUsagesEdge: TaskResourceUsagesEdge;
  TaskResourcesConnection: TaskResourcesConnection;
  TaskResourcesEdge: TaskResourcesEdge;
  TaskSource: TaskSource;
  TaskSourceCondition: TaskSourceCondition;
  TaskSourceFileId2F628862FkFileIdFileCreateInput: TaskSourceFileId2F628862FkFileIdFileCreateInput;
  TaskSourceFileId2F628862FkFileIdInput: TaskSourceFileId2F628862FkFileIdInput;
  TaskSourceFileId2F628862FkFileIdInverseInput: TaskSourceFileId2F628862FkFileIdInverseInput;
  TaskSourceFileId2F628862FkFileIdTaskSourceCreateInput: TaskSourceFileId2F628862FkFileIdTaskSourceCreateInput;
  TaskSourceFilter: TaskSourceFilter;
  TaskSourceInput: TaskSourceInput;
  TaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingTaskSourcePkeyUpdate: TaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdUsingTaskSourcePkeyUpdate;
  TaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskSourcePkeyUpdate: TaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdUsingTaskSourcePkeyUpdate;
  TaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingTaskSourcePkeyUpdate: TaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingTaskSourcePkeyUpdate;
  TaskSourcePatch: TaskSourcePatch;
  TaskSourceTaskIdF241BaedFkTaskIdInput: TaskSourceTaskIdF241BaedFkTaskIdInput;
  TaskSourceTaskIdF241BaedFkTaskIdInverseInput: TaskSourceTaskIdF241BaedFkTaskIdInverseInput;
  TaskSourceTaskIdF241BaedFkTaskIdTaskCreateInput: TaskSourceTaskIdF241BaedFkTaskIdTaskCreateInput;
  TaskSourceTaskIdF241BaedFkTaskIdTaskSourceCreateInput: TaskSourceTaskIdF241BaedFkTaskIdTaskSourceCreateInput;
  TaskSourceTaskSourcePkeyConnect: TaskSourceTaskSourcePkeyConnect;
  TaskSourceTaskSourcePkeyDelete: TaskSourceTaskSourcePkeyDelete;
  TaskSourceToolSourceId14453EdbFkToolSourceIdInput: TaskSourceToolSourceId14453EdbFkToolSourceIdInput;
  TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput: TaskSourceToolSourceId14453EdbFkToolSourceIdInverseInput;
  TaskSourceToolSourceId14453EdbFkToolSourceIdTaskSourceCreateInput: TaskSourceToolSourceId14453EdbFkToolSourceIdTaskSourceCreateInput;
  TaskSourceToolSourceId14453EdbFkToolSourceIdToolSourceCreateInput: TaskSourceToolSourceId14453EdbFkToolSourceIdToolSourceCreateInput;
  TaskSourcesConnection: TaskSourcesConnection;
  TaskSourcesEdge: TaskSourcesEdge;
  TaskStatusLog: TaskStatusLog;
  TaskStatusLogCondition: TaskStatusLogCondition;
  TaskStatusLogFilter: TaskStatusLogFilter;
  TaskStatusLogInput: TaskStatusLogInput;
  TaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskStatusLogPkeyUpdate: TaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskStatusLogPkeyUpdate;
  TaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskStatusLogUniqueStatusPerTaskUpdate: TaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdUsingTaskStatusLogUniqueStatusPerTaskUpdate;
  TaskStatusLogPatch: TaskStatusLogPatch;
  TaskStatusLogTaskIdFe1B9D0BFkTaskIdInput: TaskStatusLogTaskIdFe1B9D0BFkTaskIdInput;
  TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput: TaskStatusLogTaskIdFe1B9D0BFkTaskIdInverseInput;
  TaskStatusLogTaskIdFe1B9D0BFkTaskIdTaskCreateInput: TaskStatusLogTaskIdFe1B9D0BFkTaskIdTaskCreateInput;
  TaskStatusLogTaskIdFe1B9D0BFkTaskIdTaskStatusLogCreateInput: TaskStatusLogTaskIdFe1B9D0BFkTaskIdTaskStatusLogCreateInput;
  TaskStatusLogTaskStatusLogPkeyConnect: TaskStatusLogTaskStatusLogPkeyConnect;
  TaskStatusLogTaskStatusLogPkeyDelete: TaskStatusLogTaskStatusLogPkeyDelete;
  TaskStatusLogTaskStatusLogUniqueStatusPerTaskConnect: TaskStatusLogTaskStatusLogUniqueStatusPerTaskConnect;
  TaskStatusLogTaskStatusLogUniqueStatusPerTaskDelete: TaskStatusLogTaskStatusLogUniqueStatusPerTaskDelete;
  TaskStatusLogsConnection: TaskStatusLogsConnection;
  TaskStatusLogsEdge: TaskStatusLogsEdge;
  TaskTaskExecutorIdKeyConnect: TaskTaskExecutorIdKeyConnect;
  TaskTaskExecutorIdKeyDelete: TaskTaskExecutorIdKeyDelete;
  TaskTaskPkeyConnect: TaskTaskPkeyConnect;
  TaskTaskPkeyDelete: TaskTaskPkeyDelete;
  TaskTenantId148E90DaFkTenantIdInput: TaskTenantId148E90DaFkTenantIdInput;
  TaskTenantId148E90DaFkTenantIdInverseInput: TaskTenantId148E90DaFkTenantIdInverseInput;
  TaskTenantId148E90DaFkTenantIdTaskCreateInput: TaskTenantId148E90DaFkTenantIdTaskCreateInput;
  TaskTenantId148E90DaFkTenantIdTenantCreateInput: TaskTenantId148E90DaFkTenantIdTenantCreateInput;
  TaskToManyFileFilter: TaskToManyFileFilter;
  TaskToManyMetadataValueFilter: TaskToManyMetadataValueFilter;
  TaskToManyTaskResourceFilter: TaskToManyTaskResourceFilter;
  TaskToManyTaskSourceFilter: TaskToManyTaskSourceFilter;
  TaskToManyTaskStatusLogFilter: TaskToManyTaskStatusLogFilter;
  TaskToolVersionId14506837FkToolVersionIdInput: TaskToolVersionId14506837FkToolVersionIdInput;
  TaskToolVersionId14506837FkToolVersionIdInverseInput: TaskToolVersionId14506837FkToolVersionIdInverseInput;
  TaskToolVersionId14506837FkToolVersionIdTaskCreateInput: TaskToolVersionId14506837FkToolVersionIdTaskCreateInput;
  TaskToolVersionId14506837FkToolVersionIdToolVersionCreateInput: TaskToolVersionId14506837FkToolVersionIdToolVersionCreateInput;
  TaskUserId270D0Bb2FkApplicationUserIdApplicationUserCreateInput: TaskUserId270D0Bb2FkApplicationUserIdApplicationUserCreateInput;
  TaskUserId270D0Bb2FkApplicationUserIdInput: TaskUserId270D0Bb2FkApplicationUserIdInput;
  TaskUserId270D0Bb2FkApplicationUserIdInverseInput: TaskUserId270D0Bb2FkApplicationUserIdInverseInput;
  TaskUserId270D0Bb2FkApplicationUserIdTaskCreateInput: TaskUserId270D0Bb2FkApplicationUserIdTaskCreateInput;
  TasksConnection: TasksConnection;
  TasksEdge: TasksEdge;
  Tenant: Tenant;
  TenantContract: TenantContract;
  TenantContractAlloTenantContractTran29C19B1CFkTenantCoInput: TenantContractAlloTenantContractTran29C19B1CFkTenantCoInput;
  TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput: TenantContractAlloTenantContractTran29C19B1CFkTenantCoInverseInput;
  TenantContractAlloTenantContractTran29C19B1CFkTenantCoTenantContractAllowanceCreateInput: TenantContractAlloTenantContractTran29C19B1CFkTenantCoTenantContractAllowanceCreateInput;
  TenantContractAlloTenantContractTran29C19B1CFkTenantCoTenantContractTransactionCreateInput: TenantContractAlloTenantContractTran29C19B1CFkTenantCoTenantContractTransactionCreateInput;
  TenantContractAllowance: TenantContractAllowance;
  TenantContractAllowanceCondition: TenantContractAllowanceCondition;
  TenantContractAllowanceFilter: TenantContractAllowanceFilter;
  TenantContractAllowanceInput: TenantContractAllowanceInput;
  TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractAllowancePkeyUpdate: TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractAllowancePkeyUpdate;
  TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionQuotaTypeUniqueUpdate: TenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionQuotaTypeUniqueUpdate;
  TenantContractAllowancePatch: TenantContractAllowancePatch;
  TenantContractAllowanceTenantContractAllowancePkeyConnect: TenantContractAllowanceTenantContractAllowancePkeyConnect;
  TenantContractAllowanceTenantContractAllowancePkeyDelete: TenantContractAllowanceTenantContractAllowancePkeyDelete;
  TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueConnect: TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueConnect;
  TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueDelete: TenantContractAllowanceTenantContractTransactionQuotaTypeUniqueDelete;
  TenantContractAllowancesConnection: TenantContractAllowancesConnection;
  TenantContractAllowancesEdge: TenantContractAllowancesEdge;
  TenantContractCondition: TenantContractCondition;
  TenantContractFilter: TenantContractFilter;
  TenantContractInput: TenantContractInput;
  TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractNameKeyUpdate: TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractNameKeyUpdate;
  TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractPkeyUpdate: TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractPkeyUpdate;
  TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractSfidKeyUpdate: TenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantContractSfidKeyUpdate;
  TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractNameKeyUpdate: TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractNameKeyUpdate;
  TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractPkeyUpdate: TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractPkeyUpdate;
  TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractSfidKeyUpdate: TenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractSfidKeyUpdate;
  TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractNameKeyUpdate: TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractNameKeyUpdate;
  TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractPkeyUpdate: TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractPkeyUpdate;
  TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractSfidKeyUpdate: TenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantContractSfidKeyUpdate;
  TenantContractPatch: TenantContractPatch;
  TenantContractTenantContractNameKeyConnect: TenantContractTenantContractNameKeyConnect;
  TenantContractTenantContractNameKeyDelete: TenantContractTenantContractNameKeyDelete;
  TenantContractTenantContractPkeyConnect: TenantContractTenantContractPkeyConnect;
  TenantContractTenantContractPkeyDelete: TenantContractTenantContractPkeyDelete;
  TenantContractTenantContractSfidKeyConnect: TenantContractTenantContractSfidKeyConnect;
  TenantContractTenantContractSfidKeyDelete: TenantContractTenantContractSfidKeyDelete;
  TenantContractTenantIdBa8Ac167FkTenantIdInput: TenantContractTenantIdBa8Ac167FkTenantIdInput;
  TenantContractTenantIdBa8Ac167FkTenantIdInverseInput: TenantContractTenantIdBa8Ac167FkTenantIdInverseInput;
  TenantContractTenantIdBa8Ac167FkTenantIdTenantContractCreateInput: TenantContractTenantIdBa8Ac167FkTenantIdTenantContractCreateInput;
  TenantContractTenantIdBa8Ac167FkTenantIdTenantCreateInput: TenantContractTenantIdBa8Ac167FkTenantIdTenantCreateInput;
  TenantContractToManyTenantContractTransactionFilter: TenantContractToManyTenantContractTransactionFilter;
  TenantContractToManyTenantMonthlyConsumedResourceFilter: TenantContractToManyTenantMonthlyConsumedResourceFilter;
  TenantContractTranTenantContractId1E374993FkTenantCoInput: TenantContractTranTenantContractId1E374993FkTenantCoInput;
  TenantContractTranTenantContractId1E374993FkTenantCoInverseInput: TenantContractTranTenantContractId1E374993FkTenantCoInverseInput;
  TenantContractTranTenantContractId1E374993FkTenantCoTenantContractCreateInput: TenantContractTranTenantContractId1E374993FkTenantCoTenantContractCreateInput;
  TenantContractTranTenantContractId1E374993FkTenantCoTenantContractTransactionCreateInput: TenantContractTranTenantContractId1E374993FkTenantCoTenantContractTransactionCreateInput;
  TenantContractTransaction: TenantContractTransaction;
  TenantContractTransactionCondition: TenantContractTransactionCondition;
  TenantContractTransactionFilter: TenantContractTransactionFilter;
  TenantContractTransactionInput: TenantContractTransactionInput;
  TenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionPkeyUpdate: TenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoUsingTenantContractTransactionPkeyUpdate;
  TenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractTransactionPkeyUpdate: TenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoUsingTenantContractTransactionPkeyUpdate;
  TenantContractTransactionPatch: TenantContractTransactionPatch;
  TenantContractTransactionTenantContractTransactionPkeyConnect: TenantContractTransactionTenantContractTransactionPkeyConnect;
  TenantContractTransactionTenantContractTransactionPkeyDelete: TenantContractTransactionTenantContractTransactionPkeyDelete;
  TenantContractTransactionToManyTenantContractAllowanceFilter: TenantContractTransactionToManyTenantContractAllowanceFilter;
  TenantContractTransactionsConnection: TenantContractTransactionsConnection;
  TenantContractTransactionsEdge: TenantContractTransactionsEdge;
  TenantContractsConnection: TenantContractsConnection;
  TenantContractsEdge: TenantContractsEdge;
  TenantFilter: TenantFilter;
  TenantInput: TenantInput;
  TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInput: TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInput;
  TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInverseInput: TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsInverseInput;
  TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsTenantMockuserexecutorCreateInput: TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsTenantMockuserexecutorCreateInput;
  TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsTenantUserexecutorCreateInput: TenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsTenantUserexecutorCreateInput;
  TenantMockuserexecutor: TenantMockuserexecutor;
  TenantMockuserexecutorCondition: TenantMockuserexecutorCondition;
  TenantMockuserexecutorFilter: TenantMockuserexecutorFilter;
  TenantMockuserexecutorInput: TenantMockuserexecutorInput;
  TenantMockuserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsUsingTenantMockuserexecutorPkeyUpdate: TenantMockuserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsUsingTenantMockuserexecutorPkeyUpdate;
  TenantMockuserexecutorPatch: TenantMockuserexecutorPatch;
  TenantMockuserexecutorTenantMockuserexecutorPkeyConnect: TenantMockuserexecutorTenantMockuserexecutorPkeyConnect;
  TenantMockuserexecutorTenantMockuserexecutorPkeyDelete: TenantMockuserexecutorTenantMockuserexecutorPkeyDelete;
  TenantMockuserexecutorsConnection: TenantMockuserexecutorsConnection;
  TenantMockuserexecutorsEdge: TenantMockuserexecutorsEdge;
  TenantMonthlyConsuTenantContractId681267CeFkTenantCoInput: TenantMonthlyConsuTenantContractId681267CeFkTenantCoInput;
  TenantMonthlyConsuTenantContractId681267CeFkTenantCoInverseInput: TenantMonthlyConsuTenantContractId681267CeFkTenantCoInverseInput;
  TenantMonthlyConsuTenantContractId681267CeFkTenantCoTenantContractCreateInput: TenantMonthlyConsuTenantContractId681267CeFkTenantCoTenantContractCreateInput;
  TenantMonthlyConsuTenantContractId681267CeFkTenantCoTenantMonthlyConsumedResourcesCreateInput: TenantMonthlyConsuTenantContractId681267CeFkTenantCoTenantMonthlyConsumedResourcesCreateInput;
  TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInput: TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInput;
  TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput: TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdInverseInput;
  TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdTenantCreateInput: TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdTenantCreateInput;
  TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdTenantMonthlyConsumedResourcesCreateInput: TenantMonthlyConsuTenantIdCb1B80FcFkTenantIdTenantMonthlyConsumedResourcesCreateInput;
  TenantMonthlyConsuUserIdF7210F55FkApplicatiApplicationUserCreateInput: TenantMonthlyConsuUserIdF7210F55FkApplicatiApplicationUserCreateInput;
  TenantMonthlyConsuUserIdF7210F55FkApplicatiInput: TenantMonthlyConsuUserIdF7210F55FkApplicatiInput;
  TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput: TenantMonthlyConsuUserIdF7210F55FkApplicatiInverseInput;
  TenantMonthlyConsuUserIdF7210F55FkApplicatiTenantMonthlyConsumedResourcesCreateInput: TenantMonthlyConsuUserIdF7210F55FkApplicatiTenantMonthlyConsumedResourcesCreateInput;
  TenantMonthlyConsumedResource: TenantMonthlyConsumedResource;
  TenantMonthlyConsumedResourceCondition: TenantMonthlyConsumedResourceCondition;
  TenantMonthlyConsumedResourceFilter: TenantMonthlyConsumedResourceFilter;
  TenantMonthlyConsumedResourceInput: TenantMonthlyConsumedResourceInput;
  TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantMonthlyConsumedResourcesPkeyUpdate: TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantMonthlyConsumedResourcesPkeyUpdate;
  TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantMonthlyConsumedResourcesUniqueUpdate: TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoUsingTenantMonthlyConsumedResourcesUniqueUpdate;
  TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantMonthlyConsumedResourcesPkeyUpdate: TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantMonthlyConsumedResourcesPkeyUpdate;
  TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantMonthlyConsumedResourcesUniqueUpdate: TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantMonthlyConsumedResourcesUniqueUpdate;
  TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingTenantMonthlyConsumedResourcesPkeyUpdate: TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingTenantMonthlyConsumedResourcesPkeyUpdate;
  TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingTenantMonthlyConsumedResourcesUniqueUpdate: TenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiUsingTenantMonthlyConsumedResourcesUniqueUpdate;
  TenantMonthlyConsumedResourcePatch: TenantMonthlyConsumedResourcePatch;
  TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesPkeyConnect: TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesPkeyConnect;
  TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesPkeyDelete: TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesPkeyDelete;
  TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesUniqueConnect: TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesUniqueConnect;
  TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesUniqueDelete: TenantMonthlyConsumedResourceTenantMonthlyConsumedResourcesUniqueDelete;
  TenantMonthlyConsumedResourcesConnection: TenantMonthlyConsumedResourcesConnection;
  TenantMonthlyConsumedResourcesEdge: TenantMonthlyConsumedResourcesEdge;
  TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantKeyKeyUpdate: TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantPkeyUpdate: TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantPkeyUpdate;
  TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantSfidKeyUpdate: TenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantKeyKeyUpdate: TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantPkeyUpdate: TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantPkeyUpdate;
  TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantSfidKeyUpdate: TenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantKeyKeyUpdate: TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantPkeyUpdate: TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantPkeyUpdate;
  TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantSfidKeyUpdate: TenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantKeyKeyUpdate: TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantPkeyUpdate: TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantPkeyUpdate;
  TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantSfidKeyUpdate: TenantOnCommandForCommandTenantId36F95C3CFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantKeyKeyUpdate: TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantPkeyUpdate: TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantPkeyUpdate;
  TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantSfidKeyUpdate: TenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantKeyKeyUpdate: TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantPkeyUpdate: TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantPkeyUpdate;
  TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantSfidKeyUpdate: TenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantKeyKeyUpdate: TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantPkeyUpdate: TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantPkeyUpdate;
  TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantSfidKeyUpdate: TenantOnCostForCostTenantId7Dcd58A7FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantKeyKeyUpdate: TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantPkeyUpdate: TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantPkeyUpdate;
  TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantSfidKeyUpdate: TenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantPkeyUpdate: TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantPkeyUpdate: TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileForFileTenantId61625016FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantPkeyUpdate: TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantPkeyUpdate: TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantKeyKeyUpdate: TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantPkeyUpdate: TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantPkeyUpdate;
  TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantSfidKeyUpdate: TenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantKeyKeyUpdate: TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantPkeyUpdate: TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantPkeyUpdate;
  TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantSfidKeyUpdate: TenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantKeyKeyUpdate: TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantPkeyUpdate: TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantPkeyUpdate;
  TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantSfidKeyUpdate: TenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantKeyKeyUpdate: TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantPkeyUpdate: TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantPkeyUpdate;
  TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantSfidKeyUpdate: TenantOnProjectForProjectTenantId03F0Ca53FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantKeyKeyUpdate: TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantPkeyUpdate: TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantPkeyUpdate;
  TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantSfidKeyUpdate: TenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantKeyKeyUpdate: TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantPkeyUpdate: TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantPkeyUpdate;
  TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantSfidKeyUpdate: TenantOnRunForRunTenantId73Fbd8D9FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantKeyKeyUpdate: TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantPkeyUpdate: TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantPkeyUpdate;
  TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantSfidKeyUpdate: TenantOnTaskForTaskTenantId148E90DaFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantKeyKeyUpdate: TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantPkeyUpdate: TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantPkeyUpdate;
  TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantSfidKeyUpdate: TenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantKeyKeyUpdate: TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantPkeyUpdate: TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantPkeyUpdate;
  TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantSfidKeyUpdate: TenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantKeyKeyUpdate: TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantPkeyUpdate: TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantPkeyUpdate;
  TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantSfidKeyUpdate: TenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantKeyKeyUpdate: TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantPkeyUpdate: TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantPkeyUpdate;
  TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantSfidKeyUpdate: TenantOnToolForToolTenantId1Baab08EFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantKeyKeyUpdate: TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantPkeyUpdate: TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantPkeyUpdate;
  TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantSfidKeyUpdate: TenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantKeyKeyUpdate: TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantPkeyUpdate: TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantPkeyUpdate;
  TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantSfidKeyUpdate: TenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantKeyKeyUpdate: TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantPkeyUpdate: TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantPkeyUpdate;
  TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantSfidKeyUpdate: TenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingTenantSfidKeyUpdate;
  TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantKeyKeyUpdate: TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantKeyKeyUpdate;
  TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantPkeyUpdate: TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantPkeyUpdate;
  TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantRepositoryNameKeyUpdate: TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantRepositoryNameKeyUpdate;
  TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantSfidKeyUpdate: TenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingTenantSfidKeyUpdate;
  TenantPatch: TenantPatch;
  TenantTenantKeyKeyConnect: TenantTenantKeyKeyConnect;
  TenantTenantKeyKeyDelete: TenantTenantKeyKeyDelete;
  TenantTenantPkeyConnect: TenantTenantPkeyConnect;
  TenantTenantPkeyDelete: TenantTenantPkeyDelete;
  TenantTenantRepositoryNameKeyConnect: TenantTenantRepositoryNameKeyConnect;
  TenantTenantRepositoryNameKeyDelete: TenantTenantRepositoryNameKeyDelete;
  TenantTenantSfidKeyConnect: TenantTenantSfidKeyConnect;
  TenantTenantSfidKeyDelete: TenantTenantSfidKeyDelete;
  TenantToManyApplicationUserMembershipFilter: TenantToManyApplicationUserMembershipFilter;
  TenantToManyApplicationUserSessionFilter: TenantToManyApplicationUserSessionFilter;
  TenantToManyCodeFileFilter: TenantToManyCodeFileFilter;
  TenantToManyCommandFilter: TenantToManyCommandFilter;
  TenantToManyContainerImageFilter: TenantToManyContainerImageFilter;
  TenantToManyContainerImageRepositoryFilter: TenantToManyContainerImageRepositoryFilter;
  TenantToManyCostFilter: TenantToManyCostFilter;
  TenantToManyFeatureFlagsTenantFilter: TenantToManyFeatureFlagsTenantFilter;
  TenantToManyFileActivityFilter: TenantToManyFileActivityFilter;
  TenantToManyFileFilter: TenantToManyFileFilter;
  TenantToManyFileMetadatumFilter: TenantToManyFileMetadatumFilter;
  TenantToManyFileOutputGroupFilter: TenantToManyFileOutputGroupFilter;
  TenantToManyFileOutputGroupMetadatumFilter: TenantToManyFileOutputGroupMetadatumFilter;
  TenantToManyMetadataValueFilter: TenantToManyMetadataValueFilter;
  TenantToManyMetadatumFilter: TenantToManyMetadatumFilter;
  TenantToManyProjectFilter: TenantToManyProjectFilter;
  TenantToManyRoleChangeNotificationFilter: TenantToManyRoleChangeNotificationFilter;
  TenantToManyRunFilter: TenantToManyRunFilter;
  TenantToManyTaskFilter: TenantToManyTaskFilter;
  TenantToManyTenantContractFilter: TenantToManyTenantContractFilter;
  TenantToManyTenantMonthlyConsumedResourceFilter: TenantToManyTenantMonthlyConsumedResourceFilter;
  TenantToManyTenantUserMembershipNotificationFilter: TenantToManyTenantUserMembershipNotificationFilter;
  TenantToManyToolFilter: TenantToManyToolFilter;
  TenantToManyToolTenantFilter: TenantToManyToolTenantFilter;
  TenantToManyToolVersionFilter: TenantToManyToolVersionFilter;
  TenantToManyToolboxTenantFilter: TenantToManyToolboxTenantFilter;
  TenantToManyWorkflowFilter: TenantToManyWorkflowFilter;
  TenantUserMembershId10Affa8DFkNotificatInput: TenantUserMembershId10Affa8DFkNotificatInput;
  TenantUserMembershId10Affa8DFkNotificatInverseInput: TenantUserMembershId10Affa8DFkNotificatInverseInput;
  TenantUserMembershInviterId29476E5EFkApplicatiApplicationUserCreateInput: TenantUserMembershInviterId29476E5EFkApplicatiApplicationUserCreateInput;
  TenantUserMembershInviterId29476E5EFkApplicatiInput: TenantUserMembershInviterId29476E5EFkApplicatiInput;
  TenantUserMembershInviterId29476E5EFkApplicatiInverseInput: TenantUserMembershInviterId29476E5EFkApplicatiInverseInput;
  TenantUserMembershTenantIdC67818C5FkTenantIdInput: TenantUserMembershTenantIdC67818C5FkTenantIdInput;
  TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput: TenantUserMembershTenantIdC67818C5FkTenantIdInverseInput;
  TenantUserMembershTenantIdC67818C5FkTenantIdTenantCreateInput: TenantUserMembershTenantIdC67818C5FkTenantIdTenantCreateInput;
  TenantUserMembershUserId2B78E8A0FkApplicatiApplicationUserCreateInput: TenantUserMembershUserId2B78E8A0FkApplicatiApplicationUserCreateInput;
  TenantUserMembershUserId2B78E8A0FkApplicatiInput: TenantUserMembershUserId2B78E8A0FkApplicatiInput;
  TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput: TenantUserMembershUserId2B78E8A0FkApplicatiInverseInput;
  TenantUserMembershipNotification: TenantUserMembershipNotification;
  TenantUserMembershipNotificationCondition: TenantUserMembershipNotificationCondition;
  TenantUserMembershipNotificationFilter: TenantUserMembershipNotificationFilter;
  TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingTenantUserMembershipNotificationPkeyUpdate: TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatUsingTenantUserMembershipNotificationPkeyUpdate;
  TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate: TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate;
  TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantUserMembershipNotificationPkeyUpdate: TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdUsingTenantUserMembershipNotificationPkeyUpdate;
  TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate: TenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiUsingTenantUserMembershipNotificationPkeyUpdate;
  TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect: TenantUserMembershipNotificationTenantUserMembershipNotificationPkeyConnect;
  TenantUserMembershipNotificationsConnection: TenantUserMembershipNotificationsConnection;
  TenantUserMembershipNotificationsEdge: TenantUserMembershipNotificationsEdge;
  TenantUserexecutor: TenantUserexecutor;
  TenantUserexecutorCondition: TenantUserexecutorCondition;
  TenantUserexecutorFilter: TenantUserexecutorFilter;
  TenantUserexecutorInput: TenantUserexecutorInput;
  TenantUserexecutorOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsUsingTenantUserexecutorPkeyUpdate: TenantUserexecutorOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsUsingTenantUserexecutorPkeyUpdate;
  TenantUserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsUsingTenantUserexecutorPkeyUpdate: TenantUserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsUsingTenantUserexecutorPkeyUpdate;
  TenantUserexecutorOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingTenantUserexecutorPkeyUpdate: TenantUserexecutorOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoUsingTenantUserexecutorPkeyUpdate;
  TenantUserexecutorPatch: TenantUserexecutorPatch;
  TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoDjangoContentTypeCreateInput: TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoDjangoContentTypeCreateInput;
  TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInput: TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInput;
  TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput: TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoInverseInput;
  TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoTenantUserexecutorCreateInput: TenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoTenantUserexecutorCreateInput;
  TenantUserexecutorTenantUserexecutorPkeyConnect: TenantUserexecutorTenantUserexecutorPkeyConnect;
  TenantUserexecutorTenantUserexecutorPkeyDelete: TenantUserexecutorTenantUserexecutorPkeyDelete;
  TenantUserexecutorsConnection: TenantUserexecutorsConnection;
  TenantUserexecutorsEdge: TenantUserexecutorsEdge;
  TenantsEdge: TenantsEdge;
  TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoDjangoContentTypeCreateInput: TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoDjangoContentTypeCreateInput;
  TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInput: TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInput;
  TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput: TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoInverseInput;
  TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoTesContainerimageexecutorCreateInput: TesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoTesContainerimageexecutorCreateInput;
  TesContainerimageexecutor: TesContainerimageexecutor;
  TesContainerimageexecutorCondition: TesContainerimageexecutorCondition;
  TesContainerimageexecutorFilter: TesContainerimageexecutorFilter;
  TesContainerimageexecutorInput: TesContainerimageexecutorInput;
  TesContainerimageexecutorOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaUsingTesContainerimageexecutorPkeyUpdate: TesContainerimageexecutorOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaUsingTesContainerimageexecutorPkeyUpdate;
  TesContainerimageexecutorOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingTesContainerimageexecutorPkeyUpdate: TesContainerimageexecutorOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaUsingTesContainerimageexecutorPkeyUpdate;
  TesContainerimageexecutorOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaUsingTesContainerimageexecutorPkeyUpdate: TesContainerimageexecutorOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaUsingTesContainerimageexecutorPkeyUpdate;
  TesContainerimageexecutorOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingTesContainerimageexecutorPkeyUpdate: TesContainerimageexecutorOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoUsingTesContainerimageexecutorPkeyUpdate;
  TesContainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaUsingTesContainerimageexecutorPkeyUpdate: TesContainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaUsingTesContainerimageexecutorPkeyUpdate;
  TesContainerimageexecutorPatch: TesContainerimageexecutorPatch;
  TesContainerimageexecutorTesContainerimageexecutorPkeyConnect: TesContainerimageexecutorTesContainerimageexecutorPkeyConnect;
  TesContainerimageexecutorTesContainerimageexecutorPkeyDelete: TesContainerimageexecutorTesContainerimageexecutorPkeyDelete;
  TesContainerimageexecutorsConnection: TesContainerimageexecutorsConnection;
  TesContainerimageexecutorsEdge: TesContainerimageexecutorsEdge;
  TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInput: TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInput;
  TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInverseInput: TesMockcontainerimaContainerimageexecut4Eced924FkTesContaInverseInput;
  TesMockcontainerimaContainerimageexecut4Eced924FkTesContaTesContainerimageexecutorCreateInput: TesMockcontainerimaContainerimageexecut4Eced924FkTesContaTesContainerimageexecutorCreateInput;
  TesMockcontainerimaContainerimageexecut4Eced924FkTesContaTesMockcontainerimageexecutorCreateInput: TesMockcontainerimaContainerimageexecut4Eced924FkTesContaTesMockcontainerimageexecutorCreateInput;
  TesMockcontainerimageexecutor: TesMockcontainerimageexecutor;
  TesMockcontainerimageexecutorCondition: TesMockcontainerimageexecutorCondition;
  TesMockcontainerimageexecutorFilter: TesMockcontainerimageexecutorFilter;
  TesMockcontainerimageexecutorInput: TesMockcontainerimageexecutorInput;
  TesMockcontainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaUsingTesMockcontainerimageexecutorPkeyUpdate: TesMockcontainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaUsingTesMockcontainerimageexecutorPkeyUpdate;
  TesMockcontainerimageexecutorPatch: TesMockcontainerimageexecutorPatch;
  TesMockcontainerimageexecutorTesMockcontainerimageexecutorPkeyConnect: TesMockcontainerimageexecutorTesMockcontainerimageexecutorPkeyConnect;
  TesMockcontainerimageexecutorTesMockcontainerimageexecutorPkeyDelete: TesMockcontainerimageexecutorTesMockcontainerimageexecutorPkeyDelete;
  TesMockcontainerimageexecutorsConnection: TesMockcontainerimageexecutorsConnection;
  TesMockcontainerimageexecutorsEdge: TesMockcontainerimageexecutorsEdge;
  TesMocktaskexecutor: TesMocktaskexecutor;
  TesMocktaskexecutorCondition: TesMocktaskexecutorCondition;
  TesMocktaskexecutorFilter: TesMocktaskexecutorFilter;
  TesMocktaskexecutorInput: TesMocktaskexecutorInput;
  TesMocktaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeUsingTesMocktaskexecutorPkeyUpdate: TesMocktaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeUsingTesMocktaskexecutorPkeyUpdate;
  TesMocktaskexecutorPatch: TesMocktaskexecutorPatch;
  TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInput: TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInput;
  TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInverseInput: TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeInverseInput;
  TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeTesMocktaskexecutorCreateInput: TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeTesMocktaskexecutorCreateInput;
  TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeTesTaskexecutorCreateInput: TesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeTesTaskexecutorCreateInput;
  TesMocktaskexecutorTesMocktaskexecutorPkeyConnect: TesMocktaskexecutorTesMocktaskexecutorPkeyConnect;
  TesMocktaskexecutorTesMocktaskexecutorPkeyDelete: TesMocktaskexecutorTesMocktaskexecutorPkeyDelete;
  TesMocktaskexecutorsConnection: TesMocktaskexecutorsConnection;
  TesMocktaskexecutorsEdge: TesMocktaskexecutorsEdge;
  TesTaskexecutor: TesTaskexecutor;
  TesTaskexecutorCondition: TesTaskexecutorCondition;
  TesTaskexecutorFilter: TesTaskexecutorFilter;
  TesTaskexecutorInput: TesTaskexecutorInput;
  TesTaskexecutorOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeUsingTesTaskexecutorPkeyUpdate: TesTaskexecutorOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskeUsingTesTaskexecutorPkeyUpdate;
  TesTaskexecutorOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTesTaskexecutorPkeyUpdate: TesTaskexecutorOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdUsingTesTaskexecutorPkeyUpdate;
  TesTaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeUsingTesTaskexecutorPkeyUpdate: TesTaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskeUsingTesTaskexecutorPkeyUpdate;
  TesTaskexecutorOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingTesTaskexecutorPkeyUpdate: TesTaskexecutorOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoUsingTesTaskexecutorPkeyUpdate;
  TesTaskexecutorPatch: TesTaskexecutorPatch;
  TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoDjangoContentTypeCreateInput: TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoDjangoContentTypeCreateInput;
  TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInput: TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInput;
  TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput: TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoInverseInput;
  TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoTesTaskexecutorCreateInput: TesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoTesTaskexecutorCreateInput;
  TesTaskexecutorTesTaskexecutorPkeyConnect: TesTaskexecutorTesTaskexecutorPkeyConnect;
  TesTaskexecutorTesTaskexecutorPkeyDelete: TesTaskexecutorTesTaskexecutorPkeyDelete;
  TesTaskexecutorsConnection: TesTaskexecutorsConnection;
  TesTaskexecutorsEdge: TesTaskexecutorsEdge;
  Tool: Tool;
  ToolCondition: ToolCondition;
  ToolFilter: ToolFilter;
  ToolInput: ToolInput;
  ToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingToolPkeyUpdate: ToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingToolPkeyUpdate;
  ToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingToolProjectIdKeyUpdate: ToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdUsingToolProjectIdKeyUpdate;
  ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolPkeyUpdate: ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolPkeyUpdate;
  ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolProjectIdKeyUpdate: ToolOnToolForToolProjectId20A84210FkProjectIdUsingToolProjectIdKeyUpdate;
  ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolPkeyUpdate: ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolPkeyUpdate;
  ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolProjectIdKeyUpdate: ToolOnToolForToolTenantId1Baab08EFkTenantIdUsingToolProjectIdKeyUpdate;
  ToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolPkeyUpdate: ToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolPkeyUpdate;
  ToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolProjectIdKeyUpdate: ToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolProjectIdKeyUpdate;
  ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolPkeyUpdate: ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolPkeyUpdate;
  ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolProjectIdKeyUpdate: ToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdUsingToolProjectIdKeyUpdate;
  ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolPkeyUpdate: ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolPkeyUpdate;
  ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolProjectIdKeyUpdate: ToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolProjectIdKeyUpdate;
  ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolPkeyUpdate: ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolPkeyUpdate;
  ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolProjectIdKeyUpdate: ToolOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolProjectIdKeyUpdate;
  ToolParameter: ToolParameter;
  ToolParameterCondition: ToolParameterCondition;
  ToolParameterFilter: ToolParameterFilter;
  ToolParameterInput: ToolParameterInput;
  ToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolParameterPkeyUpdate: ToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolParameterPkeyUpdate;
  ToolParameterPatch: ToolParameterPatch;
  ToolParameterToolParameterPkeyConnect: ToolParameterToolParameterPkeyConnect;
  ToolParameterToolParameterPkeyDelete: ToolParameterToolParameterPkeyDelete;
  ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInput: ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInput;
  ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput: ToolParameterToolVersionIdC3A0Df75FkToolVersionIdInverseInput;
  ToolParameterToolVersionIdC3A0Df75FkToolVersionIdToolParameterCreateInput: ToolParameterToolVersionIdC3A0Df75FkToolVersionIdToolParameterCreateInput;
  ToolParameterToolVersionIdC3A0Df75FkToolVersionIdToolVersionCreateInput: ToolParameterToolVersionIdC3A0Df75FkToolVersionIdToolVersionCreateInput;
  ToolParametersConnection: ToolParametersConnection;
  ToolParametersEdge: ToolParametersEdge;
  ToolPatch: ToolPatch;
  ToolProjectId20A84210FkProjectIdInput: ToolProjectId20A84210FkProjectIdInput;
  ToolProjectId20A84210FkProjectIdInverseInput: ToolProjectId20A84210FkProjectIdInverseInput;
  ToolProjectId20A84210FkProjectIdToolCreateInput: ToolProjectId20A84210FkProjectIdToolCreateInput;
  ToolResource: ToolResource;
  ToolResourceCondition: ToolResourceCondition;
  ToolResourceFilter: ToolResourceFilter;
  ToolResourceInput: ToolResourceInput;
  ToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingReqTypeToolVersionUniqueUpdate: ToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingReqTypeToolVersionUniqueUpdate;
  ToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingToolResourcePkeyUpdate: ToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingToolResourcePkeyUpdate;
  ToolResourcePatch: ToolResourcePatch;
  ToolResourceReqTypeToolVersionUniqueConnect: ToolResourceReqTypeToolVersionUniqueConnect;
  ToolResourceReqTypeToolVersionUniqueDelete: ToolResourceReqTypeToolVersionUniqueDelete;
  ToolResourceToolResourcePkeyConnect: ToolResourceToolResourcePkeyConnect;
  ToolResourceToolResourcePkeyDelete: ToolResourceToolResourcePkeyDelete;
  ToolResourceToolVersionId5E21979DFkToolVersionIdInput: ToolResourceToolVersionId5E21979DFkToolVersionIdInput;
  ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput: ToolResourceToolVersionId5E21979DFkToolVersionIdInverseInput;
  ToolResourceToolVersionId5E21979DFkToolVersionIdToolResourceCreateInput: ToolResourceToolVersionId5E21979DFkToolVersionIdToolResourceCreateInput;
  ToolResourceToolVersionId5E21979DFkToolVersionIdToolVersionCreateInput: ToolResourceToolVersionId5E21979DFkToolVersionIdToolVersionCreateInput;
  ToolResourcesConnection: ToolResourcesConnection;
  ToolResourcesEdge: ToolResourcesEdge;
  ToolResult: ToolResult;
  ToolResultCondition: ToolResultCondition;
  ToolResultFilter: ToolResultFilter;
  ToolResultInput: ToolResultInput;
  ToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolResultPkeyUpdate: ToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolResultPkeyUpdate;
  ToolResultPatch: ToolResultPatch;
  ToolResultToolResultPkeyConnect: ToolResultToolResultPkeyConnect;
  ToolResultToolResultPkeyDelete: ToolResultToolResultPkeyDelete;
  ToolResultToolVersionId41Fb163EFkToolVersionIdInput: ToolResultToolVersionId41Fb163EFkToolVersionIdInput;
  ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput: ToolResultToolVersionId41Fb163EFkToolVersionIdInverseInput;
  ToolResultToolVersionId41Fb163EFkToolVersionIdToolResultCreateInput: ToolResultToolVersionId41Fb163EFkToolVersionIdToolResultCreateInput;
  ToolResultToolVersionId41Fb163EFkToolVersionIdToolVersionCreateInput: ToolResultToolVersionId41Fb163EFkToolVersionIdToolVersionCreateInput;
  ToolResultsConnection: ToolResultsConnection;
  ToolResultsEdge: ToolResultsEdge;
  ToolSecret: ToolSecret;
  ToolSecretCondition: ToolSecretCondition;
  ToolSecretFilter: ToolSecretFilter;
  ToolSecretInput: ToolSecretInput;
  ToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolSecretPkeyUpdate: ToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolSecretPkeyUpdate;
  ToolSecretPatch: ToolSecretPatch;
  ToolSecretToolSecretPkeyConnect: ToolSecretToolSecretPkeyConnect;
  ToolSecretToolSecretPkeyDelete: ToolSecretToolSecretPkeyDelete;
  ToolSecretToolVersionId92Dc8FadFkToolVersionIdInput: ToolSecretToolVersionId92Dc8FadFkToolVersionIdInput;
  ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput: ToolSecretToolVersionId92Dc8FadFkToolVersionIdInverseInput;
  ToolSecretToolVersionId92Dc8FadFkToolVersionIdToolSecretCreateInput: ToolSecretToolVersionId92Dc8FadFkToolVersionIdToolSecretCreateInput;
  ToolSecretToolVersionId92Dc8FadFkToolVersionIdToolVersionCreateInput: ToolSecretToolVersionId92Dc8FadFkToolVersionIdToolVersionCreateInput;
  ToolSecretsConnection: ToolSecretsConnection;
  ToolSecretsEdge: ToolSecretsEdge;
  ToolSource: ToolSource;
  ToolSourceCondition: ToolSourceCondition;
  ToolSourceFilter: ToolSourceFilter;
  ToolSourceInput: ToolSourceInput;
  ToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingToolSourcePkeyUpdate: ToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdUsingToolSourcePkeyUpdate;
  ToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolSourcePkeyUpdate: ToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolSourcePkeyUpdate;
  ToolSourcePatch: ToolSourcePatch;
  ToolSourceToManyTaskSourceFilter: ToolSourceToManyTaskSourceFilter;
  ToolSourceToolSourcePkeyConnect: ToolSourceToolSourcePkeyConnect;
  ToolSourceToolSourcePkeyDelete: ToolSourceToolSourcePkeyDelete;
  ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput: ToolSourceToolVersionId9Ac27A25FkToolVersionIdInput;
  ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput: ToolSourceToolVersionId9Ac27A25FkToolVersionIdInverseInput;
  ToolSourceToolVersionId9Ac27A25FkToolVersionIdToolSourceCreateInput: ToolSourceToolVersionId9Ac27A25FkToolVersionIdToolSourceCreateInput;
  ToolSourceToolVersionId9Ac27A25FkToolVersionIdToolVersionCreateInput: ToolSourceToolVersionId9Ac27A25FkToolVersionIdToolVersionCreateInput;
  ToolSourcesConnection: ToolSourcesConnection;
  ToolSourcesEdge: ToolSourcesEdge;
  ToolTenant: ToolTenant;
  ToolTenantCondition: ToolTenantCondition;
  ToolTenantFilter: ToolTenantFilter;
  ToolTenantId1Baab08EFkTenantIdInput: ToolTenantId1Baab08EFkTenantIdInput;
  ToolTenantId1Baab08EFkTenantIdInverseInput: ToolTenantId1Baab08EFkTenantIdInverseInput;
  ToolTenantId1Baab08EFkTenantIdTenantCreateInput: ToolTenantId1Baab08EFkTenantIdTenantCreateInput;
  ToolTenantId1Baab08EFkTenantIdToolCreateInput: ToolTenantId1Baab08EFkTenantIdToolCreateInput;
  ToolTenantInput: ToolTenantInput;
  ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsPkeyUpdate: ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsPkeyUpdate;
  ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate: ToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate;
  ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsPkeyUpdate: ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsPkeyUpdate;
  ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate: ToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdUsingToolTenantsToolIdTenantId1Ab854FcUniqUpdate;
  ToolTenantPatch: ToolTenantPatch;
  ToolTenantToolTenantsPkeyConnect: ToolTenantToolTenantsPkeyConnect;
  ToolTenantToolTenantsPkeyDelete: ToolTenantToolTenantsPkeyDelete;
  ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqConnect: ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqConnect;
  ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqDelete: ToolTenantToolTenantsToolIdTenantId1Ab854FcUniqDelete;
  ToolTenantsConnection: ToolTenantsConnection;
  ToolTenantsEdge: ToolTenantsEdge;
  ToolTenantsTenantId9C4A54FeFkTenantIdInput: ToolTenantsTenantId9C4A54FeFkTenantIdInput;
  ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput: ToolTenantsTenantId9C4A54FeFkTenantIdInverseInput;
  ToolTenantsTenantId9C4A54FeFkTenantIdTenantCreateInput: ToolTenantsTenantId9C4A54FeFkTenantIdTenantCreateInput;
  ToolTenantsTenantId9C4A54FeFkTenantIdToolTenantsCreateInput: ToolTenantsTenantId9C4A54FeFkTenantIdToolTenantsCreateInput;
  ToolTenantsToolIdF77Ef6F7FkToolIdInput: ToolTenantsToolIdF77Ef6F7FkToolIdInput;
  ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput: ToolTenantsToolIdF77Ef6F7FkToolIdInverseInput;
  ToolTenantsToolIdF77Ef6F7FkToolIdToolCreateInput: ToolTenantsToolIdF77Ef6F7FkToolIdToolCreateInput;
  ToolTenantsToolIdF77Ef6F7FkToolIdToolTenantsCreateInput: ToolTenantsToolIdF77Ef6F7FkToolIdToolTenantsCreateInput;
  ToolToManyPinnedToolFilter: ToolToManyPinnedToolFilter;
  ToolToManyToolTenantFilter: ToolToManyToolTenantFilter;
  ToolToManyToolVersionFilter: ToolToManyToolVersionFilter;
  ToolToolPkeyConnect: ToolToolPkeyConnect;
  ToolToolPkeyDelete: ToolToolPkeyDelete;
  ToolToolProjectIdKeyConnect: ToolToolProjectIdKeyConnect;
  ToolToolProjectIdKeyDelete: ToolToolProjectIdKeyDelete;
  ToolToolboxId7B1Eebf3FkToolboxIdInput: ToolToolboxId7B1Eebf3FkToolboxIdInput;
  ToolToolboxId7B1Eebf3FkToolboxIdInverseInput: ToolToolboxId7B1Eebf3FkToolboxIdInverseInput;
  ToolToolboxId7B1Eebf3FkToolboxIdToolCreateInput: ToolToolboxId7B1Eebf3FkToolboxIdToolCreateInput;
  ToolToolboxId7B1Eebf3FkToolboxIdToolboxCreateInput: ToolToolboxId7B1Eebf3FkToolboxIdToolboxCreateInput;
  ToolUserIdFd36Dfa4FkApplicationUserIdApplicationUserCreateInput: ToolUserIdFd36Dfa4FkApplicationUserIdApplicationUserCreateInput;
  ToolUserIdFd36Dfa4FkApplicationUserIdInput: ToolUserIdFd36Dfa4FkApplicationUserIdInput;
  ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput: ToolUserIdFd36Dfa4FkApplicationUserIdInverseInput;
  ToolUserIdFd36Dfa4FkApplicationUserIdToolCreateInput: ToolUserIdFd36Dfa4FkApplicationUserIdToolCreateInput;
  ToolVersion: ToolVersion;
  ToolVersionCondition: ToolVersionCondition;
  ToolVersionContainerImageId32D92A94FkContainerImageIdContainerImageCreateInput: ToolVersionContainerImageId32D92A94FkContainerImageIdContainerImageCreateInput;
  ToolVersionContainerImageId32D92A94FkContainerImageIdInput: ToolVersionContainerImageId32D92A94FkContainerImageIdInput;
  ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput: ToolVersionContainerImageId32D92A94FkContainerImageIdInverseInput;
  ToolVersionContainerImageId32D92A94FkContainerImageIdToolVersionCreateInput: ToolVersionContainerImageId32D92A94FkContainerImageIdToolVersionCreateInput;
  ToolVersionFilter: ToolVersionFilter;
  ToolVersionInput: ToolVersionInput;
  ToolVersionOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingToolVersionPkeyUpdate: ToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersUsingToolVersionPkeyUpdate;
  ToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingToolVersionPkeyUpdate: ToolVersionOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingToolVersionPkeyUpdate: ToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolVersionPkeyUpdate: ToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdUsingToolVersionPkeyUpdate;
  ToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingToolVersionPkeyUpdate: ToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdUsingToolVersionPkeyUpdate;
  ToolVersionOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdUsingToolVersionPkeyUpdate: ToolVersionOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdUsingToolVersionPkeyUpdate;
  ToolVersionPatch: ToolVersionPatch;
  ToolVersionTenantId03A60B0CFkTenantIdInput: ToolVersionTenantId03A60B0CFkTenantIdInput;
  ToolVersionTenantId03A60B0CFkTenantIdInverseInput: ToolVersionTenantId03A60B0CFkTenantIdInverseInput;
  ToolVersionTenantId03A60B0CFkTenantIdTenantCreateInput: ToolVersionTenantId03A60B0CFkTenantIdTenantCreateInput;
  ToolVersionTenantId03A60B0CFkTenantIdToolVersionCreateInput: ToolVersionTenantId03A60B0CFkTenantIdToolVersionCreateInput;
  ToolVersionToManyGdtAnalysisTableFilter: ToolVersionToManyGdtAnalysisTableFilter;
  ToolVersionToManyGdtAnalysisTableRowFilter: ToolVersionToManyGdtAnalysisTableRowFilter;
  ToolVersionToManyTaskFilter: ToolVersionToManyTaskFilter;
  ToolVersionToManyToolParameterFilter: ToolVersionToManyToolParameterFilter;
  ToolVersionToManyToolResourceFilter: ToolVersionToManyToolResourceFilter;
  ToolVersionToManyToolResultFilter: ToolVersionToManyToolResultFilter;
  ToolVersionToManyToolSecretFilter: ToolVersionToManyToolSecretFilter;
  ToolVersionToManyToolSourceFilter: ToolVersionToManyToolSourceFilter;
  ToolVersionToManyWorkflowSectionBlockFilter: ToolVersionToManyWorkflowSectionBlockFilter;
  ToolVersionToolId3B396B22FkToolIdInput: ToolVersionToolId3B396B22FkToolIdInput;
  ToolVersionToolId3B396B22FkToolIdInverseInput: ToolVersionToolId3B396B22FkToolIdInverseInput;
  ToolVersionToolId3B396B22FkToolIdToolCreateInput: ToolVersionToolId3B396B22FkToolIdToolCreateInput;
  ToolVersionToolId3B396B22FkToolIdToolVersionCreateInput: ToolVersionToolId3B396B22FkToolIdToolVersionCreateInput;
  ToolVersionToolVersionPkeyConnect: ToolVersionToolVersionPkeyConnect;
  ToolVersionToolVersionPkeyDelete: ToolVersionToolVersionPkeyDelete;
  ToolVersionUserId68A75E07FkApplicationUserIdApplicationUserCreateInput: ToolVersionUserId68A75E07FkApplicationUserIdApplicationUserCreateInput;
  ToolVersionUserId68A75E07FkApplicationUserIdInput: ToolVersionUserId68A75E07FkApplicationUserIdInput;
  ToolVersionUserId68A75E07FkApplicationUserIdInverseInput: ToolVersionUserId68A75E07FkApplicationUserIdInverseInput;
  ToolVersionUserId68A75E07FkApplicationUserIdToolVersionCreateInput: ToolVersionUserId68A75E07FkApplicationUserIdToolVersionCreateInput;
  ToolVersionsConnection: ToolVersionsConnection;
  ToolVersionsEdge: ToolVersionsEdge;
  Toolbox: Toolbox;
  ToolboxCondition: ToolboxCondition;
  ToolboxFilter: ToolboxFilter;
  ToolboxInput: ToolboxInput;
  ToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolboxKeyKeyUpdate: ToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolboxKeyKeyUpdate;
  ToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolboxPkeyUpdate: ToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdUsingToolboxPkeyUpdate;
  ToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxKeyKeyUpdate: ToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxKeyKeyUpdate;
  ToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxPkeyUpdate: ToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxPkeyUpdate;
  ToolboxPatch: ToolboxPatch;
  ToolboxTenant: ToolboxTenant;
  ToolboxTenantCondition: ToolboxTenantCondition;
  ToolboxTenantFilter: ToolboxTenantFilter;
  ToolboxTenantInput: ToolboxTenantInput;
  ToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingToolboxTenantsPkeyUpdate: ToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingToolboxTenantsPkeyUpdate;
  ToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingToolboxTenantsToolboxIdTenantId171F711CUniqUpdate: ToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdUsingToolboxTenantsToolboxIdTenantId171F711CUniqUpdate;
  ToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxTenantsPkeyUpdate: ToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxTenantsPkeyUpdate;
  ToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxTenantsToolboxIdTenantId171F711CUniqUpdate: ToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdUsingToolboxTenantsToolboxIdTenantId171F711CUniqUpdate;
  ToolboxTenantPatch: ToolboxTenantPatch;
  ToolboxTenantToolboxTenantsPkeyConnect: ToolboxTenantToolboxTenantsPkeyConnect;
  ToolboxTenantToolboxTenantsPkeyDelete: ToolboxTenantToolboxTenantsPkeyDelete;
  ToolboxTenantToolboxTenantsToolboxIdTenantId171F711CUniqConnect: ToolboxTenantToolboxTenantsToolboxIdTenantId171F711CUniqConnect;
  ToolboxTenantToolboxTenantsToolboxIdTenantId171F711CUniqDelete: ToolboxTenantToolboxTenantsToolboxIdTenantId171F711CUniqDelete;
  ToolboxTenantsConnection: ToolboxTenantsConnection;
  ToolboxTenantsEdge: ToolboxTenantsEdge;
  ToolboxTenantsTenantId5D0A40E4FkTenantIdInput: ToolboxTenantsTenantId5D0A40E4FkTenantIdInput;
  ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput: ToolboxTenantsTenantId5D0A40E4FkTenantIdInverseInput;
  ToolboxTenantsTenantId5D0A40E4FkTenantIdTenantCreateInput: ToolboxTenantsTenantId5D0A40E4FkTenantIdTenantCreateInput;
  ToolboxTenantsTenantId5D0A40E4FkTenantIdToolboxTenantsCreateInput: ToolboxTenantsTenantId5D0A40E4FkTenantIdToolboxTenantsCreateInput;
  ToolboxTenantsToolboxId9D553881FkToolboxIdInput: ToolboxTenantsToolboxId9D553881FkToolboxIdInput;
  ToolboxTenantsToolboxId9D553881FkToolboxIdInverseInput: ToolboxTenantsToolboxId9D553881FkToolboxIdInverseInput;
  ToolboxTenantsToolboxId9D553881FkToolboxIdToolboxCreateInput: ToolboxTenantsToolboxId9D553881FkToolboxIdToolboxCreateInput;
  ToolboxTenantsToolboxId9D553881FkToolboxIdToolboxTenantsCreateInput: ToolboxTenantsToolboxId9D553881FkToolboxIdToolboxTenantsCreateInput;
  ToolboxToManyToolFilter: ToolboxToManyToolFilter;
  ToolboxToManyToolboxTenantFilter: ToolboxToManyToolboxTenantFilter;
  ToolboxToolboxKeyKeyConnect: ToolboxToolboxKeyKeyConnect;
  ToolboxToolboxKeyKeyDelete: ToolboxToolboxKeyKeyDelete;
  ToolboxToolboxPkeyConnect: ToolboxToolboxPkeyConnect;
  ToolboxToolboxPkeyDelete: ToolboxToolboxPkeyDelete;
  ToolboxesConnection: ToolboxesConnection;
  ToolboxesEdge: ToolboxesEdge;
  ToolsConnection: ToolsConnection;
  ToolsEdge: ToolsEdge;
  UUID: Scalars["UUID"]["output"];
  UUIDFilter: UuidFilter;
  UpdateApplicationUserByEmailInput: UpdateApplicationUserByEmailInput;
  UpdateApplicationUserByGlobalUserIdInput: UpdateApplicationUserByGlobalUserIdInput;
  UpdateApplicationUserByIdInput: UpdateApplicationUserByIdInput;
  UpdateApplicationUserByUsernameInput: UpdateApplicationUserByUsernameInput;
  UpdateApplicationUserGroupByIdInput: UpdateApplicationUserGroupByIdInput;
  UpdateApplicationUserGroupByUserIdAndGroupIdInput: UpdateApplicationUserGroupByUserIdAndGroupIdInput;
  UpdateApplicationUserGroupPayload: UpdateApplicationUserGroupPayload;
  UpdateApplicationUserMembershipByIdInput: UpdateApplicationUserMembershipByIdInput;
  UpdateApplicationUserMembershipByUserIdAndTenantIdInput: UpdateApplicationUserMembershipByUserIdAndTenantIdInput;
  UpdateApplicationUserMembershipPayload: UpdateApplicationUserMembershipPayload;
  UpdateApplicationUserMetadatumByIdInput: UpdateApplicationUserMetadatumByIdInput;
  UpdateApplicationUserMetadatumByUserIdAndKeyInput: UpdateApplicationUserMetadatumByUserIdAndKeyInput;
  UpdateApplicationUserMetadatumPayload: UpdateApplicationUserMetadatumPayload;
  UpdateApplicationUserPayload: UpdateApplicationUserPayload;
  UpdateApplicationUserSessionByIdInput: UpdateApplicationUserSessionByIdInput;
  UpdateApplicationUserSessionPayload: UpdateApplicationUserSessionPayload;
  UpdateApplicationUserUserPermissionByIdInput: UpdateApplicationUserUserPermissionByIdInput;
  UpdateApplicationUserUserPermissionByUserIdAndPermissionIdInput: UpdateApplicationUserUserPermissionByUserIdAndPermissionIdInput;
  UpdateApplicationUserUserPermissionPayload: UpdateApplicationUserUserPermissionPayload;
  UpdateAuditlogLogentryByIdInput: UpdateAuditlogLogentryByIdInput;
  UpdateAuditlogLogentryPayload: UpdateAuditlogLogentryPayload;
  UpdateAuthGroupByIdInput: UpdateAuthGroupByIdInput;
  UpdateAuthGroupByNameInput: UpdateAuthGroupByNameInput;
  UpdateAuthGroupPayload: UpdateAuthGroupPayload;
  UpdateAuthGroupPermissionByGroupIdAndPermissionIdInput: UpdateAuthGroupPermissionByGroupIdAndPermissionIdInput;
  UpdateAuthGroupPermissionByIdInput: UpdateAuthGroupPermissionByIdInput;
  UpdateAuthGroupPermissionPayload: UpdateAuthGroupPermissionPayload;
  UpdateAuthPermissionByContentTypeIdAndCodenameInput: UpdateAuthPermissionByContentTypeIdAndCodenameInput;
  UpdateAuthPermissionByIdInput: UpdateAuthPermissionByIdInput;
  UpdateAuthPermissionPayload: UpdateAuthPermissionPayload;
  UpdateAvatarByIdInput: UpdateAvatarByIdInput;
  UpdateAvatarByUserIdInput: UpdateAvatarByUserIdInput;
  UpdateAvatarPayload: UpdateAvatarPayload;
  UpdateAwsBatchTaskByTaskexecutorPtrIdInput: UpdateAwsBatchTaskByTaskexecutorPtrIdInput;
  UpdateAwsBatchTaskPayload: UpdateAwsBatchTaskPayload;
  UpdateAwsCognitoUserByUserexecutorPtrIdInput: UpdateAwsCognitoUserByUserexecutorPtrIdInput;
  UpdateAwsCognitoUserPayload: UpdateAwsCognitoUserPayload;
  UpdateAwsEcrImageByContainerimageexecutorPtrIdInput: UpdateAwsEcrImageByContainerimageexecutorPtrIdInput;
  UpdateAwsEcrImagePayload: UpdateAwsEcrImagePayload;
  UpdateAwsMockBatchTaskByAwstaskexecutorPtrIdInput: UpdateAwsMockBatchTaskByAwstaskexecutorPtrIdInput;
  UpdateAwsMockBatchTaskPayload: UpdateAwsMockBatchTaskPayload;
  UpdateAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdInput: UpdateAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdInput;
  UpdateAwsMockDistributionImagePayload: UpdateAwsMockDistributionImagePayload;
  UpdateAwsMockEcrImageByAwscontainerimageexecutorPtrIdInput: UpdateAwsMockEcrImageByAwscontainerimageexecutorPtrIdInput;
  UpdateAwsMockEcrImagePayload: UpdateAwsMockEcrImagePayload;
  UpdateAwsMockIamUserByAwsuserexecutorPtrIdInput: UpdateAwsMockIamUserByAwsuserexecutorPtrIdInput;
  UpdateAwsMockIamUserPayload: UpdateAwsMockIamUserPayload;
  UpdateAwsMockS3FileByAwsfileexecutorPtrIdInput: UpdateAwsMockS3FileByAwsfileexecutorPtrIdInput;
  UpdateAwsMockS3FilePayload: UpdateAwsMockS3FilePayload;
  UpdateAwsS3FileByFileexecutorPtrIdInput: UpdateAwsS3FileByFileexecutorPtrIdInput;
  UpdateAwsS3FilePayload: UpdateAwsS3FilePayload;
  UpdateCodeFileByIdInput: UpdateCodeFileByIdInput;
  UpdateCodeFilePayload: UpdateCodeFilePayload;
  UpdateCommandByIdInput: UpdateCommandByIdInput;
  UpdateCommandByToolVersionIdAndCodeFileIdInput: UpdateCommandByToolVersionIdAndCodeFileIdInput;
  UpdateCommandByToolVersionIdInput: UpdateCommandByToolVersionIdInput;
  UpdateCommandPayload: UpdateCommandPayload;
  UpdateContainerImageByExecutorIdInput: UpdateContainerImageByExecutorIdInput;
  UpdateContainerImageByIdInput: UpdateContainerImageByIdInput;
  UpdateContainerImagePayload: UpdateContainerImagePayload;
  UpdateContainerImageRepositoryByIdInput: UpdateContainerImageRepositoryByIdInput;
  UpdateContainerImageRepositoryByNameAndTenantIdAndRegistryTypeInput: UpdateContainerImageRepositoryByNameAndTenantIdAndRegistryTypeInput;
  UpdateContainerImageRepositoryByRepositoryInput: UpdateContainerImageRepositoryByRepositoryInput;
  UpdateContainerImageRepositoryPayload: UpdateContainerImageRepositoryPayload;
  UpdateCostByIdInput: UpdateCostByIdInput;
  UpdateCostPayload: UpdateCostPayload;
  UpdateDistributionRegistryImageByContainerimageexecutorPtrIdInput: UpdateDistributionRegistryImageByContainerimageexecutorPtrIdInput;
  UpdateDistributionRegistryImagePayload: UpdateDistributionRegistryImagePayload;
  UpdateDjangoAdminLogByIdInput: UpdateDjangoAdminLogByIdInput;
  UpdateDjangoAdminLogPayload: UpdateDjangoAdminLogPayload;
  UpdateDjangoContentTypeByAppLabelAndModelInput: UpdateDjangoContentTypeByAppLabelAndModelInput;
  UpdateDjangoContentTypeByIdInput: UpdateDjangoContentTypeByIdInput;
  UpdateDjangoContentTypePayload: UpdateDjangoContentTypePayload;
  UpdateDjangoMigrationByIdInput: UpdateDjangoMigrationByIdInput;
  UpdateDjangoMigrationPayload: UpdateDjangoMigrationPayload;
  UpdateDjangoSesBlacklistedemailByEmailInput: UpdateDjangoSesBlacklistedemailByEmailInput;
  UpdateDjangoSesBlacklistedemailByIdInput: UpdateDjangoSesBlacklistedemailByIdInput;
  UpdateDjangoSesBlacklistedemailPayload: UpdateDjangoSesBlacklistedemailPayload;
  UpdateDjangoSesSesstatByDateInput: UpdateDjangoSesSesstatByDateInput;
  UpdateDjangoSesSesstatByIdInput: UpdateDjangoSesSesstatByIdInput;
  UpdateDjangoSesSesstatPayload: UpdateDjangoSesSesstatPayload;
  UpdateDjangoSessionBySessionKeyInput: UpdateDjangoSessionBySessionKeyInput;
  UpdateDjangoSessionPayload: UpdateDjangoSessionPayload;
  UpdateDrsFileexecutorByIdInput: UpdateDrsFileexecutorByIdInput;
  UpdateDrsFileexecutorPayload: UpdateDrsFileexecutorPayload;
  UpdateDrsMockfileexecutorByFileexecutorPtrIdInput: UpdateDrsMockfileexecutorByFileexecutorPtrIdInput;
  UpdateDrsMockfileexecutorPayload: UpdateDrsMockfileexecutorPayload;
  UpdateEulaVersionByIdInput: UpdateEulaVersionByIdInput;
  UpdateEulaVersionByVersionInput: UpdateEulaVersionByVersionInput;
  UpdateEulaVersionPayload: UpdateEulaVersionPayload;
  UpdateEulaVersionUserAcceptanceByIdInput: UpdateEulaVersionUserAcceptanceByIdInput;
  UpdateEulaVersionUserAcceptanceByUserIdAndEulaVersionIdInput: UpdateEulaVersionUserAcceptanceByUserIdAndEulaVersionIdInput;
  UpdateEulaVersionUserAcceptancePayload: UpdateEulaVersionUserAcceptancePayload;
  UpdateFeatureFlagByIdInput: UpdateFeatureFlagByIdInput;
  UpdateFeatureFlagByNameInput: UpdateFeatureFlagByNameInput;
  UpdateFeatureFlagPayload: UpdateFeatureFlagPayload;
  UpdateFeatureFlagsGroupByFeatureflagIdAndGroupIdInput: UpdateFeatureFlagsGroupByFeatureflagIdAndGroupIdInput;
  UpdateFeatureFlagsGroupByIdInput: UpdateFeatureFlagsGroupByIdInput;
  UpdateFeatureFlagsGroupPayload: UpdateFeatureFlagsGroupPayload;
  UpdateFeatureFlagsTenantByFeatureflagIdAndTenantIdInput: UpdateFeatureFlagsTenantByFeatureflagIdAndTenantIdInput;
  UpdateFeatureFlagsTenantByIdInput: UpdateFeatureFlagsTenantByIdInput;
  UpdateFeatureFlagsTenantPayload: UpdateFeatureFlagsTenantPayload;
  UpdateFeatureFlagsUserByFeatureflagIdAndUserIdInput: UpdateFeatureFlagsUserByFeatureflagIdAndUserIdInput;
  UpdateFeatureFlagsUserByIdInput: UpdateFeatureFlagsUserByIdInput;
  UpdateFeatureFlagsUserPayload: UpdateFeatureFlagsUserPayload;
  UpdateFileActivityByIdInput: UpdateFileActivityByIdInput;
  UpdateFileActivityPayload: UpdateFileActivityPayload;
  UpdateFileByIdInput: UpdateFileByIdInput;
  UpdateFileByProjectIdAndReferenceIdInput: UpdateFileByProjectIdAndReferenceIdInput;
  UpdateFileMetadatumByIdInput: UpdateFileMetadatumByIdInput;
  UpdateFileMetadatumPayload: UpdateFileMetadatumPayload;
  UpdateFileOutputGroupByIdInput: UpdateFileOutputGroupByIdInput;
  UpdateFileOutputGroupByTaskIdInput: UpdateFileOutputGroupByTaskIdInput;
  UpdateFileOutputGroupMetadatumByIdInput: UpdateFileOutputGroupMetadatumByIdInput;
  UpdateFileOutputGroupMetadatumPayload: UpdateFileOutputGroupMetadatumPayload;
  UpdateFileOutputGroupPayload: UpdateFileOutputGroupPayload;
  UpdateFilePayload: UpdateFilePayload;
  UpdateMetadataValueByIdInput: UpdateMetadataValueByIdInput;
  UpdateMetadataValuePayload: UpdateMetadataValuePayload;
  UpdateMetadatumByIdInput: UpdateMetadatumByIdInput;
  UpdateMetadatumPayload: UpdateMetadatumPayload;
  UpdateNotificationByIdInput: UpdateNotificationByIdInput;
  UpdateNotificationPayload: UpdateNotificationPayload;
  UpdateOutputGroupFileByIdInput: UpdateOutputGroupFileByIdInput;
  UpdateOutputGroupFilePayload: UpdateOutputGroupFilePayload;
  UpdatePinnedToolByIdInput: UpdatePinnedToolByIdInput;
  UpdatePinnedToolByUserIdAndToolIdInput: UpdatePinnedToolByUserIdAndToolIdInput;
  UpdatePinnedToolPayload: UpdatePinnedToolPayload;
  UpdateProjectFolderByIdInput: UpdateProjectFolderByIdInput;
  UpdateProjectFolderPayload: UpdateProjectFolderPayload;
  UpdateProjectTagByIdInput: UpdateProjectTagByIdInput;
  UpdateProjectTagPayload: UpdateProjectTagPayload;
  UpdateRunByIdInput: UpdateRunByIdInput;
  UpdateRunPayload: UpdateRunPayload;
  UpdateTaskActivityByIdInput: UpdateTaskActivityByIdInput;
  UpdateTaskActivityByTaskIdInput: UpdateTaskActivityByTaskIdInput;
  UpdateTaskActivityPayload: UpdateTaskActivityPayload;
  UpdateTaskByExecutorIdInput: UpdateTaskByExecutorIdInput;
  UpdateTaskByIdInput: UpdateTaskByIdInput;
  UpdateTaskPayload: UpdateTaskPayload;
  UpdateTaskResourceByIdInput: UpdateTaskResourceByIdInput;
  UpdateTaskResourcePayload: UpdateTaskResourcePayload;
  UpdateTaskResourceUsageByIdInput: UpdateTaskResourceUsageByIdInput;
  UpdateTaskResourceUsageByTaskIdInput: UpdateTaskResourceUsageByTaskIdInput;
  UpdateTaskResourceUsagePayload: UpdateTaskResourceUsagePayload;
  UpdateTaskSourceByIdInput: UpdateTaskSourceByIdInput;
  UpdateTaskSourcePayload: UpdateTaskSourcePayload;
  UpdateTaskStatusLogByIdInput: UpdateTaskStatusLogByIdInput;
  UpdateTaskStatusLogByTaskIdAndStatusInput: UpdateTaskStatusLogByTaskIdAndStatusInput;
  UpdateTaskStatusLogPayload: UpdateTaskStatusLogPayload;
  UpdateTenantByIdInput: UpdateTenantByIdInput;
  UpdateTenantByKeyInput: UpdateTenantByKeyInput;
  UpdateTenantByRepositoryNameInput: UpdateTenantByRepositoryNameInput;
  UpdateTenantBySfidInput: UpdateTenantBySfidInput;
  UpdateTenantContractAllowanceByIdInput: UpdateTenantContractAllowanceByIdInput;
  UpdateTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeInput: UpdateTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeInput;
  UpdateTenantContractAllowancePayload: UpdateTenantContractAllowancePayload;
  UpdateTenantContractByIdInput: UpdateTenantContractByIdInput;
  UpdateTenantContractByNameInput: UpdateTenantContractByNameInput;
  UpdateTenantContractBySfidInput: UpdateTenantContractBySfidInput;
  UpdateTenantContractPayload: UpdateTenantContractPayload;
  UpdateTenantContractTransactionByIdInput: UpdateTenantContractTransactionByIdInput;
  UpdateTenantContractTransactionPayload: UpdateTenantContractTransactionPayload;
  UpdateTenantMockuserexecutorByUserexecutorPtrIdInput: UpdateTenantMockuserexecutorByUserexecutorPtrIdInput;
  UpdateTenantMockuserexecutorPayload: UpdateTenantMockuserexecutorPayload;
  UpdateTenantMonthlyConsumedResourceByIdInput: UpdateTenantMonthlyConsumedResourceByIdInput;
  UpdateTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractInput: UpdateTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractInput;
  UpdateTenantMonthlyConsumedResourcePayload: UpdateTenantMonthlyConsumedResourcePayload;
  UpdateTenantPayload: UpdateTenantPayload;
  UpdateTenantUserexecutorByIdInput: UpdateTenantUserexecutorByIdInput;
  UpdateTenantUserexecutorPayload: UpdateTenantUserexecutorPayload;
  UpdateTesContainerimageexecutorByIdInput: UpdateTesContainerimageexecutorByIdInput;
  UpdateTesContainerimageexecutorPayload: UpdateTesContainerimageexecutorPayload;
  UpdateTesMockcontainerimageexecutorByContainerimageexecutorPtrIdInput: UpdateTesMockcontainerimageexecutorByContainerimageexecutorPtrIdInput;
  UpdateTesMockcontainerimageexecutorPayload: UpdateTesMockcontainerimageexecutorPayload;
  UpdateTesMocktaskexecutorByTaskexecutorPtrIdInput: UpdateTesMocktaskexecutorByTaskexecutorPtrIdInput;
  UpdateTesMocktaskexecutorPayload: UpdateTesMocktaskexecutorPayload;
  UpdateTesTaskexecutorByIdInput: UpdateTesTaskexecutorByIdInput;
  UpdateTesTaskexecutorPayload: UpdateTesTaskexecutorPayload;
  UpdateToolByIdInput: UpdateToolByIdInput;
  UpdateToolByProjectIdInput: UpdateToolByProjectIdInput;
  UpdateToolParameterByIdInput: UpdateToolParameterByIdInput;
  UpdateToolParameterPayload: UpdateToolParameterPayload;
  UpdateToolPayload: UpdateToolPayload;
  UpdateToolResourceByIdInput: UpdateToolResourceByIdInput;
  UpdateToolResourceByTypeAndToolVersionIdInput: UpdateToolResourceByTypeAndToolVersionIdInput;
  UpdateToolResourcePayload: UpdateToolResourcePayload;
  UpdateToolResultByIdInput: UpdateToolResultByIdInput;
  UpdateToolResultPayload: UpdateToolResultPayload;
  UpdateToolSecretByIdInput: UpdateToolSecretByIdInput;
  UpdateToolSecretPayload: UpdateToolSecretPayload;
  UpdateToolSourceByIdInput: UpdateToolSourceByIdInput;
  UpdateToolSourcePayload: UpdateToolSourcePayload;
  UpdateToolTenantByIdInput: UpdateToolTenantByIdInput;
  UpdateToolTenantByToolIdAndTenantIdInput: UpdateToolTenantByToolIdAndTenantIdInput;
  UpdateToolTenantPayload: UpdateToolTenantPayload;
  UpdateToolVersionByIdInput: UpdateToolVersionByIdInput;
  UpdateToolVersionPayload: UpdateToolVersionPayload;
  UpdateToolboxByIdInput: UpdateToolboxByIdInput;
  UpdateToolboxByKeyInput: UpdateToolboxByKeyInput;
  UpdateToolboxPayload: UpdateToolboxPayload;
  UpdateToolboxTenantByIdInput: UpdateToolboxTenantByIdInput;
  UpdateToolboxTenantByToolboxIdAndTenantIdInput: UpdateToolboxTenantByToolboxIdAndTenantIdInput;
  UpdateToolboxTenantPayload: UpdateToolboxTenantPayload;
  UpdateUserPersonalSpaceRequestByIdInput: UpdateUserPersonalSpaceRequestByIdInput;
  UpdateUserPersonalSpaceRequestPayload: UpdateUserPersonalSpaceRequestPayload;
  UpdateWaffleFlagByIdInput: UpdateWaffleFlagByIdInput;
  UpdateWaffleFlagByNameInput: UpdateWaffleFlagByNameInput;
  UpdateWaffleFlagPayload: UpdateWaffleFlagPayload;
  UpdateWaffleSampleByIdInput: UpdateWaffleSampleByIdInput;
  UpdateWaffleSampleByNameInput: UpdateWaffleSampleByNameInput;
  UpdateWaffleSamplePayload: UpdateWaffleSamplePayload;
  UpdateWaffleSwitchByIdInput: UpdateWaffleSwitchByIdInput;
  UpdateWaffleSwitchByNameInput: UpdateWaffleSwitchByNameInput;
  UpdateWaffleSwitchPayload: UpdateWaffleSwitchPayload;
  UpdateWorkflowByIdInput: UpdateWorkflowByIdInput;
  UpdateWorkflowDatumByIdInput: UpdateWorkflowDatumByIdInput;
  UpdateWorkflowDatumPayload: UpdateWorkflowDatumPayload;
  UpdateWorkflowPayload: UpdateWorkflowPayload;
  UpdateWorkflowResultByIdInput: UpdateWorkflowResultByIdInput;
  UpdateWorkflowResultPayload: UpdateWorkflowResultPayload;
  UpdateWorkflowResultWorkflowVersionByIdInput: UpdateWorkflowResultWorkflowVersionByIdInput;
  UpdateWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdInput: UpdateWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdInput;
  UpdateWorkflowResultWorkflowVersionPayload: UpdateWorkflowResultWorkflowVersionPayload;
  UpdateWorkflowSectionBlockByIdInput: UpdateWorkflowSectionBlockByIdInput;
  UpdateWorkflowSectionBlockPayload: UpdateWorkflowSectionBlockPayload;
  UpdateWorkflowSectionBlockSectionByBlockIdAndSectionIdInput: UpdateWorkflowSectionBlockSectionByBlockIdAndSectionIdInput;
  UpdateWorkflowSectionBlockSectionByIdInput: UpdateWorkflowSectionBlockSectionByIdInput;
  UpdateWorkflowSectionBlockSectionPayload: UpdateWorkflowSectionBlockSectionPayload;
  UpdateWorkflowSectionByIdInput: UpdateWorkflowSectionByIdInput;
  UpdateWorkflowSectionPayload: UpdateWorkflowSectionPayload;
  UpdateWorkflowSectionWorkflowVersionByIdInput: UpdateWorkflowSectionWorkflowVersionByIdInput;
  UpdateWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdInput: UpdateWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdInput;
  UpdateWorkflowSectionWorkflowVersionPayload: UpdateWorkflowSectionWorkflowVersionPayload;
  UpdateWorkflowSourceByIdInput: UpdateWorkflowSourceByIdInput;
  UpdateWorkflowSourcePayload: UpdateWorkflowSourcePayload;
  UpdateWorkflowSourceWorkflowVersionByIdInput: UpdateWorkflowSourceWorkflowVersionByIdInput;
  UpdateWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdInput: UpdateWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdInput;
  UpdateWorkflowSourceWorkflowVersionPayload: UpdateWorkflowSourceWorkflowVersionPayload;
  UpdateWorkflowVersionByIdInput: UpdateWorkflowVersionByIdInput;
  UpdateWorkflowVersionPayload: UpdateWorkflowVersionPayload;
  UserAccessToProject: UserAccessToProject;
  UserAccessToProjectCondition: UserAccessToProjectCondition;
  UserAccessToProjectFilter: UserAccessToProjectFilter;
  UserAccessToProjectsConnection: UserAccessToProjectsConnection;
  UserAccessToProjectsEdge: UserAccessToProjectsEdge;
  UserOnboardingQuesQuestionId65Ae6E1FFkUserOnboInput: UserOnboardingQuesQuestionId65Ae6E1FFkUserOnboInput;
  UserOnboardingQuesQuestionId65Ae6E1FFkUserOnboInverseInput: UserOnboardingQuesQuestionId65Ae6E1FFkUserOnboInverseInput;
  UserOnboardingQuesQuestionIdC28D2284FkUserOnboInput: UserOnboardingQuesQuestionIdC28D2284FkUserOnboInput;
  UserOnboardingQuesQuestionIdC28D2284FkUserOnboInverseInput: UserOnboardingQuesQuestionIdC28D2284FkUserOnboInverseInput;
  UserOnboardingQuesUserId72Eee3DfFkApplicatiApplicationUserCreateInput: UserOnboardingQuesUserId72Eee3DfFkApplicatiApplicationUserCreateInput;
  UserOnboardingQuesUserId72Eee3DfFkApplicatiInput: UserOnboardingQuesUserId72Eee3DfFkApplicatiInput;
  UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput: UserOnboardingQuesUserId72Eee3DfFkApplicatiInverseInput;
  UserOnboardingQuestion: UserOnboardingQuestion;
  UserOnboardingQuestionAnswer: UserOnboardingQuestionAnswer;
  UserOnboardingQuestionAnswerCondition: UserOnboardingQuestionAnswerCondition;
  UserOnboardingQuestionAnswerFilter: UserOnboardingQuestionAnswerFilter;
  UserOnboardingQuestionAnswerOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionAnswerPkeyUpdate: UserOnboardingQuestionAnswerOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionAnswerPkeyUpdate;
  UserOnboardingQuestionAnswerUserOnboardingQuestionAnswerPkeyConnect: UserOnboardingQuestionAnswerUserOnboardingQuestionAnswerPkeyConnect;
  UserOnboardingQuestionAnswersConnection: UserOnboardingQuestionAnswersConnection;
  UserOnboardingQuestionAnswersEdge: UserOnboardingQuestionAnswersEdge;
  UserOnboardingQuestionCondition: UserOnboardingQuestionCondition;
  UserOnboardingQuestionFilter: UserOnboardingQuestionFilter;
  UserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionCodeKeyUpdate: UserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionCodeKeyUpdate;
  UserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionPkeyUpdate: UserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboUsingUserOnboardingQuestionPkeyUpdate;
  UserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionCodeKeyUpdate: UserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionCodeKeyUpdate;
  UserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionPkeyUpdate: UserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionPkeyUpdate;
  UserOnboardingQuestionResponse: UserOnboardingQuestionResponse;
  UserOnboardingQuestionResponseCondition: UserOnboardingQuestionResponseCondition;
  UserOnboardingQuestionResponseFilter: UserOnboardingQuestionResponseFilter;
  UserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionResponsePkeyUpdate: UserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboUsingUserOnboardingQuestionResponsePkeyUpdate;
  UserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingUserOnboardingQuestionResponsePkeyUpdate: UserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiUsingUserOnboardingQuestionResponsePkeyUpdate;
  UserOnboardingQuestionResponseUserOnboardingQuestionResponsePkeyConnect: UserOnboardingQuestionResponseUserOnboardingQuestionResponsePkeyConnect;
  UserOnboardingQuestionResponsesConnection: UserOnboardingQuestionResponsesConnection;
  UserOnboardingQuestionResponsesEdge: UserOnboardingQuestionResponsesEdge;
  UserOnboardingQuestionToManyUserOnboardingQuestionAnswerFilter: UserOnboardingQuestionToManyUserOnboardingQuestionAnswerFilter;
  UserOnboardingQuestionToManyUserOnboardingQuestionResponseFilter: UserOnboardingQuestionToManyUserOnboardingQuestionResponseFilter;
  UserOnboardingQuestionUserOnboardingQuestionCodeKeyConnect: UserOnboardingQuestionUserOnboardingQuestionCodeKeyConnect;
  UserOnboardingQuestionUserOnboardingQuestionPkeyConnect: UserOnboardingQuestionUserOnboardingQuestionPkeyConnect;
  UserOnboardingQuestionsConnection: UserOnboardingQuestionsConnection;
  UserOnboardingQuestionsEdge: UserOnboardingQuestionsEdge;
  UserPersonalSpaceRequest: UserPersonalSpaceRequest;
  UserPersonalSpaceRequestCondition: UserPersonalSpaceRequestCondition;
  UserPersonalSpaceRequestFilter: UserPersonalSpaceRequestFilter;
  UserPersonalSpaceRequestInput: UserPersonalSpaceRequestInput;
  UserPersonalSpaceRequestOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingUserPersonalSpaceRequestPkeyUpdate: UserPersonalSpaceRequestOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiUsingUserPersonalSpaceRequestPkeyUpdate;
  UserPersonalSpaceRequestPatch: UserPersonalSpaceRequestPatch;
  UserPersonalSpaceRequestUserPersonalSpaceRequestPkeyConnect: UserPersonalSpaceRequestUserPersonalSpaceRequestPkeyConnect;
  UserPersonalSpaceRequestUserPersonalSpaceRequestPkeyDelete: UserPersonalSpaceRequestUserPersonalSpaceRequestPkeyDelete;
  UserPersonalSpaceRequestsConnection: UserPersonalSpaceRequestsConnection;
  UserPersonalSpaceRequestsEdge: UserPersonalSpaceRequestsEdge;
  UserPersonalSpaceUserId71D37C1EFkApplicatiApplicationUserCreateInput: UserPersonalSpaceUserId71D37C1EFkApplicatiApplicationUserCreateInput;
  UserPersonalSpaceUserId71D37C1EFkApplicatiInput: UserPersonalSpaceUserId71D37C1EFkApplicatiInput;
  UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput: UserPersonalSpaceUserId71D37C1EFkApplicatiInverseInput;
  UserPersonalSpaceUserId71D37C1EFkApplicatiUserPersonalSpaceRequestCreateInput: UserPersonalSpaceUserId71D37C1EFkApplicatiUserPersonalSpaceRequestCreateInput;
  WaffleFlag: WaffleFlag;
  WaffleFlagCondition: WaffleFlagCondition;
  WaffleFlagFilter: WaffleFlagFilter;
  WaffleFlagInput: WaffleFlagInput;
  WaffleFlagPatch: WaffleFlagPatch;
  WaffleFlagsConnection: WaffleFlagsConnection;
  WaffleFlagsEdge: WaffleFlagsEdge;
  WaffleSample: WaffleSample;
  WaffleSampleCondition: WaffleSampleCondition;
  WaffleSampleFilter: WaffleSampleFilter;
  WaffleSampleInput: WaffleSampleInput;
  WaffleSamplePatch: WaffleSamplePatch;
  WaffleSamplesConnection: WaffleSamplesConnection;
  WaffleSamplesEdge: WaffleSamplesEdge;
  WaffleSwitch: WaffleSwitch;
  WaffleSwitchCondition: WaffleSwitchCondition;
  WaffleSwitchFilter: WaffleSwitchFilter;
  WaffleSwitchInput: WaffleSwitchInput;
  WaffleSwitchPatch: WaffleSwitchPatch;
  WaffleSwitchesConnection: WaffleSwitchesConnection;
  WaffleSwitchesEdge: WaffleSwitchesEdge;
  Workflow: Workflow;
  WorkflowCondition: WorkflowCondition;
  WorkflowContainerIdE73A96E5FkContainerImageIdContainerImageCreateInput: WorkflowContainerIdE73A96E5FkContainerImageIdContainerImageCreateInput;
  WorkflowContainerIdE73A96E5FkContainerImageIdInput: WorkflowContainerIdE73A96E5FkContainerImageIdInput;
  WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput: WorkflowContainerIdE73A96E5FkContainerImageIdInverseInput;
  WorkflowContainerIdE73A96E5FkContainerImageIdWorkflowCreateInput: WorkflowContainerIdE73A96E5FkContainerImageIdWorkflowCreateInput;
  WorkflowDataConnection: WorkflowDataConnection;
  WorkflowDataEdge: WorkflowDataEdge;
  WorkflowDatum: WorkflowDatum;
  WorkflowDatumCondition: WorkflowDatumCondition;
  WorkflowDatumFilter: WorkflowDatumFilter;
  WorkflowDatumInput: WorkflowDatumInput;
  WorkflowDatumOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdUsingWorkflowDataPkeyUpdate: WorkflowDatumOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdUsingWorkflowDataPkeyUpdate;
  WorkflowDatumOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdUsingWorkflowDataPkeyUpdate: WorkflowDatumOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdUsingWorkflowDataPkeyUpdate;
  WorkflowDatumPatch: WorkflowDatumPatch;
  WorkflowDatumToManyWorkflowResultFilter: WorkflowDatumToManyWorkflowResultFilter;
  WorkflowDatumToManyWorkflowSectionBlockFilter: WorkflowDatumToManyWorkflowSectionBlockFilter;
  WorkflowDatumWorkflowDataPkeyConnect: WorkflowDatumWorkflowDataPkeyConnect;
  WorkflowDatumWorkflowDataPkeyDelete: WorkflowDatumWorkflowDataPkeyDelete;
  WorkflowFilter: WorkflowFilter;
  WorkflowInput: WorkflowInput;
  WorkflowOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingWorkflowPkeyUpdate: WorkflowOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdUsingWorkflowPkeyUpdate;
  WorkflowOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingWorkflowPkeyUpdate: WorkflowOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdUsingWorkflowPkeyUpdate;
  WorkflowOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingWorkflowPkeyUpdate: WorkflowOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdUsingWorkflowPkeyUpdate;
  WorkflowOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdUsingWorkflowPkeyUpdate: WorkflowOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdUsingWorkflowPkeyUpdate;
  WorkflowPatch: WorkflowPatch;
  WorkflowResult: WorkflowResult;
  WorkflowResultCondition: WorkflowResultCondition;
  WorkflowResultFilter: WorkflowResultFilter;
  WorkflowResultInput: WorkflowResultInput;
  WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInput: WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInput;
  WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInverseInput: WorkflowResultObjectIdC561D1C5FkWorkflowDataIdInverseInput;
  WorkflowResultObjectIdC561D1C5FkWorkflowDataIdWorkflowDataCreateInput: WorkflowResultObjectIdC561D1C5FkWorkflowDataIdWorkflowDataCreateInput;
  WorkflowResultObjectIdC561D1C5FkWorkflowDataIdWorkflowResultCreateInput: WorkflowResultObjectIdC561D1C5FkWorkflowDataIdWorkflowResultCreateInput;
  WorkflowResultOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdUsingWorkflowResultPkeyUpdate: WorkflowResultOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdUsingWorkflowResultPkeyUpdate;
  WorkflowResultOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultPkeyUpdate: WorkflowResultOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultPkeyUpdate;
  WorkflowResultPatch: WorkflowResultPatch;
  WorkflowResultToManyWorkflowResultWorkflowVersionFilter: WorkflowResultToManyWorkflowResultWorkflowVersionFilter;
  WorkflowResultWorkResultId50F959E2FkWorkflowInput: WorkflowResultWorkResultId50F959E2FkWorkflowInput;
  WorkflowResultWorkResultId50F959E2FkWorkflowInverseInput: WorkflowResultWorkResultId50F959E2FkWorkflowInverseInput;
  WorkflowResultWorkResultId50F959E2FkWorkflowWorkflowResultCreateInput: WorkflowResultWorkResultId50F959E2FkWorkflowWorkflowResultCreateInput;
  WorkflowResultWorkResultId50F959E2FkWorkflowWorkflowResultWorkflowVersionsCreateInput: WorkflowResultWorkResultId50F959E2FkWorkflowWorkflowResultWorkflowVersionsCreateInput;
  WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInput: WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInput;
  WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInverseInput: WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowInverseInput;
  WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowWorkflowResultWorkflowVersionsCreateInput: WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowWorkflowResultWorkflowVersionsCreateInput;
  WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowWorkflowVersionCreateInput: WorkflowResultWorkWorkflowversionIdB9123570FkWorkflowWorkflowVersionCreateInput;
  WorkflowResultWorkflowResultPkeyConnect: WorkflowResultWorkflowResultPkeyConnect;
  WorkflowResultWorkflowResultPkeyDelete: WorkflowResultWorkflowResultPkeyDelete;
  WorkflowResultWorkflowVersion: WorkflowResultWorkflowVersion;
  WorkflowResultWorkflowVersionCondition: WorkflowResultWorkflowVersionCondition;
  WorkflowResultWorkflowVersionFilter: WorkflowResultWorkflowVersionFilter;
  WorkflowResultWorkflowVersionInput: WorkflowResultWorkflowVersionInput;
  WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqUpdate: WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqUpdate;
  WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultWorkflowVersionsPkeyUpdate: WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowUsingWorkflowResultWorkflowVersionsPkeyUpdate;
  WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqUpdate: WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqUpdate;
  WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowResultWorkflowVersionsPkeyUpdate: WorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowResultWorkflowVersionsPkeyUpdate;
  WorkflowResultWorkflowVersionPatch: WorkflowResultWorkflowVersionPatch;
  WorkflowResultWorkflowVersionWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqConnect: WorkflowResultWorkflowVersionWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqConnect;
  WorkflowResultWorkflowVersionWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqDelete: WorkflowResultWorkflowVersionWorkflowResultWorkflowResultIdWorkflowversioF1Af219DUniqDelete;
  WorkflowResultWorkflowVersionWorkflowResultWorkflowVersionsPkeyConnect: WorkflowResultWorkflowVersionWorkflowResultWorkflowVersionsPkeyConnect;
  WorkflowResultWorkflowVersionWorkflowResultWorkflowVersionsPkeyDelete: WorkflowResultWorkflowVersionWorkflowResultWorkflowVersionsPkeyDelete;
  WorkflowResultWorkflowVersionsConnection: WorkflowResultWorkflowVersionsConnection;
  WorkflowResultWorkflowVersionsEdge: WorkflowResultWorkflowVersionsEdge;
  WorkflowResultsConnection: WorkflowResultsConnection;
  WorkflowResultsEdge: WorkflowResultsEdge;
  WorkflowSection: WorkflowSection;
  WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInput: WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInput;
  WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInverseInput: WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowInverseInput;
  WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowWorkflowSectionBlockCreateInput: WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowWorkflowSectionBlockCreateInput;
  WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowWorkflowSectionBlockSectionsCreateInput: WorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowWorkflowSectionBlockSectionsCreateInput;
  WorkflowSectionBloSectionId817C1C77FkWorkflowInput: WorkflowSectionBloSectionId817C1C77FkWorkflowInput;
  WorkflowSectionBloSectionId817C1C77FkWorkflowInverseInput: WorkflowSectionBloSectionId817C1C77FkWorkflowInverseInput;
  WorkflowSectionBloSectionId817C1C77FkWorkflowWorkflowSectionBlockSectionsCreateInput: WorkflowSectionBloSectionId817C1C77FkWorkflowWorkflowSectionBlockSectionsCreateInput;
  WorkflowSectionBloSectionId817C1C77FkWorkflowWorkflowSectionCreateInput: WorkflowSectionBloSectionId817C1C77FkWorkflowWorkflowSectionCreateInput;
  WorkflowSectionBlock: WorkflowSectionBlock;
  WorkflowSectionBlockCondition: WorkflowSectionBlockCondition;
  WorkflowSectionBlockFilter: WorkflowSectionBlockFilter;
  WorkflowSectionBlockInput: WorkflowSectionBlockInput;
  WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInput: WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInput;
  WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInverseInput: WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdInverseInput;
  WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdWorkflowDataCreateInput: WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdWorkflowDataCreateInput;
  WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdWorkflowSectionBlockCreateInput: WorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdWorkflowSectionBlockCreateInput;
  WorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdUsingWorkflowSectionBlockPkeyUpdate: WorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdUsingWorkflowSectionBlockPkeyUpdate;
  WorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdUsingWorkflowSectionBlockPkeyUpdate: WorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdUsingWorkflowSectionBlockPkeyUpdate;
  WorkflowSectionBlockOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockPkeyUpdate: WorkflowSectionBlockOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockPkeyUpdate;
  WorkflowSectionBlockPatch: WorkflowSectionBlockPatch;
  WorkflowSectionBlockSection: WorkflowSectionBlockSection;
  WorkflowSectionBlockSectionCondition: WorkflowSectionBlockSectionCondition;
  WorkflowSectionBlockSectionFilter: WorkflowSectionBlockSectionFilter;
  WorkflowSectionBlockSectionInput: WorkflowSectionBlockSectionInput;
  WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockSBlockIdSectionId2F785D93UniqUpdate: WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockSBlockIdSectionId2F785D93UniqUpdate;
  WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockSectionsPkeyUpdate: WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowUsingWorkflowSectionBlockSectionsPkeyUpdate;
  WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionBlockSBlockIdSectionId2F785D93UniqUpdate: WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionBlockSBlockIdSectionId2F785D93UniqUpdate;
  WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionBlockSectionsPkeyUpdate: WorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionBlockSectionsPkeyUpdate;
  WorkflowSectionBlockSectionPatch: WorkflowSectionBlockSectionPatch;
  WorkflowSectionBlockSectionWorkflowSectionBlockSBlockIdSectionId2F785D93UniqConnect: WorkflowSectionBlockSectionWorkflowSectionBlockSBlockIdSectionId2F785D93UniqConnect;
  WorkflowSectionBlockSectionWorkflowSectionBlockSBlockIdSectionId2F785D93UniqDelete: WorkflowSectionBlockSectionWorkflowSectionBlockSBlockIdSectionId2F785D93UniqDelete;
  WorkflowSectionBlockSectionWorkflowSectionBlockSectionsPkeyConnect: WorkflowSectionBlockSectionWorkflowSectionBlockSectionsPkeyConnect;
  WorkflowSectionBlockSectionWorkflowSectionBlockSectionsPkeyDelete: WorkflowSectionBlockSectionWorkflowSectionBlockSectionsPkeyDelete;
  WorkflowSectionBlockSectionsConnection: WorkflowSectionBlockSectionsConnection;
  WorkflowSectionBlockSectionsEdge: WorkflowSectionBlockSectionsEdge;
  WorkflowSectionBlockToManyWorkflowSectionBlockSectionFilter: WorkflowSectionBlockToManyWorkflowSectionBlockSectionFilter;
  WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInput: WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInput;
  WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput: WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdInverseInput;
  WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdToolVersionCreateInput: WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdToolVersionCreateInput;
  WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdWorkflowSectionBlockCreateInput: WorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdWorkflowSectionBlockCreateInput;
  WorkflowSectionBlockWorkflowSectionBlockPkeyConnect: WorkflowSectionBlockWorkflowSectionBlockPkeyConnect;
  WorkflowSectionBlockWorkflowSectionBlockPkeyDelete: WorkflowSectionBlockWorkflowSectionBlockPkeyDelete;
  WorkflowSectionBlocksConnection: WorkflowSectionBlocksConnection;
  WorkflowSectionBlocksEdge: WorkflowSectionBlocksEdge;
  WorkflowSectionCondition: WorkflowSectionCondition;
  WorkflowSectionFilter: WorkflowSectionFilter;
  WorkflowSectionInput: WorkflowSectionInput;
  WorkflowSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionPkeyUpdate: WorkflowSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowUsingWorkflowSectionPkeyUpdate;
  WorkflowSectionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionPkeyUpdate: WorkflowSectionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionPkeyUpdate;
  WorkflowSectionPatch: WorkflowSectionPatch;
  WorkflowSectionToManyWorkflowSectionBlockSectionFilter: WorkflowSectionToManyWorkflowSectionBlockSectionFilter;
  WorkflowSectionToManyWorkflowSectionWorkflowVersionFilter: WorkflowSectionToManyWorkflowSectionWorkflowVersionFilter;
  WorkflowSectionWorSectionId1D5C2D63FkWorkflowInput: WorkflowSectionWorSectionId1D5C2D63FkWorkflowInput;
  WorkflowSectionWorSectionId1D5C2D63FkWorkflowInverseInput: WorkflowSectionWorSectionId1D5C2D63FkWorkflowInverseInput;
  WorkflowSectionWorSectionId1D5C2D63FkWorkflowWorkflowSectionCreateInput: WorkflowSectionWorSectionId1D5C2D63FkWorkflowWorkflowSectionCreateInput;
  WorkflowSectionWorSectionId1D5C2D63FkWorkflowWorkflowSectionWorkflowVersionsCreateInput: WorkflowSectionWorSectionId1D5C2D63FkWorkflowWorkflowSectionWorkflowVersionsCreateInput;
  WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInput: WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInput;
  WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInverseInput: WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowInverseInput;
  WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowWorkflowSectionWorkflowVersionsCreateInput: WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowWorkflowSectionWorkflowVersionsCreateInput;
  WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowWorkflowVersionCreateInput: WorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowWorkflowVersionCreateInput;
  WorkflowSectionWorkflowSectionPkeyConnect: WorkflowSectionWorkflowSectionPkeyConnect;
  WorkflowSectionWorkflowSectionPkeyDelete: WorkflowSectionWorkflowSectionPkeyDelete;
  WorkflowSectionWorkflowVersion: WorkflowSectionWorkflowVersion;
  WorkflowSectionWorkflowVersionCondition: WorkflowSectionWorkflowVersionCondition;
  WorkflowSectionWorkflowVersionFilter: WorkflowSectionWorkflowVersionFilter;
  WorkflowSectionWorkflowVersionInput: WorkflowSectionWorkflowVersionInput;
  WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqUpdate: WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqUpdate;
  WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionWorkflowVersionsPkeyUpdate: WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowUsingWorkflowSectionWorkflowVersionsPkeyUpdate;
  WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqUpdate: WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqUpdate;
  WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowSectionWorkflowVersionsPkeyUpdate: WorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowSectionWorkflowVersionsPkeyUpdate;
  WorkflowSectionWorkflowVersionPatch: WorkflowSectionWorkflowVersionPatch;
  WorkflowSectionWorkflowVersionWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqConnect: WorkflowSectionWorkflowVersionWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqConnect;
  WorkflowSectionWorkflowVersionWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqDelete: WorkflowSectionWorkflowVersionWorkflowSectionWorkfloSectionIdWorkflowversi9Bd5E089UniqDelete;
  WorkflowSectionWorkflowVersionWorkflowSectionWorkflowVersionsPkeyConnect: WorkflowSectionWorkflowVersionWorkflowSectionWorkflowVersionsPkeyConnect;
  WorkflowSectionWorkflowVersionWorkflowSectionWorkflowVersionsPkeyDelete: WorkflowSectionWorkflowVersionWorkflowSectionWorkflowVersionsPkeyDelete;
  WorkflowSectionWorkflowVersionsConnection: WorkflowSectionWorkflowVersionsConnection;
  WorkflowSectionWorkflowVersionsEdge: WorkflowSectionWorkflowVersionsEdge;
  WorkflowSectionsConnection: WorkflowSectionsConnection;
  WorkflowSectionsEdge: WorkflowSectionsEdge;
  WorkflowSource: WorkflowSource;
  WorkflowSourceCondition: WorkflowSourceCondition;
  WorkflowSourceFilter: WorkflowSourceFilter;
  WorkflowSourceInput: WorkflowSourceInput;
  WorkflowSourceOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourcePkeyUpdate: WorkflowSourceOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourcePkeyUpdate;
  WorkflowSourcePatch: WorkflowSourcePatch;
  WorkflowSourceToManyWorkflowSourceWorkflowVersionFilter: WorkflowSourceToManyWorkflowSourceWorkflowVersionFilter;
  WorkflowSourceWorkSourceId608A289DFkWorkflowInput: WorkflowSourceWorkSourceId608A289DFkWorkflowInput;
  WorkflowSourceWorkSourceId608A289DFkWorkflowInverseInput: WorkflowSourceWorkSourceId608A289DFkWorkflowInverseInput;
  WorkflowSourceWorkSourceId608A289DFkWorkflowWorkflowSourceCreateInput: WorkflowSourceWorkSourceId608A289DFkWorkflowWorkflowSourceCreateInput;
  WorkflowSourceWorkSourceId608A289DFkWorkflowWorkflowSourceWorkflowVersionsCreateInput: WorkflowSourceWorkSourceId608A289DFkWorkflowWorkflowSourceWorkflowVersionsCreateInput;
  WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInput: WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInput;
  WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInverseInput: WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowInverseInput;
  WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowWorkflowSourceWorkflowVersionsCreateInput: WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowWorkflowSourceWorkflowVersionsCreateInput;
  WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowWorkflowVersionCreateInput: WorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowWorkflowVersionCreateInput;
  WorkflowSourceWorkflowSourcePkeyConnect: WorkflowSourceWorkflowSourcePkeyConnect;
  WorkflowSourceWorkflowSourcePkeyDelete: WorkflowSourceWorkflowSourcePkeyDelete;
  WorkflowSourceWorkflowVersion: WorkflowSourceWorkflowVersion;
  WorkflowSourceWorkflowVersionCondition: WorkflowSourceWorkflowVersionCondition;
  WorkflowSourceWorkflowVersionFilter: WorkflowSourceWorkflowVersionFilter;
  WorkflowSourceWorkflowVersionInput: WorkflowSourceWorkflowVersionInput;
  WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqUpdate: WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqUpdate;
  WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourceWorkflowVersionsPkeyUpdate: WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowUsingWorkflowSourceWorkflowVersionsPkeyUpdate;
  WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqUpdate: WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqUpdate;
  WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowSourceWorkflowVersionsPkeyUpdate: WorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowSourceWorkflowVersionsPkeyUpdate;
  WorkflowSourceWorkflowVersionPatch: WorkflowSourceWorkflowVersionPatch;
  WorkflowSourceWorkflowVersionWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqConnect: WorkflowSourceWorkflowVersionWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqConnect;
  WorkflowSourceWorkflowVersionWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqDelete: WorkflowSourceWorkflowVersionWorkflowSourceWorkflowSourceIdWorkflowversio20446Ce3UniqDelete;
  WorkflowSourceWorkflowVersionWorkflowSourceWorkflowVersionsPkeyConnect: WorkflowSourceWorkflowVersionWorkflowSourceWorkflowVersionsPkeyConnect;
  WorkflowSourceWorkflowVersionWorkflowSourceWorkflowVersionsPkeyDelete: WorkflowSourceWorkflowVersionWorkflowSourceWorkflowVersionsPkeyDelete;
  WorkflowSourceWorkflowVersionsConnection: WorkflowSourceWorkflowVersionsConnection;
  WorkflowSourceWorkflowVersionsEdge: WorkflowSourceWorkflowVersionsEdge;
  WorkflowSourcesConnection: WorkflowSourcesConnection;
  WorkflowSourcesEdge: WorkflowSourcesEdge;
  WorkflowTenantId9469Ff84FkTenantIdInput: WorkflowTenantId9469Ff84FkTenantIdInput;
  WorkflowTenantId9469Ff84FkTenantIdInverseInput: WorkflowTenantId9469Ff84FkTenantIdInverseInput;
  WorkflowTenantId9469Ff84FkTenantIdTenantCreateInput: WorkflowTenantId9469Ff84FkTenantIdTenantCreateInput;
  WorkflowTenantId9469Ff84FkTenantIdWorkflowCreateInput: WorkflowTenantId9469Ff84FkTenantIdWorkflowCreateInput;
  WorkflowToManyWorkflowVersionFilter: WorkflowToManyWorkflowVersionFilter;
  WorkflowUserId121C1967FkApplicationUserIdApplicationUserCreateInput: WorkflowUserId121C1967FkApplicationUserIdApplicationUserCreateInput;
  WorkflowUserId121C1967FkApplicationUserIdInput: WorkflowUserId121C1967FkApplicationUserIdInput;
  WorkflowUserId121C1967FkApplicationUserIdInverseInput: WorkflowUserId121C1967FkApplicationUserIdInverseInput;
  WorkflowUserId121C1967FkApplicationUserIdWorkflowCreateInput: WorkflowUserId121C1967FkApplicationUserIdWorkflowCreateInput;
  WorkflowVersion: WorkflowVersion;
  WorkflowVersionCondition: WorkflowVersionCondition;
  WorkflowVersionFilter: WorkflowVersionFilter;
  WorkflowVersionInput: WorkflowVersionInput;
  WorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowVersionPkeyUpdate: WorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowUsingWorkflowVersionPkeyUpdate;
  WorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowVersionPkeyUpdate: WorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowUsingWorkflowVersionPkeyUpdate;
  WorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowVersionPkeyUpdate: WorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowUsingWorkflowVersionPkeyUpdate;
  WorkflowVersionOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingWorkflowVersionPkeyUpdate: WorkflowVersionOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdUsingWorkflowVersionPkeyUpdate;
  WorkflowVersionOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdUsingWorkflowVersionPkeyUpdate: WorkflowVersionOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdUsingWorkflowVersionPkeyUpdate;
  WorkflowVersionPatch: WorkflowVersionPatch;
  WorkflowVersionToManyWorkflowResultWorkflowVersionFilter: WorkflowVersionToManyWorkflowResultWorkflowVersionFilter;
  WorkflowVersionToManyWorkflowSectionWorkflowVersionFilter: WorkflowVersionToManyWorkflowSectionWorkflowVersionFilter;
  WorkflowVersionToManyWorkflowSourceWorkflowVersionFilter: WorkflowVersionToManyWorkflowSourceWorkflowVersionFilter;
  WorkflowVersionUserId00C0F62FFkApplicationUserIdApplicationUserCreateInput: WorkflowVersionUserId00C0F62FFkApplicationUserIdApplicationUserCreateInput;
  WorkflowVersionUserId00C0F62FFkApplicationUserIdInput: WorkflowVersionUserId00C0F62FFkApplicationUserIdInput;
  WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput: WorkflowVersionUserId00C0F62FFkApplicationUserIdInverseInput;
  WorkflowVersionUserId00C0F62FFkApplicationUserIdWorkflowVersionCreateInput: WorkflowVersionUserId00C0F62FFkApplicationUserIdWorkflowVersionCreateInput;
  WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInput: WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInput;
  WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInverseInput: WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdInverseInput;
  WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdWorkflowCreateInput: WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdWorkflowCreateInput;
  WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdWorkflowVersionCreateInput: WorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdWorkflowVersionCreateInput;
  WorkflowVersionWorkflowVersionPkeyConnect: WorkflowVersionWorkflowVersionPkeyConnect;
  WorkflowVersionWorkflowVersionPkeyDelete: WorkflowVersionWorkflowVersionPkeyDelete;
  WorkflowVersionsConnection: WorkflowVersionsConnection;
  WorkflowVersionsEdge: WorkflowVersionsEdge;
  WorkflowWorkflowPkeyConnect: WorkflowWorkflowPkeyConnect;
  WorkflowWorkflowPkeyDelete: WorkflowWorkflowPkeyDelete;
  WorkflowsConnection: WorkflowsConnection;
  WorkflowsEdge: WorkflowsEdge;
  updateApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdPatch: UpdateApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdPatch;
  updateApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdPatch: UpdateApplicationUserGroupOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdPatch;
  updateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch: UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
  updateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch: UpdateApplicationUserMembershipOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
  updateApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch: UpdateApplicationUserMetadatumOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
  updateApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdPatch: UpdateApplicationUserOnApplicationUserGroupForApplicationUserGroupsUserIdE5A7130FFkApplicationUserIdPatch;
  updateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch: UpdateApplicationUserOnApplicationUserMembershipForApplicationUserMemUserId631Fddc5FkApplicatiPatch;
  updateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch: UpdateApplicationUserOnApplicationUserMetadatumForApplicationUserMetUserId897Fbde1FkApplicatiPatch;
  updateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch: UpdateApplicationUserOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
  updateApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiPatch: UpdateApplicationUserOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiPatch;
  updateApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdPatch: UpdateApplicationUserOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdPatch;
  updateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch: UpdateApplicationUserOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
  updateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch: UpdateApplicationUserOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
  updateApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdPatch: UpdateApplicationUserOnCommandForCommandUserId4A445414FkApplicationUserIdPatch;
  updateApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdPatch: UpdateApplicationUserOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdPatch;
  updateApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiPatch: UpdateApplicationUserOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiPatch;
  updateApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdPatch: UpdateApplicationUserOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdPatch;
  updateApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdPatch: UpdateApplicationUserOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdPatch;
  updateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch: UpdateApplicationUserOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
  updateApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdPatch: UpdateApplicationUserOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdPatch;
  updateApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdPatch: UpdateApplicationUserOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdPatch;
  updateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch: UpdateApplicationUserOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
  updateApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdPatch: UpdateApplicationUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdPatch;
  updateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch: UpdateApplicationUserOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
  updateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch: UpdateApplicationUserOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
  updateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch: UpdateApplicationUserOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
  updateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch: UpdateApplicationUserOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
  updateApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiPatch: UpdateApplicationUserOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiPatch;
  updateApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiPatch: UpdateApplicationUserOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiPatch;
  updateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch: UpdateApplicationUserOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
  updateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch: UpdateApplicationUserOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
  updateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch: UpdateApplicationUserOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
  updateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch: UpdateApplicationUserOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
  updateApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdPatch: UpdateApplicationUserOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdPatch;
  updateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch: UpdateApplicationUserOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
  updateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch: UpdateApplicationUserOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
  updateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch: UpdateApplicationUserOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
  updateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
  updateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch: UpdateApplicationUserOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
  updateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch: UpdateApplicationUserOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
  updateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch: UpdateApplicationUserOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
  updateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch: UpdateApplicationUserOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
  updateApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiPatch: UpdateApplicationUserOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiPatch;
  updateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
  updateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch: UpdateApplicationUserOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
  updateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch: UpdateApplicationUserOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
  updateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch: UpdateApplicationUserOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
  updateApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiPatch: UpdateApplicationUserOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiPatch;
  updateApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiPatch: UpdateApplicationUserOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiPatch;
  updateApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdPatch: UpdateApplicationUserOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdPatch;
  updateApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdPatch: UpdateApplicationUserOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdPatch;
  updateApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch: UpdateApplicationUserSessionOnApplicationUserSessionForApplicationUserSesUserId2Fb30D0CFkApplicatiPatch;
  updateApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch: UpdateApplicationUserSessionOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
  updateApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermPatch: UpdateApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermPatch;
  updateApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiPatch: UpdateApplicationUserUserPermissionOnApplicationUserUserPermissionForApplicationUserUseUserIdE643F548FkApplicatiPatch;
  updateAuditlogLogentryOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdPatch: UpdateAuditlogLogentryOnAuditlogLogentryForAuditlogLogentryActorId959271D2FkApplicationUserIdPatch;
  updateAuditlogLogentryOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoPatch: UpdateAuditlogLogentryOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoPatch;
  updateAuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdPatch: UpdateAuthGroupOnApplicationUserGroupForApplicationUserGroupsGroupId7157B7AcFkAuthGroupIdPatch;
  updateAuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdPatch: UpdateAuthGroupOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdPatch;
  updateAuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdPatch: UpdateAuthGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdPatch;
  updateAuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermPatch: UpdateAuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermPatch;
  updateAuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdPatch: UpdateAuthGroupPermissionOnAuthGroupPermissionForAuthGroupPermissionsGroupIdB120Cbf9FkAuthGroupIdPatch;
  updateAuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermPatch: UpdateAuthPermissionOnApplicationUserUserPermissionForApplicationUserUsePermissionIdDbf9693DFkAuthPermPatch;
  updateAuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermPatch: UpdateAuthPermissionOnAuthGroupPermissionForAuthGroupPermissioPermissionId84C5C92EFkAuthPermPatch;
  updateAuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoPatch: UpdateAuthPermissionOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoPatch;
  updateAvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch: UpdateAvatarOnAvatarForAvatarUserId771332F2FkApplicationUserIdPatch;
  updateAwsBatchTaskOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskePatch: UpdateAwsBatchTaskOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskePatch;
  updateAwsBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchPatch: UpdateAwsBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchPatch;
  updateAwsCognitoUserOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsPatch: UpdateAwsCognitoUserOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsPatch;
  updateAwsCognitoUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniPatch: UpdateAwsCognitoUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniPatch;
  updateAwsEcrImageOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaPatch: UpdateAwsEcrImageOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaPatch;
  updateAwsEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIPatch: UpdateAwsEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIPatch;
  updateAwsMockBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchPatch: UpdateAwsMockBatchTaskOnAwsMockBatchTaskForAwsMockBatchTaskAwstaskexecutorPtrFfae22F7FkAwsBatchPatch;
  updateAwsMockDistributionImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributPatch: UpdateAwsMockDistributionImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributPatch;
  updateAwsMockEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIPatch: UpdateAwsMockEcrImageOnAwsMockEcrImageForAwsMockEcrImageAwscontainerimageexe31C2A1A9FkAwsEcrIPatch;
  updateAwsMockIamUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniPatch: UpdateAwsMockIamUserOnAwsMockIamUserForAwsMockIamUserAwsuserexecutorPtrB5032Cd2FkAwsCogniPatch;
  updateAwsMockS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiPatch: UpdateAwsMockS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiPatch;
  updateAwsS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiPatch: UpdateAwsS3FileOnAwsMockS3FileForAwsMockS3FileAwsfileexecutorPtrC1Bbee03FkAwsS3FiPatch;
  updateAwsS3FileOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdPatch: UpdateAwsS3FileOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdPatch;
  updateCodeFileOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdPatch: UpdateCodeFileOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdPatch;
  updateCodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdPatch: UpdateCodeFileOnCodeFileForCodeFileSeriesParentIdE5Ea16D4FkCodeFileIdPatch;
  updateCodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch: UpdateCodeFileOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
  updateCodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch: UpdateCodeFileOnCodeFileForCodeFileUserIdAb9E5143FkApplicationUserIdPatch;
  updateCodeFileOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdPatch: UpdateCodeFileOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdPatch;
  updateCommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdPatch: UpdateCommandOnCommandForCommandCodeFileIdE6Dc0F85FkCodeFileIdPatch;
  updateCommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdPatch: UpdateCommandOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdPatch;
  updateCommandOnCommandForCommandTenantId36F95C3CFkTenantIdPatch: UpdateCommandOnCommandForCommandTenantId36F95C3CFkTenantIdPatch;
  updateCommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdPatch: UpdateCommandOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdPatch;
  updateCommandOnCommandForCommandUserId4A445414FkApplicationUserIdPatch: UpdateCommandOnCommandForCommandUserId4A445414FkApplicationUserIdPatch;
  updateContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdPatch: UpdateContainerImageOnCommandForCommandContainerImageId447E7Cb3FkContainerImageIdPatch;
  updateContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerPatch: UpdateContainerImageOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerPatch;
  updateContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaPatch: UpdateContainerImageOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaPatch;
  updateContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdPatch: UpdateContainerImageOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdPatch;
  updateContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdPatch: UpdateContainerImageOnContainerImageForContainerImageUserId3919E673FkApplicationUserIdPatch;
  updateContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdPatch: UpdateContainerImageOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdPatch;
  updateContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdPatch: UpdateContainerImageOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdPatch;
  updateContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdPatch: UpdateContainerImageOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdPatch;
  updateContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerPatch: UpdateContainerImageRepositoryOnContainerImageForContainerImageContainerImageRepoBe6Ba4A8FkContainerPatch;
  updateContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiPatch: UpdateContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepoUserIdAf9751AfFkApplicatiPatch;
  updateContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdPatch: UpdateContainerImageRepositoryOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdPatch;
  updateCostOnCostForCostTenantId7Dcd58A7FkTenantIdPatch: UpdateCostOnCostForCostTenantId7Dcd58A7FkTenantIdPatch;
  updateCostOnFileActivityForFileActivityCostId2A88D90AFkCostIdPatch: UpdateCostOnFileActivityForFileActivityCostId2A88D90AFkCostIdPatch;
  updateCostOnTaskActivityForTaskActivityCostId49E66058FkCostIdPatch: UpdateCostOnTaskActivityForTaskActivityCostId49E66058FkCostIdPatch;
  updateDataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdPatch: UpdateDataTableCellOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdPatch;
  updateDataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdPatch: UpdateDataTableCellOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdPatch;
  updateDataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdPatch: UpdateDataTableCellOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdPatch;
  updateDataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdPatch: UpdateDataTableCellOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdPatch;
  updateDataTableColumnDefinitionBooleanOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIPatch: UpdateDataTableColumnDefinitionBooleanOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIPatch;
  updateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoPatch: UpdateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoPatch;
  updateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoPatch: UpdateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoPatch;
  updateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIPatch: UpdateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIPatch;
  updateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoPatch: UpdateDataTableColumnDefinitionCellStatusOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoPatch;
  updateDataTableColumnDefinitionChoiceOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIPatch: UpdateDataTableColumnDefinitionChoiceOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIPatch;
  updateDataTableColumnDefinitionDateOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIPatch: UpdateDataTableColumnDefinitionDateOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIPatch;
  updateDataTableColumnDefinitionFileOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIPatch: UpdateDataTableColumnDefinitionFileOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIPatch;
  updateDataTableColumnDefinitionFloatOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIPatch: UpdateDataTableColumnDefinitionFloatOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIPatch;
  updateDataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIPatch: UpdateDataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIPatch;
  updateDataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoPatch: UpdateDataTableColumnDefinitionIdentifierOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoPatch;
  updateDataTableColumnDefinitionIntegerOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIPatch: UpdateDataTableColumnDefinitionIntegerOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIPatch;
  updateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoPatch: UpdateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoPatch;
  updateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIPatch: UpdateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIPatch;
  updateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoPatch: UpdateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoPatch;
  updateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIE4E5D06AFkDjangoCoPatch: UpdateDataTableColumnDefinitionJoinOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoPatch;
  updateDataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoPatch: UpdateDataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoPatch;
  updateDataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIPatch: UpdateDataTableColumnDefinitionMetadatumOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIPatch;
  updateDataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoPatch: UpdateDataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoPatch;
  updateDataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIPatch: UpdateDataTableColumnDefinitionRoiFrameOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIPatch;
  updateDataTableColumnDefinitionTextOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIPatch: UpdateDataTableColumnDefinitionTextOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIPatch;
  updateDataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIPatch: UpdateDataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIPatch;
  updateDataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoPatch: UpdateDataTableColumnGroupDefinitionJoinOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoPatch;
  updateDataTableColumnGroupDefinitionSourceOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIPatch: UpdateDataTableColumnGroupDefinitionSourceOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIPatch;
  updateDataTableColumnGroupOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablPatch: UpdateDataTableColumnGroupOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablPatch;
  updateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoPatch: UpdateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoPatch;
  updateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdPatch: UpdateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdPatch;
  updateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdPatch: UpdateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdPatch;
  updateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdPatch: UpdateDataTableColumnGroupOnDataTableColumnGroupForDataTableColumnGroupUserId0F35Bde1FkApplicationUserIdPatch;
  updateDataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdPatch: UpdateDataTableColumnOnDataTableCellForDataTableCellColumnId9A5117BdFkDataTableColumnIdPatch;
  updateDataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoPatch;
  updateDataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnGroupIdAbcd4Ec0FkDataTablPatch;
  updateDataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdPatch;
  updateDataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdPatch;
  updateDataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdPatch: UpdateDataTableColumnOnDataTableColumnForDataTableColumnUserId57054882FkApplicationUserIdPatch;
  updateDataTableOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdPatch: UpdateDataTableOnDataTableCellForDataTableCellTableId12E87426FkDataTableIdPatch;
  updateDataTableOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdPatch: UpdateDataTableOnDataTableColumnForDataTableColumnTableIdF295C823FkDataTableIdPatch;
  updateDataTableOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdPatch: UpdateDataTableOnDataTableColumnGroupForDataTableColumnGroupTableId46C58CccFkDataTableIdPatch;
  updateDataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch: UpdateDataTableOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch;
  updateDataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch: UpdateDataTableOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch;
  updateDataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch: UpdateDataTableOnDataTableForDataTableUserIdAb79B056FkApplicationUserIdPatch;
  updateDataTableOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdPatch: UpdateDataTableOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdPatch;
  updateDataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdPatch: UpdateDataTableRowOnDataTableCellForDataTableCellRowId3A3C7567FkDataTableRowIdPatch;
  updateDataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdPatch: UpdateDataTableRowOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdPatch;
  updateDataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdPatch: UpdateDataTableRowOnDataTableRowForDataTableRowTableIdF77C2D36FkDataTableIdPatch;
  updateDataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdPatch: UpdateDataTableRowOnDataTableRowForDataTableRowUserId3C5E98E5FkApplicationUserIdPatch;
  updateDistributionRegistryImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributPatch: UpdateDistributionRegistryImageOnAwsMockDistributionImageForAwsMockDistributioDistributioncontaineD5Bda68DFkDistributPatch;
  updateDistributionRegistryImageOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaPatch: UpdateDistributionRegistryImageOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaPatch;
  updateDjangoAdminLogOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoPatch: UpdateDjangoAdminLogOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoPatch;
  updateDjangoAdminLogOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdPatch: UpdateDjangoAdminLogOnDjangoAdminLogForDjangoAdminLogUserIdC564Eba6FkApplicationUserIdPatch;
  updateDjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoPatch: UpdateDjangoContentTypeOnAuditlogLogentryForAuditlogLogentryContentTypeId75830218FkDjangoCoPatch;
  updateDjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoPatch: UpdateDjangoContentTypeOnAuthPermissionForAuthPermissionContentTypeId2F476E4BFkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeCellSetFileColumn5Ed8A79BFkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeEventSetFileColumAb691C45FkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionCellStatusForDataTableColumnDeQcReportFileColum864C112DFkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionIdentifierForDataTableColumnDeTableTypeId6A986C02FkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeLeftColumnTypeId1B679Aa5FkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeRightColumnTypeId6Dbd1E8CFkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIE4E5D06AFkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionJoinForDataTableColumnDeSourceColumnTypeIe4E5D06AFkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionMetadatumForDataTableColumnDeFileColumnTypeId8167165CFkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeFileColumnTypeId6C8373EbFkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnForDataTableColumnDefinitionTypeId9C22C97DFkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrTableTypeId70D51D68FkDjangoCoPatch;
  updateDjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoPatch: UpdateDjangoContentTypeOnDataTableColumnGroupForDataTableColumnGrDefinitionTypeId6C9B0BafFkDjangoCoPatch;
  updateDjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoPatch: UpdateDjangoContentTypeOnDjangoAdminLogForDjangoAdminLogContentTypeIdC4Bce8EbFkDjangoCoPatch;
  updateDjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoPatch: UpdateDjangoContentTypeOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoPatch;
  updateDjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoPatch: UpdateDjangoContentTypeOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoPatch;
  updateDjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoPatch: UpdateDjangoContentTypeOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoPatch;
  updateDjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoPatch: UpdateDjangoContentTypeOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoPatch;
  updateDjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoPatch: UpdateDjangoContentTypeOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoPatch;
  updateDjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoPatch: UpdateDjangoContentTypeOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoPatch;
  updateDjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoPatch: UpdateDjangoContentTypeOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoPatch;
  updateDrsFileexecutorOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdPatch: UpdateDrsFileexecutorOnAwsS3FileForAwsS3FileFileexecutorPtrId9869C5B4FkDrsFileexecutorIdPatch;
  updateDrsFileexecutorOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdPatch: UpdateDrsFileexecutorOnCodeFileForCodeFileExecutorId5A9A5C72FkDrsFileexecutorIdPatch;
  updateDrsFileexecutorOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoPatch: UpdateDrsFileexecutorOnDrsFileexecutorForDrsFileexecutorPolymorphicCtypeId2Aecbaf1FkDjangoCoPatch;
  updateDrsFileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileePatch: UpdateDrsFileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileePatch;
  updateDrsMockfileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileePatch: UpdateDrsMockfileexecutorOnDrsMockfileexecutorForDrsMockfileexecutorFileexecutorPtrIdF4025193FkDrsFileePatch;
  updateEulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch: UpdateEulaVersionOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch;
  updateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch: UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcEulaVersionIdD2635C45FkEulaVersPatch;
  updateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch: UpdateEulaVersionUserAcceptanceOnEulaVersionUserAcceptanceForEulaVersionUserAcUserIdB72Ed9C5FkApplicatiPatch;
  updateFeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFPatch: UpdateFeatureFlagOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFPatch;
  updateFeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFPatch: UpdateFeatureFlagOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFPatch;
  updateFeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdPatch: UpdateFeatureFlagOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdPatch;
  updateFeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFPatch: UpdateFeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsFeatureflagId4319112AFkFeatureFPatch;
  updateFeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdPatch: UpdateFeatureFlagsGroupOnFeatureFlagsGroupForFeatureFlagsGroupsGroupId5Ad1180AFkAuthGroupIdPatch;
  updateFeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFPatch: UpdateFeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantFeatureflagIdBd940441FkFeatureFPatch;
  updateFeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdPatch: UpdateFeatureFlagsTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdPatch;
  updateFeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdPatch: UpdateFeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersFeatureflagId68Ed0EcbFkFeatureFlagsIdPatch;
  updateFeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdPatch: UpdateFeatureFlagsUserOnFeatureFlagsUserForFeatureFlagsUsersUserIdF3036Ad6FkApplicationUserIdPatch;
  updateFileActivityOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoPatch: UpdateFileActivityOnFileActivityForFileActivityContentTypeIdD010Fc58FkDjangoCoPatch;
  updateFileActivityOnFileActivityForFileActivityCostId2A88D90AFkCostIdPatch: UpdateFileActivityOnFileActivityForFileActivityCostId2A88D90AFkCostIdPatch;
  updateFileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdPatch: UpdateFileActivityOnFileActivityForFileActivityFileId015763A9FkFileIdPatch;
  updateFileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch: UpdateFileActivityOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch;
  updateFileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch: UpdateFileActivityOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
  updateFileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch: UpdateFileActivityOnFileActivityForFileActivityUserId868Ad8A9FkApplicationUserIdPatch;
  updateFileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch;
  updateFileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch;
  updateFileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch;
  updateFileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch: UpdateFileMetadatumOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
  updateFileOnFileActivityForFileActivityFileId015763A9FkFileIdPatch: UpdateFileOnFileActivityForFileActivityFileId015763A9FkFileIdPatch;
  updateFileOnFileForFileProjectId3Ecca975FkProjectIdPatch: UpdateFileOnFileForFileProjectId3Ecca975FkProjectIdPatch;
  updateFileOnFileForFileSeriesParentIdF7A07E20FkFileIdPatch: UpdateFileOnFileForFileSeriesParentIdF7A07E20FkFileIdPatch;
  updateFileOnFileForFileTaskIdE4Da87AeFkTaskIdPatch: UpdateFileOnFileForFileTaskIdE4Da87AeFkTaskIdPatch;
  updateFileOnFileForFileTenantId61625016FkTenantIdPatch: UpdateFileOnFileForFileTenantId61625016FkTenantIdPatch;
  updateFileOnFileForFileUserId01D90B53FkApplicationUserIdPatch: UpdateFileOnFileForFileUserId01D90B53FkApplicationUserIdPatch;
  updateFileOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch: UpdateFileOnFileMetadatumForFileMetadataFileId78256936FkFileIdPatch;
  updateFileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch: UpdateFileOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch;
  updateFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch: UpdateFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch;
  updateFileOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch: UpdateFileOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch;
  updateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch;
  updateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch;
  updateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch;
  updateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch: UpdateFileOutputGroupMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
  updateFileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch;
  updateFileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch;
  updateFileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
  updateFileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch: UpdateFileOutputGroupOnFileOutputGroupForFileOutputGroupUserIdB22Ec436FkApplicationUserIdPatch;
  updateFileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch: UpdateFileOutputGroupOnFileOutputGroupMetadatumForFileOutputGroupMeFileOutputGroupIdE3798458FkFileOutpPatch;
  updateFileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch: UpdateFileOutputGroupOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch;
  updateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotiUserId08265156FkApplicatiPatch;
  updateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationFileId717B514EFkFileIdPatch;
  updateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch: UpdateFileProcessingNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch;
  updateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyPatch: UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyPatch;
  updateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyPatch: UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyPatch;
  updateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyPatch: UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyPatch;
  updateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdPatch: UpdateGdtAnalysisTableCellOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdPatch;
  updateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyPatch: UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyPatch;
  updateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoPatch: UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCDefinitionTypeIdBcd80F41FkDjangoCoPatch;
  updateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIPatch: UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIPatch;
  updateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyPatch: UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyPatch;
  updateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiPatch: UpdateGdtAnalysisTableColumnGroupOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCUserId8709Cf1FFkApplicatiPatch;
  updateGdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableCellForGdtAnalysisTableCColumnId54344A43FkGdtAnalyPatch;
  updateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCDefinitionTypeId90050C11FkDjangoCoPatch;
  updateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCGroupIdE356CdffFkGdtAnalyPatch;
  updateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyPatch;
  updateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableCUserId75C939B7FkApplicatiPatch;
  updateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdPatch: UpdateGdtAnalysisTableColumnOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableCellForGdtAnalysisTableCTableIdE0C756BaFkGdtAnalyPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableColumnForGdtAnalysisTableCTableIdB3Ac256BFkGdtAnalyPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCTableId2788Fb29FkGdtAnalyPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableForGdtAnalysisTableUserId1E9A1A36FkApplicationUserIdPatch;
  updateGdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch: UpdateGdtAnalysisTableOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableCellForGdtAnalysisTableCRowIdEeacbde2FkGdtAnalyPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRTableIdAf79B47BFkGdtAnalyPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
  updateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch: UpdateGdtAnalysisTableRowOnGdtAnalysisTableRowForGdtAnalysisTableRowUserIdB802Bdc0FkApplicationUserIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
  updateMetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch: UpdateMetadataValueOnMetadataValueForMetadataValueUserIdB2Bb45AeFkApplicationUserIdPatch;
  updateMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch: UpdateMetadatumOnFileMetadatumForFileMetadataMetadataIdFefc0061FkMetadataIdPatch;
  updateMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch: UpdateMetadatumOnFileOutputGroupMetadatumForFileOutputGroupMetadataMetadataId3A08Fd87FkMetadataIdPatch;
  updateMetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch: UpdateMetadatumOnMetadataValueForMetadataValueMetadataId063A53B6FkMetadataIdPatch;
  updateMetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch: UpdateMetadatumOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch;
  updateMetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch: UpdateMetadatumOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
  updateNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch: UpdateNotificationOnFileProcessingNotificationForFileProcessingNotificationId630E6495FkNotificationIdPatch;
  updateNotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch: UpdateNotificationOnNotificationForNotificationUserId1002Fc38FkApplicationUserIdPatch;
  updateNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch: UpdateNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch;
  updateNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch: UpdateNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch;
  updateNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch: UpdateNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch;
  updateNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch: UpdateNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch;
  updateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileIdEdeabb23FkFileIdPatch;
  updateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesFileOutputGroupIdF5Ba9324FkFileOutpPatch;
  updateOutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch: UpdateOutputGroupFileOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch;
  updatePinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdPatch: UpdatePinnedToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdPatch;
  updatePinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdPatch: UpdatePinnedToolOnPinnedToolForPinnedToolUserId59D3492DFkApplicationUserIdPatch;
  updateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch;
  updateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotifUserId4Fd693D7FkApplicatiPatch;
  updateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationIdD235A018FkNotificationIdPatch;
  updateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch: UpdateProjectClonedNotificationOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch;
  updateProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch: UpdateProjectFolderOnDataTableForDataTableFolderId4Fe6C7FeFkProjectFolderIdPatch;
  updateProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch: UpdateProjectFolderOnGdtAnalysisTableForGdtAnalysisTableFolderId6A997B49FkProjectFolderIdPatch;
  updateProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch: UpdateProjectFolderOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch;
  updateProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch: UpdateProjectFolderOnProjectFolderForProjectFolderUserIdF2E16179FkApplicationUserIdPatch;
  updateProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdPatch: UpdateProjectOnDataTableCellForDataTableCellProjectIdEf5721A0FkProjectIdPatch;
  updateProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionBooleanForDataTableColumnDeProjectId29F0D38FFkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionCellStatusForDataTableColumnDeProjectId33688488FkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionChoiceForDataTableColumnDeProjectIdC7B1D7FbFkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionDateForDataTableColumnDeProjectIdC5C8B765FkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionFileForDataTableColumnDeProjectId433Daf03FkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionFloatForDataTableColumnDeProjectId869397AfFkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionIdentifierForDataTableColumnDeProjectIdE2A11292FkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionIntegerForDataTableColumnDeProjectId2487E0EbFkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionJoinForDataTableColumnDeProjectId7732E962FkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionMetadatumForDataTableColumnDeProjectId3A701Ad3FkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionRoiFrameForDataTableColumnDeProjectId8E855Eb8FkProjectIPatch;
  updateProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIPatch: UpdateProjectOnDataTableColumnDefinitionTextForDataTableColumnDeProjectIdBc4Cdb01FkProjectIPatch;
  updateProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdPatch: UpdateProjectOnDataTableColumnForDataTableColumnProjectId91C18F88FkProjectIdPatch;
  updateProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIPatch: UpdateProjectOnDataTableColumnGroupDefinitionJoinForDataTableColumnGrProjectId2Af8Cd7EFkProjectIPatch;
  updateProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIPatch: UpdateProjectOnDataTableColumnGroupDefinitionSourceForDataTableColumnGrProjectId7376573CFkProjectIPatch;
  updateProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdPatch: UpdateProjectOnDataTableColumnGroupForDataTableColumnGroupProjectIdE5Cb2883FkProjectIdPatch;
  updateProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch: UpdateProjectOnDataTableForDataTableProjectId59F60EaeFkProjectIdPatch;
  updateProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdPatch: UpdateProjectOnDataTableRowForDataTableRowProjectId43Bf0Ab0FkProjectIdPatch;
  updateProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch: UpdateProjectOnFileActivityForFileActivityProjectId6F35B8CcFkProjectIdPatch;
  updateProjectOnFileForFileProjectId3Ecca975FkProjectIdPatch: UpdateProjectOnFileForFileProjectId3Ecca975FkProjectIdPatch;
  updateProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch: UpdateProjectOnFileMetadatumForFileMetadataProjectId3474994EFkProjectIdPatch;
  updateProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch: UpdateProjectOnFileOutputGroupForFileOutputGroupProjectId908Fb9FfFkProjectIdPatch;
  updateProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch: UpdateProjectOnFileOutputGroupMetadatumForFileOutputGroupMetadataProjectIdD7463Dc3FkProjectIdPatch;
  updateProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdPatch: UpdateProjectOnGdtAnalysisTableCellForGdtAnalysisTableCellProjectId57B70FedFkProjectIdPatch;
  updateProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdPatch: UpdateProjectOnGdtAnalysisTableColumnForGdtAnalysisTableColumnProjectId9D4C01B6FkProjectIdPatch;
  updateProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIPatch: UpdateProjectOnGdtAnalysisTableColumnGroupForGdtAnalysisTableCProjectId77B86B06FkProjectIPatch;
  updateProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch: UpdateProjectOnGdtAnalysisTableForGdtAnalysisTableProjectId544B76D9FkProjectIdPatch;
  updateProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch: UpdateProjectOnGdtAnalysisTableRowForGdtAnalysisTableRowProjectIdF415C371FkProjectIdPatch;
  updateProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch: UpdateProjectOnMetadataValueForMetadataValueProjectId87227D96FkProjectIdPatch;
  updateProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch: UpdateProjectOnMetadatumForMetadataProjectId3333C2AdFkProjectIdPatch;
  updateProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch: UpdateProjectOnOutputGroupFileForOutputGroupFilesProjectId8709B561FkProjectIdPatch;
  updateProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch: UpdateProjectOnProjectClonedNotificationForProjectClonedNotifSrcProjectId65Cd0BdfFkProjectIPatch;
  updateProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch: UpdateProjectOnProjectClonedNotificationForProjectClonedNotificationProjectIdF6267374FkProjectIdPatch;
  updateProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch: UpdateProjectOnProjectFolderForProjectFolderProjectIdEf44DadfFkProjectIdPatch;
  updateProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdPatch: UpdateProjectOnProjectForProjectCloneSourceId92Ccacf5FkProjectIdPatch;
  updateProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch: UpdateProjectOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
  updateProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch: UpdateProjectOnProjectForProjectUserIdB5Fbb914FkApplicationUserIdPatch;
  updateProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch: UpdateProjectOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch;
  updateProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch: UpdateProjectOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch;
  updateProjectOnTaskForTaskProjectId963D6354FkProjectIdPatch: UpdateProjectOnTaskForTaskProjectId963D6354FkProjectIdPatch;
  updateProjectOnToolForToolProjectId20A84210FkProjectIdPatch: UpdateProjectOnToolForToolProjectId20A84210FkProjectIdPatch;
  updateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifSharerIdAbe16C5BFkApplicatiPatch;
  updateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotifUserId9A19122FFkApplicatiPatch;
  updateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationIdD5Cd7E61FkNotificationIdPatch;
  updateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch: UpdateProjectSharedNotificationOnProjectSharedNotificationForProjectSharedNotificationProjectIdCf7Edf4AFkProjectIdPatch;
  updateProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch: UpdateProjectTagOnProjectTagForProjectTagProjectId5Ab280C9FkProjectIdPatch;
  updateProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch: UpdateProjectTagOnProjectTagForProjectTagUserId780C8348FkApplicationUserIdPatch;
  updateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificaUserId879Bd49AFkApplicatiPatch;
  updateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationIdD576A528FkNotificationIdPatch;
  updateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch: UpdateRoleChangeNotificationOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
  updateRunOnRunForRunTenantId73Fbd8D9FkTenantIdPatch: UpdateRunOnRunForRunTenantId73Fbd8D9FkTenantIdPatch;
  updateTaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdPatch: UpdateTaskActivityOnTaskActivityForTaskActivityCostId49E66058FkCostIdPatch;
  updateTaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch: UpdateTaskActivityOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch;
  updateTaskOnFileForFileTaskIdE4Da87AeFkTaskIdPatch: UpdateTaskOnFileForFileTaskIdE4Da87AeFkTaskIdPatch;
  updateTaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch: UpdateTaskOnFileOutputGroupForFileOutputGroupTaskId2B1Df6A1FkTaskIdPatch;
  updateTaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch: UpdateTaskOnGdtAnalysisTableRowForGdtAnalysisTableRowTaskId14Ab233FFkTaskIdPatch;
  updateTaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch: UpdateTaskOnMetadataValueForMetadataValueTaskId3D37D135FkTaskIdPatch;
  updateTaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch: UpdateTaskOnTaskActivityForTaskActivityTaskIdC451Ae92FkTaskIdPatch;
  updateTaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdPatch: UpdateTaskOnTaskForTaskContainerImageId92Ed2DaeFkContainerImageIdPatch;
  updateTaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdPatch: UpdateTaskOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdPatch;
  updateTaskOnTaskForTaskProjectId963D6354FkProjectIdPatch: UpdateTaskOnTaskForTaskProjectId963D6354FkProjectIdPatch;
  updateTaskOnTaskForTaskTenantId148E90DaFkTenantIdPatch: UpdateTaskOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
  updateTaskOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch: UpdateTaskOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch;
  updateTaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch: UpdateTaskOnTaskForTaskUserId270D0Bb2FkApplicationUserIdPatch;
  updateTaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch: UpdateTaskOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch;
  updateTaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch: UpdateTaskOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch;
  updateTaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch: UpdateTaskOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch;
  updateTaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdPatch: UpdateTaskOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdPatch;
  updateTaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch: UpdateTaskResourceOnTaskResourceForTaskResourceTaskId73Fcabc0FkTaskIdPatch;
  updateTaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch: UpdateTaskResourceUsageOnTaskResourceUsageForTaskResourceUsageTaskIdA28F1580FkTaskIdPatch;
  updateTaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch: UpdateTaskSourceOnTaskSourceForTaskSourceFileId2F628862FkFileIdPatch;
  updateTaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch: UpdateTaskSourceOnTaskSourceForTaskSourceTaskIdF241BaedFkTaskIdPatch;
  updateTaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch: UpdateTaskSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch;
  updateTaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdPatch: UpdateTaskStatusLogOnTaskStatusLogForTaskStatusLogTaskIdFe1B9D0BFkTaskIdPatch;
  updateTenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch: UpdateTenantContractAllowanceOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch;
  updateTenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch: UpdateTenantContractOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
  updateTenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch: UpdateTenantContractOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch;
  updateTenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoPatch: UpdateTenantContractOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoPatch;
  updateTenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch: UpdateTenantContractTransactionOnTenantContractAllowanceForTenantContractAlloTenantContractTran29C19B1CFkTenantCoPatch;
  updateTenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch: UpdateTenantContractTransactionOnTenantContractTransactionForTenantContractTranTenantContractId1E374993FkTenantCoPatch;
  updateTenantMockuserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsPatch: UpdateTenantMockuserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsPatch;
  updateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoPatch: UpdateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantContractId681267CeFkTenantCoPatch;
  updateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdPatch: UpdateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdPatch;
  updateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiPatch: UpdateTenantMonthlyConsumedResourceOnTenantMonthlyConsumedResourceForTenantMonthlyConsuUserIdF7210F55FkApplicatiPatch;
  updateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch: UpdateTenantOnApplicationUserMembershipForApplicationUserMembershipTenantId5E54Da7AFkTenantIdPatch;
  updateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch: UpdateTenantOnApplicationUserSessionForApplicationUserSessionTenantId00A81Cc5FkTenantIdPatch;
  updateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch: UpdateTenantOnCodeFileForCodeFileTenantIdC35D8B4EFkTenantIdPatch;
  updateTenantOnCommandForCommandTenantId36F95C3CFkTenantIdPatch: UpdateTenantOnCommandForCommandTenantId36F95C3CFkTenantIdPatch;
  updateTenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdPatch: UpdateTenantOnContainerImageForContainerImageTenantIdD0Beb309FkTenantIdPatch;
  updateTenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdPatch: UpdateTenantOnContainerImageRepositoryForContainerImageRepositoryTenantId217F4E90FkTenantIdPatch;
  updateTenantOnCostForCostTenantId7Dcd58A7FkTenantIdPatch: UpdateTenantOnCostForCostTenantId7Dcd58A7FkTenantIdPatch;
  updateTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdPatch: UpdateTenantOnFeatureFlagsTenantForFeatureFlagsTenantsTenantId6D718C42FkTenantIdPatch;
  updateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch: UpdateTenantOnFileActivityForFileActivityTenantIdC46A4F01FkTenantIdPatch;
  updateTenantOnFileForFileTenantId61625016FkTenantIdPatch: UpdateTenantOnFileForFileTenantId61625016FkTenantIdPatch;
  updateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch: UpdateTenantOnFileMetadatumForFileMetadataTenantId79Fe438BFkTenantIdPatch;
  updateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch: UpdateTenantOnFileOutputGroupForFileOutputGroupTenantId3Fa46D44FkTenantIdPatch;
  updateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch: UpdateTenantOnFileOutputGroupMetadatumForFileOutputGroupMetadataTenantIdE6Ba41EbFkTenantIdPatch;
  updateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch: UpdateTenantOnMetadataValueForMetadataValueTenantIdB4C2D5D6FkTenantIdPatch;
  updateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch: UpdateTenantOnMetadatumForMetadataTenantIdC1D8772DFkTenantIdPatch;
  updateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch: UpdateTenantOnProjectForProjectTenantId03F0Ca53FkTenantIdPatch;
  updateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch: UpdateTenantOnRoleChangeNotificationForRoleChangeNotificationTenantId36852Ce9FkTenantIdPatch;
  updateTenantOnRunForRunTenantId73Fbd8D9FkTenantIdPatch: UpdateTenantOnRunForRunTenantId73Fbd8D9FkTenantIdPatch;
  updateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch: UpdateTenantOnTaskForTaskTenantId148E90DaFkTenantIdPatch;
  updateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch: UpdateTenantOnTenantContractForTenantContractTenantIdBa8Ac167FkTenantIdPatch;
  updateTenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdPatch: UpdateTenantOnTenantMonthlyConsumedResourceForTenantMonthlyConsuTenantIdCb1B80FcFkTenantIdPatch;
  updateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch: UpdateTenantOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
  updateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch: UpdateTenantOnToolForToolTenantId1Baab08EFkTenantIdPatch;
  updateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch: UpdateTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
  updateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch: UpdateTenantOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
  updateTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdPatch: UpdateTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdPatch;
  updateTenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdPatch: UpdateTenantOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdPatch;
  updateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershId10Affa8DFkNotificatPatch;
  updateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershInviterId29476E5EFkApplicatiPatch;
  updateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershTenantIdC67818C5FkTenantIdPatch;
  updateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch: UpdateTenantUserMembershipNotificationOnTenantUserMembershipNotificationForTenantUserMembershUserId2B78E8A0FkApplicatiPatch;
  updateTenantUserexecutorOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsPatch: UpdateTenantUserexecutorOnAwsCognitoUserForAwsCognitoUserUserexecutorPtrId23B14Ef0FkTenantUsPatch;
  updateTenantUserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsPatch: UpdateTenantUserexecutorOnTenantMockuserexecutorForTenantMockuserexecuUserexecutorPtrId757654E7FkTenantUsPatch;
  updateTenantUserexecutorOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoPatch: UpdateTenantUserexecutorOnTenantUserexecutorForTenantUserexecutorPolymorphicCtypeIdF45E3068FkDjangoCoPatch;
  updateTesContainerimageexecutorOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaPatch: UpdateTesContainerimageexecutorOnAwsEcrImageForAwsEcrImageContainerimageexecutAabe4FdbFkTesContaPatch;
  updateTesContainerimageexecutorOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaPatch: UpdateTesContainerimageexecutorOnContainerImageForContainerImageExecutorId68979Fb6FkTesContaPatch;
  updateTesContainerimageexecutorOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaPatch: UpdateTesContainerimageexecutorOnDistributionRegistryImageForDistributionRegistrContainerimageexecut830E7Af5FkTesContaPatch;
  updateTesContainerimageexecutorOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoPatch: UpdateTesContainerimageexecutorOnTesContainerimageexecutorForTesContainerimageexPolymorphicCtypeId60Cd6000FkDjangoCoPatch;
  updateTesContainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaPatch: UpdateTesContainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaPatch;
  updateTesMockcontainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaPatch: UpdateTesMockcontainerimageexecutorOnTesMockcontainerimageexecutorForTesMockcontainerimaContainerimageexecut4Eced924FkTesContaPatch;
  updateTesMocktaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskePatch: UpdateTesMocktaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskePatch;
  updateTesTaskexecutorOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskePatch: UpdateTesTaskexecutorOnAwsBatchTaskForAwsBatchTaskTaskexecutorPtrIdA5A06Eb9FkTesTaskePatch;
  updateTesTaskexecutorOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdPatch: UpdateTesTaskexecutorOnTaskForTaskExecutorId24A67329FkTesTaskexecutorIdPatch;
  updateTesTaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskePatch: UpdateTesTaskexecutorOnTesMocktaskexecutorForTesMocktaskexecutorTaskexecutorPtrIdEf30C727FkTesTaskePatch;
  updateTesTaskexecutorOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoPatch: UpdateTesTaskexecutorOnTesTaskexecutorForTesTaskexecutorPolymorphicCtypeIdFd457Dc0FkDjangoCoPatch;
  updateToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdPatch: UpdateToolOnPinnedToolForPinnedToolToolId7Ba143DfFkToolIdPatch;
  updateToolOnToolForToolProjectId20A84210FkProjectIdPatch: UpdateToolOnToolForToolProjectId20A84210FkProjectIdPatch;
  updateToolOnToolForToolTenantId1Baab08EFkTenantIdPatch: UpdateToolOnToolForToolTenantId1Baab08EFkTenantIdPatch;
  updateToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdPatch: UpdateToolOnToolForToolToolboxId7B1Eebf3FkToolboxIdPatch;
  updateToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch: UpdateToolOnToolForToolUserIdFd36Dfa4FkApplicationUserIdPatch;
  updateToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch: UpdateToolOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch;
  updateToolOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch: UpdateToolOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch;
  updateToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch: UpdateToolParameterOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch;
  updateToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdPatch: UpdateToolResourceOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdPatch;
  updateToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch: UpdateToolResultOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch;
  updateToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch: UpdateToolSecretOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch;
  updateToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch: UpdateToolSourceOnTaskSourceForTaskSourceToolSourceId14453EdbFkToolSourceIdPatch;
  updateToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch: UpdateToolSourceOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch;
  updateToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch: UpdateToolTenantOnToolTenantForToolTenantsTenantId9C4A54FeFkTenantIdPatch;
  updateToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch: UpdateToolTenantOnToolTenantForToolTenantsToolIdF77Ef6F7FkToolIdPatch;
  updateToolVersionOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdPatch: UpdateToolVersionOnCommandForCommandToolVersionId9DbddabaFkToolVersionIdPatch;
  updateToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch: UpdateToolVersionOnGdtAnalysisTableForGdtAnalysisTableToolVersionId265E8E0BFkToolVersionIdPatch;
  updateToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch: UpdateToolVersionOnGdtAnalysisTableRowForGdtAnalysisTableRToolVersionId0050D5BdFkToolVersPatch;
  updateToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch: UpdateToolVersionOnTaskForTaskToolVersionId14506837FkToolVersionIdPatch;
  updateToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch: UpdateToolVersionOnToolParameterForToolParameterToolVersionIdC3A0Df75FkToolVersionIdPatch;
  updateToolVersionOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdPatch: UpdateToolVersionOnToolResourceForToolResourceToolVersionId5E21979DFkToolVersionIdPatch;
  updateToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch: UpdateToolVersionOnToolResultForToolResultToolVersionId41Fb163EFkToolVersionIdPatch;
  updateToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch: UpdateToolVersionOnToolSecretForToolSecretToolVersionId92Dc8FadFkToolVersionIdPatch;
  updateToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch: UpdateToolVersionOnToolSourceForToolSourceToolVersionId9Ac27A25FkToolVersionIdPatch;
  updateToolVersionOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdPatch: UpdateToolVersionOnToolVersionForToolVersionContainerImageId32D92A94FkContainerImageIdPatch;
  updateToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch: UpdateToolVersionOnToolVersionForToolVersionTenantId03A60B0CFkTenantIdPatch;
  updateToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch: UpdateToolVersionOnToolVersionForToolVersionToolId3B396B22FkToolIdPatch;
  updateToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch: UpdateToolVersionOnToolVersionForToolVersionUserId68A75E07FkApplicationUserIdPatch;
  updateToolVersionOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdPatch: UpdateToolVersionOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdPatch;
  updateToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdPatch: UpdateToolboxOnToolForToolToolboxId7B1Eebf3FkToolboxIdPatch;
  updateToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdPatch: UpdateToolboxOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdPatch;
  updateToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdPatch: UpdateToolboxTenantOnToolboxTenantForToolboxTenantsTenantId5D0A40E4FkTenantIdPatch;
  updateToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdPatch: UpdateToolboxTenantOnToolboxTenantForToolboxTenantsToolboxId9D553881FkToolboxIdPatch;
  updateUserOnboardingQuestionAnswerOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboPatch: UpdateUserOnboardingQuestionAnswerOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboPatch;
  updateUserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboPatch: UpdateUserOnboardingQuestionOnUserOnboardingQuestionAnswerForUserOnboardingQuesQuestionIdC28D2284FkUserOnboPatch;
  updateUserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboPatch: UpdateUserOnboardingQuestionOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboPatch;
  updateUserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboPatch: UpdateUserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesQuestionId65Ae6E1FFkUserOnboPatch;
  updateUserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiPatch: UpdateUserOnboardingQuestionResponseOnUserOnboardingQuestionResponseForUserOnboardingQuesUserId72Eee3DfFkApplicatiPatch;
  updateUserPersonalSpaceRequestOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiPatch: UpdateUserPersonalSpaceRequestOnUserPersonalSpaceRequestForUserPersonalSpaceUserId71D37C1EFkApplicatiPatch;
  updateWorkflowDatumOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdPatch: UpdateWorkflowDatumOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdPatch;
  updateWorkflowDatumOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdPatch: UpdateWorkflowDatumOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdPatch;
  updateWorkflowOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdPatch: UpdateWorkflowOnWorkflowForWorkflowContainerIdE73A96E5FkContainerImageIdPatch;
  updateWorkflowOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdPatch: UpdateWorkflowOnWorkflowForWorkflowTenantId9469Ff84FkTenantIdPatch;
  updateWorkflowOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdPatch: UpdateWorkflowOnWorkflowForWorkflowUserId121C1967FkApplicationUserIdPatch;
  updateWorkflowOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdPatch: UpdateWorkflowOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdPatch;
  updateWorkflowResultOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdPatch: UpdateWorkflowResultOnWorkflowResultForWorkflowResultObjectIdC561D1C5FkWorkflowDataIdPatch;
  updateWorkflowResultOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowPatch: UpdateWorkflowResultOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowPatch;
  updateWorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowPatch: UpdateWorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkResultId50F959E2FkWorkflowPatch;
  updateWorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowPatch: UpdateWorkflowResultWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowPatch;
  updateWorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdPatch: UpdateWorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockObjectId13E0Dfc9FkWorkflowDataIdPatch;
  updateWorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdPatch: UpdateWorkflowSectionBlockOnWorkflowSectionBlockForWorkflowSectionBlockToolId0E3B9Fc6FkToolVersionIdPatch;
  updateWorkflowSectionBlockOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowPatch: UpdateWorkflowSectionBlockOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowPatch;
  updateWorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowPatch: UpdateWorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloBlockIdF2Fa4B4DFkWorkflowPatch;
  updateWorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowPatch: UpdateWorkflowSectionBlockSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowPatch;
  updateWorkflowSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowPatch: UpdateWorkflowSectionOnWorkflowSectionBlockSectionForWorkflowSectionBloSectionId817C1C77FkWorkflowPatch;
  updateWorkflowSectionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowPatch: UpdateWorkflowSectionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowPatch;
  updateWorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowPatch: UpdateWorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorSectionId1D5C2D63FkWorkflowPatch;
  updateWorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowPatch: UpdateWorkflowSectionWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowPatch;
  updateWorkflowSourceOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowPatch: UpdateWorkflowSourceOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowPatch;
  updateWorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowPatch: UpdateWorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkSourceId608A289DFkWorkflowPatch;
  updateWorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowPatch: UpdateWorkflowSourceWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowPatch;
  updateWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowPatch: UpdateWorkflowVersionOnWorkflowResultWorkflowVersionForWorkflowResultWorkWorkflowversionIdB9123570FkWorkflowPatch;
  updateWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowPatch: UpdateWorkflowVersionOnWorkflowSectionWorkflowVersionForWorkflowSectionWorWorkflowversionIdFe181CfcFkWorkflowPatch;
  updateWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowPatch: UpdateWorkflowVersionOnWorkflowSourceWorkflowVersionForWorkflowSourceWorkWorkflowversionIdDe9FcfaaFkWorkflowPatch;
  updateWorkflowVersionOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdPatch: UpdateWorkflowVersionOnWorkflowVersionForWorkflowVersionUserId00C0F62FFkApplicationUserIdPatch;
  updateWorkflowVersionOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdPatch: UpdateWorkflowVersionOnWorkflowVersionForWorkflowVersionWorkflowIdC2B7Bb13FkWorkflowIdPatch;
};

export type AdminProjectResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AdminProject"] = ResolversParentTypes["AdminProject"],
> = {
  id?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  tenantId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminProjectsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AdminProjectsConnection"] = ResolversParentTypes["AdminProjectsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["AdminProjectsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["AdminProject"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdminProjectsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AdminProjectsEdge"] = ResolversParentTypes["AdminProjectsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["AdminProject"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ApplicationUser"] = ResolversParentTypes["ApplicationUser"],
> = {
  applicationUserGroupsByUserId?: Resolver<
    ResolversTypes["ApplicationUserGroupsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserApplicationUserGroupsByUserIdArgs, "orderBy">
  >;
  applicationUserMembershipsByUserId?: Resolver<
    ResolversTypes["ApplicationUserMembershipsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ApplicationUserApplicationUserMembershipsByUserIdArgs,
      "orderBy"
    >
  >;
  applicationUserMetadataByUserId?: Resolver<
    ResolversTypes["ApplicationUserMetadataConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserApplicationUserMetadataByUserIdArgs, "orderBy">
  >;
  applicationUserSessionsByUserId?: Resolver<
    ResolversTypes["ApplicationUserSessionsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserApplicationUserSessionsByUserIdArgs, "orderBy">
  >;
  applicationUserUserPermissionsByUserId?: Resolver<
    ResolversTypes["ApplicationUserUserPermissionsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ApplicationUserApplicationUserUserPermissionsByUserIdArgs,
      "orderBy"
    >
  >;
  auditlogLogentriesByActorId?: Resolver<
    ResolversTypes["AuditlogLogentriesConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserAuditlogLogentriesByActorIdArgs, "orderBy">
  >;
  avatarByUserId?: Resolver<
    Maybe<ResolversTypes["Avatar"]>,
    ParentType,
    ContextType
  >;
  avatarsByUserId?: Resolver<
    ResolversTypes["AvatarsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserAvatarsByUserIdArgs, "orderBy">
  >;
  codeFilesByUserId?: Resolver<
    ResolversTypes["CodeFilesConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserCodeFilesByUserIdArgs, "orderBy">
  >;
  cognitoTenantKey?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  commandsByUserId?: Resolver<
    ResolversTypes["CommandsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserCommandsByUserIdArgs, "orderBy">
  >;
  containerImageRepositoriesByUserId?: Resolver<
    ResolversTypes["ContainerImageRepositoriesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ApplicationUserContainerImageRepositoriesByUserIdArgs,
      "orderBy"
    >
  >;
  containerImagesByUserId?: Resolver<
    ResolversTypes["ContainerImagesConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserContainerImagesByUserIdArgs, "orderBy">
  >;
  created?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  dataTableColumnGroupsByUserId?: Resolver<
    ResolversTypes["DataTableColumnGroupsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserDataTableColumnGroupsByUserIdArgs, "orderBy">
  >;
  dataTableColumnsByUserId?: Resolver<
    ResolversTypes["DataTableColumnsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserDataTableColumnsByUserIdArgs, "orderBy">
  >;
  dataTableRowsByUserId?: Resolver<
    ResolversTypes["DataTableRowsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserDataTableRowsByUserIdArgs, "orderBy">
  >;
  dataTablesByUserId?: Resolver<
    ResolversTypes["DataTablesConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserDataTablesByUserIdArgs, "orderBy">
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  djangoAdminLogsByUserId?: Resolver<
    ResolversTypes["DjangoAdminLogsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserDjangoAdminLogsByUserIdArgs, "orderBy">
  >;
  email?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  emailMarketingConsent?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  eulaVersionUserAcceptancesByUserId?: Resolver<
    ResolversTypes["EulaVersionUserAcceptancesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ApplicationUserEulaVersionUserAcceptancesByUserIdArgs,
      "orderBy"
    >
  >;
  featureFlagsUsersByUserId?: Resolver<
    ResolversTypes["FeatureFlagsUsersConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserFeatureFlagsUsersByUserIdArgs, "orderBy">
  >;
  fileActivitiesByUserId?: Resolver<
    ResolversTypes["FileActivitiesConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserFileActivitiesByUserIdArgs, "orderBy">
  >;
  fileOutputGroupsByUserId?: Resolver<
    ResolversTypes["FileOutputGroupsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserFileOutputGroupsByUserIdArgs, "orderBy">
  >;
  fileProcessingNotificationsByUserId?: Resolver<
    ResolversTypes["FileProcessingNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ApplicationUserFileProcessingNotificationsByUserIdArgs,
      "orderBy"
    >
  >;
  filesByUserId?: Resolver<
    ResolversTypes["FilesConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserFilesByUserIdArgs, "orderBy">
  >;
  firstName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  gdtAnalysisTableColumnGroupsByUserId?: Resolver<
    ResolversTypes["GdtAnalysisTableColumnGroupsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ApplicationUserGdtAnalysisTableColumnGroupsByUserIdArgs,
      "orderBy"
    >
  >;
  gdtAnalysisTableColumnsByUserId?: Resolver<
    ResolversTypes["GdtAnalysisTableColumnsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserGdtAnalysisTableColumnsByUserIdArgs, "orderBy">
  >;
  gdtAnalysisTableRowsByUserId?: Resolver<
    ResolversTypes["GdtAnalysisTableRowsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserGdtAnalysisTableRowsByUserIdArgs, "orderBy">
  >;
  gdtAnalysisTablesByUserId?: Resolver<
    ResolversTypes["GdtAnalysisTablesConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserGdtAnalysisTablesByUserIdArgs, "orderBy">
  >;
  globalUserId?: Resolver<
    Maybe<ResolversTypes["UUID"]>,
    ParentType,
    ContextType
  >;
  homeRegion?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  internal?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isStaff?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isSuperuser?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  metadataValuesByUserId?: Resolver<
    ResolversTypes["MetadataValuesConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserMetadataValuesByUserIdArgs, "orderBy">
  >;
  notificationsByUserId?: Resolver<
    ResolversTypes["NotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserNotificationsByUserIdArgs, "orderBy">
  >;
  personalRegion?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  pinnedToolsByUserId?: Resolver<
    ResolversTypes["PinnedToolsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserPinnedToolsByUserIdArgs, "orderBy">
  >;
  projectClonedNotificationsByUserId?: Resolver<
    ResolversTypes["ProjectClonedNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ApplicationUserProjectClonedNotificationsByUserIdArgs,
      "orderBy"
    >
  >;
  projectFoldersByUserId?: Resolver<
    ResolversTypes["ProjectFoldersConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserProjectFoldersByUserIdArgs, "orderBy">
  >;
  projectSharedNotificationsBySharerId?: Resolver<
    ResolversTypes["ProjectSharedNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ApplicationUserProjectSharedNotificationsBySharerIdArgs,
      "orderBy"
    >
  >;
  projectSharedNotificationsByUserId?: Resolver<
    ResolversTypes["ProjectSharedNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ApplicationUserProjectSharedNotificationsByUserIdArgs,
      "orderBy"
    >
  >;
  projectTagsByUserId?: Resolver<
    ResolversTypes["ProjectTagsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserProjectTagsByUserIdArgs, "orderBy">
  >;
  projectsByUserId?: Resolver<
    ResolversTypes["ProjectsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserProjectsByUserIdArgs, "orderBy">
  >;
  roleChangeNotificationsByUserId?: Resolver<
    ResolversTypes["RoleChangeNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserRoleChangeNotificationsByUserIdArgs, "orderBy">
  >;
  tasksByUserId?: Resolver<
    ResolversTypes["TasksConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserTasksByUserIdArgs, "orderBy">
  >;
  tenantMonthlyConsumedResourcesByUserId?: Resolver<
    ResolversTypes["TenantMonthlyConsumedResourcesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ApplicationUserTenantMonthlyConsumedResourcesByUserIdArgs,
      "orderBy"
    >
  >;
  tenantUserMembershipNotificationsByInviterId?: Resolver<
    ResolversTypes["TenantUserMembershipNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ApplicationUserTenantUserMembershipNotificationsByInviterIdArgs,
      "orderBy"
    >
  >;
  tenantUserMembershipNotificationsByUserId?: Resolver<
    ResolversTypes["TenantUserMembershipNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ApplicationUserTenantUserMembershipNotificationsByUserIdArgs,
      "orderBy"
    >
  >;
  toolVersionsByUserId?: Resolver<
    ResolversTypes["ToolVersionsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserToolVersionsByUserIdArgs, "orderBy">
  >;
  toolsByUserId?: Resolver<
    ResolversTypes["ToolsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserToolsByUserIdArgs, "orderBy">
  >;
  userOnboardingQuestionResponsesByUserId?: Resolver<
    ResolversTypes["UserOnboardingQuestionResponsesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ApplicationUserUserOnboardingQuestionResponsesByUserIdArgs,
      "orderBy"
    >
  >;
  userOrigin?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  userPersonalSpaceRequestsByUserId?: Resolver<
    ResolversTypes["UserPersonalSpaceRequestsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ApplicationUserUserPersonalSpaceRequestsByUserIdArgs,
      "orderBy"
    >
  >;
  username?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  workflowVersionsByUserId?: Resolver<
    ResolversTypes["WorkflowVersionsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserWorkflowVersionsByUserIdArgs, "orderBy">
  >;
  workflowsByUserId?: Resolver<
    ResolversTypes["WorkflowsConnection"],
    ParentType,
    ContextType,
    RequireFields<ApplicationUserWorkflowsByUserIdArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserGroupResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ApplicationUserGroup"] = ResolversParentTypes["ApplicationUserGroup"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  authGroupByGroupId?: Resolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    ParentType,
    ContextType
  >;
  groupId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserGroupsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ApplicationUserGroupsConnection"] = ResolversParentTypes["ApplicationUserGroupsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ApplicationUserGroupsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ApplicationUserGroup"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserGroupsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ApplicationUserGroupsEdge"] = ResolversParentTypes["ApplicationUserGroupsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["ApplicationUserGroup"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserMembershipResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ApplicationUserMembership"] = ResolversParentTypes["ApplicationUserMembership"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  role?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  sfLeadCreated?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserMembershipsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ApplicationUserMembershipsConnection"] = ResolversParentTypes["ApplicationUserMembershipsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ApplicationUserMembershipsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ApplicationUserMembership"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserMembershipsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ApplicationUserMembershipsEdge"] = ResolversParentTypes["ApplicationUserMembershipsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["ApplicationUserMembership"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserMetadataConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ApplicationUserMetadataConnection"] = ResolversParentTypes["ApplicationUserMetadataConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ApplicationUserMetadataEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ApplicationUserMetadatum"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserMetadataEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ApplicationUserMetadataEdge"] = ResolversParentTypes["ApplicationUserMetadataEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["ApplicationUserMetadatum"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserMetadatumResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ApplicationUserMetadatum"] = ResolversParentTypes["ApplicationUserMetadatum"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  value?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserSessionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ApplicationUserSession"] = ResolversParentTypes["ApplicationUserSession"],
> = {
  active?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  datetimeLastActive?: Resolver<
    ResolversTypes["Datetime"],
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  lastPath?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes["JSON"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserSessionsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ApplicationUserSessionsConnection"] = ResolversParentTypes["ApplicationUserSessionsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ApplicationUserSessionsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ApplicationUserSession"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserSessionsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ApplicationUserSessionsEdge"] = ResolversParentTypes["ApplicationUserSessionsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["ApplicationUserSession"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserUserPermissionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ApplicationUserUserPermission"] = ResolversParentTypes["ApplicationUserUserPermission"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  authPermissionByPermissionId?: Resolver<
    Maybe<ResolversTypes["AuthPermission"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  permissionId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserUserPermissionsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ApplicationUserUserPermissionsConnection"] = ResolversParentTypes["ApplicationUserUserPermissionsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ApplicationUserUserPermissionsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ApplicationUserUserPermission"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUserUserPermissionsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ApplicationUserUserPermissionsEdge"] = ResolversParentTypes["ApplicationUserUserPermissionsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["ApplicationUserUserPermission"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationUsersEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ApplicationUsersEdge"] = ResolversParentTypes["ApplicationUsersEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["ApplicationUser"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuditlogLogentriesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AuditlogLogentriesConnection"] = ResolversParentTypes["AuditlogLogentriesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["AuditlogLogentriesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["AuditlogLogentry"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuditlogLogentriesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AuditlogLogentriesEdge"] = ResolversParentTypes["AuditlogLogentriesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["AuditlogLogentry"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuditlogLogentryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AuditlogLogentry"] = ResolversParentTypes["AuditlogLogentry"],
> = {
  action?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  actorEmail?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  actorId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  additionalData?: Resolver<
    Maybe<ResolversTypes["JSON"]>,
    ParentType,
    ContextType
  >;
  applicationUserByActorId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  changes?: Resolver<Maybe<ResolversTypes["JSON"]>, ParentType, ContextType>;
  changesText?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  cid?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  contentTypeId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  djangoContentTypeByContentTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes["BigInt"]>, ParentType, ContextType>;
  objectPk?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  objectRepr?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  remoteAddr?: Resolver<
    Maybe<ResolversTypes["InternetAddress"]>,
    ParentType,
    ContextType
  >;
  remotePort?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  serializedData?: Resolver<
    Maybe<ResolversTypes["JSON"]>,
    ParentType,
    ContextType
  >;
  timestamp?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthGroupResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AuthGroup"] = ResolversParentTypes["AuthGroup"],
> = {
  applicationUserGroupsByGroupId?: Resolver<
    ResolversTypes["ApplicationUserGroupsConnection"],
    ParentType,
    ContextType,
    RequireFields<AuthGroupApplicationUserGroupsByGroupIdArgs, "orderBy">
  >;
  authGroupPermissionsByGroupId?: Resolver<
    ResolversTypes["AuthGroupPermissionsConnection"],
    ParentType,
    ContextType,
    RequireFields<AuthGroupAuthGroupPermissionsByGroupIdArgs, "orderBy">
  >;
  featureFlagsGroupsByGroupId?: Resolver<
    ResolversTypes["FeatureFlagsGroupsConnection"],
    ParentType,
    ContextType,
    RequireFields<AuthGroupFeatureFlagsGroupsByGroupIdArgs, "orderBy">
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthGroupPermissionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AuthGroupPermission"] = ResolversParentTypes["AuthGroupPermission"],
> = {
  authGroupByGroupId?: Resolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    ParentType,
    ContextType
  >;
  authPermissionByPermissionId?: Resolver<
    Maybe<ResolversTypes["AuthPermission"]>,
    ParentType,
    ContextType
  >;
  groupId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  permissionId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthGroupPermissionsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AuthGroupPermissionsConnection"] = ResolversParentTypes["AuthGroupPermissionsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["AuthGroupPermissionsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["AuthGroupPermission"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthGroupPermissionsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AuthGroupPermissionsEdge"] = ResolversParentTypes["AuthGroupPermissionsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["AuthGroupPermission"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthGroupsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AuthGroupsConnection"] = ResolversParentTypes["AuthGroupsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["AuthGroupsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<Array<ResolversTypes["AuthGroup"]>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthGroupsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AuthGroupsEdge"] = ResolversParentTypes["AuthGroupsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["AuthGroup"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthPermissionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AuthPermission"] = ResolversParentTypes["AuthPermission"],
> = {
  applicationUserUserPermissionsByPermissionId?: Resolver<
    ResolversTypes["ApplicationUserUserPermissionsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      AuthPermissionApplicationUserUserPermissionsByPermissionIdArgs,
      "orderBy"
    >
  >;
  authGroupPermissionsByPermissionId?: Resolver<
    ResolversTypes["AuthGroupPermissionsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      AuthPermissionAuthGroupPermissionsByPermissionIdArgs,
      "orderBy"
    >
  >;
  codename?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  contentTypeId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  djangoContentTypeByContentTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthPermissionsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AuthPermissionsConnection"] = ResolversParentTypes["AuthPermissionsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["AuthPermissionsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["AuthPermission"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthPermissionsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AuthPermissionsEdge"] = ResolversParentTypes["AuthPermissionsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["AuthPermission"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableNonRestrictedProjectResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AvailableNonRestrictedProject"] = ResolversParentTypes["AvailableNonRestrictedProject"],
> = {
  defaultUserAccessLevel?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  tenantId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableNonRestrictedProjectsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AvailableNonRestrictedProjectsConnection"] = ResolversParentTypes["AvailableNonRestrictedProjectsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["AvailableNonRestrictedProjectsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["AvailableNonRestrictedProject"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvailableNonRestrictedProjectsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AvailableNonRestrictedProjectsEdge"] = ResolversParentTypes["AvailableNonRestrictedProjectsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["AvailableNonRestrictedProject"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvatarResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Avatar"] = ResolversParentTypes["Avatar"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  color?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  imageBase64?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  initials?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  useImage?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvatarsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AvatarsConnection"] = ResolversParentTypes["AvatarsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["AvatarsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<Array<ResolversTypes["Avatar"]>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AvatarsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AvatarsEdge"] = ResolversParentTypes["AvatarsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["Avatar"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsBatchTaskResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsBatchTask"] = ResolversParentTypes["AwsBatchTask"],
> = {
  awsDataBucketName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  awsInstanceId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  awsInstanceMemory?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  awsInstanceType?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  awsInstanceVcpus?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  awsJobId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  awsJobQueue?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  awsJobStatus?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  awsJobStatusReason?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  awsMockBatchTaskByAwstaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsMockBatchTask"]>,
    ParentType,
    ContextType
  >;
  awsMockBatchTasksByAwstaskexecutorPtrId?: Resolver<
    ResolversTypes["AwsMockBatchTasksConnection"],
    ParentType,
    ContextType,
    RequireFields<
      AwsBatchTaskAwsMockBatchTasksByAwstaskexecutorPtrIdArgs,
      "orderBy"
    >
  >;
  awsRegion?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  awsTaskPath?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  exitcode?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  resultsProcessed?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  taskexecutorPtrId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  tesTaskexecutorByTaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsBatchTasksConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsBatchTasksConnection"] = ResolversParentTypes["AwsBatchTasksConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["AwsBatchTasksEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["AwsBatchTask"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsBatchTasksEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsBatchTasksEdge"] = ResolversParentTypes["AwsBatchTasksEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["AwsBatchTask"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsCognitoUserResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsCognitoUser"] = ResolversParentTypes["AwsCognitoUser"],
> = {
  awsMockIamUserByAwsuserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsMockIamUser"]>,
    ParentType,
    ContextType
  >;
  awsMockIamUsersByAwsuserexecutorPtrId?: Resolver<
    ResolversTypes["AwsMockIamUsersConnection"],
    ParentType,
    ContextType,
    RequireFields<
      AwsCognitoUserAwsMockIamUsersByAwsuserexecutorPtrIdArgs,
      "orderBy"
    >
  >;
  tenantUserexecutorByUserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TenantUserexecutor"]>,
    ParentType,
    ContextType
  >;
  userexecutorPtrId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsCognitoUsersConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsCognitoUsersConnection"] = ResolversParentTypes["AwsCognitoUsersConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["AwsCognitoUsersEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["AwsCognitoUser"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsCognitoUsersEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsCognitoUsersEdge"] = ResolversParentTypes["AwsCognitoUsersEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["AwsCognitoUser"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsEcrImageResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsEcrImage"] = ResolversParentTypes["AwsEcrImage"],
> = {
  awsMockEcrImageByAwscontainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsMockEcrImage"]>,
    ParentType,
    ContextType
  >;
  awsMockEcrImagesByAwscontainerimageexecutorPtrId?: Resolver<
    ResolversTypes["AwsMockEcrImagesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      AwsEcrImageAwsMockEcrImagesByAwscontainerimageexecutorPtrIdArgs,
      "orderBy"
    >
  >;
  containerimageexecutorPtrId?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  jobDefinitionName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  jobDefinitionRevision?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  repositoryArn?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  tesContainerimageexecutorByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsEcrImagesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsEcrImagesConnection"] = ResolversParentTypes["AwsEcrImagesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["AwsEcrImagesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["AwsEcrImage"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsEcrImagesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsEcrImagesEdge"] = ResolversParentTypes["AwsEcrImagesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["AwsEcrImage"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsMockBatchTaskResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsMockBatchTask"] = ResolversParentTypes["AwsMockBatchTask"],
> = {
  awsBatchTaskByAwstaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsBatchTask"]>,
    ParentType,
    ContextType
  >;
  awstaskexecutorPtrId?: Resolver<
    ResolversTypes["UUID"],
    ParentType,
    ContextType
  >;
  containerName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsMockBatchTasksConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsMockBatchTasksConnection"] = ResolversParentTypes["AwsMockBatchTasksConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["AwsMockBatchTasksEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["AwsMockBatchTask"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsMockBatchTasksEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsMockBatchTasksEdge"] = ResolversParentTypes["AwsMockBatchTasksEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["AwsMockBatchTask"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsMockDistributionImageResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsMockDistributionImage"] = ResolversParentTypes["AwsMockDistributionImage"],
> = {
  distributionRegistryImageByDistributioncontainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DistributionRegistryImage"]>,
    ParentType,
    ContextType
  >;
  distributioncontainerimageexecutorPtrId?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsMockDistributionImagesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsMockDistributionImagesConnection"] = ResolversParentTypes["AwsMockDistributionImagesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["AwsMockDistributionImagesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["AwsMockDistributionImage"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsMockDistributionImagesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsMockDistributionImagesEdge"] = ResolversParentTypes["AwsMockDistributionImagesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["AwsMockDistributionImage"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsMockEcrImageResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsMockEcrImage"] = ResolversParentTypes["AwsMockEcrImage"],
> = {
  awsEcrImageByAwscontainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsEcrImage"]>,
    ParentType,
    ContextType
  >;
  awscontainerimageexecutorPtrId?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsMockEcrImagesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsMockEcrImagesConnection"] = ResolversParentTypes["AwsMockEcrImagesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["AwsMockEcrImagesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["AwsMockEcrImage"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsMockEcrImagesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsMockEcrImagesEdge"] = ResolversParentTypes["AwsMockEcrImagesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["AwsMockEcrImage"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsMockIamUserResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsMockIamUser"] = ResolversParentTypes["AwsMockIamUser"],
> = {
  awsCognitoUserByAwsuserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsCognitoUser"]>,
    ParentType,
    ContextType
  >;
  awsuserexecutorPtrId?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsMockIamUsersConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsMockIamUsersConnection"] = ResolversParentTypes["AwsMockIamUsersConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["AwsMockIamUsersEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["AwsMockIamUser"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsMockIamUsersEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsMockIamUsersEdge"] = ResolversParentTypes["AwsMockIamUsersEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["AwsMockIamUser"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsMockS3FileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsMockS3File"] = ResolversParentTypes["AwsMockS3File"],
> = {
  awsS3FileByAwsfileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsS3File"]>,
    ParentType,
    ContextType
  >;
  awsfileexecutorPtrId?: Resolver<
    ResolversTypes["UUID"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsMockS3FilesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsMockS3FilesConnection"] = ResolversParentTypes["AwsMockS3FilesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["AwsMockS3FilesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["AwsMockS3File"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsMockS3FilesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsMockS3FilesEdge"] = ResolversParentTypes["AwsMockS3FilesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["AwsMockS3File"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsS3FileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsS3File"] = ResolversParentTypes["AwsS3File"],
> = {
  awsMockS3FileByAwsfileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsMockS3File"]>,
    ParentType,
    ContextType
  >;
  awsMockS3FilesByAwsfileexecutorPtrId?: Resolver<
    ResolversTypes["AwsMockS3FilesConnection"],
    ParentType,
    ContextType,
    RequireFields<AwsS3FileAwsMockS3FilesByAwsfileexecutorPtrIdArgs, "orderBy">
  >;
  awsUploadPath?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  drsFileexecutorByFileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutor"]>,
    ParentType,
    ContextType
  >;
  fileexecutorPtrId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsS3FilesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsS3FilesConnection"] = ResolversParentTypes["AwsS3FilesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["AwsS3FilesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<Array<ResolversTypes["AwsS3File"]>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwsS3FilesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["AwsS3FilesEdge"] = ResolversParentTypes["AwsS3FilesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["AwsS3File"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface BigFloatScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes["BigFloat"], any> {
  name: "BigFloat";
}

export interface BigIntScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes["BigInt"], any> {
  name: "BigInt";
}

export type ChangeUserSessionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ChangeUserSessionPayload"] = ResolversParentTypes["ChangeUserSessionPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserSession?: Resolver<
    Maybe<ResolversTypes["ApplicationUserSession"]>,
    ParentType,
    ContextType
  >;
  applicationUserSessionEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUserSessionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      ChangeUserSessionPayloadApplicationUserSessionEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CodeFileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CodeFile"] = ResolversParentTypes["CodeFile"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  checksum?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  codeFileBySeriesParentId?: Resolver<
    Maybe<ResolversTypes["CodeFile"]>,
    ParentType,
    ContextType
  >;
  codeFilesBySeriesParentId?: Resolver<
    ResolversTypes["CodeFilesConnection"],
    ParentType,
    ContextType,
    RequireFields<CodeFileCodeFilesBySeriesParentIdArgs, "orderBy">
  >;
  commandsByCodeFileId?: Resolver<
    ResolversTypes["CommandsConnection"],
    ParentType,
    ContextType,
    RequireFields<CodeFileCommandsByCodeFileIdArgs, "orderBy">
  >;
  compressed?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  dateArchived?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  dateDataDeleted?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  dateDeleted?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  drsFileexecutorByExecutorId?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutor"]>,
    ParentType,
    ContextType
  >;
  executorId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  fileFormat?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  fileStructure?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  fileType?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  isSeries?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  multipartUploadId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  originalName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  partSize?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  seriesParentId?: Resolver<
    Maybe<ResolversTypes["UUID"]>,
    ParentType,
    ContextType
  >;
  signal?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes["BigInt"]>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tags?: Resolver<
    Array<Maybe<ResolversTypes["String"]>>,
    ParentType,
    ContextType
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  uploadStatus?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CodeFilesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CodeFilesConnection"] = ResolversParentTypes["CodeFilesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["CodeFilesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<Array<ResolversTypes["CodeFile"]>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CodeFilesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CodeFilesEdge"] = ResolversParentTypes["CodeFilesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["CodeFile"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommandResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Command"] = ResolversParentTypes["Command"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  codeFileByCodeFileId?: Resolver<
    Maybe<ResolversTypes["CodeFile"]>,
    ParentType,
    ContextType
  >;
  codeFileId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  containerImageByContainerImageId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  containerImageId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  entryPoint?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  filePath?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  originalToolSpec?: Resolver<ResolversTypes["JSON"], ParentType, ContextType>;
  programType?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  toolVersionId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommandsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CommandsConnection"] = ResolversParentTypes["CommandsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["CommandsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<Array<ResolversTypes["Command"]>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommandsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CommandsEdge"] = ResolversParentTypes["CommandsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["Command"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContainerImageResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ContainerImage"] = ResolversParentTypes["ContainerImage"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  checksum?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  commandsByContainerImageId?: Resolver<
    ResolversTypes["CommandsConnection"],
    ParentType,
    ContextType,
    RequireFields<ContainerImageCommandsByContainerImageIdArgs, "orderBy">
  >;
  containerImageRepositoryByContainerImageRepositoryId?: Resolver<
    Maybe<ResolversTypes["ContainerImageRepository"]>,
    ParentType,
    ContextType
  >;
  containerImageRepositoryId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  dateDeleted?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  dateUpdated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  description?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  executorId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  readme?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  size?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  spec?: Resolver<Maybe<ResolversTypes["JSON"]>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tags?: Resolver<
    Maybe<Array<Maybe<ResolversTypes["String"]>>>,
    ParentType,
    ContextType
  >;
  tasksByContainerImageId?: Resolver<
    ResolversTypes["TasksConnection"],
    ParentType,
    ContextType,
    RequireFields<ContainerImageTasksByContainerImageIdArgs, "orderBy">
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  tesContainerimageexecutorByExecutorId?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  toolVersionsByContainerImageId?: Resolver<
    ResolversTypes["ToolVersionsConnection"],
    ParentType,
    ContextType,
    RequireFields<ContainerImageToolVersionsByContainerImageIdArgs, "orderBy">
  >;
  userId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  workflowsByContainerId?: Resolver<
    ResolversTypes["WorkflowsConnection"],
    ParentType,
    ContextType,
    RequireFields<ContainerImageWorkflowsByContainerIdArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContainerImageRepositoriesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ContainerImageRepositoriesConnection"] = ResolversParentTypes["ContainerImageRepositoriesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ContainerImageRepositoriesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ContainerImageRepository"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContainerImageRepositoriesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ContainerImageRepositoriesEdge"] = ResolversParentTypes["ContainerImageRepositoriesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["ContainerImageRepository"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContainerImageRepositoryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ContainerImageRepository"] = ResolversParentTypes["ContainerImageRepository"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  containerImagesByContainerImageRepositoryId?: Resolver<
    ResolversTypes["ContainerImagesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ContainerImageRepositoryContainerImagesByContainerImageRepositoryIdArgs,
      "orderBy"
    >
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  registryType?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  repository?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  status?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  visibility?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContainerImagesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ContainerImagesConnection"] = ResolversParentTypes["ContainerImagesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ContainerImagesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContainerImagesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ContainerImagesEdge"] = ResolversParentTypes["ContainerImagesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["ContainerImage"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CostResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Cost"] = ResolversParentTypes["Cost"],
> = {
  costType?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes["Datetime"]>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  fileActivitiesByCostId?: Resolver<
    ResolversTypes["FileActivitiesConnection"],
    ParentType,
    ContextType,
    RequireFields<CostFileActivitiesByCostIdArgs, "orderBy">
  >;
  id?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  rateCode?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  taskActivitiesByCostId?: Resolver<
    ResolversTypes["TaskActivitiesConnection"],
    ParentType,
    ContextType,
    RequireFields<CostTaskActivitiesByCostIdArgs, "orderBy">
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  value?: Resolver<ResolversTypes["BigFloat"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CostsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CostsConnection"] = ResolversParentTypes["CostsConnection"],
> = {
  edges?: Resolver<Array<ResolversTypes["CostsEdge"]>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes["Cost"]>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CostsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CostsEdge"] = ResolversParentTypes["CostsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["Cost"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAdminProjectPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateAdminProjectPayload"] = ResolversParentTypes["CreateAdminProjectPayload"],
> = {
  adminProject?: Resolver<
    Maybe<ResolversTypes["AdminProject"]>,
    ParentType,
    ContextType
  >;
  adminProjectEdge?: Resolver<
    Maybe<ResolversTypes["AdminProjectsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateAdminProjectPayloadAdminProjectEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateApplicationUserGroupPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateApplicationUserGroupPayload"] = ResolversParentTypes["CreateApplicationUserGroupPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserGroup?: Resolver<
    Maybe<ResolversTypes["ApplicationUserGroup"]>,
    ParentType,
    ContextType
  >;
  applicationUserGroupEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUserGroupsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateApplicationUserGroupPayloadApplicationUserGroupEdgeArgs,
      "orderBy"
    >
  >;
  authGroupByGroupId?: Resolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateApplicationUserMembershipPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateApplicationUserMembershipPayload"] = ResolversParentTypes["CreateApplicationUserMembershipPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserMembership?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMembership"]>,
    ParentType,
    ContextType
  >;
  applicationUserMembershipEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMembershipsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateApplicationUserMembershipPayloadApplicationUserMembershipEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateApplicationUserMetadatumPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateApplicationUserMetadatumPayload"] = ResolversParentTypes["CreateApplicationUserMetadatumPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserMetadatum?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMetadatum"]>,
    ParentType,
    ContextType
  >;
  applicationUserMetadatumEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMetadataEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateApplicationUserMetadatumPayloadApplicationUserMetadatumEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateApplicationUserPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateApplicationUserPayload"] = ResolversParentTypes["CreateApplicationUserPayload"],
> = {
  applicationUser?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUsersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateApplicationUserPayloadApplicationUserEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateApplicationUserSessionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateApplicationUserSessionPayload"] = ResolversParentTypes["CreateApplicationUserSessionPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserSession?: Resolver<
    Maybe<ResolversTypes["ApplicationUserSession"]>,
    ParentType,
    ContextType
  >;
  applicationUserSessionEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUserSessionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateApplicationUserSessionPayloadApplicationUserSessionEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateApplicationUserUserPermissionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateApplicationUserUserPermissionPayload"] = ResolversParentTypes["CreateApplicationUserUserPermissionPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserUserPermission?: Resolver<
    Maybe<ResolversTypes["ApplicationUserUserPermission"]>,
    ParentType,
    ContextType
  >;
  applicationUserUserPermissionEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUserUserPermissionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateApplicationUserUserPermissionPayloadApplicationUserUserPermissionEdgeArgs,
      "orderBy"
    >
  >;
  authPermissionByPermissionId?: Resolver<
    Maybe<ResolversTypes["AuthPermission"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAuditlogLogentryPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateAuditlogLogentryPayload"] = ResolversParentTypes["CreateAuditlogLogentryPayload"],
> = {
  applicationUserByActorId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  auditlogLogentry?: Resolver<
    Maybe<ResolversTypes["AuditlogLogentry"]>,
    ParentType,
    ContextType
  >;
  auditlogLogentryEdge?: Resolver<
    Maybe<ResolversTypes["AuditlogLogentriesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateAuditlogLogentryPayloadAuditlogLogentryEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByContentTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAuthGroupPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateAuthGroupPayload"] = ResolversParentTypes["CreateAuthGroupPayload"],
> = {
  authGroup?: Resolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    ParentType,
    ContextType
  >;
  authGroupEdge?: Resolver<
    Maybe<ResolversTypes["AuthGroupsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateAuthGroupPayloadAuthGroupEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAuthGroupPermissionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateAuthGroupPermissionPayload"] = ResolversParentTypes["CreateAuthGroupPermissionPayload"],
> = {
  authGroupByGroupId?: Resolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    ParentType,
    ContextType
  >;
  authGroupPermission?: Resolver<
    Maybe<ResolversTypes["AuthGroupPermission"]>,
    ParentType,
    ContextType
  >;
  authGroupPermissionEdge?: Resolver<
    Maybe<ResolversTypes["AuthGroupPermissionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateAuthGroupPermissionPayloadAuthGroupPermissionEdgeArgs,
      "orderBy"
    >
  >;
  authPermissionByPermissionId?: Resolver<
    Maybe<ResolversTypes["AuthPermission"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAuthPermissionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateAuthPermissionPayload"] = ResolversParentTypes["CreateAuthPermissionPayload"],
> = {
  authPermission?: Resolver<
    Maybe<ResolversTypes["AuthPermission"]>,
    ParentType,
    ContextType
  >;
  authPermissionEdge?: Resolver<
    Maybe<ResolversTypes["AuthPermissionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateAuthPermissionPayloadAuthPermissionEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByContentTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAvailableNonRestrictedProjectPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateAvailableNonRestrictedProjectPayload"] = ResolversParentTypes["CreateAvailableNonRestrictedProjectPayload"],
> = {
  availableNonRestrictedProject?: Resolver<
    Maybe<ResolversTypes["AvailableNonRestrictedProject"]>,
    ParentType,
    ContextType
  >;
  availableNonRestrictedProjectEdge?: Resolver<
    Maybe<ResolversTypes["AvailableNonRestrictedProjectsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateAvailableNonRestrictedProjectPayloadAvailableNonRestrictedProjectEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAvatarPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateAvatarPayload"] = ResolversParentTypes["CreateAvatarPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  avatar?: Resolver<Maybe<ResolversTypes["Avatar"]>, ParentType, ContextType>;
  avatarEdge?: Resolver<
    Maybe<ResolversTypes["AvatarsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateAvatarPayloadAvatarEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAwsBatchTaskPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateAwsBatchTaskPayload"] = ResolversParentTypes["CreateAwsBatchTaskPayload"],
> = {
  awsBatchTask?: Resolver<
    Maybe<ResolversTypes["AwsBatchTask"]>,
    ParentType,
    ContextType
  >;
  awsBatchTaskEdge?: Resolver<
    Maybe<ResolversTypes["AwsBatchTasksEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateAwsBatchTaskPayloadAwsBatchTaskEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesTaskexecutorByTaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAwsCognitoUserPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateAwsCognitoUserPayload"] = ResolversParentTypes["CreateAwsCognitoUserPayload"],
> = {
  awsCognitoUser?: Resolver<
    Maybe<ResolversTypes["AwsCognitoUser"]>,
    ParentType,
    ContextType
  >;
  awsCognitoUserEdge?: Resolver<
    Maybe<ResolversTypes["AwsCognitoUsersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateAwsCognitoUserPayloadAwsCognitoUserEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantUserexecutorByUserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TenantUserexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAwsEcrImagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateAwsEcrImagePayload"] = ResolversParentTypes["CreateAwsEcrImagePayload"],
> = {
  awsEcrImage?: Resolver<
    Maybe<ResolversTypes["AwsEcrImage"]>,
    ParentType,
    ContextType
  >;
  awsEcrImageEdge?: Resolver<
    Maybe<ResolversTypes["AwsEcrImagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateAwsEcrImagePayloadAwsEcrImageEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesContainerimageexecutorByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAwsMockBatchTaskPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateAwsMockBatchTaskPayload"] = ResolversParentTypes["CreateAwsMockBatchTaskPayload"],
> = {
  awsBatchTaskByAwstaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsBatchTask"]>,
    ParentType,
    ContextType
  >;
  awsMockBatchTask?: Resolver<
    Maybe<ResolversTypes["AwsMockBatchTask"]>,
    ParentType,
    ContextType
  >;
  awsMockBatchTaskEdge?: Resolver<
    Maybe<ResolversTypes["AwsMockBatchTasksEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateAwsMockBatchTaskPayloadAwsMockBatchTaskEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAwsMockDistributionImagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateAwsMockDistributionImagePayload"] = ResolversParentTypes["CreateAwsMockDistributionImagePayload"],
> = {
  awsMockDistributionImage?: Resolver<
    Maybe<ResolversTypes["AwsMockDistributionImage"]>,
    ParentType,
    ContextType
  >;
  awsMockDistributionImageEdge?: Resolver<
    Maybe<ResolversTypes["AwsMockDistributionImagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateAwsMockDistributionImagePayloadAwsMockDistributionImageEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  distributionRegistryImageByDistributioncontainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DistributionRegistryImage"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAwsMockEcrImagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateAwsMockEcrImagePayload"] = ResolversParentTypes["CreateAwsMockEcrImagePayload"],
> = {
  awsEcrImageByAwscontainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsEcrImage"]>,
    ParentType,
    ContextType
  >;
  awsMockEcrImage?: Resolver<
    Maybe<ResolversTypes["AwsMockEcrImage"]>,
    ParentType,
    ContextType
  >;
  awsMockEcrImageEdge?: Resolver<
    Maybe<ResolversTypes["AwsMockEcrImagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateAwsMockEcrImagePayloadAwsMockEcrImageEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAwsMockIamUserPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateAwsMockIamUserPayload"] = ResolversParentTypes["CreateAwsMockIamUserPayload"],
> = {
  awsCognitoUserByAwsuserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsCognitoUser"]>,
    ParentType,
    ContextType
  >;
  awsMockIamUser?: Resolver<
    Maybe<ResolversTypes["AwsMockIamUser"]>,
    ParentType,
    ContextType
  >;
  awsMockIamUserEdge?: Resolver<
    Maybe<ResolversTypes["AwsMockIamUsersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateAwsMockIamUserPayloadAwsMockIamUserEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAwsMockS3FilePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateAwsMockS3FilePayload"] = ResolversParentTypes["CreateAwsMockS3FilePayload"],
> = {
  awsMockS3File?: Resolver<
    Maybe<ResolversTypes["AwsMockS3File"]>,
    ParentType,
    ContextType
  >;
  awsMockS3FileEdge?: Resolver<
    Maybe<ResolversTypes["AwsMockS3FilesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateAwsMockS3FilePayloadAwsMockS3FileEdgeArgs, "orderBy">
  >;
  awsS3FileByAwsfileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsS3File"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateAwsS3FilePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateAwsS3FilePayload"] = ResolversParentTypes["CreateAwsS3FilePayload"],
> = {
  awsS3File?: Resolver<
    Maybe<ResolversTypes["AwsS3File"]>,
    ParentType,
    ContextType
  >;
  awsS3FileEdge?: Resolver<
    Maybe<ResolversTypes["AwsS3FilesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateAwsS3FilePayloadAwsS3FileEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  drsFileexecutorByFileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutor"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateCodeFilePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateCodeFilePayload"] = ResolversParentTypes["CreateCodeFilePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  codeFile?: Resolver<
    Maybe<ResolversTypes["CodeFile"]>,
    ParentType,
    ContextType
  >;
  codeFileBySeriesParentId?: Resolver<
    Maybe<ResolversTypes["CodeFile"]>,
    ParentType,
    ContextType
  >;
  codeFileEdge?: Resolver<
    Maybe<ResolversTypes["CodeFilesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateCodeFilePayloadCodeFileEdgeArgs, "orderBy">
  >;
  drsFileexecutorByExecutorId?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutor"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateCommandPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateCommandPayload"] = ResolversParentTypes["CreateCommandPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  codeFileByCodeFileId?: Resolver<
    Maybe<ResolversTypes["CodeFile"]>,
    ParentType,
    ContextType
  >;
  command?: Resolver<Maybe<ResolversTypes["Command"]>, ParentType, ContextType>;
  commandEdge?: Resolver<
    Maybe<ResolversTypes["CommandsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateCommandPayloadCommandEdgeArgs, "orderBy">
  >;
  containerImageByContainerImageId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateContainerImagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateContainerImagePayload"] = ResolversParentTypes["CreateContainerImagePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  containerImage?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  containerImageEdge?: Resolver<
    Maybe<ResolversTypes["ContainerImagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateContainerImagePayloadContainerImageEdgeArgs, "orderBy">
  >;
  containerImageRepositoryByContainerImageRepositoryId?: Resolver<
    Maybe<ResolversTypes["ContainerImageRepository"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tesContainerimageexecutorByExecutorId?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateContainerImageRepositoryPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateContainerImageRepositoryPayload"] = ResolversParentTypes["CreateContainerImageRepositoryPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  containerImageRepository?: Resolver<
    Maybe<ResolversTypes["ContainerImageRepository"]>,
    ParentType,
    ContextType
  >;
  containerImageRepositoryEdge?: Resolver<
    Maybe<ResolversTypes["ContainerImageRepositoriesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateContainerImageRepositoryPayloadContainerImageRepositoryEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateCostPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateCostPayload"] = ResolversParentTypes["CreateCostPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  cost?: Resolver<Maybe<ResolversTypes["Cost"]>, ParentType, ContextType>;
  costEdge?: Resolver<
    Maybe<ResolversTypes["CostsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateCostPayloadCostEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateCurrentApplicationUserPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateCurrentApplicationUserPayload"] = ResolversParentTypes["CreateCurrentApplicationUserPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  currentApplicationUser?: Resolver<
    Maybe<ResolversTypes["CurrentApplicationUser"]>,
    ParentType,
    ContextType
  >;
  currentApplicationUserEdge?: Resolver<
    Maybe<ResolversTypes["CurrentApplicationUsersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateCurrentApplicationUserPayloadCurrentApplicationUserEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateDistributionRegistryImagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateDistributionRegistryImagePayload"] = ResolversParentTypes["CreateDistributionRegistryImagePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  distributionRegistryImage?: Resolver<
    Maybe<ResolversTypes["DistributionRegistryImage"]>,
    ParentType,
    ContextType
  >;
  distributionRegistryImageEdge?: Resolver<
    Maybe<ResolversTypes["DistributionRegistryImagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateDistributionRegistryImagePayloadDistributionRegistryImageEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesContainerimageexecutorByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateDjangoAdminLogPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateDjangoAdminLogPayload"] = ResolversParentTypes["CreateDjangoAdminLogPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoAdminLog?: Resolver<
    Maybe<ResolversTypes["DjangoAdminLog"]>,
    ParentType,
    ContextType
  >;
  djangoAdminLogEdge?: Resolver<
    Maybe<ResolversTypes["DjangoAdminLogsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateDjangoAdminLogPayloadDjangoAdminLogEdgeArgs, "orderBy">
  >;
  djangoContentTypeByContentTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateDjangoContentTypePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateDjangoContentTypePayload"] = ResolversParentTypes["CreateDjangoContentTypePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoContentType?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeEdge?: Resolver<
    Maybe<ResolversTypes["DjangoContentTypesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateDjangoContentTypePayloadDjangoContentTypeEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateDjangoMigrationPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateDjangoMigrationPayload"] = ResolversParentTypes["CreateDjangoMigrationPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoMigration?: Resolver<
    Maybe<ResolversTypes["DjangoMigration"]>,
    ParentType,
    ContextType
  >;
  djangoMigrationEdge?: Resolver<
    Maybe<ResolversTypes["DjangoMigrationsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateDjangoMigrationPayloadDjangoMigrationEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateDjangoSesBlacklistedemailPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateDjangoSesBlacklistedemailPayload"] = ResolversParentTypes["CreateDjangoSesBlacklistedemailPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoSesBlacklistedemail?: Resolver<
    Maybe<ResolversTypes["DjangoSesBlacklistedemail"]>,
    ParentType,
    ContextType
  >;
  djangoSesBlacklistedemailEdge?: Resolver<
    Maybe<ResolversTypes["DjangoSesBlacklistedemailsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateDjangoSesBlacklistedemailPayloadDjangoSesBlacklistedemailEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateDjangoSesSesstatPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateDjangoSesSesstatPayload"] = ResolversParentTypes["CreateDjangoSesSesstatPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoSesSesstat?: Resolver<
    Maybe<ResolversTypes["DjangoSesSesstat"]>,
    ParentType,
    ContextType
  >;
  djangoSesSesstatEdge?: Resolver<
    Maybe<ResolversTypes["DjangoSesSesstatsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateDjangoSesSesstatPayloadDjangoSesSesstatEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateDjangoSessionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateDjangoSessionPayload"] = ResolversParentTypes["CreateDjangoSessionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoSession?: Resolver<
    Maybe<ResolversTypes["DjangoSession"]>,
    ParentType,
    ContextType
  >;
  djangoSessionEdge?: Resolver<
    Maybe<ResolversTypes["DjangoSessionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateDjangoSessionPayloadDjangoSessionEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateDrsFileexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateDrsFileexecutorPayload"] = ResolversParentTypes["CreateDrsFileexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByPolymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  drsFileexecutor?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutor"]>,
    ParentType,
    ContextType
  >;
  drsFileexecutorEdge?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateDrsFileexecutorPayloadDrsFileexecutorEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateDrsMockfileexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateDrsMockfileexecutorPayload"] = ResolversParentTypes["CreateDrsMockfileexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  drsFileexecutorByFileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutor"]>,
    ParentType,
    ContextType
  >;
  drsMockfileexecutor?: Resolver<
    Maybe<ResolversTypes["DrsMockfileexecutor"]>,
    ParentType,
    ContextType
  >;
  drsMockfileexecutorEdge?: Resolver<
    Maybe<ResolversTypes["DrsMockfileexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateDrsMockfileexecutorPayloadDrsMockfileexecutorEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateEulaVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateEulaVersionPayload"] = ResolversParentTypes["CreateEulaVersionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  eulaVersion?: Resolver<
    Maybe<ResolversTypes["EulaVersion"]>,
    ParentType,
    ContextType
  >;
  eulaVersionEdge?: Resolver<
    Maybe<ResolversTypes["EulaVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateEulaVersionPayloadEulaVersionEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateEulaVersionUserAcceptancePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateEulaVersionUserAcceptancePayload"] = ResolversParentTypes["CreateEulaVersionUserAcceptancePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  eulaVersionByEulaVersionId?: Resolver<
    Maybe<ResolversTypes["EulaVersion"]>,
    ParentType,
    ContextType
  >;
  eulaVersionUserAcceptance?: Resolver<
    Maybe<ResolversTypes["EulaVersionUserAcceptance"]>,
    ParentType,
    ContextType
  >;
  eulaVersionUserAcceptanceEdge?: Resolver<
    Maybe<ResolversTypes["EulaVersionUserAcceptancesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateEulaVersionUserAcceptancePayloadEulaVersionUserAcceptanceEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateFeatureFlagPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateFeatureFlagPayload"] = ResolversParentTypes["CreateFeatureFlagPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  featureFlag?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType
  >;
  featureFlagEdge?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateFeatureFlagPayloadFeatureFlagEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateFeatureFlagsGroupPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateFeatureFlagsGroupPayload"] = ResolversParentTypes["CreateFeatureFlagsGroupPayload"],
> = {
  authGroupByGroupId?: Resolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  featureFlagByFeatureflagId?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType
  >;
  featureFlagsGroup?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsGroup"]>,
    ParentType,
    ContextType
  >;
  featureFlagsGroupEdge?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsGroupsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateFeatureFlagsGroupPayloadFeatureFlagsGroupEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateFeatureFlagsTenantPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateFeatureFlagsTenantPayload"] = ResolversParentTypes["CreateFeatureFlagsTenantPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  featureFlagByFeatureflagId?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType
  >;
  featureFlagsTenant?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsTenant"]>,
    ParentType,
    ContextType
  >;
  featureFlagsTenantEdge?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsTenantsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateFeatureFlagsTenantPayloadFeatureFlagsTenantEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateFeatureFlagsUserPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateFeatureFlagsUserPayload"] = ResolversParentTypes["CreateFeatureFlagsUserPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  featureFlagByFeatureflagId?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType
  >;
  featureFlagsUser?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsUser"]>,
    ParentType,
    ContextType
  >;
  featureFlagsUserEdge?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsUsersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateFeatureFlagsUserPayloadFeatureFlagsUserEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateFileActivityPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateFileActivityPayload"] = ResolversParentTypes["CreateFileActivityPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  costByCostId?: Resolver<
    Maybe<ResolversTypes["Cost"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByContentTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  fileActivity?: Resolver<
    Maybe<ResolversTypes["FileActivity"]>,
    ParentType,
    ContextType
  >;
  fileActivityEdge?: Resolver<
    Maybe<ResolversTypes["FileActivitiesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateFileActivityPayloadFileActivityEdgeArgs, "orderBy">
  >;
  fileByFileId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateFileMetadatumPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateFileMetadatumPayload"] = ResolversParentTypes["CreateFileMetadatumPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  fileByFileId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  fileMetadatum?: Resolver<
    Maybe<ResolversTypes["FileMetadatum"]>,
    ParentType,
    ContextType
  >;
  fileMetadatumEdge?: Resolver<
    Maybe<ResolversTypes["FileMetadataEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateFileMetadatumPayloadFileMetadatumEdgeArgs, "orderBy">
  >;
  metadatumByMetadataId?: Resolver<
    Maybe<ResolversTypes["Metadatum"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateFileOutputGroupMetadatumPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateFileOutputGroupMetadatumPayload"] = ResolversParentTypes["CreateFileOutputGroupMetadatumPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroupByFileOutputGroupId?: Resolver<
    Maybe<ResolversTypes["FileOutputGroup"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroupMetadatum?: Resolver<
    Maybe<ResolversTypes["FileOutputGroupMetadatum"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroupMetadatumEdge?: Resolver<
    Maybe<ResolversTypes["FileOutputGroupMetadataEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateFileOutputGroupMetadatumPayloadFileOutputGroupMetadatumEdgeArgs,
      "orderBy"
    >
  >;
  metadatumByMetadataId?: Resolver<
    Maybe<ResolversTypes["Metadatum"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateFilePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateFilePayload"] = ResolversParentTypes["CreateFilePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  file?: Resolver<Maybe<ResolversTypes["File"]>, ParentType, ContextType>;
  fileBySeriesParentId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  fileEdge?: Resolver<
    Maybe<ResolversTypes["FilesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateFilePayloadFileEdgeArgs, "orderBy">
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateFilesByExecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateFilesByExecutorPayload"] = ResolversParentTypes["CreateFilesByExecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  filesByExecutor?: Resolver<
    Maybe<ResolversTypes["FilesByExecutor"]>,
    ParentType,
    ContextType
  >;
  filesByExecutorEdge?: Resolver<
    Maybe<ResolversTypes["FilesByExecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateFilesByExecutorPayloadFilesByExecutorEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateMetadataValuePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateMetadataValuePayload"] = ResolversParentTypes["CreateMetadataValuePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  metadataValue?: Resolver<
    Maybe<ResolversTypes["MetadataValue"]>,
    ParentType,
    ContextType
  >;
  metadataValueEdge?: Resolver<
    Maybe<ResolversTypes["MetadataValuesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateMetadataValuePayloadMetadataValueEdgeArgs, "orderBy">
  >;
  metadatumByMetadataId?: Resolver<
    Maybe<ResolversTypes["Metadatum"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateMetadatumPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateMetadatumPayload"] = ResolversParentTypes["CreateMetadatumPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  metadatum?: Resolver<
    Maybe<ResolversTypes["Metadatum"]>,
    ParentType,
    ContextType
  >;
  metadatumEdge?: Resolver<
    Maybe<ResolversTypes["MetadataEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateMetadatumPayloadMetadatumEdgeArgs, "orderBy">
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateOutputGroupFilePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateOutputGroupFilePayload"] = ResolversParentTypes["CreateOutputGroupFilePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  fileByFileId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroupByFileOutputGroupId?: Resolver<
    Maybe<ResolversTypes["FileOutputGroup"]>,
    ParentType,
    ContextType
  >;
  outputGroupFile?: Resolver<
    Maybe<ResolversTypes["OutputGroupFile"]>,
    ParentType,
    ContextType
  >;
  outputGroupFileEdge?: Resolver<
    Maybe<ResolversTypes["OutputGroupFilesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateOutputGroupFilePayloadOutputGroupFileEdgeArgs,
      "orderBy"
    >
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreatePinnedToolPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreatePinnedToolPayload"] = ResolversParentTypes["CreatePinnedToolPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  pinnedTool?: Resolver<
    Maybe<ResolversTypes["PinnedTool"]>,
    ParentType,
    ContextType
  >;
  pinnedToolEdge?: Resolver<
    Maybe<ResolversTypes["PinnedToolsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreatePinnedToolPayloadPinnedToolEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolByToolId?: Resolver<
    Maybe<ResolversTypes["Tool"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateProjectFolderPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateProjectFolderPayload"] = ResolversParentTypes["CreateProjectFolderPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectFolder?: Resolver<
    Maybe<ResolversTypes["ProjectFolder"]>,
    ParentType,
    ContextType
  >;
  projectFolderEdge?: Resolver<
    Maybe<ResolversTypes["ProjectFoldersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateProjectFolderPayloadProjectFolderEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateProjectTagPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateProjectTagPayload"] = ResolversParentTypes["CreateProjectTagPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectTag?: Resolver<
    Maybe<ResolversTypes["ProjectTag"]>,
    ParentType,
    ContextType
  >;
  projectTagEdge?: Resolver<
    Maybe<ResolversTypes["ProjectTagsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateProjectTagPayloadProjectTagEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateRolePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateRolePayload"] = ResolversParentTypes["CreateRolePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateRunPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateRunPayload"] = ResolversParentTypes["CreateRunPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  run?: Resolver<Maybe<ResolversTypes["Run"]>, ParentType, ContextType>;
  runEdge?: Resolver<
    Maybe<ResolversTypes["RunsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateRunPayloadRunEdgeArgs, "orderBy">
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateSessionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateSessionPayload"] = ResolversParentTypes["CreateSessionPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserSession?: Resolver<
    Maybe<ResolversTypes["ApplicationUserSession"]>,
    ParentType,
    ContextType
  >;
  applicationUserSessionEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUserSessionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateSessionPayloadApplicationUserSessionEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTaskActivityPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateTaskActivityPayload"] = ResolversParentTypes["CreateTaskActivityPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  costByCostId?: Resolver<
    Maybe<ResolversTypes["Cost"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskActivity?: Resolver<
    Maybe<ResolversTypes["TaskActivity"]>,
    ParentType,
    ContextType
  >;
  taskActivityEdge?: Resolver<
    Maybe<ResolversTypes["TaskActivitiesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateTaskActivityPayloadTaskActivityEdgeArgs, "orderBy">
  >;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTaskPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateTaskPayload"] = ResolversParentTypes["CreateTaskPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  containerImageByContainerImageId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  task?: Resolver<Maybe<ResolversTypes["Task"]>, ParentType, ContextType>;
  taskEdge?: Resolver<
    Maybe<ResolversTypes["TasksEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateTaskPayloadTaskEdgeArgs, "orderBy">
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tesTaskexecutorByExecutorId?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutor"]>,
    ParentType,
    ContextType
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTaskResourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateTaskResourcePayload"] = ResolversParentTypes["CreateTaskResourcePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskResource?: Resolver<
    Maybe<ResolversTypes["TaskResource"]>,
    ParentType,
    ContextType
  >;
  taskResourceEdge?: Resolver<
    Maybe<ResolversTypes["TaskResourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateTaskResourcePayloadTaskResourceEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTaskResourceUsagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateTaskResourceUsagePayload"] = ResolversParentTypes["CreateTaskResourceUsagePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskResourceUsage?: Resolver<
    Maybe<ResolversTypes["TaskResourceUsage"]>,
    ParentType,
    ContextType
  >;
  taskResourceUsageEdge?: Resolver<
    Maybe<ResolversTypes["TaskResourceUsagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateTaskResourceUsagePayloadTaskResourceUsageEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTaskSourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateTaskSourcePayload"] = ResolversParentTypes["CreateTaskSourcePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  fileByFileId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskSource?: Resolver<
    Maybe<ResolversTypes["TaskSource"]>,
    ParentType,
    ContextType
  >;
  taskSourceEdge?: Resolver<
    Maybe<ResolversTypes["TaskSourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateTaskSourcePayloadTaskSourceEdgeArgs, "orderBy">
  >;
  toolSourceByToolSourceId?: Resolver<
    Maybe<ResolversTypes["ToolSource"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTaskStatusLogPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateTaskStatusLogPayload"] = ResolversParentTypes["CreateTaskStatusLogPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskStatusLog?: Resolver<
    Maybe<ResolversTypes["TaskStatusLog"]>,
    ParentType,
    ContextType
  >;
  taskStatusLogEdge?: Resolver<
    Maybe<ResolversTypes["TaskStatusLogsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateTaskStatusLogPayloadTaskStatusLogEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTenantContractAllowancePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateTenantContractAllowancePayload"] = ResolversParentTypes["CreateTenantContractAllowancePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantContractAllowance?: Resolver<
    Maybe<ResolversTypes["TenantContractAllowance"]>,
    ParentType,
    ContextType
  >;
  tenantContractAllowanceEdge?: Resolver<
    Maybe<ResolversTypes["TenantContractAllowancesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateTenantContractAllowancePayloadTenantContractAllowanceEdgeArgs,
      "orderBy"
    >
  >;
  tenantContractTransactionByTenantContractTransactionId?: Resolver<
    Maybe<ResolversTypes["TenantContractTransaction"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTenantContractPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateTenantContractPayload"] = ResolversParentTypes["CreateTenantContractPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantContract?: Resolver<
    Maybe<ResolversTypes["TenantContract"]>,
    ParentType,
    ContextType
  >;
  tenantContractEdge?: Resolver<
    Maybe<ResolversTypes["TenantContractsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateTenantContractPayloadTenantContractEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTenantContractTransactionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateTenantContractTransactionPayload"] = ResolversParentTypes["CreateTenantContractTransactionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantContractByTenantContractId?: Resolver<
    Maybe<ResolversTypes["TenantContract"]>,
    ParentType,
    ContextType
  >;
  tenantContractTransaction?: Resolver<
    Maybe<ResolversTypes["TenantContractTransaction"]>,
    ParentType,
    ContextType
  >;
  tenantContractTransactionEdge?: Resolver<
    Maybe<ResolversTypes["TenantContractTransactionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateTenantContractTransactionPayloadTenantContractTransactionEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTenantMockuserexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateTenantMockuserexecutorPayload"] = ResolversParentTypes["CreateTenantMockuserexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantMockuserexecutor?: Resolver<
    Maybe<ResolversTypes["TenantMockuserexecutor"]>,
    ParentType,
    ContextType
  >;
  tenantMockuserexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TenantMockuserexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateTenantMockuserexecutorPayloadTenantMockuserexecutorEdgeArgs,
      "orderBy"
    >
  >;
  tenantUserexecutorByUserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TenantUserexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTenantMonthlyConsumedResourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateTenantMonthlyConsumedResourcePayload"] = ResolversParentTypes["CreateTenantMonthlyConsumedResourcePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantContractByTenantContractId?: Resolver<
    Maybe<ResolversTypes["TenantContract"]>,
    ParentType,
    ContextType
  >;
  tenantMonthlyConsumedResource?: Resolver<
    Maybe<ResolversTypes["TenantMonthlyConsumedResource"]>,
    ParentType,
    ContextType
  >;
  tenantMonthlyConsumedResourceEdge?: Resolver<
    Maybe<ResolversTypes["TenantMonthlyConsumedResourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateTenantMonthlyConsumedResourcePayloadTenantMonthlyConsumedResourceEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTenantPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateTenantPayload"] = ResolversParentTypes["CreateTenantPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenant?: Resolver<Maybe<ResolversTypes["Tenant"]>, ParentType, ContextType>;
  tenantEdge?: Resolver<
    Maybe<ResolversTypes["TenantsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateTenantPayloadTenantEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTenantUserexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateTenantUserexecutorPayload"] = ResolversParentTypes["CreateTenantUserexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByPolymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantUserexecutor?: Resolver<
    Maybe<ResolversTypes["TenantUserexecutor"]>,
    ParentType,
    ContextType
  >;
  tenantUserexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TenantUserexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateTenantUserexecutorPayloadTenantUserexecutorEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTesContainerimageexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateTesContainerimageexecutorPayload"] = ResolversParentTypes["CreateTesContainerimageexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByPolymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesContainerimageexecutor?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  tesContainerimageexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateTesContainerimageexecutorPayloadTesContainerimageexecutorEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTesMockcontainerimageexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateTesMockcontainerimageexecutorPayload"] = ResolversParentTypes["CreateTesMockcontainerimageexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesContainerimageexecutorByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  tesMockcontainerimageexecutor?: Resolver<
    Maybe<ResolversTypes["TesMockcontainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  tesMockcontainerimageexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TesMockcontainerimageexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateTesMockcontainerimageexecutorPayloadTesMockcontainerimageexecutorEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTesMocktaskexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateTesMocktaskexecutorPayload"] = ResolversParentTypes["CreateTesMocktaskexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesMocktaskexecutor?: Resolver<
    Maybe<ResolversTypes["TesMocktaskexecutor"]>,
    ParentType,
    ContextType
  >;
  tesMocktaskexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TesMocktaskexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateTesMocktaskexecutorPayloadTesMocktaskexecutorEdgeArgs,
      "orderBy"
    >
  >;
  tesTaskexecutorByTaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateTesTaskexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateTesTaskexecutorPayload"] = ResolversParentTypes["CreateTesTaskexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByPolymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesTaskexecutor?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutor"]>,
    ParentType,
    ContextType
  >;
  tesTaskexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateTesTaskexecutorPayloadTesTaskexecutorEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolParameterPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateToolParameterPayload"] = ResolversParentTypes["CreateToolParameterPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolParameter?: Resolver<
    Maybe<ResolversTypes["ToolParameter"]>,
    ParentType,
    ContextType
  >;
  toolParameterEdge?: Resolver<
    Maybe<ResolversTypes["ToolParametersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateToolParameterPayloadToolParameterEdgeArgs, "orderBy">
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateToolPayload"] = ResolversParentTypes["CreateToolPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tool?: Resolver<Maybe<ResolversTypes["Tool"]>, ParentType, ContextType>;
  toolEdge?: Resolver<
    Maybe<ResolversTypes["ToolsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateToolPayloadToolEdgeArgs, "orderBy">
  >;
  toolboxByToolboxId?: Resolver<
    Maybe<ResolversTypes["Toolbox"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolResourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateToolResourcePayload"] = ResolversParentTypes["CreateToolResourcePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolResource?: Resolver<
    Maybe<ResolversTypes["ToolResource"]>,
    ParentType,
    ContextType
  >;
  toolResourceEdge?: Resolver<
    Maybe<ResolversTypes["ToolResourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateToolResourcePayloadToolResourceEdgeArgs, "orderBy">
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolResultPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateToolResultPayload"] = ResolversParentTypes["CreateToolResultPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolResult?: Resolver<
    Maybe<ResolversTypes["ToolResult"]>,
    ParentType,
    ContextType
  >;
  toolResultEdge?: Resolver<
    Maybe<ResolversTypes["ToolResultsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateToolResultPayloadToolResultEdgeArgs, "orderBy">
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolSecretPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateToolSecretPayload"] = ResolversParentTypes["CreateToolSecretPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolSecret?: Resolver<
    Maybe<ResolversTypes["ToolSecret"]>,
    ParentType,
    ContextType
  >;
  toolSecretEdge?: Resolver<
    Maybe<ResolversTypes["ToolSecretsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateToolSecretPayloadToolSecretEdgeArgs, "orderBy">
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolSourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateToolSourcePayload"] = ResolversParentTypes["CreateToolSourcePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolSource?: Resolver<
    Maybe<ResolversTypes["ToolSource"]>,
    ParentType,
    ContextType
  >;
  toolSourceEdge?: Resolver<
    Maybe<ResolversTypes["ToolSourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateToolSourcePayloadToolSourceEdgeArgs, "orderBy">
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolTenantPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateToolTenantPayload"] = ResolversParentTypes["CreateToolTenantPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  toolByToolId?: Resolver<
    Maybe<ResolversTypes["Tool"]>,
    ParentType,
    ContextType
  >;
  toolTenant?: Resolver<
    Maybe<ResolversTypes["ToolTenant"]>,
    ParentType,
    ContextType
  >;
  toolTenantEdge?: Resolver<
    Maybe<ResolversTypes["ToolTenantsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateToolTenantPayloadToolTenantEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateToolVersionPayload"] = ResolversParentTypes["CreateToolVersionPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  containerImageByContainerImageId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  toolByToolId?: Resolver<
    Maybe<ResolversTypes["Tool"]>,
    ParentType,
    ContextType
  >;
  toolVersion?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  toolVersionEdge?: Resolver<
    Maybe<ResolversTypes["ToolVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateToolVersionPayloadToolVersionEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolboxPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateToolboxPayload"] = ResolversParentTypes["CreateToolboxPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolbox?: Resolver<Maybe<ResolversTypes["Toolbox"]>, ParentType, ContextType>;
  toolboxEdge?: Resolver<
    Maybe<ResolversTypes["ToolboxesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateToolboxPayloadToolboxEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolboxTenantPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateToolboxTenantPayload"] = ResolversParentTypes["CreateToolboxTenantPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  toolboxByToolboxId?: Resolver<
    Maybe<ResolversTypes["Toolbox"]>,
    ParentType,
    ContextType
  >;
  toolboxTenant?: Resolver<
    Maybe<ResolversTypes["ToolboxTenant"]>,
    ParentType,
    ContextType
  >;
  toolboxTenantEdge?: Resolver<
    Maybe<ResolversTypes["ToolboxTenantsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateToolboxTenantPayloadToolboxTenantEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateUserPersonalSpaceRequestPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateUserPersonalSpaceRequestPayload"] = ResolversParentTypes["CreateUserPersonalSpaceRequestPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  userPersonalSpaceRequest?: Resolver<
    Maybe<ResolversTypes["UserPersonalSpaceRequest"]>,
    ParentType,
    ContextType
  >;
  userPersonalSpaceRequestEdge?: Resolver<
    Maybe<ResolversTypes["UserPersonalSpaceRequestsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateUserPersonalSpaceRequestPayloadUserPersonalSpaceRequestEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateWaffleFlagPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateWaffleFlagPayload"] = ResolversParentTypes["CreateWaffleFlagPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  waffleFlag?: Resolver<
    Maybe<ResolversTypes["WaffleFlag"]>,
    ParentType,
    ContextType
  >;
  waffleFlagEdge?: Resolver<
    Maybe<ResolversTypes["WaffleFlagsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateWaffleFlagPayloadWaffleFlagEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateWaffleSamplePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateWaffleSamplePayload"] = ResolversParentTypes["CreateWaffleSamplePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  waffleSample?: Resolver<
    Maybe<ResolversTypes["WaffleSample"]>,
    ParentType,
    ContextType
  >;
  waffleSampleEdge?: Resolver<
    Maybe<ResolversTypes["WaffleSamplesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateWaffleSamplePayloadWaffleSampleEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateWaffleSwitchPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateWaffleSwitchPayload"] = ResolversParentTypes["CreateWaffleSwitchPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  waffleSwitch?: Resolver<
    Maybe<ResolversTypes["WaffleSwitch"]>,
    ParentType,
    ContextType
  >;
  waffleSwitchEdge?: Resolver<
    Maybe<ResolversTypes["WaffleSwitchesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateWaffleSwitchPayloadWaffleSwitchEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateWorkflowDatumPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateWorkflowDatumPayload"] = ResolversParentTypes["CreateWorkflowDatumPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowDatum?: Resolver<
    Maybe<ResolversTypes["WorkflowDatum"]>,
    ParentType,
    ContextType
  >;
  workflowDatumEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowDataEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateWorkflowDatumPayloadWorkflowDatumEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateWorkflowPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateWorkflowPayload"] = ResolversParentTypes["CreateWorkflowPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  containerImageByContainerId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  workflow?: Resolver<
    Maybe<ResolversTypes["Workflow"]>,
    ParentType,
    ContextType
  >;
  workflowEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateWorkflowPayloadWorkflowEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateWorkflowResultPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateWorkflowResultPayload"] = ResolversParentTypes["CreateWorkflowResultPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowDatumByObjectId?: Resolver<
    Maybe<ResolversTypes["WorkflowDatum"]>,
    ParentType,
    ContextType
  >;
  workflowResult?: Resolver<
    Maybe<ResolversTypes["WorkflowResult"]>,
    ParentType,
    ContextType
  >;
  workflowResultEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowResultsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateWorkflowResultPayloadWorkflowResultEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateWorkflowResultWorkflowVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateWorkflowResultWorkflowVersionPayload"] = ResolversParentTypes["CreateWorkflowResultWorkflowVersionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowResultByResultId?: Resolver<
    Maybe<ResolversTypes["WorkflowResult"]>,
    ParentType,
    ContextType
  >;
  workflowResultWorkflowVersion?: Resolver<
    Maybe<ResolversTypes["WorkflowResultWorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  workflowResultWorkflowVersionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowResultWorkflowVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateWorkflowResultWorkflowVersionPayloadWorkflowResultWorkflowVersionEdgeArgs,
      "orderBy"
    >
  >;
  workflowVersionByWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["WorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateWorkflowSectionBlockPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateWorkflowSectionBlockPayload"] = ResolversParentTypes["CreateWorkflowSectionBlockPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolVersionByToolId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  workflowDatumByObjectId?: Resolver<
    Maybe<ResolversTypes["WorkflowDatum"]>,
    ParentType,
    ContextType
  >;
  workflowSectionBlock?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlock"]>,
    ParentType,
    ContextType
  >;
  workflowSectionBlockEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlocksEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateWorkflowSectionBlockPayloadWorkflowSectionBlockEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateWorkflowSectionBlockSectionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateWorkflowSectionBlockSectionPayload"] = ResolversParentTypes["CreateWorkflowSectionBlockSectionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowSectionBlockByBlockId?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlock"]>,
    ParentType,
    ContextType
  >;
  workflowSectionBlockSection?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlockSection"]>,
    ParentType,
    ContextType
  >;
  workflowSectionBlockSectionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlockSectionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateWorkflowSectionBlockSectionPayloadWorkflowSectionBlockSectionEdgeArgs,
      "orderBy"
    >
  >;
  workflowSectionBySectionId?: Resolver<
    Maybe<ResolversTypes["WorkflowSection"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateWorkflowSectionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateWorkflowSectionPayload"] = ResolversParentTypes["CreateWorkflowSectionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowSection?: Resolver<
    Maybe<ResolversTypes["WorkflowSection"]>,
    ParentType,
    ContextType
  >;
  workflowSectionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateWorkflowSectionPayloadWorkflowSectionEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateWorkflowSectionWorkflowVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateWorkflowSectionWorkflowVersionPayload"] = ResolversParentTypes["CreateWorkflowSectionWorkflowVersionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowSectionBySectionId?: Resolver<
    Maybe<ResolversTypes["WorkflowSection"]>,
    ParentType,
    ContextType
  >;
  workflowSectionWorkflowVersion?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionWorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  workflowSectionWorkflowVersionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionWorkflowVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateWorkflowSectionWorkflowVersionPayloadWorkflowSectionWorkflowVersionEdgeArgs,
      "orderBy"
    >
  >;
  workflowVersionByWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["WorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateWorkflowSourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateWorkflowSourcePayload"] = ResolversParentTypes["CreateWorkflowSourcePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowSource?: Resolver<
    Maybe<ResolversTypes["WorkflowSource"]>,
    ParentType,
    ContextType
  >;
  workflowSourceEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<CreateWorkflowSourcePayloadWorkflowSourceEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateWorkflowSourceWorkflowVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateWorkflowSourceWorkflowVersionPayload"] = ResolversParentTypes["CreateWorkflowSourceWorkflowVersionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowSourceBySourceId?: Resolver<
    Maybe<ResolversTypes["WorkflowSource"]>,
    ParentType,
    ContextType
  >;
  workflowSourceWorkflowVersion?: Resolver<
    Maybe<ResolversTypes["WorkflowSourceWorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  workflowSourceWorkflowVersionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSourceWorkflowVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateWorkflowSourceWorkflowVersionPayloadWorkflowSourceWorkflowVersionEdgeArgs,
      "orderBy"
    >
  >;
  workflowVersionByWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["WorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateWorkflowVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CreateWorkflowVersionPayload"] = ResolversParentTypes["CreateWorkflowVersionPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowByWorkflowId?: Resolver<
    Maybe<ResolversTypes["Workflow"]>,
    ParentType,
    ContextType
  >;
  workflowVersion?: Resolver<
    Maybe<ResolversTypes["WorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  workflowVersionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      CreateWorkflowVersionPayloadWorkflowVersionEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentApplicationUserResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CurrentApplicationUser"] = ResolversParentTypes["CurrentApplicationUser"],
> = {
  email?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  globalUserId?: Resolver<
    Maybe<ResolversTypes["UUID"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  isActive?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  username?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentApplicationUsersConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CurrentApplicationUsersConnection"] = ResolversParentTypes["CurrentApplicationUsersConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["CurrentApplicationUsersEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["CurrentApplicationUser"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentApplicationUsersEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CurrentApplicationUsersEdge"] = ResolversParentTypes["CurrentApplicationUsersEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["CurrentApplicationUser"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentUserMembershipResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CurrentUserMembership"] = ResolversParentTypes["CurrentUserMembership"],
> = {
  role?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  tenantId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentUserMembershipsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CurrentUserMembershipsConnection"] = ResolversParentTypes["CurrentUserMembershipsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["CurrentUserMembershipsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["CurrentUserMembership"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentUserMembershipsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["CurrentUserMembershipsEdge"] = ResolversParentTypes["CurrentUserMembershipsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["CurrentUserMembership"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface CursorScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes["Cursor"], any> {
  name: "Cursor";
}

export type DataTableResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTable"] = ResolversParentTypes["DataTable"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  dataTableCellsByTableId?: Resolver<
    ResolversTypes["DataTableCellsConnection"],
    ParentType,
    ContextType,
    RequireFields<DataTableDataTableCellsByTableIdArgs, "orderBy">
  >;
  dataTableColumnGroupsByTableId?: Resolver<
    ResolversTypes["DataTableColumnGroupsConnection"],
    ParentType,
    ContextType,
    RequireFields<DataTableDataTableColumnGroupsByTableIdArgs, "orderBy">
  >;
  dataTableColumnsByTableId?: Resolver<
    ResolversTypes["DataTableColumnsConnection"],
    ParentType,
    ContextType,
    RequireFields<DataTableDataTableColumnsByTableIdArgs, "orderBy">
  >;
  dataTableRowsByTableId?: Resolver<
    ResolversTypes["DataTableRowsConnection"],
    ParentType,
    ContextType,
    RequireFields<DataTableDataTableRowsByTableIdArgs, "orderBy">
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  dateDeleted?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  description?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  folderId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  hidden?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectFolderByFolderId?: Resolver<
    Maybe<ResolversTypes["ProjectFolder"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableCellResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableCell"] = ResolversParentTypes["DataTableCell"],
> = {
  columnId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  dataTableByTableId?: Resolver<
    Maybe<ResolversTypes["DataTable"]>,
    ParentType,
    ContextType
  >;
  dataTableColumnByColumnId?: Resolver<
    Maybe<ResolversTypes["DataTableColumn"]>,
    ParentType,
    ContextType
  >;
  dataTableRowByRowId?: Resolver<
    Maybe<ResolversTypes["DataTableRow"]>,
    ParentType,
    ContextType
  >;
  formula?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  tableId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableCellsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableCellsConnection"] = ResolversParentTypes["DataTableCellsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableCellsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableCell"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableCellsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableCellsEdge"] = ResolversParentTypes["DataTableCellsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["DataTableCell"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumn"] = ResolversParentTypes["DataTableColumn"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  dataTableByTableId?: Resolver<
    Maybe<ResolversTypes["DataTable"]>,
    ParentType,
    ContextType
  >;
  dataTableCellsByColumnId?: Resolver<
    ResolversTypes["DataTableCellsConnection"],
    ParentType,
    ContextType,
    RequireFields<DataTableColumnDataTableCellsByColumnIdArgs, "orderBy">
  >;
  dataTableColumnGroupByGroupId?: Resolver<
    Maybe<ResolversTypes["DataTableColumnGroup"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  dateDeleted?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  defaultFormula?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  definitionId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  definitionTypeId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  deletable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  djangoContentTypeByDefinitionTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  editable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  groupId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  helpText?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  identifierPosition?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  isIdColumn?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  pinned?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  tableId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  width?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionBooleanResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionBoolean"] = ResolversParentTypes["DataTableColumnDefinitionBoolean"],
> = {
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionBooleansConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionBooleansConnection"] = ResolversParentTypes["DataTableColumnDefinitionBooleansConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionBooleansEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionBoolean"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionBooleansEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionBooleansEdge"] = ResolversParentTypes["DataTableColumnDefinitionBooleansEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DataTableColumnDefinitionBoolean"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionCellStatusResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionCellStatus"] = ResolversParentTypes["DataTableColumnDefinitionCellStatus"],
> = {
  cellSetFileColumnId?: Resolver<
    ResolversTypes["UUID"],
    ParentType,
    ContextType
  >;
  cellSetFileColumnTypeId?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  djangoContentTypeByCellSetFileColumnTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByEventSetFileColumnTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByQcReportFileColumnTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  eventSetFileColumnId?: Resolver<
    Maybe<ResolversTypes["UUID"]>,
    ParentType,
    ContextType
  >;
  eventSetFileColumnTypeId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  qcReportFileColumnId?: Resolver<
    Maybe<ResolversTypes["UUID"]>,
    ParentType,
    ContextType
  >;
  qcReportFileColumnTypeId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionCellStatusesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionCellStatusesConnection"] = ResolversParentTypes["DataTableColumnDefinitionCellStatusesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionCellStatusesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionCellStatus"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionCellStatusesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionCellStatusesEdge"] = ResolversParentTypes["DataTableColumnDefinitionCellStatusesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DataTableColumnDefinitionCellStatus"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionChoiceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionChoice"] = ResolversParentTypes["DataTableColumnDefinitionChoice"],
> = {
  choices?: Resolver<ResolversTypes["JSON"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionChoicesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionChoicesConnection"] = ResolversParentTypes["DataTableColumnDefinitionChoicesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionChoicesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionChoice"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionChoicesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionChoicesEdge"] = ResolversParentTypes["DataTableColumnDefinitionChoicesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DataTableColumnDefinitionChoice"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionDateResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionDate"] = ResolversParentTypes["DataTableColumnDefinitionDate"],
> = {
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionDatesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionDatesConnection"] = ResolversParentTypes["DataTableColumnDefinitionDatesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionDatesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionDate"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionDatesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionDatesEdge"] = ResolversParentTypes["DataTableColumnDefinitionDatesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DataTableColumnDefinitionDate"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionFileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionFile"] = ResolversParentTypes["DataTableColumnDefinitionFile"],
> = {
  fileFormats?: Resolver<
    Array<Maybe<ResolversTypes["String"]>>,
    ParentType,
    ContextType
  >;
  fileTypes?: Resolver<
    Array<Maybe<ResolversTypes["Int"]>>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  multiple?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionFilesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionFilesConnection"] = ResolversParentTypes["DataTableColumnDefinitionFilesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionFilesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionFile"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionFilesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionFilesEdge"] = ResolversParentTypes["DataTableColumnDefinitionFilesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DataTableColumnDefinitionFile"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionFloatResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionFloat"] = ResolversParentTypes["DataTableColumnDefinitionFloat"],
> = {
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionFloatsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionFloatsConnection"] = ResolversParentTypes["DataTableColumnDefinitionFloatsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionFloatsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionFloat"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionFloatsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionFloatsEdge"] = ResolversParentTypes["DataTableColumnDefinitionFloatsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DataTableColumnDefinitionFloat"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionIdentifierResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionIdentifier"] = ResolversParentTypes["DataTableColumnDefinitionIdentifier"],
> = {
  djangoContentTypeByTableTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  tableId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  tableTypeId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionIdentifiersConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionIdentifiersConnection"] = ResolversParentTypes["DataTableColumnDefinitionIdentifiersConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionIdentifiersEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionIdentifier"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionIdentifiersEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionIdentifiersEdge"] = ResolversParentTypes["DataTableColumnDefinitionIdentifiersEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DataTableColumnDefinitionIdentifier"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionIntegerResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionInteger"] = ResolversParentTypes["DataTableColumnDefinitionInteger"],
> = {
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes["BigInt"]>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes["BigInt"]>, ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionIntegersConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionIntegersConnection"] = ResolversParentTypes["DataTableColumnDefinitionIntegersConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionIntegersEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionInteger"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionIntegersEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionIntegersEdge"] = ResolversParentTypes["DataTableColumnDefinitionIntegersEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DataTableColumnDefinitionInteger"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionJoinResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionJoin"] = ResolversParentTypes["DataTableColumnDefinitionJoin"],
> = {
  djangoContentTypeByLeftColumnTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByRightColumnTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeBySourceColumnTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  leftColumnId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  leftColumnTypeId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  rightColumnId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  rightColumnTypeId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  sourceColumnId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  sourceColumnTypeId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionJoinsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionJoinsConnection"] = ResolversParentTypes["DataTableColumnDefinitionJoinsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionJoinsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionJoin"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionJoinsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionJoinsEdge"] = ResolversParentTypes["DataTableColumnDefinitionJoinsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DataTableColumnDefinitionJoin"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionMetadataConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionMetadataConnection"] = ResolversParentTypes["DataTableColumnDefinitionMetadataConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionMetadataEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionMetadatum"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionMetadataEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionMetadataEdge"] = ResolversParentTypes["DataTableColumnDefinitionMetadataEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DataTableColumnDefinitionMetadatum"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionMetadatumResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionMetadatum"] = ResolversParentTypes["DataTableColumnDefinitionMetadatum"],
> = {
  djangoContentTypeByFileColumnTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  fileColumnId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  fileColumnTypeId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  metadatumKey?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionRoiFrameResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionRoiFrame"] = ResolversParentTypes["DataTableColumnDefinitionRoiFrame"],
> = {
  boundingBox?: Resolver<
    Maybe<ResolversTypes["JSON"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByFileColumnTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  fileColumnId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  fileColumnTypeId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  groups?: Resolver<Maybe<ResolversTypes["JSON"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  overlap?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  sourceFileData?: Resolver<ResolversTypes["JSON"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionRoiFramesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionRoiFramesConnection"] = ResolversParentTypes["DataTableColumnDefinitionRoiFramesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionRoiFramesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionRoiFrame"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionRoiFramesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionRoiFramesEdge"] = ResolversParentTypes["DataTableColumnDefinitionRoiFramesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DataTableColumnDefinitionRoiFrame"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionTextResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionText"] = ResolversParentTypes["DataTableColumnDefinitionText"],
> = {
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  maxLength?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionTextsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionTextsConnection"] = ResolversParentTypes["DataTableColumnDefinitionTextsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionTextsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableColumnDefinitionText"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnDefinitionTextsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnDefinitionTextsEdge"] = ResolversParentTypes["DataTableColumnDefinitionTextsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DataTableColumnDefinitionText"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnGroupResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnGroup"] = ResolversParentTypes["DataTableColumnGroup"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  dataTableByTableId?: Resolver<
    Maybe<ResolversTypes["DataTable"]>,
    ParentType,
    ContextType
  >;
  dataTableColumnsByGroupId?: Resolver<
    ResolversTypes["DataTableColumnsConnection"],
    ParentType,
    ContextType,
    RequireFields<DataTableColumnGroupDataTableColumnsByGroupIdArgs, "orderBy">
  >;
  dateDeleted?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  definitionId?: Resolver<
    Maybe<ResolversTypes["UUID"]>,
    ParentType,
    ContextType
  >;
  definitionTypeId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByDefinitionTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  tableId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnGroupDefinitionJoinResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnGroupDefinitionJoin"] = ResolversParentTypes["DataTableColumnGroupDefinitionJoin"],
> = {
  djangoContentTypeByTableTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  tableId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  tableTypeId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnGroupDefinitionJoinsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnGroupDefinitionJoinsConnection"] = ResolversParentTypes["DataTableColumnGroupDefinitionJoinsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableColumnGroupDefinitionJoinsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableColumnGroupDefinitionJoin"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnGroupDefinitionJoinsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnGroupDefinitionJoinsEdge"] = ResolversParentTypes["DataTableColumnGroupDefinitionJoinsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DataTableColumnGroupDefinitionJoin"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnGroupDefinitionSourceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnGroupDefinitionSource"] = ResolversParentTypes["DataTableColumnGroupDefinitionSource"],
> = {
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnGroupDefinitionSourcesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnGroupDefinitionSourcesConnection"] = ResolversParentTypes["DataTableColumnGroupDefinitionSourcesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableColumnGroupDefinitionSourcesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableColumnGroupDefinitionSource"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnGroupDefinitionSourcesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnGroupDefinitionSourcesEdge"] = ResolversParentTypes["DataTableColumnGroupDefinitionSourcesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DataTableColumnGroupDefinitionSource"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnGroupsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnGroupsConnection"] = ResolversParentTypes["DataTableColumnGroupsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableColumnGroupsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableColumnGroup"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnGroupsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnGroupsEdge"] = ResolversParentTypes["DataTableColumnGroupsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DataTableColumnGroup"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnsConnection"] = ResolversParentTypes["DataTableColumnsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableColumnsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableColumn"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableColumnsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableColumnsEdge"] = ResolversParentTypes["DataTableColumnsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["DataTableColumn"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableRowResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableRow"] = ResolversParentTypes["DataTableRow"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  dataTableByTableId?: Resolver<
    Maybe<ResolversTypes["DataTable"]>,
    ParentType,
    ContextType
  >;
  dataTableCellsByRowId?: Resolver<
    ResolversTypes["DataTableCellsConnection"],
    ParentType,
    ContextType,
    RequireFields<DataTableRowDataTableCellsByRowIdArgs, "orderBy">
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  dateDeleted?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  editable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  index?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  joinable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  tableId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableRowsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableRowsConnection"] = ResolversParentTypes["DataTableRowsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTableRowsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DataTableRow"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTableRowsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTableRowsEdge"] = ResolversParentTypes["DataTableRowsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["DataTableRow"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTablesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTablesConnection"] = ResolversParentTypes["DataTablesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DataTablesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<Array<ResolversTypes["DataTable"]>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DataTablesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DataTablesEdge"] = ResolversParentTypes["DataTablesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["DataTable"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes["Date"], any> {
  name: "Date";
}

export interface DatetimeScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes["Datetime"], any> {
  name: "Datetime";
}

export type DeleteApplicationUserGroupPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteApplicationUserGroupPayload"] = ResolversParentTypes["DeleteApplicationUserGroupPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserGroup?: Resolver<
    Maybe<ResolversTypes["ApplicationUserGroup"]>,
    ParentType,
    ContextType
  >;
  applicationUserGroupEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUserGroupsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteApplicationUserGroupPayloadApplicationUserGroupEdgeArgs,
      "orderBy"
    >
  >;
  authGroupByGroupId?: Resolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedApplicationUserGroupId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteApplicationUserMembershipPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteApplicationUserMembershipPayload"] = ResolversParentTypes["DeleteApplicationUserMembershipPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserMembership?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMembership"]>,
    ParentType,
    ContextType
  >;
  applicationUserMembershipEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMembershipsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteApplicationUserMembershipPayloadApplicationUserMembershipEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedApplicationUserMembershipId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteApplicationUserMetadatumPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteApplicationUserMetadatumPayload"] = ResolversParentTypes["DeleteApplicationUserMetadatumPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserMetadatum?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMetadatum"]>,
    ParentType,
    ContextType
  >;
  applicationUserMetadatumEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMetadataEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteApplicationUserMetadatumPayloadApplicationUserMetadatumEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedApplicationUserMetadatumId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteApplicationUserPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteApplicationUserPayload"] = ResolversParentTypes["DeleteApplicationUserPayload"],
> = {
  applicationUser?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUsersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteApplicationUserPayloadApplicationUserEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedApplicationUserId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteApplicationUserSessionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteApplicationUserSessionPayload"] = ResolversParentTypes["DeleteApplicationUserSessionPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserSession?: Resolver<
    Maybe<ResolversTypes["ApplicationUserSession"]>,
    ParentType,
    ContextType
  >;
  applicationUserSessionEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUserSessionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteApplicationUserSessionPayloadApplicationUserSessionEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedApplicationUserSessionId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteApplicationUserUserPermissionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteApplicationUserUserPermissionPayload"] = ResolversParentTypes["DeleteApplicationUserUserPermissionPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserUserPermission?: Resolver<
    Maybe<ResolversTypes["ApplicationUserUserPermission"]>,
    ParentType,
    ContextType
  >;
  applicationUserUserPermissionEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUserUserPermissionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteApplicationUserUserPermissionPayloadApplicationUserUserPermissionEdgeArgs,
      "orderBy"
    >
  >;
  authPermissionByPermissionId?: Resolver<
    Maybe<ResolversTypes["AuthPermission"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedApplicationUserUserPermissionId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteAuditlogLogentryPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteAuditlogLogentryPayload"] = ResolversParentTypes["DeleteAuditlogLogentryPayload"],
> = {
  applicationUserByActorId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  auditlogLogentry?: Resolver<
    Maybe<ResolversTypes["AuditlogLogentry"]>,
    ParentType,
    ContextType
  >;
  auditlogLogentryEdge?: Resolver<
    Maybe<ResolversTypes["AuditlogLogentriesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteAuditlogLogentryPayloadAuditlogLogentryEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedAuditlogLogentryId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByContentTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteAuthGroupPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteAuthGroupPayload"] = ResolversParentTypes["DeleteAuthGroupPayload"],
> = {
  authGroup?: Resolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    ParentType,
    ContextType
  >;
  authGroupEdge?: Resolver<
    Maybe<ResolversTypes["AuthGroupsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteAuthGroupPayloadAuthGroupEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedAuthGroupId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteAuthGroupPermissionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteAuthGroupPermissionPayload"] = ResolversParentTypes["DeleteAuthGroupPermissionPayload"],
> = {
  authGroupByGroupId?: Resolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    ParentType,
    ContextType
  >;
  authGroupPermission?: Resolver<
    Maybe<ResolversTypes["AuthGroupPermission"]>,
    ParentType,
    ContextType
  >;
  authGroupPermissionEdge?: Resolver<
    Maybe<ResolversTypes["AuthGroupPermissionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteAuthGroupPermissionPayloadAuthGroupPermissionEdgeArgs,
      "orderBy"
    >
  >;
  authPermissionByPermissionId?: Resolver<
    Maybe<ResolversTypes["AuthPermission"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedAuthGroupPermissionId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteAuthPermissionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteAuthPermissionPayload"] = ResolversParentTypes["DeleteAuthPermissionPayload"],
> = {
  authPermission?: Resolver<
    Maybe<ResolversTypes["AuthPermission"]>,
    ParentType,
    ContextType
  >;
  authPermissionEdge?: Resolver<
    Maybe<ResolversTypes["AuthPermissionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteAuthPermissionPayloadAuthPermissionEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedAuthPermissionId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByContentTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteAvatarPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteAvatarPayload"] = ResolversParentTypes["DeleteAvatarPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  avatar?: Resolver<Maybe<ResolversTypes["Avatar"]>, ParentType, ContextType>;
  avatarEdge?: Resolver<
    Maybe<ResolversTypes["AvatarsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteAvatarPayloadAvatarEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedAvatarId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteAwsBatchTaskPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteAwsBatchTaskPayload"] = ResolversParentTypes["DeleteAwsBatchTaskPayload"],
> = {
  awsBatchTask?: Resolver<
    Maybe<ResolversTypes["AwsBatchTask"]>,
    ParentType,
    ContextType
  >;
  awsBatchTaskEdge?: Resolver<
    Maybe<ResolversTypes["AwsBatchTasksEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteAwsBatchTaskPayloadAwsBatchTaskEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedAwsBatchTaskId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesTaskexecutorByTaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteAwsCognitoUserPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteAwsCognitoUserPayload"] = ResolversParentTypes["DeleteAwsCognitoUserPayload"],
> = {
  awsCognitoUser?: Resolver<
    Maybe<ResolversTypes["AwsCognitoUser"]>,
    ParentType,
    ContextType
  >;
  awsCognitoUserEdge?: Resolver<
    Maybe<ResolversTypes["AwsCognitoUsersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteAwsCognitoUserPayloadAwsCognitoUserEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedAwsCognitoUserId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantUserexecutorByUserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TenantUserexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteAwsEcrImagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteAwsEcrImagePayload"] = ResolversParentTypes["DeleteAwsEcrImagePayload"],
> = {
  awsEcrImage?: Resolver<
    Maybe<ResolversTypes["AwsEcrImage"]>,
    ParentType,
    ContextType
  >;
  awsEcrImageEdge?: Resolver<
    Maybe<ResolversTypes["AwsEcrImagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteAwsEcrImagePayloadAwsEcrImageEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedAwsEcrImageId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesContainerimageexecutorByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteAwsMockBatchTaskPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteAwsMockBatchTaskPayload"] = ResolversParentTypes["DeleteAwsMockBatchTaskPayload"],
> = {
  awsBatchTaskByAwstaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsBatchTask"]>,
    ParentType,
    ContextType
  >;
  awsMockBatchTask?: Resolver<
    Maybe<ResolversTypes["AwsMockBatchTask"]>,
    ParentType,
    ContextType
  >;
  awsMockBatchTaskEdge?: Resolver<
    Maybe<ResolversTypes["AwsMockBatchTasksEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteAwsMockBatchTaskPayloadAwsMockBatchTaskEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedAwsMockBatchTaskId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteAwsMockDistributionImagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteAwsMockDistributionImagePayload"] = ResolversParentTypes["DeleteAwsMockDistributionImagePayload"],
> = {
  awsMockDistributionImage?: Resolver<
    Maybe<ResolversTypes["AwsMockDistributionImage"]>,
    ParentType,
    ContextType
  >;
  awsMockDistributionImageEdge?: Resolver<
    Maybe<ResolversTypes["AwsMockDistributionImagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteAwsMockDistributionImagePayloadAwsMockDistributionImageEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedAwsMockDistributionImageId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  distributionRegistryImageByDistributioncontainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DistributionRegistryImage"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteAwsMockEcrImagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteAwsMockEcrImagePayload"] = ResolversParentTypes["DeleteAwsMockEcrImagePayload"],
> = {
  awsEcrImageByAwscontainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsEcrImage"]>,
    ParentType,
    ContextType
  >;
  awsMockEcrImage?: Resolver<
    Maybe<ResolversTypes["AwsMockEcrImage"]>,
    ParentType,
    ContextType
  >;
  awsMockEcrImageEdge?: Resolver<
    Maybe<ResolversTypes["AwsMockEcrImagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteAwsMockEcrImagePayloadAwsMockEcrImageEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedAwsMockEcrImageId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteAwsMockIamUserPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteAwsMockIamUserPayload"] = ResolversParentTypes["DeleteAwsMockIamUserPayload"],
> = {
  awsCognitoUserByAwsuserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsCognitoUser"]>,
    ParentType,
    ContextType
  >;
  awsMockIamUser?: Resolver<
    Maybe<ResolversTypes["AwsMockIamUser"]>,
    ParentType,
    ContextType
  >;
  awsMockIamUserEdge?: Resolver<
    Maybe<ResolversTypes["AwsMockIamUsersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteAwsMockIamUserPayloadAwsMockIamUserEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedAwsMockIamUserId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteAwsMockS3FilePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteAwsMockS3FilePayload"] = ResolversParentTypes["DeleteAwsMockS3FilePayload"],
> = {
  awsMockS3File?: Resolver<
    Maybe<ResolversTypes["AwsMockS3File"]>,
    ParentType,
    ContextType
  >;
  awsMockS3FileEdge?: Resolver<
    Maybe<ResolversTypes["AwsMockS3FilesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteAwsMockS3FilePayloadAwsMockS3FileEdgeArgs, "orderBy">
  >;
  awsS3FileByAwsfileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsS3File"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedAwsMockS3FileId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteAwsS3FilePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteAwsS3FilePayload"] = ResolversParentTypes["DeleteAwsS3FilePayload"],
> = {
  awsS3File?: Resolver<
    Maybe<ResolversTypes["AwsS3File"]>,
    ParentType,
    ContextType
  >;
  awsS3FileEdge?: Resolver<
    Maybe<ResolversTypes["AwsS3FilesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteAwsS3FilePayloadAwsS3FileEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedAwsS3FileId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  drsFileexecutorByFileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutor"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteCodeFilePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteCodeFilePayload"] = ResolversParentTypes["DeleteCodeFilePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  codeFile?: Resolver<
    Maybe<ResolversTypes["CodeFile"]>,
    ParentType,
    ContextType
  >;
  codeFileBySeriesParentId?: Resolver<
    Maybe<ResolversTypes["CodeFile"]>,
    ParentType,
    ContextType
  >;
  codeFileEdge?: Resolver<
    Maybe<ResolversTypes["CodeFilesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteCodeFilePayloadCodeFileEdgeArgs, "orderBy">
  >;
  deletedCodeFileId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  drsFileexecutorByExecutorId?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutor"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteCommandPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteCommandPayload"] = ResolversParentTypes["DeleteCommandPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  codeFileByCodeFileId?: Resolver<
    Maybe<ResolversTypes["CodeFile"]>,
    ParentType,
    ContextType
  >;
  command?: Resolver<Maybe<ResolversTypes["Command"]>, ParentType, ContextType>;
  commandEdge?: Resolver<
    Maybe<ResolversTypes["CommandsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteCommandPayloadCommandEdgeArgs, "orderBy">
  >;
  containerImageByContainerImageId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  deletedCommandId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteContainerImagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteContainerImagePayload"] = ResolversParentTypes["DeleteContainerImagePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  containerImage?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  containerImageEdge?: Resolver<
    Maybe<ResolversTypes["ContainerImagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteContainerImagePayloadContainerImageEdgeArgs, "orderBy">
  >;
  containerImageRepositoryByContainerImageRepositoryId?: Resolver<
    Maybe<ResolversTypes["ContainerImageRepository"]>,
    ParentType,
    ContextType
  >;
  deletedContainerImageId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tesContainerimageexecutorByExecutorId?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteContainerImageRepositoryPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteContainerImageRepositoryPayload"] = ResolversParentTypes["DeleteContainerImageRepositoryPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  containerImageRepository?: Resolver<
    Maybe<ResolversTypes["ContainerImageRepository"]>,
    ParentType,
    ContextType
  >;
  containerImageRepositoryEdge?: Resolver<
    Maybe<ResolversTypes["ContainerImageRepositoriesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteContainerImageRepositoryPayloadContainerImageRepositoryEdgeArgs,
      "orderBy"
    >
  >;
  deletedContainerImageRepositoryId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteCostPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteCostPayload"] = ResolversParentTypes["DeleteCostPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  cost?: Resolver<Maybe<ResolversTypes["Cost"]>, ParentType, ContextType>;
  costEdge?: Resolver<
    Maybe<ResolversTypes["CostsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteCostPayloadCostEdgeArgs, "orderBy">
  >;
  deletedCostId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteDistributionRegistryImagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteDistributionRegistryImagePayload"] = ResolversParentTypes["DeleteDistributionRegistryImagePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedDistributionRegistryImageId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  distributionRegistryImage?: Resolver<
    Maybe<ResolversTypes["DistributionRegistryImage"]>,
    ParentType,
    ContextType
  >;
  distributionRegistryImageEdge?: Resolver<
    Maybe<ResolversTypes["DistributionRegistryImagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteDistributionRegistryImagePayloadDistributionRegistryImageEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesContainerimageexecutorByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteDjangoAdminLogPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteDjangoAdminLogPayload"] = ResolversParentTypes["DeleteDjangoAdminLogPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedDjangoAdminLogId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  djangoAdminLog?: Resolver<
    Maybe<ResolversTypes["DjangoAdminLog"]>,
    ParentType,
    ContextType
  >;
  djangoAdminLogEdge?: Resolver<
    Maybe<ResolversTypes["DjangoAdminLogsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteDjangoAdminLogPayloadDjangoAdminLogEdgeArgs, "orderBy">
  >;
  djangoContentTypeByContentTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteDjangoContentTypePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteDjangoContentTypePayload"] = ResolversParentTypes["DeleteDjangoContentTypePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedDjangoContentTypeId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  djangoContentType?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeEdge?: Resolver<
    Maybe<ResolversTypes["DjangoContentTypesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteDjangoContentTypePayloadDjangoContentTypeEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteDjangoMigrationPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteDjangoMigrationPayload"] = ResolversParentTypes["DeleteDjangoMigrationPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedDjangoMigrationId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  djangoMigration?: Resolver<
    Maybe<ResolversTypes["DjangoMigration"]>,
    ParentType,
    ContextType
  >;
  djangoMigrationEdge?: Resolver<
    Maybe<ResolversTypes["DjangoMigrationsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteDjangoMigrationPayloadDjangoMigrationEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteDjangoSesBlacklistedemailPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteDjangoSesBlacklistedemailPayload"] = ResolversParentTypes["DeleteDjangoSesBlacklistedemailPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedDjangoSesBlacklistedemailId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  djangoSesBlacklistedemail?: Resolver<
    Maybe<ResolversTypes["DjangoSesBlacklistedemail"]>,
    ParentType,
    ContextType
  >;
  djangoSesBlacklistedemailEdge?: Resolver<
    Maybe<ResolversTypes["DjangoSesBlacklistedemailsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteDjangoSesBlacklistedemailPayloadDjangoSesBlacklistedemailEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteDjangoSesSesstatPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteDjangoSesSesstatPayload"] = ResolversParentTypes["DeleteDjangoSesSesstatPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedDjangoSesSesstatId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  djangoSesSesstat?: Resolver<
    Maybe<ResolversTypes["DjangoSesSesstat"]>,
    ParentType,
    ContextType
  >;
  djangoSesSesstatEdge?: Resolver<
    Maybe<ResolversTypes["DjangoSesSesstatsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteDjangoSesSesstatPayloadDjangoSesSesstatEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteDjangoSessionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteDjangoSessionPayload"] = ResolversParentTypes["DeleteDjangoSessionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedDjangoSessionId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  djangoSession?: Resolver<
    Maybe<ResolversTypes["DjangoSession"]>,
    ParentType,
    ContextType
  >;
  djangoSessionEdge?: Resolver<
    Maybe<ResolversTypes["DjangoSessionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteDjangoSessionPayloadDjangoSessionEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteDrsFileexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteDrsFileexecutorPayload"] = ResolversParentTypes["DeleteDrsFileexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedDrsFileexecutorId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByPolymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  drsFileexecutor?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutor"]>,
    ParentType,
    ContextType
  >;
  drsFileexecutorEdge?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteDrsFileexecutorPayloadDrsFileexecutorEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteDrsMockfileexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteDrsMockfileexecutorPayload"] = ResolversParentTypes["DeleteDrsMockfileexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedDrsMockfileexecutorId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  drsFileexecutorByFileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutor"]>,
    ParentType,
    ContextType
  >;
  drsMockfileexecutor?: Resolver<
    Maybe<ResolversTypes["DrsMockfileexecutor"]>,
    ParentType,
    ContextType
  >;
  drsMockfileexecutorEdge?: Resolver<
    Maybe<ResolversTypes["DrsMockfileexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteDrsMockfileexecutorPayloadDrsMockfileexecutorEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteEulaVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteEulaVersionPayload"] = ResolversParentTypes["DeleteEulaVersionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedEulaVersionId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  eulaVersion?: Resolver<
    Maybe<ResolversTypes["EulaVersion"]>,
    ParentType,
    ContextType
  >;
  eulaVersionEdge?: Resolver<
    Maybe<ResolversTypes["EulaVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteEulaVersionPayloadEulaVersionEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteEulaVersionUserAcceptancePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteEulaVersionUserAcceptancePayload"] = ResolversParentTypes["DeleteEulaVersionUserAcceptancePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedEulaVersionUserAcceptanceId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  eulaVersionByEulaVersionId?: Resolver<
    Maybe<ResolversTypes["EulaVersion"]>,
    ParentType,
    ContextType
  >;
  eulaVersionUserAcceptance?: Resolver<
    Maybe<ResolversTypes["EulaVersionUserAcceptance"]>,
    ParentType,
    ContextType
  >;
  eulaVersionUserAcceptanceEdge?: Resolver<
    Maybe<ResolversTypes["EulaVersionUserAcceptancesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteEulaVersionUserAcceptancePayloadEulaVersionUserAcceptanceEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteFeatureFlagPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteFeatureFlagPayload"] = ResolversParentTypes["DeleteFeatureFlagPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedFeatureFlagId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  featureFlag?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType
  >;
  featureFlagEdge?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteFeatureFlagPayloadFeatureFlagEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteFeatureFlagsGroupPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteFeatureFlagsGroupPayload"] = ResolversParentTypes["DeleteFeatureFlagsGroupPayload"],
> = {
  authGroupByGroupId?: Resolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedFeatureFlagsGroupId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  featureFlagByFeatureflagId?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType
  >;
  featureFlagsGroup?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsGroup"]>,
    ParentType,
    ContextType
  >;
  featureFlagsGroupEdge?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsGroupsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteFeatureFlagsGroupPayloadFeatureFlagsGroupEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteFeatureFlagsTenantPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteFeatureFlagsTenantPayload"] = ResolversParentTypes["DeleteFeatureFlagsTenantPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedFeatureFlagsTenantId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  featureFlagByFeatureflagId?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType
  >;
  featureFlagsTenant?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsTenant"]>,
    ParentType,
    ContextType
  >;
  featureFlagsTenantEdge?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsTenantsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteFeatureFlagsTenantPayloadFeatureFlagsTenantEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteFeatureFlagsUserPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteFeatureFlagsUserPayload"] = ResolversParentTypes["DeleteFeatureFlagsUserPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedFeatureFlagsUserId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  featureFlagByFeatureflagId?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType
  >;
  featureFlagsUser?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsUser"]>,
    ParentType,
    ContextType
  >;
  featureFlagsUserEdge?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsUsersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteFeatureFlagsUserPayloadFeatureFlagsUserEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteFileActivityPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteFileActivityPayload"] = ResolversParentTypes["DeleteFileActivityPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  costByCostId?: Resolver<
    Maybe<ResolversTypes["Cost"]>,
    ParentType,
    ContextType
  >;
  deletedFileActivityId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByContentTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  fileActivity?: Resolver<
    Maybe<ResolversTypes["FileActivity"]>,
    ParentType,
    ContextType
  >;
  fileActivityEdge?: Resolver<
    Maybe<ResolversTypes["FileActivitiesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteFileActivityPayloadFileActivityEdgeArgs, "orderBy">
  >;
  fileByFileId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteFileMetadatumPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteFileMetadatumPayload"] = ResolversParentTypes["DeleteFileMetadatumPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedFileMetadatumId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  fileByFileId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  fileMetadatum?: Resolver<
    Maybe<ResolversTypes["FileMetadatum"]>,
    ParentType,
    ContextType
  >;
  fileMetadatumEdge?: Resolver<
    Maybe<ResolversTypes["FileMetadataEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteFileMetadatumPayloadFileMetadatumEdgeArgs, "orderBy">
  >;
  metadatumByMetadataId?: Resolver<
    Maybe<ResolversTypes["Metadatum"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteFileOutputGroupMetadatumPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteFileOutputGroupMetadatumPayload"] = ResolversParentTypes["DeleteFileOutputGroupMetadatumPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedFileOutputGroupMetadatumId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroupByFileOutputGroupId?: Resolver<
    Maybe<ResolversTypes["FileOutputGroup"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroupMetadatum?: Resolver<
    Maybe<ResolversTypes["FileOutputGroupMetadatum"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroupMetadatumEdge?: Resolver<
    Maybe<ResolversTypes["FileOutputGroupMetadataEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteFileOutputGroupMetadatumPayloadFileOutputGroupMetadatumEdgeArgs,
      "orderBy"
    >
  >;
  metadatumByMetadataId?: Resolver<
    Maybe<ResolversTypes["Metadatum"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteFileOutputGroupPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteFileOutputGroupPayload"] = ResolversParentTypes["DeleteFileOutputGroupPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedFileOutputGroupId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroup?: Resolver<
    Maybe<ResolversTypes["FileOutputGroup"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroupEdge?: Resolver<
    Maybe<ResolversTypes["FileOutputGroupsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteFileOutputGroupPayloadFileOutputGroupEdgeArgs,
      "orderBy"
    >
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteFilePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteFilePayload"] = ResolversParentTypes["DeleteFilePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedFileId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  file?: Resolver<Maybe<ResolversTypes["File"]>, ParentType, ContextType>;
  fileBySeriesParentId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  fileEdge?: Resolver<
    Maybe<ResolversTypes["FilesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteFilePayloadFileEdgeArgs, "orderBy">
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteMetadataValuePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteMetadataValuePayload"] = ResolversParentTypes["DeleteMetadataValuePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedMetadataValueId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  metadataValue?: Resolver<
    Maybe<ResolversTypes["MetadataValue"]>,
    ParentType,
    ContextType
  >;
  metadataValueEdge?: Resolver<
    Maybe<ResolversTypes["MetadataValuesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteMetadataValuePayloadMetadataValueEdgeArgs, "orderBy">
  >;
  metadatumByMetadataId?: Resolver<
    Maybe<ResolversTypes["Metadatum"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteMetadatumPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteMetadatumPayload"] = ResolversParentTypes["DeleteMetadatumPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedMetadatumId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  metadatum?: Resolver<
    Maybe<ResolversTypes["Metadatum"]>,
    ParentType,
    ContextType
  >;
  metadatumEdge?: Resolver<
    Maybe<ResolversTypes["MetadataEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteMetadatumPayloadMetadatumEdgeArgs, "orderBy">
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteOutputGroupFilePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteOutputGroupFilePayload"] = ResolversParentTypes["DeleteOutputGroupFilePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedOutputGroupFileId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  fileByFileId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroupByFileOutputGroupId?: Resolver<
    Maybe<ResolversTypes["FileOutputGroup"]>,
    ParentType,
    ContextType
  >;
  outputGroupFile?: Resolver<
    Maybe<ResolversTypes["OutputGroupFile"]>,
    ParentType,
    ContextType
  >;
  outputGroupFileEdge?: Resolver<
    Maybe<ResolversTypes["OutputGroupFilesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteOutputGroupFilePayloadOutputGroupFileEdgeArgs,
      "orderBy"
    >
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeletePinnedToolPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeletePinnedToolPayload"] = ResolversParentTypes["DeletePinnedToolPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedPinnedToolId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  pinnedTool?: Resolver<
    Maybe<ResolversTypes["PinnedTool"]>,
    ParentType,
    ContextType
  >;
  pinnedToolEdge?: Resolver<
    Maybe<ResolversTypes["PinnedToolsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeletePinnedToolPayloadPinnedToolEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolByToolId?: Resolver<
    Maybe<ResolversTypes["Tool"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteProjectFolderPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteProjectFolderPayload"] = ResolversParentTypes["DeleteProjectFolderPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedProjectFolderId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectFolder?: Resolver<
    Maybe<ResolversTypes["ProjectFolder"]>,
    ParentType,
    ContextType
  >;
  projectFolderEdge?: Resolver<
    Maybe<ResolversTypes["ProjectFoldersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteProjectFolderPayloadProjectFolderEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteProjectTagPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteProjectTagPayload"] = ResolversParentTypes["DeleteProjectTagPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedProjectTagId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectTag?: Resolver<
    Maybe<ResolversTypes["ProjectTag"]>,
    ParentType,
    ContextType
  >;
  projectTagEdge?: Resolver<
    Maybe<ResolversTypes["ProjectTagsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteProjectTagPayloadProjectTagEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteRunPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteRunPayload"] = ResolversParentTypes["DeleteRunPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedRunId?: Resolver<Maybe<ResolversTypes["ID"]>, ParentType, ContextType>;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  run?: Resolver<Maybe<ResolversTypes["Run"]>, ParentType, ContextType>;
  runEdge?: Resolver<
    Maybe<ResolversTypes["RunsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteRunPayloadRunEdgeArgs, "orderBy">
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteSessionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteSessionPayload"] = ResolversParentTypes["DeleteSessionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTaskActivityPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteTaskActivityPayload"] = ResolversParentTypes["DeleteTaskActivityPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  costByCostId?: Resolver<
    Maybe<ResolversTypes["Cost"]>,
    ParentType,
    ContextType
  >;
  deletedTaskActivityId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskActivity?: Resolver<
    Maybe<ResolversTypes["TaskActivity"]>,
    ParentType,
    ContextType
  >;
  taskActivityEdge?: Resolver<
    Maybe<ResolversTypes["TaskActivitiesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteTaskActivityPayloadTaskActivityEdgeArgs, "orderBy">
  >;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTaskPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteTaskPayload"] = ResolversParentTypes["DeleteTaskPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  containerImageByContainerImageId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  deletedTaskId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  task?: Resolver<Maybe<ResolversTypes["Task"]>, ParentType, ContextType>;
  taskEdge?: Resolver<
    Maybe<ResolversTypes["TasksEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteTaskPayloadTaskEdgeArgs, "orderBy">
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tesTaskexecutorByExecutorId?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutor"]>,
    ParentType,
    ContextType
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTaskResourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteTaskResourcePayload"] = ResolversParentTypes["DeleteTaskResourcePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedTaskResourceId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskResource?: Resolver<
    Maybe<ResolversTypes["TaskResource"]>,
    ParentType,
    ContextType
  >;
  taskResourceEdge?: Resolver<
    Maybe<ResolversTypes["TaskResourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteTaskResourcePayloadTaskResourceEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTaskResourceUsagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteTaskResourceUsagePayload"] = ResolversParentTypes["DeleteTaskResourceUsagePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedTaskResourceUsageId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskResourceUsage?: Resolver<
    Maybe<ResolversTypes["TaskResourceUsage"]>,
    ParentType,
    ContextType
  >;
  taskResourceUsageEdge?: Resolver<
    Maybe<ResolversTypes["TaskResourceUsagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteTaskResourceUsagePayloadTaskResourceUsageEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTaskSourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteTaskSourcePayload"] = ResolversParentTypes["DeleteTaskSourcePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedTaskSourceId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  fileByFileId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskSource?: Resolver<
    Maybe<ResolversTypes["TaskSource"]>,
    ParentType,
    ContextType
  >;
  taskSourceEdge?: Resolver<
    Maybe<ResolversTypes["TaskSourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteTaskSourcePayloadTaskSourceEdgeArgs, "orderBy">
  >;
  toolSourceByToolSourceId?: Resolver<
    Maybe<ResolversTypes["ToolSource"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTaskStatusLogPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteTaskStatusLogPayload"] = ResolversParentTypes["DeleteTaskStatusLogPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedTaskStatusLogId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskStatusLog?: Resolver<
    Maybe<ResolversTypes["TaskStatusLog"]>,
    ParentType,
    ContextType
  >;
  taskStatusLogEdge?: Resolver<
    Maybe<ResolversTypes["TaskStatusLogsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteTaskStatusLogPayloadTaskStatusLogEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTenantContractAllowancePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteTenantContractAllowancePayload"] = ResolversParentTypes["DeleteTenantContractAllowancePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedTenantContractAllowanceId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantContractAllowance?: Resolver<
    Maybe<ResolversTypes["TenantContractAllowance"]>,
    ParentType,
    ContextType
  >;
  tenantContractAllowanceEdge?: Resolver<
    Maybe<ResolversTypes["TenantContractAllowancesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteTenantContractAllowancePayloadTenantContractAllowanceEdgeArgs,
      "orderBy"
    >
  >;
  tenantContractTransactionByTenantContractTransactionId?: Resolver<
    Maybe<ResolversTypes["TenantContractTransaction"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTenantContractPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteTenantContractPayload"] = ResolversParentTypes["DeleteTenantContractPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedTenantContractId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantContract?: Resolver<
    Maybe<ResolversTypes["TenantContract"]>,
    ParentType,
    ContextType
  >;
  tenantContractEdge?: Resolver<
    Maybe<ResolversTypes["TenantContractsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteTenantContractPayloadTenantContractEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTenantContractTransactionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteTenantContractTransactionPayload"] = ResolversParentTypes["DeleteTenantContractTransactionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedTenantContractTransactionId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantContractByTenantContractId?: Resolver<
    Maybe<ResolversTypes["TenantContract"]>,
    ParentType,
    ContextType
  >;
  tenantContractTransaction?: Resolver<
    Maybe<ResolversTypes["TenantContractTransaction"]>,
    ParentType,
    ContextType
  >;
  tenantContractTransactionEdge?: Resolver<
    Maybe<ResolversTypes["TenantContractTransactionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteTenantContractTransactionPayloadTenantContractTransactionEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTenantMockuserexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteTenantMockuserexecutorPayload"] = ResolversParentTypes["DeleteTenantMockuserexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedTenantMockuserexecutorId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantMockuserexecutor?: Resolver<
    Maybe<ResolversTypes["TenantMockuserexecutor"]>,
    ParentType,
    ContextType
  >;
  tenantMockuserexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TenantMockuserexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteTenantMockuserexecutorPayloadTenantMockuserexecutorEdgeArgs,
      "orderBy"
    >
  >;
  tenantUserexecutorByUserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TenantUserexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTenantMonthlyConsumedResourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteTenantMonthlyConsumedResourcePayload"] = ResolversParentTypes["DeleteTenantMonthlyConsumedResourcePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedTenantMonthlyConsumedResourceId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantContractByTenantContractId?: Resolver<
    Maybe<ResolversTypes["TenantContract"]>,
    ParentType,
    ContextType
  >;
  tenantMonthlyConsumedResource?: Resolver<
    Maybe<ResolversTypes["TenantMonthlyConsumedResource"]>,
    ParentType,
    ContextType
  >;
  tenantMonthlyConsumedResourceEdge?: Resolver<
    Maybe<ResolversTypes["TenantMonthlyConsumedResourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteTenantMonthlyConsumedResourcePayloadTenantMonthlyConsumedResourceEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTenantPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteTenantPayload"] = ResolversParentTypes["DeleteTenantPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedTenantId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenant?: Resolver<Maybe<ResolversTypes["Tenant"]>, ParentType, ContextType>;
  tenantEdge?: Resolver<
    Maybe<ResolversTypes["TenantsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteTenantPayloadTenantEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTenantUserexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteTenantUserexecutorPayload"] = ResolversParentTypes["DeleteTenantUserexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedTenantUserexecutorId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByPolymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantUserexecutor?: Resolver<
    Maybe<ResolversTypes["TenantUserexecutor"]>,
    ParentType,
    ContextType
  >;
  tenantUserexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TenantUserexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteTenantUserexecutorPayloadTenantUserexecutorEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTesContainerimageexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteTesContainerimageexecutorPayload"] = ResolversParentTypes["DeleteTesContainerimageexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedTesContainerimageexecutorId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByPolymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesContainerimageexecutor?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  tesContainerimageexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteTesContainerimageexecutorPayloadTesContainerimageexecutorEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTesMockcontainerimageexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteTesMockcontainerimageexecutorPayload"] = ResolversParentTypes["DeleteTesMockcontainerimageexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedTesMockcontainerimageexecutorId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesContainerimageexecutorByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  tesMockcontainerimageexecutor?: Resolver<
    Maybe<ResolversTypes["TesMockcontainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  tesMockcontainerimageexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TesMockcontainerimageexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteTesMockcontainerimageexecutorPayloadTesMockcontainerimageexecutorEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTesMocktaskexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteTesMocktaskexecutorPayload"] = ResolversParentTypes["DeleteTesMocktaskexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedTesMocktaskexecutorId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesMocktaskexecutor?: Resolver<
    Maybe<ResolversTypes["TesMocktaskexecutor"]>,
    ParentType,
    ContextType
  >;
  tesMocktaskexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TesMocktaskexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteTesMocktaskexecutorPayloadTesMocktaskexecutorEdgeArgs,
      "orderBy"
    >
  >;
  tesTaskexecutorByTaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteTesTaskexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteTesTaskexecutorPayload"] = ResolversParentTypes["DeleteTesTaskexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedTesTaskexecutorId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByPolymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesTaskexecutor?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutor"]>,
    ParentType,
    ContextType
  >;
  tesTaskexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteTesTaskexecutorPayloadTesTaskexecutorEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolParameterPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteToolParameterPayload"] = ResolversParentTypes["DeleteToolParameterPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedToolParameterId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolParameter?: Resolver<
    Maybe<ResolversTypes["ToolParameter"]>,
    ParentType,
    ContextType
  >;
  toolParameterEdge?: Resolver<
    Maybe<ResolversTypes["ToolParametersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteToolParameterPayloadToolParameterEdgeArgs, "orderBy">
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteToolPayload"] = ResolversParentTypes["DeleteToolPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedToolId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tool?: Resolver<Maybe<ResolversTypes["Tool"]>, ParentType, ContextType>;
  toolEdge?: Resolver<
    Maybe<ResolversTypes["ToolsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteToolPayloadToolEdgeArgs, "orderBy">
  >;
  toolboxByToolboxId?: Resolver<
    Maybe<ResolversTypes["Toolbox"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolResourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteToolResourcePayload"] = ResolversParentTypes["DeleteToolResourcePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedToolResourceId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolResource?: Resolver<
    Maybe<ResolversTypes["ToolResource"]>,
    ParentType,
    ContextType
  >;
  toolResourceEdge?: Resolver<
    Maybe<ResolversTypes["ToolResourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteToolResourcePayloadToolResourceEdgeArgs, "orderBy">
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolResultPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteToolResultPayload"] = ResolversParentTypes["DeleteToolResultPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedToolResultId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolResult?: Resolver<
    Maybe<ResolversTypes["ToolResult"]>,
    ParentType,
    ContextType
  >;
  toolResultEdge?: Resolver<
    Maybe<ResolversTypes["ToolResultsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteToolResultPayloadToolResultEdgeArgs, "orderBy">
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolSecretPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteToolSecretPayload"] = ResolversParentTypes["DeleteToolSecretPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedToolSecretId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolSecret?: Resolver<
    Maybe<ResolversTypes["ToolSecret"]>,
    ParentType,
    ContextType
  >;
  toolSecretEdge?: Resolver<
    Maybe<ResolversTypes["ToolSecretsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteToolSecretPayloadToolSecretEdgeArgs, "orderBy">
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolSourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteToolSourcePayload"] = ResolversParentTypes["DeleteToolSourcePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedToolSourceId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolSource?: Resolver<
    Maybe<ResolversTypes["ToolSource"]>,
    ParentType,
    ContextType
  >;
  toolSourceEdge?: Resolver<
    Maybe<ResolversTypes["ToolSourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteToolSourcePayloadToolSourceEdgeArgs, "orderBy">
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolTenantPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteToolTenantPayload"] = ResolversParentTypes["DeleteToolTenantPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedToolTenantId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  toolByToolId?: Resolver<
    Maybe<ResolversTypes["Tool"]>,
    ParentType,
    ContextType
  >;
  toolTenant?: Resolver<
    Maybe<ResolversTypes["ToolTenant"]>,
    ParentType,
    ContextType
  >;
  toolTenantEdge?: Resolver<
    Maybe<ResolversTypes["ToolTenantsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteToolTenantPayloadToolTenantEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteToolVersionPayload"] = ResolversParentTypes["DeleteToolVersionPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  containerImageByContainerImageId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  deletedToolVersionId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  toolByToolId?: Resolver<
    Maybe<ResolversTypes["Tool"]>,
    ParentType,
    ContextType
  >;
  toolVersion?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  toolVersionEdge?: Resolver<
    Maybe<ResolversTypes["ToolVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteToolVersionPayloadToolVersionEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolboxPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteToolboxPayload"] = ResolversParentTypes["DeleteToolboxPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedToolboxId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolbox?: Resolver<Maybe<ResolversTypes["Toolbox"]>, ParentType, ContextType>;
  toolboxEdge?: Resolver<
    Maybe<ResolversTypes["ToolboxesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteToolboxPayloadToolboxEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolboxTenantPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteToolboxTenantPayload"] = ResolversParentTypes["DeleteToolboxTenantPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedToolboxTenantId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  toolboxByToolboxId?: Resolver<
    Maybe<ResolversTypes["Toolbox"]>,
    ParentType,
    ContextType
  >;
  toolboxTenant?: Resolver<
    Maybe<ResolversTypes["ToolboxTenant"]>,
    ParentType,
    ContextType
  >;
  toolboxTenantEdge?: Resolver<
    Maybe<ResolversTypes["ToolboxTenantsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteToolboxTenantPayloadToolboxTenantEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteUserPersonalSpaceRequestPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteUserPersonalSpaceRequestPayload"] = ResolversParentTypes["DeleteUserPersonalSpaceRequestPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedUserPersonalSpaceRequestId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  userPersonalSpaceRequest?: Resolver<
    Maybe<ResolversTypes["UserPersonalSpaceRequest"]>,
    ParentType,
    ContextType
  >;
  userPersonalSpaceRequestEdge?: Resolver<
    Maybe<ResolversTypes["UserPersonalSpaceRequestsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteUserPersonalSpaceRequestPayloadUserPersonalSpaceRequestEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteWaffleFlagPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteWaffleFlagPayload"] = ResolversParentTypes["DeleteWaffleFlagPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedWaffleFlagId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  waffleFlag?: Resolver<
    Maybe<ResolversTypes["WaffleFlag"]>,
    ParentType,
    ContextType
  >;
  waffleFlagEdge?: Resolver<
    Maybe<ResolversTypes["WaffleFlagsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteWaffleFlagPayloadWaffleFlagEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteWaffleSamplePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteWaffleSamplePayload"] = ResolversParentTypes["DeleteWaffleSamplePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedWaffleSampleId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  waffleSample?: Resolver<
    Maybe<ResolversTypes["WaffleSample"]>,
    ParentType,
    ContextType
  >;
  waffleSampleEdge?: Resolver<
    Maybe<ResolversTypes["WaffleSamplesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteWaffleSamplePayloadWaffleSampleEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteWaffleSwitchPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteWaffleSwitchPayload"] = ResolversParentTypes["DeleteWaffleSwitchPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedWaffleSwitchId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  waffleSwitch?: Resolver<
    Maybe<ResolversTypes["WaffleSwitch"]>,
    ParentType,
    ContextType
  >;
  waffleSwitchEdge?: Resolver<
    Maybe<ResolversTypes["WaffleSwitchesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteWaffleSwitchPayloadWaffleSwitchEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteWorkflowDatumPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteWorkflowDatumPayload"] = ResolversParentTypes["DeleteWorkflowDatumPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedWorkflowDatumId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowDatum?: Resolver<
    Maybe<ResolversTypes["WorkflowDatum"]>,
    ParentType,
    ContextType
  >;
  workflowDatumEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowDataEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteWorkflowDatumPayloadWorkflowDatumEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteWorkflowPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteWorkflowPayload"] = ResolversParentTypes["DeleteWorkflowPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  containerImageByContainerId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  deletedWorkflowId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  workflow?: Resolver<
    Maybe<ResolversTypes["Workflow"]>,
    ParentType,
    ContextType
  >;
  workflowEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteWorkflowPayloadWorkflowEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteWorkflowResultPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteWorkflowResultPayload"] = ResolversParentTypes["DeleteWorkflowResultPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedWorkflowResultId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowDatumByObjectId?: Resolver<
    Maybe<ResolversTypes["WorkflowDatum"]>,
    ParentType,
    ContextType
  >;
  workflowResult?: Resolver<
    Maybe<ResolversTypes["WorkflowResult"]>,
    ParentType,
    ContextType
  >;
  workflowResultEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowResultsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteWorkflowResultPayloadWorkflowResultEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteWorkflowResultWorkflowVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteWorkflowResultWorkflowVersionPayload"] = ResolversParentTypes["DeleteWorkflowResultWorkflowVersionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedWorkflowResultWorkflowVersionId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowResultByResultId?: Resolver<
    Maybe<ResolversTypes["WorkflowResult"]>,
    ParentType,
    ContextType
  >;
  workflowResultWorkflowVersion?: Resolver<
    Maybe<ResolversTypes["WorkflowResultWorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  workflowResultWorkflowVersionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowResultWorkflowVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteWorkflowResultWorkflowVersionPayloadWorkflowResultWorkflowVersionEdgeArgs,
      "orderBy"
    >
  >;
  workflowVersionByWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["WorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteWorkflowSectionBlockPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteWorkflowSectionBlockPayload"] = ResolversParentTypes["DeleteWorkflowSectionBlockPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedWorkflowSectionBlockId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolVersionByToolId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  workflowDatumByObjectId?: Resolver<
    Maybe<ResolversTypes["WorkflowDatum"]>,
    ParentType,
    ContextType
  >;
  workflowSectionBlock?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlock"]>,
    ParentType,
    ContextType
  >;
  workflowSectionBlockEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlocksEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteWorkflowSectionBlockPayloadWorkflowSectionBlockEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteWorkflowSectionBlockSectionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteWorkflowSectionBlockSectionPayload"] = ResolversParentTypes["DeleteWorkflowSectionBlockSectionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedWorkflowSectionBlockSectionId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowSectionBlockByBlockId?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlock"]>,
    ParentType,
    ContextType
  >;
  workflowSectionBlockSection?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlockSection"]>,
    ParentType,
    ContextType
  >;
  workflowSectionBlockSectionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlockSectionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteWorkflowSectionBlockSectionPayloadWorkflowSectionBlockSectionEdgeArgs,
      "orderBy"
    >
  >;
  workflowSectionBySectionId?: Resolver<
    Maybe<ResolversTypes["WorkflowSection"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteWorkflowSectionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteWorkflowSectionPayload"] = ResolversParentTypes["DeleteWorkflowSectionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedWorkflowSectionId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowSection?: Resolver<
    Maybe<ResolversTypes["WorkflowSection"]>,
    ParentType,
    ContextType
  >;
  workflowSectionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteWorkflowSectionPayloadWorkflowSectionEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteWorkflowSectionWorkflowVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteWorkflowSectionWorkflowVersionPayload"] = ResolversParentTypes["DeleteWorkflowSectionWorkflowVersionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedWorkflowSectionWorkflowVersionId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowSectionBySectionId?: Resolver<
    Maybe<ResolversTypes["WorkflowSection"]>,
    ParentType,
    ContextType
  >;
  workflowSectionWorkflowVersion?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionWorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  workflowSectionWorkflowVersionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionWorkflowVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteWorkflowSectionWorkflowVersionPayloadWorkflowSectionWorkflowVersionEdgeArgs,
      "orderBy"
    >
  >;
  workflowVersionByWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["WorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteWorkflowSourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteWorkflowSourcePayload"] = ResolversParentTypes["DeleteWorkflowSourcePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedWorkflowSourceId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowSource?: Resolver<
    Maybe<ResolversTypes["WorkflowSource"]>,
    ParentType,
    ContextType
  >;
  workflowSourceEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<DeleteWorkflowSourcePayloadWorkflowSourceEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteWorkflowSourceWorkflowVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteWorkflowSourceWorkflowVersionPayload"] = ResolversParentTypes["DeleteWorkflowSourceWorkflowVersionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedWorkflowSourceWorkflowVersionId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowSourceBySourceId?: Resolver<
    Maybe<ResolversTypes["WorkflowSource"]>,
    ParentType,
    ContextType
  >;
  workflowSourceWorkflowVersion?: Resolver<
    Maybe<ResolversTypes["WorkflowSourceWorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  workflowSourceWorkflowVersionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSourceWorkflowVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteWorkflowSourceWorkflowVersionPayloadWorkflowSourceWorkflowVersionEdgeArgs,
      "orderBy"
    >
  >;
  workflowVersionByWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["WorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteWorkflowVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DeleteWorkflowVersionPayload"] = ResolversParentTypes["DeleteWorkflowVersionPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  deletedWorkflowVersionId?: Resolver<
    Maybe<ResolversTypes["ID"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowByWorkflowId?: Resolver<
    Maybe<ResolversTypes["Workflow"]>,
    ParentType,
    ContextType
  >;
  workflowVersion?: Resolver<
    Maybe<ResolversTypes["WorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  workflowVersionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      DeleteWorkflowVersionPayloadWorkflowVersionEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DistributionRegistryImageResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DistributionRegistryImage"] = ResolversParentTypes["DistributionRegistryImage"],
> = {
  awsMockDistributionImageByDistributioncontainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsMockDistributionImage"]>,
    ParentType,
    ContextType
  >;
  awsMockDistributionImagesByDistributioncontainerimageexecutorPtrId?: Resolver<
    ResolversTypes["AwsMockDistributionImagesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DistributionRegistryImageAwsMockDistributionImagesByDistributioncontainerimageexecutorPtrIdArgs,
      "orderBy"
    >
  >;
  containerimageexecutorPtrId?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  jobDefinitionName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  jobDefinitionRevision?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  tesContainerimageexecutorByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DistributionRegistryImagesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DistributionRegistryImagesConnection"] = ResolversParentTypes["DistributionRegistryImagesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DistributionRegistryImagesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DistributionRegistryImage"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DistributionRegistryImagesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DistributionRegistryImagesEdge"] = ResolversParentTypes["DistributionRegistryImagesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DistributionRegistryImage"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoAdminLogResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoAdminLog"] = ResolversParentTypes["DjangoAdminLog"],
> = {
  actionFlag?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  actionTime?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  changeMessage?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  contentTypeId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByContentTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  objectRepr?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoAdminLogsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoAdminLogsConnection"] = ResolversParentTypes["DjangoAdminLogsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DjangoAdminLogsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DjangoAdminLog"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoAdminLogsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoAdminLogsEdge"] = ResolversParentTypes["DjangoAdminLogsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["DjangoAdminLog"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoContentTypeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoContentType"] = ResolversParentTypes["DjangoContentType"],
> = {
  appLabel?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  auditlogLogentriesByContentTypeId?: Resolver<
    ResolversTypes["AuditlogLogentriesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeAuditlogLogentriesByContentTypeIdArgs,
      "orderBy"
    >
  >;
  authPermissionsByContentTypeId?: Resolver<
    ResolversTypes["AuthPermissionsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeAuthPermissionsByContentTypeIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionCellStatusesByCellSetFileColumnTypeId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionCellStatusesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeDataTableColumnDefinitionCellStatusesByCellSetFileColumnTypeIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionCellStatusesByEventSetFileColumnTypeId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionCellStatusesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeDataTableColumnDefinitionCellStatusesByEventSetFileColumnTypeIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionCellStatusesByQcReportFileColumnTypeId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionCellStatusesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeDataTableColumnDefinitionCellStatusesByQcReportFileColumnTypeIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionIdentifiersByTableTypeId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionIdentifiersConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeDataTableColumnDefinitionIdentifiersByTableTypeIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionJoinsByLeftColumnTypeId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionJoinsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeDataTableColumnDefinitionJoinsByLeftColumnTypeIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionJoinsByRightColumnTypeId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionJoinsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeDataTableColumnDefinitionJoinsByRightColumnTypeIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionJoinsBySourceColumnTypeId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionJoinsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeDataTableColumnDefinitionJoinsBySourceColumnTypeIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionMetadataByFileColumnTypeId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionMetadataConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeDataTableColumnDefinitionMetadataByFileColumnTypeIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionRoiFramesByFileColumnTypeId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionRoiFramesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeDataTableColumnDefinitionRoiFramesByFileColumnTypeIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnGroupDefinitionJoinsByTableTypeId?: Resolver<
    ResolversTypes["DataTableColumnGroupDefinitionJoinsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeDataTableColumnGroupDefinitionJoinsByTableTypeIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnGroupsByDefinitionTypeId?: Resolver<
    ResolversTypes["DataTableColumnGroupsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeDataTableColumnGroupsByDefinitionTypeIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnsByDefinitionTypeId?: Resolver<
    ResolversTypes["DataTableColumnsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeDataTableColumnsByDefinitionTypeIdArgs,
      "orderBy"
    >
  >;
  djangoAdminLogsByContentTypeId?: Resolver<
    ResolversTypes["DjangoAdminLogsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeDjangoAdminLogsByContentTypeIdArgs,
      "orderBy"
    >
  >;
  drsFileexecutorsByPolymorphicCtypeId?: Resolver<
    ResolversTypes["DrsFileexecutorsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeDrsFileexecutorsByPolymorphicCtypeIdArgs,
      "orderBy"
    >
  >;
  fileActivitiesByContentTypeId?: Resolver<
    ResolversTypes["FileActivitiesConnection"],
    ParentType,
    ContextType,
    RequireFields<DjangoContentTypeFileActivitiesByContentTypeIdArgs, "orderBy">
  >;
  gdtAnalysisTableColumnGroupsByDefinitionTypeId?: Resolver<
    ResolversTypes["GdtAnalysisTableColumnGroupsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeGdtAnalysisTableColumnGroupsByDefinitionTypeIdArgs,
      "orderBy"
    >
  >;
  gdtAnalysisTableColumnsByDefinitionTypeId?: Resolver<
    ResolversTypes["GdtAnalysisTableColumnsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeGdtAnalysisTableColumnsByDefinitionTypeIdArgs,
      "orderBy"
    >
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  model?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  tenantUserexecutorsByPolymorphicCtypeId?: Resolver<
    ResolversTypes["TenantUserexecutorsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeTenantUserexecutorsByPolymorphicCtypeIdArgs,
      "orderBy"
    >
  >;
  tesContainerimageexecutorsByPolymorphicCtypeId?: Resolver<
    ResolversTypes["TesContainerimageexecutorsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeTesContainerimageexecutorsByPolymorphicCtypeIdArgs,
      "orderBy"
    >
  >;
  tesTaskexecutorsByPolymorphicCtypeId?: Resolver<
    ResolversTypes["TesTaskexecutorsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DjangoContentTypeTesTaskexecutorsByPolymorphicCtypeIdArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoContentTypesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoContentTypesConnection"] = ResolversParentTypes["DjangoContentTypesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DjangoContentTypesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoContentTypesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoContentTypesEdge"] = ResolversParentTypes["DjangoContentTypesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["DjangoContentType"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoMigrationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoMigration"] = ResolversParentTypes["DjangoMigration"],
> = {
  app?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  applied?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoMigrationsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoMigrationsConnection"] = ResolversParentTypes["DjangoMigrationsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DjangoMigrationsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DjangoMigration"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoMigrationsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoMigrationsEdge"] = ResolversParentTypes["DjangoMigrationsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["DjangoMigration"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoSesBlacklistedemailResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoSesBlacklistedemail"] = ResolversParentTypes["DjangoSesBlacklistedemail"],
> = {
  email?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoSesBlacklistedemailsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoSesBlacklistedemailsConnection"] = ResolversParentTypes["DjangoSesBlacklistedemailsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DjangoSesBlacklistedemailsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DjangoSesBlacklistedemail"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoSesBlacklistedemailsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoSesBlacklistedemailsEdge"] = ResolversParentTypes["DjangoSesBlacklistedemailsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DjangoSesBlacklistedemail"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoSesSesstatResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoSesSesstat"] = ResolversParentTypes["DjangoSesSesstat"],
> = {
  bounces?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  complaints?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  date?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
  deliveryAttempts?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  rejects?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoSesSesstatsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoSesSesstatsConnection"] = ResolversParentTypes["DjangoSesSesstatsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DjangoSesSesstatsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DjangoSesSesstat"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoSesSesstatsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoSesSesstatsEdge"] = ResolversParentTypes["DjangoSesSesstatsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["DjangoSesSesstat"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoSessionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoSession"] = ResolversParentTypes["DjangoSession"],
> = {
  expireDate?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  sessionData?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  sessionKey?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoSessionsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoSessionsConnection"] = ResolversParentTypes["DjangoSessionsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DjangoSessionsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DjangoSession"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DjangoSessionsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DjangoSessionsEdge"] = ResolversParentTypes["DjangoSessionsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["DjangoSession"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DrsFileexecutorResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DrsFileexecutor"] = ResolversParentTypes["DrsFileexecutor"],
> = {
  awsS3FileByFileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsS3File"]>,
    ParentType,
    ContextType
  >;
  awsS3FilesByFileexecutorPtrId?: Resolver<
    ResolversTypes["AwsS3FilesConnection"],
    ParentType,
    ContextType,
    RequireFields<DrsFileexecutorAwsS3FilesByFileexecutorPtrIdArgs, "orderBy">
  >;
  codeFilesByExecutorId?: Resolver<
    ResolversTypes["CodeFilesConnection"],
    ParentType,
    ContextType,
    RequireFields<DrsFileexecutorCodeFilesByExecutorIdArgs, "orderBy">
  >;
  djangoContentTypeByPolymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  drsMockfileexecutorByFileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DrsMockfileexecutor"]>,
    ParentType,
    ContextType
  >;
  drsMockfileexecutorsByFileexecutorPtrId?: Resolver<
    ResolversTypes["DrsMockfileexecutorsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      DrsFileexecutorDrsMockfileexecutorsByFileexecutorPtrIdArgs,
      "orderBy"
    >
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  polymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DrsFileexecutorsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DrsFileexecutorsConnection"] = ResolversParentTypes["DrsFileexecutorsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DrsFileexecutorsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DrsFileexecutor"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DrsFileexecutorsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DrsFileexecutorsEdge"] = ResolversParentTypes["DrsFileexecutorsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["DrsFileexecutor"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DrsMockfileexecutorResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DrsMockfileexecutor"] = ResolversParentTypes["DrsMockfileexecutor"],
> = {
  drsFileexecutorByFileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutor"]>,
    ParentType,
    ContextType
  >;
  fileexecutorPtrId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DrsMockfileexecutorsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DrsMockfileexecutorsConnection"] = ResolversParentTypes["DrsMockfileexecutorsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["DrsMockfileexecutorsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["DrsMockfileexecutor"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DrsMockfileexecutorsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["DrsMockfileexecutorsEdge"] = ResolversParentTypes["DrsMockfileexecutorsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["DrsMockfileexecutor"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EulaVersionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EulaVersion"] = ResolversParentTypes["EulaVersion"],
> = {
  content?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  dateVersion?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  eulaVersionUserAcceptancesByEulaVersionId?: Resolver<
    ResolversTypes["EulaVersionUserAcceptancesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      EulaVersionEulaVersionUserAcceptancesByEulaVersionIdArgs,
      "orderBy"
    >
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  version?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EulaVersionUserAcceptanceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EulaVersionUserAcceptance"] = ResolversParentTypes["EulaVersionUserAcceptance"],
> = {
  accepted?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  dateReviewed?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  eulaVersionByEulaVersionId?: Resolver<
    Maybe<ResolversTypes["EulaVersion"]>,
    ParentType,
    ContextType
  >;
  eulaVersionId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EulaVersionUserAcceptancesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EulaVersionUserAcceptancesConnection"] = ResolversParentTypes["EulaVersionUserAcceptancesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["EulaVersionUserAcceptancesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["EulaVersionUserAcceptance"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EulaVersionUserAcceptancesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EulaVersionUserAcceptancesEdge"] = ResolversParentTypes["EulaVersionUserAcceptancesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["EulaVersionUserAcceptance"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EulaVersionsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EulaVersionsConnection"] = ResolversParentTypes["EulaVersionsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["EulaVersionsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["EulaVersion"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EulaVersionsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["EulaVersionsEdge"] = ResolversParentTypes["EulaVersionsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["EulaVersion"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FeatureFlag"] = ResolversParentTypes["FeatureFlag"],
> = {
  authenticated?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  created?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  everyone?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  featureFlagsGroupsByFeatureflagId?: Resolver<
    ResolversTypes["FeatureFlagsGroupsConnection"],
    ParentType,
    ContextType,
    RequireFields<FeatureFlagFeatureFlagsGroupsByFeatureflagIdArgs, "orderBy">
  >;
  featureFlagsTenantsByFeatureflagId?: Resolver<
    ResolversTypes["FeatureFlagsTenantsConnection"],
    ParentType,
    ContextType,
    RequireFields<FeatureFlagFeatureFlagsTenantsByFeatureflagIdArgs, "orderBy">
  >;
  featureFlagsUsersByFeatureflagId?: Resolver<
    ResolversTypes["FeatureFlagsUsersConnection"],
    ParentType,
    ContextType,
    RequireFields<FeatureFlagFeatureFlagsUsersByFeatureflagIdArgs, "orderBy">
  >;
  id?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  languages?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  modified?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  note?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  percent?: Resolver<
    Maybe<ResolversTypes["BigFloat"]>,
    ParentType,
    ContextType
  >;
  rollout?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  staff?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  superusers?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  testing?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FeatureFlagsConnection"] = ResolversParentTypes["FeatureFlagsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["FeatureFlagsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FeatureFlagsEdge"] = ResolversParentTypes["FeatureFlagsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["FeatureFlag"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagsGroupResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FeatureFlagsGroup"] = ResolversParentTypes["FeatureFlagsGroup"],
> = {
  authGroupByGroupId?: Resolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    ParentType,
    ContextType
  >;
  featureFlagByFeatureflagId?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType
  >;
  featureflagId?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  groupId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagsGroupsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FeatureFlagsGroupsConnection"] = ResolversParentTypes["FeatureFlagsGroupsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["FeatureFlagsGroupsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["FeatureFlagsGroup"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagsGroupsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FeatureFlagsGroupsEdge"] = ResolversParentTypes["FeatureFlagsGroupsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["FeatureFlagsGroup"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagsTenantResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FeatureFlagsTenant"] = ResolversParentTypes["FeatureFlagsTenant"],
> = {
  featureFlagByFeatureflagId?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType
  >;
  featureflagId?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagsTenantsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FeatureFlagsTenantsConnection"] = ResolversParentTypes["FeatureFlagsTenantsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["FeatureFlagsTenantsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["FeatureFlagsTenant"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagsTenantsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FeatureFlagsTenantsEdge"] = ResolversParentTypes["FeatureFlagsTenantsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["FeatureFlagsTenant"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagsUserResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FeatureFlagsUser"] = ResolversParentTypes["FeatureFlagsUser"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  featureFlagByFeatureflagId?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType
  >;
  featureflagId?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagsUsersConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FeatureFlagsUsersConnection"] = ResolversParentTypes["FeatureFlagsUsersConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["FeatureFlagsUsersEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["FeatureFlagsUser"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeatureFlagsUsersEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FeatureFlagsUsersEdge"] = ResolversParentTypes["FeatureFlagsUsersEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["FeatureFlagsUser"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["File"] = ResolversParentTypes["File"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  dateArchived?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  dateDataDeleted?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  dateDeleted?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  fileActivitiesByFileId?: Resolver<
    ResolversTypes["FileActivitiesConnection"],
    ParentType,
    ContextType,
    RequireFields<FileFileActivitiesByFileIdArgs, "orderBy">
  >;
  fileBySeriesParentId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  fileFormat?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  fileMetadataByFileId?: Resolver<
    ResolversTypes["FileMetadataConnection"],
    ParentType,
    ContextType,
    RequireFields<FileFileMetadataByFileIdArgs, "orderBy">
  >;
  fileProcessingNotificationsByFileId?: Resolver<
    ResolversTypes["FileProcessingNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<FileFileProcessingNotificationsByFileIdArgs, "orderBy">
  >;
  fileStructure?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  fileType?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  filesBySeriesParentId?: Resolver<
    ResolversTypes["FilesConnection"],
    ParentType,
    ContextType,
    RequireFields<FileFilesBySeriesParentIdArgs, "orderBy">
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  isSeries?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  multipartUploadId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  originalName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  outputGroupFilesByFileId?: Resolver<
    ResolversTypes["OutputGroupFilesConnection"],
    ParentType,
    ContextType,
    RequireFields<FileOutputGroupFilesByFileIdArgs, "orderBy">
  >;
  parentIds?: Resolver<Maybe<ResolversTypes["JSON"]>, ParentType, ContextType>;
  partSize?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  preview?: Resolver<Maybe<ResolversTypes["JSON"]>, ParentType, ContextType>;
  processingStatus?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  referenceId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  seriesOrder?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  seriesParentId?: Resolver<
    Maybe<ResolversTypes["UUID"]>,
    ParentType,
    ContextType
  >;
  signal?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes["BigInt"]>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  status?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tags?: Resolver<
    Array<Maybe<ResolversTypes["String"]>>,
    ParentType,
    ContextType
  >;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  taskSourcesByFileId?: Resolver<
    ResolversTypes["TaskSourcesConnection"],
    ParentType,
    ContextType,
    RequireFields<FileTaskSourcesByFileIdArgs, "orderBy">
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  uploadStatus?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileActivitiesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FileActivitiesConnection"] = ResolversParentTypes["FileActivitiesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["FileActivitiesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["FileActivity"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileActivitiesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FileActivitiesEdge"] = ResolversParentTypes["FileActivitiesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["FileActivity"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileActivityResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FileActivity"] = ResolversParentTypes["FileActivity"],
> = {
  activityType?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  bytes?: Resolver<Maybe<ResolversTypes["BigInt"]>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  contentTypeId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  costByCostId?: Resolver<
    Maybe<ResolversTypes["Cost"]>,
    ParentType,
    ContextType
  >;
  costId?: Resolver<Maybe<ResolversTypes["BigInt"]>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  djangoContentTypeByContentTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  fileByFileId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  fileId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileMetadataConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FileMetadataConnection"] = ResolversParentTypes["FileMetadataConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["FileMetadataEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["FileMetadatum"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileMetadataEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FileMetadataEdge"] = ResolversParentTypes["FileMetadataEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["FileMetadatum"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileMetadatumResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FileMetadatum"] = ResolversParentTypes["FileMetadatum"],
> = {
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  fileByFileId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  fileId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  metadataId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  metadatumByMetadataId?: Resolver<
    Maybe<ResolversTypes["Metadatum"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileOutputGroupResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FileOutputGroup"] = ResolversParentTypes["FileOutputGroup"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  fileOutputGroupMetadataByFileOutputGroupId?: Resolver<
    ResolversTypes["FileOutputGroupMetadataConnection"],
    ParentType,
    ContextType,
    RequireFields<
      FileOutputGroupFileOutputGroupMetadataByFileOutputGroupIdArgs,
      "orderBy"
    >
  >;
  groupType?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  outputGroupFilesByFileOutputGroupId?: Resolver<
    ResolversTypes["OutputGroupFilesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      FileOutputGroupOutputGroupFilesByFileOutputGroupIdArgs,
      "orderBy"
    >
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileOutputGroupMetadataConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FileOutputGroupMetadataConnection"] = ResolversParentTypes["FileOutputGroupMetadataConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["FileOutputGroupMetadataEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["FileOutputGroupMetadatum"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileOutputGroupMetadataEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FileOutputGroupMetadataEdge"] = ResolversParentTypes["FileOutputGroupMetadataEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["FileOutputGroupMetadatum"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileOutputGroupMetadatumResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FileOutputGroupMetadatum"] = ResolversParentTypes["FileOutputGroupMetadatum"],
> = {
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  fileOutputGroupByFileOutputGroupId?: Resolver<
    Maybe<ResolversTypes["FileOutputGroup"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroupId?: Resolver<
    Maybe<ResolversTypes["UUID"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  metadataId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  metadatumByMetadataId?: Resolver<
    Maybe<ResolversTypes["Metadatum"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileOutputGroupsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FileOutputGroupsConnection"] = ResolversParentTypes["FileOutputGroupsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["FileOutputGroupsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["FileOutputGroup"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileOutputGroupsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FileOutputGroupsEdge"] = ResolversParentTypes["FileOutputGroupsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["FileOutputGroup"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileProcessingNotificationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FileProcessingNotification"] = ResolversParentTypes["FileProcessingNotification"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  fileByFileId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  fileId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  notificationById?: Resolver<
    Maybe<ResolversTypes["Notification"]>,
    ParentType,
    ContextType
  >;
  status?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileProcessingNotificationsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FileProcessingNotificationsConnection"] = ResolversParentTypes["FileProcessingNotificationsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["FileProcessingNotificationsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["FileProcessingNotification"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileProcessingNotificationsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FileProcessingNotificationsEdge"] = ResolversParentTypes["FileProcessingNotificationsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["FileProcessingNotification"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FilesByExecutorResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FilesByExecutor"] = ResolversParentTypes["FilesByExecutor"],
> = {
  executorId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FilesByExecutorsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FilesByExecutorsConnection"] = ResolversParentTypes["FilesByExecutorsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["FilesByExecutorsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["FilesByExecutor"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FilesByExecutorsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FilesByExecutorsEdge"] = ResolversParentTypes["FilesByExecutorsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["FilesByExecutor"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FilesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FilesConnection"] = ResolversParentTypes["FilesConnection"],
> = {
  edges?: Resolver<Array<ResolversTypes["FilesEdge"]>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes["File"]>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FilesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["FilesEdge"] = ResolversParentTypes["FilesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["File"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTableResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["GdtAnalysisTable"] = ResolversParentTypes["GdtAnalysisTable"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  dateDeleted?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  description?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  folderId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  gdtAnalysisTableCellsByTableId?: Resolver<
    ResolversTypes["GdtAnalysisTableCellsConnection"],
    ParentType,
    ContextType,
    RequireFields<GdtAnalysisTableGdtAnalysisTableCellsByTableIdArgs, "orderBy">
  >;
  gdtAnalysisTableColumnGroupsByTableId?: Resolver<
    ResolversTypes["GdtAnalysisTableColumnGroupsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      GdtAnalysisTableGdtAnalysisTableColumnGroupsByTableIdArgs,
      "orderBy"
    >
  >;
  gdtAnalysisTableColumnsByTableId?: Resolver<
    ResolversTypes["GdtAnalysisTableColumnsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      GdtAnalysisTableGdtAnalysisTableColumnsByTableIdArgs,
      "orderBy"
    >
  >;
  gdtAnalysisTableRowsByTableId?: Resolver<
    ResolversTypes["GdtAnalysisTableRowsConnection"],
    ParentType,
    ContextType,
    RequireFields<GdtAnalysisTableGdtAnalysisTableRowsByTableIdArgs, "orderBy">
  >;
  hidden?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectFolderByFolderId?: Resolver<
    Maybe<ResolversTypes["ProjectFolder"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  toolVersionId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTableCellResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["GdtAnalysisTableCell"] = ResolversParentTypes["GdtAnalysisTableCell"],
> = {
  columnId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  formula?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  gdtAnalysisTableByTableId?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTable"]>,
    ParentType,
    ContextType
  >;
  gdtAnalysisTableColumnByColumnId?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTableColumn"]>,
    ParentType,
    ContextType
  >;
  gdtAnalysisTableRowByRowId?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTableRow"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  rowId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  tableId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTableCellsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["GdtAnalysisTableCellsConnection"] = ResolversParentTypes["GdtAnalysisTableCellsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["GdtAnalysisTableCellsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["GdtAnalysisTableCell"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTableCellsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["GdtAnalysisTableCellsEdge"] = ResolversParentTypes["GdtAnalysisTableCellsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["GdtAnalysisTableCell"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTableColumnResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["GdtAnalysisTableColumn"] = ResolversParentTypes["GdtAnalysisTableColumn"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  customDefaultFormula?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  dateDeleted?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  defaultFormula?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  definitionId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  definitionTypeId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  deletable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  djangoContentTypeByDefinitionTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  editable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  gdtAnalysisTableByTableId?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTable"]>,
    ParentType,
    ContextType
  >;
  gdtAnalysisTableCellsByColumnId?: Resolver<
    ResolversTypes["GdtAnalysisTableCellsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      GdtAnalysisTableColumnGdtAnalysisTableCellsByColumnIdArgs,
      "orderBy"
    >
  >;
  gdtAnalysisTableColumnGroupByGroupId?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTableColumnGroup"]>,
    ParentType,
    ContextType
  >;
  groupId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  helpText?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  identifierPosition?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  isIdColumn?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isResult?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  pinned?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  required?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  tableId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  width?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTableColumnGroupResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["GdtAnalysisTableColumnGroup"] = ResolversParentTypes["GdtAnalysisTableColumnGroup"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  dateDeleted?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  definitionId?: Resolver<
    Maybe<ResolversTypes["UUID"]>,
    ParentType,
    ContextType
  >;
  definitionTypeId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByDefinitionTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  gdtAnalysisTableByTableId?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTable"]>,
    ParentType,
    ContextType
  >;
  gdtAnalysisTableColumnsByGroupId?: Resolver<
    ResolversTypes["GdtAnalysisTableColumnsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      GdtAnalysisTableColumnGroupGdtAnalysisTableColumnsByGroupIdArgs,
      "orderBy"
    >
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  tableId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTableColumnGroupsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["GdtAnalysisTableColumnGroupsConnection"] = ResolversParentTypes["GdtAnalysisTableColumnGroupsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["GdtAnalysisTableColumnGroupsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["GdtAnalysisTableColumnGroup"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTableColumnGroupsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["GdtAnalysisTableColumnGroupsEdge"] = ResolversParentTypes["GdtAnalysisTableColumnGroupsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["GdtAnalysisTableColumnGroup"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTableColumnsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["GdtAnalysisTableColumnsConnection"] = ResolversParentTypes["GdtAnalysisTableColumnsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["GdtAnalysisTableColumnsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["GdtAnalysisTableColumn"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTableColumnsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["GdtAnalysisTableColumnsEdge"] = ResolversParentTypes["GdtAnalysisTableColumnsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["GdtAnalysisTableColumn"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTableRowResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["GdtAnalysisTableRow"] = ResolversParentTypes["GdtAnalysisTableRow"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  dateDeleted?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  editable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  gdtAnalysisTableByTableId?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTable"]>,
    ParentType,
    ContextType
  >;
  gdtAnalysisTableCellsByRowId?: Resolver<
    ResolversTypes["GdtAnalysisTableCellsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      GdtAnalysisTableRowGdtAnalysisTableCellsByRowIdArgs,
      "orderBy"
    >
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  index?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  joinable?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  resourceTier?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  tableId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  toolVersionId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTableRowsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["GdtAnalysisTableRowsConnection"] = ResolversParentTypes["GdtAnalysisTableRowsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["GdtAnalysisTableRowsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["GdtAnalysisTableRow"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTableRowsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["GdtAnalysisTableRowsEdge"] = ResolversParentTypes["GdtAnalysisTableRowsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["GdtAnalysisTableRow"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTablesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["GdtAnalysisTablesConnection"] = ResolversParentTypes["GdtAnalysisTablesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["GdtAnalysisTablesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["GdtAnalysisTable"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GdtAnalysisTablesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["GdtAnalysisTablesEdge"] = ResolversParentTypes["GdtAnalysisTablesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["GdtAnalysisTable"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface InternetAddressScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes["InternetAddress"], any> {
  name: "InternetAddress";
}

export type IntervalResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Interval"] = ResolversParentTypes["Interval"],
> = {
  days?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  hours?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  minutes?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  months?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  seconds?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  years?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes["JSON"], any> {
  name: "JSON";
}

export type MetadataConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["MetadataConnection"] = ResolversParentTypes["MetadataConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["MetadataEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<Array<ResolversTypes["Metadatum"]>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetadataEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["MetadataEdge"] = ResolversParentTypes["MetadataEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["Metadatum"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetadataValueResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["MetadataValue"] = ResolversParentTypes["MetadataValue"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  metadataId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  metadatumByMetadataId?: Resolver<
    Maybe<ResolversTypes["Metadatum"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes["JSON"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetadataValuesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["MetadataValuesConnection"] = ResolversParentTypes["MetadataValuesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["MetadataValuesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["MetadataValue"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetadataValuesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["MetadataValuesEdge"] = ResolversParentTypes["MetadataValuesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["MetadataValue"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetadatumResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Metadatum"] = ResolversParentTypes["Metadatum"],
> = {
  activeValue?: Resolver<
    Maybe<ResolversTypes["JSON"]>,
    ParentType,
    ContextType,
    Partial<MetadatumActiveValueArgs>
  >;
  displayName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  fileMetadataByMetadataId?: Resolver<
    ResolversTypes["FileMetadataConnection"],
    ParentType,
    ContextType,
    RequireFields<MetadatumFileMetadataByMetadataIdArgs, "orderBy">
  >;
  fileOutputGroupMetadataByMetadataId?: Resolver<
    ResolversTypes["FileOutputGroupMetadataConnection"],
    ParentType,
    ContextType,
    RequireFields<MetadatumFileOutputGroupMetadataByMetadataIdArgs, "orderBy">
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  metadataValuesByMetadataId?: Resolver<
    ResolversTypes["MetadataValuesConnection"],
    ParentType,
    ContextType,
    RequireFields<MetadatumMetadataValuesByMetadataIdArgs, "orderBy">
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Mutation"] = ResolversParentTypes["Mutation"],
> = {
  changeUserSession?: Resolver<
    Maybe<ResolversTypes["ChangeUserSessionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationChangeUserSessionArgs, "input">
  >;
  createAdminProject?: Resolver<
    Maybe<ResolversTypes["CreateAdminProjectPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateAdminProjectArgs, "input">
  >;
  createApplicationUser?: Resolver<
    Maybe<ResolversTypes["CreateApplicationUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateApplicationUserArgs, "input">
  >;
  createApplicationUserGroup?: Resolver<
    Maybe<ResolversTypes["CreateApplicationUserGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateApplicationUserGroupArgs, "input">
  >;
  createApplicationUserMembership?: Resolver<
    Maybe<ResolversTypes["CreateApplicationUserMembershipPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateApplicationUserMembershipArgs, "input">
  >;
  createApplicationUserMetadatum?: Resolver<
    Maybe<ResolversTypes["CreateApplicationUserMetadatumPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateApplicationUserMetadatumArgs, "input">
  >;
  createApplicationUserSession?: Resolver<
    Maybe<ResolversTypes["CreateApplicationUserSessionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateApplicationUserSessionArgs, "input">
  >;
  createApplicationUserUserPermission?: Resolver<
    Maybe<ResolversTypes["CreateApplicationUserUserPermissionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateApplicationUserUserPermissionArgs, "input">
  >;
  createAuditlogLogentry?: Resolver<
    Maybe<ResolversTypes["CreateAuditlogLogentryPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateAuditlogLogentryArgs, "input">
  >;
  createAuthGroup?: Resolver<
    Maybe<ResolversTypes["CreateAuthGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateAuthGroupArgs, "input">
  >;
  createAuthGroupPermission?: Resolver<
    Maybe<ResolversTypes["CreateAuthGroupPermissionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateAuthGroupPermissionArgs, "input">
  >;
  createAuthPermission?: Resolver<
    Maybe<ResolversTypes["CreateAuthPermissionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateAuthPermissionArgs, "input">
  >;
  createAvailableNonRestrictedProject?: Resolver<
    Maybe<ResolversTypes["CreateAvailableNonRestrictedProjectPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateAvailableNonRestrictedProjectArgs, "input">
  >;
  createAvatar?: Resolver<
    Maybe<ResolversTypes["CreateAvatarPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateAvatarArgs, "input">
  >;
  createAwsBatchTask?: Resolver<
    Maybe<ResolversTypes["CreateAwsBatchTaskPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateAwsBatchTaskArgs, "input">
  >;
  createAwsCognitoUser?: Resolver<
    Maybe<ResolversTypes["CreateAwsCognitoUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateAwsCognitoUserArgs, "input">
  >;
  createAwsEcrImage?: Resolver<
    Maybe<ResolversTypes["CreateAwsEcrImagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateAwsEcrImageArgs, "input">
  >;
  createAwsMockBatchTask?: Resolver<
    Maybe<ResolversTypes["CreateAwsMockBatchTaskPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateAwsMockBatchTaskArgs, "input">
  >;
  createAwsMockDistributionImage?: Resolver<
    Maybe<ResolversTypes["CreateAwsMockDistributionImagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateAwsMockDistributionImageArgs, "input">
  >;
  createAwsMockEcrImage?: Resolver<
    Maybe<ResolversTypes["CreateAwsMockEcrImagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateAwsMockEcrImageArgs, "input">
  >;
  createAwsMockIamUser?: Resolver<
    Maybe<ResolversTypes["CreateAwsMockIamUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateAwsMockIamUserArgs, "input">
  >;
  createAwsMockS3File?: Resolver<
    Maybe<ResolversTypes["CreateAwsMockS3FilePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateAwsMockS3FileArgs, "input">
  >;
  createAwsS3File?: Resolver<
    Maybe<ResolversTypes["CreateAwsS3FilePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateAwsS3FileArgs, "input">
  >;
  createCodeFile?: Resolver<
    Maybe<ResolversTypes["CreateCodeFilePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateCodeFileArgs, "input">
  >;
  createCommand?: Resolver<
    Maybe<ResolversTypes["CreateCommandPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateCommandArgs, "input">
  >;
  createContainerImage?: Resolver<
    Maybe<ResolversTypes["CreateContainerImagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateContainerImageArgs, "input">
  >;
  createContainerImageRepository?: Resolver<
    Maybe<ResolversTypes["CreateContainerImageRepositoryPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateContainerImageRepositoryArgs, "input">
  >;
  createCost?: Resolver<
    Maybe<ResolversTypes["CreateCostPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateCostArgs, "input">
  >;
  createCurrentApplicationUser?: Resolver<
    Maybe<ResolversTypes["CreateCurrentApplicationUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateCurrentApplicationUserArgs, "input">
  >;
  createDistributionRegistryImage?: Resolver<
    Maybe<ResolversTypes["CreateDistributionRegistryImagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateDistributionRegistryImageArgs, "input">
  >;
  createDjangoAdminLog?: Resolver<
    Maybe<ResolversTypes["CreateDjangoAdminLogPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateDjangoAdminLogArgs, "input">
  >;
  createDjangoContentType?: Resolver<
    Maybe<ResolversTypes["CreateDjangoContentTypePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateDjangoContentTypeArgs, "input">
  >;
  createDjangoMigration?: Resolver<
    Maybe<ResolversTypes["CreateDjangoMigrationPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateDjangoMigrationArgs, "input">
  >;
  createDjangoSesBlacklistedemail?: Resolver<
    Maybe<ResolversTypes["CreateDjangoSesBlacklistedemailPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateDjangoSesBlacklistedemailArgs, "input">
  >;
  createDjangoSesSesstat?: Resolver<
    Maybe<ResolversTypes["CreateDjangoSesSesstatPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateDjangoSesSesstatArgs, "input">
  >;
  createDjangoSession?: Resolver<
    Maybe<ResolversTypes["CreateDjangoSessionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateDjangoSessionArgs, "input">
  >;
  createDrsFileexecutor?: Resolver<
    Maybe<ResolversTypes["CreateDrsFileexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateDrsFileexecutorArgs, "input">
  >;
  createDrsMockfileexecutor?: Resolver<
    Maybe<ResolversTypes["CreateDrsMockfileexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateDrsMockfileexecutorArgs, "input">
  >;
  createEulaVersion?: Resolver<
    Maybe<ResolversTypes["CreateEulaVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateEulaVersionArgs, "input">
  >;
  createEulaVersionUserAcceptance?: Resolver<
    Maybe<ResolversTypes["CreateEulaVersionUserAcceptancePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateEulaVersionUserAcceptanceArgs, "input">
  >;
  createFeatureFlag?: Resolver<
    Maybe<ResolversTypes["CreateFeatureFlagPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateFeatureFlagArgs, "input">
  >;
  createFeatureFlagsGroup?: Resolver<
    Maybe<ResolversTypes["CreateFeatureFlagsGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateFeatureFlagsGroupArgs, "input">
  >;
  createFeatureFlagsTenant?: Resolver<
    Maybe<ResolversTypes["CreateFeatureFlagsTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateFeatureFlagsTenantArgs, "input">
  >;
  createFeatureFlagsUser?: Resolver<
    Maybe<ResolversTypes["CreateFeatureFlagsUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateFeatureFlagsUserArgs, "input">
  >;
  createFile?: Resolver<
    Maybe<ResolversTypes["CreateFilePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateFileArgs, "input">
  >;
  createFileActivity?: Resolver<
    Maybe<ResolversTypes["CreateFileActivityPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateFileActivityArgs, "input">
  >;
  createFileMetadatum?: Resolver<
    Maybe<ResolversTypes["CreateFileMetadatumPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateFileMetadatumArgs, "input">
  >;
  createFileOutputGroupMetadatum?: Resolver<
    Maybe<ResolversTypes["CreateFileOutputGroupMetadatumPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateFileOutputGroupMetadatumArgs, "input">
  >;
  createFilesByExecutor?: Resolver<
    Maybe<ResolversTypes["CreateFilesByExecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateFilesByExecutorArgs, "input">
  >;
  createMetadataValue?: Resolver<
    Maybe<ResolversTypes["CreateMetadataValuePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateMetadataValueArgs, "input">
  >;
  createMetadatum?: Resolver<
    Maybe<ResolversTypes["CreateMetadatumPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateMetadatumArgs, "input">
  >;
  createOutputGroupFile?: Resolver<
    Maybe<ResolversTypes["CreateOutputGroupFilePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateOutputGroupFileArgs, "input">
  >;
  createPinnedTool?: Resolver<
    Maybe<ResolversTypes["CreatePinnedToolPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePinnedToolArgs, "input">
  >;
  createProjectFolder?: Resolver<
    Maybe<ResolversTypes["CreateProjectFolderPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateProjectFolderArgs, "input">
  >;
  createProjectTag?: Resolver<
    Maybe<ResolversTypes["CreateProjectTagPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateProjectTagArgs, "input">
  >;
  createRole?: Resolver<
    Maybe<ResolversTypes["CreateRolePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateRoleArgs, "input">
  >;
  createRun?: Resolver<
    Maybe<ResolversTypes["CreateRunPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateRunArgs, "input">
  >;
  createSession?: Resolver<
    Maybe<ResolversTypes["CreateSessionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateSessionArgs, "input">
  >;
  createTask?: Resolver<
    Maybe<ResolversTypes["CreateTaskPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTaskArgs, "input">
  >;
  createTaskActivity?: Resolver<
    Maybe<ResolversTypes["CreateTaskActivityPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTaskActivityArgs, "input">
  >;
  createTaskResource?: Resolver<
    Maybe<ResolversTypes["CreateTaskResourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTaskResourceArgs, "input">
  >;
  createTaskResourceUsage?: Resolver<
    Maybe<ResolversTypes["CreateTaskResourceUsagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTaskResourceUsageArgs, "input">
  >;
  createTaskSource?: Resolver<
    Maybe<ResolversTypes["CreateTaskSourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTaskSourceArgs, "input">
  >;
  createTaskStatusLog?: Resolver<
    Maybe<ResolversTypes["CreateTaskStatusLogPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTaskStatusLogArgs, "input">
  >;
  createTenant?: Resolver<
    Maybe<ResolversTypes["CreateTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTenantArgs, "input">
  >;
  createTenantContract?: Resolver<
    Maybe<ResolversTypes["CreateTenantContractPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTenantContractArgs, "input">
  >;
  createTenantContractAllowance?: Resolver<
    Maybe<ResolversTypes["CreateTenantContractAllowancePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTenantContractAllowanceArgs, "input">
  >;
  createTenantContractTransaction?: Resolver<
    Maybe<ResolversTypes["CreateTenantContractTransactionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTenantContractTransactionArgs, "input">
  >;
  createTenantMockuserexecutor?: Resolver<
    Maybe<ResolversTypes["CreateTenantMockuserexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTenantMockuserexecutorArgs, "input">
  >;
  createTenantMonthlyConsumedResource?: Resolver<
    Maybe<ResolversTypes["CreateTenantMonthlyConsumedResourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTenantMonthlyConsumedResourceArgs, "input">
  >;
  createTenantUserexecutor?: Resolver<
    Maybe<ResolversTypes["CreateTenantUserexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTenantUserexecutorArgs, "input">
  >;
  createTesContainerimageexecutor?: Resolver<
    Maybe<ResolversTypes["CreateTesContainerimageexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTesContainerimageexecutorArgs, "input">
  >;
  createTesMockcontainerimageexecutor?: Resolver<
    Maybe<ResolversTypes["CreateTesMockcontainerimageexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTesMockcontainerimageexecutorArgs, "input">
  >;
  createTesMocktaskexecutor?: Resolver<
    Maybe<ResolversTypes["CreateTesMocktaskexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTesMocktaskexecutorArgs, "input">
  >;
  createTesTaskexecutor?: Resolver<
    Maybe<ResolversTypes["CreateTesTaskexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTesTaskexecutorArgs, "input">
  >;
  createTool?: Resolver<
    Maybe<ResolversTypes["CreateToolPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateToolArgs, "input">
  >;
  createToolParameter?: Resolver<
    Maybe<ResolversTypes["CreateToolParameterPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateToolParameterArgs, "input">
  >;
  createToolResource?: Resolver<
    Maybe<ResolversTypes["CreateToolResourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateToolResourceArgs, "input">
  >;
  createToolResult?: Resolver<
    Maybe<ResolversTypes["CreateToolResultPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateToolResultArgs, "input">
  >;
  createToolSecret?: Resolver<
    Maybe<ResolversTypes["CreateToolSecretPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateToolSecretArgs, "input">
  >;
  createToolSource?: Resolver<
    Maybe<ResolversTypes["CreateToolSourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateToolSourceArgs, "input">
  >;
  createToolTenant?: Resolver<
    Maybe<ResolversTypes["CreateToolTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateToolTenantArgs, "input">
  >;
  createToolVersion?: Resolver<
    Maybe<ResolversTypes["CreateToolVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateToolVersionArgs, "input">
  >;
  createToolbox?: Resolver<
    Maybe<ResolversTypes["CreateToolboxPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateToolboxArgs, "input">
  >;
  createToolboxTenant?: Resolver<
    Maybe<ResolversTypes["CreateToolboxTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateToolboxTenantArgs, "input">
  >;
  createUserPersonalSpaceRequest?: Resolver<
    Maybe<ResolversTypes["CreateUserPersonalSpaceRequestPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateUserPersonalSpaceRequestArgs, "input">
  >;
  createWaffleFlag?: Resolver<
    Maybe<ResolversTypes["CreateWaffleFlagPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateWaffleFlagArgs, "input">
  >;
  createWaffleSample?: Resolver<
    Maybe<ResolversTypes["CreateWaffleSamplePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateWaffleSampleArgs, "input">
  >;
  createWaffleSwitch?: Resolver<
    Maybe<ResolversTypes["CreateWaffleSwitchPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateWaffleSwitchArgs, "input">
  >;
  createWorkflow?: Resolver<
    Maybe<ResolversTypes["CreateWorkflowPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateWorkflowArgs, "input">
  >;
  createWorkflowDatum?: Resolver<
    Maybe<ResolversTypes["CreateWorkflowDatumPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateWorkflowDatumArgs, "input">
  >;
  createWorkflowResult?: Resolver<
    Maybe<ResolversTypes["CreateWorkflowResultPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateWorkflowResultArgs, "input">
  >;
  createWorkflowResultWorkflowVersion?: Resolver<
    Maybe<ResolversTypes["CreateWorkflowResultWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateWorkflowResultWorkflowVersionArgs, "input">
  >;
  createWorkflowSection?: Resolver<
    Maybe<ResolversTypes["CreateWorkflowSectionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateWorkflowSectionArgs, "input">
  >;
  createWorkflowSectionBlock?: Resolver<
    Maybe<ResolversTypes["CreateWorkflowSectionBlockPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateWorkflowSectionBlockArgs, "input">
  >;
  createWorkflowSectionBlockSection?: Resolver<
    Maybe<ResolversTypes["CreateWorkflowSectionBlockSectionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateWorkflowSectionBlockSectionArgs, "input">
  >;
  createWorkflowSectionWorkflowVersion?: Resolver<
    Maybe<ResolversTypes["CreateWorkflowSectionWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateWorkflowSectionWorkflowVersionArgs, "input">
  >;
  createWorkflowSource?: Resolver<
    Maybe<ResolversTypes["CreateWorkflowSourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateWorkflowSourceArgs, "input">
  >;
  createWorkflowSourceWorkflowVersion?: Resolver<
    Maybe<ResolversTypes["CreateWorkflowSourceWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateWorkflowSourceWorkflowVersionArgs, "input">
  >;
  createWorkflowVersion?: Resolver<
    Maybe<ResolversTypes["CreateWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateWorkflowVersionArgs, "input">
  >;
  deleteApplicationUserByEmail?: Resolver<
    Maybe<ResolversTypes["DeleteApplicationUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteApplicationUserByEmailArgs, "input">
  >;
  deleteApplicationUserByGlobalUserId?: Resolver<
    Maybe<ResolversTypes["DeleteApplicationUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteApplicationUserByGlobalUserIdArgs, "input">
  >;
  deleteApplicationUserById?: Resolver<
    Maybe<ResolversTypes["DeleteApplicationUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteApplicationUserByIdArgs, "input">
  >;
  deleteApplicationUserByUsername?: Resolver<
    Maybe<ResolversTypes["DeleteApplicationUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteApplicationUserByUsernameArgs, "input">
  >;
  deleteApplicationUserGroupById?: Resolver<
    Maybe<ResolversTypes["DeleteApplicationUserGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteApplicationUserGroupByIdArgs, "input">
  >;
  deleteApplicationUserGroupByUserIdAndGroupId?: Resolver<
    Maybe<ResolversTypes["DeleteApplicationUserGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteApplicationUserGroupByUserIdAndGroupIdArgs,
      "input"
    >
  >;
  deleteApplicationUserMembershipById?: Resolver<
    Maybe<ResolversTypes["DeleteApplicationUserMembershipPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteApplicationUserMembershipByIdArgs, "input">
  >;
  deleteApplicationUserMembershipByUserIdAndTenantId?: Resolver<
    Maybe<ResolversTypes["DeleteApplicationUserMembershipPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteApplicationUserMembershipByUserIdAndTenantIdArgs,
      "input"
    >
  >;
  deleteApplicationUserMetadatumById?: Resolver<
    Maybe<ResolversTypes["DeleteApplicationUserMetadatumPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteApplicationUserMetadatumByIdArgs, "input">
  >;
  deleteApplicationUserMetadatumByUserIdAndKey?: Resolver<
    Maybe<ResolversTypes["DeleteApplicationUserMetadatumPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteApplicationUserMetadatumByUserIdAndKeyArgs,
      "input"
    >
  >;
  deleteApplicationUserSessionById?: Resolver<
    Maybe<ResolversTypes["DeleteApplicationUserSessionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteApplicationUserSessionByIdArgs, "input">
  >;
  deleteApplicationUserUserPermissionById?: Resolver<
    Maybe<ResolversTypes["DeleteApplicationUserUserPermissionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteApplicationUserUserPermissionByIdArgs, "input">
  >;
  deleteApplicationUserUserPermissionByUserIdAndPermissionId?: Resolver<
    Maybe<ResolversTypes["DeleteApplicationUserUserPermissionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteApplicationUserUserPermissionByUserIdAndPermissionIdArgs,
      "input"
    >
  >;
  deleteAuditlogLogentryById?: Resolver<
    Maybe<ResolversTypes["DeleteAuditlogLogentryPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteAuditlogLogentryByIdArgs, "input">
  >;
  deleteAuthGroupById?: Resolver<
    Maybe<ResolversTypes["DeleteAuthGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteAuthGroupByIdArgs, "input">
  >;
  deleteAuthGroupByName?: Resolver<
    Maybe<ResolversTypes["DeleteAuthGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteAuthGroupByNameArgs, "input">
  >;
  deleteAuthGroupPermissionByGroupIdAndPermissionId?: Resolver<
    Maybe<ResolversTypes["DeleteAuthGroupPermissionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteAuthGroupPermissionByGroupIdAndPermissionIdArgs,
      "input"
    >
  >;
  deleteAuthGroupPermissionById?: Resolver<
    Maybe<ResolversTypes["DeleteAuthGroupPermissionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteAuthGroupPermissionByIdArgs, "input">
  >;
  deleteAuthPermissionByContentTypeIdAndCodename?: Resolver<
    Maybe<ResolversTypes["DeleteAuthPermissionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteAuthPermissionByContentTypeIdAndCodenameArgs,
      "input"
    >
  >;
  deleteAuthPermissionById?: Resolver<
    Maybe<ResolversTypes["DeleteAuthPermissionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteAuthPermissionByIdArgs, "input">
  >;
  deleteAvatarById?: Resolver<
    Maybe<ResolversTypes["DeleteAvatarPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteAvatarByIdArgs, "input">
  >;
  deleteAvatarByUserId?: Resolver<
    Maybe<ResolversTypes["DeleteAvatarPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteAvatarByUserIdArgs, "input">
  >;
  deleteAwsBatchTaskByTaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DeleteAwsBatchTaskPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteAwsBatchTaskByTaskexecutorPtrIdArgs, "input">
  >;
  deleteAwsCognitoUserByUserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DeleteAwsCognitoUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteAwsCognitoUserByUserexecutorPtrIdArgs, "input">
  >;
  deleteAwsEcrImageByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DeleteAwsEcrImagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteAwsEcrImageByContainerimageexecutorPtrIdArgs,
      "input"
    >
  >;
  deleteAwsMockBatchTaskByAwstaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DeleteAwsMockBatchTaskPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteAwsMockBatchTaskByAwstaskexecutorPtrIdArgs,
      "input"
    >
  >;
  deleteAwsMockDistributionImageByDistributioncontainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DeleteAwsMockDistributionImagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdArgs,
      "input"
    >
  >;
  deleteAwsMockEcrImageByAwscontainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DeleteAwsMockEcrImagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteAwsMockEcrImageByAwscontainerimageexecutorPtrIdArgs,
      "input"
    >
  >;
  deleteAwsMockIamUserByAwsuserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DeleteAwsMockIamUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteAwsMockIamUserByAwsuserexecutorPtrIdArgs,
      "input"
    >
  >;
  deleteAwsMockS3FileByAwsfileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DeleteAwsMockS3FilePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteAwsMockS3FileByAwsfileexecutorPtrIdArgs,
      "input"
    >
  >;
  deleteAwsS3FileByFileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DeleteAwsS3FilePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteAwsS3FileByFileexecutorPtrIdArgs, "input">
  >;
  deleteCodeFileById?: Resolver<
    Maybe<ResolversTypes["DeleteCodeFilePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteCodeFileByIdArgs, "input">
  >;
  deleteCommandById?: Resolver<
    Maybe<ResolversTypes["DeleteCommandPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteCommandByIdArgs, "input">
  >;
  deleteCommandByToolVersionId?: Resolver<
    Maybe<ResolversTypes["DeleteCommandPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteCommandByToolVersionIdArgs, "input">
  >;
  deleteCommandByToolVersionIdAndCodeFileId?: Resolver<
    Maybe<ResolversTypes["DeleteCommandPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteCommandByToolVersionIdAndCodeFileIdArgs,
      "input"
    >
  >;
  deleteContainerImageByExecutorId?: Resolver<
    Maybe<ResolversTypes["DeleteContainerImagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteContainerImageByExecutorIdArgs, "input">
  >;
  deleteContainerImageById?: Resolver<
    Maybe<ResolversTypes["DeleteContainerImagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteContainerImageByIdArgs, "input">
  >;
  deleteContainerImageRepositoryById?: Resolver<
    Maybe<ResolversTypes["DeleteContainerImageRepositoryPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteContainerImageRepositoryByIdArgs, "input">
  >;
  deleteContainerImageRepositoryByNameAndTenantIdAndRegistryType?: Resolver<
    Maybe<ResolversTypes["DeleteContainerImageRepositoryPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteContainerImageRepositoryByNameAndTenantIdAndRegistryTypeArgs,
      "input"
    >
  >;
  deleteContainerImageRepositoryByRepository?: Resolver<
    Maybe<ResolversTypes["DeleteContainerImageRepositoryPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteContainerImageRepositoryByRepositoryArgs,
      "input"
    >
  >;
  deleteCostById?: Resolver<
    Maybe<ResolversTypes["DeleteCostPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteCostByIdArgs, "input">
  >;
  deleteDistributionRegistryImageByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DeleteDistributionRegistryImagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteDistributionRegistryImageByContainerimageexecutorPtrIdArgs,
      "input"
    >
  >;
  deleteDjangoAdminLogById?: Resolver<
    Maybe<ResolversTypes["DeleteDjangoAdminLogPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteDjangoAdminLogByIdArgs, "input">
  >;
  deleteDjangoContentTypeByAppLabelAndModel?: Resolver<
    Maybe<ResolversTypes["DeleteDjangoContentTypePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteDjangoContentTypeByAppLabelAndModelArgs,
      "input"
    >
  >;
  deleteDjangoContentTypeById?: Resolver<
    Maybe<ResolversTypes["DeleteDjangoContentTypePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteDjangoContentTypeByIdArgs, "input">
  >;
  deleteDjangoMigrationById?: Resolver<
    Maybe<ResolversTypes["DeleteDjangoMigrationPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteDjangoMigrationByIdArgs, "input">
  >;
  deleteDjangoSesBlacklistedemailByEmail?: Resolver<
    Maybe<ResolversTypes["DeleteDjangoSesBlacklistedemailPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteDjangoSesBlacklistedemailByEmailArgs, "input">
  >;
  deleteDjangoSesBlacklistedemailById?: Resolver<
    Maybe<ResolversTypes["DeleteDjangoSesBlacklistedemailPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteDjangoSesBlacklistedemailByIdArgs, "input">
  >;
  deleteDjangoSesSesstatByDate?: Resolver<
    Maybe<ResolversTypes["DeleteDjangoSesSesstatPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteDjangoSesSesstatByDateArgs, "input">
  >;
  deleteDjangoSesSesstatById?: Resolver<
    Maybe<ResolversTypes["DeleteDjangoSesSesstatPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteDjangoSesSesstatByIdArgs, "input">
  >;
  deleteDjangoSessionBySessionKey?: Resolver<
    Maybe<ResolversTypes["DeleteDjangoSessionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteDjangoSessionBySessionKeyArgs, "input">
  >;
  deleteDrsFileexecutorById?: Resolver<
    Maybe<ResolversTypes["DeleteDrsFileexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteDrsFileexecutorByIdArgs, "input">
  >;
  deleteDrsMockfileexecutorByFileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DeleteDrsMockfileexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteDrsMockfileexecutorByFileexecutorPtrIdArgs,
      "input"
    >
  >;
  deleteEulaVersionById?: Resolver<
    Maybe<ResolversTypes["DeleteEulaVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteEulaVersionByIdArgs, "input">
  >;
  deleteEulaVersionByVersion?: Resolver<
    Maybe<ResolversTypes["DeleteEulaVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteEulaVersionByVersionArgs, "input">
  >;
  deleteEulaVersionUserAcceptanceById?: Resolver<
    Maybe<ResolversTypes["DeleteEulaVersionUserAcceptancePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteEulaVersionUserAcceptanceByIdArgs, "input">
  >;
  deleteEulaVersionUserAcceptanceByUserIdAndEulaVersionId?: Resolver<
    Maybe<ResolversTypes["DeleteEulaVersionUserAcceptancePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteEulaVersionUserAcceptanceByUserIdAndEulaVersionIdArgs,
      "input"
    >
  >;
  deleteFeatureFlagById?: Resolver<
    Maybe<ResolversTypes["DeleteFeatureFlagPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteFeatureFlagByIdArgs, "input">
  >;
  deleteFeatureFlagByName?: Resolver<
    Maybe<ResolversTypes["DeleteFeatureFlagPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteFeatureFlagByNameArgs, "input">
  >;
  deleteFeatureFlagsGroupByFeatureflagIdAndGroupId?: Resolver<
    Maybe<ResolversTypes["DeleteFeatureFlagsGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteFeatureFlagsGroupByFeatureflagIdAndGroupIdArgs,
      "input"
    >
  >;
  deleteFeatureFlagsGroupById?: Resolver<
    Maybe<ResolversTypes["DeleteFeatureFlagsGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteFeatureFlagsGroupByIdArgs, "input">
  >;
  deleteFeatureFlagsTenantByFeatureflagIdAndTenantId?: Resolver<
    Maybe<ResolversTypes["DeleteFeatureFlagsTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteFeatureFlagsTenantByFeatureflagIdAndTenantIdArgs,
      "input"
    >
  >;
  deleteFeatureFlagsTenantById?: Resolver<
    Maybe<ResolversTypes["DeleteFeatureFlagsTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteFeatureFlagsTenantByIdArgs, "input">
  >;
  deleteFeatureFlagsUserByFeatureflagIdAndUserId?: Resolver<
    Maybe<ResolversTypes["DeleteFeatureFlagsUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteFeatureFlagsUserByFeatureflagIdAndUserIdArgs,
      "input"
    >
  >;
  deleteFeatureFlagsUserById?: Resolver<
    Maybe<ResolversTypes["DeleteFeatureFlagsUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteFeatureFlagsUserByIdArgs, "input">
  >;
  deleteFileActivityById?: Resolver<
    Maybe<ResolversTypes["DeleteFileActivityPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteFileActivityByIdArgs, "input">
  >;
  deleteFileById?: Resolver<
    Maybe<ResolversTypes["DeleteFilePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteFileByIdArgs, "input">
  >;
  deleteFileByProjectIdAndReferenceId?: Resolver<
    Maybe<ResolversTypes["DeleteFilePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteFileByProjectIdAndReferenceIdArgs, "input">
  >;
  deleteFileMetadatumById?: Resolver<
    Maybe<ResolversTypes["DeleteFileMetadatumPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteFileMetadatumByIdArgs, "input">
  >;
  deleteFileOutputGroupById?: Resolver<
    Maybe<ResolversTypes["DeleteFileOutputGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteFileOutputGroupByIdArgs, "input">
  >;
  deleteFileOutputGroupByTaskId?: Resolver<
    Maybe<ResolversTypes["DeleteFileOutputGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteFileOutputGroupByTaskIdArgs, "input">
  >;
  deleteFileOutputGroupMetadatumById?: Resolver<
    Maybe<ResolversTypes["DeleteFileOutputGroupMetadatumPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteFileOutputGroupMetadatumByIdArgs, "input">
  >;
  deleteMetadataValueById?: Resolver<
    Maybe<ResolversTypes["DeleteMetadataValuePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteMetadataValueByIdArgs, "input">
  >;
  deleteMetadatumById?: Resolver<
    Maybe<ResolversTypes["DeleteMetadatumPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteMetadatumByIdArgs, "input">
  >;
  deleteOutputGroupFileById?: Resolver<
    Maybe<ResolversTypes["DeleteOutputGroupFilePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteOutputGroupFileByIdArgs, "input">
  >;
  deletePinnedToolById?: Resolver<
    Maybe<ResolversTypes["DeletePinnedToolPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeletePinnedToolByIdArgs, "input">
  >;
  deletePinnedToolByUserIdAndToolId?: Resolver<
    Maybe<ResolversTypes["DeletePinnedToolPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeletePinnedToolByUserIdAndToolIdArgs, "input">
  >;
  deleteProjectFolderById?: Resolver<
    Maybe<ResolversTypes["DeleteProjectFolderPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteProjectFolderByIdArgs, "input">
  >;
  deleteProjectTagById?: Resolver<
    Maybe<ResolversTypes["DeleteProjectTagPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteProjectTagByIdArgs, "input">
  >;
  deleteRunById?: Resolver<
    Maybe<ResolversTypes["DeleteRunPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteRunByIdArgs, "input">
  >;
  deleteSession?: Resolver<
    Maybe<ResolversTypes["DeleteSessionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteSessionArgs, "input">
  >;
  deleteTaskActivityById?: Resolver<
    Maybe<ResolversTypes["DeleteTaskActivityPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTaskActivityByIdArgs, "input">
  >;
  deleteTaskActivityByTaskId?: Resolver<
    Maybe<ResolversTypes["DeleteTaskActivityPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTaskActivityByTaskIdArgs, "input">
  >;
  deleteTaskByExecutorId?: Resolver<
    Maybe<ResolversTypes["DeleteTaskPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTaskByExecutorIdArgs, "input">
  >;
  deleteTaskById?: Resolver<
    Maybe<ResolversTypes["DeleteTaskPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTaskByIdArgs, "input">
  >;
  deleteTaskResourceById?: Resolver<
    Maybe<ResolversTypes["DeleteTaskResourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTaskResourceByIdArgs, "input">
  >;
  deleteTaskResourceUsageById?: Resolver<
    Maybe<ResolversTypes["DeleteTaskResourceUsagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTaskResourceUsageByIdArgs, "input">
  >;
  deleteTaskResourceUsageByTaskId?: Resolver<
    Maybe<ResolversTypes["DeleteTaskResourceUsagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTaskResourceUsageByTaskIdArgs, "input">
  >;
  deleteTaskSourceById?: Resolver<
    Maybe<ResolversTypes["DeleteTaskSourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTaskSourceByIdArgs, "input">
  >;
  deleteTaskStatusLogById?: Resolver<
    Maybe<ResolversTypes["DeleteTaskStatusLogPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTaskStatusLogByIdArgs, "input">
  >;
  deleteTaskStatusLogByTaskIdAndStatus?: Resolver<
    Maybe<ResolversTypes["DeleteTaskStatusLogPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTaskStatusLogByTaskIdAndStatusArgs, "input">
  >;
  deleteTenantById?: Resolver<
    Maybe<ResolversTypes["DeleteTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTenantByIdArgs, "input">
  >;
  deleteTenantByKey?: Resolver<
    Maybe<ResolversTypes["DeleteTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTenantByKeyArgs, "input">
  >;
  deleteTenantByRepositoryName?: Resolver<
    Maybe<ResolversTypes["DeleteTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTenantByRepositoryNameArgs, "input">
  >;
  deleteTenantBySfid?: Resolver<
    Maybe<ResolversTypes["DeleteTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTenantBySfidArgs, "input">
  >;
  deleteTenantContractAllowanceById?: Resolver<
    Maybe<ResolversTypes["DeleteTenantContractAllowancePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTenantContractAllowanceByIdArgs, "input">
  >;
  deleteTenantContractAllowanceByTenantContractTransactionIdAndQuotaType?: Resolver<
    Maybe<ResolversTypes["DeleteTenantContractAllowancePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeArgs,
      "input"
    >
  >;
  deleteTenantContractById?: Resolver<
    Maybe<ResolversTypes["DeleteTenantContractPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTenantContractByIdArgs, "input">
  >;
  deleteTenantContractByName?: Resolver<
    Maybe<ResolversTypes["DeleteTenantContractPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTenantContractByNameArgs, "input">
  >;
  deleteTenantContractBySfid?: Resolver<
    Maybe<ResolversTypes["DeleteTenantContractPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTenantContractBySfidArgs, "input">
  >;
  deleteTenantContractTransactionById?: Resolver<
    Maybe<ResolversTypes["DeleteTenantContractTransactionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTenantContractTransactionByIdArgs, "input">
  >;
  deleteTenantMockuserexecutorByUserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DeleteTenantMockuserexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteTenantMockuserexecutorByUserexecutorPtrIdArgs,
      "input"
    >
  >;
  deleteTenantMonthlyConsumedResourceById?: Resolver<
    Maybe<ResolversTypes["DeleteTenantMonthlyConsumedResourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTenantMonthlyConsumedResourceByIdArgs, "input">
  >;
  deleteTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract?: Resolver<
    Maybe<ResolversTypes["DeleteTenantMonthlyConsumedResourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractArgs,
      "input"
    >
  >;
  deleteTenantUserexecutorById?: Resolver<
    Maybe<ResolversTypes["DeleteTenantUserexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTenantUserexecutorByIdArgs, "input">
  >;
  deleteTesContainerimageexecutorById?: Resolver<
    Maybe<ResolversTypes["DeleteTesContainerimageexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTesContainerimageexecutorByIdArgs, "input">
  >;
  deleteTesMockcontainerimageexecutorByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DeleteTesMockcontainerimageexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteTesMockcontainerimageexecutorByContainerimageexecutorPtrIdArgs,
      "input"
    >
  >;
  deleteTesMocktaskexecutorByTaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DeleteTesMocktaskexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteTesMocktaskexecutorByTaskexecutorPtrIdArgs,
      "input"
    >
  >;
  deleteTesTaskexecutorById?: Resolver<
    Maybe<ResolversTypes["DeleteTesTaskexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTesTaskexecutorByIdArgs, "input">
  >;
  deleteToolById?: Resolver<
    Maybe<ResolversTypes["DeleteToolPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteToolByIdArgs, "input">
  >;
  deleteToolByProjectId?: Resolver<
    Maybe<ResolversTypes["DeleteToolPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteToolByProjectIdArgs, "input">
  >;
  deleteToolParameterById?: Resolver<
    Maybe<ResolversTypes["DeleteToolParameterPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteToolParameterByIdArgs, "input">
  >;
  deleteToolResourceById?: Resolver<
    Maybe<ResolversTypes["DeleteToolResourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteToolResourceByIdArgs, "input">
  >;
  deleteToolResourceByTypeAndToolVersionId?: Resolver<
    Maybe<ResolversTypes["DeleteToolResourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteToolResourceByTypeAndToolVersionIdArgs, "input">
  >;
  deleteToolResultById?: Resolver<
    Maybe<ResolversTypes["DeleteToolResultPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteToolResultByIdArgs, "input">
  >;
  deleteToolSecretById?: Resolver<
    Maybe<ResolversTypes["DeleteToolSecretPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteToolSecretByIdArgs, "input">
  >;
  deleteToolSourceById?: Resolver<
    Maybe<ResolversTypes["DeleteToolSourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteToolSourceByIdArgs, "input">
  >;
  deleteToolTenantById?: Resolver<
    Maybe<ResolversTypes["DeleteToolTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteToolTenantByIdArgs, "input">
  >;
  deleteToolTenantByToolIdAndTenantId?: Resolver<
    Maybe<ResolversTypes["DeleteToolTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteToolTenantByToolIdAndTenantIdArgs, "input">
  >;
  deleteToolVersionById?: Resolver<
    Maybe<ResolversTypes["DeleteToolVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteToolVersionByIdArgs, "input">
  >;
  deleteToolboxById?: Resolver<
    Maybe<ResolversTypes["DeleteToolboxPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteToolboxByIdArgs, "input">
  >;
  deleteToolboxByKey?: Resolver<
    Maybe<ResolversTypes["DeleteToolboxPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteToolboxByKeyArgs, "input">
  >;
  deleteToolboxTenantById?: Resolver<
    Maybe<ResolversTypes["DeleteToolboxTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteToolboxTenantByIdArgs, "input">
  >;
  deleteToolboxTenantByToolboxIdAndTenantId?: Resolver<
    Maybe<ResolversTypes["DeleteToolboxTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteToolboxTenantByToolboxIdAndTenantIdArgs,
      "input"
    >
  >;
  deleteUserPersonalSpaceRequestById?: Resolver<
    Maybe<ResolversTypes["DeleteUserPersonalSpaceRequestPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteUserPersonalSpaceRequestByIdArgs, "input">
  >;
  deleteWaffleFlagById?: Resolver<
    Maybe<ResolversTypes["DeleteWaffleFlagPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteWaffleFlagByIdArgs, "input">
  >;
  deleteWaffleFlagByName?: Resolver<
    Maybe<ResolversTypes["DeleteWaffleFlagPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteWaffleFlagByNameArgs, "input">
  >;
  deleteWaffleSampleById?: Resolver<
    Maybe<ResolversTypes["DeleteWaffleSamplePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteWaffleSampleByIdArgs, "input">
  >;
  deleteWaffleSampleByName?: Resolver<
    Maybe<ResolversTypes["DeleteWaffleSamplePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteWaffleSampleByNameArgs, "input">
  >;
  deleteWaffleSwitchById?: Resolver<
    Maybe<ResolversTypes["DeleteWaffleSwitchPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteWaffleSwitchByIdArgs, "input">
  >;
  deleteWaffleSwitchByName?: Resolver<
    Maybe<ResolversTypes["DeleteWaffleSwitchPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteWaffleSwitchByNameArgs, "input">
  >;
  deleteWorkflowById?: Resolver<
    Maybe<ResolversTypes["DeleteWorkflowPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteWorkflowByIdArgs, "input">
  >;
  deleteWorkflowDatumById?: Resolver<
    Maybe<ResolversTypes["DeleteWorkflowDatumPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteWorkflowDatumByIdArgs, "input">
  >;
  deleteWorkflowResultById?: Resolver<
    Maybe<ResolversTypes["DeleteWorkflowResultPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteWorkflowResultByIdArgs, "input">
  >;
  deleteWorkflowResultWorkflowVersionById?: Resolver<
    Maybe<ResolversTypes["DeleteWorkflowResultWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteWorkflowResultWorkflowVersionByIdArgs, "input">
  >;
  deleteWorkflowResultWorkflowVersionByResultIdAndWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["DeleteWorkflowResultWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdArgs,
      "input"
    >
  >;
  deleteWorkflowSectionBlockById?: Resolver<
    Maybe<ResolversTypes["DeleteWorkflowSectionBlockPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteWorkflowSectionBlockByIdArgs, "input">
  >;
  deleteWorkflowSectionBlockSectionByBlockIdAndSectionId?: Resolver<
    Maybe<ResolversTypes["DeleteWorkflowSectionBlockSectionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteWorkflowSectionBlockSectionByBlockIdAndSectionIdArgs,
      "input"
    >
  >;
  deleteWorkflowSectionBlockSectionById?: Resolver<
    Maybe<ResolversTypes["DeleteWorkflowSectionBlockSectionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteWorkflowSectionBlockSectionByIdArgs, "input">
  >;
  deleteWorkflowSectionById?: Resolver<
    Maybe<ResolversTypes["DeleteWorkflowSectionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteWorkflowSectionByIdArgs, "input">
  >;
  deleteWorkflowSectionWorkflowVersionById?: Resolver<
    Maybe<ResolversTypes["DeleteWorkflowSectionWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteWorkflowSectionWorkflowVersionByIdArgs, "input">
  >;
  deleteWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["DeleteWorkflowSectionWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdArgs,
      "input"
    >
  >;
  deleteWorkflowSourceById?: Resolver<
    Maybe<ResolversTypes["DeleteWorkflowSourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteWorkflowSourceByIdArgs, "input">
  >;
  deleteWorkflowSourceWorkflowVersionById?: Resolver<
    Maybe<ResolversTypes["DeleteWorkflowSourceWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteWorkflowSourceWorkflowVersionByIdArgs, "input">
  >;
  deleteWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["DeleteWorkflowSourceWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationDeleteWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdArgs,
      "input"
    >
  >;
  deleteWorkflowVersionById?: Resolver<
    Maybe<ResolversTypes["DeleteWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteWorkflowVersionByIdArgs, "input">
  >;
  updateApplicationUserByEmail?: Resolver<
    Maybe<ResolversTypes["UpdateApplicationUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateApplicationUserByEmailArgs, "input">
  >;
  updateApplicationUserByGlobalUserId?: Resolver<
    Maybe<ResolversTypes["UpdateApplicationUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateApplicationUserByGlobalUserIdArgs, "input">
  >;
  updateApplicationUserById?: Resolver<
    Maybe<ResolversTypes["UpdateApplicationUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateApplicationUserByIdArgs, "input">
  >;
  updateApplicationUserByUsername?: Resolver<
    Maybe<ResolversTypes["UpdateApplicationUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateApplicationUserByUsernameArgs, "input">
  >;
  updateApplicationUserGroupById?: Resolver<
    Maybe<ResolversTypes["UpdateApplicationUserGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateApplicationUserGroupByIdArgs, "input">
  >;
  updateApplicationUserGroupByUserIdAndGroupId?: Resolver<
    Maybe<ResolversTypes["UpdateApplicationUserGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateApplicationUserGroupByUserIdAndGroupIdArgs,
      "input"
    >
  >;
  updateApplicationUserMembershipById?: Resolver<
    Maybe<ResolversTypes["UpdateApplicationUserMembershipPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateApplicationUserMembershipByIdArgs, "input">
  >;
  updateApplicationUserMembershipByUserIdAndTenantId?: Resolver<
    Maybe<ResolversTypes["UpdateApplicationUserMembershipPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateApplicationUserMembershipByUserIdAndTenantIdArgs,
      "input"
    >
  >;
  updateApplicationUserMetadatumById?: Resolver<
    Maybe<ResolversTypes["UpdateApplicationUserMetadatumPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateApplicationUserMetadatumByIdArgs, "input">
  >;
  updateApplicationUserMetadatumByUserIdAndKey?: Resolver<
    Maybe<ResolversTypes["UpdateApplicationUserMetadatumPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateApplicationUserMetadatumByUserIdAndKeyArgs,
      "input"
    >
  >;
  updateApplicationUserSessionById?: Resolver<
    Maybe<ResolversTypes["UpdateApplicationUserSessionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateApplicationUserSessionByIdArgs, "input">
  >;
  updateApplicationUserUserPermissionById?: Resolver<
    Maybe<ResolversTypes["UpdateApplicationUserUserPermissionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateApplicationUserUserPermissionByIdArgs, "input">
  >;
  updateApplicationUserUserPermissionByUserIdAndPermissionId?: Resolver<
    Maybe<ResolversTypes["UpdateApplicationUserUserPermissionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateApplicationUserUserPermissionByUserIdAndPermissionIdArgs,
      "input"
    >
  >;
  updateAuditlogLogentryById?: Resolver<
    Maybe<ResolversTypes["UpdateAuditlogLogentryPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAuditlogLogentryByIdArgs, "input">
  >;
  updateAuthGroupById?: Resolver<
    Maybe<ResolversTypes["UpdateAuthGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAuthGroupByIdArgs, "input">
  >;
  updateAuthGroupByName?: Resolver<
    Maybe<ResolversTypes["UpdateAuthGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAuthGroupByNameArgs, "input">
  >;
  updateAuthGroupPermissionByGroupIdAndPermissionId?: Resolver<
    Maybe<ResolversTypes["UpdateAuthGroupPermissionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateAuthGroupPermissionByGroupIdAndPermissionIdArgs,
      "input"
    >
  >;
  updateAuthGroupPermissionById?: Resolver<
    Maybe<ResolversTypes["UpdateAuthGroupPermissionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAuthGroupPermissionByIdArgs, "input">
  >;
  updateAuthPermissionByContentTypeIdAndCodename?: Resolver<
    Maybe<ResolversTypes["UpdateAuthPermissionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateAuthPermissionByContentTypeIdAndCodenameArgs,
      "input"
    >
  >;
  updateAuthPermissionById?: Resolver<
    Maybe<ResolversTypes["UpdateAuthPermissionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAuthPermissionByIdArgs, "input">
  >;
  updateAvatarById?: Resolver<
    Maybe<ResolversTypes["UpdateAvatarPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAvatarByIdArgs, "input">
  >;
  updateAvatarByUserId?: Resolver<
    Maybe<ResolversTypes["UpdateAvatarPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAvatarByUserIdArgs, "input">
  >;
  updateAwsBatchTaskByTaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["UpdateAwsBatchTaskPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAwsBatchTaskByTaskexecutorPtrIdArgs, "input">
  >;
  updateAwsCognitoUserByUserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["UpdateAwsCognitoUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAwsCognitoUserByUserexecutorPtrIdArgs, "input">
  >;
  updateAwsEcrImageByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["UpdateAwsEcrImagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateAwsEcrImageByContainerimageexecutorPtrIdArgs,
      "input"
    >
  >;
  updateAwsMockBatchTaskByAwstaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["UpdateAwsMockBatchTaskPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateAwsMockBatchTaskByAwstaskexecutorPtrIdArgs,
      "input"
    >
  >;
  updateAwsMockDistributionImageByDistributioncontainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["UpdateAwsMockDistributionImagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdArgs,
      "input"
    >
  >;
  updateAwsMockEcrImageByAwscontainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["UpdateAwsMockEcrImagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateAwsMockEcrImageByAwscontainerimageexecutorPtrIdArgs,
      "input"
    >
  >;
  updateAwsMockIamUserByAwsuserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["UpdateAwsMockIamUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateAwsMockIamUserByAwsuserexecutorPtrIdArgs,
      "input"
    >
  >;
  updateAwsMockS3FileByAwsfileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["UpdateAwsMockS3FilePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateAwsMockS3FileByAwsfileexecutorPtrIdArgs,
      "input"
    >
  >;
  updateAwsS3FileByFileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["UpdateAwsS3FilePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateAwsS3FileByFileexecutorPtrIdArgs, "input">
  >;
  updateCodeFileById?: Resolver<
    Maybe<ResolversTypes["UpdateCodeFilePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateCodeFileByIdArgs, "input">
  >;
  updateCommandById?: Resolver<
    Maybe<ResolversTypes["UpdateCommandPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateCommandByIdArgs, "input">
  >;
  updateCommandByToolVersionId?: Resolver<
    Maybe<ResolversTypes["UpdateCommandPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateCommandByToolVersionIdArgs, "input">
  >;
  updateCommandByToolVersionIdAndCodeFileId?: Resolver<
    Maybe<ResolversTypes["UpdateCommandPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateCommandByToolVersionIdAndCodeFileIdArgs,
      "input"
    >
  >;
  updateContainerImageByExecutorId?: Resolver<
    Maybe<ResolversTypes["UpdateContainerImagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateContainerImageByExecutorIdArgs, "input">
  >;
  updateContainerImageById?: Resolver<
    Maybe<ResolversTypes["UpdateContainerImagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateContainerImageByIdArgs, "input">
  >;
  updateContainerImageRepositoryById?: Resolver<
    Maybe<ResolversTypes["UpdateContainerImageRepositoryPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateContainerImageRepositoryByIdArgs, "input">
  >;
  updateContainerImageRepositoryByNameAndTenantIdAndRegistryType?: Resolver<
    Maybe<ResolversTypes["UpdateContainerImageRepositoryPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateContainerImageRepositoryByNameAndTenantIdAndRegistryTypeArgs,
      "input"
    >
  >;
  updateContainerImageRepositoryByRepository?: Resolver<
    Maybe<ResolversTypes["UpdateContainerImageRepositoryPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateContainerImageRepositoryByRepositoryArgs,
      "input"
    >
  >;
  updateCostById?: Resolver<
    Maybe<ResolversTypes["UpdateCostPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateCostByIdArgs, "input">
  >;
  updateDistributionRegistryImageByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["UpdateDistributionRegistryImagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateDistributionRegistryImageByContainerimageexecutorPtrIdArgs,
      "input"
    >
  >;
  updateDjangoAdminLogById?: Resolver<
    Maybe<ResolversTypes["UpdateDjangoAdminLogPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateDjangoAdminLogByIdArgs, "input">
  >;
  updateDjangoContentTypeByAppLabelAndModel?: Resolver<
    Maybe<ResolversTypes["UpdateDjangoContentTypePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateDjangoContentTypeByAppLabelAndModelArgs,
      "input"
    >
  >;
  updateDjangoContentTypeById?: Resolver<
    Maybe<ResolversTypes["UpdateDjangoContentTypePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateDjangoContentTypeByIdArgs, "input">
  >;
  updateDjangoMigrationById?: Resolver<
    Maybe<ResolversTypes["UpdateDjangoMigrationPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateDjangoMigrationByIdArgs, "input">
  >;
  updateDjangoSesBlacklistedemailByEmail?: Resolver<
    Maybe<ResolversTypes["UpdateDjangoSesBlacklistedemailPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateDjangoSesBlacklistedemailByEmailArgs, "input">
  >;
  updateDjangoSesBlacklistedemailById?: Resolver<
    Maybe<ResolversTypes["UpdateDjangoSesBlacklistedemailPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateDjangoSesBlacklistedemailByIdArgs, "input">
  >;
  updateDjangoSesSesstatByDate?: Resolver<
    Maybe<ResolversTypes["UpdateDjangoSesSesstatPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateDjangoSesSesstatByDateArgs, "input">
  >;
  updateDjangoSesSesstatById?: Resolver<
    Maybe<ResolversTypes["UpdateDjangoSesSesstatPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateDjangoSesSesstatByIdArgs, "input">
  >;
  updateDjangoSessionBySessionKey?: Resolver<
    Maybe<ResolversTypes["UpdateDjangoSessionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateDjangoSessionBySessionKeyArgs, "input">
  >;
  updateDrsFileexecutorById?: Resolver<
    Maybe<ResolversTypes["UpdateDrsFileexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateDrsFileexecutorByIdArgs, "input">
  >;
  updateDrsMockfileexecutorByFileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["UpdateDrsMockfileexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateDrsMockfileexecutorByFileexecutorPtrIdArgs,
      "input"
    >
  >;
  updateEulaVersionById?: Resolver<
    Maybe<ResolversTypes["UpdateEulaVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateEulaVersionByIdArgs, "input">
  >;
  updateEulaVersionByVersion?: Resolver<
    Maybe<ResolversTypes["UpdateEulaVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateEulaVersionByVersionArgs, "input">
  >;
  updateEulaVersionUserAcceptanceById?: Resolver<
    Maybe<ResolversTypes["UpdateEulaVersionUserAcceptancePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateEulaVersionUserAcceptanceByIdArgs, "input">
  >;
  updateEulaVersionUserAcceptanceByUserIdAndEulaVersionId?: Resolver<
    Maybe<ResolversTypes["UpdateEulaVersionUserAcceptancePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateEulaVersionUserAcceptanceByUserIdAndEulaVersionIdArgs,
      "input"
    >
  >;
  updateFeatureFlagById?: Resolver<
    Maybe<ResolversTypes["UpdateFeatureFlagPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateFeatureFlagByIdArgs, "input">
  >;
  updateFeatureFlagByName?: Resolver<
    Maybe<ResolversTypes["UpdateFeatureFlagPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateFeatureFlagByNameArgs, "input">
  >;
  updateFeatureFlagsGroupByFeatureflagIdAndGroupId?: Resolver<
    Maybe<ResolversTypes["UpdateFeatureFlagsGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateFeatureFlagsGroupByFeatureflagIdAndGroupIdArgs,
      "input"
    >
  >;
  updateFeatureFlagsGroupById?: Resolver<
    Maybe<ResolversTypes["UpdateFeatureFlagsGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateFeatureFlagsGroupByIdArgs, "input">
  >;
  updateFeatureFlagsTenantByFeatureflagIdAndTenantId?: Resolver<
    Maybe<ResolversTypes["UpdateFeatureFlagsTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateFeatureFlagsTenantByFeatureflagIdAndTenantIdArgs,
      "input"
    >
  >;
  updateFeatureFlagsTenantById?: Resolver<
    Maybe<ResolversTypes["UpdateFeatureFlagsTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateFeatureFlagsTenantByIdArgs, "input">
  >;
  updateFeatureFlagsUserByFeatureflagIdAndUserId?: Resolver<
    Maybe<ResolversTypes["UpdateFeatureFlagsUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateFeatureFlagsUserByFeatureflagIdAndUserIdArgs,
      "input"
    >
  >;
  updateFeatureFlagsUserById?: Resolver<
    Maybe<ResolversTypes["UpdateFeatureFlagsUserPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateFeatureFlagsUserByIdArgs, "input">
  >;
  updateFileActivityById?: Resolver<
    Maybe<ResolversTypes["UpdateFileActivityPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateFileActivityByIdArgs, "input">
  >;
  updateFileById?: Resolver<
    Maybe<ResolversTypes["UpdateFilePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateFileByIdArgs, "input">
  >;
  updateFileByProjectIdAndReferenceId?: Resolver<
    Maybe<ResolversTypes["UpdateFilePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateFileByProjectIdAndReferenceIdArgs, "input">
  >;
  updateFileMetadatumById?: Resolver<
    Maybe<ResolversTypes["UpdateFileMetadatumPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateFileMetadatumByIdArgs, "input">
  >;
  updateFileOutputGroupById?: Resolver<
    Maybe<ResolversTypes["UpdateFileOutputGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateFileOutputGroupByIdArgs, "input">
  >;
  updateFileOutputGroupByTaskId?: Resolver<
    Maybe<ResolversTypes["UpdateFileOutputGroupPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateFileOutputGroupByTaskIdArgs, "input">
  >;
  updateFileOutputGroupMetadatumById?: Resolver<
    Maybe<ResolversTypes["UpdateFileOutputGroupMetadatumPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateFileOutputGroupMetadatumByIdArgs, "input">
  >;
  updateMetadataValueById?: Resolver<
    Maybe<ResolversTypes["UpdateMetadataValuePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateMetadataValueByIdArgs, "input">
  >;
  updateMetadatumById?: Resolver<
    Maybe<ResolversTypes["UpdateMetadatumPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateMetadatumByIdArgs, "input">
  >;
  updateNotificationById?: Resolver<
    Maybe<ResolversTypes["UpdateNotificationPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateNotificationByIdArgs, "input">
  >;
  updateOutputGroupFileById?: Resolver<
    Maybe<ResolversTypes["UpdateOutputGroupFilePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateOutputGroupFileByIdArgs, "input">
  >;
  updatePinnedToolById?: Resolver<
    Maybe<ResolversTypes["UpdatePinnedToolPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdatePinnedToolByIdArgs, "input">
  >;
  updatePinnedToolByUserIdAndToolId?: Resolver<
    Maybe<ResolversTypes["UpdatePinnedToolPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdatePinnedToolByUserIdAndToolIdArgs, "input">
  >;
  updateProjectFolderById?: Resolver<
    Maybe<ResolversTypes["UpdateProjectFolderPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateProjectFolderByIdArgs, "input">
  >;
  updateProjectTagById?: Resolver<
    Maybe<ResolversTypes["UpdateProjectTagPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateProjectTagByIdArgs, "input">
  >;
  updateRunById?: Resolver<
    Maybe<ResolversTypes["UpdateRunPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateRunByIdArgs, "input">
  >;
  updateTaskActivityById?: Resolver<
    Maybe<ResolversTypes["UpdateTaskActivityPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTaskActivityByIdArgs, "input">
  >;
  updateTaskActivityByTaskId?: Resolver<
    Maybe<ResolversTypes["UpdateTaskActivityPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTaskActivityByTaskIdArgs, "input">
  >;
  updateTaskByExecutorId?: Resolver<
    Maybe<ResolversTypes["UpdateTaskPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTaskByExecutorIdArgs, "input">
  >;
  updateTaskById?: Resolver<
    Maybe<ResolversTypes["UpdateTaskPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTaskByIdArgs, "input">
  >;
  updateTaskResourceById?: Resolver<
    Maybe<ResolversTypes["UpdateTaskResourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTaskResourceByIdArgs, "input">
  >;
  updateTaskResourceUsageById?: Resolver<
    Maybe<ResolversTypes["UpdateTaskResourceUsagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTaskResourceUsageByIdArgs, "input">
  >;
  updateTaskResourceUsageByTaskId?: Resolver<
    Maybe<ResolversTypes["UpdateTaskResourceUsagePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTaskResourceUsageByTaskIdArgs, "input">
  >;
  updateTaskSourceById?: Resolver<
    Maybe<ResolversTypes["UpdateTaskSourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTaskSourceByIdArgs, "input">
  >;
  updateTaskStatusLogById?: Resolver<
    Maybe<ResolversTypes["UpdateTaskStatusLogPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTaskStatusLogByIdArgs, "input">
  >;
  updateTaskStatusLogByTaskIdAndStatus?: Resolver<
    Maybe<ResolversTypes["UpdateTaskStatusLogPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTaskStatusLogByTaskIdAndStatusArgs, "input">
  >;
  updateTenantById?: Resolver<
    Maybe<ResolversTypes["UpdateTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTenantByIdArgs, "input">
  >;
  updateTenantByKey?: Resolver<
    Maybe<ResolversTypes["UpdateTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTenantByKeyArgs, "input">
  >;
  updateTenantByRepositoryName?: Resolver<
    Maybe<ResolversTypes["UpdateTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTenantByRepositoryNameArgs, "input">
  >;
  updateTenantBySfid?: Resolver<
    Maybe<ResolversTypes["UpdateTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTenantBySfidArgs, "input">
  >;
  updateTenantContractAllowanceById?: Resolver<
    Maybe<ResolversTypes["UpdateTenantContractAllowancePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTenantContractAllowanceByIdArgs, "input">
  >;
  updateTenantContractAllowanceByTenantContractTransactionIdAndQuotaType?: Resolver<
    Maybe<ResolversTypes["UpdateTenantContractAllowancePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeArgs,
      "input"
    >
  >;
  updateTenantContractById?: Resolver<
    Maybe<ResolversTypes["UpdateTenantContractPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTenantContractByIdArgs, "input">
  >;
  updateTenantContractByName?: Resolver<
    Maybe<ResolversTypes["UpdateTenantContractPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTenantContractByNameArgs, "input">
  >;
  updateTenantContractBySfid?: Resolver<
    Maybe<ResolversTypes["UpdateTenantContractPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTenantContractBySfidArgs, "input">
  >;
  updateTenantContractTransactionById?: Resolver<
    Maybe<ResolversTypes["UpdateTenantContractTransactionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTenantContractTransactionByIdArgs, "input">
  >;
  updateTenantMockuserexecutorByUserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["UpdateTenantMockuserexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateTenantMockuserexecutorByUserexecutorPtrIdArgs,
      "input"
    >
  >;
  updateTenantMonthlyConsumedResourceById?: Resolver<
    Maybe<ResolversTypes["UpdateTenantMonthlyConsumedResourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTenantMonthlyConsumedResourceByIdArgs, "input">
  >;
  updateTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract?: Resolver<
    Maybe<ResolversTypes["UpdateTenantMonthlyConsumedResourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractArgs,
      "input"
    >
  >;
  updateTenantUserexecutorById?: Resolver<
    Maybe<ResolversTypes["UpdateTenantUserexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTenantUserexecutorByIdArgs, "input">
  >;
  updateTesContainerimageexecutorById?: Resolver<
    Maybe<ResolversTypes["UpdateTesContainerimageexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTesContainerimageexecutorByIdArgs, "input">
  >;
  updateTesMockcontainerimageexecutorByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["UpdateTesMockcontainerimageexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateTesMockcontainerimageexecutorByContainerimageexecutorPtrIdArgs,
      "input"
    >
  >;
  updateTesMocktaskexecutorByTaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["UpdateTesMocktaskexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateTesMocktaskexecutorByTaskexecutorPtrIdArgs,
      "input"
    >
  >;
  updateTesTaskexecutorById?: Resolver<
    Maybe<ResolversTypes["UpdateTesTaskexecutorPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateTesTaskexecutorByIdArgs, "input">
  >;
  updateToolById?: Resolver<
    Maybe<ResolversTypes["UpdateToolPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateToolByIdArgs, "input">
  >;
  updateToolByProjectId?: Resolver<
    Maybe<ResolversTypes["UpdateToolPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateToolByProjectIdArgs, "input">
  >;
  updateToolParameterById?: Resolver<
    Maybe<ResolversTypes["UpdateToolParameterPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateToolParameterByIdArgs, "input">
  >;
  updateToolResourceById?: Resolver<
    Maybe<ResolversTypes["UpdateToolResourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateToolResourceByIdArgs, "input">
  >;
  updateToolResourceByTypeAndToolVersionId?: Resolver<
    Maybe<ResolversTypes["UpdateToolResourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateToolResourceByTypeAndToolVersionIdArgs, "input">
  >;
  updateToolResultById?: Resolver<
    Maybe<ResolversTypes["UpdateToolResultPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateToolResultByIdArgs, "input">
  >;
  updateToolSecretById?: Resolver<
    Maybe<ResolversTypes["UpdateToolSecretPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateToolSecretByIdArgs, "input">
  >;
  updateToolSourceById?: Resolver<
    Maybe<ResolversTypes["UpdateToolSourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateToolSourceByIdArgs, "input">
  >;
  updateToolTenantById?: Resolver<
    Maybe<ResolversTypes["UpdateToolTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateToolTenantByIdArgs, "input">
  >;
  updateToolTenantByToolIdAndTenantId?: Resolver<
    Maybe<ResolversTypes["UpdateToolTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateToolTenantByToolIdAndTenantIdArgs, "input">
  >;
  updateToolVersionById?: Resolver<
    Maybe<ResolversTypes["UpdateToolVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateToolVersionByIdArgs, "input">
  >;
  updateToolboxById?: Resolver<
    Maybe<ResolversTypes["UpdateToolboxPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateToolboxByIdArgs, "input">
  >;
  updateToolboxByKey?: Resolver<
    Maybe<ResolversTypes["UpdateToolboxPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateToolboxByKeyArgs, "input">
  >;
  updateToolboxTenantById?: Resolver<
    Maybe<ResolversTypes["UpdateToolboxTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateToolboxTenantByIdArgs, "input">
  >;
  updateToolboxTenantByToolboxIdAndTenantId?: Resolver<
    Maybe<ResolversTypes["UpdateToolboxTenantPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateToolboxTenantByToolboxIdAndTenantIdArgs,
      "input"
    >
  >;
  updateUserPersonalSpaceRequestById?: Resolver<
    Maybe<ResolversTypes["UpdateUserPersonalSpaceRequestPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateUserPersonalSpaceRequestByIdArgs, "input">
  >;
  updateWaffleFlagById?: Resolver<
    Maybe<ResolversTypes["UpdateWaffleFlagPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateWaffleFlagByIdArgs, "input">
  >;
  updateWaffleFlagByName?: Resolver<
    Maybe<ResolversTypes["UpdateWaffleFlagPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateWaffleFlagByNameArgs, "input">
  >;
  updateWaffleSampleById?: Resolver<
    Maybe<ResolversTypes["UpdateWaffleSamplePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateWaffleSampleByIdArgs, "input">
  >;
  updateWaffleSampleByName?: Resolver<
    Maybe<ResolversTypes["UpdateWaffleSamplePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateWaffleSampleByNameArgs, "input">
  >;
  updateWaffleSwitchById?: Resolver<
    Maybe<ResolversTypes["UpdateWaffleSwitchPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateWaffleSwitchByIdArgs, "input">
  >;
  updateWaffleSwitchByName?: Resolver<
    Maybe<ResolversTypes["UpdateWaffleSwitchPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateWaffleSwitchByNameArgs, "input">
  >;
  updateWorkflowById?: Resolver<
    Maybe<ResolversTypes["UpdateWorkflowPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateWorkflowByIdArgs, "input">
  >;
  updateWorkflowDatumById?: Resolver<
    Maybe<ResolversTypes["UpdateWorkflowDatumPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateWorkflowDatumByIdArgs, "input">
  >;
  updateWorkflowResultById?: Resolver<
    Maybe<ResolversTypes["UpdateWorkflowResultPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateWorkflowResultByIdArgs, "input">
  >;
  updateWorkflowResultWorkflowVersionById?: Resolver<
    Maybe<ResolversTypes["UpdateWorkflowResultWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateWorkflowResultWorkflowVersionByIdArgs, "input">
  >;
  updateWorkflowResultWorkflowVersionByResultIdAndWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["UpdateWorkflowResultWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdArgs,
      "input"
    >
  >;
  updateWorkflowSectionBlockById?: Resolver<
    Maybe<ResolversTypes["UpdateWorkflowSectionBlockPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateWorkflowSectionBlockByIdArgs, "input">
  >;
  updateWorkflowSectionBlockSectionByBlockIdAndSectionId?: Resolver<
    Maybe<ResolversTypes["UpdateWorkflowSectionBlockSectionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateWorkflowSectionBlockSectionByBlockIdAndSectionIdArgs,
      "input"
    >
  >;
  updateWorkflowSectionBlockSectionById?: Resolver<
    Maybe<ResolversTypes["UpdateWorkflowSectionBlockSectionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateWorkflowSectionBlockSectionByIdArgs, "input">
  >;
  updateWorkflowSectionById?: Resolver<
    Maybe<ResolversTypes["UpdateWorkflowSectionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateWorkflowSectionByIdArgs, "input">
  >;
  updateWorkflowSectionWorkflowVersionById?: Resolver<
    Maybe<ResolversTypes["UpdateWorkflowSectionWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateWorkflowSectionWorkflowVersionByIdArgs, "input">
  >;
  updateWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["UpdateWorkflowSectionWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdArgs,
      "input"
    >
  >;
  updateWorkflowSourceById?: Resolver<
    Maybe<ResolversTypes["UpdateWorkflowSourcePayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateWorkflowSourceByIdArgs, "input">
  >;
  updateWorkflowSourceWorkflowVersionById?: Resolver<
    Maybe<ResolversTypes["UpdateWorkflowSourceWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateWorkflowSourceWorkflowVersionByIdArgs, "input">
  >;
  updateWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["UpdateWorkflowSourceWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<
      MutationUpdateWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdArgs,
      "input"
    >
  >;
  updateWorkflowVersionById?: Resolver<
    Maybe<ResolversTypes["UpdateWorkflowVersionPayload"]>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateWorkflowVersionByIdArgs, "input">
  >;
};

export type NotificationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Notification"] = ResolversParentTypes["Notification"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  fileProcessingNotificationById?: Resolver<
    Maybe<ResolversTypes["FileProcessingNotification"]>,
    ParentType,
    ContextType
  >;
  fileProcessingNotificationsById?: Resolver<
    ResolversTypes["FileProcessingNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<NotificationFileProcessingNotificationsByIdArgs, "orderBy">
  >;
  hasSeen?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  projectClonedNotificationById?: Resolver<
    Maybe<ResolversTypes["ProjectClonedNotification"]>,
    ParentType,
    ContextType
  >;
  projectClonedNotificationsById?: Resolver<
    ResolversTypes["ProjectClonedNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<NotificationProjectClonedNotificationsByIdArgs, "orderBy">
  >;
  projectSharedNotificationById?: Resolver<
    Maybe<ResolversTypes["ProjectSharedNotification"]>,
    ParentType,
    ContextType
  >;
  projectSharedNotificationsById?: Resolver<
    ResolversTypes["ProjectSharedNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<NotificationProjectSharedNotificationsByIdArgs, "orderBy">
  >;
  roleChangeNotificationById?: Resolver<
    Maybe<ResolversTypes["RoleChangeNotification"]>,
    ParentType,
    ContextType
  >;
  roleChangeNotificationsById?: Resolver<
    ResolversTypes["RoleChangeNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<NotificationRoleChangeNotificationsByIdArgs, "orderBy">
  >;
  tenantUserMembershipNotificationById?: Resolver<
    Maybe<ResolversTypes["TenantUserMembershipNotification"]>,
    ParentType,
    ContextType
  >;
  tenantUserMembershipNotificationsById?: Resolver<
    ResolversTypes["TenantUserMembershipNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      NotificationTenantUserMembershipNotificationsByIdArgs,
      "orderBy"
    >
  >;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["NotificationsConnection"] = ResolversParentTypes["NotificationsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["NotificationsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["Notification"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["NotificationsEdge"] = ResolversParentTypes["NotificationsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["Notification"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OutputGroupFileResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["OutputGroupFile"] = ResolversParentTypes["OutputGroupFile"],
> = {
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  fileByFileId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  fileId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  fileOutputGroupByFileOutputGroupId?: Resolver<
    Maybe<ResolversTypes["FileOutputGroup"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroupId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OutputGroupFilesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["OutputGroupFilesConnection"] = ResolversParentTypes["OutputGroupFilesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["OutputGroupFilesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["OutputGroupFile"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OutputGroupFilesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["OutputGroupFilesEdge"] = ResolversParentTypes["OutputGroupFilesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["OutputGroupFile"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["PageInfo"] = ResolversParentTypes["PageInfo"],
> = {
  endCursor?: Resolver<
    Maybe<ResolversTypes["Cursor"]>,
    ParentType,
    ContextType
  >;
  hasNextPage?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  hasPreviousPage?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  startCursor?: Resolver<
    Maybe<ResolversTypes["Cursor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PinnedToolResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["PinnedTool"] = ResolversParentTypes["PinnedTool"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  toolByToolId?: Resolver<
    Maybe<ResolversTypes["Tool"]>,
    ParentType,
    ContextType
  >;
  toolId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PinnedToolsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["PinnedToolsConnection"] = ResolversParentTypes["PinnedToolsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["PinnedToolsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["PinnedTool"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PinnedToolsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["PinnedToolsEdge"] = ResolversParentTypes["PinnedToolsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["PinnedTool"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Project"] = ResolversParentTypes["Project"],
> = {
  activeFiles?: Resolver<
    ResolversTypes["FilesConnection"],
    ParentType,
    ContextType,
    Partial<ProjectActiveFilesArgs>
  >;
  activeStorageSize?: Resolver<
    Maybe<ResolversTypes["BigInt"]>,
    ParentType,
    ContextType
  >;
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  archivedStorageSize?: Resolver<
    Maybe<ResolversTypes["BigInt"]>,
    ParentType,
    ContextType
  >;
  cloneSourceId?: Resolver<
    Maybe<ResolversTypes["UUID"]>,
    ParentType,
    ContextType
  >;
  dataTableCellsByProjectId?: Resolver<
    ResolversTypes["DataTableCellsConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectDataTableCellsByProjectIdArgs, "orderBy">
  >;
  dataTableColumnDefinitionBooleansByProjectId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionBooleansConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ProjectDataTableColumnDefinitionBooleansByProjectIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionCellStatusesByProjectId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionCellStatusesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ProjectDataTableColumnDefinitionCellStatusesByProjectIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionChoicesByProjectId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionChoicesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ProjectDataTableColumnDefinitionChoicesByProjectIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionDatesByProjectId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionDatesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ProjectDataTableColumnDefinitionDatesByProjectIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionFilesByProjectId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionFilesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ProjectDataTableColumnDefinitionFilesByProjectIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionFloatsByProjectId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionFloatsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ProjectDataTableColumnDefinitionFloatsByProjectIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionIdentifiersByProjectId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionIdentifiersConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ProjectDataTableColumnDefinitionIdentifiersByProjectIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionIntegersByProjectId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionIntegersConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ProjectDataTableColumnDefinitionIntegersByProjectIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionJoinsByProjectId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionJoinsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ProjectDataTableColumnDefinitionJoinsByProjectIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionMetadataByProjectId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionMetadataConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ProjectDataTableColumnDefinitionMetadataByProjectIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionRoiFramesByProjectId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionRoiFramesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ProjectDataTableColumnDefinitionRoiFramesByProjectIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnDefinitionTextsByProjectId?: Resolver<
    ResolversTypes["DataTableColumnDefinitionTextsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ProjectDataTableColumnDefinitionTextsByProjectIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnGroupDefinitionJoinsByProjectId?: Resolver<
    ResolversTypes["DataTableColumnGroupDefinitionJoinsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ProjectDataTableColumnGroupDefinitionJoinsByProjectIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnGroupDefinitionSourcesByProjectId?: Resolver<
    ResolversTypes["DataTableColumnGroupDefinitionSourcesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ProjectDataTableColumnGroupDefinitionSourcesByProjectIdArgs,
      "orderBy"
    >
  >;
  dataTableColumnGroupsByProjectId?: Resolver<
    ResolversTypes["DataTableColumnGroupsConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectDataTableColumnGroupsByProjectIdArgs, "orderBy">
  >;
  dataTableColumnsByProjectId?: Resolver<
    ResolversTypes["DataTableColumnsConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectDataTableColumnsByProjectIdArgs, "orderBy">
  >;
  dataTableRowsByProjectId?: Resolver<
    ResolversTypes["DataTableRowsConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectDataTableRowsByProjectIdArgs, "orderBy">
  >;
  dataTablesByProjectId?: Resolver<
    ResolversTypes["DataTablesConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectDataTablesByProjectIdArgs, "orderBy">
  >;
  dateArchived?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  dateDataDeleted?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  dateDeleted?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  dateLastActive?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  defaultUserAccessLevel?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  description?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  fileActivitiesByProjectId?: Resolver<
    ResolversTypes["FileActivitiesConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectFileActivitiesByProjectIdArgs, "orderBy">
  >;
  fileMetadataByProjectId?: Resolver<
    ResolversTypes["FileMetadataConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectFileMetadataByProjectIdArgs, "orderBy">
  >;
  fileOutputGroupMetadataByProjectId?: Resolver<
    ResolversTypes["FileOutputGroupMetadataConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectFileOutputGroupMetadataByProjectIdArgs, "orderBy">
  >;
  fileOutputGroupsByProjectId?: Resolver<
    ResolversTypes["FileOutputGroupsConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectFileOutputGroupsByProjectIdArgs, "orderBy">
  >;
  filesByProjectId?: Resolver<
    ResolversTypes["FilesConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectFilesByProjectIdArgs, "orderBy">
  >;
  gdtAnalysisTableCellsByProjectId?: Resolver<
    ResolversTypes["GdtAnalysisTableCellsConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectGdtAnalysisTableCellsByProjectIdArgs, "orderBy">
  >;
  gdtAnalysisTableColumnGroupsByProjectId?: Resolver<
    ResolversTypes["GdtAnalysisTableColumnGroupsConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectGdtAnalysisTableColumnGroupsByProjectIdArgs, "orderBy">
  >;
  gdtAnalysisTableColumnsByProjectId?: Resolver<
    ResolversTypes["GdtAnalysisTableColumnsConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectGdtAnalysisTableColumnsByProjectIdArgs, "orderBy">
  >;
  gdtAnalysisTableRowsByProjectId?: Resolver<
    ResolversTypes["GdtAnalysisTableRowsConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectGdtAnalysisTableRowsByProjectIdArgs, "orderBy">
  >;
  gdtAnalysisTablesByProjectId?: Resolver<
    ResolversTypes["GdtAnalysisTablesConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectGdtAnalysisTablesByProjectIdArgs, "orderBy">
  >;
  icon?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  iconColor?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  iconText?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  isDemo?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  isToolProject?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  metadataByProjectId?: Resolver<
    ResolversTypes["MetadataConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectMetadataByProjectIdArgs, "orderBy">
  >;
  metadataValuesByProjectId?: Resolver<
    ResolversTypes["MetadataValuesConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectMetadataValuesByProjectIdArgs, "orderBy">
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  outputGroupFilesByProjectId?: Resolver<
    ResolversTypes["OutputGroupFilesConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectOutputGroupFilesByProjectIdArgs, "orderBy">
  >;
  pinned?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  prefix?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  projectByCloneSourceId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectClonedNotificationsByProjectId?: Resolver<
    ResolversTypes["ProjectClonedNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectProjectClonedNotificationsByProjectIdArgs, "orderBy">
  >;
  projectClonedNotificationsBySrcProjectId?: Resolver<
    ResolversTypes["ProjectClonedNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      ProjectProjectClonedNotificationsBySrcProjectIdArgs,
      "orderBy"
    >
  >;
  projectFoldersByProjectId?: Resolver<
    ResolversTypes["ProjectFoldersConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectProjectFoldersByProjectIdArgs, "orderBy">
  >;
  projectSharedNotificationsByProjectId?: Resolver<
    ResolversTypes["ProjectSharedNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectProjectSharedNotificationsByProjectIdArgs, "orderBy">
  >;
  projectTagsByProjectId?: Resolver<
    ResolversTypes["ProjectTagsConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectProjectTagsByProjectIdArgs, "orderBy">
  >;
  projectsByCloneSourceId?: Resolver<
    ResolversTypes["ProjectsConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectProjectsByCloneSourceIdArgs, "orderBy">
  >;
  shortDescription?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  status?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tasksByProjectId?: Resolver<
    ResolversTypes["TasksConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectTasksByProjectIdArgs, "orderBy">
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  toolByProjectId?: Resolver<
    Maybe<ResolversTypes["Tool"]>,
    ParentType,
    ContextType
  >;
  toolsByProjectId?: Resolver<
    ResolversTypes["ToolsConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectToolsByProjectIdArgs, "orderBy">
  >;
  tourType?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  usedCredits?: Resolver<
    Maybe<ResolversTypes["Float"]>,
    ParentType,
    ContextType
  >;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectClonedNotificationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProjectClonedNotification"] = ResolversParentTypes["ProjectClonedNotification"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  notificationById?: Resolver<
    Maybe<ResolversTypes["Notification"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectBySrcProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  projectName?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  srcProjectId?: Resolver<
    Maybe<ResolversTypes["UUID"]>,
    ParentType,
    ContextType
  >;
  succeeded?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectClonedNotificationsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProjectClonedNotificationsConnection"] = ResolversParentTypes["ProjectClonedNotificationsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ProjectClonedNotificationsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ProjectClonedNotification"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectClonedNotificationsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProjectClonedNotificationsEdge"] = ResolversParentTypes["ProjectClonedNotificationsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["ProjectClonedNotification"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectFolderResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProjectFolder"] = ResolversParentTypes["ProjectFolder"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  color?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  dataTablesByFolderId?: Resolver<
    ResolversTypes["DataTablesConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectFolderDataTablesByFolderIdArgs, "orderBy">
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  gdtAnalysisTablesByFolderId?: Resolver<
    ResolversTypes["GdtAnalysisTablesConnection"],
    ParentType,
    ContextType,
    RequireFields<ProjectFolderGdtAnalysisTablesByFolderIdArgs, "orderBy">
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectFoldersConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProjectFoldersConnection"] = ResolversParentTypes["ProjectFoldersConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ProjectFoldersEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ProjectFolder"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectFoldersEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProjectFoldersEdge"] = ResolversParentTypes["ProjectFoldersEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["ProjectFolder"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectSharedNotificationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProjectSharedNotification"] = ResolversParentTypes["ProjectSharedNotification"],
> = {
  accessLevel?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  applicationUserBySharerId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  notificationById?: Resolver<
    Maybe<ResolversTypes["Notification"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  sharerId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectSharedNotificationsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProjectSharedNotificationsConnection"] = ResolversParentTypes["ProjectSharedNotificationsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ProjectSharedNotificationsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ProjectSharedNotification"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectSharedNotificationsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProjectSharedNotificationsEdge"] = ResolversParentTypes["ProjectSharedNotificationsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["ProjectSharedNotification"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectTagResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProjectTag"] = ResolversParentTypes["ProjectTag"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  label?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectTagsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProjectTagsConnection"] = ResolversParentTypes["ProjectTagsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ProjectTagsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ProjectTag"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectTagsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProjectTagsEdge"] = ResolversParentTypes["ProjectTagsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["ProjectTag"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProjectsConnection"] = ResolversParentTypes["ProjectsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ProjectsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<Array<ResolversTypes["Project"]>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ProjectsEdge"] = ResolversParentTypes["ProjectsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["Project"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Query"] = ResolversParentTypes["Query"],
> = {
  allAdminProjects?: Resolver<
    Maybe<ResolversTypes["AdminProjectsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllAdminProjectsArgs, "orderBy">
  >;
  allApplicationUserGroups?: Resolver<
    Maybe<ResolversTypes["ApplicationUserGroupsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllApplicationUserGroupsArgs, "orderBy">
  >;
  allApplicationUserMemberships?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMembershipsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllApplicationUserMembershipsArgs, "orderBy">
  >;
  allApplicationUserMetadata?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMetadataConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllApplicationUserMetadataArgs, "orderBy">
  >;
  allApplicationUserSessions?: Resolver<
    Maybe<ResolversTypes["ApplicationUserSessionsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllApplicationUserSessionsArgs, "orderBy">
  >;
  allApplicationUserUserPermissions?: Resolver<
    Maybe<ResolversTypes["ApplicationUserUserPermissionsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllApplicationUserUserPermissionsArgs, "orderBy">
  >;
  allAuditlogLogentries?: Resolver<
    Maybe<ResolversTypes["AuditlogLogentriesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllAuditlogLogentriesArgs, "orderBy">
  >;
  allAuthGroupPermissions?: Resolver<
    Maybe<ResolversTypes["AuthGroupPermissionsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllAuthGroupPermissionsArgs, "orderBy">
  >;
  allAuthGroups?: Resolver<
    Maybe<ResolversTypes["AuthGroupsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllAuthGroupsArgs, "orderBy">
  >;
  allAuthPermissions?: Resolver<
    Maybe<ResolversTypes["AuthPermissionsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllAuthPermissionsArgs, "orderBy">
  >;
  allAvailableNonRestrictedProjects?: Resolver<
    Maybe<ResolversTypes["AvailableNonRestrictedProjectsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllAvailableNonRestrictedProjectsArgs, "orderBy">
  >;
  allAvatars?: Resolver<
    Maybe<ResolversTypes["AvatarsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllAvatarsArgs, "orderBy">
  >;
  allAwsBatchTasks?: Resolver<
    Maybe<ResolversTypes["AwsBatchTasksConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllAwsBatchTasksArgs, "orderBy">
  >;
  allAwsCognitoUsers?: Resolver<
    Maybe<ResolversTypes["AwsCognitoUsersConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllAwsCognitoUsersArgs, "orderBy">
  >;
  allAwsEcrImages?: Resolver<
    Maybe<ResolversTypes["AwsEcrImagesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllAwsEcrImagesArgs, "orderBy">
  >;
  allAwsMockBatchTasks?: Resolver<
    Maybe<ResolversTypes["AwsMockBatchTasksConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllAwsMockBatchTasksArgs, "orderBy">
  >;
  allAwsMockDistributionImages?: Resolver<
    Maybe<ResolversTypes["AwsMockDistributionImagesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllAwsMockDistributionImagesArgs, "orderBy">
  >;
  allAwsMockEcrImages?: Resolver<
    Maybe<ResolversTypes["AwsMockEcrImagesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllAwsMockEcrImagesArgs, "orderBy">
  >;
  allAwsMockIamUsers?: Resolver<
    Maybe<ResolversTypes["AwsMockIamUsersConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllAwsMockIamUsersArgs, "orderBy">
  >;
  allAwsMockS3Files?: Resolver<
    Maybe<ResolversTypes["AwsMockS3FilesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllAwsMockS3FilesArgs, "orderBy">
  >;
  allAwsS3Files?: Resolver<
    Maybe<ResolversTypes["AwsS3FilesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllAwsS3FilesArgs, "orderBy">
  >;
  allCodeFiles?: Resolver<
    Maybe<ResolversTypes["CodeFilesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllCodeFilesArgs, "orderBy">
  >;
  allCommands?: Resolver<
    Maybe<ResolversTypes["CommandsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllCommandsArgs, "orderBy">
  >;
  allContainerImageRepositories?: Resolver<
    Maybe<ResolversTypes["ContainerImageRepositoriesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllContainerImageRepositoriesArgs, "orderBy">
  >;
  allContainerImages?: Resolver<
    Maybe<ResolversTypes["ContainerImagesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllContainerImagesArgs, "orderBy">
  >;
  allCosts?: Resolver<
    Maybe<ResolversTypes["CostsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllCostsArgs, "orderBy">
  >;
  allCurrentApplicationUsers?: Resolver<
    Maybe<ResolversTypes["CurrentApplicationUsersConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllCurrentApplicationUsersArgs, "orderBy">
  >;
  allCurrentUserMemberships?: Resolver<
    Maybe<ResolversTypes["CurrentUserMembershipsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllCurrentUserMembershipsArgs, "orderBy">
  >;
  allDataTableCells?: Resolver<
    Maybe<ResolversTypes["DataTableCellsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableCellsArgs, "orderBy">
  >;
  allDataTableColumnDefinitionBooleans?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionBooleansConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableColumnDefinitionBooleansArgs, "orderBy">
  >;
  allDataTableColumnDefinitionCellStatuses?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionCellStatusesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableColumnDefinitionCellStatusesArgs, "orderBy">
  >;
  allDataTableColumnDefinitionChoices?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionChoicesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableColumnDefinitionChoicesArgs, "orderBy">
  >;
  allDataTableColumnDefinitionDates?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionDatesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableColumnDefinitionDatesArgs, "orderBy">
  >;
  allDataTableColumnDefinitionFiles?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionFilesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableColumnDefinitionFilesArgs, "orderBy">
  >;
  allDataTableColumnDefinitionFloats?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionFloatsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableColumnDefinitionFloatsArgs, "orderBy">
  >;
  allDataTableColumnDefinitionIdentifiers?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionIdentifiersConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableColumnDefinitionIdentifiersArgs, "orderBy">
  >;
  allDataTableColumnDefinitionIntegers?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionIntegersConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableColumnDefinitionIntegersArgs, "orderBy">
  >;
  allDataTableColumnDefinitionJoins?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionJoinsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableColumnDefinitionJoinsArgs, "orderBy">
  >;
  allDataTableColumnDefinitionMetadata?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionMetadataConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableColumnDefinitionMetadataArgs, "orderBy">
  >;
  allDataTableColumnDefinitionRoiFrames?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionRoiFramesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableColumnDefinitionRoiFramesArgs, "orderBy">
  >;
  allDataTableColumnDefinitionTexts?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionTextsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableColumnDefinitionTextsArgs, "orderBy">
  >;
  allDataTableColumnGroupDefinitionJoins?: Resolver<
    Maybe<ResolversTypes["DataTableColumnGroupDefinitionJoinsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableColumnGroupDefinitionJoinsArgs, "orderBy">
  >;
  allDataTableColumnGroupDefinitionSources?: Resolver<
    Maybe<ResolversTypes["DataTableColumnGroupDefinitionSourcesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableColumnGroupDefinitionSourcesArgs, "orderBy">
  >;
  allDataTableColumnGroups?: Resolver<
    Maybe<ResolversTypes["DataTableColumnGroupsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableColumnGroupsArgs, "orderBy">
  >;
  allDataTableColumns?: Resolver<
    Maybe<ResolversTypes["DataTableColumnsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableColumnsArgs, "orderBy">
  >;
  allDataTableRows?: Resolver<
    Maybe<ResolversTypes["DataTableRowsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTableRowsArgs, "orderBy">
  >;
  allDataTables?: Resolver<
    Maybe<ResolversTypes["DataTablesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDataTablesArgs, "orderBy">
  >;
  allDistributionRegistryImages?: Resolver<
    Maybe<ResolversTypes["DistributionRegistryImagesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDistributionRegistryImagesArgs, "orderBy">
  >;
  allDjangoAdminLogs?: Resolver<
    Maybe<ResolversTypes["DjangoAdminLogsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDjangoAdminLogsArgs, "orderBy">
  >;
  allDjangoContentTypes?: Resolver<
    Maybe<ResolversTypes["DjangoContentTypesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDjangoContentTypesArgs, "orderBy">
  >;
  allDjangoMigrations?: Resolver<
    Maybe<ResolversTypes["DjangoMigrationsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDjangoMigrationsArgs, "orderBy">
  >;
  allDjangoSesBlacklistedemails?: Resolver<
    Maybe<ResolversTypes["DjangoSesBlacklistedemailsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDjangoSesBlacklistedemailsArgs, "orderBy">
  >;
  allDjangoSesSesstats?: Resolver<
    Maybe<ResolversTypes["DjangoSesSesstatsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDjangoSesSesstatsArgs, "orderBy">
  >;
  allDjangoSessions?: Resolver<
    Maybe<ResolversTypes["DjangoSessionsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDjangoSessionsArgs, "orderBy">
  >;
  allDrsFileexecutors?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutorsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDrsFileexecutorsArgs, "orderBy">
  >;
  allDrsMockfileexecutors?: Resolver<
    Maybe<ResolversTypes["DrsMockfileexecutorsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllDrsMockfileexecutorsArgs, "orderBy">
  >;
  allEulaVersionUserAcceptances?: Resolver<
    Maybe<ResolversTypes["EulaVersionUserAcceptancesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllEulaVersionUserAcceptancesArgs, "orderBy">
  >;
  allEulaVersions?: Resolver<
    Maybe<ResolversTypes["EulaVersionsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllEulaVersionsArgs, "orderBy">
  >;
  allFeatureFlags?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllFeatureFlagsArgs, "orderBy">
  >;
  allFeatureFlagsGroups?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsGroupsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllFeatureFlagsGroupsArgs, "orderBy">
  >;
  allFeatureFlagsTenants?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsTenantsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllFeatureFlagsTenantsArgs, "orderBy">
  >;
  allFeatureFlagsUsers?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsUsersConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllFeatureFlagsUsersArgs, "orderBy">
  >;
  allFileActivities?: Resolver<
    Maybe<ResolversTypes["FileActivitiesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllFileActivitiesArgs, "orderBy">
  >;
  allFileMetadata?: Resolver<
    Maybe<ResolversTypes["FileMetadataConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllFileMetadataArgs, "orderBy">
  >;
  allFileOutputGroupMetadata?: Resolver<
    Maybe<ResolversTypes["FileOutputGroupMetadataConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllFileOutputGroupMetadataArgs, "orderBy">
  >;
  allFileOutputGroups?: Resolver<
    Maybe<ResolversTypes["FileOutputGroupsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllFileOutputGroupsArgs, "orderBy">
  >;
  allFileProcessingNotifications?: Resolver<
    Maybe<ResolversTypes["FileProcessingNotificationsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllFileProcessingNotificationsArgs, "orderBy">
  >;
  allFiles?: Resolver<
    Maybe<ResolversTypes["FilesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllFilesArgs, "orderBy">
  >;
  allFilesByExecutors?: Resolver<
    Maybe<ResolversTypes["FilesByExecutorsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllFilesByExecutorsArgs, "orderBy">
  >;
  allGdtAnalysisTableCells?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTableCellsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllGdtAnalysisTableCellsArgs, "orderBy">
  >;
  allGdtAnalysisTableColumnGroups?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTableColumnGroupsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllGdtAnalysisTableColumnGroupsArgs, "orderBy">
  >;
  allGdtAnalysisTableColumns?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTableColumnsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllGdtAnalysisTableColumnsArgs, "orderBy">
  >;
  allGdtAnalysisTableRows?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTableRowsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllGdtAnalysisTableRowsArgs, "orderBy">
  >;
  allGdtAnalysisTables?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTablesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllGdtAnalysisTablesArgs, "orderBy">
  >;
  allNotifications?: Resolver<
    Maybe<ResolversTypes["NotificationsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllNotificationsArgs, "orderBy">
  >;
  allOutputGroupFiles?: Resolver<
    Maybe<ResolversTypes["OutputGroupFilesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllOutputGroupFilesArgs, "orderBy">
  >;
  allPinnedTools?: Resolver<
    Maybe<ResolversTypes["PinnedToolsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllPinnedToolsArgs, "orderBy">
  >;
  allProjectClonedNotifications?: Resolver<
    Maybe<ResolversTypes["ProjectClonedNotificationsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllProjectClonedNotificationsArgs, "orderBy">
  >;
  allProjectFolders?: Resolver<
    Maybe<ResolversTypes["ProjectFoldersConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllProjectFoldersArgs, "orderBy">
  >;
  allProjectSharedNotifications?: Resolver<
    Maybe<ResolversTypes["ProjectSharedNotificationsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllProjectSharedNotificationsArgs, "orderBy">
  >;
  allProjectTags?: Resolver<
    Maybe<ResolversTypes["ProjectTagsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllProjectTagsArgs, "orderBy">
  >;
  allProjects?: Resolver<
    Maybe<ResolversTypes["ProjectsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllProjectsArgs, "orderBy">
  >;
  allRoleChangeNotifications?: Resolver<
    Maybe<ResolversTypes["RoleChangeNotificationsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllRoleChangeNotificationsArgs, "orderBy">
  >;
  allRuns?: Resolver<
    Maybe<ResolversTypes["RunsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllRunsArgs, "orderBy">
  >;
  allTaskActivities?: Resolver<
    Maybe<ResolversTypes["TaskActivitiesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTaskActivitiesArgs, "orderBy">
  >;
  allTaskResourceUsages?: Resolver<
    Maybe<ResolversTypes["TaskResourceUsagesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTaskResourceUsagesArgs, "orderBy">
  >;
  allTaskResources?: Resolver<
    Maybe<ResolversTypes["TaskResourcesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTaskResourcesArgs, "orderBy">
  >;
  allTaskSources?: Resolver<
    Maybe<ResolversTypes["TaskSourcesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTaskSourcesArgs, "orderBy">
  >;
  allTaskStatusLogs?: Resolver<
    Maybe<ResolversTypes["TaskStatusLogsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTaskStatusLogsArgs, "orderBy">
  >;
  allTasks?: Resolver<
    Maybe<ResolversTypes["TasksConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTasksArgs, "orderBy">
  >;
  allTenantContractAllowances?: Resolver<
    Maybe<ResolversTypes["TenantContractAllowancesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTenantContractAllowancesArgs, "orderBy">
  >;
  allTenantContractTransactions?: Resolver<
    Maybe<ResolversTypes["TenantContractTransactionsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTenantContractTransactionsArgs, "orderBy">
  >;
  allTenantContracts?: Resolver<
    Maybe<ResolversTypes["TenantContractsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTenantContractsArgs, "orderBy">
  >;
  allTenantMockuserexecutors?: Resolver<
    Maybe<ResolversTypes["TenantMockuserexecutorsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTenantMockuserexecutorsArgs, "orderBy">
  >;
  allTenantMonthlyConsumedResources?: Resolver<
    Maybe<ResolversTypes["TenantMonthlyConsumedResourcesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTenantMonthlyConsumedResourcesArgs, "orderBy">
  >;
  allTenantUserMembershipNotifications?: Resolver<
    Maybe<ResolversTypes["TenantUserMembershipNotificationsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTenantUserMembershipNotificationsArgs, "orderBy">
  >;
  allTenantUserexecutors?: Resolver<
    Maybe<ResolversTypes["TenantUserexecutorsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTenantUserexecutorsArgs, "orderBy">
  >;
  allTesContainerimageexecutors?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutorsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTesContainerimageexecutorsArgs, "orderBy">
  >;
  allTesMockcontainerimageexecutors?: Resolver<
    Maybe<ResolversTypes["TesMockcontainerimageexecutorsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTesMockcontainerimageexecutorsArgs, "orderBy">
  >;
  allTesMocktaskexecutors?: Resolver<
    Maybe<ResolversTypes["TesMocktaskexecutorsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTesMocktaskexecutorsArgs, "orderBy">
  >;
  allTesTaskexecutors?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutorsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllTesTaskexecutorsArgs, "orderBy">
  >;
  allToolParameters?: Resolver<
    Maybe<ResolversTypes["ToolParametersConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllToolParametersArgs, "orderBy">
  >;
  allToolResources?: Resolver<
    Maybe<ResolversTypes["ToolResourcesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllToolResourcesArgs, "orderBy">
  >;
  allToolResults?: Resolver<
    Maybe<ResolversTypes["ToolResultsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllToolResultsArgs, "orderBy">
  >;
  allToolSecrets?: Resolver<
    Maybe<ResolversTypes["ToolSecretsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllToolSecretsArgs, "orderBy">
  >;
  allToolSources?: Resolver<
    Maybe<ResolversTypes["ToolSourcesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllToolSourcesArgs, "orderBy">
  >;
  allToolTenants?: Resolver<
    Maybe<ResolversTypes["ToolTenantsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllToolTenantsArgs, "orderBy">
  >;
  allToolVersions?: Resolver<
    Maybe<ResolversTypes["ToolVersionsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllToolVersionsArgs, "orderBy">
  >;
  allToolboxTenants?: Resolver<
    Maybe<ResolversTypes["ToolboxTenantsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllToolboxTenantsArgs, "orderBy">
  >;
  allToolboxes?: Resolver<
    Maybe<ResolversTypes["ToolboxesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllToolboxesArgs, "orderBy">
  >;
  allTools?: Resolver<
    Maybe<ResolversTypes["ToolsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllToolsArgs, "orderBy">
  >;
  allUserAccessToProjects?: Resolver<
    Maybe<ResolversTypes["UserAccessToProjectsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllUserAccessToProjectsArgs, "orderBy">
  >;
  allUserOnboardingQuestionAnswers?: Resolver<
    Maybe<ResolversTypes["UserOnboardingQuestionAnswersConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllUserOnboardingQuestionAnswersArgs, "orderBy">
  >;
  allUserOnboardingQuestionResponses?: Resolver<
    Maybe<ResolversTypes["UserOnboardingQuestionResponsesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllUserOnboardingQuestionResponsesArgs, "orderBy">
  >;
  allUserOnboardingQuestions?: Resolver<
    Maybe<ResolversTypes["UserOnboardingQuestionsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllUserOnboardingQuestionsArgs, "orderBy">
  >;
  allWaffleFlags?: Resolver<
    Maybe<ResolversTypes["WaffleFlagsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllWaffleFlagsArgs, "orderBy">
  >;
  allWaffleSamples?: Resolver<
    Maybe<ResolversTypes["WaffleSamplesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllWaffleSamplesArgs, "orderBy">
  >;
  allWaffleSwitches?: Resolver<
    Maybe<ResolversTypes["WaffleSwitchesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllWaffleSwitchesArgs, "orderBy">
  >;
  allWorkflowData?: Resolver<
    Maybe<ResolversTypes["WorkflowDataConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllWorkflowDataArgs, "orderBy">
  >;
  allWorkflowResultWorkflowVersions?: Resolver<
    Maybe<ResolversTypes["WorkflowResultWorkflowVersionsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllWorkflowResultWorkflowVersionsArgs, "orderBy">
  >;
  allWorkflowResults?: Resolver<
    Maybe<ResolversTypes["WorkflowResultsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllWorkflowResultsArgs, "orderBy">
  >;
  allWorkflowSectionBlockSections?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlockSectionsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllWorkflowSectionBlockSectionsArgs, "orderBy">
  >;
  allWorkflowSectionBlocks?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlocksConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllWorkflowSectionBlocksArgs, "orderBy">
  >;
  allWorkflowSectionWorkflowVersions?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionWorkflowVersionsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllWorkflowSectionWorkflowVersionsArgs, "orderBy">
  >;
  allWorkflowSections?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllWorkflowSectionsArgs, "orderBy">
  >;
  allWorkflowSourceWorkflowVersions?: Resolver<
    Maybe<ResolversTypes["WorkflowSourceWorkflowVersionsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllWorkflowSourceWorkflowVersionsArgs, "orderBy">
  >;
  allWorkflowSources?: Resolver<
    Maybe<ResolversTypes["WorkflowSourcesConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllWorkflowSourcesArgs, "orderBy">
  >;
  allWorkflowVersions?: Resolver<
    Maybe<ResolversTypes["WorkflowVersionsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllWorkflowVersionsArgs, "orderBy">
  >;
  allWorkflows?: Resolver<
    Maybe<ResolversTypes["WorkflowsConnection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAllWorkflowsArgs, "orderBy">
  >;
  applicationUserByEmail?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType,
    RequireFields<QueryApplicationUserByEmailArgs, "email">
  >;
  applicationUserByGlobalUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType,
    RequireFields<QueryApplicationUserByGlobalUserIdArgs, "globalUserId">
  >;
  applicationUserById?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType,
    RequireFields<QueryApplicationUserByIdArgs, "id">
  >;
  applicationUserByUsername?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType,
    RequireFields<QueryApplicationUserByUsernameArgs, "username">
  >;
  applicationUserGroupById?: Resolver<
    Maybe<ResolversTypes["ApplicationUserGroup"]>,
    ParentType,
    ContextType,
    RequireFields<QueryApplicationUserGroupByIdArgs, "id">
  >;
  applicationUserGroupByUserIdAndGroupId?: Resolver<
    Maybe<ResolversTypes["ApplicationUserGroup"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryApplicationUserGroupByUserIdAndGroupIdArgs,
      "groupId" | "userId"
    >
  >;
  applicationUserMembershipById?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMembership"]>,
    ParentType,
    ContextType,
    RequireFields<QueryApplicationUserMembershipByIdArgs, "id">
  >;
  applicationUserMembershipByUserIdAndTenantId?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMembership"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryApplicationUserMembershipByUserIdAndTenantIdArgs,
      "tenantId" | "userId"
    >
  >;
  applicationUserMetadatumById?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMetadatum"]>,
    ParentType,
    ContextType,
    RequireFields<QueryApplicationUserMetadatumByIdArgs, "id">
  >;
  applicationUserMetadatumByUserIdAndKey?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMetadatum"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryApplicationUserMetadatumByUserIdAndKeyArgs,
      "key" | "userId"
    >
  >;
  applicationUserSessionById?: Resolver<
    Maybe<ResolversTypes["ApplicationUserSession"]>,
    ParentType,
    ContextType,
    RequireFields<QueryApplicationUserSessionByIdArgs, "id">
  >;
  applicationUserUserPermissionById?: Resolver<
    Maybe<ResolversTypes["ApplicationUserUserPermission"]>,
    ParentType,
    ContextType,
    RequireFields<QueryApplicationUserUserPermissionByIdArgs, "id">
  >;
  applicationUserUserPermissionByUserIdAndPermissionId?: Resolver<
    Maybe<ResolversTypes["ApplicationUserUserPermission"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryApplicationUserUserPermissionByUserIdAndPermissionIdArgs,
      "permissionId" | "userId"
    >
  >;
  assertUserAcceptedEula?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  assertUserCanSeeTenantInfo?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType,
    Partial<QueryAssertUserCanSeeTenantInfoArgs>
  >;
  assertUserCanSeeUserInfo?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType,
    Partial<QueryAssertUserCanSeeUserInfoArgs>
  >;
  assertUserHasProjectSharedByTenant?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType,
    Partial<QueryAssertUserHasProjectSharedByTenantArgs>
  >;
  assertUserHasTenantOfId?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType,
    Partial<QueryAssertUserHasTenantOfIdArgs>
  >;
  assertUserIsAdminOfProjectTenant?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType,
    Partial<QueryAssertUserIsAdminOfProjectTenantArgs>
  >;
  assertUserIsAdminOfTenant?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType,
    Partial<QueryAssertUserIsAdminOfTenantArgs>
  >;
  assertUserIsInvitedToTenant?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType,
    Partial<QueryAssertUserIsInvitedToTenantArgs>
  >;
  auditlogLogentryById?: Resolver<
    Maybe<ResolversTypes["AuditlogLogentry"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAuditlogLogentryByIdArgs, "id">
  >;
  authGroupById?: Resolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAuthGroupByIdArgs, "id">
  >;
  authGroupByName?: Resolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAuthGroupByNameArgs, "name">
  >;
  authGroupPermissionByGroupIdAndPermissionId?: Resolver<
    Maybe<ResolversTypes["AuthGroupPermission"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryAuthGroupPermissionByGroupIdAndPermissionIdArgs,
      "groupId" | "permissionId"
    >
  >;
  authGroupPermissionById?: Resolver<
    Maybe<ResolversTypes["AuthGroupPermission"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAuthGroupPermissionByIdArgs, "id">
  >;
  authPermissionByContentTypeIdAndCodename?: Resolver<
    Maybe<ResolversTypes["AuthPermission"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryAuthPermissionByContentTypeIdAndCodenameArgs,
      "codename" | "contentTypeId"
    >
  >;
  authPermissionById?: Resolver<
    Maybe<ResolversTypes["AuthPermission"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAuthPermissionByIdArgs, "id">
  >;
  avatarById?: Resolver<
    Maybe<ResolversTypes["Avatar"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAvatarByIdArgs, "id">
  >;
  avatarByUserId?: Resolver<
    Maybe<ResolversTypes["Avatar"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAvatarByUserIdArgs, "userId">
  >;
  awsBatchTaskByTaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsBatchTask"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAwsBatchTaskByTaskexecutorPtrIdArgs, "taskexecutorPtrId">
  >;
  awsCognitoUserByUserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsCognitoUser"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryAwsCognitoUserByUserexecutorPtrIdArgs,
      "userexecutorPtrId"
    >
  >;
  awsEcrImageByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsEcrImage"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryAwsEcrImageByContainerimageexecutorPtrIdArgs,
      "containerimageexecutorPtrId"
    >
  >;
  awsMockBatchTaskByAwstaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsMockBatchTask"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryAwsMockBatchTaskByAwstaskexecutorPtrIdArgs,
      "awstaskexecutorPtrId"
    >
  >;
  awsMockDistributionImageByDistributioncontainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsMockDistributionImage"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdArgs,
      "distributioncontainerimageexecutorPtrId"
    >
  >;
  awsMockEcrImageByAwscontainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsMockEcrImage"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryAwsMockEcrImageByAwscontainerimageexecutorPtrIdArgs,
      "awscontainerimageexecutorPtrId"
    >
  >;
  awsMockIamUserByAwsuserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsMockIamUser"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryAwsMockIamUserByAwsuserexecutorPtrIdArgs,
      "awsuserexecutorPtrId"
    >
  >;
  awsMockS3FileByAwsfileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsMockS3File"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryAwsMockS3FileByAwsfileexecutorPtrIdArgs,
      "awsfileexecutorPtrId"
    >
  >;
  awsS3FileByFileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsS3File"]>,
    ParentType,
    ContextType,
    RequireFields<QueryAwsS3FileByFileexecutorPtrIdArgs, "fileexecutorPtrId">
  >;
  codeFileById?: Resolver<
    Maybe<ResolversTypes["CodeFile"]>,
    ParentType,
    ContextType,
    RequireFields<QueryCodeFileByIdArgs, "id">
  >;
  commandById?: Resolver<
    Maybe<ResolversTypes["Command"]>,
    ParentType,
    ContextType,
    RequireFields<QueryCommandByIdArgs, "id">
  >;
  commandByToolVersionId?: Resolver<
    Maybe<ResolversTypes["Command"]>,
    ParentType,
    ContextType,
    RequireFields<QueryCommandByToolVersionIdArgs, "toolVersionId">
  >;
  commandByToolVersionIdAndCodeFileId?: Resolver<
    Maybe<ResolversTypes["Command"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryCommandByToolVersionIdAndCodeFileIdArgs,
      "codeFileId" | "toolVersionId"
    >
  >;
  containerImageByExecutorId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType,
    RequireFields<QueryContainerImageByExecutorIdArgs, "executorId">
  >;
  containerImageById?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType,
    RequireFields<QueryContainerImageByIdArgs, "id">
  >;
  containerImageRepositoryById?: Resolver<
    Maybe<ResolversTypes["ContainerImageRepository"]>,
    ParentType,
    ContextType,
    RequireFields<QueryContainerImageRepositoryByIdArgs, "id">
  >;
  containerImageRepositoryByNameAndTenantIdAndRegistryType?: Resolver<
    Maybe<ResolversTypes["ContainerImageRepository"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryContainerImageRepositoryByNameAndTenantIdAndRegistryTypeArgs,
      "name" | "registryType" | "tenantId"
    >
  >;
  containerImageRepositoryByRepository?: Resolver<
    Maybe<ResolversTypes["ContainerImageRepository"]>,
    ParentType,
    ContextType,
    RequireFields<QueryContainerImageRepositoryByRepositoryArgs, "repository">
  >;
  costById?: Resolver<
    Maybe<ResolversTypes["Cost"]>,
    ParentType,
    ContextType,
    RequireFields<QueryCostByIdArgs, "id">
  >;
  dataTableById?: Resolver<
    Maybe<ResolversTypes["DataTable"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableByIdArgs, "id">
  >;
  dataTableCellByColumnIdAndRowId?: Resolver<
    Maybe<ResolversTypes["DataTableCell"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryDataTableCellByColumnIdAndRowIdArgs,
      "columnId" | "rowId"
    >
  >;
  dataTableCellById?: Resolver<
    Maybe<ResolversTypes["DataTableCell"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableCellByIdArgs, "id">
  >;
  dataTableColumnById?: Resolver<
    Maybe<ResolversTypes["DataTableColumn"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableColumnByIdArgs, "id">
  >;
  dataTableColumnByTableIdAndOrder?: Resolver<
    Maybe<ResolversTypes["DataTableColumn"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryDataTableColumnByTableIdAndOrderArgs,
      "order" | "tableId"
    >
  >;
  dataTableColumnDefinitionBooleanById?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionBoolean"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableColumnDefinitionBooleanByIdArgs, "id">
  >;
  dataTableColumnDefinitionCellStatusById?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionCellStatus"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableColumnDefinitionCellStatusByIdArgs, "id">
  >;
  dataTableColumnDefinitionChoiceById?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionChoice"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableColumnDefinitionChoiceByIdArgs, "id">
  >;
  dataTableColumnDefinitionDateById?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionDate"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableColumnDefinitionDateByIdArgs, "id">
  >;
  dataTableColumnDefinitionFileById?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionFile"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableColumnDefinitionFileByIdArgs, "id">
  >;
  dataTableColumnDefinitionFloatById?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionFloat"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableColumnDefinitionFloatByIdArgs, "id">
  >;
  dataTableColumnDefinitionIdentifierById?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionIdentifier"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableColumnDefinitionIdentifierByIdArgs, "id">
  >;
  dataTableColumnDefinitionIntegerById?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionInteger"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableColumnDefinitionIntegerByIdArgs, "id">
  >;
  dataTableColumnDefinitionJoinById?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionJoin"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableColumnDefinitionJoinByIdArgs, "id">
  >;
  dataTableColumnDefinitionMetadatumById?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionMetadatum"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableColumnDefinitionMetadatumByIdArgs, "id">
  >;
  dataTableColumnDefinitionRoiFrameById?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionRoiFrame"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableColumnDefinitionRoiFrameByIdArgs, "id">
  >;
  dataTableColumnDefinitionTextById?: Resolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionText"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableColumnDefinitionTextByIdArgs, "id">
  >;
  dataTableColumnGroupById?: Resolver<
    Maybe<ResolversTypes["DataTableColumnGroup"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableColumnGroupByIdArgs, "id">
  >;
  dataTableColumnGroupDefinitionJoinById?: Resolver<
    Maybe<ResolversTypes["DataTableColumnGroupDefinitionJoin"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableColumnGroupDefinitionJoinByIdArgs, "id">
  >;
  dataTableColumnGroupDefinitionSourceById?: Resolver<
    Maybe<ResolversTypes["DataTableColumnGroupDefinitionSource"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableColumnGroupDefinitionSourceByIdArgs, "id">
  >;
  dataTableRowById?: Resolver<
    Maybe<ResolversTypes["DataTableRow"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableRowByIdArgs, "id">
  >;
  dataTableRowByTableIdAndIndex?: Resolver<
    Maybe<ResolversTypes["DataTableRow"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDataTableRowByTableIdAndIndexArgs, "index" | "tableId">
  >;
  distributionRegistryImageByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DistributionRegistryImage"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryDistributionRegistryImageByContainerimageexecutorPtrIdArgs,
      "containerimageexecutorPtrId"
    >
  >;
  djangoAdminLogById?: Resolver<
    Maybe<ResolversTypes["DjangoAdminLog"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDjangoAdminLogByIdArgs, "id">
  >;
  djangoContentTypeByAppLabelAndModel?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryDjangoContentTypeByAppLabelAndModelArgs,
      "appLabel" | "model"
    >
  >;
  djangoContentTypeById?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDjangoContentTypeByIdArgs, "id">
  >;
  djangoMigrationById?: Resolver<
    Maybe<ResolversTypes["DjangoMigration"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDjangoMigrationByIdArgs, "id">
  >;
  djangoSesBlacklistedemailByEmail?: Resolver<
    Maybe<ResolversTypes["DjangoSesBlacklistedemail"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDjangoSesBlacklistedemailByEmailArgs, "email">
  >;
  djangoSesBlacklistedemailById?: Resolver<
    Maybe<ResolversTypes["DjangoSesBlacklistedemail"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDjangoSesBlacklistedemailByIdArgs, "id">
  >;
  djangoSesSesstatByDate?: Resolver<
    Maybe<ResolversTypes["DjangoSesSesstat"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDjangoSesSesstatByDateArgs, "date">
  >;
  djangoSesSesstatById?: Resolver<
    Maybe<ResolversTypes["DjangoSesSesstat"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDjangoSesSesstatByIdArgs, "id">
  >;
  djangoSessionBySessionKey?: Resolver<
    Maybe<ResolversTypes["DjangoSession"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDjangoSessionBySessionKeyArgs, "sessionKey">
  >;
  drsFileexecutorById?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutor"]>,
    ParentType,
    ContextType,
    RequireFields<QueryDrsFileexecutorByIdArgs, "id">
  >;
  drsMockfileexecutorByFileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DrsMockfileexecutor"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryDrsMockfileexecutorByFileexecutorPtrIdArgs,
      "fileexecutorPtrId"
    >
  >;
  eulaVersionById?: Resolver<
    Maybe<ResolversTypes["EulaVersion"]>,
    ParentType,
    ContextType,
    RequireFields<QueryEulaVersionByIdArgs, "id">
  >;
  eulaVersionByVersion?: Resolver<
    Maybe<ResolversTypes["EulaVersion"]>,
    ParentType,
    ContextType,
    RequireFields<QueryEulaVersionByVersionArgs, "version">
  >;
  eulaVersionUserAcceptanceById?: Resolver<
    Maybe<ResolversTypes["EulaVersionUserAcceptance"]>,
    ParentType,
    ContextType,
    RequireFields<QueryEulaVersionUserAcceptanceByIdArgs, "id">
  >;
  eulaVersionUserAcceptanceByUserIdAndEulaVersionId?: Resolver<
    Maybe<ResolversTypes["EulaVersionUserAcceptance"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryEulaVersionUserAcceptanceByUserIdAndEulaVersionIdArgs,
      "eulaVersionId" | "userId"
    >
  >;
  featureFlagById?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType,
    RequireFields<QueryFeatureFlagByIdArgs, "id">
  >;
  featureFlagByName?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType,
    RequireFields<QueryFeatureFlagByNameArgs, "name">
  >;
  featureFlagsGroupByFeatureflagIdAndGroupId?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsGroup"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryFeatureFlagsGroupByFeatureflagIdAndGroupIdArgs,
      "featureflagId" | "groupId"
    >
  >;
  featureFlagsGroupById?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsGroup"]>,
    ParentType,
    ContextType,
    RequireFields<QueryFeatureFlagsGroupByIdArgs, "id">
  >;
  featureFlagsTenantByFeatureflagIdAndTenantId?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsTenant"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryFeatureFlagsTenantByFeatureflagIdAndTenantIdArgs,
      "featureflagId" | "tenantId"
    >
  >;
  featureFlagsTenantById?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsTenant"]>,
    ParentType,
    ContextType,
    RequireFields<QueryFeatureFlagsTenantByIdArgs, "id">
  >;
  featureFlagsUserByFeatureflagIdAndUserId?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsUser"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryFeatureFlagsUserByFeatureflagIdAndUserIdArgs,
      "featureflagId" | "userId"
    >
  >;
  featureFlagsUserById?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsUser"]>,
    ParentType,
    ContextType,
    RequireFields<QueryFeatureFlagsUserByIdArgs, "id">
  >;
  fileActivityById?: Resolver<
    Maybe<ResolversTypes["FileActivity"]>,
    ParentType,
    ContextType,
    RequireFields<QueryFileActivityByIdArgs, "id">
  >;
  fileById?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType,
    RequireFields<QueryFileByIdArgs, "id">
  >;
  fileByProjectIdAndReferenceId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryFileByProjectIdAndReferenceIdArgs,
      "projectId" | "referenceId"
    >
  >;
  fileMetadatumById?: Resolver<
    Maybe<ResolversTypes["FileMetadatum"]>,
    ParentType,
    ContextType,
    RequireFields<QueryFileMetadatumByIdArgs, "id">
  >;
  fileOutputGroupById?: Resolver<
    Maybe<ResolversTypes["FileOutputGroup"]>,
    ParentType,
    ContextType,
    RequireFields<QueryFileOutputGroupByIdArgs, "id">
  >;
  fileOutputGroupByTaskId?: Resolver<
    Maybe<ResolversTypes["FileOutputGroup"]>,
    ParentType,
    ContextType,
    RequireFields<QueryFileOutputGroupByTaskIdArgs, "taskId">
  >;
  fileOutputGroupMetadatumById?: Resolver<
    Maybe<ResolversTypes["FileOutputGroupMetadatum"]>,
    ParentType,
    ContextType,
    RequireFields<QueryFileOutputGroupMetadatumByIdArgs, "id">
  >;
  fileProcessingNotificationById?: Resolver<
    Maybe<ResolversTypes["FileProcessingNotification"]>,
    ParentType,
    ContextType,
    RequireFields<QueryFileProcessingNotificationByIdArgs, "id">
  >;
  gdtAnalysisTableById?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTable"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGdtAnalysisTableByIdArgs, "id">
  >;
  gdtAnalysisTableCellByColumnIdAndRowId?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTableCell"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryGdtAnalysisTableCellByColumnIdAndRowIdArgs,
      "columnId" | "rowId"
    >
  >;
  gdtAnalysisTableCellById?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTableCell"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGdtAnalysisTableCellByIdArgs, "id">
  >;
  gdtAnalysisTableColumnById?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTableColumn"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGdtAnalysisTableColumnByIdArgs, "id">
  >;
  gdtAnalysisTableColumnByTableIdAndOrder?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTableColumn"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryGdtAnalysisTableColumnByTableIdAndOrderArgs,
      "order" | "tableId"
    >
  >;
  gdtAnalysisTableColumnGroupById?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTableColumnGroup"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGdtAnalysisTableColumnGroupByIdArgs, "id">
  >;
  gdtAnalysisTableRowById?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTableRow"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGdtAnalysisTableRowByIdArgs, "id">
  >;
  gdtAnalysisTableRowByTableIdAndIndex?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTableRow"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryGdtAnalysisTableRowByTableIdAndIndexArgs,
      "index" | "tableId"
    >
  >;
  gdtAnalysisTableRowByTaskId?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTableRow"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGdtAnalysisTableRowByTaskIdArgs, "taskId">
  >;
  getCurrentUser?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  getCurrentUserId?: Resolver<
    Maybe<ResolversTypes["UUID"]>,
    ParentType,
    ContextType
  >;
  getUserActiveSession?: Resolver<
    Maybe<ResolversTypes["ApplicationUserSession"]>,
    ParentType,
    ContextType,
    RequireFields<QueryGetUserActiveSessionArgs, "userid">
  >;
  jwtHasGlobalUserIdClaim?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  metadataValueById?: Resolver<
    Maybe<ResolversTypes["MetadataValue"]>,
    ParentType,
    ContextType,
    RequireFields<QueryMetadataValueByIdArgs, "id">
  >;
  metadatumById?: Resolver<
    Maybe<ResolversTypes["Metadatum"]>,
    ParentType,
    ContextType,
    RequireFields<QueryMetadatumByIdArgs, "id">
  >;
  notificationById?: Resolver<
    Maybe<ResolversTypes["Notification"]>,
    ParentType,
    ContextType,
    RequireFields<QueryNotificationByIdArgs, "id">
  >;
  outputGroupFileById?: Resolver<
    Maybe<ResolversTypes["OutputGroupFile"]>,
    ParentType,
    ContextType,
    RequireFields<QueryOutputGroupFileByIdArgs, "id">
  >;
  pinnedToolById?: Resolver<
    Maybe<ResolversTypes["PinnedTool"]>,
    ParentType,
    ContextType,
    RequireFields<QueryPinnedToolByIdArgs, "id">
  >;
  pinnedToolByUserIdAndToolId?: Resolver<
    Maybe<ResolversTypes["PinnedTool"]>,
    ParentType,
    ContextType,
    RequireFields<QueryPinnedToolByUserIdAndToolIdArgs, "toolId" | "userId">
  >;
  projectById?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType,
    RequireFields<QueryProjectByIdArgs, "id">
  >;
  projectByKeyAndTenantId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType,
    RequireFields<QueryProjectByKeyAndTenantIdArgs, "key" | "tenantId">
  >;
  projectClonedNotificationById?: Resolver<
    Maybe<ResolversTypes["ProjectClonedNotification"]>,
    ParentType,
    ContextType,
    RequireFields<QueryProjectClonedNotificationByIdArgs, "id">
  >;
  projectFolderById?: Resolver<
    Maybe<ResolversTypes["ProjectFolder"]>,
    ParentType,
    ContextType,
    RequireFields<QueryProjectFolderByIdArgs, "id">
  >;
  projectSharedNotificationById?: Resolver<
    Maybe<ResolversTypes["ProjectSharedNotification"]>,
    ParentType,
    ContextType,
    RequireFields<QueryProjectSharedNotificationByIdArgs, "id">
  >;
  projectTagById?: Resolver<
    Maybe<ResolversTypes["ProjectTag"]>,
    ParentType,
    ContextType,
    RequireFields<QueryProjectTagByIdArgs, "id">
  >;
  query?: Resolver<ResolversTypes["Query"], ParentType, ContextType>;
  roleChangeNotificationById?: Resolver<
    Maybe<ResolversTypes["RoleChangeNotification"]>,
    ParentType,
    ContextType,
    RequireFields<QueryRoleChangeNotificationByIdArgs, "id">
  >;
  runById?: Resolver<
    Maybe<ResolversTypes["Run"]>,
    ParentType,
    ContextType,
    RequireFields<QueryRunByIdArgs, "id">
  >;
  sessionIsActive?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  sessionIsActiveSession?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType,
    RequireFields<QuerySessionIsActiveSessionArgs, "id">
  >;
  taskActivityById?: Resolver<
    Maybe<ResolversTypes["TaskActivity"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTaskActivityByIdArgs, "id">
  >;
  taskActivityByTaskId?: Resolver<
    Maybe<ResolversTypes["TaskActivity"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTaskActivityByTaskIdArgs, "taskId">
  >;
  taskByExecutorId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTaskByExecutorIdArgs, "executorId">
  >;
  taskById?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTaskByIdArgs, "id">
  >;
  taskResourceById?: Resolver<
    Maybe<ResolversTypes["TaskResource"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTaskResourceByIdArgs, "id">
  >;
  taskResourceUsageById?: Resolver<
    Maybe<ResolversTypes["TaskResourceUsage"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTaskResourceUsageByIdArgs, "id">
  >;
  taskResourceUsageByTaskId?: Resolver<
    Maybe<ResolversTypes["TaskResourceUsage"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTaskResourceUsageByTaskIdArgs, "taskId">
  >;
  taskSourceById?: Resolver<
    Maybe<ResolversTypes["TaskSource"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTaskSourceByIdArgs, "id">
  >;
  taskStatusLogById?: Resolver<
    Maybe<ResolversTypes["TaskStatusLog"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTaskStatusLogByIdArgs, "id">
  >;
  taskStatusLogByTaskIdAndStatus?: Resolver<
    Maybe<ResolversTypes["TaskStatusLog"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTaskStatusLogByTaskIdAndStatusArgs, "status" | "taskId">
  >;
  tenantById?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTenantByIdArgs, "id">
  >;
  tenantByKey?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTenantByKeyArgs, "key">
  >;
  tenantByRepositoryName?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTenantByRepositoryNameArgs, "repositoryName">
  >;
  tenantBySfid?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTenantBySfidArgs, "sfid">
  >;
  tenantContractAllowanceById?: Resolver<
    Maybe<ResolversTypes["TenantContractAllowance"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTenantContractAllowanceByIdArgs, "id">
  >;
  tenantContractAllowanceByTenantContractTransactionIdAndQuotaType?: Resolver<
    Maybe<ResolversTypes["TenantContractAllowance"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeArgs,
      "quotaType" | "tenantContractTransactionId"
    >
  >;
  tenantContractById?: Resolver<
    Maybe<ResolversTypes["TenantContract"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTenantContractByIdArgs, "id">
  >;
  tenantContractByName?: Resolver<
    Maybe<ResolversTypes["TenantContract"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTenantContractByNameArgs, "name">
  >;
  tenantContractBySfid?: Resolver<
    Maybe<ResolversTypes["TenantContract"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTenantContractBySfidArgs, "sfid">
  >;
  tenantContractTransactionById?: Resolver<
    Maybe<ResolversTypes["TenantContractTransaction"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTenantContractTransactionByIdArgs, "id">
  >;
  tenantMockuserexecutorByUserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TenantMockuserexecutor"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryTenantMockuserexecutorByUserexecutorPtrIdArgs,
      "userexecutorPtrId"
    >
  >;
  tenantMonthlyConsumedResourceById?: Resolver<
    Maybe<ResolversTypes["TenantMonthlyConsumedResource"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTenantMonthlyConsumedResourceByIdArgs, "id">
  >;
  tenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract?: Resolver<
    Maybe<ResolversTypes["TenantMonthlyConsumedResource"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractArgs,
      | "month"
      | "monthInActiveContract"
      | "quotaType"
      | "tenantContractId"
      | "tenantId"
      | "userId"
    >
  >;
  tenantUserMembershipNotificationById?: Resolver<
    Maybe<ResolversTypes["TenantUserMembershipNotification"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTenantUserMembershipNotificationByIdArgs, "id">
  >;
  tenantUserexecutorById?: Resolver<
    Maybe<ResolversTypes["TenantUserexecutor"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTenantUserexecutorByIdArgs, "id">
  >;
  tesContainerimageexecutorById?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTesContainerimageexecutorByIdArgs, "id">
  >;
  tesMockcontainerimageexecutorByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesMockcontainerimageexecutor"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryTesMockcontainerimageexecutorByContainerimageexecutorPtrIdArgs,
      "containerimageexecutorPtrId"
    >
  >;
  tesMocktaskexecutorByTaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesMocktaskexecutor"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryTesMocktaskexecutorByTaskexecutorPtrIdArgs,
      "taskexecutorPtrId"
    >
  >;
  tesTaskexecutorById?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutor"]>,
    ParentType,
    ContextType,
    RequireFields<QueryTesTaskexecutorByIdArgs, "id">
  >;
  toolById?: Resolver<
    Maybe<ResolversTypes["Tool"]>,
    ParentType,
    ContextType,
    RequireFields<QueryToolByIdArgs, "id">
  >;
  toolByProjectId?: Resolver<
    Maybe<ResolversTypes["Tool"]>,
    ParentType,
    ContextType,
    RequireFields<QueryToolByProjectIdArgs, "projectId">
  >;
  toolParameterById?: Resolver<
    Maybe<ResolversTypes["ToolParameter"]>,
    ParentType,
    ContextType,
    RequireFields<QueryToolParameterByIdArgs, "id">
  >;
  toolResourceById?: Resolver<
    Maybe<ResolversTypes["ToolResource"]>,
    ParentType,
    ContextType,
    RequireFields<QueryToolResourceByIdArgs, "id">
  >;
  toolResourceByTypeAndToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolResource"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryToolResourceByTypeAndToolVersionIdArgs,
      "toolVersionId" | "type"
    >
  >;
  toolResultById?: Resolver<
    Maybe<ResolversTypes["ToolResult"]>,
    ParentType,
    ContextType,
    RequireFields<QueryToolResultByIdArgs, "id">
  >;
  toolSecretById?: Resolver<
    Maybe<ResolversTypes["ToolSecret"]>,
    ParentType,
    ContextType,
    RequireFields<QueryToolSecretByIdArgs, "id">
  >;
  toolSourceById?: Resolver<
    Maybe<ResolversTypes["ToolSource"]>,
    ParentType,
    ContextType,
    RequireFields<QueryToolSourceByIdArgs, "id">
  >;
  toolTenantById?: Resolver<
    Maybe<ResolversTypes["ToolTenant"]>,
    ParentType,
    ContextType,
    RequireFields<QueryToolTenantByIdArgs, "id">
  >;
  toolTenantByToolIdAndTenantId?: Resolver<
    Maybe<ResolversTypes["ToolTenant"]>,
    ParentType,
    ContextType,
    RequireFields<QueryToolTenantByToolIdAndTenantIdArgs, "tenantId" | "toolId">
  >;
  toolVersionById?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType,
    RequireFields<QueryToolVersionByIdArgs, "id">
  >;
  toolboxById?: Resolver<
    Maybe<ResolversTypes["Toolbox"]>,
    ParentType,
    ContextType,
    RequireFields<QueryToolboxByIdArgs, "id">
  >;
  toolboxByKey?: Resolver<
    Maybe<ResolversTypes["Toolbox"]>,
    ParentType,
    ContextType,
    RequireFields<QueryToolboxByKeyArgs, "key">
  >;
  toolboxTenantById?: Resolver<
    Maybe<ResolversTypes["ToolboxTenant"]>,
    ParentType,
    ContextType,
    RequireFields<QueryToolboxTenantByIdArgs, "id">
  >;
  toolboxTenantByToolboxIdAndTenantId?: Resolver<
    Maybe<ResolversTypes["ToolboxTenant"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryToolboxTenantByToolboxIdAndTenantIdArgs,
      "tenantId" | "toolboxId"
    >
  >;
  userHasActiveSession?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType,
    RequireFields<QueryUserHasActiveSessionArgs, "userid">
  >;
  userIdIsSettingsGlobalUserId?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType,
    Partial<QueryUserIdIsSettingsGlobalUserIdArgs>
  >;
  userOnboardingQuestionAnswerById?: Resolver<
    Maybe<ResolversTypes["UserOnboardingQuestionAnswer"]>,
    ParentType,
    ContextType,
    RequireFields<QueryUserOnboardingQuestionAnswerByIdArgs, "id">
  >;
  userOnboardingQuestionByCode?: Resolver<
    Maybe<ResolversTypes["UserOnboardingQuestion"]>,
    ParentType,
    ContextType,
    RequireFields<QueryUserOnboardingQuestionByCodeArgs, "code">
  >;
  userOnboardingQuestionById?: Resolver<
    Maybe<ResolversTypes["UserOnboardingQuestion"]>,
    ParentType,
    ContextType,
    RequireFields<QueryUserOnboardingQuestionByIdArgs, "id">
  >;
  userOnboardingQuestionResponseById?: Resolver<
    Maybe<ResolversTypes["UserOnboardingQuestionResponse"]>,
    ParentType,
    ContextType,
    RequireFields<QueryUserOnboardingQuestionResponseByIdArgs, "id">
  >;
  userPersonalSpaceRequestById?: Resolver<
    Maybe<ResolversTypes["UserPersonalSpaceRequest"]>,
    ParentType,
    ContextType,
    RequireFields<QueryUserPersonalSpaceRequestByIdArgs, "id">
  >;
  waffleFlagById?: Resolver<
    Maybe<ResolversTypes["WaffleFlag"]>,
    ParentType,
    ContextType,
    RequireFields<QueryWaffleFlagByIdArgs, "id">
  >;
  waffleFlagByName?: Resolver<
    Maybe<ResolversTypes["WaffleFlag"]>,
    ParentType,
    ContextType,
    RequireFields<QueryWaffleFlagByNameArgs, "name">
  >;
  waffleSampleById?: Resolver<
    Maybe<ResolversTypes["WaffleSample"]>,
    ParentType,
    ContextType,
    RequireFields<QueryWaffleSampleByIdArgs, "id">
  >;
  waffleSampleByName?: Resolver<
    Maybe<ResolversTypes["WaffleSample"]>,
    ParentType,
    ContextType,
    RequireFields<QueryWaffleSampleByNameArgs, "name">
  >;
  waffleSwitchById?: Resolver<
    Maybe<ResolversTypes["WaffleSwitch"]>,
    ParentType,
    ContextType,
    RequireFields<QueryWaffleSwitchByIdArgs, "id">
  >;
  waffleSwitchByName?: Resolver<
    Maybe<ResolversTypes["WaffleSwitch"]>,
    ParentType,
    ContextType,
    RequireFields<QueryWaffleSwitchByNameArgs, "name">
  >;
  workflowById?: Resolver<
    Maybe<ResolversTypes["Workflow"]>,
    ParentType,
    ContextType,
    RequireFields<QueryWorkflowByIdArgs, "id">
  >;
  workflowDatumById?: Resolver<
    Maybe<ResolversTypes["WorkflowDatum"]>,
    ParentType,
    ContextType,
    RequireFields<QueryWorkflowDatumByIdArgs, "id">
  >;
  workflowResultById?: Resolver<
    Maybe<ResolversTypes["WorkflowResult"]>,
    ParentType,
    ContextType,
    RequireFields<QueryWorkflowResultByIdArgs, "id">
  >;
  workflowResultWorkflowVersionById?: Resolver<
    Maybe<ResolversTypes["WorkflowResultWorkflowVersion"]>,
    ParentType,
    ContextType,
    RequireFields<QueryWorkflowResultWorkflowVersionByIdArgs, "id">
  >;
  workflowResultWorkflowVersionByResultIdAndWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["WorkflowResultWorkflowVersion"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdArgs,
      "resultId" | "workflowversionId"
    >
  >;
  workflowSectionBlockById?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlock"]>,
    ParentType,
    ContextType,
    RequireFields<QueryWorkflowSectionBlockByIdArgs, "id">
  >;
  workflowSectionBlockSectionByBlockIdAndSectionId?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlockSection"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryWorkflowSectionBlockSectionByBlockIdAndSectionIdArgs,
      "blockId" | "sectionId"
    >
  >;
  workflowSectionBlockSectionById?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlockSection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryWorkflowSectionBlockSectionByIdArgs, "id">
  >;
  workflowSectionById?: Resolver<
    Maybe<ResolversTypes["WorkflowSection"]>,
    ParentType,
    ContextType,
    RequireFields<QueryWorkflowSectionByIdArgs, "id">
  >;
  workflowSectionWorkflowVersionById?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionWorkflowVersion"]>,
    ParentType,
    ContextType,
    RequireFields<QueryWorkflowSectionWorkflowVersionByIdArgs, "id">
  >;
  workflowSectionWorkflowVersionBySectionIdAndWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionWorkflowVersion"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdArgs,
      "sectionId" | "workflowversionId"
    >
  >;
  workflowSourceById?: Resolver<
    Maybe<ResolversTypes["WorkflowSource"]>,
    ParentType,
    ContextType,
    RequireFields<QueryWorkflowSourceByIdArgs, "id">
  >;
  workflowSourceWorkflowVersionById?: Resolver<
    Maybe<ResolversTypes["WorkflowSourceWorkflowVersion"]>,
    ParentType,
    ContextType,
    RequireFields<QueryWorkflowSourceWorkflowVersionByIdArgs, "id">
  >;
  workflowSourceWorkflowVersionBySourceIdAndWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["WorkflowSourceWorkflowVersion"]>,
    ParentType,
    ContextType,
    RequireFields<
      QueryWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdArgs,
      "sourceId" | "workflowversionId"
    >
  >;
  workflowVersionById?: Resolver<
    Maybe<ResolversTypes["WorkflowVersion"]>,
    ParentType,
    ContextType,
    RequireFields<QueryWorkflowVersionByIdArgs, "id">
  >;
};

export type RoleChangeNotificationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["RoleChangeNotification"] = ResolversParentTypes["RoleChangeNotification"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  notificationById?: Resolver<
    Maybe<ResolversTypes["Notification"]>,
    ParentType,
    ContextType
  >;
  role?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleChangeNotificationsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["RoleChangeNotificationsConnection"] = ResolversParentTypes["RoleChangeNotificationsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["RoleChangeNotificationsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["RoleChangeNotification"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleChangeNotificationsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["RoleChangeNotificationsEdge"] = ResolversParentTypes["RoleChangeNotificationsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["RoleChangeNotification"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes["Run"] = ResolversParentTypes["Run"],
> = {
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["RunsConnection"] = ResolversParentTypes["RunsConnection"],
> = {
  edges?: Resolver<Array<ResolversTypes["RunsEdge"]>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes["Run"]>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RunsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["RunsEdge"] = ResolversParentTypes["RunsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["Run"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Subscription"] = ResolversParentTypes["Subscription"],
> = {
  allAdminProjects?: SubscriptionResolver<
    Maybe<ResolversTypes["AdminProjectsConnection"]>,
    "allAdminProjects",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllAdminProjectsArgs, "orderBy">
  >;
  allApplicationUserGroups?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUserGroupsConnection"]>,
    "allApplicationUserGroups",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllApplicationUserGroupsArgs, "orderBy">
  >;
  allApplicationUserMemberships?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUserMembershipsConnection"]>,
    "allApplicationUserMemberships",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllApplicationUserMembershipsArgs, "orderBy">
  >;
  allApplicationUserMetadata?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUserMetadataConnection"]>,
    "allApplicationUserMetadata",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllApplicationUserMetadataArgs, "orderBy">
  >;
  allApplicationUserSessions?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUserSessionsConnection"]>,
    "allApplicationUserSessions",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllApplicationUserSessionsArgs, "orderBy">
  >;
  allApplicationUserUserPermissions?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUserUserPermissionsConnection"]>,
    "allApplicationUserUserPermissions",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllApplicationUserUserPermissionsArgs, "orderBy">
  >;
  allAuditlogLogentries?: SubscriptionResolver<
    Maybe<ResolversTypes["AuditlogLogentriesConnection"]>,
    "allAuditlogLogentries",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllAuditlogLogentriesArgs, "orderBy">
  >;
  allAuthGroupPermissions?: SubscriptionResolver<
    Maybe<ResolversTypes["AuthGroupPermissionsConnection"]>,
    "allAuthGroupPermissions",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllAuthGroupPermissionsArgs, "orderBy">
  >;
  allAuthGroups?: SubscriptionResolver<
    Maybe<ResolversTypes["AuthGroupsConnection"]>,
    "allAuthGroups",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllAuthGroupsArgs, "orderBy">
  >;
  allAuthPermissions?: SubscriptionResolver<
    Maybe<ResolversTypes["AuthPermissionsConnection"]>,
    "allAuthPermissions",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllAuthPermissionsArgs, "orderBy">
  >;
  allAvailableNonRestrictedProjects?: SubscriptionResolver<
    Maybe<ResolversTypes["AvailableNonRestrictedProjectsConnection"]>,
    "allAvailableNonRestrictedProjects",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllAvailableNonRestrictedProjectsArgs, "orderBy">
  >;
  allAvatars?: SubscriptionResolver<
    Maybe<ResolversTypes["AvatarsConnection"]>,
    "allAvatars",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllAvatarsArgs, "orderBy">
  >;
  allAwsBatchTasks?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsBatchTasksConnection"]>,
    "allAwsBatchTasks",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllAwsBatchTasksArgs, "orderBy">
  >;
  allAwsCognitoUsers?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsCognitoUsersConnection"]>,
    "allAwsCognitoUsers",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllAwsCognitoUsersArgs, "orderBy">
  >;
  allAwsEcrImages?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsEcrImagesConnection"]>,
    "allAwsEcrImages",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllAwsEcrImagesArgs, "orderBy">
  >;
  allAwsMockBatchTasks?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsMockBatchTasksConnection"]>,
    "allAwsMockBatchTasks",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllAwsMockBatchTasksArgs, "orderBy">
  >;
  allAwsMockDistributionImages?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsMockDistributionImagesConnection"]>,
    "allAwsMockDistributionImages",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllAwsMockDistributionImagesArgs, "orderBy">
  >;
  allAwsMockEcrImages?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsMockEcrImagesConnection"]>,
    "allAwsMockEcrImages",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllAwsMockEcrImagesArgs, "orderBy">
  >;
  allAwsMockIamUsers?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsMockIamUsersConnection"]>,
    "allAwsMockIamUsers",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllAwsMockIamUsersArgs, "orderBy">
  >;
  allAwsMockS3Files?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsMockS3FilesConnection"]>,
    "allAwsMockS3Files",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllAwsMockS3FilesArgs, "orderBy">
  >;
  allAwsS3Files?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsS3FilesConnection"]>,
    "allAwsS3Files",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllAwsS3FilesArgs, "orderBy">
  >;
  allCodeFiles?: SubscriptionResolver<
    Maybe<ResolversTypes["CodeFilesConnection"]>,
    "allCodeFiles",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllCodeFilesArgs, "orderBy">
  >;
  allCommands?: SubscriptionResolver<
    Maybe<ResolversTypes["CommandsConnection"]>,
    "allCommands",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllCommandsArgs, "orderBy">
  >;
  allContainerImageRepositories?: SubscriptionResolver<
    Maybe<ResolversTypes["ContainerImageRepositoriesConnection"]>,
    "allContainerImageRepositories",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllContainerImageRepositoriesArgs, "orderBy">
  >;
  allContainerImages?: SubscriptionResolver<
    Maybe<ResolversTypes["ContainerImagesConnection"]>,
    "allContainerImages",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllContainerImagesArgs, "orderBy">
  >;
  allCosts?: SubscriptionResolver<
    Maybe<ResolversTypes["CostsConnection"]>,
    "allCosts",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllCostsArgs, "orderBy">
  >;
  allCurrentApplicationUsers?: SubscriptionResolver<
    Maybe<ResolversTypes["CurrentApplicationUsersConnection"]>,
    "allCurrentApplicationUsers",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllCurrentApplicationUsersArgs, "orderBy">
  >;
  allCurrentUserMemberships?: SubscriptionResolver<
    Maybe<ResolversTypes["CurrentUserMembershipsConnection"]>,
    "allCurrentUserMemberships",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllCurrentUserMembershipsArgs, "orderBy">
  >;
  allDataTableCells?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableCellsConnection"]>,
    "allDataTableCells",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDataTableCellsArgs, "orderBy">
  >;
  allDataTableColumnDefinitionBooleans?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionBooleansConnection"]>,
    "allDataTableColumnDefinitionBooleans",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAllDataTableColumnDefinitionBooleansArgs,
      "orderBy"
    >
  >;
  allDataTableColumnDefinitionCellStatuses?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionCellStatusesConnection"]>,
    "allDataTableColumnDefinitionCellStatuses",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAllDataTableColumnDefinitionCellStatusesArgs,
      "orderBy"
    >
  >;
  allDataTableColumnDefinitionChoices?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionChoicesConnection"]>,
    "allDataTableColumnDefinitionChoices",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAllDataTableColumnDefinitionChoicesArgs,
      "orderBy"
    >
  >;
  allDataTableColumnDefinitionDates?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionDatesConnection"]>,
    "allDataTableColumnDefinitionDates",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDataTableColumnDefinitionDatesArgs, "orderBy">
  >;
  allDataTableColumnDefinitionFiles?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionFilesConnection"]>,
    "allDataTableColumnDefinitionFiles",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDataTableColumnDefinitionFilesArgs, "orderBy">
  >;
  allDataTableColumnDefinitionFloats?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionFloatsConnection"]>,
    "allDataTableColumnDefinitionFloats",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDataTableColumnDefinitionFloatsArgs, "orderBy">
  >;
  allDataTableColumnDefinitionIdentifiers?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionIdentifiersConnection"]>,
    "allDataTableColumnDefinitionIdentifiers",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAllDataTableColumnDefinitionIdentifiersArgs,
      "orderBy"
    >
  >;
  allDataTableColumnDefinitionIntegers?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionIntegersConnection"]>,
    "allDataTableColumnDefinitionIntegers",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAllDataTableColumnDefinitionIntegersArgs,
      "orderBy"
    >
  >;
  allDataTableColumnDefinitionJoins?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionJoinsConnection"]>,
    "allDataTableColumnDefinitionJoins",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDataTableColumnDefinitionJoinsArgs, "orderBy">
  >;
  allDataTableColumnDefinitionMetadata?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionMetadataConnection"]>,
    "allDataTableColumnDefinitionMetadata",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAllDataTableColumnDefinitionMetadataArgs,
      "orderBy"
    >
  >;
  allDataTableColumnDefinitionRoiFrames?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionRoiFramesConnection"]>,
    "allDataTableColumnDefinitionRoiFrames",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAllDataTableColumnDefinitionRoiFramesArgs,
      "orderBy"
    >
  >;
  allDataTableColumnDefinitionTexts?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionTextsConnection"]>,
    "allDataTableColumnDefinitionTexts",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDataTableColumnDefinitionTextsArgs, "orderBy">
  >;
  allDataTableColumnGroupDefinitionJoins?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnGroupDefinitionJoinsConnection"]>,
    "allDataTableColumnGroupDefinitionJoins",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAllDataTableColumnGroupDefinitionJoinsArgs,
      "orderBy"
    >
  >;
  allDataTableColumnGroupDefinitionSources?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnGroupDefinitionSourcesConnection"]>,
    "allDataTableColumnGroupDefinitionSources",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAllDataTableColumnGroupDefinitionSourcesArgs,
      "orderBy"
    >
  >;
  allDataTableColumnGroups?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnGroupsConnection"]>,
    "allDataTableColumnGroups",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDataTableColumnGroupsArgs, "orderBy">
  >;
  allDataTableColumns?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnsConnection"]>,
    "allDataTableColumns",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDataTableColumnsArgs, "orderBy">
  >;
  allDataTableRows?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableRowsConnection"]>,
    "allDataTableRows",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDataTableRowsArgs, "orderBy">
  >;
  allDataTables?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTablesConnection"]>,
    "allDataTables",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDataTablesArgs, "orderBy">
  >;
  allDistributionRegistryImages?: SubscriptionResolver<
    Maybe<ResolversTypes["DistributionRegistryImagesConnection"]>,
    "allDistributionRegistryImages",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDistributionRegistryImagesArgs, "orderBy">
  >;
  allDjangoAdminLogs?: SubscriptionResolver<
    Maybe<ResolversTypes["DjangoAdminLogsConnection"]>,
    "allDjangoAdminLogs",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDjangoAdminLogsArgs, "orderBy">
  >;
  allDjangoContentTypes?: SubscriptionResolver<
    Maybe<ResolversTypes["DjangoContentTypesConnection"]>,
    "allDjangoContentTypes",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDjangoContentTypesArgs, "orderBy">
  >;
  allDjangoMigrations?: SubscriptionResolver<
    Maybe<ResolversTypes["DjangoMigrationsConnection"]>,
    "allDjangoMigrations",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDjangoMigrationsArgs, "orderBy">
  >;
  allDjangoSesBlacklistedemails?: SubscriptionResolver<
    Maybe<ResolversTypes["DjangoSesBlacklistedemailsConnection"]>,
    "allDjangoSesBlacklistedemails",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDjangoSesBlacklistedemailsArgs, "orderBy">
  >;
  allDjangoSesSesstats?: SubscriptionResolver<
    Maybe<ResolversTypes["DjangoSesSesstatsConnection"]>,
    "allDjangoSesSesstats",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDjangoSesSesstatsArgs, "orderBy">
  >;
  allDjangoSessions?: SubscriptionResolver<
    Maybe<ResolversTypes["DjangoSessionsConnection"]>,
    "allDjangoSessions",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDjangoSessionsArgs, "orderBy">
  >;
  allDrsFileexecutors?: SubscriptionResolver<
    Maybe<ResolversTypes["DrsFileexecutorsConnection"]>,
    "allDrsFileexecutors",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDrsFileexecutorsArgs, "orderBy">
  >;
  allDrsMockfileexecutors?: SubscriptionResolver<
    Maybe<ResolversTypes["DrsMockfileexecutorsConnection"]>,
    "allDrsMockfileexecutors",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllDrsMockfileexecutorsArgs, "orderBy">
  >;
  allEulaVersionUserAcceptances?: SubscriptionResolver<
    Maybe<ResolversTypes["EulaVersionUserAcceptancesConnection"]>,
    "allEulaVersionUserAcceptances",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllEulaVersionUserAcceptancesArgs, "orderBy">
  >;
  allEulaVersions?: SubscriptionResolver<
    Maybe<ResolversTypes["EulaVersionsConnection"]>,
    "allEulaVersions",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllEulaVersionsArgs, "orderBy">
  >;
  allFeatureFlags?: SubscriptionResolver<
    Maybe<ResolversTypes["FeatureFlagsConnection"]>,
    "allFeatureFlags",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllFeatureFlagsArgs, "orderBy">
  >;
  allFeatureFlagsGroups?: SubscriptionResolver<
    Maybe<ResolversTypes["FeatureFlagsGroupsConnection"]>,
    "allFeatureFlagsGroups",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllFeatureFlagsGroupsArgs, "orderBy">
  >;
  allFeatureFlagsTenants?: SubscriptionResolver<
    Maybe<ResolversTypes["FeatureFlagsTenantsConnection"]>,
    "allFeatureFlagsTenants",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllFeatureFlagsTenantsArgs, "orderBy">
  >;
  allFeatureFlagsUsers?: SubscriptionResolver<
    Maybe<ResolversTypes["FeatureFlagsUsersConnection"]>,
    "allFeatureFlagsUsers",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllFeatureFlagsUsersArgs, "orderBy">
  >;
  allFileActivities?: SubscriptionResolver<
    Maybe<ResolversTypes["FileActivitiesConnection"]>,
    "allFileActivities",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllFileActivitiesArgs, "orderBy">
  >;
  allFileMetadata?: SubscriptionResolver<
    Maybe<ResolversTypes["FileMetadataConnection"]>,
    "allFileMetadata",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllFileMetadataArgs, "orderBy">
  >;
  allFileOutputGroupMetadata?: SubscriptionResolver<
    Maybe<ResolversTypes["FileOutputGroupMetadataConnection"]>,
    "allFileOutputGroupMetadata",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllFileOutputGroupMetadataArgs, "orderBy">
  >;
  allFileOutputGroups?: SubscriptionResolver<
    Maybe<ResolversTypes["FileOutputGroupsConnection"]>,
    "allFileOutputGroups",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllFileOutputGroupsArgs, "orderBy">
  >;
  allFileProcessingNotifications?: SubscriptionResolver<
    Maybe<ResolversTypes["FileProcessingNotificationsConnection"]>,
    "allFileProcessingNotifications",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllFileProcessingNotificationsArgs, "orderBy">
  >;
  allFiles?: SubscriptionResolver<
    Maybe<ResolversTypes["FilesConnection"]>,
    "allFiles",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllFilesArgs, "orderBy">
  >;
  allFilesByExecutors?: SubscriptionResolver<
    Maybe<ResolversTypes["FilesByExecutorsConnection"]>,
    "allFilesByExecutors",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllFilesByExecutorsArgs, "orderBy">
  >;
  allGdtAnalysisTableCells?: SubscriptionResolver<
    Maybe<ResolversTypes["GdtAnalysisTableCellsConnection"]>,
    "allGdtAnalysisTableCells",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllGdtAnalysisTableCellsArgs, "orderBy">
  >;
  allGdtAnalysisTableColumnGroups?: SubscriptionResolver<
    Maybe<ResolversTypes["GdtAnalysisTableColumnGroupsConnection"]>,
    "allGdtAnalysisTableColumnGroups",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllGdtAnalysisTableColumnGroupsArgs, "orderBy">
  >;
  allGdtAnalysisTableColumns?: SubscriptionResolver<
    Maybe<ResolversTypes["GdtAnalysisTableColumnsConnection"]>,
    "allGdtAnalysisTableColumns",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllGdtAnalysisTableColumnsArgs, "orderBy">
  >;
  allGdtAnalysisTableRows?: SubscriptionResolver<
    Maybe<ResolversTypes["GdtAnalysisTableRowsConnection"]>,
    "allGdtAnalysisTableRows",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllGdtAnalysisTableRowsArgs, "orderBy">
  >;
  allGdtAnalysisTables?: SubscriptionResolver<
    Maybe<ResolversTypes["GdtAnalysisTablesConnection"]>,
    "allGdtAnalysisTables",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllGdtAnalysisTablesArgs, "orderBy">
  >;
  allNotifications?: SubscriptionResolver<
    Maybe<ResolversTypes["NotificationsConnection"]>,
    "allNotifications",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllNotificationsArgs, "orderBy">
  >;
  allOutputGroupFiles?: SubscriptionResolver<
    Maybe<ResolversTypes["OutputGroupFilesConnection"]>,
    "allOutputGroupFiles",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllOutputGroupFilesArgs, "orderBy">
  >;
  allPinnedTools?: SubscriptionResolver<
    Maybe<ResolversTypes["PinnedToolsConnection"]>,
    "allPinnedTools",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllPinnedToolsArgs, "orderBy">
  >;
  allProjectClonedNotifications?: SubscriptionResolver<
    Maybe<ResolversTypes["ProjectClonedNotificationsConnection"]>,
    "allProjectClonedNotifications",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllProjectClonedNotificationsArgs, "orderBy">
  >;
  allProjectFolders?: SubscriptionResolver<
    Maybe<ResolversTypes["ProjectFoldersConnection"]>,
    "allProjectFolders",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllProjectFoldersArgs, "orderBy">
  >;
  allProjectSharedNotifications?: SubscriptionResolver<
    Maybe<ResolversTypes["ProjectSharedNotificationsConnection"]>,
    "allProjectSharedNotifications",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllProjectSharedNotificationsArgs, "orderBy">
  >;
  allProjectTags?: SubscriptionResolver<
    Maybe<ResolversTypes["ProjectTagsConnection"]>,
    "allProjectTags",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllProjectTagsArgs, "orderBy">
  >;
  allProjects?: SubscriptionResolver<
    Maybe<ResolversTypes["ProjectsConnection"]>,
    "allProjects",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllProjectsArgs, "orderBy">
  >;
  allRoleChangeNotifications?: SubscriptionResolver<
    Maybe<ResolversTypes["RoleChangeNotificationsConnection"]>,
    "allRoleChangeNotifications",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllRoleChangeNotificationsArgs, "orderBy">
  >;
  allRuns?: SubscriptionResolver<
    Maybe<ResolversTypes["RunsConnection"]>,
    "allRuns",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllRunsArgs, "orderBy">
  >;
  allTaskActivities?: SubscriptionResolver<
    Maybe<ResolversTypes["TaskActivitiesConnection"]>,
    "allTaskActivities",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllTaskActivitiesArgs, "orderBy">
  >;
  allTaskResourceUsages?: SubscriptionResolver<
    Maybe<ResolversTypes["TaskResourceUsagesConnection"]>,
    "allTaskResourceUsages",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllTaskResourceUsagesArgs, "orderBy">
  >;
  allTaskResources?: SubscriptionResolver<
    Maybe<ResolversTypes["TaskResourcesConnection"]>,
    "allTaskResources",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllTaskResourcesArgs, "orderBy">
  >;
  allTaskSources?: SubscriptionResolver<
    Maybe<ResolversTypes["TaskSourcesConnection"]>,
    "allTaskSources",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllTaskSourcesArgs, "orderBy">
  >;
  allTaskStatusLogs?: SubscriptionResolver<
    Maybe<ResolversTypes["TaskStatusLogsConnection"]>,
    "allTaskStatusLogs",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllTaskStatusLogsArgs, "orderBy">
  >;
  allTasks?: SubscriptionResolver<
    Maybe<ResolversTypes["TasksConnection"]>,
    "allTasks",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllTasksArgs, "orderBy">
  >;
  allTenantContractAllowances?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantContractAllowancesConnection"]>,
    "allTenantContractAllowances",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllTenantContractAllowancesArgs, "orderBy">
  >;
  allTenantContractTransactions?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantContractTransactionsConnection"]>,
    "allTenantContractTransactions",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllTenantContractTransactionsArgs, "orderBy">
  >;
  allTenantContracts?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantContractsConnection"]>,
    "allTenantContracts",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllTenantContractsArgs, "orderBy">
  >;
  allTenantMockuserexecutors?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantMockuserexecutorsConnection"]>,
    "allTenantMockuserexecutors",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllTenantMockuserexecutorsArgs, "orderBy">
  >;
  allTenantMonthlyConsumedResources?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantMonthlyConsumedResourcesConnection"]>,
    "allTenantMonthlyConsumedResources",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllTenantMonthlyConsumedResourcesArgs, "orderBy">
  >;
  allTenantUserMembershipNotifications?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantUserMembershipNotificationsConnection"]>,
    "allTenantUserMembershipNotifications",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAllTenantUserMembershipNotificationsArgs,
      "orderBy"
    >
  >;
  allTenantUserexecutors?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantUserexecutorsConnection"]>,
    "allTenantUserexecutors",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllTenantUserexecutorsArgs, "orderBy">
  >;
  allTesContainerimageexecutors?: SubscriptionResolver<
    Maybe<ResolversTypes["TesContainerimageexecutorsConnection"]>,
    "allTesContainerimageexecutors",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllTesContainerimageexecutorsArgs, "orderBy">
  >;
  allTesMockcontainerimageexecutors?: SubscriptionResolver<
    Maybe<ResolversTypes["TesMockcontainerimageexecutorsConnection"]>,
    "allTesMockcontainerimageexecutors",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllTesMockcontainerimageexecutorsArgs, "orderBy">
  >;
  allTesMocktaskexecutors?: SubscriptionResolver<
    Maybe<ResolversTypes["TesMocktaskexecutorsConnection"]>,
    "allTesMocktaskexecutors",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllTesMocktaskexecutorsArgs, "orderBy">
  >;
  allTesTaskexecutors?: SubscriptionResolver<
    Maybe<ResolversTypes["TesTaskexecutorsConnection"]>,
    "allTesTaskexecutors",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllTesTaskexecutorsArgs, "orderBy">
  >;
  allToolParameters?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolParametersConnection"]>,
    "allToolParameters",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllToolParametersArgs, "orderBy">
  >;
  allToolResources?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolResourcesConnection"]>,
    "allToolResources",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllToolResourcesArgs, "orderBy">
  >;
  allToolResults?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolResultsConnection"]>,
    "allToolResults",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllToolResultsArgs, "orderBy">
  >;
  allToolSecrets?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolSecretsConnection"]>,
    "allToolSecrets",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllToolSecretsArgs, "orderBy">
  >;
  allToolSources?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolSourcesConnection"]>,
    "allToolSources",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllToolSourcesArgs, "orderBy">
  >;
  allToolTenants?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolTenantsConnection"]>,
    "allToolTenants",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllToolTenantsArgs, "orderBy">
  >;
  allToolVersions?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolVersionsConnection"]>,
    "allToolVersions",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllToolVersionsArgs, "orderBy">
  >;
  allToolboxTenants?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolboxTenantsConnection"]>,
    "allToolboxTenants",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllToolboxTenantsArgs, "orderBy">
  >;
  allToolboxes?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolboxesConnection"]>,
    "allToolboxes",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllToolboxesArgs, "orderBy">
  >;
  allTools?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolsConnection"]>,
    "allTools",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllToolsArgs, "orderBy">
  >;
  allUserAccessToProjects?: SubscriptionResolver<
    Maybe<ResolversTypes["UserAccessToProjectsConnection"]>,
    "allUserAccessToProjects",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllUserAccessToProjectsArgs, "orderBy">
  >;
  allUserOnboardingQuestionAnswers?: SubscriptionResolver<
    Maybe<ResolversTypes["UserOnboardingQuestionAnswersConnection"]>,
    "allUserOnboardingQuestionAnswers",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllUserOnboardingQuestionAnswersArgs, "orderBy">
  >;
  allUserOnboardingQuestionResponses?: SubscriptionResolver<
    Maybe<ResolversTypes["UserOnboardingQuestionResponsesConnection"]>,
    "allUserOnboardingQuestionResponses",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllUserOnboardingQuestionResponsesArgs, "orderBy">
  >;
  allUserOnboardingQuestions?: SubscriptionResolver<
    Maybe<ResolversTypes["UserOnboardingQuestionsConnection"]>,
    "allUserOnboardingQuestions",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllUserOnboardingQuestionsArgs, "orderBy">
  >;
  allWaffleFlags?: SubscriptionResolver<
    Maybe<ResolversTypes["WaffleFlagsConnection"]>,
    "allWaffleFlags",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllWaffleFlagsArgs, "orderBy">
  >;
  allWaffleSamples?: SubscriptionResolver<
    Maybe<ResolversTypes["WaffleSamplesConnection"]>,
    "allWaffleSamples",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllWaffleSamplesArgs, "orderBy">
  >;
  allWaffleSwitches?: SubscriptionResolver<
    Maybe<ResolversTypes["WaffleSwitchesConnection"]>,
    "allWaffleSwitches",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllWaffleSwitchesArgs, "orderBy">
  >;
  allWorkflowData?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowDataConnection"]>,
    "allWorkflowData",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllWorkflowDataArgs, "orderBy">
  >;
  allWorkflowResultWorkflowVersions?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowResultWorkflowVersionsConnection"]>,
    "allWorkflowResultWorkflowVersions",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllWorkflowResultWorkflowVersionsArgs, "orderBy">
  >;
  allWorkflowResults?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowResultsConnection"]>,
    "allWorkflowResults",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllWorkflowResultsArgs, "orderBy">
  >;
  allWorkflowSectionBlockSections?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowSectionBlockSectionsConnection"]>,
    "allWorkflowSectionBlockSections",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllWorkflowSectionBlockSectionsArgs, "orderBy">
  >;
  allWorkflowSectionBlocks?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowSectionBlocksConnection"]>,
    "allWorkflowSectionBlocks",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllWorkflowSectionBlocksArgs, "orderBy">
  >;
  allWorkflowSectionWorkflowVersions?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowSectionWorkflowVersionsConnection"]>,
    "allWorkflowSectionWorkflowVersions",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllWorkflowSectionWorkflowVersionsArgs, "orderBy">
  >;
  allWorkflowSections?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowSectionsConnection"]>,
    "allWorkflowSections",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllWorkflowSectionsArgs, "orderBy">
  >;
  allWorkflowSourceWorkflowVersions?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowSourceWorkflowVersionsConnection"]>,
    "allWorkflowSourceWorkflowVersions",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllWorkflowSourceWorkflowVersionsArgs, "orderBy">
  >;
  allWorkflowSources?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowSourcesConnection"]>,
    "allWorkflowSources",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllWorkflowSourcesArgs, "orderBy">
  >;
  allWorkflowVersions?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowVersionsConnection"]>,
    "allWorkflowVersions",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllWorkflowVersionsArgs, "orderBy">
  >;
  allWorkflows?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowsConnection"]>,
    "allWorkflows",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAllWorkflowsArgs, "orderBy">
  >;
  applicationUserByEmail?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    "applicationUserByEmail",
    ParentType,
    ContextType,
    RequireFields<SubscriptionApplicationUserByEmailArgs, "email">
  >;
  applicationUserByGlobalUserId?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    "applicationUserByGlobalUserId",
    ParentType,
    ContextType,
    RequireFields<SubscriptionApplicationUserByGlobalUserIdArgs, "globalUserId">
  >;
  applicationUserById?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    "applicationUserById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionApplicationUserByIdArgs, "id">
  >;
  applicationUserByUsername?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    "applicationUserByUsername",
    ParentType,
    ContextType,
    RequireFields<SubscriptionApplicationUserByUsernameArgs, "username">
  >;
  applicationUserGroupById?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUserGroup"]>,
    "applicationUserGroupById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionApplicationUserGroupByIdArgs, "id">
  >;
  applicationUserGroupByUserIdAndGroupId?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUserGroup"]>,
    "applicationUserGroupByUserIdAndGroupId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionApplicationUserGroupByUserIdAndGroupIdArgs,
      "groupId" | "userId"
    >
  >;
  applicationUserMembershipById?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUserMembership"]>,
    "applicationUserMembershipById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionApplicationUserMembershipByIdArgs, "id">
  >;
  applicationUserMembershipByUserIdAndTenantId?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUserMembership"]>,
    "applicationUserMembershipByUserIdAndTenantId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionApplicationUserMembershipByUserIdAndTenantIdArgs,
      "tenantId" | "userId"
    >
  >;
  applicationUserMetadatumById?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUserMetadatum"]>,
    "applicationUserMetadatumById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionApplicationUserMetadatumByIdArgs, "id">
  >;
  applicationUserMetadatumByUserIdAndKey?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUserMetadatum"]>,
    "applicationUserMetadatumByUserIdAndKey",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionApplicationUserMetadatumByUserIdAndKeyArgs,
      "key" | "userId"
    >
  >;
  applicationUserSessionById?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUserSession"]>,
    "applicationUserSessionById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionApplicationUserSessionByIdArgs, "id">
  >;
  applicationUserUserPermissionById?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUserUserPermission"]>,
    "applicationUserUserPermissionById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionApplicationUserUserPermissionByIdArgs, "id">
  >;
  applicationUserUserPermissionByUserIdAndPermissionId?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUserUserPermission"]>,
    "applicationUserUserPermissionByUserIdAndPermissionId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionApplicationUserUserPermissionByUserIdAndPermissionIdArgs,
      "permissionId" | "userId"
    >
  >;
  assertUserAcceptedEula?: SubscriptionResolver<
    Maybe<ResolversTypes["Boolean"]>,
    "assertUserAcceptedEula",
    ParentType,
    ContextType
  >;
  assertUserCanSeeTenantInfo?: SubscriptionResolver<
    Maybe<ResolversTypes["Boolean"]>,
    "assertUserCanSeeTenantInfo",
    ParentType,
    ContextType,
    Partial<SubscriptionAssertUserCanSeeTenantInfoArgs>
  >;
  assertUserCanSeeUserInfo?: SubscriptionResolver<
    Maybe<ResolversTypes["Boolean"]>,
    "assertUserCanSeeUserInfo",
    ParentType,
    ContextType,
    Partial<SubscriptionAssertUserCanSeeUserInfoArgs>
  >;
  assertUserHasProjectSharedByTenant?: SubscriptionResolver<
    Maybe<ResolversTypes["Boolean"]>,
    "assertUserHasProjectSharedByTenant",
    ParentType,
    ContextType,
    Partial<SubscriptionAssertUserHasProjectSharedByTenantArgs>
  >;
  assertUserHasTenantOfId?: SubscriptionResolver<
    Maybe<ResolversTypes["Boolean"]>,
    "assertUserHasTenantOfId",
    ParentType,
    ContextType,
    Partial<SubscriptionAssertUserHasTenantOfIdArgs>
  >;
  assertUserIsAdminOfProjectTenant?: SubscriptionResolver<
    Maybe<ResolversTypes["Boolean"]>,
    "assertUserIsAdminOfProjectTenant",
    ParentType,
    ContextType,
    Partial<SubscriptionAssertUserIsAdminOfProjectTenantArgs>
  >;
  assertUserIsAdminOfTenant?: SubscriptionResolver<
    Maybe<ResolversTypes["Boolean"]>,
    "assertUserIsAdminOfTenant",
    ParentType,
    ContextType,
    Partial<SubscriptionAssertUserIsAdminOfTenantArgs>
  >;
  assertUserIsInvitedToTenant?: SubscriptionResolver<
    Maybe<ResolversTypes["Boolean"]>,
    "assertUserIsInvitedToTenant",
    ParentType,
    ContextType,
    Partial<SubscriptionAssertUserIsInvitedToTenantArgs>
  >;
  auditlogLogentryById?: SubscriptionResolver<
    Maybe<ResolversTypes["AuditlogLogentry"]>,
    "auditlogLogentryById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAuditlogLogentryByIdArgs, "id">
  >;
  authGroupById?: SubscriptionResolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    "authGroupById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAuthGroupByIdArgs, "id">
  >;
  authGroupByName?: SubscriptionResolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    "authGroupByName",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAuthGroupByNameArgs, "name">
  >;
  authGroupPermissionByGroupIdAndPermissionId?: SubscriptionResolver<
    Maybe<ResolversTypes["AuthGroupPermission"]>,
    "authGroupPermissionByGroupIdAndPermissionId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAuthGroupPermissionByGroupIdAndPermissionIdArgs,
      "groupId" | "permissionId"
    >
  >;
  authGroupPermissionById?: SubscriptionResolver<
    Maybe<ResolversTypes["AuthGroupPermission"]>,
    "authGroupPermissionById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAuthGroupPermissionByIdArgs, "id">
  >;
  authPermissionByContentTypeIdAndCodename?: SubscriptionResolver<
    Maybe<ResolversTypes["AuthPermission"]>,
    "authPermissionByContentTypeIdAndCodename",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAuthPermissionByContentTypeIdAndCodenameArgs,
      "codename" | "contentTypeId"
    >
  >;
  authPermissionById?: SubscriptionResolver<
    Maybe<ResolversTypes["AuthPermission"]>,
    "authPermissionById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAuthPermissionByIdArgs, "id">
  >;
  avatarById?: SubscriptionResolver<
    Maybe<ResolversTypes["Avatar"]>,
    "avatarById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAvatarByIdArgs, "id">
  >;
  avatarByUserId?: SubscriptionResolver<
    Maybe<ResolversTypes["Avatar"]>,
    "avatarByUserId",
    ParentType,
    ContextType,
    RequireFields<SubscriptionAvatarByUserIdArgs, "userId">
  >;
  awsBatchTaskByTaskexecutorPtrId?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsBatchTask"]>,
    "awsBatchTaskByTaskexecutorPtrId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAwsBatchTaskByTaskexecutorPtrIdArgs,
      "taskexecutorPtrId"
    >
  >;
  awsCognitoUserByUserexecutorPtrId?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsCognitoUser"]>,
    "awsCognitoUserByUserexecutorPtrId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAwsCognitoUserByUserexecutorPtrIdArgs,
      "userexecutorPtrId"
    >
  >;
  awsEcrImageByContainerimageexecutorPtrId?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsEcrImage"]>,
    "awsEcrImageByContainerimageexecutorPtrId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAwsEcrImageByContainerimageexecutorPtrIdArgs,
      "containerimageexecutorPtrId"
    >
  >;
  awsMockBatchTaskByAwstaskexecutorPtrId?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsMockBatchTask"]>,
    "awsMockBatchTaskByAwstaskexecutorPtrId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAwsMockBatchTaskByAwstaskexecutorPtrIdArgs,
      "awstaskexecutorPtrId"
    >
  >;
  awsMockDistributionImageByDistributioncontainerimageexecutorPtrId?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsMockDistributionImage"]>,
    "awsMockDistributionImageByDistributioncontainerimageexecutorPtrId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAwsMockDistributionImageByDistributioncontainerimageexecutorPtrIdArgs,
      "distributioncontainerimageexecutorPtrId"
    >
  >;
  awsMockEcrImageByAwscontainerimageexecutorPtrId?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsMockEcrImage"]>,
    "awsMockEcrImageByAwscontainerimageexecutorPtrId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAwsMockEcrImageByAwscontainerimageexecutorPtrIdArgs,
      "awscontainerimageexecutorPtrId"
    >
  >;
  awsMockIamUserByAwsuserexecutorPtrId?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsMockIamUser"]>,
    "awsMockIamUserByAwsuserexecutorPtrId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAwsMockIamUserByAwsuserexecutorPtrIdArgs,
      "awsuserexecutorPtrId"
    >
  >;
  awsMockS3FileByAwsfileexecutorPtrId?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsMockS3File"]>,
    "awsMockS3FileByAwsfileexecutorPtrId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAwsMockS3FileByAwsfileexecutorPtrIdArgs,
      "awsfileexecutorPtrId"
    >
  >;
  awsS3FileByFileexecutorPtrId?: SubscriptionResolver<
    Maybe<ResolversTypes["AwsS3File"]>,
    "awsS3FileByFileexecutorPtrId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionAwsS3FileByFileexecutorPtrIdArgs,
      "fileexecutorPtrId"
    >
  >;
  codeFileById?: SubscriptionResolver<
    Maybe<ResolversTypes["CodeFile"]>,
    "codeFileById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionCodeFileByIdArgs, "id">
  >;
  commandById?: SubscriptionResolver<
    Maybe<ResolversTypes["Command"]>,
    "commandById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionCommandByIdArgs, "id">
  >;
  commandByToolVersionId?: SubscriptionResolver<
    Maybe<ResolversTypes["Command"]>,
    "commandByToolVersionId",
    ParentType,
    ContextType,
    RequireFields<SubscriptionCommandByToolVersionIdArgs, "toolVersionId">
  >;
  commandByToolVersionIdAndCodeFileId?: SubscriptionResolver<
    Maybe<ResolversTypes["Command"]>,
    "commandByToolVersionIdAndCodeFileId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionCommandByToolVersionIdAndCodeFileIdArgs,
      "codeFileId" | "toolVersionId"
    >
  >;
  containerImageByExecutorId?: SubscriptionResolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    "containerImageByExecutorId",
    ParentType,
    ContextType,
    RequireFields<SubscriptionContainerImageByExecutorIdArgs, "executorId">
  >;
  containerImageById?: SubscriptionResolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    "containerImageById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionContainerImageByIdArgs, "id">
  >;
  containerImageRepositoryById?: SubscriptionResolver<
    Maybe<ResolversTypes["ContainerImageRepository"]>,
    "containerImageRepositoryById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionContainerImageRepositoryByIdArgs, "id">
  >;
  containerImageRepositoryByNameAndTenantIdAndRegistryType?: SubscriptionResolver<
    Maybe<ResolversTypes["ContainerImageRepository"]>,
    "containerImageRepositoryByNameAndTenantIdAndRegistryType",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionContainerImageRepositoryByNameAndTenantIdAndRegistryTypeArgs,
      "name" | "registryType" | "tenantId"
    >
  >;
  containerImageRepositoryByRepository?: SubscriptionResolver<
    Maybe<ResolversTypes["ContainerImageRepository"]>,
    "containerImageRepositoryByRepository",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionContainerImageRepositoryByRepositoryArgs,
      "repository"
    >
  >;
  costById?: SubscriptionResolver<
    Maybe<ResolversTypes["Cost"]>,
    "costById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionCostByIdArgs, "id">
  >;
  dataTableById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTable"]>,
    "dataTableById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableByIdArgs, "id">
  >;
  dataTableCellByColumnIdAndRowId?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableCell"]>,
    "dataTableCellByColumnIdAndRowId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionDataTableCellByColumnIdAndRowIdArgs,
      "columnId" | "rowId"
    >
  >;
  dataTableCellById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableCell"]>,
    "dataTableCellById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableCellByIdArgs, "id">
  >;
  dataTableColumnById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumn"]>,
    "dataTableColumnById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableColumnByIdArgs, "id">
  >;
  dataTableColumnByTableIdAndOrder?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumn"]>,
    "dataTableColumnByTableIdAndOrder",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionDataTableColumnByTableIdAndOrderArgs,
      "order" | "tableId"
    >
  >;
  dataTableColumnDefinitionBooleanById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionBoolean"]>,
    "dataTableColumnDefinitionBooleanById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableColumnDefinitionBooleanByIdArgs, "id">
  >;
  dataTableColumnDefinitionCellStatusById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionCellStatus"]>,
    "dataTableColumnDefinitionCellStatusById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableColumnDefinitionCellStatusByIdArgs, "id">
  >;
  dataTableColumnDefinitionChoiceById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionChoice"]>,
    "dataTableColumnDefinitionChoiceById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableColumnDefinitionChoiceByIdArgs, "id">
  >;
  dataTableColumnDefinitionDateById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionDate"]>,
    "dataTableColumnDefinitionDateById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableColumnDefinitionDateByIdArgs, "id">
  >;
  dataTableColumnDefinitionFileById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionFile"]>,
    "dataTableColumnDefinitionFileById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableColumnDefinitionFileByIdArgs, "id">
  >;
  dataTableColumnDefinitionFloatById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionFloat"]>,
    "dataTableColumnDefinitionFloatById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableColumnDefinitionFloatByIdArgs, "id">
  >;
  dataTableColumnDefinitionIdentifierById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionIdentifier"]>,
    "dataTableColumnDefinitionIdentifierById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableColumnDefinitionIdentifierByIdArgs, "id">
  >;
  dataTableColumnDefinitionIntegerById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionInteger"]>,
    "dataTableColumnDefinitionIntegerById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableColumnDefinitionIntegerByIdArgs, "id">
  >;
  dataTableColumnDefinitionJoinById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionJoin"]>,
    "dataTableColumnDefinitionJoinById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableColumnDefinitionJoinByIdArgs, "id">
  >;
  dataTableColumnDefinitionMetadatumById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionMetadatum"]>,
    "dataTableColumnDefinitionMetadatumById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableColumnDefinitionMetadatumByIdArgs, "id">
  >;
  dataTableColumnDefinitionRoiFrameById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionRoiFrame"]>,
    "dataTableColumnDefinitionRoiFrameById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableColumnDefinitionRoiFrameByIdArgs, "id">
  >;
  dataTableColumnDefinitionTextById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnDefinitionText"]>,
    "dataTableColumnDefinitionTextById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableColumnDefinitionTextByIdArgs, "id">
  >;
  dataTableColumnGroupById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnGroup"]>,
    "dataTableColumnGroupById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableColumnGroupByIdArgs, "id">
  >;
  dataTableColumnGroupDefinitionJoinById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnGroupDefinitionJoin"]>,
    "dataTableColumnGroupDefinitionJoinById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableColumnGroupDefinitionJoinByIdArgs, "id">
  >;
  dataTableColumnGroupDefinitionSourceById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableColumnGroupDefinitionSource"]>,
    "dataTableColumnGroupDefinitionSourceById",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionDataTableColumnGroupDefinitionSourceByIdArgs,
      "id"
    >
  >;
  dataTableRowById?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableRow"]>,
    "dataTableRowById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDataTableRowByIdArgs, "id">
  >;
  dataTableRowByTableIdAndIndex?: SubscriptionResolver<
    Maybe<ResolversTypes["DataTableRow"]>,
    "dataTableRowByTableIdAndIndex",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionDataTableRowByTableIdAndIndexArgs,
      "index" | "tableId"
    >
  >;
  distributionRegistryImageByContainerimageexecutorPtrId?: SubscriptionResolver<
    Maybe<ResolversTypes["DistributionRegistryImage"]>,
    "distributionRegistryImageByContainerimageexecutorPtrId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionDistributionRegistryImageByContainerimageexecutorPtrIdArgs,
      "containerimageexecutorPtrId"
    >
  >;
  djangoAdminLogById?: SubscriptionResolver<
    Maybe<ResolversTypes["DjangoAdminLog"]>,
    "djangoAdminLogById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDjangoAdminLogByIdArgs, "id">
  >;
  djangoContentTypeByAppLabelAndModel?: SubscriptionResolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    "djangoContentTypeByAppLabelAndModel",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionDjangoContentTypeByAppLabelAndModelArgs,
      "appLabel" | "model"
    >
  >;
  djangoContentTypeById?: SubscriptionResolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    "djangoContentTypeById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDjangoContentTypeByIdArgs, "id">
  >;
  djangoMigrationById?: SubscriptionResolver<
    Maybe<ResolversTypes["DjangoMigration"]>,
    "djangoMigrationById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDjangoMigrationByIdArgs, "id">
  >;
  djangoSesBlacklistedemailByEmail?: SubscriptionResolver<
    Maybe<ResolversTypes["DjangoSesBlacklistedemail"]>,
    "djangoSesBlacklistedemailByEmail",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDjangoSesBlacklistedemailByEmailArgs, "email">
  >;
  djangoSesBlacklistedemailById?: SubscriptionResolver<
    Maybe<ResolversTypes["DjangoSesBlacklistedemail"]>,
    "djangoSesBlacklistedemailById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDjangoSesBlacklistedemailByIdArgs, "id">
  >;
  djangoSesSesstatByDate?: SubscriptionResolver<
    Maybe<ResolversTypes["DjangoSesSesstat"]>,
    "djangoSesSesstatByDate",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDjangoSesSesstatByDateArgs, "date">
  >;
  djangoSesSesstatById?: SubscriptionResolver<
    Maybe<ResolversTypes["DjangoSesSesstat"]>,
    "djangoSesSesstatById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDjangoSesSesstatByIdArgs, "id">
  >;
  djangoSessionBySessionKey?: SubscriptionResolver<
    Maybe<ResolversTypes["DjangoSession"]>,
    "djangoSessionBySessionKey",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDjangoSessionBySessionKeyArgs, "sessionKey">
  >;
  drsFileexecutorById?: SubscriptionResolver<
    Maybe<ResolversTypes["DrsFileexecutor"]>,
    "drsFileexecutorById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionDrsFileexecutorByIdArgs, "id">
  >;
  drsMockfileexecutorByFileexecutorPtrId?: SubscriptionResolver<
    Maybe<ResolversTypes["DrsMockfileexecutor"]>,
    "drsMockfileexecutorByFileexecutorPtrId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionDrsMockfileexecutorByFileexecutorPtrIdArgs,
      "fileexecutorPtrId"
    >
  >;
  eulaVersionById?: SubscriptionResolver<
    Maybe<ResolversTypes["EulaVersion"]>,
    "eulaVersionById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionEulaVersionByIdArgs, "id">
  >;
  eulaVersionByVersion?: SubscriptionResolver<
    Maybe<ResolversTypes["EulaVersion"]>,
    "eulaVersionByVersion",
    ParentType,
    ContextType,
    RequireFields<SubscriptionEulaVersionByVersionArgs, "version">
  >;
  eulaVersionUserAcceptanceById?: SubscriptionResolver<
    Maybe<ResolversTypes["EulaVersionUserAcceptance"]>,
    "eulaVersionUserAcceptanceById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionEulaVersionUserAcceptanceByIdArgs, "id">
  >;
  eulaVersionUserAcceptanceByUserIdAndEulaVersionId?: SubscriptionResolver<
    Maybe<ResolversTypes["EulaVersionUserAcceptance"]>,
    "eulaVersionUserAcceptanceByUserIdAndEulaVersionId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionEulaVersionUserAcceptanceByUserIdAndEulaVersionIdArgs,
      "eulaVersionId" | "userId"
    >
  >;
  featureFlagById?: SubscriptionResolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    "featureFlagById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionFeatureFlagByIdArgs, "id">
  >;
  featureFlagByName?: SubscriptionResolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    "featureFlagByName",
    ParentType,
    ContextType,
    RequireFields<SubscriptionFeatureFlagByNameArgs, "name">
  >;
  featureFlagsGroupByFeatureflagIdAndGroupId?: SubscriptionResolver<
    Maybe<ResolversTypes["FeatureFlagsGroup"]>,
    "featureFlagsGroupByFeatureflagIdAndGroupId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionFeatureFlagsGroupByFeatureflagIdAndGroupIdArgs,
      "featureflagId" | "groupId"
    >
  >;
  featureFlagsGroupById?: SubscriptionResolver<
    Maybe<ResolversTypes["FeatureFlagsGroup"]>,
    "featureFlagsGroupById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionFeatureFlagsGroupByIdArgs, "id">
  >;
  featureFlagsTenantByFeatureflagIdAndTenantId?: SubscriptionResolver<
    Maybe<ResolversTypes["FeatureFlagsTenant"]>,
    "featureFlagsTenantByFeatureflagIdAndTenantId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionFeatureFlagsTenantByFeatureflagIdAndTenantIdArgs,
      "featureflagId" | "tenantId"
    >
  >;
  featureFlagsTenantById?: SubscriptionResolver<
    Maybe<ResolversTypes["FeatureFlagsTenant"]>,
    "featureFlagsTenantById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionFeatureFlagsTenantByIdArgs, "id">
  >;
  featureFlagsUserByFeatureflagIdAndUserId?: SubscriptionResolver<
    Maybe<ResolversTypes["FeatureFlagsUser"]>,
    "featureFlagsUserByFeatureflagIdAndUserId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionFeatureFlagsUserByFeatureflagIdAndUserIdArgs,
      "featureflagId" | "userId"
    >
  >;
  featureFlagsUserById?: SubscriptionResolver<
    Maybe<ResolversTypes["FeatureFlagsUser"]>,
    "featureFlagsUserById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionFeatureFlagsUserByIdArgs, "id">
  >;
  fileActivityById?: SubscriptionResolver<
    Maybe<ResolversTypes["FileActivity"]>,
    "fileActivityById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionFileActivityByIdArgs, "id">
  >;
  fileById?: SubscriptionResolver<
    Maybe<ResolversTypes["File"]>,
    "fileById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionFileByIdArgs, "id">
  >;
  fileByProjectIdAndReferenceId?: SubscriptionResolver<
    Maybe<ResolversTypes["File"]>,
    "fileByProjectIdAndReferenceId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionFileByProjectIdAndReferenceIdArgs,
      "projectId" | "referenceId"
    >
  >;
  fileMetadatumById?: SubscriptionResolver<
    Maybe<ResolversTypes["FileMetadatum"]>,
    "fileMetadatumById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionFileMetadatumByIdArgs, "id">
  >;
  fileOutputGroupById?: SubscriptionResolver<
    Maybe<ResolversTypes["FileOutputGroup"]>,
    "fileOutputGroupById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionFileOutputGroupByIdArgs, "id">
  >;
  fileOutputGroupByTaskId?: SubscriptionResolver<
    Maybe<ResolversTypes["FileOutputGroup"]>,
    "fileOutputGroupByTaskId",
    ParentType,
    ContextType,
    RequireFields<SubscriptionFileOutputGroupByTaskIdArgs, "taskId">
  >;
  fileOutputGroupMetadatumById?: SubscriptionResolver<
    Maybe<ResolversTypes["FileOutputGroupMetadatum"]>,
    "fileOutputGroupMetadatumById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionFileOutputGroupMetadatumByIdArgs, "id">
  >;
  fileProcessingNotificationById?: SubscriptionResolver<
    Maybe<ResolversTypes["FileProcessingNotification"]>,
    "fileProcessingNotificationById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionFileProcessingNotificationByIdArgs, "id">
  >;
  gdtAnalysisTableById?: SubscriptionResolver<
    Maybe<ResolversTypes["GdtAnalysisTable"]>,
    "gdtAnalysisTableById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionGdtAnalysisTableByIdArgs, "id">
  >;
  gdtAnalysisTableCellByColumnIdAndRowId?: SubscriptionResolver<
    Maybe<ResolversTypes["GdtAnalysisTableCell"]>,
    "gdtAnalysisTableCellByColumnIdAndRowId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionGdtAnalysisTableCellByColumnIdAndRowIdArgs,
      "columnId" | "rowId"
    >
  >;
  gdtAnalysisTableCellById?: SubscriptionResolver<
    Maybe<ResolversTypes["GdtAnalysisTableCell"]>,
    "gdtAnalysisTableCellById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionGdtAnalysisTableCellByIdArgs, "id">
  >;
  gdtAnalysisTableColumnById?: SubscriptionResolver<
    Maybe<ResolversTypes["GdtAnalysisTableColumn"]>,
    "gdtAnalysisTableColumnById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionGdtAnalysisTableColumnByIdArgs, "id">
  >;
  gdtAnalysisTableColumnByTableIdAndOrder?: SubscriptionResolver<
    Maybe<ResolversTypes["GdtAnalysisTableColumn"]>,
    "gdtAnalysisTableColumnByTableIdAndOrder",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionGdtAnalysisTableColumnByTableIdAndOrderArgs,
      "order" | "tableId"
    >
  >;
  gdtAnalysisTableColumnGroupById?: SubscriptionResolver<
    Maybe<ResolversTypes["GdtAnalysisTableColumnGroup"]>,
    "gdtAnalysisTableColumnGroupById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionGdtAnalysisTableColumnGroupByIdArgs, "id">
  >;
  gdtAnalysisTableRowById?: SubscriptionResolver<
    Maybe<ResolversTypes["GdtAnalysisTableRow"]>,
    "gdtAnalysisTableRowById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionGdtAnalysisTableRowByIdArgs, "id">
  >;
  gdtAnalysisTableRowByTableIdAndIndex?: SubscriptionResolver<
    Maybe<ResolversTypes["GdtAnalysisTableRow"]>,
    "gdtAnalysisTableRowByTableIdAndIndex",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionGdtAnalysisTableRowByTableIdAndIndexArgs,
      "index" | "tableId"
    >
  >;
  gdtAnalysisTableRowByTaskId?: SubscriptionResolver<
    Maybe<ResolversTypes["GdtAnalysisTableRow"]>,
    "gdtAnalysisTableRowByTaskId",
    ParentType,
    ContextType,
    RequireFields<SubscriptionGdtAnalysisTableRowByTaskIdArgs, "taskId">
  >;
  getCurrentUser?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    "getCurrentUser",
    ParentType,
    ContextType
  >;
  getCurrentUserId?: SubscriptionResolver<
    Maybe<ResolversTypes["UUID"]>,
    "getCurrentUserId",
    ParentType,
    ContextType
  >;
  getUserActiveSession?: SubscriptionResolver<
    Maybe<ResolversTypes["ApplicationUserSession"]>,
    "getUserActiveSession",
    ParentType,
    ContextType,
    RequireFields<SubscriptionGetUserActiveSessionArgs, "userid">
  >;
  jwtHasGlobalUserIdClaim?: SubscriptionResolver<
    Maybe<ResolversTypes["Boolean"]>,
    "jwtHasGlobalUserIdClaim",
    ParentType,
    ContextType
  >;
  metadataValueById?: SubscriptionResolver<
    Maybe<ResolversTypes["MetadataValue"]>,
    "metadataValueById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionMetadataValueByIdArgs, "id">
  >;
  metadatumById?: SubscriptionResolver<
    Maybe<ResolversTypes["Metadatum"]>,
    "metadatumById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionMetadatumByIdArgs, "id">
  >;
  notificationById?: SubscriptionResolver<
    Maybe<ResolversTypes["Notification"]>,
    "notificationById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionNotificationByIdArgs, "id">
  >;
  outputGroupFileById?: SubscriptionResolver<
    Maybe<ResolversTypes["OutputGroupFile"]>,
    "outputGroupFileById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionOutputGroupFileByIdArgs, "id">
  >;
  pinnedToolById?: SubscriptionResolver<
    Maybe<ResolversTypes["PinnedTool"]>,
    "pinnedToolById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionPinnedToolByIdArgs, "id">
  >;
  pinnedToolByUserIdAndToolId?: SubscriptionResolver<
    Maybe<ResolversTypes["PinnedTool"]>,
    "pinnedToolByUserIdAndToolId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionPinnedToolByUserIdAndToolIdArgs,
      "toolId" | "userId"
    >
  >;
  projectById?: SubscriptionResolver<
    Maybe<ResolversTypes["Project"]>,
    "projectById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionProjectByIdArgs, "id">
  >;
  projectByKeyAndTenantId?: SubscriptionResolver<
    Maybe<ResolversTypes["Project"]>,
    "projectByKeyAndTenantId",
    ParentType,
    ContextType,
    RequireFields<SubscriptionProjectByKeyAndTenantIdArgs, "key" | "tenantId">
  >;
  projectClonedNotificationById?: SubscriptionResolver<
    Maybe<ResolversTypes["ProjectClonedNotification"]>,
    "projectClonedNotificationById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionProjectClonedNotificationByIdArgs, "id">
  >;
  projectFolderById?: SubscriptionResolver<
    Maybe<ResolversTypes["ProjectFolder"]>,
    "projectFolderById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionProjectFolderByIdArgs, "id">
  >;
  projectSharedNotificationById?: SubscriptionResolver<
    Maybe<ResolversTypes["ProjectSharedNotification"]>,
    "projectSharedNotificationById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionProjectSharedNotificationByIdArgs, "id">
  >;
  projectTagById?: SubscriptionResolver<
    Maybe<ResolversTypes["ProjectTag"]>,
    "projectTagById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionProjectTagByIdArgs, "id">
  >;
  query?: SubscriptionResolver<
    ResolversTypes["Query"],
    "query",
    ParentType,
    ContextType
  >;
  roleChangeNotificationById?: SubscriptionResolver<
    Maybe<ResolversTypes["RoleChangeNotification"]>,
    "roleChangeNotificationById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionRoleChangeNotificationByIdArgs, "id">
  >;
  runById?: SubscriptionResolver<
    Maybe<ResolversTypes["Run"]>,
    "runById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionRunByIdArgs, "id">
  >;
  sessionIsActiveSession?: SubscriptionResolver<
    Maybe<ResolversTypes["Boolean"]>,
    "sessionIsActiveSession",
    ParentType,
    ContextType,
    RequireFields<SubscriptionSessionIsActiveSessionArgs, "id">
  >;
  taskActivityById?: SubscriptionResolver<
    Maybe<ResolversTypes["TaskActivity"]>,
    "taskActivityById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTaskActivityByIdArgs, "id">
  >;
  taskActivityByTaskId?: SubscriptionResolver<
    Maybe<ResolversTypes["TaskActivity"]>,
    "taskActivityByTaskId",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTaskActivityByTaskIdArgs, "taskId">
  >;
  taskByExecutorId?: SubscriptionResolver<
    Maybe<ResolversTypes["Task"]>,
    "taskByExecutorId",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTaskByExecutorIdArgs, "executorId">
  >;
  taskById?: SubscriptionResolver<
    Maybe<ResolversTypes["Task"]>,
    "taskById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTaskByIdArgs, "id">
  >;
  taskResourceById?: SubscriptionResolver<
    Maybe<ResolversTypes["TaskResource"]>,
    "taskResourceById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTaskResourceByIdArgs, "id">
  >;
  taskResourceUsageById?: SubscriptionResolver<
    Maybe<ResolversTypes["TaskResourceUsage"]>,
    "taskResourceUsageById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTaskResourceUsageByIdArgs, "id">
  >;
  taskResourceUsageByTaskId?: SubscriptionResolver<
    Maybe<ResolversTypes["TaskResourceUsage"]>,
    "taskResourceUsageByTaskId",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTaskResourceUsageByTaskIdArgs, "taskId">
  >;
  taskSourceById?: SubscriptionResolver<
    Maybe<ResolversTypes["TaskSource"]>,
    "taskSourceById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTaskSourceByIdArgs, "id">
  >;
  taskStatusLogById?: SubscriptionResolver<
    Maybe<ResolversTypes["TaskStatusLog"]>,
    "taskStatusLogById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTaskStatusLogByIdArgs, "id">
  >;
  taskStatusLogByTaskIdAndStatus?: SubscriptionResolver<
    Maybe<ResolversTypes["TaskStatusLog"]>,
    "taskStatusLogByTaskIdAndStatus",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionTaskStatusLogByTaskIdAndStatusArgs,
      "status" | "taskId"
    >
  >;
  tenantById?: SubscriptionResolver<
    Maybe<ResolversTypes["Tenant"]>,
    "tenantById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTenantByIdArgs, "id">
  >;
  tenantByKey?: SubscriptionResolver<
    Maybe<ResolversTypes["Tenant"]>,
    "tenantByKey",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTenantByKeyArgs, "key">
  >;
  tenantByRepositoryName?: SubscriptionResolver<
    Maybe<ResolversTypes["Tenant"]>,
    "tenantByRepositoryName",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTenantByRepositoryNameArgs, "repositoryName">
  >;
  tenantBySfid?: SubscriptionResolver<
    Maybe<ResolversTypes["Tenant"]>,
    "tenantBySfid",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTenantBySfidArgs, "sfid">
  >;
  tenantContractAllowanceById?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantContractAllowance"]>,
    "tenantContractAllowanceById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTenantContractAllowanceByIdArgs, "id">
  >;
  tenantContractAllowanceByTenantContractTransactionIdAndQuotaType?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantContractAllowance"]>,
    "tenantContractAllowanceByTenantContractTransactionIdAndQuotaType",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionTenantContractAllowanceByTenantContractTransactionIdAndQuotaTypeArgs,
      "quotaType" | "tenantContractTransactionId"
    >
  >;
  tenantContractById?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantContract"]>,
    "tenantContractById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTenantContractByIdArgs, "id">
  >;
  tenantContractByName?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantContract"]>,
    "tenantContractByName",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTenantContractByNameArgs, "name">
  >;
  tenantContractBySfid?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantContract"]>,
    "tenantContractBySfid",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTenantContractBySfidArgs, "sfid">
  >;
  tenantContractTransactionById?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantContractTransaction"]>,
    "tenantContractTransactionById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTenantContractTransactionByIdArgs, "id">
  >;
  tenantMockuserexecutorByUserexecutorPtrId?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantMockuserexecutor"]>,
    "tenantMockuserexecutorByUserexecutorPtrId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionTenantMockuserexecutorByUserexecutorPtrIdArgs,
      "userexecutorPtrId"
    >
  >;
  tenantMonthlyConsumedResourceById?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantMonthlyConsumedResource"]>,
    "tenantMonthlyConsumedResourceById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTenantMonthlyConsumedResourceByIdArgs, "id">
  >;
  tenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantMonthlyConsumedResource"]>,
    "tenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContract",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionTenantMonthlyConsumedResourceByUserIdAndTenantIdAndMonthAndQuotaTypeAndTenantContractIdAndMonthInActiveContractArgs,
      | "month"
      | "monthInActiveContract"
      | "quotaType"
      | "tenantContractId"
      | "tenantId"
      | "userId"
    >
  >;
  tenantUserMembershipNotificationById?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantUserMembershipNotification"]>,
    "tenantUserMembershipNotificationById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTenantUserMembershipNotificationByIdArgs, "id">
  >;
  tenantUserexecutorById?: SubscriptionResolver<
    Maybe<ResolversTypes["TenantUserexecutor"]>,
    "tenantUserexecutorById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTenantUserexecutorByIdArgs, "id">
  >;
  tesContainerimageexecutorById?: SubscriptionResolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    "tesContainerimageexecutorById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTesContainerimageexecutorByIdArgs, "id">
  >;
  tesMockcontainerimageexecutorByContainerimageexecutorPtrId?: SubscriptionResolver<
    Maybe<ResolversTypes["TesMockcontainerimageexecutor"]>,
    "tesMockcontainerimageexecutorByContainerimageexecutorPtrId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionTesMockcontainerimageexecutorByContainerimageexecutorPtrIdArgs,
      "containerimageexecutorPtrId"
    >
  >;
  tesMocktaskexecutorByTaskexecutorPtrId?: SubscriptionResolver<
    Maybe<ResolversTypes["TesMocktaskexecutor"]>,
    "tesMocktaskexecutorByTaskexecutorPtrId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionTesMocktaskexecutorByTaskexecutorPtrIdArgs,
      "taskexecutorPtrId"
    >
  >;
  tesTaskexecutorById?: SubscriptionResolver<
    Maybe<ResolversTypes["TesTaskexecutor"]>,
    "tesTaskexecutorById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionTesTaskexecutorByIdArgs, "id">
  >;
  toolById?: SubscriptionResolver<
    Maybe<ResolversTypes["Tool"]>,
    "toolById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionToolByIdArgs, "id">
  >;
  toolByProjectId?: SubscriptionResolver<
    Maybe<ResolversTypes["Tool"]>,
    "toolByProjectId",
    ParentType,
    ContextType,
    RequireFields<SubscriptionToolByProjectIdArgs, "projectId">
  >;
  toolParameterById?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolParameter"]>,
    "toolParameterById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionToolParameterByIdArgs, "id">
  >;
  toolResourceById?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolResource"]>,
    "toolResourceById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionToolResourceByIdArgs, "id">
  >;
  toolResourceByTypeAndToolVersionId?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolResource"]>,
    "toolResourceByTypeAndToolVersionId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionToolResourceByTypeAndToolVersionIdArgs,
      "toolVersionId" | "type"
    >
  >;
  toolResultById?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolResult"]>,
    "toolResultById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionToolResultByIdArgs, "id">
  >;
  toolSecretById?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolSecret"]>,
    "toolSecretById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionToolSecretByIdArgs, "id">
  >;
  toolSourceById?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolSource"]>,
    "toolSourceById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionToolSourceByIdArgs, "id">
  >;
  toolTenantById?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolTenant"]>,
    "toolTenantById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionToolTenantByIdArgs, "id">
  >;
  toolTenantByToolIdAndTenantId?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolTenant"]>,
    "toolTenantByToolIdAndTenantId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionToolTenantByToolIdAndTenantIdArgs,
      "tenantId" | "toolId"
    >
  >;
  toolVersionById?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    "toolVersionById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionToolVersionByIdArgs, "id">
  >;
  toolboxById?: SubscriptionResolver<
    Maybe<ResolversTypes["Toolbox"]>,
    "toolboxById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionToolboxByIdArgs, "id">
  >;
  toolboxByKey?: SubscriptionResolver<
    Maybe<ResolversTypes["Toolbox"]>,
    "toolboxByKey",
    ParentType,
    ContextType,
    RequireFields<SubscriptionToolboxByKeyArgs, "key">
  >;
  toolboxTenantById?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolboxTenant"]>,
    "toolboxTenantById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionToolboxTenantByIdArgs, "id">
  >;
  toolboxTenantByToolboxIdAndTenantId?: SubscriptionResolver<
    Maybe<ResolversTypes["ToolboxTenant"]>,
    "toolboxTenantByToolboxIdAndTenantId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionToolboxTenantByToolboxIdAndTenantIdArgs,
      "tenantId" | "toolboxId"
    >
  >;
  userHasActiveSession?: SubscriptionResolver<
    Maybe<ResolversTypes["Boolean"]>,
    "userHasActiveSession",
    ParentType,
    ContextType,
    RequireFields<SubscriptionUserHasActiveSessionArgs, "userid">
  >;
  userIdIsSettingsGlobalUserId?: SubscriptionResolver<
    Maybe<ResolversTypes["Boolean"]>,
    "userIdIsSettingsGlobalUserId",
    ParentType,
    ContextType,
    Partial<SubscriptionUserIdIsSettingsGlobalUserIdArgs>
  >;
  userOnboardingQuestionAnswerById?: SubscriptionResolver<
    Maybe<ResolversTypes["UserOnboardingQuestionAnswer"]>,
    "userOnboardingQuestionAnswerById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionUserOnboardingQuestionAnswerByIdArgs, "id">
  >;
  userOnboardingQuestionByCode?: SubscriptionResolver<
    Maybe<ResolversTypes["UserOnboardingQuestion"]>,
    "userOnboardingQuestionByCode",
    ParentType,
    ContextType,
    RequireFields<SubscriptionUserOnboardingQuestionByCodeArgs, "code">
  >;
  userOnboardingQuestionById?: SubscriptionResolver<
    Maybe<ResolversTypes["UserOnboardingQuestion"]>,
    "userOnboardingQuestionById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionUserOnboardingQuestionByIdArgs, "id">
  >;
  userOnboardingQuestionResponseById?: SubscriptionResolver<
    Maybe<ResolversTypes["UserOnboardingQuestionResponse"]>,
    "userOnboardingQuestionResponseById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionUserOnboardingQuestionResponseByIdArgs, "id">
  >;
  userPersonalSpaceRequestById?: SubscriptionResolver<
    Maybe<ResolversTypes["UserPersonalSpaceRequest"]>,
    "userPersonalSpaceRequestById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionUserPersonalSpaceRequestByIdArgs, "id">
  >;
  waffleFlagById?: SubscriptionResolver<
    Maybe<ResolversTypes["WaffleFlag"]>,
    "waffleFlagById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionWaffleFlagByIdArgs, "id">
  >;
  waffleFlagByName?: SubscriptionResolver<
    Maybe<ResolversTypes["WaffleFlag"]>,
    "waffleFlagByName",
    ParentType,
    ContextType,
    RequireFields<SubscriptionWaffleFlagByNameArgs, "name">
  >;
  waffleSampleById?: SubscriptionResolver<
    Maybe<ResolversTypes["WaffleSample"]>,
    "waffleSampleById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionWaffleSampleByIdArgs, "id">
  >;
  waffleSampleByName?: SubscriptionResolver<
    Maybe<ResolversTypes["WaffleSample"]>,
    "waffleSampleByName",
    ParentType,
    ContextType,
    RequireFields<SubscriptionWaffleSampleByNameArgs, "name">
  >;
  waffleSwitchById?: SubscriptionResolver<
    Maybe<ResolversTypes["WaffleSwitch"]>,
    "waffleSwitchById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionWaffleSwitchByIdArgs, "id">
  >;
  waffleSwitchByName?: SubscriptionResolver<
    Maybe<ResolversTypes["WaffleSwitch"]>,
    "waffleSwitchByName",
    ParentType,
    ContextType,
    RequireFields<SubscriptionWaffleSwitchByNameArgs, "name">
  >;
  workflowById?: SubscriptionResolver<
    Maybe<ResolversTypes["Workflow"]>,
    "workflowById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionWorkflowByIdArgs, "id">
  >;
  workflowDatumById?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowDatum"]>,
    "workflowDatumById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionWorkflowDatumByIdArgs, "id">
  >;
  workflowResultById?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowResult"]>,
    "workflowResultById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionWorkflowResultByIdArgs, "id">
  >;
  workflowResultWorkflowVersionById?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowResultWorkflowVersion"]>,
    "workflowResultWorkflowVersionById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionWorkflowResultWorkflowVersionByIdArgs, "id">
  >;
  workflowResultWorkflowVersionByResultIdAndWorkflowversionId?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowResultWorkflowVersion"]>,
    "workflowResultWorkflowVersionByResultIdAndWorkflowversionId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionWorkflowResultWorkflowVersionByResultIdAndWorkflowversionIdArgs,
      "resultId" | "workflowversionId"
    >
  >;
  workflowSectionBlockById?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowSectionBlock"]>,
    "workflowSectionBlockById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionWorkflowSectionBlockByIdArgs, "id">
  >;
  workflowSectionBlockSectionByBlockIdAndSectionId?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowSectionBlockSection"]>,
    "workflowSectionBlockSectionByBlockIdAndSectionId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionWorkflowSectionBlockSectionByBlockIdAndSectionIdArgs,
      "blockId" | "sectionId"
    >
  >;
  workflowSectionBlockSectionById?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowSectionBlockSection"]>,
    "workflowSectionBlockSectionById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionWorkflowSectionBlockSectionByIdArgs, "id">
  >;
  workflowSectionById?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowSection"]>,
    "workflowSectionById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionWorkflowSectionByIdArgs, "id">
  >;
  workflowSectionWorkflowVersionById?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowSectionWorkflowVersion"]>,
    "workflowSectionWorkflowVersionById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionWorkflowSectionWorkflowVersionByIdArgs, "id">
  >;
  workflowSectionWorkflowVersionBySectionIdAndWorkflowversionId?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowSectionWorkflowVersion"]>,
    "workflowSectionWorkflowVersionBySectionIdAndWorkflowversionId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionWorkflowSectionWorkflowVersionBySectionIdAndWorkflowversionIdArgs,
      "sectionId" | "workflowversionId"
    >
  >;
  workflowSourceById?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowSource"]>,
    "workflowSourceById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionWorkflowSourceByIdArgs, "id">
  >;
  workflowSourceWorkflowVersionById?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowSourceWorkflowVersion"]>,
    "workflowSourceWorkflowVersionById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionWorkflowSourceWorkflowVersionByIdArgs, "id">
  >;
  workflowSourceWorkflowVersionBySourceIdAndWorkflowversionId?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowSourceWorkflowVersion"]>,
    "workflowSourceWorkflowVersionBySourceIdAndWorkflowversionId",
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionWorkflowSourceWorkflowVersionBySourceIdAndWorkflowversionIdArgs,
      "sourceId" | "workflowversionId"
    >
  >;
  workflowVersionById?: SubscriptionResolver<
    Maybe<ResolversTypes["WorkflowVersion"]>,
    "workflowVersionById",
    ParentType,
    ContextType,
    RequireFields<SubscriptionWorkflowVersionByIdArgs, "id">
  >;
};

export type TaskResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Task"] = ResolversParentTypes["Task"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  cloned?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  containerImageByContainerImageId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  containerImageId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  created?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  credits?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  errorDescription?: Resolver<
    Maybe<ResolversTypes["JSON"]>,
    ParentType,
    ContextType
  >;
  executorId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  fileOutputGroupByTaskId?: Resolver<
    Maybe<ResolversTypes["FileOutputGroup"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroupsByTaskId?: Resolver<
    ResolversTypes["FileOutputGroupsConnection"],
    ParentType,
    ContextType,
    RequireFields<TaskFileOutputGroupsByTaskIdArgs, "orderBy">
  >;
  filesByTaskId?: Resolver<
    ResolversTypes["FilesConnection"],
    ParentType,
    ContextType,
    RequireFields<TaskFilesByTaskIdArgs, "orderBy">
  >;
  gdtAnalysisTableRowByTaskId?: Resolver<
    Maybe<ResolversTypes["GdtAnalysisTableRow"]>,
    ParentType,
    ContextType
  >;
  gdtAnalysisTableRowsByTaskId?: Resolver<
    ResolversTypes["GdtAnalysisTableRowsConnection"],
    ParentType,
    ContextType,
    RequireFields<TaskGdtAnalysisTableRowsByTaskIdArgs, "orderBy">
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  inputsHash?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  metadataValuesByTaskId?: Resolver<
    ResolversTypes["MetadataValuesConnection"],
    ParentType,
    ContextType,
    RequireFields<TaskMetadataValuesByTaskIdArgs, "orderBy">
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  resourceTier?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  status?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  taskActivitiesByTaskId?: Resolver<
    ResolversTypes["TaskActivitiesConnection"],
    ParentType,
    ContextType,
    RequireFields<TaskTaskActivitiesByTaskIdArgs, "orderBy">
  >;
  taskActivityByTaskId?: Resolver<
    Maybe<ResolversTypes["TaskActivity"]>,
    ParentType,
    ContextType
  >;
  taskParameters?: Resolver<
    Maybe<ResolversTypes["JSON"]>,
    ParentType,
    ContextType
  >;
  taskResourceUsageByTaskId?: Resolver<
    Maybe<ResolversTypes["TaskResourceUsage"]>,
    ParentType,
    ContextType
  >;
  taskResourceUsagesByTaskId?: Resolver<
    ResolversTypes["TaskResourceUsagesConnection"],
    ParentType,
    ContextType,
    RequireFields<TaskTaskResourceUsagesByTaskIdArgs, "orderBy">
  >;
  taskResourcesByTaskId?: Resolver<
    ResolversTypes["TaskResourcesConnection"],
    ParentType,
    ContextType,
    RequireFields<TaskTaskResourcesByTaskIdArgs, "orderBy">
  >;
  taskSourcesByTaskId?: Resolver<
    ResolversTypes["TaskSourcesConnection"],
    ParentType,
    ContextType,
    RequireFields<TaskTaskSourcesByTaskIdArgs, "orderBy">
  >;
  taskStatusLogsByTaskId?: Resolver<
    ResolversTypes["TaskStatusLogsConnection"],
    ParentType,
    ContextType,
    RequireFields<TaskTaskStatusLogsByTaskIdArgs, "orderBy">
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tesTaskexecutorByExecutorId?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutor"]>,
    ParentType,
    ContextType
  >;
  toolExitcode?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  toolExitcodeDescription?: Resolver<
    Maybe<ResolversTypes["JSON"]>,
    ParentType,
    ContextType
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  toolVersionId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivitiesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TaskActivitiesConnection"] = ResolversParentTypes["TaskActivitiesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["TaskActivitiesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["TaskActivity"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivitiesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TaskActivitiesEdge"] = ResolversParentTypes["TaskActivitiesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["TaskActivity"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskActivityResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TaskActivity"] = ResolversParentTypes["TaskActivity"],
> = {
  cloned?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  costByCostId?: Resolver<
    Maybe<ResolversTypes["Cost"]>,
    ParentType,
    ContextType
  >;
  costId?: Resolver<Maybe<ResolversTypes["BigInt"]>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes["Datetime"]>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes["Interval"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  instanceType?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResourceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TaskResource"] = ResolversParentTypes["TaskResource"],
> = {
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  value?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResourceUsageResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TaskResourceUsage"] = ResolversParentTypes["TaskResourceUsage"],
> = {
  cpuMax?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  cpuMean?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  cpuMedian?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  cpuMin?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  cpuStd?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  memoryMax?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  memoryMean?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  memoryMedian?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  memoryMin?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  memoryStd?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  storageMax?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  storageMean?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  storageMedian?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  storageMin?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  storageStd?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResourceUsagesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TaskResourceUsagesConnection"] = ResolversParentTypes["TaskResourceUsagesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["TaskResourceUsagesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["TaskResourceUsage"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResourceUsagesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TaskResourceUsagesEdge"] = ResolversParentTypes["TaskResourceUsagesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["TaskResourceUsage"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResourcesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TaskResourcesConnection"] = ResolversParentTypes["TaskResourcesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["TaskResourcesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["TaskResource"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResourcesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TaskResourcesEdge"] = ResolversParentTypes["TaskResourcesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["TaskResource"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskSourceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TaskSource"] = ResolversParentTypes["TaskSource"],
> = {
  fileByFileId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  fileId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  toolSourceByToolSourceId?: Resolver<
    Maybe<ResolversTypes["ToolSource"]>,
    ParentType,
    ContextType
  >;
  toolSourceId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskSourcesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TaskSourcesConnection"] = ResolversParentTypes["TaskSourcesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["TaskSourcesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["TaskSource"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskSourcesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TaskSourcesEdge"] = ResolversParentTypes["TaskSourcesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["TaskSource"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskStatusLogResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TaskStatusLog"] = ResolversParentTypes["TaskStatusLog"],
> = {
  created?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  status?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskStatusLogsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TaskStatusLogsConnection"] = ResolversParentTypes["TaskStatusLogsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["TaskStatusLogsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["TaskStatusLog"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskStatusLogsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TaskStatusLogsEdge"] = ResolversParentTypes["TaskStatusLogsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["TaskStatusLog"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TasksConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TasksConnection"] = ResolversParentTypes["TasksConnection"],
> = {
  edges?: Resolver<Array<ResolversTypes["TasksEdge"]>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes["Task"]>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TasksEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TasksEdge"] = ResolversParentTypes["TasksEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["Task"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Tenant"] = ResolversParentTypes["Tenant"],
> = {
  activeStorageSize?: Resolver<
    Maybe<ResolversTypes["BigInt"]>,
    ParentType,
    ContextType
  >;
  applicationUserMembershipsByTenantId?: Resolver<
    ResolversTypes["ApplicationUserMembershipsConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantApplicationUserMembershipsByTenantIdArgs, "orderBy">
  >;
  applicationUserSessionsByTenantId?: Resolver<
    ResolversTypes["ApplicationUserSessionsConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantApplicationUserSessionsByTenantIdArgs, "orderBy">
  >;
  archivedStorageSize?: Resolver<
    Maybe<ResolversTypes["BigInt"]>,
    ParentType,
    ContextType
  >;
  codeFilesByTenantId?: Resolver<
    ResolversTypes["CodeFilesConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantCodeFilesByTenantIdArgs, "orderBy">
  >;
  commandsByTenantId?: Resolver<
    ResolversTypes["CommandsConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantCommandsByTenantIdArgs, "orderBy">
  >;
  containerImageRepositoriesByTenantId?: Resolver<
    ResolversTypes["ContainerImageRepositoriesConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantContainerImageRepositoriesByTenantIdArgs, "orderBy">
  >;
  containerImagesByTenantId?: Resolver<
    ResolversTypes["ContainerImagesConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantContainerImagesByTenantIdArgs, "orderBy">
  >;
  costsByTenantId?: Resolver<
    ResolversTypes["CostsConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantCostsByTenantIdArgs, "orderBy">
  >;
  created?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  featureFlagsTenantsByTenantId?: Resolver<
    ResolversTypes["FeatureFlagsTenantsConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantFeatureFlagsTenantsByTenantIdArgs, "orderBy">
  >;
  fileActivitiesByTenantId?: Resolver<
    ResolversTypes["FileActivitiesConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantFileActivitiesByTenantIdArgs, "orderBy">
  >;
  fileMetadataByTenantId?: Resolver<
    ResolversTypes["FileMetadataConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantFileMetadataByTenantIdArgs, "orderBy">
  >;
  fileOutputGroupMetadataByTenantId?: Resolver<
    ResolversTypes["FileOutputGroupMetadataConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantFileOutputGroupMetadataByTenantIdArgs, "orderBy">
  >;
  fileOutputGroupsByTenantId?: Resolver<
    ResolversTypes["FileOutputGroupsConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantFileOutputGroupsByTenantIdArgs, "orderBy">
  >;
  filesByTenantId?: Resolver<
    ResolversTypes["FilesConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantFilesByTenantIdArgs, "orderBy">
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  internal?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  metadataByTenantId?: Resolver<
    ResolversTypes["MetadataConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantMetadataByTenantIdArgs, "orderBy">
  >;
  metadataValuesByTenantId?: Resolver<
    ResolversTypes["MetadataValuesConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantMetadataValuesByTenantIdArgs, "orderBy">
  >;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  projectsByTenantId?: Resolver<
    ResolversTypes["ProjectsConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantProjectsByTenantIdArgs, "orderBy">
  >;
  repositoryName?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  roleChangeNotificationsByTenantId?: Resolver<
    ResolversTypes["RoleChangeNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantRoleChangeNotificationsByTenantIdArgs, "orderBy">
  >;
  runsByTenantId?: Resolver<
    ResolversTypes["RunsConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantRunsByTenantIdArgs, "orderBy">
  >;
  sfid?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tasksByTenantId?: Resolver<
    ResolversTypes["TasksConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantTasksByTenantIdArgs, "orderBy">
  >;
  tenantContractsByTenantId?: Resolver<
    ResolversTypes["TenantContractsConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantTenantContractsByTenantIdArgs, "orderBy">
  >;
  tenantMonthlyConsumedResourcesByTenantId?: Resolver<
    ResolversTypes["TenantMonthlyConsumedResourcesConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantTenantMonthlyConsumedResourcesByTenantIdArgs, "orderBy">
  >;
  tenantType?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tenantUserMembershipNotificationsByTenantId?: Resolver<
    ResolversTypes["TenantUserMembershipNotificationsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      TenantTenantUserMembershipNotificationsByTenantIdArgs,
      "orderBy"
    >
  >;
  toolTenantsByTenantId?: Resolver<
    ResolversTypes["ToolTenantsConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantToolTenantsByTenantIdArgs, "orderBy">
  >;
  toolVersionsByTenantId?: Resolver<
    ResolversTypes["ToolVersionsConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantToolVersionsByTenantIdArgs, "orderBy">
  >;
  toolboxTenantsByTenantId?: Resolver<
    ResolversTypes["ToolboxTenantsConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantToolboxTenantsByTenantIdArgs, "orderBy">
  >;
  toolsByTenantId?: Resolver<
    ResolversTypes["ToolsConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantToolsByTenantIdArgs, "orderBy">
  >;
  workflowsByTenantId?: Resolver<
    ResolversTypes["WorkflowsConnection"],
    ParentType,
    ContextType,
    RequireFields<TenantWorkflowsByTenantIdArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantContract"] = ResolversParentTypes["TenantContract"],
> = {
  contractType?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  created?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  endDate?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  sfid?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantContractTransactionsByTenantContractId?: Resolver<
    ResolversTypes["TenantContractTransactionsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      TenantContractTenantContractTransactionsByTenantContractIdArgs,
      "orderBy"
    >
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tenantMonthlyConsumedResourcesByTenantContractId?: Resolver<
    ResolversTypes["TenantMonthlyConsumedResourcesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      TenantContractTenantMonthlyConsumedResourcesByTenantContractIdArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractAllowanceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantContractAllowance"] = ResolversParentTypes["TenantContractAllowance"],
> = {
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  quotaType?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tenantContractTransactionByTenantContractTransactionId?: Resolver<
    Maybe<ResolversTypes["TenantContractTransaction"]>,
    ParentType,
    ContextType
  >;
  tenantContractTransactionId?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  value?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractAllowancesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantContractAllowancesConnection"] = ResolversParentTypes["TenantContractAllowancesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["TenantContractAllowancesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["TenantContractAllowance"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractAllowancesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantContractAllowancesEdge"] = ResolversParentTypes["TenantContractAllowancesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["TenantContractAllowance"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractTransactionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantContractTransaction"] = ResolversParentTypes["TenantContractTransaction"],
> = {
  created?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  currency?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  price?: Resolver<ResolversTypes["BigFloat"], ParentType, ContextType>;
  tenantContractAllowancesByTenantContractTransactionId?: Resolver<
    ResolversTypes["TenantContractAllowancesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      TenantContractTransactionTenantContractAllowancesByTenantContractTransactionIdArgs,
      "orderBy"
    >
  >;
  tenantContractByTenantContractId?: Resolver<
    Maybe<ResolversTypes["TenantContract"]>,
    ParentType,
    ContextType
  >;
  tenantContractId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractTransactionsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantContractTransactionsConnection"] = ResolversParentTypes["TenantContractTransactionsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["TenantContractTransactionsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["TenantContractTransaction"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractTransactionsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantContractTransactionsEdge"] = ResolversParentTypes["TenantContractTransactionsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["TenantContractTransaction"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantContractsConnection"] = ResolversParentTypes["TenantContractsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["TenantContractsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["TenantContract"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantContractsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantContractsEdge"] = ResolversParentTypes["TenantContractsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["TenantContract"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantMockuserexecutorResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantMockuserexecutor"] = ResolversParentTypes["TenantMockuserexecutor"],
> = {
  tenantUserexecutorByUserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TenantUserexecutor"]>,
    ParentType,
    ContextType
  >;
  userexecutorPtrId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantMockuserexecutorsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantMockuserexecutorsConnection"] = ResolversParentTypes["TenantMockuserexecutorsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["TenantMockuserexecutorsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["TenantMockuserexecutor"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantMockuserexecutorsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantMockuserexecutorsEdge"] = ResolversParentTypes["TenantMockuserexecutorsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["TenantMockuserexecutor"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantMonthlyConsumedResourceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantMonthlyConsumedResource"] = ResolversParentTypes["TenantMonthlyConsumedResource"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  month?: Resolver<ResolversTypes["Date"], ParentType, ContextType>;
  monthInActiveContract?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  percentage?: Resolver<ResolversTypes["Float"], ParentType, ContextType>;
  quotaType?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantContractByTenantContractId?: Resolver<
    Maybe<ResolversTypes["TenantContract"]>,
    ParentType,
    ContextType
  >;
  tenantContractId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantMonthlyConsumedResourcesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantMonthlyConsumedResourcesConnection"] = ResolversParentTypes["TenantMonthlyConsumedResourcesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["TenantMonthlyConsumedResourcesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["TenantMonthlyConsumedResource"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantMonthlyConsumedResourcesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantMonthlyConsumedResourcesEdge"] = ResolversParentTypes["TenantMonthlyConsumedResourcesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["TenantMonthlyConsumedResource"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantUserMembershipNotificationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantUserMembershipNotification"] = ResolversParentTypes["TenantUserMembershipNotification"],
> = {
  applicationUserByInviterId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  inviterId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  notificationById?: Resolver<
    Maybe<ResolversTypes["Notification"]>,
    ParentType,
    ContextType
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantUserMembershipNotificationsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantUserMembershipNotificationsConnection"] = ResolversParentTypes["TenantUserMembershipNotificationsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["TenantUserMembershipNotificationsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["TenantUserMembershipNotification"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantUserMembershipNotificationsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantUserMembershipNotificationsEdge"] = ResolversParentTypes["TenantUserMembershipNotificationsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["TenantUserMembershipNotification"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantUserexecutorResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantUserexecutor"] = ResolversParentTypes["TenantUserexecutor"],
> = {
  awsCognitoUserByUserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsCognitoUser"]>,
    ParentType,
    ContextType
  >;
  awsCognitoUsersByUserexecutorPtrId?: Resolver<
    ResolversTypes["AwsCognitoUsersConnection"],
    ParentType,
    ContextType,
    RequireFields<
      TenantUserexecutorAwsCognitoUsersByUserexecutorPtrIdArgs,
      "orderBy"
    >
  >;
  djangoContentTypeByPolymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  polymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  tenantMockuserexecutorByUserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TenantMockuserexecutor"]>,
    ParentType,
    ContextType
  >;
  tenantMockuserexecutorsByUserexecutorPtrId?: Resolver<
    ResolversTypes["TenantMockuserexecutorsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      TenantUserexecutorTenantMockuserexecutorsByUserexecutorPtrIdArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantUserexecutorsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantUserexecutorsConnection"] = ResolversParentTypes["TenantUserexecutorsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["TenantUserexecutorsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["TenantUserexecutor"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantUserexecutorsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantUserexecutorsEdge"] = ResolversParentTypes["TenantUserexecutorsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["TenantUserexecutor"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TenantsEdge"] = ResolversParentTypes["TenantsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["Tenant"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TesContainerimageexecutorResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TesContainerimageexecutor"] = ResolversParentTypes["TesContainerimageexecutor"],
> = {
  awsEcrImageByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsEcrImage"]>,
    ParentType,
    ContextType
  >;
  awsEcrImagesByContainerimageexecutorPtrId?: Resolver<
    ResolversTypes["AwsEcrImagesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      TesContainerimageexecutorAwsEcrImagesByContainerimageexecutorPtrIdArgs,
      "orderBy"
    >
  >;
  containerImageByExecutorId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  containerImagesByExecutorId?: Resolver<
    ResolversTypes["ContainerImagesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      TesContainerimageexecutorContainerImagesByExecutorIdArgs,
      "orderBy"
    >
  >;
  distributionRegistryImageByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DistributionRegistryImage"]>,
    ParentType,
    ContextType
  >;
  distributionRegistryImagesByContainerimageexecutorPtrId?: Resolver<
    ResolversTypes["DistributionRegistryImagesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      TesContainerimageexecutorDistributionRegistryImagesByContainerimageexecutorPtrIdArgs,
      "orderBy"
    >
  >;
  djangoContentTypeByPolymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  polymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  tesMockcontainerimageexecutorByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesMockcontainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  tesMockcontainerimageexecutorsByContainerimageexecutorPtrId?: Resolver<
    ResolversTypes["TesMockcontainerimageexecutorsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      TesContainerimageexecutorTesMockcontainerimageexecutorsByContainerimageexecutorPtrIdArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TesContainerimageexecutorsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TesContainerimageexecutorsConnection"] = ResolversParentTypes["TesContainerimageexecutorsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["TesContainerimageexecutorsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TesContainerimageexecutorsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TesContainerimageexecutorsEdge"] = ResolversParentTypes["TesContainerimageexecutorsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["TesContainerimageexecutor"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TesMockcontainerimageexecutorResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TesMockcontainerimageexecutor"] = ResolversParentTypes["TesMockcontainerimageexecutor"],
> = {
  containerimageexecutorPtrId?: Resolver<
    ResolversTypes["Int"],
    ParentType,
    ContextType
  >;
  tesContainerimageexecutorByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TesMockcontainerimageexecutorsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TesMockcontainerimageexecutorsConnection"] = ResolversParentTypes["TesMockcontainerimageexecutorsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["TesMockcontainerimageexecutorsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["TesMockcontainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TesMockcontainerimageexecutorsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TesMockcontainerimageexecutorsEdge"] = ResolversParentTypes["TesMockcontainerimageexecutorsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["TesMockcontainerimageexecutor"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TesMocktaskexecutorResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TesMocktaskexecutor"] = ResolversParentTypes["TesMocktaskexecutor"],
> = {
  taskexecutorPtrId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  tesTaskexecutorByTaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TesMocktaskexecutorsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TesMocktaskexecutorsConnection"] = ResolversParentTypes["TesMocktaskexecutorsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["TesMocktaskexecutorsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["TesMocktaskexecutor"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TesMocktaskexecutorsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TesMocktaskexecutorsEdge"] = ResolversParentTypes["TesMocktaskexecutorsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["TesMocktaskexecutor"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TesTaskexecutorResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TesTaskexecutor"] = ResolversParentTypes["TesTaskexecutor"],
> = {
  awsBatchTaskByTaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsBatchTask"]>,
    ParentType,
    ContextType
  >;
  awsBatchTasksByTaskexecutorPtrId?: Resolver<
    ResolversTypes["AwsBatchTasksConnection"],
    ParentType,
    ContextType,
    RequireFields<
      TesTaskexecutorAwsBatchTasksByTaskexecutorPtrIdArgs,
      "orderBy"
    >
  >;
  djangoContentTypeByPolymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  polymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  taskByExecutorId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  tasksByExecutorId?: Resolver<
    ResolversTypes["TasksConnection"],
    ParentType,
    ContextType,
    RequireFields<TesTaskexecutorTasksByExecutorIdArgs, "orderBy">
  >;
  tesMocktaskexecutorByTaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesMocktaskexecutor"]>,
    ParentType,
    ContextType
  >;
  tesMocktaskexecutorsByTaskexecutorPtrId?: Resolver<
    ResolversTypes["TesMocktaskexecutorsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      TesTaskexecutorTesMocktaskexecutorsByTaskexecutorPtrIdArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TesTaskexecutorsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TesTaskexecutorsConnection"] = ResolversParentTypes["TesTaskexecutorsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["TesTaskexecutorsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["TesTaskexecutor"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TesTaskexecutorsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["TesTaskexecutorsEdge"] = ResolversParentTypes["TesTaskexecutorsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["TesTaskexecutor"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Tool"] = ResolversParentTypes["Tool"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  codeLink?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  created?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  docsLink?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  helpText?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  maturity?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  pinnedToolsByToolId?: Resolver<
    ResolversTypes["PinnedToolsConnection"],
    ParentType,
    ContextType,
    RequireFields<ToolPinnedToolsByToolIdArgs, "orderBy">
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  searchTerms?: Resolver<
    Maybe<ResolversTypes["JSON"]>,
    ParentType,
    ContextType
  >;
  status?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tags?: Resolver<
    Array<Maybe<ResolversTypes["String"]>>,
    ParentType,
    ContextType
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  toolTenantsByToolId?: Resolver<
    ResolversTypes["ToolTenantsConnection"],
    ParentType,
    ContextType,
    RequireFields<ToolToolTenantsByToolIdArgs, "orderBy">
  >;
  toolVersionsByToolId?: Resolver<
    ResolversTypes["ToolVersionsConnection"],
    ParentType,
    ContextType,
    RequireFields<ToolToolVersionsByToolIdArgs, "orderBy">
  >;
  toolboxByToolboxId?: Resolver<
    Maybe<ResolversTypes["Toolbox"]>,
    ParentType,
    ContextType
  >;
  toolboxId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  visibility?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolParameterResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolParameter"] = ResolversParentTypes["ToolParameter"],
> = {
  default?: Resolver<Maybe<ResolversTypes["JSON"]>, ParentType, ContextType>;
  helpText?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  options?: Resolver<Maybe<ResolversTypes["JSON"]>, ParentType, ContextType>;
  required?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  toolVersionId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolParametersConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolParametersConnection"] = ResolversParentTypes["ToolParametersConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ToolParametersEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ToolParameter"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolParametersEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolParametersEdge"] = ResolversParentTypes["ToolParametersEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["ToolParameter"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolResourceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolResource"] = ResolversParentTypes["ToolResource"],
> = {
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  toolVersionId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  type?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  value?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolResourcesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolResourcesConnection"] = ResolversParentTypes["ToolResourcesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ToolResourcesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ToolResource"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolResourcesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolResourcesEdge"] = ResolversParentTypes["ToolResourcesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["ToolResource"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolResult"] = ResolversParentTypes["ToolResult"],
> = {
  fileFormats?: Resolver<
    Maybe<ResolversTypes["JSON"]>,
    ParentType,
    ContextType
  >;
  helpText?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  required?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  toolVersionId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolResultsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolResultsConnection"] = ResolversParentTypes["ToolResultsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ToolResultsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ToolResult"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolResultsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolResultsEdge"] = ResolversParentTypes["ToolResultsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["ToolResult"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolSecretResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolSecret"] = ResolversParentTypes["ToolSecret"],
> = {
  helpText?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  required?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  toolVersionId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolSecretsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolSecretsConnection"] = ResolversParentTypes["ToolSecretsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ToolSecretsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ToolSecret"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolSecretsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolSecretsEdge"] = ResolversParentTypes["ToolSecretsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["ToolSecret"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolSourceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolSource"] = ResolversParentTypes["ToolSource"],
> = {
  fileFormats?: Resolver<
    Maybe<ResolversTypes["JSON"]>,
    ParentType,
    ContextType
  >;
  helpText?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  multiple?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  required?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  taskSourcesByToolSourceId?: Resolver<
    ResolversTypes["TaskSourcesConnection"],
    ParentType,
    ContextType,
    RequireFields<ToolSourceTaskSourcesByToolSourceIdArgs, "orderBy">
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  toolVersionId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolSourcesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolSourcesConnection"] = ResolversParentTypes["ToolSourcesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ToolSourcesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ToolSource"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolSourcesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolSourcesEdge"] = ResolversParentTypes["ToolSourcesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["ToolSource"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolTenantResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolTenant"] = ResolversParentTypes["ToolTenant"],
> = {
  id?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  toolByToolId?: Resolver<
    Maybe<ResolversTypes["Tool"]>,
    ParentType,
    ContextType
  >;
  toolId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolTenantsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolTenantsConnection"] = ResolversParentTypes["ToolTenantsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ToolTenantsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ToolTenant"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolTenantsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolTenantsEdge"] = ResolversParentTypes["ToolTenantsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["ToolTenant"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolVersionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolVersion"] = ResolversParentTypes["ToolVersion"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  changelog?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  command?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  commandByToolVersionId?: Resolver<
    Maybe<ResolversTypes["Command"]>,
    ParentType,
    ContextType
  >;
  commandsByToolVersionId?: Resolver<
    ResolversTypes["CommandsConnection"],
    ParentType,
    ContextType,
    RequireFields<ToolVersionCommandsByToolVersionIdArgs, "orderBy">
  >;
  compatibleVersions?: Resolver<
    ResolversTypes["ToolVersionsConnection"],
    ParentType,
    ContextType,
    Partial<ToolVersionCompatibleVersionsArgs>
  >;
  containerImageByContainerImageId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  containerImageId?: Resolver<
    Maybe<ResolversTypes["Int"]>,
    ParentType,
    ContextType
  >;
  created?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  credits?: Resolver<Maybe<ResolversTypes["Float"]>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  draftToolSpec?: Resolver<
    Maybe<ResolversTypes["JSON"]>,
    ParentType,
    ContextType
  >;
  gdtAnalysisTableRowsByToolVersionId?: Resolver<
    ResolversTypes["GdtAnalysisTableRowsConnection"],
    ParentType,
    ContextType,
    RequireFields<ToolVersionGdtAnalysisTableRowsByToolVersionIdArgs, "orderBy">
  >;
  gdtAnalysisTablesByToolVersionId?: Resolver<
    ResolversTypes["GdtAnalysisTablesConnection"],
    ParentType,
    ContextType,
    RequireFields<ToolVersionGdtAnalysisTablesByToolVersionIdArgs, "orderBy">
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  isToolSpecForwardsCompatible?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  isUpgradableToNextVersion?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  maturity?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  status?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  tasksByToolVersionId?: Resolver<
    ResolversTypes["TasksConnection"],
    ParentType,
    ContextType,
    RequireFields<ToolVersionTasksByToolVersionIdArgs, "orderBy">
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  toolByToolId?: Resolver<
    Maybe<ResolversTypes["Tool"]>,
    ParentType,
    ContextType
  >;
  toolId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  toolParametersByToolVersionId?: Resolver<
    ResolversTypes["ToolParametersConnection"],
    ParentType,
    ContextType,
    RequireFields<ToolVersionToolParametersByToolVersionIdArgs, "orderBy">
  >;
  toolResourcesByToolVersionId?: Resolver<
    ResolversTypes["ToolResourcesConnection"],
    ParentType,
    ContextType,
    RequireFields<ToolVersionToolResourcesByToolVersionIdArgs, "orderBy">
  >;
  toolResultsByToolVersionId?: Resolver<
    ResolversTypes["ToolResultsConnection"],
    ParentType,
    ContextType,
    RequireFields<ToolVersionToolResultsByToolVersionIdArgs, "orderBy">
  >;
  toolSecretsByToolVersionId?: Resolver<
    ResolversTypes["ToolSecretsConnection"],
    ParentType,
    ContextType,
    RequireFields<ToolVersionToolSecretsByToolVersionIdArgs, "orderBy">
  >;
  toolSourcesByToolVersionId?: Resolver<
    ResolversTypes["ToolSourcesConnection"],
    ParentType,
    ContextType,
    RequireFields<ToolVersionToolSourcesByToolVersionIdArgs, "orderBy">
  >;
  toolSpec?: Resolver<Maybe<ResolversTypes["JSON"]>, ParentType, ContextType>;
  toolSpecVersion?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  visibility?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  workflowSectionBlocksByToolId?: Resolver<
    ResolversTypes["WorkflowSectionBlocksConnection"],
    ParentType,
    ContextType,
    RequireFields<ToolVersionWorkflowSectionBlocksByToolIdArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolVersionsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolVersionsConnection"] = ResolversParentTypes["ToolVersionsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ToolVersionsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolVersionsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolVersionsEdge"] = ResolversParentTypes["ToolVersionsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["ToolVersion"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolboxResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Toolbox"] = ResolversParentTypes["Toolbox"],
> = {
  created?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  key?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  toolboxTenantsByToolboxId?: Resolver<
    ResolversTypes["ToolboxTenantsConnection"],
    ParentType,
    ContextType,
    RequireFields<ToolboxToolboxTenantsByToolboxIdArgs, "orderBy">
  >;
  toolsByToolboxId?: Resolver<
    ResolversTypes["ToolsConnection"],
    ParentType,
    ContextType,
    RequireFields<ToolboxToolsByToolboxIdArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolboxTenantResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolboxTenant"] = ResolversParentTypes["ToolboxTenant"],
> = {
  id?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  toolboxByToolboxId?: Resolver<
    Maybe<ResolversTypes["Toolbox"]>,
    ParentType,
    ContextType
  >;
  toolboxId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolboxTenantsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolboxTenantsConnection"] = ResolversParentTypes["ToolboxTenantsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ToolboxTenantsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["ToolboxTenant"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolboxTenantsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolboxTenantsEdge"] = ResolversParentTypes["ToolboxTenantsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["ToolboxTenant"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolboxesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolboxesConnection"] = ResolversParentTypes["ToolboxesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["ToolboxesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<Array<ResolversTypes["Toolbox"]>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolboxesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolboxesEdge"] = ResolversParentTypes["ToolboxesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["Toolbox"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolsConnection"] = ResolversParentTypes["ToolsConnection"],
> = {
  edges?: Resolver<Array<ResolversTypes["ToolsEdge"]>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes["Tool"]>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["ToolsEdge"] = ResolversParentTypes["ToolsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["Tool"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UuidScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes["UUID"], any> {
  name: "UUID";
}

export type UpdateApplicationUserGroupPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateApplicationUserGroupPayload"] = ResolversParentTypes["UpdateApplicationUserGroupPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserGroup?: Resolver<
    Maybe<ResolversTypes["ApplicationUserGroup"]>,
    ParentType,
    ContextType
  >;
  applicationUserGroupEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUserGroupsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateApplicationUserGroupPayloadApplicationUserGroupEdgeArgs,
      "orderBy"
    >
  >;
  authGroupByGroupId?: Resolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateApplicationUserMembershipPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateApplicationUserMembershipPayload"] = ResolversParentTypes["UpdateApplicationUserMembershipPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserMembership?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMembership"]>,
    ParentType,
    ContextType
  >;
  applicationUserMembershipEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMembershipsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateApplicationUserMembershipPayloadApplicationUserMembershipEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateApplicationUserMetadatumPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateApplicationUserMetadatumPayload"] = ResolversParentTypes["UpdateApplicationUserMetadatumPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserMetadatum?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMetadatum"]>,
    ParentType,
    ContextType
  >;
  applicationUserMetadatumEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUserMetadataEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateApplicationUserMetadatumPayloadApplicationUserMetadatumEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateApplicationUserPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateApplicationUserPayload"] = ResolversParentTypes["UpdateApplicationUserPayload"],
> = {
  applicationUser?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUsersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateApplicationUserPayloadApplicationUserEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateApplicationUserSessionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateApplicationUserSessionPayload"] = ResolversParentTypes["UpdateApplicationUserSessionPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserSession?: Resolver<
    Maybe<ResolversTypes["ApplicationUserSession"]>,
    ParentType,
    ContextType
  >;
  applicationUserSessionEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUserSessionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateApplicationUserSessionPayloadApplicationUserSessionEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateApplicationUserUserPermissionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateApplicationUserUserPermissionPayload"] = ResolversParentTypes["UpdateApplicationUserUserPermissionPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  applicationUserUserPermission?: Resolver<
    Maybe<ResolversTypes["ApplicationUserUserPermission"]>,
    ParentType,
    ContextType
  >;
  applicationUserUserPermissionEdge?: Resolver<
    Maybe<ResolversTypes["ApplicationUserUserPermissionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateApplicationUserUserPermissionPayloadApplicationUserUserPermissionEdgeArgs,
      "orderBy"
    >
  >;
  authPermissionByPermissionId?: Resolver<
    Maybe<ResolversTypes["AuthPermission"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAuditlogLogentryPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateAuditlogLogentryPayload"] = ResolversParentTypes["UpdateAuditlogLogentryPayload"],
> = {
  applicationUserByActorId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  auditlogLogentry?: Resolver<
    Maybe<ResolversTypes["AuditlogLogentry"]>,
    ParentType,
    ContextType
  >;
  auditlogLogentryEdge?: Resolver<
    Maybe<ResolversTypes["AuditlogLogentriesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateAuditlogLogentryPayloadAuditlogLogentryEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByContentTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAuthGroupPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateAuthGroupPayload"] = ResolversParentTypes["UpdateAuthGroupPayload"],
> = {
  authGroup?: Resolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    ParentType,
    ContextType
  >;
  authGroupEdge?: Resolver<
    Maybe<ResolversTypes["AuthGroupsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateAuthGroupPayloadAuthGroupEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAuthGroupPermissionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateAuthGroupPermissionPayload"] = ResolversParentTypes["UpdateAuthGroupPermissionPayload"],
> = {
  authGroupByGroupId?: Resolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    ParentType,
    ContextType
  >;
  authGroupPermission?: Resolver<
    Maybe<ResolversTypes["AuthGroupPermission"]>,
    ParentType,
    ContextType
  >;
  authGroupPermissionEdge?: Resolver<
    Maybe<ResolversTypes["AuthGroupPermissionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateAuthGroupPermissionPayloadAuthGroupPermissionEdgeArgs,
      "orderBy"
    >
  >;
  authPermissionByPermissionId?: Resolver<
    Maybe<ResolversTypes["AuthPermission"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAuthPermissionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateAuthPermissionPayload"] = ResolversParentTypes["UpdateAuthPermissionPayload"],
> = {
  authPermission?: Resolver<
    Maybe<ResolversTypes["AuthPermission"]>,
    ParentType,
    ContextType
  >;
  authPermissionEdge?: Resolver<
    Maybe<ResolversTypes["AuthPermissionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateAuthPermissionPayloadAuthPermissionEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByContentTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAvatarPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateAvatarPayload"] = ResolversParentTypes["UpdateAvatarPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  avatar?: Resolver<Maybe<ResolversTypes["Avatar"]>, ParentType, ContextType>;
  avatarEdge?: Resolver<
    Maybe<ResolversTypes["AvatarsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateAvatarPayloadAvatarEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAwsBatchTaskPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateAwsBatchTaskPayload"] = ResolversParentTypes["UpdateAwsBatchTaskPayload"],
> = {
  awsBatchTask?: Resolver<
    Maybe<ResolversTypes["AwsBatchTask"]>,
    ParentType,
    ContextType
  >;
  awsBatchTaskEdge?: Resolver<
    Maybe<ResolversTypes["AwsBatchTasksEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateAwsBatchTaskPayloadAwsBatchTaskEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesTaskexecutorByTaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAwsCognitoUserPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateAwsCognitoUserPayload"] = ResolversParentTypes["UpdateAwsCognitoUserPayload"],
> = {
  awsCognitoUser?: Resolver<
    Maybe<ResolversTypes["AwsCognitoUser"]>,
    ParentType,
    ContextType
  >;
  awsCognitoUserEdge?: Resolver<
    Maybe<ResolversTypes["AwsCognitoUsersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateAwsCognitoUserPayloadAwsCognitoUserEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantUserexecutorByUserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TenantUserexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAwsEcrImagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateAwsEcrImagePayload"] = ResolversParentTypes["UpdateAwsEcrImagePayload"],
> = {
  awsEcrImage?: Resolver<
    Maybe<ResolversTypes["AwsEcrImage"]>,
    ParentType,
    ContextType
  >;
  awsEcrImageEdge?: Resolver<
    Maybe<ResolversTypes["AwsEcrImagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateAwsEcrImagePayloadAwsEcrImageEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesContainerimageexecutorByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAwsMockBatchTaskPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateAwsMockBatchTaskPayload"] = ResolversParentTypes["UpdateAwsMockBatchTaskPayload"],
> = {
  awsBatchTaskByAwstaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsBatchTask"]>,
    ParentType,
    ContextType
  >;
  awsMockBatchTask?: Resolver<
    Maybe<ResolversTypes["AwsMockBatchTask"]>,
    ParentType,
    ContextType
  >;
  awsMockBatchTaskEdge?: Resolver<
    Maybe<ResolversTypes["AwsMockBatchTasksEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateAwsMockBatchTaskPayloadAwsMockBatchTaskEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAwsMockDistributionImagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateAwsMockDistributionImagePayload"] = ResolversParentTypes["UpdateAwsMockDistributionImagePayload"],
> = {
  awsMockDistributionImage?: Resolver<
    Maybe<ResolversTypes["AwsMockDistributionImage"]>,
    ParentType,
    ContextType
  >;
  awsMockDistributionImageEdge?: Resolver<
    Maybe<ResolversTypes["AwsMockDistributionImagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateAwsMockDistributionImagePayloadAwsMockDistributionImageEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  distributionRegistryImageByDistributioncontainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DistributionRegistryImage"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAwsMockEcrImagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateAwsMockEcrImagePayload"] = ResolversParentTypes["UpdateAwsMockEcrImagePayload"],
> = {
  awsEcrImageByAwscontainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsEcrImage"]>,
    ParentType,
    ContextType
  >;
  awsMockEcrImage?: Resolver<
    Maybe<ResolversTypes["AwsMockEcrImage"]>,
    ParentType,
    ContextType
  >;
  awsMockEcrImageEdge?: Resolver<
    Maybe<ResolversTypes["AwsMockEcrImagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateAwsMockEcrImagePayloadAwsMockEcrImageEdgeArgs,
      "orderBy"
    >
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAwsMockIamUserPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateAwsMockIamUserPayload"] = ResolversParentTypes["UpdateAwsMockIamUserPayload"],
> = {
  awsCognitoUserByAwsuserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsCognitoUser"]>,
    ParentType,
    ContextType
  >;
  awsMockIamUser?: Resolver<
    Maybe<ResolversTypes["AwsMockIamUser"]>,
    ParentType,
    ContextType
  >;
  awsMockIamUserEdge?: Resolver<
    Maybe<ResolversTypes["AwsMockIamUsersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateAwsMockIamUserPayloadAwsMockIamUserEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAwsMockS3FilePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateAwsMockS3FilePayload"] = ResolversParentTypes["UpdateAwsMockS3FilePayload"],
> = {
  awsMockS3File?: Resolver<
    Maybe<ResolversTypes["AwsMockS3File"]>,
    ParentType,
    ContextType
  >;
  awsMockS3FileEdge?: Resolver<
    Maybe<ResolversTypes["AwsMockS3FilesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateAwsMockS3FilePayloadAwsMockS3FileEdgeArgs, "orderBy">
  >;
  awsS3FileByAwsfileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["AwsS3File"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateAwsS3FilePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateAwsS3FilePayload"] = ResolversParentTypes["UpdateAwsS3FilePayload"],
> = {
  awsS3File?: Resolver<
    Maybe<ResolversTypes["AwsS3File"]>,
    ParentType,
    ContextType
  >;
  awsS3FileEdge?: Resolver<
    Maybe<ResolversTypes["AwsS3FilesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateAwsS3FilePayloadAwsS3FileEdgeArgs, "orderBy">
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  drsFileexecutorByFileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutor"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateCodeFilePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateCodeFilePayload"] = ResolversParentTypes["UpdateCodeFilePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  codeFile?: Resolver<
    Maybe<ResolversTypes["CodeFile"]>,
    ParentType,
    ContextType
  >;
  codeFileBySeriesParentId?: Resolver<
    Maybe<ResolversTypes["CodeFile"]>,
    ParentType,
    ContextType
  >;
  codeFileEdge?: Resolver<
    Maybe<ResolversTypes["CodeFilesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateCodeFilePayloadCodeFileEdgeArgs, "orderBy">
  >;
  drsFileexecutorByExecutorId?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutor"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateCommandPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateCommandPayload"] = ResolversParentTypes["UpdateCommandPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  codeFileByCodeFileId?: Resolver<
    Maybe<ResolversTypes["CodeFile"]>,
    ParentType,
    ContextType
  >;
  command?: Resolver<Maybe<ResolversTypes["Command"]>, ParentType, ContextType>;
  commandEdge?: Resolver<
    Maybe<ResolversTypes["CommandsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateCommandPayloadCommandEdgeArgs, "orderBy">
  >;
  containerImageByContainerImageId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateContainerImagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateContainerImagePayload"] = ResolversParentTypes["UpdateContainerImagePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  containerImage?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  containerImageEdge?: Resolver<
    Maybe<ResolversTypes["ContainerImagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateContainerImagePayloadContainerImageEdgeArgs, "orderBy">
  >;
  containerImageRepositoryByContainerImageRepositoryId?: Resolver<
    Maybe<ResolversTypes["ContainerImageRepository"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tesContainerimageexecutorByExecutorId?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateContainerImageRepositoryPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateContainerImageRepositoryPayload"] = ResolversParentTypes["UpdateContainerImageRepositoryPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  containerImageRepository?: Resolver<
    Maybe<ResolversTypes["ContainerImageRepository"]>,
    ParentType,
    ContextType
  >;
  containerImageRepositoryEdge?: Resolver<
    Maybe<ResolversTypes["ContainerImageRepositoriesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateContainerImageRepositoryPayloadContainerImageRepositoryEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateCostPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateCostPayload"] = ResolversParentTypes["UpdateCostPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  cost?: Resolver<Maybe<ResolversTypes["Cost"]>, ParentType, ContextType>;
  costEdge?: Resolver<
    Maybe<ResolversTypes["CostsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateCostPayloadCostEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateDistributionRegistryImagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateDistributionRegistryImagePayload"] = ResolversParentTypes["UpdateDistributionRegistryImagePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  distributionRegistryImage?: Resolver<
    Maybe<ResolversTypes["DistributionRegistryImage"]>,
    ParentType,
    ContextType
  >;
  distributionRegistryImageEdge?: Resolver<
    Maybe<ResolversTypes["DistributionRegistryImagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateDistributionRegistryImagePayloadDistributionRegistryImageEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesContainerimageexecutorByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateDjangoAdminLogPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateDjangoAdminLogPayload"] = ResolversParentTypes["UpdateDjangoAdminLogPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoAdminLog?: Resolver<
    Maybe<ResolversTypes["DjangoAdminLog"]>,
    ParentType,
    ContextType
  >;
  djangoAdminLogEdge?: Resolver<
    Maybe<ResolversTypes["DjangoAdminLogsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateDjangoAdminLogPayloadDjangoAdminLogEdgeArgs, "orderBy">
  >;
  djangoContentTypeByContentTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateDjangoContentTypePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateDjangoContentTypePayload"] = ResolversParentTypes["UpdateDjangoContentTypePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoContentType?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeEdge?: Resolver<
    Maybe<ResolversTypes["DjangoContentTypesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateDjangoContentTypePayloadDjangoContentTypeEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateDjangoMigrationPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateDjangoMigrationPayload"] = ResolversParentTypes["UpdateDjangoMigrationPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoMigration?: Resolver<
    Maybe<ResolversTypes["DjangoMigration"]>,
    ParentType,
    ContextType
  >;
  djangoMigrationEdge?: Resolver<
    Maybe<ResolversTypes["DjangoMigrationsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateDjangoMigrationPayloadDjangoMigrationEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateDjangoSesBlacklistedemailPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateDjangoSesBlacklistedemailPayload"] = ResolversParentTypes["UpdateDjangoSesBlacklistedemailPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoSesBlacklistedemail?: Resolver<
    Maybe<ResolversTypes["DjangoSesBlacklistedemail"]>,
    ParentType,
    ContextType
  >;
  djangoSesBlacklistedemailEdge?: Resolver<
    Maybe<ResolversTypes["DjangoSesBlacklistedemailsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateDjangoSesBlacklistedemailPayloadDjangoSesBlacklistedemailEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateDjangoSesSesstatPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateDjangoSesSesstatPayload"] = ResolversParentTypes["UpdateDjangoSesSesstatPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoSesSesstat?: Resolver<
    Maybe<ResolversTypes["DjangoSesSesstat"]>,
    ParentType,
    ContextType
  >;
  djangoSesSesstatEdge?: Resolver<
    Maybe<ResolversTypes["DjangoSesSesstatsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateDjangoSesSesstatPayloadDjangoSesSesstatEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateDjangoSessionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateDjangoSessionPayload"] = ResolversParentTypes["UpdateDjangoSessionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoSession?: Resolver<
    Maybe<ResolversTypes["DjangoSession"]>,
    ParentType,
    ContextType
  >;
  djangoSessionEdge?: Resolver<
    Maybe<ResolversTypes["DjangoSessionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateDjangoSessionPayloadDjangoSessionEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateDrsFileexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateDrsFileexecutorPayload"] = ResolversParentTypes["UpdateDrsFileexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByPolymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  drsFileexecutor?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutor"]>,
    ParentType,
    ContextType
  >;
  drsFileexecutorEdge?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateDrsFileexecutorPayloadDrsFileexecutorEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateDrsMockfileexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateDrsMockfileexecutorPayload"] = ResolversParentTypes["UpdateDrsMockfileexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  drsFileexecutorByFileexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["DrsFileexecutor"]>,
    ParentType,
    ContextType
  >;
  drsMockfileexecutor?: Resolver<
    Maybe<ResolversTypes["DrsMockfileexecutor"]>,
    ParentType,
    ContextType
  >;
  drsMockfileexecutorEdge?: Resolver<
    Maybe<ResolversTypes["DrsMockfileexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateDrsMockfileexecutorPayloadDrsMockfileexecutorEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateEulaVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateEulaVersionPayload"] = ResolversParentTypes["UpdateEulaVersionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  eulaVersion?: Resolver<
    Maybe<ResolversTypes["EulaVersion"]>,
    ParentType,
    ContextType
  >;
  eulaVersionEdge?: Resolver<
    Maybe<ResolversTypes["EulaVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateEulaVersionPayloadEulaVersionEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateEulaVersionUserAcceptancePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateEulaVersionUserAcceptancePayload"] = ResolversParentTypes["UpdateEulaVersionUserAcceptancePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  eulaVersionByEulaVersionId?: Resolver<
    Maybe<ResolversTypes["EulaVersion"]>,
    ParentType,
    ContextType
  >;
  eulaVersionUserAcceptance?: Resolver<
    Maybe<ResolversTypes["EulaVersionUserAcceptance"]>,
    ParentType,
    ContextType
  >;
  eulaVersionUserAcceptanceEdge?: Resolver<
    Maybe<ResolversTypes["EulaVersionUserAcceptancesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateEulaVersionUserAcceptancePayloadEulaVersionUserAcceptanceEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateFeatureFlagPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateFeatureFlagPayload"] = ResolversParentTypes["UpdateFeatureFlagPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  featureFlag?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType
  >;
  featureFlagEdge?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateFeatureFlagPayloadFeatureFlagEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateFeatureFlagsGroupPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateFeatureFlagsGroupPayload"] = ResolversParentTypes["UpdateFeatureFlagsGroupPayload"],
> = {
  authGroupByGroupId?: Resolver<
    Maybe<ResolversTypes["AuthGroup"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  featureFlagByFeatureflagId?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType
  >;
  featureFlagsGroup?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsGroup"]>,
    ParentType,
    ContextType
  >;
  featureFlagsGroupEdge?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsGroupsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateFeatureFlagsGroupPayloadFeatureFlagsGroupEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateFeatureFlagsTenantPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateFeatureFlagsTenantPayload"] = ResolversParentTypes["UpdateFeatureFlagsTenantPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  featureFlagByFeatureflagId?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType
  >;
  featureFlagsTenant?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsTenant"]>,
    ParentType,
    ContextType
  >;
  featureFlagsTenantEdge?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsTenantsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateFeatureFlagsTenantPayloadFeatureFlagsTenantEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateFeatureFlagsUserPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateFeatureFlagsUserPayload"] = ResolversParentTypes["UpdateFeatureFlagsUserPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  featureFlagByFeatureflagId?: Resolver<
    Maybe<ResolversTypes["FeatureFlag"]>,
    ParentType,
    ContextType
  >;
  featureFlagsUser?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsUser"]>,
    ParentType,
    ContextType
  >;
  featureFlagsUserEdge?: Resolver<
    Maybe<ResolversTypes["FeatureFlagsUsersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateFeatureFlagsUserPayloadFeatureFlagsUserEdgeArgs,
      "orderBy"
    >
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateFileActivityPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateFileActivityPayload"] = ResolversParentTypes["UpdateFileActivityPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  costByCostId?: Resolver<
    Maybe<ResolversTypes["Cost"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByContentTypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  fileActivity?: Resolver<
    Maybe<ResolversTypes["FileActivity"]>,
    ParentType,
    ContextType
  >;
  fileActivityEdge?: Resolver<
    Maybe<ResolversTypes["FileActivitiesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateFileActivityPayloadFileActivityEdgeArgs, "orderBy">
  >;
  fileByFileId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateFileMetadatumPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateFileMetadatumPayload"] = ResolversParentTypes["UpdateFileMetadatumPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  fileByFileId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  fileMetadatum?: Resolver<
    Maybe<ResolversTypes["FileMetadatum"]>,
    ParentType,
    ContextType
  >;
  fileMetadatumEdge?: Resolver<
    Maybe<ResolversTypes["FileMetadataEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateFileMetadatumPayloadFileMetadatumEdgeArgs, "orderBy">
  >;
  metadatumByMetadataId?: Resolver<
    Maybe<ResolversTypes["Metadatum"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateFileOutputGroupMetadatumPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateFileOutputGroupMetadatumPayload"] = ResolversParentTypes["UpdateFileOutputGroupMetadatumPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroupByFileOutputGroupId?: Resolver<
    Maybe<ResolversTypes["FileOutputGroup"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroupMetadatum?: Resolver<
    Maybe<ResolversTypes["FileOutputGroupMetadatum"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroupMetadatumEdge?: Resolver<
    Maybe<ResolversTypes["FileOutputGroupMetadataEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateFileOutputGroupMetadatumPayloadFileOutputGroupMetadatumEdgeArgs,
      "orderBy"
    >
  >;
  metadatumByMetadataId?: Resolver<
    Maybe<ResolversTypes["Metadatum"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateFileOutputGroupPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateFileOutputGroupPayload"] = ResolversParentTypes["UpdateFileOutputGroupPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroup?: Resolver<
    Maybe<ResolversTypes["FileOutputGroup"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroupEdge?: Resolver<
    Maybe<ResolversTypes["FileOutputGroupsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateFileOutputGroupPayloadFileOutputGroupEdgeArgs,
      "orderBy"
    >
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateFilePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateFilePayload"] = ResolversParentTypes["UpdateFilePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  file?: Resolver<Maybe<ResolversTypes["File"]>, ParentType, ContextType>;
  fileBySeriesParentId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  fileEdge?: Resolver<
    Maybe<ResolversTypes["FilesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateFilePayloadFileEdgeArgs, "orderBy">
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMetadataValuePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateMetadataValuePayload"] = ResolversParentTypes["UpdateMetadataValuePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  metadataValue?: Resolver<
    Maybe<ResolversTypes["MetadataValue"]>,
    ParentType,
    ContextType
  >;
  metadataValueEdge?: Resolver<
    Maybe<ResolversTypes["MetadataValuesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateMetadataValuePayloadMetadataValueEdgeArgs, "orderBy">
  >;
  metadatumByMetadataId?: Resolver<
    Maybe<ResolversTypes["Metadatum"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateMetadatumPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateMetadatumPayload"] = ResolversParentTypes["UpdateMetadatumPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  metadatum?: Resolver<
    Maybe<ResolversTypes["Metadatum"]>,
    ParentType,
    ContextType
  >;
  metadatumEdge?: Resolver<
    Maybe<ResolversTypes["MetadataEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateMetadatumPayloadMetadatumEdgeArgs, "orderBy">
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateNotificationPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateNotificationPayload"] = ResolversParentTypes["UpdateNotificationPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  notification?: Resolver<
    Maybe<ResolversTypes["Notification"]>,
    ParentType,
    ContextType
  >;
  notificationEdge?: Resolver<
    Maybe<ResolversTypes["NotificationsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateNotificationPayloadNotificationEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateOutputGroupFilePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateOutputGroupFilePayload"] = ResolversParentTypes["UpdateOutputGroupFilePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  fileByFileId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  fileOutputGroupByFileOutputGroupId?: Resolver<
    Maybe<ResolversTypes["FileOutputGroup"]>,
    ParentType,
    ContextType
  >;
  outputGroupFile?: Resolver<
    Maybe<ResolversTypes["OutputGroupFile"]>,
    ParentType,
    ContextType
  >;
  outputGroupFileEdge?: Resolver<
    Maybe<ResolversTypes["OutputGroupFilesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateOutputGroupFilePayloadOutputGroupFileEdgeArgs,
      "orderBy"
    >
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdatePinnedToolPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdatePinnedToolPayload"] = ResolversParentTypes["UpdatePinnedToolPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  pinnedTool?: Resolver<
    Maybe<ResolversTypes["PinnedTool"]>,
    ParentType,
    ContextType
  >;
  pinnedToolEdge?: Resolver<
    Maybe<ResolversTypes["PinnedToolsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdatePinnedToolPayloadPinnedToolEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolByToolId?: Resolver<
    Maybe<ResolversTypes["Tool"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateProjectFolderPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateProjectFolderPayload"] = ResolversParentTypes["UpdateProjectFolderPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectFolder?: Resolver<
    Maybe<ResolversTypes["ProjectFolder"]>,
    ParentType,
    ContextType
  >;
  projectFolderEdge?: Resolver<
    Maybe<ResolversTypes["ProjectFoldersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateProjectFolderPayloadProjectFolderEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateProjectTagPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateProjectTagPayload"] = ResolversParentTypes["UpdateProjectTagPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  projectTag?: Resolver<
    Maybe<ResolversTypes["ProjectTag"]>,
    ParentType,
    ContextType
  >;
  projectTagEdge?: Resolver<
    Maybe<ResolversTypes["ProjectTagsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateProjectTagPayloadProjectTagEdgeArgs, "orderBy">
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateRunPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateRunPayload"] = ResolversParentTypes["UpdateRunPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  run?: Resolver<Maybe<ResolversTypes["Run"]>, ParentType, ContextType>;
  runEdge?: Resolver<
    Maybe<ResolversTypes["RunsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateRunPayloadRunEdgeArgs, "orderBy">
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTaskActivityPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateTaskActivityPayload"] = ResolversParentTypes["UpdateTaskActivityPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  costByCostId?: Resolver<
    Maybe<ResolversTypes["Cost"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskActivity?: Resolver<
    Maybe<ResolversTypes["TaskActivity"]>,
    ParentType,
    ContextType
  >;
  taskActivityEdge?: Resolver<
    Maybe<ResolversTypes["TaskActivitiesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateTaskActivityPayloadTaskActivityEdgeArgs, "orderBy">
  >;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTaskPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateTaskPayload"] = ResolversParentTypes["UpdateTaskPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  containerImageByContainerImageId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  task?: Resolver<Maybe<ResolversTypes["Task"]>, ParentType, ContextType>;
  taskEdge?: Resolver<
    Maybe<ResolversTypes["TasksEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateTaskPayloadTaskEdgeArgs, "orderBy">
  >;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tesTaskexecutorByExecutorId?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutor"]>,
    ParentType,
    ContextType
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTaskResourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateTaskResourcePayload"] = ResolversParentTypes["UpdateTaskResourcePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskResource?: Resolver<
    Maybe<ResolversTypes["TaskResource"]>,
    ParentType,
    ContextType
  >;
  taskResourceEdge?: Resolver<
    Maybe<ResolversTypes["TaskResourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateTaskResourcePayloadTaskResourceEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTaskResourceUsagePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateTaskResourceUsagePayload"] = ResolversParentTypes["UpdateTaskResourceUsagePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskResourceUsage?: Resolver<
    Maybe<ResolversTypes["TaskResourceUsage"]>,
    ParentType,
    ContextType
  >;
  taskResourceUsageEdge?: Resolver<
    Maybe<ResolversTypes["TaskResourceUsagesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateTaskResourceUsagePayloadTaskResourceUsageEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTaskSourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateTaskSourcePayload"] = ResolversParentTypes["UpdateTaskSourcePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  fileByFileId?: Resolver<
    Maybe<ResolversTypes["File"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskSource?: Resolver<
    Maybe<ResolversTypes["TaskSource"]>,
    ParentType,
    ContextType
  >;
  taskSourceEdge?: Resolver<
    Maybe<ResolversTypes["TaskSourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateTaskSourcePayloadTaskSourceEdgeArgs, "orderBy">
  >;
  toolSourceByToolSourceId?: Resolver<
    Maybe<ResolversTypes["ToolSource"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTaskStatusLogPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateTaskStatusLogPayload"] = ResolversParentTypes["UpdateTaskStatusLogPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  taskByTaskId?: Resolver<
    Maybe<ResolversTypes["Task"]>,
    ParentType,
    ContextType
  >;
  taskStatusLog?: Resolver<
    Maybe<ResolversTypes["TaskStatusLog"]>,
    ParentType,
    ContextType
  >;
  taskStatusLogEdge?: Resolver<
    Maybe<ResolversTypes["TaskStatusLogsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateTaskStatusLogPayloadTaskStatusLogEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTenantContractAllowancePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateTenantContractAllowancePayload"] = ResolversParentTypes["UpdateTenantContractAllowancePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantContractAllowance?: Resolver<
    Maybe<ResolversTypes["TenantContractAllowance"]>,
    ParentType,
    ContextType
  >;
  tenantContractAllowanceEdge?: Resolver<
    Maybe<ResolversTypes["TenantContractAllowancesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateTenantContractAllowancePayloadTenantContractAllowanceEdgeArgs,
      "orderBy"
    >
  >;
  tenantContractTransactionByTenantContractTransactionId?: Resolver<
    Maybe<ResolversTypes["TenantContractTransaction"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTenantContractPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateTenantContractPayload"] = ResolversParentTypes["UpdateTenantContractPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantContract?: Resolver<
    Maybe<ResolversTypes["TenantContract"]>,
    ParentType,
    ContextType
  >;
  tenantContractEdge?: Resolver<
    Maybe<ResolversTypes["TenantContractsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateTenantContractPayloadTenantContractEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTenantContractTransactionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateTenantContractTransactionPayload"] = ResolversParentTypes["UpdateTenantContractTransactionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantContractByTenantContractId?: Resolver<
    Maybe<ResolversTypes["TenantContract"]>,
    ParentType,
    ContextType
  >;
  tenantContractTransaction?: Resolver<
    Maybe<ResolversTypes["TenantContractTransaction"]>,
    ParentType,
    ContextType
  >;
  tenantContractTransactionEdge?: Resolver<
    Maybe<ResolversTypes["TenantContractTransactionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateTenantContractTransactionPayloadTenantContractTransactionEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTenantMockuserexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateTenantMockuserexecutorPayload"] = ResolversParentTypes["UpdateTenantMockuserexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantMockuserexecutor?: Resolver<
    Maybe<ResolversTypes["TenantMockuserexecutor"]>,
    ParentType,
    ContextType
  >;
  tenantMockuserexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TenantMockuserexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateTenantMockuserexecutorPayloadTenantMockuserexecutorEdgeArgs,
      "orderBy"
    >
  >;
  tenantUserexecutorByUserexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TenantUserexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTenantMonthlyConsumedResourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateTenantMonthlyConsumedResourcePayload"] = ResolversParentTypes["UpdateTenantMonthlyConsumedResourcePayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantContractByTenantContractId?: Resolver<
    Maybe<ResolversTypes["TenantContract"]>,
    ParentType,
    ContextType
  >;
  tenantMonthlyConsumedResource?: Resolver<
    Maybe<ResolversTypes["TenantMonthlyConsumedResource"]>,
    ParentType,
    ContextType
  >;
  tenantMonthlyConsumedResourceEdge?: Resolver<
    Maybe<ResolversTypes["TenantMonthlyConsumedResourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateTenantMonthlyConsumedResourcePayloadTenantMonthlyConsumedResourceEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTenantPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateTenantPayload"] = ResolversParentTypes["UpdateTenantPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenant?: Resolver<Maybe<ResolversTypes["Tenant"]>, ParentType, ContextType>;
  tenantEdge?: Resolver<
    Maybe<ResolversTypes["TenantsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateTenantPayloadTenantEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTenantUserexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateTenantUserexecutorPayload"] = ResolversParentTypes["UpdateTenantUserexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByPolymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantUserexecutor?: Resolver<
    Maybe<ResolversTypes["TenantUserexecutor"]>,
    ParentType,
    ContextType
  >;
  tenantUserexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TenantUserexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateTenantUserexecutorPayloadTenantUserexecutorEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTesContainerimageexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateTesContainerimageexecutorPayload"] = ResolversParentTypes["UpdateTesContainerimageexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByPolymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesContainerimageexecutor?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  tesContainerimageexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateTesContainerimageexecutorPayloadTesContainerimageexecutorEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTesMockcontainerimageexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateTesMockcontainerimageexecutorPayload"] = ResolversParentTypes["UpdateTesMockcontainerimageexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesContainerimageexecutorByContainerimageexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesContainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  tesMockcontainerimageexecutor?: Resolver<
    Maybe<ResolversTypes["TesMockcontainerimageexecutor"]>,
    ParentType,
    ContextType
  >;
  tesMockcontainerimageexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TesMockcontainerimageexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateTesMockcontainerimageexecutorPayloadTesMockcontainerimageexecutorEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTesMocktaskexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateTesMocktaskexecutorPayload"] = ResolversParentTypes["UpdateTesMocktaskexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesMocktaskexecutor?: Resolver<
    Maybe<ResolversTypes["TesMocktaskexecutor"]>,
    ParentType,
    ContextType
  >;
  tesMocktaskexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TesMocktaskexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateTesMocktaskexecutorPayloadTesMocktaskexecutorEdgeArgs,
      "orderBy"
    >
  >;
  tesTaskexecutorByTaskexecutorPtrId?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutor"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateTesTaskexecutorPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateTesTaskexecutorPayload"] = ResolversParentTypes["UpdateTesTaskexecutorPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  djangoContentTypeByPolymorphicCtypeId?: Resolver<
    Maybe<ResolversTypes["DjangoContentType"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tesTaskexecutor?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutor"]>,
    ParentType,
    ContextType
  >;
  tesTaskexecutorEdge?: Resolver<
    Maybe<ResolversTypes["TesTaskexecutorsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateTesTaskexecutorPayloadTesTaskexecutorEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolParameterPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateToolParameterPayload"] = ResolversParentTypes["UpdateToolParameterPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolParameter?: Resolver<
    Maybe<ResolversTypes["ToolParameter"]>,
    ParentType,
    ContextType
  >;
  toolParameterEdge?: Resolver<
    Maybe<ResolversTypes["ToolParametersEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateToolParameterPayloadToolParameterEdgeArgs, "orderBy">
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateToolPayload"] = ResolversParentTypes["UpdateToolPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  projectByProjectId?: Resolver<
    Maybe<ResolversTypes["Project"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tool?: Resolver<Maybe<ResolversTypes["Tool"]>, ParentType, ContextType>;
  toolEdge?: Resolver<
    Maybe<ResolversTypes["ToolsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateToolPayloadToolEdgeArgs, "orderBy">
  >;
  toolboxByToolboxId?: Resolver<
    Maybe<ResolversTypes["Toolbox"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolResourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateToolResourcePayload"] = ResolversParentTypes["UpdateToolResourcePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolResource?: Resolver<
    Maybe<ResolversTypes["ToolResource"]>,
    ParentType,
    ContextType
  >;
  toolResourceEdge?: Resolver<
    Maybe<ResolversTypes["ToolResourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateToolResourcePayloadToolResourceEdgeArgs, "orderBy">
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolResultPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateToolResultPayload"] = ResolversParentTypes["UpdateToolResultPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolResult?: Resolver<
    Maybe<ResolversTypes["ToolResult"]>,
    ParentType,
    ContextType
  >;
  toolResultEdge?: Resolver<
    Maybe<ResolversTypes["ToolResultsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateToolResultPayloadToolResultEdgeArgs, "orderBy">
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolSecretPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateToolSecretPayload"] = ResolversParentTypes["UpdateToolSecretPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolSecret?: Resolver<
    Maybe<ResolversTypes["ToolSecret"]>,
    ParentType,
    ContextType
  >;
  toolSecretEdge?: Resolver<
    Maybe<ResolversTypes["ToolSecretsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateToolSecretPayloadToolSecretEdgeArgs, "orderBy">
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolSourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateToolSourcePayload"] = ResolversParentTypes["UpdateToolSourcePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolSource?: Resolver<
    Maybe<ResolversTypes["ToolSource"]>,
    ParentType,
    ContextType
  >;
  toolSourceEdge?: Resolver<
    Maybe<ResolversTypes["ToolSourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateToolSourcePayloadToolSourceEdgeArgs, "orderBy">
  >;
  toolVersionByToolVersionId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolTenantPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateToolTenantPayload"] = ResolversParentTypes["UpdateToolTenantPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  toolByToolId?: Resolver<
    Maybe<ResolversTypes["Tool"]>,
    ParentType,
    ContextType
  >;
  toolTenant?: Resolver<
    Maybe<ResolversTypes["ToolTenant"]>,
    ParentType,
    ContextType
  >;
  toolTenantEdge?: Resolver<
    Maybe<ResolversTypes["ToolTenantsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateToolTenantPayloadToolTenantEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateToolVersionPayload"] = ResolversParentTypes["UpdateToolVersionPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  containerImageByContainerImageId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  toolByToolId?: Resolver<
    Maybe<ResolversTypes["Tool"]>,
    ParentType,
    ContextType
  >;
  toolVersion?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  toolVersionEdge?: Resolver<
    Maybe<ResolversTypes["ToolVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateToolVersionPayloadToolVersionEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolboxPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateToolboxPayload"] = ResolversParentTypes["UpdateToolboxPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolbox?: Resolver<Maybe<ResolversTypes["Toolbox"]>, ParentType, ContextType>;
  toolboxEdge?: Resolver<
    Maybe<ResolversTypes["ToolboxesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateToolboxPayloadToolboxEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolboxTenantPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateToolboxTenantPayload"] = ResolversParentTypes["UpdateToolboxTenantPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  toolboxByToolboxId?: Resolver<
    Maybe<ResolversTypes["Toolbox"]>,
    ParentType,
    ContextType
  >;
  toolboxTenant?: Resolver<
    Maybe<ResolversTypes["ToolboxTenant"]>,
    ParentType,
    ContextType
  >;
  toolboxTenantEdge?: Resolver<
    Maybe<ResolversTypes["ToolboxTenantsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateToolboxTenantPayloadToolboxTenantEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserPersonalSpaceRequestPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateUserPersonalSpaceRequestPayload"] = ResolversParentTypes["UpdateUserPersonalSpaceRequestPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  userPersonalSpaceRequest?: Resolver<
    Maybe<ResolversTypes["UserPersonalSpaceRequest"]>,
    ParentType,
    ContextType
  >;
  userPersonalSpaceRequestEdge?: Resolver<
    Maybe<ResolversTypes["UserPersonalSpaceRequestsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateUserPersonalSpaceRequestPayloadUserPersonalSpaceRequestEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateWaffleFlagPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateWaffleFlagPayload"] = ResolversParentTypes["UpdateWaffleFlagPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  waffleFlag?: Resolver<
    Maybe<ResolversTypes["WaffleFlag"]>,
    ParentType,
    ContextType
  >;
  waffleFlagEdge?: Resolver<
    Maybe<ResolversTypes["WaffleFlagsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateWaffleFlagPayloadWaffleFlagEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateWaffleSamplePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateWaffleSamplePayload"] = ResolversParentTypes["UpdateWaffleSamplePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  waffleSample?: Resolver<
    Maybe<ResolversTypes["WaffleSample"]>,
    ParentType,
    ContextType
  >;
  waffleSampleEdge?: Resolver<
    Maybe<ResolversTypes["WaffleSamplesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateWaffleSamplePayloadWaffleSampleEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateWaffleSwitchPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateWaffleSwitchPayload"] = ResolversParentTypes["UpdateWaffleSwitchPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  waffleSwitch?: Resolver<
    Maybe<ResolversTypes["WaffleSwitch"]>,
    ParentType,
    ContextType
  >;
  waffleSwitchEdge?: Resolver<
    Maybe<ResolversTypes["WaffleSwitchesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateWaffleSwitchPayloadWaffleSwitchEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateWorkflowDatumPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateWorkflowDatumPayload"] = ResolversParentTypes["UpdateWorkflowDatumPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowDatum?: Resolver<
    Maybe<ResolversTypes["WorkflowDatum"]>,
    ParentType,
    ContextType
  >;
  workflowDatumEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowDataEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateWorkflowDatumPayloadWorkflowDatumEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateWorkflowPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateWorkflowPayload"] = ResolversParentTypes["UpdateWorkflowPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  containerImageByContainerId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  workflow?: Resolver<
    Maybe<ResolversTypes["Workflow"]>,
    ParentType,
    ContextType
  >;
  workflowEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateWorkflowPayloadWorkflowEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateWorkflowResultPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateWorkflowResultPayload"] = ResolversParentTypes["UpdateWorkflowResultPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowDatumByObjectId?: Resolver<
    Maybe<ResolversTypes["WorkflowDatum"]>,
    ParentType,
    ContextType
  >;
  workflowResult?: Resolver<
    Maybe<ResolversTypes["WorkflowResult"]>,
    ParentType,
    ContextType
  >;
  workflowResultEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowResultsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateWorkflowResultPayloadWorkflowResultEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateWorkflowResultWorkflowVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateWorkflowResultWorkflowVersionPayload"] = ResolversParentTypes["UpdateWorkflowResultWorkflowVersionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowResultByResultId?: Resolver<
    Maybe<ResolversTypes["WorkflowResult"]>,
    ParentType,
    ContextType
  >;
  workflowResultWorkflowVersion?: Resolver<
    Maybe<ResolversTypes["WorkflowResultWorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  workflowResultWorkflowVersionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowResultWorkflowVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateWorkflowResultWorkflowVersionPayloadWorkflowResultWorkflowVersionEdgeArgs,
      "orderBy"
    >
  >;
  workflowVersionByWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["WorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateWorkflowSectionBlockPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateWorkflowSectionBlockPayload"] = ResolversParentTypes["UpdateWorkflowSectionBlockPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  toolVersionByToolId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  workflowDatumByObjectId?: Resolver<
    Maybe<ResolversTypes["WorkflowDatum"]>,
    ParentType,
    ContextType
  >;
  workflowSectionBlock?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlock"]>,
    ParentType,
    ContextType
  >;
  workflowSectionBlockEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlocksEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateWorkflowSectionBlockPayloadWorkflowSectionBlockEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateWorkflowSectionBlockSectionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateWorkflowSectionBlockSectionPayload"] = ResolversParentTypes["UpdateWorkflowSectionBlockSectionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowSectionBlockByBlockId?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlock"]>,
    ParentType,
    ContextType
  >;
  workflowSectionBlockSection?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlockSection"]>,
    ParentType,
    ContextType
  >;
  workflowSectionBlockSectionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlockSectionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateWorkflowSectionBlockSectionPayloadWorkflowSectionBlockSectionEdgeArgs,
      "orderBy"
    >
  >;
  workflowSectionBySectionId?: Resolver<
    Maybe<ResolversTypes["WorkflowSection"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateWorkflowSectionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateWorkflowSectionPayload"] = ResolversParentTypes["UpdateWorkflowSectionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowSection?: Resolver<
    Maybe<ResolversTypes["WorkflowSection"]>,
    ParentType,
    ContextType
  >;
  workflowSectionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateWorkflowSectionPayloadWorkflowSectionEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateWorkflowSectionWorkflowVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateWorkflowSectionWorkflowVersionPayload"] = ResolversParentTypes["UpdateWorkflowSectionWorkflowVersionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowSectionBySectionId?: Resolver<
    Maybe<ResolversTypes["WorkflowSection"]>,
    ParentType,
    ContextType
  >;
  workflowSectionWorkflowVersion?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionWorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  workflowSectionWorkflowVersionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionWorkflowVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateWorkflowSectionWorkflowVersionPayloadWorkflowSectionWorkflowVersionEdgeArgs,
      "orderBy"
    >
  >;
  workflowVersionByWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["WorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateWorkflowSourcePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateWorkflowSourcePayload"] = ResolversParentTypes["UpdateWorkflowSourcePayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowSource?: Resolver<
    Maybe<ResolversTypes["WorkflowSource"]>,
    ParentType,
    ContextType
  >;
  workflowSourceEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSourcesEdge"]>,
    ParentType,
    ContextType,
    RequireFields<UpdateWorkflowSourcePayloadWorkflowSourceEdgeArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateWorkflowSourceWorkflowVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateWorkflowSourceWorkflowVersionPayload"] = ResolversParentTypes["UpdateWorkflowSourceWorkflowVersionPayload"],
> = {
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowSourceBySourceId?: Resolver<
    Maybe<ResolversTypes["WorkflowSource"]>,
    ParentType,
    ContextType
  >;
  workflowSourceWorkflowVersion?: Resolver<
    Maybe<ResolversTypes["WorkflowSourceWorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  workflowSourceWorkflowVersionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowSourceWorkflowVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateWorkflowSourceWorkflowVersionPayloadWorkflowSourceWorkflowVersionEdgeArgs,
      "orderBy"
    >
  >;
  workflowVersionByWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["WorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateWorkflowVersionPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UpdateWorkflowVersionPayload"] = ResolversParentTypes["UpdateWorkflowVersionPayload"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  clientMutationId?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  query?: Resolver<Maybe<ResolversTypes["Query"]>, ParentType, ContextType>;
  workflowByWorkflowId?: Resolver<
    Maybe<ResolversTypes["Workflow"]>,
    ParentType,
    ContextType
  >;
  workflowVersion?: Resolver<
    Maybe<ResolversTypes["WorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  workflowVersionEdge?: Resolver<
    Maybe<ResolversTypes["WorkflowVersionsEdge"]>,
    ParentType,
    ContextType,
    RequireFields<
      UpdateWorkflowVersionPayloadWorkflowVersionEdgeArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAccessToProjectResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UserAccessToProject"] = ResolversParentTypes["UserAccessToProject"],
> = {
  edit?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  grantAccess?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  projectId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  view?: Resolver<Maybe<ResolversTypes["Boolean"]>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAccessToProjectsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UserAccessToProjectsConnection"] = ResolversParentTypes["UserAccessToProjectsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["UserAccessToProjectsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["UserAccessToProject"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAccessToProjectsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UserAccessToProjectsEdge"] = ResolversParentTypes["UserAccessToProjectsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["UserAccessToProject"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOnboardingQuestionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UserOnboardingQuestion"] = ResolversParentTypes["UserOnboardingQuestion"],
> = {
  category?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  code?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  concatenateResponse?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  deprecated?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  multiAnswer?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  optional?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  order?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  question?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  salesforceLeadAttributes?: Resolver<
    ResolversTypes["String"],
    ParentType,
    ContextType
  >;
  salesforceMultiAttribute?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  userOnboardingQuestionAnswersByQuestionId?: Resolver<
    ResolversTypes["UserOnboardingQuestionAnswersConnection"],
    ParentType,
    ContextType,
    RequireFields<
      UserOnboardingQuestionUserOnboardingQuestionAnswersByQuestionIdArgs,
      "orderBy"
    >
  >;
  userOnboardingQuestionResponsesByQuestionId?: Resolver<
    ResolversTypes["UserOnboardingQuestionResponsesConnection"],
    ParentType,
    ContextType,
    RequireFields<
      UserOnboardingQuestionUserOnboardingQuestionResponsesByQuestionIdArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOnboardingQuestionAnswerResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UserOnboardingQuestionAnswer"] = ResolversParentTypes["UserOnboardingQuestionAnswer"],
> = {
  answerType?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  maxLen?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  option?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  questionId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  salesforceOption?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  userOnboardingQuestionByQuestionId?: Resolver<
    Maybe<ResolversTypes["UserOnboardingQuestion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOnboardingQuestionAnswersConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UserOnboardingQuestionAnswersConnection"] = ResolversParentTypes["UserOnboardingQuestionAnswersConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["UserOnboardingQuestionAnswersEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["UserOnboardingQuestionAnswer"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOnboardingQuestionAnswersEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UserOnboardingQuestionAnswersEdge"] = ResolversParentTypes["UserOnboardingQuestionAnswersEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["UserOnboardingQuestionAnswer"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOnboardingQuestionResponseResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UserOnboardingQuestionResponse"] = ResolversParentTypes["UserOnboardingQuestionResponse"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  questionId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  salesforceSynced?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  text?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  userOnboardingQuestionByQuestionId?: Resolver<
    Maybe<ResolversTypes["UserOnboardingQuestion"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOnboardingQuestionResponsesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UserOnboardingQuestionResponsesConnection"] = ResolversParentTypes["UserOnboardingQuestionResponsesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["UserOnboardingQuestionResponsesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["UserOnboardingQuestionResponse"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOnboardingQuestionResponsesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UserOnboardingQuestionResponsesEdge"] = ResolversParentTypes["UserOnboardingQuestionResponsesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["UserOnboardingQuestionResponse"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOnboardingQuestionsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UserOnboardingQuestionsConnection"] = ResolversParentTypes["UserOnboardingQuestionsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["UserOnboardingQuestionsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["UserOnboardingQuestion"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserOnboardingQuestionsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UserOnboardingQuestionsEdge"] = ResolversParentTypes["UserOnboardingQuestionsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["UserOnboardingQuestion"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPersonalSpaceRequestResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UserPersonalSpaceRequest"] = ResolversParentTypes["UserPersonalSpaceRequest"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  dateActivated?: Resolver<
    Maybe<ResolversTypes["Datetime"]>,
    ParentType,
    ContextType
  >;
  dateRequested?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  status?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  synchronizeHome?: Resolver<
    ResolversTypes["Boolean"],
    ParentType,
    ContextType
  >;
  userId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPersonalSpaceRequestsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UserPersonalSpaceRequestsConnection"] = ResolversParentTypes["UserPersonalSpaceRequestsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["UserPersonalSpaceRequestsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["UserPersonalSpaceRequest"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPersonalSpaceRequestsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["UserPersonalSpaceRequestsEdge"] = ResolversParentTypes["UserPersonalSpaceRequestsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["UserPersonalSpaceRequest"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WaffleFlagResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WaffleFlag"] = ResolversParentTypes["WaffleFlag"],
> = {
  authenticated?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  created?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  everyone?: Resolver<
    Maybe<ResolversTypes["Boolean"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  languages?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  modified?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  note?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  percent?: Resolver<
    Maybe<ResolversTypes["BigFloat"]>,
    ParentType,
    ContextType
  >;
  rollout?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  staff?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  superusers?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  testing?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WaffleFlagsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WaffleFlagsConnection"] = ResolversParentTypes["WaffleFlagsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["WaffleFlagsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["WaffleFlag"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WaffleFlagsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WaffleFlagsEdge"] = ResolversParentTypes["WaffleFlagsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["WaffleFlag"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WaffleSampleResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WaffleSample"] = ResolversParentTypes["WaffleSample"],
> = {
  created?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  modified?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  note?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  percent?: Resolver<ResolversTypes["BigFloat"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WaffleSamplesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WaffleSamplesConnection"] = ResolversParentTypes["WaffleSamplesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["WaffleSamplesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["WaffleSample"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WaffleSamplesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WaffleSamplesEdge"] = ResolversParentTypes["WaffleSamplesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["WaffleSample"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WaffleSwitchResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WaffleSwitch"] = ResolversParentTypes["WaffleSwitch"],
> = {
  active?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  created?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  modified?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  note?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WaffleSwitchesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WaffleSwitchesConnection"] = ResolversParentTypes["WaffleSwitchesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["WaffleSwitchesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["WaffleSwitch"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WaffleSwitchesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WaffleSwitchesEdge"] = ResolversParentTypes["WaffleSwitchesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["WaffleSwitch"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["Workflow"] = ResolversParentTypes["Workflow"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  containerId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  containerImageByContainerId?: Resolver<
    Maybe<ResolversTypes["ContainerImage"]>,
    ParentType,
    ContextType
  >;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  description?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  tenantByTenantId?: Resolver<
    Maybe<ResolversTypes["Tenant"]>,
    ParentType,
    ContextType
  >;
  tenantId?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  workflowVersionsByWorkflowId?: Resolver<
    ResolversTypes["WorkflowVersionsConnection"],
    ParentType,
    ContextType,
    RequireFields<WorkflowWorkflowVersionsByWorkflowIdArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowDataConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowDataConnection"] = ResolversParentTypes["WorkflowDataConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["WorkflowDataEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["WorkflowDatum"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowDataEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowDataEdge"] = ResolversParentTypes["WorkflowDataEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["WorkflowDatum"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowDatumResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowDatum"] = ResolversParentTypes["WorkflowDatum"],
> = {
  fresh?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  workflowResultsByObjectId?: Resolver<
    ResolversTypes["WorkflowResultsConnection"],
    ParentType,
    ContextType,
    RequireFields<WorkflowDatumWorkflowResultsByObjectIdArgs, "orderBy">
  >;
  workflowSectionBlocksByObjectId?: Resolver<
    ResolversTypes["WorkflowSectionBlocksConnection"],
    ParentType,
    ContextType,
    RequireFields<WorkflowDatumWorkflowSectionBlocksByObjectIdArgs, "orderBy">
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowResult"] = ResolversParentTypes["WorkflowResult"],
> = {
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  objectId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  workflowDatumByObjectId?: Resolver<
    Maybe<ResolversTypes["WorkflowDatum"]>,
    ParentType,
    ContextType
  >;
  workflowResultWorkflowVersionsByResultId?: Resolver<
    ResolversTypes["WorkflowResultWorkflowVersionsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      WorkflowResultWorkflowResultWorkflowVersionsByResultIdArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowResultWorkflowVersionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowResultWorkflowVersion"] = ResolversParentTypes["WorkflowResultWorkflowVersion"],
> = {
  id?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  resultId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  workflowResultByResultId?: Resolver<
    Maybe<ResolversTypes["WorkflowResult"]>,
    ParentType,
    ContextType
  >;
  workflowVersionByWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["WorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  workflowversionId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowResultWorkflowVersionsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowResultWorkflowVersionsConnection"] = ResolversParentTypes["WorkflowResultWorkflowVersionsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["WorkflowResultWorkflowVersionsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["WorkflowResultWorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowResultWorkflowVersionsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowResultWorkflowVersionsEdge"] = ResolversParentTypes["WorkflowResultWorkflowVersionsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["WorkflowResultWorkflowVersion"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowResultsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowResultsConnection"] = ResolversParentTypes["WorkflowResultsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["WorkflowResultsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["WorkflowResult"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowResultsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowResultsEdge"] = ResolversParentTypes["WorkflowResultsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["WorkflowResult"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSection"] = ResolversParentTypes["WorkflowSection"],
> = {
  description?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  order?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  workflowSectionBlockSectionsBySectionId?: Resolver<
    ResolversTypes["WorkflowSectionBlockSectionsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      WorkflowSectionWorkflowSectionBlockSectionsBySectionIdArgs,
      "orderBy"
    >
  >;
  workflowSectionWorkflowVersionsBySectionId?: Resolver<
    ResolversTypes["WorkflowSectionWorkflowVersionsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      WorkflowSectionWorkflowSectionWorkflowVersionsBySectionIdArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSectionBlockResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSectionBlock"] = ResolversParentTypes["WorkflowSectionBlock"],
> = {
  columns?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  markdown?: Resolver<Maybe<ResolversTypes["String"]>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  order?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  parameters?: Resolver<Maybe<ResolversTypes["JSON"]>, ParentType, ContextType>;
  results?: Resolver<Maybe<ResolversTypes["JSON"]>, ParentType, ContextType>;
  sources?: Resolver<Maybe<ResolversTypes["JSON"]>, ParentType, ContextType>;
  toolId?: Resolver<Maybe<ResolversTypes["Int"]>, ParentType, ContextType>;
  toolVersionByToolId?: Resolver<
    Maybe<ResolversTypes["ToolVersion"]>,
    ParentType,
    ContextType
  >;
  workflowDatumByObjectId?: Resolver<
    Maybe<ResolversTypes["WorkflowDatum"]>,
    ParentType,
    ContextType
  >;
  workflowSectionBlockSectionsByBlockId?: Resolver<
    ResolversTypes["WorkflowSectionBlockSectionsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      WorkflowSectionBlockWorkflowSectionBlockSectionsByBlockIdArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSectionBlockSectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSectionBlockSection"] = ResolversParentTypes["WorkflowSectionBlockSection"],
> = {
  blockId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  sectionId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  workflowSectionBlockByBlockId?: Resolver<
    Maybe<ResolversTypes["WorkflowSectionBlock"]>,
    ParentType,
    ContextType
  >;
  workflowSectionBySectionId?: Resolver<
    Maybe<ResolversTypes["WorkflowSection"]>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSectionBlockSectionsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSectionBlockSectionsConnection"] = ResolversParentTypes["WorkflowSectionBlockSectionsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["WorkflowSectionBlockSectionsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["WorkflowSectionBlockSection"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSectionBlockSectionsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSectionBlockSectionsEdge"] = ResolversParentTypes["WorkflowSectionBlockSectionsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["WorkflowSectionBlockSection"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSectionBlocksConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSectionBlocksConnection"] = ResolversParentTypes["WorkflowSectionBlocksConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["WorkflowSectionBlocksEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["WorkflowSectionBlock"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSectionBlocksEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSectionBlocksEdge"] = ResolversParentTypes["WorkflowSectionBlocksEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["WorkflowSectionBlock"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSectionWorkflowVersionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSectionWorkflowVersion"] = ResolversParentTypes["WorkflowSectionWorkflowVersion"],
> = {
  id?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  sectionId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  workflowSectionBySectionId?: Resolver<
    Maybe<ResolversTypes["WorkflowSection"]>,
    ParentType,
    ContextType
  >;
  workflowVersionByWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["WorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  workflowversionId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSectionWorkflowVersionsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSectionWorkflowVersionsConnection"] = ResolversParentTypes["WorkflowSectionWorkflowVersionsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["WorkflowSectionWorkflowVersionsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["WorkflowSectionWorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSectionWorkflowVersionsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSectionWorkflowVersionsEdge"] = ResolversParentTypes["WorkflowSectionWorkflowVersionsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["WorkflowSectionWorkflowVersion"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSectionsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSectionsConnection"] = ResolversParentTypes["WorkflowSectionsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["WorkflowSectionsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["WorkflowSection"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSectionsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSectionsEdge"] = ResolversParentTypes["WorkflowSectionsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["WorkflowSection"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSourceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSource"] = ResolversParentTypes["WorkflowSource"],
> = {
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  workflowSourceWorkflowVersionsBySourceId?: Resolver<
    ResolversTypes["WorkflowSourceWorkflowVersionsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      WorkflowSourceWorkflowSourceWorkflowVersionsBySourceIdArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSourceWorkflowVersionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSourceWorkflowVersion"] = ResolversParentTypes["WorkflowSourceWorkflowVersion"],
> = {
  id?: Resolver<ResolversTypes["BigInt"], ParentType, ContextType>;
  sourceId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  workflowSourceBySourceId?: Resolver<
    Maybe<ResolversTypes["WorkflowSource"]>,
    ParentType,
    ContextType
  >;
  workflowVersionByWorkflowversionId?: Resolver<
    Maybe<ResolversTypes["WorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  workflowversionId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSourceWorkflowVersionsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSourceWorkflowVersionsConnection"] = ResolversParentTypes["WorkflowSourceWorkflowVersionsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["WorkflowSourceWorkflowVersionsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["WorkflowSourceWorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSourceWorkflowVersionsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSourceWorkflowVersionsEdge"] = ResolversParentTypes["WorkflowSourceWorkflowVersionsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<
    ResolversTypes["WorkflowSourceWorkflowVersion"],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSourcesConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSourcesConnection"] = ResolversParentTypes["WorkflowSourcesConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["WorkflowSourcesEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["WorkflowSource"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowSourcesEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowSourcesEdge"] = ResolversParentTypes["WorkflowSourcesEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["WorkflowSource"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowVersionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowVersion"] = ResolversParentTypes["WorkflowVersion"],
> = {
  applicationUserByUserId?: Resolver<
    Maybe<ResolversTypes["ApplicationUser"]>,
    ParentType,
    ContextType
  >;
  autoGenerated?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes["Datetime"], ParentType, ContextType>;
  description?: Resolver<
    Maybe<ResolversTypes["String"]>,
    ParentType,
    ContextType
  >;
  draft?: Resolver<ResolversTypes["Boolean"], ParentType, ContextType>;
  id?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  name?: Resolver<ResolversTypes["String"], ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes["UUID"]>, ParentType, ContextType>;
  workflowByWorkflowId?: Resolver<
    Maybe<ResolversTypes["Workflow"]>,
    ParentType,
    ContextType
  >;
  workflowId?: Resolver<ResolversTypes["UUID"], ParentType, ContextType>;
  workflowResultWorkflowVersionsByWorkflowversionId?: Resolver<
    ResolversTypes["WorkflowResultWorkflowVersionsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      WorkflowVersionWorkflowResultWorkflowVersionsByWorkflowversionIdArgs,
      "orderBy"
    >
  >;
  workflowSectionWorkflowVersionsByWorkflowversionId?: Resolver<
    ResolversTypes["WorkflowSectionWorkflowVersionsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      WorkflowVersionWorkflowSectionWorkflowVersionsByWorkflowversionIdArgs,
      "orderBy"
    >
  >;
  workflowSourceWorkflowVersionsByWorkflowversionId?: Resolver<
    ResolversTypes["WorkflowSourceWorkflowVersionsConnection"],
    ParentType,
    ContextType,
    RequireFields<
      WorkflowVersionWorkflowSourceWorkflowVersionsByWorkflowversionIdArgs,
      "orderBy"
    >
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowVersionsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowVersionsConnection"] = ResolversParentTypes["WorkflowVersionsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["WorkflowVersionsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes["WorkflowVersion"]>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowVersionsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowVersionsEdge"] = ResolversParentTypes["WorkflowVersionsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["WorkflowVersion"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowsConnectionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowsConnection"] = ResolversParentTypes["WorkflowsConnection"],
> = {
  edges?: Resolver<
    Array<ResolversTypes["WorkflowsEdge"]>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<Array<ResolversTypes["Workflow"]>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes["PageInfo"], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes["Int"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkflowsEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes["WorkflowsEdge"] = ResolversParentTypes["WorkflowsEdge"],
> = {
  cursor?: Resolver<Maybe<ResolversTypes["Cursor"]>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes["Workflow"], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AdminProject?: AdminProjectResolvers<ContextType>;
  AdminProjectsConnection?: AdminProjectsConnectionResolvers<ContextType>;
  AdminProjectsEdge?: AdminProjectsEdgeResolvers<ContextType>;
  ApplicationUser?: ApplicationUserResolvers<ContextType>;
  ApplicationUserGroup?: ApplicationUserGroupResolvers<ContextType>;
  ApplicationUserGroupsConnection?: ApplicationUserGroupsConnectionResolvers<ContextType>;
  ApplicationUserGroupsEdge?: ApplicationUserGroupsEdgeResolvers<ContextType>;
  ApplicationUserMembership?: ApplicationUserMembershipResolvers<ContextType>;
  ApplicationUserMembershipsConnection?: ApplicationUserMembershipsConnectionResolvers<ContextType>;
  ApplicationUserMembershipsEdge?: ApplicationUserMembershipsEdgeResolvers<ContextType>;
  ApplicationUserMetadataConnection?: ApplicationUserMetadataConnectionResolvers<ContextType>;
  ApplicationUserMetadataEdge?: ApplicationUserMetadataEdgeResolvers<ContextType>;
  ApplicationUserMetadatum?: ApplicationUserMetadatumResolvers<ContextType>;
  ApplicationUserSession?: ApplicationUserSessionResolvers<ContextType>;
  ApplicationUserSessionsConnection?: ApplicationUserSessionsConnectionResolvers<ContextType>;
  ApplicationUserSessionsEdge?: ApplicationUserSessionsEdgeResolvers<ContextType>;
  ApplicationUserUserPermission?: ApplicationUserUserPermissionResolvers<ContextType>;
  ApplicationUserUserPermissionsConnection?: ApplicationUserUserPermissionsConnectionResolvers<ContextType>;
  ApplicationUserUserPermissionsEdge?: ApplicationUserUserPermissionsEdgeResolvers<ContextType>;
  ApplicationUsersEdge?: ApplicationUsersEdgeResolvers<ContextType>;
  AuditlogLogentriesConnection?: AuditlogLogentriesConnectionResolvers<ContextType>;
  AuditlogLogentriesEdge?: AuditlogLogentriesEdgeResolvers<ContextType>;
  AuditlogLogentry?: AuditlogLogentryResolvers<ContextType>;
  AuthGroup?: AuthGroupResolvers<ContextType>;
  AuthGroupPermission?: AuthGroupPermissionResolvers<ContextType>;
  AuthGroupPermissionsConnection?: AuthGroupPermissionsConnectionResolvers<ContextType>;
  AuthGroupPermissionsEdge?: AuthGroupPermissionsEdgeResolvers<ContextType>;
  AuthGroupsConnection?: AuthGroupsConnectionResolvers<ContextType>;
  AuthGroupsEdge?: AuthGroupsEdgeResolvers<ContextType>;
  AuthPermission?: AuthPermissionResolvers<ContextType>;
  AuthPermissionsConnection?: AuthPermissionsConnectionResolvers<ContextType>;
  AuthPermissionsEdge?: AuthPermissionsEdgeResolvers<ContextType>;
  AvailableNonRestrictedProject?: AvailableNonRestrictedProjectResolvers<ContextType>;
  AvailableNonRestrictedProjectsConnection?: AvailableNonRestrictedProjectsConnectionResolvers<ContextType>;
  AvailableNonRestrictedProjectsEdge?: AvailableNonRestrictedProjectsEdgeResolvers<ContextType>;
  Avatar?: AvatarResolvers<ContextType>;
  AvatarsConnection?: AvatarsConnectionResolvers<ContextType>;
  AvatarsEdge?: AvatarsEdgeResolvers<ContextType>;
  AwsBatchTask?: AwsBatchTaskResolvers<ContextType>;
  AwsBatchTasksConnection?: AwsBatchTasksConnectionResolvers<ContextType>;
  AwsBatchTasksEdge?: AwsBatchTasksEdgeResolvers<ContextType>;
  AwsCognitoUser?: AwsCognitoUserResolvers<ContextType>;
  AwsCognitoUsersConnection?: AwsCognitoUsersConnectionResolvers<ContextType>;
  AwsCognitoUsersEdge?: AwsCognitoUsersEdgeResolvers<ContextType>;
  AwsEcrImage?: AwsEcrImageResolvers<ContextType>;
  AwsEcrImagesConnection?: AwsEcrImagesConnectionResolvers<ContextType>;
  AwsEcrImagesEdge?: AwsEcrImagesEdgeResolvers<ContextType>;
  AwsMockBatchTask?: AwsMockBatchTaskResolvers<ContextType>;
  AwsMockBatchTasksConnection?: AwsMockBatchTasksConnectionResolvers<ContextType>;
  AwsMockBatchTasksEdge?: AwsMockBatchTasksEdgeResolvers<ContextType>;
  AwsMockDistributionImage?: AwsMockDistributionImageResolvers<ContextType>;
  AwsMockDistributionImagesConnection?: AwsMockDistributionImagesConnectionResolvers<ContextType>;
  AwsMockDistributionImagesEdge?: AwsMockDistributionImagesEdgeResolvers<ContextType>;
  AwsMockEcrImage?: AwsMockEcrImageResolvers<ContextType>;
  AwsMockEcrImagesConnection?: AwsMockEcrImagesConnectionResolvers<ContextType>;
  AwsMockEcrImagesEdge?: AwsMockEcrImagesEdgeResolvers<ContextType>;
  AwsMockIamUser?: AwsMockIamUserResolvers<ContextType>;
  AwsMockIamUsersConnection?: AwsMockIamUsersConnectionResolvers<ContextType>;
  AwsMockIamUsersEdge?: AwsMockIamUsersEdgeResolvers<ContextType>;
  AwsMockS3File?: AwsMockS3FileResolvers<ContextType>;
  AwsMockS3FilesConnection?: AwsMockS3FilesConnectionResolvers<ContextType>;
  AwsMockS3FilesEdge?: AwsMockS3FilesEdgeResolvers<ContextType>;
  AwsS3File?: AwsS3FileResolvers<ContextType>;
  AwsS3FilesConnection?: AwsS3FilesConnectionResolvers<ContextType>;
  AwsS3FilesEdge?: AwsS3FilesEdgeResolvers<ContextType>;
  BigFloat?: GraphQLScalarType;
  BigInt?: GraphQLScalarType;
  ChangeUserSessionPayload?: ChangeUserSessionPayloadResolvers<ContextType>;
  CodeFile?: CodeFileResolvers<ContextType>;
  CodeFilesConnection?: CodeFilesConnectionResolvers<ContextType>;
  CodeFilesEdge?: CodeFilesEdgeResolvers<ContextType>;
  Command?: CommandResolvers<ContextType>;
  CommandsConnection?: CommandsConnectionResolvers<ContextType>;
  CommandsEdge?: CommandsEdgeResolvers<ContextType>;
  ContainerImage?: ContainerImageResolvers<ContextType>;
  ContainerImageRepositoriesConnection?: ContainerImageRepositoriesConnectionResolvers<ContextType>;
  ContainerImageRepositoriesEdge?: ContainerImageRepositoriesEdgeResolvers<ContextType>;
  ContainerImageRepository?: ContainerImageRepositoryResolvers<ContextType>;
  ContainerImagesConnection?: ContainerImagesConnectionResolvers<ContextType>;
  ContainerImagesEdge?: ContainerImagesEdgeResolvers<ContextType>;
  Cost?: CostResolvers<ContextType>;
  CostsConnection?: CostsConnectionResolvers<ContextType>;
  CostsEdge?: CostsEdgeResolvers<ContextType>;
  CreateAdminProjectPayload?: CreateAdminProjectPayloadResolvers<ContextType>;
  CreateApplicationUserGroupPayload?: CreateApplicationUserGroupPayloadResolvers<ContextType>;
  CreateApplicationUserMembershipPayload?: CreateApplicationUserMembershipPayloadResolvers<ContextType>;
  CreateApplicationUserMetadatumPayload?: CreateApplicationUserMetadatumPayloadResolvers<ContextType>;
  CreateApplicationUserPayload?: CreateApplicationUserPayloadResolvers<ContextType>;
  CreateApplicationUserSessionPayload?: CreateApplicationUserSessionPayloadResolvers<ContextType>;
  CreateApplicationUserUserPermissionPayload?: CreateApplicationUserUserPermissionPayloadResolvers<ContextType>;
  CreateAuditlogLogentryPayload?: CreateAuditlogLogentryPayloadResolvers<ContextType>;
  CreateAuthGroupPayload?: CreateAuthGroupPayloadResolvers<ContextType>;
  CreateAuthGroupPermissionPayload?: CreateAuthGroupPermissionPayloadResolvers<ContextType>;
  CreateAuthPermissionPayload?: CreateAuthPermissionPayloadResolvers<ContextType>;
  CreateAvailableNonRestrictedProjectPayload?: CreateAvailableNonRestrictedProjectPayloadResolvers<ContextType>;
  CreateAvatarPayload?: CreateAvatarPayloadResolvers<ContextType>;
  CreateAwsBatchTaskPayload?: CreateAwsBatchTaskPayloadResolvers<ContextType>;
  CreateAwsCognitoUserPayload?: CreateAwsCognitoUserPayloadResolvers<ContextType>;
  CreateAwsEcrImagePayload?: CreateAwsEcrImagePayloadResolvers<ContextType>;
  CreateAwsMockBatchTaskPayload?: CreateAwsMockBatchTaskPayloadResolvers<ContextType>;
  CreateAwsMockDistributionImagePayload?: CreateAwsMockDistributionImagePayloadResolvers<ContextType>;
  CreateAwsMockEcrImagePayload?: CreateAwsMockEcrImagePayloadResolvers<ContextType>;
  CreateAwsMockIamUserPayload?: CreateAwsMockIamUserPayloadResolvers<ContextType>;
  CreateAwsMockS3FilePayload?: CreateAwsMockS3FilePayloadResolvers<ContextType>;
  CreateAwsS3FilePayload?: CreateAwsS3FilePayloadResolvers<ContextType>;
  CreateCodeFilePayload?: CreateCodeFilePayloadResolvers<ContextType>;
  CreateCommandPayload?: CreateCommandPayloadResolvers<ContextType>;
  CreateContainerImagePayload?: CreateContainerImagePayloadResolvers<ContextType>;
  CreateContainerImageRepositoryPayload?: CreateContainerImageRepositoryPayloadResolvers<ContextType>;
  CreateCostPayload?: CreateCostPayloadResolvers<ContextType>;
  CreateCurrentApplicationUserPayload?: CreateCurrentApplicationUserPayloadResolvers<ContextType>;
  CreateDistributionRegistryImagePayload?: CreateDistributionRegistryImagePayloadResolvers<ContextType>;
  CreateDjangoAdminLogPayload?: CreateDjangoAdminLogPayloadResolvers<ContextType>;
  CreateDjangoContentTypePayload?: CreateDjangoContentTypePayloadResolvers<ContextType>;
  CreateDjangoMigrationPayload?: CreateDjangoMigrationPayloadResolvers<ContextType>;
  CreateDjangoSesBlacklistedemailPayload?: CreateDjangoSesBlacklistedemailPayloadResolvers<ContextType>;
  CreateDjangoSesSesstatPayload?: CreateDjangoSesSesstatPayloadResolvers<ContextType>;
  CreateDjangoSessionPayload?: CreateDjangoSessionPayloadResolvers<ContextType>;
  CreateDrsFileexecutorPayload?: CreateDrsFileexecutorPayloadResolvers<ContextType>;
  CreateDrsMockfileexecutorPayload?: CreateDrsMockfileexecutorPayloadResolvers<ContextType>;
  CreateEulaVersionPayload?: CreateEulaVersionPayloadResolvers<ContextType>;
  CreateEulaVersionUserAcceptancePayload?: CreateEulaVersionUserAcceptancePayloadResolvers<ContextType>;
  CreateFeatureFlagPayload?: CreateFeatureFlagPayloadResolvers<ContextType>;
  CreateFeatureFlagsGroupPayload?: CreateFeatureFlagsGroupPayloadResolvers<ContextType>;
  CreateFeatureFlagsTenantPayload?: CreateFeatureFlagsTenantPayloadResolvers<ContextType>;
  CreateFeatureFlagsUserPayload?: CreateFeatureFlagsUserPayloadResolvers<ContextType>;
  CreateFileActivityPayload?: CreateFileActivityPayloadResolvers<ContextType>;
  CreateFileMetadatumPayload?: CreateFileMetadatumPayloadResolvers<ContextType>;
  CreateFileOutputGroupMetadatumPayload?: CreateFileOutputGroupMetadatumPayloadResolvers<ContextType>;
  CreateFilePayload?: CreateFilePayloadResolvers<ContextType>;
  CreateFilesByExecutorPayload?: CreateFilesByExecutorPayloadResolvers<ContextType>;
  CreateMetadataValuePayload?: CreateMetadataValuePayloadResolvers<ContextType>;
  CreateMetadatumPayload?: CreateMetadatumPayloadResolvers<ContextType>;
  CreateOutputGroupFilePayload?: CreateOutputGroupFilePayloadResolvers<ContextType>;
  CreatePinnedToolPayload?: CreatePinnedToolPayloadResolvers<ContextType>;
  CreateProjectFolderPayload?: CreateProjectFolderPayloadResolvers<ContextType>;
  CreateProjectTagPayload?: CreateProjectTagPayloadResolvers<ContextType>;
  CreateRolePayload?: CreateRolePayloadResolvers<ContextType>;
  CreateRunPayload?: CreateRunPayloadResolvers<ContextType>;
  CreateSessionPayload?: CreateSessionPayloadResolvers<ContextType>;
  CreateTaskActivityPayload?: CreateTaskActivityPayloadResolvers<ContextType>;
  CreateTaskPayload?: CreateTaskPayloadResolvers<ContextType>;
  CreateTaskResourcePayload?: CreateTaskResourcePayloadResolvers<ContextType>;
  CreateTaskResourceUsagePayload?: CreateTaskResourceUsagePayloadResolvers<ContextType>;
  CreateTaskSourcePayload?: CreateTaskSourcePayloadResolvers<ContextType>;
  CreateTaskStatusLogPayload?: CreateTaskStatusLogPayloadResolvers<ContextType>;
  CreateTenantContractAllowancePayload?: CreateTenantContractAllowancePayloadResolvers<ContextType>;
  CreateTenantContractPayload?: CreateTenantContractPayloadResolvers<ContextType>;
  CreateTenantContractTransactionPayload?: CreateTenantContractTransactionPayloadResolvers<ContextType>;
  CreateTenantMockuserexecutorPayload?: CreateTenantMockuserexecutorPayloadResolvers<ContextType>;
  CreateTenantMonthlyConsumedResourcePayload?: CreateTenantMonthlyConsumedResourcePayloadResolvers<ContextType>;
  CreateTenantPayload?: CreateTenantPayloadResolvers<ContextType>;
  CreateTenantUserexecutorPayload?: CreateTenantUserexecutorPayloadResolvers<ContextType>;
  CreateTesContainerimageexecutorPayload?: CreateTesContainerimageexecutorPayloadResolvers<ContextType>;
  CreateTesMockcontainerimageexecutorPayload?: CreateTesMockcontainerimageexecutorPayloadResolvers<ContextType>;
  CreateTesMocktaskexecutorPayload?: CreateTesMocktaskexecutorPayloadResolvers<ContextType>;
  CreateTesTaskexecutorPayload?: CreateTesTaskexecutorPayloadResolvers<ContextType>;
  CreateToolParameterPayload?: CreateToolParameterPayloadResolvers<ContextType>;
  CreateToolPayload?: CreateToolPayloadResolvers<ContextType>;
  CreateToolResourcePayload?: CreateToolResourcePayloadResolvers<ContextType>;
  CreateToolResultPayload?: CreateToolResultPayloadResolvers<ContextType>;
  CreateToolSecretPayload?: CreateToolSecretPayloadResolvers<ContextType>;
  CreateToolSourcePayload?: CreateToolSourcePayloadResolvers<ContextType>;
  CreateToolTenantPayload?: CreateToolTenantPayloadResolvers<ContextType>;
  CreateToolVersionPayload?: CreateToolVersionPayloadResolvers<ContextType>;
  CreateToolboxPayload?: CreateToolboxPayloadResolvers<ContextType>;
  CreateToolboxTenantPayload?: CreateToolboxTenantPayloadResolvers<ContextType>;
  CreateUserPersonalSpaceRequestPayload?: CreateUserPersonalSpaceRequestPayloadResolvers<ContextType>;
  CreateWaffleFlagPayload?: CreateWaffleFlagPayloadResolvers<ContextType>;
  CreateWaffleSamplePayload?: CreateWaffleSamplePayloadResolvers<ContextType>;
  CreateWaffleSwitchPayload?: CreateWaffleSwitchPayloadResolvers<ContextType>;
  CreateWorkflowDatumPayload?: CreateWorkflowDatumPayloadResolvers<ContextType>;
  CreateWorkflowPayload?: CreateWorkflowPayloadResolvers<ContextType>;
  CreateWorkflowResultPayload?: CreateWorkflowResultPayloadResolvers<ContextType>;
  CreateWorkflowResultWorkflowVersionPayload?: CreateWorkflowResultWorkflowVersionPayloadResolvers<ContextType>;
  CreateWorkflowSectionBlockPayload?: CreateWorkflowSectionBlockPayloadResolvers<ContextType>;
  CreateWorkflowSectionBlockSectionPayload?: CreateWorkflowSectionBlockSectionPayloadResolvers<ContextType>;
  CreateWorkflowSectionPayload?: CreateWorkflowSectionPayloadResolvers<ContextType>;
  CreateWorkflowSectionWorkflowVersionPayload?: CreateWorkflowSectionWorkflowVersionPayloadResolvers<ContextType>;
  CreateWorkflowSourcePayload?: CreateWorkflowSourcePayloadResolvers<ContextType>;
  CreateWorkflowSourceWorkflowVersionPayload?: CreateWorkflowSourceWorkflowVersionPayloadResolvers<ContextType>;
  CreateWorkflowVersionPayload?: CreateWorkflowVersionPayloadResolvers<ContextType>;
  CurrentApplicationUser?: CurrentApplicationUserResolvers<ContextType>;
  CurrentApplicationUsersConnection?: CurrentApplicationUsersConnectionResolvers<ContextType>;
  CurrentApplicationUsersEdge?: CurrentApplicationUsersEdgeResolvers<ContextType>;
  CurrentUserMembership?: CurrentUserMembershipResolvers<ContextType>;
  CurrentUserMembershipsConnection?: CurrentUserMembershipsConnectionResolvers<ContextType>;
  CurrentUserMembershipsEdge?: CurrentUserMembershipsEdgeResolvers<ContextType>;
  Cursor?: GraphQLScalarType;
  DataTable?: DataTableResolvers<ContextType>;
  DataTableCell?: DataTableCellResolvers<ContextType>;
  DataTableCellsConnection?: DataTableCellsConnectionResolvers<ContextType>;
  DataTableCellsEdge?: DataTableCellsEdgeResolvers<ContextType>;
  DataTableColumn?: DataTableColumnResolvers<ContextType>;
  DataTableColumnDefinitionBoolean?: DataTableColumnDefinitionBooleanResolvers<ContextType>;
  DataTableColumnDefinitionBooleansConnection?: DataTableColumnDefinitionBooleansConnectionResolvers<ContextType>;
  DataTableColumnDefinitionBooleansEdge?: DataTableColumnDefinitionBooleansEdgeResolvers<ContextType>;
  DataTableColumnDefinitionCellStatus?: DataTableColumnDefinitionCellStatusResolvers<ContextType>;
  DataTableColumnDefinitionCellStatusesConnection?: DataTableColumnDefinitionCellStatusesConnectionResolvers<ContextType>;
  DataTableColumnDefinitionCellStatusesEdge?: DataTableColumnDefinitionCellStatusesEdgeResolvers<ContextType>;
  DataTableColumnDefinitionChoice?: DataTableColumnDefinitionChoiceResolvers<ContextType>;
  DataTableColumnDefinitionChoicesConnection?: DataTableColumnDefinitionChoicesConnectionResolvers<ContextType>;
  DataTableColumnDefinitionChoicesEdge?: DataTableColumnDefinitionChoicesEdgeResolvers<ContextType>;
  DataTableColumnDefinitionDate?: DataTableColumnDefinitionDateResolvers<ContextType>;
  DataTableColumnDefinitionDatesConnection?: DataTableColumnDefinitionDatesConnectionResolvers<ContextType>;
  DataTableColumnDefinitionDatesEdge?: DataTableColumnDefinitionDatesEdgeResolvers<ContextType>;
  DataTableColumnDefinitionFile?: DataTableColumnDefinitionFileResolvers<ContextType>;
  DataTableColumnDefinitionFilesConnection?: DataTableColumnDefinitionFilesConnectionResolvers<ContextType>;
  DataTableColumnDefinitionFilesEdge?: DataTableColumnDefinitionFilesEdgeResolvers<ContextType>;
  DataTableColumnDefinitionFloat?: DataTableColumnDefinitionFloatResolvers<ContextType>;
  DataTableColumnDefinitionFloatsConnection?: DataTableColumnDefinitionFloatsConnectionResolvers<ContextType>;
  DataTableColumnDefinitionFloatsEdge?: DataTableColumnDefinitionFloatsEdgeResolvers<ContextType>;
  DataTableColumnDefinitionIdentifier?: DataTableColumnDefinitionIdentifierResolvers<ContextType>;
  DataTableColumnDefinitionIdentifiersConnection?: DataTableColumnDefinitionIdentifiersConnectionResolvers<ContextType>;
  DataTableColumnDefinitionIdentifiersEdge?: DataTableColumnDefinitionIdentifiersEdgeResolvers<ContextType>;
  DataTableColumnDefinitionInteger?: DataTableColumnDefinitionIntegerResolvers<ContextType>;
  DataTableColumnDefinitionIntegersConnection?: DataTableColumnDefinitionIntegersConnectionResolvers<ContextType>;
  DataTableColumnDefinitionIntegersEdge?: DataTableColumnDefinitionIntegersEdgeResolvers<ContextType>;
  DataTableColumnDefinitionJoin?: DataTableColumnDefinitionJoinResolvers<ContextType>;
  DataTableColumnDefinitionJoinsConnection?: DataTableColumnDefinitionJoinsConnectionResolvers<ContextType>;
  DataTableColumnDefinitionJoinsEdge?: DataTableColumnDefinitionJoinsEdgeResolvers<ContextType>;
  DataTableColumnDefinitionMetadataConnection?: DataTableColumnDefinitionMetadataConnectionResolvers<ContextType>;
  DataTableColumnDefinitionMetadataEdge?: DataTableColumnDefinitionMetadataEdgeResolvers<ContextType>;
  DataTableColumnDefinitionMetadatum?: DataTableColumnDefinitionMetadatumResolvers<ContextType>;
  DataTableColumnDefinitionRoiFrame?: DataTableColumnDefinitionRoiFrameResolvers<ContextType>;
  DataTableColumnDefinitionRoiFramesConnection?: DataTableColumnDefinitionRoiFramesConnectionResolvers<ContextType>;
  DataTableColumnDefinitionRoiFramesEdge?: DataTableColumnDefinitionRoiFramesEdgeResolvers<ContextType>;
  DataTableColumnDefinitionText?: DataTableColumnDefinitionTextResolvers<ContextType>;
  DataTableColumnDefinitionTextsConnection?: DataTableColumnDefinitionTextsConnectionResolvers<ContextType>;
  DataTableColumnDefinitionTextsEdge?: DataTableColumnDefinitionTextsEdgeResolvers<ContextType>;
  DataTableColumnGroup?: DataTableColumnGroupResolvers<ContextType>;
  DataTableColumnGroupDefinitionJoin?: DataTableColumnGroupDefinitionJoinResolvers<ContextType>;
  DataTableColumnGroupDefinitionJoinsConnection?: DataTableColumnGroupDefinitionJoinsConnectionResolvers<ContextType>;
  DataTableColumnGroupDefinitionJoinsEdge?: DataTableColumnGroupDefinitionJoinsEdgeResolvers<ContextType>;
  DataTableColumnGroupDefinitionSource?: DataTableColumnGroupDefinitionSourceResolvers<ContextType>;
  DataTableColumnGroupDefinitionSourcesConnection?: DataTableColumnGroupDefinitionSourcesConnectionResolvers<ContextType>;
  DataTableColumnGroupDefinitionSourcesEdge?: DataTableColumnGroupDefinitionSourcesEdgeResolvers<ContextType>;
  DataTableColumnGroupsConnection?: DataTableColumnGroupsConnectionResolvers<ContextType>;
  DataTableColumnGroupsEdge?: DataTableColumnGroupsEdgeResolvers<ContextType>;
  DataTableColumnsConnection?: DataTableColumnsConnectionResolvers<ContextType>;
  DataTableColumnsEdge?: DataTableColumnsEdgeResolvers<ContextType>;
  DataTableRow?: DataTableRowResolvers<ContextType>;
  DataTableRowsConnection?: DataTableRowsConnectionResolvers<ContextType>;
  DataTableRowsEdge?: DataTableRowsEdgeResolvers<ContextType>;
  DataTablesConnection?: DataTablesConnectionResolvers<ContextType>;
  DataTablesEdge?: DataTablesEdgeResolvers<ContextType>;
  Date?: GraphQLScalarType;
  Datetime?: GraphQLScalarType;
  DeleteApplicationUserGroupPayload?: DeleteApplicationUserGroupPayloadResolvers<ContextType>;
  DeleteApplicationUserMembershipPayload?: DeleteApplicationUserMembershipPayloadResolvers<ContextType>;
  DeleteApplicationUserMetadatumPayload?: DeleteApplicationUserMetadatumPayloadResolvers<ContextType>;
  DeleteApplicationUserPayload?: DeleteApplicationUserPayloadResolvers<ContextType>;
  DeleteApplicationUserSessionPayload?: DeleteApplicationUserSessionPayloadResolvers<ContextType>;
  DeleteApplicationUserUserPermissionPayload?: DeleteApplicationUserUserPermissionPayloadResolvers<ContextType>;
  DeleteAuditlogLogentryPayload?: DeleteAuditlogLogentryPayloadResolvers<ContextType>;
  DeleteAuthGroupPayload?: DeleteAuthGroupPayloadResolvers<ContextType>;
  DeleteAuthGroupPermissionPayload?: DeleteAuthGroupPermissionPayloadResolvers<ContextType>;
  DeleteAuthPermissionPayload?: DeleteAuthPermissionPayloadResolvers<ContextType>;
  DeleteAvatarPayload?: DeleteAvatarPayloadResolvers<ContextType>;
  DeleteAwsBatchTaskPayload?: DeleteAwsBatchTaskPayloadResolvers<ContextType>;
  DeleteAwsCognitoUserPayload?: DeleteAwsCognitoUserPayloadResolvers<ContextType>;
  DeleteAwsEcrImagePayload?: DeleteAwsEcrImagePayloadResolvers<ContextType>;
  DeleteAwsMockBatchTaskPayload?: DeleteAwsMockBatchTaskPayloadResolvers<ContextType>;
  DeleteAwsMockDistributionImagePayload?: DeleteAwsMockDistributionImagePayloadResolvers<ContextType>;
  DeleteAwsMockEcrImagePayload?: DeleteAwsMockEcrImagePayloadResolvers<ContextType>;
  DeleteAwsMockIamUserPayload?: DeleteAwsMockIamUserPayloadResolvers<ContextType>;
  DeleteAwsMockS3FilePayload?: DeleteAwsMockS3FilePayloadResolvers<ContextType>;
  DeleteAwsS3FilePayload?: DeleteAwsS3FilePayloadResolvers<ContextType>;
  DeleteCodeFilePayload?: DeleteCodeFilePayloadResolvers<ContextType>;
  DeleteCommandPayload?: DeleteCommandPayloadResolvers<ContextType>;
  DeleteContainerImagePayload?: DeleteContainerImagePayloadResolvers<ContextType>;
  DeleteContainerImageRepositoryPayload?: DeleteContainerImageRepositoryPayloadResolvers<ContextType>;
  DeleteCostPayload?: DeleteCostPayloadResolvers<ContextType>;
  DeleteDistributionRegistryImagePayload?: DeleteDistributionRegistryImagePayloadResolvers<ContextType>;
  DeleteDjangoAdminLogPayload?: DeleteDjangoAdminLogPayloadResolvers<ContextType>;
  DeleteDjangoContentTypePayload?: DeleteDjangoContentTypePayloadResolvers<ContextType>;
  DeleteDjangoMigrationPayload?: DeleteDjangoMigrationPayloadResolvers<ContextType>;
  DeleteDjangoSesBlacklistedemailPayload?: DeleteDjangoSesBlacklistedemailPayloadResolvers<ContextType>;
  DeleteDjangoSesSesstatPayload?: DeleteDjangoSesSesstatPayloadResolvers<ContextType>;
  DeleteDjangoSessionPayload?: DeleteDjangoSessionPayloadResolvers<ContextType>;
  DeleteDrsFileexecutorPayload?: DeleteDrsFileexecutorPayloadResolvers<ContextType>;
  DeleteDrsMockfileexecutorPayload?: DeleteDrsMockfileexecutorPayloadResolvers<ContextType>;
  DeleteEulaVersionPayload?: DeleteEulaVersionPayloadResolvers<ContextType>;
  DeleteEulaVersionUserAcceptancePayload?: DeleteEulaVersionUserAcceptancePayloadResolvers<ContextType>;
  DeleteFeatureFlagPayload?: DeleteFeatureFlagPayloadResolvers<ContextType>;
  DeleteFeatureFlagsGroupPayload?: DeleteFeatureFlagsGroupPayloadResolvers<ContextType>;
  DeleteFeatureFlagsTenantPayload?: DeleteFeatureFlagsTenantPayloadResolvers<ContextType>;
  DeleteFeatureFlagsUserPayload?: DeleteFeatureFlagsUserPayloadResolvers<ContextType>;
  DeleteFileActivityPayload?: DeleteFileActivityPayloadResolvers<ContextType>;
  DeleteFileMetadatumPayload?: DeleteFileMetadatumPayloadResolvers<ContextType>;
  DeleteFileOutputGroupMetadatumPayload?: DeleteFileOutputGroupMetadatumPayloadResolvers<ContextType>;
  DeleteFileOutputGroupPayload?: DeleteFileOutputGroupPayloadResolvers<ContextType>;
  DeleteFilePayload?: DeleteFilePayloadResolvers<ContextType>;
  DeleteMetadataValuePayload?: DeleteMetadataValuePayloadResolvers<ContextType>;
  DeleteMetadatumPayload?: DeleteMetadatumPayloadResolvers<ContextType>;
  DeleteOutputGroupFilePayload?: DeleteOutputGroupFilePayloadResolvers<ContextType>;
  DeletePinnedToolPayload?: DeletePinnedToolPayloadResolvers<ContextType>;
  DeleteProjectFolderPayload?: DeleteProjectFolderPayloadResolvers<ContextType>;
  DeleteProjectTagPayload?: DeleteProjectTagPayloadResolvers<ContextType>;
  DeleteRunPayload?: DeleteRunPayloadResolvers<ContextType>;
  DeleteSessionPayload?: DeleteSessionPayloadResolvers<ContextType>;
  DeleteTaskActivityPayload?: DeleteTaskActivityPayloadResolvers<ContextType>;
  DeleteTaskPayload?: DeleteTaskPayloadResolvers<ContextType>;
  DeleteTaskResourcePayload?: DeleteTaskResourcePayloadResolvers<ContextType>;
  DeleteTaskResourceUsagePayload?: DeleteTaskResourceUsagePayloadResolvers<ContextType>;
  DeleteTaskSourcePayload?: DeleteTaskSourcePayloadResolvers<ContextType>;
  DeleteTaskStatusLogPayload?: DeleteTaskStatusLogPayloadResolvers<ContextType>;
  DeleteTenantContractAllowancePayload?: DeleteTenantContractAllowancePayloadResolvers<ContextType>;
  DeleteTenantContractPayload?: DeleteTenantContractPayloadResolvers<ContextType>;
  DeleteTenantContractTransactionPayload?: DeleteTenantContractTransactionPayloadResolvers<ContextType>;
  DeleteTenantMockuserexecutorPayload?: DeleteTenantMockuserexecutorPayloadResolvers<ContextType>;
  DeleteTenantMonthlyConsumedResourcePayload?: DeleteTenantMonthlyConsumedResourcePayloadResolvers<ContextType>;
  DeleteTenantPayload?: DeleteTenantPayloadResolvers<ContextType>;
  DeleteTenantUserexecutorPayload?: DeleteTenantUserexecutorPayloadResolvers<ContextType>;
  DeleteTesContainerimageexecutorPayload?: DeleteTesContainerimageexecutorPayloadResolvers<ContextType>;
  DeleteTesMockcontainerimageexecutorPayload?: DeleteTesMockcontainerimageexecutorPayloadResolvers<ContextType>;
  DeleteTesMocktaskexecutorPayload?: DeleteTesMocktaskexecutorPayloadResolvers<ContextType>;
  DeleteTesTaskexecutorPayload?: DeleteTesTaskexecutorPayloadResolvers<ContextType>;
  DeleteToolParameterPayload?: DeleteToolParameterPayloadResolvers<ContextType>;
  DeleteToolPayload?: DeleteToolPayloadResolvers<ContextType>;
  DeleteToolResourcePayload?: DeleteToolResourcePayloadResolvers<ContextType>;
  DeleteToolResultPayload?: DeleteToolResultPayloadResolvers<ContextType>;
  DeleteToolSecretPayload?: DeleteToolSecretPayloadResolvers<ContextType>;
  DeleteToolSourcePayload?: DeleteToolSourcePayloadResolvers<ContextType>;
  DeleteToolTenantPayload?: DeleteToolTenantPayloadResolvers<ContextType>;
  DeleteToolVersionPayload?: DeleteToolVersionPayloadResolvers<ContextType>;
  DeleteToolboxPayload?: DeleteToolboxPayloadResolvers<ContextType>;
  DeleteToolboxTenantPayload?: DeleteToolboxTenantPayloadResolvers<ContextType>;
  DeleteUserPersonalSpaceRequestPayload?: DeleteUserPersonalSpaceRequestPayloadResolvers<ContextType>;
  DeleteWaffleFlagPayload?: DeleteWaffleFlagPayloadResolvers<ContextType>;
  DeleteWaffleSamplePayload?: DeleteWaffleSamplePayloadResolvers<ContextType>;
  DeleteWaffleSwitchPayload?: DeleteWaffleSwitchPayloadResolvers<ContextType>;
  DeleteWorkflowDatumPayload?: DeleteWorkflowDatumPayloadResolvers<ContextType>;
  DeleteWorkflowPayload?: DeleteWorkflowPayloadResolvers<ContextType>;
  DeleteWorkflowResultPayload?: DeleteWorkflowResultPayloadResolvers<ContextType>;
  DeleteWorkflowResultWorkflowVersionPayload?: DeleteWorkflowResultWorkflowVersionPayloadResolvers<ContextType>;
  DeleteWorkflowSectionBlockPayload?: DeleteWorkflowSectionBlockPayloadResolvers<ContextType>;
  DeleteWorkflowSectionBlockSectionPayload?: DeleteWorkflowSectionBlockSectionPayloadResolvers<ContextType>;
  DeleteWorkflowSectionPayload?: DeleteWorkflowSectionPayloadResolvers<ContextType>;
  DeleteWorkflowSectionWorkflowVersionPayload?: DeleteWorkflowSectionWorkflowVersionPayloadResolvers<ContextType>;
  DeleteWorkflowSourcePayload?: DeleteWorkflowSourcePayloadResolvers<ContextType>;
  DeleteWorkflowSourceWorkflowVersionPayload?: DeleteWorkflowSourceWorkflowVersionPayloadResolvers<ContextType>;
  DeleteWorkflowVersionPayload?: DeleteWorkflowVersionPayloadResolvers<ContextType>;
  DistributionRegistryImage?: DistributionRegistryImageResolvers<ContextType>;
  DistributionRegistryImagesConnection?: DistributionRegistryImagesConnectionResolvers<ContextType>;
  DistributionRegistryImagesEdge?: DistributionRegistryImagesEdgeResolvers<ContextType>;
  DjangoAdminLog?: DjangoAdminLogResolvers<ContextType>;
  DjangoAdminLogsConnection?: DjangoAdminLogsConnectionResolvers<ContextType>;
  DjangoAdminLogsEdge?: DjangoAdminLogsEdgeResolvers<ContextType>;
  DjangoContentType?: DjangoContentTypeResolvers<ContextType>;
  DjangoContentTypesConnection?: DjangoContentTypesConnectionResolvers<ContextType>;
  DjangoContentTypesEdge?: DjangoContentTypesEdgeResolvers<ContextType>;
  DjangoMigration?: DjangoMigrationResolvers<ContextType>;
  DjangoMigrationsConnection?: DjangoMigrationsConnectionResolvers<ContextType>;
  DjangoMigrationsEdge?: DjangoMigrationsEdgeResolvers<ContextType>;
  DjangoSesBlacklistedemail?: DjangoSesBlacklistedemailResolvers<ContextType>;
  DjangoSesBlacklistedemailsConnection?: DjangoSesBlacklistedemailsConnectionResolvers<ContextType>;
  DjangoSesBlacklistedemailsEdge?: DjangoSesBlacklistedemailsEdgeResolvers<ContextType>;
  DjangoSesSesstat?: DjangoSesSesstatResolvers<ContextType>;
  DjangoSesSesstatsConnection?: DjangoSesSesstatsConnectionResolvers<ContextType>;
  DjangoSesSesstatsEdge?: DjangoSesSesstatsEdgeResolvers<ContextType>;
  DjangoSession?: DjangoSessionResolvers<ContextType>;
  DjangoSessionsConnection?: DjangoSessionsConnectionResolvers<ContextType>;
  DjangoSessionsEdge?: DjangoSessionsEdgeResolvers<ContextType>;
  DrsFileexecutor?: DrsFileexecutorResolvers<ContextType>;
  DrsFileexecutorsConnection?: DrsFileexecutorsConnectionResolvers<ContextType>;
  DrsFileexecutorsEdge?: DrsFileexecutorsEdgeResolvers<ContextType>;
  DrsMockfileexecutor?: DrsMockfileexecutorResolvers<ContextType>;
  DrsMockfileexecutorsConnection?: DrsMockfileexecutorsConnectionResolvers<ContextType>;
  DrsMockfileexecutorsEdge?: DrsMockfileexecutorsEdgeResolvers<ContextType>;
  EulaVersion?: EulaVersionResolvers<ContextType>;
  EulaVersionUserAcceptance?: EulaVersionUserAcceptanceResolvers<ContextType>;
  EulaVersionUserAcceptancesConnection?: EulaVersionUserAcceptancesConnectionResolvers<ContextType>;
  EulaVersionUserAcceptancesEdge?: EulaVersionUserAcceptancesEdgeResolvers<ContextType>;
  EulaVersionsConnection?: EulaVersionsConnectionResolvers<ContextType>;
  EulaVersionsEdge?: EulaVersionsEdgeResolvers<ContextType>;
  FeatureFlag?: FeatureFlagResolvers<ContextType>;
  FeatureFlagsConnection?: FeatureFlagsConnectionResolvers<ContextType>;
  FeatureFlagsEdge?: FeatureFlagsEdgeResolvers<ContextType>;
  FeatureFlagsGroup?: FeatureFlagsGroupResolvers<ContextType>;
  FeatureFlagsGroupsConnection?: FeatureFlagsGroupsConnectionResolvers<ContextType>;
  FeatureFlagsGroupsEdge?: FeatureFlagsGroupsEdgeResolvers<ContextType>;
  FeatureFlagsTenant?: FeatureFlagsTenantResolvers<ContextType>;
  FeatureFlagsTenantsConnection?: FeatureFlagsTenantsConnectionResolvers<ContextType>;
  FeatureFlagsTenantsEdge?: FeatureFlagsTenantsEdgeResolvers<ContextType>;
  FeatureFlagsUser?: FeatureFlagsUserResolvers<ContextType>;
  FeatureFlagsUsersConnection?: FeatureFlagsUsersConnectionResolvers<ContextType>;
  FeatureFlagsUsersEdge?: FeatureFlagsUsersEdgeResolvers<ContextType>;
  File?: FileResolvers<ContextType>;
  FileActivitiesConnection?: FileActivitiesConnectionResolvers<ContextType>;
  FileActivitiesEdge?: FileActivitiesEdgeResolvers<ContextType>;
  FileActivity?: FileActivityResolvers<ContextType>;
  FileMetadataConnection?: FileMetadataConnectionResolvers<ContextType>;
  FileMetadataEdge?: FileMetadataEdgeResolvers<ContextType>;
  FileMetadatum?: FileMetadatumResolvers<ContextType>;
  FileOutputGroup?: FileOutputGroupResolvers<ContextType>;
  FileOutputGroupMetadataConnection?: FileOutputGroupMetadataConnectionResolvers<ContextType>;
  FileOutputGroupMetadataEdge?: FileOutputGroupMetadataEdgeResolvers<ContextType>;
  FileOutputGroupMetadatum?: FileOutputGroupMetadatumResolvers<ContextType>;
  FileOutputGroupsConnection?: FileOutputGroupsConnectionResolvers<ContextType>;
  FileOutputGroupsEdge?: FileOutputGroupsEdgeResolvers<ContextType>;
  FileProcessingNotification?: FileProcessingNotificationResolvers<ContextType>;
  FileProcessingNotificationsConnection?: FileProcessingNotificationsConnectionResolvers<ContextType>;
  FileProcessingNotificationsEdge?: FileProcessingNotificationsEdgeResolvers<ContextType>;
  FilesByExecutor?: FilesByExecutorResolvers<ContextType>;
  FilesByExecutorsConnection?: FilesByExecutorsConnectionResolvers<ContextType>;
  FilesByExecutorsEdge?: FilesByExecutorsEdgeResolvers<ContextType>;
  FilesConnection?: FilesConnectionResolvers<ContextType>;
  FilesEdge?: FilesEdgeResolvers<ContextType>;
  GdtAnalysisTable?: GdtAnalysisTableResolvers<ContextType>;
  GdtAnalysisTableCell?: GdtAnalysisTableCellResolvers<ContextType>;
  GdtAnalysisTableCellsConnection?: GdtAnalysisTableCellsConnectionResolvers<ContextType>;
  GdtAnalysisTableCellsEdge?: GdtAnalysisTableCellsEdgeResolvers<ContextType>;
  GdtAnalysisTableColumn?: GdtAnalysisTableColumnResolvers<ContextType>;
  GdtAnalysisTableColumnGroup?: GdtAnalysisTableColumnGroupResolvers<ContextType>;
  GdtAnalysisTableColumnGroupsConnection?: GdtAnalysisTableColumnGroupsConnectionResolvers<ContextType>;
  GdtAnalysisTableColumnGroupsEdge?: GdtAnalysisTableColumnGroupsEdgeResolvers<ContextType>;
  GdtAnalysisTableColumnsConnection?: GdtAnalysisTableColumnsConnectionResolvers<ContextType>;
  GdtAnalysisTableColumnsEdge?: GdtAnalysisTableColumnsEdgeResolvers<ContextType>;
  GdtAnalysisTableRow?: GdtAnalysisTableRowResolvers<ContextType>;
  GdtAnalysisTableRowsConnection?: GdtAnalysisTableRowsConnectionResolvers<ContextType>;
  GdtAnalysisTableRowsEdge?: GdtAnalysisTableRowsEdgeResolvers<ContextType>;
  GdtAnalysisTablesConnection?: GdtAnalysisTablesConnectionResolvers<ContextType>;
  GdtAnalysisTablesEdge?: GdtAnalysisTablesEdgeResolvers<ContextType>;
  InternetAddress?: GraphQLScalarType;
  Interval?: IntervalResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  MetadataConnection?: MetadataConnectionResolvers<ContextType>;
  MetadataEdge?: MetadataEdgeResolvers<ContextType>;
  MetadataValue?: MetadataValueResolvers<ContextType>;
  MetadataValuesConnection?: MetadataValuesConnectionResolvers<ContextType>;
  MetadataValuesEdge?: MetadataValuesEdgeResolvers<ContextType>;
  Metadatum?: MetadatumResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Notification?: NotificationResolvers<ContextType>;
  NotificationsConnection?: NotificationsConnectionResolvers<ContextType>;
  NotificationsEdge?: NotificationsEdgeResolvers<ContextType>;
  OutputGroupFile?: OutputGroupFileResolvers<ContextType>;
  OutputGroupFilesConnection?: OutputGroupFilesConnectionResolvers<ContextType>;
  OutputGroupFilesEdge?: OutputGroupFilesEdgeResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  PinnedTool?: PinnedToolResolvers<ContextType>;
  PinnedToolsConnection?: PinnedToolsConnectionResolvers<ContextType>;
  PinnedToolsEdge?: PinnedToolsEdgeResolvers<ContextType>;
  Project?: ProjectResolvers<ContextType>;
  ProjectClonedNotification?: ProjectClonedNotificationResolvers<ContextType>;
  ProjectClonedNotificationsConnection?: ProjectClonedNotificationsConnectionResolvers<ContextType>;
  ProjectClonedNotificationsEdge?: ProjectClonedNotificationsEdgeResolvers<ContextType>;
  ProjectFolder?: ProjectFolderResolvers<ContextType>;
  ProjectFoldersConnection?: ProjectFoldersConnectionResolvers<ContextType>;
  ProjectFoldersEdge?: ProjectFoldersEdgeResolvers<ContextType>;
  ProjectSharedNotification?: ProjectSharedNotificationResolvers<ContextType>;
  ProjectSharedNotificationsConnection?: ProjectSharedNotificationsConnectionResolvers<ContextType>;
  ProjectSharedNotificationsEdge?: ProjectSharedNotificationsEdgeResolvers<ContextType>;
  ProjectTag?: ProjectTagResolvers<ContextType>;
  ProjectTagsConnection?: ProjectTagsConnectionResolvers<ContextType>;
  ProjectTagsEdge?: ProjectTagsEdgeResolvers<ContextType>;
  ProjectsConnection?: ProjectsConnectionResolvers<ContextType>;
  ProjectsEdge?: ProjectsEdgeResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RoleChangeNotification?: RoleChangeNotificationResolvers<ContextType>;
  RoleChangeNotificationsConnection?: RoleChangeNotificationsConnectionResolvers<ContextType>;
  RoleChangeNotificationsEdge?: RoleChangeNotificationsEdgeResolvers<ContextType>;
  Run?: RunResolvers<ContextType>;
  RunsConnection?: RunsConnectionResolvers<ContextType>;
  RunsEdge?: RunsEdgeResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  Task?: TaskResolvers<ContextType>;
  TaskActivitiesConnection?: TaskActivitiesConnectionResolvers<ContextType>;
  TaskActivitiesEdge?: TaskActivitiesEdgeResolvers<ContextType>;
  TaskActivity?: TaskActivityResolvers<ContextType>;
  TaskResource?: TaskResourceResolvers<ContextType>;
  TaskResourceUsage?: TaskResourceUsageResolvers<ContextType>;
  TaskResourceUsagesConnection?: TaskResourceUsagesConnectionResolvers<ContextType>;
  TaskResourceUsagesEdge?: TaskResourceUsagesEdgeResolvers<ContextType>;
  TaskResourcesConnection?: TaskResourcesConnectionResolvers<ContextType>;
  TaskResourcesEdge?: TaskResourcesEdgeResolvers<ContextType>;
  TaskSource?: TaskSourceResolvers<ContextType>;
  TaskSourcesConnection?: TaskSourcesConnectionResolvers<ContextType>;
  TaskSourcesEdge?: TaskSourcesEdgeResolvers<ContextType>;
  TaskStatusLog?: TaskStatusLogResolvers<ContextType>;
  TaskStatusLogsConnection?: TaskStatusLogsConnectionResolvers<ContextType>;
  TaskStatusLogsEdge?: TaskStatusLogsEdgeResolvers<ContextType>;
  TasksConnection?: TasksConnectionResolvers<ContextType>;
  TasksEdge?: TasksEdgeResolvers<ContextType>;
  Tenant?: TenantResolvers<ContextType>;
  TenantContract?: TenantContractResolvers<ContextType>;
  TenantContractAllowance?: TenantContractAllowanceResolvers<ContextType>;
  TenantContractAllowancesConnection?: TenantContractAllowancesConnectionResolvers<ContextType>;
  TenantContractAllowancesEdge?: TenantContractAllowancesEdgeResolvers<ContextType>;
  TenantContractTransaction?: TenantContractTransactionResolvers<ContextType>;
  TenantContractTransactionsConnection?: TenantContractTransactionsConnectionResolvers<ContextType>;
  TenantContractTransactionsEdge?: TenantContractTransactionsEdgeResolvers<ContextType>;
  TenantContractsConnection?: TenantContractsConnectionResolvers<ContextType>;
  TenantContractsEdge?: TenantContractsEdgeResolvers<ContextType>;
  TenantMockuserexecutor?: TenantMockuserexecutorResolvers<ContextType>;
  TenantMockuserexecutorsConnection?: TenantMockuserexecutorsConnectionResolvers<ContextType>;
  TenantMockuserexecutorsEdge?: TenantMockuserexecutorsEdgeResolvers<ContextType>;
  TenantMonthlyConsumedResource?: TenantMonthlyConsumedResourceResolvers<ContextType>;
  TenantMonthlyConsumedResourcesConnection?: TenantMonthlyConsumedResourcesConnectionResolvers<ContextType>;
  TenantMonthlyConsumedResourcesEdge?: TenantMonthlyConsumedResourcesEdgeResolvers<ContextType>;
  TenantUserMembershipNotification?: TenantUserMembershipNotificationResolvers<ContextType>;
  TenantUserMembershipNotificationsConnection?: TenantUserMembershipNotificationsConnectionResolvers<ContextType>;
  TenantUserMembershipNotificationsEdge?: TenantUserMembershipNotificationsEdgeResolvers<ContextType>;
  TenantUserexecutor?: TenantUserexecutorResolvers<ContextType>;
  TenantUserexecutorsConnection?: TenantUserexecutorsConnectionResolvers<ContextType>;
  TenantUserexecutorsEdge?: TenantUserexecutorsEdgeResolvers<ContextType>;
  TenantsEdge?: TenantsEdgeResolvers<ContextType>;
  TesContainerimageexecutor?: TesContainerimageexecutorResolvers<ContextType>;
  TesContainerimageexecutorsConnection?: TesContainerimageexecutorsConnectionResolvers<ContextType>;
  TesContainerimageexecutorsEdge?: TesContainerimageexecutorsEdgeResolvers<ContextType>;
  TesMockcontainerimageexecutor?: TesMockcontainerimageexecutorResolvers<ContextType>;
  TesMockcontainerimageexecutorsConnection?: TesMockcontainerimageexecutorsConnectionResolvers<ContextType>;
  TesMockcontainerimageexecutorsEdge?: TesMockcontainerimageexecutorsEdgeResolvers<ContextType>;
  TesMocktaskexecutor?: TesMocktaskexecutorResolvers<ContextType>;
  TesMocktaskexecutorsConnection?: TesMocktaskexecutorsConnectionResolvers<ContextType>;
  TesMocktaskexecutorsEdge?: TesMocktaskexecutorsEdgeResolvers<ContextType>;
  TesTaskexecutor?: TesTaskexecutorResolvers<ContextType>;
  TesTaskexecutorsConnection?: TesTaskexecutorsConnectionResolvers<ContextType>;
  TesTaskexecutorsEdge?: TesTaskexecutorsEdgeResolvers<ContextType>;
  Tool?: ToolResolvers<ContextType>;
  ToolParameter?: ToolParameterResolvers<ContextType>;
  ToolParametersConnection?: ToolParametersConnectionResolvers<ContextType>;
  ToolParametersEdge?: ToolParametersEdgeResolvers<ContextType>;
  ToolResource?: ToolResourceResolvers<ContextType>;
  ToolResourcesConnection?: ToolResourcesConnectionResolvers<ContextType>;
  ToolResourcesEdge?: ToolResourcesEdgeResolvers<ContextType>;
  ToolResult?: ToolResultResolvers<ContextType>;
  ToolResultsConnection?: ToolResultsConnectionResolvers<ContextType>;
  ToolResultsEdge?: ToolResultsEdgeResolvers<ContextType>;
  ToolSecret?: ToolSecretResolvers<ContextType>;
  ToolSecretsConnection?: ToolSecretsConnectionResolvers<ContextType>;
  ToolSecretsEdge?: ToolSecretsEdgeResolvers<ContextType>;
  ToolSource?: ToolSourceResolvers<ContextType>;
  ToolSourcesConnection?: ToolSourcesConnectionResolvers<ContextType>;
  ToolSourcesEdge?: ToolSourcesEdgeResolvers<ContextType>;
  ToolTenant?: ToolTenantResolvers<ContextType>;
  ToolTenantsConnection?: ToolTenantsConnectionResolvers<ContextType>;
  ToolTenantsEdge?: ToolTenantsEdgeResolvers<ContextType>;
  ToolVersion?: ToolVersionResolvers<ContextType>;
  ToolVersionsConnection?: ToolVersionsConnectionResolvers<ContextType>;
  ToolVersionsEdge?: ToolVersionsEdgeResolvers<ContextType>;
  Toolbox?: ToolboxResolvers<ContextType>;
  ToolboxTenant?: ToolboxTenantResolvers<ContextType>;
  ToolboxTenantsConnection?: ToolboxTenantsConnectionResolvers<ContextType>;
  ToolboxTenantsEdge?: ToolboxTenantsEdgeResolvers<ContextType>;
  ToolboxesConnection?: ToolboxesConnectionResolvers<ContextType>;
  ToolboxesEdge?: ToolboxesEdgeResolvers<ContextType>;
  ToolsConnection?: ToolsConnectionResolvers<ContextType>;
  ToolsEdge?: ToolsEdgeResolvers<ContextType>;
  UUID?: GraphQLScalarType;
  UpdateApplicationUserGroupPayload?: UpdateApplicationUserGroupPayloadResolvers<ContextType>;
  UpdateApplicationUserMembershipPayload?: UpdateApplicationUserMembershipPayloadResolvers<ContextType>;
  UpdateApplicationUserMetadatumPayload?: UpdateApplicationUserMetadatumPayloadResolvers<ContextType>;
  UpdateApplicationUserPayload?: UpdateApplicationUserPayloadResolvers<ContextType>;
  UpdateApplicationUserSessionPayload?: UpdateApplicationUserSessionPayloadResolvers<ContextType>;
  UpdateApplicationUserUserPermissionPayload?: UpdateApplicationUserUserPermissionPayloadResolvers<ContextType>;
  UpdateAuditlogLogentryPayload?: UpdateAuditlogLogentryPayloadResolvers<ContextType>;
  UpdateAuthGroupPayload?: UpdateAuthGroupPayloadResolvers<ContextType>;
  UpdateAuthGroupPermissionPayload?: UpdateAuthGroupPermissionPayloadResolvers<ContextType>;
  UpdateAuthPermissionPayload?: UpdateAuthPermissionPayloadResolvers<ContextType>;
  UpdateAvatarPayload?: UpdateAvatarPayloadResolvers<ContextType>;
  UpdateAwsBatchTaskPayload?: UpdateAwsBatchTaskPayloadResolvers<ContextType>;
  UpdateAwsCognitoUserPayload?: UpdateAwsCognitoUserPayloadResolvers<ContextType>;
  UpdateAwsEcrImagePayload?: UpdateAwsEcrImagePayloadResolvers<ContextType>;
  UpdateAwsMockBatchTaskPayload?: UpdateAwsMockBatchTaskPayloadResolvers<ContextType>;
  UpdateAwsMockDistributionImagePayload?: UpdateAwsMockDistributionImagePayloadResolvers<ContextType>;
  UpdateAwsMockEcrImagePayload?: UpdateAwsMockEcrImagePayloadResolvers<ContextType>;
  UpdateAwsMockIamUserPayload?: UpdateAwsMockIamUserPayloadResolvers<ContextType>;
  UpdateAwsMockS3FilePayload?: UpdateAwsMockS3FilePayloadResolvers<ContextType>;
  UpdateAwsS3FilePayload?: UpdateAwsS3FilePayloadResolvers<ContextType>;
  UpdateCodeFilePayload?: UpdateCodeFilePayloadResolvers<ContextType>;
  UpdateCommandPayload?: UpdateCommandPayloadResolvers<ContextType>;
  UpdateContainerImagePayload?: UpdateContainerImagePayloadResolvers<ContextType>;
  UpdateContainerImageRepositoryPayload?: UpdateContainerImageRepositoryPayloadResolvers<ContextType>;
  UpdateCostPayload?: UpdateCostPayloadResolvers<ContextType>;
  UpdateDistributionRegistryImagePayload?: UpdateDistributionRegistryImagePayloadResolvers<ContextType>;
  UpdateDjangoAdminLogPayload?: UpdateDjangoAdminLogPayloadResolvers<ContextType>;
  UpdateDjangoContentTypePayload?: UpdateDjangoContentTypePayloadResolvers<ContextType>;
  UpdateDjangoMigrationPayload?: UpdateDjangoMigrationPayloadResolvers<ContextType>;
  UpdateDjangoSesBlacklistedemailPayload?: UpdateDjangoSesBlacklistedemailPayloadResolvers<ContextType>;
  UpdateDjangoSesSesstatPayload?: UpdateDjangoSesSesstatPayloadResolvers<ContextType>;
  UpdateDjangoSessionPayload?: UpdateDjangoSessionPayloadResolvers<ContextType>;
  UpdateDrsFileexecutorPayload?: UpdateDrsFileexecutorPayloadResolvers<ContextType>;
  UpdateDrsMockfileexecutorPayload?: UpdateDrsMockfileexecutorPayloadResolvers<ContextType>;
  UpdateEulaVersionPayload?: UpdateEulaVersionPayloadResolvers<ContextType>;
  UpdateEulaVersionUserAcceptancePayload?: UpdateEulaVersionUserAcceptancePayloadResolvers<ContextType>;
  UpdateFeatureFlagPayload?: UpdateFeatureFlagPayloadResolvers<ContextType>;
  UpdateFeatureFlagsGroupPayload?: UpdateFeatureFlagsGroupPayloadResolvers<ContextType>;
  UpdateFeatureFlagsTenantPayload?: UpdateFeatureFlagsTenantPayloadResolvers<ContextType>;
  UpdateFeatureFlagsUserPayload?: UpdateFeatureFlagsUserPayloadResolvers<ContextType>;
  UpdateFileActivityPayload?: UpdateFileActivityPayloadResolvers<ContextType>;
  UpdateFileMetadatumPayload?: UpdateFileMetadatumPayloadResolvers<ContextType>;
  UpdateFileOutputGroupMetadatumPayload?: UpdateFileOutputGroupMetadatumPayloadResolvers<ContextType>;
  UpdateFileOutputGroupPayload?: UpdateFileOutputGroupPayloadResolvers<ContextType>;
  UpdateFilePayload?: UpdateFilePayloadResolvers<ContextType>;
  UpdateMetadataValuePayload?: UpdateMetadataValuePayloadResolvers<ContextType>;
  UpdateMetadatumPayload?: UpdateMetadatumPayloadResolvers<ContextType>;
  UpdateNotificationPayload?: UpdateNotificationPayloadResolvers<ContextType>;
  UpdateOutputGroupFilePayload?: UpdateOutputGroupFilePayloadResolvers<ContextType>;
  UpdatePinnedToolPayload?: UpdatePinnedToolPayloadResolvers<ContextType>;
  UpdateProjectFolderPayload?: UpdateProjectFolderPayloadResolvers<ContextType>;
  UpdateProjectTagPayload?: UpdateProjectTagPayloadResolvers<ContextType>;
  UpdateRunPayload?: UpdateRunPayloadResolvers<ContextType>;
  UpdateTaskActivityPayload?: UpdateTaskActivityPayloadResolvers<ContextType>;
  UpdateTaskPayload?: UpdateTaskPayloadResolvers<ContextType>;
  UpdateTaskResourcePayload?: UpdateTaskResourcePayloadResolvers<ContextType>;
  UpdateTaskResourceUsagePayload?: UpdateTaskResourceUsagePayloadResolvers<ContextType>;
  UpdateTaskSourcePayload?: UpdateTaskSourcePayloadResolvers<ContextType>;
  UpdateTaskStatusLogPayload?: UpdateTaskStatusLogPayloadResolvers<ContextType>;
  UpdateTenantContractAllowancePayload?: UpdateTenantContractAllowancePayloadResolvers<ContextType>;
  UpdateTenantContractPayload?: UpdateTenantContractPayloadResolvers<ContextType>;
  UpdateTenantContractTransactionPayload?: UpdateTenantContractTransactionPayloadResolvers<ContextType>;
  UpdateTenantMockuserexecutorPayload?: UpdateTenantMockuserexecutorPayloadResolvers<ContextType>;
  UpdateTenantMonthlyConsumedResourcePayload?: UpdateTenantMonthlyConsumedResourcePayloadResolvers<ContextType>;
  UpdateTenantPayload?: UpdateTenantPayloadResolvers<ContextType>;
  UpdateTenantUserexecutorPayload?: UpdateTenantUserexecutorPayloadResolvers<ContextType>;
  UpdateTesContainerimageexecutorPayload?: UpdateTesContainerimageexecutorPayloadResolvers<ContextType>;
  UpdateTesMockcontainerimageexecutorPayload?: UpdateTesMockcontainerimageexecutorPayloadResolvers<ContextType>;
  UpdateTesMocktaskexecutorPayload?: UpdateTesMocktaskexecutorPayloadResolvers<ContextType>;
  UpdateTesTaskexecutorPayload?: UpdateTesTaskexecutorPayloadResolvers<ContextType>;
  UpdateToolParameterPayload?: UpdateToolParameterPayloadResolvers<ContextType>;
  UpdateToolPayload?: UpdateToolPayloadResolvers<ContextType>;
  UpdateToolResourcePayload?: UpdateToolResourcePayloadResolvers<ContextType>;
  UpdateToolResultPayload?: UpdateToolResultPayloadResolvers<ContextType>;
  UpdateToolSecretPayload?: UpdateToolSecretPayloadResolvers<ContextType>;
  UpdateToolSourcePayload?: UpdateToolSourcePayloadResolvers<ContextType>;
  UpdateToolTenantPayload?: UpdateToolTenantPayloadResolvers<ContextType>;
  UpdateToolVersionPayload?: UpdateToolVersionPayloadResolvers<ContextType>;
  UpdateToolboxPayload?: UpdateToolboxPayloadResolvers<ContextType>;
  UpdateToolboxTenantPayload?: UpdateToolboxTenantPayloadResolvers<ContextType>;
  UpdateUserPersonalSpaceRequestPayload?: UpdateUserPersonalSpaceRequestPayloadResolvers<ContextType>;
  UpdateWaffleFlagPayload?: UpdateWaffleFlagPayloadResolvers<ContextType>;
  UpdateWaffleSamplePayload?: UpdateWaffleSamplePayloadResolvers<ContextType>;
  UpdateWaffleSwitchPayload?: UpdateWaffleSwitchPayloadResolvers<ContextType>;
  UpdateWorkflowDatumPayload?: UpdateWorkflowDatumPayloadResolvers<ContextType>;
  UpdateWorkflowPayload?: UpdateWorkflowPayloadResolvers<ContextType>;
  UpdateWorkflowResultPayload?: UpdateWorkflowResultPayloadResolvers<ContextType>;
  UpdateWorkflowResultWorkflowVersionPayload?: UpdateWorkflowResultWorkflowVersionPayloadResolvers<ContextType>;
  UpdateWorkflowSectionBlockPayload?: UpdateWorkflowSectionBlockPayloadResolvers<ContextType>;
  UpdateWorkflowSectionBlockSectionPayload?: UpdateWorkflowSectionBlockSectionPayloadResolvers<ContextType>;
  UpdateWorkflowSectionPayload?: UpdateWorkflowSectionPayloadResolvers<ContextType>;
  UpdateWorkflowSectionWorkflowVersionPayload?: UpdateWorkflowSectionWorkflowVersionPayloadResolvers<ContextType>;
  UpdateWorkflowSourcePayload?: UpdateWorkflowSourcePayloadResolvers<ContextType>;
  UpdateWorkflowSourceWorkflowVersionPayload?: UpdateWorkflowSourceWorkflowVersionPayloadResolvers<ContextType>;
  UpdateWorkflowVersionPayload?: UpdateWorkflowVersionPayloadResolvers<ContextType>;
  UserAccessToProject?: UserAccessToProjectResolvers<ContextType>;
  UserAccessToProjectsConnection?: UserAccessToProjectsConnectionResolvers<ContextType>;
  UserAccessToProjectsEdge?: UserAccessToProjectsEdgeResolvers<ContextType>;
  UserOnboardingQuestion?: UserOnboardingQuestionResolvers<ContextType>;
  UserOnboardingQuestionAnswer?: UserOnboardingQuestionAnswerResolvers<ContextType>;
  UserOnboardingQuestionAnswersConnection?: UserOnboardingQuestionAnswersConnectionResolvers<ContextType>;
  UserOnboardingQuestionAnswersEdge?: UserOnboardingQuestionAnswersEdgeResolvers<ContextType>;
  UserOnboardingQuestionResponse?: UserOnboardingQuestionResponseResolvers<ContextType>;
  UserOnboardingQuestionResponsesConnection?: UserOnboardingQuestionResponsesConnectionResolvers<ContextType>;
  UserOnboardingQuestionResponsesEdge?: UserOnboardingQuestionResponsesEdgeResolvers<ContextType>;
  UserOnboardingQuestionsConnection?: UserOnboardingQuestionsConnectionResolvers<ContextType>;
  UserOnboardingQuestionsEdge?: UserOnboardingQuestionsEdgeResolvers<ContextType>;
  UserPersonalSpaceRequest?: UserPersonalSpaceRequestResolvers<ContextType>;
  UserPersonalSpaceRequestsConnection?: UserPersonalSpaceRequestsConnectionResolvers<ContextType>;
  UserPersonalSpaceRequestsEdge?: UserPersonalSpaceRequestsEdgeResolvers<ContextType>;
  WaffleFlag?: WaffleFlagResolvers<ContextType>;
  WaffleFlagsConnection?: WaffleFlagsConnectionResolvers<ContextType>;
  WaffleFlagsEdge?: WaffleFlagsEdgeResolvers<ContextType>;
  WaffleSample?: WaffleSampleResolvers<ContextType>;
  WaffleSamplesConnection?: WaffleSamplesConnectionResolvers<ContextType>;
  WaffleSamplesEdge?: WaffleSamplesEdgeResolvers<ContextType>;
  WaffleSwitch?: WaffleSwitchResolvers<ContextType>;
  WaffleSwitchesConnection?: WaffleSwitchesConnectionResolvers<ContextType>;
  WaffleSwitchesEdge?: WaffleSwitchesEdgeResolvers<ContextType>;
  Workflow?: WorkflowResolvers<ContextType>;
  WorkflowDataConnection?: WorkflowDataConnectionResolvers<ContextType>;
  WorkflowDataEdge?: WorkflowDataEdgeResolvers<ContextType>;
  WorkflowDatum?: WorkflowDatumResolvers<ContextType>;
  WorkflowResult?: WorkflowResultResolvers<ContextType>;
  WorkflowResultWorkflowVersion?: WorkflowResultWorkflowVersionResolvers<ContextType>;
  WorkflowResultWorkflowVersionsConnection?: WorkflowResultWorkflowVersionsConnectionResolvers<ContextType>;
  WorkflowResultWorkflowVersionsEdge?: WorkflowResultWorkflowVersionsEdgeResolvers<ContextType>;
  WorkflowResultsConnection?: WorkflowResultsConnectionResolvers<ContextType>;
  WorkflowResultsEdge?: WorkflowResultsEdgeResolvers<ContextType>;
  WorkflowSection?: WorkflowSectionResolvers<ContextType>;
  WorkflowSectionBlock?: WorkflowSectionBlockResolvers<ContextType>;
  WorkflowSectionBlockSection?: WorkflowSectionBlockSectionResolvers<ContextType>;
  WorkflowSectionBlockSectionsConnection?: WorkflowSectionBlockSectionsConnectionResolvers<ContextType>;
  WorkflowSectionBlockSectionsEdge?: WorkflowSectionBlockSectionsEdgeResolvers<ContextType>;
  WorkflowSectionBlocksConnection?: WorkflowSectionBlocksConnectionResolvers<ContextType>;
  WorkflowSectionBlocksEdge?: WorkflowSectionBlocksEdgeResolvers<ContextType>;
  WorkflowSectionWorkflowVersion?: WorkflowSectionWorkflowVersionResolvers<ContextType>;
  WorkflowSectionWorkflowVersionsConnection?: WorkflowSectionWorkflowVersionsConnectionResolvers<ContextType>;
  WorkflowSectionWorkflowVersionsEdge?: WorkflowSectionWorkflowVersionsEdgeResolvers<ContextType>;
  WorkflowSectionsConnection?: WorkflowSectionsConnectionResolvers<ContextType>;
  WorkflowSectionsEdge?: WorkflowSectionsEdgeResolvers<ContextType>;
  WorkflowSource?: WorkflowSourceResolvers<ContextType>;
  WorkflowSourceWorkflowVersion?: WorkflowSourceWorkflowVersionResolvers<ContextType>;
  WorkflowSourceWorkflowVersionsConnection?: WorkflowSourceWorkflowVersionsConnectionResolvers<ContextType>;
  WorkflowSourceWorkflowVersionsEdge?: WorkflowSourceWorkflowVersionsEdgeResolvers<ContextType>;
  WorkflowSourcesConnection?: WorkflowSourcesConnectionResolvers<ContextType>;
  WorkflowSourcesEdge?: WorkflowSourcesEdgeResolvers<ContextType>;
  WorkflowVersion?: WorkflowVersionResolvers<ContextType>;
  WorkflowVersionsConnection?: WorkflowVersionsConnectionResolvers<ContextType>;
  WorkflowVersionsEdge?: WorkflowVersionsEdgeResolvers<ContextType>;
  WorkflowsConnection?: WorkflowsConnectionResolvers<ContextType>;
  WorkflowsEdge?: WorkflowsEdgeResolvers<ContextType>;
};
